angular.module('lodash', [])
    .factory('_', ['$window', function ($window) {
        return $window._;
    }]);
angular
    .module('templates', []);
angular
    .module('application', [
    'ngAnimate',
    'ngAria',
    'ngMaterial',
    'templates',
    'lodash',
    'ngStorage',
    'btford.socket-io',
    'ui.router',
    'ui.router.stateHelper',
    'datatables',
    'datatables.ibmTheme',
    'ngFileUpload',
    'ngSanitize',
    'angularMoment',
]);
var HttpProvider = (function () {
    function HttpProvider($httpProvider) {
        this.$httpProvider = $httpProvider;
        $httpProvider.defaults.useXDomain = true;
        // delete $httpProvider.defaults.headers.common['X-Requested-With'];
        $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    }
    HttpProvider.$inject = ['$httpProvider'];
    return HttpProvider;
}());
angular
    .module('application')
    .config(['$httpProvider', HttpProvider]);
var CompileProvider = (function () {
    function CompileProvider($compileProvider) {
        this.$compileProvider = $compileProvider;
        $compileProvider.debugInfoEnabled(false);
    }
    CompileProvider.$inject = ['$compileProvider'];
    return CompileProvider;
}());
angular
    .module('application')
    .config(['$compileProvider', CompileProvider]);
/*
class MdAriaProvider {
    static $inject = ['$mdAriaProvider'];
    constructor(private $mdAriaProvider: any) {
        $mdAriaProvider.disableWarnings();
    }
}

angular
    .module('application')
    .config(['$mdAriaProvider', MdAriaProvider]);
*/
var LocationProvider = (function () {
    function LocationProvider($locationProvider) {
        this.$locationProvider = $locationProvider;
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false,
            rewriteLinks: false
        });
    }
    LocationProvider.$inject = ['$locationProvider'];
    return LocationProvider;
}());
angular
    .module('application')
    .config(['$locationProvider', LocationProvider]);
var MdIconProvider = (function () {
    function MdIconProvider($mdIconProvider) {
        this.$mdIconProvider = $mdIconProvider;
        $mdIconProvider
            .icon('more', '/static/img/icons/ic_more_vert_24px.svg', 24)
            .icon('close', '/static/img/icons/ic_close_24px.svg', 24);
    }
    MdIconProvider.$inject = ['$mdIconProvider'];
    return MdIconProvider;
}());
angular
    .module('application')
    .config(['$mdIconProvider', MdIconProvider]);
var MdThemingProvider = (function () {
    function MdThemingProvider($mdThemingProvider) {
        this.$mdThemingProvider = $mdThemingProvider;
        //        $mdThemingProvider;
        $mdThemingProvider.theme('red');
        $mdThemingProvider.theme('green');
    }
    MdThemingProvider.$inject = ['$mdThemingProvider'];
    return MdThemingProvider;
}());
angular
    .module('application')
    .config(['$mdThemingProvider', MdThemingProvider]);
var Run = (function () {
    function Run($rootScope, $state, env, $window, $location, $http, $localStorage, $login, socket) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.env = env;
        this.$window = $window;
        this.$location = $location;
        this.$http = $http;
        this.$localStorage = $localStorage;
        this.$login = $login;
        this.socket = socket;
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            //If redirected to a dead end page, ie: not auth'd etc
            var deadEnds = ['500', '400', '403', 'terms'];
            if (deadEnds.indexOf(toState.name) > -1) {
                return;
            }
            if (toState.authenticate && !this.env.user.loggedIn) {
                console.info('$init.ts => Not logged in...routing to home');
                this.$window.location.href = '/';
            }
            else if ((toState.authenticate && !this.env.user.allowed) ||
                (this.env.user.loggedIn && !this.env.user.allowed)) {
                // User authenticated but not in any Blue Groups
                $state.transitionTo('500');
                event.preventDefault();
                return;
            }
            else if (this.env.user.loggedIn && this.env.user.allowed) {
                // If the user has not confirmed the latest terms (defined server-side)...redirect to enforce it
                if (!this.env.user.termsOk) {
                    $state.transitionTo('terms');
                    event.preventDefault();
                    return;
                }
                //Authenticated AND in Blue Groups
                //                if (toState.name ==='admin' && !this.env.user.access.systemAdmin) {
                if (toState.name.indexOf('admin.') > -1
                    && (toState.name.indexOf('mysa-dmt-view') < 0 || toState.name.indexOf('mysa-im-outbound-view') < 0) && !this.env.user.access.systemAdmin) {
                    //If user attempts to access Admin pages but is not system admin
                    $state.transitionTo('noadmin');
                    event.preventDefault();
                    return;
                }
                else if (toState.name === 'home') {
                    /* User is authenticated and doesn't ask anything else */
                    //Home for BPSO Admin or Non-BPSO Admin is myqueue...everyone else is teamqueue
                    var homeQueue = 'teamqueue';
                    if (env.user.access.bpsoAdmin || env.user.access.nonBpsoAdmin) {
                        homeQueue = 'myqueue';
                    }
                    $state.transitionTo('queue', {
                        id: homeQueue
                    });
                    event.preventDefault();
                }
                else if (toState.name === 'approvals' && !this.env.user.approver) {
                    /* User is authenticated and doesn't ask anything else */
                    $state.transitionTo('noapprover');
                    event.preventDefault();
                    return;
                }
            }
        });
    }
    Run.$inject = ['$rootScope', '$state', 'env', '$window', '$location', '$http', '$localStorage', '$login', 'socket'];
    return Run;
}());
angular
    .module('application')
    .run(Run);



var DTSService = (function () {
    function DTSService($localStorage, socket, env, $filter, $http, _) {
        this.$localStorage = $localStorage;
        this.socket = socket;
        this.env = env;
        this.$filter = $filter;
        this.$http = $http;
        this._ = _;
    }
    DTSService.prototype.now = function () {
        var x = new Date().toISOString();
        x = x.replace('T', ' ');
        x = x.replace('Z', ' ');
        return x;
    };
    DTSService.prototype.timestamp = function (x) {
        var t = new Date(x).toISOString();
        t = t.replace('T', ' ');
        t = t.replace('Z', '');
        return t;
    };
    DTSService.prototype.getIndex = function (array, id, tp) {
        var i = -1;
        _.some(array, function (data, idx) {
            if (data[tp] === id) {
                i = idx;
                return i;
            }
        });
        return i;
    };
    DTSService.prototype.getAvatar = function (user, size) {
        if (!user || user === undefined) {
            return null;
        }
        var baseUrl = 'https://w3-unifiedprofile-api.dal1a.cirrus.ibm.com';
        return baseUrl + "/v3/image/" + user + "?def=null&size=" + (size || 115);
    };
    DTSService.prototype.token = function () {
        return this.$localStorage.token;
    };
    DTSService.prototype.getDate = function (dt) {
        var dat = new Date(parseInt(dt));
        return dat;
    };
    DTSService.prototype.guid = function () {
        function _p8(s) {
            var array = new Uint32Array(2);
            var p = (window.crypto.getRandomValues(array)[0].toString(16) + '000000000').substr(2, 8);
            return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
        }
        var t = _p8(false) + _p8(true) + _p8(true) + _p8(false);
        return t.toLowerCase();
    };
    // Retrieves name & serial number from faces
    DTSService.prototype.getUser = function (email) {
        //return this.$http.jsonp('//faces.tap.ibm.com/api/find/?q=' + email +'&callback=JSON_CALLBACK');
        return this.$http.jsonp('https://w3-services1.w3-969.ibm.com/myw3/unified-profile/v1/api/find?q=' + email + '&callback=JSON_CALLBACK');
    };
    DTSService.$inject = [
        '$localStorage', 'socket', 'env', '$filter', '$http', '_'
    ];
    return DTSService;
}());
angular
    .module('application')
    .service('DTS', DTSService);



var Admin = (function () {
    function Admin($rootScope, $timeout, $q, socket, env, $injector, $filter, config, $state, settings) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.env = env;
        this.$injector = $injector;
        this.$filter = $filter;
        this.config = config;
        this.$state = $state;
        this.settings = settings;
        this.selected = null;
        this.listOfCheckList = [
            {
                name: 'Completeness checklist',
                variableName: 'check_list',
                radioButtonName: 'cl_rb',
                description: 'Located in the eligibility tab in the Completeness checklist section',
                visible: false,
                editView: false
            },
            {
                name: 'GOE checklist',
                variableName: 'check_list2',
                radioButtonName: 'cl2_rb',
                description: 'Located in the eligibility tab under the GOE section',
                visible: false,
                editView: false
            },
            {
                name: 'Duplicate checklist',
                variableName: 'check_list3',
                radioButtonName: 'cl3_rb',
                description: 'Located in the eligibility tab under the duplicate check section',
                visible: false,
                editView: false
            },
            {
                name: 'Validation checklist',
                variableName: 'check_list_validation',
                radioButtonName: 'cl_validation_rb',
                description: 'Located in the validation tab',
                visible: false,
                editView: false
            },
            {
                name: 'Sampling Solution checklist',
                variableName: 'check_list_solution_sampling',
                radioButtonName: 'cl_sampling_rb',
                description: 'Located in the sampling solution section',
                visible: false,
                editView: false
            },
            {
                name: 'Sampling SSA checklist',
                variableName: 'check_list_sampling',
                radioButtonName: 'cl_sampling_rb',
                description: 'Located in the sampling ssa section',
                visible: false,
                editView: false
            },
            {
                name: 'Calculation checklist',
                variableName: 'check_list_calculation',
                radioButtonName: 'cl_calculation_rb',
                description: 'Located in the calculation section',
                visible: false,
                editView: false
            },
            {
                name: 'Opportunity Detail checklist',
                variableName: 'check_list_opportunity_detail',
                radioButtonName: 'cl_opportunity_detail_rb',
                description: 'Located in the general section',
                visible: false,
                editView: false
            },
            {
                name: 'Investment Review checklist',
                variableName: 'check_list_investment_review',
                radioButtonName: 'cl_investment_rb',
                description: 'Located in the general section',
                visible: false,
                editView: false
            },
            {
                name: 'Payment checklist',
                variableName: 'check_list_payment',
                radioButtonName: 'cl_payment_rb',
                description: 'Located in the general section',
                visible: false,
                editView: false
            },
            {
                name: 'Exceptions checklist',
                variableName: 'check_list_exceptions',
                radioButtonName: 'cl_exceptions_rb',
                description: 'Located in the general section',
                visible: false,
                editView: false
            }
        ];
        this.clSelection = {
            selected: 'All',
            filters: ['All', 'Active', 'Disabled', 'Not yet enabled']
        };
        this.copySingleLog = undefined;
    }
    Admin.prototype.getCopySingleLog = function () {
        return this.copySingleLog;
    };
    Admin.prototype.setCopySingleLog = function (copySL) {
        this.copySingleLog = copySL;
    };
    Admin.prototype.newLine = function (index, cols) {
        if (index % cols === 0) {
            return true;
        }
        else {
            return false;
        }
    };
    Admin.prototype.navigate = function (where) {
        this.$state.go(where, '');
    };
    Admin.prototype.setProgramID = function (editObj) {
        editObj._id = editObj.country + '|' + editObj.program + '|' + editObj.brand + '|' + editObj.bp_type;
    };
    Admin.prototype.refreshAdvancedFilter = function (table) {
        angular.forEach(table.filters, function (v, k) {
            if (!v) {
                delete table.filterParams[k];
            }
        });
    };
    Admin.prototype.getCountryIOT = function (countrySHORT) {
        var iot = '';
        this.settings.country_list.some(function (cty) {
            if (cty.short === countrySHORT && cty.ic === 'Country') {
                iot = cty.imt;
                return true; //break loop
            }
        });
        return iot;
    };
    Admin.prototype.tidy = function (value) {
        if (angular.isArray(value)) {
            var newValue_1 = '';
            angular.forEach(value, function (ele) {
                if (newValue_1.length > 0) {
                    newValue_1 = newValue_1 + ', ';
                }
                newValue_1 = newValue_1 + ele;
            });
            return newValue_1;
        }
        return value;
    };
    Admin.prototype.getBGName = function (role) {
        if (role === 0) {
            return 'BPSO Administrator';
        }
        else if (role === 1) {
            return 'Non-BPSO Administrator';
        }
        if (role === 2) {
            return 'BPSO Approver';
        }
        if (role === 3) {
            return 'Non-BPSO Approver';
        }
        if (role === 4) {
            return 'Reader';
        }
        if (role === 7) {
            return 'System Administrator';
        }
    };
    Admin.prototype.exportUserPermissions = function () {
        //Make call to get Excel of users' country access
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportUserPermissions',
                script: '/admin/admin-user-excel',
                user: this.env.user
            }
        });
    };
    Admin.prototype.getTermsProfile = function () {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getTermsProfile',
                script: '/config/config',
                user: this.env.user
            }
        });
    };
    Admin.prototype.getMiscCodesByType = function (type) {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                code_set: type,
                function: 'getMiscCodesByType',
                script: '/config/config',
                user: this.env.user
            }
        });
    };
    Admin.prototype.getListOfAllDisputes = function (data) {
        //Make call to get all disputes
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getListOfAllDisputes',
                script: '/config/config',
                user: this.env.user,
                data: data
            }
        });
    };
    Admin.prototype.getMiscCodes = function (sum) {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getMiscCodes',
                script: '/config/config',
                summary: sum,
                user: this.env.user
            }
        });
    };
    Admin.prototype.updateTerms = function (data) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateTerms',
                script: '/config/config',
                data: data,
                user: this.env.user
            }
        });
    };
    Admin.prototype.updateMiscCodes = function (pack) {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: pack,
                function: 'updateMiscCodes',
                script: '/config/config',
                user: this.env.user
            }
        });
    };
    // getGBT20Profile() {
    //     //Make call to get All Program Profiles
    //     this.socket.emit('module', {
    //         module: {
    //             application: 'dmt',
    //             function: 'getGBT20Profile',
    //             script: '/config/config',
    //             user: this.env.user,
    //         }
    //     });
    // }
    Admin.prototype.getGPPLoadProfile = function () {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getGPPLoadProfile',
                script: '/config/config',
                user: this.env.user
            }
        });
    };
    Admin.prototype.getSummaryProgramProfiles = function () {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getSummaryProgramProfiles',
                script: '/config/config',
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.getUserProfile = function (email) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getUserProfileByEmail',
                script: '/config/config',
                email: email,
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.updateUserProfile = function (data) {
        this.socket.emit('module', {
            application: 'dmt',
            module: {
                function: 'updateUserProfile',
                script: '/config/config',
                data: data.data,
                changelog: data.changelog,
                token: this.env.user.token //To check access
            }
        });
    };
    Admin.prototype.getAllProgramProfiles = function () {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getAllProgramProfiles',
                script: '/config/config',
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.getProgramProfileByName = function (name) {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getProgramProfileByName',
                script: '/config/config',
                profile_id: name,
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.getUserProfiles = function () {
        //Make call to get All User Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getUserProfiles',
                script: '/config/config',
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.getUserProfileByEmail = function (email) {
        //Make call to get All User Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getUserProfileByEmail',
                script: '/config/config',
                email: email,
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.getCountryConfig = function () {
        //Make call to get Country settings
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getCountryConfig',
                script: '/config/config',
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.getGeneralConfig = function () {
        //Make call to get General config
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getGeneralConfig',
                script: '/config/config',
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.updateAdminProfile = function (data) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateAdminProfile',
                script: '/config/config',
                data: data,
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.deleteAdminProfile = function (data) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'deleteAdminProfile',
                script: '/config/config',
                data: data,
                token: this.env.user.token
            }
        });
    };
    //getting sampling
    Admin.prototype.getAllCtySamples = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getAllCountrySamplesBackend',
                script: '/sampling/ctrySampling',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    //getting bpoi setup
    Admin.prototype.getBpoiSetup = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getBpoiSetupBackend',
                script: '/admin/bpoi-enabler',
                user: this.env.user
            }
        });
    };
    //add one new Cty to the
    Admin.prototype.addOneCtySample = function (newEntry) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'addCountrySamplesBackend',
                script: '/sampling/ctrySampling',
                data: newEntry,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    //edit all existing country samples
    Admin.prototype.updateAllCtySamples = function (samples) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateAllCtySamplesBackend',
                script: '/sampling/ctrySampling',
                data: samples,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    //getting sampling source
    Admin.prototype.getBaseSamples = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getBaseSamples',
                script: '/sampling/baseTableSampling',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.updateBaseSamples = function (newSource, questionsArr) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateBaseSamples',
                script: '/sampling/baseTableSampling',
                data: newSource,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    ;
    /**
     * Convert a couch property key such as misc_codes or program_template_desc to proper case, ie:
     * Misc Codes, Program Template Desc
     *
     * @param {string} value
     * @returns {string}
     *
     * @memberOf Admin
     */
    Admin.prototype.toProperCase = function (value) {
        if (value.indexOf('_') > -1) {
            var array = value.split('_');
            for (var i = 0; i < array.length; i++) {
                array[i] = array[i].charAt(0).toUpperCase() + array[i].substring(1);
            }
            return array.join(' ');
        }
        return value;
    };
    /**
     * Function to send notification to system Admin team in the event of Admin page update
     *
     * @param {*} bundle
     * @returns
     *
     * @memberOf Admin
     */
    Admin.prototype.sendAdminUpdate = function (bundle) {
        //Bundle should contain
        // - profile - Admin Profile name, ie: Exchange Rate Table
        // - docurl - path of doc updated, ie: exchangerate-view 
        var email = {
            id: 'Admin Profile Update',
            title: bundle.profile,
            to: ['rogersm@uk.ibm.com'],
            subject: 'DMT - Admin Profile Update - ' + bundle.profile,
            message: 'N/A',
            opp: 'N/A',
            bpName: 'N/A',
            fromwho: this.env.user.email,
            template: 'admin-update',
            type: 'mailing',
            event: 'invitation',
            adminUrlPath: bundle.docurl
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'sendAdminEmail',
                script: '/config/config',
                emailBundle: email,
                token: this.env.user.token
            }
        });
    };
    Admin.$inject = ['$rootScope', '$timeout', '$q', 'socket', 'env', '$injector', '$filter', 'config', '$state', 'settings'];
    return Admin;
}());
angular
    .module('application')
    .service('admin', Admin);
//red - star directive to display red star
angular.module('application')
    .directive('req', function () {
    return {
        template: '<span style="color:red; f">*</span>'
    };
});



var OppStatus;
(function (OppStatus) {
    OppStatus[OppStatus["PAID"] = 7] = "PAID";
    OppStatus[OppStatus["VALIDATION"] = 4] = "VALIDATION";
})(OppStatus || (OppStatus = {}));
var OppSubStatusGroup = (function () {
    function OppSubStatusGroup() {
    }
    OppSubStatusGroup.SUBSTATUSES_CALCULATION_COMPLETED = [15, 16, 17, 18, 19, 20, 21, 22];
    return OppSubStatusGroup;
}());
/* tslint:disable:max-classes-per-file */
var ConfigurationStatus = (function () {
    function ConfigurationStatus($rootScope, $timeout, $q, socket, env, $injector, $filter, settings) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.env = env;
        this.$injector = $injector;
        this.$filter = $filter;
        this.settings = settings;
        this.proProfileLoaded = false;
    }
    // tslint:disable-next-line: typedef
    ConfigurationStatus.prototype.isOppCalculationCompleted = function (status, substatus) {
        var stat = Number(status);
        var subStat = Number(substatus);
        return stat === OppStatus.PAID
            || (stat === OppStatus.VALIDATION && OppSubStatusGroup.SUBSTATUSES_CALCULATION_COMPLETED.includes(subStat));
    };
    /**
     * getProgramStatusFlow  - Get the array of main statuses for a Program by Program Name
     */
    ConfigurationStatus.prototype.getProgramStatusFlow = function (name) {
        var ps = [];
        if (this.settings.program_cfg) {
            angular.forEach(this.settings.program_cfg, function (prg) {
                if (prg.title === name) {
                    ps = prg.process_seq;
                }
            });
        }
        return ps;
    };
    ConfigurationStatus.prototype.loadStatus = function (ev, results) { };
    /**
     * setProgramProfile - Function that will be called when an emit is received from the Config.Program service.
     * The content of the data will be loaded to the config.proProfile variable
     *
     * @param  {type} data: any Result from server either containing an error or the profile data
     */
    ConfigurationStatus.prototype.setProgramProfile = function (data) {
        this.proProfile = data;
        // console.log('program data retrieved');
        if (this.proProfile !== undefined) {
            if (angular.isString(this.proProfile) && this.proProfile.indexOf('ERROR:') > -1) {
                this.proProfileLoaded = false; //it's there but errored
            }
            else {
                this.proProfileLoaded = true; //it's there
            }
        }
        else {
            this.proProfileLoaded = false; //not there
        }
    };
    ConfigurationStatus.prototype.isStageApprover = function (currentUser, mainStatus, subStatus) {
        var found = false;
        var appStage = this.getSubStatusBySubStatusNo2(mainStatus, subStatus);
        appStage.users.some(function (approver) {
            if (approver.email === currentUser) {
                found = true;
                return true; //break
            }
        });
        return found;
    };
    /**
     * hasPreApproval - Function to determine if the program profile is enabled for Pre-Approval stage.  It does
     * this by checking the length of the preapproval_stages array.
     *
     * @return {type}  true if so; false otherwise
     */
    ConfigurationStatus.prototype.hasPreApproval = function () {
        //if (angular.isDefined(this.proProfile) && this.proProfile.preapproval_stages.length > 0) {
        if (this.proProfileLoaded && this.proProfile.preapproval_stages.length > 0) {
            return true;
        }
        return false;
    };
    /**
     * getSubStatusBySubStatusNo - Function to pull the sub-status object from within the status config object by number
     *
     * @param  {type} mainStatus: any       main status object which contains the array of subs within .value
     * @param  {type} sub_status_no: number the sub-status number to search for
     * @return {type}                       the sub-status object containing no, txt and owner
     */
    ConfigurationStatus.prototype.getSubStatusBySubStatusNo = function (mainStatus, sub_status_no) {
        var sub = null;
        mainStatus.subs.some(function (subStatus) {
            if (subStatus.no === sub_status_no) {
                sub = subStatus;
                return true;
            }
        });
        return sub;
    };
    ConfigurationStatus.prototype.getSubStatusBySubStatusNo2 = function (mainStatus, sub_status_no) {
        var main = this.getMainStatusByMainStatusNo(mainStatus);
        var sub = undefined;
        main.subs.some(function (subStatus) {
            if (subStatus.no === sub_status_no) {
                sub = subStatus;
                return true;
            }
        });
        return sub;
    };
    ConfigurationStatus.prototype.getSubStatusByDesc = function (mainStatus, sub_status_desc) {
        var main = this.getMainStatusByMainStatusNo(mainStatus);
        var sub = null;
        main.subs.some(function (subStatus) {
            if (subStatus.txt === sub_status_desc) {
                sub = subStatus;
                return true;
            }
        });
        return sub;
    };
    ConfigurationStatus.prototype.getAppStagesForApprover = function (user, peer) {
        var _this = this;
        var stages = [];
        var stage = {};
        //Loop through the statuses
        angular.forEach(this.settings.status_cfg, function (stat) {
            //If status is an approval status
            if ([2, 5].indexOf(stat.no) > -1) {
                //Loop through the sub-statuses
                angular.forEach(stat.subs, function (sub) {
                    //If we're NOT looking for a peer
                    if (peer === null) {
                        if (sub.users && sub.users.length > 0) {
                            //Loop through the users
                            angular.forEach(sub.users, function (bod) {
                                if (bod.email === user) {
                                    stage.main_name = stat.txt;
                                    stage.name = sub.txt;
                                    stage.prez = _this.getAppStageForPrez(stat.no, sub.no, false);
                                    stages.push(stage);
                                    stage = {};
                                }
                            });
                        }
                    }
                    else {
                        if (sub.peer && ((sub.bpso && peer === 'BPSO') || (!sub.bpso && peer === 'Non-BPSO'))) {
                            stage.main_name = stat.txt;
                            stage.name = sub.txt;
                            stage.prez = _this.getAppStageForPrez(stat.no, sub.no, false);
                            stages.push(stage);
                            stage = {};
                        }
                    }
                });
            }
        });
        return stages;
    };
    ConfigurationStatus.prototype.getMainStatusForPrez = function (mainStatus, descOnly) {
        var main = this.getMainStatusByMainStatusNo(mainStatus);
        if (angular.isUndefined(main)) {
            // console.log('Unable to find Main Status profile for Program Profile pop-up.');
            return;
        }
        if (descOnly) {
            return main.txt;
        }
        var packString = 'Main Status Title : ' + main.txt + '\n' +
            'Status ID : ' + main.no + '\n' +
            'Description : ' + main.desc;
        return packString;
    };
    ConfigurationStatus.prototype.getAppStageForPrez = function (mainStatus, sub_status_no, descOnly) {
        var main = this.getMainStatusByMainStatusNo(mainStatus);
        var sub = null;
        if (angular.isUndefined(main)) {
            // console.log('Unable to find Main Status profile for Program Profile pop-up.');
            return;
        }
        main.subs.some(function (subStatus) {
            if (subStatus.no === sub_status_no) {
                sub = subStatus;
                return true;
            }
        });
        if (sub == null) {
            if (descOnly) {
                return 'Stage not found!!';
            }
            else {
                return 'No such Stage found.  Contact DMT System Administrators.';
            }
        }
        if (descOnly) {
            return sub.txt;
        }
        var packString;
        if ([2, 5].indexOf(mainStatus) > -1) {
            var bpso = sub.bpso ? 'BPSO' : 'Non-BPSO';
            var pmt = void 0;
            var approvers_1 = 'Authorised Approvers :';
            if (!sub.peer) {
                if (sub.manager) {
                    pmt = 'Manager';
                }
                else {
                    pmt = 'Team Leader';
                }
                sub.users.forEach(function (bod) {
                    approvers_1 = approvers_1 + '\n' + bod.name + ' (' + bod.email + ')';
                });
            }
            else {
                pmt = 'Peer/Colleague';
                approvers_1 = 'Authorised Approvers : Anyone within ' + bpso + ' Administration team';
            }
            packString =
                'Stage Title : ' + sub.txt + '\n' +
                    'Approval Stage ID : ' + mainStatus + '-' + sub.no + '\n' +
                    'Cycle Time Owner : ' + sub.owner + '\n' +
                    'Clip Level : ' + this.$filter('currency')(sub.clip, '$', 2) + '\n' +
                    'Responsibility : ' + bpso + ' ' + pmt + '\n' +
                    approvers_1;
        }
        else {
            var sys = angular.isDefined(sub.system) && sub.system ? 'Yes' : 'No';
            packString =
                'Sub-Status Title : ' + sub.txt + '\n' +
                    'Sub-Status ID : ' + mainStatus + '-' + sub.no + '\n' +
                    'Cycle Time Owner : ' + sub.owner + '\n' +
                    'System-Set : ' + sys;
        }
        return packString;
    };
    /**
     * getMainStatusByMainStatusNo - Function to pull the main status object from within the status config object by number
     *
     * @param  {type} status_no: number The main status number to search for
     * @return {type}                   The main status object containing txt, no and array of sub-status objects
     */
    ConfigurationStatus.prototype.getMainStatusByMainStatusNo = function (status_no) {
        var main = null;
        //if (angular.isDefined(this.tempData.rows)) {
        if (angular.isDefined(this.settings.status_cfg)) {
            //this.tempData.rows.some((mainStatus: any) => {
            this.settings.status_cfg.some(function (mainStatus) {
                if (mainStatus.no === status_no) {
                    main = mainStatus;
                    return true;
                }
            });
        }
        return main;
    };
    /**
     * getSubStatusesByMainStatusNo - Function to get all sub-status objects for a main status
     *
     * @param  {type} status_no: number The main status number to search for
     * @return {type}                   Array of sub-status objects
     */
    ConfigurationStatus.prototype.getSubStatusesByMainStatusNo = function (status_no) {
        var subs = null;
        var activeSubs = [];
        //if (angular.isDefined(this.tempData.rows)) {
        if (angular.isDefined(this.settings.status_cfg)) {
            //this.tempData.rows.some((mainStatus: any) => {
            this.settings.status_cfg.some(function (mainStatus) {
                if (mainStatus.no === status_no) {
                    angular.forEach(mainStatus.subs, function (sub) {
                        // Strip out the inactive ones
                        if (angular.isUndefined(sub.active) || (angular.isDefined(sub.active) && sub.active !== false)) {
                            activeSubs.push(sub);
                        }
                    });
                    return true;
                }
            });
        }
        if (activeSubs.length > 0) {
            return activeSubs;
        }
        return subs;
    };
    /**
     * getAllMainStatuses - Function to build an array of all the Main statuses
     *
     * @return {type}  description
     */
    ConfigurationStatus.prototype.getAllMainStatuses = function () {
        var main = [];
        //if (angular.isDefined(this.tempData.rows)) {
        if (angular.isDefined(this.settings.status_cfg)) {
            //angular.forEach(this.tempData.rows, (stat) => {
            angular.forEach(this.settings.status_cfg, function (stat) {
                main.push(stat.txt);
            });
        }
        return main;
    };
    /**
     * getAllSubStatuses - Function to build and array of all the Sub statuses
     *
     * @return {type}  description
     */
    ConfigurationStatus.prototype.getAllSubStatuses = function () {
        var subs = [];
        //if (angular.isDefined(this.tempData.rows)) {
        if (angular.isDefined(this.settings.status_cfg)) {
            //angular.forEach(this.tempData.rows, (stat) => {
            angular.forEach(this.settings.status_cfg, function (stat) {
                angular.forEach(stat.subs, function (sub) {
                    subs.push(sub.txt);
                });
            });
        }
        return subs;
    };
    /**
     * Function to determine in the sub-status in question is a system-set status
     */
    ConfigurationStatus.prototype.isSystemStatus = function (mainStatusNo, subStatusNo) {
        var status = this.getSubStatusBySubStatusNo2(mainStatusNo, subStatusNo);
        if (angular.isDefined(status) && status.system) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     *  getCountryByName - Function to retrieve the full country name based on the full name, ie:
     *                      Germany would return DE
     *  @return {string} Full country name
     */
    ConfigurationStatus.prototype.getCountryByName = function (fullName) {
        var shortName = fullName;
        if (this.settings.country_list) {
            this.settings.country_list.some(function (cty) {
                if (cty.country === fullName) {
                    shortName = cty.cc;
                    return true;
                }
            });
        }
        return shortName;
    };
    /**
     *  getCountryByShort - Function to retrieve the full country name based on the 2 character shortname, ie:
     *                      DE would return Germany
     *  @return {string} Full country name
     */
    ConfigurationStatus.prototype.getCountryByShort = function (shortName) {
        var fullName = shortName;
        if (this.settings.country_list) {
            this.settings.country_list.some(function (cty) {
                if (cty.short === shortName) {
                    fullName = cty.country;
                    return true;
                }
            });
        }
        return fullName;
    };
    /*
        getStatusConfig() {
          this.socket.emit('module', {
              module: {
                  application: 'dmt',
                  function: 'getStatusConfig',
                  script: '/config/config'
              }
          });
        }
    */
    /**
     * getProgramProfile - Function to make call to server looking for Program Profile(s)
     *
     * @param  {type} topic: any Object containing the following fields from the topic: Country,
     * Program, BP Type, Onshore/Offshore and Brands
     */
    ConfigurationStatus.prototype.getProgramProfile = function (topic) {
        var searchCriteria = {
            country: topic.country,
            program: topic.program,
            bpType: topic.bp_type,
            onoff: topic.onshore_offshore,
            brands: topic.brands
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getProgramProfile',
                script: '/config/config',
                sc: searchCriteria,
                token: this.env.user.token
            }
        });
    };
    ConfigurationStatus.prototype.updateStatusConfig = function (data) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateStatusConfig',
                script: '/config/config',
                data: data,
                token: this.env.user.token
            }
        });
    };
    ConfigurationStatus.prototype.getLatestTermsOfUse = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getLatestTermsOfUse',
                script: '/config/config',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    ConfigurationStatus.prototype.updateUserTermsConfirm = function (vers, profile) {
        this.socket.emit('module', {
            application: 'dmt',
            module: {
                function: 'updateUserTermsConfirm',
                script: '/config/config',
                version: vers,
                user: this.env.user
            }
        });
    };
    ConfigurationStatus.$inject = ['$rootScope', '$timeout', '$q', 'socket', 'env', '$injector', '$filter', 'settings'];
    return ConfigurationStatus;
}());
angular
    .module('application')
    .service('config', ConfigurationStatus);



var DialogService = (function () {
    function DialogService($mdDialog, $sce, $rootScope, socket, env, settings, DTS) {
        this.$mdDialog = $mdDialog;
        this.$sce = $sce;
        this.$rootScope = $rootScope;
        this.socket = socket;
        this.env = env;
        this.settings = settings;
        this.DTS = DTS;
        var test = this;
        return;
    }
    DialogService.prototype.openDialog = function ($event, items, DialogController, template, target) {
        //console.log('Received items ', items);
        var parentEl = angular.element(document.body);
        var mod = this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            templateUrl: template,
            bindToController: true,
            locals: items,
            //controller: DialogController,
            controller: ['$mdDialog', function ($mdDialog) {
                    var _this = this;
                    var dResult = this;
                    dResult.comment = 'test';
                    dResult.teamname = items.name;
                    dResult.people = items.members;
                    // you will be returning quest
                    this.clickYes = function ($event) {
                        dResult.confirm = true;
                        $mdDialog.hide(dResult);
                    };
                    this.clickNo = function ($event) {
                        dResult.confirm = false;
                        $mdDialog.hide(dResult);
                    };
                    this.cancel = function ($event) {
                        $mdDialog.cancel();
                    };
                    this.getAvatar = function (email) {
                        return _this.DTS.getAvatar(email, 115);
                    };
                }],
            controllerAs: 'vm',
            clickOutsideToClose: true,
            escapeToClose: true,
            closeTo: parentEl
        });
        return mod;
    };
    DialogService.prototype.openDialog2 = function ($event, items, DialogController, template, target, scope) {
        var parentEl = angular.element(document.body);
        var mod = this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            templateUrl: template,
            bindToController: true,
            locals: items,
            preserveScope: true,
            scope: scope,
            controller: DialogController,
            controllerAs: 'vm',
            clickOutsideToClose: true,
            escapeToClose: true,
            closeTo: parentEl
        });
        return mod;
    };
    DialogService.prototype.confirmDelete = function ($event, sample) {
        var parentEl = angular.element(document.body);
        return this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            template: "\n                <md-dialog>\n                    <p> Are you sure you want to delete this line?</p>\n                    <md-button ng-click=\"vm.confirmDelete()\"> OK </md-button>\n                    <md-button ng-click=\"vm.cancelDelete()\"> Cancel </md-button>\n                </md-dialog>\n                ",
            bindToController: true,
            controller: ['$mdDialog', function ($mdDialog) {
                    var isConfirmed = false;
                    this.confirmDelete = function () {
                        isConfirmed = true;
                        $mdDialog.hide(isConfirmed);
                    };
                    this.cancelDelete = function () {
                        $mdDialog.hide(isConfirmed);
                    };
                }],
            locals: sample,
            controllerAs: 'vm',
            clickOutsideToClose: false,
            escapeToClose: false,
            closeTo: parentEl
        });
    };
    DialogService.prototype.showingErrors = function ($event, sample, template) {
        var parentEl = angular.element(document.body);
        return this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            locals: sample,
            templateUrl: template,
            bindToController: true,
            controller: ['$mdDialog', function ($mdDialog) {
                    var isOk = false;
                    this.confirmOk = function () {
                        isOk = true;
                        $mdDialog.hide(isOk);
                    };
                }],
            controllerAs: 'vm',
            clickOutsideToClose: true,
            escapeToClose: true,
            closeTo: parentEl
        });
    };
    DialogService.prototype.openDialog3 = function ($event, items, DialogController, template, target, scope) {
        var parentEl = angular.element(document.body);
        var try1 = scope.vm;
        //console.log('SCOPE =>', try1);
        var mod = this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            templateUrl: template,
            bindToController: true,
            locals: items,
            preserveScope: true,
            controller: DialogController,
            controllerAs: 'vm',
            clickOutsideToClose: true,
            escapeToClose: false,
            closeTo: parentEl
        });
        return mod;
    };
    /* dialog for validation tab. Where there are these fields : Old value, new value and
    *comments the following contorller handles the save, cancel events
    */
    DialogService.prototype.updateValidForm = function ($event, items, template, target) {
        var parentEl = angular.element(document.body);
        // console.log(items);
        return this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            templateUrl: template,
            bindToController: true,
            locals: items,
            //controller: DialogController,
            controller: ['$mdDialog', function ($mdDialog) {
                    var dResult = this;
                    dResult.comment = '';
                    // you will be returning quest
                    this.clickYes = function ($event) {
                        dResult.confirm = true;
                        $mdDialog.hide(dResult);
                    };
                    this.clickUploadAdd = function ($event, data) {
                        dResult.confirm = true;
                        dResult.data = data;
                        $mdDialog.hide(dResult);
                    };
                    this.clickUploadReplace = function ($event, data) {
                        dResult.confirm = true;
                        dResult.data = data;
                        $mdDialog.hide(dResult);
                    };
                    this.clickNo = function ($event) {
                        dResult.confirm = false;
                        $mdDialog.hide(dResult);
                    };
                    this.picChange = function ($event) {
                        dResult.divdiv = $event.target.innerHTML;
                    };
                    this.cancel = function ($event) {
                        $mdDialog.cancel();
                    };
                    this.finish = function ($event) {
                        $mdDialog.hide();
                    };
                    this.answer = function () {
                        //pass quest to hide function.
                        $mdDialog.hide(dResult);
                    };
                    this.changeOppty = function () {
                        dResult.confirm = true;
                        //dResult.newOppty = this.newOppty;
                        $mdDialog.hide(dResult);
                    };
                    this.removeBtn = function () {
                        dResult.confirm = true;
                        $mdDialog.hide(dResult);
                    };
                    // converts the lotus notes link into a clickable link
                    this.convertNotesLink = function () {
                        dResult.processing = true;
                        var tempText = dResult.comment;
                        if (angular.isDefined(dResult.comment) && (tempText.match(/\<NDL\>/g) || []).length) {
                            var noMoreFound = false;
                            var replaceText = '';
                            var ndl = void 0;
                            var hint = void 0;
                            var replica = void 0;
                            var view = void 0;
                            var note = void 0;
                            var rem = void 0;
                            var dbPath = void 0;
                            var docPath = void 0;
                            do {
                                var replaceRem = '';
                                // Look for <NDL> and </NDL> so I can determine, which part is gonna be replaced
                                ndl = { start: -1, end: -1, content: '' };
                                hint = { start: -1, end: -1, content: '' };
                                replica = { start: -1, end: -1, content: '' };
                                view = { start: -1, end: -1, content: '' };
                                note = { start: -1, end: -1, content: '' };
                                dbPath = { start: -1, end: -1, content: '' };
                                docPath = { start: -1, end: -1, content: '' };
                                rem = { start: -1, end: -1, content: '' };
                                ndl.start = tempText.indexOf('<NDL>');
                                ndl.end = tempText.indexOf('</NDL>') + 6;
                                if (ndl.start > -1 && ndl.end > -1 && ndl.end > ndl.start) {
                                    ndl.content = tempText.substring(ndl.start, ndl.end);
                                    var ndlText = angular.copy(ndl.content);
                                    // In hint the server is located and we will convert link only when we get the server
                                    hint.start = ndlText.indexOf('<HINT>CN=');
                                    if (hint.start > -1 && ndlText.length > hint.start + 1) {
                                        hint.end = ndlText.indexOf('/', hint.start + 1);
                                        if (hint.end > -1 && hint.end > hint.start + 9) {
                                            hint.temp = angular.copy(ndlText);
                                            hint.temp = hint.temp.substring(hint.start + 9, hint.end);
                                            hint.content = hint.temp.replace('/', '').trim();
                                        }
                                    }
                                    ;
                                    // Replica contain important information for the link
                                    replica.start = ndlText.indexOf('<REPLICA');
                                    if (replica.start > -1 && ndlText.length > replica.start + 1) {
                                        replica.end = ndlText.indexOf('>', replica.start);
                                        if (replica.end > -1 && replica.end > replica.start + 8) {
                                            replica.temp = angular.copy(ndlText);
                                            replica.temp = replica.temp.substring(replica.start + 8, replica.end);
                                            replica.content = replica.temp.replace(new RegExp('-ON', 'g'), '').replace(new RegExp(':', 'g'), '').trim();
                                        }
                                    }
                                    // View contains important information for the document link
                                    view.start = ndlText.indexOf('<VIEW OF');
                                    if (view.start > -1 && ndlText.length > view.start + 1) {
                                        view.end = ndlText.indexOf('>', view.start + 1);
                                        if (view.end > -1 && view.end > view.start + 8) {
                                            view.temp = angular.copy(ndlText);
                                            view.temp = view.temp.substring(view.start + 8, view.end);
                                            view.content = view.temp.replace(new RegExp('-ON', 'g'), '').replace(new RegExp(':', 'g'), '').trim();
                                        }
                                    }
                                    ;
                                    // note contains important information for the document link
                                    note.start = ndlText.indexOf('<NOTE OF');
                                    if (note.start > -1 && ndlText.length > note.start + 1) {
                                        note.end = ndlText.indexOf('>', note.start);
                                        if (note.end > -1 && note.end > note.start + 8) {
                                            note.temp = angular.copy(ndlText);
                                            note.temp = note.temp.substring(note.start + 8, note.end);
                                            note.content = note.temp.replace(new RegExp('-ON', 'g'), '').replace(new RegExp(':', 'g'), '').trim();
                                        }
                                    }
                                    // Looking for REM to remove the Free text name before the NDL xml object
                                    rem.start = ndlText.indexOf('<REM>');
                                    if (rem.start > -1 && ndlText.length > rem.start + 1) {
                                        rem.end = ndlText.indexOf('</REM>', rem.start + 1);
                                        if (rem.end > -1 && rem.end > rem.start + 5) {
                                            rem.temp = angular.copy(ndlText);
                                            rem.temp = rem.temp.substring(rem.start + 5, rem.end);
                                            dbPath.start = rem.temp.indexOf('Database \'');
                                            docPath.start = rem.temp.indexOf('Document \'');
                                            // If document link, there is a different format of the REM compared to database link.
                                            if (dbPath.start > -1 && docPath.start > -1) {
                                                // DOcument link
                                                if (rem.temp.length > dbPath.start + 10) {
                                                    dbPath.end = rem.temp.indexOf('\'', dbPath.start + 10);
                                                    if (dbPath.end > -1 && dbPath.end > dbPath.start) {
                                                        dbPath.content = rem.temp.substring(dbPath.start + 10, dbPath.end);
                                                    }
                                                }
                                                if (rem.temp.length > docPath.start + 10) {
                                                    docPath.end = rem.temp.indexOf('\'', docPath.start + 10);
                                                    if (docPath.end > -1 && docPath.end > docPath.start) {
                                                        docPath.content = rem.temp.substring(docPath.start + 10, docPath.end);
                                                    }
                                                }
                                                if (dbPath.content.length > 0 && docPath.content.length > 0) {
                                                    replaceRem = dbPath.content + ' - ' + docPath.content;
                                                }
                                            }
                                            else {
                                                // Database link
                                                replaceRem = rem.temp;
                                            }
                                            rem.content = rem.temp.replace('/', '').trim();
                                        }
                                    }
                                    ;
                                    // Replace the copy object with the actual link.
                                    if (hint.content.length > 0 && replica.content.length > 0) {
                                        replaceText = 'Notes://' + hint.content + '/' + replica.content + '/';
                                        if (view.content.length > 0) {
                                            replaceText = replaceText + view.content + '/';
                                        }
                                        if (note.content.length > 0) {
                                            replaceText = replaceText + note.content;
                                        }
                                        tempText = tempText.replace(ndlText, replaceText);
                                        tempText = tempText.replace(replaceRem, '');
                                    }
                                }
                                else {
                                    noMoreFound = true;
                                }
                            } while (!noMoreFound);
                        }
                        dResult.comment = tempText;
                        dResult.processing = false;
                    };
                }],
            controllerAs: 'vm',
            clickOutsideToClose: true,
            escapeToClose: true,
            closeTo: parentEl
        });
    };
    /* dialog for validation tab. Where there are these fields : Old value, new value and
    *comments the following contorller handles the save, cancel events
    */
    DialogService.prototype.YesNoForm = function ($event, items, template, target) {
        var parentEl = angular.element(document.body);
        //console.log(items);
        return this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            templateUrl: template,
            bindToController: true,
            locals: items,
            //controller: DialogController,
            controller: ['$mdDialog', function ($mdDialog) {
                    var dResult = this;
                    // you will be returning quest
                    this.clickYes = function ($event) {
                        dResult.confirm = true;
                        $mdDialog.hide(dResult);
                    };
                    this.clickNo = function ($event) {
                        dResult.confirm = false;
                        $mdDialog.hide(dResult);
                    };
                    this.cancel = function ($event) {
                        $mdDialog.cancel();
                    };
                    this.finish = function ($event) {
                        $mdDialog.hide();
                    };
                    this.answer = function () {
                        //pass quest to hide function.
                        $mdDialog.hide(dResult);
                    };
                }],
            controllerAs: 'vm',
            clickOutsideToClose: false,
            escapeToClose: false,
            closeTo: parentEl
        });
    };
    /* dialog for validation tab. Where there are these fields : Old value, new value and
    *comments the following contorller handles the save, cancel events
    */
    DialogService.prototype.searchResultsForm = function ($event, items, template, target) {
        var parentEl = angular.element(document.body);
        //console.log(items);
        var socketTemp = this.socket;
        var rootScopeTemp = this.$rootScope;
        var envTemp = this.env;
        return this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            templateUrl: template,
            bindToController: true,
            locals: items,
            //controller: DialogController,
            controller: ['$mdDialog', function ($mdDialog) {
                    var _this = this;
                    var dResult = this;
                    /*socketTemp.forward('topic.search.export', rootScopeTemp);
                    rootScopeTemp.$on('socket:topic.search.export', (event: ng.IAngularEvent, data: any) => {
                      if (angular.isDefined(data)) {
                          let a: HTMLElement = document.createElement('A');
                          document.body.appendChild(a);
                          a.setAttribute('style', 'display: none;');
                          let url = window.URL.createObjectURL(new Blob([data.payload], {
                              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                          }));
                          a.setAttribute('href', url);
                          let d = new Date().toDateString();
                          a.setAttribute('download', `DMT-Search-Report_${d}.xlsx`);
                          a.click();
                      }
                    });*/
                    this.dontSave = function ($event) {
                        $mdDialog.hide();
                    };
                    this.save = function () {
                        //pass quest to hide function.
                        $mdDialog.hide(dResult);
                    };
                    this.excelExport = function () {
                        socketTemp.emit('module', {
                            module: {
                                application: 'dmt',
                                function: 'searchExportExcel',
                                script: '/detail/eligibility/eligibility',
                                data: _this.item.table,
                                token: envTemp.user.token
                            }
                        });
                    };
                    this.removeItem = function (item) {
                        var position = _this.results.table.indexOf(item);
                        if (position > -1) {
                            _this.results.table.splice(position, 1);
                        }
                    };
                    this.addItem = function (item) {
                        if (_this.results.table.indexOf(item) < 0) {
                            _this.results.table.push(item);
                        }
                    };
                }],
            controllerAs: 'vm',
            clickOutsideToClose: false,
            escapeToClose: false,
            closeTo: parentEl
        });
    };
    //createODSList($event: any, odsDataList: any) {
    // Mimmo - 20180308 - Technical note: below table is fed by odsTables.ts controller.
    DialogService.prototype.createODSList = function (odsDataList, isV4OrLater) {
        var parentEl = angular.element(document.body);
        var seLabel = isV4OrLater ? 'Engagement Id' : 'Solution Id';
        return this.$mdDialog.show({
            parent: angular.element(document.body),
            //targetEvent: $event,
            //RselCustNum => t2Name
            template: "\n                <md-dialog>\n                        <md-toolbar>\n                        <div class=\"md-toolbar-tools\">\n                            <h2>Please Select a Sales Order to Validate</h2>\n                            <span flex></span>\n                            <md-button class=\"md-icon-button\" ng-click=\"vm.cancelSO()\">\n                            <md-icon class=\"white_icon\" md-svg-src=\"/public/images/ic_close_white_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n                            </md-button>\n                        </div>\n                        </md-toolbar>\n                    <md-dialog-content style=\"max-width:1000px;max-height:910px; \" >\n                        <table class=\"ibm-data-table ibm-grid ibm-altrows\" style=\"margin: 10px;\">\n                            <thead>\n                                <tr> \n                                     <td class=\"ibm-bgcolor-gray-10\"> Select </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Invoice Number </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> SO Number </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Charge Agreement Num </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Customer Name </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Country </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> SO Date </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Reseller </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Payer </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Part Number </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Brand Family </td> \n                                    <td class=\"ibm-bgcolor-gray-10\"> " + seLabel + " </td>      \n                                    <td class=\"ibm-bgcolor-gray-10\"> Extended Price </td> \n                                    <td class=\"ibm-bgcolor-gray-10\"> Customer Designation </td> \n                            </thead>\n                            <tbody style=\"font-size:small\">\n                                <tr ng-repeat=\"oneODS in vm.data\">\n                                    <td> \n                                        <div class = \"select_good checkbox_subcontainer\" ng-style=\"!vm.isDisabledOrder(oneODS) && {'background-color': '#e5e5e5'}\">\n                                            <input type=\"checkbox\" ng-model=\"oneODS.isChecked\"\n                                            ng-disabled=\"!vm.isDisabledOrder(oneODS)\" ng-change=\"vm.checkOrder(oneODS)\" style=\"    width: 20px;\n                                            height: 30px;\">\n                                        </div>\n                                    </td>\n                                    <td> \n                                        <p>{{oneODS.invoiceNo}} </p>\n                                    </td>\n                                    <td> \n                                          <a ng-click=\"$event.preventDefault();vm.confirmSO(oneODS)\">{{oneODS.soNumber}} </a>\n                                    </td>\n                                    <td>\n                                        <p style=\"font-size:small\">{{oneODS.chargeAgreementNum ? oneODS.chargeAgreementNum : '-' }}</p>\n                                    </td>\n                                    <td>\n                                        <p style=\"font-size:small\">{{oneODS.bpName}}</p>\n                                    </td>\n                                    <td> \n                                        <p style=\"font-size:small\">{{oneODS.bpCty}}</p>\n                                    </td>\n                                    <td> \n                                        <p style=\"font-size:small\">{{oneODS.soDate}}</p>\n                                    </td>\n                                    <td> \n                                        <p style=\"font-size:small\">{{oneODS.tier2ResellerNum}}</p> \n                                    </td>\n                                    <td> \n                                        <p style=\"font-size:small\">{{oneODS.tier1DistrNum}}</p>\n                                    </td>\n                                    <td> \n                                        <li style=\"width:max-content\" ng-repeat=\"oneItem in oneODS.itemList\">{{oneItem.pn}}</li>\n                                    </td>\n                                    <td> \n                                        <li style=\"width:max-content\" ng-repeat=\"oneItem in oneODS.itemList\">{{oneItem.brandfamDesc || 'No Description found'}}</li>\n                                    </td>\n                                    <td> \n                                        <li style=\"width:max-content\" ng-repeat=\"oneItem in oneODS.itemList\">{{oneItem.solutionId || 'N/A'}}</li> \n                                    </td>\n                                    <td>\n                                        <li style=\"width:max-content\" ng-repeat=\"oneItem in oneODS.itemList\">{{oneItem.extendPrice | number: 2}}</li>\n                                    </td>\n                                    <td> \n                                        <li style=\"width:max-content\" ng-repeat=\"oneItem in oneODS.itemList\">{{oneItem.customerSegmentCode || 'N/A'}}</li>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                        <md-button ng-click=\"vm.cancelSO()\" class=\"ibm-btn-pri ibm-btn-small ibm-btn-red-50\"><md-icon class=\"white_icon\" md-svg-icon=\"/public/images/close-circle.svg\"></md-icon> Cancel </md-button>\n                        <md-button ng-disabled=\"!(vm.isOrderSelect)\" ng-click=\"vm.confirmSO()\" class=\"ibm-btn-pri ibm-btn-small ibm-btn-green-50\"> OK </md-button>\n                        </md-dialog-content>\n                </md-dialog>\n                ",
            bindToController: true,
            controller: ['$mdDialog', function ($mdDialog) {
                    var confirmSO = null;
                    var selectedOrders = [];
                    var splitByOrder = [];
                    var soList = [];
                    this.isOrderSelect = false;
                    odsDataList.data.forEach(function (oneData) {
                        if (soList.indexOf(oneData.soNumber) < 0) {
                            splitByOrder.push({ soNumber: oneData.soNumber, data: [oneData] });
                            soList.push(oneData.soNumber);
                        }
                        else {
                            var whereTo = soList.indexOf(oneData.soNumber);
                            splitByOrder[whereTo].data.push(oneData);
                        }
                    });
                    this.sentSelectedOrders = function (orders) {
                        var invoice_numbers = [];
                        orders.forEach(function (el, i) {
                            invoice_numbers.push(el.invoiceNo);
                            if (i !== 0) {
                                orders[0].itemList = orders[0].itemList.concat(el.itemList);
                            }
                        });
                        confirmSO = { data: orders[0], invoice: invoice_numbers };
                        $mdDialog.hide(confirmSO);
                    };
                    this.confirmSO = function (oneODS) {
                        var _this = this;
                        if (oneODS) {
                            splitByOrder.forEach(function (el) {
                                if (el.soNumber === oneODS.soNumber) {
                                    _this.sentSelectedOrders(el.data);
                                }
                            });
                        }
                        else {
                            this.sentSelectedOrders(selectedOrders);
                        }
                    };
                    this.isDisabledOrder = function (odsData) {
                        var isMultipleOrder = false;
                        splitByOrder.forEach(function (el) {
                            if (el.soNumber === odsData.soNumber && el.data.length > 1 && el.data.findIndex(function (el) { return el.isChecked === true; }) > -1) {
                                isMultipleOrder = true;
                            }
                        });
                        if (odsData.isChecked || selectedOrders.length === 0) {
                            return true;
                        }
                        else {
                            return isMultipleOrder ? true : false;
                        }
                    };
                    this.cancelSO = function () {
                        $mdDialog.hide(confirmSO);
                    };
                    this.checkOrder = function (ODS) {
                        if (ODS.isChecked) {
                            selectedOrders.push(ODS);
                            this.isOrderSelect = true;
                        }
                        else {
                            var toDel = selectedOrders.indexOf(ODS);
                            selectedOrders.splice(toDel);
                            this.isOrderSelect = false;
                        }
                    };
                }],
            locals: odsDataList,
            controllerAs: 'vm',
            clickOutsideToClose: false,
            escapeToClose: false,
            closeTo: parentEl
        });
    };
    DialogService.prototype.cancel = function () {
        this.$mdDialog.cancel();
    };
    DialogService.prototype.closeDialog = function () {
        this.$mdDialog.cancel();
    };
    /*
        cancel = function($event: any) {
          this.$mdDialog.cancel();
          alert('Cancel');
        };

        finish = function($event: any) {
          this.$mdDialog.hide();
          alert('Finish');
        };

        answer = (test: any) => {
        //pass quest to hide function.
         this.$mdDialog.hide(test);
         alert('answer');
        };
        */
    DialogService.prototype.showOnlyMessage = function (textLines) {
        // const textLines = {
        //    msgLines: ['Order has been reevaluated']
        // }
        var parentEl = angular.element(document.body);
        return this.$mdDialog.show({
            parent: angular.element(document.body),
            //targetEvent: $event,
            //RselCustNum => t2Name
            template: "\n                <md-dialog>\n                        <p ng-repeat=\"oneLine in vm.msgLines\">{{oneLine}}</p> <!-- singleLineText -->\n                    <md-button ng-click=\"vm.ok()\"> OK </md-button>\n                </md-dialog>\n                ",
            bindToController: true,
            controller: ['$mdDialog', function ($mdDialog) {
                    this.ok = function () {
                        $mdDialog.hide();
                    };
                }],
            locals: textLines,
            controllerAs: 'vm',
            clickOutsideToClose: false,
            escapeToClose: false,
            closeTo: parentEl
        });
    };
    DialogService.$inject = ['$mdDialog', '$sce', '$rootScope', 'socket', 'env', 'settings', 'DTS'];
    return DialogService;
}());
angular
    .module('application')
    .service('Dialog', DialogService);



'use strict';
var dynamic = (function () {
    function dynamic($compile) {
        this.$compile = $compile;
        this.replace = true;
        this.restrict = 'A';
    }
    dynamic.prototype.link = function (scope, element, attrs) {
        var _this = this;
        scope.$watch(attrs.dynamic, function (html) {
            element.html(html);
            _this.$compile(element.contents())(scope);
        });
    };
    dynamic.factory = function () {
        var directive = function ($compile) { return new dynamic($compile); };
        directive.$inject = ['$compile'];
        return directive;
    };
    return dynamic;
}());
angular
    .module('application')
    .directive('dynamic', dynamic.factory());



var EnvService = (function () {
    function EnvService($localStorage) {
        this.$localStorage = $localStorage;
        this.notifications = 'on';
        this.loaded = { env: false, config: false, topic: false };
        this.topics = [];
        this.user = {
            email: null,
            name: null,
            token: null,
            loggedIn: false,
            access: {},
            allowed: false,
            approver: false,
            termsOk: true
        };
        this.promises = {};
    }
    EnvService.prototype.getRoleAsString = function () {
        if (this.user.access.bpsoAdmin) {
            return 'BPSO Administrator';
        }
        else if (this.user.access.nonBpsoAdmin) {
            return 'Non-BPSO Administrator';
        }
        else if (this.user.access.bpsoApprover) {
            return 'BPSO Approver';
        }
        else if (this.user.access.nonBpsoApprover) {
            return 'Non-BPSO Approver';
        }
        else if (this.user.access.reader) {
            return 'Reader';
        }
        else if (this.user.access.systemAdmin) {
            return 'System Administrator';
        }
    };
    /**
     * getDefaultQueue - Get default queue for a user based on their access.  My Queue for Admin; Workitems for everyone else
     *
     * @return {type}  description state id for queue/:id
     */
    EnvService.prototype.getDefaultQueue = function () {
        if (this.user.access.bpsoAdmin || this.user.access.nonBpsoAdmin) {
            return 'myqueue';
        }
        else if (this.user.approver) {
            return 'approval';
        }
        return 'workitems'; //probably end up as Teams' Queue...
    };
    EnvService.prototype.setUser = function (obj) {
        for (var prop in obj) {
            if (!obj.hasOwnProperty(prop)) {
                continue;
            }
            ;
            //  console.log(prop + ' = ' + obj[prop]);
            this.user[prop] = obj[prop];
        }
        this.loaded.env = true;
    };
    EnvService.prototype.revokeUser = function () {
        this.user = {
            email: null,
            name: null,
            token: null,
            loggedIn: false,
            access: [],
            allowed: false,
            approver: false,
            uid: null
        };
        this.$localStorage.$reset();
    };
    EnvService.prototype.updateLoaded = function (type, value) {
        this.loaded[type] = value;
    };
    EnvService.$inject = [
        '$localStorage',
    ];
    return EnvService;
}());
angular
    .module('application')
    .service('env', EnvService);



var ModelFilter = (function () {
    function ModelFilter() {
    }
    //static $inject = ['topic'];
    ModelFilter.Factory = function () {
        return function (arr, targetField) {
            var results = [];
            var foundValues = [];
            angular.forEach(arr, function (lineItem) {
                if (foundValues.indexOf(lineItem[targetField]) < 0) {
                    foundValues.push(lineItem[targetField]);
                    results.push(lineItem);
                }
            });
            return results;
        };
    };
    return ModelFilter;
}());
ModelFilter = ModelFilter;
var ApproverFilter = (function () {
    function ApproverFilter() {
    }
    ApproverFilter.Factory = function () {
        return (function (componentArray, namesToExclude) {
            angular.forEach(componentArray, function (approver) {
                var i = namesToExclude.indexOf(approver.email);
                if (i > -1) {
                    componentArray.splice(i, 1);
                }
            });
            return componentArray;
        });
    };
    return ApproverFilter;
}());
ApproverFilter = ApproverFilter;
var StatusFilter = (function () {
    function StatusFilter() {
    }
    StatusFilter.Factory = function () {
        return function (stats) {
            var results = [];
            angular.forEach(stats, function (sub) {
                // Only add to the list if:
                if ((!sub.system || (sub.system && sub.systemOverride)) &&
                    sub.active !== false &&
                    (angular.isUndefined(sub.ignore) || (angular.isDefined(sub.ignore) && !sub.ignore))) {
                    results.push(sub);
                }
            });
            return results;
        };
    };
    return StatusFilter;
}());
StatusFilter = StatusFilter;
var IOTFilter = (function () {
    function IOTFilter() {
    }
    IOTFilter.Factory = function () {
        return function (countries, iots) {
            var results = [];
            angular.forEach(countries, function (cty) {
                //If the country's IOT is in the array AND the ic is set to Country
                if (angular.isDefined(iots) && iots.indexOf(cty.imt) > -1 && cty.ic === 'Country') {
                    results.push(cty);
                }
            });
            return results;
        };
    };
    return IOTFilter;
}());
IOTFilter = IOTFilter;
var RevFilter = (function () {
    function RevFilter() {
    }
    RevFilter.Factory = function () {
        return function (items) {
            return items.slice().reverse();
        };
    };
    return RevFilter;
}());
RevFilter = RevFilter;
var LinkyNotesFilter = (function () {
    function LinkyNotesFilter() {
    }
    LinkyNotesFilter.Factory = function ($sce) {
        /*
        var urlPattern = /(http|ftp|https|Notes):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/gi;
        return function (text: string, target: string) {
            return text.replace(urlPattern, '<a target="' + target + '" href="$&">$&</a>') ;
        */
        return function (text, target) {
            if (angular.isDefined(text)) {
                var foundLinks = text.match(/((http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])|(notes:\/\/[\w-.\/]+))/gi);
                //console.log('converting text: ' + text);
                var uniqueLinks = [];
                var foundDuplicate = void 0;
                if (angular.isDefined(foundLinks) && foundLinks !== null) {
                    for (var fl = 0; fl < foundLinks.length; fl++) {
                        foundDuplicate = false;
                        for (var ul = 0; ul < uniqueLinks.length; ul++) {
                            if (foundLinks[fl].indexOf(uniqueLinks[ul]) > -1) {
                                foundDuplicate = true;
                            }
                        }
                        ;
                        if (!foundDuplicate) {
                            uniqueLinks.push(foundLinks[fl]);
                        }
                    }
                }
                angular.forEach(uniqueLinks, function (link) {
                    //console.log('link is: ' + link + '.');
                    //console.log('<a target="' + target + '" href="' + link + '">' + link + '</a>');
                    //text = text.replace(link, '<a target="' + target + '" href="' + link + '">' + link + '</a>') ;
                    if (link.toLowerCase().indexOf('notes://') > -1) {
                        text = text.replace(new RegExp(link, 'g'), '<a target="_self" href="' + link + '" title="' + link + '">Lotus Link</a>');
                    }
                    else {
                        text = text.replace(new RegExp(link, 'g'), '<a target="' + target + '" href="' + link + '">' + link + '</a>');
                    }
                });
                text = text.split('<+g>').join('<span class="green_text"><b>');
                text = text.split('</+g>').join('</b></span>');
                text = text.split('<+r>').join('<span class="red_text"><b>');
                text = text.split('</+r>').join('</b></span>');
                text = text.split('<+b>').join('<span class="blue_text"><b>');
                text = text.split('</+b>').join('</b></span>');
                text = text.split('<+c>').join('<b>');
                text = text.split('</+c>').join('</b>');
                //return text;
                return $sce.trustAsHtml(text);
            }
            else {
                return '';
            }
        };
    };
    LinkyNotesFilter.replaceAll = function (target, search, replacement) {
        return target.replace(new RegExp(search, 'g'), replacement);
    };
    return LinkyNotesFilter;
}());
LinkyNotesFilter = LinkyNotesFilter;
angular
    .module('application')
    .filter('uniqueF', ModelFilter.Factory)
    .filter('multiIOT', IOTFilter.Factory)
    .filter('statusFilter', StatusFilter.Factory)
    .filter('reverseF', RevFilter.Factory)
    .filter('appFilter', ApproverFilter.Factory)
    .filter('linkyWithNotes', ['$sce', LinkyNotesFilter.Factory]);



'use strict';
var IbmBackToTop = (function () {
    function IbmBackToTop() {
        this.restrict = 'A';
    }
    IbmBackToTop.instance = function () {
        return new IbmBackToTop;
    };
    IbmBackToTop.prototype.link = function (scope, element) {
        var isActive = false, didScroll = false, windowHeight = $(window).height();
        var buttonAppendTo = $('#ibm-content-body')[0], buttonText = 'Back';
        $(window).scroll(function () {
            didScroll = true;
        });
        setInterval(function () {
            if (didScroll) {
                didScroll = false;
                toggleBackToTop();
            }
        }, 500);
        $(function () {
            // Remove any existing one b/c we're injecting a new one (for cases dynamic locale change).
            $(buttonAppendTo).find('.ibm-btt-auto').remove();
            var appel = '<p class="ibm-ind-link ibm-nospacing ibm-icononly ibm-btt-auto ibm-hidden-small">' +
                '<a class="ibm-nospacing ibm-chevron-up-link" aria-label="' +
                buttonText + '" href="#top">' + buttonText + '</a></p>';
            $(appel)
                .appendTo(buttonAppendTo)
                .children('a')
                .attr('tabindex', '-1')
                .click(function (evt) {
                var duration = ($(window).scrollTop() / 2);
                evt.preventDefault();
                $('html, body').animate({
                    scrollTop: 0
                }, duration);
            });
            toggleBackToTop();
        });
        function toggleBackToTop() {
            //console.log('$(window)=', $(window));
            if ($(window).scrollTop() > windowHeight && !isActive) {
                $('.ibm-btt-auto').addClass('ibm-active').children('a').attr('tabindex', '0');
                isActive = true;
            }
            else if ($(window).scrollTop() < windowHeight && isActive) {
                $('.ibm-btt-auto').removeClass('ibm-active').children('a').attr('tabindex', '-1');
                isActive = false;
            }
        }
    };
    return IbmBackToTop;
}());
angular
    .module('application')
    .directive('ibmBackToTop', IbmBackToTop.instance);



'use strict';
var ibmParallaxScroll = (function () {
    function ibmParallaxScroll() {
        this.restrict = 'A';
    }
    ibmParallaxScroll.instance = function () {
        return new ibmParallaxScroll;
    };
    ibmParallaxScroll.prototype.link = function (scope, element, attrs) {
        var $el = element;
        var scrollspeed = $el.data("scrollspeed") || 2;
        var backgroundX = $el.css("backgroundPosition").split(" ")[0];
        var disabledSmall = $el.data("disablesmallgrid");
        // Add class that sets the proper styles.
        $el.addClass("ibm-parallax-scroll");
        function adjustImage() {
            var $window = $(window), bgpos = backgroundX + " " + -Math.floor((Math.floor($window.scrollTop()) - Math.floor($el.offset()
                .top)) / scrollspeed) + "px";
            if (disabledSmall && $("html").hasClass("ibm-grid-small")) {
                return;
            }
            $el.css("background-position", bgpos);
        }
        // Bind the background to shift whenever the page scrolls.
        $(window).scroll(adjustImage);
        // Adjust image onload.
        adjustImage();
    };
    return ibmParallaxScroll;
}());
angular
    .module('application')
    .directive('ibmParallaxScroll', ibmParallaxScroll.instance);



'use strict';
var ibmStickyFooter = (function () {
    function ibmStickyFooter($window) {
        this.$window = $window;
        this.restrict = 'A';
    }
    ibmStickyFooter.prototype.link = function (scope, element, iAttrs) {
        var stickyFooterWrapper = $(iAttrs.stickyFooter);
        stickyFooterWrapper.parents().css('height', '100%');
        stickyFooterWrapper.css({
            'min-height': '100%',
            'height': 'auto'
        });
        // Append a pushing div to the stickyFooterWrapper.
        var stickyFooterPush = $('<div class="push"></div>');
        stickyFooterWrapper.append(stickyFooterPush);
        var setHeights = function () {
            var height = element.outerHeight();
            stickyFooterPush.height(height);
            stickyFooterWrapper.css('margin-bottom', -(height));
        };
        $(window).on('resize', setHeights);
    };
    ibmStickyFooter.factory = function () {
        var directive = function ($window) { return new ibmStickyFooter($window); };
        directive.$inject = ['$window'];
        return directive;
    };
    return ibmStickyFooter;
}());
angular
    .module('application')
    .directive('ibmStickyFooter', function () { return ibmStickyFooter.factory(); });



'use strict';
var ibmStickyHeader = (function () {
    function ibmStickyHeader($window) {
        this.$window = $window;
        this.restrict = 'A';
    }
    ibmStickyHeader.instance = function () {
        return new ibmParallaxScroll;
    };
    ibmStickyHeader.prototype.link = function (scope, element) {
        var windowEl = angular.element(this.$window);
        var body = angular.element(document).find('body');
        var b = element.height();
        var c = false;
        var handler = function () {
            var a = windowEl.scrollTop();
            if (a >= b) {
                if (c) {
                    return;
                }
                else {
                    body.addClass('ibm-sitenav-menu-sticky');
                    c = true;
                }
            }
            else {
                c = false;
                body.removeClass('ibm-sitenav-menu-sticky');
            }
        };
        windowEl.on('scroll', scope.$apply.bind(scope, handler));
        handler();
    };
    ibmStickyHeader.factory = function () {
        var directive = function ($window) { return new ibmStickyHeader($window); };
        directive.$inject = ['$window'];
        return directive;
    };
    return ibmStickyHeader;
}());
angular
    .module('application')
    .directive('ibmStickyHeader', function () { return ibmStickyHeader.factory(); });



'use strict';
var ibmUserHover = (function () {
    function ibmUserHover() {
        this.restrict = 'A';
    }
    ibmUserHover.prototype.link = function (scope, element) {
        element.bind('mouseover', function () {
            element.addClass("ibm-active");
        });
        element.bind('mouseout', function (e) {
            element.removeClass("ibm-active");
        });
    };
    ibmUserHover.instance = function () {
        return new ibmUserHover;
    };
    return ibmUserHover;
}());
angular
    .module('application')
    .directive('ibmUserHover', ibmUserHover.instance);



var jwtHelper = (function () {
    function jwtHelper() {
    }
    jwtHelper.prototype.validateToken = function (token) {
        var output = token.replace(/-/g, '+').replace(/_/g, '/');
        switch (output.length % 4) {
            case 0: {
                break;
            }
            case 2: {
                output += '==';
                break;
            }
            case 3: {
                output += '=';
                break;
            }
            default: {
                throw 'Illegal base64url string!';
            }
        }
        return output;
    };
    jwtHelper.prototype.encodeToken = function (token) {
        try {
            //const encoded: string = encodeURIComponent(encodeURI(window.btoa(token))); //polifyll https://github.com/davidchambers/Base64.js            
            var encoded = encodeURIComponent(window.btoa(token)); //polifyll https://github.com/davidchambers/Base64.js            
            return encoded;
        }
        catch (e) {
            throw new Error('Cannot encode the token');
        }
    };
    jwtHelper.prototype.updateCookie = function (cookie, token) {
        // Insert the new encoded token into the existing cookie's 2nd 
        var parts = cookie.split('.'); // split it
        parts[1] = token; // add updated user data into the 2nd element
        return parts.join('.'); // merge again
    };
    jwtHelper.prototype.decodeToken = function (token) {
        var parts = token.split('.');
        if (parts.length !== 3) {
            throw new Error('JWT must have 3 parts');
        }
        try {
            var vt = this.validateToken(parts[1]);
            var decoded = decodeURIComponent(encodeURI(window.atob(vt))); //polifyll https://github.com/davidchambers/Base64.js            
            return JSON.parse(decoded);
        }
        catch (e) {
            throw new Error('Cannot decode the token');
        }
        //        const decoded: string = this.base64Decode(parts[1]);
        //       if (!decoded) {
        //          throw new Error('Cannot decode the token');
        //    }
        //return JSON.parse(decoded);
    };
    jwtHelper.prototype.getTokenExpirationDate = function (token) {
        var decoded;
        decoded = this.decodeToken(token);
        if (typeof decoded.exp === "undefined") {
            return null;
        }
        var d = new Date(0); // The 0 here is the key, which sets the date to the epoch
        d.setUTCSeconds(decoded.exp);
        return d;
    };
    jwtHelper.prototype.isTokenExpired = function (token, offsetSeconds) {
        var d = this.getTokenExpirationDate(token);
        offsetSeconds = offsetSeconds || 0;
        if (d === null) {
            return false;
        }
        // Token expired?
        var t = (d.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
        return !t;
    };
    return jwtHelper;
}());
angular
    .module('application')
    .service('jwtHelper', jwtHelper);



var LoginService = (function () {
    function LoginService($localStorage, env, jwtHelper, DTS, socket) {
        this.$localStorage = $localStorage;
        this.env = env;
        this.jwtHelper = jwtHelper;
        this.DTS = DTS;
        this.socket = socket;
    }
    LoginService.prototype.setUser = function (cd) {
        var _this = this;
        var valid = false;
        var cookie = this.getCookie('io-user');
        if (cookie === null || undefined) {
            console.log('$login => no cookie found...collecting from local storage');
            if (this.$localStorage.user !== undefined) {
                valid = true;
                cookie = this.$localStorage.user;
            }
        }
        else {
            console.log('$login => cookie found');
            valid = true;
            this.$localStorage.user = cookie;
        }
        if (valid) {
            if (this.jwtHelper.isTokenExpired(cookie)) {
                return this.env.revokeUser();
            }
            console.info('$login => we have a token');
            // console.log('$token expires => ' + this.jwtHelper.getTokenExpirationDate(cookie));
            var tokendec_1 = this.jwtHelper.decodeToken(cookie);
            // console.info(`$login.ts => user roles : ` + roles);
            var hasProfile = tokendec_1.hasProfile;
            var access = tokendec_1.access;
            var allowed = false;
            var approver = false;
            var termsOk = tokendec_1.termsOk;
            if (tokendec_1.allowed = 'Y' && tokendec_1.programs.includes('SVI')) {
                allowed = true;
            }
            ;
            if (allowed) {
                //An approver can be defined as anyone in the following groups:
                // BPSO Approver, Non-BPSO Approver (managers and team leads), BPSO Admin, Non-BPSO Admin ('peers')
                if (access.bpsoApprover || access.nonBpsoApprover || access.bpsoAdmin || access.nonBpsoAdmin) {
                    approver = true;
                }
            }
            //allowed = false; //to test no Blue Group access
            if (this.$localStorage.bpuser === undefined || this.$localStorage.bpuser === {}) {
                // Ivan - Get name & uid from faces if the localStorge is undefined
                this.$localStorage.bpuser = {};
                this.DTS.getUser(tokendec_1.email)
                    .then(function (response) {
                    // console.log('response', response.data);
                    angular.forEach(response.data, function (item) {
                        // console.log('item', item);
                        // console.log('email item : ' + item.email + ' tokenemail ' + tokendec.email);
                        if (!angular.isUndefined(item.email) && !angular.isUndefined(tokendec_1.email) &&
                            (item.email.toLowerCase() == tokendec_1.email.toLowerCase())) {
                            _this.$localStorage.bpuser.name = item.name;
                            _this.$localStorage.bpuser.uid = item.uid;
                            console.log('user is : ' + _this.$localStorage.bpuser.name + ' - ' + _this.$localStorage.bpuser.uid);
                            _this.env.setUser({
                                name: _this.$localStorage.bpuser.name,
                                uid: _this.$localStorage.bpuser.uid
                            });
                        }
                        ;
                    });
                });
            }
            this.env.setUser({
                email: tokendec_1.email,
                hasProfile: hasProfile,
                token: cookie,
                loggedIn: true,
                access: access,
                allowed: allowed,
                approver: approver,
                termsOk: termsOk
            });
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getUserProfile',
                    script: '/settings/settings',
                    data: this.env.uid,
                    token: this.env.user.token
                }
            });
            console.log('$login.ts => user logged in : ' + this.$localStorage.bpuser.name);
            for (var k in this.env.user) {
                if (this.env.user.hasOwnProperty(k)) {
                }
            }
            if (cd) {
                cd();
            }
        }
        else {
            console.log('$login => no cookie found...anywhere... revoking');
            this.env.revokeUser();
        }
    };
    LoginService.prototype.getCookie = function (name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    };
    LoginService.$inject = [
        '$localStorage', 'env', 'jwtHelper', 'DTS', 'socket'
    ];
    return LoginService;
}());
angular
    .module('application')
    .service('$login', LoginService);



var NotifyService = (function () {
    function NotifyService($mdToast) {
        this.$mdToast = $mdToast;
    }
    NotifyService.prototype.error = function (msg) {
        this.$mdToast.show(this.$mdToast.simple()
            .content(msg)
            .action('OK')
            .position('top right')
            .hideDelay(13000000)
            .theme('red'));
    };
    NotifyService.prototype.success = function (msg) {
        this.$mdToast.show(this.$mdToast.simple()
            .content(msg)
            .position('bottom left')
            .hideDelay(3000)
            .theme('green'));
    };
    NotifyService.$inject = ['$mdToast'];
    return NotifyService;
}());
;
angular
    .module('application')
    .service('notify', NotifyService);



'use strict';
var Pivot = (function () {
    function Pivot() {
    }
    Pivot.instance = function () {
        return new Pivot;
    };
    //scope: { twoWayBind: "=myTwoWayBind" };
    Pivot.prototype.link = function (scope, element, attrs) {
        var c3;
        //let windowEl: any = angular.element(this.$window);
        //windowEl.c3 = c3;
        var derivers = $.extend($.pivotUtilities.renderers, $.pivotUtilities.c3_renderers, $.pivotUtilities.d3_renderers, $.pivotUtilities.export_renderers);
        function updatePivotTable(newValue) {
            if (newValue) {
                var pivotData = scope.$eval(attrs.pivotData);
                if (pivotData) {
                    var pivotAttrs = $.extend({}, {
                        renderers: derivers,
                        rows: attrs.rows ? scope.$eval(attrs.rows) : undefined,
                        cols: attrs.cols ? scope.$eval(attrs.cols) : undefined,
                        aggregatorName: attrs.aggregatorName ? scope.$eval(attrs.aggregatorName) : undefined,
                        vals: attrs.vals ? scope.$eval(attrs.vals) : undefined,
                        rendererName: attrs.rendererName ? scope.$eval(attrs.rendererName) : undefined,
                        derivedAttributes: attrs.derivedAttributes ? scope.$eval(attrs.derivedAttributes) : undefined
                    });
                    angular.element(element)
                        .pivotUI(pivotData, pivotAttrs);
                }
            }
        }
        scope.$watchGroup([
            attrs.pivotData,
            attrs.rows,
            attrs.cols,
            attrs.aggregatorName,
            attrs.vals,
            attrs.rendererName,
            attrs.derivedAttributes
        ], updatePivotTable, true);
    };
    return Pivot;
}());
angular
    .module('application')
    .directive('pivotChart', Pivot.instance);



/**
 * @author Ivan Toth.
 *  Stores data about app settins, like country, user profile
 */
var SearchSubmitService = (function () {
    function SearchSubmitService() {
        this.laterProcess = false;
    }
    SearchSubmitService.prototype.updateLaterProcess = function (processLater) {
        this.laterProcess = processLater;
    };
    SearchSubmitService.prototype.checkIfReportLoaded = function () {
        if (angular.isUndefined(this.original) || angular.isUndefined(this.original.table)) {
            return false;
        }
        else {
            return true;
        }
        ;
    };
    SearchSubmitService.prototype.updateSearchResults = function (data) {
        var _this = this;
        this.laterProcess = false;
        angular.forEach(data.type, function (tempType) {
            _this.type = tempType;
        });
        this.original = { table: [] };
        if (angular.isDefined(data.response)) {
            this.original = data.response;
        }
        this.results = angular.copy(this.original);
        this.results.table = [];
    };
    SearchSubmitService.prototype.updateOriginal = function (data) {
        this.original = data;
    };
    SearchSubmitService.prototype.updateResults = function (data) {
        this.results = data;
    };
    SearchSubmitService.prototype.removeItem = function (item) {
        var position = -1;
        for (var i = 0; i < this.results.table.length; i++) {
            var tableItem = this.results.table[i];
            var found = true;
            for (var prop in tableItem) {
                if (prop != '$$hashKey' && tableItem[prop] != item[prop]) {
                    found = false;
                }
            }
            if (found) {
                position = i;
                break;
            }
        }
        if (position > -1) {
            this.results.table.splice(position, 1);
            return true;
        }
        else {
            return false;
        }
    };
    SearchSubmitService.prototype.addItem = function (item) {
        if (this.results.table.indexOf(item) < 0) {
            this.results.table.push(item);
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Function to return a human readable name for the various search result items
     * @param keyword
     */
    SearchSubmitService.prototype.getItemName = function (keyword) {
        console.info(keyword);
        switch (keyword) {
            case 'dc':
                return 'Duplicate Check';
            case 'cmr':
            case 'cmr_valid':
                return 'Find CMR';
            case 'nc':
                return 'New Client';
            case 'fastpass':
                return 'Fastpass';
            default:
                if (angular.isDefined(keyword)) {
                    return keyword.toUpperCase();
                }
                return 'Unknown Search Results';
        }
    };
    return SearchSubmitService;
}());
angular
    .module('application')
    .service('searchSubmit', SearchSubmitService);



'use strict';
var selectDirective = (function () {
    function selectDirective($timeout, $parse) {
        this.$timeout = $timeout;
        this.$parse = $parse;
        this.restrict = 'ACE';
    }
    selectDirective.prototype.link = function (scope, element, attrs) {
        var _this = this;
        var opt = {
            placeholder: attrs.placeholder || null,
            minimumResultsForSearch: attrs.single || null,
            width: attrs.width
        };
        this.$timeout(function () {
            element.select2(opt);
            element.select2Initialized = true;
        });
        var refreshSelect = function () {
            if (!element.select2Initialized)
                return;
            _this.$timeout(function () {
                element.trigger('change');
            });
        };
        var recreateSelect = function () {
            if (!element.select2Initialized)
                return;
            _this.$timeout(function () {
                element.select2('destroy');
                element.select2(opt);
            });
        };
        scope.$watch(attrs.ngModel, refreshSelect);
        if (attrs.ngOptions) {
            var list = attrs.ngOptions.match(/ in ([^ ]*)/)[1];
            // watch for option list change
            scope.$watch(list, recreateSelect);
        }
        if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refreshSelect);
        }
    };
    selectDirective.factory = function () {
        var directive = function ($timeout, $parse) { return new selectDirective($timeout, $parse); };
        directive.$inject = ['$timeout', '$parse'];
        return directive;
    };
    return selectDirective;
}());
angular
    .module('application')
    .directive('select', selectDirective.factory());



/**
 * @author Ivan Toth.
 *  Stores data about app settins, like country, user profile
 */
var SettingsService = (function () {
    function SettingsService(socket, env) {
        var _this = this;
        this.socket = socket;
        this.env = env;
        this.socket.on('connect', function () {
            if (!_this.connected && angular.isDefined(_this.env.user) && _this.env.user.loggedIn) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'getGlobalSettings',
                        script: '/config/config',
                        data: {},
                        token: _this.env.user.token
                    }
                });
            }
            _this.connected = true;
        });
        this.socket.on('disconnect', function () {
            _this.connected = false;
        });
        this.up = {};
        this.loaded = false;
        this.iot_list = {
            calculated: false,
            iots: []
        };
        this.eligibilityOptions = ['Eligible', 'Not Eligible'];
        this.bpoiEligibilityOptions = ['BP ID', 'IBM ID', 'Not Eligible'];
        this.calculationTreeLevels = ['Payment', 'Sales Order', 'Brand Family', 'Part Number', 'Revenue Line Item'];
    }
    /**
     * getNextMainStatus - Function to get the next main status in the process sequence whether moving forward or backards
     *
     * @return {number}  The next main status number
     */
    SettingsService.prototype.getNextMainStatus = function (currentStatus, program, rollback) {
        var nextStatus = currentStatus; //Set as current is case all fails
        if (this.program_cfg) {
            this.program_cfg.some(function (prog) {
                if (prog.title === program) {
                    var index = prog.process_seq.indexOf(currentStatus);
                    if (!rollback) {
                        //If going forward
                        if (index + 1 <= prog.process_seq.length) {
                            nextStatus = prog.process_seq[index + 1];
                        }
                    }
                    else {
                        //Going back
                        if (index - 1 >= 0) {
                            nextStatus = prog.process_seq[index - 1];
                            //if that new status is an approval status then go back one more
                            if ([2, 5].indexOf(nextStatus) > -1) {
                                nextStatus = prog.process_seq[index - 2];
                            }
                        }
                    }
                    return true; //Break loop
                }
            });
        }
        return nextStatus;
    };
    SettingsService.prototype.getProgramProfile = function (name) {
        var program;
        if (angular.isDefined(this.program_cfg)) {
            angular.forEach(this.program_cfg, function (prog) {
                if (name === prog.title) {
                    program = prog;
                }
            });
        }
        return program;
    };
    SettingsService.prototype.updateSettings = function (data) {
        this.country_list = data.country_list;
        this.teams = data.teams;
        this.columnNames = data.columnNames;
        this.allColumnOrder = data.allColumnOrder;
        this.svistatuses = data.svistatuses;
        this.bp_types = data.bp_types;
        this.brands = data.brands;
        this.programs = data.programs;
        this.program_cfg = data.program_cfg;
        this.iot_list = data.iot_list;
        this.imt_list = data.imt_list;
        this.us_states = data.us_states;
        this.statuses = data.statuses;
        this.substatuses = data.substatuses;
        this.status_cfg = data.status_cfg;
        this.payment_systems = data.payment_systems;
        this.loaded = true;
        this.dmtModuleHeaderUpdateDate = data.dmt_module_properties.dmtModuleHeaderUpdateDate;
        this.generalDeterminationCutoverDate = data.dmt_module_properties.generalDeterminationCutoverDate;
        this.misc_codes = data.misc_codes;
    };
    /*
        updateIot() {
            if (!this.iot_list.calculated) {
                this.iot_list.iots = this.country_list.filter(this.getIOT);
                this.iot_list.calculated = true;
            }
        }
    */
    SettingsService.prototype.getIOT = function (iot) {
        if (iot.ic === 'IOT') {
            return iot;
        }
    };
    ;
    SettingsService.prototype.calcIot = function (short) {
        var foundIot = '';
        angular.forEach(this.country_list, function (ctry) {
            if (ctry.short === short) {
                foundIot = ctry.imt;
            }
        });
        return foundIot;
    };
    SettingsService.prototype.calcCountryObj = function (short) {
        var foundObj = { short: '' };
        angular.forEach(this.country_list, function (ctry) {
            if (ctry.short === short) {
                foundObj = ctry;
            }
        });
        return foundObj;
    };
    SettingsService.prototype.getShortName = function (country) {
        var foundShort;
        angular.forEach(this.country_list, function (ctry) {
            if (ctry.country === country) {
                foundShort = ctry.short;
            }
        });
        return foundShort;
    };
    /**
     * getCountryList - Pull list of country names only
     *
     * @return {type}  Array of country names
     */
    SettingsService.prototype.getCountryList = function () {
        var cty = [];
        if (Array.isArray(this.country_list)) {
            this.country_list.forEach(function (c) {
                if (c.ic.toLowerCase() === 'country') {
                    cty.push(c.country);
                }
            });
        }
        return cty;
    };
    SettingsService.prototype.updateProfile = function (data) {
        this.up = data;
    };
    SettingsService.$inject = ['socket', 'env'];
    return SettingsService;
}());
angular
    .module('application')
    .service('settings', SettingsService);



var SocketService = (function () {
    function SocketService(socketFactory, $localStorage, socket) {
        this.socketFactory = socketFactory;
        this.$localStorage = $localStorage;
        this.socket = socket;
        var self = this;
        this.start = new Date().getTime();
        this.socket = io.connect('/', {
            forceNew: false,
            timeout: SocketService.CLINET_SOCKET_IO_PING_TIMEOUT,
            transports: ['websocket'],
            upgrade: false
        });
        this.socket.on('connect', onConnect);
        this.socket.on('disconnect', onDisconnect);
        this.socket.on('error', onError);
        var mySocket = socketFactory({
            ioSocket: this.socket
        });
        return mySocket;
        function onConnect(data) {
            console.info("$scoket (onConnect) => socket connected at " + (new Date().getTime() - self.start) + " ms");
            if (!('Notification' in window)) {
                console.info('$scoket (onConnect) => Web Notification not supported');
                return;
            }
            var not = self.$localStorage.notification;
            if (not) {
                console.info('$scoket (onConnect) => notifications enabled');
                return notif();
            }
            Notification.requestPermission(function (permission) {
                if (permission === 'granted') {
                    notif();
                    self.$localStorage.notification = true;
                    console.info('notifications saved');
                }
            });
        }
        function notif() {
            var _this = this;
            this.notification = new Notification('DMT', {
                body: 'You are now connected to DMT',
                icon: '/static/img/io-lab-green.png',
                dir: 'auto'
            });
            return setTimeout(function () {
                _this.notification.close();
            }, 3000);
        }
        function onDisconnect(data) {
            console.error("Socket Disconnected " + (new Date().getTime() - self.start) + " ms");
        }
        function onError(data) {
            console.error("Socket Error " + (new Date().getTime() - self.start) + " ms", data);
        }
    }
    SocketService.$inject = ['socketFactory', '$localStorage'];
    SocketService.CLINET_SOCKET_IO_PING_TIMEOUT = 40000; // 20000 by default
    return SocketService;
}());
angular
    .module('application')
    .factory('socket', SocketService);



var StateHelperProvider = (function () {
    function StateHelperProvider(stateHelperProvider, $urlRouterProvider) {
        this.stateHelperProvider = stateHelperProvider;
        this.$urlRouterProvider = $urlRouterProvider;
        $urlRouterProvider.otherwise('/404');
        stateHelperProvider
            .state({
            authenticate: false,
            children: [],
            name: 'home',
            template: '<home-section/>',
            url: '/'
        })
            .state({
            authenticate: true,
            name: 'subtest-view',
            template: '<subtest-view-section/>',
            url: '/subtest-view'
        })
            .state({
            authenticate: true,
            name: 'queue',
            template: '<queue-section/>',
            url: '/queue/:id'
        })
            .state({
            authenticate: true,
            name: 'landing',
            template: '<landing-section/>',
            url: '/landing-page'
        })
            .state({
            authenticate: true,
            name: 'queueSampling',
            template: '<queue-sampling-section/>',
            url: '/queue-sampling'
        })
            .state({
            authenticate: true,
            name: 'queueError',
            template: '<queue-error-section/>',
            url: '/queue-error'
        })
            .state({
            authenticate: true,
            name: 'queueErrorGeneral',
            template: '<queue-error-gen-section/>',
            url: '/queue-error_general'
        }).
            state({
            authenticate: true,
            name: 'queueSapMissing',
            template: '<queue-sap-missing-section/>',
            url: '/queue-sap-missing'
        })
            .state({
            authenticate: true,
            name: 'queueSetAside',
            template: '<queue-setaside-section/>',
            url: '/queue-setaside'
        })
            .state({
            authenticate: true,
            name: 'approvals',
            template: '<approvals-section/>',
            url: '/approvals'
        })
            .state({
            authenticate: true,
            children: [
                {
                    authenticate: true,
                    name: 'general',
                    template: '<detail-general/>',
                    url: '/general'
                },
                {
                    authenticate: true,
                    name: 'eligibility',
                    template: '<detail-eligibility/>',
                    url: '/eligibility'
                }, {
                    authenticate: true,
                    name: 'payment',
                    template: '<payment-gate/>',
                    url: '/payment'
                }, {
                    authenticate: true,
                    name: 'sampling',
                    template: '<detail-sampling/>',
                    url: '/sampling'
                }, {
                    name: 'validation',
                    url: '/validation',
                    template: '<detail-validation/>',
                    authenticate: true
                }, {
                    name: 'searchsubmit',
                    url: '/searchsubmit',
                    template: '<search-submit-section/>',
                    authenticate: true
                }],
            name: 'detail',
            template: '<detail-section/>',
            url: '/detail/:id'
        })
            .state({
            authenticate: true,
            name: 'preview',
            template: '<preview-section/>',
            url: '/preview/:id'
        })
            .state({
            authenticate: true,
            name: 'team',
            template: '<team-view/>',
            url: '/team/:id'
        })
            .state({
            authenticate: true,
            name: 'reporting',
            template: '<reporting-section/>',
            url: '/reporting'
        })
            .state({
            authenticate: true,
            name: 'help',
            template: '<help-section/>',
            url: '/help'
        })
            .state({
            authenticate: false,
            children: [],
            name: 'about',
            template: '<about-section/>',
            url: '/about'
        })
            .state({
            authenticate: true,
            children: [
                {
                    authenticate: true,
                    name: 'main',
                    template: '<admin-main-section/>',
                    url: '/main'
                },
                {
                    authenticate: true,
                    name: 'termsofuse-view',
                    template: '<view-terms-section/>',
                    url: '/termsofuse-view'
                },
                {
                    authenticate: true,
                    name: 'checklist-view',
                    template: '<view-check-list-section/>',
                    url: '/checklist-view'
                },
                {
                    authenticate: true,
                    name: 'checklist-update',
                    template: '<admin-check-list-section/>',
                    url: '/checklist-update/:sl'
                },
                {
                    authenticate: true,
                    name: 'checklist-edit',
                    template: '<admin-check-list-section/>',
                    url: '/checklist-edit/:sl'
                },
                {
                    authenticate: true,
                    name: 'misc-codes-view',
                    template: '<view-misc-codes-section/>',
                    url: '/misc-codes-view'
                },
                // {
                //     authenticate: true,
                //     name: 'gbt20-view',
                //     template: '<view-gbt20-section/>',
                //     url: '/gbt20-view',
                // },
                {
                    authenticate: true,
                    name: 'mysa-dmt-view',
                    template: '<view-mysa-dmt-section/>',
                    url: '/mysa-dmt-view'
                },
                {
                    authenticate: true,
                    name: 'mysa-im-outbound-view',
                    template: '<view-mysa-im-outbound-section/>',
                    url: '/mysa-im-outbound-view'
                },
                {
                    authenticate: true,
                    name: 'gppload-view',
                    template: '<view-gppload-section/>',
                    url: '/gppload-view'
                },
                {
                    authenticate: true,
                    name: 'columns-view',
                    template: '<view-columns-section/>',
                    url: '/columns-view'
                },
                {
                    authenticate: true,
                    name: 'columns',
                    template: '<admin-columns-section/>',
                    url: '/columns/:id'
                },
                {
                    authenticate: true,
                    name: 'program-view',
                    template: '<view-program-section/>',
                    url: '/program-view'
                },
                {
                    authenticate: true,
                    name: 'program',
                    template: '<admin-program-section/>',
                    url: '/program/:id'
                },
                {
                    authenticate: true,
                    name: 'sampling-view',
                    template: '<view-sampling-section/>',
                    url: '/sampling-view'
                },
                {
                    authenticate: true,
                    name: 'bpoiswitches-view',
                    template: '<view-bpoiswitch-section/>',
                    url: '/bpoiswitches-view'
                },
                {
                    authenticate: true,
                    name: 'validation-view',
                    template: '<view-validation-section/>',
                    url: '/validation-view'
                },
                {
                    authenticate: true,
                    name: 'exchangerate-view',
                    template: '<view-exchangerate-section/>',
                    url: '/exchangerate-view'
                },
                {
                    authenticate: true,
                    name: 'country-view',
                    template: '<view-country-section/>',
                    url: '/country-view'
                },
                {
                    authenticate: true,
                    name: 'calculation-view',
                    template: '<view-calculation-section/>',
                    url: '/calculation-view'
                },
                {
                    authenticate: true,
                    name: 'adminreporting-view',
                    template: '<view-adminreporting-section/>',
                    url: '/adminreporting-view'
                },
                {
                    authenticate: true,
                    name: 'status-view',
                    template: '<view-status-section/>',
                    url: '/status-view'
                },
                {
                    authenticate: true,
                    name: 'status',
                    template: '<admin-status-section/>',
                    url: '/status/edit?status'
                },
                {
                    authenticate: true,
                    name: 'mysaerrlogs-view',
                    template: '<mysaerrlogs-section>',
                    url: '/mysa-errors-logs'
                },
                {
                    authenticate: true,
                    name: 'mysaerrlogs-details-view',
                    template: '<mysaerrlogs-details-section/>',
                    url: '/mysa-errors-logs/:id'
                },
                {
                    authenticate: true,
                    name: 'users-view',
                    template: '<view-user-section/>',
                    url: '/users-view'
                },
                {
                    authenticate: true,
                    name: 'mysaresponse-view',
                    template: '<view-mysaresponse-section/>',
                    url: '/mysaresponse-view'
                },
                {
                    authenticate: true,
                    name: 'bpmergers-view',
                    template: '<view-bpmergers-section/>',
                    url: '/bpMergers'
                },
                {
                    authenticate: true,
                    name: 'user',
                    template: '<admin-user-main-section/>',
                    url: '/user/edit?user'
                },
                {
                    authenticate: true,
                    name: 'approvedlist-view',
                    template: '<approved-list-section/>',
                    url: '/approved-list'
                },
                {
                    authenticate: true,
                    name: 'massupdates-view',
                    template: '<mass-update-section>',
                    url: '/mass-update'
                },
                {
                    authenticate: true,
                    name: 'complianceplan-view',
                    template: '<complianceplan-section>',
                    url: '/compliance-plan'
                },
                {
                    authenticate: true,
                    name: 'eslogs-view',
                    template: '<eslogs-section>',
                    url: '/es-logs'
                },
                {
                    authenticate: true,
                    name: 'eslogs-details-view',
                    template: '<eslogs-details-section/>',
                    url: '/es-logs/:id'
                },
            ],
            name: 'admin',
            template: '<admin-section/>',
            url: '/admin/main'
        })
            .state({
            authenticate: true,
            name: 'download',
            template: '',
            url: '/download/:id/:name'
        })
            .state({
            authenticate: true,
            name: 'excel-export',
            template: '',
            url: '/excel-export/:id/:comp/:timestamp'
        })
            .state({
            authenticate: true,
            name: 'user-profile',
            template: '<user-profile-section/>',
            url: '/user-profile'
        })
            .state({
            authenticate: true,
            name: 'loading',
            template: '<loading-view/>',
            url: '/loading/:id'
        })
            .state({
            authenticate: false,
            children: [],
            name: '404',
            templateUrl: '404.html',
            url: '/404'
        })
            .state({
            authenticate: false,
            children: [],
            name: '403',
            templateUrl: '403.html',
            url: '/403'
        })
            .state({
            children: [],
            name: '500',
            notauth: true,
            template: '<not-auth-section>',
            url: '/500'
        })
            .state({
            children: [],
            name: 'noprofile',
            notauth: true,
            url: '/noprofile',
            templateUrl: 'noprofile.html'
        })
            .state({
            children: [],
            name: 'noadmin',
            notauth: true,
            templateUrl: 'noadmin.html',
            url: '/noadmin'
        })
            .state({
            children: [],
            name: 'terms',
            notauth: true,
            template: '<terms-section>',
            url: '/terms'
        })
            .state({
            children: [],
            name: 'noapprover',
            notauth: true,
            templateUrl: 'noapprover.html',
            url: '/noapprover'
        })
            .state({
            name: 'login',
            notauth: true,
            url: 'loginw3'
        });
    }
    StateHelperProvider.$inject = ['stateHelperProvider', '$urlRouterProvider'];
    return StateHelperProvider;
}());
angular
    .module('application')
    .config(StateHelperProvider);



//Author Matthew Rogers
var StatusChangeService = (function () {
    function StatusChangeService($rootScope, $timeout, $q, socket, env, config, $mdDialog, DTS, Dialog, settings, notify) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.env = env;
        this.config = config;
        this.$mdDialog = $mdDialog;
        this.DTS = DTS;
        this.Dialog = Dialog;
        this.settings = settings;
        this.notify = notify;
        this.mainStatusChange = false; //if true the status SAVE button should not be visible
        this.disableApproveButtons = false;
        this.ASSIST_VALUES = ['CVR Sales Assist', 'Sales Assist'];
        this.OPP_VERSION_4 = 4;
    }
    StatusChangeService.prototype.refreshChecklists = function (bundle) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                chkBundle: bundle,
                function: 'refreshChecklists',
                script: '/config/config',
                user: this.env.user
            }
        });
    };
    StatusChangeService.prototype.createDispute = function (bundle) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                disBundle: bundle,
                function: 'createDispute',
                script: '/disputes/disputes',
                user: this.env.user
            }
        });
    };
    /**
     * isRollBackAction - Function to determine whether the approval action in process is a Rejection,
     * Cancellation or Reversal.
     *
     * @param  {type} action: string The Approval process action
     * @return {type}                Returns true if Reject, Cancel Approval or Reverse Approval
     */
    StatusChangeService.prototype.isRollBackAction = function (action) {
        if (['Reject', 'Cancel Approval', 'Reverse Approval'].indexOf(action) > -1) {
            return true;
        }
        return false;
    };
    /**
     * nonAppStatusChange - Function for handling main status changes other than Approval stages, ie:
     * Received to Validation...Validation/Received to Rejected etc
     *
     * @param  {type} event: any        browser event
     * @param  {type} action: string    the action, ie: Initiate Validation, Rejected...
     * @param  {type} statusObject: any current topic's status object
     * @param  {type} callback: any     callback function to return
     * @return {type}                   callback containing error and next status bundle
     */
    StatusChangeService.prototype.nonAppStatusChange = function (event, action, statusObject, callback) {
        var statBundle = {};
        //First step, ensure the program profile is available
        //if (this.config.programProfileMissing()) {
        if (!this.config.proProfileLoaded) {
            this.getProfileMissingDetails(statBundle); //Set prompt details
            return callback('bad profile', statBundle);
        }
        //Check what the next status is based on current one
        var currentStatus = statusObject.status_no;
        var newStatus;
        var newSubStatus;
        var newStatusDesc;
        var newSubStatusDesc;
        var newDefaultSub;
        var nextSubStatuses;
        if (action === 'Initiate Validation') {
            newStatus = 4; //Validation
            newStatusDesc = 'Validation';
            //The automated sub-status for Validation should be Unassigned (4-1), but since user is manually performing the change, set as Pending BPSO (4-3), 
            newDefaultSub = this.config.getSubStatusBySubStatusNo2(4, 3);
            //newDefaultSub = this.config.getSubStatusesByMainStatusNo(newStatus)[0]; //should be 1
            newSubStatus = newDefaultSub.no;
            newSubStatusDesc = newDefaultSub.txt;
        }
        else if (action === 'Close Disbursement') {
            newStatus = 9; //Rejected
            newStatusDesc = 'Closed'; //pull using config function?
            nextSubStatuses = this.config.getSubStatusesByMainStatusNo(9); //Get the closed subs
            newSubStatus = 1;
            newSubStatusDesc = this.config.getSubStatusBySubStatusNo2(9, newSubStatus).txt; //Get description of that subby
        }
        else {
            newStatus = 8; //Rejected
            newStatusDesc = 'Rejected'; //pull using config function?
            nextSubStatuses = this.config.getSubStatusesByMainStatusNo(8); //Get the rejection subs
            if ([1, 3].indexOf(currentStatus) > -1) {
                newSubStatus = 2; // Eligibility Rejected
            }
            else if ([4].indexOf(currentStatus) > -1) {
                newSubStatus = 4; // Validation or Sales Verfication Rejected - set as Validation for now
            }
            else {
                newSubStatus = 1; // Payment Rejected
            }
            newSubStatusDesc = this.config.getSubStatusBySubStatusNo2(8, newSubStatus).txt; //Get description of that subby
        }
        statBundle.nextStatusDesc = newStatusDesc; //Description to be displayed
        statBundle.nextSubStatusDesc = newSubStatusDesc; //Description to be displayed
        statBundle.nextStatus = newStatus;
        statBundle.nextSubStatus = newSubStatus;
        statBundle.nextSubStatuses = nextSubStatuses;
        statBundle.action = action;
        return callback(null, statBundle);
    };
    /**
     * newPromise - Promise created for the call to the getUsersByRole service...process needs to wait
     * on the results
     *
     * @param  {type} socket: any        socket to make the service call
     * @param  {type} role  : string the role number to search for, ie: role 0 = BPSO Admin
     * @param  {type} cty   : string the country shortname the approvers should have access to, ie: US, GB, DE
     * @return {type}                    Deferred promise once results received
     */
    StatusChangeService.prototype.newPromise = function (socket, role, cty) {
        var _this = this;
        this.deferred = this.$q.defer(); //Set deferred object...to be sent to browser
        this.$timeout(function () {
            _this.deferred.reject([]); //If not resolved within 10 seconds...reject
        }, 10000);
        //Make the service call to get the users
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                country: cty,
                function: 'getUsersByRoleApprovals',
                roleNumber: role,
                script: '/approvals/approvals',
                user: this.env.user
            }
        });
        //declare listener for response from the service
        this.socket.forward('approvals.usersbyrole', this.$rootScope);
        this.$rootScope.$on('socket:approvals.usersbyrole', function (event, data) {
            //Once the results of any call to the getUsersByRole service are received...
            _this.deferred.resolve(data.results); //add the results to the deferred object
        });
        return this.deferred.promise; //fire off the promise
    };
    StatusChangeService.prototype.getCurrentApprovalStatus = function (statusObject) {
        //Grab current main and sub-status
        var currentStatus = statusObject.status_no;
        var currentSubStatus = statusObject.sub_status_no;
        var main = this.config.getMainStatusByMainStatusNo(currentStatus);
        var sub = this.config.getSubStatusBySubStatusNo(main, currentSubStatus);
        //Once done..prepare status object to return.
        var renotifyBundle = {
            nextStatusDesc: main.txt,
            nextSubStatusDesc: sub.txt,
            nextStatus: currentStatus,
            nextSubStatus: currentSubStatus,
            nextStatusObject: sub,
            approvalComplete: false,
            action: '',
            commentsMandatory: false,
            select_approver: '',
            approvalProcess: this.isPreApproval(currentStatus) ? 'Pre-Approval' : 'Approval'
        };
        return renotifyBundle;
    };
    /**
     * getNextRRCStatus - Function to determine next status if Reject, Reverse or Cancel Approval is fired
     *
     * @param  {type} statusObject: any Current topic's Status Object
     * @param  {type} action: string    action, ie: Reject, Reverse Approval or Cancel Approval
     * @return {type}                   An object containing the next status details
     */
    StatusChangeService.prototype.getNextRRCStatus = function (statusObject, action, program) {
        //work out which main status to go back to...should be just current main -1!!
        //Grab current main and sub-status
        var currentStatus = statusObject.status_no;
        var nextStatus = this.settings.getNextMainStatus(currentStatus, program, true);
        var main = this.config.getMainStatusByMainStatusNo(nextStatus);
        var sub = nextStatus === 1 ? this.config.getSubStatusBySubStatusNo2(1, 2) : this.config.getSubStatusBySubStatusNo2(4, 3); //Pending Pre-Approval Initialisation for Received (1)...Pending BPSO for Validation (4)
        var nextSubStatus = sub.no;
        //Once done..prepare status object to return.
        var rcBundle = {
            nextStatusDesc: main.txt,
            nextSubStatusDesc: sub.txt,
            nextStatus: nextStatus,
            nextSubStatus: nextSubStatus,
            nextStatusObject: main,
            approvalComplete: false,
            action: '',
            commentsMandatory: true,
            select_approver: '',
            approvalProcess: this.isPreApproval(currentStatus) ? 'Pre-Approval' : 'Approval'
        };
        return rcBundle;
    };
    /**
     * isPreApproval - Function to determine which Approval Process we are in/about
     * to enter based on current status
     *
     * @param  {type} currentStatus: number Current status, ie: 1 to 9
     * @return {type}                       Returns true in in Pre-Approval; false otherwise
     */
    StatusChangeService.prototype.isPreApproval = function (currentStatus) {
        //Get the program approval stages...based on where we are
        var approvalStages;
        //If at stage 1 about to submit for pre-approval, or in pre-approval
        if ([1, 2].indexOf(currentStatus) > -1) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * getNextApprovalStatus - Function to work out the next approval status based on current status and the
     * Program Profile.
     *
     * @param  {type} statusObject: any Object containing current status details
     * @return {type}                   Object containing details of the next status among other things
     */
    StatusChangeService.prototype.getNextApprovalStatus = function (statusObject, program) {
        //Set flag to determine if the approval process is complete....assume it isn't
        var approvalComplete = false;
        var preApproval = false;
        //Grab current main and sub-status
        var currentStatus = statusObject.status_no;
        var currentSubStatus = statusObject.sub_status_no;
        //Get the program approval stages...based on where we are
        var approvalStages;
        var approvalAmount; //Get the Disbursement amount to be approved. accordingly
        //If at stage 1 about to submit for pre-approval, or in pre-approval
        if (this.isPreApproval(currentStatus)) {
            approvalStages = this.config.proProfile.preapproval_stages;
            approvalAmount = Math.abs(statusObject.approvals.preapproval_amount); // Absolute values so debits are the same as credits
            preApproval = true;
        }
        else {
            approvalStages = this.config.proProfile.approval_stages;
            approvalAmount = Math.abs(statusObject.approvals.approval_amount); // Absolute values so debits are the same as credits
        }
        //Prepate the next statuses
        var nextStatus = currentStatus; //Again assume we won't be changing main status
        var nextSubStatus = currentSubStatus;
        var currentSubIndex; //The index with the approval stages for current status
        //Get the main status object, ie: Pre-Approval or Approval
        var main;
        var subbies;
        var sub;
        var nextStageFound = false; //initialise
        //Check if just starting an approval process, ie: if NOT status is 2 (Pending Pre-Approval) or
        // 5 (Pending Approval)
        if ([2, 5].indexOf(currentStatus) === -1) {
            //If submitting for approval or pre-approval
            nextStatus = preApproval ? 2 : 5; //Set accordingly
            nextSubStatus = approvalStages[0]; //indicating first entry (index 0) of the approval stage array
            main = this.config.getMainStatusByMainStatusNo(nextStatus);
            sub = this.config.getSubStatusBySubStatusNo(main, nextSubStatus);
            //Check if there's a clip level for this stage and if so, is the approval ampount less than
            // the clip...
            if (sub != null && sub.clip > 0 && approvalAmount <= sub.clip) {
            }
            else {
                nextStageFound = true; ///to escape loop
            }
        }
        else {
            main = this.config.getMainStatusByMainStatusNo(nextStatus);
        }
        //Keep looping until next approval stage found
        while (!nextStageFound) {
            //Get the index of the current approval status
            currentSubIndex = approvalStages.indexOf(nextSubStatus);
            //Check if there is another approval stage
            if (currentSubIndex + 1 > approvalStages.length - 1) {
                //If this is the last stage, disbursement can move to Eligibility, Validation or Approved status
                // depending on the program profile...so grab from program profile
                approvalComplete = true;
                //nextStatus = preApproval ? 3 : 5; //Set accordingly...Validation or Approved
                nextStatus = this.settings.getNextMainStatus(nextStatus, program, false);
                nextStageFound = true; ///to escape loop
                main = this.config.getMainStatusByMainStatusNo(nextStatus);
                subbies = main.subs;
                if (!subbies) {
                    nextSubStatus = 1; //Set as 1 if error....there should be a 1!
                }
                else {
                    nextSubStatus = subbies[0].no; //pull first status from the array
                }
                sub = this.config.getSubStatusBySubStatusNo(main, nextSubStatus);
            }
            else {
                //If in the middle of approval set as the next one in the sequence...since already set if submitting
                //if ([2, 5].indexOf(currentStatus) > -1) {
                nextSubStatus = approvalStages[currentSubIndex + 1];
                //}
                //Once we have that, grab the sub-status object that will be set next
                sub = this.config.getSubStatusBySubStatusNo(main, nextSubStatus);
                //Check if there's a clip level for this stage and if so, is the approval ampount less than
                // the clip...
                if (sub != null && sub.clip > 0 && approvalAmount <= sub.clip) {
                }
                else {
                    nextStageFound = true; ///to escape loop
                }
            }
        }
        //Once done..prepare status object to return.  May be a normal main status or an approval status
        var appBundle = {
            nextStatusDesc: main.txt,
            nextSubStatusDesc: sub != null ? sub.txt : null,
            nextStatus: nextStatus,
            nextSubStatus: nextSubStatus,
            nextStatusObject: approvalComplete ? main : sub,
            approvalComplete: approvalComplete,
            action: '',
            commentsMandatory: false,
            select_approver: '',
            approvalProcess: preApproval ? 'Pre-Approval' : 'Approval'
        };
        return appBundle;
    };
    /**
     * getProfileMissingDetails - Function to define the error details within the app bundle should
     * the program profle be missing
     *
     * @param  {type} appBundle: any Object containing the next status etc
     * @return {type}                Same object
     */
    StatusChangeService.prototype.getProfileMissingDetails = function (bundle) {
        bundle.error = true;
        bundle.title = 'Program Profile Missing';
        bundle.textContent = 'It has not been possible to retrieve the Program Profile for this Disbursement.' +
            '  &nbsp;The Profile is required to determine the next status.<p><p>Please contact the <b>DMT System' +
            ' Administrators</b> for guidance.';
        return bundle;
    };
    StatusChangeService.prototype.getPromptDetails = function (appBundle, statusObject) {
        appBundle.title = appBundle.action;
        if (!appBundle.approvalComplete) {
            //If Approval Process not complete
            if (appBundle.action === 'Reject') {
                appBundle.textContent = 'You have chosen to <b>Reject</b> this Disbursement. &nbsp;Should you choose to continue, ' +
                    'the Disbursement will be moved back to the ' + this.getBoldStatus(appBundle.nextStatusObject.txt, 'blue') +
                    ' status and all previous Approvals will be wiped.';
            }
            else if (appBundle.action === 'Reverse Approval') {
                appBundle.textContent = 'You have chosen to <b>Reverse</b> the Approvals for this Disbursement. &nbsp;' +
                    'Should you choose to continue, ' +
                    'the Disbursement will be moved back to the ' + this.getBoldStatus(appBundle.nextStatusObject.txt, 'blue') +
                    ' status and all previous Approvals will be wiped.';
            }
            else if (appBundle.action === 'Renotify Approver') {
                appBundle.textContent = 'You have chosen to <b>Renotify</b> the Approver for this Disbursement. &nbsp;' +
                    'You can choose to either resend notification to the current selected Approver, <b>' +
                    statusObject.approvals.selected_approver_name + '</b>, or choose someone else.';
                appBundle.selected_approver = {
                    email: statusObject.approvals.selected_approver_email,
                    name: statusObject.approvals.selected_approver_name
                };
            }
            else if (appBundle.action === 'Cancel Approval') {
                appBundle.textContent = 'You have chosen to <b>Cancel</b> the Approval process for this Disbursement. &nbsp;' +
                    'Should you choose to continue, ' +
                    'the Disbursement will be moved back to the ' + this.getBoldStatus(appBundle.nextStatusObject.txt, 'blue') +
                    ' status, and notification sent to <b>' + statusObject.approvals.selected_approver_name +
                    '</b> informing them to ignore the request. &nbsp;All previous Approvals will also be wiped.';
                appBundle.selected_approver = {
                    email: statusObject.approvals.selected_approver_email,
                    name: statusObject.approvals.selected_approver_name
                };
            }
            else {
                if (appBundle.action.indexOf('Submit') > -1) {
                    appBundle.textContent = 'You are about to enter the ' + appBundle.approvalProcess + ' process. &nbsp;Once' +
                        ' submitted, the Disbursement content will become be locked and uneditable.';
                }
            }
        }
        else {
            //If just starting or the end
            if (appBundle.action.indexOf('Submit') > -1) {
                appBundle.title = appBundle.action + ' for ' + appBundle.approvalProcess;
                appBundle.textContent = 'This Disbursement does not require Approval. &nbsp;Should you choose to continue, the ' +
                    'Disbursement will be moved' +
                    ' directly to ' + this.getBoldStatus(appBundle.nextStatusObject.txt, 'blue') + ' status. &nbsp;Continue?';
            }
            else {
                appBundle.textContent = 'This is the final ' + appBundle.approvalProcess +
                    ' Stage.  &nbsp;Should you choose to continue, the Disbursement will be moved' +
                    ' to ' + this.getBoldStatus(appBundle.nextStatusObject.txt, 'blue') + ' status.';
            }
        }
        return appBundle;
    };
    StatusChangeService.prototype.getBoldStatus = function (status, colour) {
        return '<span class="ibm-textcolor-' + colour + '-50"><b>' + status + '</b></span>';
    };
    /**
         * Function to allow System Admin to resolve errors.
         *
         * @param {*} event
         * @param {*} topic
         * @param {Function} callback
         *
         * @memberOf StatusChangeService
         */
    StatusChangeService.prototype.resolveError = function (event, errors, callback) {
        var _this = this;
        var resolveBundle = { action: 'Resolve Error' };
        resolveBundle.errors = errors;
        //Set default error first non-resolved one
        for (var i = 0; i < errors.err.length; i++) {
            if (errors.err[i].resolved === false) {
                resolveBundle.error = errors.err[i];
                break;
            }
        }
        var items = {
            resolveBundle: resolveBundle
        };
        //Show to-be-solved-error selection prompt dialog...
        this.Dialog.updateValidForm(event, items, 'resolveerror-dialog.html').then(function (dResult) {
            //Hereunder we do setup values to send back to server for document update
            //Let's set error as solved
            dResult.locals.resolveBundle.error.resolved = true;
            //let's calculate cycletime
            dResult.locals.resolveBundle.error.cycle = _this.dateDiffInDays(new Date(resolveBundle.error.timestamp), new Date());
            //let's update unresolved errors count
            dResult.locals.resolveBundle.errors.unresolved = dResult.locals.resolveBundle.errors.unresolved - 1;
            //let's track down resolve timestamp
            dResult.locals.resolveBundle.error.resolvedtimestamp = new Date().getTime();
            //let's track down who resolved error
            dResult.locals.resolveBundle.error.resolveuser = _this.env.user.email;
            return callback(false, dResult.locals.resolveBundle);
        }).catch(function () {
            return callback(true); //User cancelled
        });
    };
    /**
     * Function to allow System Admin to roll-back / update the status in certain scenarios
     *
     * @param {*} event
     * @param {*} topic
     * @param {Function} callback
     *
     * @memberOf StatusChangeService
     */
    StatusChangeService.prototype.rollbackStatus = function (event, topic, callback) {
        var _this = this;
        var rollBundle = { action: 'Rollback Status' };
        var mainStatuses = [];
        var nextStatuses = [];
        var setAside = false;
        rollBundle.currentStatus = topic.topic.status.status_no; //Set current status
        rollBundle.helpText = 'The statuses available are based on the current status.';
        //rollBundle.deleteAttach = false;
        mainStatuses.push(topic.topic.status.status_no); //As well as allowing to change current sub-status
        if (topic.topic.status.status_no === 4) {
            //If in a system-set status, ie: set aside - only allow Elig roll-back - no not permit
            //sub-status change since user should use the 'revert' button for that
            if (this.config.isSystemStatus(topic.topic.status.status_no, topic.topic.status.sub_status_no)) {
                //   mainStatuses.splice(0, 1); //Lose current status
                rollBundle.helpText += ' &nbsp;Use the \'Revert\' button instead should you wish to update the Calculations.';
            }
            //If in Validation status...allow to go back to Elig as well as updating sub-status
            mainStatuses.push(3);
            // If in a Set-Aside status...only allow sub-status change to other set aside statuses
            if (this.config.isSystemStatus(topic.topic.status.status_no, topic.topic.status.sub_status_no)) {
                setAside = true;
                mainStatuses.push(4);
            }
        }
        else if (topic.topic.status.status_no === 7) {
            // rollBundle.helpText += ' &nbsp;You are only permitted to update the Sub-Status.';
            //If PAID...move back to APPROVED (if went through approval process) or VALIDATION if not
            if (topic.topic.status.approvals.approval_required && topic.topic.status.approvals.complete) {
                mainStatuses.push(6); //only allow to go back to Approved
            }
            else {
                mainStatuses.push(4); //only allow to go back to Validation
            }
        }
        else if ([8, 9].indexOf(topic.topic.status.status_no) > -1) {
            rollBundle.helpText += ' &nbsp;You are only permitted to update the Sub-Status, or Roll-back to the status prior to ';
            //If Closed or Paid...allow sub-status change, or to go back to the status it was Closed/Rejected
            if (angular.isDefined(topic.topic.status.close_details)) {
                mainStatuses.push(topic.topic.status.close_details.close_status); //back to status closed at
                rollBundle.helpText += 'Closure.';
            }
            else if (angular.isDefined(topic.topic.status.rejection_details)) {
                mainStatuses.push(topic.topic.status.rejection_details.reject_status); //back to status rejected at
                rollBundle.helpText += 'Rejection.';
            }
            //it should allow Sys_admin to allow to roll back to validation
            mainStatuses.push(4);
        }
        //Build array of the permitted main status objects
        angular.forEach(this.settings.status_cfg, function (status) {
            if (mainStatuses.indexOf(status.no) > -1) {
                //Loop through all the subs...set the ignore flag to those that should be available...
                angular.forEach(status.subs, function (sub) {
                    //So...if the not current status or Unassigned status (since that would involve owner table update)
                    if (sub.txt === 'Unassigned' || (sub.no === topic.topic.status.sub_status_no && status.no === topic.topic.status.status_no)) {
                        sub.ignore = true;
                    }
                    else {
                        sub.ignore = false;
                        if (sub.system) {
                            sub.systemOverride = true; // Override temporarily
                        }
                        else {
                            // If not system and current status is set aside, skip non-system statuses
                            if (status.no === 4 && setAside && !sub.system) {
                                sub.ignore = true;
                            }
                        }
                    }
                });
                nextStatuses.push(status);
            }
        });
        rollBundle.nextStatuses = nextStatuses; //Set the main statuses
        rollBundle.nextStatus = nextStatuses[nextStatuses.length - 1]; //Set default main status as the upper bound of the array
        //Set default sub-status...ie: the first non-system one
        for (var i = 0; i < rollBundle.nextStatus.subs.length; i++) {
            //if (angular.isUndefined(rollBundle.nextStatus.subs[i].system) || !rollBundle.nextStatus.subs[i].system) {
            if (!rollBundle.nextStatus.subs[i].ignore) {
                rollBundle.nextSubStatus = rollBundle.nextStatus.subs[i];
                break;
            }
        }
        var items = {
            rollBundle: rollBundle
        };
        //Show rejection dialog...
        this.Dialog.updateValidForm(event, items, 'rollback-dialog.html').then(function (dResult) {
            if (topic.status.status_no !== rollBundle.nextStatus.no) {
                _this.mainStatusChange = true;
            }
            // Wipe the appBundle property in the status service that may still be set if rollback
            // takes place after an approval/rejection...if the appBundle remains it may trigger
            // and approval email
            _this.appBundle = null;
            //Update display
            topic.temp_ext.status = rollBundle.nextStatus.txt;
            topic.temp_ext.sub_status = rollBundle.nextSubStatus.txt;
            return callback(false, dResult.locals.rollBundle);
        }).catch(function () {
            return callback(true); //User cancelled
        });
    };
    StatusChangeService.prototype.updateSetAsideStatus = function (event, topic, callback) {
        return callback();
    };
    StatusChangeService.prototype.moveToPaidStatus = function (event, topic, callback) {
        var _this = this;
        var updateBundle = {};
        updateBundle.paidDate = new Date();
        var item = {
            updateBundle: updateBundle
        };
        this.Dialog.updateValidForm(event, item, 'move-to-paid-comment.html').then(function (dResult) {
            topic.temp_ext.status = 'Paid';
            if (!topic.temp.invoice_flags) {
                topic.temp.invoice_flags = {};
            }
            topic.temp.invoice_flags = topic.topic.invoice_flags;
            topic.temp.invoice_flags.paidDate = new Date(dResult.updateBundle.paidDate);
            var assistCondition = _this.ASSIST_VALUES.includes(topic.topic.sales_assist) ||
                _this.ASSIST_VALUES.includes(topic.topic.sales_assist.type);
            topic.temp_ext.sub_status = assistCondition ? 'Paid as Assist' : 'Paid as Sold';
            return callback(false, dResult);
        }).catch(function () {
            return callback(true); // User cancelled
        });
    };
    StatusChangeService.prototype.overrideProspectCMRs = function (itemObj, event, topic, callback) {
        var item = {
            message: itemObj.message,
            okMessage: 'OK',
            DBG: '',
            DCID: '',
            CMR: '',
            isOverride: false,
            isAutomaticCheck: false,
            cancelMessage: 'Cancel',
            dialogName: itemObj.dialogName,
            addCancel: false
        };
        this.Dialog.updateValidForm(event, item, 'override-prospect.html').then(function (dResult) {
            if (dResult.confirm) {
                return callback(false, dResult);
            }
        }).catch(function () {
            return callback(true); // User cancelled
        });
    };
    StatusChangeService.prototype.passEmbargoCheck = function (event, topic, callback) {
        var item = {
            addCancel: false,
            cancelMessage: 'Cancel',
            dialogName: 'Pass Embargo Check',
            isApproved: false,
            isCountryManualReview: false,
            message: 'Please confirm that Embargo Check should be passed:',
            okMessage: 'OK'
        };
        this.Dialog.updateValidForm(event, item, 'embargo-check.html')
            .then(function (dResult) {
            if (dResult.confirm) {
                return callback(false);
            }
        })
            .catch(function () {
            return callback(true);
        });
    };
    StatusChangeService.prototype.passCrossBoardEmeaCheck = function (event, topic, callback) {
        var item = {
            addCancel: false,
            cancelMessage: 'Cancel',
            dialogName: 'Confirm cross board eligibility',
            isApproved: false,
            isCountryManualReview: false,
            message: 'Please confirm that Cross Board eligibility should be passed:',
            okMessage: 'OK'
        };
        this.Dialog.updateValidForm(event, item, 'cross-board.html')
            .then(function (dResult) {
            if (dResult.confirm) {
                return callback(false);
            }
        })
            .catch(function () {
            return callback(true);
        });
    };
    StatusChangeService.prototype.openNotificationPreviewDialog = function (event, topic, callback) {
        var item = {
            addCancel: false,
            cancelMessage: 'Cancel',
            dialogName: 'BP Notification',
            message: 'Please confirm that BP Notification should be sent',
            okMessage: 'Send',
            data: {
                mail: topic.mailPreview
            }
        };
        this.Dialog.updateValidForm(event, item, 'notification-mail.html')
            .then(function (dResult) {
            if (dResult.confirm) {
                return callback(false);
            }
        })
            .catch(function () {
            return callback(true);
        });
    };
    StatusChangeService.prototype.displayNotificationPreview = function (event, data, callback) {
        var item = {
            addCancel: false,
            cancelMessage: 'Cancel',
            dialogName: 'BP Notification',
            message: 'Bp notification info',
            data: data
        };
        this.Dialog.updateValidForm(event, item, 'notification-mail-preview.html')
            .then(function (dResult) {
        })
            .catch(function () {
            return callback(true);
        });
    };
    StatusChangeService.prototype.passCountryManualReview = function (event, topic, callback) {
        var item = {
            addCancel: false,
            cancelMessage: 'Cancel',
            dialogName: 'Pass Manaual Review',
            isApproved: false,
            isCountryManualReview: true,
            message: 'Please confirm that Manual Review should be passed:',
            okMessage: 'OK'
        };
        this.Dialog.updateValidForm(event, item, 'embargo-check.html')
            .then(function (dResult) {
            if (dResult.confirm) {
                return callback(false);
            }
        })
            .catch(function () {
            return callback(true);
        });
    };
    StatusChangeService.prototype.updatePaymentDetailsStatus = function (event, topic, callback) {
        var initialSapResult = topic.topic.calculation.sapResult;
        var updateBundle = Object.assign({}, topic.topic.calculation);
        var status = topic.topic.status;
        var posInArray = { SSA: '', Solution: '', Growth: '', Focus: '', Ctl: '', NewClient: '' };
        var mainStatuses = [];
        var nextStatuses = [];
        var arr;
        // If sapResult doesn't exist, create it
        if (!topic.topic.calculation.sapResult) {
            arr = Object.assign({}, topic.topic.calculation);
            arr.sapResult = [];
            arr = arr.sapResult;
        }
        else {
            arr = topic.topic.calculation.sapResult;
        }
        status.isMoveToPaid = false;
        status.currentStatus = status.status_no; // Set current status
        status.helpText = 'The statuses available are based on the current status.';
        mainStatuses.push(status.status_no); // As well as allowing to change current sub-status
        // Validation or Approved
        if ((status.status_no === 4 || status.status_no === 6) && updateBundle.goe === 'Y') {
            status.isMoveToPaid = true;
            mainStatuses.push(7);
            // Build array of the permitted main status objects
            angular.forEach(this.settings.status_cfg, function (status) {
                if (mainStatuses.indexOf(status.no) > -1) {
                    // Loop through all the subs...set the ignore flag to those that should be available...
                    angular.forEach(status.subs, function (sub) {
                        // So...if the not current status or Unassigned status (since that would involve owner table update)
                        if (sub.txt === 'Unassigned' || (sub.no === status.sub_status_no && status.no === status.status_no)) {
                            sub.ignore = true;
                        }
                        else {
                            sub.ignore = false;
                            if (sub.system) {
                                sub.systemOverride = true; // Override temporarily
                            }
                        }
                    });
                    nextStatuses.push(status);
                }
            });
            status.nextStatuses = nextStatuses; // Set the main statuses
            status.nextStatus = nextStatuses[nextStatuses.length - 1]; // Set default main status as the upper bound of the array
            // Set default sub-status...ie: the first non-system one
            for (var i = 0; i < status.nextStatus.subs.length; i++) {
                if (!status.nextStatus.subs[i].ignore) {
                    status.nextSubStatus = status.nextStatus.subs[i];
                    break;
                }
            }
        }
        // Set Aside
        if ((status.status_no === 4 || status.status_no === 6) && updateBundle.goe === 'N' && !topic.isSetAside()) {
            status.isMoveToPaid = true;
            if (status.status_no === 6) {
                mainStatuses[0] = 4;
            }
            // Build array of the permitted main status objects
            angular.forEach(this.settings.status_cfg, function (status) {
                if (mainStatuses.indexOf(status.no) > -1) {
                    // Loop through all the subs...set the ignore flag to those that should be available...
                    angular.forEach(status.subs, function (sub) {
                        // So...if the not current status or Unassigned status (since that would involve owner table update)
                        if (sub.txt === 'Unassigned' || (sub.no === status.sub_status_no && status.no === status.status_no) || !sub.txt.includes('Set Aside')) {
                            sub.ignore = true;
                        }
                        else if (sub.txt.includes('Set Aside')) {
                            sub.ignore = false;
                            if (sub.system) {
                                sub.systemOverride = true; // Override temporarily
                            }
                        }
                    });
                    nextStatuses.push(status);
                }
            });
            status.nextStatuses = nextStatuses; // Set the main statuses
            status.nextStatus = nextStatuses[nextStatuses.length - 1]; // Set default main status as the upper bound of the array
            // Set default sub-status...ie: the first non-system one
            for (var i = 0; i < status.nextStatus.subs.length; i++) {
                if (status.nextStatus.subs[i].txt.includes('Set Aside')) {
                    status.nextSubStatus = status.nextStatus.subs[i];
                    break;
                }
            }
        }
        // If sapResult empty or 'Set Aside', fill it
        if (arr.length === 0 || arr === 'Set Aside') {
            arr = []; // Replace sapResult in variable arr with empty array
            // If goe off it is Set Aside, create variable with value 'Set Aside' to fill object and later paste this string in input field
            var setAsideInInput = void 0;
            if (updateBundle.goe === 'N') {
                setAsideInInput = 'Set Aside';
            }
            // If order value total exist for current incentive program push object
            if (updateBundle.totalOrderValues.orderTotalSSA) {
                arr.push({
                    'iaugru': 'Y72',
                    'SSA': setAsideInInput || 'Failed - See Errors',
                    'sapResultTime': new Date().getTime(),
                    'paidTimestamp': new Date().getTime()
                });
            }
            if (updateBundle.totalOrderValues.orderTotalSolution) {
                arr.push({
                    'iaugru': 'Y79',
                    'Solution': setAsideInInput || 'Failed - See Errors',
                    'sapResultTime': new Date().getTime(),
                    'paidTimestamp': new Date().getTime()
                });
            }
            if (updateBundle.totalOrderValues.orderTotalNewClient) {
                arr.push({
                    'iaugru': 'Y81',
                    'NewClient': setAsideInInput || 'Failed - See Errors',
                    'sapResultTime': new Date().getTime(),
                    'paidTimestamp': new Date().getTime()
                });
            }
            if (updateBundle.totalOrderValues.orderTotalFocus) {
                arr.push({
                    'iaugru': 'Y90',
                    'Focus': setAsideInInput || 'Failed - See Errors',
                    'sapResultTime': new Date().getTime(),
                    'paidTimestamp': new Date().getTime()
                });
            }
            if (updateBundle.totalOrderValues.orderTotalGrowth) {
                arr.push({
                    'iaugru': 'Y92',
                    'Growth': setAsideInInput || 'Failed - See Errors',
                    'sapResultTime': new Date().getTime(),
                    'paidTimestamp': new Date().getTime()
                });
            }
            if (updateBundle.totalOrderValues.orderTotalCtl) {
                arr.push({
                    'iaugru': 'NOT_AVAILABLE',
                    'Ctl': setAsideInInput || 'Failed - See Errors',
                    'sapResultTime': new Date().getTime(),
                    'paidTimestamp': new Date().getTime()
                });
            }
            // Create initial Date if it move to Set Aside
            if (((status.status_no === 4 || status.status_no === 6) && updateBundle.complete === false && updateBundle.goe === 'N') || status.status_no === 7) {
                updateBundle.paidTimestamp = new Date();
                updateBundle.sapResultTime = updateBundle.paidTimestamp;
            }
            updateBundle.sapResult = arr;
        }
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].hasOwnProperty('SSA')) {
                posInArray.SSA = i;
            }
            if (arr[i].hasOwnProperty('Solution')) {
                posInArray.Solution = i;
            }
            if (arr[i].hasOwnProperty('NewClient')) {
                posInArray.NewClient = i;
            }
            if (arr[i].hasOwnProperty('Focus')) {
                posInArray.Focus = i;
            }
            if (arr[i].hasOwnProperty('Growth')) {
                posInArray.Growth = i;
            }
            if (arr[i].hasOwnProperty('Ctl')) {
                posInArray.Ctl = i;
            }
        }
        // Convert timestamp to date and use it in datepicker
        for (var _i = 0, _a = updateBundle.sapResult; _i < _a.length; _i++) {
            var entry = _a[_i];
            entry.paidTimestamp = new Date(entry.paidTimestamp);
            entry.sapResultTime = entry.paidTimestamp;
        }
        // Convert timestamp to date if it Set Aside
        if (((status.status_no === 4 || status.status_no === 6) && updateBundle.complete !== false && updateBundle.goe === 'N') || status.status_no === 7) {
            var entry = updateBundle;
            entry.paidTimestamp = new Date(entry.paidTimestamp);
            entry.sapResultTime = entry.paidTimestamp;
        }
        // Remove any comments
        updateBundle.comments = '';
        var items = {
            initialSapResult: initialSapResult,
            status: status,
            updateBundle: updateBundle,
            nameOfCvrSSA: posInArray.SSA,
            nameOfCvrSolution: posInArray.Solution,
            nameOfCvrNewClient: posInArray.NewClient,
            nameOfFocus: posInArray.Focus,
            nameOfGrowth: posInArray.Growth,
            nameOfCtl: posInArray.Ctl,
            ssaLabel: topic.topic.version && topic.topic.version >= this.OPP_VERSION_4 ? 'SSA' : 'CVR SSA',
            seLabel: topic.topic.version && topic.topic.version >= this.OPP_VERSION_4 ? 'Engagement' : 'CVR Solution'
        };
        if (status.status_no === 4 && topic.topic.complete.errorsArray.all.length > 0) {
            var items_1 = {
                icon: 'WARN',
                message: 'One or more sections for this stage are still to be completed before you can Submit.' +
                    ' &nbsp;Please check for any red thumbs before attempting again.',
                title: 'Update Details'
            };
            this.Dialog.updateValidForm(undefined, items_1, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        else if (status.status_no === 4 && status.approvals.approval_required && updateBundle.complete === false) {
            var items_2 = {
                icon: 'WARN',
                message: 'This Disbursement needs Approval before it can be ' + (updateBundle.goe === 'Y' ? 'sent to SAP for payment' : 'Set Aside') + '. Please select Submit for Approval from Your Actions',
                title: 'Update Details'
            };
            this.Dialog.updateValidForm(undefined, items_2, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        else {
            // Show rejection dialog...
            this.Dialog.updateValidForm(event, items, 'updatePaymentDetails-dialog.html').then(function (dResult) {
                // Convert date to timestamp to save it in cloudant
                for (var _i = 0, _a = dResult.updateBundle.sapResult; _i < _a.length; _i++) {
                    var entry = _a[_i];
                    entry.paidTimestamp = Date.parse(entry.paidTimestamp);
                    entry.sapResultTime = entry.paidTimestamp;
                }
                // Convert initial Date to timestamp if it move to Set Aside
                if (((status.status_no === 4 || status.status_no === 6) && updateBundle.goe === 'N') || status.status_no === 7) {
                    var entry = dResult.updateBundle;
                    entry.paidTimestamp = Date.parse(entry.paidTimestamp);
                    entry.sapResultTime = entry.paidTimestamp;
                }
                // Save new status if Validation or Approved
                if ((status.status_no === 4 || status.status_no === 6) && updateBundle.goe === 'Y') {
                    status.status_no = 7;
                }
                // Save new status if Set Aside
                if ((status.status_no === 4 || status.status_no === 6) && updateBundle.goe === 'N') {
                    status.status_no = 4;
                }
                return callback(false, dResult.locals);
            }).catch(function () {
                return callback(true); // User cancelled
            });
        }
    };
    StatusChangeService.prototype.reAssignUser = function (event, topic, callback) {
        var items = {
            updateBundle: topic
        };
        //Show rejection dialog...
        this.Dialog.updateValidForm(event, items, 'reAssignUser-dialog.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
    };
    StatusChangeService.prototype.approvalProcess = function (event, action, topicBundle, callback) {
        var _this = this;
        var appBundle;
        var statusObject = topicBundle.status;
        var program = topicBundle.program;
        var country = topicBundle.country;
        //First step, ensure the program profile is available
        if (!this.config.proProfileLoaded) {
            this.getProfileMissingDetails(appBundle); //Set prompt details
            return callback('bad profile', appBundle);
        }
        //Now work out what the next status will be
        if (this.isRollBackAction(action)) {
            appBundle = this.getNextRRCStatus(statusObject, action, program);
        }
        else if (action === 'Renotify Approver') {
            appBundle = this.getCurrentApprovalStatus(statusObject);
        }
        else {
            appBundle = this.getNextApprovalStatus(statusObject, program);
        }
        appBundle.action = action;
        appBundle.error = false;
        //If no sub found (due to cock-up with Admin data)...
        if (appBundle.nextStatusObject === null) {
            appBundle.error = true;
            appBundle.title = 'Status Profile Missing';
            appBundle.textContent = 'It has not been possible to retrieve the Approval profile for stage number ' +
                appBundle.nextStatus + '-' + appBundle.nextSubStatus + '. &nbsp;It would appear to be missing from the Cloudant document.' +
                '<p><p>Please contact the <b>DMT System Administrators</b> for guidance.';
            return callback('missing status', appBundle);
        }
        //If next approval stage is peer, get the users from server
        if (!appBundle.approvalComplete && appBundle.nextStatusObject.peer) {
            //Which group?
            var roleNumber = '0'; //assume it's BPSO...99% of cases
            if (!appBundle.nextStatusObject.bpso) {
                roleNumber = '1'; //Non-BPSO admin
            }
            this.newPromise(this.socket, roleNumber, country).then(function (theUsers) {
                appBundle.nextStatusObject.users = theUsers;
                if (theUsers.length > 0) {
                    //Make call to add the appropriate call details
                    _this.getPromptDetails(appBundle, statusObject);
                    _this.setDefaultSelectedApprover(appBundle);
                    return callback(null, appBundle);
                }
                else {
                    appBundle.error = true;
                    appBundle.title = 'Unable to Retrieve Approvers';
                    appBundle.textContent = 'It has not been possible to retrieve the authorised Approvers for the ' +
                        'next stage from the server. &nbsp;It would appear there are no such \'' + appBundle.nextStatusObject.txt +
                        '\' users in the DB2 table. &nbsp;Please try again.<p><p>' +
                        'If the problem persists, please contact the <b>DMT System Administrators</b> for guidance.';
                    return callback('Unable to retrieve the Approvers list from server', appBundle);
                }
            }, function (noUsersReturnedInTime) {
                appBundle.error = true;
                appBundle.title = 'Unable to Retrieve Approvers';
                appBundle.textContent = 'It has not been possible to retrieve the authorised Approvers for the ' +
                    'next stage from the server. &nbsp;Please try again.<p><p>' +
                    'If the problem persists, please contact the <b>DMT System Administrators</b> for guidance.';
                return callback('Unable to retrieve the Approvers list from server', appBundle);
            });
        }
        else {
            //If still in the approval stage, ensure the app bundle has approvers!
            if (!this.isRollBackAction(action) && !appBundle.approvalComplete &&
                (appBundle.nextStatusObject.users === undefined || appBundle.nextStatusObject.users.length === 0)) {
                appBundle.error = true;
                appBundle.title = 'No Approvers';
                appBundle.textContent = 'There are currently no Approvers set up in the Status Configuration Profile for ' +
                    'the next Approval stage: \'' + appBundle.nextStatusObject.txt + '\' [' + appBundle.nextStatus + '-' +
                    appBundle.nextStatusObject.no +
                    '].  &nbsp;It is likely the last remaining approver(s) lost their DMT access ' +
                    'recently.  &nbsp;Please contact the <b>DMT System Administrators</b> immediately to have the correct Approvers added.';
                return callback('No Approvers found in Status Configuration profile for stage', appBundle);
            }
            //Make call to add the appropriate call details
            this.getPromptDetails(appBundle, statusObject);
            if ([2, 5].indexOf(appBundle.nextStatus) > -1) {
                this.setDefaultSelectedApprover(appBundle);
            }
            return callback(null, appBundle);
        }
    };
    StatusChangeService.prototype.rejectDisbursement = function (event, topic, callback) {
        var _this = this;
        //Call initiateValidation code from Status module...will return a bundle
        this.nonAppStatusChange(event, 'Rejected', topic.topic.status, function (err, rejBundle) {
            rejBundle.config = _this.config; //Add the config in so the getSubStatusByDesc can be called
            rejBundle.setSubStatus = function () {
                this.nextSubStatus = this.config.getSubStatusByDesc(8, this.nextSubStatusDesc).no;
            };
            var items = {
                rejBundle: rejBundle
            };
            //Show rejection dialog...
            _this.Dialog.updateValidForm(event, items, 'reject-dialog.html').then(function (dResult) {
                //If user continues...
                //Add status the disbursement was rejected at as well as reason code and comments
                if (angular.isUndefined(topic.topic.status.rejection_details)) {
                    topic.topic.status.rejection_details = {};
                    topic.temp.status.rejection_details = {};
                }
                topic.temp.status.rejection_details.reject_reason = dResult.locals.rejBundle.rejectionReason.code + ' - ' + dResult.locals.rejBundle.rejectionReason.desc;
                topic.temp.status.rejection_details.reject_status = topic.topic.status.status_no;
                topic.temp.status.rejection_details.reject_comments = dResult.locals.rejBundle.comments;
                //Update display
                topic.temp_ext.status = rejBundle.nextStatusDesc;
                topic.temp_ext.sub_status = rejBundle.nextSubStatusDesc;
                //Make call to save
                _this.mainStatusChange = true;
                return callback(false, dResult.locals.rejBundle);
            }).catch(function () {
                return callback(true); //User cancelled
            });
        });
    };
    StatusChangeService.prototype.closeDisbursement = function (event, topic, callback) {
        var _this = this;
        //Call initiateValidation code from Status module...will return a bundle
        this.nonAppStatusChange(event, 'Close Disbursement', topic.topic.status, function (err, closeBundle) {
            closeBundle.config = _this.config; //Add the config in so the getSubStatusByDesc can be called
            closeBundle.setSubStatus = function () {
                this.nextSubStatus = this.config.getSubStatusByDesc(9, this.nextSubStatusDesc).no;
            };
            var items = {
                closeBundle: closeBundle
            };
            //Show close dialog...
            _this.Dialog.updateValidForm(event, items, 'close-dialog.html').then(function (dResult) {
                //If user continues...
                //Add status the disbursement was rejected at as well as reason code and comments
                if (angular.isUndefined(topic.topic.status.close_details)) {
                    topic.topic.status.close_details = {};
                    topic.temp.status.close_details = {};
                }
                topic.temp.status.close_details.close_reason = dResult.locals.closeBundle.closeReason.code + ' - ' + dResult.locals.closeBundle.closeReason.desc;
                topic.temp.status.close_details.close_status = topic.topic.status.status_no;
                topic.temp.status.close_details.close_comments = dResult.locals.closeBundle.comments;
                //Update display
                topic.temp_ext.status = closeBundle.nextStatusDesc;
                topic.temp_ext.sub_status = closeBundle.nextSubStatusDesc;
                //Make call to save
                _this.mainStatusChange = true;
                return callback(false, dResult.locals.closeBundle);
            }).catch(function () {
                return callback(true); //User cancelled
            });
        });
    };
    StatusChangeService.prototype.setDefaultSelectedApprover = function (appBundle) {
        //Set initial select value for dropdown
        if (appBundle.selected_approver) {
            //If selected approver is set, ie: Cancel Approval or Renotify...set as that
            appBundle.select_approver = appBundle.selected_approver.name;
        }
        else {
            //Otherwise set as first name
            appBundle.select_approver = appBundle.nextStatusObject.users[0].name;
        }
    };
    StatusChangeService.prototype.statusChange = function (statusObject, topic_ext, action, comments) {
        statusObject = this.calculateOwnership(statusObject);
        action = angular.isUndefined(action) ? 'Status Change' : action;
        var currentMainStatus = topic_ext.status_no;
        var currentSubStatus = topic_ext.sub_status_no;
        var newMainStatus = statusObject.status_no;
        var newSubStatus = statusObject.sub_status_no;
        var event = action;
        var maChange = false;
        var ssChange = false;
        var newHist = this.getNewHistoryObject(event, null, null, comments);
        if (newMainStatus !== currentMainStatus) {
            maChange = true;
            ssChange = true; //By default
        }
        else {
            ssChange = true;
        }
        //If simply renotifying the approver...just add that history element
        if (action === 'Renotify Approver') {
            newHist.desc = 'Approval Notification sent to \'' + statusObject.approvals.selected_approver_email + '\'';
            newHist.new_owner = '-';
            statusObject.history.push(newHist);
            return statusObject;
        }
        //angular.forEach(this.config.tempData.rows, (mainStatus) => {
        angular.forEach(this.settings.status_cfg, function (mainStatus) {
            //loop until new main status desc found
            if (mainStatus.no === newMainStatus) {
                //Now loop through the main statuses sub-statuses
                angular.forEach(mainStatus.subs, function (subStatus) {
                    if (subStatus.no === newSubStatus && ssChange) {
                        if (maChange) {
                            newHist.desc = 'Status changed to \'' + mainStatus.txt +
                                '\' and Sub-Status changed to \'' + subStatus.txt + '\'';
                        }
                        else {
                            newHist.desc = 'Sub-Status changed to \'' + subStatus.txt + '\'';
                        }
                        newHist.new_owner = subStatus.owner;
                        statusObject.history.push(newHist); //Add sub-status history entry
                    }
                });
            }
        });
        return statusObject;
    };
    /**
     * Function to extract users who should not be in the Approvers list..ie: the Assignee and any people
     * who have already approved
     */
    StatusChangeService.prototype.cleanApprovers = function (approvers, exclude) {
        if (angular.isUndefined(approvers)) {
            return approvers;
        }
        var ii = 0;
        // Loop through the array of users who should be excluded
        for (var _i = 0, exclude_1 = exclude; _i < exclude_1.length; _i++) {
            var bod = exclude_1[_i];
            ii = 0; // Reset counter
            // Loop through the approvers
            for (var _a = 0, approvers_1 = approvers; _a < approvers_1.length; _a++) {
                var app = approvers_1[_a];
                // If the name to exlude is in there...lose it
                if (bod === app.email) {
                    approvers.splice(ii, 1);
                    break; // leave the loop
                }
                ii++; // iterate the counter
            }
        }
        return approvers;
    };
    /**
    * calculateOwnership - Function to calculate the ownership cycle time for a status change
    *
    * @param  {type} statusHistoryLog: any Disibursement Status History Log object, ie: topic.status.history_log
    * @param  {type} cycleTimes: any       Disbursement Status Cycle Times object, ie: topic.status.cycle_times
    * @return {type}                       cycle_time object to be pushed to Disbursement's history log
    */
    StatusChangeService.prototype.calculateOwnership = function (statusObject) {
        //Loop back thorough the history log and grab the last status change...basically, anything
        // is a status change other than an Assignment or Reassignment
        //Grab the last history log entry from the disbursement
        var scFound = false;
        var heIndexCount = statusObject.history.length - 1;
        var historyObj;
        //Loop from back to front until an entry is found where owner is not -
        for (var i = heIndexCount; i >= 0; i--) {
            historyObj = statusObject.history[i];
            if (historyObj.new_owner !== '-') {
                break;
            }
        }
        //Grab the ownership
        var owner = historyObj.new_owner; //ie:  Billing, BPSO etc
        //Grab the timestamp
        var lastHistoryDate = new Date(historyObj.timestamp);
        //Work out the difference in days
        var rightNow = new Date();
        var cycle = this.dateDiffInDays(lastHistoryDate, rightNow);
        //Look for owner's cycle in the cycle_times object
        var newOwner = true; //assume it won't be there
        statusObject.cycle_times.some(function (cycleObj, index) {
            if (cycleObj[owner] !== undefined) {
                //If found iterate the number of days
                //  console.log('cycle already exists...');
                var newCycle = cycleObj[owner] = cycleObj[owner] + cycle; //REMOVE the 5 after testing
                statusObject.cycle_times[owner] = newCycle;
                newOwner = false;
                return true;
            }
        });
        //If not found, create new object and dump in
        if (newOwner) {
            statusObject.cycle_times.push((_a = {}, _a[owner] = cycle, _a));
        }
        /*console.log('Refreshed Cycle Times = ' + statusObject.cycle_times.length);
        statusObject.cycle_times.forEach((obj) => {
            console.log(obj);
        }); */
        return statusObject;
        var _a;
    };
    StatusChangeService.prototype.getNewHistoryObject = function (event, desc, owner, comments) {
        var newHist = {
            // TODO need not to take time from client, because it can be wrong on user machine.
            // Somewhere it's overrided by timestamp from server, but may be somewhere not...
            timestamp: new Date().getTime(),
            event: event,
            user: this.env.user.email,
            desc: desc,
            new_owner: owner,
            comments: comments
        };
        return newHist;
    };
    //call from site.body.component once saves status confirmed
    StatusChangeService.prototype.sendEmail = function (logRef, oppNum) {
        if (this.appBundle === null || angular.isUndefined(this.appBundle) || (angular.isDefined(this.appBundle) && this.appBundle.action === 'Reverse Approval')) {
            return; //no email required if sub-status change or reversal
        }
        var sendTo;
        var subject;
        var message = this.appBundle.comments;
        var title;
        var template;
        if (angular.isDefined(this.appBundle.selected_approver)) {
            sendTo = this.appBundle.selected_approver.email;
            if (this.appBundle.action === 'Cancel Approval') {
                title = 'Cancel Approval';
                subject = 'DMT - Cancel Approval' + ' - ' + logRef;
            }
            else {
                title = this.appBundle.nextStatusObject.txt;
                subject = 'DMT - Pending ' + this.appBundle.approvalProcess + ' - ' + logRef;
            }
        }
        else {
            sendTo = this.appBundle.owner;
            if (this.appBundle.action === 'Reject') {
                title = 'Rejected';
                subject = 'DMT - Rejected' + ' - ' + logRef;
            }
            else {
                title = 'Approved';
                subject = 'DMT - Approved' + ' - ' + logRef;
            }
        }
        //sendTo = this.env.user.email; //  REMOVE THIS AFTER TESTING
        var email = {
            id: logRef,
            title: title,
            to: [sendTo],
            subject: subject,
            message: message,
            opp: oppNum,
            bpName: '',
            fromwho: this.env.user.email,
            template: 'approval-process',
            type: 'mailing',
            event: 'invitation'
        };
        // console.log(email);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'sendApprovalEmail',
                script: '/approvals/approvals',
                emailBundle: email,
                token: this.env.user.token
            }
        });
    };
    StatusChangeService.prototype.dateDiffInDays = function (a, b) {
        var _MS_PER_DAY = 1000 * 60 * 60 * 24;
        // Discard the time and time-zone information.
        var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    };
    StatusChangeService.$inject = ['$rootScope', '$timeout', '$q', 'socket', 'env', 'config', '$mdDialog',
        'DTS', 'Dialog', 'settings', 'notify'];
    return StatusChangeService;
}());
angular
    .module('application')
    .service('status', StatusChangeService);



//TODO - FIXME
// tslint:disable: no-commented-code
// tslint:disable: member-access
/**
 * @author Ivan Toth.
 * Saves, calculates data for data displayed in Details section
 */
//NOTE: eligibility decision should correspond to the enum EligibilityDecision in common/server/...
var EligibilityDecision;
(function (EligibilityDecision) {
    // common decisions
    EligibilityDecision[EligibilityDecision["FULLY_ELIGIBLE"] = 'Fully Eligible'] = "FULLY_ELIGIBLE";
    EligibilityDecision[EligibilityDecision["PARTIALLY_ELIGIBLE"] = 'Partially Eligible'] = "PARTIALLY_ELIGIBLE";
    EligibilityDecision[EligibilityDecision["SPECIAL_BID_ONLY"] = 'Special Bid Only'] = "SPECIAL_BID_ONLY";
    EligibilityDecision[EligibilityDecision["REJECTED"] = 'Rejected'] = "REJECTED";
    EligibilityDecision[EligibilityDecision["UNKNOWN"] = 'Unknown'] = "UNKNOWN";
    // opp v3 decisions
    EligibilityDecision[EligibilityDecision["SOLUTION_ONLY"] = 'Solution Only'] = "SOLUTION_ONLY";
    EligibilityDecision[EligibilityDecision["SOLUTION_AND_SPECIAL_BID_ONLY"] = 'Solution and Special Bid Only'] = "SOLUTION_AND_SPECIAL_BID_ONLY";
    // opp v4 decisions
    EligibilityDecision[EligibilityDecision["ENGAGEMENT_ONLY"] = 'Engagement Only'] = "ENGAGEMENT_ONLY";
    EligibilityDecision[EligibilityDecision["ENGAGEMENT_AND_SPECIAL_BID_ONLY"] = 'Engagement and Special Bid Only'] = "ENGAGEMENT_AND_SPECIAL_BID_ONLY";
})(EligibilityDecision || (EligibilityDecision = {}));
var TopicService = (function () {
    function TopicService($rootScope, $timeout, $q, socket, config, _, status, settings, env, $state, notify, Dialog) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.config = config;
        this._ = _;
        this.status = status;
        this.settings = settings;
        this.env = env;
        this.$state = $state;
        this.notify = notify;
        this.Dialog = Dialog;
        this.usFed = { status: false, beingDeleted: false }; //Flag that if set to true would mean user MUST cease processing
        this.goeFired = false;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_5 = 5;
        this.socket.on('connect', function () {
            _this.connected = true;
            var propArray = [];
            for (var prop in _this.editableComponents) {
                propArray.push(prop);
            }
            _this.updateSocketStatus(propArray);
        });
        this.socket.on('disconnect', function () {
            _this.connected = false;
            var propArray = [];
            for (var prop in _this.editableComponents) {
                propArray.push(prop);
            }
            _this.updateSocketStatus(propArray);
        });
        this.topicObjTemplate = {
            loaded: false,
            identifier: '',
            mgr: {},
            cl: {},
            fastpass: {},
            fastpass_valid: {},
            gpp: {},
            goe_data: {},
            goe_valid: {},
            goe_valid_data: {},
            cmr_valid_data: {},
            cmr: {},
            sc: {},
            pw: {},
            bpims: {},
            dc: {},
            dc_mysa: {},
            dc_sc: {},
            pd: {},
            complcl: {},
            complcl2: {},
            complcl3: {},
            complcl4: {},
            complcl_validation: {},
            complcl_calculation: {},
            complcl_opportunity_detail: {},
            complcl_investment_review: {},
            complcl_payment: {},
            complcl_exceptions: {},
            complcl_sampling: {},
            complcl_sampling_SSA: {},
            complcl_sampling_Solution: {},
            sampling_q: {},
            logs: {},
            gpp_valid: [],
            gpp_history: [],
            teams: [],
            statuses: [],
            substatuses: [],
            svistatuses: [],
            countriesAndImt: [],
            files: [],
            sampling: {},
            comments: {},
            calculation_logs: {},
            invoice_flags: {},
            sales_assist: {},
            ctl_so: {}
        };
        this.searchDropDownNames = {
            '': 'Unknown',
            'MGR': 'MGR',
            'FP-CN': 'Cust No.',
            'FP-BP': 'Acc Name',
            'FP-SN': 'Site No.',
            'FP-SO': 'S. Order',
            'CMR': 'CMR',
            'VCMR': 'Validation CMR',
            'AVCMR': 'Auto. Val. CMR',
            'GPP': 'MySA',
            'GPP-AP': 'GPP',
            'SC': 'Sales Connect',
            'SC-AP': 'Sal Con',
            'FP-V-CN': 'Cust No.',
            'FP-V-BP': 'Acc Name',
            'FP-V-SN': 'Site No.',
            'FP-V-SO': 'S. Order',
            'NC': 'AIW',
            'goe_data': "FindGOE",
            'GOE_DATA': "FindGOE",
            'GOE_VALID': "FindGOE",
            'GOE_VALID_DATA': "2ndGOE",
            'CMR_VALID_DATA': "2ndCMR",
            'dc_mysa': 'MySA',
            'dc_mysa_v4': 'MySA',
            'dc_v5': 'MySA',
            'dc_sc': 'Sales Connect',
            'MYSA_DUP': 'MySA',
            'SC_DUP': 'Sales Connect'
        };
        // Fills the topic - which will then fill all the fields in details
        this.clearTopic(undefined);
        this.visibleTabs = {};
        this.fpGovHostCodes = ['12', '13', '14', '15', '16', '17'];
        this.tabs = {
            // The list of tabs, that should be appeared
            list: [],
            // To identify which tab is active - and also to identify which edit tab to open
            activeTab: ''
        };
        //this.gov = {};
        //this.unkn = {};
        //this.resetEditable();
    }
    /**
     * Function called when topic is loaded/refreshed.  The reason is to
     * determine whether the sub-status is system-set or not which will then determine if the drop-down should be
     * visible at all.  This is a workaround that would not be needed if the sub-status field model was the status
     * object rather than the status description
     */
    TopicService.prototype.checkSubStatus = function () {
        var subStatus = this.config.getSubStatusBySubStatusNo2(this.topic.status.status_no, this.topic.status.sub_status_no);
        this.isSubSystemSet = !!subStatus && subStatus.system;
    };
    /**
     * Function to called if disbursement in an approval stage, ie: 2 or 5...purpose is to work out whether
     * the current user has authority to approve the current stage
     */
    TopicService.prototype.canApproveThisStage = function () {
        //First things first...the same user can't approve more than one stage...so if they have already approved during the process, do not allow
        if (angular.isDefined(this.topic.status.approvals.approvers) && this.topic.status.approvals.approvers.indexOf(this.env.user.email) > -1) {
            return false;
        }
        var appStage = this.config.getSubStatusBySubStatusNo2(this.topic.status.status_no, this.topic.status.sub_status_no);
        if (appStage.peer) {
            //If in a peer (non manager/team lead approval stage)
            if (appStage.bpso && this.env.user.access.bpsoAdmin) {
                //&& this.env.user.email !== this.topic.owner) {
                //If stage is BPSO Admin Peer AND user has that role AND user is not Assignee
                return true;
            }
            else if (!appStage.bpso && this.env.user.access.nonBpsoAdmin) {
                //If stage is Non-BPSO Admin Peer AND user has that role
                return true;
            }
        }
        else {
            //If in team lead/management approval stage
            if (appStage.bpso
                && this.env.user.access.bpsoApprover
                && this.config.isStageApprover(this.env.user.email, this.topic.status.status_no, this.topic.status.sub_status_no)) {
                //&& this.env.user.email !== this.topic.owner) {
                //If stage is BPSO Approver AND user has that role AND is listed as one of the approvers AND is not Assignee
                return true;
            }
            else if (!appStage.bpso
                && this.env.user.access.nonBpsoApprover
                && this.config.isStageApprover(this.env.user.email, this.topic.status.status_no, this.topic.status.sub_status_no)) {
                //If stage is Non-BPSO Approver AND user has that role AND is listed as one of the approvers
                return true;
            }
        }
        return false;
    };
    TopicService.prototype.compareDates = function (date1, date2) {
        var _MS_PER_DAY = 1000 * 60 * 60 * 24;
        var d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
        var d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
        var diff = Math.floor((d1 - d2) / _MS_PER_DAY);
        return diff;
    };
    /**
     * setActionButtons - Function to be called when the topic and everything has been loaded.  This runs
     * the actionStatus function against each user action in turn, setting true or false accordingly.  If all are
     * false the noneAvailable variable will be set to true and the action button will be disabled
     */
    TopicService.prototype.setActionButtons = function () {
        //If in the approval processes, check if the user is someone who can approve
        var canApprove = false;
        if ([2, 5].indexOf(this.topic.status.status_no) > -1) {
            canApprove = this.canApproveThisStage();
        }
        this.actions = {
            approve: this.actionStatus('approve', canApprove),
            cancelApproval: this.actionStatus('cancelApproval', canApprove),
            close: this.actionStatus('close', canApprove),
            createDispute: this.actionStatus('createDispute', canApprove),
            initiateValidation: this.actionStatus('initiateValidation', canApprove),
            refreshChecklists: this.actionStatus('refreshChecklists', canApprove),
            reject: this.actionStatus('reject', canApprove),
            rejectDis: this.actionStatus('rejectDis', canApprove),
            renotify: this.actionStatus('renotify', canApprove),
            resolveError: this.actionStatus('resolveError', canApprove),
            reverseApproval: this.actionStatus('reverseApproval', canApprove),
            rollbackStatus: this.actionStatus('rollbackStatus', canApprove),
            submitForApproval: this.actionStatus('submitForApproval', canApprove),
            viewDisputeList: this.actionStatus('viewDisputeList', canApprove),
            viewDisputes: this.actionStatus('viewDisputes', canApprove),
            changeInvReqFlag: this.actionStatus('changeInvReqFlag', canApprove),
            changeInvReceivedFlag: this.actionStatus('changeInvReceivedFlag', canApprove),
            //copyOppData: this.actionStatus('copyOppData', canApprove),
            submittedToAccountsFlag: this.actionStatus('submittedToAccountsFlag', canApprove),
            changeSalesAssist: this.actionStatus('changeSalesAssist', canApprove),
            updatePaymentDetailsStatus: this.actionStatus('updatePaymentDetailsStatus', canApprove),
            moveToPaidStatus: this.actionStatus('moveToPaidStatus', canApprove),
            overrideProspect: this.actionStatus('overrideProspect', canApprove),
            refreshSiteIds: this.actionStatus('refreshSiteIds', canApprove),
            updateCmrCdid: this.actionStatus('updateCmrCdid', canApprove),
            reAssignUser: this.actionStatus('reAssignUser', canApprove),
            embargoCheck: this.actionStatus('embargoCheck', canApprove),
            countryManualReview: this.actionStatus('countryManualReview', canApprove),
            crossBoarderEmea: this.actionStatus('crossBoarderEmea', canApprove),
            notificationPreview: this.actionStatus('notificationPreview', canApprove)
        };
        var nAvail = true;
        angular.forEach(this.actions, function (button) {
            if (button) {
                nAvail = false;
            }
        });
        this.actions.noneAvailable = nAvail;
    };
    ;
    TopicService.prototype.isAdminUser = function () {
        if (this.env.user.access.bpsoAdmin || this.env.user.access.nonBpsoAdmin) {
            return true;
        }
        return false;
    };
    TopicService.prototype.isReader = function () {
        if (this.env.user.access.reader) {
            return true;
        }
        return false;
    };
    /**
     * actionStatus - Function to determine whether the action buttons should be visible for the user.
     *                Assignee doesn't really mean much in terms of controlling who can access action buttons.
     *                Basically, if the user is able to access the document (controlled by country access) and they
     *                are not a READER, they may be able to click the buttons...
     * @param  {string} action:   string The action button in question
     * @return                    true if should be visible; else false
     */
    TopicService.prototype.actionStatus = function (action, canApprove) {
        var readerActions = ['viewDisputes', 'viewDisputeList'];
        if (this.isReader() && readerActions.indexOf(action) < 0) {
            return false;
        }
        // If no owner, only the Assign and viewDisputeList button should be available
        var noOwnerActions = ['reAssignUser', 'viewDisputeList'];
        if (!this.hasOwner() && noOwnerActions.indexOf(action) < 0) {
            return false;
        }
        if (action === 'submitForApproval') {
            // If no approval required, or it is and is complete
            if (!this.topic.status.approvals.approval_required || this.topic.status.approvals.complete) {
                return false;
            }
            if ([1, 4].indexOf(this.topic.status.status_no) === -1 || !this.isAdminUser()) {
                return false; //Not in Received or Validation status
            }
            //Only show if in stage 1 (and enabled for Pre-Approval) or stage 4 (with calcs started) and not an approver
            var preApp = this.config.hasPreApproval();
            if (((this.topic.status.status_no === 4 && angular.isDefined(this.topic.calculation)) || (this.topic.status.status_no === 1 && preApp))) {
                return true;
            }
        }
        else if (action === 'resolveError') {
            //Only show if user is an ADMIN and there are unresolved errors // Card 744 Domenico with Matt
            if (this.env.user.access.systemAdmin && angular.isDefined(this.topic.errors) && this.topic.errors.unresolved > 0) {
                return true;
            }
        }
        else if (action === 'renotify') {
            //Only show if in the middle of approval process...and is an approver (admin or approver role)
            if ([2, 5].indexOf(this.topic.status.status_no) > -1 && this.env.user.approver) {
                return true;
            }
        }
        else if (action === 'cancelApproval') {
            //Only show if in the middle of approval process and the user is NOT someone who can approve
            if ([2, 5].indexOf(this.topic.status.status_no) > -1 && !canApprove && !this.env.user.reader) {
                return true;
            }
        }
        else if (action === 'reverseApproval') {
            //Only show if in Eligibility or Validation process and enabled for Pre-approval, or in Approved status
            var preApp = this.config.hasPreApproval();
            if ((this.topic.status.status_no === 6 || ([3, 4].indexOf(this.topic.status.status_no) > -1 && preApp))
                && (this.isAdminUser() || this.env.user.systemAdmin)) {
                return true;
            }
        }
        else if (['approve', 'reject'].indexOf(action) > -1) {
            if ([2, 5].indexOf(this.topic.status.status_no) > -1 && canApprove) {
                return true; //Not in approval status
            }
        }
        else if (action === 'initiateValidation') {
            //Should only be visible in stage 3 Eligibility - if flow has the status.  Plus only if sub-status is Marked as Eligble(3) or Partially Eligible(4)
            // Not relevant for claims that do not have the Eligibility status since they will auto move to Validation upon Assignment
            if ([3].indexOf(this.topic.status.status_no) > -1 && [3, 4, 23, 28, 29, 32, 33].indexOf(this.topic.status.sub_status_no) > -1
                && this.isAdminUser()) {
                return true;
            }
        }
        else if (action === 'rejectDis') {
            //Should only be visible in stage 1 Received (if enabled for pre-approval),
            //stage 3 Eligibility, stage 4 Validation, stage 6 Approved
            var preApp = this.config.hasPreApproval();
            if (((this.topic.status.status_no === 1 && preApp)
                || [3, 4, 6].indexOf(this.topic.status.status_no) > -1)
                && this.isAdminUser()) {
                return true;
            }
        }
        else if (action === 'createDispute') {
            //Should only be visible in stage 7,8,9 (Paid, Rejected, Closed)...or stage 4 (Validation) but
            // in a Set-Aside status....and is not a dispute itself
            if (((this.topic.status.status_no === 4
                && [13, 15, 16, 17, 18, 19, 20, 21, 22, 24].indexOf(this.topic.status.sub_status_no) > -1)
                || [7, 8, 9].indexOf(this.topic.status.status_no) > -1)
                && this.isAdminUser()) {
                return true;
            }
        }
        else if (action === 'viewDisputeList') {
            //Only visible if a dispute...and topic has a dispute_details object...anyone can view
            if (angular.isDefined(this.topic.dispute_details)) {
                return true;
            }
        }
        else if (action === 'viewDisputes') {
            //Only visible if at least 1 dispute has been created...anyone can view
            if (angular.isDefined(this.topic.disputes) && this.topic.disputes.length > 0) {
                return true;
            }
        }
        else if (action === 'close') {
            //Should only be visible in stage 1 Received (if enabled for pre-approval),
            //stage 3 Eligibility, stage 4 Validation, stage 6 Approved
            var preApp = this.config.hasPreApproval();
            if (((this.topic.status.status_no === 1 && preApp)
                || [3, 4, 6].indexOf(this.topic.status.status_no) > -1)
                && this.isAdminUser()) {
                return true;
            }
        }
        else if (action === 'rollbackStatus') {
            //Only allow for System Admin...and only if sub-status is system-set OR if in Validation, Closed or Paid status where they could be rolled-back
            if ([2, 5].indexOf(this.topic.status.status_no) < 0
                && ([4, 7, 9].indexOf(this.topic.status.status_no) > -1 || this.config.isSystemStatus(this.topic.status.status_no, this.topic.status.sub_status_no)) && this.env.user.access.systemAdmin) {
                return true;
            }
        }
        else if (action === 'refreshChecklists') {
            //Only allow for System Admin...and only if in Elig,Validation or Approved statuses - if Closed/Rejected/Paid..allow for Sampling update
            if ([3, 4, 6, 7, 8, 9].indexOf(this.topic.status.status_no) > -1 && this.env.user.access.systemAdmin) {
                return true;
            }
        }
        else if (action === 'changeInvReqFlag') {
            if (this.topic.status.status_no === 4 &&
                [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(this.topic.status.sub_status_no) > -1) {
                if (this.env.user.access.bpsoAdmin) {
                    return true;
                }
            }
        }
        else if (action === 'changeInvReceivedFlag') {
            if (this.topic.status.status_no === 4 &&
                [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(this.topic.status.sub_status_no) > -1) {
                if (this.env.user.access.bpsoAdmin) {
                    return true;
                }
            }
        }
        else if (action === 'submittedToAccountsFlag') {
            if (this.topic.status.status_no === 4 && [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(this.topic.status.sub_status_no) > -1) {
                if (this.env.user.access.bpsoAdmin) {
                    return true;
                }
            }
        }
        else if (action === 'changeSalesAssist') {
            if (this.env.user.access.systemAdmin) {
                return true;
            }
        }
        else if (action === 'embargoCheck') {
            return _.get(this, 'checksData.manualReview.history.isRCISCountry', false) && (this.env.user.access.systemAdmin || this.env.user.access.bpsoAdmin);
        }
        else if (action === 'countryManualReview') {
            return (_.get(this, 'checksData.manualReview.history.isChinaCountry', false) ||
                _.get(this, 'checksData.manualReview.history.isItalyCountryException', false) ||
                _.get(this, 'checksData.manualReview.history.isAsiaPacificCountryException', false)) ||
                _.get(this, 'checksData.manualReview.history.isKoreaCountryException', false) ||
                _.get(this, 'checksData.manualReview.history.isJapanCountryException', false) &&
                    (this.env.user.access.systemAdmin || this.env.user.access.bpsoAdmin);
        }
        else if (action === 'updatePaymentDetailsStatus') {
            if (this.env.user.access.systemAdmin) {
                if (this.topic.status.status_no === 7 || ([4, 6].indexOf(this.topic.status.status_no) > -1 && this.areCalcsStarted())) {
                    // const setAside: boolean = this.topic.calculation && this.topic.calculation.sapResult === 'Set Aside' ? true : false;
                    // if (!setAside) {
                    //     return true;
                    // }
                    return true;
                }
            }
        }
        else if (action === 'moveToPaidStatus') {
            if (this.env.user.access.bpsoAdmin) {
                var updateBundle = Object.assign({}, this.topic.calculation);
                if ((this.topic_ext.sub_status === 'Pending BPSO - Submit to Accounts Payable' ||
                    this.topic_ext.sub_status === 'Pending Accounts Payable') && updateBundle.goe === 'N') {
                    return true;
                }
            }
        }
        else if (action === 'updateCmrCdid') {
            var uiVersion = _.get(this, 'checksData.uiVersion', 1);
            var cmrNumber = _.get(this, 'checksData.inbound.inbound.incentiveInformation.incentiveDetail.incentiveCMRNumber', '');
            var generics = _.get(this, 'checksData.inbound.inbound.incentiveInformation.incentiveDetail.generics', []);
            var isDCID = generics.filter(function (genericObject) { return genericObject.name === 'domesticClientId' && genericObject.value; }).length > 0;
            var isSystem = this.env.user.access.systemAdmin;
            var isBPSO = this.env.user.access.bpsoAdmin;
            if (uiVersion >= this.OPP_VERSION_3 && (((!cmrNumber || !isDCID) && isBPSO) || isSystem)) {
                return true;
            }
        }
        else if (action === 'overrideProspect') {
            var uiVersion = _.get(this, 'checksData.uiVersion', 1);
            var cmrNumber = _.get(this, 'checksData.inbound.inbound.incentiveInformation.incentiveDetail.incentiveCMRNumber', '');
            if (cmrNumber.substr(0, 1) === "P" && uiVersion >= this.OPP_VERSION_3 && (this.env.user.access.systemAdmin || this.env.user.access.bpsoAdmin)) {
                return true;
            }
        }
        else if (action === 'reAssignUser') {
            if (this.env.user.access.bpsoAdmin || this.env.user.access.systemAdmin || this.env.user.access.nonBpsoAdmin) {
                return true;
            }
            return true;
        }
        else if (action === 'refreshSiteIds') {
            // Only show on eligibility and exclude "eligible" substatuses
            if ((this.env.user.access.bpsoAdmin || this.env.user.access.systemAdmin || this.env.user.access.nonBpsoAdmin) &&
                this.topic.version && this.topic.version >= this.OPP_VERSION_5 &&
                (this.topic.status.status_no < 4 && !([3, 4, 23, 28, 29, 32, 33].indexOf(this.topic.status.sub_status_no) > -1))) {
                return true;
            }
        }
        else if (action === 'crossBoarderEmea') {
            return (_.get(this, 'checksData.manualReview.history.isCrossBoarder', false) &&
                _.get(this, 'checksData.manualReview.history.isEmeaCountry', false) &&
                (this.env.user.access.systemAdmin || this.env.user.access.bpsoAdmin));
        }
        else if (action === 'notificationPreview') {
            if ((this.env.user.access.systemAdmin || this.env.user.access.bpsoAdmin || this.env.user.access.nonBpsoAdmin) &&
                _.get(this, 'topic.bpNotificationTemplateInfo.isTemplateExist', false)) {
                return true;
            }
        }
        // else if (action === 'copyOppData') {
        //     const isDispute: boolean = /-DIS:/.test(this.topic._id);
        //     // if role is admin and it's parent. Feature is not applicable to dev
        //     if (this.env.user.access.systemAdmin && !isDispute) {
        //         return true;
        //     }
        // }
        return false; ///set to true to see all buttons
    };
    /**
     * Function to determine if disbursement is in a Set Aside sub-status
     */
    TopicService.prototype.isSetAside = function () {
        var subby = this.config.getSubStatusBySubStatusNo2(this.topic.status.status_no, this.topic.status.sub_status_no);
        if (subby.txt.indexOf('Set Aside') > -1) {
            return true;
        }
        return false;
    };
    /**
     * Function to determine if the Disbursement is at the end of its life cycle, ie: Rejected, Paid or Closed
     */
    TopicService.prototype.isComplete = function () {
        if ([7, 8, 9].indexOf(this.topic.status.status_no) > -1) {
            return true;
        }
        return false;
    };
    /**
      resetEditable - Resets the editableComponents values to false, or removes them completely
    */
    TopicService.prototype.resetEditable = function () {
        // Decision if the template can be edited & if its currently in edit mode
        var _this = this;
        //These objects do not exist on the saved cloud document - they need to be added at initial load time
        var sections = ['eligibility', 'validation', 'sampling_SSA', 'mysa', 'sampling_Solution', 'payment', 'fcmr', 'fcmr_valid'];
        //Set the files and comments objects for each
        this.editableComponents = {};
        angular.forEach(sections, function (section) {
            _this.editableComponents['files$' + section] = { editable: false, editMode: false };
            _this.editableComponents['comments$' + section] = { editable: false, editMode: false };
        });
    };
    /**
      updateSocketStatus - Updates the socket status of editableComponents based on input or editable property
      @param {any} nestedArray:  Array of nested objects, whose edit options should be recalculated
      @returns void
    */
    TopicService.prototype.updateSocketStatus = function (nestedArray) {
        var _this = this;
        var currentStatus = this.connected ? '' : 'Disconnected';
        angular.forEach(nestedArray, function (prop) {
            if (_this.editableComponents[prop].editable) {
                _this.editableComponents[prop]['socket'] = currentStatus;
            }
            else if (_this.editableComponents[prop].locked) {
                _this.editableComponents[prop]['socket'] = 'Locked';
            }
            else {
                _this.editableComponents[prop]['socket'] = 'Not Editable';
            }
        });
    };
    /**
      updatePartialSocketStatus - If a update is performed this function identifies which object is beeing updated in editableComponents. If the socket property
      is empty then its updateable, if somethign is filled (upd - updating and waitng for response, dc - socket disconnected)
      @param {Array<string>} itemArray:       array of strings, which identify what object's socket property is changed
      @param {string} newValue:               value to update
      @returns boolean                        decides if hte object can be updated or not
    */
    TopicService.prototype.updatePartialSocketStatus = function (itemArray, newValue) {
        var _this = this;
        var canBeUpdated = true;
        angular.forEach(itemArray, function (value) {
            // socket item has to be defined, not 'dc' and not filled if you want to add a non empty string
            if (angular.isDefined(_this.editableComponents[value])) {
                if (_this.editableComponents[value]['socket'] === 'Locked' && _this.env.user.access.systemAdmin) {
                }
                else if ((!_this.editableComponents[value].editable) &&
                    ((_this.editableComponents[value]['socket'] === 'Disconnected') ||
                        (_this.editableComponents[value]['socket'] !== '' && newValue !== 'clear'))) {
                    canBeUpdated = false;
                }
            }
            else {
                canBeUpdated = false;
            }
        });
        if (canBeUpdated) {
            angular.forEach(itemArray, function (value) {
                if (_this.editableComponents[value]['socket'] !== 'Disconnected' && newValue === 'clear') {
                    newValue = '';
                }
                _this.editableComponents[value]['socket'] = newValue;
            });
            return true;
        }
        else {
            this.notify.error('You either do not have access, or are not permitted to make any updates at present');
            return false;
        }
    };
    /**
      clearTopic - Clears all the important properties of the topic. Calculates the browser random ID, calculates socket statuses
      @param {string} id:       id of the topic
    */
    TopicService.prototype.clearTopic = function (id) {
        // console.info('$topic (clearTopic) => clearing topic');
        if (angular.isUndefined(this.loaded)) {
            this.clearLoading();
        }
        this.loaded.topic = false;
        var array = new Uint32Array(2);
        this.topicBrowserID = window.crypto.getRandomValues(array)[0];
        this.reloadCheck = {
            topicBrowserID: this.topicBrowserID,
            id: id //Q unique ID
        };
        this.topic = angular.copy(this.topicObjTemplate);
        this.editArrays = {
            editableObjectArrayFalse: [],
            editableObjectArrayTrue: [],
            nonEditArray: [],
            nonEditArrayBrowser: [],
            lockedArray: [],
            editableComponentsArray: []
        };
        this.resetCompareGppData();
        this.topic_ext = {};
        this.decStatus = 'Unknown';
        this.temp = {
            mgr: {},
            cl: {},
            fp: {},
            gpp: {},
            cmr: {},
            cmr_valid_data: {},
            goe_data: {},
            sc: {},
            pw: {},
            bpims: {},
            dc: {},
            pd: {},
            complcl: {},
            sampling_q: {},
            logs: {},
            comments: {}
        };
        this.temp_ext = {};
        this.liveGpp = {};
        this.country = {};
        if (angular.isUndefined(this.loaded) || !this.loaded.userProfile) {
            this.resetEditable(); //initiate editablecomponents
            var propArray = [];
            for (var prop in this.editableComponents) {
                propArray.push(prop);
            }
            this.updateSocketStatus(propArray);
        }
        else {
            for (var prop in this.topic.editableComponents) {
                this.calculateAccess([prop], false);
            }
        }
    };
    /**
      clearLoading - clears the loading values
    */
    TopicService.prototype.clearLoading = function () {
        this.loaded = { config: false, topic: false, gpp_valid: false, gpp_elig: false, settings: false, program: false, userProfile: false };
    };
    /**
      fromConfig - Sends all the data from config
    */
    TopicService.prototype.fromConfig = function () {
        this.loaded.config = true;
        this.transformTopic();
    };
    /**
      fromConfigProgram - Called once the program profile has been retrieved and set - from site.body.component
    */
    TopicService.prototype.fromConfigProgram = function () {
        this.loaded.program = true;
        //this.setActionButtons(); //Make call on the hide/show for the action buttons
    };
    /**
      fromUserProfile - Check if the topic is loaded, if not, save the nested objects for later process
    */
    TopicService.prototype.fromUserProfile = function () {
        this.loaded.userProfile = true;
        if (!this.loaded.topic) {
            if (angular.isUndefined(this.processAccessLater)) {
                this.processAccessLater = [];
            }
            for (var prop in this.editArrays.editableComponentsArray) {
                this.processAccessLater.push(this.editArrays.editableComponentsArray[prop]);
            }
        }
        for (var prop in this.editArrays.editableComponentsArray) {
            this.calculateAccess([this.editArrays.editableComponentsArray[prop]], true);
        }
    };
    /**
      calculateAccess - Checks if the array of nested objects is editable or not
      @param {any} nestedObj:       nested object to check if editable
      @param {boolean} addObj:      if true, nested object that will be passed will be added into editableCompnents
    */
    TopicService.prototype.calculateAccess = function (nestedObj, addObj) {
        var _this = this;
        var nestedUpd = [];
        angular.forEach(nestedObj, function (nested) {
            if (angular.isDefined(_this.editableComponents[nested]) || addObj) {
                _this.editableComponents[nested] = {
                    editable: false,
                    editMode: false,
                    socket: ''
                };
                if (_this.editArrays.lockedArray.indexOf(nested) > -1) {
                    _this.editableComponents[nested].locked = true; //If is in the locked array, set as locked
                }
                else if (angular.isUndefined(_this.editArrays.nonEditArrayBrowser) || _this.editArrays.nonEditArrayBrowser.indexOf(nested) > -1
                    || _this.editArrays.nonEditArray.indexOf(nested) > -1) {
                }
                else if (_this.editArrays.editableObjectArrayFalse.indexOf(nested) > -1) {
                    //If if the editfalse array set accordingly
                    _this.editableComponents[nested].editable = true;
                    _this.editableComponents[nested].editMode = false;
                }
                else if (_this.editArrays.editableObjectArrayTrue.indexOf(nested) > -1) {
                    //If if the edittrue array set accordingly
                    _this.editableComponents[nested].editable = true;
                    _this.editableComponents[nested].editMode = true;
                }
                else {
                }
                nestedUpd.push(nested);
            }
        });
        //Call routine to set each editable object's socket status..ie: 'Not editable' etc
        this.updateSocketStatus(nestedUpd);
    };
    /**
      updateEditOptions - updates editableComponentsArray based on the server editOptions & at the end calculates the access.
      @param {any}          data:      Contains the editOption object, that is sent from the server(has the edit, non-edit, locked objects)
      @param {string}    program:      program of the opened oppty
    */
    TopicService.prototype.updateEditOptions = function (data, program) {
        var _this = this;
        this.resetEditable(); //Wipe....so it can be refreshed with the values from the server (otherwise items NOT pulled back from the server remain editable)
        this.editArrays.editableObjectArrayFalse = data.editableObjectArrayFalse;
        this.editArrays.editableObjectArrayTrue = data.editableObjectArrayTrue;
        this.editArrays.nonEditArray = data.nonEditArray;
        this.editArrays.lockedArray = data.lockedArray;
        this.setTabList(data.openableTabs, program);
        this.editArrays.editableComponentsArray = [];
        angular.forEach(this.editArrays.editableObjectArrayFalse, function (nested) {
            _this.editArrays.editableComponentsArray.push(nested);
        });
        angular.forEach(this.editArrays.editableObjectArrayTrue, function (nested) {
            _this.editArrays.editableComponentsArray.push(nested);
        });
        angular.forEach(this.editArrays.nonEditArray, function (nested) {
            _this.editArrays.editableComponentsArray.push(nested);
        });
        angular.forEach(this.editArrays.lockedArray, function (nested) {
            _this.editArrays.editableComponentsArray.push(nested);
        });
        this.calculateAccess(this.editArrays.editableComponentsArray, true);
    };
    /**
      fromSettings - Sends all the data from config
    */
    TopicService.prototype.fromSettings = function () {
        this.loaded.settings = true;
        this.setCountry();
    };
    /**
      sameRequest - Returns true if the same opp number is beeing selected again
      @param {string} identifier:   identifier of the opened screen
      @returns {boolean}            calls at the end updateServerTopic - that sends the socket to the server
    */
    TopicService.prototype.sameRequest = function (identifier) {
        return (this.topic.identifier === identifier) ? true : false;
    };
    TopicService.prototype.setCountry = function () {
        if ((this.loaded.settings || this.settings.loaded) && this.loaded.topic) {
            this.country = this.settings.calcCountryObj(this.topic.gpp[0].acctctry);
        }
    };
    TopicService.prototype.topicLoaded = function () {
        this.loaded.topic = true;
    };
    /** Updates every property in the topic object one by one
        @param {any} data:   Passes the object from server into topic without any calculation
    */
    TopicService.prototype.updateTopicWithoutCalc = function (data) {
        for (var prop in data) {
            if (!data.hasOwnProperty(prop)) {
                continue;
            }
            ;
            this.topic[prop] = data[prop];
            if (prop === 'gpp_live') {
                this.calculateGppDifference('gpp_live', 'gpp');
            }
        }
    };
    /**
      calculateGppDifference - calculates the difference in the GPP array objects and sets true for every property in compareGpp,
        where the value is identical. If difference, its marked as red. If row ID missing, put it into another gppMissing variable
      @param {string} original:   string name of the to be compared gpp object
      @param {string} difference:   string name of the to be display red items in the gpp object
      @returns void
    */
    TopicService.prototype.calculateGppDifference = function (original, difference) {
        var _this = this;
        if (angular.isUndefined(this.compareGpp[difference])) {
            this.compareGpp[difference] = {};
        }
        angular.forEach(this.topic[difference], function (diffItem) {
            if (angular.isUndefined(diffItem.ods_mismatch)) {
                _this.compareGpp.gppSection.ods.message = 'ODS check not performed';
            }
            else if (diffItem.ods_mismatch) {
                _this.compareGpp.gppSection.ods.status = true;
            }
            _this.compareGpp[difference][diffItem.row_id] = { found: false };
        });
        angular.forEach(this.topic[original], function (origItem) {
            var foundLine = false;
            angular.forEach(_this.topic[difference], function (diffItem) {
                if (angular.isDefined(origItem.row_id) && angular.isDefined(diffItem.row_id) && origItem.row_id === diffItem.row_id) {
                    foundLine = true;
                    _this.compareGpp[difference][diffItem.row_id].found = true;
                    for (var prop in diffItem) {
                        if (diffItem[prop] === origItem[prop]) {
                            _this.compareGpp[difference][diffItem.row_id][prop] = true;
                        }
                        else {
                            // To display warning sign if something is missing there
                            if (_this.compareGpp.gppSection.bf.variables.indexOf(prop) > -1) {
                                _this.compareGpp.gppSection.bf.status = true;
                            }
                            else if (_this.compareGpp.gppSection.or.variables.indexOf(prop) > -1) {
                                _this.compareGpp.gppSection.or.status = true;
                            }
                            else if (_this.compareGpp.gppSection.svi.variables.indexOf(prop) > -1) {
                                _this.compareGpp.gppSection.svi.status = true;
                            }
                            else if (_this.compareGpp.gppSection.ci.variables.indexOf(prop) > -1) {
                                _this.compareGpp.gppSection.ci.status = true;
                            }
                        }
                    }
                }
            });
            if (!foundLine) {
                _this.compareGpp.gppSection.bf.status = true;
                //this.compareGpp.gppSection.st.status = true;
                _this.compareGpp.gppSection.or.status = true;
                _this.compareGpp.gppSection.svi.status = true;
                _this.compareGpp.gppSection.ci.status = true;
                _this.compareGpp[difference + 'Missing'].push(origItem);
            }
        });
    };
    /**
      lockCheck - Checks if the updated objects in topic are locked or not.
      @param {Array<string>} propArray:   array contains objects, that are beeing updated in topic
    */
    /*lockCheck(propArray: any) {
        let lockCheckArray = ['cmr', 'mgr', 'fastpass', 'dc', 'complcl2', 'complcl3'];
        angular.forEach(lockCheckArray, (component) => {
            if (propArray.indexOf(component) > -1) {
                if (angular.isDefined(this.topic[component].locked) && this.topic[component].locked) {
                    this.editArrays.nonEditArrayBrowser.push(component);
                };
            }
        });
    }*/
    /** Updates every property in the topic object one by one and preforms calculations
     * @param {any}                        data:   data to be updated into the topic.
     * @param {boolean}                     sub:   true = updates topic with 10k$ code, false = it'll copy over the variables into topic
     * @param {Array<string>} updateEditObjects:   true = will recalculate also edit options, false= edit options recalculation is ignored
     * @returns void
     */
    TopicService.prototype.updateTopic = function (data, sub, updateEditObjects) {
        var _this = this;
        //console.info('$topic (updateTopic) => data: ', data, 'sub: ', sub, 'eo: ', updateEditObjects);
        var propArray = [];
        if (sub) {
            for (var prop in data) {
                var topicUpd = this.topic; //reset topic
                var varName = prop.split('.');
                propArray.push(varName[0]);
                var val = data[prop];
                //Ensure the prop exists - Added by Matt on 18th May 2017 since there are several scenarios
                //where the cloudantmodel is not up-to-date and valid objects do not exist on the topic...this
                //resylts in this code failing and not being able to refresh the browser content correctly
                if (angular.isUndefined(topicUpd[varName[0]])) {
                    topicUpd[varName[0]] = {};
                }
                //topicUpd = topicUpd[varName.shift()];
                // Getting to the location of the update object
                while (varName.length > 1) {
                    topicUpd = topicUpd[varName.shift()];
                }
                if (angular.isUndefined(topicUpd)) {
                    // In case the updated object is undefined, take the whole nested object content
                    this.updateServerTopic('getPartialCouchObj', { id: this.topic._id, data: {}, type: [varName[0]] }, false);
                }
                // Perform update based on type of update
                if (val.add) {
                    topicUpd[varName.shift()] = val.data;
                }
                else if (val.push) {
                    var dot = varName.shift();
                    if (!_.isArray(topicUpd[dot])) {
                        topicUpd[dot] = [];
                    }
                    for (var p in val.data) {
                        topicUpd[dot].push(val.data[p]);
                    }
                }
                else if (val.clearArray) {
                    var tempObj = varName.shift();
                    topicUpd[tempObj] = [];
                }
                else if (val.delete) {
                    delete topicUpd[varName.shift()];
                }
            }
        }
        else {
            for (var prop in data) {
                if (!data.hasOwnProperty(prop)) {
                    continue;
                }
                ;
                propArray.push(prop);
                this.topic[prop] = data[prop];
            }
        }
        if (propArray.length > 0) {
            if (updateEditObjects.length > 0) {
                this.calculateAccess(updateEditObjects, true);
            }
            else {
                this.calculateAccess(propArray, true);
            }
            this.topicLoaded();
        }
        if (propArray.indexOf('status') > -1 || propArray.indexOf('files') > -1) {
            this.transformTopic();
            //Make call on the hide/show for the action buttons...moved from socket listener fromConfigProgram()
            // since the settings HAVE to be loaded before the topic so need to wait until topic is loaded.  This function
            // needs both settings and topic to be loaded before firing
            this.setActionButtons();
        }
        var govItems = [];
        if (propArray.indexOf('complete') > -1 && angular.isDefined(this.topic.complete.errorsArray)) {
            this.topic.complete.errorsArray.all = [];
            var table_1 = [];
            for (var prop_1 in this.topic.complete.errorsArray) {
                // filter out errors from inner 2 goe check in validation - to exclude double errors on top level
                if (angular.isArray(this.topic.complete.errorsArray[prop_1]) &&
                    !['goePick_valid', 'complcl_validation'].includes(prop_1)) {
                    angular.forEach(this.topic.complete.errorsArray[prop_1], function (tableItem) {
                        table_1.push(tableItem);
                    });
                }
            }
            this.topic.complete.errorsArray.all = table_1;
        }
        if (propArray.indexOf('cmr_valid') > -1) {
            govItems.push('cmr_valid');
        }
        if (propArray.indexOf('cmr') > -1) {
            govItems.push('cmr');
        }
        if (propArray.indexOf('mgr') > -1) {
            govItems.push('mgr');
        }
        if (propArray.indexOf('fastpass') > -1) {
            govItems.push('fastpass');
        }
        if (propArray.indexOf('fastpass_valid') > -1) {
            govItems.push('fastpass_valid');
        }
        if (govItems.length > 0) {
            this.calcGovItems(govItems);
        }
        if (propArray.indexOf('gpp') > -1) {
            this.setTempFromTopicPart('gpp');
        }
        if (propArray.indexOf('elig_dec') > -1) {
            if (this.topic.elig_dec.eligibilityDecision === EligibilityDecision.FULLY_ELIGIBLE) {
                this.decStatus = 'Marked as Eligible';
            }
            else if (this.topic.elig_dec.eligibilityDecision === EligibilityDecision.PARTIALLY_ELIGIBLE) {
                this.decStatus = 'Marked as Partially Eligible';
            }
            else if (this.topic.elig_dec.eligibilityDecision === EligibilityDecision.SOLUTION_ONLY) {
                this.decStatus = 'Marked as Eligible - Solution Only';
            }
            else if (this.topic.elig_dec.eligibilityDecision === EligibilityDecision.REJECTED) {
                this.decStatus = 'Eligibility Rejected';
            }
            else if (this.topic.elig_dec.eligibilityDecision === EligibilityDecision.SOLUTION_AND_SPECIAL_BID_ONLY) {
                this.decStatus = 'Change Sub-Status to Marked as Eligible - Solution and Special Bid Only';
            }
            else if (this.topic.elig_dec.eligibilityDecision === EligibilityDecision.SPECIAL_BID_ONLY) {
                this.decStatus = 'Change Sub-Status to Marked as Eligible - Special Bid Only';
            }
        }
        this.setTempFromTopicPart('header_data');
        var countryArray = ['gpp'];
        angular.forEach(countryArray, function (component) {
            if (propArray.indexOf(component) > -1) {
                _this.setCountry();
            }
        });
        //Once the topic is loaded, check if the Program Profile is already loaded
        if (propArray.length > 0) {
            this.checkProgramProfile();
        }
        if (updateEditObjects) {
            this.$rootScope.$broadcast('broadcast:topicUpdated', propArray); // $rootScope.$on
        }
        propArray = [];
        //this.loaded.topic = true;
    };
    /**
     * checkProgramProfile - Function to check if the Program Profile needs to be loaded.  If already loaded
     * a check will be made to compare the program key of the current topic and the profile loaded.  If they
     * don't match, ie: user exits one Disbursement and enters another, the call will be made to get it
     *
     */
    TopicService.prototype.checkProgramProfile = function () {
        if (this.config.proProfileLoaded) {
            //If so, get the current program key from the topic
            var currPPKey = this.topic.country + this.topic.program + this.topic.bp_type +
                this.topic.onshore_offshore;
            //And the key of the profile loaded
            var profKey = this.config.proProfile.country + this.config.proProfile.program +
                this.config.proProfile.bp_type + this.config.proProfile.onshore_offshore;
            //check brands
            var brandMatch = false;
            if (this.topic.brands.indexOf(this.config.proProfile.brand) > -1) {
                brandMatch = true;
            }
            //if they don't match...
            if (currPPKey !== profKey || !brandMatch) {
                this.config.getProgramProfile(this.topic); //make the call to get it
            }
        }
        else {
            this.config.getProgramProfile(this.topic); //make the call to get it
        }
    };
    TopicService.prototype.setLiveGpp = function (data) {
        this.liveGpp = data;
    };
    TopicService.prototype.setTopic = function (data) {
        this.topic = data;
    };
    TopicService.prototype.getTopic = function () {
        return this.topic;
    };
    // Calulates if items in the table have the government flag set to Y.. its ugly now, but once we get more data sources, this will
    // be overwritten into a general function
    TopicService.prototype.calcGovItems = function (govItems) {
        var _this = this;
        angular.forEach(govItems, function (govItem) {
            var objectName = govItem;
            // Check if its a object and if its not undefined and has at least 1 result
            if (angular.isDefined(_this.topic[objectName]) && angular.isDefined(_this.topic[objectName].results) && angular.isArray(_this.topic[objectName].results)) {
                _this.topic[objectName].govs = -1;
                _this.topic[objectName].unkn = -1;
                if (_this.topic[objectName].results.length > 0) {
                    _this.topic[objectName].govs = 0;
                    _this.topic[objectName].unkn = 0;
                    angular.forEach(_this.topic[objectName].results, function (tableRow) {
                        if (angular.isDefined(tableRow.govs) && tableRow.govs > -1) {
                            _this.topic[objectName].govs += tableRow.govs;
                            _this.topic[objectName].unkn += tableRow.unkn;
                        } /*else {
                  angular.forEach(tableRow.table, (item) => {
                    // Insert here comparison if needed
                  });
                }*/
                    });
                }
            }
            else {
                _this.topic[objectName] = {};
                _this.topic[objectName].govs = -1;
                _this.topic[objectName].unkn = -1;
                _this.topic[objectName].results = [];
            }
        });
    };
    // transforms the topic status data from id's to description
    TopicService.prototype.transformTopic = function () {
        var _this = this;
        if (this.loaded.config && this.loaded.topic && this.loaded.userProfile) {
            //Just to copy into the temp folder the status
            this.temp['status'] = angular.copy(this.topic.status);
            this.setTempFromTopicPart('status');
            var tempTopic = {};
            this.topic_ext = {};
            angular.copy(this.topic, tempTopic);
            var tempStatus = { status: '', sub_status: '', status_array: [], problem: true };
            //Loops through available statuses and if the status is found looop through substatuses
            //if (!angular.isUndefined(this.topic.status.status_no) && !angular.isUndefined(this.config.tempData)) {
            if (!angular.isUndefined(this.topic.status.status_no) && !angular.isUndefined(this.settings.status_cfg)) {
                //angular.forEach(this.config.tempData.rows, (status) => {
                angular.forEach(this.settings.status_cfg, function (status) {
                    if (status.no === _this.topic.status.status_no) {
                        tempStatus.status = status.txt;
                        angular.forEach(status.subs, function (sub_status) {
                            tempStatus.status_array.push({ no: sub_status.no, txt: sub_status.txt, active: angular.isUndefined(sub_status.active) ? true : sub_status.active, system: angular.isDefined(sub_status.system) ? sub_status.system : false });
                            // status & substatus is found convert it
                            if (sub_status.no === _this.topic.status.sub_status_no) {
                                tempStatus.sub_status = sub_status.txt;
                                tempStatus.problem = false;
                            }
                        });
                    }
                });
                this.topic_ext = tempStatus;
            }
            else {
                console.info('could not load status: ' + this.topic.status.status_no + ' - ' + this.settings.status_cfg);
            }
            this.topic_ext.attachments = this.topic.files.map(function (file) { return file.name; });
            angular.copy(this.topic_ext, this.temp_ext);
        }
    };
    // translates status description into id values
    TopicService.prototype.detransform = function (obj) {
        var _this = this;
        var obj_ext = obj + '_ext';
        if (this.loaded.config && this.loaded.topic && this.loaded.userProfile) {
            //if (!angular.isUndefined(this[obj_ext].status) && !angular.isUndefined(this.config.tempData)) {
            if (!angular.isUndefined(this[obj_ext].status) && !angular.isUndefined(this.settings.status_cfg)) {
                //angular.forEach(this.config.tempData.rows, (status) => {
                angular.forEach(this.settings.status_cfg, function (status) {
                    if (status.txt === _this[obj_ext].status) {
                        _this[obj].status.status_no = status.no;
                        angular.forEach(status.subs, function (sub_status) {
                            // status & substatus is found convert it
                            if (sub_status.txt === _this[obj_ext].sub_status) {
                                _this[obj].status.sub_status_no = sub_status.no;
                            }
                        });
                    }
                });
            }
        }
    };
    /** diff- calculate the difference between 2 objects. This will keep only those objects, that are the temp difference vs topic content
     * @param {any}          a: temp object
     * @param {any}          b: topic object
     * @param {any} reversible: for now always false / probably not needed
     */
    TopicService.prototype.diff = function (a, b, reversible) {
        var r = {};
        this.deepDiff(a, b, r, reversible);
        if (reversible) {
            this.deepDiff(b, a, r, reversible);
        }
        return r;
    };
    // needed for the diff functions
    /** deepDiff shows difference also when object is undefined
     * @param {any}          a: temp object
     * @param {any}          b: topic object
     * @param {any}          r: result -the difference in object
     * @param {any} reversible: for now always false / probably not needed
     */
    TopicService.prototype.deepDiff = function (a, b, r, reversible) {
        var _this = this;
        _.each(a, function (v, k) {
            //Ivan This ensures, that also undefined objects will be displayed in delta
            if (angular.isUndefined(b)) {
                return r[k] = v;
            }
            if (angular.isUndefined(r) || angular.isUndefined(a)) {
                return;
            }
            // already checked this or equal...
            if (r.hasOwnProperty(k) || b[k] === v) {
                return;
            }
            // but what if it returns an empty object? still attach?
            var val = _.isObject(v) ? _this.diff(v, b[k], reversible) : v;
            if (!_.isObject(val) || _.keys(val).length > 0) {
                r[k] = val;
            }
        });
    };
    ;
    /** diff_withPath - Translates the difference object into a dot separated object
     * @param {any}    a: the difference object (its does not have string paths)
     * @param {any} path: the starting string path
     * @param {any}    r: starting result object
     */
    TopicService.prototype.diff_withPath = function (a, path, r) {
        this.deepDiff_withPath(a, path, r);
        return r;
    };
    /** deepDiff_withPath - Converts the difference object to dot separated objects - It does not work 100%, therefore in same cases you need stop
     *      the whole comparison and get only a part of the diff object
     * @param {any}    a: the difference object (its does not have string paths)
     * @param {any} path: the starting string path
     * @param {any}    r: starting result object
     */
    TopicService.prototype.deepDiff_withPath = function (a, path, r) {
        var _this = this;
        // Push the array for the whole object, if its the lower mentioned object
        if (path == 'gpp_history') {
            for (var prop in a) {
                if (!a.hasOwnProperty(prop)) {
                    continue;
                }
                ;
                if (angular.isUndefined(r[path])) {
                    r[path] = {};
                }
                ;
                if (angular.isUndefined(r[path]['data'])) {
                    r[path] = { data: [], push: true };
                }
                r[path]['data'].push(a[prop]);
            }
            return r;
        }
        //Ivan This ensures, that also undefined objects will be displayed in delta (at least once nested)
        _.each(a, function (v, k) {
            if (path + '.' + k === 'status.history' || path === 'comments') {
                for (var prop in v) {
                    if (!v.hasOwnProperty(prop)) {
                        continue;
                    }
                    ;
                    if (angular.isUndefined(r[path + '.' + k])) {
                        r[path + '.' + k] = {};
                    }
                    ;
                    if (angular.isUndefined(r[path + '.' + k]['data'])) {
                        r[path + '.' + k] = { data: [], push: true };
                    }
                    r[path + '.' + k]['data'].push(v[prop]);
                }
                return r;
            }
            if (path + '.' + k === 'status.cycle_times') {
                var itemToBeAdded = -1;
                var tempV = {};
                var toBeUpdItem = '';
                for (var toFindArrayObj in v) {
                    for (var updItemName in v[toFindArrayObj]) {
                        toBeUpdItem = updItemName;
                    }
                }
                for (var l = 0; l < _this.topic.status.cycle_times.length; l++) {
                    for (var ctProp in _this.topic.status.cycle_times[l]) {
                        if (toBeUpdItem === ctProp) {
                            itemToBeAdded = l;
                            tempV = _this.topic.status.cycle_times[l];
                        }
                    }
                    ;
                }
                ;
                if (itemToBeAdded > -1) {
                    r[path + '.' + k + '.' + itemToBeAdded] = { add: true, data: tempV };
                    return r;
                }
                else {
                    r[path + '.' + k] = { push: true, data: v };
                    return r;
                }
            }
            // but what if it returns an empty object? still attach?
            if (_.isObject(v) || _.isArray(v)) {
                r = _this.diff_withPath(v, path + '.' + k, r);
            }
            else if (!_.isObject(v) || _.keys(v).length > 0) {
                r[path + '.' + k] = { add: true, data: v };
                return r;
            }
            else {
                return r;
            }
        });
    };
    ;
    /** sendForUpdate - Prepares the object, that will be later on sent into server for update - handled only for status change
     * @param {string[]}    propertyNames: Array of strings that we plan to update
     * @param {string}      action:
     * @param {string}    comments:
     * @param {boolean}    partial: whatever was updated will be sent back & updated in topic
     */
    TopicService.prototype.sendForUpdate = function (propertyNames, action, comments, partial) {
        var _this = this;
        var tempDataArray = { id: this.topic._id, data: {}, type: [], action: action };
        if (propertyNames.indexOf('status') > -1) {
            this.detransform('temp');
            this.temp.status = this.status.statusChange(this.temp.status, this.topic.status, action, comments);
        }
        if (propertyNames.indexOf('sales_assist') > -1) {
            if (this.temp_ext.sales_assist) {
                this.temp.sales_assist = { type: this.temp_ext.sales_assist };
            }
        }
        var objPath = {};
        propertyNames.forEach(function (prop) {
            objPath = _.merge(objPath, _this.differenceByPath(prop));
            switch (prop) {
                case 'status':
                    tempDataArray[prop] = { id: _this.getId(_this.topic._id), opp: _this.topic.opp, status: _this.temp.status.status_no, subStatus: _this.temp.status.sub_status_no };
                    break;
                case 'sales_assist':
                    tempDataArray[prop] = _this.temp[prop];
                    break;
            }
            tempDataArray.type.push(prop);
        });
        tempDataArray.data = objPath;
        //if status change, then send also the DB2 update
        this.updateServerTopic('updateStatus', tempDataArray, partial);
    };
    TopicService.prototype.differenceByPath = function (propertyName) {
        var objDiff = {};
        objDiff[propertyName] = this.diff(this.temp[propertyName], this.topic[propertyName], false);
        return this.diff_withPath(objDiff[propertyName], propertyName, {});
    };
    /** sendForUpdateFiles - Prepares the object, that will be later on sent into server for update - handled only for files
     * @param {string}        comp: component to which the file belongs
     * @param {boolean}    partial: whatever was updated will be sent back & updated in topic
     */
    TopicService.prototype.sendForUpdateFiles = function (comp, partial) {
        var section = comp.replace('files$', '');
        //this.topic.sendForUpdateGeneral(this.updateArray, true);
        var filesData = [];
        angular.forEach(this.temp.files, function (file) {
            if (file.modified && file.type === section ||
                (section === 'sampling_SSA' && file.type === 'sampling')) {
                filesData.push({ name: file.name, comment: file.comment });
            }
        });
        var tempDataArray = {
            filesData: filesData,
            //id: this.topic.opp,
            id: this.topic._id,
            type: ['files$' + section]
        };
        if (filesData.length > 0) {
            this.updateServerTopic('updateFileNested', tempDataArray, partial);
        }
        else {
            this.cancelEdit(comp);
            this.calculateAccess([comp], false);
        }
    };
    ;
    /**sendForUpdateGeneral - Prepares the object, that will be later on sent into server for update
     * @param {any}          objectArray:     array of objects, that should be updated when we receive response
     * @param {boolean}          partial:     whatever was updated will be sent back & updated in topic
     * @param {boolean}   getEditOptions:     true = on respones the edit options will be recalculated, false = edit options recalculations ignored
     * @returns void             calls at the end updateServerTopic - that sends the socket to the server
     *
    */
    TopicService.prototype.sendForUpdateGeneral = function (objectArray, partial, getEditOptions, check) {
        var _this = this;
        var tempDataArray = { id: this.topic._id, data: {}, type: objectArray, getEditOptions: (getEditOptions ? true : undefined) };
        var objDiff = {};
        this.detransform('temp');
        var objPath = {};
        var statusUpdate = false;
        //this.temp.status = this.status.subStatusChange(this.temp.status);
        angular.forEach(objectArray, function (propWhole) {
            var propSplitted = propWhole.split('$');
            var prop = propSplitted[0];
            if (prop === 'gpp_valid') {
                objPath[prop] = { data: _this.temp[prop], add: true };
            }
            else {
                objDiff[prop] = _this.diff(_this.temp[prop], _this.topic[prop], false);
                var diffObj = _this.diff_withPath(objDiff[prop], prop, {});
                for (var attrname in diffObj) {
                    objPath[attrname] = diffObj[attrname];
                }
                ;
            }
            //objDiff[prop] =  this.diff2(this.temp[prop], this.topic[prop]);
        });
        tempDataArray.data = objPath;
        //if status change, then send also the DB2 update
        this.updateServerTopic('couchUpdate', tempDataArray, partial, check);
    };
    //sendCommentForUpdateGeneral- preps comment, calls updateServerTopic
    TopicService.prototype.sendCommentForUpdateGeneral = function (objectArray, partial, getEditOptions, check) {
        var _this = this;
        var tempDataArray = { id: this.topic._id, data: {}, type: objectArray, getEditOptions: (getEditOptions ? true : undefined) };
        var objDiff = {};
        this.detransform('temp');
        var objPath = {};
        angular.forEach(objectArray, function (propWhole) {
            var propSplitted = propWhole.split('$');
            var prop = propSplitted[0];
            objDiff[prop] = _this.diff(_this.temp[prop], _this.topic[prop], false);
            var diffObj = _this.diff_withPath(objDiff[prop], prop, {});
            for (var attrname in diffObj) {
                objPath[attrname] = diffObj[attrname];
            }
            ;
        });
        tempDataArray.data = objPath;
        this.updateServerTopic('updateCoreComments', tempDataArray, partial, check);
    };
    ;
    /** updateServerTopic - Sends the prepared object for updating couch
     * @param {string}    source:       which function to call in config/config eg. couchUpdate, updateStatus
     * @param {any}       upData:       consists of id (DMT-<opp>), type (array of objects, that were updated),
     * @param {boolean}  partial:     whatever was updated will be sent back & updated in topic
     * @returns void       sends a socket with the data to be updated
     */
    TopicService.prototype.updateServerTopic = function (source, upData, partial, check) {
        if (angular.isDefined(upData)) {
            if (this.isEmptyObject(upData.data)) {
                this.calculateAccess(upData.type, false);
                this.notify.error('No update was detected - Save Cancelled.');
                console.info('No update was detected - Save Cancelled.', upData.type);
            }
            else {
                for (var prop in upData.data) {
                    if (prop.includes('$$hashKey')) {
                        delete upData.data[prop];
                    }
                }
                this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        bID: this.topicBrowserID,
                        data: upData,
                        function: source,
                        partial: partial,
                        script: 'config/config',
                        token: this.env.user.token,
                        check: check
                    }
                });
            }
        }
        else {
            this.notify.error('Unable to update, section not defined');
            console.info('Unable to update, section not defined', upData);
        }
    };
    TopicService.prototype.updateChecksResults = function (upData) {
        if (angular.isDefined(upData)) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topicBrowserID,
                    data: upData,
                    function: 'updateInboundCMR',
                    script: '/detail/eligibility/eligibility',
                    token: this.env.user.token
                }
            });
        }
        else {
            this.notify.error('Unable to update checks results, data not defined');
        }
    };
    TopicService.prototype.remapAllChecks = function (data) {
        if (angular.isDefined(data)) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topicBrowserID,
                    data: data,
                    function: 'remapEmbargoChecks',
                    script: '/detail/eligibility/eligibility',
                    token: this.env.user.token
                }
            });
        }
        else {
            this.notify.error('Unable to remap checks - data not defined');
        }
    };
    TopicService.prototype.confirmCrossBoardEligibility = function (data) {
        if (angular.isDefined(data)) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topicBrowserID,
                    data: data,
                    function: 'confirmCrossBoardEligibility',
                    script: '/detail/eligibility/eligibility',
                    token: this.env.user.token
                }
            });
        }
        else {
            this.notify.error('Unable to confirm Cross Board - data not defined');
        }
    };
    TopicService.prototype.loadNotificationPreview = function (data) {
        if (angular.isDefined(data)) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topicBrowserID,
                    data: data,
                    function: 'loadNotification',
                    script: '/detail/eligibility/eligibility',
                    token: this.env.user.token
                }
            });
        }
        else {
            this.notify.error('Unable to load notification - data not defined');
        }
    };
    TopicService.prototype.sendNotification = function (data) {
        if (angular.isDefined(data)) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topicBrowserID,
                    data: data,
                    function: 'sendNotification',
                    script: '/detail/eligibility/eligibility',
                    token: this.env.user.token
                }
            });
        }
        else {
            this.notify.error('Unable to send notification - data not defined');
        }
    };
    TopicService.prototype.extractNotifications = function (data) {
        if (angular.isDefined(data)) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topicBrowserID,
                    data: data,
                    function: 'extractOpportunityNotifications',
                    script: '/detail/eligibility/eligibility',
                    token: this.env.user.token
                }
            });
        }
        else {
            this.notify.error('Unable to extract notification - data not defined');
        }
    };
    TopicService.prototype.isEmptyObject = function (obj) {
        if (angular.isUndefined(obj)) {
            return false;
        }
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop) && prop.indexOf('$$hashKey') === -1) {
                return false;
            }
        }
        return true;
    };
    TopicService.prototype.loopAndAssignObject = function (objectArray) {
        for (var prop in objectArray) {
            if (!objectArray.hasOwnProperty(prop)) {
                continue;
            }
            ;
            this.topic[prop] = objectArray[prop];
        }
    };
    /** setTempFromTopic - copies whole topic into temp
    */
    TopicService.prototype.setTempFromTopic = function () {
        this.temp = angular.copy(this.topic);
        //this.temp = this.topic;
    };
    /** setTempFromTopic - copies whole temp into topic
    */
    TopicService.prototype.setTopicFromTemp = function () {
        this.topic = angular.copy(this.temp);
        //this.topic = this.temp;
    };
    /** setTempFromTopicPart - Change the edit mode to true of the component & copy from topic to temp
     * @param {string}    obj:   object we want copy from topic to temp
     */
    TopicService.prototype.setTempFromCalculationV2 = function () {
        if (angular.isDefined(this.editableComponents['calculation']) && this.editableComponents['calculation'].editable) {
            this.temp['calculation'] = angular.copy(this['calculation']);
            return this.editableComponents['calculation'].editMode = true;
        }
        else {
            //alert('You are not authorized to modify ' + obj);
            return this.editableComponents['calculation'].editMode = false;
        }
    };
    /** setTempFromTopicPart - Change the edit mode to true of the component & copy from topic to temp
     * @param {string}    obj:   object we want copy from topic to temp
     */
    TopicService.prototype.setTempFromTopicPart = function (obj) {
        if (angular.isDefined(this.editableComponents[obj]) && this.editableComponents[obj].editable) {
            var objArray = obj.split('$');
            if (objArray.length === 1) {
                this.temp[obj] = angular.copy(this.topic[obj]);
            }
            else if (objArray.length === 2) {
                if (angular.isUndefined(this.topic[objArray[0]][objArray[1]])) {
                    this.topic[objArray[0]][objArray[1]] = [];
                }
                this.temp[objArray[0]][objArray[1]] = angular.copy(this.topic[objArray[0]][objArray[1]]);
            }
            else {
                //alert('Problem with moving into edit mode ' + obj);
                return this.editableComponents[obj].editMode = false;
            }
            return this.editableComponents[obj].editMode = true;
        }
        else {
            //alert('You are not authorized to modify ' + obj);
            return this.editableComponents[obj].editMode = false;
        }
    };
    /** setTempFromTopicPartFiles - Change the edit mode to true false of the component & assign either the temp or topic data for files
     * @param {string}    comp:   object we want copy from topic to temp
     */
    TopicService.prototype.setTempFromTopicPartFiles = function (comp) {
        var section = comp.replace('files$', '');
        var tempFiles = [];
        if (angular.isDefined(this.temp.files)) {
            angular.forEach(this.temp.files, function (file) {
                if (file.type !== section &&
                    !(section === 'sampling_SSA' && file.type === 'sampling')) {
                    tempFiles.push(file);
                }
            });
        }
        if (angular.isDefined(this.topic.files)) {
            angular.forEach((this.topic.files), function (file) {
                if (file.type === section ||
                    (section === 'sampling_SSA' && file.type === 'sampling')) {
                    tempFiles.push(file);
                }
            });
        }
        else {
            return this.editableComponents[comp].editMode = false;
        }
        if (angular.isDefined(this.editableComponents[comp]) && comp !== '' && this.editableComponents[comp].editable) {
            this.temp.files = tempFiles;
            return this.editableComponents[comp].editMode = true;
        }
        else {
            return this.editableComponents[comp].editMode = false;
        }
    };
    /** setTopicFromTempPart - Change the edit mode to false of the component & copy from temp to topic
     * @param {string}    obj:   object we want copy from temp to topic
     */
    TopicService.prototype.setTopicFromTempPart = function (obj) {
        if (angular.isDefined(this.editableComponents[obj]) && obj !== '' && this.editableComponents[obj].editable) {
            if (obj === 'calculation' && this.topic.calculationVersion >= 2) {
                this['calculation'] = angular.copy(this.temp['calculation']);
            }
            var objArray = obj.split('$');
            if (objArray.length === 1) {
                this.topic[obj] = angular.copy(this.temp[obj]);
            }
            else if (objArray.length === 2) {
                this.topic[objArray[0]][objArray[1]] = angular.copy(this.temp[objArray[0]][objArray[1]]);
            }
            else {
                alert('Problem with moving out of edit mode ' + obj);
                return this.editableComponents[obj].editMode = true;
            }
            return this.editableComponents[obj].editMode = false;
        }
        else {
            //alert('You are not authorized to modify ' + obj);
            return this.editableComponents[obj].editMode = true;
        }
    };
    TopicService.prototype.cancelEdit = function (obj) {
        if (angular.isDefined(this.editableComponents[obj]) && obj !== '' && this.editableComponents[obj].editable) {
            return this.editableComponents[obj].editMode = false;
        }
        else {
            return false;
        }
    };
    TopicService.prototype.getEditComponent = function (obj) {
        if (angular.isDefined(this.editableComponents[obj]) && obj !== '' && this.editableComponents[obj].editable) {
            return this.editableComponents[obj];
        }
        else {
            return false;
        }
    };
    TopicService.prototype.clearTempComments = function () {
        this.temp.elig_dec_text = '';
    };
    // Sets the active tab - so we know which one should be highlighted
    TopicService.prototype.setActiveTab = function (tab) {
        this.tabs.activeTab = tab;
        this.tabs.short = tab.replace('detail.', '');
    };
    // Set the tabs in the details view
    TopicService.prototype.setTabList = function (list, program) {
        var _this = this;
        if (angular.isUndefined(list)) {
            list = { general: true };
        }
        switch (program) {
            case 'SVI':
                this.visibleTabs = {
                    eligibility: true,
                    general: true,
                    payment: true,
                    sampling: true,
                    validation: true
                };
                break;
            default:
                this.visibleTabs = {
                    general: true
                };
        }
        this.tabs.list = [
            {
                editable: list.general,
                name: 'detail.general',
                title: 'General',
                visible: this.visibleTabs.general
            }, {
                editable: list.eligibility,
                name: 'detail.eligibility',
                title: 'Eligibility',
                visible: this.visibleTabs.eligibility
            }, {
                editable: list.validation,
                name: 'detail.validation',
                title: 'Sales Order Validation',
                visible: this.visibleTabs.validation
            }, {
                editable: list.sampling,
                name: 'detail.sampling',
                title: 'Sales Document Verification',
                visible: this.visibleTabs.sampling
            }, {
                editable: list.payment,
                name: 'detail.payment',
                title: 'Calculation & Payment',
                visible: this.visibleTabs.payment
            },
        ];
        angular.forEach(this.tabs.list, function (tab) {
            if (tab.name === _this.$state.current.name) {
                if (!tab.editable || !tab.visible) {
                    _this.setActiveTab('detail.general');
                    _this.$state.go('detail.general');
                }
            }
        });
    };
    /*
        //Sets if the tab is in edit mode
        setEditMode( value: any ) {
          this.tabs.editMode = value;
        }
    */
    TopicService.prototype.addFiles = function (fileNames) {
        var _this = this;
        angular.forEach(fileNames, function (fileName) {
            var fileFound = false;
            angular.forEach(_this.topic.files, function (att) {
                if (angular.isDefined(att.name)) {
                    if (fileName.name === att.name) {
                        fileFound = true;
                    }
                }
            });
            if (!fileFound) {
                // If file is not found push it into the file array
                _this.topic.files.push(fileName);
            }
        });
    };
    TopicService.prototype.deleteFiles = function (fileNames) {
        return this.topic_ext.attachments.filter(function (el) { return !fileNames.includes(el.name); });
    };
    TopicService.prototype.getId = function (fullDMTId) {
        //Id will be DMT-xxxxxxxxxx...we just want the part after DMT- as that is what is used
        //as the unique reference in the db2 tables
        return fullDMTId.substring(4);
    };
    /**
     * Function called from the site body after a dispute has been created, but only if the user
     * chooses NOT to open the new dispute and remain on the current document
     */
    TopicService.prototype.addDisputeDetails = function (bundle) {
        if (angular.isDefined(bundle.history)) {
            this.topic.status.history.push(bundle.history);
        }
        //Check if any disputes have been raised before
        if (this.topic.disputes) {
            this.topic.disputes.push(bundle.unid);
        }
        else {
            this.topic.disputes = [bundle.unid];
        }
    };
    TopicService.prototype.deleteFederalDisbursement = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'deleteFederal',
                script: 'federal/federal',
                opp: this.topic.opp,
                id: this.topic._id,
                token: this.env.user.token,
                user: this.env.user
            }
        });
    };
    /**
     * Function to simply reset the gpp comparison data - will be called when doc is opened each time or f5 pressed
     * or if a GPP reload takes place
     */
    TopicService.prototype.resetCompareGppData = function () {
        this.compareGpp = {
            gpp: {},
            gppMissing: [],
            gppSection: {
                bf: {
                    status: false,
                    variables: ['row_id', 'billdate', 'level10prod', 'brandfam', 'brand', 'winprob', 'revn_qty', 'price', 'revenue',
                        'salesorder', 'brandfamsviparticip', 'brandcert', 'salesstage', 'crncy', 'x_svi_status',
                    ]
                },
                st: {
                    status: false,
                    variables: []
                },
                or: {
                    status: false,
                    variables: ['inctvname', 'inctvstat', 'reqdate', 'approvalident', 'bustype', 'competitor',
                        'sernumreplaced', 'inctvexpdate', 'bpname',
                    ]
                },
                svi: {
                    status: false,
                    variables: ['row_id', 'level10prod', 'brandfam', 'revn_qty', 'price', 'revenue', 'crncy',
                        'x_svi_status', 'dup_opp_flg', 'dup_opp_num', 'svicmnt',
                    ]
                },
                ci: {
                    status: false,
                    variables: ['lname', 'fname', 'wrkphone', 'jobtitle', 'email', 'account', 'cellphone']
                },
                ods: {
                    status: false,
                    variables: []
                }
            }
        };
    };
    TopicService.prototype.setUSFed = function (goeSection) {
        //If set to Yes/Unknown and US radio not set, set as false, or If is was set to Yes but user now clicks No...set to No
        if ((this.temp && this.temp[goeSection] && ['Yes', 'Unknown', 'State Owned'].indexOf(this.temp[goeSection].picked) > -1 && this.temp[goeSection].usfederal === undefined) ||
            (this.temp && this.temp[goeSection] && ['No'].indexOf(this.temp[goeSection].picked) > -1 && this.temp[goeSection].usfederal === true)) {
            this.temp[goeSection].usfederal = false; //set default as false (No)
            this.usFed.status = false;
        }
    };
    TopicService.prototype.confirmUSFederal = function (event) {
        var _this = this;
        if (!this.env.user.access.nonBpsoAdmin) {
            var items = {
                icon: 'ERROR',
                message: 'Only Non-BPSO Administrators have authority to continue.',
                title: 'Restricted'
            };
            this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) { return; });
        }
        else {
            //Prepare to ask question...based on event
            var items = {
                icon: 'QUESTION',
                message: '<b>FINAL WARNING</b>: Upon confirming this Disbursement as a US Federal opportunity, the record will be removed from DMT permanently. &nbsp;Continue?',
                title: 'US Federal Opportunity'
            };
            //Ask it...
            this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                if (dResult.confirm) {
                    //make call to delete all trace of the record EXCEPT the Summary data in the Queue
                    _this.topic.usFed.beingDeleted = true;
                    _this.topic.deleteFederalDisbursement();
                }
            });
        }
    };
    /**
     * Function called from site.body when refreshed checklists are received
     * @param checklists
     */
    TopicService.prototype.updateRefreshedChecklists = function (data) {
        var _this = this;
        //Loop through the array and update the topic
        angular.forEach(data.chk, function (cl) {
            _this.topic[cl.name] = cl.checklist;
        });
        this.topic.complete = data.cmpl;
    };
    TopicService.prototype.isGOE = function () {
        var eGEC = angular.isDefined(this.topic.goe) && angular.isDefined(this.topic.goe.picked) && this.topic.goe.picked !== '' ? this.topic.goe.picked : undefined;
        var vGEC = angular.isDefined(this.topic.goe_valid) && angular.isDefined(this.topic.goe_valid.picked) && this.topic.goe_valid.picked !== '' ? this.topic.goe_valid.picked : undefined;
        var GE_Decision = eGEC;
        //Where we at?  If beyond Elig, take the Validation entry...if that's not there, take elig
        if (this.topic.status.status_no > 3) {
            if (angular.isDefined(vGEC)) {
                GE_Decision = vGEC;
            }
        }
        if ((['US', 'CA'].indexOf(this.topic.country) > -1 && GE_Decision === 'Yes') //If US and goe is Yes
            || (['US', 'CA'].indexOf(this.topic.country) === -1 && ['Yes', 'Unknown'].indexOf(GE_Decision) > -1)) {
            return true;
        }
        return false;
    };
    /**
     * Function to detetrmine whether or not a 2nd GOE needs to be performed in the Validation tab.
     * It will only be required if:
     * - Country is US or Canada and the Eligibility GOE Decision is 'No' or 'Unknown'
     * - Country is anything else and the Eligibility GOE Decision is 'No'
     *
     * @returns {boolean}
     *
     * @memberof TopicService
     */
    TopicService.prototype.is2ndGOENeeded = function () {
        if ((['US', 'CA'].indexOf(this.topic.country) === -1 && this.topic.goe.picked === 'No') //If not US and goe is No
            || (['US', 'CA'].indexOf(this.topic.country) > -1 && ['No', 'Unknown'].indexOf(this.topic.goe.picked) > -1)) {
            return true;
        }
        return false;
    };
    TopicService.prototype.is2ndGOEComplete = function () {
        if (angular.isDefined(this.topic.cmr_valid) && angular.isDefined(this.topic.cmr_valid.decision) && angular.isDefined(this.topic.cmr_valid.decision.success)) {
            return true;
        }
        return false;
    };
    TopicService.prototype.strRight = function (value, len) {
        if (len < value.length) {
            return value.substring(value.length - len);
        }
        return value;
    };
    TopicService.prototype.useBPOI = function () {
        if (!this.topic.goe || !this.topic.goe.picked
            || !this.topic.states || !this.topic.states.bpoi) {
            return false;
        }
        else if ((!this.is2ndGOENeeded() && this.topic.states.bpoi.geYes)
            || (this.is2ndGOENeeded() && this.topic.states.bpoi.geNo)) {
            return true;
        }
        else {
            return false;
        }
    };
    TopicService.prototype.attachmentsFound = function (fileType) {
        //Loop through all the files looking for a type fcmr_valid, ie: ad-hoc attachments in Find CMR Validaltion
        var attachmentsFound = false;
        angular.forEach(this.topic.files, function (file) {
            if (file.type === fileType) {
                attachmentsFound = true;
            }
        });
        return attachmentsFound;
    };
    TopicService.prototype.getGOEValidStatus = function () {
        var _this = this;
        //Are there Find CMR results...could be auto (via 2nd GOE) or manual
        var avcmrErr = 0;
        var searchCount = 0;
        var manCount = 0;
        var decisionErrors = [];
        if (angular.isDefined(this.topic.cmr_valid) && angular.isDefined(this.topic.cmr_valid.results) && this.topic.cmr_valid.results.length > 0) {
            angular.forEach(this.topic.cmr_valid.results, function (cmr) {
                searchCount++; //sum up the number of searches made
                //If auto one found...
                if (cmr.ds === 'AVCMR') {
                    //Loop through results
                    angular.forEach(cmr.table, function (row) {
                        //If the nonToGoe is true...that's an error
                        if (row.nonToGoe) {
                            avcmrErr++;
                        }
                    });
                    //Since it's an auto GOE, check the Decision, too...if that's an error, add it
                    if (!_this.topic.cmr_valid.decision.success) {
                        decisionErrors = _this.topic.cmr_valid.decision.errors;
                    }
                }
                else {
                    manCount++;
                }
            });
        }
        return {
            auto: searchCount - manCount,
            manual: manCount,
            errors: avcmrErr,
            decerrs: decisionErrors
        };
    };
    TopicService.prototype.isBaseSampling = function () {
        if ((this.getIncentiveType() === 'CVR Sales Assist' || this.getIncentiveType() === 'Sales Assist') &&
            this.topic.status.status_no === 4 &&
            !this.isGOE() &&
            !this.areCalcsStarted()) {
            return true;
        }
        return false;
    };
    TopicService.prototype.isNewUI = function () {
        // Check if svisubmitdate is before the date in the file - cut-over date is the gpp/mysa cutover - everything
        // after this date is subject to new ui and dupe checks
        var mysaCutoverDate = this.settings.dmtModuleHeaderUpdateDate;
        var submitDate = Number(this.topic.gpp[0].svisubmitdate);
        this.topic.newUI = false;
        if (submitDate && mysaCutoverDate && submitDate >= mysaCutoverDate) {
            this.topic.newUI = true;
        }
    };
    TopicService.prototype.isSamplingStarted = function (incentive) {
        var sampl = this.topic.sampling[incentive] || this.topic.sampling;
        if (!_.isUndefined(sampl) && !_.isUndefined(sampl.samplingStatus)) {
            if (sampl.samplingStatus !== 'untested') {
                return true;
            }
            return false;
        }
        return false;
    };
    TopicService.prototype.isSamplingComplete = function (incentive) {
        var sampl = this.topic.sampling[incentive] || this.topic.sampling;
        // The statuses that mean Sampling is complete
        var finalSampStatuses = [
            'Manually sampled - Failed',
            'Manually sampled - Passed',
            'Manual override',
            'Passed',
            'Failed'];
        if (!_.isUndefined(sampl) && !_.isUndefined(sampl.samplingStatus)) {
            if (finalSampStatuses.indexOf(sampl.samplingStatus) > -1) {
                return true;
            }
            return false;
        }
        return false;
    };
    TopicService.prototype.getIncentiveType = function () {
        if (!_.isUndefined(this.topic.sales_assist) && !_.isUndefined(this.topic.sales_assist.type)) {
            return this.topic.sales_assist.type;
        }
        return 'Unknown';
    };
    TopicService.prototype.areCalcsStarted = function () {
        if (this.topic.calculation) {
            return true;
        }
        return false;
    };
    TopicService.prototype.isNotInEligibilityStatus = function () {
        if (this.topic.status.status_no === 3 && [3, 4, 23, 28, 29, 32, 33].indexOf(this.topic.status.sub_status_no) !== -1) {
            return true;
        }
        return false;
    };
    TopicService.prototype.isEligibilityDecisionButtonHide = function () {
        return this.isNotInEligibilityStatus() || this.topic.status.status_no > 3;
    };
    // used to reload during assignment
    TopicService.prototype.isInitialV3 = function () {
        if (this.topic.status.status_no === 1 && this.topic.status.sub_status_no === 3) {
            return true;
        }
        return false;
    };
    /**
     * Function to reload the current opp
     * @param stateParamId
     */
    TopicService.prototype.reloadDisbursement = function (stateParamId) {
        //Reload!!
        var gppOpp = this.topic.opp;
        this.clearTopic(stateParamId);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'loadDataClient',
                script: '/detail/general/general',
                data: {
                    opp: gppOpp,
                    unid: 'DMT-' + stateParamId
                },
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to determine if the Disbursement has an owner
     */
    TopicService.prototype.hasOwner = function () {
        if (angular.isUndefined(this.topic.owner) || this.topic.owner === '') {
            return false;
        }
        return true;
    };
    /**
     * Function to determine if the Disbursement is in a Pre-Sales Order Validation status
     */
    TopicService.prototype.isValidationPreSalesOrder = function () {
        if (this.topic.status.status_no === 4 && (angular.isUndefined(this.topic.sap) || this.topic.sap.length === 0)) {
            return true;
        }
        return false;
    };
    /**
     * Determine if the disbursement has any unresolved errors
     */
    TopicService.prototype.hasUnresolvedErrors = function () {
        if (angular.isDefined(this.topic.errors) && this.topic.errors.unresolved > 0) {
            return true;
        }
        return false;
    };
    /**
     *
     * @param {string} comp
     * return
     */
    TopicService.prototype.checkNewClientEditMode = function (comp) {
        var isEditModeOn = this.editableComponents[comp].socket !== '';
        // || (_.has(this, 'checksData.result.NC')
        //     && _.has(this, 'topic.nc.results')
        //     && !_.has(this, 'checksData.result.NC.error'));
        this.editableComponents[comp] = isEditModeOn
            ? {
                editable: false,
                editMode: false,
                socket: 'Not Editable'
            } : {
            editable: true,
            editMode: false,
            socket: ''
        };
        return !!this.editableComponents[comp].socket;
    };
    /**
     * Return full name of the country (example "US" => "USA")
     *
     * @param {string} countryShort
     * @returns {string}
     * @memberof TopicService
     */
    TopicService.prototype.getCountryFullName = function (countryShort) {
        var countryInfo = this.config.settings.country_list.find(function (e) { return e.short === countryShort; });
        return countryInfo ? countryInfo.country : '';
    };
    //if the socket response is from the opp number that sent the req socket
    TopicService.$inject = ['$rootScope', '$timeout', '$q', 'socket', 'config', '_', 'status', 'settings', 'env', '$state', 'notify', 'Dialog'];
    return TopicService;
}());
TopicService = TopicService;
angular
    .module('application')
    .service('topic', TopicService);



var BodyController = (function () {
    function BodyController($login, env, socket, $scope, notify, $state, $stateParams, config, topic, $rootScope, settings, status, searchSubmit, Dialog, $window, $timeout) {
        var _this = this;
        this.$login = $login;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.notify = notify;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.config = config;
        this.topic = topic;
        this.$rootScope = $rootScope;
        this.settings = settings;
        this.status = status;
        this.searchSubmit = searchSubmit;
        this.Dialog = Dialog;
        this.$window = $window;
        this.$timeout = $timeout;
        this.topic.loaded = { config: false, topic: false, gpp_valid: false, settings: false, program: false, userProfile: false };
        socket.forward('message', $scope);
        this.$scope.$on('socket:message', function (event, data) {
            _this.message(event, data);
        });
        socket.forward('redirect.login', $scope);
        this.$scope.$on('socket:redirect.login', function (event, data) {
            /*if ('400,403,404,500,login'.indexOf(this.$state.current.name) < 0) {
              this.$window.location.href = '/403';
            }*/
            if (_this.env.user.loggedIn) {
                _this.env.revokeUser();
                // 1 second added, becaues window
                _this.$timeout(function () {
                    _this.$window.location.href = '/logout';
                }, 1000);
            }
        });
        socket.forward('federal.delete', $scope);
        this.$scope.$on('socket:federal.delete', function (event, data) {
            _this.topic.usFed.beingDeleted = false; //turn off
            if (data.success) {
                var items = {
                    icon: 'INFO',
                    message: 'The Disbursement content has been successfully deleted from DMT, and notification sent to System Admin for their records.<br><br><b>NOTE:</b> Despite the content being deleted, summary details of the Disbursement will still be avaiable via the Custom Reports. &nbsp;Click <b>OK</b> to return to My Queue.',
                    title: 'US Federal Deletion'
                };
                //Prompt
                _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                    $state.go('queue', { id: 'myqueue' }); ///go home
                });
            }
        });
        socket.forward('status.enable_action', $scope);
        this.$scope.$on('socket:status.enable_action', function (event, data) {
            _this.status.disableApproveButtons = false; //make action button available again
        });
        socket.forward('dispute.error', $scope);
        this.$scope.$on('socket:dispute.error', function (event, data) {
            _this.status.disableApproveButtons = false; //make action button available again
        });
        socket.forward('dispute.success', $scope);
        this.$scope.$on('socket:dispute.success', function (event, data) {
            _this.status.disableApproveButtons = false;
            //Ask user if they wanna open the new dispute
            var items = {
                icon: 'QUESTION',
                message: 'Dispute <b>' + data.unid + '</b> has been successfully created.<br><br>Do you want to open it now?',
                title: 'New Dispute'
            };
            //Ask it...
            _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                //If clicked no
                if (!dResult.confirm) {
                    //Update the topic with the new history element and append the dispute number
                    _this.topic.addDisputeDetails(data);
                    _this.topic.setActionButtons(); //Make call on the hide/show for the action buttons
                }
                else {
                    _this.$state.go('detail.general', {
                        id: data.unid.substring(4)
                    });
                }
            });
        });
        //Listener for when prrogam profile is sent
        this.socket.forward('config.program', this.$rootScope);
        this.$rootScope.$on('socket:config.program', function (event, data) {
            _this.config.setProgramProfile(data);
            _this.topic.fromConfigProgram();
        });
        // topic data
        this.socket.forward('topic.update', this.$scope);
        this.$scope.$on('socket:topic.update', function (event, data) {
            if (data.success && angular.isDefined(data.results.topic) && angular.isDefined(data.results.topic._id) &&
                angular.isDefined(data.results.edit)) {
                _this.topic.checksData = data.results.checksData;
                _this.topic.calculation = data.results.calculation;
                _this.topic.siteIdData = data.results.siteIdData;
                _this.topic.salesAssistData = data.results.salesAssistData;
                _this.topic.goeHistoryCheck = data.results.goeHistoryCheck;
                _this.topic.hasCtlSo = Boolean(data.results.hasCtlSo);
                _this.topic.externalLinks = data.results.externalLinks;
                _this.topic.inbound = data.results.checksData.inbound;
                _this.topic.clearTopic(_this.topic.getId(data.results.topic._id));
                _this.topic.updateEditOptions(data.results.edit, data.results.topic.program);
                _this.topic.updateTopic(data.results.topic, false, []);
                _this.topic.updateTopicWithoutCalc(data.results.gpp_live);
                _this.topic.checkSubStatus();
                _this.topic.isNewUI();
            }
            else {
                _this.topic.clearTopic(undefined);
                var items = {
                    title: 'Disbursement Retrieval Error',
                    message: 'There was a problem retrieving the Disbursement details:<br><br><b>' + (angular.isDefined(data.error.message) ? data.error.message : data.error) + '</b>',
                    icon: 'ERROR'
                };
                _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                    _this.$state.go('queue', {
                        id: _this.env.getDefaultQueue()
                    });
                });
            }
        });
        // Just a dummy chcek, if all worked
        this.socket.forward('topic.reponsefromserver', this.$scope);
        this.$scope.$on('socket:topic.reponsefromserver', function (event, data) {
            alert('Alert is ' + data._id);
        });
        // this is called when status is updated
        this.socket.forward('status.updateStatus', this.$scope);
        this.$scope.$on('socket:status.updateStatus', function (event, data) {
            if (angular.isDefined(data.result.data) && angular.isDefined(data.eos)) {
                _this.status.mainStatusChange = false;
                _this.status.eligDecisionFired = false;
                //If it's not a rollback, refresh the elements that have changed
                if (!data.rollback) {
                    angular.copy(_this.topic.topic_ext, _this.topic.temp_ext);
                    _this.topic.updateEditOptions(data.eos, _this.topic.topic.program);
                    _this.topic.updateTopic(data.result.data, true, []);
                    _this.topic.checkSubStatus();
                    _this.status.sendEmail(_this.topic.topic._id, _this.topic.topic.opp);
                    _this.topic.updatePartialSocketStatus(['status'], '');
                    _this.topic.setActionButtons(); //Make call on the hide/show for the action buttons
                }
                else {
                    //If it is a rollback...don't bother, just reload the page since many things may have changed that are beyond the
                    //(current) capability of the $10k
                    //Reload!!
                    _this.topic.reloadDisbursement(_this.$stateParams.id);
                }
            }
            else {
                console.log('wrong response on status change');
            }
        });
        // message when the file was uploaded
        this.socket.forward('upload.confirmation', this.$scope);
        this.$scope.$on('socket:upload.confirmation', function (event, data) {
            if (data !== undefined) {
                if (data.type === 'delete') {
                    _this.topic.deleteFiles(data.fileNames);
                }
                if (data.type === 'add') {
                    _this.topic.addFiles(data.fileNames);
                    _this.message(event, data);
                }
                if (angular.isDefined(data.complete)) {
                    _this.topic.updateTopic(data.complete, true, []);
                    _this.topic.updateTopic(data.errors, true, []);
                }
            }
        });
        // If a main object needs to be updated, call this function,
        // it'll iterate over the array of object and updates objects, that are sent.
        this.socket.forward('topic.update.from.server', this.$scope);
        this.$scope.$on('socket:topic.update.from.server', function (event, data) {
            console.log('updating form server');
            if (!angular.isUndefined(data)) {
                if (_this.topic.topicBrowserID === data.bID) {
                    if (data.success) {
                        if (angular.isUndefined(data.partialResult)) {
                            _this.topic.updateTopic(data.response, false, []);
                        }
                        else {
                            _this.topic.updateTopic(data.partialResult, true, []);
                        }
                        _this.message(event, { msg: 'Update Successful' });
                    }
                    else {
                        _this.topic.calculateAccess(data.type, false);
                        console.log('displaying eror message', data.err);
                        _this.message(event, { err: true, msg: data.msg });
                    }
                }
                else {
                    _this.message(event, { err: true, msg: 'Page was reloaded since the update, reload your page - topic.update.from.server' });
                }
            }
            else {
                _this.message(event, { err: true, msg: 'Empty response - topic.update.from.server' });
            }
            ;
        });
        this.socket.forward('topic.update.tab', this.$scope);
        this.$scope.$on('socket:topic.update.tab', function (event, data) {
            if (data && data.tab && data.oppDocId) {
                _this.topic.setActiveTab(data.tab);
                _this.$state.go(data.tab, _this.$stateParams);
            }
        });
        //calculation v2 creation
        this.socket.forward('topic.calculation.created', this.$scope);
        this.$scope.$on("socket:topic.calculation.created", function (event, data) {
            _this.topic.calculation = data.calculation;
        });
        this.socket.forward('topic.update.partial', this.$scope);
        this.$scope.$on('socket:topic.update.partial', function (event, data) {
            // Here I need to change the data.type to whatever that will reply to me the array of changed objects
            if (!angular.isUndefined(data)) {
                if (_this.topic.topicBrowserID === data.bID) {
                    if (data.success) {
                        if (angular.isDefined(data.eos)) {
                            _this.topic.updateEditOptions(data.eos, _this.topic.topic.program);
                        }
                        if (angular.isUndefined(data.partialResult)) {
                            angular.forEach(data.type, function (type) {
                                _this.topic.setTopicFromTempPart(type);
                                _this.topic.calculateAccess([type], false);
                            });
                        }
                        else {
                            // This is a hack... if something is newly-unlocked, the element in question
                            // is not sent back from the server and therefore is not processed correctly
                            // as an editable object without an F5... this adds it based on current data
                            // which will not have changed (since it was locked)
                            angular.forEach(data.partialResult, function (v, k) {
                                if (k.indexOf('lock_indicator.') > -1) {
                                    var locked_comp = k.substring('lock_indicator.'.indexOf(k) + 16);
                                    data.partialResult[locked_comp] = { add: true, data: _this.topic.topic[locked_comp] };
                                }
                            });
                            _this.topic.updateTopic(data.partialResult, true, data.type);
                            //If the update involves gpp data...perform the calculate...added by Matt @ 4 May 2017
                            if (data.type.indexOf('gpp') > -1) {
                                _this.topic.resetCompareGppData();
                                _this.topic.calculateGppDifference('gpp_live', 'gpp');
                            }
                            _this.topic.checkSubStatus(); // In case status object is part of the changes and is a system-set one
                            //If the update involves cmr_valid, re-enable the GOE Validation button
                            _this.topic.goeFired = false;
                        }
                        _this.message(event, { msg: 'Update Successful' });
                    }
                    else {
                        console.log('displaying eror message', 'err-' + data.err);
                        _this.topic.calculateAccess(data.type, false);
                        _this.message(event, { err: true, msg: data.err });
                    }
                }
                else {
                    _this.message(event, { err: true, msg: 'Page was reloaded since the update, reload your page - topic.update.partial' });
                }
            }
            else {
                _this.message(event, { err: true, msg: 'Empty response - topic.update.partial' });
            }
        });
        // config data from server
        this.socket.forward('topic.search.result', this.$scope);
        this.$scope.$on('socket:topic.search.result', function (event, data) {
            // here display the data from search & submit for approval
            if (_this.topic.topicBrowserID === data.bID) {
                if (data.success) {
                    if (_this.searchSubmit.checkIfReportLoaded()) {
                        var desc = _this.searchSubmit.getItemName(data.type[0]);
                        var items = {
                            cancelMessage: 'Ignore',
                            dialogName: 'Replace Search Results',
                            message: "A set of search results already exists in the <b>Process Later</b> section.\n                                <br><br>Do you want to replace the old results with the new <b> " + desc + " </b> results?",
                            okMessage: 'Replace'
                        };
                        _this.Dialog.YesNoForm(event, items, 'yes-no.html').then(function (dResult) {
                            if (dResult.confirm) {
                                _this.searchSubmit.updateSearchResults(data, $stateParams);
                                _this.topic.setActiveTab('searchsubmit');
                                _this.$state.go('detail.searchsubmit', {
                                    id: _this.$stateParams.id
                                });
                            }
                            else {
                                _this.topic.calculateAccess(data.type, false);
                            }
                            return;
                        });
                    }
                    else {
                        _this.searchSubmit.updateSearchResults(data, $stateParams);
                        _this.topic.setActiveTab('searchsubmit');
                        _this.$state.go('detail.searchsubmit', {
                            id: _this.$stateParams.id
                        });
                    }
                }
                else {
                    _this.message(event, data);
                    _this.topic.updatePartialSocketStatus(data.type, '');
                }
            }
            else {
                _this.message(event, {
                    err: true, msg: "No search saved! Page was reloaded from search submit or you opened another request,\n                while waiting for search response , start search again - topic.search.result" });
            }
        });
        this.socket.forward('settings.profile', this.$scope);
        this.$scope.$on('socket:settings.profile', function (event, data) {
            // Updates user profile
            if (!angular.isUndefined(data)) {
                _this.settings.updateProfile(data);
            }
            _this.topic.fromUserProfile();
            _this.message(event, data);
        });
        /* TEMP */
        this.socket.forward('config.settings', this.$scope);
        this.$scope.$on('socket:config.settings', function (event, data) {
            // Updates user profile
            //console.log('Received Global Settings', data); //REMOVE
            _this.settings.updateSettings(data);
            _this.topic.fromSettings();
            _this.topic.fromConfig();
        });
        this.topic.loaded = { config: false, topic: false };
        socket.forward('settings.update', $scope);
        this.$scope.$on('socket:settings.update', function (event, data) {
            //  this.settings.updateSettings(data);
            //  this.topic.fromSettings();
        });
        this.socket.forward('detail.validation', this.$scope);
        this.$scope.$on('socket:detail.validation', function (event, data) {
            _this.topic.loaded.gpp_valid = false;
            _this.topic.topic.gpp_valid = data.gpp_valid;
            _this.topic.temp.gpp_valid = data.gpp_valid;
            _this.topic.topic.solutionDecision = data.solutionDecision;
        });
        this.socket.forward('topic.search.export', this.$scope);
        this.$scope.$on('socket:topic.search.export', function (event, data) {
            if (angular.isDefined(data)) {
                if (data.err) {
                    _this.notify.error('There was a problem attempting to download the attachment: ' + data.msg + '.  If the problem persists please contact the DMT System Administrators for guidance.');
                    return;
                }
                data.name = decodeURIComponent(data.name);
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.payload], {
                    type: data.fileType
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                if (data.type === 'searchResult') {
                    a.setAttribute('download', "DMT-Search-Report_" + d + ".xlsx");
                }
                else if (data.type === 'searchReport' || data.type === 'any') {
                    a.setAttribute('download', data.name);
                }
                else {
                    a.setAttribute('download', "DMT-Unknown-Filetype.???");
                }
                a.click();
            }
        });
        socket.forward('topic.general.response', $scope);
        this.$scope.$on('socket:topic.general.response', function (event, res) {
            if (res.type === 'otherContacts') {
                if (_this.topic.topicBrowserID === res.bID && res.success) {
                    var items = { table: res.table, dialogName: 'Other Contacts' };
                    _this.Dialog.updateValidForm(event, items, 'display-other-contacts.html').then(function (dResult) {
                        return;
                    });
                }
            }
        });
    }
    BodyController.prototype.$onInit = function () {
        //console.log('site.body => check user');
        this.$login.setUser();
        this.env.user.admin = false;
    };
    BodyController.prototype.message = function (ev, data) {
        //console.log(data);
        if (data.err) {
            return this.notify.error(data.msg);
        }
        this.notify.success(data.msg);
    };
    BodyController.$inject = ['$login', 'env', 'socket', '$scope', 'notify', '$state',
        '$stateParams', 'config', 'topic', '$rootScope', 'settings',
        'status', 'searchSubmit', 'Dialog', '$window', '$timeout'];
    return BodyController;
}());
var BodyComponent = (function () {
    function BodyComponent() {
        this.templateUrl = 'site-body.html';
        this.controllerAs = 'vm';
        this.controller = BodyController;
    }
    return BodyComponent;
}());
angular
    .module('application')
    .component('body', new BodyComponent());



var siteFooterController = (function () {
    function siteFooterController() {
    }
    return siteFooterController;
}());
var siteFooterComponent = (function () {
    function siteFooterComponent() {
        this.templateUrl = 'site-footer.html';
        this.controllerAs = 'vm';
        this.controller = siteFooterController;
    }
    return siteFooterComponent;
}());
angular
    .module('application')
    .component('siteFooter', new siteFooterComponent());



var SiteHeaderController = (function () {
    function SiteHeaderController(env, $window, $state, $scope, $element) {
        this.env = env;
        this.$window = $window;
        this.$state = $state;
        this.$scope = $scope;
        this.$element = $element;
        this.disableLink = true;
    }
    SiteHeaderController.prototype.getQueue = function (queryId) {
        this.$state.go('queue', {
            id: queryId
        });
    };
    SiteHeaderController.prototype.getSamplingQueue = function () {
        this.$state.go('queueSampling');
    };
    SiteHeaderController.prototype.getQueueManualReview = function () {
        this.$state.go('queueManualReview');
    };
    SiteHeaderController.prototype.setAside = function () {
        this.$state.go('queueSetAside');
    };
    SiteHeaderController.prototype.errorQueue = function () {
        this.$state.go('queueError');
    };
    SiteHeaderController.prototype.generalErrorQueue = function () {
        this.$state.go('queueErrorGeneral');
    };
    SiteHeaderController.prototype.sapMissingQueue = function () {
        this.$state.go('queueSapMissing');
    };
    SiteHeaderController.$inject = ['env', '$window', '$state', '$scope', '$element'];
    return SiteHeaderController;
}());
var SiteHeaderComponent = (function () {
    function SiteHeaderComponent() {
        this.templateUrl = 'site-header.html';
        this.controllerAs = 'vm';
        this.controller = SiteHeaderController;
    }
    return SiteHeaderComponent;
}());
angular
    .module('application')
    .component('header', new SiteHeaderComponent());



var SiteMastheadController = (function () {
    function SiteMastheadController($window, env, $timeout) {
        this.$window = $window;
        this.env = env;
        this.$timeout = $timeout;
    }
    SiteMastheadController.prototype.openMobileMenu = function () {
        var body = angular.element(document).find('body');
        body.addClass('ibm-show-mobilemenu-screen ibm-mobilemenu-show ibm-no-scroll ibm-overlay-backdrop-visible');
    };
    SiteMastheadController.prototype.logIn = function () {
        this.$window.location.href = '/loginw3';
    };
    //
    SiteMastheadController.prototype.logOut = function () {
        var _this = this;
        console.log('clearing cookies');
        this.env.revokeUser();
        // 1 second added, becaues window
        this.$timeout(function () {
            _this.$window.location.href = '/logout';
        }, 1000);
    };
    SiteMastheadController.$inject = ['$window', 'env', '$timeout'];
    return SiteMastheadController;
}());
var SiteMastheadComponent = (function () {
    function SiteMastheadComponent() {
        this.templateUrl = 'site-masthead.html';
        this.controllerAs = 'vm';
        this.controller = SiteMastheadController;
    }
    return SiteMastheadComponent;
}());
angular
    .module('application')
    .component('masthead', new SiteMastheadComponent());



var siteMobileController = (function () {
    function siteMobileController(env) {
        this.env = env;
    }
    siteMobileController.prototype.closeMobileMenu = function () {
        var body = angular.element(document).find('body');
        body.removeClass('ibm-show-mobilemenu-screen ibm-mobilemenu-show ibm-no-scroll ibm-overlay-backdrop-visible');
    };
    siteMobileController.$inject = ['env'];
    return siteMobileController;
}());
var siteMobileComponent = (function () {
    function siteMobileComponent() {
        this.templateUrl = 'site-mobile.html';
        this.controllerAs = 'vm';
        this.controller = siteMobileController;
    }
    return siteMobileComponent;
}());
angular
    .module('application')
    .component('siteMobile', new siteMobileComponent());



//declare var angular: any;
/**
 * Base dialog
 */
var BaseDialogService = (function () {
    function BaseDialogService($mdDialog, $sce, $rootScope, socket, env, settings) {
        this.$mdDialog = $mdDialog;
        this.$sce = $sce;
        this.$rootScope = $rootScope;
        this.socket = socket;
        this.env = env;
        this.settings = settings;
    }
    BaseDialogService.prototype.show = function ($event, template, items) {
        this.data = items.data;
        var parentEl = angular.element(document.body);
        return this.$mdDialog.show({
            bindToController: true,
            locals: items,
            parent: angular.element(document.body),
            targetEvent: $event,
            templateUrl: template,
            // tslint:disable-next-line: object-literal-sort-keys
            controller: ['$mdDialog', function ($mdDialog) {
                    this.cancel = function () { return $mdDialog.cancel; };
                    this.hide = function () { return $mdDialog.hide; };
                }],
            controllerAs: 'vm',
            clickOutsideToClose: false,
            escapeToClose: true,
            closeTo: parentEl
        });
    };
    BaseDialogService.prototype.cancel = function () {
        this.$mdDialog.cancel();
    };
    BaseDialogService.prototype.hide = function () {
        this.$mdDialog.hide();
    };
    BaseDialogService.prototype.getData = function () {
        return this.data;
    };
    BaseDialogService.$inject = ['$mdDialog', '$sce', '$rootScope', 'socket', 'env', 'settings'];
    return BaseDialogService;
}());
angular
    .module('application')
    .service('baseDialog', BaseDialogService);



/**
 * This plugin implements alphabet index feature
 */
angular.module('datatables.alphabet', ['datatables']).config(function () {
    // Search function
    $.fn.dataTable.Api.register("alphabetSearch()", function (searchTerm) {
        this.iterator("table", function (context) {
            context.alphabetSearch = searchTerm;
        });
        return this;
    });
    // Recalculate the alphabet display for updated data
    $.fn.dataTable.Api.register("alphabetSearch.recalc()", function (searchTerm) {
        this.iterator("table", function (context) {
            draw(new $.fn.dataTable.Api(context), $("div.alphabet", this.table().container()), context);
        });
        return this;
    });
    // Search plug-in
    $.fn.dataTable.ext.search.push(function (context, searchData) {
        // Ensure that there is a search applied to this table before running it
        if (!context.alphabetSearch) {
            return true;
        }
        if (searchData[context.oInit.alphabetColumnIndex || 0].charAt(0).toUpperCase() === context.alphabetSearch.toUpperCase()) {
            return true;
        }
        return false;
    });
    // Private support methods
    function bin(data) {
        var letter, bins = {};
        for (var i = 0, ien = data.length; i < ien; i++) {
            letter = data[i].charAt(0).toUpperCase();
            if (bins[letter]) {
                bins[letter]++;
            }
            else {
                bins[letter] = 1;
            }
        }
        return bins;
    }
    function draw(table, alphabet, context) {
        alphabet.empty();
        alphabet.append("<label>Index:</label>");
        var columnIndex = context.oInit.alphabetColumnIndex || 0;
        var columnData = table.column(columnIndex).data();
        var bins = bin(columnData);
        $('<span class="clear active"/>')
            .data("letter", "")
            .data("match-count", columnData.length)
            .html("All")
            .appendTo(alphabet);
        for (var i = 0; i < 26; i++) {
            var letter = String.fromCharCode(65 + i);
            $("<span/>")
                .data("letter", letter)
                .addClass(!bins[letter] ? "empty" : "")
                .html(letter)
                .appendTo(alphabet);
        }
        $('<div class="alphabetInfo"></div>').appendTo(alphabet);
    }
    $.fn.dataTable.AlphabetSearch = function (context) {
        var table = new $.fn.dataTable.Api(context);
        var alphabet = $('<div class="alphabet"/>');
        draw(table, alphabet, context);
        // Trigger a search
        alphabet.on("click", "span", function () {
            alphabet.find(".active").removeClass("active");
            $(this).addClass("active");
            table.alphabetSearch($(this).data("letter")).draw();
        });
        // API method to get the alphabet container node
        this.node = function () {
            return alphabet;
        };
    };
    $.fn.DataTable.AlphabetSearch = $.fn.dataTable.AlphabetSearch;
    // Register a search plug-in
    $.fn.dataTable.ext.feature.push({
        fnInit: function (settings) {
            if (settings.oInit.alphabet !== false) {
                var search = new $.fn.dataTable.AlphabetSearch(settings);
                return search.node();
            }
        },
        cFeature: "A"
    });
});



/**
 * Plugin provides decorator to DTOptionsBuilder service and updates datatables wrapper with specific class
 * Should be used with datatables-ibm-theme.css
 *
 * Example of building options:
 *
 * var options = DTOptionsBuilder.newOptions().withIBMTheme()
 */
angular
    .module("datatables.ibmTheme", [
    "datatables",
    "datatables.alphabet",
    "datatables.fieldsSearch"
])
    .config(function ($provide) {
    $provide.decorator("DTOptionsBuilder", optionsDecorator);
    function optionsDecorator($delegate) {
        var newOptions = $delegate.newOptions;
        $delegate.newOptions = function () {
            var options = newOptions();
            options.withIBMTheme = function () {
                options.isIBMTheme = true;
                options.withDOM('<"info"F<"info-container"Ali>><"table-container"t>p');
                return options;
            };
            return options;
        };
        return $delegate;
    }
})
    .run(function (DTRendererService) {
    var ibmThemePlugin = {
        postRender: postRender
    };
    DTRendererService.registerPlugin(ibmThemePlugin);
    function postRender(options, result) {
        if (options && options.isIBMTheme) {
            var container = result.dataTable
                .api()
                .table()
                .container();
            $(container).addClass("datatables-ibm-theme");
        }
    }
});



/*
    https://github.com/l-lin/angular-datatables/blob/angular1/dist/angular-datatables.js
    This patch fixes angular-datatables issue when datatable in "ng" mode doesn't work with dynamic data
*/
function dtNGRenderer($log, $q, $compile, $timeout, DTRenderer, DTRendererService, DTInstanceFactory) {
    /**
     * Renderer for displaying the Angular way
     * @param options
     * @returns {{options: *}} the renderer
     * @constructor
     */
    return {
        create: create
    };
    function create(options) {
        var _staticHTML;
        var _oTable;
        var _$elem;
        var _parentScope;
        var _newParentScope;
        var dtInstance;
        var renderer = Object.create(DTRenderer);
        renderer.name = 'DTNGRenderer';
        renderer.options = options;
        renderer.render = render;
        renderer.reloadData = reloadData;
        renderer.changeData = changeData;
        renderer.rerender = rerender;
        return renderer;
        function render($elem, $scope, staticHTML) {
            _staticHTML = staticHTML;
            _$elem = $elem;
            _parentScope = $scope.$parent;
            dtInstance = DTInstanceFactory.newDTInstance(renderer);
            var defer = $q.defer();
            var _$tableElem = _staticHTML.match(/<tbody([\s\S]*)<\/tbody>/i);
            var _expression = _$tableElem[1];
            // Find the resources from the comment <!-- ngRepeat: item in items --> displayed by angular in the DOM
            // This regexp is inspired by the one used in the "ngRepeat" directive
            var _match = _expression.match(/^\s*.+?\s+in\s+([a-zA-Z0-9\.-_$]*)\s*/m);
            if (!_match) {
                throw new Error('Expected expression in form of "_item_ in _collection_[ track by _id_]" but got "{0}".');
            }
            var _ngRepeatAttr = _match[1];
            _parentScope.$watchCollection(_ngRepeatAttr, function () {
                if (_oTable) {
                    _destroyAndCompile();
                }
                $timeout(function () {
                    if (!_oTable) {
                        // Ensure that prerender is called when the collection is updated
                        // See https://github.com/l-lin/angular-datatables/issues/502
                        DTRendererService.preRender(renderer.options);
                        var result = DTRendererService.hideLoadingAndRenderDataTable(_$elem, renderer.options);
                        _oTable = result.DataTable;
                        DTInstanceFactory.copyDTProperties(result, dtInstance);
                        defer.resolve(dtInstance);
                    }
                }, 0, false);
            }, true);
            return defer.promise;
        }
        function reloadData() {
            $log.warn('The Angular Renderer does not support reloading data. You need to do it directly on your model');
        }
        function changeData() {
            $log.warn('The Angular Renderer does not support changing the data. You need to change your model directly.');
        }
        function rerender() {
            _destroyAndCompile();
            DTRendererService.showLoading(_$elem, _parentScope);
            // Ensure that prerender is called after loadData from promise
            // See https://github.com/l-lin/angular-datatables/issues/563
            DTRendererService.preRender(options);
            $timeout(function () {
                var result = DTRendererService.hideLoadingAndRenderDataTable(_$elem, renderer.options);
                _oTable = result.DataTable;
                DTInstanceFactory.copyDTProperties(result, dtInstance);
            }, 0, false);
        }
        function _destroyAndCompile() {
            if (_newParentScope) {
                _newParentScope.$destroy();
            }
            _oTable.ngDestroy();
            _oTable = null;
            // Re-compile because we lost the angular binding to the existing data
            _$elem.html(_staticHTML);
            _newParentScope = _parentScope.$new();
            $compile(_$elem.contents())(_newParentScope);
        }
    }
}
dtNGRenderer.$inject = ['$log', '$q', '$compile', '$timeout', 'DTRenderer', 'DTRendererService', 'DTInstanceFactory'];
angular.module('datatables.renderer')
    .factory('DTNGRenderer', dtNGRenderer);



/**
 * Patch for angular-datatables which provides debounced search functionality
 */
angular
    .module("datatables.fieldsSearch", ["datatables"])
    .config(function () {
    // Search function
    $.fn.dataTable.Api.register("fieldsSearch()", function (searchInput) {
        this.iterator("table", function (context) {
            context._searchInput = searchInput;
            context.oInstance.api().search(searchInput);
        });
        return this;
    });
    $.fn.dataTable.FieldsSearch = function (context) {
        var table = new $.fn.dataTable.Api(context);
        var container = $('<div class="fields-search"/>');
        var input = $('<input class="userField" type="text" placeholder="Enter search criteria" />');
        $('<span class="search_box"><img src="/public/images/magnify.svg" /></span>').appendTo(container);
        function update(event) {
            table.fieldsSearch(input.val()).draw();
        }
        //TODO move debouncing constant to config
        input.on("input", _.debounce(update, 350));
        input.appendTo(container);
        table.fieldsSearch('');
        // API method to get the alphabet container node
        this.node = function () {
            return container;
        };
    };
    $.fn.DataTable.FieldsSearch = $.fn.dataTable.FieldsSearch;
    // Register a search plug-in
    $.fn.dataTable.ext.feature.push({
        fnInit: function (settings) {
            if (!settings.oInit.fieldsSearch !== false) {
                var search = new $.fn.dataTable.FieldsSearch(settings);
                return search.node();
            }
        },
        cFeature: "F"
    });
});



var aboutController = (function () {
    function aboutController(env, $filter, DTS, $stateParams, $state) {
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.profileLoaded = true;
        this.data = {
            _id: "Terms_Of_Use",
            _rev: "1-0a5e3e546bfdee7666d6047ae3411199",
            terms: [
                {
                    tou: "The following are the terms of an agreement between you and IBM. By accessing, or using this Web site, you acknowledge that you have read, understand, and agree to be bound by these terms and to comply with all applicable laws and regulations, including export and re-export control laws and regulations. If you do not agree to these terms, please do not use this Web site. IBM may, without notice to you, at any time, revise these Terms of Use and any other information contained in this Web site. IBM may also make improvements or changes in the products, services, or programs described in this site at any time without notice.",
                    created_by: "Pasha",
                    created_date: "2018-01-30T21:00:00.000Z",
                    version: 12,
                    effective_date: "2018-10-30T21:00:00.000Z"
                },
                {
                    tou: "This Web site contains proprietary notices and copyright information, the terms of which must be observed and followed. Please see the tab entitled “Copyright and trademark information” for related information.",
                    created_by: "Ilya Aderiho",
                    created_date: "2018-01-30T21:00:00.000Z",
                    version: 13,
                    effective_date: "2018-08-30T21:00:00.000Z"
                },
                {
                    tou: "IBM grants you a non-exclusive, non-transferable, limited permission to access and display the Web pages within this site as a customer or potential customer of IBM provided you comply with these Terms of Use, and all copyright, trademark, and other proprietary notices remain intact. You may only use a crawler to crawl this Web site as permitted by this Web site’s robots.txt ",
                    created_by: "Dmitry Mitsaliuk",
                    created_date: "2018-06-30T21:00:00.000Z",
                    version: 14,
                    effective_date: "2018-11-30T21:00:00.000Z"
                },
                {
                    tou: "IBM grants you a non-exclusive, non-transferable,  ",
                    created_by: "Matthew Rogers",
                    created_date: "2018-04-30T21:00:00.000Z",
                    version: 15,
                    effective_date: "2018-01-30T21:00:00.000Z"
                }
            ]
        };
    }
    aboutController.prototype.$onInit = function () {
        this.correctTerms = this.data.terms[this.data.terms.length - 1];
    };
    aboutController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state'];
    return aboutController;
}());
var aboutComponent = (function () {
    function aboutComponent() {
        this.templateUrl = 'about.html';
        this.controllerAs = 'vm';
        this.controller = aboutController;
    }
    return aboutComponent;
}());
angular
    .module('application')
    .component('aboutSection', new aboutComponent());



var AdminController = (function () {
    function AdminController($state, settings, env) {
        this.$state = $state;
        this.settings = settings;
        this.env = env;
    }
    AdminController.prototype.$onInit = function () {
        if (this.$state.current.name === 'admin') {
            this.$state.go('admin.main');
        }
    };
    AdminController.$inject = ['$state', 'settings', 'env'];
    return AdminController;
}());
var AdminComponent = (function () {
    function AdminComponent() {
        this.templateUrl = 'admin.html';
        this.controllerAs = 'vm';
        this.controller = AdminController;
    }
    return AdminComponent;
}());
angular
    .module('application')
    .component('adminSection', new AdminComponent());



var AdminMainController = (function () {
    function AdminMainController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin, opptyCount, countLoaded) {
        var _this = this;
        if (countLoaded === void 0) { countLoaded = false; }
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.opptyCount = opptyCount;
        this.countLoaded = countLoaded;
        this.table = { sortType: '', sortReverse: false, search: '', filter: false, filterParams: {} };
        this.options = { oneSelected: false, selected: {} };
        this.countFired = false;
        this.table.headers = ['Profile', 'Description'];
        this.table.profiles = [
            { profile: 'admin.status-view', name: 'Status Configuration', desc: 'Profile for all Main and Sub-Statuses', enabled: true },
            { profile: 'admin.mysaresponse-view', name: 'MySA Response', desc: 'MySA Response - List of Check Results', enabled: true },
            { profile: 'admin.bpmergers-view', name: 'BP Mergers', desc: 'BP Mergers table', enabled: true },
            {
                profile: 'admin.program-view', name: 'Program Workflows',
                desc: 'Profiles for each unique combination of Country, Program, Brand and BP Type', enabled: true
            },
            { profile: 'admin.misc-codes-view', name: 'Miscellaneous Codes', desc: 'Profiles for all Codes used in DMT whether that\'s payment or rejection codes, or dispute codes', enabled: true },
            // { profile: 'admin.gbt20-view', name: 'GBT20 Batch Log', desc: 'Log for the daily GBT20 batch from ODS', enabled: true },
            { profile: 'admin.mysa-dmt-view', name: 'MySA Opportunity Logs', desc: 'Interface for querying opportunity transfers to and from MySA', enabled: true },
            { profile: 'admin.mysa-im-outbound-view', name: 'MySA IM Opportunity Logs', desc: 'Interface for querying opportunity transfers to MySA IM', enabled: true },
            { profile: 'admin.gppload-view', name: 'GPP Status Update Log', desc: 'Log for the daily submission of GPP statuses for Closed, Rejected and Paid items', enabled: true },
            { profile: 'admin.bptypes-view', name: 'BP Types', desc: 'Business Partner Types', enabled: false },
            { profile: 'admin.brands-view', name: 'Brands', desc: 'Brand list', enabled: false },
            { profile: 'admin.country-view', name: 'Countries', desc: 'The Country list', enabled: true },
            { profile: 'admin.checklist-view', name: 'Program Checklists', desc: 'IOT-specific Checklists for each program', enabled: true },
            { profile: 'admin.users-view', name: 'User Profiles', desc: 'Profile for each user, controlling Countries, Programs etc', enabled: true },
            { profile: 'admin.columns-view', name: 'Search Table Columns', desc: 'Set the order of columns and their header names', enabled: false },
            { profile: 'admin.sampling-view', name: 'Sampling', desc: 'Manage sampling purposes', enabled: true },
            { profile: 'admin.validation-view', name: 'Validation Rule Tables', desc: 'Customising Validation Rules', enabled: true },
            { profile: 'admin.exchangerate-view', name: 'Exchange Rate Table', desc: 'Customising exchange rates', enabled: true },
            { profile: 'admin.calculation-view', name: 'Calculation Tables', desc: 'Customising uplifts and bonus rules', enabled: true },
            { profile: 'admin.adminreporting-view', name: 'Reporting Tables', desc: 'Customising reporting tables', enabled: true },
            { profile: 'admin.bpoiswitches-view', name: 'BPOI Switches', desc: 'Customising BPOI-switches', enabled: true },
            { profile: 'admin.approvedlist-view', name: 'Approved List', desc: 'New client approved list', enabled: true },
            { profile: 'admin.termsofuse-view', name: 'Acceptable Terms of Usage', desc: 'Acceptable Terms of Usage', enabled: true },
            { profile: 'admin.massupdates-view', name: 'Mass updates', desc: 'Performing mass updates. *WARNING* Use it carefully since it can corrupt the data', enabled: true },
            { profile: 'admin.complianceplan-view', name: 'Compliance Plan', desc: 'Compliance Plan - List of BPs', enabled: true },
            { profile: 'admin.mysaerrlogs-view', name: 'MySA Inbound Error Logs', desc: 'Review and resolve errors resulting from inbounds from MySA', enabled: true },
            { profile: 'admin.eslogs-view', name: 'Engage Support Update Logs', desc: 'Review and resolve errors resulting from updates to ES', enabled: true }
        ];
        this.socket.forward('admin.oppty_count', this.$scope);
        this.$scope.$on('socket:admin.oppty_count', function (event, data) {
            if (data.err) {
                _this.opptyCount = 'Could not retrieve opportunities count: ' + data.msg;
            }
            else {
                _this.opptyCount = data.dataUpdated;
                _this.countLoaded = true;
            }
        });
    }
    AdminMainController.prototype.$onInit = function () {
    };
    AdminMainController.prototype.getStats = function () {
        if (!this.countLoaded && !this.countFired) {
            this.countFired = true;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getAllOpptyCount',
                    script: 'admin/admin',
                    user: this.env.user
                }
            });
        }
    };
    AdminMainController.prototype.navigate = function (where) {
        this.$state.go(where, '');
    };
    AdminMainController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'admin'];
    return AdminMainController;
}());
var AdminMainComponent = (function () {
    function AdminMainComponent() {
        this.templateUrl = 'admin-main.html';
        this.controllerAs = 'vm';
        this.controller = AdminMainController;
    }
    return AdminMainComponent;
}());
angular
    .module('application')
    .component('adminMainSection', new AdminMainComponent());



//let appViewLoaded: boolean = false; //Global to handle the viewContentLoaded value...needs to be here (for some reason)
var ApprovalsController = (function () {
    function ApprovalsController(env, $filter, DTS, $stateParams, $state, socket, $scope, config, $rootScope) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.config = config;
        this.$rootScope = $rootScope;
        this.results = []; //declare the 'scoped' field to be displayed
        this.resultsRetrieved = false;
        this.table = { sortType: 'bp', sortReverse: false, search: '', filter: false, filterParams: {} };
        this.stages = null;
        this.toggleStages = false; //show hide approvers stages
        //Listener below...if a socket.emit for approvals.list is made...
        this.socket.forward('approvals.list', this.$scope);
        this.$scope.$on('socket:approvals.list', function (event, data) {
            _this.displayResults(event, data); //...take the results (data) and send to function to display
            _this.setDetails();
        });
        //Do this to prevent the onInit() firing twice on a page refresh
        //      this.$rootScope.$on('$viewContentLoaded', (event, toState, toParams, fromState, fromParams) => {
        //        appViewLoaded = true;
        //    });
        //  console.log(this.$state);
    }
    ApprovalsController.prototype.resetFilters = function () {
        this.table.filters = '';
        this.table.filterParams = {};
    };
    //This will run as soon as the page loads...will hit the /approvals url and
    //send the user's email address taken from the 'env' - the object containing the user info
    ApprovalsController.prototype.$onInit = function () {
        //Only fire the socket call if the view content is loaded (see constructor)
        //  if (appViewLoaded) {
        //Set table headers
        this.table.headers =
            [{
                    'Opp': 'opp', 'BP Name': 'bp', 'Country': 'country', 'Account Name': 'acnt',
                    'Status': 'status', 'Sub Status': 'substatus', 'Owner': 'owner'
                }];
        this.fireSocket();
        //}
    };
    ApprovalsController.prototype.fireSocket = function () {
        this.resultsRetrieved = false; //Wipe
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                currentUser: this.env.user,
                user: this.env.user,
                function: 'getAwaitingApprovalByUser',
                script: '/approvals/approvals'
            }
        });
    };
    ApprovalsController.prototype.setDetails = function () {
        //Anyone who is not an approver or Administrator shouldn't even be able to get into this page
        this.appRole = this.env.getRoleAsString();
        //let bpsononbpso = this.bpsoNonBpso === this.env.user.access.nonBpsoApprover ? 'Non-BPSO' : 'BPSO';
        var bpsononbpso = this.env.user.access.nonBpsoApprover || this.env.user.access.nonBpsoAdmin ? 'Non-BPSO' : 'BPSO';
        if (this.env.user.access.bpsoAdmin || this.env.user.access.nonBpsoAdmin) {
            this.bpsoNonBpso = bpsononbpso + ' Peer/Colleague';
            this.stages = this.config.getAppStagesForApprover(this.env.user.email, bpsononbpso);
        }
        else {
            this.bpsoNonBpso = bpsononbpso + ' Management/Team Leader';
            this.stages = this.config.getAppStagesForApprover(this.env.user.email, null);
        }
        //this.stages = this.config.getAppStagesForApprover('pavolpipiska@sk.ibm.com', null);
    };
    ApprovalsController.prototype.displayResults = function (event, data) {
        this.results = data; //Update class field
        this.resultsRetrieved = true;
    };
    ApprovalsController.prototype.getAvatar = function (email) {
        return this.DTS.getAvatar(email, 115);
    };
    ApprovalsController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'config', '$rootScope'];
    return ApprovalsController;
}());
var ApprovalsComponent = (function () {
    function ApprovalsComponent() {
        this.templateUrl = 'approvals.html';
        this.controllerAs = 'vm';
        this.controller = ApprovalsController;
    }
    return ApprovalsComponent;
}());
angular
    .module('application')
    .component('approvalsSection', new ApprovalsComponent());



var tempthat = {};
var DetailController = (function () {
    function DetailController(env, $filter, DTS, $scope, $stateParams, $state, socket, topic, $mdIcon, config, status, //probably temp
        Dialog, $mdDialog, settings, searchSubmit, $rootScope) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.topic = topic;
        this.$mdIcon = $mdIcon;
        this.config = config;
        this.status = status;
        this.Dialog = Dialog;
        this.$mdDialog = $mdDialog;
        this.settings = settings;
        this.searchSubmit = searchSubmit;
        this.$rootScope = $rootScope;
        this.allMessage = 'all';
        this.comp = 'status';
        this.loadingUsers = false;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.incentiveProgramsConfig = {
            cvrSSA: false,
            solution: false,
            growthIncentive: false,
            salesIncentive: false,
            engagement: false,
            focusIncentive: false,
            specialBid: false,
            NC: false
        };
        this.isIncentivesEmpty = true;
        //console.log(topic); // LOSE THIS AT SOME POINT - HANDY FOR NOW, THOUGH!
        this.id = $stateParams.id;
        topic.setActiveTab(this.$state.current.name);
        if (angular.isDefined(this.$state.current) && this.$state.current.name === 'detail.searchsubmit') {
            topic.setActiveTab('detail.searchsubmit');
        }
        this.showstatusSave = false;
        this.$rootScope.$on('$viewContentLoaded', function (event, toState, toParams, fromState, fromParams) {
            tempthat['viewLoaded'] = true;
            _this.saasFlag = (_this.topic.topic.sales_assist && _this.topic.topic.sales_assist.type) ? _this.topic.topic.sales_assist.type : 'Automatic';
        });
        socket.forward('history.exist', $scope);
        this.$scope.$on('socket:history.exist', function (event, res) {
            //console.log(`TMP - on history.exist:  ${new Date(Date.now())}`);
            _this.historyLoaded = true;
            var preparedDB2Data = _this.prepareESDB2HistoryData(res.history.db2Results.data);
            _this.topic.esDB2History = {
                error: res.history.db2Results.isError,
                data: preparedDB2Data
            };
            _this.topic.esCouchHistory = {
                error: res.history.couchResults.isError,
                data: res.history.couchResults.data
            };
        });
        socket.forward('detail.setIncentivePrograms', $scope);
        this.$scope.$on('socket:detail.setIncentivePrograms', function (event, data) {
            //console.log(`TMP - on detail.setIncentivePrograms:  ${new Date(Date.now())}`);
            for (var key in _this.incentiveProgramsConfig) {
                if (_this.incentiveProgramsConfig.hasOwnProperty(key)) {
                    _this.incentiveProgramsConfig[key] = data.incentiveProgramsConfig[key] || false;
                }
            }
            var NC = _.get(_this.topic, 'checksData.result.NC.data.ncDecision', false);
            _this.incentiveProgramsConfig.NC = NC;
            _this.isIncentivesEmpty = Object.keys(_this.incentiveProgramsConfig).every(function (key) { return !_this.incentiveProgramsConfig[key]; });
            _this.uiVersion = _.get(_this.topic, 'topic.version');
        });
    }
    DetailController.prototype.getAvatar = function () {
        return this.DTS.getAvatar(this.topic.topic.owner, 115);
    };
    DetailController.prototype.prepareESDB2HistoryData = function (data) {
        return data.reduce(function (currentResult, elem) {
            var createdTime = elem.CREATED;
            if (elem.ACTIVE === 'active') {
                return currentResult = currentResult.concat([{
                        esRequestId: "" + elem.ES_REQUEST_ID_ALIAS,
                        eventText: "Created for " + elem.STAGE + " stage",
                        time: createdTime
                    }]);
            }
            var closedTime = elem.UPDATED;
            return currentResult = currentResult.concat([{
                    esRequestId: "" + elem.ES_REQUEST_ID_ALIAS,
                    eventText: "Created for " + elem.STAGE + " stage",
                    time: createdTime
                }, {
                    esRequestId: "" + elem.ES_REQUEST_ID_ALIAS,
                    eventText: "Closed for " + elem.STAGE + " stage",
                    time: closedTime
                }]);
        }, []);
    };
    /**
     * Function to collect the correct title to be displayed when someone hovers over the approval flag icon
     *
     * @returns {string}
     * @memberof DetailController
     */
    DetailController.prototype.getApprovalTitle = function () {
        var amountUSD = 'Awaiting Calculations';
        var amountLC = 'Awaiting Calculations';
        var currLC = '???';
        // Currency...if GOE then take Forcast Currency, otherwise Sales Order Currency
        // TODO: update for calculation v2
        if (angular.isDefined(this.topic.topic.calculation)) {
            currLC = angular.isDefined(this.topic.topic.calculation.bonusTotalCurr) ? this.topic.topic.calculation.bonusTotalCurr : '???';
            amountUSD = this.topic.topic.status.approvals.approval_amount !== 0 ? this.$filter('number')(this.topic.topic.status.approvals.approval_amount, 2) : 'Awaiting Calculations';
            amountLC = angular.isNumber(this.topic.topic.calculation.bonusTotal) ? this.$filter('number')(this.topic.topic.calculation.bonusTotal, 2) : 'Awaiting Calculations';
        }
        // Create display showing the approval amount in USD (vital) and LC (for fun)
        var aa = '\n\nApproval Amount (USD): ' + amountUSD;
        if (currLC !== 'USD') {
            aa += '\nApproval Amount (' + currLC + '): ' + amountLC;
        }
        // If approval required but not complete
        if (this.topic.topic.status.approvals.approval_required && !this.topic.topic.status.approvals.complete) {
            return 'This Disbursement will require Approval should it need to be Paid because it is' +
                ' not \'Touchless\', ie: there has been manual intervention during either the Validation ' +
                'or Calculation stages, or both, or the payment amount has exceeded the Bonus Clip for the Geo.' + aa +
                '\n\nReason(s): \n---------------------------------------------\n' +
                this.topic.topic.status.approvals.approval_reason;
        }
        else if (!this.topic.topic.status.approvals.approval_required) {
            return 'This Disbursement would have required Approval, but the flag was removed by System Admin.' +
                '\n\nReversal Comment: ' +
                this.topic.topic.status.approvals.approval_reason;
        }
        else if (this.topic.topic.status.approvals.complete) {
            return 'This Disbursement was Approved since it was' +
                ' not \'Touchless\', ie: there had been manual intervention during either the Validation ' +
                'or Calculation stages, or both, or the payment amount has exceeded the Bonus Clip for the Geo.' + aa +
                '\n\nReason(s): \n---------------------------------------------\n' +
                this.topic.topic.status.approvals.approval_reason;
        }
    };
    DetailController.prototype.$onInit = function () {
        this.historyLoaded = false;
        this.id = this.$stateParams.id; //ie: the value on display in the queue...could be opp or opp + disputenumber
        this.unid = this.id.indexOf('DMT-') === 0 ? this.id : "DMT-" + this.id; //the full DMT unique ref...same as above but with DMT- at the front
        var opp = this.id;
        this.topic.esDB2History = {
            error: false,
            data: []
        };
        this.topic.esCouchHistory = {
            error: false,
            data: []
        };
        //If a dispute..
        var dispute = this.id.indexOf('-DIS:');
        if (dispute > -1) {
            //Strip the dispute details from the id so it's just the opp
            opp = this.id.substring(0, dispute);
        }
        /*if (!this.topic.loaded.topic) {
          this.$state.go('loading', {
              id: this.id
          });
        }*/
        //this.topic.tabs.list[3].editable = (this.topic.topic.sampling.samplingStatus === 'active');
        //console.log(`TMP - onInit:  ${new Date(Date.now())}`);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'extractHistory',
                script: '/engage-support/history/extractESHistory',
                data: {
                    //DMT-1341 - to show own log (not the parent one)
                    opportunityId: this.id
                },
                token: this.env.user.token
            }
        });
        this.searchSubmit.updateResults(undefined);
        this.searchSubmit.updateOriginal(undefined);
        this.searchSubmit.updateLaterProcess(false);
        if (tempthat['viewLoaded']) {
            if ((angular.isDefined(this.id)) && (angular.isUndefined(this.topic.reloadCheck.topicBrowserID) ||
                angular.isUndefined(this.topic.reloadCheck.id) || angular.isUndefined(this.topic.topicBrowserID) ||
                (this.id !== this.topic.reloadCheck.id))) {
                this.topic.clearTopic(this.id);
                //console.log(`TMP - onInit - viewLoaded - loadData:  ${new Date(Date.now())} - ${this.unid}`);
                this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'loadDataClient',
                        script: '/detail/general/general',
                        data: {
                            opp: opp,
                            unid: this.unid
                        },
                        token: this.env.user.token
                    }
                });
            }
            else if (angular.isDefined(this.id) && this.id === this.topic.reloadCheck.opp) {
                this.topic.updateTopic([], false, []);
            }
        }
    };
    // Once change of the tab, disable edit mode, active tab, set if it can be editable and move to the correct tab.
    DetailController.prototype.goTo = function (tab) {
        //this.topic.setEditable(tab.editable);
        //this.topic.setEditMode(false);
        if (angular.isDefined(this.$state.current) && this.$state.current.name === 'detail.searchsubmit') {
            this.topic.updatePartialSocketStatus([this.searchSubmit.type], '');
        }
        this.topic.setActiveTab(tab.name);
        //console.log('activetab set to ' + tab.name);
        this.$state.go(tab.name, this.$stateParams);
    };
    // When action = edit- enable editing & change to edit component,
    //save- save values to topic, move back to non-edit mode, ""- moves back to non-edit mode
    DetailController.prototype.changeEditMode = function (link, action) {
        console.log('edit change: ' + link + ' > ' + action + ' > ' + this.topic.tabs.editPath + ' > ' + this.topic.getEditable());
        if (action === 'save') {
            // Check if we can update the values if yes continue to update temp
            this.topic.setTopicFromTemp();
        }
        if (action === this.topic.tabs.editPath && this.topic.getEditable()) {
            this.topic.setTempFromTopic();
            //this.topic.setEditMode(true);
            this.$state.go(link + action, this.$stateParams);
        }
        else {
            //this.topic.setEditMode(false);
            this.$state.go(link, this.$stateParams);
        }
    };
    DetailController.prototype.setSalesAssistSub = function () {
        if (angular.isDefined(this.topic.topic.sap) && this.topic.topic.sap.length > 0 && angular.isDefined(this.topic.topic.sap[0].mdlTypeCode)) {
            if (this.topic.topic.sap[0].mdlTypeCode === 'ML') {
                return 'Monthly License';
            }
            else if (this.topic.topic.sap[0].mdlTypeCode === 'SS') {
                return 'SaaS';
            }
            else {
                return 'License Unknown';
            }
        }
        else {
            return 'License TBC';
        }
    };
    DetailController.prototype.showStatusSaveButton = function () {
        if (this.topic.topic_ext.sub_status !== this.topic.temp_ext.sub_status && !this.status.mainStatusChange) {
            this.showstatusSave = true;
        }
        else {
            this.showstatusSave = false;
        }
        //If new status is a system-set status...still show but disable
        /* let sub = this.config.getSubStatusByDesc(this.topic.topic.status.status_no, this.topic.temp_ext.sub_status);
               if (sub !== null && angular.isDefined(sub.system) && sub.system) {
                   this.disableStatusSave = true;
               } else {
                   this.disableStatusSave = false;
               }*/
    };
    DetailController.prototype.saveStatus = function (action, comments) {
        // This needs to be changed in order for the substatus to work nicely
        this.topic.sendForUpdate(['status'], action, comments, false);
        console.log('Sending for update status');
        this.showstatusSave = false;
    };
    DetailController.prototype.viewApprovers = function (event) {
        var _this = this;
        // Get the config
        var err = null;
        //if (angular.isUndefined(this.config.tempData)) {
        if (angular.isUndefined(this.settings.status_cfg)) {
            err = 'CONFIG';
        }
        var bundle = { expand: false, show: 'Show' };
        //Find the relevant approval package based on status/sub-status
        var appStage = this.config.getSubStatusBySubStatusNo2(this.topic.topic.status.status_no, this.topic.topic.status.sub_status_no);
        bundle.selectedApprover = {
            name: this.topic.topic.status.approvals.selected_approver_name,
            email: this.topic.topic.status.approvals.selected_approver_email
        };
        bundle.status = this.topic.topic_ext.status;
        bundle.sub_status = this.topic.topic_ext.sub_status;
        bundle.owner_email = this.topic.topic.owner;
        var roleNumber = 0;
        if (appStage.peer) {
            if (appStage.bpso) {
                bundle.team = 'BPSO Administration Team';
            }
            else {
                bundle.team = 'Non-BPSO Administration Team';
                roleNumber = 1;
            }
            bundle.peer = true;
            if (this.topic.topic.owner === this.env.user.email) {
                bundle.owner = 'you';
            }
            else {
                bundle.owner = 'the Assignee';
            }
        }
        else {
            bundle.approvers = [];
            bundle.approvers = appStage.users;
            bundle.peer = false;
            if (appStage.bpso) {
                bundle.team = 'BPSO Approvers';
            }
            else {
                bundle.team = 'Non-BPSO Approvers';
            }
        }
        //Get them
        if (!appStage.users || !bundle.approvers) {
            this.loadingUsers = true;
            this.status.newPromise(this.socket, roleNumber, this.topic.topic.country).then(function (theUsers) {
                _this.loadingUsers = false;
                bundle.approvers = theUsers;
                appStage.users = theUsers;
                _this.viewApproversExe(event, bundle, err);
            }, function (noUsersReturnedInTime) {
                _this.loadingUsers = false;
                err = 'USERS';
                _this.viewApproversExe(event, bundle, err);
            });
        }
        else {
            this.viewApproversExe(event, bundle, err);
        }
    };
    DetailController.prototype.viewApproversExe = function (event, bundle, err) {
        //People who have already approved as the Assignee should be able to approve
        bundle.excludeList = angular.isDefined(this.topic.topic.status.approvals.approvers) ? this.topic.topic.status.approvals.approvers.concat([this.topic.topic.owner]) : [this.topic.topic.owner]; //Previous approvers and assignee                
        var title = 'The following users have already approved during the current Approval Process:\n';
        for (var i = 0; i < bundle.excludeList.length - 1; i++) {
            title += '\n# ' + (i + 1) + ' ' + bundle.excludeList[i];
            if (i === 0) {
                title += ' - (initiated by)';
            }
        }
        bundle.approvers = this.status.cleanApprovers(bundle.approvers, bundle.excludeList);
        bundle.prevApprovers = title;
        this.items = {
            bundle: bundle,
            error: err,
            toggleApprovers: (function () {
                if (bundle.expand) {
                    bundle.expand = false;
                    bundle.show = 'Show';
                }
                else {
                    bundle.expand = true;
                    bundle.show = 'Hide';
                }
            })
        };
        //if no approvers for a stage
        if (bundle.approvers.length === 0) {
            this.items.error = 'NOAPPS';
        }
        this.Dialog.openDialog(event, this.items, DialogService, 'stage-approvers.html');
    };
    DetailController.prototype.viewCycleTimes = function (event) {
        //Work out days and owner from last history to now
        var statusObject = angular.copy(this.topic.topic.status);
        statusObject = this.status.calculateOwnership(statusObject);
        var e2e = 0;
        angular.forEach(statusObject.cycle_times, function (cycle) {
            for (var key in cycle) {
                if (cycle.hasOwnProperty(key)) {
                    e2e = e2e + cycle[key];
                }
            }
        });
        //Loop from back to front until an entry is found where owner is not -
        var historyObj;
        for (var i = statusObject.history.length - 1; i >= 0; i--) {
            historyObj = statusObject.history[i];
            //If entry is not blank (pff) or -
            if (['', '-'].indexOf(historyObj.new_owner) === -1) {
                break;
            }
        }
        //Current owner
        var owner = historyObj.new_owner; //ie:  Billing, BPSO etc
        //If claim is at the end of the process, ie: Paid, Rejected or closed, get that date from the history
        // otherwise use today's date
        var endDate;
        if (this.topic.isComplete()) {
            var statusDesc = this.config.getMainStatusByMainStatusNo(this.topic.topic.status.status_no).txt;
            for (var i = statusObject.history.length - 1; i >= 0; i--) {
                historyObj = statusObject.history[i];
                if (historyObj.event === statusDesc) {
                    break;
                }
            }
            endDate = new Date(historyObj.timestamp);
        }
        else {
            endDate = new Date(); //now
        }
        //Get date period
        var dates = { startDate: this.topic.topic.status.history[0].timestamp, endDate: endDate };
        this.items = {
            dates: dates,
            cycles: statusObject.cycle_times,
            columnHeaders: ['Cycle Owner Team', 'No. of Days', ''],
            totalDays: e2e,
            currentOwner: owner
        };
        this.Dialog.openDialog(event, this.items, DialogService, 'cycle-times.html');
    };
    DetailController.prototype.viewEngageSupportHistory = function (event) {
        this.esItems = {
            dataDB2: this.topic.esDB2History,
            db2ColumnHeaders: ['ES request number', 'Event', 'Date & Time'],
            dataCouch: this.topic.esCouchHistory,
            couchColumnHeaders: ['Action', 'Message', 'Date & Time']
        };
        this.Dialog.openDialog(event, this.esItems, DialogService, 'es-history.html');
    };
    DetailController.prototype.viewRejectionDetails = function (event) {
        this.items = {
            reject_status: this.config.getMainStatusByMainStatusNo(this.topic.topic.status.rejection_details.reject_status).txt,
            rejection_details: this.topic.topic.status.rejection_details
        };
        this.Dialog.openDialog(event, this.items, DialogService, 'rejection-details.html');
    };
    DetailController.prototype.viewClosureDetails = function (event) {
        this.items = {
            close_status: this.config.getMainStatusByMainStatusNo(this.topic.topic.status.close_details.close_status).txt,
            close_details: this.topic.topic.status.close_details
        };
        this.Dialog.openDialog(event, this.items, DialogService, 'closure-details.html');
    };
    DetailController.prototype.viewProgramProfile = function (event) {
        var err = null;
        if (this.config.proProfile !== undefined) {
            if (angular.isString(this.config.proProfile) && this.config.proProfile.indexOf('ERROR:') > -1) {
                err = this.config.proProfile;
            }
        }
        else {
            err = 'ERROR: System issue trying to retrieve the Program Profile';
        }
        this.items = {
            cfg: this.config,
            process_statuses: this.config.getProgramStatusFlow(this.topic.topic.program),
            error: err,
            convert: function (object) {
                var newValue = '';
                if (angular.isArray(object)) {
                    if (object.length > 0) {
                        angular.forEach(object, function (value) {
                            if (angular.isDefined(value)) {
                                newValue = newValue + ' ' + value;
                            }
                        });
                    }
                    else {
                        return 'N/A';
                    }
                }
                else {
                    newValue = object.length > 0 ? object.replace('_', ' ') : 'N/A';
                }
                return newValue.trim().toUpperCase();
            }
        };
        this.Dialog.openDialog(event, this.items, DialogService, 'program-profile.html');
    };
    DetailController.prototype.showSearchResults = function () {
        this.$state.go('detail.searchsubmit', {
            id: this.$stateParams.id
        });
    };
    /**
     * returns label for Sales, depending on oppty version
     * @returns {string}
     */
    DetailController.prototype.getSalesLabel = function () {
        var version = this.topic.checksData.uiVersion;
        var type = (this.topic.topic.sales_assist && this.topic.topic.sales_assist.type) ? this.topic.topic.sales_assist.type : undefined;
        if (!version || version < this.OPP_VERSION_3) {
            return type || 'Automatic';
        }
        else if (version === this.OPP_VERSION_3) {
            return type || 'CVR SSA';
        }
        else if (version >= this.OPP_VERSION_4) {
            if (!type || type === 'CVR SSA') {
                return 'Sales/Sales Assist';
            }
            else if (type === 'CVR Sales') {
                return 'Sales';
            }
            else if (type == 'CVR Sales Assist') {
                return 'Sales Assist';
            }
            else {
                return type;
            }
        }
    };
    /**
     * Returns CVR or SWDR based on oppy version
     * @returns {string}
     * @memberof DetailController
     */
    DetailController.prototype.getProgramType = function () {
        if (this.topic.checksData.uiVersion >= this.OPP_VERSION_3) {
            return 'SWDR';
        }
        else if (this.topic.topic.program === 'SVI') {
            return 'CVR';
        }
        else {
            return this.topic.topic.program;
        }
    };
    DetailController.$inject = ['env', '$filter', 'DTS', '$scope', '$stateParams', '$state',
        'socket', 'topic', '$mdIcon', 'config', 'status', 'Dialog', '$mdDialog', 'settings',
        'searchSubmit', '$rootScope', '_'];
    return DetailController;
}());
var DetailComponent = (function () {
    function DetailComponent() {
        this.templateUrl = 'detail.html';
        this.controllerAs = 'vm';
        this.controller = DetailController;
    }
    return DetailComponent;
}());
angular
    .module('application')
    .component('detailSection', new DetailComponent());



/**
 * @author Ivan Toth.
 */
var DetailLoadingController = (function () {
    function DetailLoadingController(topic, socket, $stateParams) {
        this.topic = topic;
        this.socket = socket;
        this.$stateParams = $stateParams;
        this.id = $stateParams.id;
    }
    DetailLoadingController.$inject = ['topic', 'socket', '$stateParams'];
    return DetailLoadingController;
}());
var DetailLoadingComponent = (function () {
    function DetailLoadingComponent() {
        this.templateUrl = 'detail-loading.html';
        this.controllerAs = 'vm';
        this.controller = DetailLoadingController;
    }
    return DetailLoadingComponent;
}());
angular
    .module('application')
    .component('loadingView', new DetailLoadingComponent());



var bind = { vm: '=' };
var FilterController = (function () {
    function FilterController($scope, socket, $state, env, $mdDialog, Dialog) {
        this.$scope = $scope;
        this.socket = socket;
        this.$state = $state;
        this.env = env;
        this.$mdDialog = $mdDialog;
        this.Dialog = Dialog;
        this.profileName = 'Default profile';
    }
    FilterController.prototype.closeFilter = function () {
        this.vm.isFilterToggled = false;
    };
    FilterController.prototype.viewProfiles = function (ev) {
        this.Dialog.openDialog2(ev, '', FilterController, 'profiles.dialog.html', '', this.$scope);
    };
    FilterController.prototype.cancel = function (ev) {
        this.$mdDialog.cancel();
    };
    FilterController.$inject = ['$scope', 'socket', '$state', 'env', '$mdDialog', 'Dialog'];
    return FilterController;
}());
var FilterComponent = (function () {
    function FilterComponent() {
        this.bindings = bind;
        this.templateUrl = 'filter.html';
        this.controller = FilterController;
    }
    return FilterComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('clearAll', '/public/icons/ic_clear_all_black_18px.svg');
})
    .component('filterSection', new FilterComponent());



/**
 * The Finger class represents a tracked finger.
 *
 * <p>Fingers are Pointable objects that the Leap has classified as a finger.
 * Get valid Finger objects from a Frame or a Hand object.</p>
 *
 * <p>Note that Finger objects can be invalid, which means that they do not
 * contain valid tracking data and do not correspond to a physical finger.
 * Invalid Finger objects can be the result of asking for a Finger object
 * using an ID from an earlier frame when no Finger objects with that ID
 * exist in the current frame. A Finger object created from the Finger
 * constructor is also invalid.<br/>
 * Test for validity with the <code>Finger.sValid()</code> function.</p>
 *
 * @author logotype
 *
 */
var helpController = (function () {
    function helpController(env, $filter, DTS, $stateParams, $state) {
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        /**
         * @formvalue for the help texte.
         */
        this.helpText = "hi";
        //console.log(this.$state);
    }
    /**
     * Comment for method ´doSomething´.
     * @param target  Comment for parameter ´target´.
     * @returns       Comment for return value.
     */
    helpController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state'];
    return helpController;
}());
/**
 * Comment for method ´doSomething´.
 * @param target  Comment for parameter ´target´.
 * @returns       Comment for return value.
 */
var helpComponent = (function () {
    function helpComponent() {
        this.templateUrl = 'help.html';
        this.controllerAs = 'vm';
        this.controller = helpController;
    }
    return helpComponent;
}());
angular
    .module('application')
    .component('helpSection', new helpComponent());



var homeController = (function () {
    function homeController($window) {
        this.$window = $window;
    }
    homeController.prototype.logIn = function () {
        this.$window.location.href = "/loginw3";
    };
    homeController.$inject = ['$window'];
    return homeController;
}());
var homeComponent = (function () {
    function homeComponent() {
        this.templateUrl = 'home.html';
        this.controllerAs = 'vm';
        this.controller = homeController;
    }
    return homeComponent;
}());
angular
    .module('application')
    .component('homeSection', new homeComponent());



var ibmContactController = (function () {
    function ibmContactController() {
    }
    ibmContactController.prototype.openContact = function () {
        this.className = "ibm-active";
    };
    ibmContactController.prototype.closeContact = function () {
        this.className = "";
    };
    return ibmContactController;
}());
var ibmContactComponent = (function () {
    function ibmContactComponent() {
        this.templateUrl = 'home-contact.html';
        this.controllerAs = 'vm';
        this.controller = ibmContactController;
    }
    return ibmContactComponent;
}());
angular
    .module('application')
    .component('ibmContactModule', new ibmContactComponent());



/**
 * @fileOverview invite.component.ts - Handling invites for people to join teams
 * @author Ivelin Ivanov
 */
var bindt = { vm: '<' };
var InviteController = (function () {
    function InviteController(socket, DTS, $q, $timeout, $stateParams, $state, $scope, $attrs, env, topic) {
        var _this = this;
        this.socket = socket;
        this.DTS = DTS;
        this.$q = $q;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.env = env;
        this.topic = topic;
        this.scopeId = this.DTS.guid();
        this.isManual = false;
        this.hasResult = false;
        this.hasText = false;
        this.isSelected = false;
        this.isDisabled = false;
        this.searchText = null;
        this.selectedItem = [];
        this.deferred = {};
        this.selectedTeams = [];
        this.arr = [];
        this.selectedEmails = [];
        this.clTEams = this.topic.topic.teams;
        this.socket.forward('add.members', this.$scope);
        this.$scope.$on('socket:add.members', function (event, data) {
            if (data === 'success') {
                _this.sendMail();
            }
        });
        this.socket.forward('get.members', this.$scope);
        this.$scope.$on('socket:get.members', function (event, data) {
            _this.clTEams = data;
        });
        this.socket.forward('typeahead.' + this.scopeId, this.$scope);
        this.$scope.$on('socket:typeahead.' + this.scopeId, function (event, data) {
            _this.lookupowner(event, data);
        });
    }
    InviteController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getTeams',
                script: '/config/config',
                data: {},
                token: this.env.user.token
            }
        });
    };
    InviteController.prototype.addMembers = function () {
        var emails = [];
        this.selectedEmails.forEach(function (mail) {
            if (mail.hasOwnProperty('email')) {
                emails.push(mail.email);
            }
        });
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'inviteMember',
                script: '/config/config',
                data: {
                    teamNames: this.selectedTeams,
                    mails: emails
                },
                token: this.env.user.token
            }
        });
    };
    InviteController.prototype.sendMail = function () {
        var emails = [];
        this.selectedEmails.forEach(function (mail) {
            if (mail.hasOwnProperty('email')) {
                emails.push(mail.email);
            }
        });
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'sendMail',
                script: '/mail/users',
                data: {
                    teams: this.selectedTeams,
                    mails: emails,
                    user: this.env.user.email
                },
                token: this.env.user.token
            }
        });
    };
    /**
   * Return the proper object when the append is called.
   */
    InviteController.prototype.transformChip = function (chip) {
        if (angular.isObject(chip)) {
            return chip;
        }
    };
    InviteController.prototype.lookupowner = function (event, data) {
        if (data.err) {
            return this.env.promises[data.id].reject([]);
        }
        this.env.promises[data.id].resolve(data.results);
        delete this.env.promises[data.id];
    };
    InviteController.prototype.searchTextChange = function (text) {
        var t = this;
        if (!text) {
            this.hasText = false;
        }
        else {
            this.hasText = true;
            this.searchText = text;
        }
    };
    InviteController.prototype.selectedItemChange = function () {
        var t = this;
        if (!this.hasText) {
            this.isSelected = false;
            this.hasResult = false;
        }
        else {
            this.isSelected = true;
            this.hasResult = true;
        }
    };
    InviteController.prototype.newPromise = function (socket, query) {
        var _this = this;
        var t = this;
        this.deferred = this.$q.defer();
        this.$timeout(function () {
            _this.deferred.reject([]);
        }, 5000);
        var id = this.DTS.guid();
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'lookUpUser',
                script: '/queue/typeahead',
                query: query,
                id: id,
                scope: this.scopeId,
                adminOnly: false,
                token: this.env.user.token
            }
        });
        this.env.promises[id] = this.deferred;
        return this.deferred.promise;
    };
    InviteController.prototype.querySearch = function (query) {
        var t = this;
        return this.newPromise(this.socket, query);
    };
    InviteController.$inject = ['socket', 'DTS', '$q', '$timeout', '$stateParams', '$state', '$scope', '$attrs', 'env', 'topic'];
    return InviteController;
}());
var InviteMemberComponent = (function () {
    function InviteMemberComponent() {
        this.bindings = bindt;
        this.templateUrl = 'invite.html';
        this.controller = InviteController;
    }
    return InviteMemberComponent;
}());
angular
    .module('application')
    .component('inviteSection', new InviteMemberComponent());



var programs = [
    'Promotions', 'Performance Bonus', 'Custom Initiatives',
    'Fees', 'Instant Rebates'
];
var landingPageController = (function () {
    function landingPageController(env, $filter, DTS, $stateParams, $state, socket, $scope, config, admin, $timeout, Dialog, $q, settings, $window) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.config = config;
        this.admin = admin;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.$q = $q;
        this.settings = settings;
        this.$window = $window;
        this.shouldSave = true;
        this.user = {};
        this.isShowClaimForms = false;
        this.isShowCore = false;
        this.isShowMetrics = false;
        this.socket.forward('config.userbyemail', this.$scope);
        this.$scope.$on('socket:config.userbyemail', function (event, data) {
            _this.user = data;
            var userSwdrPrograms = _.get(data, 'swdr_permissions.program', []);
            var userCFPrograms = _.get(data, 'claimforms_permissions.program', []);
            if (userSwdrPrograms.includes('SVI')) {
                _this.isShowCore = true;
                _this.isShowMetrics = true;
            }
            var isIncludesProgramType = userCFPrograms.filter(function (program) { return programs.includes(program); }).length > 0;
            if (isIncludesProgramType) {
                _this.isShowClaimForms = true;
            }
        });
    }
    landingPageController.prototype.$onInit = function () {
        this.admin.getUserProfile(this.env.user.email);
    };
    landingPageController.prototype.claim = function () {
        this.updateUserPermissions('claim-forms');
    };
    landingPageController.prototype.metrics = function () {
        this.updateUserPermissions('report');
    };
    landingPageController.prototype.core = function () {
        this.updateUserPermissions('');
    };
    landingPageController.prototype.updateUserPermissions = function (app) {
        this.user.swdr_permissions.app = app === '' ? 'core' : app;
        var saveBundle = { data: this.user };
        if (this.shouldSave) {
            this.admin.updateUserProfile(saveBundle);
        }
        this.$window.location.href = "/" + app;
    };
    landingPageController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state',
        'socket', '$scope', 'config', 'admin', '$timeout', 'Dialog', '$q', 'settings', '$window'];
    return landingPageController;
}());
var landingComponent = (function () {
    function landingComponent() {
        this.templateUrl = 'landing.html';
        this.controllerAs = 'vm';
        this.controller = landingPageController;
    }
    return landingComponent;
}());
angular
    .module('application')
    .component('landingSection', new landingComponent());



var NoAdminController = (function () {
    function NoAdminController() {
    }
    return NoAdminController;
}());
var NoAdminComponent = (function () {
    function NoAdminComponent() {
        this.templateUrl = 'noadmin.html';
        this.controllerAs = 'vm';
        this.controller = NoAdminController;
    }
    return NoAdminComponent;
}());
angular
    .module('application')
    .component('noAdminSection', new NoAdminComponent());



var NoApproverController = (function () {
    function NoApproverController() {
    }
    return NoApproverController;
}());
var NoApproverComponent = (function () {
    function NoApproverComponent() {
        this.templateUrl = 'noapprover.html';
        this.controllerAs = 'vm';
        this.controller = NoApproverController;
    }
    return NoApproverComponent;
}());
angular
    .module('application')
    .component('noApproverSection', new NoApproverComponent());



var NoProfileController = (function () {
    function NoProfileController() {
    }
    return NoProfileController;
}());
var NoProfileComponent = (function () {
    function NoProfileComponent() {
        this.templateUrl = 'noprofile.html';
        this.controllerAs = 'vm';
        this.controller = NoProfileController;
    }
    return NoProfileComponent;
}());
angular
    .module('application')
    .component('noProfileSection', new NoProfileComponent());



var NotAuthController = (function () {
    function NotAuthController($window, env, $timeout) {
        this.$window = $window;
        this.env = env;
        this.$timeout = $timeout;
        this.hey = 'HEY';
    }
    NotAuthController.prototype.logOut = function () {
        var _this = this;
        console.log('clearing cookies');
        this.env.revokeUser();
        // 1 second added, becaues window
        this.$timeout(function () {
            _this.$window.location.href = '/logout';
        }, 1000);
    };
    NotAuthController.$inject = ['$window', 'env', '$timeout'];
    return NotAuthController;
}());
var NotAuthComponent = (function () {
    function NotAuthComponent() {
        this.templateUrl = '500.html';
        this.controllerAs = 'vm';
        this.controller = NotAuthController;
    }
    return NotAuthComponent;
}());
angular
    .module('application')
    .component('notAuthSection', new NotAuthComponent());



var NotFoundController = (function () {
    function NotFoundController() {
    }
    return NotFoundController;
}());
var NotFoundComponent = (function () {
    function NotFoundComponent() {
        this.templateUrl = '404.html';
        this.controllerAs = 'vm';
        this.controller = NotFoundController;
    }
    return NotFoundComponent;
}());
angular
    .module('application')
    .component('notFoundSection', new NotFoundComponent());



/**
 * @fileOverview detail.preview.component.ts - Live data from GPP/MYSA
 * @author Ivelin Ivanov
 */
var tempthat = {};
var DetailPreviewController = (function () {
    function DetailPreviewController($rootScope, $timeout, $q, socket, $stateParams, topic, settings, $scope, env) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.$stateParams = $stateParams;
        this.topic = topic;
        this.settings = settings;
        this.$scope = $scope;
        this.env = env;
        this.comp = 'gpp_live';
        this.id = $stateParams.id;
        this.socket.forward('preview.preview', this.$rootScope);
        this.$scope.$on('socket:preview.preview', function (event, data) {
            _this.loadData(event, data);
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getTopicErrorsPreview',
                    id: _this.id,
                    script: '/detail/general/general',
                    user: _this.env.user
                }
            });
        });
        this.socket.forward('preview.preview_errors', this.$rootScope);
        this.$scope.$on('socket:preview.preview_errors', function (event, data) {
            _this.topic.topic.errors = data.errors;
        });
        this.topic.loaded.topic = false;
        this.$rootScope.$on('$viewContentLoaded', function (event, toState, toParams, fromState, fromParams) {
            tempthat['viewLoaded'] = true;
        });
    }
    DetailPreviewController.prototype.$onDestroy = function () {
        //Wipe the topic from the browser.  Why? Because if it is assigned and that is the next claim to be entered,
        //the old preview topic will reappear rather than being reloaded
        //this.topic.clearTopic(this.id); 
        this.topic.reloadCheck.id = '';
    };
    DetailPreviewController.prototype.$onInit = function () {
        if (tempthat['viewLoaded']) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getGppData',
                    script: '/detail/general/general',
                    data: {
                        opp: this.id
                    },
                    token: this.env.user.token
                }
            });
        }
    };
    DetailPreviewController.prototype.loadData = function (ev, results) {
        this.topic.clearTopic(this.id);
        this.topic.updateTopicWithoutCalc(results);
        this.topic.loaded.topic = true;
        this.tempData = results;
    };
    DetailPreviewController.$inject = ['$rootScope', '$timeout', '$q', 'socket', '$stateParams', 'topic', 'settings', '$scope', 'env'];
    return DetailPreviewController;
}());
var DetailPreviewComponent = (function () {
    function DetailPreviewComponent() {
        //templateUrl = 'detail-preview.html';
        this.templateUrl = 'detail-preview.html';
        this.controllerAs = 'vm';
        this.controller = DetailPreviewController;
    }
    return DetailPreviewComponent;
}());
angular
    .module('application')
    .component('previewSection', new DetailPreviewComponent());



'use strict';
var AssignController = (function () {
    function AssignController($stateParams) {
        this.$stateParams = $stateParams;
        //console.info('StateParams ', this.$stateParams);
        if (this.$stateParams.id === 'myqueue' || this.$stateParams.id === 'teamqueue') {
            this.isReassign = true;
        }
        else {
            this.isReassign = false;
        }
        //console.info('AssignComponent created', this.isReassign);
    }
    AssignController.$inject = ['$stateParams'];
    return AssignController;
}());
var AssignComponent = (function () {
    function AssignComponent() {
        this.bindings = { vm: '<' };
        this.templateUrl = 'assign.html';
        this.controller = AssignController;
    }
    return AssignComponent;
}());
angular
    .module('application')
    .component('assignSection', new AssignComponent());



var ExcelController = (function () {
    function ExcelController($scope, $window, socket, env) {
        var _this = this;
        this.$scope = $scope;
        this.$window = $window;
        this.socket = socket;
        this.env = env;
        this.socket.forward('queue.exportQueue', this.$scope);
        this.$scope.$on('socket:queue.exportQueue', function (event, data) {
            _this.vm.isDownloading = false;
            if (!data.payload.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.payload], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-" + _this.vm.queueLabel + "-Report_" + d + ".xlsx");
                a.click();
            }
        });
    }
    ExcelController.prototype.$onInit = function () {
        var data = {
            queryId: this.vm.queryId,
            filterTeams: this.vm.filterTeams,
            filterOwners: this.vm.filterOwners,
            filterSubStatuses: this.vm.filterSubStatuses,
            filterStatuses: this.vm.filterStatuses,
            filterSviStatuses: this.vm.filterSviStatuses,
            selectedStates: this.vm.selectedStates,
            filterIots: this.vm.filterIots,
            filterImts: this.vm.filterImts,
            filterCountries: this.vm.filterCountries,
            vapFilter: this.vm.vapFilter,
            verFilter: this.vm.verFilter,
            activeInactive: this.vm.activeInactive,
            goeFilter: this.vm.goeFilter,
            errorFilter: this.vm.filterErrors
        };
        if (this.vm.queryId === 'sap-missing') {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'exportSapMissingQueue',
                    script: 'queueservice/excelbuilder',
                    data: {
                        export: true,
                        iotFilter: this.vm.filterIots,
                        imtFilter: this.vm.filterImts,
                        queueType: this.vm.queryId,
                        goeFilter: this.vm.goeFilter,
                        users: [("" + this.env.user.email)],
                        countryFilter: this.vm.filterCountries,
                        statusFilter: this.vm.filterStatuses,
                        substatusFilter: this.vm.filterSubStatuses,
                        triggeredFilter: this.vm.filterTriggered
                    },
                    token: this.env.user.token
                }
            });
        }
        else {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'exportQueue',
                    script: 'queueservice/excelbuilder',
                    data: {
                        filters: data,
                        userId: this.env.user.email
                    },
                    token: this.env.user.token
                }
            });
        }
    };
    ExcelController.$inject = ['$scope', '$window', 'socket', 'env'];
    return ExcelController;
}());
var ExcelComponent = (function () {
    function ExcelComponent() {
        this.bindings = { vm: '<' };
        this.templateUrl = 'excel-export-queue.html';
        this.controller = ExcelController;
    }
    return ExcelComponent;
}());
angular
    .module('application')
    .component('downloadqSection', new ExcelComponent());



/**
* @fileOverview queue.component.ts - Contains handling of queue management
* @author Jan Valentik
*/
var QueueType;
(function (QueueType) {
    QueueType[QueueType["MY_QUEUE"] = 'myqueue'] = "MY_QUEUE";
    QueueType[QueueType["TEAM_QUEUE"] = 'teamqueue'] = "TEAM_QUEUE";
    QueueType[QueueType["STANDART_REPORT"] = 'standardreport'] = "STANDART_REPORT";
    //GBT20 = 'gbt20',
    QueueType[QueueType["ERROR_QUEUE"] = 'errorqueue'] = "ERROR_QUEUE";
    QueueType[QueueType["UNASSIGNED_QUEUE"] = 'unassigned'] = "UNASSIGNED_QUEUE";
    QueueType[QueueType["MANUAL_REVIEW_QUEUE"] = 'manualReview'] = "MANUAL_REVIEW_QUEUE";
    QueueType[QueueType["WORK_ITEMS_QUEUE"] = 'workitems'] = "WORK_ITEMS_QUEUE";
    QueueType[QueueType["SET_ASIDE_QUEUE"] = 'setAside'] = "SET_ASIDE_QUEUE";
    QueueType[QueueType["GEO_SPM_QUEUE"] = 'geospm'] = "GEO_SPM_QUEUE";
})(QueueType || (QueueType = {}));
var tempthat = {};
var QueueController = (function () {
    function QueueController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, notify, Dialog, settings, $rootScope, topic, moment) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$rootScope = $rootScope;
        this.topic = topic;
        this.moment = moment;
        this.activeInactive = 'active';
        this.newSearch = 'Default';
        //private samplingPage: boolean;
        this.processing = true;
        this.selectedStates = [];
        this.currFilter = [];
        this.dtInstance = {};
        this.checkBoxModel = {};
        this.items = [];
        this.payFreqBase = ['WEEKLY', 'MONTHLY', 'QUARTERLY', 'Unknown'];
        this.waitForReport = false;
        this.oncePressed = false;
        this.queryId = this.$stateParams.id;
        this.socket.forward('queueservice.assign', this.$scope);
        this.$scope.$on('socket:queueservice.assign', function (event, data) {
            if (data.isAssingToYourself && data.successes.length > 0) {
                var items = {
                    message: "Do you want to open " + data.payload.opp + " opportunity? ",
                    okMessage: 'YES',
                    cancelMessage: 'NO',
                    dialogName: 'Opportunity assigned'
                };
                _this.Dialog.YesNoForm(event, items, 'yes-no.html').then(function (dResult) {
                    if (dResult.confirm) {
                        _this.moveToOpp(data.payload);
                    }
                });
            }
            _this.isSubmitting = false;
            _this.dtInstance.DataTable.ajax.reload(null, false);
        });
        this.isDownloading = false;
        this.filters = {};
        this.filterIots = [];
        this.filterImts = [];
        this.filterCountries = [];
        this.filterSviStatuses = [];
        this.filterStatuses = [];
        this.filterSubStatuses = [];
        this.filterOwners = [];
        this.teams = [];
        this.filterTeams = [];
        this.vapFilter = undefined; //was false;
        this.verFilter = undefined;
        this.showFilterBtn = false;
        this.filterDetails();
        this.socket.forward('teamView.getTeams', this.$scope);
        this.$scope.$on('socket:teamView.getTeams', function (event, data) {
            if (data.id === 'getTeams') {
                _this.allTeams = [];
                _this.myTeams = data.personsTeams;
                for (var _i = 0, _a = data.allTeams; _i < _a.length; _i++) {
                    var team = _a[_i];
                    if (!_this.myTeams.includes(team)) {
                        _this.allTeams.push(team);
                    }
                }
            }
        });
        this.socket.forward('filters.getUserFilters', this.$scope);
        this.$scope.$on('socket:filters.getUserFilters', function (event, data) {
            _this.userFilters = data;
            _this.filtersExist = true;
        });
        this.socket.forward('filters.deleteProfiles', this.$scope);
        this.$scope.$on('socket:filters.deleteProfiles', function (event, data) {
            _this.userFilters = data;
            _this.allowed = false;
        });
        this.$rootScope.$on('$viewContentLoaded', function (event, toState, toParams, fromState, fromParams) {
            tempthat['viewLoaded'] = true;
        });
        socket.forward('queue.setaside.get-report', $scope);
        this.$scope.$on('socket:queue.setaside.get-report', function (event, data) {
            _this.waitForReport = false;
            if (!data.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.file], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-Set-Aside-Report_" + d + ".csv");
                a.click();
            }
        });
        socket.forward('queue.setaside.setPaid', $scope);
        this.$scope.$on('socket:queue.setaside.setPaid', function (event, data) {
            _this.dtInstance.DataTable.ajax.reload(null, false);
            if (data.error) {
                return _this.notify.error(data.error);
            }
            else {
                return _this.notify.success('Updated successfully.');
            }
        });
    }
    QueueController.prototype.isAdminUser = function () {
        if (this.env.user.access.bpsoAdmin || this.env.user.access.nonBpsoAdmin) {
            return true;
        }
        else {
            return false;
        }
    };
    QueueController.prototype.$onInit = function () {
        var _this = this;
        this.queueLabel = this.$stateParams.id;
        this.signalWrongResponse = '';
        var that = this;
        this.dtColumns = this.buildColumnsByQueueLabel(this.queueLabel);
        // Matt @ 4th Feb 18...Took this out to see the impact... component loads twice upon an F5... not sure why - Ivan
        // stuck this workaround in to prevent it, but it results in the 'State not loaded properly' error...
        //if (tempthat['viewLoaded']) {
        this.USstates = this.settings.us_states;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'FetchSavedFilters',
                script: '/queueservice/filterprofiles',
                user: this.env.user
            }
        });
        this.isSubmitting = false;
        switch (this.$stateParams.id) {
            case 'myqueue':
                this.queueHelp = 'This queue contains all Disbursements owned by you.';
                this.queueLabel = 'My Queue';
                this.isTeamQueue = false;
                this.showMassAsignment = false;
                this.filterToggles = {
                    countries: true,
                    sviStats: true,
                    dmtStats: true,
                    dmtSubStats: true,
                    teams: false,
                    ver: true
                };
                break;
            case 'unassigned':
                this.queueHelp = 'This queue contains all Unassigned Disbursements whose status is \'Duplicate Opp Search\', \'Waiting Eligibility Decision\' or \'Waiting Order Validation\'. NOTE: If VAP filtering is enabled no North American Disbursements will be displayed, but the status will be extended to include \'Draft\' and \'Denied Participation\'';
                this.queueLabel = 'Unassigned Queue';
                this.showMassAsignment = true;
                this.isTeamQueue = false;
                this.filterToggles = {
                    countries: true,
                    sviStats: true,
                    dmtStats: false,
                    dmtSubStats: false,
                    teams: false,
                    ver: true
                };
                break;
            case 'manualReview':
                this.queueHelp = 'This queue contains all Disbursements that need manual review';
                this.queueLabel = 'Manual Review';
                this.showMassAsignment = true;
                this.isTeamQueue = false;
                this.filterToggles = {
                    countries: true,
                    sviStats: true,
                    dmtStats: false,
                    dmtSubStats: false,
                    teams: false,
                    ver: true
                };
                break;
            case 'errorqueue':
                this.queueHelp = 'This queue contains all Disbursements with one or more Unresolved Error.  Hover over the Details for a breakdown of the error types.';
                this.queueLabel = 'Validation Queue';
                this.showMassAsignment = true;
                this.isTeamQueue = false;
                this.filterToggles = {
                    countries: true,
                    errors: true,
                    sviStats: true,
                    dmtStats: false,
                    dmtSubStats: false,
                    teams: false,
                    ver: true,
                    goe: true
                };
                break;
            case 'workitems':
                this.queueHelp = 'This queue contains all Disbursements regardless of status.';
                this.queueLabel = 'Work Items Queue';
                this.isTeamQueue = false;
                this.showMassAsignment = false;
                this.filterToggles = {
                    countries: true,
                    sviStats: true,
                    dmtStats: true,
                    dmtSubStats: true,
                    teams: false,
                    ver: true
                };
                break;
            case 'teamqueue':
                this.queueHelp = 'This queue contains all Disbursements owned by you and those in the same Teams as you.';
                this.queueLabel = 'Teams\' Queue';
                this.isTeamQueue = true;
                this.showMassAsignment = false;
                this.filterToggles = {
                    countries: true,
                    sviStats: true,
                    dmtStats: true,
                    dmtSubStats: true,
                    teams: true,
                    ver: true
                };
                break;
            case 'setAside':
                this.queueHelp = 'This queue contains all the set aside buckets.';
                this.queueLabel = 'Set Aside Queue';
                this.isTeamQueue = false;
                this.showMassAsignment = false;
                this.filterToggles = {
                    countries: true,
                    frequency: true,
                    sviStats: false,
                    dmtStats: false,
                    dmtSubStats: false,
                    teams: false,
                    vap: false,
                    ver: false
                };
                break;
            case QueueType.GEO_SPM_QUEUE:
                this.queueHelp = 'This queue contains all Disbursements regardless of status.';
                this.queueLabel = 'GEO SPM Queue';
                this.isTeamQueue = false;
                this.showMassAsignment = false;
                this.filterToggles = {
                    countries: true,
                    dmtStats: false,
                    dmtSubStats: false,
                    sviStats: true,
                    teams: false,
                    ver: true
                };
                break;
            default:
                this.queueLabel = '';
        }
        //If there is a lastFilter element in user's profile (in browser), set the
        // filters accordingly and apply them rather than loading the default (all)
        this.applyLastFilter();
        this.dtOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', {
            dataSrc: function (data) {
                that.checkBoxModel = {};
                if (that.queryId === 'setAside') {
                    _this.items = data.data;
                }
                else {
                    data.data.forEach(function (dmtRec) {
                        that.checkBoxModel[dmtRec.opp] = false;
                    });
                }
                return data.data;
            },
            url: '/api/queue',
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                request.setRequestHeader('Authorization', 'Bearer ' + that.env.user.token);
            },
            error: function (xhr, errorMessage, thrown) {
                // Display message, when a error appears
                //console.log('error response:' , xhr, errorMessage, thrown);
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve Queue data from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                    items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b>';
                }
                items.message += '<b style="color:red">' + errorMessage + '/' + thrown + '</b><br><br>';
                items.message += 'This is usually a temporary problem. &nbsp;Please try again, but if the problem persists contact the DMT System Administrators';
                //that.Dialog.updateValidForm(undefined, items, 'fail-alert.html').then((dResult) => {
                that.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
                    that.signalWrongResponse = items.message.replace(new RegExp('<br><br>', 'g'), ' ');
                });
                // Turns off the processing bar
                $('#table_processing').hide();
            },
            complete: function (d) {
                //alert('response received');
            },
            data: function (d, callback, settings) {
                var searchCountries = that.processFilterFieldValues(that.filterCountries);
                var searchSviStat = that.processFilterFieldValues(that.filterSviStatuses);
                var searchDmtStat = that.processFilterFieldValues(that.filterStatuses);
                var searchSubStat = that.processFilterFieldValues(that.filterSubStatuses);
                var searchOwner = that.processFilterFieldValues(that.filterOwners);
                var searchTeam = '';
                if (that.filterTeams.length) {
                    for (var _i = 0, _a = that.filterTeams; _i < _a.length; _i++) {
                        var item = _a[_i];
                        searchTeam += item + '|';
                    }
                    searchTeam = searchTeam.substring(0, searchTeam.length - 1);
                    d.columns.push({
                        data: 'team', name: 'team', orderable: false,
                        search: { regex: true, value: searchTeam }, searchable: false
                    });
                }
                var colIndex = 0;
                for (var _b = 0, _c = d.columns; _b < _c.length; _b++) {
                    var col = _c[_b];
                    if (searchCountries !== '' && col.name === 'country') {
                        col.search.regex = true;
                        col.search.value = searchCountries;
                    }
                    else if (searchCountries !== '' && col.data === 'doc.docCountry') {
                        d.countryFilter = that.filterCountries;
                    }
                    else if (searchDmtStat !== '' && col.name === 'status') {
                        col.search.regex = true;
                        col.search.value = searchDmtStat;
                    }
                    else if (searchSubStat !== '' && col.name === 'substatus') {
                        col.search.regex = true;
                        col.search.value = searchSubStat;
                    }
                    else if (searchOwner !== '' && col.name === 'owner') {
                        col.search.regex = true;
                        col.search.value = searchOwner;
                    }
                    else if (searchSviStat !== '' && col.name === 'svistat') {
                        col.search.regex = true;
                        col.search.value = searchSviStat;
                    }
                    else if (searchTeam !== '' && col.name === 'team') {
                        col.search.regex = true;
                        col.search.value = searchTeam;
                    }
                    else if (angular.isUndefined(that.dtColumns[colIndex].searchable) &&
                        angular.isDefined(that.dtColumns[colIndex].columnSearch)) {
                        col.search.regex = true;
                        col.search.value = that.dtColumns[colIndex].columnSearch;
                    }
                    colIndex++;
                }
                d.usStates = that.selectedStates;
                d.iotFilter = that.filterIots;
                d.imtFilter = that.filterImts;
                d.queueType = that.queryId;
                d.vapFilter = that.vapFilter;
                d.verFilter = that.verFilter;
                d.errorFilter = that.filterErrors;
                d.goeFilter = that.goeFilter;
                d.activeInactive = that.activeInactive;
                d.users = [("" + that.env.user.email)];
                d.freq = that.filterPayFreq;
            }
        })
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('order', [4, 'asc'])
            .withPaginationType('full_numbers')
            .withOption('createdRow', createdRow)
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
        that.searchHandler();
        //        } else {
        //           this.signalWrongResponse = 'State not loaded properly'
        //          this.dtOptions = this.DTOptionsBuilder.newOptions()
        //             .withOption('data', []);
        //    }
        function createdRow(row, data, dataIndex) {
            var OFFSET = 3;
            var thresholdDate = new Date();
            thresholdDate.setHours(0, 0, 0, 0);
            thresholdDate.setDate(thresholdDate.getDate() - OFFSET);
            var createdOn = new Date(parseInt(data.created, 10));
            createdOn.setHours(0, 0, 0, 0);
            if (createdOn <= thresholdDate && data.substatus === 'Unassigned') {
                $(row).addClass('tblRow').css('color', 'red');
            }
            else if (angular.isDefined(data.criticalColor)) {
                // If critical colour property added, set accordingly - error queue only (for now)
                $(row).addClass('tblRow').css('color', data.criticalColor);
            }
            else {
                $(row).addClass('tblRow');
            }
            var el = angular.element;
            that.$compile(el(row).contents())(that.$scope);
        }
    };
    QueueController.prototype.processFilterFieldValues = function (filterValues) {
        return Array.isArray(filterValues) ? filterValues.map(function (f) { return ("\"" + f + "\""); }).join('|') : '';
    };
    QueueController.prototype.buildColumnsByQueueLabel = function (queueLabel) {
        switch (queueLabel) {
            case QueueType.ERROR_QUEUE:
                return this.buildColumns_Error();
            case QueueType.SET_ASIDE_QUEUE:
                return this.buildColumnsSetAside();
            case QueueType.GEO_SPM_QUEUE:
                return this.buildColumnsGeoSpm();
            default:
                return this.buildColumns();
        }
    };
    // on destroy of the component a interval will be closed
    QueueController.prototype.$onDestroy = function () {
        clearInterval(this.interval);
        clearTimeout(this.waitTimeout);
        this.topic.reloadCheck.id = '';
    };
    QueueController.prototype.searchHandler = function () {
        var _this = this;
        var counter = 1000;
        this.interval = setInterval(function () {
            if ($('#table_filter input').length > 0) {
                $('#table_filter input').unbind();
                $('#table_filter input').bind('keyup', function (e) {
                    _this.signalWrongResponse = '';
                    clearTimeout(_this.waitTimeout);
                    _this.waitTimeout = setTimeout(function () {
                        clearInterval(_this.interval);
                        $('#table').dataTable().fnFilter($('#table_filter input:first').val());
                    }, 1000);
                    if (e.keyCode == 13) {
                        clearTimeout(_this.waitTimeout);
                        $('#table').dataTable().fnFilter($('#table_filter input:first').val());
                    }
                });
                counter = 0;
            }
            if (--counter < 0) {
                clearInterval(_this.interval);
            }
        }, 500);
    };
    QueueController.prototype.applyLastFilter = function () {
        var _this = this;
        //If there is a lastFilter element in user's profile (in browser), set the
        // filters accordingly and apply them rather than loading the default (all)
        if (this.settings.up.lastFilter) {
            angular.forEach(this.settings.up.lastFilter, function (v, k) {
                _this[k] = v;
            });
            this.isFilterToggled = true;
        }
    };
    QueueController.prototype.expand = function () {
        var tr = $('.ibm-data-table tbody tr:hover');
        var row = this.dtInstance.DataTable.row(tr);
        if (row.child.isShown()) {
            var expIcon = $('.ibm-data-table tbody tr:hover span md-icon.expand');
            expIcon.removeClass('ng-hide');
            var colIcon = $('.ibm-data-table tbody tr:hover span md-icon.collapse');
            colIcon.addClass('ng-hide');
            row.child.hide();
        }
        else {
            this.collapseRows();
            var expIcon = $('.ibm-data-table tbody tr:hover span md-icon.expand');
            expIcon.addClass('ng-hide');
            var colIcon = $('.ibm-data-table tbody tr:hover span md-icon.collapse');
            colIcon.removeClass('ng-hide');
            row.child(this.format(row.data())).show();
        }
    };
    QueueController.prototype.collapseRows = function () {
        var rowsCount = this.dtInstance.DataTable.page.info().length;
        for (var i = 0; i < rowsCount; i++) {
            if (this.dtInstance.DataTable.row(i).child.isShown()) {
                this.dtInstance.DataTable.row(i).child.hide();
            }
        }
    };
    QueueController.prototype.fixQuotes = function (val) {
        return val.replace(/'/g, '');
    };
    // tslint:disable-next-line: member-ordering
    QueueController.prototype.format = function (d) {
        var el = angular.element;
        if (d.substatus !== 'Unassigned' && d.substatus !== 'Pending Incentive GOE Check' && d.substatus !== 'Pending Manual Review') {
            return this.$compile(el("\n                    <table cellpadding='5' cellspacing='0' border='0' style='padding-left:50px;'>\n                        <tr ng-if=\"!vm.isSubmitting\">\n                            <td style=\"background-color:transparent; border: 0px;\">\n                                <type-ahead opp='" + d.opp + "' bpname='" + this.fixQuotes(d.bp) + "' status='" + d.status + "' country='" + this.settings.getShortName(d.country) + "' reassign=\"true\"/>\n                            </td>\n                        </tr>\n                        <tr ng-if=\"vm.isSubmitting\">\n                            <td style=\"background-color:transparent; border: 0px;\">\n                                <span class='ibm-h1' ng-if=\"vm.isSubmitting\">\n                                    <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n                                </span>\n                            </td>\n                        </tr>\n                    </table>").contents())(this.$scope);
        }
        else {
            return this.$compile(el("\n                    <table cellpadding='5' cellspacing='0' border='0' style='padding-left:50px;'>\n                        <tr ng-if=\"!vm.isSubmitting\">\n                            <td style=\"border: 0px;\">\n                                <md-button style=\"background-color: rgb(63,81,181); color: rgba(255,255,255,0.87);\" ng-click=\"vm.assign([{opp:'" + d.opp + "',bpname:'" + (d.bp ? d.bp.replace(/"/g, '') : 'Unknown BP') + "',status:'" + d.status + "',country:'" + this.settings.getShortName(d.country) + "'}])\">\n                                    Assign to myself\n                                </md-button>\n                            </td>\n                            <td style=\"background-color:transparent; border: 0px;\">\n                                <type-ahead opp='" + d.opp + "' bpname='" + d.bp + "' status='" + d.status + "' country='" + this.settings.getShortName(d.country) + "' reassign=\"false\"/>\n                            </td>\n                        </tr>\n                        <tr ng-if=\"vm.isSubmitting\">\n                            <td style=\"background-color:transparent; border: 0px;\">\n                                <span class='ibm-h1' ng-if=\"vm.isSubmitting\">\n                                    <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n                                </span>\n                            </td>\n                        </tr>\n                    </table>").contents())(this.$scope);
        }
    };
    // tslint:disable-next-line: member-ordering
    QueueController.prototype.buildColumns_Error = function () {
        var _this = this;
        var that = this;
        return [
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Select')
                .notSortable()
                .renderWith(function (data, type, full, meta) {
                return "<input type=\"checkbox\"\n                                ng-class=\"{'hide-dt-column': !vm.isMassAssignmentToggled}\"\n                                ng-model=\"vm.checkBoxModel['" + data.opp + "']\"/>";
            })
                .withOption('name', 'assign-col')
                .withOption('searchable', false),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Assign')
                .notSortable()
                .renderWith(function (data) {
                if (data.substatus !== 'Unassigned' && !_this.isAdminUser()) {
                    return "<span>\n                                <md-icon md-svg-icon=\"forbidden\"/>\n                            </span>";
                }
                else {
                    return "<span>\n                                <md-icon class=\"expand\" md-svg-icon=\"expand\" ng-click=\"vm.expand()\"/>\n                            </span>\n                            <span>\n                                <md-icon class=\"collapse ng-hide\" md-svg-icon=\"collapse\" ng-click=\"vm.expand()\"/>\n                            </span>";
                }
            })
                .withOption('className', 'details-control')
                .withOption('searchable', false),
            this.DTColumnBuilder.newColumn('ver').withTitle('Version')
                .withOption('name', 'ver')
                .renderWith(this.getVersionLabel)
                .notSortable(),
            this.DTColumnBuilder.newColumn('opp').withTitle('Opportunity')
                .withOption('name', 'opp').renderWith(this.linkUrl),
            this.DTColumnBuilder.newColumn('opp_group_id').withTitle('Opportunity Group ID')
                .withOption('name', 'opp_group_id'),
            this.DTColumnBuilder.newColumn('svistat')
                .withTitle('MySA Status').withOption('name', 'svistat'),
            this.DTColumnBuilder.newColumn('bp').withOption('name', 'bp')
                .withTitle('BP Name'),
            this.DTColumnBuilder.newColumn('country')
                .withTitle('Country').withOption('name', 'country'),
            this.DTColumnBuilder.newColumn('acnt').withOption('name', 'acnt')
                .withTitle('Account Name'),
            this.DTColumnBuilder.newColumn('sodate').withOption('name', 'sodate')
                .withTitle('SO date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); })
                .withOption('searchable', false).notSortable(),
            this.DTColumnBuilder.newColumn('payment_date').withOption('name', 'payment_date')
                .withTitle('Payment request date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); })
                .withOption('searchable', false).notSortable(),
            this.DTColumnBuilder.newColumn('status').withTitle('Status')
                .withOption('name', 'status'),
            this.DTColumnBuilder.newColumn('substatus').withOption('name', 'substatus')
                .withTitle('Sub Status'),
            this.DTColumnBuilder.newColumn('errorStat')
                .withTitle('No. of Errors').renderWith(this.errorDisplay).withOption('searchable', false).notSortable(),
            this.DTColumnBuilder.newColumn('GOE').withOption('name', 'GOE')
                .withTitle('Government Flag').withOption('searchable', false).notSortable(),
            this.DTColumnBuilder.newColumn('dispute_itrtype').withOption('name', 'dispute_itrtype')
                .withTitle('Credit/ debit flag').withOption('searchable', false).notSortable(),
            this.DTColumnBuilder.newColumn('aging').withOption('name', 'aging')
                .withTitle('Aging').withOption('searchable', false).notSortable(),
            // this.DTColumnBuilder.newColumn('errQty')
            //   .withTitle('No. of Errors'),//.renderWith(this.errorDisplay),
            this.DTColumnBuilder.newColumn('owner')
                .withOption('name', 'owner').withTitle('Owner').renderWith(function (data) {
                if (data.userid !== null) {
                    /*return `<span>
                        <img class="table-img-circle" ng-src="//faces.tap.ibm.com/imagesrv/${data.userid}.jpg?s=75"/>
                        <span class="ibm-center ibm-regular">${data.name}</span>
                    </span>`;*/
                    return "<span>\n                            <img class=\"table-img-circle\" ng-src=\"" + _this.getAvatar(data.userid) + "\"/>\n                            <span class=\"ibm-center ibm-regular\">" + data.name + "</span>\n                        </span>";
                }
                else {
                    return "<span>N/A</span>";
                }
            }),
        ];
    };
    QueueController.prototype.getAvatar = function (email) {
        return this.DTS.getAvatar(email, 115);
    };
    QueueController.prototype.getDateFormat = function (d) {
        if (!d) {
            return '';
        }
        else if (d.search('/') > -1) {
            return 'MM/DD/YYYY';
        }
        else if (d.search('-') > -1) {
            return 'YYYY-MM-DD';
        }
        else if (d.substring(2, 3) === '.') {
            return 'DD.MM.YYYY';
        }
        else {
            return 'YYYYMMDD';
        }
    };
    QueueController.prototype.getFinePrintedData = function (d) {
        // console.log('finePrintedData before: ' + d + ' type: ' + typeof d + 'is not number: ' + Number.isNaN(Number(d)));
        if (!d || d === 'N/A' || (typeof d !== 'string' && typeof d !== 'number')) {
            return 'N/A';
        }
        var mom = Number.isNaN(Number(d))
            ? this.moment(d, this.getDateFormat(String(d)))
            : this.moment.utc(Number(d));
        // console.log('finePrintedData after: ' + mom.format('YYYY/MM/DD'));
        return mom.format('YYYY/MM/DD');
    };
    // tslint:disable-next-line: member-ordering
    QueueController.prototype.buildColumns = function () {
        var _this = this;
        var that = this;
        var columns = [
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Select')
                .notSortable()
                .renderWith(function (data, type, full, meta) {
                return "<input type=\"checkbox\"\n                                ng-class=\"{'hide-dt-column': !vm.isMassAssignmentToggled}\"\n                                ng-model=\"vm.checkBoxModel['" + data.opp + "']\"/>";
            })
                .withOption('name', 'assign-col')
                .withOption('searchable', false),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Assign')
                .notSortable()
                .renderWith(function (data) {
                //If Work Items and user is not System Admin, or If not Work Items and user is not BPSO/Non-BPSO Admin...Block Assignment drop-down
                if ((that.queryId === 'workitems' && !_this.env.user.access.systemAdmin) || (that.queryId !== 'workitems' && !_this.isAdminUser())) {
                    return "<span>\n                                    <md-icon md-svg-icon=\"forbidden\"/>\n                                </span>";
                }
                else {
                    return "<span>\n                                    <md-icon class=\"expand\" md-svg-icon=\"expand\" ng-click=\"vm.expand()\"/>\n                                </span>\n                                <span>\n                                    <md-icon class=\"collapse ng-hide\" md-svg-icon=\"collapse\" ng-click=\"vm.expand()\"/>\n                                </span>";
                }
            })
                .withOption('className', 'details-control')
                .withOption('searchable', false),
            this.DTColumnBuilder.newColumn('ver').withTitle('Version')
                .withOption('name', 'ver')
                .renderWith(this.getVersionLabel)
                .notSortable(),
            this.DTColumnBuilder.newColumn('opp').withTitle('Opportunity')
                .withOption('name', 'opp').renderWith(this.linkUrl),
            this.DTColumnBuilder.newColumn('opp_group_id').withTitle('Opportunity Group ID')
                .withOption('name', 'opp_group_id'),
            this.DTColumnBuilder.newColumn('svistat')
                .withOption('name', 'svistat').withTitle('MySA Status'),
            this.DTColumnBuilder.newColumn('bp').withOption('name', 'bp').withTitle('BP Name'),
            this.DTColumnBuilder.newColumn('country')
                .withOption('name', 'country')
                .withTitle('Country'),
            this.DTColumnBuilder.newColumn('acnt').withOption('name', 'acnt')
                .withTitle('Account Name'),
            this.DTColumnBuilder.newColumn('svisubmitdate')
                .withOption('name', 'svisubmitdate').withTitle('CVR Submit Date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); }),
            this.DTColumnBuilder.newColumn('decisiondate').withOption('name', 'decisiondate')
                .withTitle('Decision Date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); })
        ];
        if (this.queryId === 'workitems' || this.queryId === 'myqueue' || this.queryId === 'teamqueue') {
            columns.push(this.DTColumnBuilder.newColumn('soNumber')
                .withOption('name', 'soNumber')
                .withTitle('SO number')
                .withOption('searchable', false).notSortable());
        }
        if (this.queryId === 'myqueue' || this.queryId === 'teamqueue' || this.queryId === 'workitems') {
            columns.push(this.DTColumnBuilder.newColumn('payment_date')
                .withOption('name', 'payment_date')
                .withTitle('Payment request date').withOption('searchable', false).notSortable()
                .renderWith(function (d) { return _this.getFinePrintedData(d); }));
        }
        columns.push(this.DTColumnBuilder.newColumn('status').withOption('name', 'status').withTitle('Status'));
        columns.push(this.DTColumnBuilder.newColumn('substatus')
            .withOption('name', 'substatus').withTitle('Sub Status'));
        columns.push(this.DTColumnBuilder.newColumn('created').withOption('name', 'created')
            .withOption('searchable', false)
            .notSortable().notVisible());
        columns.push(this.DTColumnBuilder.newColumn('acctstate').withOption('name', 'acctstate')
            .withTitle('State ').renderWith(function (data, type, full) {
            if (data.state !== null && data.country === 'USA') {
                return "<span class=\"ibm-center ibm-regular\" title=\"US State\">" + data.state + "</span>";
            }
            else {
                return "<span class =\"ibm-h2\">\n                                <md-icon md-svg-src=\"/public/icons/ic_highlight_off_black_24px.svg\" title=\"US state not found\" aria-label=\"USstate\"> </md-icon>\n                            </span>";
            }
        }));
        if (this.queryId === 'myqueue' || this.queryId === 'teamqueue' || this.queryId === 'workitems') {
            columns.push(this.DTColumnBuilder.newColumn('dispute_itrtype').withOption('name', 'dispute_itrtype').withTitle('Credit/ Debit flag').withOption('searchable', false).notSortable());
        }
        if (this.queryId === 'unassigned' || this.queryId === 'manualReview' || this.queryId === 'workitems' || this.queryId === 'myqueue' || this.queryId === 'teamqueue') {
            columns.push(this.DTColumnBuilder.newColumn('aging').withOption('name', 'aging').withTitle('Aging').withOption('searchable', false).notSortable());
        }
        if (this.queryId === 'teamqueue' || this.queryId === 'workitems') {
            columns.push(this.DTColumnBuilder.newColumn('owner').withOption('name', 'owner').withTitle('Owner').renderWith(function (data) {
                if (Boolean(data.name)) {
                    return "<span>\n                            <img class=\"table-img-circle\" ng-src=\"" + _this.getAvatar(data.userid) + "\"/>\n                                <span class=\"ibm-center ibm-regular\">" + data.name + "</span>\n                            </span>";
                }
                else {
                    return "<span>N/A</span>";
                }
            }));
        }
        return columns;
    };
    // tslint:disable-next-line: member-ordering
    QueueController.prototype.buildColumnsGeoSpm = function () {
        var _this = this;
        return [
            this.DTColumnBuilder.newColumn('opp').withOption('name', 'opp')
                .withTitle('Opportunity Number')
                .renderWith(this.linkUrl),
            this.DTColumnBuilder.newColumn('svistat').withOption('name', 'svistat')
                .withTitle('MySA Status'),
            this.DTColumnBuilder.newColumn('bp').withOption('name', 'bp')
                .withTitle('BP Name'),
            this.DTColumnBuilder.newColumn('acnt').withOption('name', 'acnt')
                .withTitle('Account Name'),
            this.DTColumnBuilder.newColumn('country').withOption('name', 'country')
                .withTitle('Account Country'),
            this.DTColumnBuilder.newColumn('acctstate').withOption('name', 'acctstate')
                .withTitle('Account State')
                .renderWith(function (data) {
                if (data.state !== null && data.country === 'USA') {
                    return "<span class=\"ibm-center ibm-regular\" title=\"US State\">" + data.state + "</span>";
                }
                else {
                    return "<span class =\"ibm-h2\">\n                                <md-icon md-svg-src=\"/public/icons/ic_highlight_off_black_24px.svg\" title=\"US state not found\" aria-label=\"USstate\"> </md-icon>\n                            </span>";
                }
            }),
            this.DTColumnBuilder.newColumn('svisubmitdate').withOption('name', 'svisubmitdate')
                .withTitle('Submit Date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); }),
            this.DTColumnBuilder.newColumn('sviexpdate').withOption('name', 'sviexpdate')
                .withTitle('Expiration Date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); }),
            this.DTColumnBuilder.newColumn('decisiondate').withOption('name', 'decisiondate')
                .withTitle('Decision Date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); }),
            this.DTColumnBuilder.newColumn('payment_date').withOption('name', 'payment_date')
                .withTitle('Submit Date for Payment')
                .renderWith(function (d) { return _this.getFinePrintedData(d); }),
            this.DTColumnBuilder.newColumn('soNumber').withOption('name', 'soNumber')
                .withTitle('Sales Order Number'),
            //.withOption('searchable', true).notSortable(),
            this.DTColumnBuilder.newColumn('ge').withOption('name', 'ge')
                .withTitle('GE flag'),
            this.DTColumnBuilder.newColumn('nc').withOption('name', 'nc')
                .withTitle('New Client')
                .renderWith(function (d) { return (_.isUndefined(d) || d === null) ? '' : Boolean(d); }),
            this.DTColumnBuilder.newColumn('cd').withOption('name', 'cd')
                .withTitle('Customer Designation'),
            this.DTColumnBuilder.newColumn('dcid').withOption('name', 'dcid')
                .withTitle('DCID'),
            this.DTColumnBuilder.newColumn('dbg').withOption('name', 'dbg')
                .withTitle('DBG'),
            this.DTColumnBuilder.newColumn('ncExpDate').withOption('name', 'ncExpDate')
                .withTitle('New Client Expiration Date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); }),
        ];
    };
    QueueController.prototype.linkUrl = function (data, type, full, meta) {
        return '<a class="ibm-ind-link" href="detail/' + data + '/general" ng-click="$event.preventDefault();vm.edit(' + meta.row + ')">' + data + '</a>';
    };
    // tslint:disable-next-line: member-ordering
    QueueController.prototype.actionsHtml = function (data, type, full, meta) {
        if (this.$stateParams.id === 'workitems') {
            return "<span>\n                        <md-icon md-svg-icon=\"forbidden\"/>\n                    </span>";
        }
        else {
            return "<span>\n                        <md-icon class=\"expand\" md-svg-icon=\"expand\" ng-click=\"vm.expand()\"/>\n                    </span>\n                    <span>\n                        <md-icon class=\"collapse ng-hide\" md-svg-icon=\"collapse\" ng-click=\"vm.expand()\"/>\n                    </span>";
        }
    };
    // tslint:disable-next-line: member-ordering
    QueueController.prototype.errorDisplay = function (data, type, full, meta) {
        var display = '';
        for (var i = 0; i < data.length; i++) {
            if (i > 0) {
                display += '\n';
            }
            display += '#' + (i + 1) + ' - Type: ' + data[i].type + '  - Details: ' + data[i].details;
        }
        return "<p style=\"font-size: inherit\" class=\"ibm-textcolor-blue-40\" title=\"" + display + "\">" + data.length + "<sup style=\"margin-left: 3px\" class=\"errComments\">DETAILS</sup></p> ";
    };
    QueueController.prototype.changemade = function (index) {
        $('#table_filter input:first').keyup();
    };
    // tslint:disable-next-line: member-ordering
    QueueController.prototype.assign = function (opp, owner) {
        if (opp === undefined) {
            opp = [];
            for (var prop in this.checkBoxModel) {
                if (this.checkBoxModel.hasOwnProperty(prop)) {
                    if (this.checkBoxModel[prop]) {
                        var data = {};
                        data.opp = prop;
                        for (var i = 0; i < this.dtInstance.DataTable.rows().data().length; i++) {
                            if (this.dtInstance.DataTable.rows().data()[i].opp === prop &&
                                this.dtInstance.DataTable.rows().data()[i].substatus === 'Unassigned') {
                                data.bpname = this.dtInstance.DataTable.rows().data()[i].bp;
                                data.status = this.dtInstance.DataTable.rows().data()[i].status; //Status added to determine if Assigning at REceived or Validation
                                data.mass = true; //Indicates mass assignment taking place
                                opp.push(data);
                                break;
                            }
                        }
                    }
                }
            }
        }
        if (owner === undefined) {
            owner = this.env.user.email;
        }
        if ((opp instanceof Array && opp.length !== 0) || !(opp instanceof Array)) {
            this.isSubmitting = true;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'assignRequests',
                    script: '/queueservice/assign',
                    data: {
                        opps: opp,
                        email: owner,
                        reassign: false,
                        currentUser: this.env.user.email,
                        notifications: this.env.notifications
                    },
                    token: this.env.user.token
                }
            });
        }
    };
    QueueController.prototype.isSelected = function () {
        for (var prop in this.checkBoxModel) {
            if (this.checkBoxModel.hasOwnProperty(prop)) {
                if (this.checkBoxModel[prop]) {
                    return true;
                }
            }
        }
        return false;
    };
    QueueController.prototype.reAssign = function (newOwner) {
        this.isSubmitting = true;
        var opp = [];
        for (var prop in this.checkBoxModel) {
            if (this.checkBoxModel.hasOwnProperty(prop)) {
                if (this.checkBoxModel[prop]) {
                    var data = {};
                    data.opp = prop;
                    for (var i = 0; i < this.dtInstance.DataTable.rows().data().length; i++) {
                        if (this.dtInstance.DataTable.rows().data()[i].opp === prop) {
                            data.bpname = this.dtInstance.DataTable.rows().data()[i].bp;
                            break;
                        }
                    }
                    opp.push(data);
                }
            }
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'assignRequests',
                script: '/queueservice/assign',
                data: {
                    opps: opp,
                    email: newOwner,
                    reassign: true,
                    currentUser: this.env.user.email,
                    notifications: this.env.notifications //User
                },
                token: this.env.user.token
            }
        });
    };
    QueueController.prototype.edit = function (index) {
        var rowData = this.dtInstance.DataTable.row(index).data();
        this.moveToOpp(rowData);
    };
    QueueController.prototype.moveToOpp = function (data) {
        if (this.queueLabel === 'Unassigned Queue') {
            this.$state.go('preview', {
                id: data.opp
            });
        }
        else {
            this.$state.go('detail.general', {
                id: data.opp
            });
        }
    };
    QueueController.prototype.toggleMassAssignment = function () {
        this.isMassAssignmentToggled = !this.isMassAssignmentToggled;
    };
    QueueController.prototype.filterDetails = function () {
        var _this = this;
        this.env.topics.imtFilterValues = this.settings.country_list;
        this.filters.iots = this.settings.iot_list;
        this.filters.imts = this.settings.imt_list;
        this.filters.countries = this.settings.getCountryList();
        if (!Array.isArray(this.filters.imts)) {
            this.filters.imts = [];
        }
        if (!Array.isArray(this.filters.iots)) {
            this.filters.iots = [];
        }
        if (!Array.isArray(this.filters.countries)) {
            this.filters.countries = [];
        }
        if (!Array.isArray(this.env.topics.imtFilterValues)) {
            this.env.topics.imtFilterValues = [];
        }
        this.filters.imts.sort();
        this.filters.iots.sort();
        this.filters.countries.sort();
        this.env.topics.imtFilterValues.forEach(function (value) {
            if (value.ic === 'IOT') {
                if (!_.includes(_this.filters.iots, value.imt)) {
                    _this.filters.iots.push(value.imt);
                }
            }
            else if (value.ic === 'IMT') {
                if (!_.includes(_this.filters.imts, value.imt_name)) {
                    _this.filters.imts.push(value.imt_name);
                }
            }
            else {
                if (!_.includes(_this.filters.countries, value.country)) {
                    _this.filters.countries.push(value.country);
                }
            }
        });
        this.filters.sviStatuses = this.settings.svistatuses;
        this.filters.statuses = this.settings.statuses;
        this.filters.subStatuses = this.settings.substatuses;
        this.filters.errorTypes = [{ t: 'Payment Errors', n: 'Payment Error' }, { t: 'WOV Errors', n: 'wovError' }, { t: 'Validation Errors', n: 'Validation Error' }, { t: 'Calculation Errors', n: 'calcError' }, { t: 'Auto GOE Errors', n: 'Auto GOE' }];
        this.showFilterBtn = true;
    };
    QueueController.prototype.changeFilters = function (id) {
        var _this = this;
        if (id === 'iot') {
            this.filterImts = [];
            this.filterCountries = [];
            this.filters.imts = [];
            this.filters.countries = [];
            if (this.filterIots.length > 0) {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'IMT') {
                        if (_.includes(_this.filterIots, value.imt) &&
                            !_.includes(_this.filters.imts, value.imt_name)) {
                            _this.filters.imts.push(value.imt_name);
                        }
                    }
                    else if (value.ic === 'Country') {
                        if (_.includes(_this.filterIots, value.imt) &&
                            !_.includes(_this.filters.countries, value.country)) {
                            _this.filters.countries.push(value.country);
                        }
                    }
                });
            }
            else {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'IMT') {
                        _this.filters.imts.push(value.imt_name);
                    }
                    else if (value.ic === 'Country') {
                        _this.filters.countries.push(value.country);
                    }
                });
            }
            this.filters.imts.sort();
            this.filters.countries.sort();
        }
        else if (id === 'imt') {
            this.filterCountries = [];
            this.filters.countries = [];
            if (this.filterImts.length > 0) {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'Country') {
                        if (_.includes(_this.filterImts, value.imt_name) &&
                            !_.includes(_this.filters.countries, value.country)) {
                            _this.filters.countries.push(value.country);
                        }
                    }
                });
            }
            else {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'Country') {
                        _this.filters.countries.push(value.country);
                    }
                });
            }
        }
    };
    QueueController.prototype.getTeamView = function () {
        this.$state.go('team', {
            id: this.env.user.email
        });
    };
    QueueController.prototype.toggleFilter = function () {
        if (this.isFilterToggled) {
            this.applyFilter();
        }
        this.isFilterToggled = !this.isFilterToggled;
    };
    QueueController.prototype.applyActiveInactive = function (value) {
        this.activeInactive = value;
        this.applyFilter();
    };
    QueueController.prototype.setLastFilter = function () {
        var _this = this;
        //Update the User Profile's lastFilter object in session
        var lf = {};
        var filters = ['vapFilter', 'verFilter', 'goeFilter', 'filterErrors', 'filterSubStatuses', 'filterStatuses', 'filterOwners',
            'filterCountries', 'filterSviStatuses', 'filterTeams', 'filterImts', 'filterIots', 'selectedStates'];
        angular.forEach(filters, function (filter) {
            lf[filter] = _this[filter];
        });
        this.settings.up.lastFilter = lf;
    };
    QueueController.prototype.applyFilter = function () {
        if (this.filterSubStatuses.length ||
            this.filterTeams.length ||
            this.filterStatuses.length ||
            this.filterCountries.length ||
            this.filterOwners.length ||
            this.filterSviStatuses.length ||
            this.filterImts.length ||
            this.filterIots.length ||
            (angular.isDefined(this.filterErrors) && this.filterErrors.length) ||
            angular.isDefined(this.goeFilter) ||
            angular.isDefined(this.vapFilter) ||
            angular.isDefined(this.verFilter)) {
            this.isFilterSet = true;
        }
        else {
            this.isFilterSet = false;
        }
        this.setLastFilter(); //Set User Profile 'last filter' for session
        this.dtInstance.DataTable.ajax.reload();
    };
    QueueController.prototype.clearFilter = function () {
        this.isFilterSet = false;
        this.vapFilter = undefined; //was false
        this.verFilter = undefined;
        this.filterSubStatuses = [];
        this.filterStatuses = [];
        this.activeInactive = 'active';
        this.filterOwners = [];
        this.filterCountries = [];
        this.filterSviStatuses = [];
        this.selectedStates = [];
        this.filterTeams = [];
        this.filterImts = [];
        this.filterIots = [];
        this.filterErrors = [];
        this.filterPayFreq = [];
        this.goeFilter = undefined;
        this.dtInstance.DataTable.ajax.reload();
        delete this.settings.up.lastFilter; //Lose the last filter, too
    };
    QueueController.prototype.toggleInvite = function () {
        if (this.isInviteToggled) {
            this.applyFilter();
        }
        this.isInviteToggled = !this.isInviteToggled;
    };
    QueueController.prototype.toggleDownload = function () {
        this.isDownloading = true;
    };
    QueueController.prototype.toggleSetAsideDownload = function () {
        this.waitForReport = true;
        this.oncePressed = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'setAsideRepCSV',
                script: 'reporting/report-set-aside',
                user: this.env.user,
                filters: {
                    freq: this.filterPayFreq,
                    countryFilter: this.filterCountries,
                    iotFilter: this.filterIots,
                    imtFilter: this.filterImts,
                    columnFilter: this.getSearchColumnFilter(),
                    searchFilter: this.getSearchFilterValue()
                }
            }
        });
    };
    // TODO - combine this logic (UI part) with 'paymentFunctions.getSetAsideData()' (server side)
    QueueController.prototype.getSearchColumnFilter = function () {
        var result = {};
        var col;
        var colName;
        var colValue;
        var columns = this.dtColumns;
        for (var columnId in columns) {
            col = columns[columnId];
            colValue = col.columnSearch;
            if (colValue && colValue.trim() !== '') {
                if (col.sTitle === 'opptyNum' || col.name === 'opptyNum') {
                    colName = 'opptyNum';
                }
                else {
                    colName = col.mData.replace('doc.', '');
                    if (colName.trim() === '') {
                        colName = 'dateFreq';
                    }
                }
                result[colName] = colValue;
            }
        }
        return result;
    };
    QueueController.prototype.getSearchFilterValue = function () {
        //TODO - make it better
        return $('#table_filter input:first').val();
    };
    QueueController.prototype.saveFilter = function () {
        var filterFound = false;
        if (typeof this.userFilters !== 'undefined') {
            for (var i = 0; i < this.userFilters.length; i++) {
                if (this.userFilters[i].name === this.newSearch) {
                    filterFound = true;
                    this.userFilters[i].vapFilter = this.vapFilter;
                    this.userFilters[i].verFilter = this.verFilter;
                    this.userFilters[i].goeFilter = this.goeFilter;
                    this.userFilters[i].filterSubStatuses = this.filterSubStatuses;
                    this.userFilters[i].filterStatuses = this.filterStatuses;
                    this.userFilters[i].selectedStates = this.selectedStates;
                    this.userFilters[i].filterOwners = this.filterOwners;
                    this.userFilters[i].filterCountries = this.filterCountries;
                    this.userFilters[i].filterSviStatuses = this.filterSviStatuses;
                    this.userFilters[i].filterTeams = this.filterTeams;
                    this.userFilters[i].filterImts = this.filterImts;
                    this.userFilters[i].filterIots = this.filterIots;
                    this.userFilters[i].filterErrors = this.filterErrors;
                    break;
                }
            }
        }
        if (!filterFound) {
            var saveSearchObj = {};
            saveSearchObj.name = this.newSearch;
            saveSearchObj.vapFilter = this.vapFilter;
            saveSearchObj.verFilter = this.verFilter;
            saveSearchObj.filterSubStatuses = this.filterSubStatuses;
            saveSearchObj.filterStatuses = this.filterStatuses;
            saveSearchObj.filterOwners = this.filterOwners;
            saveSearchObj.selectedStates = this.selectedStates;
            saveSearchObj.filterCountries = this.filterCountries;
            saveSearchObj.filterSviStatuses = this.filterSviStatuses;
            saveSearchObj.filterTeams = this.filterTeams;
            saveSearchObj.filterImts = this.filterImts;
            saveSearchObj.filterIots = this.filterIots;
            saveSearchObj.filterErrors = this.filterErrors;
            saveSearchObj.goeFilter = this.goeFilter;
            if (typeof this.userFilters !== 'undefined') {
                this.userFilters.push(saveSearchObj);
            }
            else {
                this.userFilters = [saveSearchObj];
            }
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'SaveFilter',
                script: '/queueservice/filterprofiles',
                user: this.env.user,
                data: this.userFilters
            }
        });
    };
    QueueController.prototype.changeSavedFilter = function (filter) {
        this.currFilter = filter;
        this.filterIots = filter.filterIots;
        this.filterImts = filter.filterImts;
        this.filterCountries = filter.filterCountries;
        this.selectedStates = filter.selectedStates;
        this.filterSviStatuses = filter.filterSviStatuses;
        this.filterStatuses = filter.filterStatuses;
        this.filterSubStatuses = filter.filterSubStatuses;
        this.filterOwners = filter.filterOwners;
        this.filterTeams = filter.filterTeams;
        this.filterErrors = filter.filterErrors;
        this.vapFilter = filter.vapFilter;
        this.verFilter = filter.verFilter;
        this.goeFilter = filter.goeFilter;
    };
    QueueController.prototype.deleteProfile = function (profile) {
        //console.info(profile);
        this.allowed = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'deleteProfile',
                script: '/queueservice/filterprofiles',
                user: this.env.user.email,
                data: profile,
                token: this.env.user.token
            }
        });
    };
    //setaside queue
    QueueController.prototype.buildColumnsSetAside = function () {
        var that = this;
        return [this.DTColumnBuilder.newColumn('doc.ceid')
                .withTitle('CEID')
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.bpName')
                .withTitle('BP Name')
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.bpCountry')
                .withTitle('BP Country')
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.docCountry')
                .withTitle('Opportunity Country')
                .notSortable(),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Opportunity number')
                .withOption('width', '100%')
                .renderWith(function (data, type, full, meta) {
                var oneOpprty = that.items[meta.row].doc.docs;
                var opptyList = '';
                oneOpprty.forEach(function (el, i) {
                    opptyList += i === oneOpprty.length - 1 ? el.id : el.id + '<br>';
                });
                return opptyList;
            })
                .notSortable()
                .withOption('name', 'opptyNum'),
            this.DTColumnBuilder.newColumn('doc.payDateNFreq')
                .withTitle('Payment Date / Frequency')
                .notSortable(),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Bonus Amount')
                .withOption('searchable', false)
                .renderWith(function (data, type, full, meta) {
                return full.doc.amount + " " + full.doc.currency;
            })
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.docs.length')
                .withTitle('Documents')
                .withOption('searchable', false)
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.invsRequested')
                .withTitle('Requested')
                .withOption('searchable', false)
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.invsReceived')
                .withTitle('Received')
                .withOption('searchable', false)
                .notSortable(),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('')
                .notSortable()
                .withOption('searchable', false)
                .renderWith(this.buttonDetails)
                .withOption('className', 'details-control'),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('')
                .withOption('searchable', false)
                .notSortable()
                .renderWith(this.buttonPaid)
                .withOption('className', 'details-control'),
        ];
    };
    QueueController.prototype.buttonDetails = function (data, type, full, meta) {
        return "<md-button class=\"md-raised md-primary\" ng-click=\"vm.getDetails('" + meta.row + "')\" ng-disabled=\"vm.processing\">Details</md-button>";
    };
    QueueController.prototype.buttonPaid = function (data, type, full, meta) {
        return "<md-button class=\"md-raised md-primary\" ng-click=\"vm.setPaid('" + meta.row + "')\" ng-disabled=\"vm.processing\">Paid</md-button>";
    };
    QueueController.prototype.setPaid = function (rowId) {
        var _this = this;
        if (this.processing) {
            return;
        }
        // const oneItem = JSON.parse(rowId);
        var items = {
            docs: this.items[rowId].doc.docs.map(function (doc) {
                if (doc.invoice_flags && doc.invoice_flags.requested && doc.invoice_flags.received) {
                    return {
                        doc: doc.id,
                        value: true
                    };
                }
            })
                .filter(function (item) {
                return item !== undefined;
            })
        };
        if (items.docs.length === 0) {
            var items_1 = {
                icon: 'ERROR',
                message: 'No documents with invoice received flag.',
                title: 'Error'
            };
            this.Dialog.updateValidForm(undefined, items_1, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        this.Dialog.updateValidForm(undefined, items, 'setAside-documents_select.html').then(function (dResult) {
            _this.processing = true;
            var docs = [];
            dResult.docs.forEach(function (doc) {
                if (doc.value === true) {
                    docs.push(doc.doc);
                }
            });
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'setPaid',
                    data: {
                        docs: docs,
                        item: _this.items[rowId].doc
                    },
                    script: 'detail/payment/v1/payment',
                    email: _this.env.user.email,
                    token: _this.env.user.token
                }
            });
        });
    };
    QueueController.prototype.viewRecord = function (doc_id) {
        this.$state.go('detail.payment', {
            id: doc_id.substring(4)
        });
    };
    QueueController.prototype.getDetails = function (rowId) {
        var _this = this;
        if (this.processing) {
            return;
        }
        console.log(rowId);
        //const oneItem = JSON.parse(rowId);
        var items = {
            item: this.items[rowId],
            select: function (index) {
                _this.Dialog.$mdDialog.cancel();
                _this.viewRecord(_this.items[rowId].doc.docs[index].id); //this.items[rowId].docs[index].id);
            }
        };
        if (items.item.doc.docs.length === 0) {
            var items_2 = {
                icon: 'ERROR',
                message: 'No documents in this bucket.',
                title: 'Error'
            };
            this.Dialog.updateValidForm(undefined, items_2, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        this.Dialog.updateValidForm(undefined, items, 'setAside-details.html').then(function (dResult) {
            return;
        });
    };
    QueueController.prototype.getVersionLabel = function (ver) {
        switch (ver) {
            case 1:
            case 2:
                return 'CVR';
            default:
                return 'SWDR';
        }
    };
    QueueController.$inject = ['$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings', '$rootScope', 'topic', 'moment'];
    return QueueController;
}());
var QueueComponent = (function () {
    function QueueComponent() {
        this.templateUrl = 'queue.html';
        this.controllerAs = 'vm';
        this.controller = QueueController;
    }
    return QueueComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('collapse', '/public/icons/ic_expand_less_black_18px.svg')
        .icon('filter', '/public/icons/ic_filter_list_black_18px.svg')
        .icon('team', '/public/icons/ic_group_black_18px.svg')
        .icon('expand', '/public/icons/ic_expand_more_black_18px.svg')
        .icon('invitation', '/public/icons/ic_insert_invitation_black_18px.svg')
        .icon('download', 'public/icons/ic_cloud_download_black_18px.svg')
        .icon('forbidden', 'public/images/ic_do_not_disturb_alt_black_24px.svg')
        .icon('assignment', 'public/icons/ic_assignment_black_18px.svg');
})
    .component('queueSection', new QueueComponent());



var QueueErrorController = (function () {
    function QueueErrorController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, 
        //        private DTInstances:any,
        _, $compile, $state, $stateParams, notify, Dialog, settings, $mdDialog) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$mdDialog = $mdDialog;
        this.bookmark = 'bump';
        this.enableButtons = false;
        this.filterIots = [];
        this.filterImts = [];
        this.filterComboList = [];
        this.filterCurrCombo = [];
        this.filterCountries = [];
        this.filterSamplingStatus = [];
        this.filters = {
            countries: [],
            imts: [],
            iots: [],
            samplingStatus: []
        };
        this.socket.forward('validation.error.queue', this.$scope);
        this.$scope.$on('socket:validation.error.queue', function (event, data) {
            _this.enableButtons = true;
        });
        this.$scope.searchTable = function () {
            console.log($scope.tableInstance);
        };
    }
    QueueErrorController.prototype.$onInit = function () {
        this.queueLabel = 'Validation Queue';
        var that = this;
        /*        this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'getAllErroredQueues',
                        script: 'queue/queue',
                        email: this.env.user.email,
                    }
                });
        */
        this.dtColumns = this.buildColumns();
        this.dtOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', {
            dataSrc: function (data) {
                return data.data;
            },
            url: '/api/queue/valerror',
            type: 'POST',
            beforeSend: function (request) {
                request.setRequestHeader('Authorization', 'Bearer ' + that.env.user.token);
            },
            data: {}
        })
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withPaginationType('full_numbers');
    };
    /*
        buildColumns() {
            let titleHtml = `<input type="checkbox" ng-class="{'hide-dt-column': !vm.isMassAssignmentToggled}"
            ng-model="vm.selectAll" ng-click="vm.selectAllRowsInDataTable(vm.selectAll)" />`;
    
            let columns = [
                this.DTColumnBuilder.newColumn(null)
                    .withTitle(`<input type="checkbox" ng-class="{'hide-dt-column': !vm.isMassAssignmentToggled}"
                     ng-model="vm.selectAll" ng-click="vm.selectAllRowsInDataTable(vm.selectAll)" />`)
                    .notSortable()
                    .renderWith((data: any, type: any, full: any, meta: any) => {
                        //console.log('row data', data);
                        let obj = data._id + ',' +
                            data.INVOICEDAMOUNT + ',' +
                            data.WORKNUMBER.trim() + ',' +
                            data.WN_AMOUNT_LCL;
                        //console.log('Generated text: ', obj);
                        return `<input type="checkbox"
                                ng-class="{'hide-dt-column': !vm.isMassAssignmentToggled}"
                                ng-model="vm.checkBoxModel['${obj}']"/>`;
                    })
                    .withOption('name', 'assign-col')
                    .withOption('searchable', false),
                this.DTColumnBuilder.newColumn('CTRY_DESC').withTitle('Country'),
                this.DTColumnBuilder.newColumn('LOB').withTitle('LoB'),
                this.DTColumnBuilder.newColumn('LEGALCONNUM').withTitle('Legal Contract Number'),
                this.DTColumnBuilder.newColumn('CUST_NM').withTitle('Customer Name'),
                this.DTColumnBuilder.newColumn('WORKNUMBER').withTitle('Worknumber'),
                this.DTColumnBuilder.newColumn('PONUMBER').withTitle('PO Number'),
                this.DTColumnBuilder.newColumn('WN_AMOUNT_LCL').withTitle('Worknumber Amount'),
                this.DTColumnBuilder.newColumn('CUSTOMERCONTROL').withTitle('Customer Control').withOption('width', '15%'),
                this.DTColumnBuilder.newColumn('INVOICESTATUS').withTitle('Invoice Status').withOption('width', '15%'),
                this.DTColumnBuilder.newColumn('INVOICEDAMOUNT').withTitle('Invoice Amount')
                    .renderWith(data => {
                        return Math.round((data + 0.00001) * 100) / 100;
                    }),
                this.DTColumnBuilder.newColumn('CURRENCYID').withTitle('Currency'),
                this.DTColumnBuilder.newColumn('STARTDATE').withTitle('WN Start Date'),
                this.DTColumnBuilder.newColumn('ENDDATE').withTitle('WN End Date'),
                this.DTColumnBuilder.newColumn('INVOICENUMBER').withTitle('Invoice Number'),
                this.DTColumnBuilder.newColumn('INVOICEDATE').withTitle('Invoice Date').withOption('width', '100%')
            ];
    
            return columns;
    
        }
    
        */
    QueueErrorController.prototype.buildColumns = function () {
        var _this = this;
        var that = this;
        return [this.DTColumnBuilder.newColumn('ver').withTitle('Version')
                .withOption('name', 'ver')
                .renderWith(this.getVersionLabel)
                .notSortable(),
            this.DTColumnBuilder.newColumn('opp')
                .withTitle('OPP').renderWith(this.linkUrl),
            this.DTColumnBuilder.newColumn('svistat')
                .withTitle('MySA Status'),
            this.DTColumnBuilder.newColumn('country')
                .withTitle('Country'),
            this.DTColumnBuilder.newColumn('acnt')
                .withTitle('Account Name')
                .notSortable(),
            this.DTColumnBuilder.newColumn('bp')
                .withTitle('BP Name'),
            this.DTColumnBuilder.newColumn('acnt').withOption('name', 'acnt')
                .withTitle('Account Name'),
            this.DTColumnBuilder.newColumn('svisubmitdate')
                .withOption('name', 'svisubmitdate').withTitle('CVR Submit Date')
                .renderWith(function (data) {
                //return this.$filter('date')(new Date(parseInt(data, 10)), 'yyyy/MM/dd');
                if (data === null || data === 0) {
                    return 'N/A';
                }
                else {
                    return _this.$filter('date')(new Date(data), 'yyyy/MM/dd');
                }
            }),
            this.DTColumnBuilder.newColumn('decisiondate').withOption('name', 'decisiondate')
                .withTitle('Decision Date').renderWith(function (data) {
                //return this.$filter('date')(new Date(data.replace(/ /g, 'T')), 'yyyy/MM/dd');
                if (data === null || data === 0) {
                    return 'N/A';
                }
                else {
                    return _this.$filter('date')(new Date(data), 'yyyy/MM/dd');
                }
            }),
            this.DTColumnBuilder.newColumn('status').withTitle('Status'),
            this.DTColumnBuilder.newColumn('substatus')
                .withTitle('Sub Status'),
            this.DTColumnBuilder.newColumn('errQty')
                .withTitle('Error QTY'),
            this.DTColumnBuilder.newColumn('errorStat')
                .withTitle('Action').renderWith(this.resultHtml),
        ];
    };
    QueueErrorController.prototype.linkUrl = function (data, type, full, meta) {
        return '<a class="ibm-ind-link" href="detail/' + data + '/validation" ng-click="$event.preventDefault();vm.edit(' + meta.row + ')">' + data + '</a>';
    };
    QueueErrorController.prototype.resultHtml = function (data, type, full, meta) {
        if (data === 'Reject') {
            return "<p>" + data + "</p>\n                    <span>\n                        <md-icon class=\"expand\" md-svg-icon=\"expand\"></md-icon>\n                    </span>\n                    ";
        }
        else {
            return "<p>" + data + "</p> \n                    <md-icon class=\"yellow_icon\" md-svg-src=\"/public/images/ic_error_white_24px.svg\"></md-icon>";
        }
    };
    //                    <md-icon md-svg-icon="delete"></md-icon>
    //<md-icon class ="green_icon" md-svg-src="/public/images/ic_done_all_black_36px.svg" title="More than 15 days"> </md-icon>
    QueueErrorController.prototype.edit = function (index) {
        var rowData = this.dtInstance.DataTable.row(index).data();
        if (rowData.substatus === 'Unassigned') {
            this.$state.go('preview', {
                id: rowData.opp
            });
        }
        else {
            this.$state.go('detail.validation', {
                id: rowData.opp
            });
        }
    };
    QueueErrorController.prototype.getVersionLabel = function (ver) {
        switch (ver) {
            case 1:
            case 2:
                return 'CVR';
            case 3:
                return 'SWDR';
            default:
                return '';
        }
    };
    QueueErrorController.$inject = [
        '$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings', '$mdDialog'
    ];
    return QueueErrorController;
}());
var QueueErrorComponent = (function () {
    function QueueErrorComponent() {
        this.templateUrl = 'queueerror.html';
        this.controllerAs = 'vm';
        this.controller = QueueErrorController;
    }
    return QueueErrorComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('expand', '/public/icons/ic_expand_more_black_18px.svg');
})
    .component('queueErrorSection', new QueueErrorComponent());



var QueueSamplingController = (function () {
    function QueueSamplingController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, notify, Dialog, settings, $mdDialog) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$mdDialog = $mdDialog;
        this.showFilterBtn = false;
        this.filterIots = [];
        this.goeFilter = false;
        this.verFilter = undefined;
        this.solDecFilter = 'all';
        this.filterImts = [];
        this.filterComboList = [];
        this.filterCurrCombo = [];
        this.filterCountries = [];
        this.selectedStates = [];
        this.USstates = [];
        this.filterSolutionSamplStatus = [];
        this.filterSSASamplStatus = [];
        this.filters = {
            USstates: [],
            countries: [],
            imts: [],
            iots: [],
            samplingStatus: []
        };
        this.sampReason = '';
        this.reportIsBeingBuilt = false;
        this.isFilterToggled = false;
        this.addSampArray = [];
        this.statusChange = '';
        this.dtInstance = {};
        this.queryId = this.$stateParams.id;
        this.deferred = this.$q.defer();
        this.enableButtons = false;
        this.socket.forward('sampling.additional.list', this.$scope);
        this.$scope.$on('socket:sampling.additional.list', function (event, data) {
            _this.isSubmitting = true;
            _this.addSampArray = data;
            _this.filterArray = _this.addSampArray.slice();
            _this.resetFilterLists();
            _this.filterCurrCombo = _this.filterComboList.slice();
            _this.queueDetails(event, _this.filterArray);
            _this.enableButtons = true;
        });
        this.socket.forward('queue.sampling.createSamplingExcel', this.$scope);
        this.$scope.$on('socket:queue.sampling.createSamplingExcel', function (event, data) {
            _this.reportIsBeingBuilt = false;
            if (!data.payload.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.payload], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-Sampling-Report_" + d + ".xlsx");
                a.click();
            }
        });
        this.socket.forward('addsampling.done', this.$scope);
        this.$scope.$on('socket:addsampling.done', function (event, data) {
            for (var i = 0; i < _this.addSampArray.length; i++) {
                if (_this.addSampArray[i].opp === _this.currOppty) {
                    _this.addSampArray[i].samplingStatus = _this.statusChange;
                    break;
                }
            }
            for (var i = 0; i < _this.filterArray.length; i++) {
                if (_this.filterArray[i].opp === _this.currOppty) {
                    _this.filterArray[i].samplingStatus = _this.statusChange;
                    break;
                }
            }
            _this.dtInstance.changeData(function () {
                return _this.getData(null);
            });
            _this.dtInstance.reload();
            _this.queueDetails(event, _this.filterArray);
            if (data.success === true) {
                _this.enableButtons = true;
            }
        });
    }
    QueueSamplingController.prototype.$onInit = function () {
        this.loadInitialSamplingData();
    };
    QueueSamplingController.prototype.loadInitialSamplingData = function () {
        this.samplingPage = true;
        this.queueLabel = 'Sampling Queue';
        this.filterToggles = {
            countries: true,
            goe: true,
            imts: true,
            sampStat: true,
            solutionDecision: true
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                email: this.env.user.email,
                function: 'getPotentialSampling',
                script: 'queue/queue',
                token: this.env.user.token
            }
        });
        this.isSubmitting = false;
        this.dtColumns = this.buildColumns();
        this.buildOptions();
    };
    QueueSamplingController.prototype.buildOptions = function () {
        var _this = this;
        var that = this;
        this.dtOptions = {};
        this.dtOptions = this.DTOptionsBuilder
            .fromFnPromise(function () {
            return _this.getData(null);
        })
            .withPaginationType('full_numbers')
            .withOption('processing', true)
            .withOption('createdRow', createdRow);
        function createdRow(row, data, dataIndex) {
            var OFFSET = 3;
            var thresholdDate = new Date();
            thresholdDate.setHours(0, 0, 0, 0);
            thresholdDate.setDate(thresholdDate.getDate() - OFFSET);
            var createdOn = new Date(parseInt(data.created));
            createdOn.setHours(0, 0, 0, 0);
            if (createdOn <= thresholdDate && data.substatus === 'Unassigned') {
                $(row).addClass('tblRow').css('background-color', '#ff5252');
            }
            else {
                $(row).addClass('tblRow');
            }
            var el = angular.element;
            that.$compile(el(row).contents())(that.$scope);
        }
    };
    QueueSamplingController.prototype.buildColumns = function () {
        return [
            this.DTColumnBuilder.newColumn('ver').withTitle('Version').withOption('name', 'ver')
                .renderWith(this.getVersionLabel)
                .notSortable(),
            this.DTColumnBuilder.newColumn('opp')
                .withTitle('Opp Number')
                .renderWith(this.linkUrl),
            this.DTColumnBuilder.newColumn('country').withOption('name', 'country')
                .withTitle('Country'),
            this.DTColumnBuilder.newColumn('goe').withOption('name', 'goe')
                .withTitle('GE Flag'),
            this.DTColumnBuilder.newColumn('bp_name')
                .withTitle('BP'),
            this.DTColumnBuilder.newColumn('acctname')
                .withTitle('Account'),
            this.DTColumnBuilder.newColumn('status')
                .withTitle('Status'),
            this.DTColumnBuilder.newColumn('sub_status')
                .withTitle('Sub-status'),
            this.DTColumnBuilder.newColumn('samplingStatus_ssa').withOption('name', 'samplingStatus_ssa')
                .withTitle('SSA Sampling Status'),
            this.DTColumnBuilder.newColumn('samplingStartDate_ssa').withOption('name', 'samplingStartDate_ssa')
                .withTitle('SSA Sampling Start Date'),
            this.DTColumnBuilder.newColumn('samplingStatus_solution').withOption('name', 'samplingStatus_solution')
                .withTitle('Solution Sampling Status'),
            this.DTColumnBuilder.newColumn('samplingStartDate_solution')
                .withTitle('Solution Sampling Start Date'),
            this.DTColumnBuilder.newColumn('aging')
                .withTitle('Aging'),
            this.DTColumnBuilder.newColumn('soNumber')
                .withTitle('SO Number'),
            this.DTColumnBuilder.newColumn('soDate')
                .withTitle('SO Date'),
            this.DTColumnBuilder.newColumn('solutionDecision').withOption('name', 'solutionDecision')
                .withTitle('SSA/Solution flag'),
            this.DTColumnBuilder.newColumn('state').withOption('name', 'state')
                .withTitle('State')
                .renderWith(this.showState),
        ];
    };
    QueueSamplingController.prototype.linkUrl = function (data, type, full, meta) {
        return "<a class='ibm-ind-link' href='detail/" + data + "/sampling' ng-click='$event.preventDefault();vm.sampEdit(\"" + data + "\")'>" + data + "</a>";
    };
    QueueSamplingController.prototype.showState = function (data, type, full, meta) {
        if (full.country === 'USA') {
            return "<p>" + data + "<p>";
        }
        else {
            return "<p> -- <p>";
        }
    };
    QueueSamplingController.prototype.linkButton = function (data, type, full, meta) {
        switch (full.samplingStatus) {
            case 'untested':
            case 'Manual override':
                return '<md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.sampActivate(' + meta.row + ')" ng-disabled="(!vm.enableButtons)">Activate</md-button>'; //' + meta.row + '
            case 'Manually sampled - In Progress':
                return '<md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.sampDeactivate(' + meta.row + ')" ng-disabled="(!vm.enableButtons)">Deactivate</md-button>';
            default:
                return '<p></p>';
        }
    };
    QueueSamplingController.prototype.downloadSamplingReport = function () {
        this.reportIsBeingBuilt = true;
        var filters = {
            filterCountries: this.filterCountries,
            filterImts: this.filterImts,
            filterIots: this.filterIots,
            goeFilter: this.goeFilter,
            verFilter: this.verFilter,
            filterSolutionSamplStatus: this.filterSolutionSamplStatus,
            filterSSASamplStatus: this.filterSSASamplStatus,
            selectedStates: this.selectedStates
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                email: this.env.user.email,
                function: 'downloadSampling',
                script: 'sampling/downloadSampling',
                filters: filters,
                token: this.env.user.token
            }
        });
    };
    QueueSamplingController.prototype.sampManipulate = function (oppty) {
        this.enableButtons = false;
        var rowData = this.dtInstance.DataTable.row(oppty).data();
        this.currOppty = rowData.opp;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    cty: rowData.country,
                    goe: rowData.goe,
                    initBy: this.env.user.email,
                    opp: rowData.opp,
                    program: this.topic.topic.program,
                    sampComment: {
                        comment: rowData.samplingStatus + " changed to " + this.statusChange,
                        source: this.env.user.email,
                        time: (new Date()).getTime()
                    },
                    sampReason: this.sampReason,
                    status: this.statusChange,
                    timestamp: (new Date()).getTime()
                },
                email: this.env.user.email,
                token: this.env.user.token,
                function: 'addActivateSampling',
                script: 'queue/queue'
            }
        });
    };
    QueueSamplingController.prototype.sampEdit = function (index) {
        this.$state.go('detail.sampling', {
            id: index
        });
    };
    // getting the data
    QueueSamplingController.prototype.getData = function (args) {
        return this.deferred.promise;
    };
    // manipulating the data
    QueueSamplingController.prototype.queueDetails = function (ev, data) {
        this.deferred.resolve(data);
    };
    QueueSamplingController.prototype.toggleFilter = function () {
        this.isFilterToggled = !this.isFilterToggled;
    };
    QueueSamplingController.prototype.applysolDecFilter = function (el) {
        if (el === 'Solution' || el === 'SSA') {
            this.dtInstance.DataTable.column('solutionDecision:name').search(el, true, false).draw();
        }
        else {
            this.loadInitialSamplingData();
        }
    };
    QueueSamplingController.prototype.applyFilter = function () {
        var _this = this;
        //TODO - double check it
        this.addSampArray = this.addSampArray.filter(function (sampElem) { return sampElem.samplingStatus; });
        var filterList = {
            iot: this.filterIots,
            imt: this.filterImts,
            country: this.filterCountries,
            state: this.selectedStates
        };
        var samplingFilterKeys = [];
        _.forEach(filterList, function (selectedFilters, key) {
            if (selectedFilters.length > 0) {
                _this.filterArray = [];
                samplingFilterKeys.push(key);
                selectedFilters.forEach(function (filter) {
                    _this.filterArray = _this.filterArray.concat(_this.addSampArray.filter(function (sampElem) { return sampElem[key] === filter; }));
                });
            }
        });
        this.isFilterSet = (samplingFilterKeys.length > 0 || this.goeFilter || typeof this.verFilter !== 'undefined');
        if (this.isFilterSet) {
            this.filterArray = this.addSampArray.slice();
        }
        //Ver filter
        this.dtInstance.DataTable.column('ver:name').search(this.getVersionLabel(this.verFilter), true, false).draw();
        // GOE filter
        this.dtInstance.DataTable.column('goe:name').search((this.goeFilter ? 'Yes' : ''), true, false).draw();
        // Solution Sampling Status filter
        var solStFltr = this.filterSolutionSamplStatus;
        var solStFltrRegeXp = (Array.isArray(solStFltr) && solStFltr.length > 0) ? solStFltr.join('|') : '';
        this.dtInstance.DataTable.column('samplingStatus_solution:name').search(solStFltrRegeXp, true, false).draw();
        // SSA Sampling Status filter
        var ssaStFltr = this.filterSSASamplStatus;
        var ssaStFltrRegExp = (Array.isArray(ssaStFltr) && ssaStFltr.length > 0) ? ssaStFltr.join('|') : '';
        this.dtInstance.DataTable.column('samplingStatus_ssa:name').search(ssaStFltrRegExp, true, false).draw();
        // IOT, IMT and Country filters
        var samplingFilterResult = [];
        //GEO keys - the order is important
        var orderedGeoKeys = ['iot', 'imt', 'country'];
        this.filterArray.forEach(function (elem) {
            if (samplingFilterKeys.includes('state')) {
                if (!samplingFilterResult.includes(elem.state)) {
                    samplingFilterResult.push(elem.state);
                }
            }
            else if (orderedGeoKeys.some(function (filter) { return samplingFilterKeys.includes(filter); })) {
                //process the smallest geo filter only
                var smallestGeoKey_1 = orderedGeoKeys.filter(function (geo) { return samplingFilterKeys.indexOf(geo) !== -1; }).pop();
                if (smallestGeoKey_1) {
                    //samplingFilterKeys.forEach((key) => {
                    if (elem[smallestGeoKey_1] && filterList[smallestGeoKey_1] && filterList[smallestGeoKey_1].filter(function (it) { return it === elem[smallestGeoKey_1]; }).length > 0) {
                        if (!samplingFilterResult.includes(elem.country)) {
                            samplingFilterResult.push(elem.country);
                        }
                    }
                }
            }
        });
        var tableSearchRegExp = (samplingFilterResult.length > 0) ? samplingFilterResult.join('|') : '';
        this.dtInstance.DataTable.search(tableSearchRegExp, true, false).draw();
        // State filter
        var stateRegExp = samplingFilterKeys.includes('state') ? samplingFilterResult.join('|') : '';
        this.dtInstance.DataTable.column('state:name').search(stateRegExp, true, false).draw();
    };
    QueueSamplingController.prototype.resetFilterLists = function () {
        for (var i = 0; i < this.addSampArray.length; i++) {
            if (this.filters.iots.indexOf(this.addSampArray[i].iot) < 0) {
                this.filters.iots.push(this.addSampArray[i].iot);
            }
            if (this.filters.imts.indexOf(this.addSampArray[i].imt) < 0) {
                this.filters.imts.push(this.addSampArray[i].imt);
            }
            if (this.filters.countries.indexOf(this.addSampArray[i].country) < 0) {
                this.filters.countries.push(this.addSampArray[i].country);
                var listItem = {
                    goe: this.addSampArray[i].goe,
                    imt: this.addSampArray[i].imt,
                    country: this.addSampArray[i].country,
                    state: this.addSampArray[i].country
                };
                this.filterComboList.push(listItem);
            }
            if (this.addSampArray[i].country === 'USA' && this.USstates.indexOf(this.addSampArray[i].state) < 0) {
                this.USstates.push(this.addSampArray[i].state);
            }
            this.filters.samplingStatus = [
                'Manually sampled - Failed',
                'Manually sampled - Passed',
                'Manual override',
                'Passed',
                'Failed',
                'In progress'
            ];
        }
        this.filters.imts.sort();
        this.filters.countries.sort();
        this.filters.iots.sort();
    };
    QueueSamplingController.prototype.clearFilter = function () {
        this.isFilterSet = false;
        this.goeFilter = false;
        this.filterImts = [];
        this.filterIots = [];
        this.filterCountries = [];
        this.filterSolutionSamplStatus = [];
        this.filterSSASamplStatus = [];
        this.resetFilterLists();
        this.loadInitialSamplingData();
    };
    QueueSamplingController.prototype.changeFilters = function (id) {
        var _this = this;
        if (id === 'goeFilter') {
            this.showFilterBtn = true;
        }
        if (id === 'goe') {
            this.filterImts = [];
            this.filterCountries = [];
            this.filters.imts = [];
            this.filters.countries = [];
            if (this.filterIots.length === 0) {
                for (var i = 0; i < this.filterComboList.length; i++) {
                    if (this.filters.imts.indexOf(this.filterComboList[i].imt) < 0) {
                        this.filters.imts.push(this.filterComboList[i].imt);
                    }
                    if (this.filters.countries.indexOf(this.filterComboList[i].country) < 0) {
                        this.filters.countries.push(this.filterComboList[i].country);
                    }
                }
            }
            else {
                for (var i = 0; i < this.filterComboList.length; i++) {
                    if (this.filterIots.indexOf(this.filterComboList[i].goe) > -1 && this.filters.imts.indexOf(this.filterComboList[i].imt) < 0) {
                        this.filters.imts.push(this.filterComboList[i].imt);
                    }
                    if (this.filterIots.indexOf(this.filterComboList[i].goe) > -1 && this.filters.countries.indexOf(this.filterComboList[i].country) < 0) {
                        this.filters.countries.push(this.filterComboList[i].country);
                    }
                }
            }
        }
        else if (id === 'imt') {
            this.filterCountries = [];
            this.filters.countries = [];
            if (this.filterImts.length === 0) {
                for (var i = 0; i < this.filterComboList.length; i++) {
                    if (this.filters.countries.indexOf(this.filterComboList[i].country) < 0) {
                        this.filters.countries.push(this.filterComboList[i].country);
                    }
                }
            }
            else {
                for (var i = 0; i < this.filterComboList.length; i++) {
                    if (this.filterImts.indexOf(this.filterComboList[i].imt) > -1 && this.filters.countries.indexOf(this.filterComboList[i].country) < 0) {
                        this.filters.countries.push(this.filterComboList[i].country);
                    }
                }
            }
        }
        else if (id === 'iot') {
            this.filterImts = [];
            this.filterCountries = [];
            this.filters.imts = [];
            this.filters.countries = [];
            if (this.filterIots.length > 0) {
                this.settings.country_list.forEach(function (value) {
                    if (value.ic === 'IMT') {
                        if (_.includes(_this.filterIots, value.imt) &&
                            !_.includes(_this.filters.imts, value.imt_name)) {
                            _this.filters.imts.push(value.imt_name);
                        }
                    }
                    else if (value.ic === 'Country') {
                        if (_.includes(_this.filterIots, value.imt) &&
                            !_.includes(_this.filters.countries, value.country)) {
                            _this.filters.countries.push(value.country);
                        }
                    }
                });
            }
            else {
                this.settings.country_list.forEach(function (value) {
                    if (value.ic === 'IMT') {
                        _this.filters.imts.push(value.imt_name);
                    }
                    else if (value.ic === 'Country') {
                        _this.filters.countries.push(value.country);
                    }
                });
            }
        }
        this.showFilterBtn = true;
    };
    QueueSamplingController.prototype.getVersionLabel = function (ver) {
        switch (ver) {
            case 0:
                return 'CVR|SWDR';
            case 1:
            case 2:
                return 'CVR';
            case 3:
                return 'SWDR';
            default:
                return '';
        }
    };
    QueueSamplingController.$inject = ['$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings', '$mdDialog', 'topic'];
    return QueueSamplingController;
}());
var QueueSamplingComponent = (function () {
    function QueueSamplingComponent() {
        this.templateUrl = 'queueSampling.html';
        this.controllerAs = 'vm';
        this.controller = QueueSamplingController;
    }
    return QueueSamplingComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('clearAll', '/public/icons/ic_clear_all_black_18px.svg');
})
    .component('queueSamplingSection', new QueueSamplingComponent());



/**
 * Created by Roman T on 4/12/2017.
 */
var QueueSapMissingController = (function () {
    function QueueSapMissingController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, notify, Dialog, settings, $mdDialog, filters) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$mdDialog = $mdDialog;
        this.filters = filters;
        this.newSearch = 'Default';
        this.removedOpps = [];
        this.triggeredOpps = [];
        this.isDownloading = false;
        this.isFilterSet = false;
        this.isFilterToggled = false;
        this.wasSapTriggered = false;
        this.showFilterBtn = false;
        this.removedOpps = [];
        this.triggeredOpps = [];
        this.rowData = {};
        this.dtInstance = {};
        this.tableData = {};
        this.filterSubStatuses = [];
        this.filterStatuses = [];
        this.filterCountries = [];
        this.filterIots = [];
        this.filterImts = [];
        this.filterActive = true;
        this.goeFilter = undefined;
        this.filters = {};
        this.deferred = this.$q.defer();
        this.filterDetails();
        this.socket.forward('sap.missing.update.done', this.$scope);
        this.$scope.$on('socket:sap.missing.update.done', function (event, data) {
            _this.dtInstance.DataTable.ajax.reload(function () {
                _this.removedOpps = [];
            }, false);
        });
        this.socket.forward('sap.missing.update.failed', this.$scope);
        this.$scope.$on('socket:sap.missing.update.failed', function (event, data) {
            _this.triggeredOpps.pop();
            _this.dtInstance.DataTable.ajax.reload(null, false);
        });
        this.socket.forward('filters.getUserFilters', this.$scope);
        this.$scope.$on('socket:filters.getUserFilters', function (event, data) {
            _this.userFilters = data;
        });
        this.socket.forward('filters.deleteProfiles', this.$scope);
        this.$scope.$on('socket:filters.deleteProfiles', function (event, data) {
            _this.userFilters = data;
            _this.allowed = false;
        });
    }
    QueueSapMissingController.prototype.$onInit = function () {
        var _this = this;
        var that = this;
        this.queueLabel = 'SAP Missing';
        this.queryId = 'sap-missing';
        this.dtColumns = this.buildColumns();
        this.removedOpps = [];
        this.triggeredOpps = [];
        this.filterToggles = {
            countries: true,
            dmtStats: true,
            dmtSubStats: true,
            goe: true,
            imts: true,
            iots: true
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'FetchSavedFilters',
                script: '/queueservice/filterprofiles',
                user: this.env.user
            }
        });
        this.applyLastFilter();
        this.dtOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', {
            dataSrc: function (data) {
                that.tableData = data.data;
                return data.data;
            },
            url: '/api/queue/sapmissing',
            type: 'POST',
            beforeSend: function (request) {
                request.setRequestHeader('Authorization', 'Bearer ' + _this.env.user.token);
            },
            data: function (d, callback, settings) {
                d.iotFilter = that.filterIots;
                d.imtFilter = that.filterImts;
                d.queueType = that.queryId;
                d.goeFilter = that.goeFilter;
                d.activeFilter = that.filterActive;
                d.users = [("" + that.env.user.email)];
                d.countryFilter = that.filterCountries;
                d.statusFilter = that.filterStatuses;
                d.substatusFilter = that.filterSubStatuses;
            },
            complete: function (d) {
                _this.wasSapTriggered = false;
            }
        })
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('createdRow', createdRow)
            .withPaginationType('full_numbers');
        function createdRow(row, data, dataIndex) {
            var OFFSET = 3;
            var thresholdDate = new Date();
            thresholdDate.setHours(0, 0, 0, 0);
            thresholdDate.setDate(thresholdDate.getDate() - OFFSET);
            var createdOn = new Date(parseInt(data.created));
            createdOn.setHours(0, 0, 0, 0);
            if (createdOn <= thresholdDate && data.substatus === 'Unassigned') {
                $(row).addClass('tblRow').css('background-color', '#ff5252');
            }
            else {
                $(row).addClass('tblRow');
            }
            var el = angular.element;
            that.$compile(el(row).contents())(that.$scope);
        }
    };
    QueueSapMissingController.prototype.buildColumns = function () {
        return [
            this.DTColumnBuilder.newColumn('soNumber')
                .withTitle('SAP'),
            this.DTColumnBuilder.newColumn('invoiceNo')
                .withTitle('Invoice Number'),
            this.DTColumnBuilder.newColumn('country')
                .withTitle('Country'),
            this.DTColumnBuilder.newColumn('opps')
                .withTitle('OPP').renderWith(this.listOpptys),
            this.DTColumnBuilder.newColumn('soDate')
                .withTitle('SO Date')
                .renderWith(this.soDates),
            this.DTColumnBuilder.newColumn('oppsParams')
                .withTitle('Submit date for payment')
                .renderWith(this.listPaymentDates),
            this.DTColumnBuilder.newColumn('oppsParams')
                .withTitle('Status')
                .renderWith(this.listStatuses),
            this.DTColumnBuilder.newColumn('oppsParams')
                .withTitle('SubStatus')
                .renderWith(this.listSubstatuses),
            this.DTColumnBuilder.newColumn('oppsParams')
                .withTitle('Government Flag')
                .renderWith(this.listGOEs),
            this.DTColumnBuilder.newColumn('retriger')
                .withTitle('Retriger').renderWith(this.resultDisplay).notSortable()
        ];
    };
    QueueSapMissingController.prototype.resultDisplay = function (data, type, full, meta) {
        if (data.disable_in_missing_q === 'undefined' || !data.disable_in_missing_q) {
            data.disable_in_missing_q = false;
        }
        if (typeof data.isResolved === 'undefined' || !data.isResolved) {
            return "\n            <md-button ng-disabled=\"vm.removedOpps.indexOf(" + meta.row + ") > -1 || vm.triggeredOpps.indexOf(" + meta.row + ") > -1||  vm.wasSapTriggered || " + data.disable_in_missing_q + "\" class=\"md-raised md-primary\" ng-click=\"vm.retrigSAP(" + meta.row + ")\">Retrigger</md-button>\n            <md-button ng-disabled= \"vm.removedOpps.indexOf(" + meta.row + ") > -1 || vm.triggeredOpps.indexOf(" + meta.row + ") > -1 || vm.wasSapTriggered || " + data.disable_in_missing_q + "\" class=\"md-raised md-primary\" ng-click=\"vm.removeBtn(" + meta.row + ")\">Remove</md-button>  ";
        }
        else if (data.isResolved === 'processing') {
            return "<p>Loading...</p>";
        }
        else {
            return "<p>Already processed</p>";
        }
    };
    QueueSapMissingController.prototype.removeBtn = function (rowId) {
        var _this = this;
        var obj = {
            user_activity: {
                user: this.env.user.email,
                timestamp: Date.now(),
                action: ''
            },
            affectedOpp: this.tableData[rowId]
        };
        this.Dialog.updateValidForm(undefined, obj, 'sap-missing-remove-btn.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.removedOpps.push(rowId);
                obj.user_activity.action = 'Clicked the Remove button - reason: ' + dResult.action;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'removeBtnMissingSO',
                        script: 'validation/validationTables',
                        email: _this.env.user.email,
                        data: obj,
                        user: {
                            access: _this.env.user.access,
                            email: _this.env.user.email,
                            token: _this.env.user.token
                        }
                    }
                });
            }
        });
    };
    QueueSapMissingController.prototype.retrigSAP = function (rowId) {
        this.rowData = this.dtInstance.DataTable.row(rowId).data();
        this.rowData.retriger.isResolved = 'processing';
        this.dtInstance.DataTable.row(rowId).data(this.rowData).invalidate();
        this.wasSapTriggered = true;
        this.triggeredOpps.push(rowId);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'validateMissingSAP',
                script: 'validation/validationTables',
                email: this.env.user.email,
                data: this.rowData,
                allIDs: this.rowData.allIDs,
                token: this.env.user.token
            }
        });
    };
    QueueSapMissingController.prototype.listOpptys = function (opps, type, full, meta) {
        var htmlText = '';
        if (this.env.user.access.systemAdmin && !full.isResolved) {
            opps.forEach(function (opp) {
                htmlText += "<li>" + opp + "<md-button aria-label=\"update\" ng-click=\"vm.editOppty('" + meta.row + "&" + opp + "')\"><md-icon class=\"black_icon\" md-svg-icon=\"/public/images/wrench.svg\"></md-icon></md-button></li>";
            });
        }
        else {
            opps.forEach(function (opp) {
                htmlText += "<li>" + opp + "</li>";
            });
        }
        return htmlText;
    };
    QueueSapMissingController.prototype.listValues = function (data, type, full, meta) {
        var htmlText = '';
        data.forEach(function (el) {
            htmlText += "<li>" + el + "</li>";
        });
        return htmlText;
    };
    QueueSapMissingController.prototype.listPaymentDates = function (data, type, full, meta) {
        var htmlText = '';
        var ov = Object.keys(data).map(function (key) { return data[key]; });
        var values = ov.map(function (el) {
            return el.paymentDate ? el.paymentDate : 'N/A';
        });
        values.forEach(function (el) {
            htmlText += "<li>" + el + "</li>";
        });
        return htmlText;
    };
    QueueSapMissingController.prototype.listStatuses = function (data, type, full, meta) {
        var htmlText = '';
        var ov = Object.keys(data).map(function (key) { return data[key]; });
        var values = ov.map(function (el) {
            return el.status ? el.status : 'N/A';
        });
        values.forEach(function (el) {
            htmlText += "<li>" + el + "</li>";
        });
        return htmlText;
    };
    QueueSapMissingController.prototype.listSubstatuses = function (data, type, full, meta) {
        var htmlText = '';
        var ov = Object.keys(data).map(function (key) { return data[key]; });
        var values = ov.map(function (el) {
            return el.substatus ? el.substatus : 'N/A';
        });
        values.forEach(function (el) {
            htmlText += "<li>" + el + "</li>";
        });
        return htmlText;
    };
    QueueSapMissingController.prototype.soDates = function (data, type, full, meta) {
        if (/\d{8}/.test(data)) {
            return data.substring(6, 8) + '.' + data.substring(4, 6) + '.' + data.substring(0, 4);
        }
        else if (/\d{4}-\d{2}-\d{2}/.test(data)) {
            return data.split('-')[2] + '.' + data.split('-')[1] + '.' + data.split('-')[0];
        }
        else {
            return data;
        }
    };
    QueueSapMissingController.prototype.listGOEs = function (data, type, full, meta) {
        var htmlText = '';
        var ov = Object.keys(data).map(function (key) { return data[key]; });
        var values = ov.map(function (el) {
            return el.goe ? el.goe : 'N/A';
        });
        values.forEach(function (el) {
            htmlText += "<li>" + el + "</li>";
        });
        return htmlText;
    };
    QueueSapMissingController.prototype.editOppty = function (rowData) {
        var _this = this;
        console.log(this.env.user.access.systemAdmin);
        var oneData;
        var oldOpp;
        if (isNaN(rowData)) {
            oneData = rowData.split('&')[0];
            oldOpp = rowData.split('&')[1];
        }
        else {
            oneData = rowData;
            oldOpp = '';
        }
        var items = { affectedOpp: this.tableData[oneData], oldOpp: oldOpp, newOppty: '' };
        this.Dialog.updateValidForm(undefined, items, 'sap-missing-oppty-edit.html').then(function (dResult) {
            if (dResult.confirm) {
                items.newOppty = dResult.newOppty;
                for (var oppLn in items.affectedOpp.itemList) {
                    if (items.affectedOpp.itemList[oppLn].opp === oldOpp) {
                        items.affectedOpp.itemList[oppLn].opp = dResult.newOppty;
                    }
                }
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'updateMissingSO',
                        script: 'validation/validationTables',
                        email: _this.env.user.email,
                        data: items,
                        user: {
                            access: _this.env.user.access,
                            email: _this.env.user.email,
                            token: _this.env.user.token
                        }
                    }
                });
            }
        });
    };
    QueueSapMissingController.prototype.toggleDownload = function () {
        this.isDownloading = true;
    };
    QueueSapMissingController.prototype.filterDetails = function () {
        var _this = this;
        this.env.topics.imtFilterValues = this.settings.country_list;
        this.filters.iots = this.settings.iot_list;
        this.filters.imts = this.settings.imt_list;
        this.filters.countries = this.settings.getCountryList();
        this.filters.iots.sort();
        this.filters.imts.sort();
        this.filters.countries.sort();
        this.env.topics.imtFilterValues.forEach(function (value) {
            if (value.ic === 'IOT') {
                if (!_.includes(_this.filters.iots, value.imt)) {
                    _this.filters.iots.push(value.imt);
                }
            }
            else if (value.ic === 'IMT') {
                if (!_.includes(_this.filters.imts, value.imt_name)) {
                    _this.filters.imts.push(value.imt_name);
                }
            }
            else {
                if (!_.includes(_this.filters.countries, value.country)) {
                    _this.filters.countries.push(value.country);
                }
            }
        });
        this.filters.statuses = this.settings.statuses;
        this.filters.subStatuses = this.settings.substatuses;
        this.showFilterBtn = true;
    };
    QueueSapMissingController.prototype.changeFilters = function (id) {
        var _this = this;
        if (id === 'iot') {
            this.filterImts = [];
            this.filterCountries = [];
            this.filters.imts = [];
            this.filters.countries = [];
            if (this.filterIots.length > 0) {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'IMT') {
                        if (_.includes(_this.filterIots, value.imt) &&
                            !_.includes(_this.filters.imts, value.imt_name)) {
                            _this.filters.imts.push(value.imt_name);
                        }
                    }
                    else if (value.ic === 'Country') {
                        if (_.includes(_this.filterIots, value.imt) &&
                            !_.includes(_this.filters.countries, value.country)) {
                            _this.filters.countries.push(value.country);
                        }
                    }
                });
            }
            else {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'IMT') {
                        _this.filters.imts.push(value.imt_name);
                    }
                    else if (value.ic === 'Country') {
                        _this.filters.countries.push(value.country);
                    }
                });
            }
            this.filters.imts.sort();
            this.filters.countries.sort();
        }
        else if (id === 'imt') {
            this.filterCountries = [];
            this.filters.countries = [];
            if (this.filterImts.length > 0) {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'Country') {
                        if (_.includes(_this.filterImts, value.imt_name) &&
                            !_.includes(_this.filters.countries, value.country)) {
                            _this.filters.countries.push(value.country);
                        }
                    }
                });
            }
            else {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'Country') {
                        _this.filters.countries.push(value.country);
                    }
                });
            }
        }
    };
    QueueSapMissingController.prototype.applyLastFilter = function () {
        var _this = this;
        //If there is a lastFilter element in user's profile (in browser), set the
        // filters accordingly and apply them rather than loading the default (all)
        if (this.settings.up.lastFilter) {
            angular.forEach(this.settings.up.lastFilter, function (v, k) {
                _this[k] = v;
            });
            this.isFilterToggled = true;
        }
    };
    QueueSapMissingController.prototype.setLastFilter = function () {
        var _this = this;
        //Update the User Profile's lastFilter object in session
        var lf = {};
        var filters = ['goeFilter', 'filterActive', 'filterSubStatuses', 'filterStatuses', 'filterCountries', 'filterImts', 'filterIots'];
        angular.forEach(filters, function (filter) {
            lf[filter] = _this[filter];
        });
        this.settings.up.lastFilter = lf;
    };
    QueueSapMissingController.prototype.applyFilter = function () {
        if (this.filterSubStatuses.length ||
            this.filterStatuses.length ||
            this.filterCountries.length ||
            this.filterImts.length ||
            this.filterIots.length ||
            angular.isDefined(this.goeFilter) ||
            angular.isDefined(this.filterActive)) {
            this.isFilterSet = true;
        }
        else {
            this.isFilterSet = false;
        }
        this.setLastFilter(); //Set User Profile 'last filter' for session
        this.dtInstance.DataTable.ajax.reload();
    };
    QueueSapMissingController.prototype.clearFilter = function () {
        this.filterSubStatuses = [];
        this.filterStatuses = [];
        this.filterCountries = [];
        this.filterImts = [];
        this.filterIots = [];
        this.goeFilter = undefined;
        this.dtInstance.DataTable.ajax.reload();
        delete this.settings.up.lastFilter; //Lose the last filter, too
    };
    QueueSapMissingController.prototype.toggleFilter = function () {
        if (this.isFilterToggled) {
            this.applyFilter();
        }
        this.isFilterToggled = !this.isFilterToggled;
    };
    QueueSapMissingController.prototype.saveFilter = function () {
        var filterFound = false;
        if (typeof this.userFilters !== 'undefined') {
            for (var i = 0; i < this.userFilters.length; i++) {
                if (this.userFilters[i].name === this.newSearch) {
                    filterFound = true;
                    this.userFilters[i].goeFilter = this.goeFilter;
                    this.userFilters[i].filterSubStatuses = this.filterSubStatuses;
                    this.userFilters[i].filterStatuses = this.filterStatuses;
                    this.userFilters[i].filterCountries = this.filterCountries;
                    this.userFilters[i].filterImts = this.filterImts;
                    this.userFilters[i].filterIots = this.filterIots;
                    break;
                }
            }
        }
        if (!filterFound) {
            var saveSearchObj = {};
            saveSearchObj.name = this.newSearch;
            saveSearchObj.filterSubStatuses = this.filterSubStatuses;
            saveSearchObj.filterStatuses = this.filterStatuses;
            saveSearchObj.filterCountries = this.filterCountries;
            saveSearchObj.filterImts = this.filterImts;
            saveSearchObj.filterIots = this.filterIots;
            saveSearchObj.goeFilter = this.goeFilter;
            if (typeof this.userFilters !== 'undefined') {
                this.userFilters.push(saveSearchObj);
            }
            else {
                this.userFilters = [saveSearchObj];
            }
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'SaveFilter',
                script: '/queueservice/filterprofiles',
                user: this.env.user,
                data: this.userFilters
            }
        });
    };
    QueueSapMissingController.prototype.changeSavedFilter = function (filter) {
        this.filterIots = filter.filterIots;
        this.filterImts = filter.filterImts;
        this.filterCountries = filter.filterCountries;
        this.filterStatuses = filter.filterStatuses;
        this.filterSubStatuses = filter.filterSubStatuses;
        this.goeFilter = filter.goeFilter;
    };
    QueueSapMissingController.prototype.deleteProfile = function (profile) {
        this.allowed = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'deleteProfile',
                script: '/queueservice/filterprofiles',
                user: this.env.user.email,
                data: profile,
                token: this.env.user.token
            }
        });
    };
    QueueSapMissingController.prototype.toggleFilterTriggered = function (value) {
        if (value === 'active') {
            this.filterActive = true;
        }
        else if (value === 'inactive') {
            this.filterActive = false;
        }
        else {
            this.filterActive = undefined;
        }
        this.applyFilter();
    };
    QueueSapMissingController.prototype.getVersionLabel = function (ver) {
        switch (ver) {
            case 1:
            case 2:
                return 'CVR';
            case 3:
                return 'SWDR';
            default:
                return '';
        }
    };
    QueueSapMissingController.$inject = [
        '$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings', '$mdDialog',
    ];
    return QueueSapMissingController;
}());
var QueueSapMissingComponent = (function () {
    function QueueSapMissingComponent() {
        this.templateUrl = 'sap-missing.html';
        this.controllerAs = 'vm';
        this.controller = QueueSapMissingController;
    }
    return QueueSapMissingComponent;
}());
angular
    .module('application')
    .component('queueSapMissingSection', new QueueSapMissingComponent());



/**
* @fileOverview queue.component.ts - Contains handling of queue management
* @author Jan Valentik
*/
//import IAngularEvent = angular.IAngularEvent;
var QueueSetasideController = (function () {
    function QueueSetasideController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, notify, Dialog, settings, $mdDialog) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$mdDialog = $mdDialog;
        this.items = [];
        this.processing = true;
        this.waitForReport = false;
        this.oncePressed = false;
        this.dtInstance = {};
        socket.forward('queue.setaside.setPaid', $scope);
        this.$scope.$on('socket:queue.setaside.setPaid', function (event, data) {
            _this.dtInstance.DataTable.ajax.reload(null, false);
            if (data.error) {
                return _this.notify.error(data.error);
            }
            else {
                return _this.notify.success('Updated successfully.');
            }
        });
        socket.forward('queue.setaside.get-report', $scope);
        this.$scope.$on('socket:queue.setaside.get-report', function (event, data) {
            _this.waitForReport = false;
            if (!data.payload.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([decodeURIComponent(data.payload)], { type: 'text/plain;charset=utf-8' })); //'\ufeff',
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-Set-Aside-Report_" + d + ".txt");
                a.click();
            }
        });
    }
    QueueSetasideController.prototype.$onInit = function () {
        var _this = this;
        this.queueLabel = 'Set Aside Queue';
        var that = this;
        /*        this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'getAllErroredQueues',
                        script: 'queue/queue',
                        email: this.env.user.email,
                    }
                });
        */
        this.dtColumns = this.buildColumns();
        this.dtOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', {
            dataSrc: function (data) {
                _this.items = data.data;
                return data.data;
            },
            url: '/api/queue/setaside',
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                request.setRequestHeader('Authorization', 'Bearer ' + that.env.user.token);
            },
            data: {}
        })
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withPaginationType('full_numbers')
            .withOption('createdRow', createdRow)
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
        function createdRow(row, data, dataIndex) {
            var thresholdDate = new Date();
            thresholdDate.setHours(0, 0, 0, 0);
            var finDate = 0;
            for (var _i = 0, _a = data.doc.docs; _i < _a.length; _i++) {
                var oneDoc = _a[_i];
                if (oneDoc.paymentDate > finDate) {
                    finDate = oneDoc.paymentDate;
                }
            }
            var createdOn = new Date(parseInt(finDate, 10));
            createdOn.setHours(0, 0, 0, 0);
            if (createdOn <= thresholdDate) {
                $(row).addClass('tblRow').css('color', 'red');
            }
            else {
                $(row).addClass('tblRow');
            }
            var el = angular.element;
            that.$compile(el(row).contents())(that.$scope);
        }
    };
    QueueSetasideController.prototype.buildColumns = function () {
        var _this = this;
        var that = this;
        return [this.DTColumnBuilder.newColumn('doc.ceid')
                .withTitle('CEID')
                .notSortable()
                .withOption('searchable', true),
            this.DTColumnBuilder.newColumn('doc.bpName')
                .withTitle('BP Name')
                .notSortable()
                .withOption('searchable', true),
            this.DTColumnBuilder.newColumn('doc.bpCountry')
                .withTitle('BP Country')
                .notSortable()
                .withOption('searchable', true),
            this.DTColumnBuilder.newColumn('doc.docCountry')
                .withTitle('Opportunity Country')
                .notSortable()
                .withOption('searchable', true),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Payment Date / Frequency')
                .withOption('searchable', true)
                .renderWith(function (data, type, full, meta) {
                var finDate = 0;
                var finFreq = [];
                for (var _i = 0, _a = full.doc.docs; _i < _a.length; _i++) {
                    var oneDoc = _a[_i];
                    if (oneDoc.paymentDate > finDate) {
                        finDate = oneDoc.paymentDate;
                    }
                    if (finFreq.indexOf(oneDoc.payfreq) < 0) {
                        finFreq.push(oneDoc.payfreq);
                    }
                }
                finFreq.sort();
                //let roundedDate = Math.round(parseInt(finDate, 13) / 1000);
                //console.log(roundedDate);
                return _this.$filter('date')(new Date(Math.round(finDate / 1000) * 1000), 'fullDate', 'UTC') + " / " + (finFreq.length > 0 ? finFreq.join(', ') : 'Unknown');
            })
                .notSortable(),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Bonus Amount')
                .renderWith(function (data, type, full, meta) {
                return full.doc.amount + " " + full.doc.currency;
            })
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.docs.length')
                .withTitle('Documents')
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.invsRequested')
                .withTitle('Requested')
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.invsReceived')
                .withTitle('Received')
                .notSortable(),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('')
                .notSortable()
                .renderWith(this.buttonDetails)
                .withOption('className', 'details-control'),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('')
                .notSortable()
                .renderWith(this.buttonPaid)
                .withOption('className', 'details-control'),
        ];
    };
    QueueSetasideController.prototype.buttonDetails = function (data, type, full, meta) {
        return "<md-button class=\"md-raised md-primary\" ng-click=\"vm.getDetails('" + meta.row + "')\" ng-disabled=\"vm.processing\">Details</md-button>";
    };
    QueueSetasideController.prototype.buttonPaid = function (data, type, full, meta) {
        return "<md-button class=\"md-raised md-primary\" ng-click=\"vm.setPaid('" + meta.row + "')\" ng-disabled=\"vm.processing\">Paid</md-button>";
    };
    QueueSetasideController.prototype.setPaid = function (rowId) {
        var _this = this;
        if (this.processing) {
            return;
        }
        // const oneItem = JSON.parse(rowId);
        var items = {
            docs: this.items[rowId].doc.docs.map(function (doc) {
                if (doc.invoice_flags && doc.invoice_flags.requested && doc.invoice_flags.received) {
                    return {
                        doc: doc.id,
                        value: true
                    };
                }
            })
                .filter(function (item) {
                return item !== undefined;
            })
        };
        if (items.docs.length === 0) {
            var items_1 = {
                icon: 'ERROR',
                message: 'No documents with invoice received flag.',
                title: 'Error'
            };
            this.Dialog.updateValidForm(undefined, items_1, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        this.Dialog.updateValidForm(undefined, items, 'setAside-documents_select.html').then(function (dResult) {
            _this.processing = true;
            var docs = [];
            dResult.docs.forEach(function (doc) {
                if (doc.value === true) {
                    docs.push(doc.doc);
                }
            });
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'setPaid',
                    data: {
                        docs: docs,
                        item: _this.items[rowId].doc
                    },
                    script: 'detail/payment/v1/payment',
                    email: _this.env.user.email,
                    token: _this.env.user.token
                }
            });
        });
    };
    QueueSetasideController.prototype.viewRecord = function (doc_id) {
        this.$state.go('detail.payment', {
            id: doc_id.substring(4)
        });
    };
    QueueSetasideController.prototype.getDetails = function (rowId) {
        var _this = this;
        if (this.processing) {
            return;
        }
        console.log(rowId);
        //const oneItem = JSON.parse(rowId);
        var items = {
            item: this.items[rowId],
            select: function (index) {
                _this.Dialog.$mdDialog.cancel();
                _this.viewRecord(_this.items[rowId].doc.docs[index].id); //this.items[rowId].docs[index].id);
            }
        };
        if (items.item.doc.docs.length === 0) {
            var items_2 = {
                icon: 'ERROR',
                message: 'No documents in this bucket.',
                title: 'Error'
            };
            this.Dialog.updateValidForm(undefined, items_2, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        this.Dialog.updateValidForm(undefined, items, 'setAside-details.html').then(function (dResult) {
            return;
        });
    };
    QueueSetasideController.$inject = [
        '$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings', '$mdDialog'
    ];
    return QueueSetasideController;
}());
var QueueSetasideComponent = (function () {
    function QueueSetasideComponent() {
        this.templateUrl = 'queueSetaside.html';
        this.controllerAs = 'vm';
        this.controller = QueueSetasideController;
    }
    return QueueSetasideComponent;
}());
angular
    .module('application')
    .component('queueSetasideSection', new QueueSetasideComponent());



var TypeAheadController = (function () {
    function TypeAheadController(topic, socket, DTS, $q, $timeout, $stateParams, $state, $scope, $attrs, env, notify, btnLabel, isReassign, usersFromCloudant) {
        var _this = this;
        this.topic = topic;
        this.socket = socket;
        this.DTS = DTS;
        this.$q = $q;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.env = env;
        this.notify = notify;
        this.btnLabel = btnLabel;
        this.isReassign = isReassign;
        this.usersFromCloudant = usersFromCloudant;
        this.viaActionMenu = false; // Default... ie: from Queues
        this.fired = false; // when button clicked for server update
        this.scopeId = this.DTS.guid();
        this.isManual = false;
        this.hasResult = false;
        this.hasText = false;
        this.isSelected = false;
        this.isDisabled = false;
        this.searchText = null;
        this.selectedItem = null;
        this.owner = { owner: '', newowner: '' };
        this.deferred = {};
        this.socket.forward('typeahead.' + this.scopeId, this.$scope);
        this.$scope.$on('socket:typeahead.' + this.scopeId, function (event, data) {
            _this.lookupowner(event, data);
            _this.usersFromCloudant = data.results;
        });
        this.socket.forward('typeahead.success');
        this.$scope.$on('socket:typeahead.success', function (event, data) {
            _this.fired = false;
            if (data.success) {
                // If fired from the action menu
                if (_this.viaActionMenu) {
                    _this.vm.cancel(); // close dialog
                    // if in Elig status or a Pre-Sales Order Validation status...and no owner allow... 
                    // gonna have to reload the whole thing, ffs, because the server-side code is not set-up nicely to pull 
                    // the the editable options as well as potential status-code etc...history, blah, blah
                    if (!_this.topic.hasOwner() &&
                        (!_this.topic.isNotInEligibilityStatus() ||
                            _this.topic.isValidationPreSalesOrder() ||
                            _this.topic.hasUnresolvedErrors() ||
                            _this.topic.isInitialV3())) {
                        // Reload
                        _this.topic.reloadDisbursement(_this.$stateParams.id);
                        _this.notify.success('Reloading Disbursement');
                    }
                    else {
                        // Update owner
                        _this.topic.topic.owner = data.newOwner;
                        _this.topic.setActionButtons(); //Make call on the hide/show for the action buttons
                    }
                }
            }
        });
        if (this.$attrs.reassign) {
            if (this.$attrs.reassign === 'true') {
                this.btnLabel = 'Re-Assign';
                this.isReassign = true;
            }
            else {
                this.btnLabel = 'Assign';
                this.isReassign = false;
            }
        }
        else {
            if (this.$stateParams.id === 'myqueue' || this.$stateParams.id === 'teamqueue') {
                this.btnLabel = 'Re-Assign';
                this.isReassign = true;
            }
            else {
                this.btnLabel = 'Assign';
                this.isReassign = false;
            }
        }
    }
    TypeAheadController.prototype.lookupowner = function (event, data) {
        if (data.err) {
            return this.env.promises[data.id].reject([]);
        }
        this.env.promises[data.id].resolve(data.results);
        delete this.env.promises[data.id];
    };
    TypeAheadController.prototype.searchTextChange = function (text) {
        var t = this;
        if (!text) {
            this.hasText = false;
        }
        else {
            this.hasText = true;
            this.searchText = text;
        }
    };
    // returnCancel() {
    //     return this.$attrs.vms;
    // }
    TypeAheadController.prototype.selectedItemChange = function () {
        var t = this;
        if (!this.hasText) {
            this.isSelected = false;
            this.hasResult = false;
        }
        else {
            this.isSelected = true;
            this.hasResult = true;
        }
    };
    TypeAheadController.prototype.newPromise = function (socket) {
        var _this = this;
        var t = this;
        this.deferred = this.$q.defer();
        this.$timeout(function () {
            _this.deferred.reject([]);
        }, 5000);
        var id = this.DTS.guid();
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'lookUpUser',
                script: '/queue/typeahead',
                id: id,
                scope: this.scopeId,
                adminOnly: true,
                country: this.topic.topic.country || this.$attrs.country,
                token: this.env.user.token
            }
        });
        this.env.promises[id] = this.deferred;
        return this.deferred.promise;
    };
    TypeAheadController.prototype.$onInit = function () {
        if (angular.isDefined(this.vm) && angular.isDefined('clickOutsideToClose')) {
            this.viaActionMenu = true;
        }
        this.querySearch();
    };
    TypeAheadController.prototype.querySearch = function () {
        return this.newPromise(this.socket);
    };
    TypeAheadController.prototype.querySearchByCountry = function (query) {
        var results = query ? this.createFilterByInput(query) : this.usersFromCloudant;
        return results;
    };
    TypeAheadController.prototype.createFilterByInput = function (query) {
        query = query.toLowerCase();
        return this.usersFromCloudant.filter(function (user) { return user.name.toLowerCase().includes(query); });
    };
    TypeAheadController.prototype.isEnabled = function () {
        if (this.vm === undefined) {
            return true;
        }
        else {
            if (!this.viaActionMenu) {
                return this.vm.isSelected();
            }
            else {
                return true;
            }
        }
    };
    TypeAheadController.prototype.changeOwner = function (item) {
        var opps;
        if (angular.isDefined(this.vm) && !this.viaActionMenu) {
            if (this.isReassign) {
                return this.vm.reAssign(item.email);
            }
            else {
                return this.vm.assign(undefined, item.email);
            }
        }
        else {
            this.fired = true;
            // opps = { opp: this.$attrs.opp, bpname: this.$attrs.bpname, status: this.$attrs.status }; 
            opps = { opp: this.$attrs.opp, bpname: this.$attrs.bpname };
            // If sub-status is Unassigned (ie: new claim in Received, or in Validation after an WOV update)
            if ((this.$attrs.substatus && this.$attrs.substatus === 'Unassigned') || this.$attrs.status === 'Validation') {
                opps.status = this.$attrs.status; // Send the main status
            }
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'assignRequests',
                    script: '/queueservice/assign',
                    data: {
                        currentUser: this.env.user.email,
                        opps: [opps],
                        email: item.email,
                        reassign: this.isReassign,
                        notifications: this.env.notifications
                    },
                    token: this.env.user.token
                }
            });
        }
    };
    TypeAheadController.$inject = ['topic', 'socket', 'DTS', '$q', '$timeout',
        '$stateParams', '$state', '$scope', '$attrs', 'env', 'notify'];
    return TypeAheadController;
}());
var TypeAheadComponent = (function () {
    function TypeAheadComponent() {
        this.templateUrl = 'typeahead.html';
        this.bindings = { vm: '<' };
        this.controller = TypeAheadController;
    }
    return TypeAheadComponent;
}());
angular
    .module('application')
    .component('typeAhead', new TypeAheadComponent());



var ExcelController = (function () {
    function ExcelController($scope, $window, socket, env) {
        var _this = this;
        this.$scope = $scope;
        this.$window = $window;
        this.socket = socket;
        this.env = env;
        this.socket.forward('queue.exportQueue', this.$scope);
        this.$scope.$on('socket:queue.exportQueue', function (event, data) {
            _this.vm.isDownloading = false;
            if (!data.payload.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.payload], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-" + _this.vm.queueLabel + "-Report_" + d + ".xlsx");
                a.click();
            }
        });
    }
    ExcelController.prototype.$onInit = function () {
        var data = {
            queryId: 'standardreport',
            filterTeams: this.vm.filterTeams,
            filterOwners: this.vm.filterOwners,
            filterSubStatuses: this.vm.filterSubStatuses,
            filterStatuses: this.vm.filterStatuses,
            filterSviStatuses: this.vm.filterSviStatuses,
            filterIots: this.vm.filterIots,
            filterImts: this.vm.filterImts,
            filterCountries: this.vm.filterCountries,
            vapFilter: this.vm.vapFilter
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportQueue',
                script: 'queueservice/excelbuilder',
                data: {
                    filters: data,
                    userId: this.env.user.email
                },
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    ExcelController.$inject = ['$scope', '$window', 'socket', 'env'];
    return ExcelController;
}());
var ExcelComponent = (function () {
    function ExcelComponent() {
        this.bindings = { vm: '=' };
        this.templateUrl = 'excel-export.html';
        this.controller = ExcelController;
    }
    return ExcelComponent;
}());
angular
    .module('application')
    .component('downloadrSection', new ExcelComponent());



var CompliancePlanReportController = (function () {
    function CompliancePlanReportController(env, socket, $scope, admin, settings, $filter) {
        var _this = this;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.settings = settings;
        this.$filter = $filter;
        this.clients = [];
        this.clientsLoaded = false;
        this.visible = false;
        this.err = { error: false, message: '' };
        this.excel = { downloaded: false, loaded: false, err: false };
        this.table = {};
        this.exportFired = false;
        this.viewLog = false;
        // DOWNLOAD EXCEL (user example)
        this.socket.forward('reporting.reportCompliancePlan.export', this.$scope);
        this.$scope.$on('socket:reporting.reportCompliancePlan.export', function (event, data) {
            _this.exportFired = false;
            if (!data.payload.error) {
                _this.file = data;
                _this.file.fileName = 'COMPLIANCE_PLAN_REPORT.xlsx';
                _this.file.fileSize = _this.file.payload.byteLength;
                if (_this.file.fileSize < 1000000) {
                    _this.file.fileSize = $filter('number')(_this.file.fileSize / 1000, 2) + 'KB';
                }
                else {
                    _this.file.fileSize = $filter('number')(_this.file.fileSize / 1000000, 2) + 'MB';
                }
                _this.excel.err = false;
                _this.excel.loaded = true;
            }
            else {
                _this.err.error = true;
                _this.excel.err = true;
                _this.err.message = data.error;
            }
        });
    }
    CompliancePlanReportController.prototype.toggle = function () {
        this.visible = !this.visible;
        if (this.visible) {
            this.exportClientExcel();
        }
    };
    CompliancePlanReportController.prototype.downloadExcelSpreadsheet = function () {
        this.exportFired = true;
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        var url = window.URL.createObjectURL(new Blob([this.file.payload], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        a.setAttribute('href', url);
        var d = new Date().toDateString();
        a.setAttribute('download', "COMPLIANCE_PLAN_REPORT " + d + ".xlsx");
        a.click();
        this.exportFired = false;
        this.excel.downloaded = true;
    };
    CompliancePlanReportController.prototype.exportClientExcel = function () {
        this.exportFired = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {},
                email: this.env.user.email,
                function: 'exportList',
                scopeBack: 'reporting.reportCompliancePlan.export',
                script: 'admin/complianceplan/compliance-plan',
                token: this.env.user.token
            }
        });
    };
    CompliancePlanReportController.$inject = ['env', 'socket', '$scope', 'admin', 'settings', '$filter'];
    return CompliancePlanReportController;
}());
var CompliancePlanReportComponent = (function () {
    function CompliancePlanReportComponent() {
        this.templateUrl = 'report-complianceplan.html';
        this.controllerAs = 'vm';
        this.controller = CompliancePlanReportController;
    }
    return CompliancePlanReportComponent;
}());
angular
    .module('application')
    .component('reportComplianceplan', new CompliancePlanReportComponent());



var binds = { vm: '=' };
var ReportGeneralController = (function () {
    function ReportGeneralController() {
        this.visible = false;
    }
    ReportGeneralController.prototype.toggle = function () {
        if (this.visible) {
            this.visible = false;
        }
        else {
            this.visible = true;
        }
    };
    return ReportGeneralController;
}());
var ReportGeneralComponent = (function () {
    function ReportGeneralComponent() {
        this.templateUrl = 'report-general.html';
        this.bindings = binds;
        this.controller = ReportGeneralController;
    }
    return ReportGeneralComponent;
}());
angular
    .module('application')
    .component('reportGeneral', new ReportGeneralComponent());



/**
 * @author Vlad Sirotkin
 */
var ReportNpsController = (function () {
    function ReportNpsController(env, socket, $scope, admin, settings, $filter) {
        var _this = this;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.settings = settings;
        this.$filter = $filter;
        this.clients = [];
        this.clientsLoaded = false;
        this.visible = false;
        this.err = { error: false, message: '' };
        this.excel = { downloaded: false, loaded: false, err: false };
        this.table = {};
        this.exportFired = false;
        this.viewLog = false;
        // DOWNLOAD EXCEL (user example)
        this.socket.forward('reporting.reportNps.export', this.$scope);
        this.$scope.$on('socket:reporting.reportNps.export', function (event, data) {
            _this.exportFired = false;
            if (!data.payload.error) {
                _this.file = data;
                _this.file.fileName = 'NPS_REPORT.xlsx';
                _this.file.fileSize = _this.file.payload.byteLength;
                if (_this.file.fileSize < 1000000) {
                    _this.file.fileSize = $filter('number')(_this.file.fileSize / 1000, 2) + 'KB';
                }
                else {
                    _this.file.fileSize = $filter('number')(_this.file.fileSize / 1000000, 2) + 'MB';
                }
                _this.excel.err = false;
                _this.excel.loaded = true;
            }
            else {
                _this.err.error = true;
                _this.excel.err = true;
                _this.err.message = data.error;
            }
        });
    }
    ReportNpsController.prototype.toggle = function () {
        this.visible = !this.visible;
        if (this.visible) {
            this.exportClientExcel();
        }
    };
    ReportNpsController.prototype.exportClientExcel = function () {
        this.exportFired = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {},
                email: this.env.user.email,
                function: 'exportToExcel',
                scopeBack: 'reporting.reportNps.export',
                script: 'reporting/report-nps',
                token: this.env.user.token
            }
        });
    };
    ReportNpsController.prototype.downloadExcelSpreadsheet = function () {
        this.exportFired = true;
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        var url = window.URL.createObjectURL(new Blob([this.file.payload], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        a.setAttribute('href', url);
        var d = new Date().toDateString();
        a.setAttribute('download', "NPS_REPORT " + d + ".xlsx");
        a.click();
        this.exportFired = false;
        this.excel.downloaded = true;
    };
    ReportNpsController.$inject = ['env', 'socket', '$scope', 'admin', 'settings', '$filter'];
    return ReportNpsController;
}());
var ReportNps = (function () {
    function ReportNps() {
        this.templateUrl = 'report-nps.html';
        this.controller = ReportNpsController;
    }
    return ReportNps;
}());
angular
    .module('application')
    .component('reportNps', new ReportNps());



var bindse = { vm: '=' };
var ReportPivotController = (function () {
    function ReportPivotController() {
        this.visible = false;
    }
    ReportPivotController.prototype.toggle = function () {
        if (this.visible) {
            this.visible = false;
        }
        else {
            this.visible = true;
        }
    };
    return ReportPivotController;
}());
var ReportPivotComponent = (function () {
    function ReportPivotComponent() {
        this.templateUrl = 'report-pivot.html';
        this.bindings = bindse;
        this.controller = ReportPivotController;
    }
    return ReportPivotComponent;
}());
angular
    .module('application')
    .component('reportPivot', new ReportPivotComponent());



var bindsToPredef = { vm: '=' };
var BacklogReportController = (function () {
    function BacklogReportController() {
        this.reportIsLoading = false;
        this.visible = false;
    }
    BacklogReportController.prototype.toggle = function () {
        if (this.visible) {
            this.visible = false;
        }
        else {
            this.visible = true;
        }
    };
    BacklogReportController.prototype.getReport = function () {
        this.reportIsLoading = true;
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        a.setAttribute('href', "/backlog");
        a.click();
    };
    return BacklogReportController;
}());
var backlogReportComponent = (function () {
    function backlogReportComponent() {
        this.templateUrl = 'report-backlog.html';
        this.bindings = bindsToPredef;
        this.controller = BacklogReportController;
    }
    return backlogReportComponent;
}());
angular
    .module('application')
    .component('reportBacklog', new backlogReportComponent());



/**
 * @author Matthew Rogers
 */
var bindingsBPLM = { vm: '=' };
var ReportBPLMController = (function () {
    function ReportBPLMController($scope, env, $filter, socket, settings) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.socket = socket;
        this.settings = settings;
        this.visible = false;
        this.details = { fired: false, loaded: false, err: false };
        this.excel = { fired: false, downloaded: false, err: false };
        this.viewLog = false;
        this.viewUser = false;
        this.err = { error: false, message: '' };
        this.data = {};
        this.logs = [];
        this.visible = false;
        this.socket.forward('return.bplm.report', this.$scope);
        this.$scope.$on('socket:return.bplm.report', function (event, data) {
            _this.excel.fired = false;
            if (!data.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.file], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                a.setAttribute('href', url);
                a.setAttribute('download', _this.data.fileName);
                a.click();
                _this.err = { error: false, message: '' };
                _this.excel.downloaded = true;
                _this.excel.err = false;
            }
            else {
                _this.err.error = true;
                _this.excel.err = true;
                _this.err.message = data.error;
            }
        });
        this.socket.forward('return.bplm.details', this.$scope);
        this.$scope.$on('socket:return.bplm.details', function (event, data) {
            _this.details.fired = false;
            if (data.error) {
                _this.err.error = true;
                _this.details.err = true;
                _this.err.message = data.error;
                return;
            }
            _this.data = data.bplm;
            _this.logs = data.bplm.lastrun_log;
            _this.details.loaded = true;
            _this.details.err = false;
            _this.err = { error: false, message: '' };
            _this.fileSize = (_this.data.report_details.rows || 0) + ' rows';
        });
    }
    ReportBPLMController.prototype.toggle = function () {
        this.visible = !this.visible;
        //If report already pulled, don't bother pulling again
        if (this.visible && !this.details.loaded) {
            this.getBPLMDetails();
        }
    };
    ReportBPLMController.prototype.getBPLMDetails = function () {
        this.details.fired = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                email: this.env.user.email,
                function: 'getBPLMDetails',
                script: '/reporting/reporting',
                user: this.env.user
            }
        });
    };
    ReportBPLMController.prototype.getReport = function () {
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        a.setAttribute('href', "/bplm");
        a.click();
    };
    ReportBPLMController.$inject = ['$scope', 'env', '$filter', 'socket', 'settings'];
    return ReportBPLMController;
}());
var ReportBPLMComponent = (function () {
    function ReportBPLMComponent() {
        this.templateUrl = 'report-bplm.html';
        this.bindings = bindingsBPLM;
        this.controller = ReportBPLMController;
    }
    return ReportBPLMComponent;
}());
angular
    .module('application')
    .component('reportBplm', new ReportBPLMComponent());



var SiteReportingController = (function () {
    function SiteReportingController(env, $filter, DTS, DTOptionsBuilder, DTColumnBuilder, $stateParams, $state, socket, $scope, $compile, settings) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.$compile = $compile;
        this.settings = settings;
        this.reportIsBuilt = false;
        this.pivotIsBuilt = false;
        this.visible = false;
        this.visiblePivot = false;
        this.socket.forward('reporting', this.$scope);
        this.$scope.$on('socket:reporting', function (event, data) {
            _this.results = data;
            console.log('General Report', _this.results);
            _this.reportIsBuilt = true;
        });
        this.socket.forward('pivot.reporting', this.$scope);
        this.$scope.$on('socket:pivot.reporting', function (event, data) {
            _this.data1 = data;
            _this.pivotIsBuilt = true;
        });
        this.socket.forward('report.generalCreated', this.$scope);
        this.$scope.$on('socket:report.generalCreated', function (event, data) {
            if (!data.payload.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.payload], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-General-Report_" + d + ".xlsx");
                a.click();
            }
        });
    }
    SiteReportingController.prototype.toggle = function () {
        this.visible = !this.visible;
        if (this.visible && !this.results && this.settings.up.swdr_permissions.general_report) {
            console.log('Fetching General Report...');
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getReportingData',
                    script: '/reporting/reporting',
                    user: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
    };
    SiteReportingController.prototype.togglePivot = function () {
        this.visiblePivot = !this.visiblePivot;
        if (this.visiblePivot && !this.data1 && this.settings.up.swdr_permissions.pivot_report) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getPivotData',
                    script: '/reporting/reporting',
                    user: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
    };
    SiteReportingController.prototype.$onInit = function () {
        //maybe just use the imts provided by server...
        this.imtHeaders = [
            '',
            'A/NZ IMT',
            'ASEAN IMT',
            'Asia Pacific IOT',
            'BeNeLux IMT',
            'Brazil IMT',
            'CEE IMT',
            'Canada IMT',
            'Central East Africa',
            'DACH IMT',
            'Egypt IMT',
            'Europe IOT',
            'France IMT',
            'GCG IMT',
            'Greater China Group IOT',
            'Gulf & Levante',
            'I/SA IMT',
            'Italy IMT',
            'Japan IMT',
            'Korea IMT',
            'Latin America IOT',
            'MEA IMT',
            'Mexico IMT',
            'Middle East & Africa IOT',
            'Nordic IMT',
            'North America IOT',
            'North West Africa',
            'SPGI IMT',
            'SSA IMT',
            'South Africa',
            'UKI IMT',
            'US IMT'];
        this.testRows = ['SUBSTATDESC'];
        this.testCols = ['IMT', 'SUBSTATDESC'];
        this.testAggregatorName = 'Count';
        this.testVals = ['SUBSTATDESC'];
        this.testRendererName = 'Table';
    };
    SiteReportingController.prototype.downloadReport = function (data) {
        var exportData = [];
        for (var p in data) {
            if (data.hasOwnProperty(p)) {
                var item = void 0;
                item = {};
                item = data[p][1];
                item._stat = data[p][0];
                exportData.push(item);
            }
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'downloadGeneralReport',
                script: '/reporting/report-general-excel',
                data: exportData,
                token: this.env.user.token
            }
        });
    };
    SiteReportingController.prototype.checkPivot = function (att) {
        console.info('att', this.$scope);
        console.info('this.testAggregatorName => ', this.testAggregatorName);
    };
    SiteReportingController.$inject = ['env', '$filter', 'DTS', 'DTOptionsBuilder',
        'DTColumnBuilder', '$stateParams', '$state', 'socket', '$scope', '$compile', 'settings'];
    return SiteReportingController;
}());
var SiteReportingComponent = (function () {
    function SiteReportingComponent() {
        this.templateUrl = 'reporting.html';
        this.controllerAs = 'vm';
        this.controller = SiteReportingController;
    }
    return SiteReportingComponent;
}());
angular
    .module('application')
    .component('reportingSection', new SiteReportingComponent());



var bindsToCust = { vm: '=' };
var ReportingCustomController = (function () {
    function ReportingCustomController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, notify, Dialog, settings) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.visibleCustom = false;
        this.newSearch = 'Default';
        this.filterList = {};
        this.isRowIdpresent = false;
        this.repType = 'OPP';
        this.filterType = 'current';
        this.showTable = false;
        this.dtInstance = {};
        this.showasync = false;
        this.asyncColumns = [];
        this.pendingSearch = angular.noop;
        this.cancelSearch = angular.noop;
        this.cachedQuery = {};
        this.lastSearch = {};
        this.isCustomReady = false;
        //this.allContacts = this.loadContacts();
        this.filterSelected = true;
        //    let querySearch = this.querySearch;
        //    let delayedQuerySearch = this.delayedQuerySearch;
        // datatable related
        this.currFilter = [];
        this.dynamicColumns = [];
        this.checkBoxModel = {};
        this.isDownloading = false;
        this.filters = {};
        this.filterIots = [];
        this.filterImts = [];
        this.filterCountries = [];
        this.filterSviStatuses = [];
        this.filterStatuses = [];
        this.filterSubStatuses = [];
        this.filterOwners = [];
        this.teams = [];
        this.filterTeams = [];
        this.vapFilter = false;
        this.showFilterBtn = false;
        this.tableDependencies = [];
        this.reportIsLoading = false;
        this.overLimit = false;
        this.listColumns = [];
        this.visibleCustomList = false;
        this.opptyIdList = '';
        this.mandatoryRoWIDtblName = [];
        this.sviFromDate = null;
        this.sviToDate = null;
        this.db2Col = [];
        this.genCol = [];
        this.eligCol = [];
        this.valCol = [];
        this.rowIdItem = {};
        this.oppItem = {};
        this.colQty = 0;
        this.chosenColumns = [];
        this.filterDetails();
        this.socket.forward('teamView.getTeams', this.$scope);
        this.$scope.$on('socket:teamView.getTeams', function (event, data) {
            if (data.id === 'getTeams') {
                _this.allTeams = [];
                _this.myTeams = data.personsTeams;
                for (var _i = 0, _a = data.allTeams; _i < _a.length; _i++) {
                    var team = _a[_i];
                    if (!_this.myTeams.includes(team)) {
                        _this.allTeams.push(team);
                    }
                }
            }
        });
        this.socket.forward('reporting.dynamicColumns', this.$scope);
        this.$scope.$on('socket:reporting.dynamicColumns', function (event, data) {
            _this.dynamicColumns = data.columns.columnArr;
            _this.dynamicColumns.forEach(function (oneCol) {
                oneCol['isSelected'] = false;
                if (oneCol.dbPlace.substring(0, 3) === 'doc') {
                    if (oneCol.dbPlace.indexOf('valid') > -1) {
                        _this.valCol.push(oneCol);
                    }
                    else if (oneCol.dbPlace.indexOf('gpp') > -1 || oneCol.dbPlace.indexOf('goe') > -1) {
                        _this.eligCol.push(oneCol);
                    }
                    else {
                        _this.genCol.push(oneCol);
                    }
                }
                else {
                    _this.db2Col.push(oneCol);
                    if (_this.db2Col[_this.db2Col.length - 1].name === 'ROW_ID') {
                        if (_this.repType === 'ROW_ID' && !_this.db2Col[_this.db2Col.length - 1].isSelected) {
                            _this.colQty++;
                            _this.db2Col[_this.db2Col.length - 1].isSelected = true;
                        }
                        _this.rowIdItem = _this.db2Col[_this.db2Col.length - 1];
                        _this.isRowIdpresent = _this.rowIdItem.isSelected;
                    }
                    else if (_this.db2Col[_this.db2Col.length - 1].name === 'OPP') {
                        if (_this.repType === 'OPP' && !_this.db2Col[_this.db2Col.length - 1].isSelected) {
                            _this.colQty++;
                            _this.db2Col[_this.db2Col.length - 1].isSelected = true;
                        }
                        _this.oppItem = _this.db2Col[_this.db2Col.length - 1];
                    }
                }
            });
            _this.tableDependencies = data.columns.tableDependencies;
            for (var i = 0; i < _this.tableDependencies.length; i++) {
                if (_this.tableDependencies[i].needsRowId) {
                    _this.mandatoryRoWIDtblName.push(_this.tableDependencies[i].tblName);
                }
            }
            _this.isCustomReady = true;
        });
        this.socket.forward('filters.getUserFilters', this.$scope);
        this.$scope.$on('socket:filters.getUserFilters', function (event, data) {
            _this.userFilters = data;
            _this.filtersExist = true;
        });
        this.socket.forward('filters.deleteProfiles', this.$scope);
        this.$scope.$on('socket:filters.deleteProfiles', function (event, data) {
            _this.userFilters = data;
            _this.allowed = false;
        });
        this.socket.forward('report.customFailed', this.$scope);
        this.$scope.$on('socket:report.customFailed', function (event, data) {
            _this.reportIsLoading = false;
        });
        this.socket.forward('report.customCreated', this.$scope);
        this.$scope.$on('socket:report.customCreated', function (event, data) {
            if (!data.payload.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.payload], {
                    //type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    type: 'application/vnd.openxmlformats'
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-Custom-Report_" + d + ".xlsx");
                a.click();
            }
            else {
                _this.overLimit = true;
                alert('Report is over 100 000 entries, please refine your search.');
            }
            _this.reportIsLoading = false;
        });
    }
    ReportingCustomController.prototype.$OnInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'FetchSavedFilters',
                script: '/queueservice/filterprofiles',
                user: this.env.user,
                email: this.env.user.email
            }
        });
    };
    ReportingCustomController.prototype.cloudantTest = function () {
        var test = this.opptyIdList.split(',');
        for (var key in test) {
            test[key] = test[key].trim();
        }
        // console.log(test);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'parseCloudant',
                script: '/reporting/custom-cloudant-reporting',
                user: this.env.user,
                email: this.env.user.email,
                opptys: test,
                excelBase: {
                    cols: [],
                    rows: []
                }
            }
        });
    };
    ReportingCustomController.prototype.checkboxChange = function (oneItem) {
        if (oneItem.isSelected) {
            this.colQty++;
        }
        else {
            this.colQty--;
        }
    };
    ReportingCustomController.prototype.repTypeChange = function () {
        if (this.repType === 'OPP' && !this.oppItem.isSelected) {
            this.oppItem.isSelected = true;
            this.colQty++;
        }
        else if (!this.rowIdItem.isSelected) {
            this.rowIdItem.isSelected = true;
            this.colQty++;
        }
    };
    ReportingCustomController.prototype.toggleCustom = function () {
        this.filterToggles = {
            countries: true,
            dmtSubStats: true,
            dmtStats: true,
            sviStats: true,
            teams: false,
            vap: true
        };
        if (this.visibleCustom) {
            this.visibleCustom = false;
        }
        else {
            this.visibleCustom = true;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getDynamicColumns',
                    script: '/reporting/reporting',
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'FetchSavedFilters',
                    script: '/queueservice/filterprofiles',
                    user: this.env.user,
                    email: this.env.user.email
                }
            });
        }
    };
    ReportingCustomController.prototype.viewProfiles = function (ev) {
        this.Dialog.openDialog2(ev, '', ReportingCustomController, 'report-custom-profiles.html', '', this.$scope); //FilterController
    };
    ReportingCustomController.prototype.toggleCustomList = function () {
        this.visibleCustomList = !this.visibleCustomList;
    };
    ReportingCustomController.prototype.createCustom = function () {
        this.showasync = !this.showasync;
    };
    ReportingCustomController.prototype.generateReport = function (action) {
        var that = this;
        this.chosenColumns = [];
        var rowIdObj = this.rowIdItem;
        this.isRowIdpresent = this.rowIdItem.isSelected;
        var shouldRowIdBePresent = false;
        for (var i = 0; i < this.db2Col.length; i++) {
            if (this.db2Col[i].isSelected) {
                this.chosenColumns.push(this.db2Col[i]);
                if (this.mandatoryRoWIDtblName.indexOf(this.db2Col[i].dbPlace) > -1) {
                    shouldRowIdBePresent = true;
                }
            }
        }
        var includesCloudant = false;
        for (var i = 0; i < this.genCol.length; i++) {
            if (this.genCol[i].isSelected) {
                this.chosenColumns.push(this.genCol[i]);
                includesCloudant = true;
            }
        }
        for (var i = 0; i < this.eligCol.length; i++) {
            if (this.eligCol[i].isSelected) {
                this.chosenColumns.push(this.eligCol[i]);
                includesCloudant = true;
            }
        }
        for (var i = 0; i < this.valCol.length; i++) {
            if (this.valCol[i].isSelected) {
                this.chosenColumns.push(this.valCol[i]);
                includesCloudant = true;
            }
        }
        if (shouldRowIdBePresent && !this.isRowIdpresent) {
            //this.chosenColumns.unshift(rowIdObj);
            this.chosenColumns.splice(1, 0, rowIdObj);
            this.isRowIdpresent = true;
            this.rowIdItem.isSelected = true;
        }
        that.filterList.vapFilter = that.vapFilter;
        that.filterList.filterSubStatuses = that.filterSubStatuses;
        that.filterList.filterStatuses = that.filterStatuses;
        that.filterList.filterOwners = that.filterOwners;
        that.filterList.filterCountries = that.filterCountries;
        that.filterList.filterSviStatuses = that.filterSviStatuses;
        //that.filterList.filterTeams = that.filterTeams;
        that.filterList.filterImts = that.filterImts;
        that.filterList.filterIots = that.filterIots;
        if (this.sviFromDate === null) {
            that.filterList.sviFromDate = '';
        }
        else {
            that.filterList.sviFromDate = this.sviFromDate.getFullYear() + '-' + (this.sviFromDate.getMonth() + 1) + '-' + this.sviFromDate.getDate();
        }
        if (this.sviToDate === null) {
            that.filterList.sviToDate = '';
        }
        else {
            that.filterList.sviToDate = this.sviToDate.getFullYear() + '-' + (this.sviToDate.getMonth() + 1) + '-' + this.sviToDate.getDate();
        }
        that.overLimit = false; //reset
        var data = {
            dlVsDispl: action,
            repType: that.repType,
            tableDependencies: that.tableDependencies,
            chosenColumns: this.chosenColumns,
            filterList: that.filterList,
            filterType: this.filterType,
            user: this.env.user.email,
            isRowIdpresent: this.isRowIdpresent,
            includesCloudant: includesCloudant
        };
        if (action === 'show' && this.chosenColumns.length <= 20) {
            this.dtColumns = this.buildColumns();
            this.dtOptions = this.DTOptionsBuilder
                .newOptions()
                .withOption('ajax', {
                dataSrc: function (data) {
                    return data.data;
                },
                data: data,
                url: '/api/custom/reporting',
                type: 'POST',
                timeout: 6000000,
                beforeSend: function (request) {
                    request.setRequestHeader('Authorization', 'Bearer ' + that.env.user.token);
                }
            })
                .withOption('processing', true)
                .withOption('serverSide', true)
                .withOption('searchDelay', 1000)
                .withPaginationType('full_numbers')
                .withOption('createdRow', createdRow);
            this.showTable = true;
            function createdRow(row, data, dataIndex) {
                var OFFSET = 3;
                var thresholdDate = new Date();
                thresholdDate.setHours(0, 0, 0, 0);
                thresholdDate.setDate(thresholdDate.getDate() - OFFSET);
                var createdOn = new Date(parseInt(data.created, 10));
                createdOn.setHours(0, 0, 0, 0);
                if (createdOn <= thresholdDate && data.substatus === 'Unassigned') {
                    $(row).addClass('tblRow').css('color', 'red');
                }
                else {
                    $(row).addClass('tblRow');
                }
                var el = angular.element;
                that.$compile(el(row).contents())(that.$scope);
            }
        }
        else if (this.chosenColumns.length <= 20) {
            this.reportIsLoading = true;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'createCustomExcelBackend',
                    script: '/reporting/reporting',
                    data: data,
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
    };
    ReportingCustomController.prototype.applyLastFilter = function () {
        var _this = this;
        // If there is a lastFilter element in user's profile (in browser), set the
        // filters accordingly and apply them rather than loading the default (all)
        if (this.settings.up.lastFilter) {
            angular.forEach(this.settings.up.lastFilter, function (v, k) {
                _this[k] = v;
            });
            this.isFilterToggled = true;
        }
    };
    ReportingCustomController.prototype.addColumns = function () {
        var _this = this;
        this.preparedColumns = [];
        if (this.asyncColumns.size !== 0) {
            this.asyncColumns.forEach(function (item) {
                _this.preparedColumns.push(_this.DTColumnBuilder.newColumn(item.name).withTitle(item.title).withOption('name', item.option));
                return _this.preparedColumns;
            });
        }
    };
    ReportingCustomController.prototype.buildColumns = function () {
        var _this = this;
        var that = this;
        //let columns = this.preparedColumns
        var columns = [];
        this.chosenColumns.forEach(function (oneCol) {
            var title = '';
            var name = '';
            if (oneCol.dbPlace.substring(0, 3) === 'doc') {
                if (oneCol.dbPlace.indexOf('valid') > -1) {
                    title = 'VAL ' + oneCol.title;
                    name = 'VAL_' + oneCol.name;
                }
                else if (oneCol.dbPlace.indexOf('gpp') > -1 || oneCol.dbPlace.indexOf('goe') > -1) {
                    title = 'ELIG ' + oneCol.title;
                    name = 'ELIG_' + oneCol.name;
                }
                else {
                    title = 'GNRL ' + oneCol.title;
                    name = 'GNRL_' + oneCol.name;
                }
            }
            else {
                title = oneCol.title;
                name = oneCol.name;
            }
            columns.push(_this.DTColumnBuilder.newColumn(name).withTitle(title));
        });
        for (var i = 0; i < this.asyncColumns.length; i++) {
        }
        return columns;
    };
    ReportingCustomController.prototype.changeFilters = function (id) {
        var _this = this;
        if (id === 'iot') {
            this.filterImts = [];
            this.filterCountries = [];
            this.filters.imts = [];
            this.filters.countries = [];
            this.env.topics.imtFilterValues.forEach(function (value) {
                if (value.ic === 'IMT') {
                    if (_.includes(_this.filterIots, value.imt) &&
                        !_.includes(_this.filters.imts, value.imt_name)) {
                        _this.filters.imts.push(value.imt_name);
                    }
                }
                else if (value.ic === 'Country') {
                    if (_.includes(_this.filterIots, value.imt) &&
                        !_.includes(_this.filters.countries, value.country)) {
                        _this.filters.countries.push(value.country);
                    }
                }
            });
            this.filters.imts.sort();
            this.filters.countries.sort();
        }
        else if (id === 'imt') {
            this.filterCountries = [];
            this.filters.countries = [];
            this.env.topics.imtFilterValues.forEach(function (value) {
                if (value.ic === 'Country') {
                    if (_.includes(_this.filterImts, value.imt_name) &&
                        !_.includes(_this.filters.countries, value.country)) {
                        _this.filters.countries.push(value.country);
                    }
                }
            });
        }
        // If the 'last used filter' is still active, re-add the values as they will have been lost
        // by the code above
        /*
        if (this.settings.up.lastFilter) {
            this.applyLastFilter(); // reset the values
        }
        */
    };
    ReportingCustomController.prototype.filterDetails = function () {
        var _this = this;
        this.env.topics.imtFilterValues = this.settings.country_list;
        this.filters.iots = this.settings.iot_list;
        this.filters.imts = this.settings.imt_list;
        this.filters.countries = this.settings.getCountryList();
        this.filters.iots.sort();
        this.filters.imts.sort();
        this.filters.countries.sort();
        this.env.topics.imtFilterValues.forEach(function (value) {
            if (value.ic === 'IOT') {
                if (!_.includes(_this.filters.iots, value.imt)) {
                    _this.filters.iots.push(value.imt);
                }
            }
            else if (value.ic === 'IMT') {
                if (!_.includes(_this.filters.imts, value.imt_name)) {
                    _this.filters.imts.push(value.imt_name);
                }
            }
            else {
                if (!_.includes(_this.filters.countries, value.country)) {
                    _this.filters.countries.push(value.country);
                }
            }
        });
        this.filters.sviStatuses = this.settings.svistatuses;
        this.filters.statuses = this.settings.statuses;
        this.filters.subStatuses = this.settings.substatuses;
        this.showFilterBtn = true;
    };
    ReportingCustomController.prototype.applyFilter = function () {
        if (this.filterSubStatuses.length ||
            this.filterTeams.length ||
            this.filterStatuses.length ||
            this.filterCountries.length ||
            this.filterOwners.length ||
            this.filterSviStatuses.length ||
            this.filterImts.length ||
            this.filterIots.length ||
            this.vapFilter) {
            this.isFilterSet = true;
        }
        else {
            this.isFilterSet = false;
        }
        this.dtInstance.DataTable.ajax.reload();
    };
    ReportingCustomController.prototype.clearFilter = function () {
        this.isFilterSet = false;
        this.vapFilter = false;
        this.filterSubStatuses = [];
        this.filterStatuses = [];
        this.filterOwners = [];
        this.filterCountries = [];
        this.filterSviStatuses = [];
        this.filterTeams = [];
        this.filterImts = [];
        this.filterIots = [];
        this.dtInstance.DataTable.ajax.reload();
        delete this.settings.up.lastFilter; //Lose the last filter, too
    };
    ReportingCustomController.prototype.toggleDownload = function () {
        this.isDownloading = true;
    };
    ReportingCustomController.prototype.saveFilter = function () {
        var filterFound = false;
        var dynamicColumns = JSON.parse(JSON.stringify((this.asyncColumns)));
        for (var i = 0; i < dynamicColumns.length; i++) {
            delete dynamicColumns[i].$$hashKey;
        }
        if (typeof this.userFilters !== 'undefined') {
            for (var i = 0; i < this.userFilters.length; i++) {
                if (this.userFilters[i].name === this.newSearch) {
                    filterFound = true;
                    this.userFilters[i].vapFilter = this.vapFilter;
                    this.userFilters[i].filterSubStatuses = this.filterSubStatuses;
                    this.userFilters[i].filterStatuses = this.filterStatuses;
                    this.userFilters[i].filterOwners = this.filterOwners;
                    this.userFilters[i].filterCountries = this.filterCountries;
                    this.userFilters[i].filterSviStatuses = this.filterSviStatuses;
                    this.userFilters[i].filterTeams = this.filterTeams;
                    this.userFilters[i].filterImts = this.filterImts;
                    this.userFilters[i].filterIots = this.filterIots;
                    this.userFilters[i].dynamicColumns = dynamicColumns;
                    this.userFilters[i].repType = this.repType;
                    this.userFilters[i].filterType = this.filterType;
                    this.userFilters[i].sviFromDate = this.sviFromDate;
                    this.userFilters[i].db2Col = this.db2Col;
                    this.userFilters[i].genCol = this.genCol;
                    this.userFilters[i].eligCol = this.eligCol;
                    this.userFilters[i].valCol = this.valCol;
                    break;
                }
            }
        }
        if (!filterFound) {
            var saveSearchObj = {};
            saveSearchObj.name = this.newSearch;
            saveSearchObj.vapFilter = this.vapFilter;
            saveSearchObj.filterSubStatuses = this.filterSubStatuses;
            saveSearchObj.filterStatuses = this.filterStatuses;
            saveSearchObj.filterOwners = this.filterOwners;
            saveSearchObj.filterCountries = this.filterCountries;
            saveSearchObj.filterSviStatuses = this.filterSviStatuses;
            saveSearchObj.filterTeams = this.filterTeams;
            saveSearchObj.filterImts = this.filterImts;
            saveSearchObj.filterIots = this.filterIots;
            saveSearchObj.dynamicColumns = dynamicColumns;
            saveSearchObj.repType = this.repType;
            saveSearchObj.filterType = this.filterType;
            saveSearchObj.sviFromDate = this.sviFromDate;
            saveSearchObj.db2Col = this.db2Col;
            saveSearchObj.genCol = this.genCol;
            saveSearchObj.eligCol = this.eligCol;
            saveSearchObj.valCol = this.valCol;
            if (typeof this.userFilters !== 'undefined') {
                this.userFilters.push(saveSearchObj);
            }
            else {
                this.userFilters = [saveSearchObj];
            }
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'SaveFilter',
                script: '/queueservice/filterprofiles',
                user: this.env.user,
                data: this.userFilters,
                email: this.env.user.email
            }
        });
    };
    ReportingCustomController.prototype.changeSavedFilter = function (filter) {
        this.currFilter = filter;
        this.filterIots = filter.filterIots;
        this.filterImts = filter.filterImts;
        this.filterCountries = filter.filterCountries;
        this.filterSviStatuses = filter.filterSviStatuses;
        this.filterStatuses = filter.filterStatuses;
        this.filterSubStatuses = filter.filterSubStatuses;
        this.filterOwners = filter.filterOwners;
        this.filterTeams = filter.filterTeams;
        if (typeof filter.repType !== 'undefined') {
            this.repType = filter.repType;
        }
        if (typeof filter.repType !== 'undefined') {
            this.filterType = filter.filterType;
        }
        if (typeof filter.sviFromDate !== 'undefined' && filter.sviFromDate !== '') {
            this.sviFromDate = new Date(filter.sviFromDate);
        }
        if (typeof filter.sviToDate !== 'undefined' && filter.sviToDate !== '') {
            this.sviToDate = new Date(filter.sviToDate);
        }
        if (typeof filter.db2Col !== 'undefined') {
            for (var i = 0; i < this.db2Col.length; i++) {
                for (var i2 = 0; i2 < filter.db2Col.length; i2++) {
                    if (this.db2Col[i].name === filter.db2Col[i2].name) {
                        if (!this.db2Col[i].isSelected && filter.db2Col[i2].isSelected) {
                            this.colQty++;
                        }
                        this.db2Col[i].isSelected = filter.db2Col[i2].isSelected;
                        break;
                    }
                }
            }
        }
        if (typeof filter.eligCol !== 'undefined') {
            for (var i = 0; i < this.eligCol.length; i++) {
                for (var i2 = 0; i2 < filter.eligCol.length; i2++) {
                    if (this.eligCol[i].name === filter.eligCol[i2].name) {
                        if (!this.eligCol[i].isSelected && filter.eligCol[i2].isSelected) {
                            this.colQty++;
                        }
                        this.eligCol[i].isSelected = filter.eligCol[i2].isSelected;
                        break;
                    }
                }
            }
        }
        if (typeof filter.genCol !== 'undefined') {
            for (var i = 0; i < this.genCol.length; i++) {
                for (var i2 = 0; i2 < filter.genCol.length; i2++) {
                    if (this.genCol[i].name === filter.genCol[i2].name) {
                        if (!this.genCol[i].isSelected && filter.genCol[i2].isSelected) {
                            this.colQty++;
                        }
                        this.genCol[i].isSelected = filter.genCol[i2].isSelected;
                        break;
                    }
                }
            }
        }
        if (typeof filter.valCol !== 'undefined') {
            for (var i = 0; i < this.valCol.length; i++) {
                for (var i2 = 0; i2 < filter.valCol.length; i2++) {
                    if (this.valCol[i].name === filter.valCol[i2].name) {
                        if (!this.valCol[i].isSelected && filter.valCol[i2].isSelected) {
                            this.colQty++;
                        }
                        this.valCol[i].isSelected = filter.valCol[i2].isSelected;
                        break;
                    }
                }
            }
        }
        if (typeof filter.dynamicColumns !== 'undefined') {
            this.asyncColumns = filter.dynamicColumns;
        }
    };
    ReportingCustomController.prototype.cancel = function (ev) {
        //        this.$mdDialog.cancel();
    };
    ReportingCustomController.prototype.deleteProfile = function (profile) {
        this.allowed = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'deleteProfile',
                script: '/queueservice/filterprofiles',
                user: this.env.user.email,
                data: profile,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    ReportingCustomController.prototype.querySearch = function (criteria) {
        this.cachedQuery = this.cachedQuery || criteria;
        return this.cachedQuery ? this.allContacts.filter(this.createFilterFor(this.cachedQuery)) : [];
    };
    ReportingCustomController.prototype.delayedQuerySearch = function (criteria) {
        var _this = this;
        this.cachedQuery = criteria;
        if (!this.pendingSearch || !this.debounceSearch()) {
            this.cancelSearch();
            return this.pendingSearch = this.$q(function (resolve, reject) {
                // Simulate async search... (after debouncing)
                _this.cancelSearch = reject;
                _this.$timeout(function () {
                    resolve(_this.querySearch(criteria));
                    _this.refreshDebounce();
                }, 1000);
            });
        }
    };
    ReportingCustomController.prototype.refreshDebounce = function () {
        this.lastSearch = 0;
        this.pendingSearch = null;
        this.cancelSearch = angular.noop;
    };
    /**
     * Debounce if querying faster than 300ms
     */
    ReportingCustomController.prototype.debounceSearch = function () {
        var now = new Date().getMilliseconds();
        this.lastSearch = this.lastSearch || now;
        return ((now - this.lastSearch) < 300);
    };
    /**
     * Create filter function for a query string
     */
    ReportingCustomController.prototype.createFilterFor = function (query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact._lowername.indexOf(lowercaseQuery) !== -1);
        };
    };
    ReportingCustomController.prototype.loadContacts = function () {
        var opp = {
            name: 'opp',
            title: 'Opportunity',
            option: 'opp'
        };
        var contacts = this.dynamicColumns;
        /*      let contacts = [
                  {
                      name: 'opp',
                      title: 'Opportunity',
                      option: 'opp, name'
                  },
                  {
                      name: 'brand',
                      title: 'Brand',
                      option: 'brand, name'
                  }
              ];
        */
        return contacts.map(function (c, index) {
            var contact = {
                name: c.name,
                title: c.title,
                option: c.option,
                _lowername: ''
            };
            contact._lowername = contact.title.toLowerCase();
            return contact;
        });
    };
    ReportingCustomController.$inject = ['$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings'];
    return ReportingCustomController;
}());
var ReportingCustomComponent = (function () {
    function ReportingCustomComponent() {
        this.bindings = bindsToCust;
        this.templateUrl = 'report.custom.html';
        this.controller = ReportingCustomController;
    }
    return ReportingCustomComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('clearAll', '/public/icons/ic_clear_all_black_18px.svg');
})
    .component('reportCustom', new ReportingCustomComponent());



var binding = { vm: '>' };
var ReportingFiltersController = (function () {
    function ReportingFiltersController() {
    }
    ReportingFiltersController.prototype.closeFilter = function () {
        this.vm.isFilterToggled = false;
    };
    return ReportingFiltersController;
}());
var ReportingFiltersComponent = (function () {
    function ReportingFiltersComponent() {
        this.bindings = binding;
        //templateUrl = 'report-filter.html';
        this.controller = ReportingFiltersController;
    }
    return ReportingFiltersComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('clearAll', '/public/icons/ic_clear_all_black_18px.svg');
})
    .component('filtersSection', new ReportingFiltersComponent());



var bindsToFinance = { vm: '=' };
var FinanceReportController = (function () {
    function FinanceReportController() {
        this.reportIsLoading = false;
        this.visible = false;
    }
    FinanceReportController.prototype.toggle = function () {
        if (this.visible) {
            this.visible = false;
        }
        else {
            this.visible = true;
        }
    };
    FinanceReportController.prototype.getReport = function () {
        this.reportIsLoading = true;
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        a.setAttribute('href', "/finance");
        a.click();
    };
    return FinanceReportController;
}());
var FinanceReportComponent = (function () {
    function FinanceReportComponent() {
        this.templateUrl = 'report-finance.html';
        this.bindings = bindsToFinance;
        this.controller = FinanceReportController;
    }
    return FinanceReportComponent;
}());
angular
    .module('application')
    .component('reportFinance', new FinanceReportComponent());



/**
 * @author Ilya Aderiho
 */
var ReportNewClients1Controller = (function () {
    function ReportNewClients1Controller(env, socket, $scope, admin, settings, $filter) {
        var _this = this;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.settings = settings;
        this.$filter = $filter;
        this.clients = [];
        this.clientsLoaded = false;
        this.visible = false;
        this.err = { error: false, message: '' };
        this.excel = { downloaded: false, loaded: false, err: false };
        this.table = {};
        this.exportFired = false;
        this.viewLog = false;
        // DOWNLOAD EXCEL (user example)
        this.socket.forward('admin.approvedList.export', this.$scope);
        this.$scope.$on('socket:admin.approvedList.export', function (event, data) {
            _this.exportFired = false;
            if (!data.payload.error) {
                _this.file = data;
                _this.file.fileName = 'DMT_NEW_APPROVED_CLIENTS_list.xlsx';
                _this.file.fileSize = _this.file.payload.byteLength;
                if (_this.file.fileSize < 1000000) {
                    _this.file.fileSize = $filter('number')(_this.file.fileSize / 1000, 2) + 'KB';
                }
                else {
                    _this.file.fileSize = $filter('number')(_this.file.fileSize / 1000000, 2) + 'MB';
                }
                _this.excel.err = false;
                _this.excel.loaded = true;
            }
            else {
                _this.err.error = true;
                _this.excel.err = true;
                _this.err.message = data.error;
            }
        });
    }
    ReportNewClients1Controller.prototype.toggle = function () {
        this.visible = !this.visible;
        if (this.visible) {
            this.exportClientExcel();
        }
    };
    ReportNewClients1Controller.prototype.exportClientExcel = function () {
        this.exportFired = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {},
                email: this.env.user.email,
                function: 'exportToExcel',
                scopeBack: 'admin.approvedList.export',
                script: 'admin/approvedlist/approved-list',
                token: this.env.user.token
            }
        });
    };
    ReportNewClients1Controller.prototype.downloadExcelSpreadsheet = function () {
        this.exportFired = true;
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        var url = window.URL.createObjectURL(new Blob([this.file.payload], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        a.setAttribute('href', url);
        var d = new Date().toDateString();
        a.setAttribute('download', "DMT-NEW-APPROVED-CLIENTS_" + d + ".xlsx");
        a.click();
        this.exportFired = false;
        this.excel.downloaded = true;
    };
    ReportNewClients1Controller.$inject = ['env', 'socket', '$scope', 'admin', 'settings', '$filter'];
    return ReportNewClients1Controller;
}());
var ReportNewClientsComponent = (function () {
    function ReportNewClientsComponent() {
        this.templateUrl = 'report-newclients.html';
        this.controller = ReportNewClients1Controller;
    }
    return ReportNewClientsComponent;
}());
angular
    .module('application')
    .component('reportNewclients', new ReportNewClientsComponent());



var bindsToShared = { vm: '=' };
var ReportingSharedController = (function () {
    function ReportingSharedController() {
        this.visibleShared = false;
    }
    ReportingSharedController.prototype.toggleShared = function () {
        if (this.visibleShared) {
            this.visibleShared = false;
        }
        else {
            this.visibleShared = true;
        }
    };
    return ReportingSharedController;
}());
var ReportingSharedComponent = (function () {
    function ReportingSharedComponent() {
        this.bindings = bindsToShared;
        this.templateUrl = 'report.shared.html';
        this.controller = ReportingSharedController;
    }
    return ReportingSharedComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('clearAll', '/public/icons/ic_clear_all_black_18px.svg');
})
    .component('reportShared', new ReportingSharedComponent());



/**
 * @fileOverview reporting.standard.component.ts - Standard Report
 * @author Ivelin Ivanov
 */
var bindsTo = { vm: '=' };
var ReportingStandardController = (function () {
    function ReportingStandardController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, notify, Dialog, settings) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.newSearch = 'Default';
        /* Component items */
        this.visibleStandard = false;
        this.openItems = false;
        this.closeItems = false;
        this.showTable = false;
        this.loadedOn = new Date();
        this.currFilter = [];
        this.dtInstance = {};
        this.checkBoxModel = {};
        this.queryId = this.$stateParams.id;
        this.isDownloading = false;
        this.filters = {};
        this.filterIots = [];
        this.filterImts = [];
        this.filterCountries = [];
        this.filterSviStatuses = [];
        this.filterStatuses = [];
        this.filterSubStatuses = [];
        this.filterOwners = [];
        this.teams = [];
        this.filterTeams = [];
        this.vapFilter = false;
        this.showFilterBtn = false;
        this.demo = {
            isOpen: false,
            count: 0,
            selectedDirection: 'right'
        };
        this.filterDetails();
        this.socket.forward('filters.getUserFilters', this.$scope);
        this.$scope.$on('socket:filters.getUserFilters', function (event, data) {
            _this.userFilters = data;
            _this.filtersExist = true;
        });
        this.socket.forward('filters.deleteProfiles', this.$scope);
        this.$scope.$on('socket:filters.deleteProfiles', function (event, data) {
            _this.userFilters = data;
            _this.allowed = false;
        });
        this.socket.forward('queue.exportQueue', this.$scope);
        this.$scope.$on('socket:queue.exportQueue', function (event, data) {
            _this.isDownloading = false;
            if (!data.payload.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.payload], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-STANDARD-Report_" + d + ".xlsx");
                a.click();
            }
        });
        this.isTeamQueue = false;
        this.showMassAsignment = false;
        this.filterToggles = {
            countries: true,
            sviStats: true,
            dmtStats: true,
            dmtSubStats: true,
            teams: false,
            vap: true
        };
    }
    ReportingStandardController.prototype.$onInit = function () {
        var that = this;
        this.dtColumns = this.buildColumns();
        this.dtOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', {
            dataSrc: function (data) {
                that.checkBoxModel = {};
                data.data.forEach(function (dmtRec) {
                    that.checkBoxModel[dmtRec.opp] = false;
                });
                return data.data;
            },
            url: '/api/queue',
            type: 'POST',
            beforeSend: function (request) {
                request.setRequestHeader('Authorization', 'Bearer ' + that.env.user.token);
            },
            data: function (d) {
                var searchCountries = '';
                if (that.filterCountries) {
                    for (var _i = 0, _a = that.filterCountries; _i < _a.length; _i++) {
                        var item = _a[_i];
                        searchCountries += item + '|';
                    }
                    searchCountries = searchCountries.substring(0, searchCountries.length - 1);
                }
                var searchSviStat = '';
                if (that.filterSviStatuses) {
                    for (var _b = 0, _c = that.filterSviStatuses; _b < _c.length; _b++) {
                        var item = _c[_b];
                        searchSviStat += item + '|';
                    }
                    searchSviStat = searchSviStat.substring(0, searchSviStat.length - 1);
                }
                var searchDmtStat = '';
                if (that.filterStatuses) {
                    for (var _d = 0, _e = that.filterStatuses; _d < _e.length; _d++) {
                        var item = _e[_d];
                        searchDmtStat += item + '|';
                    }
                    searchDmtStat = searchDmtStat.substring(0, searchDmtStat.length - 1);
                }
                var searchSubStat = '';
                if (that.filterSubStatuses) {
                    for (var _f = 0, _g = that.filterSubStatuses; _f < _g.length; _f++) {
                        var item = _g[_f];
                        searchSubStat += item + '|';
                    }
                    searchSubStat = searchSubStat.substring(0, searchSubStat.length - 1);
                }
                var searchOwner = '';
                if (that.filterOwners) {
                    for (var _h = 0, _j = that.filterOwners; _h < _j.length; _h++) {
                        var item = _j[_h];
                        searchOwner += item + '|';
                    }
                    searchOwner = searchOwner.substring(0, searchOwner.length - 1)
                        .replace('(', '\\(').replace(')', '\\)');
                }
                var searchTeam = '';
                if (that.filterTeams.length) {
                    for (var _k = 0, _l = that.filterTeams; _k < _l.length; _k++) {
                        var item = _l[_k];
                        searchTeam += item + '|';
                    }
                    searchTeam = searchTeam.substring(0, searchTeam.length - 1);
                    d.columns.push({
                        data: 'team', name: 'team', orderable: false,
                        search: { regex: true, value: searchTeam }, searchable: false
                    });
                }
                for (var _m = 0, _o = d.columns; _m < _o.length; _m++) {
                    var col = _o[_m];
                    if (searchCountries !== '' && col.name === 'country') {
                        col.search.regex = true;
                        col.search.value = searchCountries;
                    }
                    if (searchDmtStat !== '' && col.name === 'status') {
                        col.search.regex = true;
                        col.search.value = searchDmtStat;
                    }
                    if (searchSubStat !== '' && col.name === 'substatus') {
                        col.search.regex = true;
                        col.search.value = searchSubStat;
                    }
                    if (searchOwner !== '' && col.name === 'owner') {
                        col.search.regex = true;
                        col.search.value = searchOwner;
                    }
                    if (searchSviStat !== '' && col.name === 'svistat') {
                        col.search.regex = true;
                        col.search.value = searchSviStat;
                    }
                }
                d.iotFilter = that.filterIots;
                d.imtFilter = that.filterImts;
                d.queueType = 'standardreport';
                d.vapFilter = that.vapFilter;
                d.users = [("" + that.env.user.email)];
            }
        })
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('order', [4, 'asc'])
            .withPaginationType('full_numbers')
            .withOption('createdRow', createdRow);
        function createdRow(row, data, dataIndex) {
            var OFFSET = 3;
            var thresholdDate = new Date();
            thresholdDate.setHours(0, 0, 0, 0);
            thresholdDate.setDate(thresholdDate.getDate() - OFFSET);
            var createdOn = new Date(parseInt(data.created, 10));
            createdOn.setHours(0, 0, 0, 0);
            if (createdOn <= thresholdDate && data.substatus === 'Unassigned') {
                $(row).addClass('tblRow').css('color', 'red');
            }
            else {
                $(row).addClass('tblRow');
            }
            var el = angular.element;
            that.$compile(el(row).contents())(that.$scope);
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'FetchSavedFilters',
                script: '/queueservice/filterprofiles',
                user: this.env.user
            }
        });
    };
    ReportingStandardController.prototype.toggleStandard = function () {
        if (this.visibleStandard) {
            this.visibleStandard = false;
        }
        else {
            this.visibleStandard = true;
        }
    };
    ReportingStandardController.prototype.toggleOpenItems = function () {
        if (this.openItems) {
            this.openItems = false;
        }
        else {
            this.openItems = true;
        }
    };
    ReportingStandardController.prototype.toggleClosedItems = function () {
        if (this.closeItems) {
            this.closeItems = false;
        }
        else {
            this.closeItems = true;
        }
    };
    ReportingStandardController.prototype.toggleDownload = function () {
        this.isDownloading = true;
    };
    ReportingStandardController.prototype.loadReport = function () {
        if (!this.showTable) {
            this.showTable = true;
        }
        else {
            this.showTable = false;
        }
        var that = this;
        this.dtInstance.DataTable.ajax.reload();
    };
    ReportingStandardController.prototype.buildColumns = function () {
        var that = this;
        var columns = [
            this.DTColumnBuilder.newColumn('opp').withTitle('Opportunity')
                .withOption('name', 'opp').renderWith(this.linkUrl),
            this.DTColumnBuilder.newColumn('imt')
                .withOption('name', 'imt').withTitle('IMT'),
            this.DTColumnBuilder.newColumn('iot').withOption('name', 'iot').withTitle('IOT'),
            this.DTColumnBuilder.newColumn('country').withOption('name', 'country')
                .withTitle('Country'),
            this.DTColumnBuilder.newColumn('svistat').withTitle('MySA Status')
                .withOption('name', 'svistat'),
            this.DTColumnBuilder.newColumn('status').withOption('name', 'status')
                .withTitle('DMT Status'),
            this.DTColumnBuilder.newColumn('substatus').withOption('name', 'substatus')
                .withTitle('DMT Substatus'),
            this.DTColumnBuilder.newColumn('crncy').
                withOption('name', 'crncy').withTitle('Currency'),
            this.DTColumnBuilder.newColumn('bfamily')
                .withOption('name', 'bfamily').withTitle('Brand Family'),
            this.DTColumnBuilder.newColumn('bp')
                .withOption('name', 'bp').withTitle('BP'),
            this.DTColumnBuilder.newColumn('acnt')
                .withOption('name', 'acnt').withTitle('ACNT'),
        ];
        return columns;
    };
    ReportingStandardController.prototype.linkUrl = function (data, type, full, meta) {
        return '<a class="ibm-ind-link" href="" ng-click="vm.edit(' + meta.row + ')">' + data + '</a>';
    };
    ReportingStandardController.prototype.actionsHtml = function (data, type, full, meta) {
        if (this.$stateParams.id === 'workitems') {
            return "<span>\n                    <md-icon md-svg-icon=\"forbidden\"/>\n                  </span>";
        }
        else {
            return "<span>\n                <md-icon class=\"expand\" md-svg-icon=\"expand\" ng-click=\"vm.expand()\"/>\n              </span>\n              <span>\n                <md-icon class=\"collapse ng-hide\" md-svg-icon=\"collapse\" ng-click=\"vm.expand()\"/>\n              </span>";
        }
    };
    ReportingStandardController.prototype.filterDetails = function () {
        var _this = this;
        this.env.topics.imtFilterValues = this.settings.country_list;
        this.filters.iots = this.settings.iot_list;
        this.filters.imts = this.settings.imt_list;
        this.filters.countries = this.settings.getCountryList();
        this.filters.iots.sort();
        this.filters.imts.sort();
        this.filters.countries.sort();
        this.env.topics.imtFilterValues.forEach(function (value) {
            if (value.ic === 'IOT') {
                if (!_.includes(_this.filters.iots, value.imt)) {
                    _this.filters.iots.push(value.imt);
                }
            }
            else if (value.ic === 'IMT') {
                if (!_.includes(_this.filters.imts, value.imt_name)) {
                    _this.filters.imts.push(value.imt_name);
                }
            }
            else {
                if (!_.includes(_this.filters.countries, value.country)) {
                    _this.filters.countries.push(value.country);
                }
            }
        });
        this.filters.sviStatuses = this.settings.svistatuses;
        this.filters.statuses = this.settings.statuses;
        this.filters.subStatuses = this.settings.substatuses;
        this.showFilterBtn = true;
    };
    ReportingStandardController.prototype.changeFilters = function (id) {
        var _this = this;
        if (id === 'iot') {
            this.filterImts = [];
            this.filterCountries = [];
            this.filters.imts = [];
            this.filters.countries = [];
            this.env.topics.imtFilterValues.forEach(function (value) {
                if (value.ic === 'IMT') {
                    if (_.includes(_this.filterIots, value.imt) &&
                        !_.includes(_this.filters.imts, value.imt_name)) {
                        _this.filters.imts.push(value.imt_name);
                    }
                }
                else if (value.ic === 'Country') {
                    if (_.includes(_this.filterIots, value.imt) &&
                        !_.includes(_this.filters.countries, value.country)) {
                        _this.filters.countries.push(value.country);
                    }
                }
            });
            this.filters.imts.sort();
            this.filters.countries.sort();
        }
        else if (id === 'imt') {
            this.filterCountries = [];
            this.filters.countries = [];
            this.env.topics.imtFilterValues.forEach(function (value) {
                if (value.ic === 'Country') {
                    if (_.includes(_this.filterImts, value.imt_name) &&
                        !_.includes(_this.filters.countries, value.country)) {
                        _this.filters.countries.push(value.country);
                    }
                }
            });
        }
        var test = 1 + 1;
        //If the 'last used filter' is still active, re-add the values as they will have been lost
        // by the code above
        if (this.settings.up.lastFilter) {
            this.applyLastFilter(); //reset the values
        }
    };
    ReportingStandardController.prototype.applyLastFilter = function () {
        var _this = this;
        //If there is a lastFilter element in user's profile (in browser), set the
        // filters accordingly and apply them rather than loading the default (all)
        if (this.settings.up.lastFilter) {
            angular.forEach(this.settings.up.lastFilter, function (v, k) {
                _this[k] = v;
            });
            this.isFilterToggled = true;
        }
    };
    ReportingStandardController.prototype.toggleFilter = function () {
        if (this.isFilterToggled) {
            this.applyFilter();
        }
        this.isFilterToggled = !this.isFilterToggled;
    };
    ReportingStandardController.prototype.applyFilter = function () {
        if (this.filterSubStatuses.length ||
            this.filterTeams.length ||
            this.filterStatuses.length ||
            this.filterCountries.length ||
            this.filterOwners.length ||
            this.filterSviStatuses.length ||
            this.filterImts.length ||
            this.filterIots.length ||
            this.vapFilter) {
            this.isFilterSet = true;
        }
        else {
            this.isFilterSet = false;
        }
        this.dtInstance.DataTable.ajax.reload();
    };
    ReportingStandardController.prototype.clearFilter = function () {
        this.isFilterSet = false;
        this.vapFilter = false;
        this.filterSubStatuses = [];
        this.filterStatuses = [];
        this.filterOwners = [];
        this.filterCountries = [];
        this.filterSviStatuses = [];
        this.filterTeams = [];
        this.filterImts = [];
        this.filterIots = [];
        this.dtInstance.DataTable.ajax.reload();
    };
    ReportingStandardController.prototype.saveFilter = function () {
        var filterFound = false;
        if (typeof this.userFilters !== 'undefined') {
            for (var i = 0; i < this.userFilters.length; i++) {
                if (this.userFilters[i].name === this.newSearch) {
                    filterFound = true;
                    this.userFilters[i].vapFilter = this.vapFilter;
                    this.userFilters[i].filterSubStatuses = this.filterSubStatuses;
                    this.userFilters[i].filterStatuses = this.filterStatuses;
                    this.userFilters[i].filterOwners = this.filterOwners;
                    this.userFilters[i].filterCountries = this.filterCountries;
                    this.userFilters[i].filterSviStatuses = this.filterSviStatuses;
                    this.userFilters[i].filterTeams = this.filterTeams;
                    this.userFilters[i].filterImts = this.filterImts;
                    this.userFilters[i].filterIots = this.filterIots;
                    break;
                }
            }
        }
        if (!filterFound) {
            var saveSearchObj = {};
            saveSearchObj.name = this.newSearch;
            saveSearchObj.vapFilter = this.vapFilter;
            saveSearchObj.filterSubStatuses = this.filterSubStatuses;
            saveSearchObj.filterStatuses = this.filterStatuses;
            saveSearchObj.filterOwners = this.filterOwners;
            saveSearchObj.filterCountries = this.filterCountries;
            saveSearchObj.filterSviStatuses = this.filterSviStatuses;
            saveSearchObj.filterTeams = this.filterTeams;
            saveSearchObj.filterImts = this.filterImts;
            saveSearchObj.filterIots = this.filterIots;
            if (typeof this.userFilters !== 'undefined') {
                this.userFilters.push(saveSearchObj);
            }
            else {
                this.userFilters = [saveSearchObj];
            }
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'SaveFilter',
                script: '/queueservice/filterprofiles',
                user: this.env.user,
                data: this.userFilters
            }
        });
    };
    ReportingStandardController.prototype.changeSavedFilter = function (filter) {
        this.currFilter = filter;
        this.filterIots = filter.filterIots;
        this.filterImts = filter.filterImts;
        this.filterCountries = filter.filterCountries;
        this.filterSviStatuses = filter.filterSviStatuses;
        this.filterStatuses = filter.filterStatuses;
        this.filterSubStatuses = filter.filterSubStatuses;
        this.filterOwners = filter.filterOwners;
        this.filterTeams = filter.filterTeams;
    };
    ReportingStandardController.prototype.deleteProfile = function (profile) {
        this.allowed = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'deleteProfile',
                script: '/queueservice/filterprofiles',
                user: this.env.user.email,
                data: profile,
                token: this.env.user.token
            }
        });
    };
    ReportingStandardController.prototype.download = function () {
        this.isDownloading = true;
        var data = {
            queryId: 'standardreport',
            filterTeams: this.filterTeams,
            filterOwners: this.filterOwners,
            filterSubStatuses: this.filterSubStatuses,
            filterStatuses: this.filterStatuses,
            filterSviStatuses: this.filterSviStatuses,
            filterIots: this.filterIots,
            filterImts: this.filterImts,
            filterCountries: this.filterCountries,
            vapFilter: this.vapFilter
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportQueue',
                script: 'queueservice/excelbuilder',
                data: {
                    filters: data,
                    userId: this.env.user.email
                },
                token: this.env.user.token
            }
        });
    };
    ReportingStandardController.$inject = ['$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings'];
    return ReportingStandardController;
}());
var ReportingStandardComponent = (function () {
    function ReportingStandardComponent() {
        this.bindings = bindsTo;
        this.templateUrl = 'report.standard.html';
        this.controller = ReportingStandardController;
    }
    return ReportingStandardComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('clearAll', '/public/icons/ic_clear_all_black_18px.svg');
})
    .component('reportStandard', new ReportingStandardComponent());



/**
 * @fileOverview teamview.component.ts - view teams of current user , join and leave team
 * @author
 */
var TeamViewController = (function () {
    function TeamViewController($scope, socket, $state, env, $mdDialog, Dialog) {
        var _this = this;
        this.$scope = $scope;
        this.socket = socket;
        this.$state = $state;
        this.env = env;
        this.$mdDialog = $mdDialog;
        this.Dialog = Dialog;
        this.ownTeam = [];
        this.teamsAreLoaded = true;
        this.socket.forward('teamView.getTeams', this.$scope);
        this.$scope.$on('socket:teamView.getTeams', function (event, data) {
            if (data.id === 'getTeams') {
                console.info('Teams loaded =>  ', data);
                _this.allTeams = new Array();
                _this.myTeams = data.personsTeams;
                for (var _i = 0, _a = data.allTeams; _i < _a.length; _i++) {
                    var team = _a[_i];
                    if (!_this.myTeams.includes(team)) {
                        _this.allTeams.push(team);
                    }
                }
                _this.teamsAreLoaded = false;
            }
            else {
                console.error("Missing $id on Socket !");
            }
        });
        this.socket.forward('teamView.getTeamMembers', this.$scope);
        this.$scope.$on('socket:teamView.getTeamMembers', function (event, data) {
            _this.members = data.members;
            var results = {
                members: data.members,
                name: data.team
            };
            _this.Dialog.openDialog(event, results, TeamViewController, 'dialog.html', '');
        });
    }
    TeamViewController.prototype.$onInit = function () {
        console.info('Emitting socket: getTeams');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getTeams',
                script: '/teamview/teamview',
                userId: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    TeamViewController.prototype.createTeam = function () {
        if (this.teamName !== '') {
            console.info('Emitting socket CreateTeam');
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'createTeam',
                    script: '/teamview/teamview',
                    teamName: this.teamName,
                    userId: this.env.user.email,
                    type: 'create',
                    token: this.env.user.token
                }
            });
            this.teamName = '';
        }
    };
    TeamViewController.prototype.leave = function (team, ev) {
        var _this = this;
        var teamName = team;
        var confirmDialog = this.$mdDialog.confirm()
            .title('Leaving a team...')
            .textContent("Are you sure you want to leave " + teamName + " team?")
            .targetEvent(ev)
            .ok('Yes')
            .cancel('No');
        this.$mdDialog.show(confirmDialog).then(function () {
            console.log('Yes pressed');
            console.log('Emitting socket LeaveTeam');
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'leaveTeam',
                    script: '/teamview/teamview',
                    teamName: teamName,
                    userId: _this.env.user.email,
                    token: _this.env.user.token
                }
            });
        }, function () {
            console.log('No pressed');
        });
    };
    TeamViewController.prototype.join = function (team, ev) {
        var _this = this;
        var teamName = team;
        var confirmDialog = this.$mdDialog.confirm()
            .title('Joining a team...')
            .textContent("Are you sure you want to join " + teamName + " team?")
            .targetEvent(ev)
            .ok('Yes')
            .cancel('No');
        this.$mdDialog.show(confirmDialog).then(function () {
            console.log('Yes pressed');
            console.log('Emitting socket JoinTeam');
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'createTeam',
                    script: '/teamview/teamview',
                    teamName: teamName,
                    userId: _this.env.user.email,
                    type: 'join',
                    token: _this.env.user.token
                }
            });
        }, function () {
            console.log('No pressed');
        });
    };
    TeamViewController.prototype.viewMembers = function (team, ev) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getTeamMembers',
                script: '/teamview/teamview',
                teamName: team,
                token: this.env.user.token
            }
        });
    };
    TeamViewController.$inject = ['$scope', 'socket', '$state', 'env', '$mdDialog', 'Dialog'];
    return TeamViewController;
}());
var TeamViewComponent = (function () {
    function TeamViewComponent() {
        this.templateUrl = 'team.html';
        this.controllerAs = 'vm';
        this.controller = TeamViewController;
    }
    return TeamViewComponent;
}());
angular
    .module('application')
    .component('teamView', new TeamViewComponent());



var TermsController = (function () {
    function TermsController($state, $scope, socket, config, env, $localStorage, jwtHelper, $login, notify) {
        var _this = this;
        this.$state = $state;
        this.$scope = $scope;
        this.socket = socket;
        this.config = config;
        this.env = env;
        this.$localStorage = $localStorage;
        this.jwtHelper = jwtHelper;
        this.$login = $login;
        this.notify = notify;
        this.events = { confirming: false, serverError: undefined, loaded: false };
        this.socket.forward('config.terms_confirmed', this.$scope);
        this.$scope.$on('socket:config.terms_confirmed', function (event, data) {
            _this.events.confirming = false;
            if (data.error) {
                _this.events.serverError = data.error;
            }
            else {
                // Successfully updated the User Profile at the server
                _this.env.user.termsOk = true; // Update env service
                // Update browser
                document.cookie = 'io-user' + '=' + data.cookie; // Update cookie is browser's cookies
                _this.$localStorage.user = data.cookie; // as well as browser's local storage
                _this.$state.go('queue', {
                    id: _this.env.getDefaultQueue()
                });
            }
        });
        this.socket.forward('config.latest_terms', this.$scope);
        this.$scope.$on('socket:config.latest_terms', function (event, data) {
            _this.events.loaded = true;
            if (data.error) {
                _this.events.serverError = data.error;
            }
            else {
                _this.currentTerms = data.terms;
            }
        });
    }
    TermsController.prototype.$onInit = function () {
        this.config.getLatestTermsOfUse();
    };
    TermsController.prototype.confirm = function () {
        this.events.confirming = true;
        this.config.updateUserTermsConfirm(this.currentTerms.version);
    };
    TermsController.$inject = ['$state', '$scope', 'socket', 'config', 'env', '$localStorage', 'jwtHelper', '$login', 'notify'];
    return TermsController;
}());
var TermsComponent = (function () {
    function TermsComponent() {
        this.templateUrl = 'terms.html';
        this.controllerAs = 'vm';
        this.controller = TermsController;
    }
    return TermsComponent;
}());
angular
    .module('application')
    .component('termsSection', new TermsComponent());



/**
 * @author Ivan Toth.
 */
var UserProfileController = (function () {
    function UserProfileController(settings, env, admin, $scope, $q, $timeout, socket, DTS) {
        this.settings = settings;
        this.env = env;
        this.admin = admin;
        this.$scope = $scope;
        this.$q = $q;
        this.$timeout = $timeout;
        this.socket = socket;
        this.DTS = DTS;
        this.toggle = { cty: false, prg: false, pref: true, rep: false };
        this.editing = { preferences: {} };
        this.df = {
            medium: { v: 'medium', f: 'MMM d, y h:mm:ss a', e: 'Jan 5, 2016 9:05:05 AM' },
            shortDate: { v: 'shortDate', f: 'M/d/yy', e: '1/5/16' },
            custom1: { v: 'custom1', f: 'dd/MM/yyyy', e: '01/05/2016' },
            custom2: { v: 'custom2', f: 'MM/dd/yyyy', e: '05/01/2016' }
        };
        this.events = { beingSaved: false };
        this.serverError = null;
    }
    UserProfileController.prototype.getAvatar = function () {
        return this.DTS.getAvatar(this.settings.up.email, 115);
    };
    UserProfileController.prototype.$onInit = function () {
        angular.copy(this.settings.up.preferences, this.editing.preferences);
        this.editing._id = this.settings.up._id;
    };
    /**
     * save - Function triggered when user clicks the Save button.
     *
     * @param  {type} event: any Browser event for the benefit of the display prompts (if needed)
     */
    UserProfileController.prototype.save = function (event) {
        var _this = this;
        this.events.beingSaved = true; //set flag to disable save button
        this.serverError = null;
        var saveBundle = { data: this.editing, changelog: null };
        //Make the call via a promise which will wait up to 30 seconds for a response
        this.savePromise(saveBundle).then(function (data) {
            //If response from server received
            _this.events.beingSaved = false; //enable save again
            if (data.error) {
                _this.serverError = data.error;
            }
            else {
                //this.admin.navigate('admin.users-view');
                //update the object in settings which will now be out of date...could reload, I spose...
                angular.copy(_this.editing.preferences, _this.settings.up.preferences);
            }
        }, function (nothingReturnedInTime) {
            //If no response from server received
            _this.events.beingSaved = false; //enable save again
            _this.serverError = 'The server does not appear to be responding, or did not respond in a reasonable time.';
        });
    };
    UserProfileController.prototype.savePromise = function (saveBundle) {
        var _this = this;
        this.deferred = this.$q.defer(); //Set deferred object...to be sent to browser
        this.$timeout(function () {
            _this.deferred.reject([]); //If not resolved within 3 seconds...reject
        }, 30000); //30 secs
        this.admin.updateUserProfile(saveBundle);
        // TO DO
        this.socket.forward('config.user_update', this.$scope);
        this.$scope.$on('socket:config.user_update', function (event, data) {
            _this.deferred.resolve(data); //add the results to the deferred object
        });
        return this.deferred.promise; //fire off the promise
    };
    UserProfileController.$inject = ['settings', 'env', 'admin', '$scope', '$q', '$timeout', 'socket', 'DTS'];
    return UserProfileController;
}());
var UserProfileComponent = (function () {
    function UserProfileComponent() {
        this.templateUrl = 'userprofile.html';
        this.controllerAs = 'vm';
        this.controller = UserProfileController;
    }
    return UserProfileComponent;
}());
angular
    .module('application')
    .component('userProfileSection', new UserProfileComponent());



var ApproveListController = (function () {
    function ApproveListController(settings, env, $compile, $filter, socket, $scope, Dialog, notify, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$compile = $compile;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.notify = notify;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this.DTColumnDefBuilder = DTColumnDefBuilder;
        this.clientsLoaded = false;
        this.importingExcel = false;
        this.exportFired = false;
        this.isSaving = false;
        this.processing = true;
        this.clientItems = [];
        this.docTable = [];
        this.historyInfo = {};
        this.backendModuleName = 'admin/approvedlist/approved-list';
        this.scopePrefix = 'admin.approvedList';
        this.scopeGetData = this.scopePrefix + ".query";
        this.scopeGetLogs = this.scopePrefix + ".logs";
        this.scopeUpdateLogs = this.scopePrefix + ".logsUpdate";
        this.scopeUpdateRecord = this.scopePrefix + ".update";
        this.scopeCreateRecord = this.scopePrefix + ".insert";
        this.scopeDeleteRecord = this.scopePrefix + ".delete";
        this.scopeDeleteAll = this.scopePrefix + ".deleteall";
        this.scopeExport = this.scopePrefix + ".export";
        this.scopeExportTemplate = this.scopePrefix + ".exportTemplate";
        this.scopeImportFromExcel = this.scopePrefix + ".importFromExcel";
        this.scopeReplaceFromExcel = this.scopePrefix + ".replaceAllFromExcel";
        this.table = {
            dtColumns: {},
            dtInstance: {},
            filter: false,
            filterParams: {},
            filters: { BP: '' },
            search: '',
            select_options: {},
            visible: 0
        };
        this.historyTable = {
            instance: {}
        };
        this.historyInfo = {
            bpCeidInfo: '',
            customerNumberInfo: ''
        };
        this.historyTable.options = this.DTOptionsBuilder
            .newOptions()
            .withIBMTheme()
            .withOption('stateSave', true)
            .withOption('ordering', false)
            .withOption('searchDelay', 350)
            .withOption('alphabetColumnIndex', 2);
        this.historyTable.columnDefs = [];
        //GET HISTORY
        this.socket.forward(this.scopeGetLogs, this.$scope);
        this.$scope.$on("socket:" + this.scopeGetLogs, function (event, data) {
            if (data.payload.logs) {
                _this.docTable = data.payload.logs.reverse();
            }
        });
        //UPDATED HISTORY
        this.socket.forward(this.scopeUpdateLogs, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateLogs, function (event, data) {
            _this.getHistory();
        });
        // UPDATE
        this.socket.forward(this.scopeUpdateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateRecord, function (event, data) {
            _this.isSaving = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Update record');
                return _this.notify.error("Unable to update record");
            }
            else {
                _this.notify.success('Client list updated successful!');
                _this.sendNewHistoryLog('Edited record');
                return _this.initFunction();
            }
        });
        // CREATE
        this.socket.forward(this.scopeCreateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeCreateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Create record');
                return _this.notify.error("Unable to create record");
            }
            else {
                _this.notify.success('Client was added successful!');
                _this.sendNewHistoryLog('Created record');
                return _this.initFunction();
            }
        });
        // DELETE
        this.socket.forward(this.scopeDeleteRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Delete record');
                return _this.notify.error("Unable to delete record");
            }
            else {
                _this.notify.success('Record was deleted successful!');
                _this.sendNewHistoryLog('Deleted record');
                return _this.initFunction();
            }
        });
        // DELETE ALL
        this.socket.forward(this.scopeDeleteAll, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteAll, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Delete all records');
                return _this.notify.error("Unable to delete all records");
            }
            else {
                _this.notify.success('All records was deleted successful!');
                _this.sendNewHistoryLog('Deleted all records');
                return _this.initFunction();
            }
        });
        // DOWNLOAD EXCEL
        this.socket.forward(this.scopeExport, this.$scope);
        this.$scope.$on("socket:" + this.scopeExport, function (event, data) {
            _this.exportFired = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Exporting list');
                return _this.notify.error("Can't to export list");
            }
            else {
                _this.downloadFile(data.payload, 'DMT-NEW-APPROVED-CLIENTS');
                return _this.notify.success('New clients list was exported successful!');
            }
        });
        // DOWNLOAD EXCEL TEMPLATE
        this.socket.forward(this.scopeExportTemplate, this.$scope);
        this.$scope.$on("socket:" + this.scopeExportTemplate, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Exporting template');
                return _this.notify.error("Can't to export latest template");
            }
            else {
                _this.downloadFile(data.payload, 'DMT-NEW-APPROVED-CLIENTS-template');
                return _this.notify.success('New clients list latest template downloaded successful!');
            }
        });
        // UPLOADADED
        this.socket.forward(this.scopeImportFromExcel, this.$scope);
        this.$scope.$on("socket:" + this.scopeImportFromExcel, function (event, data) {
            _this.importingExcel = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Upload and Add from Excel');
                _this.notify.error("Can't to upload and add from Excel");
                _this.sendNewHistoryLog("Upload from .xlsx and added. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
            else {
                _this.notify.success('Uploaded and add from Excel successful!');
                _this.sendNewHistoryLog("Upload from .xlsx and added. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
        });
        // UPLOAD REPLACE
        this.socket.forward(this.scopeReplaceFromExcel, this.$scope);
        this.$scope.$on("socket:" + this.scopeReplaceFromExcel, function (event, data) {
            _this.importingExcel = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Upload and Replace from Excel');
                _this.notify.error("Can't to upload and replace from Excel");
                _this.sendNewHistoryLog("Upload from .xlsx and replaced. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
            else {
                _this.notify.success('Uploaded and replace from Excel successful!');
                _this.sendNewHistoryLog("Upload from .xlsx and replaced. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
        });
    }
    ApproveListController.prototype.$onInit = function () {
        var _this = this;
        this.signalWrongResponse = '';
        this.table.dtColumns = this.buildColumns();
        this.table.dtOptions = this.DTOptionsBuilder.newOptions()
            .withIBMTheme()
            .withOption('alphabetColumnIndex', 3)
            .withOption('ajax', this.buildAjaxOption())
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('order', [[3, 'asc']]) // Default sorting by BP name
            .withPaginationType('full_numbers')
            .withOption('createdRow', function (row) {
            _this.$compile(angular.element(row).contents())(_this.$scope);
        })
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
        this.getHistory();
    };
    ApproveListController.prototype.buildAjaxOption = function () {
        var _this = this;
        return {
            url: '/api/admin/approved-list',
            // tslint:disable-next-line:object-literal-sort-keys
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                _this.clientsLoaded = false;
                request.setRequestHeader('Authorization', "Bearer " + _this.env.user.token);
            },
            data: function (draw) {
                var dt = _this.table.dtInstance.DataTable;
                if (dt && dt.context && Array.isArray(dt.context)) {
                    draw.alphabetSearch = dt.context[0].alphabetSearch;
                }
            },
            dataSrc: function (data) {
                _this.clientItems = data.data;
                _this.clientsLoaded = true;
                _this.processing = false;
                return data.data;
            }, error: function (xhr, errorMessage, thrown) {
                // Display message, when an error appears
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve New Client Approved list data from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (xhr.responseText) {
                    items.message += "<b>" + xhr.responseText + "</b>\n                    <br>Please try again, if the problem persists contact the DMT System Administrators";
                }
                else {
                    if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                        items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b><br>';
                    }
                    items.message += "<b style=\"color:red\">" + errorMessage + "/" + thrown + "</b><br><br>\n                    This is usually a temporary problem.\n                    &nbsp;Please try again, if the problem persists contact the DMT System Administrators";
                }
                _this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
                    _this.signalWrongResponse = items.message.replace(new RegExp('<br><br>', 'g'), ' ');
                });
                // Turns off the processing bar
                _this.clientsLoaded = true;
                _this.importingExcel = false;
                $('#table_processing').hide();
            }
        };
    };
    ApproveListController.prototype.buildColumns = function () {
        var _this = this;
        var DATE_FORMAT = 'd MMM yyyy';
        return [
            this.DTColumnBuilder.newColumn('IOT').notSortable()
                .withOption('name', 'IOT').withTitle('IOT'),
            this.DTColumnBuilder.newColumn('IMT').notSortable()
                .withOption('name', 'IMT').withTitle('IMT'),
            this.DTColumnBuilder.newColumn('COUNTRY_NAME').notSortable()
                .withOption('name', 'COUNTRY_NAME').withTitle('Country name'),
            this.DTColumnBuilder.newColumn('BP').notSortable()
                .withOption('name', 'BP').withTitle('BP name'),
            this.DTColumnBuilder.newColumn('BP_CEID').notSortable()
                .withOption('name', 'BP_CEID').withTitle('BP CEID'),
            this.DTColumnBuilder.newColumn('CUSTOMER_NAME').notSortable()
                .withOption('name', 'CUSTOMER_NAME').withTitle('Customer name'),
            this.DTColumnBuilder.newColumn('CUSTOMER_NUMBER').notSortable()
                .withOption('name', 'CUSTOMER_NUMBER').withTitle('Customer number'),
            this.DTColumnBuilder.newColumn('START_DATE').notSortable()
                .withOption('name', 'START_DATE').withTitle('Start date').renderWith(function (data) {
                return _this.$filter('date')(new Date(data), DATE_FORMAT);
            }),
            this.DTColumnBuilder.newColumn('APPROVAL_DATE').notSortable()
                .withOption('name', 'APPROVAL_DATE').withTitle('Approval date').renderWith(function (data) {
                return _this.$filter('date')(new Date(data), DATE_FORMAT);
            }),
            this.DTColumnBuilder.newColumn('END_DATE').notSortable()
                .withOption('name', 'END_DATE').withTitle('End date').renderWith(function (data) {
                return _this.$filter('date')(new Date(data), DATE_FORMAT);
            }),
            this.DTColumnBuilder.newColumn('OPPORTUNITY_NUMBER').notSortable()
                .withOption('name', 'OPPORTUNITY_NUMBER').withTitle('Opportunity number'),
            this.DTColumnBuilder.newColumn('actions').notSortable()
                .withOption('name', 'actions').withTitle('Actions').renderWith(this.actionButtons)
        ];
    };
    ApproveListController.prototype.actionButtons = function (data, type, full, meta) {
        return "<md-button class=\"edit-button md-button md-ink-ripple\" ng-click=\"vm.editClient($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Edit\">\n                <md-icon class=\"black_icon\" md-svg-icon='edit_pen'></md-icon>\n        </md-button>\n\n        <md-button class=\"delete-button md-button md-ink-ripple\" ng-click=\"vm.deleteClient($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Delete\">\n                <md-icon md-svg-icon='delete'></md-icon>\n        </md-button>";
    };
    /**
     * Function to handle all errors
     */
    ApproveListController.prototype.isIncomingErrors = function (data) {
        if (!data || !data.error) {
            return false;
        }
        if (data.error.validationErrors.length || data.error.errors.length) {
            return true;
        }
    };
    /**
     * Function to show all errors
     */
    ApproveListController.prototype.handleIncomingErrors = function (data, name) {
        var allErrorsInfo = {
            allErrors: data,
            windowName: name
        };
        this.Dialog.showingErrors(event, allErrorsInfo, 'showing-errors.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
        return;
    };
    /**
     * Function to download files
     */
    ApproveListController.prototype.downloadFile = function (file, name) {
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        var url = window.URL.createObjectURL(new Blob([file], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        a.setAttribute('href', url);
        var d = new Date().toDateString();
        a.setAttribute('download', name + " " + d + ".xlsx");
        a.click();
    };
    /**
     * Function to prepare the DB info for export
     */
    ApproveListController.prototype.exportNewClientPermissions = function () {
        this.exportFired = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {},
                email: this.env.user.email,
                function: 'exportToExcel',
                scopeBack: this.scopeExport,
                script: this.backendModuleName,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to extract country
     */
    ApproveListController.prototype.extractCountry = function () {
        var result = this.settings.country_list.filter(function (el) { return el.ic === 'Country'; }).reduce(function (r, country) {
            r.tree[country.imt] = r.tree[country.imt] || {};
            r.tree[country.imt][country.imt_name] = r.tree[country.imt][country.imt_name] || [];
            r.tree[country.imt][country.imt_name].push(country.country);
            r.tree[country.imt][country.imt_name].sort();
            r.imts[country.imt] = r.imts[country.imt] || [];
            r.imts[country.imt].push(country.imt_name);
            r.imts[country.imt] = _.uniq(r.imts[country.imt]);
            r.imts[country.imt].sort();
            return r;
        }, { tree: {}, imts: {} });
        return result;
    };
    /**
     * Function to create new client in DB
     */
    ApproveListController.prototype.createRecord = function (event) {
        var _this = this;
        var tit = 'Add record to existing list';
        var result = this.extractCountry();
        var endDate = new Date();
        endDate.setFullYear(endDate.getFullYear() + 1);
        var items = {
            icon: 'QUESTION',
            message: 'Are you sure, you want to add records to existing list?',
            title: tit,
            tree: result.tree,
            iots: Object.keys(result.tree).sort(),
            imts: result.imts,
            newClient: {
                iot: '-Please select-',
                imt: '-Please select-',
                country: '-Please select-',
                bp: '',
                bp_ceid: '',
                customer_name: '',
                customer_number: '',
                start_date: new Date(),
                end_date: endDate,
                approval_date: new Date(),
                opportunity_number: ''
            },
            listIOTs: function (tree) { return Object.keys(tree).sort(); },
            listIMTs: function (tree, iot) { return Object.keys(tree[iot] || {}).sort(); },
            listCountries: function (tree, iot, imt) { return (tree[iot] || {})[imt] || []; }
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.Dialog.updateValidForm(event, items, 'newclient-insert.html').then(function (answer) {
                    items.newClient = answer.newClient;
                    items.newClient.start_date = items.newClient.start_date.getFullYear() + '-' + (items.newClient.start_date.getMonth() + 1) + '-' + items.newClient.start_date.getDate();
                    items.newClient.end_date = items.newClient.end_date.getFullYear() + '-' + (items.newClient.end_date.getMonth() + 1) + '-' + items.newClient.end_date.getDate();
                    items.newClient.approval_date = items.newClient.approval_date.getFullYear() + '-' + (items.newClient.approval_date.getMonth() + 1) + '-' + items.newClient.approval_date.getDate();
                    items.newClient.country = _this.settings.country_list.filter(function (num) { return num.country === items.newClient.country; })[0].short;
                    _this.socket.emit('module', {
                        module: {
                            application: 'dmt',
                            data: items.newClient,
                            function: 'insertRecord',
                            scopeBack: _this.scopeCreateRecord,
                            script: _this.backendModuleName,
                            token: _this.env.user.token,
                            email: _this.env.user.email
                        }
                    });
                    _this.historyInfo.bpCeidInfo = items.newClient.bp_ceid;
                    _this.historyInfo.customerNumberInfo = items.newClient.customer_number;
                });
            }
        });
        return;
    };
    ApproveListController.prototype.getClientById = function (id) {
        return this.clientItems.find(function (cl) { return cl['ID'] === id; });
    };
    /**
     * Function to edit exist client in DB
     */
    ApproveListController.prototype.editClient = function (event, rowId) {
        var _this = this;
        var idx = this.clientItems[rowId].ID;
        var editableClient = this.getClientById(idx);
        var result = this.extractCountry();
        var updatedData = {
            tree: result.tree,
            iots: Object.keys(result.tree).sort(),
            imts: result.imts,
            content: {
                id: editableClient['ID'],
                iot: editableClient['IOT'],
                imt: editableClient['IMT'],
                country: editableClient['COUNTRY_NAME'],
                bp: editableClient['BP'],
                bp_ceid: editableClient['BP_CEID'],
                customer_name: editableClient['CUSTOMER_NAME'],
                customer_number: editableClient['CUSTOMER_NUMBER'],
                start_date: new Date(editableClient['START_DATE']),
                end_date: new Date(editableClient['END_DATE']),
                approval_date: new Date(editableClient['APPROVAL_DATE']),
                opportunity_number: editableClient['OPPORTUNITY_NUMBER']
            },
            listIOTs: function (tree) { return Object.keys(tree).sort(); },
            listIMTs: function (tree, iot) { return Object.keys(tree[iot] || {}).sort(); },
            listCountries: function (tree, iot, imt) { return (tree[iot] || {})[imt] || []; }
        };
        this.Dialog.updateValidForm(event, updatedData, 'client-edit.html').then(function (dResult) {
            updatedData.content.start_date = updatedData.content.start_date.getFullYear() + '-' + (updatedData.content.start_date.getMonth() + 1) + '-' + updatedData.content.start_date.getDate();
            updatedData.content.end_date = updatedData.content.end_date.getFullYear() + '-' + (updatedData.content.end_date.getMonth() + 1) + '-' + updatedData.content.end_date.getDate();
            updatedData.content.approval_date = updatedData.content.approval_date.getFullYear() + '-' + (updatedData.content.approval_date.getMonth() + 1) + '-' + updatedData.content.approval_date.getDate();
            updatedData.content.country = _this.settings.country_list.filter(function (num) { return num.country === updatedData.content.country; })[0].short;
            _this.isSaving = true;
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: updatedData.content,
                    function: 'updateRecord',
                    scopeBack: _this.scopeUpdateRecord,
                    script: _this.backendModuleName,
                    token: _this.env.user.token,
                    email: _this.env.user.email
                }
            });
            _this.historyInfo.bpCeidInfo = updatedData.content.bp_ceid;
            _this.historyInfo.customerNumberInfo = updatedData.content.customer_number;
        });
        return;
    };
    /**
     * Function to delete client in DB
     */
    ApproveListController.prototype.deleteClient = function (event, rowId) {
        var _this = this;
        var idx = this.clientItems[rowId].ID;
        var removableClient = {};
        this.Dialog.confirmDelete(event, idx).then(function (dResult) {
            if (dResult) {
                removableClient = _this.getClientById(idx);
                var deletedData = {
                    id: removableClient['ID']
                };
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: deletedData,
                        function: 'deleteRecord',
                        scopeBack: _this.scopeDeleteRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token,
                        email: _this.env.user.email
                    }
                });
            }
            _this.historyInfo.bpCeidInfo = removableClient['BP_CEID'];
            _this.historyInfo.customerNumberInfo = removableClient['CUSTOMER_NUMBER'];
        });
        return;
    };
    /**
     * Function to delete all clients in DB
     */
    ApproveListController.prototype.deleteAllClients = function (event) {
        var _this = this;
        this.Dialog.confirmDelete(event).then(function (dResult) {
            if (dResult) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'deleteAllRecords',
                        scopeBack: _this.scopeDeleteAll,
                        script: _this.backendModuleName,
                        token: _this.env.user.token,
                        email: _this.env.user.email
                    }
                });
            }
        });
        return;
    };
    /**
     * Function to upload new clients list
     */
    ApproveListController.prototype.uploadNewClientsList = function (event) {
        var _this = this;
        var tit = 'Upload new list';
        var items = {
            icon: 'QUESTION',
            message: 'Do you want to add items to existing records or replace the existing list?',
            title: tit
        };
        this.Dialog.updateValidForm(event, items, 'newclient-update-add.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.uploadFilesAdd(dResult.data[0]);
            }
            else {
                var tit1 = 'Replace existing list';
                var items1 = {
                    icon: 'QUESTION',
                    message: 'Are you sure you want to completely replace the existing list?',
                    title: tit1
                };
                _this.Dialog.updateValidForm(event, items1, 'newclient-update-replace.html').then(function (dResult1) {
                    if (dResult1.confirm) {
                        _this.uploadFilesReplace(dResult1.data[0]);
                    }
                });
            }
        });
        return;
    };
    /**
     * Functions to prepare the files for file upload ADD
     */
    ApproveListController.prototype.uploadFilesAdd = function (file) {
        if (file) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: file,
                    function: 'importFromExcel',
                    scopeBack: this.scopeImportFromExcel,
                    script: this.backendModuleName,
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
        this.importingExcel = true;
    };
    /**
     * Functions to prepare the files for file upload REPLACE
     */
    ApproveListController.prototype.uploadFilesReplace = function (file) {
        if (file) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: file,
                    function: 'replaceAllFromExcel',
                    scopeBack: this.scopeReplaceFromExcel,
                    script: this.backendModuleName,
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
        this.importingExcel = true;
    };
    /**
     * Function to download clients list template
     */
    ApproveListController.prototype.downloadClientsListTemplate = function (event) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'downloadExcelTemplate',
                scopeBack: this.scopeExportTemplate,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to get all records in DB2
     */
    ApproveListController.prototype.initFunction = function () {
        this.table.dtInstance.DataTable.ajax.reload(null, true);
    };
    /**
     * Function to get all history from Cloudant
     */
    ApproveListController.prototype.getHistory = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getHistoryLogs',
                scopeBack: this.scopeGetLogs,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to send updated history to Cloudant
     */
    ApproveListController.prototype.sendNewHistoryLog = function (operation) {
        var timeStamp = new Date();
        var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
        var oneHist = {
            comment: (operation === 'Deleted record' || operation === 'Edited record' || operation === 'Created record') ?
                [(operation + " with bp_ceid: " + this.historyInfo.bpCeidInfo + " and customer number: " + this.historyInfo.customerNumberInfo)] :
                [("" + operation)],
            timestamp: timeText,
            user: this.env.user.email
        };
        this.docTable.reverse().push(oneHist);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateHistoryLogs',
                scopeBack: this.scopeUpdateLogs,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token,
                data: this.docTable
            }
        });
    };
    ApproveListController.prototype.openActionMenu = function ($mdOpenMenu, event) {
        $mdOpenMenu(event);
    };
    ApproveListController.prototype.resetFilters = function () {
        delete this.table.filters;
        this.table.filterParams = {};
    };
    ApproveListController.$inject = [
        'settings',
        'env',
        '$compile',
        '$filter',
        'socket',
        '$scope',
        'Dialog',
        'notify',
        'DTOptionsBuilder',
        'DTColumnBuilder',
        'DTColumnDefBuilder'
    ];
    return ApproveListController;
}());
var ApproveListComponent = (function () {
    function ApproveListComponent() {
        this.templateUrl = 'approved-list.html';
        this.controllerAs = 'vm';
        this.controller = ApproveListController;
    }
    return ApproveListComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider.icon("edit_pen", "/public/icons/ic_mode_edit_black_24px.svg");
})
    .filter("fullDateToFormat", function ($filter) {
    return function (input, format) {
        return $filter("date")(new Date(input), format);
    };
})
    .component('approvedListSection', new ApproveListComponent());



var DEFAULT_SELECTION = '-Please select-';
var BPMergersController = (function () {
    function BPMergersController(settings, env, $compile, $filter, socket, $scope, Dialog, notify, DTOptionsBuilder, DTColumnBuilder) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$compile = $compile;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.notify = notify;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this.processing = false;
        this.bpMergersDataLoaded = false;
        this.importingExcel = false;
        this.TEMPLATE_CONFIRM = 'confirm-prompt.html';
        this.exportFired = false;
        this.tableItems = [];
        this.historyTable = {};
        this.docTable = [];
        this.backendModuleName = 'admin/bpMergers/index';
        this.scopePrefix = 'admin.bpMergers';
        this.scopeGetLogs = this.scopePrefix + ".getLogs";
        this.scopeDeleteRecord = this.scopePrefix + ".delete";
        this.scopeUpdateRecord = this.scopePrefix + ".update";
        this.scopeCreateRecord = this.scopePrefix + ".insert";
        this.scopeExport = this.scopePrefix + ".export";
        this.table = {
            dtColumns: {},
            dtInstance: {},
            search: '',
            select_options: {},
            visible: 0
        };
        this.historyTable = {
            instance: {}
        };
        this.historyTable.options = this.DTOptionsBuilder
            .newOptions()
            .withIBMTheme()
            .withOption('stateSave', true)
            .withOption('ordering', false)
            .withOption('searchDelay', 350)
            .withOption('alphabetColumnIndex', 2);
        this.historyTable.columnDefs = [];
        // CREATE
        this.socket.forward(this.scopeCreateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeCreateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Creating BP Mergers record');
                _this.notify.error("Unable to create a BP Mergers record");
            }
            else {
                _this.notify.success('BP Mergers record successfuly added');
                _this.getHistory();
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // DELETE
        this.socket.forward(this.scopeDeleteRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Deleting BP Mergers record');
                _this.notify.error("Unable to delete BP Mergers record");
            }
            else {
                _this.notify.success('BP Mergers record was deleted successful');
                _this.getHistory();
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // UPDATE
        this.socket.forward(this.scopeUpdateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Updating BP Mergers record');
                _this.notify.error("Unable to update BP Mergers record");
            }
            else {
                _this.notify.success('BP Mergers record successfuly updated');
                _this.getHistory();
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        //GET HISTORY
        this.socket.forward(this.scopeGetLogs, this.$scope);
        this.$scope.$on("socket:" + this.scopeGetLogs, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Loading BP Mergers log records');
                _this.notify.error("Unable to extract BP Mergers log records");
            }
            else {
                if (data) {
                    _this.docTable = data.reverse();
                }
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // DOWNLOAD EXCEL
        this.socket.forward(this.scopeExport, this.$scope);
        this.$scope.$on("socket:" + this.scopeExport, function (event, data) {
            _this.exportFired = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Exporting list');
                return _this.notify.error("Can't to export list");
            }
            else {
                _this.downloadFile(data, 'DMT-BP-Mergers');
                _this.notify.success('BP Mergers was exported successful');
                _this.getHistory();
            }
        });
    }
    /**
     * Function to delete a row in DB
     */
    BPMergersController.prototype.deleteRow = function (event, rowId) {
        var _this = this;
        var idx = this.tableItems[rowId].ID;
        var removableClient = {};
        this.Dialog.confirmDelete(event, idx).then(function (dResult) {
            if (dResult) {
                removableClient = _this.getClientById(idx);
                var deletedData = {
                    id: removableClient.ID
                };
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: deletedData,
                        email: _this.env.user.email,
                        function: 'deleteRecord',
                        scopeBack: _this.scopeDeleteRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token
                    }
                });
            }
        });
    };
    /**
     * Function to insert a row in DB
     */
    BPMergersController.prototype.createRecord = function (event) {
        var _this = this;
        var item = {
            bpMergers: {
                bpCountry: '-Please select-',
                bpLosingCEID: '',
                bpLosingName: '',
                bpWinningCEID: '',
                bpWinningName: ''
            },
            icon: 'QUESTION',
            label: 'Add record to existing list',
            listCountries: this.extractCountry(),
            message: 'Are you sure, you want to add a new record to existing list?'
        };
        this.Dialog.updateValidForm(event, item, this.TEMPLATE_CONFIRM)
            .then(function (dResult) {
            if (dResult.confirm) {
                _this.Dialog.updateValidForm(event, item, 'bpmergers-create.html')
                    .then(function (answer) {
                    item.bpMergers = answer.bpMergers;
                    item.bpMergers.longBPCountryName = item.bpMergers.bpCountry;
                    item.bpMergers.bpCountry = _this.takeShortCountry(item.bpMergers.bpCountry);
                    _this.socket.emit('module', {
                        module: {
                            application: 'dmt',
                            data: item.bpMergers,
                            email: _this.env.user.email,
                            function: 'insertNewRecord',
                            scopeBack: _this.scopeCreateRecord,
                            script: _this.backendModuleName,
                            token: _this.env.user.token
                        }
                    });
                });
            }
        });
        return;
    };
    /**
     * Function to update a row in DB
     */
    BPMergersController.prototype.editClient = function (event, rowId) {
        var _this = this;
        var idx = this.tableItems[rowId].ID;
        var editableClient = this.getClientById(idx);
        var tit = 'Update BP Mergers record';
        var updatedData = {
            content: {
                bpCountry: editableClient.BP_COUNTRY,
                id: editableClient.ID,
                losingBPCeid: editableClient.LOSING_BP_CEID,
                losingBPName: editableClient.LOSING_BP_NAME,
                winningBPCeid: editableClient.WINNING_BP_CEID,
                winningBPName: editableClient.WINNING_BP_NAME
            },
            label: tit,
            listCountries: this.extractCountry()
        };
        this.Dialog.updateValidForm(event, updatedData, 'bpmergers-edit.html')
            .then(function (dResult) {
            var dataForUpdate = updatedData.content;
            dataForUpdate.longBPCountryName = updatedData.content.bpCountry;
            dataForUpdate.bpCountry = _this.takeShortCountry(updatedData.content.bpCountry);
            var originalDataUpdate = {
                bpCountry: _this.takeShortCountry(editableClient.BP_COUNTRY),
                id: editableClient.ID,
                longBPCountryName: editableClient.BP_COUNTRY,
                losingBPCeid: editableClient.LOSING_BP_CEID,
                losingBPName: editableClient.LOSING_BP_NAME,
                winningBPCeid: editableClient.WINNING_BP_CEID,
                winningBPName: editableClient.WINNING_BP_NAME
            };
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: dataForUpdate,
                    email: _this.env.user.email,
                    function: 'updateRecord',
                    originalData: originalDataUpdate,
                    scopeBack: _this.scopeUpdateRecord,
                    script: _this.backendModuleName,
                    token: _this.env.user.token
                }
            });
        });
    };
    /**
     * Function to prepare the DB info for export
     */
    BPMergersController.prototype.exportBPMergers = function () {
        this.exportFired = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {},
                email: this.env.user.email,
                function: 'exportToExcel',
                scopeBack: this.scopeExport,
                script: this.backendModuleName,
                token: this.env.user.token
            }
        });
    };
    BPMergersController.prototype.$onInit = function () {
        var _this = this;
        this.table.dtColumns = this.buildColumns();
        this.table.dtOptions = this.DTOptionsBuilder.newOptions()
            .withIBMTheme()
            .withOption('alphabetColumnIndex', 1)
            .withOption('ajax', this.buildAjaxOption())
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('order', [[1, 'asc']]) // Default sorting by 2nd column
            .withPaginationType('full_numbers')
            .withOption('createdRow', function (row) {
            _this.$compile(angular.element(row).contents())(_this.$scope);
        })
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
        this.getHistory();
    };
    BPMergersController.prototype.buildAjaxOption = function () {
        var _this = this;
        return {
            beforeSend: function (request) {
                _this.processing = true;
                _this.bpMergersDataLoaded = false;
                request.setRequestHeader('Authorization', "Bearer " + _this.env.user.token);
            },
            data: function (draw) {
                var dt = _this.table.dtInstance.DataTable;
                if (dt && dt.context && Array.isArray(dt.context)) {
                    draw.alphabetSearch = dt.context[0].alphabetSearch;
                }
            },
            dataSrc: function (data) {
                _this.bpMergersDataLoaded = true;
                _this.tableItems = data.data;
                _this.processing = false;
                return data.data;
            },
            error: function (xhr, errorMessage, thrown) {
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve BP Mergers data from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (xhr.responseText) {
                    items.message += "<b>" + xhr.responseText + "</b>\n                    <br>Please try again, if the problem persists contact the DMT System Administrators";
                }
                else {
                    if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                        items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b><br>';
                    }
                    items.message += "<b style=\"color:red\">" + errorMessage + "/" + thrown + "</b><br><br>\n                    This is usually a temporary problem.\n                    &nbsp;Please try again, if the problem persists contact the DMT System Administrators";
                }
                _this.bpMergersDataLoaded = true;
                _this.importingExcel = false;
                $('#table_processing').hide();
            },
            type: 'POST',
            url: '/api/admin/bp-mergers'
        };
    };
    BPMergersController.prototype.buildColumns = function () {
        return [
            this.DTColumnBuilder.newColumn('BP_COUNTRY').notSortable()
                .withOption('name', 'BP_COUNTRY').withTitle('BP Country'),
            this.DTColumnBuilder.newColumn('LOSING_BP_CEID').notSortable()
                .withOption('name', 'LOSING_BP_CEID').withTitle('Losing BP CEID'),
            this.DTColumnBuilder.newColumn('LOSING_BP_NAME').notSortable()
                .withOption('name', 'LOSING_BP_NAME').withTitle('Losing BP Name'),
            this.DTColumnBuilder.newColumn('WINNING_BP_CEID').notSortable()
                .withOption('name', 'WINNING_BP_CEID').withTitle('Winning BP CEID'),
            this.DTColumnBuilder.newColumn('WINNING_BP_NAME').notSortable()
                .withOption('name', 'WINNING_BP_NAME').withTitle('Winning BP Name'),
            this.DTColumnBuilder.newColumn('actions').notSortable()
                .withOption('name', 'actions').withTitle('Actions').renderWith(this.actionButtons)
        ];
    };
    BPMergersController.prototype.actionButtons = function (data, type, full, meta) {
        return "<md-button class=\"edit-button md-button md-ink-ripple\" ng-click=\"vm.editClient($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Edit\">\n                <md-icon class=\"black_icon\" md-svg-icon='edit_pen'></md-icon>\n        </md-button>\n\n        <md-button class=\"delete-button md-button md-ink-ripple\" ng-click=\"vm.deleteRow($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Delete\">\n                <md-icon md-svg-icon='delete'></md-icon>\n        </md-button>";
    };
    /**
     * Function to get all history from Cloudant
     */
    BPMergersController.prototype.getHistory = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                email: this.env.user.email,
                function: 'getBPMergersLogsData',
                scopeBack: this.scopeGetLogs,
                script: this.backendModuleName,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to download files
     */
    BPMergersController.prototype.downloadFile = function (file, name) {
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        var url = window.URL.createObjectURL(new Blob([file], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        a.setAttribute('href', url);
        var d = new Date().toDateString();
        a.setAttribute('download', name + " " + d + ".xlsx");
        a.click();
    };
    BPMergersController.prototype.getClientById = function (id) {
        return this.tableItems.find(function (item) { return item['ID'] === id; });
    };
    /**
     * Function to extract country
     */
    BPMergersController.prototype.extractCountry = function () {
        return this.settings.country_list.map(function (el) { return el.country; });
    };
    BPMergersController.prototype.takeShortCountry = function (longCountryName) {
        return _.find(this.settings.country_list, ['country', longCountryName]).short;
    };
    /**
     * Function to handle all errors
     */
    BPMergersController.prototype.isIncomingErrors = function (data) {
        return data && data.error;
    };
    /**
     * Function to show all errors
     */
    BPMergersController.prototype.handleIncomingErrors = function (data, name) {
        data.error = data.message;
        var allErrorsInfo = {
            allErrors: {
                errors: [data]
            },
            windowName: name
        };
        this.Dialog.showingErrors(event, allErrorsInfo, 'showing-errors.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
        return;
    };
    // tslint:disable-next-line:typedef
    BPMergersController.prototype.openActionMenu = function ($mdOpenMenu, event) {
        $mdOpenMenu(event);
    };
    BPMergersController.$inject = [
        'settings',
        'env',
        '$compile',
        '$filter',
        'socket',
        '$scope',
        'Dialog',
        'notify',
        'DTOptionsBuilder',
        'DTColumnBuilder',
        'DTColumnDefBuilder'
    ];
    return BPMergersController;
}());
var BPMergersComponent = (function () {
    function BPMergersComponent() {
        this.templateUrl = 'bpmergers-view.html';
        this.controllerAs = 'vm';
        this.controller = BPMergersController;
    }
    return BPMergersComponent;
}());
angular
    .module('application')
    .component('viewBpmergersSection', new BPMergersComponent());



/**
 * Created by Roman T on 11/28/2017.
 */
var BpoiSwitchesController = (function () {
    function BpoiSwitchesController(env, $filter, DTS, $stateParams, $state, socket, $scope, settings, admin, $mdDialog, Dialog) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.settings = settings;
        this.admin = admin;
        this.$mdDialog = $mdDialog;
        this.Dialog = Dialog;
        this.table = { sortType: '_link', sortReverse: false, search: '', filter: false, filterParams: {} };
        this.changeInitiated = false;
        this.bpoiLoaded = false;
        this.comments = [];
        this.socket.forward('bpoiview.getCtySampling', this.$scope);
        this.$scope.$on('socket:bpoiview.getCtySampling', function (event, data) {
            _this.iotCountries = data.iotCountries;
            _this.iotCountriesBackUp = _.cloneDeep(data.iotCountries);
            _this.countries = data.countries;
            _this.prepareBpoiTable(data.iotCountries);
            _this.comments = data.comments;
            _this.commentsBackUp = _.cloneDeep(data.comments);
            _this.bpoiLoaded = true;
            _this.changeInitiated = false;
            _this.iots = data.iots;
        });
    }
    BpoiSwitchesController.prototype.$onInit = function () {
        this.admin.getBpoiSetup();
    };
    BpoiSwitchesController.prototype.saveSourceChanges = function (e) {
        var _this = this;
        var items = {
            cancelMessage: 'Cancel',
            dialogName: 'Save BPOI Switches',
            message: 'Please confirm submission:',
            okMessage: 'Save'
        };
        this.Dialog.YesNoForm(undefined, items, 'yes-no.html').then(function (dResult) {
            var changedFields = [];
            if (dResult.confirm) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        doc: {
                            comments: _this.comments,
                            countries: _this.countries,
                            iotCountries: _this.iotCountries,
                            iots: _this.iots
                        },
                        function: 'setBpoiSetupBackend',
                        script: '/admin/bpoi-enabler',
                        user: _this.env.user
                    }
                });
                _this.changeInitiated = false;
            }
        });
    };
    BpoiSwitchesController.prototype.resetSourceChanges = function (e) {
        this.iotCountries = _.cloneDeep(this.iotCountriesBackUp);
        this.comments = _.cloneDeep(this.commentsBackUp);
        this.changeInitiated = false;
    };
    BpoiSwitchesController.prototype.checkBpoiTable = function (iot, country, field) {
        var _this = this;
        this.changeInitiated = true;
        angular.forEach(this.iotCountries, function (iotArea) {
            if (iotArea.key === iot) {
                angular.forEach(iotArea.values, function (cty) {
                    if (cty.country === country) {
                        cty.startDate = new Date(cty.startDateFormated).getTime();
                        cty.endDate = new Date(cty.endDateFormated).getTime();
                        cty.isLineValid = cty.startDateFormated <= cty.endDateFormated;
                        var value = '';
                        switch (field) {
                            case 'start date':
                                value = cty.startDateFormated.toJSON();
                                break;
                            case 'end date':
                                value = cty.endDateFormated.toJSON();
                                break;
                            case 'GE Yes':
                                value = cty.geYes;
                                break;
                            case 'GE No':
                                value = cty.geNo;
                                break;
                            case 'Designation':
                                value = cty.designation;
                                break;
                            default:
                        }
                        _this.comments.push({
                            comment: "Changed " + field + " to " + value + "  for country: " + country,
                            editedBy: _this.env.user.email,
                            timestamp: new Date().getTime()
                        });
                    }
                });
            }
        });
    };
    BpoiSwitchesController.prototype.prepareBpoiTable = function (countries) {
        angular.forEach(countries, function (country) {
            angular.forEach(country.values, function (ctr) {
                ctr.startDateFormated = ctr.startDateFormated ? new Date(ctr.startDateFormated) : ctr.startDate ? new Date(parseInt(ctr.startDate, 10)) : new Date(Date.now());
                ctr.endDateFormated = ctr.endDateFormated ? new Date(ctr.endDateFormated) : ctr.endDate ? new Date(parseInt(ctr.endDate, 10)) : new Date(Date.now());
                ctr.isLineValid = ctr.startDateFormated < ctr.endDateFormated;
            });
        });
    };
    BpoiSwitchesController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'settings', 'admin', '$mdDialog', 'Dialog'];
    return BpoiSwitchesController;
}());
var BpoiSwitchesComponent = (function () {
    function BpoiSwitchesComponent() {
        this.templateUrl = 'bpoi-switches.html';
        this.controllerAs = 'vm';
        this.controller = BpoiSwitchesController;
    }
    return BpoiSwitchesComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('delete', '/public/icons/delete-forever.svg');
})
    .component('viewBpoiswitchSection', new BpoiSwitchesComponent());



// Changelog
// YYYYMMDD-<Card>-<Dev id>-<Abstract>
// 20171201-1030-Domenico De Felice-Added new bonus fields
// 20171004-784-Domenico & Kim--SO Uplift on predefined channels only
//
var calculationTableBind = { table: '=', data: '=', parent: '=' };
var CalculationTableController = (function () {
    function CalculationTableController($state, settings, env, socket, $scope, Dialog, admin) {
        this.$state = $state;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.admin = admin;
        switch (this.table) {
            case 0:
                // Card 1030 start
                this.headers = 'Priority,Country,License,Revenue Stream Code,GOE,Incentive,ISU,Material,Customer Designation,Bonus,Start\u00A0Date,End\u00A0Date,BP\u00A0id,IBM\u00A0id,Solution,New\u00A0Client,Focus,Growth,Sales,Engagement,CTL\u00A0incentive'.split(',');
                this.columns = 'Priority,Country,License,Revenue_Stream_Code,GOE,Incentive,ISU,Material,Customer_Designation,Bonus,StartDate,EndDate,bpid,ibmid,solution,newclient,focus,growth,sales,engagement,ctl'.toUpperCase().split(',');
                // Card 1030 end
                break;
            case 1:
                // Card 1030 start
                this.headers = 'Priority,Country,License,GOE,Incentive,ISU,Material,Customer Designation,Bonus,Start Date,End Date,BP id,IBM id,Solution,New Client'.split(',');
                this.columns = 'Priority,Country,License,GOE,Incentive,ISU,Material,Customer_Designation,Bonus,StartDate,EndDate,bpid,ibmid,solution,newclient'.toUpperCase().split(',');
                // Card 1030 end
                break;
            case 2:
                this.headers = 'Priority,IOT,Country,ISU,Channel,Line of Business,Licence,Customer Designation,Uplift,Start Date,End Date'.split(',');
                this.columns = 'Priority,IOT,Country,ISU,Channel,Lob,LICENCE_TYPE,CUSTOMER_DESIGNATION,Uplift,StartDate,EndDate'.toUpperCase().split(',');
                break;
            case 3:
                this.headers = 'Priority,IOT,Country,ISU,Channel,Line of Business,Licence,Customer Designation,Uplift,Start Date,End Date'.split(',');
                this.columns = 'Priority,IOT,Country,ISU,Channel,Lob,LICENCE_TYPE,CUSTOMER_DESIGNATION,Uplift,StartDate,EndDate'.toUpperCase().split(',');
                break;
            case 4:
                this.headers = 'Country,License,Incentive,Uplift,Start Date,End Date'.split(',');
                this.columns = 'Country,License,Incentive,Uplift,StartDate,EndDate'.toUpperCase().split(',');
                break;
            case 5:
                this.headers = 'Channel,Start Date,End Date'.split(','); // Card 784
                this.columns = 'Channel,StartDate,EndDate'.toUpperCase().split(','); // Card 784
                break;
            case 6:
                this.headers = 'Currency,USD to Local,Local to USD,Start Date, End Date'.split(',');
                this.columns = 'Currency,fromUsd,toUsd,StartDate,EndDate'.toUpperCase().split(',');
                break;
            default:
                this.headers = [];
                this.columns = [];
                break;
        }
        this.countries = this.settings.country_list.filter(function (item) {
            return item.ic === 'Country';
        }).sort(function (a, b) {
            return (a.country > b.country) ? 1 : ((b.country > a.country) ? -1 : 0);
        });
        this.selectedCountry = this.countries[0];
    }
    CalculationTableController.$inject = ['$state', 'settings', 'env', 'socket', '$scope', 'Dialog', 'admin'];
    return CalculationTableController;
}());
var CalculationTableComponent = (function () {
    function CalculationTableComponent() {
        this.bindings = calculationTableBind;
        this.templateUrl = 'calculation-table-view.html';
        this.controllerAs = 'vm';
        this.controller = CalculationTableController;
    }
    return CalculationTableComponent;
}());
angular
    .module('application')
    .component('calculationTableSection', new CalculationTableComponent());



// Changelog
//2017-10-04 - Domenico & Kim - Card 784 - SO Uplift on predefined channels only
//
var CalculationController = (function () {
    function CalculationController($state, settings, env, socket, $scope, Dialog, admin, notify) {
        var _this = this;
        this.$state = $state;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.admin = admin;
        this.notify = notify;
        this.isSaving = false;
        this.isTrue = true;
        this.tables = ['Bonus', 'Bonus Off', 'Sales Order Uplift', 'Sales Order Uplift Off', 'GPP Uplift', 'SO Uplifted Channels', 'Exchange Rates'];
        this.showHistory = false;
        this.newRate = {};
        this.newChannel = {}; //Card 784 - Kim Janneck
        this.curidx = -1;
        this.isSaving = false;
        this.selectedTable = 0;
        this.dataLoaded = false;
        this.socket.forward('admin.calculation.query', this.$scope);
        this.$scope.$on('socket:admin.calculation.query', function (event, data) {
            _this.dataLoaded = true;
            if (data.error) {
                return _this.notify.error("Unable to load table data => " + data.error);
            }
            _this.data = data.data[0];
            // console.info(this.data);
            _this.historyData = data.data[1];
            if (data.data[2]) {
                if (_this.selectedTable !== 4) {
                    _this.countries = data.data[2];
                }
                else {
                    _this.currencies = data.data[2].map(function (obj) {
                        return obj.CURRENCY;
                    });
                    _this.currencies.unshift('');
                }
            }
        });
        this.socket.forward('admin.calculation.insertRate', this.$scope);
        this.$scope.$on('socket:admin.calculation.insertRate', function (event, data) {
            _this.newRate.currency = undefined;
            _this.newRate.fromUsd = undefined;
            _this.newRate.toUsd = undefined;
            _this.isSaving = false;
            if (data.error) {
                return _this.notify.error("Unable to insert new rate => " + data.error);
            }
            else {
                _this.data.unshift(data.rate);
                return _this.notify.success('Inserted successfully.');
            }
        });
        // Card 784 Insert top
        // Card 784: inserting a new channel
        this.socket.forward('admin.calculation.insertChannel', this.$scope);
        this.$scope.$on('socket:admin.calculation.insertChannel', function (event, data) {
            _this.newChannel.channelLetter = undefined;
            _this.isSaving = false;
            if (data.error) {
                return _this.notify.error("Unable to insert new channel => " + data.error);
            }
            else {
                _this.data.unshift(data.channel);
                return _this.notify.success('Inserted successfully.');
            }
        });
        // Card 784: withdrawing a channel.
        this.socket.forward('admin.calculation.withdrawChannel', this.$scope);
        this.$scope.$on('socket:admin.calculation.withdrawChannel', function (event, data) {
            for (var i = 0; i < _this.data.length; i++) {
                if (_this.compareChannels(_this.data[i], data.channel) === 0) {
                    _this.historyData.unshift(_this.data[i]);
                    _this.data.splice(i, 1);
                    break;
                }
            }
            _this.isSaving = false;
            if (data.error) {
                return _this.notify.error("Unable to withdraw channel => " + data.error);
            }
            else {
                _this.data.unshift(data.channel);
                return _this.notify.success('Withdrawn successfully.');
            }
        });
        // Card 784 Insert bottom
        this.socket.forward('admin.calculation.withdrawRate', this.$scope);
        this.$scope.$on('socket:admin.calculation.withdrawRate', function (event, data) {
            for (var i = 0; i < _this.data.length; i++) {
                if (_this.compareRates(_this.data[i], data.rate) === 0) {
                    _this.historyData.unshift(_this.data[i]);
                    _this.data.splice(i, 1);
                    break;
                }
            }
            _this.isSaving = false;
            if (data.error) {
                return _this.notify.error("Unable to withdraw rate => " + data.error);
            }
            else {
                _this.data.unshift(data.rate);
                return _this.notify.success('Withdrawn successfully.');
            }
        });
        // Card 1030 - Edit a bonus listener for autorefresh web page
        this.socket.forward('admin.calculation.updateBonus', this.$scope);
        this.$scope.$on('socket:admin.calculation.updateBonus', function (event, data) {
            _this.isSaving = false;
            if (data.error) {
                return _this.notify.error("Unable to update bonus => " + data.error);
            }
            else {
                _this.data[_this.curidx] = data;
                return _this.notify.success('Update successful! Press F5 to refresh data.');
            }
        });
        // End of Card 1030 - Edit a bonus listener
    } // end of Constructor
    // Card 784 Insert top
    CalculationController.prototype.compareChannels = function (channel1, channel2) {
        /*
        Card 784: Make make sure removal of channel rown in in active table in frontend is performed and it appears in history table.
        */
        if (channel1.CHANNEL < channel2.CHANNEL) {
            return -1;
        }
        if (channel1.CHANNEL > channel2.CHANNEL) {
            return 1;
        }
        if (channel1.STARTDATE < channel2.STARTDATE) {
            return -1;
        }
        if (channel1.STARTDATE > channel2.STARTDATE) {
            return 1;
        }
        if (channel1.ENDDATE < channel2.ENDDATE) {
            return -1;
        }
        if (channel1.ENDDATE > channel2.ENDDATE) {
            return 1;
        }
        return 0;
    };
    // Card 784 Insert bottom
    CalculationController.prototype.compareRates = function (rate1, rate2) {
        if (rate1.CURRENCY < rate2.CURRENCY) {
            return -1;
        }
        if (rate1.CURRENCY > rate2.CURRENCY) {
            return 1;
        }
        if (rate1.STARTDATE < rate2.STARTDATE) {
            return -1;
        }
        if (rate1.STARTDATE > rate2.STARTDATE) {
            return 1;
        }
        if (rate1.ENDDATE < rate2.ENDDATE) {
            return -1;
        }
        if (rate1.ENDDATE > rate2.ENDDATE) {
            return 1;
        }
        if (rate1.FROMUSD < rate2.FROMUSD) {
            return -1;
        }
        if (rate1.FROMUSD > rate2.FROMUSD) {
            return 1;
        }
        if (rate1.TOUSD < rate2.TOUSD) {
            return -1;
        }
        if (rate1.TOUSD > rate2.TOUSD) {
            return 1;
        }
        return 0;
    };
    CalculationController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getData',
                data: {
                    table: this.selectedTable,
                    countries: true
                },
                script: 'admin/calculationtables',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    CalculationController.prototype.switchTable = function () {
        this.dataLoaded = false;
        this.data = undefined;
        this.historyData = undefined;
        var data = {
            table: this.selectedTable
        };
        if (this.selectedTable === 4) {
            if (this.currency) {
                data.currency = this.currency;
            }
            if (this.validDate) {
                var mm = this.validDate.getMonth() + 1; // getMonth() is zero-based
                var dd = this.validDate.getDate();
                data.validDate = [this.validDate.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
            }
            if (!this.currencies) {
                data.countries = true;
            }
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: data,
                email: this.env.user.email,
                function: 'getData',
                script: 'admin/calculationtables',
                token: this.env.user.token
            }
        });
    };
    // Card 1030 Insert top
    CalculationController.prototype.editBonus = function (idx) {
        var _this = this;
        this.curidx = idx;
        // console.info(this.data[idx]);
        var items = {
            bonusBundle: {
                priority: this.data[idx]['PRIORITY'],
                country: this.data[idx]['COUNTRY'],
                license: this.data[idx]['LICENSE'],
                revenueStreamCode: this.data[idx]['REVENUE_STREAM_CODE'],
                goe: this.data[idx]['GOE'],
                incentive: this.data[idx]['INCENTIVE'],
                isu: this.data[idx]['ISU'],
                material: this.data[idx]['MATERIAL'],
                customerDesignation: this.data[idx]['CUSTOMER_DESIGNATION'],
                bonus: this.data[idx]['BONUS'],
                startDate: new Date(this.data[idx]['STARTDATE']),
                endDate: new Date(this.data[idx]['ENDDATE']),
                bpId: this.data[idx]['BPID'],
                ibmId: this.data[idx]['IBMID'],
                solution: this.data[idx]['SOLUTION'],
                newclient: this.data[idx]['NEWCLIENT'],
                focus: this.data[idx]['FOCUS'],
                growth: this.data[idx]['GROWTH'],
                sales: this.data[idx]['SALES'],
                engagement: this.data[idx]['ENGAGEMENT'],
                ctl: this.data[idx]['CTL']
            }
        };
        this.Dialog.updateValidForm(undefined, items, 'bonus-edit.html').then(function (dResult) {
            // console.info(items.bonusBundle);
            items.bonusBundle.startDate = items.bonusBundle.startDate.getFullYear() + '-' + (items.bonusBundle.startDate.getMonth() + 1) + '-' + items.bonusBundle.startDate.getDate();
            items.bonusBundle.endDate = items.bonusBundle.endDate.getFullYear() + '-' + (items.bonusBundle.endDate.getMonth() + 1) + '-' + items.bonusBundle.endDate.getDate();
            _this.isSaving = true;
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: _this.data[idx],
                    changes: items.bonusBundle,
                    email: _this.env.user.email,
                    function: 'updateBonus',
                    script: 'admin/calculationtables',
                    token: _this.env.user.token
                }
            });
        });
        return;
    };
    // Card 1030 Insert bottom
    // Card 784 Insert top
    CalculationController.prototype.addChannel = function () {
        //Card 784: adding a channel to the table in the front-end.
        if (!this.newChannel.channelLetter || this.newChannel.channelLetter.length !== 1) {
            var items = {
                icon: 'ERROR',
                message: 'Invalid Channel letter',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        var startDate;
        if (this.newChannel.startDate) {
            var mm = this.newChannel.startDate.getMonth() + 1; // getMonth() is zero-based
            var dd = this.newChannel.startDate.getDate();
            startDate = [this.newChannel.startDate.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
        }
        else {
            var items = {
                icon: 'ERROR',
                message: 'Invalid start date.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        var endDate;
        if (this.newChannel.endDate) {
            var mm = this.newChannel.endDate.getMonth() + 1; // getMonth() is zero-based
            var dd = this.newChannel.endDate.getDate();
            endDate = [this.newChannel.endDate.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
        }
        else {
            var items = {
                icon: 'ERROR',
                message: 'Invalid end date.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    channel: this.newChannel.channelLetter,
                    startDate: startDate,
                    endDate: endDate
                },
                email: this.env.user.email,
                function: 'insertChannel',
                script: 'admin/calculationtables',
                token: this.env.user.token
            }
        });
        this.isSaving = true;
    };
    CalculationController.prototype.withdrawChannel = function (i) {
        //Card 784: removing a channel from the table (to history) by setting an enddate to yesterday.
        this.isSaving = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: this.data[i],
                email: this.env.user.email,
                function: 'withdrawChannel',
                script: 'admin/calculationtables',
                token: this.env.user.token
            }
        });
    };
    // Card 784 Insert bottom
    CalculationController.prototype.addRate = function () {
        if (!this.newRate.currency || this.newRate.currency.length !== 3) {
            var items = {
                icon: 'ERROR',
                message: 'Invalid currency code.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        if (isNaN(Number(this.newRate.fromUsd))) {
            var items = {
                icon: 'ERROR',
                message: 'Invalid USD to Local value.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        if (isNaN(Number(this.newRate.toUsd))) {
            var items = {
                icon: 'ERROR',
                message: 'Invalid Local to USD value.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        var startDate;
        if (this.newRate.startDate) {
            var mm = this.newRate.startDate.getMonth() + 1; // getMonth() is zero-based
            var dd = this.newRate.startDate.getDate();
            startDate = [this.newRate.startDate.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
        }
        else {
            var items = {
                icon: 'ERROR',
                message: 'Invalid start date.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        var endDate;
        if (this.newRate.endDate) {
            var mm = this.newRate.endDate.getMonth() + 1; // getMonth() is zero-based
            var dd = this.newRate.endDate.getDate();
            endDate = [this.newRate.endDate.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
        }
        else {
            var items = {
                icon: 'ERROR',
                message: 'Invalid end date.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    currency: this.newRate.currency,
                    endDate: endDate,
                    fromUsd: this.newRate.fromUsd,
                    startDate: startDate,
                    toUsd: this.newRate.toUsd
                },
                email: this.env.user.email,
                function: 'insertRate',
                script: 'admin/calculationtables',
                token: this.env.user.token
            }
        });
        this.isSaving = true;
    };
    CalculationController.prototype.withdrawRate = function (i) {
        this.isSaving = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: this.data[i],
                email: this.env.user.email,
                function: 'withdrawRate',
                script: 'admin/calculationtables',
                token: this.env.user.token
            }
        });
    };
    CalculationController.$inject = ['$state', 'settings', 'env', 'socket', '$scope', 'Dialog', 'admin', 'notify'];
    return CalculationController;
}());
var CalculationComponent = (function () {
    function CalculationComponent() {
        this.templateUrl = 'calculation-view.html';
        this.controllerAs = 'vm';
        this.controller = CalculationController;
    }
    return CalculationComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('delete', '/public/icons/delete-forever.svg')
        .icon('invalid', '/public/icons/ic_highlight_off_black_24px.svg')
        .icon('save', '/public/images/ic_save_black_24px.svg');
})
    .component('viewCalculationSection', new CalculationComponent());



var CheckListEditController = (function () {
    function CheckListEditController(env, $filter, DTS, $stateParams, $state, socket, $scope, config, admin, $timeout, Dialog, $q, settings, notify) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.config = config;
        this.admin = admin;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.$q = $q;
        this.settings = settings;
        this.notify = notify;
        this.sl = '';
        this.copy = '';
        this.program = '';
        this.dataLoaded = false;
        this.clearCheckList();
        // Makes sure, that on leave without save, you will get a prompt
        this.$scope.$on("$locationChangeStart", function (event) {
            if (_this.modified) {
                // Only way I could do this is the blocking confirm. Its not possible with angular dialog promise
                var dialogCheck = confirm('Data not saved! Do you want to leave the page without saving? Press OK to leave page or CANCEL to stay on page');
                if (!dialogCheck) {
                    event.preventDefault();
                }
            }
        });
        // Based on what action was received data will be updated
        this.socket.forward('admin.program_checklist_edit', this.$scope);
        this.$scope.$on('socket:admin.program_checklist_edit', function (event, data) {
            if (_this.browserID === data.browserID) {
                if (data.action === 'update') {
                    if (data.success) {
                        _this.message(event, data);
                        _this.dataLoaded = true;
                        _this.$state.go('admin.checklist-view');
                    }
                    else {
                        _this.okMessage = undefined;
                        _this.errorMessage = data.msg;
                    }
                }
                else if (data.action === 'getItem') {
                    if (data.success) {
                        _this.stage = 1;
                        _this.message(event, data);
                        _this.dataLoaded = true;
                        _this.clOrig = data.dataUpdated;
                        _this.clTemp = angular.copy(_this.clOrig);
                        if (_this.clTemp.effStartDate) {
                            _this.stage = 2;
                            _this.effStartDate = new Date(_this.clTemp.effStartDate);
                        }
                        if (_this.clTemp.active === false) {
                            _this.stage = 3;
                        }
                        if (data.copy) {
                            _this.stage = 0;
                            _this.modified = true;
                        }
                        _this.okMessage = 'checklist retreived successfully';
                        _this.errorMessage = undefined;
                    }
                    else {
                        _this.message(event, data);
                        _this.$state.go('admin.checklist-view');
                    }
                }
            }
            else {
                _this.okMessage = undefined;
                _this.errorMessage = 'Page has been left or reloaded, please reload for the changes to take effect';
            }
        });
    }
    CheckListEditController.prototype.clearCheckList = function () {
        this.modified = false;
        this.modifiedItem = false;
        this.okMessage = undefined;
        this.errorMessage = undefined;
        this.editMain = true;
        this.editCl = true;
        this.sl = this.$stateParams.sl;
        this.copy = this.$stateParams.copy;
        this.actionList = [
            { id: undefined, desc: 'If there is no action assigned, keep this selection selected', name: 'No action' },
            { id: 1, desc: 'Real Duplicate', name: 'Real Duplicate' }
        ];
        this.stage = 0;
        this.clTemp = {
            name: undefined,
            desc: undefined,
            effStartDate: undefined,
            enabledBy: undefined,
            enabledOn: undefined,
            deactivatedBy: undefined,
            deactivatedOn: undefined,
            active: undefined,
            data: {
                pickedProgram: '',
                pickedIots: [],
                check_list: [],
                //groupID: undefined,
                _rev: undefined,
                cl_rb: { desc: '', picked: '', rb: [] },
                check_list2: [],
                cl2_rb: { desc: '', picked: '', rb: [] },
                check_list3: [],
                cl3_rb: { desc: '', picked: '', rb: [] },
                check_list_validation: [],
                cl_validation_rb: { desc: '', picked: '', rb: [] },
                check_list_sampling: [],
                cl_sampling_rb: { desc: '', picked: '', rb: [] },
                check_list_calculation: [],
                cl_calculation_rb: { desc: '', picked: '', rb: [] },
                check_list_opportunity_detail: [],
                cl_opportunity_detail_rb: { desc: '', picked: '', rb: [] },
                check_list_investment_review: [],
                cl_investment_rb: { desc: '', picked: '', rb: [] },
                check_list_payment: [],
                cl_payment_rb: { desc: '', picked: '', rb: [] },
                check_list_exceptions: [],
                cl_exceptions_rb: { desc: '', picked: '', rb: [] }
            }
        };
    };
    ;
    CheckListEditController.prototype.createCopy = function () {
        this.admin.setCopySingleLog(this.sl);
        this.$state.go('admin.checklist-edit', { sl: 'new' });
    };
    /**
      message- Shows a red or green md-toast based on the message
      @param {any} ev       event
      @param {any} data     data containg msg and err based on error
      @returns void
    */
    CheckListEditController.prototype.message = function (ev, data) {
        if (data.err) {
            return this.notify.error(data.msg);
        }
        this.notify.success(data.msg);
    };
    /**
      backToView- Moves back to checklist view
      @returns void
    */
    CheckListEditController.prototype.backToView = function () {
        this.modified = false;
        this.$state.go('admin.checklist-view');
    };
    /**
      changedIot- On iot change modification is registered
      @returns void
    */
    CheckListEditController.prototype.changedIot = function () {
        this.modified = true;
    };
    CheckListEditController.prototype.changedEffDate = function () {
        this.modified = true;
        if (this.effStartDate) {
            this.clTemp.effStartDate = this.effStartDate.getTime();
        }
        ;
    };
    CheckListEditController.prototype.$onInit = function () {
        var array = new Uint32Array(2);
        this.browserID = window.crypto.getRandomValues(array)[0];
        this.copy = this.admin.getCopySingleLog();
        this.admin.setCopySingleLog(undefined);
        this.stage = 0;
        if (angular.isDefined(this.sl) && !(this.sl === 'new' || this.sl === '')) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getAdminSingleLogEdit',
                    script: '/admin/admin',
                    browserID: this.browserID,
                    data: {
                        singleLog: this.sl,
                        adminComponent: 'checklist'
                    },
                    token: this.env.user.token
                }
            });
        }
        else if (this.copy) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getAdminSingleLogEdit',
                    script: '/admin/admin',
                    browserID: this.browserID,
                    data: {
                        copy: true,
                        singleLog: this.copy,
                        adminComponent: 'checklist'
                    },
                    token: this.env.user.token
                }
            });
        }
        else {
            this.clOrig = angular.copy(this.clTemp);
            this.dataLoaded = true;
        }
    };
    /**
      savePage- Confirms the changes done on the checklist edit page
      @param {IAngularEvent} event   event
      @returns void
    */
    CheckListEditController.prototype.savePage = function (event) {
        var _this = this;
        var items = {
            message: 'Are you sure you want to Save this Checklist? ',
            okMessage: 'Save',
            cancelMessage: 'Cancel',
            dialogName: 'Save checklist Profile'
        };
        this.Dialog.YesNoForm(event, items, 'yes-no.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'updateAdminData',
                        script: '/admin/admin',
                        browserID: _this.browserID,
                        data: {
                            name: _this.clTemp.name,
                            desc: _this.clTemp.desc,
                            effStartDate: _this.clTemp.effStartDate,
                            active: _this.clTemp.active,
                            singleLog: _this.sl,
                            adminComponent: 'checklist',
                            data: _this.clTemp.data
                        },
                        token: _this.env.user.token
                    }
                });
            }
        });
    };
    /**
      clearIOT- Clears the IOT selection
      @returns void
    */
    CheckListEditController.prototype.clearIOT = function () {
        this.clTemp.data.pickedIots = [];
    };
    /**
      expand - Expands the section with checklist & radio buttons
      @param {string} name:   name of the checklist section
    */
    CheckListEditController.prototype.expand = function (name) {
        angular.forEach(this.admin.listOfCheckList, function (cl) {
            if (cl.name === name) {
                cl.visible = true;
            }
        });
    };
    /**
      collapse - Collapses the section with checklist & radio buttons
      @param {string} name:   name of the checklist section
    */
    CheckListEditController.prototype.collapse = function (name) {
        angular.forEach(this.admin.listOfCheckList, function (cl) {
            if (cl.name === name) {
                cl.visible = false;
            }
        });
    };
    /**
      editSection - Enables edit mode of the selected section
      @param {string} name:   name of the checklist section
    */
    CheckListEditController.prototype.editSection = function (name) {
        var _this = this;
        angular.forEach(this.admin.listOfCheckList, function (cl) {
            if (cl.name === name) {
                _this.backupCheckList = angular.copy(_this.clTemp.data[cl.variableName]);
                _this.backupRadioButton = angular.copy(_this.clTemp.data[cl.radioButtonName]);
                cl.editView = true;
                cl.visible = true;
                _this.editMain = false;
            }
            else {
                cl.editView = false;
            }
        });
    };
    /**
      saveSection - Confirms the changes of the selected section & saves them
      @param {string} name:   name of the checklist section
    */
    CheckListEditController.prototype.saveSection = function (name) {
        var _this = this;
        this.modifiedItem = false;
        this.modified = true;
        angular.forEach(this.admin.listOfCheckList, function (cl) {
            if (cl.name === name) {
                _this.backupCheckList = [];
                _this.backupRadioButton = { desc: '', picked: '', rb: [] };
                cl.editView = false;
                _this.editMain = true;
            }
        });
    };
    /**
      cancelSection - Retreives the checklist & radioButton object, that was stored as backup, when edit button was inserted.
      @param {string} name:   name of the checklist section
    */
    CheckListEditController.prototype.cancelSection = function (name) {
        var _this = this;
        angular.forEach(this.admin.listOfCheckList, function (cl) {
            if (cl.name === name) {
                _this.clTemp.data[cl.variableName] = angular.copy(_this.backupCheckList);
                _this.clTemp.data[cl.radioButtonName] = angular.copy(_this.backupRadioButton);
                _this.backupCheckList = [];
                _this.backupRadioButton = { desc: '', picked: '', rb: [] };
                cl.editView = false;
                _this.editMain = true;
            }
        });
    };
    /**
      addItem - Adds a new checklist question on the end of the checklist list
      @param {string} variableName:   name of the checklist object
    */
    CheckListEditController.prototype.addItem = function (variableName) {
        this.modifiedItem = true;
        this.editCl = false;
        if (angular.isUndefined(this.clTemp.data[variableName])) {
            this.clTemp.data[variableName] = [];
        }
        this.clTemp.data[variableName].push({ q: '', answer: '', editMode: true });
        this.backupCheckListItem = angular.copy({ q: '', answer: '', editMode: false });
    };
    /**
      removeItem - Removes checklist question from the index position
      @param {string} variableName:   name of the checklist object
      @param {number} index:          position of the removed check list question
    */
    CheckListEditController.prototype.removeItem = function (variableName, index) {
        this.modifiedItem = true;
        if (angular.isDefined(this.clTemp.data[variableName]) && this.clTemp.data[variableName].length > index) {
            this.backupCheckListItem = undefined;
            this.clTemp.data[variableName].splice(index, 1);
        }
        this.editCl = true;
    };
    /**
      saveItem - Saves the checklist in the edit mode on the index position
      @param {string} variableName:   name of the checklist object
      @param {number} index:          position of the saved check list question
    */
    CheckListEditController.prototype.saveItem = function (variableName, index) {
        this.modifiedItem = true;
        if (angular.isDefined(this.clTemp.data[variableName]) && this.clTemp.data[variableName].length > index) {
            this.backupCheckListItem = undefined;
            this.clTemp.data[variableName][index].editMode = false;
        }
        this.editCl = true;
    };
    /**
      editItem - Enables editing of the checklist on the index position
      @param {string} variableName:   name of the checklist object
      @param {number} index:          position of the to be edited check list question
    */
    CheckListEditController.prototype.editItem = function (variableName, index) {
        this.editCl = false;
        if (angular.isDefined(this.clTemp.data[variableName]) && this.clTemp.data[variableName].length > index) {
            this.backupCheckListItem = angular.copy(this.clTemp.data[variableName][index]);
            this.clTemp.data[variableName][index].editMode = true;
        }
    };
    /**
      cancelItem - Restores the backuped checklist question and disables edit mode
      @param {string} variableName:   name of the checklist object
      @param {number} index:          position of the check list question where to be restored from the backup
    */
    CheckListEditController.prototype.cancelItem = function (variableName, index) {
        this.clTemp.data[variableName][index] = angular.copy(this.backupCheckListItem);
        this.backupCheckListItem = undefined;
        this.clTemp.data[variableName][index].editMode = false;
        this.editCl = true;
    };
    /**
      addItemLine - Inserts a new checklist question on the position of the index
      @param {string} variableName:   name of the checklist object
      @param {number} index:          position of the check list question where a new question will be added
    */
    CheckListEditController.prototype.addItemLine = function (variableName, index) {
        this.modifiedItem = true;
        var tempCl = angular.copy(this.clTemp.data[variableName]);
        if (angular.isDefined(tempCl) && tempCl.length > index) {
            tempCl.splice(index, 0, { q: '', answer: '', editMode: true });
            this.backupCheckListItem = angular.copy({ q: '', answer: '', editMode: false });
        }
        this.editCl = false;
        this.clTemp.data[variableName] = angular.copy(tempCl);
    };
    /**
      addRb - Adds a radio button question on the last position
      @param {string} radioButtonName:   name of the radio button object
    */
    CheckListEditController.prototype.addRb = function (radioButtonName) {
        this.modifiedItem = true;
        var tempIndex = 0;
        if (angular.isUndefined(this.clTemp.data[radioButtonName])) {
            this.clTemp.data[radioButtonName] = {
                desc: '',
                picked: '',
                rb: []
            };
        }
        angular.forEach(this.clTemp.data[radioButtonName].rb, function (radioButton) {
            if (angular.isDefined(radioButton.value)) {
                if (tempIndex < radioButton.value) {
                    tempIndex = radioButton.value;
                }
            }
        });
        tempIndex++;
        this.clTemp.data[radioButtonName].rb.push({ name: '', value: tempIndex });
    };
    /**
      clearRb - Clears the selection of any of those items
      @param {string} radioButtonName:   name of the radio button object
    */
    CheckListEditController.prototype.clearRb = function (radioButtonName) {
        this.modifiedItem = true;
        this.clTemp.data[radioButtonName].picked = '';
    };
    /**
      removeRbItem - Removes the radiobutton option from the index position
      @param {string} radioButtonName:    name of the radio button object
      @param {number} index:              position of the radiobutton that will be removed
    */
    CheckListEditController.prototype.removeRbItem = function (radioButtonName, index) {
        this.modifiedItem = true;
        if (angular.isDefined(this.clTemp.data[radioButtonName].rb) && !(this.clTemp.data[radioButtonName].rb.length - 1 < index)) {
            this.clTemp.data[radioButtonName].rb.splice(index, 1);
        }
    };
    CheckListEditController.prototype.modification = function () {
        this.modifiedItem = true;
    };
    /**
      addAnswer - Adds a additional answer to Yes/No
      @param {CheckListQuestions} clItem:    name of the radio button object
    */
    CheckListEditController.prototype.addAnswer = function (clItem) {
        var _this = this;
        if (angular.isUndefined(clItem.addA)) {
            clItem.addA = [];
        }
        var found = false;
        angular.forEach(clItem.addA, function (aItem) {
            if (aItem === _this.tempAnswer) {
                found = true;
            }
        });
        if (!found && angular.isDefined(this.tempAnswer) && this.tempAnswer !== '') {
            clItem.addA.push(this.tempAnswer);
        }
        this.tempAnswer = '';
    };
    /**
      removedAnswer - Removes a additional answer
      @param {CheckListQuestions} clItem:    name of the radio button object
    */
    CheckListEditController.prototype.removeAnswer = function (clItem, answer) {
        if (angular.isUndefined(clItem.addA)) {
            clItem.addA = [];
        }
        for (var i = 0; i < clItem.addA.length; i++) {
            if (clItem.addA[i] === answer) {
                clItem.addA.splice(i, 1);
                break;
            }
        }
    };
    CheckListEditController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state',
        'socket', '$scope', 'config', 'admin', '$timeout', 'Dialog', '$q', 'settings', 'notify'];
    return CheckListEditController;
}());
var CheckListEditComponent = (function () {
    function CheckListEditComponent() {
        this.templateUrl = 'checklist.html';
        this.controllerAs = 'vm';
        this.controller = CheckListEditController;
    }
    return CheckListEditComponent;
}());
angular
    .module('application')
    .component('adminCheckListSection', new CheckListEditComponent());



var CheckListViewController = (function () {
    function CheckListViewController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin, Dialog, notify, settings) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.Dialog = Dialog;
        this.notify = notify;
        this.settings = settings;
        this.table = { header: [], data: [], sortType: '_link', sortReverse: false, search: '', filter: false, filterParams: {} };
        this.programs = [];
        this.programsLoaded = false;
        this.selectedProgram = 'SVI';
        this.dataLoaded = false;
        /*this.table.header = [
          { header: 'Program', variable: 'program' },
          { header: 'Actions', variable: 'action' },
          { header: 'IOT', variable: 'iot' }
        ];*/
        this.table.header = [
            'Actions', 'Name', 'IOT', 'Active', 'Effective from', 'Deactivated'
        ];
        this.socket.forward('admin.program_checklist_view', this.$scope);
        this.$scope.$on('socket:admin.program_checklist_view', function (event, data) {
            if (data.action === 'logs-all') {
                _this.dataLoaded = true;
                if (data.success) {
                    _this.tempTable = data.dataUpdated;
                    _this.recalculateLogsTable();
                }
                else {
                    _this.notify.error(data.msg);
                }
            }
            else if (data.action === 'single-log') {
                if (data.success) {
                    var items = {
                        dialogName: 'Check List change: ',
                        logInfo: data.dataUpdated,
                        admin: _this.admin
                    };
                    _this.Dialog.updateValidForm(event, items, 'detail-cl-single-log.html').then(function (dResult) {
                        if (angular.isDefined(dResult)) {
                            _this.copyLog(dResult.logInfo.singleLog);
                        }
                    });
                }
                else {
                    _this.notify.error(data.msg);
                }
            }
            else {
                alert('Unknown response');
            }
        });
    }
    CheckListViewController.prototype.recalculateLogsTable = function () {
        var _this = this;
        this.logsTable = [];
        angular.forEach(this.tempTable, function (tableItem) {
            if (tableItem.value.program === _this.selectedProgram) {
                if ((_this.admin.clSelection.selected === 'All') || (_this.admin.clSelection.selected === 'Active' && tableItem.value.active) ||
                    (_this.admin.clSelection.selected === 'Disabled' && tableItem.value.active === false) ||
                    (_this.admin.clSelection.selected === 'Not yet enabled' && angular.isUndefined(tableItem.value.active))) {
                    _this.logsTable.push(tableItem);
                }
            }
        });
    };
    /**
      editMode - Opens the edit checklist view
      @param {number} sl:            singleLog
    */
    CheckListViewController.prototype.editMode = function (sl) {
        this.$state.go('admin.checklist-edit', { sl: sl });
    };
    CheckListViewController.prototype.copyLog = function (sl) {
        this.admin.setCopySingleLog(sl);
        this.$state.go('admin.checklist-edit', { sl: 'new' });
    };
    /**
    updateMode - Opens the checklist view, in update mode
    @param {number} sl:            singleLog
  */
    CheckListViewController.prototype.updateMode = function (sl) {
        this.$state.go('admin.checklist-update', { sl: sl });
    };
    /**
      showSingleLog - Opens a dialog with the checklist questions, that were logged
      @param {string} path:   name of the cloudant document stripped of the single logs unique name parts
    */
    CheckListViewController.prototype.showSingleLog = function (sl) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getAdminSingleLog',
                script: '/admin/admin',
                data: {
                    adminComponent: 'checklist',
                    singleLog: sl
                },
                token: this.env.user.token
            }
        });
    };
    CheckListViewController.prototype.$onInit = function () {
        var array = new Uint32Array(2);
        this.browserID = window.crypto.getRandomValues(array)[0];
        /*if (angular.isDefined(this.admin.config)) {
          this.admin.getGeneralConfig();
        };*/
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getAdminLogs',
                script: '/admin/admin',
                data: {
                    adminComponent: 'checklist'
                },
                token: this.env.user.token
            }
        });
    };
    /**
      createNew - Creates a new checklist object in edit mode to be added
    */
    CheckListViewController.prototype.createNew = function () {
        this.$state.go('admin.checklist-edit', { sl: 'new' });
    };
    CheckListViewController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'admin', 'Dialog', 'notify', 'settings'];
    return CheckListViewController;
}());
var CheckListViewComponent = (function () {
    function CheckListViewComponent() {
        this.templateUrl = 'checklist-view.html';
        this.controllerAs = 'vm';
        this.controller = CheckListViewController;
    }
    return CheckListViewComponent;
}());
angular
    .module('application')
    .component('viewCheckListSection', new CheckListViewComponent());



var misc_codeBind = { parent: '=', codepack: '=' };
var MiscCodesEditController = (function () {
    function MiscCodesEditController(env, $scope) {
        this.env = env;
        this.$scope = $scope;
    }
    MiscCodesEditController.$inject = ['env', '$scope'];
    return MiscCodesEditController;
}());
var MiscCodesEditComponent = (function () {
    function MiscCodesEditComponent() {
        this.bindings = misc_codeBind; //Bindings to connect with parent
        this.templateUrl = 'codes.html';
        this.controller = MiscCodesEditController;
    }
    return MiscCodesEditComponent;
}());
angular
    .module('application')
    .component('editMiscCodesSection', new MiscCodesEditComponent());



var MiscCodesViewController = (function () {
    function MiscCodesViewController(env, $filter, $stateParams, $state, socket, $scope, admin, Dialog, $timeout, $q) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.Dialog = Dialog;
        this.$timeout = $timeout;
        this.$q = $q;
        this.table = { sortType: 'type', sortReverse: false, search: '', filter: false, filterParams: {} };
        this.codes = [];
        this.codesLoaded = false;
        this.codeTypes = [];
        this.editing = false;
        this.serverError = undefined;
        this.events = { beingSaved: false };
        this.subTypes = {
            closed_codes: ['Closed'],
            dispute_codes: ['Appeal', 'Dispute', 'Exception', 'Investment Review', 'Clawback', 'Out of Policy'],
            payment_codes: ['Payment'],
            rejection_codes: ['Rejection']
        };
        this.table.headers = [{
                Type: 'type', Code: 'code', Description: 'desc', Actions: 'actions'
            }];
        this.socket.forward('config.misc_codes', this.$scope);
        this.$scope.$on('socket:config.misc_codes', function (event, payload) {
            _this.codes = payload.data;
            _this.codeTypes = payload.types;
            _this.codesLoaded = true;
            _this.selectedType = _this.codeTypes[2];
        });
    }
    MiscCodesViewController.prototype.$onInit = function () {
        this.admin.getMiscCodes(true);
    };
    MiscCodesViewController.prototype.editCode = function (code) {
        this.editing = true;
        //Combination of type and code must be unique, ie: 'dispute_codes' and 'D001'
        this.editCodePack = this.getCode(this.selectedType, code);
    };
    MiscCodesViewController.prototype.getNextCode = function (type, subtype) {
        var prefix = angular.isUndefined(subtype) ? type.charAt(0).toUpperCase() : subtype.charAt(0);
        //If no codes yet...
        if (this.codes[type].codes.length === 0) {
            return prefix + '001'; //Return x001
        }
        //Otherwise work out what the next will be
        var lowest = 0;
        if (this.codes[type].codes.length > 0) {
            //lowest = parseInt(this.codes[type].codes[0].code.substring(1), 10); //get the first index
            if (subtype !== null) {
                this.codes[type].codes.some(function (c) {
                    if (c.type.charAt(0) === prefix) {
                        lowest = parseInt(c.code.substring(1), 10);
                        return true;
                    }
                });
            }
            //If here and still 0 then there's no match
            if (lowest === 0) {
                return prefix + '001'; //Return x001
            }
            var highest_1 = lowest;
            var next = void 0;
            angular.forEach(this.codes[type].codes, function (c) {
                var stp = c.type.charAt(0);
                if (prefix === stp) {
                    var tNum = parseInt(c.code.substring(1), 10);
                    if (tNum < lowest) {
                        lowest = tNum;
                    }
                    if (tNum > highest_1) {
                        highest_1 = tNum;
                    }
                }
            });
            //Code will be a letter followed by 3 numbers
            if (lowest !== 1) {
                //if lowest is x004 for example...it means 1, 2 and 3 have been deleted, so return 3
                next = lowest - 1; //Probably will remove this...
            }
            else {
                next = highest_1 + 1;
            }
            return prefix + ('000' + next).substring(('000' + next).length - 3);
        }
    };
    MiscCodesViewController.prototype.refreshCodes = function () {
        var _this = this;
        //After an edit/delete or new code, and once success back from server, update content in browser
        var index = 0;
        if (this.editCodePack.delete) {
            this.codes[this.editCodePack.code_set].codes.some(function (code) {
                if (code.code === _this.editCodePack.code) {
                    _this.codes[_this.editCodePack.code_set].codes.splice(index, 1);
                    return true; //break loop
                }
                index++;
            });
        }
        else {
            if (this.editCodePack.new) {
                //new
                var newb = {
                    code: this.editCodePack.code,
                    desc: this.editCodePack.desc,
                    type: this.editCodePack.type
                };
                this.codes[this.editCodePack.code_set].codes.push(newb);
            }
            else {
                this.codes[this.editCodePack.code_set].codes.some(function (code) {
                    if (code.code === _this.editCodePack.code) {
                        code.type = _this.editCodePack.type;
                        code.code = _this.editCodePack.code;
                        code.desc = _this.editCodePack.desc;
                        return true; //break loop
                    }
                    index++;
                });
            }
        }
    };
    MiscCodesViewController.prototype.createNew = function () {
        var st = this.selectedType;
        var sub = this.subTypes[st];
        var newCode = this.getNextCode(st, st === 'dispute_codes' ? sub[0] : undefined);
        var McBundle = (function () {
            function McBundle() {
                this.code = newCode;
                this.code_set = st;
                this.desc = '';
                this.type = sub[0];
                this.new = true;
                this.delete = false;
                this.other = false;
            }
            return McBundle;
        }());
        this.editCodePack = new McBundle();
        this.editing = true;
        // this.newProfile = true;
    };
    /**
     * Function to collect the user-selected code and build a bundle to be processed
     *
     * @param {string} type the misc code type, ie: payment_codes, dispute_codes
     * @param {string} code the unique code within the above array, ie: D001 would be a code within dispute_codes
     * @returns {IMiscCode}
     *
     * @memberOf MiscCodesViewController
     */
    MiscCodesViewController.prototype.getCode = function (type, code) {
        var cp;
        this.codes[type].codes.some(function (c) {
            if (c.code === code) {
                cp = c;
                return true; //break loop    
            }
        });
        var McBundle = (function () {
            function McBundle() {
                this.code = cp.code;
                this.code_set = type;
                this.desc = cp.desc;
                this.type = cp.type;
                this.new = false;
                this.delete = false;
                this.other = cp.other;
            }
            return McBundle;
        }());
        return new McBundle(); //It WILL find it
    };
    MiscCodesViewController.prototype.confirmDelete = function (event, pack) {
        var _this = this;
        var items = {
            icon: 'QUESTION',
            message: 'Are you sure you want to Delete the following code from the ' + this.admin.toProperCase(this.selectedType) + '?<p><p>' +
                '<span class="ibm-textcolor-blue-40">' + pack.code + ' - ' + pack.desc + '</span>',
            title: 'Delete Code'
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                //build the package and lose it
                _this.editCodePack = _this.getCode(_this.selectedType, pack.code);
                _this.editCodePack.delete = true;
                _this.update(_this.editCodePack);
            }
        });
    };
    MiscCodesViewController.prototype.save = function () {
        this.update(this.editCodePack);
    };
    MiscCodesViewController.prototype.update = function (codePack) {
        var _this = this;
        this.events.beingSaved = true;
        this.serverError = undefined;
        //Make the call via a promise which will wait up to 30 seconds for a response
        this.updatePromise(codePack).then(function (data) {
            //If response from server received
            _this.events.beingSaved = false; //enable again
            _this.serverError = data.err;
            if (angular.isUndefined(data.err)) {
                //Update the code set accordingly, ie: delete, update, add
                _this.refreshCodes();
                //If editing or adding new, return to view
                _this.editing = false;
            }
        }, function (nothingReturnedInTime) {
            //If no response from server received
            _this.events.beingSaved = false; //enable save again
            _this.serverError = 'The server does not appear to be responding, or did not respond in a reasonable time.  Please try again.  If the problem persists, please contact the DMT System Administrators.';
        });
    };
    MiscCodesViewController.prototype.updatePromise = function (pack) {
        var _this = this;
        this.deferred = this.$q.defer(); //Set deferred object...to be sent to browser
        this.$timeout(function () {
            _this.deferred.reject([]); //If not resolved within 3 seconds...reject
        }, 30000); //30 secs = 30000
        this.admin.updateMiscCodes(pack);
        this.socket.forward('config.misc_codes_update', this.$scope);
        this.$scope.$on('socket:config.misc_codes_update', function (event, data) {
            _this.deferred.resolve(data); //add the results to the deferred object
        });
        return this.deferred.promise; //fire off the promise
    };
    MiscCodesViewController.$inject = ['env', '$filter', '$stateParams', '$state', 'socket', '$scope', 'admin', 'Dialog', '$timeout', '$q'];
    return MiscCodesViewController;
}());
var MiscCodesViewComponent = (function () {
    function MiscCodesViewComponent() {
        this.templateUrl = 'codes-view.html';
        this.controllerAs = 'vm';
        this.controller = MiscCodesViewController;
    }
    return MiscCodesViewComponent;
}());
angular
    .module('application')
    .component('viewMiscCodesSection', new MiscCodesViewComponent());



var ColumnsEditController = (function () {
    function ColumnsEditController(env, $filter, DTS, $stateParams, $state, socket, $scope, config, admin, $timeout, Dialog, $q, settings, notify) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.config = config;
        this.admin = admin;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.$q = $q;
        this.settings = settings;
        this.notify = notify;
        this.id = '';
        this.program = '';
        this.dataLoaded = false;
        this.modified = false;
        this.modifiedItem = false;
        this.okMessage = undefined;
        this.errorMessage = undefined;
        this.enableProgramChange = true;
        this.editMain = true;
        this.editCl = true;
        this.id = $stateParams.id;
        this.program = $stateParams.program;
        this.actionList = [
            { id: undefined, desc: 'If there is no action assigned, keep this selection selected', name: 'No action' }
        ];
        this.tempCheckList = {
            pickedProgram: '',
            pickedIots: [],
            check_list: [],
            groupID: undefined,
            _rev: undefined,
            cl_rb: { desc: '', picked: '', rb: [] },
            check_list2: [],
            cl2_rb: { desc: '', picked: '', rb: [] },
            check_list3: [],
            cl3_rb: { desc: '', picked: '', rb: [] },
            check_list_validation: [],
            cl_validation_rb: { desc: '', picked: '', rb: [] },
            check_list_calculation: [],
            cl_calculation_rb: { desc: '', picked: '', rb: [] },
            check_list_opportunity_detail: [],
            cl_opportunity_detail_rb: { desc: '', picked: '', rb: [] },
            check_list_investment_review: [],
            cl_investment_rb: { desc: '', picked: '', rb: [] },
            check_list_payment: [],
            cl_payment_rb: { desc: '', picked: '', rb: [] },
            check_list_exceptions: [],
            cl_exceptions_rb: { desc: '', picked: '', rb: [] }
        };
        // Makes sure, that on leave without save, you will get a prompt
        this.$scope.$on("$locationChangeStart", function (event) {
            if (_this.modified) {
                // Only way I could do this is the blocking confirm. Its not possible with angular dialog promise
                var dialogCheck = confirm('Data not saved! Do you want to leave the page without saving? Press OK to leave page or CANCEL to stay on page');
                if (!dialogCheck) {
                    event.preventDefault();
                }
            }
        });
        // Based on what action was received data will be updated
        this.socket.forward('admin.program_checklist_edit', this.$scope);
        this.$scope.$on('socket:admin.program_checklist_edit', function (event, data) {
            if (_this.browserID === data.browserID) {
                if (data.action === 'update') {
                    if (data.success) {
                        _this.message(event, data);
                        _this.dataLoaded = true;
                        _this.$state.go('admin.checklist-view');
                    }
                    else {
                        _this.okMessage = undefined;
                        _this.errorMessage = data.msg;
                    }
                }
                else if (data.action === 'clear') {
                    if (data.success) {
                        _this.message(event, data);
                        _this.dataLoaded = true;
                        _this.$state.go('admin.checklist-view');
                    }
                    else {
                        _this.okMessage = undefined;
                        _this.errorMessage = data.msg;
                    }
                }
                else if (data.action === 'getItem') {
                    if (data.success) {
                        _this.message(event, data);
                        _this.dataLoaded = true;
                        _this.tempCheckList = data.dataUpdated;
                        _this.checkList = angular.copy(_this.tempCheckList);
                        _this.enableProgramChange = false;
                        _this.okMessage = 'checklist retreived successfully';
                        _this.errorMessage = undefined;
                    }
                    else {
                        _this.message(event, data);
                        _this.$state.go('admin.checklist-view');
                    }
                }
            }
            else {
                _this.okMessage = undefined;
                _this.errorMessage = 'Page has been left or reloaded, please reload for the changes to take effect';
            }
        });
    }
    /**
      message- Shows a red or green md-toast based on the message
      @param {any} ev       event
      @param {any} data     data containg msg and err based on error
      @returns void
    */
    ColumnsEditController.prototype.message = function (ev, data) {
        if (data.err) {
            return this.notify.error(data.msg);
        }
        this.notify.success(data.msg);
    };
    /**
      backToView- Moves back to checklist view
      @returns void
    */
    ColumnsEditController.prototype.backToView = function () {
        this.modified = false;
        this.$state.go('admin.checklist-view');
    };
    /**
      changedIot- On iot change modification is registered
      @returns void
    */
    ColumnsEditController.prototype.changedIot = function () {
        this.modified = true;
    };
    ColumnsEditController.prototype.$onInit = function () {
        var array = new Uint32Array(2);
        this.browserID = window.crypto.getRandomValues(array)[0];
        if (!(angular.isDefined(this.program) && !(this.program === 'new' || this.program === ''))) {
            this.tempCheckList.pickedProgram = this.program;
        }
        if (angular.isDefined(this.admin.config)) {
            this.admin.getGeneralConfig();
        }
        ;
        //////////this.settings.updateIot();
        if (angular.isDefined(this.id) && !(this.id === 'new' || this.id === '')) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getAdminProfile',
                    script: '/admin/admin',
                    browserID: this.browserID,
                    data: {
                        program: this.program,
                        groupID: this.id,
                        token: this.env.user.token,
                        adminComponent: 'checklist'
                    },
                    token: this.env.user.token
                }
            });
        }
        else {
            this.checkList = angular.copy(this.tempCheckList);
            this.dataLoaded = true;
        }
    };
    /**
      savePage- Confirms the changes done on the checklist edit page
      @param {IAngularEvent} event   event
      @returns void
    */
    ColumnsEditController.prototype.savePage = function (event) {
        var _this = this;
        var items = {
            message: 'Are you sure you want to Save this Profile? ',
            okMessage: 'Save',
            cancelMessage: 'Cancel',
            dialogName: 'Save checklist Profile'
        };
        this.Dialog.YesNoForm(event, items, 'yes-no.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'updateAdminData',
                        script: '/admin/admin',
                        browserID: _this.browserID,
                        data: {
                            token: _this.env.user.token,
                            groupID: _this.checkList.groupID,
                            adminComponent: 'checklist',
                            data: _this.tempCheckList
                        },
                        token: _this.env.user.token
                    }
                });
            }
        });
    };
    /**
      clearPage- Will remove the displayed profile from the cloudant document
      @param {IAngularEvent} event   event
      @returns void
    */
    ColumnsEditController.prototype.clearPage = function (event) {
        var _this = this;
        var items = {
            message: 'Are you sure you want to Delete this Profile? ',
            okMessage: 'Delete',
            cancelMessage: 'Cancel',
            dialogName: 'Delete checklist Profile'
        };
        this.Dialog.YesNoForm(event, items, 'yes-no.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'clearAdminData',
                        script: '/admin/admin',
                        browserID: _this.browserID,
                        data: {
                            program: _this.program,
                            groupID: _this.id,
                            token: _this.env.user.token,
                            adminComponent: 'checklist'
                        },
                        token: _this.env.user.token
                    }
                });
            }
        });
    };
    /**
      clearIOT- Clears the IOT selection
      @returns void
    */
    ColumnsEditController.prototype.clearIOT = function () {
        this.tempCheckList.pickedIots = [];
    };
    /**
      expand - Expands the section with checklist & radio buttons
      @param {string} name:   name of the checklist section
    */
    ColumnsEditController.prototype.expand = function (name) {
        angular.forEach(this.admin.listOfCheckList, function (cl) {
            if (cl.name === name) {
                cl.visible = true;
            }
        });
    };
    /**
      collapse - Collapses the section with checklist & radio buttons
      @param {string} name:   name of the checklist section
    */
    ColumnsEditController.prototype.collapse = function (name) {
        angular.forEach(this.admin.listOfCheckList, function (cl) {
            if (cl.name === name) {
                cl.visible = false;
            }
        });
    };
    /**
      editSection - Enables edit mode of the selected section
      @param {string} name:   name of the checklist section
    */
    ColumnsEditController.prototype.editSection = function (name) {
        var _this = this;
        angular.forEach(this.admin.listOfCheckList, function (cl) {
            if (cl.name === name) {
                _this.backupCheckList = angular.copy(_this.tempCheckList[cl.variableName]);
                _this.backupRadioButton = angular.copy(_this.tempCheckList[cl.radioButtonName]);
                cl.editView = true;
                cl.visible = true;
                _this.editMain = false;
            }
            else {
                cl.editView = false;
            }
        });
    };
    /**
      saveSection - Confirms the changes of the selected section & saves them
      @param {string} name:   name of the checklist section
    */
    ColumnsEditController.prototype.saveSection = function (name) {
        var _this = this;
        this.modifiedItem = false;
        this.modified = true;
        angular.forEach(this.admin.listOfCheckList, function (cl) {
            if (cl.name === name) {
                _this.backupCheckList = [];
                _this.backupRadioButton = { desc: '', picked: '', rb: [] };
                cl.editView = false;
                _this.editMain = true;
            }
        });
    };
    /**
      cancelSection - Retreives the checklist & radioButton object, that was stored as backup, when edit button was inserted.
      @param {string} name:   name of the checklist section
    */
    ColumnsEditController.prototype.cancelSection = function (name) {
        var _this = this;
        angular.forEach(this.admin.listOfCheckList, function (cl) {
            if (cl.name === name) {
                _this.tempCheckList[cl.variableName] = angular.copy(_this.backupCheckList);
                _this.tempCheckList[cl.radioButtonName] = angular.copy(_this.backupRadioButton);
                _this.backupCheckList = [];
                _this.backupRadioButton = { desc: '', picked: '', rb: [] };
                cl.editView = false;
                _this.editMain = true;
            }
        });
    };
    /**
      addItem - Adds a new checklist question on the end of the checklist list
      @param {string} variableName:   name of the checklist object
    */
    ColumnsEditController.prototype.addItem = function (variableName) {
        this.modifiedItem = true;
        this.editCl = false;
        this.tempCheckList[variableName].push({ q: '', answer: '', editMode: true });
        this.backupCheckListItem = angular.copy({ q: '', answer: '', editMode: false });
    };
    /**
      removeItem - Removes checklist question from the index position
      @param {string} variableName:   name of the checklist object
      @param {number} index:          position of the removed check list question
    */
    ColumnsEditController.prototype.removeItem = function (variableName, index) {
        this.modifiedItem = true;
        if (angular.isDefined(this.tempCheckList[variableName]) && this.tempCheckList[variableName].length > index) {
            this.backupCheckListItem = undefined;
            this.tempCheckList[variableName].splice(index, 1);
        }
        this.editCl = true;
    };
    /**
      saveItem - Saves the checklist in the edit mode on the index position
      @param {string} variableName:   name of the checklist object
      @param {number} index:          position of the saved check list question
    */
    ColumnsEditController.prototype.saveItem = function (variableName, index) {
        this.modifiedItem = true;
        if (angular.isDefined(this.tempCheckList[variableName]) && this.tempCheckList[variableName].length > index) {
            this.backupCheckListItem = undefined;
            this.tempCheckList[variableName][index].editMode = false;
        }
        this.editCl = true;
    };
    /**
      editItem - Enables editing of the checklist on the index position
      @param {string} variableName:   name of the checklist object
      @param {number} index:          position of the to be edited check list question
    */
    ColumnsEditController.prototype.editItem = function (variableName, index) {
        this.editCl = false;
        if (angular.isDefined(this.tempCheckList[variableName]) && this.tempCheckList[variableName].length > index) {
            this.backupCheckListItem = angular.copy(this.tempCheckList[variableName][index]);
            this.tempCheckList[variableName][index].editMode = true;
        }
    };
    /**
      cancelItem - Restores the backuped checklist question and disables edit mode
      @param {string} variableName:   name of the checklist object
      @param {number} index:          position of the check list question where to be restored from the backup
    */
    ColumnsEditController.prototype.cancelItem = function (variableName, index) {
        this.tempCheckList[variableName][index] = angular.copy(this.backupCheckListItem);
        this.backupCheckListItem = undefined;
        this.tempCheckList[variableName][index].editMode = false;
        this.editCl = true;
    };
    /**
      addItemLine - Inserts a new checklist question on the position of the index
      @param {string} variableName:   name of the checklist object
      @param {number} index:          position of the check list question where a new question will be added
    */
    ColumnsEditController.prototype.addItemLine = function (variableName, index) {
        this.modifiedItem = true;
        var tempCl = angular.copy(this.tempCheckList[variableName]);
        if (angular.isDefined(tempCl) && tempCl.length > index) {
            tempCl.splice(index, 0, { q: '', answer: '', editMode: true });
            this.backupCheckListItem = angular.copy({ q: '', answer: '', editMode: false });
        }
        this.editCl = false;
        this.tempCheckList[variableName] = angular.copy(tempCl);
    };
    /**
      addRb - Adds a radio button question on the last position
      @param {string} radioButtonName:   name of the radio button object
    */
    ColumnsEditController.prototype.addRb = function (radioButtonName) {
        var tempIndex = 0;
        angular.forEach(this.tempCheckList[radioButtonName].rb, function (radioButton) {
            if (angular.isDefined(radioButton.value)) {
                if (tempIndex < radioButton.value) {
                    tempIndex = radioButton.value;
                }
            }
        });
        tempIndex++;
        this.tempCheckList[radioButtonName].rb.push({ name: '', value: tempIndex });
    };
    /**
      clearRb - Clears the selection of any of those items
      @param {string} radioButtonName:   name of the radio button object
    */
    ColumnsEditController.prototype.clearRb = function (radioButtonName) {
        this.tempCheckList[radioButtonName].picked = '';
    };
    /**
      removeRbItem - Removes the radiobutton option from the index position
      @param {string} radioButtonName:    name of the radio button object
      @param {number} index:              position of the radiobutton that will be removed
    */
    ColumnsEditController.prototype.removeRbItem = function (radioButtonName, index) {
        if (angular.isDefined(this.tempCheckList[radioButtonName].rb) && !(this.tempCheckList[radioButtonName].rb.length - 1 < index)) {
            this.tempCheckList[radioButtonName].rb.splice(index, 1);
        }
    };
    ColumnsEditController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state',
        'socket', '$scope', 'config', 'admin', '$timeout', 'Dialog', '$q', 'settings', 'notify'];
    return ColumnsEditController;
}());
var ColumnsEditComponent = (function () {
    function ColumnsEditComponent() {
        this.templateUrl = 'columns.html';
        this.controllerAs = 'vm';
        this.controller = ColumnsEditController;
    }
    return ColumnsEditComponent;
}());
angular
    .module('application')
    .component('adminColumnsSection', new ColumnsEditComponent());



var ColumnsViewController = (function () {
    function ColumnsViewController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin, Dialog, notify, settings) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.Dialog = Dialog;
        this.notify = notify;
        this.settings = settings;
        this.table = { headersNames: [], dataNames: [], headersOrder: [], dataOrder: [], filter: false, filterParams: {} };
        this.programs = [];
        this.programsLoaded = false;
        this.dataLoaded = false;
        this.table.headerNames = [
            { header: 'Search type' },
            { header: 'Data Source' },
            { header: 'Main' },
            { header: 'Secondary' }
        ];
        //this.logsColumnHeaders = ['Program', 'Action', 'Time', 'User', 'IOTs'];
        this.socket.forward('admin.program_columns_view', this.$scope);
        this.$scope.$on('socket:admin.program_columns_view', function (event, data) {
            if (data.action === 'logs-group') {
                if (data.success) {
                    if (angular.isDefined(data)) {
                        _this.table.dataNames = _this.adjustColumnNamesLayout(data.dataUpdated.all_column_order);
                        _this.table.dataOrder = data.all_column_order;
                    }
                }
                else {
                    _this.notify.error(data.msg);
                }
            }
            else if (data.action === 'single-log') {
                if (data.success) {
                    var items = {
                        dialogName: 'Check List change: ',
                        logInfo: data.dataUpdated,
                        admin: _this.admin
                    };
                    _this.Dialog.updateValidForm(event, items, 'detail-cl-single-log.html').then(function (dResult) {
                    });
                }
                else {
                    _this.notify.error(data.msg);
                }
            }
            else {
                _this.dataLoaded = true;
                if (angular.isDefined(data) && angular.isDefined(data.dataUpdated)) {
                    _this.table.dataNames = _this.adjustColumnNamesLayout(data.dataUpdated.all_column_order);
                    _this.table.dataOrder = data.dataUpdated.all_column_order;
                }
            }
        });
    }
    /**
      adjustColumnNamesLayout - Transforms the column names object into more user friendly form
      @param {number} original:         original object from the cloudant document
      return  newColumnLayout           user friendly modified object to display column layout
    */
    ColumnsViewController.prototype.adjustColumnNamesLayout = function (original) {
        var displayColumnLayout = [];
        var newColumnLayout;
        var oldColumnLayout = angular.copy(original);
        var correction;
        for (var i = 0; i < original.length; i++) {
            correction = 0;
            if (angular.isDefined(original[i])) {
                newColumnLayout = { current: '', ds: [], versions: [] };
                if (angular.isDefined(original[i].current)) {
                    newColumnLayout.current = original[i].current;
                    delete oldColumnLayout[i].current;
                    correction++;
                }
                if (angular.isArray(original[i].ds)) {
                    newColumnLayout.ds = original[i].ds;
                    delete oldColumnLayout[i].ds;
                    correction++;
                }
                for (var prop in oldColumnLayout[i]) {
                    newColumnLayout.versions.push({
                        versionName: prop,
                        columnLayout: oldColumnLayout[i][prop]
                    });
                }
                ;
                if (newColumnLayout.versions.length === 0) {
                    newColumnLayout.versions.push({
                        versionName: '',
                        columnLayout: { main: [], second: [] }
                    });
                }
            }
            if (correction > 1) {
                displayColumnLayout.push(newColumnLayout);
            }
        }
        ;
        return displayColumnLayout;
    };
    /**
      editMode - Opens the edit checklist view
      @param {number} index:            ID in the array of checklists
      @param {string} program:          program of the to be modified questions
    */
    ColumnsViewController.prototype.editMode = function (index, program) {
        this.$state.go('admin.checklist', { id: index, program: program });
    };
    /**
      viewLogs - Will display the logs of the specified program, only in a limited height
      @param {string} program:        programs name
      @param {boolean} visible:       hides or shows the logs
    */
    ColumnsViewController.prototype.viewLogs = function (program, visible) {
        var preLoaded = false;
        angular.forEach(this.table.data, function (tableItem) {
            if (tableItem.program === program) {
                tableItem.visible = visible;
                if (angular.isUndefined(tableItem.logsData)) {
                    preLoaded = true;
                }
            }
        });
        if (visible && preLoaded) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getAdminLogs',
                    script: '/admin/admin',
                    data: {
                        token: this.env.user.token,
                        adminComponent: 'columns',
                        program: program
                    },
                    token: this.env.user.token
                }
            });
        }
    };
    /**
      showSingleLog - Opens a dialog with the checklist questions, that were logged
      @param {string} path:   name of the cloudant document stripped of the single logs unique name parts
    */
    ColumnsViewController.prototype.showSingleLog = function (path) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getAdminSingleLog',
                script: '/admin/admin',
                data: {
                    token: this.env.user.token,
                    adminComponent: 'columns',
                    path: path
                },
                token: this.env.user.token
            }
        });
    };
    ColumnsViewController.prototype.$onInit = function () {
        var array = new Uint32Array(2);
        this.browserID = window.crypto.getRandomValues(array)[0];
        if (angular.isDefined(this.admin.config)) {
            this.admin.getGeneralConfig();
        }
        ;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getAdminData',
                script: '/admin/admin',
                data: {
                    token: this.env.user.token,
                    adminComponent: 'columns'
                },
                token: this.env.user.token
            }
        });
    };
    /**
      createNew - Creates a new checklist object in edit mode to be added
    */
    ColumnsViewController.prototype.createNew = function () {
        this.$state.go('admin.checklist', { id: 'new', program: 'new' });
    };
    ColumnsViewController.prototype.showColumns = function (line, type) {
        var varName = 'visible' + type;
        line[varName] = (angular.isDefined(line[varName]) && !line[varName]) ? true : false;
    };
    ColumnsViewController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'admin', 'Dialog', 'notify', 'settings'];
    return ColumnsViewController;
}());
var ColumnsViewComponent = (function () {
    function ColumnsViewComponent() {
        this.templateUrl = 'columns-view.html';
        this.controllerAs = 'vm';
        this.controller = ColumnsViewController;
    }
    return ColumnsViewComponent;
}());
angular
    .module('application')
    .component('viewColumnsSection', new ColumnsViewComponent());



var CompliancePlanColumnIdName;
(function (CompliancePlanColumnIdName) {
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["BP_CEID"] = 'BP CEID'] = "BP_CEID";
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["BP_NAME"] = 'BP Name'] = "BP_NAME";
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["COUNTRY"] = 'Country'] = "COUNTRY";
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["IOT"] = 'GEO'] = "IOT";
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["IMT"] = 'Market'] = "IMT";
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["START_DATE"] = 'Review start date'] = "START_DATE";
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["actions"] = 'Actions'] = "actions";
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["COUNTRY_ISO"] = 'COUNTRY_ISO'] = "COUNTRY_ISO";
})(CompliancePlanColumnIdName || (CompliancePlanColumnIdName = {}));
var CompliancePlanLogColumnIdName;
(function (CompliancePlanLogColumnIdName) {
    CompliancePlanLogColumnIdName[CompliancePlanLogColumnIdName["ACTION_TIMESTAMP"] = 'Time'] = "ACTION_TIMESTAMP";
    CompliancePlanLogColumnIdName[CompliancePlanLogColumnIdName["ACTION_COMMENT"] = 'Changes made'] = "ACTION_COMMENT";
    CompliancePlanLogColumnIdName[CompliancePlanLogColumnIdName["USER_EMAIL"] = ' Changed by'] = "USER_EMAIL";
})(CompliancePlanLogColumnIdName || (CompliancePlanLogColumnIdName = {}));
var CompliancePlanController = (function () {
    function CompliancePlanController(settings, env, $compile, $filter, socket, $scope, Dialog, notify, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$compile = $compile;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.notify = notify;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this.DTColumnDefBuilder = DTColumnDefBuilder;
        this.itemsLoaded = false;
        this.logLoaded = false;
        this.processing = true;
        this.exportFired = false;
        this.importingExcel = false;
        this.tableItems = [];
        this.logItems = [];
        this.docTable = [];
        this.backendModuleName = 'admin/complianceplan/compliance-plan';
        this.scopePrefix = 'admin.complianceList';
        this.scopeDeleteRecord = this.scopePrefix + ".delete";
        this.scopeUpdateRecord = this.scopePrefix + ".update";
        this.scopeCreateRecord = this.scopePrefix + ".insert";
        this.scopeExport = this.scopePrefix + ".export";
        this.scopeDeleteAll = this.scopePrefix + ".deleteall";
        this.scopeImportFromExcel = this.scopePrefix + ".importFromExcel";
        this.scopeReplaceFromExcel = this.scopePrefix + ".replaceAllFromExcel";
        this.table = {
            dtColumns: {},
            dtInstance: {},
            filter: false,
            filterParams: {},
            filters: { BP: '' },
            search: '',
            select_options: {},
            visible: 0
        };
        this.tableLog = {
            dtColumns: {},
            dtInstance: {},
            filter: false,
            filterParams: {},
            filters: { ACTION_TIMESTAMP: '' },
            search: '',
            select_options: {},
            visible: 0
        };
        // CREATE
        this.socket.forward(this.scopeCreateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeCreateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Create a record');
                _this.notify.error("Unable to create a record");
            }
            else {
                _this.notify.success('Record successfuly added');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // DELETE
        this.socket.forward(this.scopeDeleteRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Delete record');
                _this.notify.error("Unable to delete record");
            }
            else {
                _this.notify.success('Record was deleted successful!');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // UPDATE
        this.socket.forward(this.scopeUpdateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Update the record');
                _this.notify.error("Unable to update the record");
            }
            else {
                _this.notify.success('Comliance plan successfuly updated!');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // DOWNLOAD EXCEL
        this.socket.forward(this.scopeExport, this.$scope);
        this.$scope.$on("socket:" + this.scopeExport, function (event, data) {
            _this.exportFired = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Exporting list');
                return _this.notify.error("Can't to export list");
            }
            else {
                _this.downloadFile(data.payload, 'DMT-COMPLIANCE-PLAN');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
                return _this.notify.success('Compliance plan with BP list was exported successful!');
            }
        });
        // DELETE ALL
        this.socket.forward(this.scopeDeleteAll, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteAll, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Delete all records');
                _this.notify.error("Unable to delete all records");
            }
            else {
                _this.notify.success('All records was deleted successful!');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // UPLOADADED
        this.socket.forward(this.scopeImportFromExcel, this.$scope);
        this.$scope.$on("socket:" + this.scopeImportFromExcel, function (event, data) {
            _this.importingExcel = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Upload and Add from Excel');
                _this.notify.error("Can't to upload and add from Excel");
            }
            else {
                _this.notify.success('Uploaded and add from Excel successful!');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // UPLOAD REPLACE
        this.socket.forward(this.scopeReplaceFromExcel, this.$scope);
        this.$scope.$on("socket:" + this.scopeReplaceFromExcel, function (event, data) {
            _this.importingExcel = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Upload and Replace from Excel');
                _this.notify.error("Can't to upload and replace from Excel");
            }
            else {
                _this.notify.success('Uploaded and replace from Excel successful!');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
    }
    CompliancePlanController.prototype.$onInit = function () {
        var _this = this;
        this.signalWrongResponse = '';
        this.table.dtColumns = this.buildColumns();
        this.table.dtOptions = this.DTOptionsBuilder.newOptions()
            .withIBMTheme()
            .withOption('alphabetColumnIndex', 3)
            .withOption('ajax', this.buildAjaxOption())
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('order', [[3, 'asc']]) // Default sorting by BP name
            .withPaginationType('full_numbers')
            .withOption('createdRow', function (row) {
            _this.$compile(angular.element(row).contents())(_this.$scope);
        })
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
        this.tableLog.dtColumns = this.buildLogColumns();
        this.tableLog.dtOptions = this.DTOptionsBuilder.newOptions()
            .withIBMTheme()
            .withOption('ajax', this.buildLogAjaxOption())
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('order', [[0, 'desc']]) // Default sorting by time
            .withPaginationType('full_numbers')
            .withOption('createdRow', function (row) {
            _this.$compile(angular.element(row).contents())(_this.$scope);
        })
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
    };
    /**
     * Function to add new row in DB
     */
    CompliancePlanController.prototype.addRow = function (event) {
        var _this = this;
        var tit = 'Add Compliance Plan record';
        var DEFAULT_SELECTION = '-Please select-';
        var result = this.extractCountry();
        var endDate = new Date();
        endDate.setFullYear(endDate.getFullYear() + 1);
        var emptyItem = {
            bpCeid: '',
            bpName: '',
            country: DEFAULT_SELECTION,
            countryIso: '',
            imt: DEFAULT_SELECTION,
            iot: DEFAULT_SELECTION,
            startDate: new Date()
        };
        var items = {
            icon: 'QUESTION',
            message: 'Are you sure, you want to add a new record to existing list?',
            title: tit,
            tree: result.tree,
            // tslint:disable-next-line:object-literal-sort-keys
            iots: Object.keys(result.tree).sort(),
            imts: result.imts,
            newItem: emptyItem,
            listIOTs: function (tree) { return Object.keys(tree).sort(); },
            listIMTs: function (tree, iot) { return Object.keys(tree[iot] || {}).sort(); },
            listCountries: function (tree, iot, imt) { return (tree[iot] || {})[imt] || []; }
        };
        this.Dialog.updateValidForm(event, items, CompliancePlanController.TEMPLATE_CONFIRM)
            .then(function (dResult) {
            if (!dResult.confirm) {
                return;
            }
            _this.Dialog.updateValidForm(event, items, 'complianceplan-add.html')
                .then(function (answer) {
                var newItem = answer.newItem;
                items.newItem = newItem;
                var date = newItem.startDate;
                newItem.startDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
                newItem.countryIso = _this.settings.country_list
                    .filter(function (num) { return num.country === newItem.country; })[0].short;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: newItem,
                        email: _this.env.user.email,
                        function: 'insertRecord',
                        scopeBack: _this.scopeCreateRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token
                    }
                });
            });
        });
    };
    /**
     * Function to delete a row in DB
     */
    CompliancePlanController.prototype.deleteRow = function (event, rowId) {
        var _this = this;
        var rowData = this.tableItems[rowId];
        this.Dialog.confirmDelete(event, rowData).then(function (dResult) {
            if (dResult) {
                var dataToDelete = {
                    bpCeid: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.BP_CEID]],
                    country: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.COUNTRY]],
                    countryIso: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.COUNTRY_ISO]],
                    startDate: new Date(rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.START_DATE]])
                };
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: dataToDelete,
                        email: _this.env.user.email,
                        function: 'deleteRecord',
                        scopeBack: _this.scopeDeleteRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token
                    }
                });
            }
        });
    };
    /**
     * Function to update the row of Compliance plan in DB
     */
    CompliancePlanController.prototype.updateRow = function (event, rowId) {
        var _this = this;
        var rowData = this.tableItems[rowId];
        var result = this.extractCountry();
        var orginalData = {
            bpCeid: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.BP_CEID]],
            country: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.COUNTRY]],
            countryIso: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.COUNTRY_ISO]],
            startDate: new Date(rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.START_DATE]])
        };
        var dataToUpdate = {
            bpCeid: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.BP_CEID]],
            bpName: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.BP_NAME]],
            country: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.COUNTRY]],
            countryIso: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.COUNTRY_ISO]],
            imt: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.IMT]],
            iot: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.IOT]],
            startDate: new Date(rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.START_DATE]])
        };
        var updatedData = {
            tree: result.tree,
            // tslint:disable-next-line:object-literal-sort-keys
            iots: Object.keys(result.tree).sort(),
            imts: result.imts,
            content: dataToUpdate,
            orgContent: orginalData,
            listIOTs: function (tree) { return Object.keys(tree).sort(); },
            listIMTs: function (tree, iot) {
                return Object.keys(tree[iot] || {}).sort();
            },
            listCountries: function (tree, iot, imt) {
                return (tree[iot] || {})[imt] || [];
            }
        };
        this.Dialog.updateValidForm(event, updatedData, 'complianceplan-edit.html')
            .then(function (dResult) {
            var item = updatedData.content;
            var orgItem = updatedData.orgContent;
            var date = item.startDate;
            item.startDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
            item.countryIso = _this.settings.country_list
                .filter(function (num) { return num.country === item.country; })[0].short;
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: item,
                    email: _this.env.user.email,
                    function: 'updateRecord',
                    orgData: orgItem,
                    scopeBack: _this.scopeUpdateRecord,
                    script: _this.backendModuleName,
                    token: _this.env.user.token
                }
            });
        });
    };
    CompliancePlanController.prototype.buildAjaxOption = function () {
        var _this = this;
        return {
            url: '/api/admin/compliance-plan',
            // tslint:disable-next-line:object-literal-sort-keys
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                _this.itemsLoaded = false;
                request.setRequestHeader('Authorization', "Bearer " + _this.env.user.token);
            },
            data: function (draw) {
                var dt = _this.table.dtInstance.DataTable;
                if (dt && dt.context && Array.isArray(dt.context)) {
                    draw.alphabetSearch = dt.context[0].alphabetSearch;
                }
            },
            dataSrc: function (data) {
                _this.tableItems = data.data;
                _this.itemsLoaded = true;
                _this.processing = false;
                return data.data;
            }, error: function (xhr, errorMessage, thrown) {
                // Display message, when an error appears
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve Compliance Plan data from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (xhr.responseText) {
                    items.message += "<b>" + xhr.responseText + "</b>\n                    <br>Please try again, if the problem persists contact the DMT System Administrators";
                }
                else {
                    if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                        items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b><br>';
                    }
                    items.message += "<b style=\"color:red\">" + errorMessage + "/" + thrown + "</b><br><br>\n                    This is usually a temporary problem.\n                    &nbsp;Please try again, if the problem persists contact the DMT System Administrators";
                }
                _this.Dialog.updateValidForm(undefined, items, CompliancePlanController.TEMPLATE_CONFIRM).then(function (dResult) {
                    _this.signalWrongResponse = items.message.replace(new RegExp('<br><br>', 'g'), ' ');
                });
                // Turns off the processing bar
                _this.itemsLoaded = true;
                _this.importingExcel = false;
                $('#table_processing').hide();
            }
        };
    };
    CompliancePlanController.prototype.buildLogAjaxOption = function () {
        var _this = this;
        return {
            url: '/api/admin/compliance-plan-log',
            // tslint:disable-next-line:object-literal-sort-keys
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                _this.logLoaded = false;
                request.setRequestHeader('Authorization', "Bearer " + _this.env.user.token);
            },
            data: function (draw) {
                var dt = _this.tableLog.dtInstance.DataTable;
                if (dt && dt.context && Array.isArray(dt.context)) {
                    draw.alphabetSearch = dt.context[0].alphabetSearch;
                }
            },
            dataSrc: function (data) {
                _this.logItems = data.data;
                _this.logLoaded = true;
                _this.processing = false;
                return data.data;
            }, error: function (xhr, errorMessage, thrown) {
                // Display message, when an error appears
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve Compliance Plan log from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (xhr.responseText) {
                    items.message += "<b>" + xhr.responseText + "</b>\n                    <br>Please try again, if the problem persists contact the DMT System Administrators";
                }
                else {
                    if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                        items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b><br>';
                    }
                    items.message += "<b style=\"color:red\">" + errorMessage + "/" + thrown + "</b><br><br>\n                    This is usually a temporary problem.\n                    &nbsp;Please try again, if the problem persists contact the DMT System Administrators";
                }
                _this.Dialog.updateValidForm(undefined, items, CompliancePlanController.TEMPLATE_CONFIRM).then(function (dResult) {
                    _this.signalWrongResponse = items.message.replace(new RegExp('<br><br>', 'g'), ' ');
                });
                // Turns off the processing bar
                _this.logLoaded = true;
                $('#table_processing').hide();
            }
        };
    };
    CompliancePlanController.prototype.generateColumn = function (columnName, renderFn) {
        var columnId = CompliancePlanColumnIdName[columnName] || CompliancePlanLogColumnIdName[columnName];
        var orderable = columnId === CompliancePlanColumnIdName[CompliancePlanColumnIdName.BP_NAME]
            || columnId === CompliancePlanLogColumnIdName[CompliancePlanLogColumnIdName.ACTION_TIMESTAMP];
        return this.DTColumnBuilder
            .newColumn(columnId)
            .withOption('name', columnId)
            .withOption('orderable', orderable) //FIXME - tmp
            .withTitle(columnName ? columnName : columnId)
            .renderWith(renderFn ? renderFn : function (data) { return data; }); // FIXME - check an emptry fn
    };
    CompliancePlanController.prototype.buildColumns = function () {
        var _this = this;
        return [
            this.generateColumn(CompliancePlanColumnIdName.IOT),
            this.generateColumn(CompliancePlanColumnIdName.IMT),
            this.generateColumn(CompliancePlanColumnIdName.COUNTRY),
            this.generateColumn(CompliancePlanColumnIdName.BP_NAME),
            this.generateColumn(CompliancePlanColumnIdName.BP_CEID),
            this.generateColumn(CompliancePlanColumnIdName.START_DATE, function (data) {
                return _this.$filter('date')(new Date(data), CompliancePlanController.DATE_FORMAT);
            }),
            this.generateColumn(CompliancePlanColumnIdName.actions, this.actionButtons)
        ];
    };
    CompliancePlanController.prototype.buildLogColumns = function () {
        return [
            this.generateColumn(CompliancePlanLogColumnIdName.ACTION_TIMESTAMP),
            this.generateColumn(CompliancePlanLogColumnIdName.ACTION_COMMENT),
            this.generateColumn(CompliancePlanLogColumnIdName.USER_EMAIL)
        ];
    };
    CompliancePlanController.prototype.actionButtons = function (data, type, full, meta) {
        return "\n        <md-button class=\"edit-button md-button md-ink-ripple md-2ink-ripple\" ng-click=\"vm.updateRow($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Edit\">\n                <md-icon class=\"black_icon\" md-svg-icon='edit_pen'></md-icon>\n        </md-button>\n        <md-button class=\"delete-button md-button md-ink-ripple\" ng-click=\"vm.deleteRow($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Delete\">\n                <md-icon md-svg-icon='delete'></md-icon>\n        </md-button>";
    };
    /**
     * Function to extract country
     */
    CompliancePlanController.prototype.extractCountry = function () {
        var result = this.settings.country_list.filter(function (el) { return el.ic === 'Country'; }).reduce(function (r, country) {
            r.tree[country.imt] = r.tree[country.imt] || {};
            r.tree[country.imt][country.imt_name] = r.tree[country.imt][country.imt_name] || [];
            r.tree[country.imt][country.imt_name].push(country.country);
            r.tree[country.imt][country.imt_name].sort();
            r.imts[country.imt] = r.imts[country.imt] || [];
            r.imts[country.imt].push(country.imt_name);
            r.imts[country.imt] = _.uniq(r.imts[country.imt]);
            r.imts[country.imt].sort();
            return r;
        }, { tree: {}, imts: {} });
        return result;
    };
    /**
     * Function to handle all errors
     */
    CompliancePlanController.prototype.isIncomingErrors = function (data) {
        if (data && data.error) {
            if (data.error.validationErrors.length || data.error.errors.length) {
                return true;
            }
        }
        else {
            return false;
        }
    };
    /**
     * Function to show all errors
     */
    CompliancePlanController.prototype.handleIncomingErrors = function (data, name) {
        var allErrorsInfo = {
            allErrors: data,
            windowName: name
        };
        this.Dialog.showingErrors(event, allErrorsInfo, 'showing-errors.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
        return;
    };
    // tslint:disable-next-line:typedef
    CompliancePlanController.prototype.openActionMenu = function ($mdOpenMenu, event) {
        $mdOpenMenu(event);
    };
    /**
     * Function to prepare the DB info for export
     */
    CompliancePlanController.prototype.exportComplinacePlan = function () {
        this.exportFired = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {},
                email: this.env.user.email,
                function: 'exportList',
                scopeBack: this.scopeExport,
                script: this.backendModuleName,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to delete all items in DB
     */
    CompliancePlanController.prototype.deleteAllRows = function (event) {
        var _this = this;
        this.Dialog.confirmDelete(event).then(function (dResult) {
            if (dResult) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'deleteAllRecords',
                        scopeBack: _this.scopeDeleteAll,
                        script: _this.backendModuleName,
                        token: _this.env.user.token,
                        email: _this.env.user.email
                    }
                });
            }
        });
        return;
    };
    /**
     * Function to upload list
     */
    CompliancePlanController.prototype.uploadList = function (event) {
        var _this = this;
        var tit = 'Upload new list';
        var items = {
            icon: 'QUESTION',
            message: 'Do you want to add items to existing records or replace the existing list?',
            title: tit
        };
        this.Dialog.updateValidForm(event, items, 'complianceplan-update-add.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.uploadFilesAdd(dResult.data[0]);
            }
            else {
                var tit1 = 'Replace existing list';
                var items1 = {
                    icon: 'QUESTION',
                    message: 'Are you sure you want to completely replace the existing list?',
                    title: tit1
                };
                _this.Dialog.updateValidForm(event, items1, 'newclient-update-replace.html').then(function (dResult1) {
                    if (dResult1.confirm) {
                        _this.uploadFilesReplace(dResult1.data[0]);
                    }
                });
            }
        });
        return;
    };
    /**
     * Functions to prepare the files for file upload ADD
     */
    CompliancePlanController.prototype.uploadFilesAdd = function (file) {
        if (file) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: file,
                    function: 'importFromExcel',
                    scopeBack: this.scopeImportFromExcel,
                    script: this.backendModuleName,
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
        this.importingExcel = true;
    };
    /**
     * Functions to prepare the files for file upload REPLACE
     */
    CompliancePlanController.prototype.uploadFilesReplace = function (file) {
        if (file) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: file,
                    function: 'replaceAllFromExcel',
                    scopeBack: this.scopeReplaceFromExcel,
                    script: this.backendModuleName,
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
        this.importingExcel = true;
    };
    /**
     * Function to download files
     */
    CompliancePlanController.prototype.downloadFile = function (file, name) {
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        var url = window.URL.createObjectURL(new Blob([file], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        a.setAttribute('href', url);
        var d = new Date().toDateString();
        a.setAttribute('download', name + " " + d + ".xlsx");
        a.click();
    };
    CompliancePlanController.$inject = [
        'settings',
        'env',
        '$compile',
        '$filter',
        'socket',
        '$scope',
        'Dialog',
        'notify',
        'DTOptionsBuilder',
        'DTColumnBuilder',
        'DTColumnDefBuilder'
    ];
    CompliancePlanController.DATE_FORMAT = 'd MMM yyyy';
    CompliancePlanController.TEMPLATE_CONFIRM = 'confirm-prompt.html';
    return CompliancePlanController;
}());
// tslint:disable-next-line:max-classes-per-file
var CompliancePlanComponent = (function () {
    function CompliancePlanComponent() {
        this.templateUrl = 'complianceplan.html';
        this.controllerAs = 'vm';
        this.controller = CompliancePlanController;
    }
    return CompliancePlanComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    return $mdIconProvider.icon('edit_pen1', '/public/icons/ic_mode_edit_black_24px.svg');
})
    .component('complianceplanSection', new CompliancePlanComponent());







var CountryListController = (function () {
    function CountryListController($state, settings, env, socket, $scope, Dialog, admin) {
        var _this = this;
        this.$state = $state;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.admin = admin;
        this.visibleMax = 7;
        this.isSaving = false;
        this.docTableOrig = {};
        this.docTable = [];
        this.countryTable = [];
        this.isDivisionLoaded = false;
        this.isCountryLoaded = false;
        this.newCode = {
            isLineValid: true
        };
        this.socket.forward('validationview.ctyList', this.$scope);
        this.$scope.$on('socket:validationview.ctyList', function (event, data) {
            for (var i = 0; i < data.length; i++) {
                if (data[i].ic === 'Country') {
                    _this.countryTable.push(data[i]);
                }
            }
            _this.isCountryLoaded = true;
        });
        this.socket.forward('validationview.countryList', this.$scope);
        this.$scope.$on('socket:validationview.countryList', function (event, data) {
            data.isValid = true;
            for (var i2 = 0; i2 < data.currentTable.length; i2++) {
                data.currentTable[i2].isLineValid = true;
                data.currentTable[i2].reqStart = new Date(data.currentTable[i2].reqStart);
                data.currentTable[i2].reqEnd = new Date(data.currentTable[i2].reqEnd);
            }
            data.origTable = JSON.parse(JSON.stringify(data.currentTable));
            for (var i2 = 0; i2 < data.colNames.length; i2++) {
                _this.newCode[data.colNames[i2].colKey] = '';
            }
            _this.docTable = data;
            _this.docTableOrig = JSON.parse(JSON.stringify(data));
            _this.isDivisionLoaded = true;
            if (_this.isSaving) {
                //Once done saving, send email to Admin team
                var emailBundle = { docurl: 'country-view', profile: 'Country Profile', user: _this.env.user };
                _this.admin.sendAdminUpdate(emailBundle);
            }
            _this.alphabet = 'abcdefghijklmnopqrstuvwxyz'.toUpperCase().split('');
            // migration from exchange rate to country listing
            /* for (let j: number = 0; j < this.docTable.currentTable.length; j++) {
                delete this.docTable.currentTable[j].crncyToUSD;
                delete this.docTable.currentTable[j].usdToCrncy;
            } */
            _this.sortCurrentTable();
            var coord;
            coord = _this.activeLetter
                ? _this.findEndPoints(_this.activeLetter)
                : _this.findEndPoints('A');
            _this.visibleStart = coord[0];
            _this.visibleEnd = coord[1];
            _this.visibleTable = _this.docTable.currentTable.slice(_this.visibleStart, _this.visibleEnd);
            _this.isSaving = false;
        });
    }
    CountryListController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getCountryListBackend',
                script: 'validation/validationTables',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getCountryList',
                script: 'validation/validationTables',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
        this.cfg = {
            decPlaces: [
                { value: '0', label: '0' },
                { value: '1', label: '1' },
                { value: '2', label: '2' },
            ],
            incType: [
                { value: 'CVR - Sales', label: 'CVR - Sales' },
                { value: 'CVR - Sales Assist', label: 'CVR - Sales Assist' },
                { value: 'All', label: 'All' },
            ],
            licType: [
                { value: 'License', label: 'License' },
                { value: 'Monthly', label: 'Monthly' },
                { value: 'SaaS', label: 'SaaS' },
                { value: 'All', label: 'All' },
            ],
            yesNo: [
                { value: 'Yes', label: 'Yes' },
                { value: 'No', label: 'No' },
            ]
        };
    };
    // all tables need to have reqStart and reqEnd to describe their validity period
    // tables either have to have a reqCode property when only one property is essentail for comparison
    // or a series of combo keys when a combination of properties distinguishes entries
    CountryListController.prototype.addNewCode = function () {
        this.checkValidityNewCode(this.docTable);
        if (!this.newCode.isLineValid) {
            alert('Please fix the issues before saving');
            this.docTable.isValid = true;
            this.isSaving = false;
        }
        else {
            var addLine = {};
            var addText = '';
            for (var key in this.newCode) {
                for (var i = 0; i < this.docTable.colNames.length; i++) {
                    if (key === this.docTable.colNames[i].colKey) {
                        addLine[key] = this.newCode[key];
                        if (key !== 'reqStart' && key !== 'reqEnd') {
                            if (addText === '') {
                                addText = this.newCode[key];
                            }
                            else {
                                addText = addText + ', ' + this.newCode[key];
                            }
                        }
                    }
                }
            }
            addLine.reqStart = new Date(addLine.reqStart);
            addLine.reqEnd = new Date(addLine.reqEnd);
            var startText = addLine.reqStart.getDate() + '.' + (addLine.reqStart.getMonth() + 1) + '.' + addLine.reqStart.getFullYear();
            var endText = addLine.reqEnd.getDate() + '.' + (addLine.reqEnd.getMonth() + 1) + '.' + addLine.reqEnd.getFullYear();
            var historyGen = ['Entry created: ' + addText + ', ' + startText + ', ' + endText];
            var timeStamp = new Date();
            var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
            var oneHist = {
                timestamp: timeText,
                comment: historyGen,
                user: this.env.user.email
            };
            this.docTable.tableHistory.push(oneHist);
            this.docTable.currentTable.push(addLine);
            this.voidNew(this.docTable);
            this.checkValidity(this.docTable);
            this.docTableOrig = JSON.parse(JSON.stringify(this.docTable));
            delete this.docTableOrig.origTable;
            this.docTable.origTable = JSON.parse(JSON.stringify(this.docTable.currentTable));
            this.isSaving = true;
            this.sendforUpdate(historyGen);
        }
    };
    CountryListController.prototype.voidNew = function (oneTab) {
        if (oneTab) {
            this.curTab = oneTab;
            this.newCode = {
                isLineValid: true
            };
            for (var i2 = 0; i2 < oneTab.colNames.length; i2++) {
                this.newCode[oneTab.colNames[i2].colKey] = '';
            }
        }
        else {
            for (var property in this.newCode) {
                if (this.newCode.hasOwnProperty(property)) {
                    this.newCode[property] = '';
                }
            }
            this.newCode.isLineValid = true;
        }
    };
    // all tables need to have reqStart and reqEnd to describe their validity period
    // tables either have to have a reqCode property when only one property is essentail for comparison
    // or a series of combo keys when a combination of properties distinguishes entries
    CountryListController.prototype.checkValidity = function (oneTab) {
        oneTab.isValid = true;
        for (var i = 0; i < oneTab.currentTable.length; i++) {
            oneTab.currentTable[i].isLineValid = true;
        }
        // check mandatory - for the new fields
        var reqFields = ['licType', 'incType', 'primCur', 'vatUsed', 'decPlaces', 'fcUplift', 'cvrElig'];
        for (var i = 0; i < oneTab.currentTable.length; i++) {
            for (var key in oneTab.currentTable[i]) {
                // if (key.search('req') > -1 && key !== 'reqStart' && key !== 'reqEnd') {
                if (reqFields.indexOf(key) !== -1) {
                    if (oneTab.currentTable[i][key] === '') {
                        oneTab.currentTable[i].isLineValid = false;
                        oneTab.isValid = false;
                        break;
                    }
                    if (key === 'fcUplift') {
                        if (Number(oneTab.currentTable[i][key]) < 0 || Number(oneTab.currentTable[i][key]) > 100) {
                            oneTab.currentTable[i].isLineValid = false;
                            oneTab.isValid = false;
                            break;
                        }
                    }
                    // check if pri currency is three letter code only
                    if (key === 'primCur') {
                        if (oneTab.currentTable[i][key] !== '-') {
                            if (oneTab.currentTable[i][key].length !== 3) {
                                oneTab.currentTable[i].isLineValid = false;
                                oneTab.isValid = false;
                                break;
                            }
                            else {
                                if (!(/^[a-zA-Z]+$/.test(oneTab.currentTable[i][key]))) {
                                    oneTab.currentTable[i].isLineValid = false;
                                    oneTab.isValid = false;
                                    break;
                                }
                            }
                        }
                    }
                    // check if forecast uplift is a number between 0 to 100
                    if (key === 'fcUplift') {
                        if (oneTab.currentTable[i][key] !== '-') {
                            if (!Number(oneTab.currentTable[i][key])) {
                                oneTab.currentTable[i].isLineValid = false;
                                oneTab.isValid = false;
                                break;
                            }
                            else if (Number(oneTab.currentTable[i][key]) < 0 || Number(oneTab.currentTable[i][key]) > 100) {
                                oneTab.currentTable[i].isLineValid = false;
                                oneTab.isValid = false;
                                break;
                            }
                        }
                    }
                }
            }
        }
        for (var i = 0; i < oneTab.currentTable.length - 1; i++) {
            if (!(oneTab.currentTable[i].reqStart instanceof Date) || !(oneTab.currentTable[i].reqEnd instanceof Date)) {
                oneTab.currentTable[i].isLineValid = false;
                oneTab.isValid = false;
            }
            else if (oneTab.currentTable[i].reqStart > oneTab.currentTable[i].reqEnd) {
                oneTab.currentTable[i].isLineValid = false;
                oneTab.isValid = false;
            }
            else {
                for (var i2 = i + 1; i2 < oneTab.currentTable.length; i2++) {
                    var perfectFit = true;
                    var checkFit = false;
                    for (var key in oneTab.currentTable[i]) {
                        if (key.search('combo') > -1) {
                            checkFit = true;
                            if (oneTab.currentTable[i][key] !== oneTab.currentTable[i2][key]) {
                                perfectFit = false;
                                break;
                            }
                        }
                    }
                    if ((oneTab.currentTable[i].reqCode === oneTab.currentTable[i2].reqCode && typeof oneTab.currentTable[i].reqCode !== 'undefined')
                        || (oneTab.currentTable[i].country === oneTab.currentTable[i2].country && typeof oneTab.currentTable[i].country !== 'undefined')
                        || (perfectFit && checkFit)) {
                        if ((oneTab.currentTable[i].reqStart < oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqStart < oneTab.currentTable[i].reqEnd)
                            || (oneTab.currentTable[i].reqStart < oneTab.currentTable[i2].reqEnd && oneTab.currentTable[i2].reqEnd < oneTab.currentTable[i].reqEnd)
                            || (oneTab.currentTable[i].reqStart >= oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqEnd >= oneTab.currentTable[i].reqEnd)) {
                            oneTab.currentTable[i].isLineValid = false;
                            oneTab.currentTable[i2].isLineValid = false;
                            oneTab.isValid = false;
                        }
                    }
                }
            }
        }
    };
    CountryListController.prototype.checkValidityNewCode = function (oneTab) {
        var reqFields = ['licType', 'incType', 'primCur', 'vatUsed', 'decPlaces', 'fcUplift', 'cvrElig'];
        oneTab.isValid = true;
        this.newCode.isLineValid = true;
        // check license and incentive type and clear threshold accordingly 
        // if (this.newCode.licType === 'License' && this.newCode.incType === 'CVR - Sales Assist'){
        //    this.newCode.ctyThreshold = '';
        // }
        // check for mandatory, new fields
        for (var key in this.newCode) {
            if (reqFields.indexOf(key) !== -1) {
                if (this.newCode[key] === '') {
                    this.newCode.isLineValid = false;
                    break;
                }
            }
        }
        // check country for duplicates
        if (this.newCode.isLineValid) {
            for (var i = 0; i < this.docTable.currentTable.length; i++) {
                if (this.newCode.combocountry === this.docTable.currentTable[i].combocountry) {
                    this.newCode.isLineValid = false;
                    break;
                }
            }
        }
        // check if pri currency is three letter code only
        if (this.newCode.isLineValid) {
            if (this.newCode.primCur.length !== 3) {
                this.newCode.isLineValid = false;
            }
            else {
                if (!(/^[a-zA-Z]+$/.test(this.newCode.primCur))) {
                    this.newCode.isLineValid = false;
                }
            }
        }
        // check if forecast uplift is a number between 0 to 100
        if (this.newCode.isLineValid) {
            if (!Number(this.newCode.fcUplift)) {
                this.newCode.isLineValid = false;
            }
            else {
                if (Number(this.newCode.fcUplift) < 0 || Number(this.newCode.fcUplift) > 100) {
                    this.newCode.isLineValid = false;
                }
            }
        }
        if (this.newCode.isLineValid) {
            if ((this.newCode.reqStart > this.newCode.reqEnd)) {
                this.newCode.isLineValid = false;
                oneTab.isValid = false;
            }
            else if (Number(this.newCode.fcUplift) < 0 || Number(this.newCode.fcUplift) > 100) {
                this.newCode.isLineValid = false;
                oneTab.isValid = false;
            }
            else if (oneTab.currentTable.length > 0) {
                for (var i2 = 0; i2 < oneTab.currentTable.length; i2++) {
                    var perfectFit = true;
                    var checkFit = false;
                    for (var key in this.newCode) {
                        if (key.search('combo') > -1) {
                            checkFit = true;
                            if (this.newCode[key] !== oneTab.currentTable[i2][key]) {
                                perfectFit = false;
                                break;
                            }
                        }
                    }
                    if ((this.newCode.reqCode === oneTab.currentTable[i2].reqCode && typeof this.newCode.reqCode !== 'undefined') || (perfectFit && checkFit)) {
                        if ((this.newCode.reqStart < oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqStart < this.newCode.reqEnd)
                            || (this.newCode.reqStart < oneTab.currentTable[i2].reqEnd && oneTab.currentTable[i2].reqEnd < this.newCode.reqEnd)
                            || (this.newCode.reqStart >= oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqEnd >= this.newCode.reqEnd)) {
                            this.newCode.isLineValid = false;
                            oneTab.currentTable[i2].isLineValid = false;
                            oneTab.isValid = false;
                        }
                    }
                }
            }
        }
    };
    CountryListController.prototype.deleteConfirmation = function (ev, oneItem) {
        var _this = this;
        this.Dialog.confirmDelete(ev, oneItem).then(function (dResult) {
            //        this.Dialog.updateValidForm(event, this.toDelete, 'sampling.html').then((dResult: any) => {
            if (dResult) {
                _this.deleteLine(oneItem);
            }
        });
    };
    CountryListController.prototype.deleteLine = function (oneItem) {
        var curPosItem = this.docTable.currentTable.indexOf(oneItem);
        var startDate = new Date(this.docTable.origTable[curPosItem].reqStart);
        var startText = startDate.getDate() + '.' + (startDate.getMonth() + 1) + '.' + startDate.getFullYear();
        var endDate = new Date(this.docTable.currentTable[curPosItem].reqEnd);
        var endText = endDate.getDate() + '.' + (endDate.getMonth() + 1) + '.' + endDate.getFullYear();
        var timeStamp = new Date();
        var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
        var comment = 'Deleted: ';
        for (var key in this.docTable.currentTable[curPosItem]) {
            if (key !== 'reqStart' && key !== 'reqEnd' && key !== 'isLineValid') {
                comment += this.docTable.currentTable[curPosItem][key] + ', ';
            }
        }
        var oneHist = {
            timestamp: timeText,
            comment: [comment + ', start ' + startText + ', end ' + endText],
            user: this.env.user.email
        };
        this.docTable.tableHistory.push(oneHist);
        this.docTable.currentTable.splice(curPosItem, 1);
        this.docTableOrig = JSON.parse(JSON.stringify(this.docTable));
        for (var i = 0; i < this.docTable.length; i++) {
            delete this.docTableOrig.origTable;
            this.docTable.origTable = JSON.parse(JSON.stringify(this.docTable.currentTable));
        }
        this.isSaving = true;
        this.sendforUpdate(oneHist.comment);
    };
    CountryListController.prototype.save = function () {
        this.checkValidity(this.docTable);
        if (!this.docTable.isValid) {
            alert('Please fix the issues before saving');
            this.docTable.isValid = true;
            this.isSaving = false;
        }
        else {
            var historyGen = [];
            var commentBase = [];
            if (typeof this.docTable.origTable[0].reqCode === 'undefined') {
                for (var key in this.docTable.origTable[0]) {
                    if (key.search('combo') > -1) {
                        commentBase.push(key);
                    }
                }
            }
            else {
                commentBase.push(this.docTable.origTable[0].reqCode);
            }
            for (var i2 = 0; i2 < this.docTable.currentTable.length; i2++) {
                for (var key in this.docTable.currentTable[i2]) {
                    if (key === '$$hashKey') {
                        delete this.docTable.currentTable[i2][key];
                    }
                    else if (this.docTable.origTable[i2][key] !== this.docTable.currentTable[i2][key]) {
                        var colName = '';
                        var isDate = false;
                        if (key === 'reqStart' || key === 'reqEnd') {
                            isDate = true;
                        }
                        var mainText = '';
                        for (var iBase = 0; iBase < commentBase.length; iBase++) {
                            if (iBase === 0) {
                                mainText = this.docTable.origTable[i2][commentBase[iBase]];
                            }
                            else {
                                mainText = mainText + ', ' + this.docTable.origTable[i2][commentBase[iBase]];
                            }
                        }
                        if (!isDate) {
                            historyGen.push(mainText + ', ' + colName + ' changed from ' + this.docTable.origTable[i2][key] + ' to ' + this.docTable.currentTable[i2][key]);
                        }
                        else {
                            var orDate = new Date(this.docTable.origTable[i2][key]);
                            var orText = orDate.getDate() + '.' + (orDate.getMonth() + 1) + '.' + orDate.getFullYear();
                            var curDate = new Date(this.docTable.currentTable[i2][key]);
                            var curText = curDate.getDate() + '.' + (curDate.getMonth() + 1) + '.' + curDate.getFullYear();
                            if (orText !== curText) {
                                historyGen.push(mainText + ', ' + colName + ' changed from ' + orText + ' to ' + curText);
                            }
                        }
                    }
                }
            }
            if (historyGen.length > 0) {
                var timeStamp = new Date();
                var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
                var oneHist = {
                    timestamp: timeText,
                    comment: historyGen,
                    user: this.env.user.email
                };
                this.docTable.tableHistory.push(oneHist);
                this.docTableOrig = JSON.parse(JSON.stringify(this.docTable));
                delete this.docTableOrig.origTable;
                this.docTable.origTable = JSON.parse(JSON.stringify(this.docTable.currentTable));
                this.isSaving = true;
                this.sendforUpdate(historyGen);
            }
        }
    };
    CountryListController.prototype.sendforUpdate = function (historyText) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'sendCountryListBackend',
                script: 'validation/validationTables',
                email: this.env.user.email,
                token: this.env.user.token,
                data: this.docTableOrig,
                receivers: ['roman.tibensky@sk.ibm.com'],
                historyText: historyText
            }
        });
    };
    CountryListController.prototype.activateLetter = function (letter) {
        var points;
        this.activeLetter = letter;
        points = this.findEndPoints(letter);
        this.visibleStart = points[0]; // += this.visibleMax;
        this.visibleEnd = points[1]; // += this.visibleMax;
        /*this.visibleEnd = this.visibleEnd > this.docTable.currentTable.length
        ? this.docTable.currentTable.length
        : this.visibleEnd;*/
        this.visibleTable = this.docTable.currentTable.slice(this.visibleStart, this.visibleEnd);
    };
    CountryListController.prototype.sortCurrentTable = function () {
        var tmpObj;
        var obj_1;
        var obj_2;
        for (var i = 0; i < this.docTable.currentTable.length; i++) {
            for (var j = 0; j < this.docTable.currentTable.length; j++) {
                obj_1 = this.docTable.currentTable[i];
                obj_2 = this.docTable.currentTable[j];
                if (this.docTable.currentTable[j].combocountry > this.docTable.currentTable[i].combocountry) {
                    tmpObj = this.docTable.currentTable[i];
                    this.docTable.currentTable[i] = this.docTable.currentTable[j];
                    this.docTable.currentTable[j] = tmpObj;
                }
            }
        }
    };
    CountryListController.prototype.findEndPoints = function (letter) {
        var result = [];
        var i;
        for (i = 0; i < this.docTable.currentTable.length; i++) {
            if (this.docTable.currentTable[i].combocountry.charAt(0) === letter) {
                break;
            }
        }
        result.push(i);
        for (i = result[0]; i < this.docTable.currentTable.length; i++) {
            if (this.docTable.currentTable[i].combocountry.charAt(0) !== letter) {
                break;
            }
        }
        result.push(i);
        return (result);
    };
    CountryListController.$inject = ['$state', 'settings', 'env', 'socket', '$scope', 'Dialog', 'admin'];
    return CountryListController;
}());
var CountryListComponent = (function () {
    function CountryListComponent() {
        this.templateUrl = 'country-view.html';
        this.controllerAs = 'vm';
        this.controller = CountryListController;
    }
    return CountryListComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('delete', '/public/icons/delete-forever.svg')
        .icon('invalid', '/public/icons/ic_highlight_off_black_24px.svg')
        .icon('save', '/public/images/ic_save_black_24px.svg');
})
    .component('viewCountrySection', new CountryListComponent());



var TaskTypes;
(function (TaskTypes) {
    TaskTypes[TaskTypes["assign"] = 'Assign'] = "assign";
    TaskTypes[TaskTypes["createDispute"] = 'Create Dispute'] = "createDispute";
    TaskTypes[TaskTypes["createOpportunity"] = 'Create Opportunity'] = "createOpportunity";
    TaskTypes[TaskTypes["changeStatus"] = 'Change Status'] = "changeStatus";
})(TaskTypes || (TaskTypes = {}));
var EsLogsDetailsController = (function () {
    function EsLogsDetailsController(settings, env, $compile, $filter, socket, $scope, $state, $stateParams, $http, Dialog, notify, moment) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$compile = $compile;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$http = $http;
        this.Dialog = Dialog;
        this.notify = notify;
        this.moment = moment;
        this.isDetailsOpen = true;
        this.areStepsOpen = false;
        this.showUnhandledTasks = false;
        this.unprocessedNumber = 0;
        this.id = '';
        this.doc = {};
        this.checkboxModel = {
            value1: true,
            value2: 'YES'
        };
        this.tasks = [];
        this.backendModuleName = 'admin/eslogs/esLogs';
        this.scopePrefix = 'admin.eslogs';
        this.scopeGetTasks = this.scopePrefix + ".getTasks";
        this.handleDetailsClick = function (task) {
            task.isDetailsOpen = !task.isDetailsOpen;
        };
        this.handleStepsClick = function (task) {
            task.areStepsOpen = !task.areStepsOpen;
        };
        this.handleShowHideUnhadledClick = function () {
            _this.showUnhandledTasks = !_this.showUnhandledTasks;
        };
        this.id = $stateParams.id;
        this.socket.forward(this.scopeGetTasks, this.$scope);
        this.$scope.$on("socket:" + this.scopeGetTasks, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Create a record');
                _this.notify.error("Unable to create a record");
            }
            else {
                _this.tasks = data.tasks;
                _this.tasks.forEach(function (task) {
                    task.body = JSON.stringify(task.body, undefined, 4);
                    task.taskType = TaskTypes[task.taskType];
                    task.updated = task.updated ? _this.moment(task.updated).format('MM/DD/YYYY HH:mm:ss') : '';
                    task.created = task.created ? _this.moment(task.created).format('MM/DD/YYYY HH:mm:ss') : '';
                });
                _this.unprocessedNumber = _this.tasks.filter(function (task) { return task.taskStatus === 'unprocessed'; }).length;
                _this.doc = JSON.stringify(data.doc, undefined, 4);
                _this.notify.success('Record successfuly added');
            }
        });
    }
    EsLogsDetailsController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: { id: this.id },
                email: this.env.user.email,
                function: 'getTasks',
                scopeBack: this.scopeGetTasks,
                script: this.backendModuleName,
                token: this.env.user.token
            }
        });
    };
    EsLogsDetailsController.prototype.isIncomingErrors = function (data) {
        if (data && data.error) {
            if (data.error.validationErrors.length || data.error.errors.length) {
                return true;
            }
        }
        else {
            return false;
        }
    };
    /**
     * Function to show all errors
     */
    EsLogsDetailsController.prototype.handleIncomingErrors = function (data, name) {
        var allErrorsInfo = {
            allErrors: data,
            windowName: name
        };
        this.Dialog.showingErrors(event, allErrorsInfo, 'showing-errors.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
        return;
    };
    EsLogsDetailsController.$inject = [
        'settings',
        'env',
        '$compile',
        '$filter',
        'socket',
        '$scope',
        '$state',
        '$stateParams',
        '$http',
        'Dialog',
        'notify',
        'moment'
    ];
    return EsLogsDetailsController;
}());
var EsLogsDetailsComponent = (function () {
    function EsLogsDetailsComponent() {
        this.templateUrl = 'eslogs-details.html';
        this.controllerAs = 'vm';
        this.controller = EsLogsDetailsController;
    }
    return EsLogsDetailsComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider.icon('processed', '/public/icons/checkmark--filled--32.svg');
    $mdIconProvider.icon('unprocessed', '/public/icons/help--filled--32.svg');
    $mdIconProvider.icon('failed', '/public/icons/misuse--32.svg');
})
    .component('eslogsDetailsSection', new EsLogsDetailsComponent());



var EsLogsColumnNames;
(function (EsLogsColumnNames) {
    EsLogsColumnNames[EsLogsColumnNames["oppId"] = 'Opp Id'] = "oppId";
    EsLogsColumnNames[EsLogsColumnNames["lastTaskCreated"] = 'Last Executed Task Created'] = "lastTaskCreated";
    EsLogsColumnNames[EsLogsColumnNames["lastTaskError"] = 'Error'] = "lastTaskError";
    EsLogsColumnNames[EsLogsColumnNames["lastTaskType"] = 'Last Executed Task Type'] = "lastTaskType";
    EsLogsColumnNames[EsLogsColumnNames["lastTaskUpdated"] = 'Last Executed Task Updated'] = "lastTaskUpdated";
    EsLogsColumnNames[EsLogsColumnNames["unprocessedNumber"] = '№ of Unprocessed Tasks'] = "unprocessedNumber";
})(EsLogsColumnNames || (EsLogsColumnNames = {}));
var EsLogsController = (function () {
    function EsLogsController(settings, env, $compile, $filter, socket, $scope, $state, Dialog, notify, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, moment) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$compile = $compile;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.$state = $state;
        this.Dialog = Dialog;
        this.notify = notify;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this.DTColumnDefBuilder = DTColumnDefBuilder;
        this.moment = moment;
        this.itemsLoaded = true;
        this.processing = true;
        this.exportFired = false;
        this.withError = false;
        this.importingExcel = false;
        this.bookmarks = [];
        this.tableItems = [];
        this.docTable = [];
        this.goToDetails = function (info) {
            _this.$state.go('admin.eslogs-details-view', {
                id: info.oppId
            });
        };
        this.rowCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function () {
                _this.$scope.$apply(function () {
                    _this.goToDetails(aData);
                });
            });
            return nRow;
        };
        this.withErrorHandler = function () {
            _this.bookmarks = [];
            _this.table.dtInstance.DataTable.search($('#eslogs-table_filter input').val()).draw();
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        };
        this.table = {
            dtColumns: {},
            dtInstance: {},
            filter: false,
            filterParams: {},
            filters: { BP: '' },
            search: '',
            select_options: {},
            visible: 0
        };
    }
    EsLogsController.prototype.$onInit = function () {
        var _this = this;
        this.signalWrongResponse = '';
        this.table.dtColumns = this.buildColumns();
        this.table.dtOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', this.buildAjaxOption())
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('order', [])
            .withOption('rowCallback', this.rowCallback)
            .withPaginationType('full_numbers')
            .withOption('createdRow', function (row) {
            _this.$compile(angular.element(row).contents())(_this.$scope);
        })
            .withOption('pagingType', 'simple')
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        })
            .withOption('initComplete', function () {
            $('#eslogs-table_filter input').unbind();
            // on search change
            $('#eslogs-table_filter input').bind('keyup', function (e) {
                if (e.keyCode === 13) {
                    _this.bookmarks = [];
                    _this.table.dtInstance.DataTable.search($('#eslogs-table_filter input').val()).draw();
                }
            });
            // on page change
            $('#eslogs-table').on('page.dt', function (e) {
                $('.tag').tooltip();
                var page = _this.table.dtInstance.DataTable.page.info().page;
                if (_this.currentPage && _this.currentPage > page) {
                    _this.bookmarks.pop();
                    _this.bookmarks.pop();
                }
                _this.currentPage = page;
            });
            // on length of page change
            $('#eslogs-table').on('length.dt', function (e, settings, len) {
                _this.bookmarks = [];
            });
        });
    };
    EsLogsController.prototype.buildAjaxOption = function () {
        var _this = this;
        return {
            url: '/api/admin/es-logs',
            // tslint:disable-next-line:object-literal-sort-keys
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                request.setRequestHeader('Authorization', "Bearer " + _this.env.user.token);
                _this.itemsLoaded = true;
            },
            data: function (body) {
                var dt = _this.table.dtInstance.DataTable;
                if (dt && dt.context && Array.isArray(dt.context)) {
                    body.alphabetSearch = dt.context[0].alphabetSearch;
                }
                body.withError = _this.withError;
                body.bookmark = _this.bookmarks[_this.bookmarks.length - 1];
            },
            dataSrc: function (data) {
                _this.itemsLoaded = true;
                _this.tableItems = data.data;
                _this.bookmarks.push(data.bookmark);
                _this.processing = false;
                return data.data;
            }, error: function (xhr, errorMessage, thrown) {
                // Display message, when an error appears
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve Custom Report data from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (xhr.responseText) {
                    items.message += "<b>" + xhr.responseText + "</b>\n                    <br>Please try again, if the problem persists contact the DMT System Administrators";
                }
                else {
                    if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                        items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b><br>';
                    }
                    items.message += "<b style=\"color:red\">" + errorMessage + "/" + thrown + "</b><br><br>\n                    This is usually a temporary problem.\n                    &nbsp;Please try again, if the problem persists contact the DMT System Administrators";
                }
                _this.Dialog.updateValidForm(undefined, items, EsLogsController.TEMPLATE_CONFIRM).then(function (dResult) {
                    _this.signalWrongResponse = items.message.replace(new RegExp('<br><br>', 'g'), ' ');
                });
                // Turns off the processing bar
                _this.itemsLoaded = true;
                _this.importingExcel = false;
                $('#table_processing').hide();
            }
        };
    };
    EsLogsController.prototype.generateColumn = function (columnName, renderFn) {
        var columnId = EsLogsColumnNames[columnName];
        var orderable = false;
        return this.DTColumnBuilder
            .newColumn(columnId)
            .withOption('name', columnId)
            .withOption('orderable', orderable)
            .withTitle(columnName ? columnName : columnId)
            .renderWith(renderFn ? renderFn : function (data) { return data ? data : ''; });
    };
    EsLogsController.prototype.buildColumns = function () {
        var _this = this;
        return [
            this.generateColumn(EsLogsColumnNames.oppId),
            this.generateColumn(EsLogsColumnNames.lastTaskType),
            this.generateColumn(EsLogsColumnNames.lastTaskCreated, function (date) { return date ? _this.moment(date).format('MM/DD/YYYY HH:mm:ss') : ''; }),
            this.generateColumn(EsLogsColumnNames.lastTaskUpdated, function (date) { return date ? _this.moment(date).format('MM/DD/YYYY HH:mm:ss') : ''; }),
            this.generateColumn(EsLogsColumnNames.unprocessedNumber, function (value) { return ("\n                    <div>\n                        " + (value ? value : '') + "\n                    </div>  "); }),
            this.generateColumn(EsLogsColumnNames.lastTaskError, function (value) {
                if (value) {
                    return "\n                            <div>\n                                <md-icon style=\"padding-left:5px; color:rgba(234, 35, 35, 0.62);\" md-svg-icon=\"error\" title=\"" + value + "\" > </md-icon>\n                            </div>\n                        ";
                }
                else {
                    return "";
                }
            }),
        ];
    };
    /**
     * Function to handle all errors
     */
    EsLogsController.prototype.isIncomingErrors = function (data) {
        if (data && data.error) {
            if (data.error.validationErrors.length || data.error.errors.length) {
                return true;
            }
        }
        else {
            return false;
        }
    };
    /**
     * Function to show all errors
     */
    EsLogsController.prototype.handleIncomingErrors = function (data, name) {
        var allErrorsInfo = {
            allErrors: data,
            windowName: name
        };
        this.Dialog.showingErrors(event, allErrorsInfo, 'showing-errors.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
        return;
    };
    EsLogsController.$inject = [
        'settings',
        'env',
        '$compile',
        '$filter',
        'socket',
        '$scope',
        '$state',
        'Dialog',
        'notify',
        'DTOptionsBuilder',
        'DTColumnBuilder',
        'DTColumnDefBuilder',
        'moment'
    ];
    EsLogsController.DATE_FORMAT = 'd MMM yyyy';
    EsLogsController.TEMPLATE_CONFIRM = 'confirm-prompt.html';
    return EsLogsController;
}());
var EsLogsComponent = (function () {
    function EsLogsComponent() {
        this.templateUrl = 'eslogs.html';
        this.controllerAs = 'vm';
        this.controller = EsLogsController;
    }
    return EsLogsComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider.icon('error', "/public/icons/warning--filled--32.svg");
})
    .component('eslogsSection', new EsLogsComponent());



var ExchangeRateController = (function () {
    function ExchangeRateController(settings, env, $filter, socket, $scope, Dialog, notify, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.notify = notify;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this.DTColumnDefBuilder = DTColumnDefBuilder;
        this.table = {
            filter: false, filterParams: {}, filters: { CURRENCY: '' }, search: '', select_options: {}, visible: 0
        };
        this.records = [];
        this.recordsLoaded = false;
        this.importingExcel = false;
        this.exportFired = false;
        this.isSaving = false;
        this.docTable = [];
        this.historyInfo = {};
        this.historyTable = {
            instance: {}
        };
        this.backendModuleName = 'admin/exchange/exchange';
        this.scopePrefix = 'admin.exchangeRates';
        this.scopeGetData = this.scopePrefix + ".query";
        this.scopeGetLogs = this.scopePrefix + ".logs";
        this.scopeUpdateLogs = this.scopePrefix + ".logsUpdate";
        this.scopeUpdateRecord = this.scopePrefix + ".update";
        this.scopeCreateRecord = this.scopePrefix + ".insert";
        this.scopeDeleteRecord = this.scopePrefix + ".delete";
        this.scopeDeleteAll = this.scopePrefix + ".deleteall";
        this.scopeExport = this.scopePrefix + ".export";
        this.scopeExportTemplate = this.scopePrefix + ".exportTemplate";
        this.scopeImportFromExcel = this.scopePrefix + ".importFromExcel";
        this.scopeReplaceFromExcel = this.scopePrefix + ".replaceAllFromExcel";
        this.historyInfo = {
            currency: '',
            startDate: '',
            endDate: ''
        };
        this.table.headers = [{
                'Currency': 'CURRENCY',
                'From USD': 'FROMUSD',
                'To USD': 'TOUSD',
                'Start Date': 'STARTDATE',
                'End Date': 'ENDDATE',
                'Active': 'ACTIVE',
                'Created Date': 'CREATED',
                'Last Update': 'LAST_UPDATE',
                'Inactive From': 'INACTIVE_FROM',
                'Created By': 'CREATED_BY',
                'Updated By': 'UPDATED_BY'
            }];
        this.table.options = DTOptionsBuilder
            .newOptions()
            .withIBMTheme()
            .withOption("searchDelay", 350)
            .withOption("alphabetColumnIndex", 0)
            .withOption('order', [[3, 'desc']]); // Default sorting by start date descending order
        this.table.columnDefs = [
            DTColumnDefBuilder.newColumnDef(11).notSortable() // Disable sorting for "Actions" column
        ];
        this.historyTable.options = DTOptionsBuilder
            .newOptions()
            .withIBMTheme()
            .withOption('stateSave', true)
            .withOption('ordering', false)
            .withOption("searchDelay", 350)
            .withOption("alphabetColumnIndex", 2);
        this.historyTable.columnDefs = [];
        //GET ALL
        this.socket.forward(this.scopeGetData, this.$scope);
        this.$scope.$on("socket:" + this.scopeGetData, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Loading records');
                return _this.notify.error('Error with loading records');
            }
            else {
                _this.records = _this.convertToViewModels(data.payload);
                _this.recordsLoaded = true;
            }
        });
        //GET HISTORY
        this.socket.forward(this.scopeGetLogs, this.$scope);
        this.$scope.$on("socket:" + this.scopeGetLogs, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Get history data');
                return _this.notify.error("Unable to get history data");
            }
            else {
                if (data.payload.logs) {
                    _this.docTable = data.payload.logs.reverse();
                }
            }
        });
        //UPDATED HISTORY
        this.socket.forward(this.scopeUpdateLogs, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateLogs, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Update history data');
                return _this.notify.error("Unable to update history data");
            }
            else {
                _this.getHistory();
            }
        });
        // UPDATE
        this.socket.forward(this.scopeUpdateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateRecord, function (event, data) {
            _this.isSaving = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Update record');
                return _this.notify.error("Unable to update record");
            }
            else {
                _this.notify.success('Update successful!');
                _this.sendNewHistoryLog('Edited record');
                return _this.initFunction();
            }
        });
        // CREATE
        this.socket.forward(this.scopeCreateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeCreateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Create record');
                return _this.notify.error("Unable to create record");
            }
            else {
                _this.notify.success('Record was added!');
                _this.sendNewHistoryLog('Created record');
                return _this.initFunction();
            }
        });
        // DELETE
        this.socket.forward(this.scopeDeleteRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Delete record');
                return _this.notify.error("Unable to delete record");
            }
            else {
                _this.notify.success('Record was deleted successful!');
                _this.sendNewHistoryLog('Deleted record');
                return _this.initFunction();
            }
        });
        // DELETE ALL
        this.socket.forward(this.scopeDeleteAll, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteAll, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Delete all records');
                return _this.notify.error("Unable to delete all records");
            }
            else {
                _this.notify.success('All records was deleted successful!');
                _this.sendNewHistoryLog('Deleted all records');
                return _this.initFunction();
            }
        });
        // DOWNLOAD EXCEL
        this.socket.forward(this.scopeExport, this.$scope);
        this.$scope.$on("socket:" + this.scopeExport, function (event, data) {
            _this.exportFired = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Exporting list');
                return _this.notify.error("Can't to export list");
            }
            else {
                _this.downloadFile(data.payload, 'dmt-exchange-rates');
                return _this.notify.success('Export was successful!');
            }
        });
        // DOWNLOAD EXCEL TEMPLATE
        this.socket.forward(this.scopeExportTemplate, this.$scope);
        this.$scope.$on("socket:" + this.scopeExportTemplate, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Exporting template');
                return _this.notify.error("Can't to export latest template");
            }
            else {
                _this.downloadFile(data.payload, 'dmt-exchange-rates-template');
                return _this.notify.success('Template downloaded successfully!');
            }
        });
        // UPLOADADD
        this.socket.forward(this.scopeImportFromExcel, this.$scope);
        this.$scope.$on("socket:" + this.scopeImportFromExcel, function (event, data) {
            _this.importingExcel = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Upload and Add from Excel');
                _this.notify.error("Can't to upload and add from Excel");
                _this.sendNewHistoryLog("Upload from .xlsx and added. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
            else {
                _this.notify.success('Uploaded and add from Excel successful!');
                _this.sendNewHistoryLog("Upload from .xlsx and added. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
        });
        // UPLOADREPLACE
        this.socket.forward(this.scopeReplaceFromExcel, this.$scope);
        this.$scope.$on("socket:" + this.scopeReplaceFromExcel, function (event, data) {
            _this.importingExcel = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Upload and Replace from Excel');
                _this.notify.error("Can't to upload and replace from Excel");
                _this.sendNewHistoryLog("Upload from .xlsx and replaced. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
            else {
                _this.notify.success('Uploaded and replace from Excel successful!');
                _this.sendNewHistoryLog("Upload from .xlsx and replaced. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
        });
    }
    ExchangeRateController.prototype.convertToViewModels = function (payload) {
        if (!payload) {
            payload = [];
        }
        function formatNumber(number) {
            return parseFloat(number.toString().replace(/,/g, '.'));
        }
        return payload.map(function (item) {
            return Object.assign({}, item, {
                FROMUSD: formatNumber(item.FROMUSD),
                TOUSD: formatNumber(item.TOUSD)
            });
        });
    };
    /**
     * Function to handle all errors
     */
    ExchangeRateController.prototype.isIncomingErrors = function (data) {
        if (data && data.error) {
            if (data.error.validationErrors.length || data.error.errors.length) {
                return true;
            }
        }
        else {
            return false;
        }
    };
    /**
     * Function to show all errors
     */
    ExchangeRateController.prototype.handleIncomingErrors = function (data, name) {
        var allErrorsInfo = {
            allErrors: data,
            windowName: name
        };
        this.Dialog.showingErrors(event, allErrorsInfo, 'showing-errors.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
        return;
    };
    /**
     * Function to download files
     */
    ExchangeRateController.prototype.downloadFile = function (file, name) {
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        var url = window.URL.createObjectURL(new Blob([file], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        a.setAttribute('href', url);
        var d = new Date().toDateString();
        a.setAttribute('download', name + " " + d + ".xlsx");
        a.click();
    };
    /**
     * Function to export
     */
    ExchangeRateController.prototype.export = function () {
        this.exportFired = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {},
                function: 'exportToExcel',
                scopeBack: this.scopeExport,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to create new record
     */
    ExchangeRateController.prototype.createRecord = function (event) {
        var _this = this;
        var tit = 'Add record to existing list';
        var date = new Date();
        var nextDay = new Date(date.valueOf() + 1 * 1000 * 60 * 60 * 24);
        var inactiveFrom = new Date('2999-12-31');
        var items = {
            icon: 'QUESTION',
            message: 'Are you sure, you want to add records to existing list?',
            title: tit,
            record: {
                CURRENCY: '',
                FROMUSD: '',
                TOUSD: '',
                STARTDATE: date,
                ENDDATE: nextDay,
                ACTIVE: 'Y',
                INACTIVE_FROM: inactiveFrom
            }
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.Dialog.updateValidForm(event, items, 'exchange-rate-insert.html').then(function (answer) {
                    items.record = answer.record;
                    items.record.STARTDATE = _this.dateToString(items.record.STARTDATE);
                    items.record.ENDDATE = _this.dateToString(items.record.ENDDATE);
                    items.record.INACTIVE_FROM = _this.dateToString(items.record.INACTIVE_FROM);
                    items.record.CREATED_BY = _this.env.user.email;
                    _this.socket.emit('module', {
                        module: {
                            application: 'dmt',
                            data: items.record,
                            function: 'insertRecord',
                            scopeBack: _this.scopeCreateRecord,
                            script: _this.backendModuleName,
                            token: _this.env.user.token,
                            email: _this.env.user.email
                        }
                    });
                    _this.historyInfo.currency = items.record.CURRENCY;
                    _this.historyInfo.startDate = items.record.STARTDATE;
                    _this.historyInfo.endDate = items.record.ENDDATE;
                });
            }
        });
        return;
    };
    ExchangeRateController.prototype.getRecordById = function (id) {
        return this.records.find(function (cl) { return cl['ID'] === id; });
    };
    /**
     * Function to edit record
     */
    ExchangeRateController.prototype.editRecord = function (event, editableRecord) {
        var _this = this;
        console.info("Record: " + editableRecord);
        var updatedData = {
            content: {
                ID: editableRecord['ID'],
                CURRENCY: editableRecord['CURRENCY'],
                FROMUSD: editableRecord['FROMUSD'],
                TOUSD: editableRecord['TOUSD'],
                STARTDATE: new Date(editableRecord['STARTDATE']),
                ENDDATE: new Date(editableRecord['ENDDATE']),
                ACTIVE: editableRecord['ACTIVE'],
                INACTIVE_FROM: new Date(editableRecord['INACTIVE_FROM'])
            }
        };
        this.Dialog.updateValidForm(event, updatedData, 'exchange-rate-edit.html').then(function (dResult) {
            updatedData.content.STARTDATE = _this.dateToString(updatedData.content.STARTDATE);
            updatedData.content.ENDDATE = _this.dateToString(updatedData.content.ENDDATE);
            updatedData.content.INACTIVE_FROM = _this.dateToString(updatedData.content.INACTIVE_FROM);
            _this.isSaving = true;
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: updatedData.content,
                    function: 'updateRecord',
                    scopeBack: _this.scopeUpdateRecord,
                    script: _this.backendModuleName,
                    token: _this.env.user.token,
                    email: _this.env.user.email
                }
            });
            _this.historyInfo.currency = updatedData.content.CURRENCY;
            _this.historyInfo.startDate = updatedData.content.STARTDATE;
            _this.historyInfo.endDate = updatedData.content.ENDDATE;
        });
        return;
    };
    ExchangeRateController.prototype.dateToString = function (date) {
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    };
    /**
     * Function to delete record
     */
    ExchangeRateController.prototype.deleteRecord = function (event, deleteRecord) {
        var _this = this;
        //let deleteRecord: any = {};
        this.Dialog.confirmDelete(event, deleteRecord).then(function (dResult) {
            if (dResult) {
                //deleteRecord = this.getRecordById(idx);
                var deletedData = {
                    ID: deleteRecord.ID
                };
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: deletedData,
                        function: 'deleteRecord',
                        scopeBack: _this.scopeDeleteRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token,
                        email: _this.env.user.email
                    }
                });
            }
            _this.historyInfo.currency = deleteRecord.CURRENCY;
            _this.historyInfo.startDate = deleteRecord.STARTDATE;
            _this.historyInfo.endDate = deleteRecord.ENDDATE;
        });
        return;
    };
    /**
     * Function to delete all records
     */
    ExchangeRateController.prototype.deleteAllRecords = function (event) {
        var _this = this;
        this.Dialog.confirmDelete(event).then(function (dResult) {
            if (dResult) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'deleteAllRecords',
                        scopeBack: _this.scopeDeleteAll,
                        script: _this.backendModuleName,
                        token: _this.env.user.token,
                        email: _this.env.user.email
                    }
                });
            }
        });
        return;
    };
    /**
     * Function to upload new list
     */
    ExchangeRateController.prototype.uploadRecordList = function (event) {
        var _this = this;
        var tit = 'Upload new list';
        var items = {
            icon: 'QUESTION',
            message: 'Do you want to add items to existing records or replace the existing list?',
            title: tit
        };
        this.Dialog.updateValidForm(event, items, 'newclient-update-add.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.uploadFilesAdd(dResult.data[0]);
            }
            else {
                var tit1 = 'Replace existing list';
                var items1 = {
                    icon: 'QUESTION',
                    message: 'Are you sure you want to completely replace the existing list?',
                    title: tit1
                };
                _this.Dialog.updateValidForm(event, items1, 'newclient-update-replace.html').then(function (dResult1) {
                    if (dResult1.confirm) {
                        _this.uploadFilesReplace(dResult1.data[0]);
                    }
                });
            }
        });
        return;
    };
    /**
     * Functions to prepare the files for file upload ADD
     */
    ExchangeRateController.prototype.uploadFilesAdd = function (file) {
        if (file) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: file,
                    function: 'importFromExcel',
                    scopeBack: this.scopeImportFromExcel,
                    script: this.backendModuleName,
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
        this.importingExcel = true;
    };
    /**
     * Functions to prepare the files for file upload REPLACE
     */
    ExchangeRateController.prototype.uploadFilesReplace = function (file) {
        if (file) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: file,
                    function: 'replaceAllFromExcel',
                    scopeBack: this.scopeReplaceFromExcel,
                    script: this.backendModuleName,
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
        this.importingExcel = true;
    };
    /**
     * Function to download template
     */
    ExchangeRateController.prototype.downloadTemplate = function (event) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'downloadExcelTemplate',
                scopeBack: this.scopeExportTemplate,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to get all records in DB2
     */
    ExchangeRateController.prototype.initFunction = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getData',
                scopeBack: this.scopeGetData,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to get all history from Cloudant
     */
    ExchangeRateController.prototype.getHistory = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getHistoryLogs',
                scopeBack: this.scopeGetLogs,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to send updated history to Cloudant
     */
    ExchangeRateController.prototype.sendNewHistoryLog = function (operation) {
        var timeStamp = new Date();
        var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
        var oneHist = {
            comment: (operation === 'Deleted record' || operation === 'Edited record' || operation === 'Created record') ?
                [(operation + " with currency: " + this.historyInfo.currency + ", start date: " + this.historyInfo.startDate + ", end date: " + this.historyInfo.endDate)] :
                [("" + operation)],
            timestamp: timeText,
            user: this.env.user.email
        };
        this.docTable.reverse();
        this.docTable.push(oneHist);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateHistoryLogs',
                scopeBack: this.scopeUpdateLogs,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token,
                data: this.docTable
            }
        });
    };
    ExchangeRateController.prototype.openActionMenu = function ($mdOpenMenu, event) {
        $mdOpenMenu(event);
    };
    ExchangeRateController.prototype.$onInit = function () {
        this.initFunction();
        this.getHistory();
    };
    ExchangeRateController.prototype.resetFilters = function () {
        delete this.table.filters;
        this.table.filterParams = {};
    };
    ExchangeRateController.$inject = [
        'settings',
        'env',
        '$filter',
        'socket',
        '$scope',
        'Dialog',
        'notify',
        'DTOptionsBuilder',
        'DTColumnBuilder',
        'DTColumnDefBuilder'
    ];
    return ExchangeRateController;
}());
var ExchangeRateComponent = (function () {
    function ExchangeRateComponent() {
        this.templateUrl = 'exchangerate-view.html';
        this.controllerAs = 'vm';
        this.controller = ExchangeRateController;
    }
    return ExchangeRateComponent;
}());
angular
    .module('application')
    .filter("stringToDateFormat", function ($filter) {
    return function (input, format) {
        return $filter("date")(new Date(input), format);
    };
})
    .component('viewExchangerateSection', new ExchangeRateComponent());



// class GBT20ViewController {
//     private profileLoaded: boolean = false;
//     private serverError: string = undefined;
//     private profile: any = {};
//     static $inject = ['env', '$filter', '$stateParams', '$state', 'socket', '$scope', 'admin'];
//     constructor(
//         private env: any,
//         private $filter: any,
//         private $stateParams: any,
//         private $state: any,
//         private socket: any,
//         private $scope: any,
//         private admin: any
//     ) {
//         this.socket.forward('config.gbt20_profile', this.$scope);
//         this.$scope.$on('socket:config.gbt20_profile', (event: ng.IAngularEvent, payload: any) => {
//             if (angular.isDefined(payload.error)) {
//                 this.serverError = payload.error;
//             } else {
//                 this.profile = payload.data;
//                 this.profileLoaded = true;
//             }
//         });
//     }
//     toggle(ting: any): void {
//         if (angular.isDefined(ting.view)) {
//             ting.view = !ting.view;
//         } else {
//             ting.view = true;
//         }
//     }
//     $onInit(): void {
//         this.admin.getGBT20Profile();
//     }
// }
// class GBT20ViewComponent implements ng.IComponentOptions {
//     templateUrl = 'gbt20-view.html';
//     controllerAs = 'vm';
//     controller = GBT20ViewController;
// }
// angular
//     .module('application')
//     .component('viewGbt20Section', new GBT20ViewComponent());



var GPPLoadViewController = (function () {
    function GPPLoadViewController(env, $filter, $stateParams, $state, socket, $scope, admin) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.profileLoaded = false;
        this.serverError = undefined;
        this.profile = {};
        this.socket.forward('config.gppload_profile', this.$scope);
        this.$scope.$on('socket:config.gppload_profile', function (event, payload) {
            if (angular.isDefined(payload.error)) {
                _this.serverError = payload.error;
            }
            else {
                _this.profile = payload.data;
                _this.profileLoaded = true;
            }
        });
    }
    GPPLoadViewController.prototype.toggle = function (ting) {
        if (angular.isDefined(ting.view)) {
            ting.view = !ting.view;
        }
        else {
            ting.view = true;
        }
    };
    GPPLoadViewController.prototype.$onInit = function () {
        this.admin.getGPPLoadProfile();
    };
    GPPLoadViewController.$inject = ['env', '$filter', '$stateParams', '$state', 'socket', '$scope', 'admin'];
    return GPPLoadViewController;
}());
var GPPLoadViewComponent = (function () {
    function GPPLoadViewComponent() {
        this.templateUrl = 'gppload-view.html';
        this.controllerAs = 'vm';
        this.controller = GPPLoadViewController;
    }
    return GPPLoadViewComponent;
}());
angular
    .module('application')
    .component('viewGpploadSection', new GPPLoadViewComponent());



var MassUpateController = (function () {
    function MassUpateController($scope, $state, env, Dialog, socket, $mdDialog) {
        this.$scope = $scope;
        this.$state = $state;
        this.env = env;
        this.Dialog = Dialog;
        this.socket = socket;
        this.$mdDialog = $mdDialog;
        this.bpoiFile = null;
        this.scopePrefix = "admin.massUpdate";
        this.scopeBPOIUpload = this.scopePrefix + ".bpoi.upload";
        this.scopePermittedUsers = this.scopePrefix + ".bpoi.permissions";
        this.scopeUpdateProgress = this.scopePrefix + ".progress";
        this.permittedUsers = ["evgeny.sorokin@ibm.com"];
        this.inProgress = false;
    }
    MassUpateController.prototype.$onInit = function () {
        var _this = this;
        this.socket.forward(this.scopeBPOIUpload, this.$scope);
        this.$scope.$on("socket:" + this.scopeBPOIUpload, function (event, data) {
            console.log(data.msg);
            _this.$mdDialog.show(_this.$mdDialog
                .alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title("Alert!")
                .textContent(data.msg)
                .ok("Got it!"));
            if (data.status === 'success') {
                _this.bpoiFile = null;
            }
        });
        this.socket.forward(this.scopeUpdateProgress, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateProgress, function (event, data) {
            _this.inProgress = data.inProgress;
        });
        this.socket.forward(this.scopePermittedUsers, this.$scope);
        this.$scope.$on("socket:" + this.scopePermittedUsers, function (event, data) {
            if (!data.permitted) {
                _this.$mdDialog.show(_this.$mdDialog
                    .alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(true)
                    .title("Alert!")
                    .textContent("You're not allowed to view this page")
                    .ariaLabel("not allowed alert")
                    .ok("Got it!"));
                _this.$state.go("admin.main");
            }
        });
        this.checkPermission();
        this.checkUpdateStatus();
    };
    MassUpateController.prototype.checkPermission = function () {
        this.socket.emit("module", {
            module: {
                application: "dmt",
                data: {},
                function: "getUserPermission",
                scopeBack: this.scopePermittedUsers,
                script: "admin/mass-update/mass-update",
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    MassUpateController.prototype.isSubmitDisabled = function () {
        return this.inProgress || !this.bpoiFile;
    };
    MassUpateController.prototype.checkUpdateStatus = function () {
        this.socket.emit("module", {
            module: {
                application: "dmt",
                data: {},
                function: "checkMassUpdateProgress",
                scopeBack: this.scopeUpdateProgress,
                script: "admin/mass-update/mass-update",
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    MassUpateController.prototype.selectBPOIFile = function (event, files) {
        this.bpoiFile = files[0];
    };
    MassUpateController.prototype.onBPOISubmit = function (event) {
        if (this.bpoiFile) {
            this.uploadBPOIFile(this.bpoiFile);
            this.inProgress = true;
            this.checkUpdateStatus();
        }
    };
    MassUpateController.prototype.uploadBPOIFile = function (file) {
        this.socket.emit("module", {
            module: {
                application: "dmt",
                data: {
                    file: file,
                    fileType: file.type
                },
                function: "uploadBPOIFile",
                scopeBack: this.scopeBPOIUpload,
                script: "admin/mass-update/mass-update",
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    MassUpateController.$inject = [
        "$scope",
        "$state",
        "env",
        "Dialog",
        "socket",
        "$mdDialog"
    ];
    return MassUpateController;
}());
var MassUpdateComponent = (function () {
    function MassUpdateComponent() {
        this.templateUrl = "mass-update.html";
        this.controllerAs = "vm";
        this.controller = MassUpateController;
    }
    return MassUpdateComponent;
}());
angular
    .module("application")
    .component("massUpdateSection", new MassUpdateComponent());



/**
 * @author Matthew Rogers
 * Controller for MYSA Opportunity Log admin page
 */
var MYSADMTViewController = (function () {
    function MYSADMTViewController(env, socket, $scope, Dialog, notify, $state) {
        var _this = this;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.notify = notify;
        this.$state = $state;
        this.loaded = { inbound: false, outbound: false, opp: false, ready: false };
        this.serverError = undefined;
        this.defects = { inbound: undefined, outbound: undefined, total: 0 };
        this.filter = { defectIN: '', defectOUT: '' };
        this.oppLog = { log: undefined, notfound: false, searching: { in: {}, out: {}, opp: false }, opp: '', oppty: '', in: [], out: [] };
        // Listener for the inbound and outbound defects to arrive
        this.socket.forward('mysa.mysadmt-defects', this.$scope);
        this.$scope.$on('socket:mysa.mysadmt-defects', function (event, payload) {
            if (angular.isDefined(payload.error)) {
                // this.serverError = payload.error;
                // Flash the error and go back to admin view
                _this.notify.error(payload.error);
                $state.go('admin.main');
            }
            else {
                _this.defects[payload.type] = payload.data;
                _this.loaded[payload.type] = true;
                _this.areWeReady();
            }
        });
        // Listener for the opp log retrieval to arrive
        this.socket.forward('mysa.mysadmt-opp-log', this.$scope);
        this.$scope.$on('socket:mysa.mysadmt-opp-log', function (event, payload) {
            // console.info(payload);
            _this.oppLog.searching = { in: {}, out: {}, opp: false }; // Reset search button
            if (angular.isDefined(payload.error)) {
                // this.serverError = payload.error;
                _this.notify.error(payload.error);
            }
            else if (!angular.isDefined(payload.data)) {
                _this.oppLog.notfound = true;
            }
            else {
                _this.oppLog.in = payload.data.logEntriesInBound;
                _this.oppLog.out = payload.data.logEntriesOutBound;
                _this.oppLog.oppty = payload.data._id.substr(payload.data._id.indexOf('LOG-') + 4);
                _this.loaded.opp = true;
            }
        });
    }
    /**
     * Function to view the details of the inbound or outbound log details in a pop-up
     * @param entry - Object - the entire log details
     * @param inout - String - whether Inbound or Outbound log
     */
    MYSADMTViewController.prototype.viewLog = function (event, entry, inout) {
        // Object containing details for the pop-up
        var items = {
            logBundle: {
                log: JSON.stringify(entry, undefined, 4),
                opp: this.oppLog.oppty,
                time: this.getDate(entry.timestamp),
                module: entry.module,
                success: entry.success,
                message: entry.message.info ? entry.message.info : entry.message,
                io: inout
            }
        };
        // Display pop-up
        this.Dialog.updateValidForm(event, items, 'mysa-dmt-viewlog.html');
    };
    /**
     * Function fired when initially inbound or outbound data is received.  Only if both are loaded, will the
     * page detail appear
     */
    MYSADMTViewController.prototype.areWeReady = function () {
        if (this.loaded.inbound && this.loaded.outbound) {
            this.defects.total = this.defects.inbound.length + this.defects.outbound.length;
            this.loaded.ready = true;
        }
    };
    /**
     * Function to collect an opportunity's log document from cloudant - could be called via the search button, or
     * when selecting from the defect list
     * @param oppNum - String - the opportunity number
     * @param index - Number - the index number of the defect selected by the user
     */
    MYSADMTViewController.prototype.retrieveLog = function (oppNum, index, io) {
        // Set search flag accordingly
        if (angular.isDefined(index)) {
            this.oppLog.searching[io][index] = true;
        }
        else {
            this.oppLog.searching.opp = true;
        }
        this.oppLog.notfound = false; // reset
        // Make call to server
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getLogByOpp',
                opp: oppNum,
                script: '/admin/mysa-dmt/mysa-dmt',
                user: this.env.user
            }
        });
    };
    MYSADMTViewController.prototype.getDate = function (date) {
        return new Date(date);
    };
    MYSADMTViewController.prototype.getTitle = function (log) {
        if (log.message.success) {
            return 'INFO: ' + log.message.info + '\n\nClick to display full log details';
        }
        else {
            if (log.message.info) {
                return 'INFO: ' + log.message.info + '\nERROR: ' + log.message.errors + '\n\nClick to display full log details';
            }
            else {
                return 'ERROR: ' + log.message + '\n\nClick to display full log details';
            }
        }
    };
    MYSADMTViewController.prototype.$onInit = function () {
        var _this = this;
        // Make calls to get the outbound and inbound defects
        var defects = ['mysa-dmt-defective-outbound', 'mysa-dmt-defective-inbound'];
        angular.forEach(defects, function (viewName) {
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getMYSA2DMTFailures',
                    script: '/admin/mysa-dmt/mysa-dmt',
                    view: viewName,
                    user: _this.env.user
                }
            });
        });
    };
    MYSADMTViewController.$inject = ['env', 'socket', '$scope', 'Dialog', 'notify', '$state'];
    return MYSADMTViewController;
}());
var MYSADMTViewComponent = (function () {
    function MYSADMTViewComponent() {
        this.templateUrl = 'mysa-dmt-view.html';
        this.controllerAs = 'vm';
        this.controller = MYSADMTViewController;
    }
    return MYSADMTViewComponent;
}());
angular
    .module('application')
    .component('viewMysaDmtSection', new MYSADMTViewComponent());



//TODO move the constants 'read/edit/send' to enum
// enum Mode {
//     READ = 'ready',
//     EDIT = 'edit',
//     SENDING = 'sending',
// }
/**
 * Controller for MYSA IM outbound Opportunity Log admin page
 */
var MysaImOutboundViewController = (function () {
    function MysaImOutboundViewController(env, socket, $scope, baseDialog, notify, $state) {
        var _this = this;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.baseDialog = baseDialog;
        this.notify = notify;
        this.$state = $state;
        this.scopePrefix = 'admin.mysa-in-outbond';
        this.scopeOutboundSend = this.scopePrefix + ".send";
        this.loaded = { outbound: false, opp: false, ready: false };
        this.serverError = undefined;
        this.defects = { outbound: undefined, total: 0 };
        this.filter = { defectOUT: '', errorOnly: false };
        this.oppLog = { log: undefined, notfound: false, editMode: false, searching: { in: {}, out: {}, opp: false }, opp: '', oppty: '', in: [], out: [] };
        // Listener for the outbound defects to arrive
        this.socket.forward('mysa.mysa-im-outbound-defects', this.$scope);
        this.$scope.$on('socket:mysa.mysa-im-outbound-defects', function (event, payload) {
            if (angular.isDefined(payload.error)) {
                // this.serverError = payload.error;
                // Flash the error and go back to admin view
                _this.notify.error(payload.error);
                $state.go('admin.main');
            }
            else {
                _this.defects[payload.type] = payload.data;
                _this.loaded[payload.type] = true;
                _this.isReady();
            }
        });
        // Listener for the opp log retrieval to arrive
        this.socket.forward('mysa.mysa-im-outbound-opp-log', this.$scope);
        this.$scope.$on('socket:mysa.mysa-im-outbound-opp-log', function (event, payload) {
            // - console.info(payload);
            _this.oppLog.searching = { out: {}, opp: false }; // Reset search button
            if (angular.isDefined(payload.error)) {
                // this.serverError = payload.error;
                _this.notify.error(payload.error);
            }
            else if (!angular.isDefined(payload.data)) {
                _this.oppLog.notfound = true;
            }
            else {
                _this.oppLog.out = payload.data.logEntriesOutBound;
                if (!payload.data._id) {
                }
                else {
                    _this.oppLog.oppty = payload.data._id.substr(payload.data._id.indexOf('LOG-') + 4);
                }
                _this.loaded.opp = true;
            }
        });
        // SEND
        this.socket.forward(this.scopeOutboundSend, this.$scope);
        this.$scope.$on("socket:" + this.scopeOutboundSend, function (event, respData) {
            // - console.log('on scopeOutboundSend - im - outbound - opp - log');
            if (respData && respData.error) {
                _this.notify.error("Unable to send outbound: " + respData.error);
            }
            else {
                // - console.log(this.baseDialog.getData());
                var dlgData = _this.baseDialog.getData();
                dlgData.log = dlgData;
                dlgData.mode = 'read';
                dlgData.trigger = _this.env.user.email;
                dlgData.success = respData.success;
                dlgData.message = respData.msg;
                _this.notify.success("Outboud is sent. Status: " + (respData && respData.status));
            }
        });
    }
    /**
     * Function to view the details of the outbound log details in a pop-up
     * @param entry - Object - the entire log details
     * @param inout - String - whether Outbound log
     */
    MysaImOutboundViewController.prototype.viewLog = function (entry, isLast) {
        // - console.log(`viewlog: [${entry}]`);
        var _this = this;
        var d = this.generateData(entry, isLast);
        var requestBodyOrg = d.requestBody;
        //const scope: any = this;
        //Object containing details for the pop - up
        var items = {
            data: d,
            isEditMode: function () {
                return items.data.mode === 'edit';
            },
            isSendMode: function () {
                return items.data.mode === 'send';
            },
            onClose: function () {
                _this.baseDialog.hide();
            },
            onEdit: function () {
                // - console.log(`onEdit - items.data.mode: ${items.data.mode}`);
                if (items.data.mode !== 'read') {
                    items.data.mode = 'read';
                    items.data.requestBody = requestBodyOrg;
                }
                else {
                    items.data.mode = 'edit';
                }
            },
            onSend: function (outboundText) {
                // - console.log(`onSend: ${outboundText}`);
                items.data.mode = 'send';
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'outboundToMysaIm',
                        opp: items.data.opp,
                        outboundBody: outboundText,
                        script: MysaImOutboundViewController.URL_ADMIN_MYSA_IM_OUTBOUND,
                        user: _this.env.user
                    }
                });
            }
        };
        //Display pop - up
        this.baseDialog.show(event, 'mysa-im-outbound-dlg.html', items)
            .then(function () {
            // - console.log('dlg:: hidden');
            _this.requestOutbound();
            _this.retrieveOutLog(d.opp);
        }).catch(function (e) {
            // - console.log(e);
            _this.requestOutbound();
            _this.retrieveOutLog(d.opp);
        });
    };
    /**
     * Function fired when initially outbound data is received.  Only if both are loaded, will the
     * page detail appear
     */
    MysaImOutboundViewController.prototype.isReady = function () {
        if (this.loaded.outbound) {
            this.defects.total = this.defects.outbound.length;
            this.defects.totalError = this.defects.outbound.filter(function (opp) { return !opp.value.success; }).length;
            this.loaded.ready = true;
        }
    };
    /**
     * Function to collect an opportunity's log document from cloudant - could be called via the search button, or
     * when selecting from the defect list
     * @param oppNum - String - the opportunity number
     * @param index - Number - the index number of the defect selected by the user
     */
    MysaImOutboundViewController.prototype.retrieveOutLog = function (oppNum, index) {
        // - console.log('retrieveOutLog index=' + index);
        var io = 'out';
        // Set search flag accordingly
        if (index > -1) {
            this.oppLog.searching[io][index] = true;
        }
        else {
            this.oppLog.searching.opp = true;
        }
        this.oppLog.notfound = false; // reset
        // Make call to server
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getLogByOpp',
                opp: oppNum,
                script: MysaImOutboundViewController.URL_ADMIN_MYSA_IM_OUTBOUND,
                user: this.env.user
            }
        });
    };
    MysaImOutboundViewController.prototype.getDate = function (date) {
        return new Date(date);
    };
    MysaImOutboundViewController.prototype.getStatus = function (log) {
        return log && log.logObject && log.logObject.incentiveStatus || 'no status defined';
    };
    MysaImOutboundViewController.prototype.getTitle = function (log) {
        return log.message.substr(0, 100) + "... Click to display request details";
    };
    MysaImOutboundViewController.prototype.$onInit = function () {
        this.requestOutbound();
    };
    MysaImOutboundViewController.prototype.generateData = function (ent, isLast) {
        var entry = ent || {};
        // - console.log(entry.logObject);
        return {
            isLast: (isLast === true || isLast === false) ? isLast : true,
            message: (entry.message.info || entry.message),
            mode: 'read',
            module: entry.module,
            opp: this.oppLog.oppty,
            requestBody: entry.requestBody,
            success: entry.success,
            time: this.getDate(entry.timestamp),
            trigger: entry.trigger
        };
    };
    /**
     * Make calls to get the outbound defects
     */
    // tslint:disable-next-line: typedef
    MysaImOutboundViewController.prototype.requestOutbound = function () {
        // - console.log('requestOutbound');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getMysaImOutbounds',
                script: MysaImOutboundViewController.URL_ADMIN_MYSA_IM_OUTBOUND,
                user: this.env.user
            }
        });
    };
    MysaImOutboundViewController.$inject = ['env', 'socket', '$scope', 'baseDialog', 'notify', '$state'];
    MysaImOutboundViewController.URL_ADMIN_MYSA_IM_OUTBOUND = '/admin/mysa-im-outbound/mysa-im-outbound';
    return MysaImOutboundViewController;
}());
// tslint:disable-next-line: max-classes-per-file
var MysaImOutboundViewComponent = (function () {
    function MysaImOutboundViewComponent() {
        this.templateUrl = 'mysa-im-outbound-view.html';
        this.controllerAs = 'vm';
        this.controller = MysaImOutboundViewController;
    }
    return MysaImOutboundViewComponent;
}());
angular
    .module('application')
    .component('viewMysaImOutboundSection', new MysaImOutboundViewComponent());



var MysaerrlogsDetailsController = (function () {
    function MysaerrlogsDetailsController(settings, env, $compile, $filter, socket, $scope, $state, $stateParams, $http, Dialog, notify) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$compile = $compile;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$http = $http;
        this.Dialog = Dialog;
        this.notify = notify;
        this.table = { sortType: '', sortReverse: false, search: '', filter: false, filterParams: {} };
        this.options = { oneSelected: false, selected: {} };
        this.countFired = false;
        this.isDetailsOpen = true;
        this.id = '';
        this.failedQueue = [];
        this.backendModuleName = 'admin/mysaerrors/mysaerr-logs';
        this.scopePrefix = 'admin.mysaerrors';
        this.scopeGetOppLogs = this.scopePrefix + ".getMysaErrLogs";
        this.scoperesolveOppLogs = this.scopePrefix + ".resovleMysaErr";
        this.id = $stateParams.id;
        this.dataLoaded = false;
        this.socket.forward(this.scopeGetOppLogs, this.$scope);
        this.$scope.$on("socket:" + this.scopeGetOppLogs, function (event, data) {
            if (data.items) {
                _this.failedQueue = data.items[0].errors;
            }
        });
        this.socket.forward(this.scoperesolveOppLogs, this.$scope);
        this.$scope.$on("socket:" + this.scoperesolveOppLogs, function (event, data) {
            if (data.message) {
                _this.dataLoaded = false;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: { id: _this.id },
                        email: _this.env.user.email,
                        function: 'getMysaErrLogs',
                        scopeBack: _this.scopeGetOppLogs,
                        script: _this.backendModuleName,
                        token: _this.env.user.token
                    }
                });
            }
        });
    }
    MysaerrlogsDetailsController.prototype.handleDetailsClick = function (index) {
        this.isDetailsOpen = this.isDetailsOpen === index ? false : index;
    };
    MysaerrlogsDetailsController.prototype.handleResolveClick = function (errorId) {
        this.dataLoaded = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    id: this.id,
                    errId: errorId
                },
                function: 'resovleMysaErr',
                script: this.backendModuleName,
                token: this.env.user.token
            }
        });
    };
    MysaerrlogsDetailsController.prototype.getJsonInbound = function (inbound) {
        return JSON.stringify(inbound).replace(/,/gi, '",\n\n').replace(/},/gi, '\n},\n\n').replace(/{/gi, '\n{\n\n');
    };
    MysaerrlogsDetailsController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: { id: this.id },
                email: this.env.user.email,
                function: 'getMysaErrLogs',
                scopeBack: this.scopeGetOppLogs,
                script: this.backendModuleName,
                token: this.env.user.token
            }
        });
    };
    MysaerrlogsDetailsController.$inject = [
        'settings',
        'env',
        '$compile',
        '$filter',
        'socket',
        '$scope',
        '$state',
        '$stateParams',
        '$http',
        'Dialog',
        'notify'
    ];
    return MysaerrlogsDetailsController;
}());
var MysaerrlogsDetailsComponent = (function () {
    function MysaerrlogsDetailsComponent() {
        this.templateUrl = 'mysaerrlogs-details.html';
        this.controllerAs = 'vm';
        this.controller = MysaerrlogsDetailsController;
    }
    return MysaerrlogsDetailsComponent;
}());
angular
    .module('application')
    .component('mysaerrlogsDetailsSection', new MysaerrlogsDetailsComponent());



var MysaErrorsViewController = (function () {
    function MysaErrorsViewController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, notify, Dialog, settings, $mdDialog, filters) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$mdDialog = $mdDialog;
        this.filters = filters;
        this.newSearch = 'Default';
        this.someClickHandler = function (info) {
            _this.$state.go('admin.mysaerrlogs-details-view', {
                id: info.value
            });
        };
        this.rowCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function () {
                _this.$scope.$apply(function () {
                    _this.someClickHandler(aData);
                });
            });
            return nRow;
        };
        this.wasSapTriggered = false;
        this.showFilterBtn = false;
        this.rowData = {};
        this.dtInstance = {};
        this.tableData = {};
        this.filters = {};
        this.deferred = this.$q.defer();
    }
    MysaErrorsViewController.prototype.$onInit = function () {
        var _this = this;
        var that = this;
        this.dtColumns = this.buildColumns();
        this.dtOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', {
            dataSrc: function (data) {
                that.tableData = data.data;
                return data.data;
            },
            url: '/api/admin/mysaerr-logs',
            type: 'POST',
            beforeSend: function (request) {
                request.setRequestHeader('Authorization', 'Bearer ' + _this.env.user.token);
            },
            data: function (d, callback, settings) {
                d.users = [("" + that.env.user.email)];
            },
            complete: function (d) {
                _this.wasSapTriggered = false;
            }
        })
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('createdRow', createdRow)
            .withOption('rowCallback', this.rowCallback)
            .withPaginationType('full_numbers');
        function createdRow(row, data, dataIndex) {
            var el = angular.element;
            that.$compile(el(row).contents())(that.$scope);
        }
        this.dtHistoryColumns = this.buildHistoryColumns();
        this.dtHistoryOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', {
            dataSrc: function (data) {
                that.tableData = data.data;
                return data.data;
            },
            url: '/api/admin/mysaerr-logs-history',
            type: 'POST',
            beforeSend: function (request) {
                request.setRequestHeader('Authorization', 'Bearer ' + _this.env.user.token);
            },
            data: function (d, callback, settings) {
                console.info(d, settings);
            },
            complete: function (d) {
                _this.wasSapTriggered = false;
            }
        })
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('createdRow', createdHistoryRow)
            .withPaginationType('full_numbers');
        function createdHistoryRow(row, data, dataIndex) {
            var OFFSET = 3;
            var el = angular.element;
            that.$compile(el(row).contents())(that.$scope);
        }
    };
    MysaErrorsViewController.prototype.buildColumns = function () {
        return [this.DTColumnBuilder.newColumn('value')
                .withTitle('OPP'),
        ];
    };
    MysaErrorsViewController.prototype.buildHistoryColumns = function () {
        return [
            this.DTColumnBuilder.newColumn('date')
                .withTitle('Time'),
            this.DTColumnBuilder.newColumn('data')
                .withTitle('Changes made'),
            this.DTColumnBuilder.newColumn('user')
                .withTitle('Changed by'),
        ];
    };
    MysaErrorsViewController.$inject = [
        '$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings', '$mdDialog',
    ];
    return MysaErrorsViewController;
}());
var MysaErrorsComponent = (function () {
    function MysaErrorsComponent() {
        this.templateUrl = 'mysaerrlogs.html';
        this.controllerAs = 'vm';
        this.controller = MysaErrorsViewController;
    }
    return MysaErrorsComponent;
}());
angular
    .module('application')
    .component('mysaerrlogsSection', new MysaErrorsComponent());



var bindCheck = { check: '=' };
var YES_NO_ARR = [
    'Yes',
    'No',
    "Yes/No",
];
var NA_ARR = [
    'Yes',
    'No',
    'Not applicable'
];
var RESP_ARR = [
    "APPROVED", "NOT_APPROVED", "MANUAL_REVIEW"
];
var CODE_RESP = [
    'DBG_DUPLICATE',
    'EXISTING_REGISTRATION',
    'CLIP',
    'EXISTING_IBM_LED',
    'GOE',
    'CEIDS',
    'GLOBALCLIENT',
    'PROSPECT',
    'NO_SKILLS',
    'TA',
    'NOT_APPLICABLE',
    'NO_BPA_TA',
    'NOT_CHECKED',
    'NO_SOLUTIONS',
    'SYS_ERROR',
    'EXISTING_CLIENT',
    'DCID_DUPLICATE',
    'NOT_CHECKED',
    'JP_REVIEW',
];
var CMR_ARR = [
    "Standard",
    "Prospect",
    "Not Provided",
    "Standard/Prospect",
    "Standard/Not Provided",
    "Prospect/Not Provided",
    "Standard/Prospect/Not Provided"
];
var DR_GOE_ARR = [
    "Yes",
    "No",
    "Unknown",
    "State Owned",
    "Yes/No",
    "Yes/Unknown",
    "Yes/State Owned",
    "No/Unknown",
    "No/State Owned",
    "Unknown/State Owned",
    "Yes/No/Unknown",
    "Yes/No/State Owned",
    "Yes/Unknown/State Owned",
    "No/Unknown/State Owned",
    "Yes/No/Unknown/State Owned"
];
var MYSA_DUP = [
    "Yes",
    "No",
    "Manual Review",
    "Yes/No",
    "Yes/Manual Review",
    "No/Manual Review",
    "Yes/No/Manual Review"
];
var CD_ARR = [
    "BP-Led",
    "Co-Led",
    "IBM-Led",
    "Unassigned",
    "BP-Led/Co-Led",
    "BP-Led/IBM-Led",
    "Co-Led/IBM-Led",
    "BP-Led/Unassigned",
    "IBM-Led/Unassigned",
    "Co-Led/Unassigned",
    "BP-Led/Co-Led/IBM-Led",
    "BP-Led/Co-Led/Unassigned",
    "BP-Led/IBM-Led/Unassigned",
    "Co-Led/IBM-Led/Unassigned",
    "BP-Led/Co-Led/IBM-Led/Unassigned",
];
var TA_ARR = [
    "Yes",
    "No",
    "Not Applicable",
    "Manual Review",
    "Yes/No",
    "Yes/Not Applicable",
    "Yes/Manual Review",
    "No/Not Applicable",
    "No/Manual Review",
    "Yes/No/Not Applicable",
    "Yes/No/Manual Review",
    "No/Not Applicable/Manual Review",
    "Yes/No/Not Applicable/Manual Review"
];
var INCENTIVES_GOE_ARR = [
    "Yes",
    "No",
    "Unknown",
    "State Owned",
    "Manual Review",
    "Yes/No",
    "Yes/Unknown",
    "Yes/State Owned",
    "Yes/Manual Review",
    "No/Unknown",
    "No/State Owned",
    "No/Manual Review",
    "Unknown/State Owned",
    "Unknown/Manual Review",
    "State Owned/Manual Review",
    "Yes/No/Unknown",
    "Yes/No/State Owned",
    "Yes/No/Manual Review",
    "Yes/Unknown/State Owned",
    "Yes/Unknown/Manual Review",
    "Yes/State Owned/Manual Review",
    "No/Unknown/State Owned",
    "No/Unknown/Manual Review",
    "No/State Owned/Manual Review",
    "Unknown/State Owned/Manual Review",
    "Yes/No/Unknown/State Owned",
    "Yes/No/Unknown/Manual Review",
    "Yes/No/State Owned/Maunal Review",
    "No/Unknown/State Owned/Manual Review",
    "Yes/No/Unknown/State Owned/Manual Review",
];
var SC_DUP = [
    "Yes",
    "No",
    "Manual Review",
    "Yes/No",
    "Yes/Manual Review",
    "No/Manual Review",
    "Yes/No/Manual Review"
];
var NC = [
    "Yes",
    "No",
    "Manual Review",
    "Yes/No",
    "Yes/Manual Review",
    "No/Manual Review",
    "Yes/No/Manual Review"
];
var SOLUTION_ARR = [
    "Yes",
    "No",
    "Manual Review",
    "Yes/No",
    "No/Manual Review",
    "Yes/No/Manual Review"
];
var CD_RESP = [
    "BP_LED", "CO_LED", "IBM_LED", "MANUAL_REVIEW"
];
var SPEC_BID_RESP = [
    "APPROVED", "NOT_APPROVED", "MANUAL_REVIEW", "NOT_APPLICABLE"
];
var CVR_SSA_RESP = [
    "BP_ID", "IBM_ID", "NOT_APPROVED", "MANUAL_REVIEW"
];
var RESP_INC_GOE_ARR = [
    "APPROVED", "NOT_APPROVED", "MANUAL_REVIEW", "GOVERNMENT_OWNED", "STATE_OWNED", "NO"
];
var DEFAULT_SELECTION = '-Please select-';
var CheckResultsUpdateController = (function () {
    function CheckResultsUpdateController(settings, env, $compile, $filter, socket, $scope, Dialog, notify, DTOptionsBuilder, DTColumnBuilder) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$compile = $compile;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.notify = notify;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this.TEMPLATE_CONFIRM = 'confirm-prompt.html';
        this.checkData = this.check;
        this.tableItems = [];
        this.backendModuleName = 'admin/mysaresponse/mysa-response';
        this.scopePrefix = 'admin.mysaresponse';
        this.scopeDeleteRecord = this.scopePrefix + ".delete";
        this.scopeUpdateRecord = this.scopePrefix + ".update";
        this.scopeCreateRecord = this.scopePrefix + ".insert";
        this.table = {
            dtColumns: {},
            dtInstance: {},
            filter: false,
            filterParams: {},
            filters: {},
            search: '',
            select_options: {},
            visible: 0
        };
        this.tableLog = {
            dtColumns: {},
            dtInstance: {},
            filter: false,
            filterParams: {},
            filters: {},
            search: '',
            select_options: {},
            visible: 0
        };
        // CREATE
        this.socket.forward(this.scopeCreateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeCreateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Create a record');
                _this.notify.error("Unable to create a record");
            }
            else {
                _this.notify.success('Record successfuly added');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // DELETE
        this.socket.forward(this.scopeDeleteRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Delete record');
                _this.notify.error("Unable to delete record");
            }
            else {
                _this.notify.success('Record was deleted successful!');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // UPDATE
        this.socket.forward(this.scopeUpdateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Update the record');
                _this.notify.error("Unable to update the record");
            }
            else {
                _this.notify.success('Comliance plan successfuly updated!');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
    }
    CheckResultsUpdateController.prototype.$onInit = function () {
        var _this = this;
        this.signalWrongResponse = '';
        this.columnIdName = this.checkData.columnIdName;
        this.columnLogIdName = this.checkData.columnLogIdName;
        this.table.dtColumns = this.buildColumns(this.columnIdName);
        this.table.dtOptions = this.DTOptionsBuilder.newOptions()
            .withIBMTheme()
            .withOption('ajax', this.buildAjaxOption())
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withPaginationType('full_numbers')
            .withOption('createdRow', function (row) {
            _this.$compile(angular.element(row).contents())(_this.$scope);
        })
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
        this.tableLog.dtColumns = this.buildColumns(this.columnLogIdName);
        this.tableLog.dtOptions = this.DTOptionsBuilder.newOptions()
            .withIBMTheme()
            .withOption('ajax', this.buildLogAjaxOption())
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('order', [[0, 'desc']]) // Default sorting by time
            .withPaginationType('full_numbers')
            .withOption('createdRow', function (row) {
            _this.$compile(angular.element(row).contents())(_this.$scope);
        })
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
    };
    /**
       * Function to delete a row in DB
    */
    CheckResultsUpdateController.prototype.deleteRow = function (event, rowId) {
        var _this = this;
        var rowData = this.tableItems[rowId];
        var dataToDelete = {
            ID: rowData['ID']
        };
        this.Dialog.confirmDelete(event, rowData).then(function (dResult) {
            if (dResult) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: dataToDelete,
                        table: _this.checkData.db,
                        email: _this.env.user.email,
                        function: 'deleteRecord',
                        scopeBack: _this.scopeDeleteRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token
                    }
                });
            }
        });
    };
    /**
       * Function to insert a row in DB
    */
    CheckResultsUpdateController.prototype.addRow = function (event) {
        var _this = this;
        var result = this.extractCountry();
        var tit = 'Add Mysa Response record';
        var defaultColumns = {};
        Object.keys(this.columnIdName).forEach(function (element) {
            defaultColumns[element] = [];
        });
        var item = {
            icon: 'QUESTION',
            message: 'Are you sure, you want to add a new record to existing list?',
            title: tit,
            tree: result.tree,
            iots: Object.keys(result.tree).sort(),
            imts: result.imts,
            content: defaultColumns,
            listIOTs: function (tree) { return Object.keys(tree).sort(); },
            listIMTs: function (tree, iot, imts) {
                return iot.length > 0
                    ? (_a = []).concat.apply(_a, iot.map(function (el) { return imts[el]; }))
                    : '';
                var _a;
            },
            listCountries: function (tree, iot, imt, imts) {
                if (iot.length > 0 && imt.length > 0) {
                    var countries = [];
                    for (var _i = 0, iot_1 = iot; _i < iot_1.length; _i++) {
                        var el = iot_1[_i];
                        for (var _a = 0, imt_1 = imt; _a < imt_1.length; _a++) {
                            var elem = imt_1[_a];
                            if (tree[el][elem]) {
                                countries = countries.concat(tree[el][elem]);
                            }
                        }
                    }
                    return countries;
                }
                return tree[iot] ? tree[iot][imt] : DEFAULT_SELECTION;
            },
            yesNoArr: YES_NO_ARR,
            arrayNA: NA_ARR,
            respArr: RESP_ARR,
            cmrArr: CMR_ARR,
            drArr: DR_GOE_ARR,
            taArr: TA_ARR,
            cdArr: CD_ARR,
            solutionArr: YES_NO_ARR,
            mysaArr: MYSA_DUP,
            scArr: SC_DUP,
            ncArr: NC,
            solArr: SOLUTION_ARR,
            incArr: INCENTIVES_GOE_ARR,
            cdResp: CD_RESP,
            specBidResp: SPEC_BID_RESP,
            cvrSSAResp: CVR_SSA_RESP,
            incGoeResp: RESP_INC_GOE_ARR,
            codeResp: CODE_RESP,
            table: this.checkData.db
        };
        this.Dialog.updateValidForm(event, item, this.TEMPLATE_CONFIRM)
            .then(function (dResult) {
            if (!dResult.confirm) {
                return;
            }
            _this.Dialog.updateValidForm(event, item, 'mysaresponse-edit.html')
                .then(function (answer) {
                var content = answer.mdTextContent;
                var countryReslt = _this.extractCountry();
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: _this.getRecordsArr(content, countryReslt),
                        table: _this.checkData.db,
                        email: _this.env.user.email,
                        function: 'insertRecord',
                        scopeBack: _this.scopeCreateRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token
                    }
                });
            });
        });
    };
    CheckResultsUpdateController.prototype.getRecordsArr = function (content, countryReslt) {
        var contentArr = [];
        if (content['GEO'].length > 0) {
            for (var _i = 0, _a = content['GEO']; _i < _a.length; _i++) {
                var iot = _a[_i];
                if (content['IMT'].length > 0) {
                    for (var _b = 0, _c = content['IMT']; _b < _c.length; _b++) {
                        var imt = _c[_b];
                        if (countryReslt.tree[iot][imt] && content['COUNTRY'].length === 0) {
                            var oneRecord = Object.assign({}, content);
                            oneRecord['GEO'] = iot;
                            oneRecord['IMT'] = imt;
                            oneRecord = this.prepareRecord(oneRecord);
                            contentArr.push(oneRecord);
                        }
                        else {
                            for (var _d = 0, _e = content['COUNTRY']; _d < _e.length; _d++) {
                                var country = _e[_d];
                                if (countryReslt.tree[iot][imt] && countryReslt.tree[iot][imt].indexOf(country) !== -1) {
                                    var oneRecord = Object.assign({}, content);
                                    oneRecord['GEO'] = iot;
                                    oneRecord['IMT'] = imt;
                                    oneRecord['COUNTRY'] = country;
                                    oneRecord = this.prepareRecord(oneRecord);
                                    contentArr.push(oneRecord);
                                }
                            }
                        }
                    }
                }
                else {
                    var oneRecord = Object.assign({}, content);
                    oneRecord['GEO'] = iot;
                    oneRecord = this.prepareRecord(oneRecord);
                    contentArr.push(oneRecord);
                }
            }
        }
        else {
            var oneRecord = Object.assign({}, content);
            oneRecord = this.prepareRecord(oneRecord);
            contentArr.push(oneRecord);
        }
        return contentArr;
    };
    CheckResultsUpdateController.prototype.prepareRecord = function (oneRecord) {
        for (var field in oneRecord) {
            if (oneRecord[field]) {
                oneRecord[field] = Array.isArray(oneRecord[field]) ? oneRecord[field].join('/') : oneRecord[field];
            }
            else {
                oneRecord[field] = '';
            }
        }
        return oneRecord;
    };
    CheckResultsUpdateController.prototype.buildAjaxOption = function () {
        var _this = this;
        return {
            url: '/api/admin/mysa-response-check',
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                _this.itemsLoaded = false;
                request.setRequestHeader('Authorization', "Bearer " + _this.env.user.token);
            },
            data: function (draw) {
                var dt = _this.table.dtInstance.DataTable;
                draw.sourceData = _this.checkData.db;
                if (dt && dt.context && Array.isArray(dt.context)) {
                    draw.alphabetSearch = dt.context[0].alphabetSearch;
                }
                _this.itemsLoaded = true;
            },
            dataSrc: function (data) {
                _this.itemsLoaded = true;
                _this.tableItems = data.data;
                _this.processing = false;
                _this.countData = data.data.length;
                return data.data;
            }, error: function (xhr, errorMessage, thrown) {
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve Mysa Response data from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (xhr.responseText) {
                    items.message += "<b>" + xhr.responseText + "</b>\n                    <br>Please try again, if the problem persists contact the DMT System Administrators";
                }
                else {
                    if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                        items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b><br>';
                    }
                    items.message += "<b style=\"color:red\">" + errorMessage + "/" + thrown + "</b><br><br>\n                    This is usually a temporary problem.\n                    &nbsp;Please try again, if the problem persists contact the DMT System Administrators";
                }
                _this.itemsLoaded = true;
                _this.importingExcel = false;
                $('#table_processing').hide();
            }
        };
    };
    CheckResultsUpdateController.prototype.buildLogAjaxOption = function () {
        var _this = this;
        return {
            url: '/api/admin/mysa-response-log',
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                _this.logLoaded = false;
                request.setRequestHeader('Authorization', "Bearer " + _this.env.user.token);
            },
            data: function (draw) {
                var dt = _this.tableLog.dtInstance.DataTable;
                draw.sourceData = _this.checkData.db;
                if (dt && dt.context && Array.isArray(dt.context)) {
                    draw.alphabetSearch = dt.context[0].alphabetSearch;
                }
            },
            dataSrc: function (data) {
                _this.logItems = data.data;
                _this.logLoaded = true;
                _this.processing = false;
                return data.data;
            }, error: function (xhr, errorMessage, thrown) {
                // Display message, when an error appears
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve Compliance Plan log from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (xhr.responseText) {
                    items.message += "<b>" + xhr.responseText + "</b>\n                    <br>Please try again, if the problem persists contact the DMT System Administrators";
                }
                else {
                    if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                        items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b><br>';
                    }
                    items.message += "<b style=\"color:red\">" + errorMessage + "/" + thrown + "</b><br><br>\n                    This is usually a temporary problem.\n                    &nbsp;Please try again, if the problem persists contact the DMT System Administrators";
                }
                _this.logLoaded = true;
                $('#table_processing').hide();
            }
        };
    };
    CheckResultsUpdateController.prototype.generateColumn = function (columnId, renderFn) {
        var columnName = this.columnIdName[columnId] || this.columnLogIdName[columnId];
        var orderable = true;
        return this.DTColumnBuilder
            .newColumn(columnId)
            .withOption('name', columnId)
            .withTitle(columnName ? columnName : columnId)
            .renderWith(renderFn ? renderFn : function (data) {
            return "<span class=\"columnTest\">" + data + "</span>";
        });
    };
    CheckResultsUpdateController.prototype.buildColumns = function (columnName) {
        var arr = [];
        for (var col in columnName) {
            arr.push(this.generateColumn(col));
        }
        if (columnName === this.columnIdName) {
            arr.push(this.generateColumn('Actions', this.actionButtons));
        }
        return arr;
    };
    CheckResultsUpdateController.prototype.actionButtons = function (data, type, full, meta) {
        return "\n        <md-button class=\"edit-button md-button md-ink-ripple md-2ink-ripple\" ng-click=\"vm.updateRow($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Edit\">\n                <md-icon class=\"black_icon\" md-svg-icon='edit_pen'></md-icon>\n        </md-button>\n        <md-button class=\"delete-button md-button md-ink-ripple\" ng-click=\"vm.deleteRow($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Delete\">\n                <md-icon md-svg-icon='delete'></md-icon>\n        </md-button>";
    };
    /**
       * Function to update a row in DB
    */
    CheckResultsUpdateController.prototype.updateRow = function (event, rowId) {
        var _this = this;
        var result = this.extractCountry();
        var tit = 'Update Mysa Response record';
        var orgContent = {};
        Object.keys(this.columnIdName).forEach(function (element) {
            orgContent[element] = _this.tableItems[rowId][element];
        });
        var updatedData = {
            icon: 'QUESTION',
            message: 'Are you sure, you want to update a new record to existing list?',
            tree: result.tree,
            iots: Object.keys(result.tree).sort(),
            imts: result.imts,
            orgContent: orgContent,
            content: this.tableItems[rowId],
            cmrArr: CMR_ARR,
            listIOTs: function (tree) { return Object.keys(tree).sort(); },
            listIMTs: function (tree, iot, imt) {
                return Object.keys(tree[iot] || {}).sort();
            },
            listCountries: function (tree, iot, imt) {
                return tree[iot] ? tree[iot][imt] : DEFAULT_SELECTION;
            },
            yesNoArr: YES_NO_ARR,
            arrayNA: NA_ARR,
            respArr: RESP_ARR,
            taArr: TA_ARR,
            drArr: DR_GOE_ARR,
            cdArr: CD_ARR,
            solutionArr: YES_NO_ARR,
            mysaArr: MYSA_DUP,
            scArr: SC_DUP,
            ncArr: NC,
            solArr: SOLUTION_ARR,
            incGoeResp: RESP_INC_GOE_ARR,
            incArr: INCENTIVES_GOE_ARR,
            cdResp: CD_RESP,
            specBidResp: SPEC_BID_RESP,
            cvrSSAResp: CVR_SSA_RESP,
            codeResp: CODE_RESP,
            table: this.checkData.db
        };
        this.Dialog.updateValidForm(event, updatedData, this.TEMPLATE_CONFIRM)
            .then(function (dResult) {
            if (!dResult.confirm) {
                return;
            }
            _this.Dialog.updateValidForm(event, updatedData, 'mysaresponse-edit.html')
                .then(function (dResult) {
                dResult.mdTextContent.table = _this.checkData.db;
                var content = dResult.mdTextContent;
                for (var field in content) {
                    if (content[field]) {
                        content[field] = Array.isArray(content[field]) ? content[field].join('/') : content[field];
                    }
                    else {
                        content[field] = '';
                    }
                }
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: content,
                        originalData: dResult.orgContent,
                        table: _this.checkData.db,
                        email: _this.env.user.email,
                        function: 'updateRecord',
                        scopeBack: _this.scopeUpdateRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token
                    }
                });
            });
        });
    };
    /**
     * Function to extract country
     */
    CheckResultsUpdateController.prototype.extractCountry = function () {
        var result = this.settings.country_list.filter(function (el) { return el.ic === 'Country'; }).reduce(function (r, country) {
            r.tree[country.imt] = r.tree[country.imt] || {};
            r.tree[country.imt][country.imt_name] = r.tree[country.imt][country.imt_name] || [];
            r.tree[country.imt][country.imt_name].push(country.country);
            r.tree[country.imt][country.imt_name].sort();
            r.imts[country.imt] = r.imts[country.imt] || [];
            r.imts[country.imt].push(country.imt_name);
            r.imts[country.imt] = _.uniq(r.imts[country.imt]);
            r.imts[country.imt].sort();
            return r;
        }, { tree: {}, imts: {} });
        return result;
    };
    /**
     * Function to handle all errors
     */
    CheckResultsUpdateController.prototype.isIncomingErrors = function (data) {
        if (data && data.error) {
            if (data.error.validationErrors.length || data.error.errors.length) {
                return true;
            }
        }
        else {
            return false;
        }
    };
    /**
     * Function to show all errors
     */
    CheckResultsUpdateController.prototype.handleIncomingErrors = function (data, name) {
        var allErrorsInfo = {
            allErrors: data,
            windowName: name
        };
        this.Dialog.showingErrors(event, allErrorsInfo, 'showing-errors.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
        return;
    };
    // tslint:disable-next-line:typedef
    CheckResultsUpdateController.prototype.openActionMenu = function ($mdOpenMenu, event) {
        $mdOpenMenu(event);
    };
    CheckResultsUpdateController.$inject = [
        'settings',
        'env',
        '$compile',
        '$filter',
        'socket',
        '$scope',
        'Dialog',
        'notify',
        'DTOptionsBuilder',
        'DTColumnBuilder',
        'DTColumnDefBuilder'
    ];
    return CheckResultsUpdateController;
}());
var CheckResultsUpdateComponent = (function () {
    function CheckResultsUpdateComponent() {
        this.templateUrl = 'checkupdate.html';
        this.controllerAs = 'vm';
        this.bindings = bindCheck;
        this.controller = CheckResultsUpdateController;
    }
    return CheckResultsUpdateComponent;
}());
angular
    .module('application')
    .component('checkResultsUpdate', new CheckResultsUpdateComponent());



var MysaResponseLogColumnIdName = {
    ACTION_TIMESTAMP: 'Time',
    ACTIONS_COMMENT: 'Changes made',
    USER_EMAIL: ' Changed by'
};
var ValueAchievedColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    BPA: 'BPA',
    TA: 'TA',
    VALUE: 'Value',
    RESPONSE: 'Value Achieved Response',
    RESPONSE_CODE: 'Reason Code'
};
var BPAuthorizationColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    BPA: 'BPA',
    TA: 'TA',
    RESPONSE: 'BP Authorization Response',
    RESPONSE_CODE: 'Reason Code'
};
var CVRSolutionColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    BPA: 'BPA',
    TA: 'TA',
    VALUE: 'Value',
    CMR: 'CMR',
    SOLUTION: 'Solution',
    RESPONSE: 'CVR Solution response',
    RESPONSE_CODE: 'Reason Code'
};
var CVRNCColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    BPA: 'BPA',
    TA: 'TA',
    MYSA_DUP: 'MySa Dup',
    CD: 'CD',
    NC: 'NC',
    DR_GOE: 'DR GOE',
    INC_GOE: 'Incentives GOE',
    VALUE: 'Value',
    CMR: 'CMR',
    RESPONSE: 'CVR New Client response',
    RESPONSE_CODE: 'Reason Code'
};
var CVRSSAColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    BPA: 'BPA',
    TA: 'TA',
    MYSA_DUP: 'MySa Dup',
    SC_DUP: 'SC Dup',
    DR_GOE: 'DR GOE',
    INC_GOE: 'Incentives GOE',
    VALUE: 'Value',
    CMR: 'CMR',
    RESPONSE: 'CVR SSA response',
    RESPONSE_CODE: 'Reason Code'
};
var dupColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    BPA: 'BPA',
    TA: 'TA',
    MYSA_DUP: 'MySa Dup',
    DR_GOE: 'DR GOE',
    VALUE: 'Value',
    CMR: 'CMR',
    RESPONSE: 'Duplicate Check response',
    RESPONSE_CODE: 'Reason Code'
};
var BidColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    BPA: 'BPA',
    TA: 'TA',
    MYSA_DUP: 'MySa Dup',
    DR_GOE: 'DR GOE',
    VALUE: 'Value',
    CMR: 'CMR',
    RESPONSE: 'Special Bid response',
    RESPONSE_CODE: 'Reason Code'
};
var CDColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    CMR: 'CMR',
    CD: 'CD',
    RESPONSE: 'Customer Designation response',
    RESPONSE_CODE: 'Reason Code'
};
var IncGOEColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    CMR: 'CMR',
    INC_GOE: 'Incentives GOE',
    RESPONSE: 'Incentives GEO response',
    RESPONSE_CODE: 'Reason Code'
};
var MysaresponseViewController = (function () {
    function MysaresponseViewController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin, config, settings) {
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.config = config;
        this.settings = settings;
        this.table = {};
        this.editMode = false;
        this.checkResults = [
            {
                name: 'BP Authorization',
                db: 'BP_AUTH',
                columnIdName: BPAuthorizationColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'Value Achieved Configuration',
                db: 'VALUE_ACHIEVED',
                columnIdName: ValueAchievedColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'CVR Solution Configuration',
                db: 'CVR_SOLUTION',
                columnIdName: CVRSolutionColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'Customer Designation Configuration',
                db: 'CD',
                columnIdName: CDColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'CVR New Client Configuration',
                db: 'CVR_NC',
                columnIdName: CVRNCColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'Special Bid Configuration',
                db: 'SPEC_BID',
                columnIdName: BidColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'CVR SSA Configuration',
                db: 'CVR_SSA',
                columnIdName: CVRSSAColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'Incentives GOE Configuration',
                db: 'INC_GOE',
                columnIdName: IncGOEColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'Duplicate Found Configuration',
                db: 'DUP',
                columnIdName: dupColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
        ];
        this.table.headers = [{
                'Main Status': '_link',
                'Description': 'desc'
            }];
    }
    MysaresponseViewController.prototype.updateCheckData = function (check) {
        var _this = this;
        this.editMode = true;
        this.checkResults.forEach(function (el) {
            if (check === el.name) {
                _this.selectedCheckData = el;
            }
        });
    };
    MysaresponseViewController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket',
        '$scope', 'admin', 'config', 'settings'];
    return MysaresponseViewController;
}());
var MysaresponseViewComponent = (function () {
    function MysaresponseViewComponent() {
        this.templateUrl = 'mysaresponse-view.html';
        this.controllerAs = 'vm';
        this.controller = MysaresponseViewController;
    }
    return MysaresponseViewComponent;
}());
angular
    .module('application')
    .component('viewMysaresponseSection', new MysaresponseViewComponent());



var ProgramEditController = (function () {
    function ProgramEditController(env, $filter, DTS, $stateParams, $state, socket, $scope, config, admin, $timeout, Dialog, $q, settings) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.config = config;
        this.admin = admin;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.$q = $q;
        this.settings = settings;
        this.id = '';
        this.original = { _id: '' }; //for future logging reference at save time
        this.select = {
            countries: {}, brands: {}, bp_types: {}, hasPreApproval: false,
            preapproval: { stages: {}, stages_ordered: [], stages_ordered_text: [] },
            approval: { stages: {}, stages_ordered: [], stages_ordered_text: [] }
        };
        this.selectValid = false;
        this.valid = { approval: false, preapproval: false };
        this.readyMan = false;
        this.appProcesses = ['approval', 'preapproval'];
        this.newProfile = false;
        this.events = { beingSaved: false, beingDeleted: false };
        this.combinations = 0;
        this.conflicts = {
            keys: false, profile_id: '', viewDetails: false, resolved: false
        };
        this.serverError = null;
        this.id = $stateParams.id;
        this.socket.forward('config.program_by_name', this.$scope);
        this.$scope.$on('socket:config.program_by_name', function (event, data) {
            _this.$timeout(function () {
                _this.setProgramData(data);
            }, 1000); //hmm..naughty
        });
    }
    ProgramEditController.prototype.newLine = function (index, cols) {
        if (index % cols === 0) {
            return true;
        }
        else {
            return false;
        }
    };
    ProgramEditController.prototype.setProgramData = function (data) {
        this.editing = data;
        angular.copy(data, this.original); //for logging etc
        this.select.countries = this.prepareCountries(this.editing.imt);
        this.select.brands = this.prepareGenerals('brands');
        this.select.bp_types = this.prepareGenerals('bp_types');
        this.prepareAppStages('approval', 5);
        this.prepareAppStages('preapproval', 2);
        this.select.approval.stages_ordered = this.editing.approval_stages;
        this.select.preapproval.stages_ordered = this.editing.preapproval_stages;
        this.setCombinations();
        this.readyMan = true;
    };
    ProgramEditController.prototype.removeConflicts = function () {
        var _this = this;
        var tempEditCty = [];
        angular.copy(this.editing.countries, tempEditCty); //Create copy to loop through since original will change
        //All I can think to do here is remove the offending countries from selection
        angular.forEach(tempEditCty, function (cty) {
            angular.forEach(_this.conflicts.details, function (dupe) {
                if (dupe.cty === cty) {
                    _this.editing.countries.splice(_this.editing.countries.indexOf(cty), 1); //remove from short array
                    //Loop through selected array and set to false
                    angular.forEach(_this.select.countries, function (value, key) {
                        if (key === cty) {
                            _this.select.countries[key] = false;
                        }
                    });
                }
            });
        });
        this.sync('countries');
        this.conflicts.resolved = true;
    };
    ProgramEditController.prototype.conflictsFound = function (data) {
        var _this = this;
        this.conflicts.keys = true; //Set flag to show conflict on keys
        this.conflicts.details = data.data; //set the data
        this.conflicts.headers = [{
                'Profile ID': 'profile_id', 'Brand': 'brand', 'BP Type': 'bp_type',
                'Abbr': 'cty', 'Country Name': 'country'
            }];
        //Loop through and update the country names for display
        angular.forEach(this.settings.country_list, function (cty) {
            if (cty.imt === _this.editing.imt) {
                //if (cty.imt === 'Europe IOT') {
                angular.forEach(_this.conflicts.details, function (dupe) {
                    if (cty.short === dupe.cty) {
                        dupe.country = cty.country;
                    }
                });
            }
        });
    };
    ProgramEditController.prototype.iotChange = function () {
        this.select.countries = {};
        this.sync('countries');
    };
    ProgramEditController.prototype.syncAppStages = function (stageNo, appProcess, appPN) {
        var currentIndexNo = this.select[appProcess].stages_ordered.indexOf(stageNo);
        //check if that stage is in the ordered list or not
        if (currentIndexNo > -1) {
            //If so, assume it needs deleting
            this.select[appProcess].stages_ordered.splice(currentIndexNo, 1);
            this.select[appProcess].stages_ordered_text.splice(currentIndexNo, 1);
        }
        else {
            //If not, add it to the end..
            this.select[appProcess].stages_ordered.push(stageNo);
            this.select[appProcess].stages_ordered_text.push(this.config.getSubStatusBySubStatusNo2(appPN, stageNo).txt);
        }
        this.areApprovalsValid();
    };
    ProgramEditController.prototype.sync = function (field) {
        var _this = this;
        var ignore = ['preapproval', 'approval'];
        var newArray = [];
        angular.forEach(this.select[field], function (value, key) {
            if (value && ignore.indexOf(key) === -1) {
                newArray.push(key);
            }
        });
        this.editing[field] = newArray;
        var sv = 0;
        angular.forEach(this.select, function (value, key) {
            if (ignore.indexOf(key) && angular.isDefined(_this.editing[key]) && _this.editing[key].length > 0) {
                sv++;
            }
        });
        if (sv !== 3) {
            this.selectValid = false;
        }
        else {
            this.selectValid = true;
        }
        this.setCombinations();
    };
    ProgramEditController.prototype.prepareCountries = function (imt) {
        var _this = this;
        var newCountries = {};
        angular.forEach(this.settings.country_list, function (cty) {
            if (cty.imt === imt && _this.editing.countries.indexOf(cty.short) > -1) {
                newCountries[cty.short] = true;
            }
        });
        return newCountries;
    };
    ProgramEditController.prototype.prepareGenerals = function (field) {
        var _this = this;
        var newObject = {};
        angular.forEach(this.settings[field], function (x) {
            if (_this.editing[field].indexOf(x) > -1) {
                newObject[x] = true;
            }
        });
        return newObject;
    };
    ProgramEditController.prototype.getAppStages = function (appStage) {
        var stages = 'approval_stages';
        if (appStage === 'preapproval') {
            stages = 'preapproval_stages';
        }
        return stages;
    };
    ProgramEditController.prototype.prepareAppStages = function (appProcess, appPN) {
        var _this = this;
        var newStages = {};
        angular.forEach(this.config.getSubStatusesByMainStatusNo(appPN), function (stage) {
            if (_this.editing[_this.getAppStages(appProcess)].indexOf(stage.no) > -1) {
                newStages[stage.no] = true;
            }
        });
        this.select[appProcess].stages = newStages;
        var newStages_Text = [];
        angular.forEach(this.editing[this.getAppStages(appProcess)], function (stage) {
            var stg = _this.config.getSubStatusBySubStatusNo2(appPN, stage);
            if (stg !== null) {
                newStages_Text.push(_this.config.getSubStatusBySubStatusNo2(appPN, stage).txt);
            }
        });
        this.select[appProcess].stages_ordered_text = newStages_Text;
        if (newStages_Text.length > 0 && appPN === 2) {
            this.select.hasPreApproval = true;
        }
    };
    /**
      confirmDelete - Ask user to confirm if they wanna delete or not...just incase they click by mistake
      @param {IAngularEvent} event   event
      @returns void
    */
    ProgramEditController.prototype.confirmDelete = function (event) {
        var _this = this;
        var items = {
            title: 'Delete Program Profile',
            message: 'Are you sure you want to Delete this Program Profile?',
            icon: 'QUESTION'
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.delete(event);
            }
        });
    };
    ProgramEditController.prototype.delete = function (event) {
        var _this = this;
        this.events.beingDeleted = true;
        this.serverError = null;
        //Make the call via a promise which will wait up to 30 seconds for a response
        this.deletePromise().then(function (data) {
            //If response from server received
            _this.events.beingDeleted = false; //enable again
            if (data.error) {
                _this.serverError = data.error;
            }
            else {
                _this.admin.navigate('admin.program-view');
            }
        }, function (nothingReturnedInTime) {
            //If no response from server received
            _this.events.beingSaved = false; //enable save again
            _this.serverError = 'The server does not appear to be responding, or did not respond in a reasonable time.';
        });
    };
    ProgramEditController.prototype.setCombinations = function () {
        var _this = this;
        var count = 0;
        angular.forEach(this.editing.countries, function (cty) {
            angular.forEach(_this.editing.brands, function (brand) {
                angular.forEach(_this.editing.bp_types, function (bp) {
                    count++;
                });
            });
        });
        this.combinations = count;
    };
    /**
     * save - Function triggered when user clicks the Save button.
     *
     * @param  {type} event: any Browser event for the benefit of the display prompts (if needed)
     */
    ProgramEditController.prototype.save = function (event) {
        var _this = this;
        this.events.beingSaved = true; //set flag to disable save button
        this.serverError = null;
        this.conflicts = {}; //reset conflicts
        /*
        Removed since the main status flow is now under the Program Profile - it is assumed (yikes!) that the main
        status flow for a Program will be the same worldwide!
                if (this.newProfile) {
        
                    //If new profile, set the status flow
                    let statusflow: any = [1, 3, 4, 5, 6, 7, 8];
                    if (this.editing.preapproval_stages.length > 0) {
                        statusflow = [1, 2, 3, 4, 5, 6, 7, 8];
                    }
        
                    this.editing.status_flow = statusflow;
        
                }
                */
        //Make the call via a promise which will wait up to 30 seconds for a response
        this.savePromise().then(function (data) {
            //If response from server received
            _this.events.beingSaved = false; //enable save again
            if (data.error) {
                if (data.error.indexOf('Duplicates') > -1) {
                    _this.conflictsFound(data);
                }
                else if (data.error.indexOf('Conflicting Profile') > -1) {
                    _this.conflicts.profile_id = _this.editing.profile_id;
                }
                else {
                    _this.serverError = data.error;
                }
            }
            else {
                _this.admin.navigate('admin.program-view');
            }
        }, function (nothingReturnedInTime) {
            //If no response from server received
            _this.events.beingSaved = false; //enable save again
            _this.serverError = 'The server does not appear to be responding, or did not respond in a reasonable time.';
        });
    };
    ProgramEditController.prototype.$onInit = function () {
        //this.admin.getCountryConfig();
        //this.admin.getGeneralConfig();
        var _this = this;
        if (this.id !== '') {
            //Get details
            this.admin.getProgramProfileByName(this.id);
            this.selectValid = true;
            this.valid = { approval: true, preapproval: true };
        }
        else {
            this.newProfile = true;
            this.editing = { countries: [], type: 'program3', onshore_offshore: '' };
            angular.forEach(this.appProcesses, function (appProcess) {
                _this.editing[_this.getAppStages(appProcess)] = [];
                _this.select[appProcess].stages_ordered = _this.editing[_this.getAppStages(appProcess)]; //this binds the two somehow!
                _this.select[appProcess].stages_ordered_text = [];
            });
            this.readyMan = true;
        }
    };
    ProgramEditController.prototype.selectAll = function (tf) {
        var _this = this;
        if (!tf) {
            this.select.countries = {};
        }
        else {
            angular.forEach(this.settings.country_list, function (cty) {
                if (cty.imt === _this.editing.imt && cty.ic === 'Country') {
                    _this.select.countries[cty.short] = true;
                }
            });
        }
        this.sync('countries');
    };
    ProgramEditController.prototype.areApprovalsValid = function () {
        var _this = this;
        var appProcesses = ['approval', 'preapproval'];
        angular.forEach(this.appProcesses, function (appProcess) {
            //Set form validity
            if (_this.select[appProcess].stages_ordered.length > 0) {
                _this.valid[appProcess] = true;
            }
            else {
                _this.valid[appProcess] = false;
                if (appProcess === 'preapproval' && !_this.select.hasPreApproval) {
                    _this.valid[appProcess] = true; //actually ok
                }
            }
        });
    };
    ProgramEditController.prototype.wipeApprovals = function (appProcess) {
        var _this = this;
        angular.forEach(this.select[appProcess].stages, function (value, key) {
            _this.select[appProcess].stages[key] = false;
        });
        this.editing[this.getAppStages(appProcess)] = [];
        this.select[appProcess].stages_ordered = this.editing[this.getAppStages(appProcess)]; //this binds the two somehow!
        this.select[appProcess].stages_ordered_text = [];
        this.areApprovalsValid();
    };
    ProgramEditController.prototype.selectAll2 = function (tf, field) {
        var _this = this;
        if (!tf) {
            this.select[field] = {};
        }
        else {
            //angular.forEach(this.admin.general[field], (x) => {
            angular.forEach(this.settings[field], function (x) {
                _this.select[field][x] = true;
            });
        }
        this.sync(field);
    };
    ProgramEditController.prototype.displayPrompt = function (event, bundle, icon) {
        var items = {
            title: bundle.title,
            message: bundle.textContent,
            icon: icon //ERROR, INFO, WARN
        };
        this.Dialog.openDialog(event, items, DialogService, 'confirm-prompt.html');
    };
    ProgramEditController.prototype.savePromise = function () {
        var _this = this;
        this.deferred = this.$q.defer(); //Set deferred object...to be sent to browser
        this.$timeout(function () {
            _this.deferred.reject([]); //If not resolved within 3 seconds...reject
        }, 30000); //30 secs
        this.admin.updateAdminProfile(this.editing);
        this.socket.forward('config.admin_update', this.$scope);
        this.$scope.$on('socket:config.admin_update', function (event, data) {
            _this.deferred.resolve(data); //add the results to the deferred object
            //Once done saving, send email to Admin team
            var emailBundle = { docurl: 'program/' + _this.id, profile: 'Program Workflow Profile (' + _this.editing.profile_id + ')', user: _this.env.user };
            _this.admin.sendAdminUpdate(emailBundle);
        });
        return this.deferred.promise; //fire off the promise
    };
    ProgramEditController.prototype.deletePromise = function () {
        var _this = this;
        this.deferred = this.$q.defer(); //Set deferred object...to be sent to browser
        this.$timeout(function () {
            _this.deferred.reject([]); //If not resolved within 3 seconds...reject
        }, 30000); //30 secs
        var delPackage = { _id: this.editing._id, _rev: this.editing._rev, profile_id: this.editing.profile_id };
        this.admin.deleteAdminProfile(delPackage);
        this.socket.forward('config.admin_delete', this.$scope);
        this.$scope.$on('socket:config.admin_delete', function (event, data) {
            _this.deferred.resolve(data); //add the results to the deferred object
        });
        return this.deferred.promise; //fire off the promise
    };
    ProgramEditController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state',
        'socket', '$scope', 'config', 'admin', '$timeout', 'Dialog', '$q', 'settings'];
    return ProgramEditController;
}());
var ProgramEditComponent = (function () {
    function ProgramEditComponent() {
        this.templateUrl = 'program.html';
        this.controllerAs = 'vm';
        this.controller = ProgramEditController;
    }
    return ProgramEditComponent;
}());
angular
    .module('application')
    .component('adminProgramSection', new ProgramEditComponent());



var ProgramViewController = (function () {
    function ProgramViewController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.table = { sortType: '_link', sortReverse: false, search: '', filter: false, filterParams: {} };
        this.programs = [];
        this.programsLoaded = false;
        this.table.headers = [{
                'Profile ID': '_link', 'Program': 'program', 'IOT': 'imt', 'Countries': 'countries',
                'Brands': 'brands', 'BP Types': 'bp_types'
            }];
        this.socket.forward('config.program_summary', this.$scope);
        this.$scope.$on('socket:config.program_summary', function (event, data) {
            _this.programs = data;
            _this.programsLoaded = true;
        });
    }
    ProgramViewController.prototype.prepLink = function (value, link) {
        var split = value.split('|');
        if (link) {
            return split[0];
        }
        else {
            return split[1]; //Name
        }
    };
    ProgramViewController.prototype.$onInit = function () {
        this.admin.getSummaryProgramProfiles();
    };
    ProgramViewController.prototype.resetFilters = function () {
        delete this.table.filters;
        this.table.filterParams = {};
    };
    ProgramViewController.prototype.createNew = function () {
        this.$state.go('admin.program', 'new');
    };
    ProgramViewController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'admin'];
    return ProgramViewController;
}());
var ProgramViewComponent = (function () {
    function ProgramViewComponent() {
        this.templateUrl = 'program-view.html';
        this.controllerAs = 'vm';
        this.controller = ProgramViewController;
    }
    return ProgramViewComponent;
}());
angular
    .module('application')
    .component('viewProgramSection', new ProgramViewComponent());



var adminreportingTableBind = { table: '=', data: '=' };
var AdminreportingTableController = (function () {
    function AdminreportingTableController($state, settings, env, socket, $scope, Dialog, admin) {
        this.$state = $state;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.admin = admin;
        switch (this.table) {
            case 0:
                this.headers = 'Looser Country,Looser ID,Looser CEID,Winner Country,Winner ID,Winner CEID,Effective Date,Expiry Date'.split(',');
                this.columns = 'LS_COUNTRY,LS_PARTNER_ID,LS_PARTNER_CEID,WN_COUNTRY,WN_PARTNER_ID,WN_PARTNER_CEID,EFF_DATE,EXP_DATE'.toUpperCase().split(',');
                break;
            default:
                this.headers = [];
                this.columns = [];
                break;
        }
    }
    AdminreportingTableController.$inject = ['$state', 'settings', 'env', 'socket', '$scope', 'Dialog', 'admin'];
    return AdminreportingTableController;
}());
var AdminreportingTableComponent = (function () {
    function AdminreportingTableComponent() {
        this.bindings = adminreportingTableBind;
        this.templateUrl = 'adminreporting-table-view.html';
        this.controllerAs = 'vm';
        this.controller = AdminreportingTableController;
    }
    return AdminreportingTableComponent;
}());
angular
    .module('application')
    .component('adminreportingTableSection', new AdminreportingTableComponent());



var AdminreportingController = (function () {
    function AdminreportingController($state, settings, env, socket, $scope, Dialog, admin, notify) {
        var _this = this;
        this.$state = $state;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.admin = admin;
        this.notify = notify;
        this.tables = ['Merger'];
        this.isSaving = false;
        this.selectedTable = 0;
        this.dataLoaded = false;
        this.socket.forward('admin.reporting.query', this.$scope);
        this.$scope.$on('socket:admin.reporting.query', function (event, data) {
            _this.dataLoaded = true;
            if (data.error) {
                return _this.notify.error("Unable to load table data => " + data.error);
            }
            _this.data = data.data;
        });
    }
    AdminreportingController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    table: this.selectedTable
                },
                function: 'getReportingData',
                script: 'admin/calculationtables',
                token: this.env.user.token
            }
        });
    };
    AdminreportingController.prototype.switchTable = function () {
        this.dataLoaded = false;
        this.data = undefined;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    table: this.selectedTable
                },
                function: 'getReportingData',
                script: 'admin/calculationtables',
                token: this.env.user.token
            }
        });
    };
    AdminreportingController.$inject = ['$state', 'settings', 'env', 'socket', '$scope', 'Dialog', 'admin', 'notify'];
    return AdminreportingController;
}());
var AdminreportingComponent = (function () {
    function AdminreportingComponent() {
        this.templateUrl = 'adminreporting-view.html';
        this.controllerAs = 'vm';
        this.controller = AdminreportingController;
    }
    return AdminreportingComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('delete', '/public/icons/delete-forever.svg')
        .icon('invalid', '/public/icons/ic_highlight_off_black_24px.svg')
        .icon('save', '/public/images/ic_save_black_24px.svg');
})
    .component('viewAdminreportingSection', new AdminreportingComponent());



var SamplingViewController = (function () {
    function SamplingViewController(env, $filter, $stateParams, $state, socket, $scope, settings, admin, Dialog, config) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.settings = settings;
        this.admin = admin;
        this.Dialog = Dialog;
        this.config = config;
        this.table = { filters: { cty: '' }, visible: 0 };
        this.rates = [{ k: 'rev0to25', v: '0 - 25 K' }, { k: 'rev25to50', v: '25 - 50 K' }, { k: 'rev50to100', v: '50 - 100 K' }, { k: 'rev100to500', v: '100 - 500 K' }, { k: 'rev500to1000', v: '500 - 1000 K' }, { k: 'rev1000andUp', v: 'over 1000 K' }];
        this.events = { beingSaved: false, serverErrors: undefined, viewBase: false };
        this.alphabet = { full: 'abcdefghijklmnopqrstuvwxyz'.toUpperCase().split(''), act: [], selected: '' };
        this.countriesLoaded = false;
        this.sourceLoaded = false;
        //        this.gmuList = [{ value: 'Y', text: 'Yes' }, { value: 'N', text: 'No' }];
        this.riskLevelList = [{ value: 'highRisk', text: 'High Risk' }, { value: 'lowStRisk', text: 'Low/Std Risk' }];
        this.samplingRateList = [{ value: 'baseline', text: 'Baseline' }, { value: 'lowFrequency', text: 'Low Frequency' }, { value: 'highFrequency', text: 'High Frequency' }];
        // Listener for successfully saved the country profile
        this.socket.forward('samplingview.ctySamplingSave', this.$scope);
        this.$scope.$on('socket:samplingview.ctySamplingSave', function (event, data) {
            _this.events.beingSaved = false; // turn off the being saved flag
            if (data.err) {
                // Update errors section for user
                _this.events.serverErrors = data.err;
            }
        });
        // Listener for successfully saved the base profile
        this.socket.forward('samplingview.baseSamplingSave', this.$scope);
        this.$scope.$on('socket:samplingview.baseSamplingSave', function (event, data) {
            _this.events.beingSaved = false; // turn off the being saved flag
        });
        // Listener for initial pull for countries
        this.socket.forward('samplingview.getCtySampling', this.$scope);
        this.$scope.$on('socket:samplingview.getCtySampling', function (event, data) {
            _this.prepareCtyForEdit(data); // Prepare the data for display
            _this.samplingCountries = data; // dump it
            _this.activateLetter('A'); // set index to A
            _this.countriesLoaded = true; // set flag to show
        });
        // Listener for source/base data
        this.socket.forward('samplingview.getSourceSampling', this.$scope);
        this.$scope.$on('socket:samplingview.getSourceSampling', function (event, data) {
            _this.prepareBaseForEdit(data.ratingSource);
            _this.riskSamplingSource = data.ratingSource;
            _this.sourceLoaded = true;
        });
    }
    /**
     * Function for when a letter is clicked on the index list
     * @param letter
     */
    SamplingViewController.prototype.activateLetter = function (letter) {
        var _this = this;
        if (this.alphabet.act.indexOf(letter) < 0) {
            return; // do nothing...
        }
        this.alphabet.selected = letter;
        this.table.visible = 0;
        angular.forEach(this.samplingCountries, function (samp) {
            if (samp.cty.substring(0, 1).toUpperCase() === letter.toUpperCase()) {
                samp.show = true;
                _this.table.visible++;
            }
            else {
                samp.show = false;
            }
        });
    };
    /**
     * Function to generate a country setting for all countries that do not have a Sampling entry
     */
    SamplingViewController.prototype.createMissingCountries = function (event) {
        var _this = this;
        var count = 0;
        var tit = 'Create Missing Countries';
        var items = {
            icon: 'QUESTION',
            message: 'Use this option to create profile for all countries that are not listed below. &nbsp;Continue?',
            title: tit
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                // Get array of the shortnames
                var shortNames_1 = _this.samplingCountries.map(function (sampCty) {
                    if (sampCty.cc) {
                        return sampCty.cc; // Pull country name
                    }
                    else {
                        // If no country code, add it
                        sampCty.cc = _this.config.getCountryByName(sampCty.cty);
                        return sampCty.cc;
                    }
                });
                angular.forEach(_this.settings.country_list, function (cty) {
                    // If entry is a country (and not IOT/IMT) and name is not already listed
                    if (cty.ic === 'Country' && shortNames_1.indexOf(cty.cc) < 0) {
                        // Create entry for country
                        _this.samplingCountries.push(_this.getNewCtry(cty.country, cty.short));
                        count++;
                    }
                });
                var mess = count > 0 ? '<b>' + count + '</b> new Countries added.  Please update the necessary fields.' : 'All Countries already have a Sampling Profile';
                items = {
                    icon: 'INFO',
                    message: mess,
                    title: tit
                };
                _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (whatevs) { return; });
            }
        });
    };
    /**
     * Function to delete all periods in the country list whose end date is in the past
     * @param event
     */
    SamplingViewController.prototype.massDeleteExpired = function (event) {
        var _this = this;
        var count = 0;
        var tit = 'Mass Delete All Expired Periods';
        var items = {
            icon: 'QUESTION',
            message: 'Use this option to mass delete all Country Periods whose range is in the past.' +
                '<p><p><b>NOTE: &nbsp;</b>Only Countries with more than one Period will be checked. &nbsp;Continue?',
            title: tit
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                var today_1 = new Date().getTime();
                angular.forEach(_this.samplingCountries, function (cty) {
                    var newp = [];
                    // Only consider if more than one period
                    if (cty.periods.length > 1) {
                        for (var _i = 0, _a = cty.periods; _i < _a.length; _i++) {
                            var period = _a[_i];
                            // If the end date is less than today...
                            var pdate = new Date(period.edate_dp);
                            if (pdate.getTime() < today_1) {
                                count++;
                            }
                            else {
                                newp.push(period);
                            }
                        }
                        // If there are valid ones
                        if (newp.length > 0) {
                            cty.periods = newp; // Replace with valid ones
                        }
                        else {
                            cty.periods = [cty.periods[cty.periods.length - 1]];
                            count--;
                        }
                    }
                });
                var mess = count > 0 ? '<b>' + count + '</b> expired Periods successfully deleted. &nbsp;Remember to Save.' : 'There are no expired Periods to be deleted.';
                items = {
                    icon: 'INFO',
                    message: mess,
                    title: tit
                };
                _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (whatevs) { return; });
            }
        });
    };
    /**
     * Function to add a new entry to every country based on the last one...but a year on
     * @param event
     */
    SamplingViewController.prototype.massUpdateAdd = function (event) {
        var _this = this;
        var count = 0;
        var tit = 'Mass Update New Periods';
        var items = {
            icon: 'QUESTION',
            message: 'Use this option to add a new Period for every country en-masse. &nbsp;The new Period\'s Start and End Date will be a year on from the last. &nbsp;Continue?',
            title: tit
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                angular.forEach(_this.samplingCountries, function (cty) {
                    _this.createPeriod(cty);
                    count++;
                });
                items = {
                    icon: 'INFO',
                    message: '<b>' + count + '</b> new Periods successfully added.',
                    title: tit
                };
                _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (whatevs) { return; });
            }
        });
    };
    /**
     * Function to prepare the server data for display, ie: convert timestamps to Dates etc
     * @param ctryData
     */
    SamplingViewController.prototype.prepareCtyForEdit = function (ctryData) {
        var _this = this;
        angular.forEach(ctryData, function (ctry) {
            // Set the date-pickers up
            angular.forEach(ctry.periods, function (period) {
                period.sdate_dp = new Date(period.sdate);
                period.edate_dp = new Date(period.edate);
                period.finalRates = _this.convertRates(period.finalRates);
            });
            // Fix the index
            if (_this.alphabet.act.indexOf(ctry.cty.substring(0, 1).toUpperCase()) < 0) {
                _this.alphabet.act.push(ctry.cty.substring(0, 1).toUpperCase());
            }
            _this.alphabet.act.sort();
        });
    };
    /**
     * Function to prepare the server data for display, ie: numbers to full numbers
     * @param baseData
     */
    SamplingViewController.prototype.prepareBaseForEdit = function (baseData) {
        var _this = this;
        angular.forEach(baseData, function (base) {
            angular.forEach(base, function (risk) {
                angular.forEach(risk, function (v, k) {
                    risk[k] = _this.convertRate(v);
                });
            });
        });
    };
    SamplingViewController.prototype.$onInit = function () {
        this.admin.getAllCtySamples(); // Get the country data
        this.admin.getBaseSamples(); // Get the base data
    };
    /**
     * Function fired when user clicks save for country data
     */
    SamplingViewController.prototype.saveCountryData = function () {
        this.events.beingSaved = true; // Set flag to disable buttons
        delete this.events.serverErrors; // Delete any previous errors
        this.admin.updateAllCtySamples(this.samplingCountries); // Make call to server
    };
    /**
     * Function fired when user clicks save for base data
     */
    SamplingViewController.prototype.saveBaseData = function () {
        this.events.beingSaved = true; // Set flag to disable buttons
        this.admin.updateBaseSamples(this.riskSamplingSource); // Make call to server
    };
    /**
     * Function to refesh the country profiles should the base rates change
     * @param samp
     * @param risk
     * @param rate
     */
    SamplingViewController.prototype.baseChange = function (samp, risk, rate) {
        var _this = this;
        angular.forEach(this.samplingCountries, function (cty) {
            angular.forEach(cty.periods, function (period) {
                // If we have a match
                if (period.riskLevel === risk && period.samplingRate === samp) {
                    if (period.override) {
                        // If it's overriden, lose the override details
                        if (_this.riskSamplingSource[samp][risk][rate] === period.finalRates[rate]) {
                            delete period.override;
                        }
                    }
                    else {
                        period.finalRates[rate] = _this.riskSamplingSource[samp][risk][rate]; // Overwrite
                    }
                }
            });
        });
    };
    SamplingViewController.prototype.getCurrentPeriod = function () {
        // Set dates based on today's date...if in 2018... set as 1st Jan to 31st Dec
        var pds = {};
        var sd = new Date();
        var ed = new Date();
        sd.setFullYear(new Date().getFullYear(), 0, 1);
        ed.setFullYear(new Date().getFullYear(), 11, 31);
        pds.sd = sd;
        pds.ed = ed;
        return pds;
    };
    /**
     * Function to create a new country object with a single period
     * @param name
     * @param short
     */
    SamplingViewController.prototype.getNewCtry = function (name, short) {
        var dates = this.getCurrentPeriod();
        var cty = {
            cty: name,
            cc: short,
            periods: [
                {
                    GMU: '',
                    sdate: dates.sd.getTime(),
                    edate: dates.ed.getTime(),
                    sdate_dp: dates.sd,
                    edate_dp: dates.ed,
                    riskLevel: '',
                    samplingRate: ''
                },
            ]
        };
        // Set final rates based on above default settings - only if default settings are used
        // cty.periods[0].finalRates = this.convertRates(angular.copy(this.riskSamplingSource.lowFrequency.highRisk));
        // If no defaults, just set as ''
        var period = {};
        angular.forEach(this.rates, function (v, k) {
            period[k] = ''; // Set as nothing
        });
        cty.periods[0].finalRates = period;
        // If should be visible, show it
        if (name.substring(0, 1).toUpperCase() === this.alphabet.selected) {
            cty.show = true;
            this.table.visible++;
        }
        else {
            cty.show = false;
        }
        // Refresh the index
        if (this.alphabet.act.indexOf(cty.cty.substring(0, 1).toUpperCase()) < 0) {
            this.alphabet.act.push(cty.cty.substring(0, 1).toUpperCase());
        }
        this.alphabet.act.sort();
        return cty;
    };
    /**
     * Function to check if a period's percentages have been changed by a user and differ from the base rates
     * @param period
     */
    SamplingViewController.prototype.checkForOverride = function (period) {
        var _this = this;
        var orchange = false;
        // If someone updates one of the %, perform this check to set the 'edited' flag
        angular.forEach(period.finalRates, function (v, k) {
            // If the value in the field doesn't match the base value
            if (period.finalRates[k] !== _this.riskSamplingSource[period.samplingRate][period.riskLevel][k]) {
                // If no override details for period at all...
                if (angular.isUndefined(period.override)) {
                    // create an object
                    period.override = {};
                    orchange = true;
                }
                else {
                    // if already set for this rate
                    if (period.override[k]) {
                        // check if the value has changed
                        if (period.finalRates[k] !== period.override[k].cv) {
                            // If they have overwrite the user
                            orchange = true;
                        }
                    }
                    else {
                        orchange = true;
                    }
                }
                // Add override details for perc
                if (orchange) {
                    period.override[k] = { cv: period.finalRates[k], who: _this.env.user.email, when: new Date() };
                    orchange = false; // reset
                }
            }
            else {
                // If the same as base...delete any overrides for that perc
                if (angular.isDefined(period.override)) {
                    delete period.override[k]; // If previously flagged as overridden, wipe it
                }
            }
        });
        // If overridden still exists, check it still has props
        if (angular.isDefined(period.override) && Object.keys(period.override).length === 0) {
            delete period.override; // If no elements overridden, delete the section completely
        }
    };
    // Display override update when hovering over the exclamation mark
    SamplingViewController.prototype.getTitle = function (period, rate) {
        var base = this.riskSamplingSource[period.samplingRate][period.riskLevel][rate];
        return 'This percentage differs from the current base rate of ' + base +
            '.  It was last updated by:\n\n'
            + period.override[rate].who + ' on ' + period.override[rate].when + '.';
    };
    /**
     * Function to check if a change has been made to the sampling rate or risk level and to update
     * values accordingly if so
     * @param period
     */
    SamplingViewController.prototype.reevaluateCty = function (period) {
        //const guys: string[][] = [['GMU', 'newGMU'], ['riskLevel', 'newRiskLevel'], ['samplingRate', 'newSamplingRate']];
        var guys = [['riskLevel', 'newRiskLevel'], ['samplingRate', 'newSamplingRate']];
        // Check if there's been a change
        var change = false;
        angular.forEach(guys, function (guy) {
            if (angular.isDefined(period[guy[1]]) && period[guy[0]] !== period[guy[1]]) {
                change = true;
            }
        });
        // If so...
        if (change) {
            period.GMU = period.newGMU;
            period.riskLevel = period.newRiskLevel;
            period.samplingRate = period.newSamplingRate;
            // And all the source data is available...
            if (typeof this.riskSamplingSource !== 'undefined' && typeof this.riskSamplingSource[period.samplingRate] !== 'undefined' && typeof this.riskSamplingSource[period.samplingRate][period.riskLevel] !== 'undefined') {
                // Replace it...
                //period.finalRates = this.convertRates(angular.copy(this.riskSamplingSource[period.samplingRate][period.riskLevel]));
                period.finalRates = angular.copy(this.riskSamplingSource[period.samplingRate][period.riskLevel]);
            }
        }
        this.checkForOverride(period);
    };
    SamplingViewController.prototype.convertRate = function (v) {
        return (v * 100).toFixed(0); // Convert to text
    };
    SamplingViewController.prototype.convertRates = function (finalRates) {
        angular.forEach(finalRates, function (v, k) {
            finalRates[k] = (v * 100).toFixed(0); // Convert to text
        });
        return finalRates;
    };
    /**
     * openActionMenu - Launch action menu dropdown using MD functions
     *
     * @param  {type} $mdOpenMenu: any ngMaterials open menu object
     * @param  {type} event: any       browser event
     */
    SamplingViewController.prototype.openActionMenu = function ($mdOpenMenu, event) {
        $mdOpenMenu(event);
    };
    /**
     * Function to append a new period to a country - will simply copy the previous one
     * but shift the year on
     * @param cty
     */
    SamplingViewController.prototype.addPeriod = function (cty) {
        var _this = this;
        angular.forEach(this.samplingCountries, function (samp) {
            if (samp.cty === cty) {
                _this.createPeriod(samp);
            }
        });
    };
    SamplingViewController.prototype.createPeriod = function (country) {
        var period = angular.copy(country.periods[country.periods.length - 1]);
        // Set the dates to the next year, assuming that's is what will be required
        var startDate = new Date(period.sdate_dp);
        var endDate = new Date(period.edate_dp);
        startDate.setFullYear(startDate.getFullYear() + 1);
        endDate.setFullYear(endDate.getFullYear() + 1);
        period.sdate = startDate.getTime();
        period.edate = endDate.getTime();
        period.sdate_dp = startDate;
        period.edate_dp = endDate;
        country.periods.push(period);
    };
    SamplingViewController.prototype.deletePeriod = function (ev, sample, p_index) {
        var _this = this;
        // Only allow if there's more than one for this country - disabled...but if someone's naughty
        if (sample.periods.length < 2) {
            return;
        }
        var items = {
            icon: 'QUESTION',
            message: 'Are you sure you want to Delete this Country Period?',
            title: 'Delete Country Period'
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult) {
                // Find the entry and lose it
                angular.forEach(_this.samplingCountries, function (samp) {
                    if (samp.cty === sample.cty) {
                        samp.periods.splice(p_index, 1);
                    }
                });
            }
        });
    };
    SamplingViewController.$inject = ['env', '$filter', '$stateParams', '$state',
        'socket', '$scope', 'settings', 'admin', 'Dialog', 'config'];
    return SamplingViewController;
}());
var SamplingViewComponent = (function () {
    function SamplingViewComponent() {
        this.templateUrl = 'sampling-view.html';
        this.controllerAs = 'vm';
        this.controller = SamplingViewController;
    }
    return SamplingViewComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('delete', '/public/icons/delete-forever.svg');
})
    .component('viewSamplingSection', new SamplingViewComponent());



var StatusEditController = (function () {
    function StatusEditController(env, $filter, DTS, $stateParams, $state, socket, $scope, config, admin, $timeout, Dialog, $q, settings) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.config = config;
        this.admin = admin;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.$q = $q;
        this.settings = settings;
        this.mainStatus = {};
        this.approvalStage = false;
        this.editMode = false;
        this.id = '';
        this.original = { _id: '' }; //for future logging reference at save time
        this.select = {
            users: {}
        };
        this.newStage = false;
        this.stageOwners = [];
        this.handOffActivity = [];
        this.handOffRoles = [];
        this.mysaStatuses = [];
        this.dswEligibilityAppStatusArray = [];
        this.approvers = { bpso: [], nonbpso: [] };
        this.selectValid = false;
        this.loaded = { bpso: false, nonbpso: false, statuses: false };
        this.readyMan = false;
        this.events = { beingSaved: false, beingDeleted: false };
        this.conflicts = { title: '', notManagers: [], viewDetails: false, resolved: true };
        this.serverError = null;
        this.filter = 'Active'; // Default
        this.rolesLoaded = false;
        this.statusesLoaded = false;
        this.dswStatusesLoaded = false;
        this.id = $stateParams.status;
        this.disInStatus = { opps: [], viewDetails: false };
        this.pwWithStatus = { pws: [], viewDetails: false };
        this.stageOwners = ['BPSO', 'Business Partner', 'Billing', 'Channels', 'Vendor', 'Brand', 'Other IBM Function', 'SPM'];
        this.handOffActivity = ['No ES Hand Off', 'Create ES Hand Off', 'Close ES Request'];
        //Listener for bpso and non bpso admin users
        //TO DO
        this.socket.forward('approvals.usersbyrole', this.$scope);
        this.$scope.$on('socket:approvals.usersbyrole', function (event, data) {
            //  this.$timeout(() => {
            //this.setProgramData(data);
            if (data.role === 2) {
                _this.approvers.bpso = data.results;
                _this.loaded.bpso = true;
            }
            else if (data.role === 3) {
                _this.approvers.nonbpso = data.results;
                _this.loaded.nonbpso = true;
            }
            _this.checkAllLoaded();
            //  }, 1000); //hmm..naughty
        });
        this.socket.forward('engage_support.roles', this.$scope);
        this.$scope.$on('socket:engage_support.roles', function (event, data) {
            _this.handOffRoles = data.roles;
            _this.rolesLoaded = true;
        });
        this.socket.forward('mysaStatuses.list', this.$scope);
        this.$scope.$on('socket:mysaStatuses.list', function (event, data) {
            _this.mysaStatuses = data.statuses;
            _this.statusesLoaded = true;
        });
        this.socket.forward('dswStatuses.list', this.$scope);
        this.$scope.$on('socket:dswStatuses.list', function (event, data) {
            _this.dswEligibilityAppStatusArray = data.statuses;
            _this.dswStatusesLoaded = true;
        });
        //Listen out for a broadcast from the site.body for when the config statuses are loaded...
        // this will only be required if accessing the url directly
        //  $scope.$on('configStatusLoaded', (events, args) => {
        this.setUp(); //Then run the set-up
        //  });
    }
    StatusEditController.prototype.selectAll = function (tf) {
        var _this = this;
        if (!tf) {
            this.select.users = {};
        }
        else {
            angular.forEach(this.approvers[this.approvalGroup], function (x) {
                _this.select.users[x.email] = true;
            });
        }
        this.syncApprovers();
    };
    StatusEditController.prototype.setBGName = function () {
        if (this.editing.bpso && this.editing.peer) {
            this.bgName = 'DMT BPSO Administrators';
        }
        else if (!this.editing.bpso && this.editing.peer) {
            this.bgName = 'DMT Non-BPSO Administrators';
        }
        else if (this.editing.bpso && !this.editing.peer) {
            this.bgName = 'DMT BPSO Approvers';
        }
        else if (!this.editing.bpso && !this.editing.peer) {
            this.bgName = 'DMT Non-BPSO Approvers';
        }
    };
    StatusEditController.prototype.removeNonManagers = function () {
        var _this = this;
        angular.forEach(this.conflicts.notManagers, function (x) {
            _this.select.users[x.email] = false;
        });
        this.conflicts.resolved = true;
        this.syncApprovers();
    };
    StatusEditController.prototype.syncApprovers = function () {
        var _this = this;
        if (this.editing.peer) {
            this.selectValid = true;
            return;
        }
        var newApprovers = [];
        //Based on what has been selected in the select.users array, loop through and update the editing.users
        // accordingly
        angular.forEach(this.select.users, function (value, key) {
            if (value) {
                //find the matching object in the approvers list
                _this.approvers[_this.approvalGroup].some(function (approver) {
                    if (approver.email === key) {
                        newApprovers.push(approver); //Add to array
                        //let tempApp = angular.copy(approver);
                        //delete tempApp.is_manager;
                        //newApprovers.push(tempApp); //Add to array
                        return true; //break
                    }
                });
            }
        });
        this.editing.users = newApprovers;
        if (this.editing.users.length > 0) {
            this.selectValid = true;
        }
        else {
            this.selectValid = false;
        }
    };
    StatusEditController.prototype.checkAllLoaded = function () {
        //If an Approval stage, gonna need both bpso and non-bpso approvers and the statuses
        if ([2, 4].indexOf(Number(this.id)) > -1) {
            if (this.loaded.bpso && this.loaded.nonbpso && this.loaded.statuses && this.rolesLoaded && this.statusesLoaded && this.dswStatusesLoaded) {
                this.readyMan = true;
            }
        }
        else {
            if (this.loaded.statuses && this.rolesLoaded && this.statusesLoaded && this.dswStatusesLoaded) {
                this.readyMan = true;
            }
        }
    };
    StatusEditController.prototype.createNew = function () {
        //First work out what the next number in sequence will be
        var nextNumber = 0;
        if (this.mainStatus && Array.isArray(this.mainStatus.subs)) {
            nextNumber = Math.max.apply(Math, this.mainStatus.subs.map(function (s) { return s.no; }).concat([nextNumber]));
        }
        nextNumber++; //roll it on
        this.editing = {
            active: true,
            dswEligibilityApp: false,
            prmOutbound: false,
            duplicateCheck: false,
            esHandOff: this.handOffActivity[0],
            esHandOffRole: this.handOffRoles[0].roleId,
            mySAPortalStatus: this.mysaStatuses[0],
            dswEligibilityAppStatus: this.dswEligibilityAppStatusArray[0],
            no: nextNumber,
            owner: 'BPSO',
            system: false
        };
        if (this.approvalStage) {
            this.editing.bpso = true;
            this.editing.clip = 0;
            this.editing.manager = false;
            this.editing.peer = true;
        }
        this.setBGName();
        this.newStage = true;
        this.selectValid = true;
        this.editMode = true;
    };
    StatusEditController.prototype.refresh = function () {
        var _this = this;
        if (this.approvalStage) {
            if (this.editing.peer) {
                delete this.editing.users;
                this.selectValid = true;
            }
            else {
                if (!this.editing.users) {
                    this.editing.users = [];
                }
                if (this.editing.bpso) {
                    this.approvalGroup = 'bpso';
                }
                else {
                    this.approvalGroup = 'nonbpso';
                }
                //loop though the exiting editing users to create
                angular.forEach(this.editing.users, function (approver) {
                    _this.select.users[approver.email] = true;
                });
                this.syncApprovers();
            }
            this.setBGName();
        }
        else {
            //Non approval stage
            this.selectValid = true;
        }
    };
    StatusEditController.prototype.reset = function (mainStatus) {
        var _this = this;
        angular.forEach(this.mainStatus.subs, function (sub) {
            if (mainStatus === sub.no) {
                _this.editing = angular.copy(sub);
            }
        });
    };
    StatusEditController.prototype.updateConfig = function () {
        var _this = this;
        //Find the status to update, change it
        var index = 0;
        //this.config.tempData.rows.forEach((main) => {
        this.settings.status_cfg.forEach(function (main) {
            if (main.no === _this.mainStatus.no) {
                if (!_this.newStage) {
                    //If not new, find it and replace it
                    main.subs.forEach(function (subby) {
                        if (subby.no === _this.editing.no) {
                            main.subs.splice(index, 1, _this.editing);
                        }
                        index++;
                    });
                }
                else {
                    main.subs.push(_this.editing);
                    _this.newStage = false; // reset
                }
            }
        });
    };
    StatusEditController.prototype.setEditingData = function (mainStatus) {
        var _this = this;
        angular.forEach(this.mainStatus.subs, function (sub) {
            if (mainStatus === sub.no) {
                _this.editing = angular.copy(sub);
                _this.refresh();
                _this.editMode = true;
                //If no system value, set as false
                _this.editing.system = !_this.editing.system ? false : _this.editing.system;
                // If no active value, set as true
                _this.editing.active = angular.isUndefined(_this.editing.active) ? true : _this.editing.active;
                // // If no value for esHandOff, set as false
                _this.editing.esHandOff = angular.isUndefined(_this.editing.esHandOff) ? _this.handOffActivity[0] : _this.editing.esHandOff;
                _this.editing.esHandOffRole = angular.isUndefined(_this.editing.esHandOffRole) ? _this.handOffRoles[0].roleId : _this.editing.esHandOffRole;
                _this.editing.mySAPortalStatus = angular.isUndefined(_this.editing.mySAPortalStatus) ? _this.mysaStatuses[0] : _this.editing.mySAPortalStatus;
                _this.editing.duplicateCheck = angular.isUndefined(_this.editing.duplicateCheck) ? false : _this.editing.duplicateCheck;
                _this.editing.dswEligibilityApp = !!_this.editing.dswEligibilityApp;
                _this.editing.prmOutbound = !!_this.editing.prmOutbound;
                _this.editing.dswEligibilityAppStatus = angular.isUndefined(_this.editing.dswEligibilityAppStatus) ? _this.dswEligibilityAppStatusArray[0] : _this.editing.dswEligibilityAppStatus;
            }
        });
    };
    StatusEditController.prototype.cancel = function (event) {
        this.reset(this.mainStatus.no);
        this.$scope.statForm.$setPristine();
        this.select = { users: {} };
        this.serverError = null;
        this.newStage = false;
        this.conflicts = { title: '', notManagers: [], resolved: true };
        this.disInStatus = { opps: [], viewDetails: false };
        this.pwWithStatus = { pws: [], viewDetails: false };
        this.editMode = false;
    };
    /**
     * notManagers - Function to check if the users listed as approvers are actually managers if the isManager field
     * is set...if not, return array of those that are not managers
     *
     * @return {type}  description
     */
    StatusEditController.prototype.notManagers = function () {
        var _this = this;
        this.conflicts.notManagers = [];
        if (this.editing.manager) {
            angular.forEach(this.editing.users, function (user) {
                angular.forEach(_this.approvers[_this.approvalGroup], function (approver) {
                    if (user.email === approver.email && approver.is_manager !== 'Y') {
                        _this.conflicts.notManagers.push(user);
                    }
                });
            });
        }
        if (this.conflicts.notManagers.length > 0) {
            this.conflicts.resolved = false;
            return true;
        }
        else {
            return false;
        }
    };
    StatusEditController.prototype.isConflict = function () {
        var _this = this;
        this.mainStatus.subs.some(function (sub) {
            if (sub.no !== _this.editing.no && angular.equals(sub.txt.toUpperCase(), _this.editing.txt.toUpperCase())) {
                _this.conflicts.title = sub.txt.toUpperCase();
                return true; //break
            }
        });
        if (this.conflicts.title) {
            return true;
        }
        else {
            this.conflicts.title = '';
            return false;
        }
    };
    /**
     * save - Function triggered when user clicks the Save button.
     *
     * @param  {type} event: any Browser event for the benefit of the display prompts (if needed)
     */
    StatusEditController.prototype.save = function (event) {
        var _this = this;
        //Ensure the name is not already taken inside this status...can have dupes in other statuses
        if (this.isConflict()) {
            return;
        }
        //Ensure managers are managers if they're all meant to be
        if (this.notManagers()) {
            return;
        }
        //if saving an update to an existing one, loop through the mainstatus.values and replace the entire object
        // - also make a note of whether the txt has changed...if so, will mean a db2 update, too
        var index = 0;
        var titleChange = false;
        var deactivate = false;
        var statusToSave = angular.copy(this.mainStatus); //move this to server-side
        angular.forEach(this.mainStatus.subs, function (sub) {
            if (sub.no === _this.editing.no) {
                //replace it
                statusToSave.subs.splice(index, 1, _this.editing); //move this to server-side
                //Check title...if it's change set db2 flag
                if (sub.txt !== _this.editing.txt) {
                    titleChange = true;
                }
                // Check if active status is being deactivated
                if ((sub.active === true || angular.isUndefined(sub.active)) && !_this.editing.active) {
                    deactivate = true;
                }
            }
            index++;
        });
        // If a MySA value is there, ensure it's in uppercase
        if (angular.isDefined(this.editing.mysa) && this.editing.mysa.trim() !== '') {
            this.editing.mysa = this.editing.mysa.toUpperCase();
        }
        else {
            delete this.editing.mysa;
        }
        var saveBundle = {
            msDesc: this.mainStatus.txt,
            msNo: this.mainStatus.no,
            status: this.editing,
            newStage: this.newStage,
            title: titleChange,
            deactivated: deactivate
        };
        // console.log('send this', saveBundle);
        //return;
        this.events.beingSaved = true; //set flag to disable save button
        this.serverError = null;
        //Make the call via a promise which will wait up to 30 seconds for a response
        this.savePromise(saveBundle).then(function (data) {
            //If response from server received
            _this.events.beingSaved = false; //enable save again
            // If there's an error
            if (data.error) {
                _this.serverError = data.error;
                if (data.error.indexOf('Disbursements in this status') > -1) {
                    _this.disInStatus.opps = data.opps; // Add the Disbursements 
                }
                else if (data.error.indexOf('There are Program Workflows') > -1) {
                    _this.pwWithStatus.pws = data.flows; // Add the Workflows 
                }
            }
            else {
                _this.updateConfig();
                _this.reset(_this.mainStatus.no); //Otherwise edit details remain if user goes to another stage
                _this.$scope.statForm.$setPristine(); //May not be necessary
                _this.editMode = false; //out of edit mode and back to sub-status view
            }
        }, function (nothingReturnedInTime) {
            //If no response from server received
            _this.events.beingSaved = false; //enable save again
            _this.serverError = 'The server does not appear to be responding, or did not respond in a reasonable time.';
        });
    };
    StatusEditController.prototype.setUp = function () {
        var _this = this;
        //If the config is loaded and readyMan var not set...
        //if (this.config.tempData.rows && !this.readyMan) {
        if (this.settings.status_cfg && !this.readyMan) {
            this.readyMan = true;
            this.loaded.statuses = true;
            //this.config.tempData.rows.some((row) => {
            this.settings.status_cfg.some(function (main) {
                if (main.no === Number(_this.id)) {
                    _this.mainStatus = main;
                    return true; //break loop
                }
            });
            if (this.mainStatus.no === 2 || this.mainStatus.no === 5) {
                this.approvalStage = true;
            }
            this.checkAllLoaded();
        }
    };
    StatusEditController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getHandOffRoles',
                script: '/engage-support/roles/extractESRoles',
                user: this.env.user
            }
        });
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getMySAPortalStatuses',
                script: '/mysaStatuses/index',
                user: this.env.user
            }
        });
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getDSWEligAppStatuses',
                script: '/dswEligibilityAppStatuses/index',
                user: this.env.user
            }
        });
        //If moving from the Status View then the configs will already be loaded...
        if (this.config.statusesLoaded) {
            //if so...call the set-up
            this.setUp();
        }
        if ([2, 5].indexOf(Number(this.id)) > -1) {
            if (!this.loaded.bpso) {
                //TO DO
                this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'getUsersByRoleApprovals',
                        roleNumber: 2,
                        script: '/approvals/approvals',
                        user: this.env.user
                    }
                });
            }
            if (!this.loaded.nonbpso) {
                //TO DO
                this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'getUsersByRoleApprovals',
                        roleNumber: 3,
                        script: '/approvals/approvals',
                        user: this.env.user
                    }
                });
            }
        }
    };
    StatusEditController.prototype.displayPrompt = function (event, bundle, icon) {
        var items = {
            title: bundle.title,
            message: bundle.textContent,
            icon: icon //ERROR, INFO, WARN
        };
        this.Dialog.openDialog(event, items, DialogService, 'confirm-prompt.html');
    };
    StatusEditController.prototype.savePromise = function (saveBundle) {
        var _this = this;
        this.deferred = this.$q.defer(); //Set deferred object...to be sent to browser
        this.$timeout(function () {
            _this.deferred.reject([]); //If not resolved within 3 seconds...reject
        }, 30000); //30 secs
        this.config.updateStatusConfig(saveBundle);
        // TO DO
        this.socket.forward('config.config_update', this.$scope);
        this.$scope.$on('socket:config.config_update', function (event, data) {
            _this.deferred.resolve(data); //add the results to the deferred object
        });
        return this.deferred.promise; //fire off the promise
    };
    StatusEditController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'config', 'admin', '$timeout', 'Dialog', '$q', 'settings'];
    return StatusEditController;
}());
var StatusEditComponent = (function () {
    function StatusEditComponent() {
        this.templateUrl = 'status.html';
        this.controllerAs = 'vm';
        this.controller = StatusEditController;
    }
    return StatusEditComponent;
}());
angular
    .module('application')
    .component('adminStatusSection', new StatusEditComponent());



var StatusViewController = (function () {
    function StatusViewController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin, config, settings) {
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.config = config;
        this.settings = settings;
        this.table = {};
        this.table.headers = [{
                'Main Status': '_link',
                'Description': 'desc'
            }];
    }
    StatusViewController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket',
        '$scope', 'admin', 'config', 'settings'];
    return StatusViewController;
}());
var StatusViewComponent = (function () {
    function StatusViewComponent() {
        this.templateUrl = 'status-view.html';
        this.controllerAs = 'vm';
        this.controller = StatusViewController;
    }
    return StatusViewComponent;
}());
angular
    .module('application')
    .component('viewStatusSection', new StatusViewComponent());



var TermsViewController = (function () {
    function TermsViewController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin, config, settings) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.config = config;
        this.settings = settings;
        this.isCreateFormShow = false;
        this.profileLoaded = false;
        this.saving = {};
        this.events = {
            beingSaved: false
        };
        this.today = new Date();
        this.socket.forward('config.terms_profile', this.$scope);
        this.$scope.$on('socket:config.terms_profile', function (event, payload) {
            if (angular.isDefined(payload.error)) {
                _this.$state.go('admin.main'); // Go back to main admin
            }
            else {
                _this.data = payload.data;
                _this.profileLoaded = true;
                _this.getcorrectTerm();
            }
        });
        this.socket.forward('config.terms_profile_save', this.$scope);
        this.$scope.$on('socket:config.terms_profile_save', function (event, payload) {
            _this.events.beingSaved = false;
            if (angular.isDefined(payload.error)) {
                _this.events.serverError = payload.error;
            }
            else {
                // If successful
                _this.data.terms.push(payload.newTerm); // Add term
                _this.getcorrectTerm(); // set as the current one to show
                _this.isCreateFormShow = false;
                _this.today = new Date(); // lazy update to stop the newly-added entry appearing as a Future Term when it's not :)
            }
        });
    }
    TermsViewController.prototype.getcorrectTerm = function () {
        this.correctTerm = this.data.terms[this.data.terms.length - 1];
    };
    TermsViewController.prototype.openCreateVersionForm = function () {
        this.saving.tou = '';
        this.saving.effective_date = new Date();
        this.isCreateFormShow = true;
        this.events.beingSaved = false;
    };
    TermsViewController.prototype.changeVersion = function (version) {
        this.correctTerm = this.data.terms.filter(function (data) { return data.version === version; })[0];
    };
    TermsViewController.prototype.$onInit = function () {
        this.admin.getTermsProfile();
        this.minEffectiveDate = new Date();
    };
    TermsViewController.prototype.saveData = function () {
        var newTerm = {
            tou: this.saving.tou,
            created_by: this.env.user.email,
            created_date: Date.now(),
            version: this.data.terms[this.data.terms.length - 1].version + 1,
            effective_date: new Date(this.saving.effective_date).getTime()
        };
        //this.data.terms.push(newTerm);
        delete this.events.serverError;
        this.admin.updateTerms(newTerm); // Make call to server
        //this.isCreateFormShow = false;
        //this.getcorrectTerm();
        this.events.beingSaved = true; // Set flag to disable buttons
    };
    TermsViewController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket',
        '$scope', 'admin', 'config', 'settings'];
    return TermsViewController;
}());
var TermsViewComponent = (function () {
    function TermsViewComponent() {
        this.templateUrl = 'termsofuse.html';
        this.controllerAs = 'vm';
        this.controller = TermsViewController;
    }
    return TermsViewComponent;
}());
angular
    .module('application')
    .component('viewTermsSection', new TermsViewComponent());



var UserMainEditController = (function () {
    function UserMainEditController(env, $filter, DTS, $stateParams, $state, socket, $scope, config, admin, $timeout, Dialog, $q, settings) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.config = config;
        this.admin = admin;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.$q = $q;
        this.settings = settings;
        this.email = '';
        this.user = {};
        this.userLoaded = false;
        this.email = $stateParams.user;
        //Listener for the user profile
        this.socket.forward('config.userbyemail', this.$scope);
        this.$scope.$on('socket:config.userbyemail', function (event, data) {
            _this.user = data;
            _this.userLoaded = true;
        });
    }
    UserMainEditController.prototype.$onInit = function () {
        //Get the Country Profiles
        //this.admin.getCountryConfig();
        //Get the General settings
        //this.admin.getGeneralConfig();
        //Get the User Profile
        this.admin.getUserProfile(this.email);
    };
    UserMainEditController.prototype.getAvatar = function () {
        if (this.user) {
            return this.DTS.getAvatar(this.user.email, 115);
        }
        return '';
    };
    UserMainEditController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state',
        'socket', '$scope', 'config', 'admin', 'settings'];
    return UserMainEditController;
}());
var UserMainEditComponent = (function () {
    function UserMainEditComponent() {
        this.templateUrl = 'user-main.html';
        this.controllerAs = 'vm';
        this.controller = UserMainEditController;
    }
    return UserMainEditComponent;
}());
angular
    .module('application')
    .component('adminUserMainSection', new UserMainEditComponent());



/**
 * @author Matthew Rogers
 */
var upclBind = { changelog: '<', bod: '<' };
var UserEditChangeLogController = (function () {
    function UserEditChangeLogController(Dialog) {
        this.Dialog = Dialog;
    }
    ;
    UserEditChangeLogController.prototype.viewLog = function (event) {
        var items = {
            logdata: this.changelog,
            bod: this.bod,
            viewEntries: [],
            expand: function (num) {
                if (this.viewEntries.indexOf(num) > -1) {
                    this.viewEntries.splice(this.viewEntries.indexOf(num), 1); //lose
                }
                else {
                    this.viewEntries.push(num);
                }
            },
            columnHeaders: ['Date Updated', 'by Admin User']
        };
        this.Dialog.openDialog(event, items, DialogService, 'user.edit-changelog-view.html');
    };
    UserEditChangeLogController.$inject = ['Dialog'];
    return UserEditChangeLogController;
}());
var UserEditChangeLogComponent = (function () {
    function UserEditChangeLogComponent() {
        this.bindings = upclBind;
        this.templateUrl = 'user.edit-changelog.html';
        this.controller = UserEditChangeLogController;
    }
    return UserEditChangeLogComponent;
}());
angular
    .module('application')
    .component('userChangeLog', new UserEditChangeLogComponent());



var upb = { parent: '=' };
var programs = [
    'Promotions', 'Performance Bonus', 'Custom Initiatives',
    'Fees', 'Instant Rebates'
];
var UserEditController = (function () {
    function UserEditController(env, $filter, DTS, $stateParams, $state, socket, $scope, config, admin, $timeout, Dialog, $q, settings) {
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.config = config;
        this.admin = admin;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.$q = $q;
        this.settings = settings;
        this.user = {};
        this.select = { countries: {}, iots: {}, programs: {}, standard_reports: {}, cbg: {}, valid: false };
        this.original = { swdr_permissions: {} }; //for future logging reference at save time
        this.editing = { imts: [] };
        this.isShowClaimForms = false;
        this.isShowCore = false;
        this.isShowMetrics = false;
        this.events = { beingSaved: false };
        this.view = { country: true };
        this.serverError = null;
        this.toggle = { rep: false, cty: false, prg: false };
    }
    UserEditController.prototype.setUp = function () {
        var _this = this;
        this.editing = this.parent.user; //set
        this.setAvailablePrograms();
        angular.copy(this.parent.user, this.original); //for logging etc
        delete this.editing.change_log; //remove the change log from the data to be saved
        //Set all to no.....this could easily be resolved by saving objects in couch
        angular.forEach(this.settings.iot_list, function (iot) {
            _this.select.iots[iot] = false;
        });
        //set the selected permission options based on cloudant data
        this.syncEditingPermissions('iot', 'iots');
        this.syncEditingPermissions('country', 'countries');
        this.syncEditingPermissions('program', 'programs');
        this.syncEditingPermissions('standard_report', 'standard_reports');
        this.standardReports = ['Closed', 'Open']; //Temp...pull from cloudant doc
        this.syncCountries();
    };
    UserEditController.prototype.setAvailablePrograms = function () {
        var userPrograms = _.get(this.editing, 'swdr_permissions.program', []);
        if (userPrograms.includes('SVI')) {
            this.isShowCore = true;
            this.isShowMetrics = true;
        }
        var isIncludesProgramType = userPrograms.filter(function (program) { return programs.includes(program); }).length > 0;
        if (isIncludesProgramType) {
            this.isShowClaimForms = true;
        }
    };
    UserEditController.prototype.syncEditingPermissions = function (object, target) {
        var _this = this;
        angular.forEach(this.editing.swdr_permissions[object], function (value) {
            _this.select[target][value] = true;
        });
    };
    UserEditController.prototype.syncCountries = function () {
        var _this = this;
        var cty = [];
        this.select.cbg = {}; //reset
        //Build array of countries short names only
        angular.forEach(this.select.countries, function (value, key) {
            if (value) {
                cty.push(key);
                //count countries per geo
                var geo = _this.admin.getCountryIOT(key);
                if (_this.select.cbg[geo] === undefined) {
                    _this.select.cbg[geo] = 1;
                }
                else {
                    _this.select.cbg[geo]++;
                }
            }
        });
        this.editing.swdr_permissions.country = cty;
        this.validateIOTs();
    };
    UserEditController.prototype.validateIOTs = function () {
        var _this = this;
        //Validate selections
        var valid = true;
        if (Object.keys(this.select.iots).length > 0) {
            //Loop through the selected IOTs
            angular.forEach(this.select.iots, function (value, key) {
                //If enabled but no selections made
                if (value && angular.isUndefined(_this.select.cbg[key])) {
                    valid = false; //not valid
                }
            });
        }
        this.select.valid = valid;
    };
    UserEditController.prototype.syncPrograms = function () {
        var prg = [];
        //Build array of countries short names only
        angular.forEach(this.select.programs, function (value, key) {
            if (value) {
                prg.push(key);
            }
        });
        this.editing.swdr_permissions.program = prg;
    };
    UserEditController.prototype.syncReports = function () {
        var rep = [];
        //Build array of countries short names only
        angular.forEach(this.select.standard_reports, function (value, key) {
            if (value) {
                rep.push(key);
            }
        });
        this.editing.swdr_permissions.standard_report = rep;
    };
    UserEditController.prototype.selectAll = function (iot) {
        var _this = this;
        //Loop through the countries
        angular.forEach(this.settings.country_list, function (cty) {
            //If the iot matches...add it
            if (iot === cty.imt && cty.ic === 'Country') {
                _this.select.countries[cty.short] = true;
            }
        });
        this.syncCountries();
    };
    UserEditController.prototype.deselectAll = function (iot) {
        var _this = this;
        //Loop through the selected countries
        angular.forEach(this.select.countries, function (value, key) {
            //If the iot matches...lose it
            if (iot === _this.admin.getCountryIOT(key)) {
                _this.select.countries[key] = false;
            }
        });
        this.syncCountries();
    };
    /**
     * refreshIOTs - Function called when an IOT is enabled or disabled.  This will rebuild the
     * list of iots for the checkbox and to be saved in the editing data
     */
    UserEditController.prototype.refreshIOTs = function (enabled, iot) {
        if (!enabled) {
            this.deselectAll(iot);
        }
        var iots = [];
        angular.forEach(this.select.iots, function (value, key) {
            if (value) {
                iots.push(key);
            }
        });
        this.editing.swdr_permissions.iot = iots;
        this.validateIOTs();
    };
    UserEditController.prototype.$onInit = function () {
        this.setUp();
    };
    UserEditController.prototype.getChangeValues = function (data) {
        var v = data;
        if (angular.isArray(v)) {
            v = data.toString().replace(/,/g, ', ');
        }
        else if (data === true) {
            v = 'Yes';
        }
        else if (data === false) {
            v = 'No';
        }
        if (v === '' || angular.isUndefined(v) || v.length === 0) {
            v = '-';
        }
        return v;
    };
    UserEditController.prototype.getChangeLog = function () {
        var _this = this;
        var clPack = {
            changes: {},
            timestamp: new Date().getTime(),
            user: this.env.user.email
        };
        var changes = {};
        var count = 0;
        var fields = ['iot', 'country', 'program',
            'standard_report', 'general_report', 'pivot_report', 'custom_report', 'shared_report', 'app'];
        angular.forEach(fields, function (field) {
            if (!angular.equals(_this.original.swdr_permissions[field], _this.editing.swdr_permissions[field])) {
                var o = _this.getChangeValues(_this.original.swdr_permissions[field]);
                var n = _this.getChangeValues(_this.editing.swdr_permissions[field]);
                clPack.changes[field] = { old: o, new: n };
            }
        });
        return clPack;
    };
    /**
     * save - Function triggered when user clicks the Save button.
     *
     * @param  {type} event: any Browser event for the benefit of the display prompts (if needed)
     */
    UserEditController.prototype.save = function (event) {
        var _this = this;
        this.events.beingSaved = true; //set flag to disable save button
        this.serverError = null;
        var saveBundle = { data: this.editing, changelog: this.getChangeLog() };
        //Make the call via a promise which will wait up to 30 seconds for a response
        this.savePromise(saveBundle).then(function (data) {
            //If response from server received
            _this.events.beingSaved = false; //enable save again
            if (data.error) {
                _this.serverError = data.error;
            }
            else {
                _this.admin.navigate('admin.users-view');
            }
        }, function (nothingReturnedInTime) {
            //If no response from server received
            _this.events.beingSaved = false; //enable save again
            _this.serverError = 'The server does not appear to be responding, or did not respond in a reasonable time.';
        });
    };
    UserEditController.prototype.savePromise = function (saveBundle) {
        var _this = this;
        this.deferred = this.$q.defer(); //Set deferred object...to be sent to browser
        this.$timeout(function () {
            _this.deferred.reject([]); //If not resolved within 3 seconds...reject
        }, 30000); //30 secs
        this.admin.updateUserProfile(saveBundle);
        // TO DO
        this.socket.forward('config.user_update', this.$scope);
        this.$scope.$on('socket:config.user_update', function (event, data) {
            _this.deferred.resolve(data); //add the results to the deferred object
        });
        return this.deferred.promise; //fire off the promise
    };
    UserEditController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state',
        'socket', '$scope', 'config', 'admin', '$timeout', 'Dialog', '$q', 'settings'];
    return UserEditController;
}());
var UserEditComponent = (function () {
    function UserEditComponent() {
        this.bindings = upb; //Bindings to connect with parent
        this.templateUrl = 'user.html';
        //controllerAs = 'vm';  //No controller required...$ctrl becomes the controller by default as this is a child
        this.controller = UserEditController;
    }
    return UserEditComponent;
}());
angular
    .module('application')
    .component('adminUserSection', new UserEditComponent());



var UserViewController = (function () {
    function UserViewController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.table = {
            sortType: 'name', sortReverse: false, search: '',
            filter: false, filterParams: {}, select_options: {}
        };
        this.users = [];
        this.usersLoaded = false;
        this.exportFired = false;
        this.table.headers = [{
                'Name': 'name', 'Email': 'email', 'Role': 'role', 'Status': 'status'
            }];
        this.socket.forward('config.users', this.$scope);
        this.$scope.$on('socket:config.users', function (event, data) {
            _this.users = data;
            _this.usersLoaded = true;
            _this.buildSelects();
        });
        this.socket.forward('config.admin-user-excel', this.$scope);
        this.$scope.$on('socket:config.admin-user-excel', function (event, data) {
            _this.exportFired = false;
            if (!data.payload.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.payload], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-USER-PERMISSIONS_" + d + ".xlsx");
                a.click();
            }
        });
    }
    UserViewController.prototype.exportUserPermissions = function () {
        this.exportFired = true;
        this.admin.exportUserPermissions();
    };
    UserViewController.prototype.strict = function () {
        if (this.table.filter) {
            return true;
        }
        else {
            return undefined;
        }
    };
    UserViewController.prototype.buildSelects = function () {
        var _this = this;
        var s = [];
        var r = [];
        angular.forEach(this.users, function (user) {
            if (s.indexOf(user.status) === -1) {
                s.push(user.status);
            }
            var who = _this.admin.getBGName(user.swdr_permissions.role);
            if (r.indexOf(who) === -1) {
                r.push(who);
            }
            user.role = who; //Convert roles for display
        });
        s.sort();
        this.table.select_options.status = s;
        r.sort();
        this.table.select_options.role = r;
    };
    UserViewController.prototype.$onInit = function () {
        this.admin.getUserProfiles();
    };
    UserViewController.prototype.resetFilters = function () {
        delete this.table.filters;
        this.table.filterParams = {};
    };
    UserViewController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'admin'];
    return UserViewController;
}());
var UserViewComponent = (function () {
    function UserViewComponent() {
        this.templateUrl = 'users-view.html';
        this.controllerAs = 'vm';
        this.controller = UserViewController;
    }
    return UserViewComponent;
}());
angular
    .module('application')
    .component('viewUserSection', new UserViewComponent());



var ValidationViewController = (function () {
    function ValidationViewController($state, settings, env, socket, $scope, Dialog, admin) {
        var _this = this;
        this.$state = $state;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.admin = admin;
        this.isSaving = false;
        this.docTableOrig = {};
        this.docTable = [];
        this.countryTable = [];
        this.isDivisionLoaded = false;
        this.isCountryLoaded = false;
        this.newCode = {
            isLineValid: true
        };
        this.socket.forward('validationview.ctyList', this.$scope);
        this.$scope.$on('socket:validationview.ctyList', function (event, data) {
            _this.countryTable = data;
            _this.isCountryLoaded = true;
        });
        this.socket.forward('validationview.valTables', this.$scope);
        this.$scope.$on('socket:validationview.valTables', function (event, data) {
            for (var i = 0; i < data.tbl.length; i++) {
                data.tbl[i].isValid = true;
                for (var i2 = 0; i2 < data.tbl[i].currentTable.length; i2++) {
                    data.tbl[i].currentTable[i2].isLineValid = true;
                    data.tbl[i].currentTable[i2].reqStart = new Date(data.tbl[i].currentTable[i2].reqStart);
                    data.tbl[i].currentTable[i2].reqEnd = new Date(data.tbl[i].currentTable[i2].reqEnd);
                }
                data.tbl[i].origTable = JSON.parse(JSON.stringify(data.tbl[i].currentTable));
            }
            if (typeof _this.curTab === 'undefined') {
                _this.curTab = data.tbl[0];
            }
            for (var i2 = 0; i2 < _this.curTab.colNames.length; i2++) {
                _this.newCode[_this.curTab.colNames[i2].colKey] = '';
            }
            _this.docTable = data;
            _this.docTableOrig = JSON.parse(JSON.stringify(data));
            _this.isDivisionLoaded = true;
            if (_this.isSaving) {
                //Once done saving, send email to Admin team
                var emailBundle = { docurl: 'validation-view', profile: 'Validation Rule Table (' + _this.curTab.name + ')', user: _this.env.user };
                _this.admin.sendAdminUpdate(emailBundle);
            }
            _this.isSaving = false;
        });
    }
    ValidationViewController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getValidationListBackend',
                script: 'validation/validationTables',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getCountryList',
                script: 'validation/validationTables',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    // all tables need to have reqStart and reqEnd to describe their validity period
    // tables either have to have a reqCode property when only one property is essentail for comparison
    // or a series of combo keys when a combination of properties distinguishes entries
    ValidationViewController.prototype.addNewCode = function (oneTab) {
        var addLine = {};
        var addText = '';
        for (var key in this.newCode) {
            for (var i = 0; i < oneTab.colNames.length; i++) {
                if (key === oneTab.colNames[i].colKey) {
                    addLine[key] = this.newCode[key];
                    if (key !== 'reqStart' && key !== 'reqEnd') {
                        if (addText === '') {
                            addText = this.newCode[key];
                        }
                        else {
                            addText = addText + ', ' + this.newCode[key];
                        }
                    }
                }
            }
        }
        addLine.reqStart = new Date(addLine.reqStart);
        addLine.reqEnd = new Date(addLine.reqEnd);
        var startText = addLine.reqStart.getDate() + '.' + (addLine.reqStart.getMonth() + 1) + '.' + addLine.reqStart.getFullYear();
        var endText = addLine.reqEnd.getDate() + '.' + (addLine.reqEnd.getMonth() + 1) + '.' + addLine.reqEnd.getFullYear();
        var historyGen = ['Entry created: ' + addText + ', ' + startText + ', ' + endText];
        var timeStamp = new Date();
        var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
        var oneHist = {
            timestamp: timeText,
            comment: historyGen,
            user: this.env.user.email
        };
        oneTab.tableHistory.push(oneHist);
        oneTab.currentTable.push(addLine);
        this.voidNew(oneTab);
        this.checkValidity(oneTab);
        this.docTableOrig = JSON.parse(JSON.stringify(this.docTable));
        for (var i = 0; i < this.docTable.tbl.length; i++) {
            delete this.docTableOrig.tbl[i].origTable;
            this.docTable.tbl[i].origTable = JSON.parse(JSON.stringify(this.docTable.tbl[i].currentTable));
        }
        this.isSaving = true;
        this.sendforUpdate(historyGen);
    };
    ValidationViewController.prototype.voidNew = function (oneTab) {
        console.info(oneTab.name);
        this.curTab = oneTab;
        this.newCode = {
            isLineValid: true
        };
        for (var i2 = 0; i2 < oneTab.colNames.length; i2++) {
            this.newCode[oneTab.colNames[i2].colKey] = '';
        }
    };
    // all tables need to have reqStart and reqEnd to describe their validity period
    // tables either have to have a reqCode property when only one property is essentail for comparison
    // or a series of combo keys when a combination of properties distinguishes entries
    ValidationViewController.prototype.checkValidity = function (oneTab) {
        oneTab.isValid = true;
        for (var i = 0; i < oneTab.currentTable.length; i++) {
            oneTab.currentTable[i].isLineValid = true;
        }
        for (var i = 0; i < oneTab.currentTable.length - 1; i++) {
            if (!(oneTab.currentTable[i].reqStart instanceof Date) || !(oneTab.currentTable[i].reqEnd instanceof Date)) {
                oneTab.currentTable[i].isLineValid = false;
                oneTab.isValid = false;
            }
            else if (oneTab.currentTable[i].reqStart > oneTab.currentTable[i].reqEnd) {
                oneTab.currentTable[i].isLineValid = false;
                oneTab.isValid = false;
            }
            else {
                for (var i2 = i + 1; i2 < oneTab.currentTable.length; i2++) {
                    var perfectFit = true;
                    var checkFit = false;
                    for (var key in oneTab.currentTable[i]) {
                        if (key.search('combo') > -1) {
                            checkFit = true;
                            if (oneTab.currentTable[i][key] !== oneTab.currentTable[i2][key]) {
                                perfectFit = false;
                                break;
                            }
                        }
                    }
                    if ((oneTab.currentTable[i].reqCode === oneTab.currentTable[i2].reqCode && typeof oneTab.currentTable[i].reqCode !== 'undefined')
                        || (oneTab.currentTable[i].country === oneTab.currentTable[i2].country && typeof oneTab.currentTable[i].country !== 'undefined')
                        || (perfectFit && checkFit)) {
                        if ((oneTab.currentTable[i].reqStart < oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqStart < oneTab.currentTable[i].reqEnd)
                            || (oneTab.currentTable[i].reqStart < oneTab.currentTable[i2].reqEnd && oneTab.currentTable[i2].reqEnd < oneTab.currentTable[i].reqEnd)
                            || (oneTab.currentTable[i].reqStart >= oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqEnd >= oneTab.currentTable[i].reqEnd)) {
                            oneTab.currentTable[i].isLineValid = false;
                            oneTab.currentTable[i2].isLineValid = false;
                            oneTab.isValid = false;
                        }
                    }
                }
            }
        }
        this.newCode.isLineValid = true;
        if ((this.newCode.reqStart > this.newCode.reqEnd)) {
            this.newCode.isLineValid = false;
        }
        else if (oneTab.currentTable.length > 0) {
            for (var i2 = 0; i2 < oneTab.currentTable.length; i2++) {
                var perfectFit = true;
                var checkFit = false;
                for (var key in this.newCode) {
                    if (key.search('combo') > -1) {
                        checkFit = true;
                        if (this.newCode[key] !== oneTab.currentTable[i2][key]) {
                            perfectFit = false;
                            break;
                        }
                    }
                }
                if ((this.newCode.reqCode === oneTab.currentTable[i2].reqCode && typeof this.newCode.reqCode !== 'undefined') || (perfectFit && checkFit)) {
                    if ((this.newCode.reqStart < oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqStart < this.newCode.reqEnd)
                        || (this.newCode.reqStart < oneTab.currentTable[i2].reqEnd && oneTab.currentTable[i2].reqEnd < this.newCode.reqEnd)
                        || (this.newCode.reqStart >= oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqEnd >= this.newCode.reqEnd)) {
                        this.newCode.isLineValid = false;
                        oneTab.currentTable[i2].isLineValid = false;
                        oneTab.isValid = false;
                    }
                }
            }
        }
    };
    ValidationViewController.prototype.deleteConfirmation = function (ev, oneTab, oneItem) {
        var _this = this;
        this.Dialog.confirmDelete(ev, oneTab).then(function (dResult) {
            //        this.Dialog.updateValidForm(event, this.toDelete, 'sampling.html').then((dResult: any) => {
            if (dResult) {
                _this.deleteLine(oneTab, oneItem);
            }
        });
    };
    ValidationViewController.prototype.deleteLine = function (oneTab, oneItem) {
        var curPosItem = oneTab.currentTable.indexOf(oneItem);
        var curPosTab = this.docTable.tbl.indexOf(oneTab);
        var startDate = new Date(this.docTable.tbl[curPosTab].origTable[curPosItem].reqStart);
        var startText = startDate.getDate() + '.' + (startDate.getMonth() + 1) + '.' + startDate.getFullYear();
        var endDate = new Date(this.docTable.tbl[curPosTab].currentTable[curPosItem].reqEnd);
        var endText = endDate.getDate() + '.' + (endDate.getMonth() + 1) + '.' + endDate.getFullYear();
        var timeStamp = new Date();
        var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
        var comment = 'Deleted: ';
        for (var key in this.docTable.tbl[curPosTab].currentTable[curPosItem]) {
            if (key !== 'reqStart' && key !== 'reqEnd' && key !== 'isLineValid') {
                comment += this.docTable.tbl[curPosTab].currentTable[curPosItem][key] + ', ';
            }
        }
        var oneHist = {
            timestamp: timeText,
            comment: [comment + ', start ' + startText + ', end ' + endText],
            user: this.env.user.email
        };
        this.docTable.tbl[curPosTab].tableHistory.push(oneHist);
        this.docTable.tbl[curPosTab].currentTable.splice(curPosItem, 1);
        this.docTableOrig = JSON.parse(JSON.stringify(this.docTable));
        for (var i = 0; i < this.docTable.tbl.length; i++) {
            delete this.docTableOrig.tbl[i].origTable;
            this.docTable.tbl[i].origTable = JSON.parse(JSON.stringify(this.docTable.tbl[i].currentTable));
        }
        this.isSaving = true;
        this.sendforUpdate(oneHist.comment);
    };
    ValidationViewController.prototype.save = function (oneTab) {
        var curPos = this.docTable.tbl.indexOf(oneTab);
        var historyGen = [];
        var commentBase = [];
        if (typeof this.docTable.tbl[curPos].origTable[0].reqCode === 'undefined') {
            for (var key in this.docTable.tbl[curPos].origTable[0]) {
                if (key.search('combo') > -1) {
                    commentBase.push(key);
                }
            }
        }
        else {
            commentBase.push(this.docTable.tbl[curPos].origTable[0].reqCode);
        }
        for (var i2 = 0; i2 < this.docTable.tbl[curPos].currentTable.length; i2++) {
            for (var key in this.docTable.tbl[curPos].currentTable[i2]) {
                if (key === '$$hashKey') {
                    delete this.docTable.tbl[curPos].currentTable[i2][key];
                }
                else if (this.docTable.tbl[curPos].origTable[i2][key] !== this.docTable.tbl[curPos].currentTable[i2][key]) {
                    var colName = '';
                    var isDate = false;
                    if (key === 'reqStart' || key === 'reqEnd') {
                        isDate = true;
                    }
                    var mainText = '';
                    for (var iBase = 0; iBase < commentBase.length; iBase++) {
                        if (iBase === 0) {
                            mainText = this.docTable.tbl[curPos].origTable[i2][commentBase[iBase]];
                        }
                        else {
                            mainText = mainText + ', ' + this.docTable.tbl[curPos].origTable[i2][commentBase[iBase]];
                        }
                    }
                    if (!isDate) {
                        historyGen.push(mainText + ', ' + colName + ' changed from ' + this.docTable.tbl[curPos].origTable[i2][key] + ' to ' + this.docTable.tbl[curPos].currentTable[i2][key]);
                    }
                    else {
                        var orDate = new Date(this.docTable.tbl[curPos].origTable[i2][key]);
                        var orText = orDate.getDate() + '.' + (orDate.getMonth() + 1) + '.' + orDate.getFullYear();
                        var curDate = new Date(this.docTable.tbl[curPos].currentTable[i2][key]);
                        var curText = curDate.getDate() + '.' + (curDate.getMonth() + 1) + '.' + curDate.getFullYear();
                        if (orText !== curText) {
                            historyGen.push(mainText + ', ' + colName + ' changed from ' + orText + ' to ' + curText);
                        }
                    }
                }
            }
        }
        if (historyGen.length > 0) {
            var timeStamp = new Date();
            var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
            var oneHist = {
                timestamp: timeText,
                comment: historyGen,
                user: this.env.user.email
            };
            this.docTable.tbl[curPos].tableHistory.push(oneHist);
            this.docTableOrig = JSON.parse(JSON.stringify(this.docTable));
            for (var i = 0; i < this.docTable.tbl.length; i++) {
                delete this.docTableOrig.tbl[i].origTable;
                this.docTable.tbl[i].origTable = JSON.parse(JSON.stringify(this.docTable.tbl[i].currentTable));
            }
            this.isSaving = true;
            this.sendforUpdate(historyGen);
        }
    };
    ValidationViewController.prototype.sendforUpdate = function (historyText) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'sendValidationListBackend',
                script: 'validation/validationTables',
                email: this.env.user.email,
                token: this.env.user.token,
                data: this.docTableOrig,
                receivers: ['roman.tibensky@sk.ibm.com'],
                historyText: historyText
            }
        });
    };
    ValidationViewController.$inject = ['$state', 'settings', 'env', 'socket', '$scope', 'Dialog', 'admin'];
    return ValidationViewController;
}());
var ValidationViewComponent = (function () {
    function ValidationViewComponent() {
        this.templateUrl = 'validation-view.html';
        this.controllerAs = 'vm';
        this.controller = ValidationViewController;
    }
    return ValidationViewComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('delete', '/public/icons/delete-forever.svg')
        .icon('invalid', '/public/icons/ic_highlight_off_black_24px.svg')
        .icon('save', '/public/images/ic_save_black_24px.svg');
})
    .component('viewValidationSection', new ValidationViewComponent());



/**
 * @author Matthew Rogers.
 */
var ActionMenuController = (function () {
    function ActionMenuController(config, Dialog, status, topic, $state, settings, env, socket, $scope, admin, notify) {
        var _this = this;
        this.config = config;
        this.Dialog = Dialog;
        this.status = status;
        this.topic = topic;
        this.$state = $state;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.notify = notify;
        this.codesLoaded = false;
        this.showDisputeList = true;
        this.scopeUpdateSubstatus = 'actionmenu.substatus.update';
        this.invFlagUpdateBackendModuleName = 'detail/validation/substatusUpdate';
        this.getNewUIInfo = {
            uiVersion: _.get(this.topic.checksData, 'uiVersion', 1)
        };
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_5 = 5;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (_this.moveToPaidData && _this.moveToPaidData.isMoveToPaidAction && data[0] === 'invoice_flags') {
                _this.topic.sendForUpdate(['status'], 'Change Status To Paid', _this.moveToPaidData.comment, false);
                _this.moveToPaidData.isMoveToPaidAction = false;
            }
        });
        this.socket.forward('eligibility.updateInboundCMR', this.$scope);
        this.$scope.$on('socket:eligibility.updateInboundCMR', function (event, data) {
            var result = data;
            if (data.statusCode === 200) {
                var desc = '';
                var cmrNumberDescription = "CMR changed from '" + result.oldCMR + "' to '" + result.CMR + "' ";
                var dcidDescription = "DCID changed from '" + result.oldDCID + "' to '" + result.DCID + "' ";
                if (_.isString(result.CMR) && result.CMR !== '') {
                    desc += cmrNumberDescription;
                }
                if (_.isString(result.DCID) && result.DCID !== '') {
                    desc += dcidDescription;
                }
                var newHistory = _this.status.getNewHistoryObject('Override CMR Change', desc, '-', '');
                var data_1 = {
                    id: _this.topic.topic._id,
                    data: (_a = {},
                        _a['status.history'] = {
                            push: true,
                            data: [newHistory]
                        },
                        _a
                    ),
                    type: ['status']
                };
                // Send for update
                _this.topic.updateServerTopic('couchUpdate', data_1, true);
                //this.topic.reloadDisbursement(this.topic.topic._id.split('DMT-')[1]);
                _this.notify.success('CMR data successfully updated, please reload page');
            }
            else {
                _this.notify.error(data);
            }
            var _a;
        });
        this.socket.forward('eligibility.remapEmbargoCheck', this.$scope);
        this.$scope.$on('socket:eligibility.remapEmbargoCheck', function (event, data) {
            if (data.success) {
                _this.topic.reloadDisbursement(_this.topic.topic._id.split('DMT-')[1]);
                _this.notify.success('Embargo Check passed, please reload page');
            }
            else {
                _this.notify.error(data.error);
            }
        });
        this.socket.forward('eligibility.confirmCrossBoardEligibility', this.$scope);
        this.$scope.$on('socket:eligibility.confirmCrossBoardEligibility', function (event, data) {
            if (data.success) {
                _this.topic.reloadDisbursement(_this.topic.topic._id.split('DMT-')[1]);
                _this.notify.success('Cross Border Eligibility confirmed');
            }
            else {
                _this.notify.error(data.error);
            }
        });
        this.socket.forward('eligibility.loadNotification', this.$scope);
        this.$scope.$on('socket:eligibility.loadNotification', function (event, data) {
            if (data.success) {
                _this.notify.success('BP Notification Preview loaded');
                _this.topic.mailPreview = data.previewInfo;
                _this.status.openNotificationPreviewDialog(event, _this.topic, function (err) {
                    if (!err) {
                        _this.topic.sendNotification({
                            opportunityId: _this.topic.topic._id.substring(4),
                            mailData: _this.topic.mailPreview,
                            country: _this.topic.topic.country,
                            statusInfo: {
                                status: _this.topic.topic.status.status_no,
                                subStatus: _this.topic.topic.status.sub_status_no
                            },
                            incentiveGoeDecision: _.get(_this, 'topic.topic.goe.picked', 'Unknown'),
                            isPublicTender: _this.topic.topic.isPublicTender,
                            version: _this.topic.topic.version
                        });
                    }
                });
            }
            else {
                _this.notify.error(data.error);
            }
        });
        this.socket.forward('eligibility.sendNotification', this.$scope);
        this.$scope.$on('socket:eligibility.sendNotification', function (event, data) {
            if (data.success) {
                _this.notify.success('BP Notification sent successfully');
            }
            else {
                _this.notify.error(data.error);
            }
        });
        this.socket.forward('eligibility.refreshSiteIds', this.$scope);
        this.$scope.$on('socket:eligibility.refreshSiteIds', function (event, data) {
            _this.topic.siteIdData = data;
            _this.notify.success('Refreshed Passport Advantage Site Numbers');
        });
        this.socket.forward('config.getListOfAllDisputes', this.$scope);
        this.$scope.$on('socket:config.getListOfAllDisputes', function (event, data) {
            _this.codesLoaded = true;
            if (data.error) {
                return _this.notify.error("Unable to load table data => " + data.error);
            }
            // Output dispute list and filter out oppy which is equal to opened in the browser
            data.data = data.data.filter(function (oppy) { return oppy !== _this.topic.topic._id; });
            _this.reasonCodes = data;
        });
        // this.socket.forward('config.copyOppData', this.$scope);
        // this.$scope.$on('socket:config.copyOppData', (event: ng.IAngularEvent, res: any) => {
        //     if (res.err) {
        //         console.error(res.err);
        //         return this.notify.error(`Error happened while coping opportunity: ${res.err.message}`);
        //     } else {
        //         console.info(res.data);
        //         return this.notify.success(`Copying succeeded.`);
        //     }
        // });
    }
    /**
     * Need to add bold style for parent oppy in dispute list
     * @param {string} element
     * @returns {object}
     */
    ActionMenuController.prototype.setBoldStyleToParent = function (element) {
        if (element === this.topic.topic.dispute_details.parent) {
            return {
                'font-weight': '500'
            };
        }
    };
    ActionMenuController.prototype.getListOfAllDisputes = function () {
        this.showDisputeList = false;
        var disputeData = {
            originalOppy: this.topic.topic.opp,
            parentOppy: this.topic.topic.dispute_details.parent
        };
        this.admin.getListOfAllDisputes(disputeData);
    };
    ActionMenuController.prototype.viewDispute = function (event, dispute_id) {
        this.$state.go('detail.general', {
            id: dispute_id.substring(4)
        });
    };
    ActionMenuController.prototype.newLine = function (index, cols) {
        return index % cols === 0;
    };
    ActionMenuController.prototype.dispute = function (event) {
        var _this = this;
        var types = [
            { name: 'Dispute', desc: 'For situations where the Business Partner is disputing the Rejection or Payment details' },
            { name: 'Appeal', desc: 'For situations where the Business Partner is disputing the GOE decision' },
            { name: 'Exception', desc: 'For situations where an approved exception has been granted by Finance' },
            { name: 'Investment Review', desc: 'For situations where Business Partner is requesting additional review of the eligibility decision of his deal registration' },
            { name: 'Clawback', desc: 'For situations where IBM needs to recover issued bonus' },
            { name: 'Out of Policy', desc: 'For situations where an Out of Policy claim has been raised and approved' }
        ];
        var copySections = {
            'swdr': [
                { section: 'Attachments' },
                { section: 'Comments' },
                { section: 'BP Authorization Check Results' },
                { section: 'Incentive Government Check Results' },
                //{ section: 'Customer Designation' },
                { section: 'BP Duplicate Check' },
            ],
            '3': [
                { section: 'Completeness Checklist' },
                { section: 'Government Check Results' },
                { section: 'Duplicate Check Results' },
                { section: 'Eligibility Attachments' },
                { section: 'Comments' }
            ],
            '4': [
                { section: 'Validation Attachments' },
                { section: 'Comments' }
            ]
        };
        if (!this.isVersion5AndMore()) {
            copySections['swdr'].push({ section: 'Customer Designation' });
            if (!this.isVersion4AndMore()) {
                copySections['swdr'].push({ section: 'IBM Duplicate Check' });
                copySections['swdr'].push({ section: 'New Client Determination' });
            }
        }
        var statusMap = { 3: [3], 4: [3, 4] };
        var isOppyValRejected;
        var stats = [];
        var CVRType = [];
        var incents;
        if (this.isVersion4AndMore()) {
            incents = ['SSA', 'Solution', 'Focus', 'Growth', 'Ctl'];
        }
        else {
            incents = ['SSA', 'Solution', 'NewClient'];
        }
        var currStatusDesc = this.config.getMainStatusByMainStatusNo(this.topic.topic.status.status_no).txt;
        var validationRules;
        var lastStatus;
        var sapResultSrc;
        if ([8, 9].includes(this.topic.topic.status.status_no)) {
            // If Closed or Rejected
            var field = this.topic.topic.status.status_no === 8
                ? ['rejection_details', 'reject_status']
                : ['close_details', 'close_status'];
            lastStatus = this.topic.topic.status[field[0]] && this.topic.topic.status[field[0]][field[1]]
                ? this.topic.topic.status[field[0]][field[1]]
                : 3;
        }
        else {
            // If Paid (7) or Validation (4)
            lastStatus = this.topic.topic.status.status_no;
        }
        var lastStatusDesc = this.config.getMainStatusByMainStatusNo(lastStatus).txt;
        // Create solutionDecision object with incents and bool: false, for each one
        _.forEach(incents, function (e) {
            CVRType.push({ name: e, bool: false });
        });
        // Add true in current checkbox
        switch (this.topic.topic.solutionDecision) {
            case 'Solution and SSA':
                CVRType[0].bool = true;
                break;
            case 'Solution only':
                CVRType[1].bool = true;
                break;
            default: CVRType[0].bool = true;
        }
        //If calc had been started, add attachments option, too
        // TODO: update for calculation v2
        if (this.topic.topic.calculation) {
            copySections['4'].push({ section: 'Calculation & Payment Attachments' });
        }
        //Get the available statuses based on the last status (if rejected or closed) or current status if Paid
        var newStartStatuses = statusMap[lastStatus] || [3, 4];
        // Check if oppty was rejected in validation
        if (this.topic.topic.status.status_no === 8 && this.topic.topic.status.sub_status_no === 4) {
            isOppyValRejected = true;
            validationRules = false;
        }
        else {
            isOppyValRejected = false;
            validationRules = true;
        }
        angular.forEach(newStartStatuses, function (stat) {
            stats.push({ no: stat, txt: _this.config.getMainStatusByMainStatusNo(stat).txt });
        });
        var dCodes = this.settings.misc_codes.dispute_codes.codes.reduce(function (dCodes, code) {
            !dCodes[code.type]
                ? Object.assign(dCodes, (_a = {}, _a[code.type] = [code], _a))
                : dCodes[code.type].push(code);
            return dCodes;
            var _a;
        }, {});
        // Get the program profile dispute codes
        // let's be sure calculation object is there, and sapResult... it may not be if rejected pre Validation
        // const dCodes: any = this.settings.getProgramProfile(this.topic.topic.program).dispute_codes; // old logic
        // TODO: update for calculation v2
        if (this.topic.topic.calculation && this.topic.topic.calculation.sapResult) {
            sapResultSrc = typeof this.topic.topic.calculation.sapResult === 'string'
                ? this.topic.topic.calculation.sapResult.replace(/[']/g, '')
                : this.topic.topic.calculation.sapResult;
        }
        else {
            sapResultSrc = null;
        }
        // Validate swdr sections
        var checkExistence = this.topic.checksData.checkExistence;
        var swdrValidatedSects = {
            'BP Authorization Check Results': !checkExistence.checks,
            'Incentive Government Check Results': false,
            //'Customer Designation': !checkExistence.checks,
            'BP Duplicate Check': !checkExistence.DUP_MySA_check,
            'Attachments': false,
            'Comments': false
        };
        if (!this.isVersion5AndMore()) {
            swdrValidatedSects['Customer Designation'] = !checkExistence.checks;
            if (!this.isVersion4AndMore()) {
                swdrValidatedSects['IBM Duplicate Check'] = !checkExistence.DUP_SC_check;
                swdrValidatedSects['New Client Determination'] = !checkExistence.NC_check;
            }
        }
        var items = {
            disBundle: {
                uiVersion: this.topic.topic.version,
                CVRType: CVRType,
                currStatus: currStatusDesc,
                disputeCode: dCodes[types[0].name][0],
                disputeCodes: dCodes,
                disputeType: types[0],
                id: this.topic.topic._id,
                Itrtype: 'C',
                lastStatus: lastStatusDesc,
                lastStatusNo: lastStatus,
                paid: this.topic.topic.status.status_no === 7 ? true : false,
                sapResult: sapResultSrc,
                sections: copySections,
                sects2: {},
                swdrValidatedSects: swdrValidatedSects,
                swdrSects: {},
                status: stats[stats.length - 1],
                statuses: stats,
                types: types,
                isOppyValRejected: isOppyValRejected,
                validationRules: validationRules,
                solutionDecision: this.topic.topic.solutionDecision
            }
        };
        if (this.topic.topic.version && this.topic.topic.version >= 3 && items.disBundle.status.txt === 'Eligibility') {
            for (var sect in swdrValidatedSects) {
                if (swdrValidatedSects[sect]) {
                    items.disBundle.swdrSects[sect] = true;
                }
            }
        }
        this.Dialog.updateValidForm(event, items, 'dispute-dialog.html').then(function (dResult) {
            if (dResult.locals.disBundle.solutionDecision === 'Solution only') {
                for (var _i = 0, _a = dResult.locals.disBundle.CVRType; _i < _a.length; _i++) {
                    var element = _a[_i];
                    if ((element.name !== 'Solution' && element.name !== 'Engagement') && element.bool) {
                        dResult.disBundle.status.no = 3;
                    }
                }
            }
            // If Eligibility was selected, remove cvrTypes array and validationRules
            if (dResult.locals.disBundle.status.no === 3) {
                delete dResult.disBundle.CVRType;
                dResult.disBundle.validationRules = false;
            }
            // Filter out unnecessary checkboxes
            if (dResult.locals.disBundle.status.no === 4) {
                dResult.disBundle.CVRType = dResult.disBundle.CVRType.filter(function (e) { return e.bool; });
            }
            if (!angular.isUndefined(dResult)) {
                //Get the sub-status based on the new status and the Pending BPSO
                var newSubStatus = _this.config.getSubStatusByDesc(dResult.locals.disBundle.status.no, 'Pending BPSO');
                dResult.locals.disBundle.substatus = newSubStatus;
                console.info(dResult.locals.disBundle);
                _this.status.disableApproveButtons = true;
                _this.status.createDispute(dResult.locals.disBundle);
            }
        }).catch(function () {
            _this.status.disableApproveButtons = false; //User cancelled
        });
    };
    ActionMenuController.prototype.refreshChecklists = function (event) {
        var _this = this;
        var checklists = [{ name: 'Completeness Checklist', cl: 'complcl', stats: [3], refresh: false, info: 'Eligibility Tab' },
            { name: 'GOE Checklist', cl: 'complcl2', stats: [3], refresh: false, info: 'Eligibility Tab' },
            { name: 'Duplicate Search Checklist', cl: 'complcl3', stats: [3], refresh: false, info: 'Eligibility Tab' },
            { name: 'Validation Checklist', cl: 'complcl_validation', stats: [3, 4], refresh: false, info: 'Sales Order Validation Tab' },
            { name: 'Calculation Checklist', cl: 'complcl_calculation', stats: [3, 4], refresh: false, info: 'Calculation & Payment Tab' },
            { name: 'Payment Checklist', cl: 'complcl_payment', stats: [3, 4], refresh: false, info: 'Calculation & Payment Tab' },
        ];
        var items = {
            chkBundle: {
                selected: 0,
                //Function to count how many selected...probably a fancy way to do this
                tick: function (ckkBundle) {
                    ckkBundle.selected = 0;
                    ckkBundle.cls.forEach(function (cl) {
                        if (cl.refresh) {
                            ckkBundle.selected++;
                        }
                    });
                },
                status_no: this.topic.topic.status.status_no,
                cls: checklists,
                newLine: function (index, cols) {
                    if (index % cols === 0) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            }
        };
        this.Dialog.updateValidForm(event, items, 'refreshcl-dialog.html').then(function (dResult) {
            //Build the object to be sent
            var chkBundle = {
                id: _this.topic.topic._id,
                cls: [],
                comments: dResult.locals.chkBundle.comments,
                bID: _this.topic.topicBrowserID //Need this to be able to utilise the update.partial socket
            };
            angular.forEach(dResult.locals.chkBundle.cls, function (checklist) {
                if (checklist.refresh) {
                    chkBundle.cls.push(checklist);
                }
            });
            _this.status.disableApproveButtons = true;
            _this.status.refreshChecklists(chkBundle);
        }).catch(function () {
            _this.status.disableApproveButtons = false; //User cancelled
        });
    };
    ActionMenuController.prototype.resolveError = function (event) {
        var _this = this;
        this.topic.setTempFromTopicPart('errors');
        this.status.resolveError(event, this.topic.temp.errors, function (err, resolveBundle) {
            if (!err) {
                _this.topic.temp.errors = resolveBundle.errors;
                _this.topic.sendForUpdateGeneral(['errors'], true, false);
            }
        });
    };
    ActionMenuController.prototype.rollBack = function (event) {
        var _this = this;
        this.status.rollbackStatus(event, this.topic, function (err, rollBundle) {
            if (!err) {
                _this.topic.sendForUpdate(['status'], rollBundle.action, rollBundle.comments, false);
            }
        });
    };
    ActionMenuController.prototype.updatePaymentDetails = function (event) {
        var _this = this;
        this.status.updatePaymentDetailsStatus(event, this.topic, function (err, locals) {
            if (!err) {
                _this.topic.updateServerTopic('updatePaymentDetails', locals, true);
            }
        });
    };
    ActionMenuController.prototype.moveToPaid = function (event) {
        var _this = this;
        this.status.moveToPaidStatus(event, this.topic, function (err, locals) {
            if (!err) {
                var updateObject = {
                    data: (_a = {},
                        _a['invoice_flags'] = {
                            add: true,
                            data: _this.topic.temp.invoice_flags
                        },
                        _a
                    ),
                    editOption: undefined,
                    id: _this.topic.topic._id,
                    type: ['invoice_flags']
                };
                _this.moveToPaidData = {
                    isMoveToPaidAction: true,
                    comment: locals.action
                };
                _this.topic.updateServerTopic('couchUpdate', updateObject, true); // Send it to be saved
            }
            var _a;
        });
    };
    ActionMenuController.prototype.overrideProspectCMR = function (event) {
        var _this = this;
        var item = {
            message: 'Please confirm the CMR should be overridden:',
            dialogName: 'CMR Prospect Override'
        };
        this.status.overrideProspectCMRs(item, event, this.topic, function (err, locals) {
            if (!err) {
                var cmrData = {
                    CMR: locals.CMR,
                    DBG: locals.DBG,
                    DCID: locals.DCID,
                    oldDCID: _this.topic.topic.version >= _this.OPP_VERSION_5 ?
                        _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrDomesticClientId') :
                        _this.getAccountValue('domesticClientId'),
                    oldCMR: _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.incentiveCMRNumber'),
                    id: _this.topic.topic._id.split('DMT-')[1],
                    isAutomaticCheck: locals.isAutomaticCheck,
                    isOverride: locals.isOverride,
                    version: _this.topic.topic.version
                };
                _this.topic.updateChecksResults(cmrData);
            }
        });
    };
    ActionMenuController.prototype.getAccountValue = function (accountName) {
        var generics = _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.generics');
        var accountObj = generics.find(function (generic) { return generic.name === accountName; });
        return accountObj ? accountObj.value : '';
    };
    ActionMenuController.prototype.CmrCdidOverride = function (event) {
        var _this = this;
        var item = {
            message: 'Please confirm the CMR/CDID should be update:',
            dialogName: 'Update CMR/DCID'
        };
        this.status.overrideProspectCMRs(item, event, this.topic, function (err, locals) {
            if (!err) {
                var cmrData = {
                    CMR: locals.CMR,
                    DBG: locals.DBG,
                    DCID: locals.DCID,
                    oldDCID: _this.topic.topic.version >= _this.OPP_VERSION_5 ?
                        _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrDomesticClientId') :
                        _this.getAccountValue('domesticClientId'),
                    oldCMR: _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.incentiveCMRNumber'),
                    id: _this.topic.topic._id.split('DMT-')[1],
                    isAutomaticCheck: locals.isAutomaticCheck,
                    isOverride: locals.isOverride,
                    version: _this.topic.topic.version
                };
                _this.topic.updateChecksResults(cmrData);
            }
        });
    };
    ActionMenuController.prototype.passEmbargoCheck = function (event) {
        var _this = this;
        this.status.passEmbargoCheck(event, this.topic, function (err) {
            if (!err) {
                _this.topic.remapAllChecks({ id: _this.topic.topic._id.substring(4) });
            }
        });
    };
    ActionMenuController.prototype.openNotificationPreview = function (event) {
        this.topic.loadNotificationPreview({
            id: this.topic.topic._id.substring(4),
            templateId: this.topic.topic.bpNotificationTemplateInfo.templateId
        });
    };
    ActionMenuController.prototype.passCrossBoardEmeaCheck = function (event) {
        var _this = this;
        this.status.passCrossBoardEmeaCheck(event, this.topic, function (err) {
            if (!err) {
                _this.topic.confirmCrossBoardEligibility({ id: _this.topic.topic._id.substring(4) });
            }
        });
    };
    ActionMenuController.prototype.passCountryManualReview = function (event) {
        var _this = this;
        this.status.passCountryManualReview(event, this.topic, function (err) {
            if (!err) {
                _this.topic.remapAllChecks({ id: _this.topic.topic._id.substring(4) });
            }
        });
    };
    ActionMenuController.prototype.updateReAssignUser = function (event) {
        var _this = this;
        this.status.reAssignUser(event, this.topic, function (err, locals) {
            if (!err) {
                _this.topic.updateServerTopic('updateReAssignUser', locals, true);
            }
        });
    };
    ActionMenuController.prototype.close = function (event) {
        var _this = this;
        this.status.closeDisbursement(event, this.topic, function (err, closeBundle) {
            if (!err) {
                _this.topic.sendForUpdate(['status'], closeBundle.action, closeBundle.comments, false);
            }
        });
    };
    ActionMenuController.prototype.rej = function (event) {
        var _this = this;
        this.status.rejectDisbursement(event, this.topic, function (err, rejBundle) {
            if (!err) {
                _this.topic.sendForUpdate(['status'], rejBundle.action, rejBundle.comments, false);
            }
        });
    };
    /**
     * Need to ensure the approval amount in USD is set...if not, user need to refresh calcs
     * in order to set them.  This should all be backend really, but major rewrite would be needed
     *
     * @param {*} event
     * @returns {boolean}
     * @memberof ActionMenuController
     */
    ActionMenuController.prototype.ensureApprovalAmountSet = function (event, action) {
        // If all is well it means both bonusTotalCurr and the bonusTotalUSD value should be set
        // TODO: update for calculation v2
        if (angular.isDefined(this.topic.topic.calculation.bonusTotalCurr) && this.topic.topic.calculation.bonusTotalCurr !== '???' &&
            angular.isDefined(this.topic.topic.calculation.bonusTotalUSD)) {
            return true;
        }
        //Kill...
        var items = {
            icon: 'WARN',
            message: 'The Approval Amount in USD does not appear to have been set correctly.  Hover over the red Approval Required icon for details, ' +
                'and reperform the Calculations via the \'Refresh\' button to fix. &nbsp;If that does not resolve the issue, contact the ' +
                'DMT System Administrators for guidance.',
            title: action
        };
        //Block
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            return false;
        });
    };
    ActionMenuController.prototype.checkStageCompleteForApproval = function () {
        var _this = this;
        // some scenarios statusComplete is not getting updated as expected. below is the fall back.
        var status = this.topic.topic.status.status_no;
        if (status !== 4) {
            return false;
        }
        // If calculation node is present, validation has been completed
        if (this.topic.topic.calculation && this.topic.topic.complete.calculation && this.topic.topic.complete.complcl_calculation) {
            return true;
        }
        else {
            // check if all validation sections are completed
            var validThumbSections = ['sap', 'goePick_valid', 'goeCheck_valid', 'complcl_validation',
                'complcl_calculation', 'calculation'];
            var isValidCompleted = validThumbSections.filter(function (secName) { return !_this.topic.topic.complete[secName]; }).length === 0;
            return isValidCompleted;
        }
        return false;
    };
    ActionMenuController.prototype.checkStageComplete = function (event, action) {
        var status = this.topic.topic.status.status_no;
        if (this.topic.topic.complete.statusComplete[status] || (action === 'Submit for Approval' && this.checkStageCompleteForApproval())) {
            return true;
        }
        else {
            //Prepare to ask question...based on event
            var items = {
                icon: 'WARN',
                message: 'Several sections are still to be completed before you can move to the next stage in the process.' +
                    ' &nbsp;Please check for any red thumbs as well as resolving any general errors (ie: pink banner) before attempting again.',
                title: action
            };
            //Block
            this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                return false;
            });
        }
    };
    /**
     * nonAppStatusChange - Function triggered when user changes main status - excluding Approval stages
     *
     * @param  {type} event: any  browser event
     * @param  {type} action: any action event, ie: Initiate Validation, Reject Disbursement etc
    */
    ActionMenuController.prototype.nonAppStatusChange = function (event, action) {
        var _this = this;
        if (!this.checkStageComplete(event, action)) {
            return;
        }
        //Prepare to ask question...based on event
        var items = {
            icon: 'QUESTION',
            message: null,
            title: action
        };
        var isInitalValidation = action === 'Initiate Validation';
        var template = isInitalValidation
            ? 'initiate-validation-dialog.html'
            : 'confirm-prompt.html';
        //Ask it...
        this.Dialog.updateValidForm(event, items, template).then(function (dResult) {
            var incentiveType = '';
            if (isInitalValidation) {
                incentiveType = dResult.locals && dResult.locals.incentiveType;
            }
            var clickedYes = isInitalValidation ? incentiveType : dResult.confirm;
            //If clicked no
            if (!clickedYes) {
                return; //Die
            }
            //Clicked Yes
            //Call initiateValidation code from Status module...will return a bundle
            _this.status.nonAppStatusChange(event, action, _this.topic.topic.status, function (err, statBundle) {
                //If there was an error, ie: Program Profile missing...
                if (statBundle.error) {
                    _this.displayPrompt(event, statBundle, 'ERROR'); //Display error and die
                }
                else {
                    //Update display
                    _this.topic.temp_ext.status = statBundle.nextStatusDesc;
                    _this.topic.temp_ext.sub_status = statBundle.nextSubStatusDesc;
                    _this.topic.temp_ext.sales_assist = incentiveType;
                    //Make call to save
                    _this.status.mainStatusChange = true;
                    _this.saveStatus(statBundle.action, incentiveType);
                }
            });
        });
    };
    /**
     * displayPrompt - Display ok or confirm prompt to user
     *
     * @param  {type} event: any   browser event
     * @param  {type} bundle: any  status bundle
     * @param  {type} icon: string icon to display, ie: INFO, WARN, ERROR
     */
    ActionMenuController.prototype.displayPrompt = function (event, bundle, icon) {
        var items = {
            icon: icon,
            message: bundle.textContent,
            title: bundle.title
        };
        this.Dialog.openDialog(event, items, DialogService, 'confirm-prompt.html');
    };
    /**
     * openActionMenu - Launch action menu dropdown using MD functions
     *
     * @param  {type} $mdOpenMenu: any ngMaterials open menu object
     * @param  {type} event: any       browser event
     */
    ActionMenuController.prototype.openActionMenu = function ($mdOpenMenu, event) {
        var originatorEv = event;
        $mdOpenMenu(event);
    };
    /**
     * showApprovalDialog - Display the Approval Process overlay which will contain instructions,
     * approvers to select, and comments section
     *
     * @param  {type} event: any     browser event
     * @param  {type} appBundle: any approval stage bundle
     * @param  {type} callback: any  callback function to be returned
     * @return {type}                callback containing the contents of the overlay
     */
    ActionMenuController.prototype.showApprovalDialog = function (event, appBundle, callback) {
        //If approving...add user to the approvers list so they are excluded
        if (['Approve', 'Submit for Approval'].indexOf(appBundle.action) > -1) {
            if (angular.isDefined(this.topic.topic.status.approvals.approvers) && this.topic.topic.status.approvals.approvers.indexOf(this.env.user.email) < 0) {
                this.topic.topic.status.approvals.approvers.push(this.env.user.email);
            }
            else {
                this.topic.topic.status.approvals.approvers = [this.env.user.email];
            }
        }
        appBundle.owner = this.topic.topic.owner; //Add assignee
        //appBundle.excludeList = angular.isDefined(this.topic.topic.status.approvals.approvers) ? this.topic.topic.status.approvals.approvers.concat([this.topic.topic.owner]) : [this.topic.topic.owner]; //Previous approvers and assignee                
        appBundle.excludeList = angular.isDefined(this.topic.topic.status.approvals.approvers) ? this.topic.topic.status.approvals.approvers : []; //Previous approvers
        appBundle.nextStatusObject.users = this.status.cleanApprovers(appBundle.nextStatusObject.users, appBundle.excludeList);
        var title = 'The following users have already approved during the current Approval Process:\n';
        for (var i = 0; i < appBundle.excludeList.length - 1; i++) {
            title += '\n# ' + (i + 1) + ' ' + appBundle.excludeList[i];
            if (i === 0) {
                title += ' - (initiated by)';
            }
        }
        appBundle.prevApprovers = title;
        var items = {
            appBundle: appBundle
        };
        this.Dialog.updateValidForm(event, items, 'approval-dialog.html').then(function (dResult) {
            //Check dialog result var...
            if (!angular.isUndefined(dResult)) {
                return callback(dResult.locals.appBundle);
            }
        });
    };
    ActionMenuController.prototype.finaliseAppStage = function (appBundle, action) {
        //If approver selected and differs from current one (if any)
        if (appBundle.select_approver) {
            if (!appBundle.selected_approver ||
                (appBundle.selected_approver && appBundle.selected_approver.name !== appBundle.select_approver)) {
                //Need to work out email for new approver
                angular.forEach(appBundle.nextStatusObject.users, function (approver) {
                    if (approver.name === appBundle.select_approver) {
                        appBundle.selected_approver = {
                            name: approver.name,
                            email: approver.email
                        };
                    }
                });
            }
        }
        //Update display
        this.topic.temp_ext.status = appBundle.nextStatusDesc;
        this.topic.temp_ext.sub_status = appBundle.nextSubStatusDesc;
        if (appBundle.approvalComplete || this.status.isRollBackAction(action)) {
            this.topic.temp.status.approvals.approval_profile = ''; //Wipe
            this.topic.temp.status.approvals.selected_approver_name = '';
            this.topic.temp.status.approvals.selected_approver_email = '';
        }
        else {
            this.topic.temp.status.approvals.approval_profile = appBundle.nextStatus + '-' + appBundle.nextSubStatus; //Wipe
            this.topic.temp.status.approvals.selected_approver_name = appBundle.selected_approver.name;
            this.topic.temp.status.approvals.selected_approver_email = appBundle.selected_approver.email;
        }
        appBundle.owner = this.topic.topic.owner;
        this.status.appBundle = appBundle; //Set locally so it can be retrieved for email later
        this.status.mainStatusChange = true;
        this.saveStatus(appBundle.action, appBundle.comments);
    };
    ActionMenuController.prototype.saveStatus = function (action, comments) {
        // This needs to be changed in order for the substatus to work nicely
        this.topic.sendForUpdate(['status', 'sales_assist'], action, comments, false);
        //If sending for Initiate Validation and 2nd GOE is gonna be fired, set the socket so the button is disabled
        //if (action === 'Initiate Validation' && this.topic.is2ndGOENeeded()) {
        //this.topic.updatePartialSocketStatus(['cmr_valid'], 'Updating'); //Wouldn't work
        //    this.topic.goeFired = true;
        //}
    };
    ActionMenuController.prototype.app = function (event, action) {
        var _this = this;
        if (action === 'Submit for Approval' && !this.checkStageComplete(event, action)) {
            return;
        }
        if (action === 'Submit for Approval' && !this.ensureApprovalAmountSet(event, action)) {
            return;
        }
        this.status.disableApproveButtons = true;
        this.status.appBundle = null;
        var topicBundle = {
            country: this.topic.topic.country,
            program: this.topic.topic.program,
            status: this.topic.topic.status
        };
        //Call approval process to build the bundle
        //let appBundle: any = this.status.approvalProcess(event, action, this.topic.topic.status);
        this.status.approvalProcess(event, action, topicBundle, function (err, appBundle) {
            _this.status.disableApproveButtons = false;
            //If there was an error, ie: Program Profile missing...
            if (appBundle.error) {
                _this.displayPrompt(event, appBundle, 'ERROR'); //Display error and die
            }
            else {
                //Display dialog with appropriate messages etc
                _this.showApprovalDialog(event, appBundle, function (appBundle) {
                    _this.finaliseAppStage(appBundle, action);
                });
            }
        });
    };
    ActionMenuController.prototype.updateSubstatusSetAside = function (docId, flag, invoice_flags, turnOn) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    docId: docId,
                    flag: flag,
                    invoice_flags: invoice_flags,
                    turnOn: turnOn
                },
                bID: this.topic.topicBrowserID,
                function: 'substatusUpdate',
                scopeBack: this.scopeUpdateSubstatus,
                script: this.invFlagUpdateBackendModuleName,
                token: this.env.user.token,
                email: this.env.user.email
            }
        });
        return;
    };
    ActionMenuController.prototype.refreshSiteIds = function () {
        this.socket.emit('module', {
            module: {
                data: {
                    opportunityId: this.topic.topic._id
                },
                //bID: this.topic.topicBrowserID,
                className: 'SiteIdGate',
                function: 'refreshSiteIdDataClient',
                //scopeBack: 'eligibility.refreshSiteIds',
                script: 'dswSiteId/siteIdGate',
                token: this.env.user.token
            }
        });
        return;
    };
    ActionMenuController.prototype.changeInvFlag = function (event, flag) {
        //flag 0 -> the invoice requested, flag 1 -> the invoice received
        var turnOn;
        if (flag === 0) {
            if (!this.topic.topic.version || this.topic.topic.version < this.OPP_VERSION_3) {
                if (!this.topic.topic.invoice_flags.requested && !this.topic.topic.eu_check) {
                    this.displayPrompt(event, { textContent: 'Unable to raise this flag when "End User Check" is not "Yes".', title: 'Flag setting error' }, 'ERROR');
                    return;
                }
                //#1774 - no need for this check
                // if (this.topic.topic.invoice_flags.requested && this.topic.topic.eu_check.decision === 'Yes') {
                //     this.displayPrompt(event, { textContent: 'Unable to remove this flag when "End User Check" is "Yes".', title: 'Flag setting error' }, 'ERROR');
                //     return;
                // }
                if (!this.topic.topic.invoice_flags.requested && this.topic.topic.eu_check.decision !== 'Yes') {
                    this.displayPrompt(event, { textContent: 'Unable to raise this flag when "End User Check" is not "Yes".', title: 'Flag setting error' }, 'ERROR');
                    return;
                }
            }
            if (this.topic.topic.invoice_flags.requested && (this.topic.topic.invoice_flags.received || this.topic.topic.invoice_flags.submitted)) {
                this.displayPrompt(event, { textContent: 'Unable to remove this flag when "Invoice Received Flag" or "Submitted to Accounts Payable" are raised.', title: 'Flag removal error' }, 'ERROR');
                return;
            }
            this.topic.topic.invoice_flags.requested = !this.topic.topic.invoice_flags.requested;
            if (this.topic.topic.invoice_flags.requested) {
                this.topic.topic.invoice_flags.requestedTimestamp = new Date().getTime();
                this.topic.topic.invoice_flags.requestedFlaggedBy = this.env.user.email;
            }
            else {
                this.topic.topic.invoice_flags.requestedTimestamp = null;
                this.topic.topic.invoice_flags.requestedFlaggedBy = null;
            }
            turnOn = this.topic.topic.invoice_flags.requested;
        }
        else if (flag === 1) {
            if (!this.topic.topic.invoice_flags.received && !this.topic.topic.invoice_flags.requested) {
                this.displayPrompt(event, { textContent: 'Unable to raise this flag when "Invoice Requested Flag" is not raised.', title: 'Flag setting error' }, 'ERROR');
                return;
            }
            if (this.topic.topic.invoice_flags.received && this.topic.topic.invoice_flags.submitted) {
                this.displayPrompt(event, { textContent: 'Unable to remove this flag when "Submitted to Accounts Payable" is raised.', title: 'Flag removal error' }, 'ERROR');
                return;
            }
            this.topic.topic.invoice_flags.received = !this.topic.topic.invoice_flags.received;
            if (this.topic.topic.invoice_flags.received) {
                this.topic.topic.invoice_flags.receivedTimestamp = new Date().getTime();
                this.topic.topic.invoice_flags.receivedFlaggedBy = this.env.user.email;
            }
            else {
                this.topic.topic.invoice_flags.receivedTimestamp = null;
                this.topic.topic.invoice_flags.receivedFlaggedBy = null;
            }
            turnOn = this.topic.topic.invoice_flags.received;
        }
        else if (flag === 2) {
            if (!this.topic.topic.version || this.topic.topic.version < this.OPP_VERSION_3) {
                if (this.topic.topic.iot === 'North America IOT' && (this.topic.topic.eu_check === undefined || this.topic.topic.eu_check.decision !== 'Yes')) {
                    this.displayPrompt(event, { textContent: 'Unable to raise this flag when "End User Check" is not "Yes".', title: 'Flag setting error' }, 'ERROR');
                    return;
                }
            }
            if (!this.topic.topic.invoice_flags.submitted && (!this.topic.topic.invoice_flags.requested || !this.topic.topic.invoice_flags.received)) {
                this.displayPrompt(event, { textContent: 'Unable to raise this flag when "Invoice Requested Flag" or "Invoice Received Flag" are not raised.', title: 'Flag setting error' }, 'ERROR');
                return;
            }
            this.topic.topic.invoice_flags.submitted = !this.topic.topic.invoice_flags.submitted;
            // end user editable mode is updated in detail.payment.eu.check.component.ts by broadcast event sent when topic is updated
            if (this.topic.topic.invoice_flags.submitted) {
                this.topic.topic.invoice_flags.submittedTimestamp = new Date().getTime();
                this.topic.topic.invoice_flags.submittedFlaggedBy = this.env.user.email;
            }
            else {
                // if (this.topic.topic.iot === 'North America IOT' && this.topic.editableComponents && (this.topic.editableComponents.eu_check === undefined || (this.topic.editableComponents.eu_check.editable === false))) {
                //     this.topic.editableComponents.eu_check = { editable: true, editMode: false, socket: '' };
                // }
                this.topic.topic.invoice_flags.submittedTimestamp = null;
                this.topic.topic.invoice_flags.submittedFlaggedBy = null;
            }
            turnOn = this.topic.topic.invoice_flags.submitted;
        }
        this.updateSubstatusSetAside(this.topic.topic._id, flag, this.topic.topic.invoice_flags, turnOn);
    };
    //Roman Tibensky  20171017, Card 789 : Sales Assist flag - Sys Admin function
    ActionMenuController.prototype.changeSalesAssist = function (event) {
        var _this = this;
        var salesOptionLabel = this.getNewUIInfo.uiVersion >= 4 ? 'Sales' : 'CVR Sales';
        var salesAssistOptionLabel = this.getNewUIInfo.uiVersion >= 4 ? 'Sales Assist' : 'CVR Sales Assist';
        var saFlagArray = [
            salesAssistOptionLabel,
            salesOptionLabel,
            'Automatic',
            'NO FLAG',
        ];
        var currentFlag = (this.topic.topic.sales_assist && this.topic.topic.sales_assist.type) ? this.topic.topic.sales_assist.type : 'Automatic';
        var items = { saFlags: saFlagArray, saFlag: currentFlag, original: currentFlag };
        items.saFlags.splice(saFlagArray.indexOf(currentFlag), 1);
        items.saFlag = items.saFlags[0];
        this.Dialog.updateValidForm(undefined, items, 'set-sa-flag-dialog.html').then(function (dResult) {
            if (dResult.confirm) {
                // Set history description
                var desc = 'Incentive Type changed from \'' + currentFlag + '\' to \'' + dResult.saFlag + '\'';
                if (_this.topic.temp.sales_assist && _this.topic.temp.sales_assist.type) {
                    _this.topic.temp.sales_assist.type = dResult.saFlag;
                }
                else {
                    _this.topic.temp.sales_assist = {
                        type: dResult.saFlag
                    };
                }
                // Get history entry
                var newHistory = _this.status.getNewHistoryObject('Incentive Type Change', desc, '-', dResult.comment);
                // Prepare object for $10k
                var data = {
                    id: _this.topic.topic._id,
                    data: (_a = {},
                        _a['sales_assist'] = {
                            add: true,
                            data: _this.topic.temp.sales_assist
                        },
                        _a['status.history'] = {
                            push: true,
                            data: [newHistory]
                        },
                        _a
                    ),
                    type: ['sales_assist', 'status']
                };
                // Send for update
                _this.topic.updateServerTopic('couchUpdate', data, true);
            }
            var _a;
        });
    };
    ActionMenuController.prototype.copyOppData = function (event) {
        alert('DEPRECATED');
        //     const data: { inCurrentStatus: boolean, disputes: string[], choosedDispute: string } = {
        //         choosedDispute: undefined,
        //         disputes: this.topic.topic.disputes,
        //         inCurrentStatus: true,
        //     };
        //     this.Dialog.updateValidForm(event, data, 'copy-uat-dialog.html').then((dResult: any) => {
        //         const dataReq: any = {
        //             dispute: dResult.locals.choosedDispute,
        //             disputes: this.topic.topic.disputes,
        //             inCurrentStatus: dResult.locals.inCurrentStatus,
        //             oppId: this.topic.topic._id,
        //         };
        //         this.socket.emit('module', {
        //             module: {
        //                 application: 'dmt',
        //                 data: dataReq,
        //                 function: 'copyOppData',
        //                 script: '/config/config',
        //                 user: this.env.user
        //             },
        //         });
        //     });
    };
    ActionMenuController.prototype.isVersion4AndMore = function () {
        return this.topic.topic.version > 3;
    };
    ActionMenuController.prototype.isVersion5AndMore = function () {
        return this.topic.topic.version > 4;
    };
    ActionMenuController.$inject = ['config', 'Dialog', 'status', 'topic', '$state', 'settings', 'env', 'socket', '$scope', 'admin', 'notify'];
    return ActionMenuController;
}());
var ActionMenuComponent = (function () {
    function ActionMenuComponent() {
        this.templateUrl = 'action-menu.html';
        this.controllerAs = 'vm';
        this.controller = ActionMenuController;
    }
    return ActionMenuComponent;
}());
angular
    .module('application')
    .component('actionMenu', new ActionMenuComponent());



/**
 * @author Matthew Rogers
 */
var AttachmentController = (function () {
    function AttachmentController($state, $scope, socket, topic, env, settings, notify, $attrs) {
        var _this = this;
        this.$state = $state;
        this.$scope = $scope;
        this.socket = socket;
        this.topic = topic;
        this.env = env;
        this.settings = settings;
        this.notify = notify;
        this.$attrs = $attrs;
        this.lockEnabled = false;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.showAttachment = false;
        this.submitting = true;
        this.sources = {};
        this.fileUploaded = false;
        this.fileList = this.topic.topic.files;
        ;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
        this.socket.forward("attachments.mysa.names", this.$scope);
        this.$scope.$on('socket:attachments.mysa.names', function (event, data) {
            if (_this.isMysaV3()) {
                if (data.type === 'SUCCESS') {
                    if (_this.$attrs.incentive === data.incentive) {
                        _this.fileList = data.files;
                    }
                    return;
                }
                else {
                    console.error(data.message);
                    return _this.notify.error(data.message);
                }
            }
        });
        this.socket.forward("attachments.mysa.comments.save", this.$scope);
        this.$scope.$on('socket:attachments.mysa.comments.save', function (event, data) {
            if (_this.isMysaV3()) {
                //this.topic[this.comp].locked = false;
                _this.topic.updatePartialSocketStatus(_this.updateArray, '');
                if (data.type === 'SUCCESS') {
                    console.log(data.message);
                    return _this.notify.success(data.message);
                }
                else {
                    console.error(data.message);
                    return _this.notify.error(data.message);
                }
            }
        });
    }
    AttachmentController.prototype.showHide = function () {
        this.showAttachment = this.showAttachment ? false : true;
    };
    AttachmentController.prototype.decode = function (file) {
        return decodeURIComponent(file); //Probably not necessary anymore since names are not being stored encoded
    };
    // Prepares the files for file upload
    AttachmentController.prototype.uploadFiles = function (files) {
        this.fileNames = [];
        var fileContent = files;
        // If some files submitted perform the update
        if (fileContent.length > 0) {
            // check that file names are unique
            for (var _i = 0, fileContent_1 = fileContent; _i < fileContent_1.length; _i++) {
                var file = fileContent_1[_i];
                for (var _a = 0, _b = this.topic.topic.files; _a < _b.length; _a++) {
                    var existingFile = _b[_a];
                    if (file.name === existingFile.name) {
                        this.notify.error("File attachment with name '" + file.name + "' already exists");
                        this.edit.editMode = this.topic.cancelEdit(this.comp);
                        return;
                    }
                }
            }
            var i = 0;
            for (var _c = 0, fileContent_2 = fileContent; _c < fileContent_2.length; _c++) {
                var file = fileContent_2[_c];
                this.fileNames[i] = { name: file.name, type: file.type, comment: '' };
                i++;
            }
            this.fileUploaded = true;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'uploadFile',
                    script: 'config/config',
                    data: { files: this.fileNames, id: this.topic.topic._id, type: this.section },
                    files: this.sources,
                    bID: this.topic.topicBrowserID,
                    token: this.env.user.token
                }
            });
        }
        this.edit.editMode = this.topic.cancelEdit(this.comp);
    };
    AttachmentController.prototype.downloadAttachment = function (file) {
        var name = file.pureName ? file.pureName : file.name;
        var type = file.type;
        var version = file.version;
        if (['mysa'].includes(type)) {
            this.downloadMysaAttachment(name, version);
        }
        else if (['si', 'ei', 'ai'].includes(type)) {
            this.downloadMysaAttachment(name, version, type);
        }
        else {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: {
                        id: this.topic.topic._id,
                        name: name
                    },
                    function: 'downloadAttachment',
                    script: '/detail/eligibility/eligibility',
                    token: this.env.user.token
                }
            });
        }
    };
    AttachmentController.prototype.downloadMysaAttachment = function (name, version, type) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    name: name,
                    opportunityId: this.topic.topic._id,
                    version: version,
                    type: type
                },
                function: 'downloadAttachment',
                script: '/mysa-attachments/maGate',
                token: this.env.user.token
            }
        });
    };
    AttachmentController.prototype.showUserData = function (file, visible) {
        file.visible = visible;
    };
    AttachmentController.prototype.getFileList = function () {
        var _this = this;
        //vm.fileList| filter: { type: vm.section }
        return this.fileList.filter(function (fileItem) {
            return _this.section === fileItem.type ||
                (_this.section === 'sampling_SSA' && fileItem.type === 'sampling') ||
                _this.section === 'mysa';
        }); // filtered by type on server for this case
    };
    AttachmentController.prototype.$onInit = function () {
        //The display name, ie: Validation, Eligibility, Find CMR etc
        if (this.$attrs.title) {
            this.title = this.$attrs.title;
        }
        else {
            this.title = this.topic.tabs.short;
        }
        if (this.$attrs.section) {
            this.section = this.$attrs.section;
            this.incentive = this.$attrs.incentive;
        }
        else {
            this.section = this.topic.tabs.short;
        }
        this.comp = "files$" + this.section;
        this.updateArray = [("" + this.comp)];
        this.edit = this.topic.getEditComponent(this.comp);
        //treat mysa version 3 in specific way - file list is located in a separate document
        if (this.isMysaV3()) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topic.topicBrowserID,
                    data: {
                        opportunityId: this.topic.topic._id,
                        types: this.getMysaAttachmentTypes(),
                        incentive: this.$attrs.incentive
                    },
                    function: 'getAttachmentNames',
                    script: 'mysa-attachments/maGate',
                    token: this.env.user.token,
                    email: this.env.user.email
                }
            });
        }
    };
    AttachmentController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                if (this.isMysaV3()) {
                    // save file comments to the specific file in attachments db for mysa for v3
                    var commentsData_1 = {
                        opportunityId: this.topic.topic._id,
                        type: this.comp,
                        fileComments: []
                    };
                    angular.forEach(this.fileList, function (file) {
                        commentsData_1.fileComments.push({ name: file.pureName, version: file.version, comment: file.comment });
                    });
                    this.socket.emit('module', {
                        module: {
                            application: 'dmt',
                            bID: this.topic.topicBrowserID,
                            data: commentsData_1,
                            function: 'saveAttachmentComments',
                            script: 'mysa-attachments/maGate',
                            token: this.env.user.token
                        }
                    });
                }
                else {
                    // standard behaviour
                    this.topic.sendForUpdateFiles(this.comp, false);
                }
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPartFiles(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    AttachmentController.prototype.commentChange = function (fileName) {
        angular.forEach(this.topic.temp.files, function (file) {
            if (file.name === fileName) {
                file.modified = true;
            }
        });
    };
    AttachmentController.prototype.isMysaV3 = function () {
        return ['mysa'].includes(this.$attrs.section) && this.topic.checksData && this.topic.checksData.uiVersion >= this.OPP_VERSION_3;
    };
    AttachmentController.prototype.getMysaAttachmentTypes = function () {
        var types; // mysa attachment type
        if (this.topic.topic.version >= this.OPP_VERSION_4) {
            if (this.$attrs.incentive) {
                if (this.$attrs.incentive === 'Solution') {
                    types = ['ei', 'ai'];
                }
                else if (this.$attrs.incentive === 'SSA') {
                    types = ['si', 'ai'];
                }
                else {
                    types = ['ei', 'si', 'ai'];
                }
            }
        }
        if (this.topic.topic.version === this.OPP_VERSION_4) {
            if (!types) {
                types = [];
            }
            types.push('mysa');
        }
        return types;
    };
    AttachmentController.$inject = ['$state', '$scope', 'socket', 'topic', 'env', 'settings', 'notify', '$attrs'];
    return AttachmentController;
}());
var AttachmentComponent = (function () {
    function AttachmentComponent() {
        this.templateUrl = 'attachment.html';
        this.controllerAs = 'vm';
        this.controller = AttachmentController;
    }
    return AttachmentComponent;
}());
angular
    .module('application')
    .component('attachmentSection', new AttachmentComponent());



/**
 * @author Dmitry Mitsaliuk
 */
var MysaAttachmentController = (function () {
    function MysaAttachmentController($scope, socket, topic, env) {
        this.$scope = $scope;
        this.socket = socket;
        this.topic = topic;
        this.env = env;
        this.showAttachment = false;
        this.fetchMysaData = true;
        this.profileLoaded = false;
    }
    MysaAttachmentController.prototype.showHide = function () {
        var _this = this;
        this.showAttachment = this.showAttachment ? false : true;
        if (this.fetchMysaData) {
            this.socket.forward('getMysaAttachments', this.$scope);
            this.$scope.$on('socket:getMysaAttachments', function (event, data) {
                if (angular.isDefined(data.error)) {
                    _this.serverError = data.error;
                }
                else {
                    _this.data = data;
                    _this.profileLoaded = true;
                }
            });
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: {
                        id: this.topic.topic._id
                    },
                    function: 'getMysaAttachments',
                    script: 'config/config',
                    token: this.env.user.token
                }
            });
        }
        this.fetchMysaData = false;
    };
    MysaAttachmentController.$inject = ['$scope', 'socket', 'topic', 'env'];
    return MysaAttachmentController;
}());
var MysaAttachmentComponent = (function () {
    function MysaAttachmentComponent() {
        this.templateUrl = 'mysaattachment.html';
        this.controllerAs = 'vm';
        this.controller = MysaAttachmentController;
    }
    return MysaAttachmentComponent;
}());
angular
    .module('application')
    .component('attachmentMysaSection', new MysaAttachmentComponent());



/**
 * @author Ilya Aderiho
 */
var BpNotificationsController = (function () {
    function BpNotificationsController($state, $scope, socket, topic, env, settings, notify, $attrs, status) {
        var _this = this;
        this.$state = $state;
        this.$scope = $scope;
        this.socket = socket;
        this.topic = topic;
        this.env = env;
        this.settings = settings;
        this.notify = notify;
        this.$attrs = $attrs;
        this.status = status;
        this.lockEnabled = false;
        this.OPP_VERSION_3 = 3;
        this.showBpNotifications = false;
        this.notificationsArray = [];
        this.submitting = true;
        this.sources = {};
        this.fileUploaded = false;
        this.fileList = this.topic.topic.files;
        ;
        this.socket.forward("eligibility.extractNotifications", this.$scope);
        this.$scope.$on('socket:eligibility.extractNotifications', function (event, data) {
            if (data.success) {
                _this.notificationsArray = data.data;
            }
        });
    }
    BpNotificationsController.prototype.showHide = function () {
        this.showBpNotifications = this.showBpNotifications ? false : true;
    };
    BpNotificationsController.prototype.showBpNotification = function (item, event) {
        var data = {
            email: item.mailData.email.join(', '),
            from: item.mailData.from,
            subject: item.mailData.subject,
            html: item.mailData.html
        };
        this.status.displayNotificationPreview(event, data, (function (err) {
        }));
    };
    BpNotificationsController.prototype.downloadAttachment = function (attachment) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    name: attachment
                },
                function: 'downloadBpNotificationAttachment',
                script: '/mysa-attachments/maGate',
                token: this.env.user.token
            }
        });
    };
    BpNotificationsController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                bID: this.topic.topicBrowserID,
                data: { opportunityId: this.topic.topic._id.substring(4) },
                function: 'extractOpportunityNotifications',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token
            }
        });
    };
    BpNotificationsController.$inject = ['$state', '$scope', 'socket', 'topic', 'env', 'settings', 'notify', '$attrs', 'status'];
    return BpNotificationsController;
}());
var BpNotificationsComponent = (function () {
    function BpNotificationsComponent() {
        this.templateUrl = 'bp-notifications.html';
        this.controllerAs = 'vm';
        this.controller = BpNotificationsController;
    }
    return BpNotificationsComponent;
}());
angular
    .module('application')
    .component('bpNotificationsSection', new BpNotificationsComponent());



/**
 * @author Matthew Rogers.
 */
var close_reasonBind = { parent: '=' };
var CloseReasonSelectController = (function () {
    function CloseReasonSelectController(socket, $scope, env, admin) {
        var _this = this;
        this.socket = socket;
        this.$scope = $scope;
        this.env = env;
        this.admin = admin;
        this.codesLoaded = false;
        //declare listener for response from the service
        this.socket.forward('config.misc_codes_by_type', this.$scope);
        this.$scope.$on('socket:config.misc_codes_by_type', function (event, data) {
            if (angular.isDefined(data)) {
                _this.reasonCodes = data;
                _this.codesLoaded = true;
            }
        });
    }
    CloseReasonSelectController.prototype.$onInit = function () {
        this.admin.getMiscCodesByType('closed_codes');
    };
    CloseReasonSelectController.$inject = ['socket', '$scope', 'env', 'admin'];
    return CloseReasonSelectController;
}());
var CloseReasonSelectComponent = (function () {
    function CloseReasonSelectComponent() {
        this.templateUrl = 'close-reason-select.html';
        this.bindings = close_reasonBind;
        this.controller = CloseReasonSelectController;
    }
    return CloseReasonSelectComponent;
}());
angular
    .module('application')
    .component('closeReasonSelect', new CloseReasonSelectComponent());



var CtlSoInformationController = (function () {
    function CtlSoInformationController(topic, Dialog, env, moment) {
        this.topic = topic;
        this.Dialog = Dialog;
        this.env = env;
        this.moment = moment;
        this.comp = 'ctl_so';
    }
    CtlSoInformationController.prototype.$onInit = function () {
        this.data = {};
        this.readModel = {};
        this.editModel = {};
        this.billingFrequencyOptions = [
            {
                key: 'A', value: 'Annual'
            },
            {
                key: 'M', value: 'Month'
            },
            {
                key: 'U', value: 'Upfront'
            }
        ];
        if (this.topic && this.topic.topic.ctl_so) {
            this.data.lengthOfTerm = this.topic.topic.ctl_so.lengthOfTerm;
            this.data.billingFrequency = this.topic.topic.ctl_so.billingFrequency;
            this.data.startDate = this.topic.topic.ctl_so.startDate;
            this.data.billingDate = this.topic.topic.ctl_so.billingDate;
        }
        this.restoreEditModel();
        this.edit = this.topic.getEditComponent(this.comp);
        this.canClickButton(); // Set who can click the Submit and Edit buttons
        this.syncReadModel();
    };
    CtlSoInformationController.prototype.syncReadModel = function () {
        var _this = this;
        this.readModel.lengthOfTerm = this.data.lengthOfTerm ? String(this.data.lengthOfTerm) : '-';
        this.readModel.billingFrequencyLabel = this.billingFrequencyOptions.filter(function (opt) { return opt.key === _this.data.billingFrequency; }).map(function (opt) { return opt.value; }).pop() || '-';
        var monDiff = this.diffInMonths(this.data.startDate, this.data.billingDate, true);
        this.readModel.billingMonth = monDiff ? String(monDiff) : '-';
    };
    CtlSoInformationController.prototype.inlineDataWithUI = function () {
        this.data.lengthOfTerm = this.editModel.lengthOfTerm || undefined;
        this.data.billingFrequency = this.editModel.billingFrequency || undefined;
        this.data.startDate = this.formatDate(this.startDate);
        this.data.billingDate = this.formatDate(this.billingDate);
        return this.data;
    };
    CtlSoInformationController.prototype.restoreEditModel = function () {
        this.editModel.lengthOfTerm = this.data.lengthOfTerm || undefined;
        this.editModel.billingFrequency = this.data.billingFrequency || undefined;
        this.editModel.startDate = this.data.startDate; //this.formatDate(this.startDate);
        this.editModel.billingDate = this.data.billingDate; //this.formatDate(this.billingDate);
        this.startDate = this.toDate(this.data.startDate);
        this.billingDate = this.toDate(this.data.billingDate);
    };
    CtlSoInformationController.prototype.diffInMonths = function (dateValueFrom, dateValueTo, includedBorder) {
        if (!dateValueFrom || !dateValueTo) {
            return undefined;
        }
        var momFrom = this.moment.utc(dateValueFrom, CtlSoInformationController.BILLING_DATE_FORMAT);
        var momTo = this.moment.utc(dateValueTo, CtlSoInformationController.BILLING_DATE_FORMAT);
        var diffInMonths = (momTo.format('YYYY') - momFrom.format('YYYY')) * 12
            + (momTo.format('MM') - momFrom.format('MM'));
        if (diffInMonths < 0) {
            return undefined;
        }
        return diffInMonths + (includedBorder ? 1 : 0);
    };
    CtlSoInformationController.prototype.canClickButton = function () {
        this.canClick = false;
        // If user is bpso admin or system admin
        if (this.env.user.access.bpsoAdmin ||
            this.env.user.access.systemAdmin) {
            this.canClick = true; // Enable submit and refresh buttons
        }
    };
    CtlSoInformationController.prototype.showErrorDlg = function (msg) {
        var items = {
            icon: 'ERROR',
            message: msg,
            title: 'Saving Error'
        };
        this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
            return;
        });
    };
    CtlSoInformationController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            var hasError = !!this.termError || !!this.billingError || !!this.frequencyError;
            if (hasError) {
                this.showErrorDlg('Please, fix incorrect CTL SO fields.');
                return;
            }
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                this.inlineDataWithUI();
                var updateObject = {
                    data: {
                        ctl_so: {
                            add: true,
                            data: this.data
                        }
                    },
                    editOption: undefined,
                    id: this.topic.topic._id,
                    type: ['ctl_so']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true);
                this.syncReadModel();
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            if (this.topic.temp.status.status_no !== 4 || !this.topic.getEditComponent('ctl_so')) {
                this.showErrorDlg('It is not allowed to edit CTL SO at the current stage.');
                return;
            }
            this.restoreEditModel();
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.restoreEditModel();
            this.syncReadModel();
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
        this.onChange();
    };
    CtlSoInformationController.prototype.formatDate = function (date) {
        return date ? this.moment(date).format(CtlSoInformationController.BILLING_DATE_FORMAT) : undefined;
    };
    CtlSoInformationController.prototype.toDate = function (dateStr) {
        return dateStr ? this.moment(dateStr, CtlSoInformationController.BILLING_DATE_FORMAT).toDate() : undefined;
    };
    CtlSoInformationController.prototype.onChange = function () {
        this.checkTerm();
        this.checkFrequency();
        this.checkBillingDates();
    };
    CtlSoInformationController.prototype.checkTerm = function () {
        this.termError = this.editModel.lengthOfTerm ? '' : "* 'Length of term' is invalid.";
    };
    CtlSoInformationController.prototype.checkFrequency = function () {
        this.frequencyError = this.editModel.billingFrequency ? '' : "* 'Billing frequency' is invalid.";
    };
    CtlSoInformationController.prototype.checkBillingDates = function () {
        var err = '';
        if (angular.isUndefined(this.startDate) || this.startDate === null || !angular.isDate(this.startDate)) {
            err = "* Please enter 'Start Date'<br>";
        }
        if (angular.isUndefined(this.billingDate) || this.billingDate === null || !angular.isDate(this.billingDate)) {
            err += "* Please enter 'Billing Date'";
        }
        if (!err) {
            var range = Math.round(this.billingDate - this.startDate);
            if (range < 0) {
                err = '* The Start/Billing Date range is invalid.';
            }
        }
        this.billingError = err;
    };
    CtlSoInformationController.$inject = ['topic', 'Dialog', 'env', 'moment'];
    CtlSoInformationController.BILLING_DATE_FORMAT = 'YYYYMMDD';
    return CtlSoInformationController;
}());
var CtlSoInformationComponent = (function () {
    function CtlSoInformationComponent() {
        this.templateUrl = 'ctl-so-information.html';
        this.controllerAs = 'vm';
        this.controller = CtlSoInformationController;
    }
    return CtlSoInformationComponent;
}());
angular
    .module('application')
    .component('ctlSoInformation', new CtlSoInformationComponent());



/**
 * @author Ivan Toth.
 */
var CommentController = (function () {
    function CommentController(topic, Dialog, $state, settings, $attrs) {
        this.topic = topic;
        this.Dialog = Dialog;
        this.$state = $state;
        this.settings = settings;
        this.$attrs = $attrs;
        this.comp = 'comments'; // + $<active tabname>
        this.updateArray = ['comments']; //+ $<active tabname>
        this.visible = false;
    }
    ;
    /**
     * Removed the detail. part, so I get the active tab name
     */
    CommentController.prototype.$onInit = function () {
        if (this.$attrs.section) {
            this.section = this.$attrs.section;
            this.activeTab = this.section;
        }
        else {
            this.section = this.topic.tabs.short;
            this.activeTab = this.$state.current.name.replace('detail.', '');
        }
        this.comp = 'comments$' + this.section;
        this.updateArray = ['comments$' + this.section];
        if (this.topic.topic.comments[this.section] && this.topic.topic.comments[this.section].length) {
            this.topic.topic.comments[this.section] = this.topic.topic.comments[this.section].sort(function (a, b) { return a.time.localeCompare(b.time); });
        }
    };
    /**
     * Toggles the visibility of the comments table
     */
    CommentController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    /**
     * adds a comment based on which tab, the component was clicked. It takes the activeTab from the state name.
     * calls a dialog where you can insert a comment. In case cancel was pressed nothing happens
     * After submitted comment, I call the sendForUpdateGeneral to start the process of uploading
     * @param event - in html I'm passing the $event.
     */
    CommentController.prototype.addComment = function (event) {
        var _this = this;
        var items;
        //Here to add the comment into the server
        //this.topic.clearTempComments();
        if (!this.$attrs.section) {
            this.activeTab = this.topic.tabs.short;
        }
        items = { dialogName: this.activeTab };
        //Ensure the comments.object exists on the topic...and if not, add it
        var objArray = this.comp.split('$');
        if (objArray.length === 2 && angular.isUndefined(this.topic.topic[objArray[0]][objArray[1]])) {
            this.topic.topic[objArray[0]][objArray[1]] = [];
        }
        this.Dialog.updateValidForm(event, items, 'detail-comment-dialog.html').then(function (dResult) {
            if (!angular.isUndefined(dResult)) {
                if (_this.topic.updatePartialSocketStatus(_this.updateArray, 'Updating')) {
                    _this.topic.setTempFromTopicPart(_this.comp);
                    _this.topic.temp.comments[dResult.dialogName].push({
                        time: (new Date()).getTime(),
                        source: _this.topic.settings.up.email,
                        comment: dResult.comment,
                        section: _this.topic.tabs.short
                    });
                    _this.topic.sendCommentForUpdateGeneral(_this.updateArray, true);
                }
            }
            return;
        });
    };
    CommentController.$inject = ['topic', 'Dialog', '$state', 'settings', '$attrs'];
    return CommentController;
}());
var CommentComponent = (function () {
    function CommentComponent() {
        this.templateUrl = 'detail-comment.html';
        this.controllerAs = 'vm';
        this.controller = CommentController;
    }
    return CommentComponent;
}());
angular
    .module('application')
    .component('detailComment', new CommentComponent());



/**
 * @author Ivan Toth.
 */
var bindDisErr = { section: '=' };
var DisplayErrorController = (function () {
    function DisplayErrorController(topic, Dialog) {
        this.topic = topic;
        this.Dialog = Dialog;
        this.hovered = false;
    }
    DisplayErrorController.prototype.showErrors = function (event) {
        var items;
        //Here to add the comment into the server
        //this.topic.clearTempComments();
        var title = 'Unknown';
        if (angular.isDefined(this.topic.topic.complete.errorsArray[this.section])) {
            var table = this.topic.topic.complete.errorsArray[this.section] || [];
            switch (this.section) {
                case 'bfCheck':
                    title = 'Brand Family Details Missing';
                    break;
                case 'goeCheck':
                case 'goeCheck_valid':
                    title = 'Find CMR/GOE Missing';
                    break;
                case 'complcl':
                    title = 'Completeness Checklist Missing';
                    break;
                case 'complcl2':
                    title = 'Government Checklist Missing';
                    break;
                case 'complcl3':
                    title = 'Duplicate Checklist Missing';
                    break;
                case 'dcCheck':
                    title = 'Duplicate Check Missing';
                    break;
                case 'goe_add_fields':
                    title = 'Government Determination';
                    break;
                case 'goePick':
                case 'goePick_valid':
                    title = 'Government Check Decision Missing';
                    break;
                case 'sap':
                    title = 'ODS Results Missing';
                    break;
                case 'complcl_validation':
                    title = 'Validation Checklist Missing';
                    break;
                case 'calculation':
                    title = 'Calculation Issues';
                    break;
                case 'complcl_calculation':
                    title = 'Calculation Checklist Missing';
                    break;
                case 'eligibilityGoeHistory':
                    title = 'GOE History Check';
                    break;
                case 'all':
                    title = 'All Missing';
                    break;
            }
            items = { title: title, table: table };
        }
        else {
            items = { title: title, table: [] };
        }
        this.Dialog.updateValidForm(event, items, 'dialog-missing-error.html');
    };
    DisplayErrorController.$inject = ['topic', 'Dialog'];
    return DisplayErrorController;
}());
var DisplayErrorComponent = (function () {
    function DisplayErrorComponent() {
        this.bindings = bindDisErr;
        this.templateUrl = 'display-missing-error.html';
        this.controller = DisplayErrorController;
    }
    return DisplayErrorComponent;
}());
angular
    .module('application')
    .component('displayError', new DisplayErrorComponent());



/**
 * @author Ivan Toth.
 * contains edit, cancel, save buttons, that are running the bound functions of their parents
 */
var bindings = { vm: '=', lock: '=' };
var EscButtonController = (function () {
    function EscButtonController(topic, Dialog, settings, env) {
        this.topic = topic;
        this.Dialog = Dialog;
        this.settings = settings;
        this.env = env;
    }
    EscButtonController.prototype.lockComponent = function (event, component, locking) {
        var _this = this;
        this.updateArray = [];
        switch (component) {
            case 'dc':
                this.updateArray = ['dc', 'complcl3'];
                break;
            case 'complcl':
                this.updateArray = ['complcl'];
                break;
            case 'complcl3':
                this.updateArray = ['dc', 'complcl3'];
                break;
            case 'goe':
                this.updateArray = ['goe', 'cmr', 'goe_data', 'fastpass', 'mgr', 'complcl2', 'files$fcmr'];
                break;
            case 'goe_valid':
                this.updateArray = ['goe_valid', 'cmr_valid', 'files$fcmr_valid'];
                break;
            case 'files$general':
                this.updateArray = ['files$general'];
                break;
            case 'files$eligibility':
                this.updateArray = ['files$eligibility'];
                break;
            case 'files$mysa':
                this.updateArray = ['files$mysa'];
                break;
            case 'files$sampling':
                this.updateArray = ['files$sampling'];
                break;
            case 'files$sampling_Solution':
                this.updateArray = ['files$sampling_Solution'];
                break;
            case 'files$sampling_SSA':
                this.updateArray = ['files$sampling_SSA'];
                break;
            case 'complcl_sampling_Solution':
                this.updateArray = ['complcl_sampling_Solution', 'complcl_sampling'];
                break;
            case 'complcl_sampling_SSA':
                this.updateArray = ['complcl_sampling_SSA', 'complcl_sampling'];
                break;
            case 'complcl_sampling':
                this.updateArray = ['complcl_sampling'];
                break;
            case 'customerDesignation':
                this.updateArray = ['customerDesignation'];
                break;
            case 'nc':
                this.updateArray = ['nc'];
                break;
            case 'ctl_so':
                this.updateArray = ['ctl_so'];
                break;
            default:
                this.updateArray = [];
                alert('Unknown component');
                return;
        }
        var items = {
            icon: 'QUESTION',
            cancelMessage: 'Cancel'
        };
        if (locking) {
            items.message = 'Should you choose to continue, you will no longer be able to edit this section. &nbsp;Continue?';
            items.okMessage = 'Lock';
            items.title = 'Lock';
        }
        else {
            items.message = 'Should you choose to continue, this section will become editable once more. &nbsp;Continue?';
            items.okMessage = 'Unlock';
            items.title = 'Unlock';
        }
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                var updateObject_1 = {
                    id: _this.topic.topic._id,
                    data: {},
                    type: _this.updateArray,
                    editOption: true
                };
                if (_this.topic.updatePartialSocketStatus(_this.updateArray, 'Updating')) {
                    angular.forEach(_this.updateArray, function (component) {
                        updateObject_1.data['lock_indicator.' + component] = {
                            add: true,
                            data: locking
                        };
                    });
                    //If unlocking Sampling, we'll need to update sampling status, too
                    if (!locking && _this.updateArray.indexOf('complcl_sampling') > -1) {
                        var intensiveType = _this.updateArray.indexOf('complcl_sampling_SSA') > -1
                            ? 'SSA'
                            : (_this.updateArray.indexOf('complcl_sampling_Solution') > -1 ? 'Solution' : undefined);
                        if (intensiveType) {
                            _this.updateArray.push('sampling'); // This object will need refreshing...
                            //Work out what the previous status was
                            var originalStatus = 'In Progress';
                            if (_this.topic.topic.sampling[intensiveType].samplingStatus.indexOf('Manually sampled') > -1) {
                                originalStatus = 'Manually sampled - In Progress';
                            }
                            _this.topic.setTempFromTopicPart('sampling');
                            _this.topic.temp.sampling[intensiveType].samplingStatus = originalStatus;
                            delete _this.topic.temp.sampling[intensiveType].sampTimeEnd;
                            //Add as a field to be updated server-side
                            updateObject_1.data['sampling'] = {
                                add: true,
                                data: _this.topic.temp.sampling
                            };
                        }
                        else {
                            _this.updateArray.push('sampling'); // This object will need refreshing...
                            //Work out what the previous status was
                            var originalStatus = 'In Progress';
                            if (_this.topic.topic.sampling.samplingStatus.indexOf('Manually sampled') > -1) {
                                originalStatus = 'Manually sampled - In Progress';
                            }
                            _this.topic.setTempFromTopicPart('sampling');
                            _this.topic.temp.sampling.samplingStatus = originalStatus;
                            delete _this.topic.temp.sampling.sampTimeEnd;
                            //Add as a field to be updated server-side
                            updateObject_1.data['sampling'] = {
                                add: true,
                                data: _this.topic.temp.sampling
                            };
                        }
                    }
                    _this.topic.updateServerTopic('couchUpdate', updateObject_1, true);
                }
            }
        });
    };
    EscButtonController.$inject = ['topic', 'Dialog', 'settings', 'env'];
    return EscButtonController;
}());
var EscButtonComponent = (function () {
    function EscButtonComponent() {
        this.bindings = bindings;
        this.templateUrl = 'esc-button.html';
        this.controller = EscButtonController;
    }
    return EscButtonComponent;
}());
angular
    .module('application')
    .component('escButtonSection', new EscButtonComponent());



/**
 * @author Ivan Toth.
 * contains edit, cancel, save buttons, that are running the bound functions of their parents
 */
var FlagController = (function () {
    function FlagController(topic, env) {
        this.topic = topic;
        this.env = env;
        this.comp = 'header_data';
        this.updateArray = ['header_data'];
    }
    FlagController.prototype.$onInit = function () {
        this.hovered = false;
        this.edit = this.topic.getEditComponent(this.comp);
    };
    FlagController.prototype.flagChange = function (newStat) {
        if (this.topic.getEditComponent(this.comp)) {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.temp.header_data.flag = newStat;
                this.topic.sendForUpdateGeneral(this.updateArray, false);
            }
        }
    };
    FlagController.prototype.sendComment = function () {
        if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
            this.hovered = false;
            this.topic.temp.header_data.comment = this.comment;
            this.topic.sendForUpdateGeneral(this.updateArray, false);
        }
    };
    FlagController.prototype.enableComment = function () {
        this.hovered = true;
        this.comment = this.topic.temp.header_data.comment;
    };
    FlagController.$inject = ['topic', 'env'];
    return FlagController;
}());
var FlagComponent = (function () {
    function FlagComponent() {
        this.templateUrl = 'flag.html';
        this.controllerAs = 'vm';
        this.controller = FlagController;
    }
    return FlagComponent;
}());
angular
    .module('application')
    .component('flagSection', new FlagComponent());



/**
 * @author Ivan Toth.
 */
var lockBind = { comp: '=' };
var DetailLockController = (function () {
    function DetailLockController(topic) {
        this.topic = topic;
        return;
    }
    DetailLockController.$inject = ['topic'];
    return DetailLockController;
}());
var DetailLockComponent = (function () {
    function DetailLockComponent() {
        this.bindings = lockBind;
        this.templateUrl = 'lock.html';
        this.controller = DetailLockController;
    }
    return DetailLockComponent;
}());
angular
    .module('application')
    .component('lockSection', new DetailLockComponent());



/**
 * @author Ivan Toth.
 */
var govBind = { comp: '=' };
var DetailGovCheckController = (function () {
    function DetailGovCheckController(topic) {
        this.topic = topic;
        return;
    }
    ;
    DetailGovCheckController.$inject = ['topic'];
    return DetailGovCheckController;
}());
var DetailGovCheckComponent = (function () {
    function DetailGovCheckComponent() {
        this.bindings = govBind;
        this.templateUrl = 'gov-check.html';
        this.controller = DetailGovCheckController;
    }
    return DetailGovCheckComponent;
}());
angular
    .module('application')
    .component('govCheckSection', new DetailGovCheckComponent());



/**
 * @author Ivan Toth.
 */
var treeBind = { item: '=', caller: '=', level: '=', parent: '=' };
var DetailTreeController = (function () {
    function DetailTreeController(topic, settings) {
        this.topic = topic;
        this.settings = settings;
        this.visible = true;
        this.defaultState = true;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.excludeCountries = ['JP', 'CN', 'TW', 'HK', 'BR', 'AF', 'AU', 'BN', 'KH', 'FJ', 'PH', 'BT', 'SG', 'SB', 'LA',
            'TL', 'IN', 'ID', 'PG', 'LK', 'AS', 'KR', 'KP', 'VN', 'BD', 'MY', 'MV', 'NZ', 'TH', 'WS'];
        return;
    }
    ;
    DetailTreeController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    DetailTreeController.prototype.rbr = function (v) {
        if (angular.isDefined(v)) {
            return v.replace(/<br>/g, '\n');
        }
    };
    DetailTreeController.prototype.parseSAPAmount = function (amount) {
        try {
            amount = String(amount).trim();
            if (amount.includes('.') && amount.includes(',')) {
                return amount.lastIndexOf('.') > amount.lastIndexOf(',')
                    ? Number(amount.split(',').join(''))
                    : Number(amount.split('.').join('').replace(',', '.'));
            }
            if (amount.includes('.')) {
                var parts = amount.split('.');
                return parts[parts.length - 1].length === 3
                    ? Number(parts.join(''))
                    : Number(amount);
            }
            if (amount.includes(',')) {
                var parts = amount.split(',');
                return parts[parts.length - 1].length === 3
                    ? Number(parts.join(''))
                    : Number(amount.replace(',', '.'));
            }
            return Number(amount);
        }
        catch (e) {
            return NaN;
        }
    };
    DetailTreeController.$inject = ['topic', 'settings'];
    return DetailTreeController;
}());
var DetailTreeComponent = (function () {
    function DetailTreeComponent() {
        this.bindings = treeBind;
        this.templateUrl = 'detail-tree.html';
        this.controller = DetailTreeController;
    }
    return DetailTreeComponent;
}());
angular
    .module('application')
    .component('detailTreeSection', new DetailTreeComponent());



/**
 * @author Ivan Toth.
 */
var treeEditBind = {
    item: '=',
    caller: '=',
    level: '=',
    parent: '='
};
var DetailTreeEditController = (function () {
    function DetailTreeEditController(topic, socket, env, $scope, Dialog, settings) {
        this.topic = topic;
        this.socket = socket;
        this.env = env;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.settings = settings;
        this.defaultState = true;
        this.visible = true;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.excludeCountries = [
            'JP',
            'CN',
            'TW',
            'HK',
            'BR',
            'AF',
            'AU',
            'BN',
            'KH',
            'FJ',
            'PH',
            'BT',
            'SG',
            'SB',
            'LA',
            'TL',
            'IN',
            'ID',
            'PG',
            'LK',
            'AS',
            'KR',
            'KP',
            'VN',
            'BD',
            'MY',
            'MV',
            'NZ',
            'TH',
            'WS',
        ];
        this.compId = DetailTreeEditController.generateId();
        //this.validate();
        return;
    }
    DetailTreeEditController.generateId = function () {
        DetailTreeEditController.uniqueId++;
        return DetailTreeEditController.uniqueId;
    };
    DetailTreeEditController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    DetailTreeEditController.prototype.rbr = function (v) {
        if (angular.isDefined(v)) {
            return v.replace(/<br>/g, '\n');
        }
    };
    DetailTreeEditController.prototype.parseSAPAmount = function (amount) {
        try {
            amount = String(amount).trim();
            if (amount.includes('.') && amount.includes(',')) {
                return amount.lastIndexOf('.') > amount.lastIndexOf(',')
                    ? Number(amount.split(',').join(''))
                    : Number(amount.split('.').join('').replace(',', '.'));
            }
            if (amount.includes('.')) {
                var parts = amount.split('.');
                return parts[parts.length - 1].length === 3
                    ? Number(parts.join(''))
                    : Number(amount);
            }
            if (amount.includes(',')) {
                var parts = amount.split(',');
                return parts[parts.length - 1].length === 3
                    ? Number(parts.join(''))
                    : Number(amount.replace(',', '.'));
            }
            return Number(amount);
        }
        catch (e) {
            return NaN;
        }
    };
    DetailTreeEditController.prototype.addChild = function () {
        this.topic.temp.calculation.recalculated = false;
        var obj = this.item;
        var level = this.level;
        while (level < this.settings.calculationTreeLevels.length - 1) {
            if (level === 3) {
                obj.children.unshift({
                    id: '',
                    bonus: null,
                    bonusSolution: null,
                    bonusNewClient: null,
                    bonusFocus: null,
                    bonusGrowth: null,
                    bonusCtl: null,
                    children: [],
                    createdManual: true
                });
            }
            else {
                obj.children.unshift({
                    id: '',
                    children: []
                });
            }
            level++;
            obj = obj.children[0];
        }
        obj.children = undefined;
    };
    DetailTreeEditController.prototype.remove = function () {
        this.topic.temp.calculation.recalculated = false;
        for (var i = 0; i < this.parent.item.children.length; i++) {
            if (this.parent.item.children[i] === this.item) {
                this.parent.item.children.splice(i, 1);
                break;
            }
        }
        if (this.level > 0) {
            if (this.parent.item.children.length < 1) {
                this.parent.remove();
            }
        }
        this.validate();
    };
    DetailTreeEditController.prototype.updateVal = function () {
        this.topic.temp.calculation.recalculated = false;
        this.validate();
    };
    DetailTreeEditController.prototype.validate = function () {
        this.topic.temp.calculation.recalculated = false;
        /*		if (this.caller === 'payment') {
            this.validateCalculation();
        }
*/
    };
    DetailTreeEditController.prototype.validateCalculation = function () {
        var _this = this;
        this.item.error = '';
        if (isNaN(this.level)) {
            this.item.error = "Invalid tree level.";
        }
        if (!this.item.id) {
            this.item.error = this.settings.calculationTreeLevels[this.level] + " must not be empty.";
        }
        if (this.level > 0) {
            var count_1 = 0;
            this.parent.item.children.forEach(function (item) {
                if (item.id === _this.item.id) {
                    count_1++;
                }
            });
            if (count_1 > 1) {
                this.item.error += "Duplicate " + this.settings.calculationTreeLevels[this.level];
            }
        }
        if (this.level === 4) {
            if (isNaN(this.item.amountLC)) {
                this.item.error = 'Invalid SO amount.';
            }
        }
    };
    DetailTreeEditController.prototype.changeUplift = function (event) {
        var _this = this;
        var errMessGPP = 'One or more values are invalid. The Uplift Opportunity % must be between 1 and 1000 or N/A, and the Comments are mandatory';
        var errMessSO = 'One or more values are invalid. The Uplift Sales Order % must be between 1 and 100 or N/A, and the Comments are mandatory';
        var items;
        items = {
            type: 'Uplift',
            upliftTypes: ['Opportunity', 'Sales Order']
        };
        this.Dialog.updateValidForm(event, items, 'dialog-uplift-bonus.html').then(function (dResult) {
            _this.topic.temp.calculation.recalculated = false;
            if (dResult.upliftType === 'Opportunity') {
                if (!_this.validateBU(dResult.value, dResult.comments, "GPP")) {
                    var items2 = {
                        icon: 'ERROR',
                        message: errMessGPP,
                        title: 'Saving Error'
                    };
                    _this.Dialog.updateValidForm(undefined, items2, 'confirm-prompt.html').then(function (dResult) {
                        return;
                    });
                    return;
                }
            }
            if (dResult.upliftType === "Sales Order") {
                if (!_this.validateBU(dResult.value, dResult.comments, "SO")) {
                    var items2 = {
                        icon: 'ERROR',
                        message: errMessSO,
                        title: 'Saving Error'
                    };
                    _this.Dialog.updateValidForm(undefined, items2, 'confirm-prompt.html').then(function (dResult) {
                        return;
                    });
                    return;
                }
            }
            if (dResult.upliftType === 'Opportunity') {
                _this.item.autoUplift = false;
                _this.item.uplift = Math.round(dResult.value * 100) / 100;
                _this.item.upliftComments = dResult.comments;
            }
            else {
                _this.item.autoUpliftSo = false;
                _this.item.upliftSo = Math.round(dResult.value * 100) / 100;
                _this.item.upliftSoComments = dResult.comments;
            }
            return;
        });
    };
    DetailTreeEditController.prototype.changeBonus = function (event) {
        var _this = this;
        var it = {};
        it.ssa = angular.isDefined(this.item.bonus);
        it.solution = angular.isDefined(this.item.bonusSolution);
        it.newclient = angular.isDefined(this.item.bonusNewClient);
        it.focus = angular.isDefined(this.item.bonusFocus);
        it.growth = angular.isDefined(this.item.bonusGrowth);
        it.ctl = angular.isDefined(this.item.bonusCtl);
        var errMess = 'One or more values are invalid. The Bonus % must be between 1 and 100 or N/A, and the Comments are mandatory';
        var bonusLabel = 'CVR SSA';
        var bonusSolutionLabel = 'CVR Solution';
        if (this.topic.topic.version && this.topic.topic.version >= 4) {
            bonusLabel = 'SSA';
            bonusSolutionLabel = 'Engagement';
        }
        var items;
        items = {
            type: 'Bonus',
            bonuses: {
                bonus: bonusLabel,
                bonusSolution: bonusSolutionLabel,
                bonusNewClient: 'CVR New Client',
                bonusGrowth: 'Growth',
                bonusFocus: 'Focus',
                bonusCtl: 'Ctl'
            },
            item: this.item,
            valueBonus: this.item.bonus,
            valueSolution: this.item.bonusSolution,
            valueNewClient: this.item.bonusNewClient,
            valueGrowth: this.item.bonusGrowth,
            valueFocus: this.item.bonusFocus,
            valueCtl: this.item.bonusCtl,
            commentsBonus: this.item.bonusComments,
            commentsSolution: this.item.bonusSolutionComments,
            commentsNewClient: this.item.bonusNewClientComments,
            commentsGrowth: this.item.bonusGrowthComments,
            commentsFocus: this.item.bonusFocusComments,
            commentsCtl: this.item.bonusCtlComments
        };
        this.Dialog.updateValidForm(event, items, 'dialog-uplift-bonus.html').then(function (dResult) {
            _this.topic.temp.calculation.recalculated = false;
            // If input not valid for some reason
            if ((it.ssa &&
                !_this.validateBU(dResult.valueBonus, dResult.commentsBonus)) ||
                (it.solution &&
                    !_this.validateBU(dResult.valueSolution, dResult.commentsSolution)) ||
                (it.newclient &&
                    !_this.validateBU(dResult.valueNewClient, dResult.commentsNewClient)) ||
                (it.growth &&
                    !_this.validateBU(dResult.valueGrowth, dResult.commentsGrowth)) ||
                (it.ctl &&
                    !_this.validateBU(dResult.valueCtl, dResult.commentsCtl)) ||
                (it.focus &&
                    !_this.validateBU(dResult.valueFocus, dResult.commentsFocus))) {
                var items2 = {
                    icon: 'ERROR',
                    message: errMess,
                    title: 'Saving Error'
                };
                _this.Dialog.updateValidForm(undefined, items2, 'confirm-prompt.html').then(function (dResult) {
                    return;
                });
                return;
            } /*
            if ((isNaN(Number(dResult.valueBonus)) && its.ssa && dResult.valueBonus !== 'N/A')
                || (isNaN(Number(dResult.valueSolution)) && its.solution && dResult.valueSolution !== 'N/A')
                || (isNaN(Number(dResult.valueNewClient)) && its.newclient && dResult.valueNewClient !== 'N/A')) {
                let items2: any = {
                    icon: 'ERROR',
                    message: errMess,
                    title: 'Saving Error',
                };
                this.Dialog.updateValidForm(undefined, items2, 'confirm-prompt.html').then((dResult) => { return; });
                return;
            }*/
            if (dResult.valueBonus === 'N/A') {
                dResult.valueBonus = undefined;
            }
            if (dResult.valueSolution === 'N/A') {
                dResult.valueSolution = undefined;
            }
            if (dResult.valueNewClient === 'N/A') {
                dResult.valueNewClient = undefined;
            }
            if (dResult.valueGrowth === 'N/A') {
                dResult.valueGrowth = undefined;
            }
            if (dResult.valueFocus === 'N/A') {
                dResult.valueFocus = undefined;
            }
            if (dResult.valueCtl === 'N/A') {
                dResult.valueCtl = undefined;
            }
            if (dResult.commentsBonus === 'N/A') {
                dResult.commentsBonus = undefined;
            }
            if (dResult.commentsSolution === 'N/A') {
                dResult.commentsSolution = undefined;
            }
            if (dResult.commentsNewClient === 'N/A') {
                dResult.commentsNewClient = undefined;
            }
            if (dResult.commentsGrowth === 'N/A') {
                dResult.commentsGrowth = undefined;
            }
            if (dResult.commentsFocus === 'N/A') {
                dResult.commentsFocus = undefined;
            }
            if (dResult.commentsCtl === 'N/A') {
                dResult.commentsCtl = undefined;
            }
            _this.item.autoBonus = false;
            _this.item.bonus = dResult.valueBonus;
            _this.item.bonusComments = dResult.commentsBonus;
            _this.item.bonusSolution = dResult.valueSolution;
            _this.item.bonusSolutionComments = dResult.commentsSolution;
            _this.item.bonusNewClient = dResult.valueNewClient;
            _this.item.bonusNewClientComments = dResult.commentsNewClient;
            _this.item.bonusGrowth = dResult.valueGrowth;
            _this.item.bonusGrowthComments = dResult.commentsGrowth;
            _this.item.bonusFocus = dResult.valueFocus;
            _this.item.bonusFocusComments = dResult.commentsFocus;
            _this.item.bonusCtl = dResult.valueCtl;
            _this.item.bonusCtlComments = dResult.commentsCtl;
            return;
        });
    };
    DetailTreeEditController.prototype.changeForecast = function (event) {
        if (this.topic.checksData.uiVersion >= this.OPP_VERSION_3) {
            this.topic.temp.calculation.forecasts[this.parent.parent.item.drpgId].auto = false;
            this.topic.temp.calculation.forecasts[this.parent.parent.item.drpgId].value = Number(this.topic.temp.calculation.forecasts[this.parent.parent.item.drpgId].value);
            this.topic.temp.calculation = this.changeBFForecast(this.topic.temp.calculation, "drpgId", this.parent.parent.item.drpgId, this.topic.temp.calculation.forecasts[this.parent.parent.item.drpgId].value);
        }
        else {
            this.topic.temp.calculation.forecasts[this.parent.parent.item.brandCode].auto = false;
            this.topic.temp.calculation.forecasts[this.parent.parent.item.brandCode].value = Number(this.topic.temp.calculation.forecasts[this.parent.parent.item.brandCode].value);
            this.topic.temp.calculation = this.changeBFForecast(this.topic.temp.calculation, "brandCode", this.parent.parent.item.brandCode, this.topic.temp.calculation.forecasts[this.parent.parent.item.brandCode].value);
        }
        this.updateVal();
    };
    DetailTreeEditController.prototype.changeBFForecast = function (calc, propertyName, value, newValue) {
        calc.children.forEach(function (orderObject) {
            orderObject.children.forEach(function (bfObject) {
                if (bfObject[propertyName] === value) {
                    bfObject.bfForecast = newValue;
                    bfObject.children.forEach(function (partNumberObject) {
                        partNumberObject.children.forEach(function (lineItemObject) {
                            lineItemObject.bfTotalForecast = newValue;
                        });
                    });
                }
            });
        });
        return calc;
    };
    DetailTreeEditController.prototype.changePayed = function () {
        if (this.topic.checksData.uiVersion >= this.OPP_VERSION_3) {
            this.topic.temp.calculation.payed[this.parent.parent.item.drpgId].auto = false;
            this.topic.temp.calculation.payed[this.parent.parent.item.drpgId].value = Number(this.topic.temp.calculation.payed[this.parent.parent.item.drpgId].value);
        }
        else {
            this.topic.temp.calculation.payed[this.parent.parent.item.brandCode].auto = false;
            this.topic.temp.calculation.payed[this.parent.parent.item.brandCode].value = Number(this.topic.temp.calculation.payed[this.parent.parent.item.brandCode].value);
        }
        this.updateVal();
    };
    DetailTreeEditController.prototype.updateAmount = function () {
        this.item.amountLC = Number(this.item.amountLC);
        this.updateVal();
    };
    DetailTreeEditController.prototype.changeSoAmount = function () {
        this.item.amountLC = Number(this.item.amountLC);
        this.updateVal();
    };
    DetailTreeEditController.prototype.changeBaseAmount = function (val) {
        this.item.baseAmount.amount = Number(val);
        this.updateVal();
    };
    /**
     * Function to validate the user-entered uplift or bonus %
     *
     * @param {*} value
     * @returns {boolean}
     * @memberof DetailTreeEditController
     */
    DetailTreeEditController.prototype.validateBU = function (value, comments, type) {
        // Are the comments there?
        if (angular.isUndefined(comments) || comments.trim() === '') {
            return false;
        }
        var percentage = Number(value); // Convert the value
        // If not a number...
        if (isNaN(percentage)) {
            if (angular.isUndefined(value) || value.toUpperCase() !== 'N/A') {
                return false; // If not N/A...
            }
        }
        else {
            // Is a number
            if (type === "GPP") {
                if (percentage < 0 || percentage > 1000) {
                    return false;
                }
            }
            if (type === "SO") {
                if (percentage < 0 || percentage > 100) {
                    return false;
                }
            }
        }
        return true; // All good
    };
    DetailTreeEditController.$inject = ['topic', 'socket', 'env', '$scope', 'Dialog', 'settings'];
    DetailTreeEditController.uniqueId = 0;
    return DetailTreeEditController;
}());
var DetailTreeEditComponent = (function () {
    function DetailTreeEditComponent() {
        this.bindings = treeEditBind;
        this.templateUrl = 'detail-tree-edit.html';
        this.controller = DetailTreeEditController;
    }
    return DetailTreeEditComponent;
}());
angular
    .module('application')
    .component('detailTreeEditSection', new DetailTreeEditComponent());



/**
* @author Ivan Toth.
*/
var treeEditBind = {
    item: '=',
    caller: '=',
    level: '=',
    parent: '='
};
var DetailTreeEditV2Controller = (function () {
    function DetailTreeEditV2Controller(topic, socket, env, $scope, Dialog, settings) {
        this.topic = topic;
        this.socket = socket;
        this.env = env;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.settings = settings;
        this.defaultState = true;
        this.visible = true;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.compId = DetailTreeEditV2Controller.generateId();
        //this.validate();
        return;
    }
    DetailTreeEditV2Controller.generateId = function () {
        DetailTreeEditV2Controller.uniqueId++;
        return DetailTreeEditV2Controller.uniqueId;
    };
    DetailTreeEditV2Controller.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    DetailTreeEditV2Controller.prototype.rbr = function (v) {
        if (angular.isDefined(v)) {
            return v.replace(/<br>/g, '\n');
        }
    };
    DetailTreeEditV2Controller.prototype.parseSAPAmount = function (amount) {
        try {
            amount = String(amount).trim();
            if (amount.includes('.') && amount.includes(',')) {
                return amount.lastIndexOf('.') > amount.lastIndexOf(',')
                    ? Number(amount.split(',').join(''))
                    : Number(amount.split('.').join('').replace(',', '.'));
            }
            if (amount.includes('.')) {
                var parts = amount.split('.');
                return parts[parts.length - 1].length === 3
                    ? Number(parts.join(''))
                    : Number(amount);
            }
            if (amount.includes(',')) {
                var parts = amount.split(',');
                return parts[parts.length - 1].length === 3
                    ? Number(parts.join(''))
                    : Number(amount.replace(',', '.'));
            }
            return Number(amount);
        }
        catch (e) {
            return NaN;
        }
    };
    DetailTreeEditV2Controller.prototype.addChild = function () {
        this.topic.temp.calculation.recalculated = false;
        var obj = this.item;
        var level = this.level;
        while (level < this.settings.calculationTreeLevels.length - 1) {
            if (level === 3) {
                obj.children.unshift({
                    id: '',
                    bonus: null,
                    bonusSolution: null,
                    bonusNewClient: null,
                    bonusFocus: null,
                    bonusGrowth: null,
                    bonusCtl: null,
                    children: [],
                    createdManual: true
                });
            }
            else {
                obj.children.unshift({
                    id: '',
                    children: []
                });
            }
            level++;
            obj = obj.children[0];
        }
        obj.children = undefined;
    };
    DetailTreeEditV2Controller.prototype.remove = function () {
        this.topic.temp.calculation.recalculated = false;
        for (var i = 0; i < this.parent.item.children.length; i++) {
            if (this.parent.item.children[i] === this.item) {
                this.parent.item.children.splice(i, 1);
                break;
            }
        }
        if (this.level > 0) {
            if (this.parent.item.children.length < 1) {
                this.parent.remove();
            }
        }
        this.validate();
    };
    DetailTreeEditV2Controller.prototype.updateVal = function () {
        this.topic.temp.calculation.recalculated = false;
        this.validate();
    };
    DetailTreeEditV2Controller.prototype.validate = function () {
        this.topic.temp.calculation.recalculated = false;
        /*		if (this.caller === 'payment') {
            this.validateCalculation();
        }
*/
    };
    DetailTreeEditV2Controller.prototype.validateCalculation = function () {
        var _this = this;
        this.item.error = '';
        if (isNaN(this.level)) {
            this.item.error = "Invalid tree level.";
        }
        if (!this.item.id) {
            this.item.error = this.settings.calculationTreeLevels[this.level] + " must not be empty.";
        }
        if (this.level > 0) {
            var count_1 = 0;
            this.parent.item.children.forEach(function (item) {
                if (item.id === _this.item.id) {
                    count_1++;
                }
            });
            if (count_1 > 1) {
                this.item.error += "Duplicate " + this.settings.calculationTreeLevels[this.level];
            }
        }
        if (this.level === 4) {
            if (isNaN(this.item.amountLC)) {
                this.item.error = 'Invalid SO amount.';
            }
        }
    };
    DetailTreeEditV2Controller.prototype.changeUplift = function (event) {
        var _this = this;
        var errMessGPP = 'One or more values are invalid. The Uplift Opportunity % must be between 1 and 1000 or N/A, and the Comments are mandatory';
        var errMessSO = 'One or more values are invalid. The Uplift Sales Order % must be between 1 and 100 or N/A, and the Comments are mandatory';
        var items;
        items = {
            type: 'Uplift',
            upliftTypes: ['Opportunity', 'Sales Order']
        };
        this.Dialog.updateValidForm(event, items, 'dialog-uplift-bonus.html').then(function (dResult) {
            _this.topic.temp.calculation.recalculated = false;
            if (dResult.upliftType === 'Opportunity') {
                if (!_this.validateBU(dResult.value, dResult.comments, "GPP")) {
                    var items2 = {
                        icon: 'ERROR',
                        message: errMessGPP,
                        title: 'Saving Error'
                    };
                    _this.Dialog.updateValidForm(undefined, items2, 'confirm-prompt.html').then(function (dResult) {
                        return;
                    });
                    return;
                }
            }
            if (dResult.upliftType === "Sales Order") {
                if (!_this.validateBU(dResult.value, dResult.comments, "SO")) {
                    var items2 = {
                        icon: 'ERROR',
                        message: errMessSO,
                        title: 'Saving Error'
                    };
                    _this.Dialog.updateValidForm(undefined, items2, 'confirm-prompt.html').then(function (dResult) {
                        return;
                    });
                    return;
                }
            }
            var item = (event === 'ctlSo' && _this.item.ctlSo) ? _this.item.ctlSo : _this.item;
            if (dResult.upliftType === 'Opportunity') {
                item.autoUplift = false;
                item.uplift = Math.round(dResult.value * 100) / 100;
                item.upliftComments = dResult.comments;
            }
            else {
                item.autoUpliftSo = false;
                item.upliftSo = Math.round(dResult.value * 100) / 100;
                item.upliftSoComments = dResult.comments;
            }
            return;
        });
    };
    DetailTreeEditV2Controller.prototype.changeBonus = function (event) {
        var _this = this;
        var subRevIt = (event === 'ctlSo' && this.item.ctlSo) ? this.item.ctlSo : this.item;
        var it = {};
        it.ssa = angular.isDefined(subRevIt.bonus);
        it.solution = angular.isDefined(subRevIt.bonusSolution);
        it.newclient = angular.isDefined(subRevIt.bonusNewClient);
        it.focus = angular.isDefined(subRevIt.bonusFocus);
        it.growth = angular.isDefined(subRevIt.bonusGrowth);
        it.ctl = angular.isDefined(subRevIt.bonusCtl);
        var errMess = 'One or more values are invalid. The Bonus % must be between 1 and 100 or N/A, and the Comments are mandatory';
        var bonusLabel = 'CVR SSA';
        var bonusSolutionLabel = 'CVR Solution';
        if (this.topic.topic.version && this.topic.topic.version >= 4) {
            bonusLabel = 'SSA';
            bonusSolutionLabel = 'Engagement';
        }
        var items;
        items = {
            type: 'Bonus',
            bonuses: {
                bonus: bonusLabel,
                bonusSolution: bonusSolutionLabel,
                bonusNewClient: 'CVR New Client',
                bonusGrowth: 'Growth',
                bonusFocus: 'Focus',
                bonusCtl: 'Ctl'
            },
            item: this.item,
            valueBonus: subRevIt.bonus,
            valueSolution: subRevIt.bonusSolution,
            valueNewClient: subRevIt.bonusNewClient,
            valueGrowth: subRevIt.bonusGrowth,
            valueFocus: subRevIt.bonusFocus,
            valueCtl: subRevIt.bonusCtl,
            commentsBonus: subRevIt.bonusComments,
            commentsSolution: subRevIt.bonusSolutionComments,
            commentsNewClient: subRevIt.bonusNewClientComments,
            commentsGrowth: subRevIt.bonusGrowthComments,
            commentsFocus: subRevIt.bonusFocusComments,
            commentsCtl: subRevIt.bonusCtlComments
        };
        this.Dialog.updateValidForm(event, items, 'dialog-uplift-bonus.html').then(function (dResult) {
            _this.topic.temp.calculation.recalculated = false;
            // If input not valid for some reason
            if ((it.ssa &&
                !_this.validateBU(dResult.valueBonus, dResult.commentsBonus)) ||
                (it.solution &&
                    !_this.validateBU(dResult.valueSolution, dResult.commentsSolution)) ||
                (it.newclient &&
                    !_this.validateBU(dResult.valueNewClient, dResult.commentsNewClient)) ||
                (it.growth &&
                    !_this.validateBU(dResult.valueGrowth, dResult.commentsGrowth)) ||
                (it.ctl &&
                    !_this.validateBU(dResult.valueCtl, dResult.commentsCtl)) ||
                (it.focus &&
                    !_this.validateBU(dResult.valueFocus, dResult.commentsFocus))) {
                var items2 = {
                    icon: 'ERROR',
                    message: errMess,
                    title: 'Saving Error'
                };
                _this.Dialog.updateValidForm(undefined, items2, 'confirm-prompt.html').then(function (dResult) {
                    return;
                });
                return;
            }
            if (dResult.valueBonus === 'N/A') {
                dResult.valueBonus = undefined;
            }
            if (dResult.valueSolution === 'N/A') {
                dResult.valueSolution = undefined;
            }
            if (dResult.valueNewClient === 'N/A') {
                dResult.valueNewClient = undefined;
            }
            if (dResult.valueGrowth === 'N/A') {
                dResult.valueGrowth = undefined;
            }
            if (dResult.valueFocus === 'N/A') {
                dResult.valueFocus = undefined;
            }
            if (dResult.valueCtl === 'N/A') {
                dResult.valueCtl = undefined;
            }
            if (dResult.commentsBonus === 'N/A') {
                dResult.commentsBonus = undefined;
            }
            if (dResult.commentsSolution === 'N/A') {
                dResult.commentsSolution = undefined;
            }
            if (dResult.commentsNewClient === 'N/A') {
                dResult.commentsNewClient = undefined;
            }
            if (dResult.commentsGrowth === 'N/A') {
                dResult.commentsGrowth = undefined;
            }
            if (dResult.commentsFocus === 'N/A') {
                dResult.commentsFocus = undefined;
            }
            if (dResult.commentsCtl === 'N/A') {
                dResult.commentsCtl = undefined;
            }
            subRevIt.autoBonus = false;
            subRevIt.bonus = dResult.valueBonus;
            subRevIt.bonusComments = dResult.commentsBonus;
            subRevIt.bonusSolution = dResult.valueSolution;
            subRevIt.bonusSolutionComments = dResult.commentsSolution;
            subRevIt.bonusNewClient = dResult.valueNewClient;
            subRevIt.bonusNewClientComments = dResult.commentsNewClient;
            subRevIt.bonusGrowth = dResult.valueGrowth;
            subRevIt.bonusGrowthComments = dResult.commentsGrowth;
            subRevIt.bonusFocus = dResult.valueFocus;
            subRevIt.bonusFocusComments = dResult.commentsFocus;
            subRevIt.bonusCtl = dResult.valueCtl;
            subRevIt.bonusCtlComments = dResult.commentsCtl;
            return;
        });
    };
    DetailTreeEditV2Controller.prototype.changeForecast = function (event) {
        if (this.topic.checksData.uiVersion >= this.OPP_VERSION_3) {
            this.topic.temp.calculation.forecasts[this.parent.parent.item.drpgId].auto = false;
            this.topic.temp.calculation.forecasts[this.parent.parent.item.drpgId].value = Number(this.topic.temp.calculation.forecasts[this.parent.parent.item.drpgId].value);
            this.topic.temp.calculation = this.changeBFForecast(this.topic.temp.calculation, "drpgId", this.parent.parent.item.drpgId, this.topic.temp.calculation.forecasts[this.parent.parent.item.drpgId].value);
        }
        else {
            this.topic.temp.calculation.forecasts[this.parent.parent.item.brandCode].auto = false;
            this.topic.temp.calculation.forecasts[this.parent.parent.item.brandCode].value = Number(this.topic.temp.calculation.forecasts[this.parent.parent.item.brandCode].value);
            this.topic.temp.calculation = this.changeBFForecast(this.topic.temp.calculation, "brandCode", this.parent.parent.item.brandCode, this.topic.temp.calculation.forecasts[this.parent.parent.item.brandCode].value);
        }
        this.updateVal();
    };
    DetailTreeEditV2Controller.prototype.changeBFForecast = function (calc, propertyName, value, newValue) {
        calc.children.forEach(function (orderObject) {
            orderObject.children.forEach(function (bfObject) {
                if (bfObject[propertyName] === value) {
                    bfObject.bfForecast = newValue;
                    bfObject.children.forEach(function (partNumberObject) {
                        partNumberObject.children.forEach(function (lineItemObject) {
                            lineItemObject.bfTotalForecast = newValue;
                        });
                    });
                }
            });
        });
        return calc;
    };
    DetailTreeEditV2Controller.prototype.changePayed = function () {
        if (this.topic.checksData.uiVersion >= this.OPP_VERSION_3) {
            this.topic.temp.calculation.payed[this.parent.parent.item.drpgId].auto = false;
            this.topic.temp.calculation.payed[this.parent.parent.item.drpgId].value = Number(this.topic.temp.calculation.payed[this.parent.parent.item.drpgId].value);
        }
        else {
            this.topic.temp.calculation.payed[this.parent.parent.item.brandCode].auto = false;
            this.topic.temp.calculation.payed[this.parent.parent.item.brandCode].value = Number(this.topic.temp.calculation.payed[this.parent.parent.item.brandCode].value);
        }
        this.updateVal();
    };
    DetailTreeEditV2Controller.prototype.updateAmount = function (flag) {
        var item = (flag === 'ctlSo' && this.item.ctlSo) ? this.item.ctlSo : this.item;
        item.amountLC = Number(item.amountLC);
        this.updateVal();
    };
    DetailTreeEditV2Controller.prototype.changeBaseAmount = function (val, flag) {
        var item = (flag === 'ctlSo' && this.item.ctlSo) ? this.item.ctlSo : this.item;
        item.baseAmount.amount = Number(val);
        this.updateVal();
    };
    /**
     * Function to validate the user-entered uplift or bonus %
     *
     * @param {*} value
     * @returns {boolean}
     * @memberof DetailTreeEditV2Controller
     */
    DetailTreeEditV2Controller.prototype.validateBU = function (value, comments, type) {
        // Are the comments there?
        if (angular.isUndefined(comments) || comments.trim() === '') {
            return false;
        }
        var percentage = Number(value); // Convert the value
        // If not a number...
        if (isNaN(percentage)) {
            if (angular.isUndefined(value) || value.toUpperCase() !== 'N/A') {
                return false; // If not N/A...
            }
        }
        else {
            // Is a number
            if (type === "GPP") {
                if (percentage < 0 || percentage > 1000) {
                    return false;
                }
            }
            if (type === "SO") {
                if (percentage < 0 || percentage > 100) {
                    return false;
                }
            }
        }
        return true; // All good
    };
    DetailTreeEditV2Controller.prototype.isCtlSo24Plus = function () {
        return this.item.bonusType === 'ctl_so_24_plus';
    };
    DetailTreeEditV2Controller.prototype.isCtlSo24PlusOnly = function () {
        return this.item.bonusType === 'ctl_so_24_plus_only';
    };
    DetailTreeEditV2Controller.prototype.isPayedBySo = function () {
        return this.item.payedBy === 'so';
    };
    DetailTreeEditV2Controller.prototype.isPayedByForecast = function () {
        return this.item.payedBy === 'forecast';
    };
    DetailTreeEditV2Controller.prototype.isVer3AndMore = function () {
        return this.topic.checksData.uiVersion >= 3;
    };
    DetailTreeEditV2Controller.prototype.isVer4AndMore = function () {
        return this.topic.checksData.uiVersion >= 4;
    };
    DetailTreeEditV2Controller.prototype.isVerLess4 = function () {
        return this.topic.checksData.uiVersion < 4;
    };
    DetailTreeEditV2Controller.$inject = ['topic', 'socket', 'env', '$scope', 'Dialog', 'settings'];
    DetailTreeEditV2Controller.uniqueId = 0;
    return DetailTreeEditV2Controller;
}());
var DetailTreeEditV2Component = (function () {
    function DetailTreeEditV2Component() {
        this.bindings = treeEditBind;
        this.templateUrl = 'detail-tree-edit-v2.html';
        this.controller = DetailTreeEditV2Controller;
    }
    return DetailTreeEditV2Component;
}());
angular
    .module('application')
    .component('detailTreeEditV2Section', new DetailTreeEditV2Component());



var treeBindV2 = { item: '=', caller: '=', level: '=', parent: '=' };
var DetailTreeV2Controller = (function () {
    function DetailTreeV2Controller(topic, settings) {
        this.topic = topic;
        this.settings = settings;
        this.visible = true;
    }
    ;
    DetailTreeV2Controller.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    DetailTreeV2Controller.prototype.rbr = function (v) {
        if (v) {
            return v.replace(/<br>/g, '\n');
        }
    };
    DetailTreeV2Controller.prototype.isAvailable = function () {
        return this.caller === 'payment' && this.level === 4;
    };
    DetailTreeV2Controller.prototype.isCtlSo24Plus = function () {
        return this.item.bonusType === 'ctl_so_24_plus';
    };
    DetailTreeV2Controller.prototype.isPayedByForecast = function () {
        return this.item.payedBy === 'forecast';
    };
    DetailTreeV2Controller.prototype.isPayedBySo = function () {
        return this.item.payedBy === 'so';
    };
    DetailTreeV2Controller.prototype.isVer3AndMore = function () {
        return this.topic.checksData.uiVersion >= 3;
    };
    DetailTreeV2Controller.prototype.isVer4AndMore = function () {
        return this.topic.checksData.uiVersion >= 4;
    };
    DetailTreeV2Controller.prototype.isVerLess4 = function () {
        return this.topic.checksData.uiVersion < 4;
    };
    DetailTreeV2Controller.prototype.getTotalForecastAmount = function () {
        return this.item.bfTotalForecast !== undefined ? this.item.bfTotalForecast : this.item.amountLC;
    };
    DetailTreeV2Controller.prototype.isNotAutoForecasts = function () {
        var id = this.isVer3AndMore() ? this.parent.parent.item.drpgId : this.parent.parent.item.brandCode;
        return this.topic.topic.calculation.forecasts[id].auto === false;
    };
    DetailTreeV2Controller.prototype.isNotAutoPayed = function () {
        var id = this.isVer3AndMore() ? this.parent.parent.item.drpgId : this.parent.parent.item.brandCode;
        return this.topic.topic.calculation.payed[id].auto === false;
    };
    DetailTreeV2Controller.prototype.getAlreadyPaidAmount = function () {
        var parIt = this.parent.parent.item;
        var calc = this.topic.topic.calculation;
        if (this.isVer3AndMore()) {
            return calc.payed[parIt.drpgId].value;
        }
        return calc.payed[parIt.brandCode || parIt.id].value;
    };
    DetailTreeV2Controller.prototype.getTotalAmount = function () {
        var parIt = this.parent.parent.item;
        var calc = this.topic.topic.calculation;
        if (this.isVer3AndMore()) {
            return calc.dealRegistrationProductGroups[parIt.drpgId].amount;
        }
        var brFams = calc.brandFamilies;
        return brFams[parIt.brandCode].amount !== undefined ? brFams[parIt.brandCode].amount : brFams[parIt.id].amount;
    };
    DetailTreeV2Controller.prototype.getUpliftedAmountHeader = function (flag) {
        var item = (flag === 'ctlSo' && this.item.ctlSo) ? this.item.ctlSo : this.item;
        return item.baseAmount.isBaseAmount
            ? 'Uplifted Amount (ZFN4)'
            : "Uplift " + item.upliftSo + "% (" + this.parent.parent.parent.item.currency + ")";
    };
    DetailTreeV2Controller.prototype.getCurrency = function () {
        return this.topic.topic.calculation.goe === "Y"
            ? this.parent.parent.parent.item.currency
            : this.topic.topic.calculation.forecasts.currency;
    };
    DetailTreeV2Controller.$inject = ['topic', 'settings'];
    return DetailTreeV2Controller;
}());
var DetailTreeV2Component = (function () {
    function DetailTreeV2Component() {
        this.bindings = treeBindV2;
        this.templateUrl = 'detail-tree-v2.html';
        this.controller = DetailTreeV2Controller;
    }
    return DetailTreeV2Component;
}());
angular
    .module('application')
    .component('detailTreeV2Section', new DetailTreeV2Component())
    .directive('bonusPercentage', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            scope.$watch(attrs.bonusPercentage, function (value) {
                element.text(value ? "Bonus " + value + "% (" + attrs.currency + ")" : 'N/A');
            });
        }
    };
})
    .directive('bonusAmount', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            scope.$watch(attrs.bonusAmount, function (value) {
                if (value > 0 || value < 0) {
                    element.addClass(value > 0 ? 'ibm-textcolor-green-50' : 'ibm-textcolor-red-50');
                }
                element.text(value || 'N/A');
            });
        }
    };
});



/**
 * @author Matthew Rogers.
 * Section for Dispute details...and potential actions
 */
var disBind = { vm: '=' };
var DisputeDetailsController = (function () {
    function DisputeDetailsController(topic) {
        this.topic = topic;
        this.cdIndicator = 'Credit';
    }
    DisputeDetailsController.prototype.$onInit = function () {
        var cd = this.topic.topic.dispute_details.dispute_itrtype ? this.topic.topic.dispute_details.dispute_itrtype : 'C';
        this.cdIndicator = cd === 'C' ? 'Credit' : 'Debit';
        this.disputeDetails = 'This is a Dispute.  The details are as follows:\n\n' +
            'Original Disbursement: ' + this.topic.topic.dispute_details.parent +
            '\nCredit/Debit: ' + this.cdIndicator +
            '\nType: ' + this.topic.topic.dispute_details.dispute_type +
            '\nCode: ' + this.topic.topic.dispute_details.dispute_code +
            '\n\nView the parent Disbursement via \'Your Actions\'';
    };
    DisputeDetailsController.$inject = ['topic'];
    return DisputeDetailsController;
}());
var DisputeDetailsComponent = (function () {
    function DisputeDetailsComponent() {
        this.bindings = disBind;
        this.templateUrl = 'dispute-details.html';
        this.controller = DisputeDetailsController;
    }
    return DisputeDetailsComponent;
}());
angular
    .module('application')
    .component('disputeDetailsSection', new DisputeDetailsComponent());



/**
 * @author Matthew Rogers.
 * Section for FTP to GPP results
 */
var ftpgppBind = { vm: '=' };
var FTPGPPDetailsController = (function () {
    function FTPGPPDetailsController(topic, $filter, settings) {
        this.topic = topic;
        this.$filter = $filter;
        this.settings = settings;
    }
    FTPGPPDetailsController.prototype.$onInit = function () {
        this.gppftpDetails = 'This Disbursement has been checked for GPP Status Update.  The results are as follows:\n\n' +
            'Date Checked: ' + this.$filter('date')(new Date(this.topic.topic.ftp_gppreport.date_processed), this.settings.up.preferences.dateFormat) +
            '\nData Sent back to GPP: ' + this.topic.topic.ftp_gppreport.data_sent +
            '\n\nIf nothing sent it means there must be other open Disbursements for this Opportunity';
    };
    FTPGPPDetailsController.$inject = ['topic', '$filter', 'settings'];
    return FTPGPPDetailsController;
}());
var FTPGPPDetailsComponent = (function () {
    function FTPGPPDetailsComponent() {
        this.bindings = ftpgppBind;
        this.templateUrl = 'ftpgpp-details.html';
        this.controller = FTPGPPDetailsController;
    }
    return FTPGPPDetailsComponent;
}());
angular
    .module('application')
    .component('ftpgppDetailsSection', new FTPGPPDetailsComponent());



/**
 * @author Ivan Toth.
 */
var paSiteBind = { editable: '=', tab: '@' };
var PaSiteNumController = (function () {
    function PaSiteNumController(topic) {
        this.topic = topic;
        this.comp = "paSiteNum";
        this.updateArray = [this.comp];
        return;
    }
    ;
    PaSiteNumController.prototype.addPaNum = function () {
        if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
            if (angular.isUndefined(this.topic.topic.paSiteNum) || !angular.isArray(this.topic.topic.paSiteNum)) {
                this.topic.topic.paSiteNum = [];
            }
            this.topic.setTempFromTopicPart(this.comp);
            if (angular.isDefined(this.paSiteNum) && this.paSiteNum !== '' && this.topic.temp.paSiteNum.indexOf(this.paSiteNum) < 0) {
                this.topic.temp.paSiteNum.push(this.paSiteNum);
                this.sendForUpdate('Added', this.paSiteNum);
            }
        }
    };
    PaSiteNumController.prototype.clearPaNum = function (item) {
        if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
            if (angular.isUndefined(this.topic.topic.paSiteNum) || !angular.isArray(this.topic.topic.paSiteNum)) {
                this.topic.topic.paSiteNum = [];
            }
            this.topic.setTempFromTopicPart(this.comp);
            var deleted = false;
            for (var count = this.topic.temp.paSiteNum.length - 1; count > -1; count--) {
                if (this.topic.temp.paSiteNum[count] === item) {
                    deleted = true;
                    this.topic.temp.paSiteNum.splice(count, 1);
                }
            }
            if (deleted) {
                this.sendForUpdate('Cleared', item);
            }
        }
    };
    PaSiteNumController.prototype.sendForUpdate = function (action, item) {
        var updData = {
            data: (_a = {},
                _a[this.comp] = {
                    add: true,
                    data: this.topic.temp.paSiteNum
                },
                _a['comments.' + this.tab] = {
                    push: true,
                    data: [{ comment: action + ' PA Site Num: ' + item }]
                },
                _a
            ),
            id: this.topic.topic._id,
            type: [this.comp, 'comments$' + this.tab]
        };
        this.topic.updateServerTopic('couchUpdate', updData, true);
        var _a;
    };
    PaSiteNumController.$inject = ['topic'];
    return PaSiteNumController;
}());
var PaSiteNumComponent = (function () {
    function PaSiteNumComponent() {
        this.bindings = paSiteBind;
        this.templateUrl = 'pa-site-num.html';
        this.controller = PaSiteNumController;
    }
    return PaSiteNumComponent;
}());
angular
    .module('application')
    .component('paSiteNumSection', new PaSiteNumComponent());



/**
 * @author Matthew Rogers.
 */
var reject_reasonBind = { parent: '=' };
var RejectReasonSelectController = (function () {
    function RejectReasonSelectController(socket, $scope, env, admin) {
        var _this = this;
        this.socket = socket;
        this.$scope = $scope;
        this.env = env;
        this.admin = admin;
        this.codesLoaded = false;
        //declare listener for response from the service
        this.socket.forward('config.misc_codes_by_type', this.$scope);
        this.$scope.$on('socket:config.misc_codes_by_type', function (event, data) {
            if (angular.isDefined(data)) {
                _this.reasonCodes = data;
                _this.codesLoaded = true;
            }
        });
    }
    RejectReasonSelectController.prototype.$onInit = function () {
        this.admin.getMiscCodesByType('rejection_codes');
    };
    RejectReasonSelectController.$inject = ['socket', '$scope', 'env', 'admin'];
    return RejectReasonSelectController;
}());
var RejectReasonSelectComponent = (function () {
    function RejectReasonSelectComponent() {
        this.templateUrl = 'reject-reason-select.html';
        this.bindings = reject_reasonBind;
        this.controller = RejectReasonSelectController;
    }
    return RejectReasonSelectComponent;
}());
angular
    .module('application')
    .component('rejectReasonSelect', new RejectReasonSelectComponent());



/**
 * @author Matthew Rogers.
 */
var topic_errorsBind = { errors: '=' };
var TopicErrorsController = (function () {
    function TopicErrorsController(socket, $scope, env, admin, Dialog, settings, $filter) {
        this.socket = socket;
        this.$scope = $scope;
        this.env = env;
        this.admin = admin;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$filter = $filter;
    }
    TopicErrorsController.prototype.showErrors = function (event) {
        var items = {
            dateFormat: this.settings.up.preferences.dateFormat,
            errs: this.errors
        };
        this.Dialog.updateValidForm(event, items, 'display-topic-errors.html');
    };
    TopicErrorsController.$inject = ['socket', '$scope', 'env', 'admin', 'Dialog', 'settings', '$filter'];
    return TopicErrorsController;
}());
var TopicErrorsComponent = (function () {
    function TopicErrorsComponent() {
        this.templateUrl = 'topic-errors.html';
        this.bindings = topic_errorsBind;
        this.controller = TopicErrorsController;
    }
    return TopicErrorsComponent;
}());
angular
    .module('application')
    .component('topicErrors', new TopicErrorsComponent());



/**
 * Created by Roman T on 3/24/2017.
 */
//const dcItemBindings: { [bindngs: string]: string } = { item: '=', row: '<', comp: '<', filter: '=' };
var DetailEligibilityFindcmrCommentsController = (function () {
    function DetailEligibilityFindcmrCommentsController(topic, settings, env, socket, $scope, $attrs) {
        this.topic = topic;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.newComment = '';
    }
    DetailEligibilityFindcmrCommentsController.prototype.showHide = function () {
        this.show = this.show ? false : true;
    };
    DetailEligibilityFindcmrCommentsController.prototype.$onInit = function () {
        if (this.$attrs.section) {
            this.section = this.$attrs.section;
        }
        else {
            this.section = 'findCmr'; //Should not happen! But if so, all will be added to Elig tab
        }
    };
    DetailEligibilityFindcmrCommentsController.prototype.addCmrComment = function () {
        var objectPath = 'comments.' + this.section; //apply to Elig tab comments or Validation tab accordingly
        var data = {
            id: this.topic.topic._id,
            data: (_a = {},
                //['comments.findCmr']: {
                _a[objectPath] = {
                    push: true,
                    data: [{
                            comment: this.newComment,
                            user: this.env.user.email,
                            source: this.env.user.email,
                            time: new Date().getTime(),
                            section: this.section
                        }]
                },
                _a
            ),
            type: ['comments']
        };
        this.topic.updateServerTopic('updateCoreComments', data, true);
        this.newComment = '';
        var _a;
    };
    DetailEligibilityFindcmrCommentsController.$inject = ['topic', 'settings', 'env', 'socket', '$scope', '$attrs'];
    return DetailEligibilityFindcmrCommentsController;
}());
var DetailEligibilityFindcmrCommentsComponent = (function () {
    function DetailEligibilityFindcmrCommentsComponent() {
        this.templateUrl = 'detail-eligibility-findcmr-comments.html';
        this.controllerAs = 'vm';
        this.controller = DetailEligibilityFindcmrCommentsController;
    }
    return DetailEligibilityFindcmrCommentsComponent;
}());
angular
    .module('application')
    .component('detailEligibilityFindcmrComments', new DetailEligibilityFindcmrCommentsComponent());



var bantBind = { data: '=' };
var BantFormTableController = (function () {
    function BantFormTableController(topic, socket, $scope, env) {
        this.topic = topic;
        this.socket = socket;
        this.$scope = $scope;
        this.env = env;
        this.tableName = 'Eligibility Decisions Checklist';
        this.comp = 'complcl4';
        this.visible = false;
        this.data = this.data || [];
    }
    BantFormTableController.prototype.toggle = function () {
        this.visible = !this.visible;
        var bantLabels = {
            activitiesDescription: '6. Account url',
            activitiesPerformed: '5. Activities Performed',
            additionalInformation: '7. Additional information',
            contactEmail: '9. Contact Email',
            contactName: '8. Contact Name',
            hasItalianPublicTender: '10. Italian Public Tender',
            hasPreviousOpportunity: '3. Re-registration',
            isGEProcurement: '11. AP GE Procurement Request',
            meetingRequirement: '4. Meeting Requirement',
            previousOpportunityNumber: '3a. Please enter the previous opportunity number',
            problemDescription: '1. Problem Description',
            pronunciation: '8a. Pronunciation',
            solutionBenefit: '2. Solution Value'
        };
        this.data = this.data.filter(function (elem) { return bantLabels[elem.name] && elem.value !== ''; });
        this.data.forEach(function (elem) {
            elem.shortDescription = bantLabels[elem.name];
            elem.questionNumber = parseInt(elem.shortDescription, 10);
            if (['activitiesPerformed', 'meetingRequirement'].includes(elem.name)) {
                elem.value = elem.value === true ? 'Confirmed' : 'Not Confirmed';
                elem.label = elem.name === 'activitiesPerformed'
                    ? 'Please confirm that your company has or will participate in value-add or technical activities with your customer regarding this opportunity and that you will provide evidence of these activities open request.'
                    : 'Please confirm that an in-person meeting or conference call has taken place between your company, your Customer\'s software decision-maker, or between your company and the IBM Direct Client team or Channel team in regards to this opportunity.';
            }
        });
        this.data = this.data.filter(function (elem) { return angular.isDefined(elem.value); });
    };
    BantFormTableController.$inject = ['topic', 'socket', '$scope', 'env'];
    return BantFormTableController;
}());
// tslint:disable-next-line:max-classes-per-file
var BantFormComponent = (function () {
    function BantFormComponent() {
        this.templateUrl = 'detail-table-bant-form.html';
        this.controllerAs = 'vm';
        this.controller = BantFormTableController;
        this.bindings = bantBind;
    }
    return BantFormComponent;
}());
angular
    .module('application')
    .component('bantFormTable', new BantFormComponent());



'use strict';
var bfBind = { data: '=' };
var DetailDrgCheckDecisionController = (function () {
    function DetailDrgCheckDecisionController(topic) {
        this.topic = topic;
        this.comp = 'goe_data';
        this.lock = true;
        this.completeSection = 'goePick';
        this.goeResultStatusMap = {
            n: 'No',
            u: 'Unknown',
            y: 'Yes'
        };
        this.goeResultStatus = (angular.isDefined(this.data) && !this.data.isError)
            ? this.goeResultStatusMap[this.data.data.goeResult.finalGoeResult.toLowerCase()]
            : "Undetermined";
    }
    DetailDrgCheckDecisionController.$inject = ['topic'];
    return DetailDrgCheckDecisionController;
}());
var DetailDrgCheckDecisionComponent = (function () {
    function DetailDrgCheckDecisionComponent() {
        this.templateUrl = 'detail-drgcheck-decision.html';
        this.controllerAs = 'vm';
        this.controller = DetailDrgCheckDecisionController;
        this.bindings = bfBind;
    }
    return DetailDrgCheckDecisionComponent;
}());
angular
    .module('application')
    .component('drgCheckDecisionSection', new DetailDrgCheckDecisionComponent());



/**
 * @author Vlad
 */
var DetailEligibilityController = (function () {
    function DetailEligibilityController(topic, $state, socket, $scope, env, _) {
        this.topic = topic;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.env = env;
        this._ = _;
        this.goeCheck = 'goeCheck';
        this.isNewOppty = false;
        this.OPP_VERSION_1 = 1;
        this.OPP_VERSION_2 = 2;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_5 = 5;
        this.checksData = {
            CD: undefined,
            CMR: undefined,
            DUP: undefined,
            GOE: undefined,
            NC: undefined
        };
        this.isCheckListVisible = true;
        this.getNewUIInfo = {
            uiVersion: _.get(this.topic.checksData, 'uiVersion', 1)
        };
    }
    DetailEligibilityController.prototype.$onInit = function () {
        this.getNewOppyData();
    };
    DetailEligibilityController.prototype.getNewOppyData = function () {
        var _this = this;
        var data = this.topic.checksData;
        var inbound = data.inbound;
        this.bantData = _.get(inbound, "inbound.incentiveInformation.incentiveDetail.generics", []);
        this.isCheckListVisible = !_.get(this, 'topic.checksData.isAutoEligibilityGoe', false);
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_2) {
            this.isNewOppty = true;
            Object.keys(this.checksData)
                .filter(function (key) { return data.result && angular.isDefined(data.result[key]); })
                .forEach(function (key) {
                _this.checksData[key] = {
                    data: data.result[key].isError ? data.result[key].error : data.result[key].data,
                    isError: data.result[key].isError
                };
            });
            if (angular.isDefined(this.checksData.CD) && angular.isDefined(this.checksData.CMR)) {
                this.checksData.CD.CMR = this.checksData.CMR.data; // Copy CMR data to CD check
            }
            if (data.result && angular.isDefined(data.result.DUP_MYSA) && angular.isDefined(data.result.DUP_SC)) {
                this.checksData.DUP = {
                    DUP_MYSA: data.result.DUP_MYSA,
                    DUP_SC: data.result.DUP_SC
                };
            }
        }
    };
    DetailEligibilityController.prototype.isDisplayHistory = function () {
        return this.topic.checksData.isAutoEligibilityGoe; // && (!this.topic.goeHistoryCheck || !this.topic.goeHistoryCheck.isPassed);
    };
    DetailEligibilityController.$inject = ['topic', '$state', 'socket', '$scope', 'env', '_'];
    return DetailEligibilityController;
}());
var DetailEligibilityComponent = (function () {
    function DetailEligibilityComponent() {
        this.templateUrl = 'detail-eligibility.html';
        this.controllerAs = 'vm';
        this.controller = DetailEligibilityController;
    }
    return DetailEligibilityComponent;
}());
angular
    .module('application')
    .component('detailEligibility', new DetailEligibilityComponent());



var DetailEligDecController = (function () {
    function DetailEligDecController(topic, $scope, config, status, Dialog, socket, env) {
        this.topic = topic;
        this.$scope = $scope;
        this.config = config;
        this.status = status;
        this.Dialog = Dialog;
        this.socket = socket;
        this.env = env;
        this.emptyIdentified = false;
        this.completeSection = 'elig_dec';
        this.comp = 'elig_dec';
        this.updateArray = ['elig_dec'];
        this.statusUpdateFired = false;
        this.isElegibilityComplete = false;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
    }
    DetailEligDecController.prototype.$onInit = function () {
        //Set the suggested status on creation...it will match the current status
        this.suggestedStatus = this.config.getSubStatusBySubStatusNo2(3, this.topic.topic.status.sub_status_no);
        this.isElegibilityComplete = this.topic.isEligibilityDecisionButtonHide();
        if (this.topic.checksData && this.topic.checksData.uiVersion >= this.OPP_VERSION_3) {
            this.dealRegEligDecision = this.topic.topic.elig_dec.eligibilityDecision;
            this.eligibilityUiVersion = this.topic.checksData.uiVersion;
        }
    };
    DetailEligDecController.prototype.updateStatus = function (event) {
        var _this = this;
        if (this.topic.updatePartialSocketStatus(['gpp', 'comments$eligibility'], 'Updating')) {
            if (this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.REJECTED) {
                this.status.rejectDisbursement(event, this.topic, function (err, rejBundle) {
                    if (!err) {
                        _this.topic.sendForUpdate(['status'], rejBundle.action, rejBundle.comments, false);
                        _this.status.eligDecisionFired = true;
                    }
                });
            }
            else {
                //Prepare to ask question...based on event
                var items = {
                    icon: 'QUESTION',
                    message: 'Should you choose to continue, the Disbursement will become locked and uneditable. &nbsp;Do you want to continue?',
                    title: this.topic.topic.elig_dec.eligibilityDecision
                };
                //Ask it...
                this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                    //If clicked no
                    if (!dResult.confirm) {
                        return; //Die
                    }
                    else {
                        if (_this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.PARTIALLY_ELIGIBLE) {
                            _this.topic.temp_ext.sub_status = _this.config.getSubStatusBySubStatusNo2(3, 4).txt;
                            _this.topic.sendForUpdate(['status'], 'Eligibility Decision', '', false);
                            _this.status.eligDecisionFired = true;
                        }
                        else if (_this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.SOLUTION_ONLY) {
                            _this.topic.temp_ext.sub_status = _this.config.getSubStatusBySubStatusNo2(3, 23).txt;
                            _this.topic.sendForUpdate(['status'], 'Eligibility Decision', '', false);
                            _this.status.eligDecisionFired = true;
                        }
                        else if (_this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.ENGAGEMENT_ONLY) {
                            _this.topic.temp_ext.sub_status = _this.config.getSubStatusBySubStatusNo2(3, 32).txt;
                            _this.topic.sendForUpdate(['status'], 'Eligibility Decision', '', false);
                            _this.status.eligDecisionFired = true;
                        }
                        else if (_this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.FULLY_ELIGIBLE) {
                            _this.topic.temp_ext.sub_status = _this.config.getSubStatusBySubStatusNo2(3, 3).txt;
                            _this.topic.sendForUpdate(['status'], 'Eligibility Decision', '', false);
                            _this.status.eligDecisionFired = true;
                        }
                        else if (_this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.SPECIAL_BID_ONLY) {
                            _this.topic.temp_ext.sub_status = _this.config.getSubStatusBySubStatusNo2(3, 28).txt;
                            _this.topic.sendForUpdate(['status'], 'Eligibility Decision', '', false);
                            _this.status.eligDecisionFired = true;
                        }
                        else if (_this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.SOLUTION_AND_SPECIAL_BID_ONLY) {
                            _this.topic.temp_ext.sub_status = _this.config.getSubStatusBySubStatusNo2(3, 29).txt;
                            _this.topic.sendForUpdate(['status'], 'Eligibility Decision', '', false);
                            _this.status.eligDecisionFired = true;
                        }
                        else if (_this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.ENGAGEMENT_AND_SPECIAL_BID_ONLY) {
                            _this.topic.temp_ext.sub_status = _this.config.getSubStatusBySubStatusNo2(3, 33).txt;
                            _this.topic.sendForUpdate(['status'], 'Eligibility Decision', '', false);
                            _this.status.eligDecisionFired = true;
                        }
                    }
                });
            }
        }
    };
    /**
     * Returns true if button is disabled
     * @returns {boolean}
     */
    DetailEligDecController.prototype.isButtonDisabled = function () {
        return !(this.topic.topic.complete.statusComplete['3']
            && [
                EligibilityDecision.PARTIALLY_ELIGIBLE,
                EligibilityDecision.SOLUTION_ONLY,
                EligibilityDecision.FULLY_ELIGIBLE,
                EligibilityDecision.SOLUTION_AND_SPECIAL_BID_ONLY,
                EligibilityDecision.SPECIAL_BID_ONLY,
                EligibilityDecision.ENGAGEMENT_ONLY,
                EligibilityDecision.ENGAGEMENT_AND_SPECIAL_BID_ONLY,
                EligibilityDecision.REJECTED,
            ].includes(this.topic.topic.elig_dec.eligibilityDecision))
            || this.status.eligDecisionFired
            || this.topic.usFed.status
            || this.topic.topic.elig_dec.eligibilityDecision === 'Unknown'
            || this.topic.editableComponents.elig_dec.socket !== ''
            || (!this.topic.topic.gpp[0].dup_check_flg && this.topic.newUI);
    };
    DetailEligDecController.$inject = ['topic', '$scope', 'config', 'status', 'Dialog', 'socket', 'env'];
    return DetailEligDecController;
}());
var DetailEligDecComponent = (function () {
    function DetailEligDecComponent() {
        this.templateUrl = 'detail-elig-decision.html';
        this.controllerAs = 'vm';
        this.controller = DetailEligDecController;
    }
    return DetailEligDecComponent;
}());
angular
    .module('application')
    .component('eligibilityDecisionSection', new DetailEligDecComponent());



/**
 * Created by Roman T on 1/29/2018.
 */
var bfBind = { data: '=' };
var DetailEligibilityDecisionAutoController = (function () {
    function DetailEligibilityDecisionAutoController($scope, socket, settings, topic, Dialog, $state, $timeout, env, $http, notify) {
        var _this = this;
        this.$scope = $scope;
        this.socket = socket;
        this.settings = settings;
        this.topic = topic;
        this.Dialog = Dialog;
        this.$state = $state;
        this.$timeout = $timeout;
        this.env = env;
        this.$http = $http;
        this.notify = notify;
        this.desArray = ['IBM-Led', 'BP-Led', 'Co-Led', 'Not determined', 'Unassigned'];
        this.sectionHeader = 'Customer Designation';
        this.comp = 'customerDesignation';
        this.isResetting = false;
        this.cdResult = angular.isDefined(this.data) ? this.data : undefined;
        this.cmrArray = (angular.isDefined(this.data) && angular.isDefined(this.data.CMR))
            ? this.data.CMR.cmrCheckResults
            : undefined;
        this.finalTimestamp = this.cmrArray ? this.data.CMR.finalTimestamp : undefined;
        this.customerDesignation = (angular.isDefined(this.data) && !this.data.isError)
            ? this.data.data // CD check data
            : 'Not determined';
        this.isCDcheckPerformed = angular.isDefined(this.customerDesignation) && this.customerDesignation !== 'Not determined' && this.customerDesignation !== 'Unknown';
        this.OPP_VERSION_5 = 5;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (!_this.isCDcheckPerformed) {
                _this.customerDesignation = _this.topic.topic.customerDesignation;
                _this.isResetting = false;
            }
        });
    }
    DetailEligibilityDecisionAutoController.prototype.showCmrDataList = function (event) {
        var items = {
            dialogName: this.cmrArray,
            columnHeaders: [
                'Account Name',
                'Customer Designation',
                'Country',
                'CMR Number',
                'DCID'
            ]
        };
        this.Dialog.updateValidForm(event, items, 'cmrCdData-dialog.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
    };
    DetailEligibilityDecisionAutoController.prototype.excelExport = function () {
        console.log('sending export Excel request');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportReportExcel',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.getId(this.topic.topic._id),
                    comp: 'cd',
                    cmrArray: this.cmrArray,
                    timestamp: this.finalTimestamp
                }
            }
        });
    };
    DetailEligibilityDecisionAutoController.prototype.showOverrideButton = function () {
        if (this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5) {
            return false;
        }
        else {
            return !this.isCDcheckPerformed;
        }
    };
    DetailEligibilityDecisionAutoController.prototype.resetDecision = function (event) {
        var _this = this;
        // Prepare data to be saved
        var cdFlagArray = ['IBM-Led', 'BP-Led', 'Co-Led', 'Unassigned'];
        var currentFlag = this.topic.topic.customerDesignation ? this.topic.topic.customerDesignation : 'Not determined';
        var flagItems = {
            cdFlags: cdFlagArray,
            cdFlag: currentFlag,
            original: currentFlag,
            message: 'Please confirm the designation should be overridden:',
            okMessage: 'OK',
            cancelMessage: 'Cancel',
            dialogName: 'Designation Override',
            addCancel: false
        };
        this.Dialog.updateValidForm(event, flagItems, 'detail-elig-designation-dialog.html').then(function (dResult) {
            if (dResult.confirm && dResult.comment && dResult.comment.trim() !== '' && dResult.cdFlag.trim() !== '') {
                if (_this.topic.updatePartialSocketStatus([_this.comp], 'Updating')) {
                    // Prepare data to be saved
                    var updateObject = {
                        data: (_a = {},
                            _a['comments.eligibility'] = {
                                push: true,
                                data: [{
                                        comment: 'Designation changed from: ' + _this.topic.temp.customerDesignation + ' to ' + dResult.cdFlag + '; ' + dResult.comment,
                                        user: _this.env.user.email
                                    }]
                            },
                            _a.customerDesignation = {
                                add: true,
                                data: dResult.cdFlag
                            },
                            _a
                        ),
                        id: _this.topic.topic._id,
                        type: ['comments', 'customerDesignation']
                    };
                    var check = [{
                            name: 'CD',
                            value: dResult.cdFlag,
                            id: _this.topic.topic._id.substr(4)
                        }];
                    _this.topic.updateServerTopic('couchUpdate', updateObject, true, check); // Send it to be saved
                    _this.isResetting = true;
                }
            }
            var _a;
        });
    };
    DetailEligibilityDecisionAutoController.prototype.isEligibilityCompleted = function () {
        return !(this.topic.topic.status.status_no === 3
            && [3, 4, 23, 28, 29, 32, 33].indexOf(this.topic.topic.status.sub_status_no) < 0);
    };
    DetailEligibilityDecisionAutoController.prototype.$onInit = function () {
        if (this.topic.topic.customerDesignation && ['Not determined', 'Unknown'].indexOf(this.topic.topic.customerDesignation) < 0) {
            this.customerDesignation = this.topic.topic.customerDesignation;
        }
    };
    DetailEligibilityDecisionAutoController.$inject = ['$scope', 'socket', 'settings', 'topic', 'Dialog', '$state', '$timeout', 'env', '$http', 'notify', 'Dialog'];
    return DetailEligibilityDecisionAutoController;
}());
var DetailEligibilityDecisionAutoComponent = (function () {
    function DetailEligibilityDecisionAutoComponent() {
        this.templateUrl = 'detail-eligibility-designation-auto.html';
        this.bindings = bfBind;
        this.controller = DetailEligibilityDecisionAutoController;
        this.controllerAs = 'vm';
    }
    return DetailEligibilityDecisionAutoComponent;
}());
angular
    .module('application')
    .component('customerDesignationAuto', new DetailEligibilityDecisionAutoComponent());



/**
 * Created by Roman T on 1/29/2018.
 */
var DetailEligibilityDecisionController = (function () {
    function DetailEligibilityDecisionController(topic, $state, $stateParams, DTS, socket, $scope, env, Dialog) {
        var _this = this;
        this.topic = topic;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.DTS = DTS;
        this.socket = socket;
        this.$scope = $scope;
        this.env = env;
        this.Dialog = Dialog;
        this.comp = 'customerDesignation';
        this.desArray = ['IBM-Led', 'BP-Led', 'Co-Led', 'Unknown', 'Unassigned'];
        this.sectionHeader = 'Customer Designation';
        this.isResetting = false;
        this.showOverride = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            _this.isResetting = false;
            _this.setOverrideStatus();
        });
    }
    DetailEligibilityDecisionController.prototype.setOverrideStatus = function () {
        // If user is not an approver or reader...
        if (!this.env.user.access.approver && !this.env.user.access.reader) {
            if (this.topic.topic.status.status_no === 3 &&
                [3, 4, 23, 28, 29, 32, 33].indexOf(this.topic.topic.status.sub_status_no) < 0 &&
                angular.isDefined(this.topic.topic.goe.picked) &&
                this.topic.topic.goe.picked !== '') {
                //this.topic.topic.customerDesignation) {
                this.showOverride = true; // If in eligibility status...show it
            }
            else if (this.topic.topic.status.status_no === 4 && !this.topic.areCalcsStarted() && this.env.user.access.systemAdmin) {
                this.showOverride = true; // If in validation and pre-calcs and system admin, show it
            }
            else {
                this.showOverride = false;
            }
        }
        else {
            this.showOverride = false;
        }
        // Could be a scenario where the server says this object is not editable, but a change to another component such
        // as GE Decision or find cmr will mean this component now needs to be editable... the 10k does not refresh
        // the editable components on a partial update, so need to hack it here
        if (this.showOverride) {
            this.topic.editableComponents.customerDesignation = { editable: true, editMode: false, socket: '' };
        }
        else {
            this.topic.editableComponents.customerDesignation = { editable: false, editMode: false, socket: 'Not Editable' };
        }
    };
    DetailEligibilityDecisionController.prototype.$onInit = function () {
        this.setOverrideStatus();
    };
    DetailEligibilityDecisionController.prototype.resetDecision = function (event) {
        var _this = this;
        // Prepare data to be saved
        var cdFlagArray = ['IBM-Led', 'BP-Led', 'Co-Led', 'Unassigned'];
        var currentFlag = this.topic.topic.customerDesignation ? this.topic.topic.customerDesignation : 'Unknown';
        var flagItems = {
            cdFlags: cdFlagArray,
            cdFlag: currentFlag,
            original: currentFlag,
            message: 'Please confirm the designation should be overridden:',
            okMessage: 'OK',
            cancelMessage: 'Cancel',
            dialogName: 'Designation Override',
            addCancel: false
        };
        //flagItems.cdFlags.splice(cdFlagArray.indexOf(currentFlag), 1);
        //flagItems.cdFlag = flagItems.cdFlags[0];
        this.Dialog.updateValidForm(event, flagItems, 'detail-elig-designation-dialog.html').then(function (dResult) {
            if (dResult.confirm && dResult.comment && dResult.comment.trim() !== '' && dResult.cdFlag.trim() !== '') {
                if (_this.topic.updatePartialSocketStatus([_this.comp], 'Updating')) {
                    // Prepare data to be saved
                    var updateObject = {
                        data: (_a = {},
                            _a['comments.eligibility'] = {
                                push: true,
                                data: [{
                                        comment: 'Designation changed from: ' + _this.topic.temp.customerDesignation + ' to ' + dResult.cdFlag + '; ' + dResult.comment,
                                        user: _this.env.user.email
                                    }]
                            },
                            _a.customerDesignation = {
                                add: true,
                                data: dResult.cdFlag
                            },
                            _a
                        ),
                        id: _this.topic.topic._id,
                        type: ['comments', 'customerDesignation']
                    };
                    _this.topic.updateServerTopic('couchUpdate', updateObject, true); // Send it to be saved
                    _this.isResetting = true;
                }
            }
            var _a;
        });
    };
    DetailEligibilityDecisionController.$inject = ['topic', '$state', '$stateParams', 'DTS', 'socket', '$scope', 'env', 'Dialog'];
    return DetailEligibilityDecisionController;
}());
var DetailEligibilityDecisionComponent = (function () {
    function DetailEligibilityDecisionComponent() {
        this.templateUrl = 'detail-eligibility-designation.html';
        this.controllerAs = 'vm';
        this.controller = DetailEligibilityDecisionController;
    }
    return DetailEligibilityDecisionComponent;
}());
angular
    .module('application')
    .component('customerDesignation', new DetailEligibilityDecisionComponent());



/**
 * @author Ivan Toth.
 */
var DetailEligibilityEditController = (function () {
    function DetailEligibilityEditController(topic, $state, $stateParams) {
        this.topic = topic;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.OPP_VERSION_2 = 2;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_5 = 5;
    }
    ;
    DetailEligibilityEditController.prototype.$onInit = function () {
        this.fieldStyle = { color: 'red' };
    };
    DetailEligibilityEditController.prototype.goto = function (tab) {
        this.$state.go(tab.name, this.$stateParams);
        this.activeTab = tab.name;
    };
    // Attach file attachemnts
    DetailEligibilityEditController.prototype.attachFile = function () {
        alert('Attaching a file');
    };
    DetailEligibilityEditController.$inject = ['topic', '$state', '$stateParams'];
    return DetailEligibilityEditController;
}());
var DetailEligibilityEditComponent = (function () {
    function DetailEligibilityEditComponent() {
        this.templateUrl = 'detail-eligibility.html';
        this.controllerAs = 'vm';
        this.controller = DetailEligibilityEditController;
    }
    return DetailEligibilityEditComponent;
}());
angular
    .module('application')
    .component('detailEligibilityEdit', new DetailEligibilityEditComponent());



/**
 * @author Domenico de Felice 2018-02-14 - Card 1226 - additional fields in Eligibility "appeal" disputes.
 */
'use strict';
var DetailEligibilityGoeAppealController = (function () {
    function DetailEligibilityGoeAppealController(topic, $scope, socket) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.comp = 'goe_appeal'; // Name of this component
        this.appealRequestReceived = undefined;
        this.appealRequestSentToSecondReview = undefined;
        this.appealValidityInformation = ''; // default value
        this.appealStage = ''; // default value
        // this is set to true only for DMT dispute documents flagged as 'appeal'
        if (topic.topic.dispute_details) {
            if (topic.topic.dispute_details.dispute_type) {
                //console.log("Dispute details: " + topic.topic.dispute_details.dispute_type);
                if (topic.topic.dispute_details.dispute_type === 'Appeal') {
                    // set subform visible
                    this.visibleGOEAppealSection = true; // set subform visible
                    //console.log("GOE Appeal section visible: " + this.visibleGOEAppealSection);
                    // Field: appeal request received
                    topic.topic.goe_appeal && topic.topic.goe_appeal.appealRequestReceived ?
                        this.appealRequestReceived = new Date(parseInt(topic.topic.goe_appeal.appealRequestReceived, 10)) :
                        this.appealRequestReceived;
                    //console.log("Appeal request received: " + this.appealRequestReceived);
                    // Field: Appeal validity information
                    topic.topic.goe_appeal && topic.topic.goe_appeal.appealValidityInformation ?
                        this.appealValidityInformation = topic.topic.goe_appeal.appealValidityInformation :
                        this.appealValidityInformation;
                    //console.log("Appeal validity info: " + this.appealValidityInformation);
                    // Field: Appeal Stage
                    topic.topic.goe_appeal && topic.topic.goe_appeal.appealStage ?
                        this.appealStage = topic.topic.goe_appeal.appealStage :
                        this.appealStage;
                    //console.log("Appeal request stage: " + this.appealStage);
                    // Field: Appeal request sent to second review
                    topic.topic.goe_appeal && topic.topic.goe_appeal.appealRequestSentToSecondReview ?
                        this.appealRequestSentToSecondReview = new Date(parseInt(topic.topic.goe_appeal.appealRequestSentToSecondReview, 10)) :
                        this.appealRequestSentToSecondReview;
                }
            }
        }
        // options for dropdown menu Appeal Stage
        this.appealStageOptions = ['appeal on hold',
            'appeal approved',
            'appeal declined',
            'appeal rejected',
            'second review',
            'second review on hold',
            'review approved',
            'review declined',
            'review rejected'];
        this.appealValidityOptions = ['Valid', 'Invalid'];
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // If the topic has been updated from the server...check if this component is part of
            // what was changed
            if (data.indexOf(_this.comp) > -1) {
                // If so, set edit status accordingly...
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    DetailEligibilityGoeAppealController.prototype.toggleGOEAppealFields = function () {
        this.visibleGOEAppealFields = !this.visibleGOEAppealFields;
    };
    DetailEligibilityGoeAppealController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp); // Set edit based on value in topic.editableComponents
    };
    /**
     * Default function for all components that use the 10k edit/save/cancel component
     * @param action
     */
    DetailEligibilityGoeAppealController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            // Set the status of this component to Updating...
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                // Prepare data to be saved
                var updateObject = {
                    data: {
                        goe_appeal: {
                            add: true,
                            data: this.topic.temp.goe_appeal
                        }
                    },
                    id: this.topic.topic._id,
                    type: ['goe_appeal']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true); // Send it to be saved
                this.edit.editMode = this.topic.cancelEdit(this.comp); // Turn edit off
            }
        }
        else if (action === 'edit') {
            // Set temp values in topic for invoice_flags - and set edit mode to editable
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp); // Set status uneditable
        }
    };
    DetailEligibilityGoeAppealController.$inject = ['topic', '$scope', 'socket']; // Minimum required
    return DetailEligibilityGoeAppealController;
}());
var DetailEligibilityGoeAppealComponent = (function () {
    function DetailEligibilityGoeAppealComponent() {
        this.templateUrl = 'detail-eligibility-goe-appeal.html';
        this.controllerAs = 'vm';
        this.controller = DetailEligibilityGoeAppealController;
    }
    return DetailEligibilityGoeAppealComponent;
}());
// const angular: any = undefined;
angular
    .module('application')
    .component('detailEligibilityGoeAppeal', new DetailEligibilityGoeAppealComponent());



/**
 * Created by Vladislav
 */
var NewClientDeterminationController = (function () {
    function NewClientDeterminationController(topic, $state, settings, $stateParams, DTS, socket, $scope, env, Dialog, moment) {
        var _this = this;
        this.topic = topic;
        this.$state = $state;
        this.settings = settings;
        this.$stateParams = $stateParams;
        this.DTS = DTS;
        this.socket = socket;
        this.$scope = $scope;
        this.env = env;
        this.Dialog = Dialog;
        this.moment = moment;
        this.comp = 'nc';
        this.lock = true;
        this.desArray = ['IBM-Led', 'BP-Led', 'Co-Led', 'Unassigned'];
        this.enableSection = true;
        this.isResetting = false;
        this.showThumb = true;
        this.processing = false;
        this.ncEndData = '';
        this.OPP_VERSION_3 = 3;
        this.getNewUIInfo = {
            NC: _.get(this.topic.checksData.result, 'NC', {}),
            uiVersion: _.get(this.topic.checksData, 'uiVersion', 1)
        };
        this.newClient = {};
        this.errorCheckerInput = false;
        this.socket.forward('topic.search.result', this.$scope);
        this.$scope.$on('socket:topic.search.result', function (event, data) {
            _this.processing = false;
        });
        this.visible = false;
        this.filterDisplay = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // If the topic has been updated from the server...check if this component is part of
            // what was changed
            if (data.indexOf(_this.comp) > -1) {
                // HACK... if topic is updated and customer designation is IBM-Led
                // update the nc edit options accordingly... this is out-of-scope of the 10k
                // Sweet baby jesus and the orphans!!
                if (_this.topic.topic.customerDesignation === 'IBM-Led') {
                    _this.topic.editableComponents.nc = { editable: false, editMode: false, socket: 'Not Editable' };
                }
                else {
                    _this.topic.editableComponents.nc = { editable: true, editMode: false, socket: '' };
                }
                _this.edit = _this.topic.editableComponents.nc;
            }
            _this.ncEndData = _this.getNewClientApplicabilityEndData();
        });
    }
    NewClientDeterminationController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
        this.ncEndData = this.getNewClientApplicabilityEndData();
    };
    NewClientDeterminationController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    NewClientDeterminationController.prototype.isButtonDisabled = function () {
        return this.topic.checkNewClientEditMode(this.comp);
    };
    NewClientDeterminationController.prototype.toggleFilter = function () {
        this.filterDisplay = !this.filterDisplay;
        if (!this.filterDisplay) {
            this.newClient.country = undefined;
            this.newClient.cmrNum = undefined;
            this.newClient.fuzzySearch = undefined;
        }
    };
    NewClientDeterminationController.prototype.formChecker = function () {
        this.errorCheckerInput = this.newClient.country && (this.newClient.cmrNum || this.newClient.fuzzySearch);
    };
    NewClientDeterminationController.prototype.doSearch = function (opp) {
        this.newClient.ds = 'NC';
        this.newClient.opp = opp;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getFuzzyResults',
                script: '/detail/eligibility/eligibility',
                data: this.newClient,
                token: this.env.user.token,
                bID: this.topic.topicBrowserID,
                partial: true
            }
        });
    };
    NewClientDeterminationController.prototype.changeEditMode = function (action, event) {
        var _this = this;
        if (action === 'save') {
            if (typeof this.topic.topic.nc.ncDecision === 'undefined') {
                this.saveNewClientDecision('initilazed');
            }
            else {
                var items = {
                    message: 'Please justify the new client determination override:',
                    okMessage: 'OK',
                    cancelMessage: 'Cancel',
                    dialogName: 'New Client Override',
                    addCancel: false
                };
                this.Dialog.updateValidForm(event, items, 'confirm-and-comment.html').then(function (dResult) {
                    if (dResult.confirm && dResult.comment && dResult.comment.trim() !== '') {
                        _this.saveNewClientDecision(dResult.comment);
                    }
                });
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.topic.temp[this.comp] = this.topic.topic[this.comp]; //Reset to original value
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    NewClientDeterminationController.prototype.saveNewClientDecision = function (comment) {
        if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
            // Prepare data to be saved
            this.topic.temp.nc.manual = true;
            var updateObject = {
                data: (_a = {},
                    _a['comments.nc'] = {
                        push: true,
                        data: [{
                                comment: 'New Client determinations changed to: ' + this.topic.temp.nc.ncDecision + '; ' + comment,
                                user: this.env.user.email
                            }]
                    },
                    _a.nc = {
                        add: true,
                        data: this.topic.temp.nc
                    },
                    _a
                ),
                id: this.topic.topic._id,
                type: ['comments', 'nc']
            };
            var check = [{
                    id: this.topic.topic._id.substring(4),
                    name: 'NC',
                    value: this.topic.temp.nc
                }];
            this.topic.updateServerTopic('couchUpdate', updateObject, true, check); // Send it to be saved
            this.edit.editMode = this.topic.cancelEdit(this.comp); // Turn edit off
        }
        var _a;
    };
    NewClientDeterminationController.prototype.getNewClientApplicabilityEndData = function () {
        var minEndDate = '';
        //if the temp topic is not presented to check NC decision from the persistent topic
        var nc = this.topic.temp.nc || this.topic.topic.nc;
        if (nc && nc.ncDecision) {
            if (this.getNewUIInfo.NC && this.getNewUIInfo.NC.data && Number(this.getNewUIInfo.NC.data.minNcApprovedEndDate) > 0) {
                minEndDate = this.getNewUIInfo.NC.data.minNcApprovedEndDate;
            }
            else if (Number(this.topic.topic.gpp[0].svisubmitdate) > 0) {
                minEndDate = this.moment(Number(this.topic.topic.gpp[0].svisubmitdate)).add(1, 'years').valueOf();
            }
        }
        return minEndDate;
    };
    /**
     * Determine for v3 is section(Is New Client) can be disabled
     * @private
     * @returns {boolean}
     * @memberof NewClientDeterminationController
     */
    NewClientDeterminationController.prototype.isNewClientV3Disabled = function () {
        var _this = this;
        var isNcCopied = function () {
            return typeof _.get(_this.topic.topic, 'dispute_details.copiedChecks.isNcCopied') === 'boolean'
                ? !_.get(_this.topic.topic, 'dispute_details.copiedChecks.isNcCopied')
                : undefined;
        };
        // If Dispute && NC was not copied
        if (this.topic.topic._id.includes('DIS') && isNcCopied()) {
            return false;
        }
        return !this.getNewUIInfo.NC.isError;
    };
    NewClientDeterminationController.$inject = ['topic', '$state', 'settings', '$stateParams', 'DTS', 'socket', '$scope', 'env', 'Dialog', 'moment'];
    return NewClientDeterminationController;
}());
var NewClientDeterminationComponent = (function () {
    function NewClientDeterminationComponent() {
        this.templateUrl = 'detail-new-client.html';
        this.controllerAs = 'vm';
        this.controller = NewClientDeterminationController;
    }
    return NewClientDeterminationComponent;
}());
angular
    .module('application')
    .component('newClientDetermination', new NewClientDeterminationComponent());



/**
 * @author Ivan Toth.
 */
var FileUploadFcmrController = (function () {
    function FileUploadFcmrController($state, $scope, socket, topic, env, settings, notify) {
        var _this = this;
        this.$state = $state;
        this.$scope = $scope;
        this.socket = socket;
        this.topic = topic;
        this.env = env;
        this.settings = settings;
        this.notify = notify;
        this.lockEnabled = false;
        this.title = 'Government Check';
        this.section = 'fcmr';
        this.comp = 'files$fcmr';
        this.updateArray = ['files$fcmr'];
        this.showAttachment = false;
        this.submitting = true;
        this.sources = {};
        this.fileUploaded = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    FileUploadFcmrController.prototype.showHide = function () {
        this.showAttachment = this.showAttachment ? false : true;
    };
    FileUploadFcmrController.prototype.decode = function (file) {
        return decodeURIComponent(file);
    };
    // Prepares the files for file upload
    FileUploadFcmrController.prototype.uploadFiles = function (files) {
        this.fileNames = [];
        var fileContent = files;
        // If some files submitted perform the update
        if (fileContent.length > 0) {
            var i = 0;
            for (var _i = 0, fileContent_1 = fileContent; _i < fileContent_1.length; _i++) {
                var file = fileContent_1[_i];
                console.info('$detail.file.upload (uploadFiles) => file before update: ' + file.name);
                this.fileNames[i] = { name: file.name, type: file.type, comment: '' };
                i++;
            }
            this.fileUploaded = true;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'uploadFile',
                    script: 'config/config',
                    data: { files: this.fileNames, id: this.topic.topic._id, type: this.section },
                    files: this.sources,
                    bID: this.topic.topicBrowserID,
                    token: this.env.user.token
                }
            });
        }
        this.edit.editMode = this.topic.cancelEdit(this.comp);
        //files = [];
        //return files;
    };
    FileUploadFcmrController.prototype.downloadAttachment = function (name) {
        console.info('$detail.file.upload (downloadAttachment) downloaded attachment');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'downloadAttachment',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.topic._id,
                    name: name
                }
            }
        });
    };
    FileUploadFcmrController.prototype.showUserData = function (file, visible) {
        file.visible = visible;
    };
    FileUploadFcmrController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    FileUploadFcmrController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.sendForUpdateFiles(this.comp, false);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPartFiles(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    FileUploadFcmrController.prototype.commentChange = function (fileName) {
        angular.forEach(this.topic.temp.files, function (file) {
            if (file.name === fileName) {
                file.modified = true;
            }
        });
    };
    FileUploadFcmrController.$inject = ['$state', '$scope', 'socket', 'topic', 'env', 'settings', 'notify'];
    return FileUploadFcmrController;
}());
var FileUploadFcmrComponent = (function () {
    function FileUploadFcmrComponent() {
        this.templateUrl = 'detail-file-upload.html';
        this.controllerAs = 'vm';
        this.controller = FileUploadFcmrController;
    }
    return FileUploadFcmrComponent;
}());
angular
    .module('application')
    .component('fileUploadFcmrSection', new FileUploadFcmrComponent());



/**
 * @author Ivan Toth.
 */
var FileUploadController = (function () {
    function FileUploadController($state, $scope, socket, topic, env, settings, notify) {
        var _this = this;
        this.$state = $state;
        this.$scope = $scope;
        this.socket = socket;
        this.topic = topic;
        this.env = env;
        this.settings = settings;
        this.notify = notify;
        this.title = 'Eligibility';
        this.lockEnabled = false;
        this.section = 'eligibility';
        this.comp = 'files$eligibility';
        this.updateArray = ['files$eligibility'];
        this.showAttachment = false;
        this.submitting = true;
        this.sources = {};
        this.fileUploaded = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    FileUploadController.prototype.showHide = function () {
        this.showAttachment = this.showAttachment ? false : true;
    };
    FileUploadController.prototype.decode = function (file) {
        return decodeURIComponent(file); //Probably not necessary anymore since names are not being stored encoded
    };
    // Prepares the files for file upload
    FileUploadController.prototype.uploadFiles = function (files) {
        this.fileNames = [];
        var fileContent = files;
        // If some files submitted perform the update
        if (fileContent.length > 0) {
            var i = 0;
            for (var _i = 0, fileContent_1 = fileContent; _i < fileContent_1.length; _i++) {
                var file = fileContent_1[_i];
                console.info('$detail.file.upload (uploadFiles) => file before update: ' + file.name);
                this.fileNames[i] = { name: file.name, type: file.type, comment: '' };
                i++;
            }
            this.fileUploaded = true;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'uploadFile',
                    script: 'config/config',
                    data: { files: this.fileNames, id: this.topic.topic._id, type: this.section },
                    files: this.sources,
                    bID: this.topic.topicBrowserID,
                    token: this.env.user.token
                }
            });
        }
        this.edit.editMode = this.topic.cancelEdit(this.comp);
    };
    FileUploadController.prototype.downloadAttachment = function (name) {
        console.info('$detail.file.upload (downloadAttachment) downloaded attachment');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'downloadAttachment',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.topic._id,
                    name: name
                }
            }
        });
    };
    FileUploadController.prototype.showUserData = function (file, visible) {
        file.visible = visible;
    };
    FileUploadController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    FileUploadController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.sendForUpdateFiles(this.comp, false);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPartFiles(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    FileUploadController.prototype.commentChange = function (fileName) {
        angular.forEach(this.topic.temp.files, function (file) {
            if (file.name === fileName) {
                file.modified = true;
            }
        });
    };
    FileUploadController.$inject = ['$state', '$scope', 'socket', 'topic', 'env', 'settings', 'notify'];
    return FileUploadController;
}());
var FileUploadComponent = (function () {
    function FileUploadComponent() {
        this.templateUrl = 'detail-file-upload.html';
        this.controllerAs = 'vm';
        this.controller = FileUploadController;
    }
    return FileUploadComponent;
}());
angular
    .module('application')
    .component('fileUploadSection', new FileUploadComponent());



var DetailGppStaticController = (function () {
    function DetailGppStaticController(topic, settings, socket, env, $filter, Dialog, _, $state) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.env = env;
        this.$filter = $filter;
        this.Dialog = Dialog;
        this._ = _;
        this.$state = $state;
        this.comp = 'gpp';
        this.diffArray = 'gppMissing';
        this.paSiteVisibe = false;
        this.paSiteEditable = true;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.timestamp = this.getTimestamp();
        var contactEmail = this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5 ?
            this.topic.topic.contactEmail :
            _.get(this.topic.checksData, 'inboundInitial.inbound.incentiveInformation.incentiveDetail.createdBy');
        var oppVersion = _.get(this.topic.checksData, 'uiVersion', 1);
        this.getNewUIInfo = {
            uiVersion: oppVersion,
            email: contactEmail,
            cmr: _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.incentiveCMRNumber'),
            accountInfo: _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.account.sites'),
            isRestricted: _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.opportunity.isRestricted'),
            bpCountry: function () {
                return _this.topic.getCountryFullName(_.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.country'));
            },
            accountCountry: function () {
                return _this.topic.getCountryFullName(_.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrCountryCode'));
            },
            bpName: function () {
                var bpFirstName;
                var bpLastName;
                if (oppVersion && oppVersion <= _this.OPP_VERSION_4) {
                    bpFirstName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.bpFirstName');
                    bpLastName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.bpLastName');
                }
                else {
                    bpFirstName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.bpFirstName');
                    bpLastName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.bpLastName');
                }
                return bpFirstName + " " + bpLastName;
            },
            getSVISumbitDateName: function () {
                return _this.getNewUIInfo.uiVersion >= _this.OPP_VERSION_3
                    ? 'Submit Date:'
                    : 'Submit Date for CVR Eligibility:';
            },
            getAccountValue: function (accountName) {
                var generics = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.generics', []);
                var accountObj = generics.find(function (generic) { return generic.name === accountName; });
                return accountObj ? accountObj.value : '';
            },
            externalLinks: function (link) { return _this.topic.externalLinks[link]; }
        };
    }
    DetailGppStaticController.prototype.getDcId = function () {
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrDomesticClientId');
        }
        else {
            return this.getNewUIInfo.getAccountValue('domesticClientId');
        }
    };
    DetailGppStaticController.prototype.getRevenueV5 = function () {
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.opportunityAmount');
        }
        return undefined;
    };
    DetailGppStaticController.prototype.getOppCurrencyV5 = function () {
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.opportunityCurrency');
        }
        return undefined;
    };
    DetailGppStaticController.prototype.getDbg = function () {
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrDomesticBuyingGroup');
        }
        else {
            return this.getNewUIInfo.getAccountValue('domesticBuyingGroup');
        }
    };
    DetailGppStaticController.prototype.isSiteIdDataAvailable = function () {
        return this.topic.siteIdData && this.topic.siteIdData.length;
    };
    /**
     * Return timestamp based on which tab was clicked
     * @returns number
     * @memberof DetailGppStaticController
     */
    DetailGppStaticController.prototype.getTimestamp = function () {
        var activeTab = _.words(this.$state.current.name)[1];
        if (activeTab === 'eligibility') {
            return this.topic.topic["gpp"][0].timestamp;
        }
        if (activeTab === 'general') {
            if (this.topic.topic['gppOnAssign']) {
                return this.topic.topic['gppOnAssign'][0].timestamp;
            }
            // If the gppOnAssign object is not exist,
            // set timestamp from gpp_live - ie: the latest data
            return this.topic.topic['gpp_live'][0].timestamp;
        }
    };
    DetailGppStaticController.prototype.isV4OrLess = function () {
        var version = this.topic.topic.version;
        return !version || version <= this.OPP_VERSION_4;
    };
    DetailGppStaticController.prototype.changePaVisible = function () {
        this.paSiteVisibe = !this.paSiteVisibe;
    };
    DetailGppStaticController.prototype.getRestricted = function () {
        return this.isV4OrLess() ? this.getRestrictedV4() : this.getRestrictedV5();
    };
    DetailGppStaticController.prototype.getRestrictedV4 = function () {
        switch (this.getNewUIInfo.isRestricted) {
            case 'RESTNOT':
                return 'Not Restricted';
            case 'RESTOPCL':
                return 'Restricted to opportunity team, client team and incentive review team';
            case 'RESTOPTY':
                return 'Restricted to opportunity team and incentive review team';
            default:
                return '';
        }
    };
    DetailGppStaticController.prototype.getRestrictedV5 = function () {
        switch (this.topic.topic.isRestr) {
            case 'N':
                return 'Not Restricted';
            case 'Y':
                return 'Restricted';
            default:
                return '';
        }
    };
    DetailGppStaticController.prototype.showAccountArrayList = function () {
        var items = {
            dialogName: this.getNewUIInfo.accountInfo,
            columnHeaders: [
                'CMR Number',
                'Site ID',
                'Account Name',
                'Address',
                'City',
                'State',
                'Postal Code',
                'Country'
            ]
        };
        this.Dialog.updateValidForm(event, items, 'accountInfoData-dialog.html');
    };
    DetailGppStaticController.prototype.showSiteIdData = function () {
        var items = {
            siteIdData: this.topic.siteIdData,
            headers: [
                'CMR Number',
                'Site ID',
                'Account Name',
                'Address',
                'City',
                'State',
                'Postal Code',
                'Country'
            ]
        };
        this.Dialog.updateValidForm(event, items, 'siteIdData-dialog.html');
    };
    DetailGppStaticController.prototype.excelSiteIDsExport = function () {
        console.log('sending export Excel request');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportReportExcel',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.getId(this.topic.topic._id),
                    comp: 'siteids',
                    siteIdsArray: this.getNewUIInfo.accountInfo.map(function (element) {
                        element.cntryCode2 = undefined;
                        return element;
                    })
                }
            }
        });
    };
    DetailGppStaticController.prototype.excelSiteIdsV5Export = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportReportExcel',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.getId(this.topic.topic._id),
                    comp: 'siteIdsV5',
                    siteIdsArray: this.topic.siteIdData.map(function (element) {
                        element.cntryCode2 = undefined;
                        return element;
                    })
                }
            }
        });
    };
    DetailGppStaticController.prototype.getMySAChange = function (field, type) {
        var refresh = this.topic.isInEligibilityStatus() ? '  Click Refresh Opportunity Data to overwrite.' : '';
        var value;
        if (type === 'date') {
            value = this.$filter('date')(new Date(Number(this.topic.topic.gpp_live[0][field])), this.settings.up.preferences.dateFormat, '+1200');
        }
        else if (type === 'number') {
            value = this.$filter('number')(this.topic.topic.gpp_live[0][field], 2);
        }
        else {
            value = this.topic.topic.gpp_live[0][field];
        }
        return "This value has changed at MySA.  The new value is " + value + "." + refresh;
    };
    DetailGppStaticController.prototype.reload = function () {
        // not actual anymore
        // if (this.topic.updatePartialSocketStatus(['gpp', 'comments$eligibility'], 'Updating')) {
        //     this.socket.emit('module', {
        //         module: {
        //             application: 'dmt',
        //             bID: this.topic.topicBrowserID,
        //             data: {
        //                 opp: this.topic.topic.opp, //This will run a query in DB2 so needs to be OPP
        //                 type: ['gpp', 'comments$eligibility'],
        //                 unid: this.topic.topic._id,
        //             },
        //             function: 'updateEligGppData',
        //             partial: true,
        //             script: '/detail/general/general',
        //             token: this.env.user.token,
        //         },
        //     });
        // } else {
        //     alert('Problem when updating eligibility gpp');
        // }
    };
    DetailGppStaticController.$inject = ['topic', 'settings', 'socket', 'env', '$filter', 'Dialog', '_', '$state'];
    return DetailGppStaticController;
}());
var DetailGppStaticComponent = (function () {
    function DetailGppStaticComponent() {
        this.templateUrl = 'detail-eligibility-gpp.html';
        this.controllerAs = 'vm';
        this.controller = DetailGppStaticController;
    }
    return DetailGppStaticComponent;
}());
angular
    .module('application')
    .component('detailGppStatic', new DetailGppStaticComponent());



/**
 * Created by Kim J on 2018-01-31.
 */
var DetailEligGOEAddFieldsController = (function () {
    function DetailEligGOEAddFieldsController(topic, $scope, socket) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.comp = 'goe_add_fields';
        this.cutOver = this.topic.settings.generalDeterminationCutoverDate;
        this.isNewGoeDetermination = false; // new Goe Determination questions (cutover date: 18/02/2020)
        this.overallFindGOEResult = ['Government Owned Entity', 'State Owned Enterprise', 'Unknown', 'Non-Government', 'No Results Found'];
        this.overallGoeIndicator = ['Government Owned Entity', 'State Owned Enterprise', 'Unknown', 'Non-Government'];
        this.goeDeterminant = ['FindGOE Tool', 'Exception list', 'IntOrg list', 'DUNS tab check', 'PEP check', 'GOE Team', 'NGE Declaration Process', 'SO name Clarification'];
        this.declarationLetter = ['Yes', 'No'];
        this.uiVersion = this.topic.checksData.uiVersion;
        this.visibleGOEAddFields = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp) > -1) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
        this.goe_decl_letter_sent = ['Yes', 'No'];
        this.goe_indicator = ['GE', 'Unknown', 'NGE'];
        this.goe_determinant = ['FindCMR tool', 'Exception list', 'Internet check', 'IntOrgList', 'BRET check', 'PEP check', 'GOE Team', '25%/75% rule', 'SME Protocol', 'NGE 10.3.4', 'SO name clarification'];
        this.goe_overall_find_cmr = ['8A GE', '8B Unknown', '8C NGE', '8D GE', '8E Unknown', '8F Unknown'];
    }
    DetailEligGOEAddFieldsController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
        if (this.checkDate()) {
            this.isNewGoeDetermination = true;
        }
    };
    DetailEligGOEAddFieldsController.prototype.checkDate = function () {
        return this.topic.compareDates(new Date(Number(this.topic.topic.gpp[0].svisubmitdate)), new Date(this.cutOver)) > 0;
    };
    DetailEligGOEAddFieldsController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                var updateObject = {
                    data: {
                        goe_add_fields: {
                            add: true,
                            data: this.topic.temp.goe_add_fields
                        }
                    },
                    id: this.topic.topic._id,
                    type: ['goe_add_fields']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailEligGOEAddFieldsController.prototype.toggleGOEAddFields = function () {
        this.visibleGOEAddFields = !this.visibleGOEAddFields;
    };
    DetailEligGOEAddFieldsController.$inject = ['topic', '$scope', 'socket', 'env', '_'];
    return DetailEligGOEAddFieldsController;
}());
var DetailEligGOEAddFieldsComponent = (function () {
    function DetailEligGOEAddFieldsComponent() {
        this.templateUrl = 'detail-eligibility-goe-addfields.html';
        this.controllerAs = 'vm';
        this.controller = DetailEligGOEAddFieldsController;
    }
    return DetailEligGOEAddFieldsComponent;
}());
angular
    .module('application')
    .component('detailEligibilityGoeAddfields', new DetailEligGOEAddFieldsComponent());



var DetailGoeController = (function () {
    function DetailGoeController(topic, $scope, Dialog, env) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.env = env;
        this.lock = true;
        this.completeSection = 'goePick';
        this.comp = 'goe';
        this.updateArray = ['goe'];
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
        this.goeOptions = ['Yes', 'No', 'Unknown', 'State Owned'];
    }
    DetailGoeController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailGoeController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                var check = [{
                        id: this.topic.topic._id.substring(4),
                        name: 'INCGOE',
                        value: this.topic.temp.goe.picked
                    }];
                this.topic.sendForUpdateGeneral(this.updateArray, true, undefined, check);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.topic.temp[this.comp] = this.topic.topic[this.comp]; //Reset to original value
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailGoeController.$inject = ['topic', '$scope', 'Dialog', 'env'];
    return DetailGoeController;
}());
var DetailGoeComponent = (function () {
    function DetailGoeComponent() {
        this.templateUrl = 'detail-goe.html';
        this.controllerAs = 'vm';
        this.controller = DetailGoeController;
    }
    return DetailGoeComponent;
}());
angular
    .module('application')
    .component('goeSection', new DetailGoeComponent());



var BPChecksFieldKey;
(function (BPChecksFieldKey) {
    BPChecksFieldKey[BPChecksFieldKey["skillsDecision"] = 'SKILLS'] = "skillsDecision";
    BPChecksFieldKey[BPChecksFieldKey["valDecision"] = 'VAL'] = "valDecision";
    BPChecksFieldKey[BPChecksFieldKey["taDecision"] = 'BPATA.TA'] = "taDecision";
    BPChecksFieldKey[BPChecksFieldKey["bpaDecision"] = 'BPATA.BPA'] = "bpaDecision";
    BPChecksFieldKey[BPChecksFieldKey["solDecision"] = 'SOL'] = "solDecision";
    BPChecksFieldKey[BPChecksFieldKey["compDecision"] = 'COMP'] = "compDecision";
})(BPChecksFieldKey || (BPChecksFieldKey = {}));
var DetailTableBpAuthorizationController = (function () {
    function DetailTableBpAuthorizationController(topic, settings, socket, $injector, env, $timeout, $scope, $attrs, Dialog) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.Dialog = Dialog;
        this.tableName = 'BP Authorization';
        this.bpaProps = ["Approved", "Not Approved"].map(function (e) { return ({ abbrev: e }); });
        this.taProps = ["Approved", "Not Approved", "Not Required"].map(function (e) { return ({ abbrev: e }); });
        this.valuesProps = ["Yes", "No"].map(function (e) { return ({ abbrev: e }); });
        this.stateList = [];
        this.stateListCopy = [];
        this.OPP_VERSION_5 = 5;
        this.isTableEditMode = false;
        this.comp = "bpAuth";
        this.socket.forward('eligibility.getBpAuthorizationData', this.$scope);
        this.$scope.$on('socket:eligibility.getBpAuthorizationData', function (event, data) {
            _this.tableHeader = data.header;
            _this.tableRows = data.rows;
            _this.tableError = _.get(data, "err", '');
            _this.checkIfRowFails();
        });
        this.socket.forward('topic.update.partial', this.$scope);
        this.$scope.$on('socket:topic.update.partial', function (event, data) {
            _this.updateDealRegProductGroupData();
        });
    }
    DetailTableBpAuthorizationController.prototype.$onInit = function () {
        this.getBpAuthorizationData();
    };
    DetailTableBpAuthorizationController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    DetailTableBpAuthorizationController.prototype.changeTableEditMode = function (isEdit) {
        this.isTableEditMode = isEdit;
    };
    DetailTableBpAuthorizationController.prototype.edit = function () {
        this.stateListCopy = _.cloneDeep(this.stateList);
        this.changeTableEditMode(true);
    };
    DetailTableBpAuthorizationController.prototype.cancel = function () {
        this.stateList = this.stateListCopy;
        this.changeTableEditMode(false);
    };
    DetailTableBpAuthorizationController.prototype.getBpAuthorizationData = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getBpAuthorizationData',
                script: '/detail/eligibility/bpAuthorization/index',
                data: {
                    oppName: this.topic.topic._id
                },
                token: this.env.user.token
            }
        });
    };
    DetailTableBpAuthorizationController.prototype.isEditButtonEnabled = function () {
        return !this.isAllCompletedAutomatically() &&
            this.topic.editableComponents[this.comp] && !this.topic.editableComponents[this.comp].socket;
    };
    DetailTableBpAuthorizationController.prototype.displayValueDecision = function (fieldValue, key, stateFieldName) {
        return (fieldValue !== 'Manual Review' && !this.isBPATAExistInCloudant) ||
            (this.isBPATAExistInCloudant && !_.get(this, "stateList[" + key + "][" + stateFieldName + "].isManualReview"));
    };
    DetailTableBpAuthorizationController.prototype.isAllCompletedAutomatically = function () {
        var notAutoFound = false;
        for (var i = 0; i < this.tableRows.length; i++) {
            if (!this.isCompletedAutomatically(this.tableRows[i], i)) {
                notAutoFound = true;
                break;
            }
        }
        return !notAutoFound;
    };
    DetailTableBpAuthorizationController.prototype.isCompletedAutomatically = function (value, key) {
        var result = (value.bpAgreement !== 'Manual Review' &&
            value.transactionAgreement !== 'Manual Review' &&
            value.competency !== 'Manual Review' &&
            value.skills !== 'Manual Review' &&
            value.solution !== 'Manual Review' &&
            value.valueDecision !== 'Manual Review' && !this.isBPATAExistInCloudant)
            || (this.isBPATAExistInCloudant &&
                !_.get(this, "stateList[" + key + "].bpaDecision.isManualReview") &&
                !_.get(this, "stateList[" + key + "].compDecision.isManualReview") &&
                !_.get(this, "stateList[" + key + "].skillsDecision.isManualReview") &&
                !_.get(this, "stateList[" + key + "].solDecision.isManualReview") &&
                !_.get(this, "stateList[" + key + "].taDecision.isManualReview") &&
                !_.get(this, "stateList[" + key + "].valDecision.isManualReview"));
        return result;
    };
    DetailTableBpAuthorizationController.prototype.isRowCompleted = function (key) {
        return !(!_.get(this, "stateList[" + key + "].comments") ||
            !_.get(this, "stateList[" + key + "].bpaDecision.value") ||
            !_.get(this, "stateList[" + key + "].compDecision.value") ||
            !_.get(this, "stateList[" + key + "].skillsDecision.value") ||
            !_.get(this, "stateList[" + key + "].solDecision.value") ||
            !_.get(this, "stateList[" + key + "].taDecision.value") ||
            !_.get(this, "stateList[" + key + "].valDecision.value"));
    };
    DetailTableBpAuthorizationController.prototype.checkIfRowFails = function () {
        var _this = this;
        this.bpAuthorizationResults = _.get(this.topic.topic, "eligibility.bpAuthorization");
        this.isBPATAExistInCloudant = !!this.bpAuthorizationResults;
        this.stateList = this.tableRows.map(function (row, index) {
            if (_this.bpAuthorizationResults) {
                return _this.bpAuthorizationResults[index];
            }
            var obj = {
                bpaDecision: { isManualReview: false, value: row.bpAgreement },
                comments: '',
                compDecision: { isManualReview: false, value: row.competency },
                // isFinal: false,
                level2Label: row.gbt20ID,
                skillsDecision: { isManualReview: false, value: row.skills },
                solDecision: { isManualReview: false, value: row.solution },
                solutionId: row.dealRegProductGroupID,
                taDecision: { isManualReview: false, value: row.transactionAgreement },
                valDecision: { isManualReview: false, value: row.valueDecision }
            };
            if (row.bpAgreement === 'Manual Review') {
                obj.bpaDecision = Object.assign(obj.bpaDecision, { value: '', isManualReview: true });
            }
            if (row.transactionAgreement === 'Manual Review') {
                obj.taDecision = Object.assign(obj.taDecision, { value: '', isManualReview: true });
            }
            if (row.skills === 'Manual Review') {
                obj.skillsDecision = Object.assign(obj.skillsDecision, { value: '', isManualReview: true });
            }
            if (row.competency === 'Manual Review') {
                obj.compDecision = Object.assign(obj.compDecision, { value: '', isManualReview: true });
            }
            if (row.solution === 'Manual Review') {
                obj.solDecision = Object.assign(obj.solDecision, { value: '', isManualReview: true });
            }
            if (row.valueDecision === 'Manual Review') {
                obj.valDecision = Object.assign(obj.valDecision, { value: '', isManualReview: true });
            }
            return obj;
        });
    };
    DetailTableBpAuthorizationController.prototype.save = function () {
        var updatedTable = [];
        for (var i = 0; i < this.tableRows.length; i++) {
            var row = this.prepareToUpload(i);
            updatedTable.push(row);
        }
        var updateData = {
            isBpAuthOrDupCheckResult: true,
            opportunityId: this.topic.topic._id.substring(4),
            table: updatedTable
        };
        this.uploadResults({ "bpAuthorization": this.stateListObj }, updateData);
        this.changeTableEditMode(false);
    };
    DetailTableBpAuthorizationController.prototype.prepareToUpload = function (key) {
        // Return object of objects with index and change flag to true for current stateList
        this.stateListObj = this.stateList.reduce(function (obj, el, index) {
            // if (index === key) {
            //     el.isFinal = true;
            // }
            return Object.assign(obj, (_a = {}, _a[index] = el, _a));
            var _a;
        }, {});
        var check = {
            BPA: this.stateList[key].bpaDecision.value,
            COMP: this.stateList[key].compDecision.value,
            SKILLS: this.stateList[key].skillsDecision.value,
            SOL: this.stateList[key].solDecision.value,
            TA: this.stateList[key].taDecision.value,
            VAL: this.stateList[key].valDecision.value,
            level2Label: this.stateList[key].level2Label,
            solutionId: this.stateList[key].solutionId
        };
        return check;
    };
    DetailTableBpAuthorizationController.prototype.uploadResults = function (itemToUpdate, table) {
        var data = {
            data: (_a = {},
                _a['eligibility'] = {
                    add: true,
                    data: itemToUpdate
                },
                _a
            ),
            id: this.topic.topic._id,
            type: ['eligibility']
        };
        this.topic.updateServerTopic('couchUpdate', data, true, table);
        var _a;
    };
    /**
     * Update TA in Deal Registration Product Group table
     * @param {any} itemToUpdate
     */
    DetailTableBpAuthorizationController.prototype.updateDealRegProductGroupData = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    oppName: this.topic.topic._id.substring(4)
                },
                function: 'getDealRegProductGroupData',
                script: '/detail/eligibility/drpgResult/index',
                token: this.env.user.token
            }
        });
    };
    DetailTableBpAuthorizationController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope', '$attrs', 'Dialog', '_'];
    return DetailTableBpAuthorizationController;
}());
var DetailTableBpAuthorizationComponent = (function () {
    function DetailTableBpAuthorizationComponent() {
        this.templateUrl = 'detail-table-bp-authorization.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableBpAuthorizationController;
    }
    return DetailTableBpAuthorizationComponent;
}());
angular
    .module('application')
    .component('detailTableBpAuthorization', new DetailTableBpAuthorizationComponent());



var BpDuplCheckController = (function () {
    //  = !this.oppVersion || this.oppVersion <= this.OPP_VERSION_4 ?
    //     this.mysaCheckData && angular.isDefined(this.mysaCheckData.DUPMYSA) ? [this.mysaCheckData.DUPMYSA.data] : undefined;:
    // ;
    function BpDuplCheckController(topic, $injector, env, $stateParams, $scope) {
        this.topic = topic;
        this.$injector = $injector;
        this.env = env;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        //private OPP_VERSION_3: number = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.tableName = 'BP Duplicate Check';
        this.visible = false;
        this.filterDisplay = false;
        if (this.topic.checksData.uiVersion === this.OPP_VERSION_4) {
            this.comp = 'dc_mysa_v4';
        }
        else if (this.topic.checksData.uiVersion > this.OPP_VERSION_4) {
            this.comp = 'dc_v5';
        }
        else {
            this.comp = 'dc_mysa';
        }
        this.oppVersion = this.topic.topic.version;
        var checksData = _.get(this, 'topic.checksData.result');
        if ((!this.oppVersion || this.oppVersion <= this.OPP_VERSION_4) && checksData.DUPMYSA) {
            this.mysaResult = [checksData.DUPMYSA.data];
        }
        else if (this.oppVersion && this.oppVersion >= this.OPP_VERSION_5 && checksData.DUP && checksData.DUP.data) {
            this.mysaEiResult = [JSON.parse(JSON.stringify(checksData.DUP.data))];
            this.mysaEiResult[0].isEi = true;
            this.mysaSsaResult = [JSON.parse(JSON.stringify(checksData.DUP.data))];
            this.mysaSsaResult[0].isEi = false;
        }
    }
    BpDuplCheckController.prototype.toggleFilter = function () {
        this.filterDisplay = !this.filterDisplay;
    };
    BpDuplCheckController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    BpDuplCheckController.prototype.isSectionEnabled = function () {
        if (this.oppVersion && this.oppVersion >= this.OPP_VERSION_5) {
            return true;
        }
        else {
            return _.get(this, 'mysaResult') !== undefined
                ? !this.mysaResult.isError
                : false;
        }
    };
    BpDuplCheckController.prototype.isError = function () {
        if (this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5) {
            if (_.get(this, 'topic.checksData.result.DUP.isError') === true) {
                return true;
            }
        }
        else {
            // update for v4 if necessary
            return false;
        }
    };
    BpDuplCheckController.$inject = ['topic', '$injector', 'env', '$stateParams', '$scope', '_'];
    return BpDuplCheckController;
}());
var BpDuplCheckComponent = (function () {
    function BpDuplCheckComponent() {
        this.templateUrl = 'detail-table-bp-duplcheck.html';
        this.controllerAs = 'vm';
        this.controller = BpDuplCheckController;
    }
    return BpDuplCheckComponent;
}());
angular
    .module('application')
    .component('detailTableBpCheck', new BpDuplCheckComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableComplClController = (function () {
    function DetailTableComplClController(topic, $scope, settings) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.settings = settings;
        this.tableName = 'Completeness Checklist';
        this.displayRadioButton = true;
        this.lock = true;
        this.enableSection = true;
        this.showThumb = false; //will show on section header
        this.sectionHeader = 'Completeness Results';
        this.comp = 'complcl';
        this.updateArray = ['complcl'];
        this.visible = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    ;
    DetailTableComplClController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableComplClController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailTableComplClController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.sendForUpdateGeneral(this.updateArray, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableComplClController.prototype.itemChanged = function (line) { };
    DetailTableComplClController.$inject = ['topic', '$scope', 'settings'];
    return DetailTableComplClController;
}());
var DetailTableComplClComponent = (function () {
    function DetailTableComplClComponent() {
        this.templateUrl = 'detail-table-complcl.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableComplClController;
    }
    return DetailTableComplClComponent;
}());
angular
    .module('application')
    .component('detailTableComplCl', new DetailTableComplClComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableComplCl2Controller = (function () {
    function DetailTableComplCl2Controller(topic, $scope, settings) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.settings = settings;
        this.tableName = 'GOE Checklist';
        this.displayRadioButton = true;
        this.lock = false;
        this.enableSection = true;
        this.showThumb = true;
        this.comp = 'complcl2';
        this.updateArray = ['complcl2'];
        this.visible = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    ;
    DetailTableComplCl2Controller.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableComplCl2Controller.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailTableComplCl2Controller.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.sendForUpdateGeneral(this.updateArray, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableComplCl2Controller.prototype.itemChanged = function (line) { };
    DetailTableComplCl2Controller.$inject = ['topic', '$scope', 'settings'];
    return DetailTableComplCl2Controller;
}());
var DetailTableComplCl2Component = (function () {
    function DetailTableComplCl2Component() {
        this.templateUrl = 'detail-table-complcl.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableComplCl2Controller;
    }
    return DetailTableComplCl2Component;
}());
angular
    .module('application')
    .component('detailTableComplCl2', new DetailTableComplCl2Component());



/**
 * @author Ivan Toth.
 */
var DetailTableComplCl3Controller = (function () {
    function DetailTableComplCl3Controller(topic, $scope, settings) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.settings = settings;
        this.tableName = 'Duplicate Check Checklist';
        this.displayRadioButton = true;
        this.lock = true;
        this.enableSection = true;
        this.showThumb = true;
        this.comp = 'complcl3';
        this.updateArray = ['complcl3'];
        this.visible = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    ;
    DetailTableComplCl3Controller.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    DetailTableComplCl3Controller.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailTableComplCl3Controller.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.sendForUpdateGeneral(this.updateArray, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableComplCl3Controller.prototype.itemChanged = function (line) { };
    DetailTableComplCl3Controller.$inject = ['topic', '$scope', 'settings'];
    return DetailTableComplCl3Controller;
}());
var DetailTableComplCl3Component = (function () {
    function DetailTableComplCl3Component() {
        this.templateUrl = 'detail-table-complcl.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableComplCl3Controller;
    }
    return DetailTableComplCl3Component;
}());
angular
    .module('application')
    .component('detailTableComplCl3', new DetailTableComplCl3Component());



/**
 * @author Vlad
 */
var typeBindings = { type: '=' };
var DealRegistrationProductGroupController = (function () {
    function DealRegistrationProductGroupController(topic, settings, socket, $injector, env, $timeout, $scope, $attrs) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.props = [
            'dealRegProductGroupID',
            'dealRegProductGroupName',
            'gbt20ID',
            'gbt20Name',
            'revenue',
            'bpa',
            'ta',
            'value',
            'bpDuplicateFound',
            'bpDuplicateOpportunityNumber',
            'ibmDuplicateFound',
            'ibmDuplicateOpportunityNumber',
            'specialBid',
            'cvrSSA',
            'solution',
            'solutionID'
        ];
        this.propsV4 = [];
        this.propsV5eligibility = [
            'dealRegProductGroupID',
            'dealRegProductGroupName',
            'bpa',
            'ta',
            'value',
            'bpDuplicateFound',
            'bpDuplicateOpportunityNumber',
            'cvrSSA',
            'solution',
            'solutionID',
        ];
        this.propsV4eligibility = [
            'dealRegProductGroupID',
            'dealRegProductGroupName',
            'gbt20ID',
            'gbt20Name',
            'revenue',
            'bpa',
            'ta',
            'value',
            'bpDuplicateFound',
            'bpDuplicateOpportunityNumber',
            'specialBid',
            'cvrSSA',
            'solution',
            'solutionID',
        ];
        this.propsV4validation = [
            'dealRegProductGroupID',
            'dealRegProductGroupName',
            'gbt20ID',
            'gbt20Name',
            'salesIncentive',
            'engagement',
            'engagementID',
            'growthIncentive',
            'focusIncentive',
        ];
        this.propsV5validation = [
            'dealRegProductGroupID',
            'dealRegProductGroupName',
            'salesIncentive',
            'engagement',
            'engagementID',
            'growthIncentive',
            'focusIncentive',
        ];
        this.revenueStr = 'revenue';
        this.DRPGsArr = [];
        this.tableName = 'Deal Registration Product Group';
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.initTableColumns();
        this.socket.forward('eligibility.getDealRegProductGroupData', this.$scope);
        this.$scope.$on('socket:eligibility.getDealRegProductGroupData', function (event, data /*ITableData*/) {
            _this.tableHeader = Array.isArray(data.header) ? data.header.map(function (h) { return h.value; }) : data.header;
            _this.tableRows = data.rows;
            _this.tableRows.forEach(function (item, i) {
                if (_this.tableRows[i + 1] && _this.tableRows[i + 1].dealRegProductGroupID === _this.tableRows[i].dealRegProductGroupID && _this.tableRows[i + 1].cvrSSA === _this.tableRows[i].cvrSSA
                    && _this.tableRows[i + 1].solution === _this.tableRows[i].solution && _this.type === 'validation') {
                    for (var el in item) {
                        item[el] = _this.getDRPGelem(item, el, i);
                    }
                    _this.DRPGsArr.push(item);
                    _this.tableRows.splice(i + 1, 1);
                }
                else {
                    for (var el in item) {
                        item[el] = Array.isArray(item[el]) || _this.type !== 'validation' ? item[el] : [item[el]];
                    }
                    _this.DRPGsArr.push(item);
                }
            });
            _this.tableError = data.error || '';
            _this.url = _this.topic.$state.current.name.split('.')[1];
        });
    }
    DealRegistrationProductGroupController.prototype.initTableColumns = function () {
        if (this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5) {
            this.propsV4 = this.type === 'validation' ? this.propsV5validation : this.propsV5eligibility;
        }
        else {
            this.propsV4 = this.type === 'validation' ? this.propsV4validation : this.propsV4eligibility;
        }
    };
    DealRegistrationProductGroupController.prototype.getDRPGelem = function (item, el, i) {
        if (el === this.revenueStr) {
            return [Number.parseInt(item[this.revenueStr]) + Number.parseInt(this.tableRows[i + 1][this.revenueStr])];
        }
        if (typeof item[el] === 'string' && el !== this.revenueStr) {
            return item[el] === this.tableRows[i + 1][el] ? [item[el]] : [item[el], this.tableRows[i + 1][el]];
        }
        if (Array.isArray(item[el])) {
            var mergedArrs_1 = item[el].concat(this.tableRows[i + 1][el]);
            return mergedArrs_1.filter(function (item, pos) {
                return mergedArrs_1.indexOf(item) == pos;
            });
        }
    };
    DealRegistrationProductGroupController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DealRegistrationProductGroupController.prototype.$onInit = function () {
        this.getDealRegProductGroupData();
    };
    DealRegistrationProductGroupController.prototype.getDealRegProductGroupData = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    oppName: this.topic.topic._id.substring(4),
                    type: this.type
                },
                function: 'getDealRegProductGroupData',
                script: '/detail/eligibility/drpgResult/index',
                token: this.env.user.token
            }
        });
    };
    DealRegistrationProductGroupController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope', '$attrs'];
    return DealRegistrationProductGroupController;
}());
var DealRegistrationProductGroupComponent = (function () {
    function DealRegistrationProductGroupComponent() {
        this.templateUrl = 'deal-registration-product-group.html';
        this.controllerAs = 'vm';
        this.bindings = typeBindings;
        this.controller = DealRegistrationProductGroupController;
    }
    return DealRegistrationProductGroupComponent;
}());
angular
    .module('application')
    .component('dealRegistrationProductGroup', new DealRegistrationProductGroupComponent());



var DetailTableDrgCheckController = (function () {
    function DetailTableDrgCheckController(topic, settings, socket, $injector, env, $timeout, $scope, $attrs) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.comp = 'goe_data';
        this.requiredCountrySearch = true;
        this.goeResult = [_.get(this.topic, 'checksData.result.GOE.data.goeResult', [])]; //ToDo: rewrite that arrayish structure
        this.goeError = _.get(this.topic, 'checksData.result.GOE.error', '');
        this.socket.forward('topic.search.result', this.$scope);
        this.$scope.$on('socket:topic.search.result', function (event, data) {
            _this.processing = false;
        });
        this.errorCheckerInput = false;
        this.cmrData = {};
        this.filterDisplay = false;
        this.bol = false;
        this.selectedCustName = [];
        this.tableName = 'Deal Registration Government Check';
        this.cmrData.cmrIssuingCountry = '';
        this.cmrData.customerCountryLanded = '';
        this.cmrData.fuzzyOption = 'Contains';
        this.cmrData.cmrOwner = 'IBM';
        this.cmrData.cmrTypeStandard = true;
        this.cmrData.accTypeSoldTo = true;
        this.cmrData.customerName = 'CustNameOnly';
        this.cmrData.rows = '500';
        this.cmrData.cmrNum = '';
        this.cmrData.fuzzySearch = '';
        this.visible = false;
        this.expand = false;
        this.dataSources = ['CMR'];
        this.stopSubmit = false;
        this.noValidCheck = true;
        this.govCheck = true;
        this.processing = false;
        this.fuzzyOptions = ['Contains', 'Begins with', 'Fuzzy'];
        this.resultRows = ['50', '100', '500', '1000', '5000'];
        this.cmrOwnerOptions = ['ALL', 'IBM', 'Lenovo', 'Truro', 'Fonseca'];
        this.custNameOptions = [
            { name: 'Customer Name Only', value: 'CustNameOnly' },
            { name: 'Business Name Only', value: 'BusNameOnly' },
            { name: 'Customer & Business Name', value: 'CustBusName' }
        ];
    }
    DetailTableDrgCheckController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    DetailTableDrgCheckController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope', '$attrs', '_'];
    return DetailTableDrgCheckController;
}());
var DetailTableDrgCheckComponent = (function () {
    function DetailTableDrgCheckComponent() {
        this.templateUrl = 'detail-table-drgcheck.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableDrgCheckController;
    }
    return DetailTableDrgCheckComponent;
}());
angular
    .module('application')
    .component('detailTableDrgCheck', new DetailTableDrgCheckComponent());



var DetailTableDuplCheckController = (function () {
    function DetailTableDuplCheckController(topic, settings, socket, $injector, env, $timeout, $stateParams, $scope) {
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.dataSources = ['dc_mysa', 'dc_sc'];
        this.comp = ['dc_mysa', 'dc_sc'];
        this.updateArray = ['dc'];
        this.lock = true;
        this.requiredCountrySearch = true;
        this.checkData = _.get(this, 'topic.checksData.result');
        this.OPP_VERSION_5 = 5;
        this.tableName = 'Automatic Duplicate Check';
        this.dc = {
            ds: 'GPP',
            countrySelected: [],
            usStatesAll: [],
            fuzzySearch: '',
            opp: '',
            countryLine: [],
            alterBrandFam: [],
            createDate: 0,
            decisionDate: 0
        };
        this.visible = false;
        this.expand = false;
        this.stopSubmit = false;
        this.filterDisplay = false;
    }
    DetailTableDuplCheckController.prototype.toggleFilter = function () {
        this.filterDisplay = !this.filterDisplay;
    };
    // For EU/NA vs AP different options to display
    DetailTableDuplCheckController.prototype.$onInit = function () {
        this.usPicked = false;
        this.countryDecided = angular.isDefined(this.topic.country.imt);
    };
    DetailTableDuplCheckController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    // sends a broadcast to expand or colapse the table sections
    DetailTableDuplCheckController.prototype.expandAll = function (value) {
        this.$injector.get('$rootScope').$broadcast('expand.all.dc', value);
        this.expand = value;
    };
    DetailTableDuplCheckController.prototype.updateBant = function () {
        this.topic.setTempFromTopicPart(this.comp);
        var upData = {
            id: this.topic.topic._id,
            data: {
                'dc.0.bant': {
                    add: true,
                    data: this.topic.temp.dc[0].bant
                }
            },
            type: ['dc', 'complcl3']
        };
        this.topic.updateServerTopic('couchUpdate', upData, false);
    };
    DetailTableDuplCheckController.prototype.reload = function () {
        console.info('$detail.table.duplcheck (reload) => reloading');
        this.topic.loaded.gpp_valid = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'validation',
                script: '/detail/validation/validation',
                opp: this.topic.topic.opp,
                unid: this.topic.topic._id,
                token: this.env.user.token
            }
        });
    };
    DetailTableDuplCheckController.prototype.pushAlterBfItem = function () {
        var _this = this;
        var dupli = false;
        angular.forEach(this.dc.alterBrandFam, function (iter) {
            if (iter === _this.alterToBeInserted) {
                dupli = true;
            }
        });
        if (!dupli) {
            this.dc.alterBrandFam.push(this.alterToBeInserted);
        }
        this.alterToBeInserted = '';
    };
    DetailTableDuplCheckController.prototype.clearAlterBFList = function () {
        this.dc.alterBrandFam = [];
    };
    DetailTableDuplCheckController.prototype.countryChange = function () {
        var _this = this;
        this.usPicked = false;
        angular.forEach(this.dc.countrySelected, function (country) {
            if (country.short === 'US') {
                _this.usPicked = true;
            }
        });
    };
    DetailTableDuplCheckController.prototype.hasCheckRun = function (type) {
        if (this.topic.topic.dc && this.topic.topic.dc.results) {
            for (var _i = 0, _a = this.topic.topic.dc.results; _i < _a.length; _i++) {
                var oneRes = _a[_i];
                if (oneRes.ds === type && !oneRes.error) {
                    return true;
                }
            }
        }
        return false;
    };
    DetailTableDuplCheckController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            var data = {
                id: this.topic.topic._id,
                data: (_a = {},
                    _a['dc'] = {
                        add: true,
                        data: this.topic.temp.dc
                    },
                    _a['complcl3'] = {
                        add: true,
                        data: this.topic.temp.complcl3
                    },
                    _a
                ),
                type: ['dc', 'complcl3']
            };
            this.topic.updateServerTopic('couchUpdate', data, true);
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.topic.temp[this.comp] = this.topic.topic[this.comp]; //Reset to original value
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
        var _a;
    };
    DetailTableDuplCheckController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$stateParams', '$scope', '_'];
    return DetailTableDuplCheckController;
}());
var DetailTableDuplCheckComponent = (function () {
    function DetailTableDuplCheckComponent() {
        this.templateUrl = 'detail-table-duplcheck-4x4.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableDuplCheckController;
    }
    return DetailTableDuplCheckComponent;
}());
angular
    .module('application')
    .component('detailTableDuplCheckAutomatic', new DetailTableDuplCheckComponent());



/**
 * @author Ilya Aderiho.
 */
var bfBind = { data: '=' };
var DetailTableDuplCheckController = (function () {
    function DetailTableDuplCheckController(topic, settings, socket, $injector, env, $timeout, $stateParams, $scope) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.comp = 'dc';
        this.updateArray = ['dc'];
        this.lock = true;
        this.requiredCountrySearch = true;
        this.OPP_VERSION_2 = 2;
        this.OPP_VERSION_3 = 3;
        this.showBPOI = this.topic.useBPOI();
        this.tableName = 'Duplicate Check';
        this.dc = {
            accountName: '',
            alterBrandFam: [],
            countrySelected: '',
            ds: 'MYSA_DUP',
            isDRPGSearch: false,
            opp: ''
        };
        this.visible = false;
        this.expand = false;
        this.stopSubmit = false;
        this.filterDisplay = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            _this.showBPOI = _this.topic.checksData.uiVersion >= 4 ? false : _this.topic.useBPOI();
            _this.dataSources = _this.showBPOI ? ['MYSA_DUP', 'SC_DUP'] : ['MYSA_DUP'];
        });
    }
    ;
    DetailTableDuplCheckController.prototype.toggleFilter = function () {
        this.filterDisplay = !this.filterDisplay;
    };
    // For EU/NA vs AP different options to display
    DetailTableDuplCheckController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
        this.showBPOI = this.topic.checksData.uiVersion >= 4 ? false : this.topic.useBPOI();
        this.dataSources = this.showBPOI ? ['MYSA_DUP', 'SC_DUP'] : ['MYSA_DUP']; // was this.useBPOI()
        this.usPicked = false;
        if (angular.isDefined(this.topic.country.imt)) {
            if (this.topic.country.imt === 'Japan IOT' || this.topic.country.imt === 'Greater China Group IOT' ||
                this.topic.country.imt === 'Asia Pacific IOT') {
            }
            this.countryDecided = true;
        }
        else {
            this.countryDecided = false;
        }
    };
    DetailTableDuplCheckController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    DetailTableDuplCheckController.prototype.sendDupliCheck = function (opp) {
        if (!this.countryDecided) {
            this.topic.setCountry();
            if (angular.isUndefined(this.topic.country.imt)) {
                return alert("It was not possible to find a Country Profile for the Account Country - " + this.topic.topic.gpp[0].acctctry + ".\n           Please contact the System Administrators and ask to have it added.");
            }
            this.countryDecided = true;
        }
        this.dc.version = this.topic.checksData.uiVersion;
        this.dc.sviSubmitDate = _.get(this, "topic.checksData.inbound.inboud.incentiveInformation.incentiveDetail.incentiveSubmitDate");
        if (!this.dc.sviSubmitDate) {
            this.dc.sviSubmitDate = _.get(this, "topic.checksData.inbound.inbound.incentiveInformation.incentiveDetail.incentiveSubmitDate");
        }
        this.dc.bpCEID = _.get(this, "topic.checksData.inbound.inboud.incentiveInformation.incentiveDetail.submittingCeid");
        if (!this.dc.bpCEID) {
            this.dc.bpCEID = _.get(this, "topic.checksData.inbound.inbound.incentiveInformation.incentiveDetail.submittingCeid");
        }
        if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
            this.dc.opp = opp;
            this.dc.gpp = this.topic.topic.gpp || this.topic.topic.gpp_lastload;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topic.topicBrowserID,
                    data: this.dc,
                    function: 'startManualDuplicateCheck',
                    partial: true,
                    script: '/detail/eligibility/duplicate/index',
                    token: this.env.user.token
                }
            });
        }
    };
    // sends a broadcast to expand or colapse the table sections
    DetailTableDuplCheckController.prototype.expandAll = function (value) {
        this.$injector.get('$rootScope').$broadcast('expand.all.dc', value);
        this.expand = value;
    };
    DetailTableDuplCheckController.prototype.updateBant = function () {
        this.topic.setTempFromTopicPart(this.comp);
        var upData = {
            id: this.topic.topic._id,
            data: {
                'dc.0.bant': {
                    add: true,
                    data: this.topic.temp.dc[0].bant
                }
            },
            type: ['dc', 'complcl3']
        };
        this.topic.updateServerTopic('couchUpdate', upData, false);
    };
    DetailTableDuplCheckController.prototype.reload = function () {
        console.info('$detail.table.duplcheck (reload) => reloading');
        this.topic.loaded.gpp_valid = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'validation',
                script: '/detail/validation/validation',
                opp: this.topic.topic.opp,
                unid: this.topic.topic._id,
                token: this.env.user.token
            }
        });
    };
    DetailTableDuplCheckController.prototype.pushAlterBfItem = function () {
        var _this = this;
        var dupli = false;
        angular.forEach(this.dc.alterBrandFam, function (iter) {
            if (iter === _this.alterToBeInserted) {
                dupli = true;
            }
        });
        if (!dupli) {
            this.dc.alterBrandFam.push(this.alterToBeInserted);
        }
        this.alterToBeInserted = '';
    };
    DetailTableDuplCheckController.prototype.clearAlterBFList = function () {
        this.dc.alterBrandFam = [];
    };
    DetailTableDuplCheckController.prototype.hasCheckRun = function (type) {
        if (this.topic.topic.dc && this.topic.topic.dc.results) {
            for (var _i = 0, _a = this.topic.topic.dc.results; _i < _a.length; _i++) {
                var oneRes = _a[_i];
                if (oneRes.ds === type && !oneRes.error) {
                    return true;
                }
            }
        }
        return false;
    };
    DetailTableDuplCheckController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            var data = {
                id: this.topic.topic._id,
                data: (_a = {},
                    _a['dc'] = {
                        add: true,
                        data: this.topic.temp.dc
                    },
                    _a['complcl3'] = {
                        add: true,
                        data: this.topic.temp.complcl3
                    },
                    _a
                ),
                type: ['dc', 'complcl3']
            };
            this.topic.updateServerTopic('couchUpdate', data, true);
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.topic.temp[this.comp] = this.topic.topic[this.comp]; //Reset to original value
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
        var _a;
    };
    DetailTableDuplCheckController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$stateParams', '$scope'];
    return DetailTableDuplCheckController;
}());
var DetailTableDuplCheckComponent = (function () {
    function DetailTableDuplCheckComponent() {
        this.templateUrl = 'detail-table-dc.html';
        this.bindings = bfBind;
        this.controllerAs = 'vm';
        this.controller = DetailTableDuplCheckController;
    }
    return DetailTableDuplCheckComponent;
}());
angular
    .module('application')
    .component('detailTableDuplCheck', new DetailTableDuplCheckComponent());



/**
 * @author Vlad
 */
var dupBind = { data: '=' };
var DetailTableDuplCheckResultsController = (function () {
    function DetailTableDuplCheckResultsController(topic, settings, socket, $injector, env, $timeout, $scope, $attrs, Dialog, _) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.Dialog = Dialog;
        this._ = _;
        this.tableName = 'Duplicate Check Results';
        this.stateList = [];
        this.stateListCopy = [];
        this.duplicateFoundProps = ["Yes", "No"].map(function (e) { return ({ abbrev: e }); });
        this.isVersion4AndMore = false;
        this.isVersion5AndMore = false;
        this.OPP_VERSION_5 = 5;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_3 = 3;
        this.isTableEditMode = false;
        this.comp = 'dc';
        this.socket.forward('eligibility.getDuplicateCheckResultsData', this.$scope);
        this.$scope.$on('socket:eligibility.getDuplicateCheckResultsData', function (event, data) {
            _this.tableHeader = data.header;
            _this.tableRows = data.rows;
            _this.tableBackendErrors = data.err;
            _this.isEditableList = _this.tableRows.map(function (e) { return false; });
            _this.version = data.version;
            _this.isVersion4AndMore = (data.version > _this.OPP_VERSION_3);
            _this.isVersion5AndMore = (data.version >= _this.OPP_VERSION_5);
            _this.checkIfRowFails();
            _this.checkTableErrors();
        });
        this.socket.forward('topic.update.partial', this.$scope);
        this.$scope.$on('socket:topic.update.partial', function (event, data) {
            _this.updateDealRegProductGroupData();
        });
    }
    DetailTableDuplCheckResultsController.prototype.$onInit = function () {
        this.getDuplicateCheckResultsDataV3AndMore();
    };
    DetailTableDuplCheckResultsController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableDuplCheckResultsController.prototype.checkTableErrors = function () {
        var errors = [];
        if (this.tableBackendErrors) {
            errors = this.tableBackendErrors;
        }
        var tableRowErrors = this.getTableRowErrors();
        if (tableRowErrors) {
            errors.push(this.getTableRowErrors());
        }
        if (errors && errors.length > 0) {
            this.tableConsolidatedErrors = errors.join(', ');
        }
        else {
            this.tableConsolidatedErrors = undefined;
        }
    };
    DetailTableDuplCheckResultsController.prototype.getTableRowErrors = function () {
        if (!(this.topic.topic.version >= this.OPP_VERSION_4 && this.isDupEditButtonEnabled()) ||
            (this.topic.topic.version < this.OPP_VERSION_4 && !this.isDupEditButtonEnabledVersion3AndLess())) {
            return;
        }
        if (!this.tableRows || !this.tableRows.length) {
            return;
        }
        var errorRows = [];
        for (var i = 0; i < this.tableRows.length; i++) {
            if (!this.isRowCompleted(i)) {
                errorRows.push(i + 1);
            }
        }
        if (errorRows && errorRows.length > 0) {
            return errorRows.length === 1 ?
                "Row " + errorRows[0] + " has missing values" :
                "Rows " + errorRows.join(', ') + " have missing values";
        }
        return undefined;
    };
    DetailTableDuplCheckResultsController.prototype.isRowCompleted = function (key) {
        if (this.topic.topic.version >= this.OPP_VERSION_5) {
            return this.isRowCompletedV5(key);
        }
        else if (this.topic.topic.version >= this.OPP_VERSION_4) {
            return this.isRowCompletedV4(key);
        }
        else {
            return this.isRowCompletedV3(key);
        }
    };
    DetailTableDuplCheckResultsController.prototype.isRowCompletedV5 = function (key) {
        //return !(!_.get(this, `stateList[${key}].comments`) ||
        return _.get(this, "stateList[" + key + "].ssaDecision.value") &&
            _.get(this, "stateList[" + key + "].eiDecision.value");
    };
    DetailTableDuplCheckResultsController.prototype.isRowCompletedV4 = function (key) {
        //return !(!_.get(this, `stateList[${key}].comments`) ||
        return _.get(this, "stateList[" + key + "].ssaDecision.value") &&
            _.get(this, "stateList[" + key + "].eiDecision.value") &&
            _.get(this, "stateList[" + key + "].sbDecision.value");
    };
    DetailTableDuplCheckResultsController.prototype.isRowCompletedV3 = function (key) {
        //return !(!_.get(this, `stateList[${key}].comments`) ||
        return _.get(this, "stateList[" + key + "].cvrDecision.value") &&
            _.get(this, "stateList[" + key + "].ibmDecision.value") &&
            _.get(this, "stateList[" + key + "].sbDecision.value");
    };
    DetailTableDuplCheckResultsController.prototype.getDuplicateCheckResultsDataV3AndMore = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    oppName: this.topic.topic._id
                },
                function: 'getDuplicateCheckResultsDataV3AndMore',
                script: '/detail/eligibility/duplicate/index',
                token: this.env.user.token
            }
        });
    };
    DetailTableDuplCheckResultsController.prototype.checkIfRowFails = function () {
        var _this = this;
        this.duplicateCheckResults = _.get(this.topic.topic, "eligibility.duplicateCheckResults", false);
        this.isDupExistInCloudant = !!this.duplicateCheckResults;
        this.stateList = this.tableRows.map(function (row, index) {
            if (_this.duplicateCheckResults) {
                return _this.duplicateCheckResults[index];
            }
            var obj = _this.isVersion4AndMore ?
                {
                    comments: '',
                    eiDecision: { isManualReview: false, value: row.eiDupFound },
                    isFinal: false,
                    level2Label: row.level2Label || row.gbt20ID,
                    sbDecision: { isManualReview: false, value: row.sbDupFound },
                    solutionId: row.dealRegProductGroupID || row.solutionId,
                    ssaDecision: { isManualReview: false, value: row.ssaDupFound }
                } :
                {
                    comments: '',
                    cvrDecision: { isManualReview: false, value: row.cvrDupFound },
                    ibmDecision: { isManualReview: false, value: row.ibmDuplicateFound },
                    isFinal: false,
                    level2Label: row.level2Label || row.gbt20ID,
                    sbDecision: { isManualReview: false, value: row.sbDupFound },
                    solutionId: row.dealRegProductGroupID || row.solutionId
                };
            if (row.cvrDupFound === 'Manual Review') {
                obj.cvrDecision = Object.assign(obj.cvrDecision, { value: '', isManualReview: true });
            }
            if (row.sbDupFound === 'Manual Review') {
                obj.sbDecision = Object.assign(obj.sbDecision, { value: '', isManualReview: true });
            }
            if (row.ibmDuplicateFound === 'Manual Review') {
                obj.ibmDecision = Object.assign(obj.ibmDecision, { value: '', isManualReview: true });
            }
            if (row.eiDupFound === 'Manual Review') {
                obj.eiDecision = Object.assign(obj.eiDecision, { value: '', isManualReview: true });
            }
            if (row.ssaDupFound === 'Manual Review') {
                obj.ssaDecision = Object.assign(obj.ssaDecision, { value: '', isManualReview: true });
            }
            return obj;
        });
    };
    DetailTableDuplCheckResultsController.prototype.edit = function () {
        this.stateListCopy = _.cloneDeep(this.stateList);
        this.changeTableEditMode(true);
    };
    DetailTableDuplCheckResultsController.prototype.cancel = function () {
        this.stateList = this.stateListCopy;
        this.changeTableEditMode(false);
    };
    DetailTableDuplCheckResultsController.prototype.save = function () {
        var updatedTable = [];
        for (var i = 0; i < this.tableRows.length; i++) {
            var row = this.prepareToUpload(i);
            updatedTable.push(row);
        }
        var updateData = {
            isBpAuthOrDupCheckResult: true,
            opportunityId: this.topic.topic._id.substring(4),
            table: updatedTable
        };
        this.uploadResults({ "duplicateCheckResults": this.stateListObj }, updateData);
        this.changeTableEditMode(false);
    };
    DetailTableDuplCheckResultsController.prototype.changeTableEditMode = function (isEdit) {
        this.isTableEditMode = isEdit;
        this.checkTableErrors();
    };
    DetailTableDuplCheckResultsController.prototype.isCvrDupEditable = function (value, key) {
        return (value.cvrDupFound === 'Manual Review' && !this.isDupExistInCloudant) ||
            (this.isDupExistInCloudant && this.stateList[key].cvrDecision.isManualReview);
    };
    DetailTableDuplCheckResultsController.prototype.isSsaDupEditable = function (value, key) {
        return (value.ssaDupFound === 'Manual Review' && !this.isDupExistInCloudant) ||
            (this.isDupExistInCloudant && this.stateList[key].ssaDecision.isManualReview);
    };
    DetailTableDuplCheckResultsController.prototype.isEiDupEditable = function (value, key) {
        return (value.eiDupFound === 'Manual Review' && !this.isDupExistInCloudant) ||
            (this.isDupExistInCloudant && this.stateList[key].eiDecision.isManualReview);
    };
    DetailTableDuplCheckResultsController.prototype.isSbDupEditable = function (value, key) {
        return (value.sbDupFound === 'Manual Review' && !this.isDupExistInCloudant) ||
            (this.isDupExistInCloudant && this.stateList[key].sbDecision.isManualReview);
    };
    DetailTableDuplCheckResultsController.prototype.isIbmDupEditable = function (value, key) {
        return (value.ibmDuplicateFound === 'Manual Review' && !this.isDupExistInCloudant) ||
            (this.isDupExistInCloudant && this.stateList[key].ibmDecision.isManualReview);
    };
    DetailTableDuplCheckResultsController.prototype.isDupEditButtonEnabledVersion3AndLess = function () {
        if (!this.topic.editableComponents[this.comp] || this.topic.editableComponents[this.comp].socket) {
            return false;
        }
        if (!this.tableRows || !this.tableRows.length) {
            return false;
        }
        for (var i = 0; i < this.tableRows.length; i++) {
            if (this.isCvrDupEditable(this.tableRows[i], i) || this.isSbDupEditable(this.tableRows[i], i) || this.isIbmDupEditable(this.tableRows[i], i)) {
                return true;
            }
        }
        return false;
    };
    DetailTableDuplCheckResultsController.prototype.isRowEditableVersion3AndLess = function (key) {
        if (this.isCvrDupEditable(this.tableRows[key], key) || this.isSbDupEditable(this.tableRows[key], key) || this.isIbmDupEditable(this.tableRows[key], key)) {
            return true;
        }
        return false;
    };
    DetailTableDuplCheckResultsController.prototype.isDupEditButtonEnabled = function () {
        if (!this.topic.editableComponents[this.comp] || this.topic.editableComponents[this.comp].socket) {
            return false;
        }
        if (!this.tableRows || !this.tableRows.length) {
            return false;
        }
        for (var i = 0; i < this.tableRows.length; i++) {
            if (this.isSsaDupEditable(this.tableRows[i], i) || this.isEiDupEditable(this.tableRows[i], i) || this.isSbDupEditable(this.tableRows[i], i)) {
                return true;
            }
        }
        return false;
    };
    DetailTableDuplCheckResultsController.prototype.isRowEditable = function (key) {
        if (this.isSsaDupEditable(this.tableRows[key], key) || this.isEiDupEditable(this.tableRows[key], key) || this.isSbDupEditable(this.tableRows[key], key)) {
            return true;
        }
        return false;
    };
    DetailTableDuplCheckResultsController.prototype.uploadResults = function (itemToUpdate, table) {
        var data = {
            data: (_a = {},
                _a['eligibility'] = {
                    add: true,
                    data: itemToUpdate
                },
                _a
            ),
            id: this.topic.topic._id,
            type: ['eligibility']
        };
        this.topic.updateServerTopic('couchUpdate', data, true, table);
        var _a;
    };
    /**
     * Update BP Duplicate Found? and IBM Duplicate Found? in Deal Registration Product Group table
     * @param {any} itemToUpdate
     */
    DetailTableDuplCheckResultsController.prototype.updateDealRegProductGroupData = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    oppName: this.topic.topic._id.substring(4)
                },
                function: 'getDealRegProductGroupData',
                script: '/detail/eligibility/drpgResult/index',
                token: this.env.user.token
            }
        });
    };
    DetailTableDuplCheckResultsController.prototype.prepareToUpload = function (key) {
        // Return object of objects with index and change flag to true for current stateList
        this.stateListObj = this.stateList.reduce(function (obj, el, index) {
            // if (index === key) {
            //     el.isFinal = true;
            // }
            return Object.assign(obj, (_a = {}, _a[index] = el, _a));
            var _a;
        }, {});
        var check = {
            EI: this.isVersion4AndMore ? this.stateList[key].eiDecision.value : undefined,
            SB: this.stateList[key].sbDecision.value,
            SC: this.isVersion4AndMore ? undefined : this.stateList[key].ibmDecision.value,
            SSA: this.isVersion4AndMore ? this.stateList[key].ssaDecision.value : this.stateList[key].cvrDecision.value,
            level2Label: this.stateList[key].level2Label,
            solutionId: this.stateList[key].solutionId
        };
        return check;
        //        this.uploadResults({ "duplicateCheckResults": stateListObj }, checks);
    };
    DetailTableDuplCheckResultsController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope', '$attrs', 'Dialog', '_'];
    return DetailTableDuplCheckResultsController;
}());
var DetailTableDuplCheckResultsComponent = (function () {
    function DetailTableDuplCheckResultsComponent() {
        this.templateUrl = 'detail-table-duplcheck-results.html';
        this.controllerAs = 'vm';
        this.bindings = dupBind;
        this.controller = DetailTableDuplCheckResultsController;
    }
    return DetailTableDuplCheckResultsComponent;
}());
angular
    .module('application')
    .component('detailTableDuplCheckResults', new DetailTableDuplCheckResultsComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableFcmrController = (function () {
    function DetailTableFcmrController(topic, settings, socket, $injector, env, $timeout, $scope) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.comp = 'cmr';
        this.requiredCountrySearch = true;
        this.OPP_VERSION_3 = 3;
        this.socket.forward('topic.search.result', this.$scope);
        this.$scope.$on('socket:topic.search.result', function (event, data) {
            _this.processing = false;
        });
        // IF YOU CHANGE ANY OF THESE VALUES, PLEASE CHANGE IT ALSO IN TEH ELIGIBILITY.TS in prepareFuzzyObject  function!!!!
        this.errorCheckerInput = false;
        this.cmrData = {};
        this.filterDisplay = false;
        this.bol = false;
        this.selectedCustName = [];
        this.tableName = 'Find CMR';
        this.cmrData.cmrIssuingCountry = '';
        this.cmrData.customerCountryLanded = '';
        this.cmrData.fuzzyOption = 'Contains';
        this.cmrData.cmrOwner = 'IBM';
        this.cmrData.cmrTypeStandard = true;
        this.cmrData.accTypeSoldTo = true;
        this.cmrData.customerName = 'CustNameOnly';
        this.cmrData.rows = '500';
        this.cmrData.cmrNum = '';
        this.cmrData.fuzzySearch = '';
        this.visible = false;
        this.expand = false;
        this.dataSources = ['CMR'];
        this.stopSubmit = false;
        this.noValidCheck = true;
        this.govCheck = true;
        this.processing = false;
        this.fuzzyOptions = ['Contains', 'Begins with', 'Fuzzy'];
        this.resultRows = ['50', '100', '500', '1000', '5000'];
        this.cmrOwnerOptions = ['ALL', 'IBM', 'Lenovo', 'Truro', 'Fonseca'];
        this.custNameOptions = [
            { name: 'Customer Name Only', value: 'CustNameOnly' },
            { name: 'Business Name Only', value: 'BusNameOnly' },
            { name: 'Customer & Business Name', value: 'CustBusName' }
        ];
    }
    DetailTableFcmrController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableFcmrController.prototype.toggleFilter = function () {
        this.filterDisplay = this.filterDisplay ? false : true;
    };
    DetailTableFcmrController.prototype.errorChecker = function () {
        if (this.cmrData.cmrNum === null) {
            this.errorCheckerInput = true;
        }
        else {
            this.errorCheckerInput = false;
        }
    };
    DetailTableFcmrController.prototype.nameChecker = function () {
        if (this.cmrData.fuzzySearch === '') {
            this.errorCheckerInput = true;
        }
        else {
            this.errorCheckerInput = false;
        }
    };
    DetailTableFcmrController.prototype.sendDupliCheck = function (opp) {
        if (this.cmrData.fuzzySearch === '' && this.cmrData.cmrNum === '') {
            this.errorCheckerInput = true;
        }
        else {
            this.errorCheckerInput = false;
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                this.cmrData.opp = opp;
                this.cmrData.ds = 'CMR';
                this.processing = true;
                console.info('detail.tabl.fcmr (sendDupliCheck) => socket getFuzzyResults', this.cmrData);
                this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'getFuzzyResults',
                        script: '/detail/eligibility/eligibility',
                        data: this.cmrData,
                        token: this.env.user.token,
                        bID: this.topic.topicBrowserID,
                        partial: true
                    }
                });
            }
        }
    };
    // sends a broadcast to expand or colapse the table sections
    DetailTableFcmrController.prototype.expandAll = function (value) {
        this.$injector.get('$rootScope').$broadcast('expand.all.cmr', value);
        this.expand = value;
    };
    DetailTableFcmrController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope'];
    return DetailTableFcmrController;
}());
var DetailTableFcmrComponent = (function () {
    function DetailTableFcmrComponent() {
        this.templateUrl = 'detail-table-dc.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableFcmrController;
    }
    return DetailTableFcmrComponent;
}());
angular
    .module('application')
    .component('detailTableFcmr', new DetailTableFcmrComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableFpController = (function () {
    function DetailTableFpController(topic, settings, socket, $injector, env, $timeout) {
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.comp = 'fastpass';
        this.requiredCountrySearch = true;
        this.OPP_VERSION_3 = 3;
        this.tableName = 'Fast Pass';
        this.dc = { ds: 'FP-CN', countrySelected: '', fuzzySearch: '', opp: '', countryLine: [], pickList: [] };
        this.visible = false;
        this.expand = false;
        //this.dataSources = [{name: 'Cust No.', ds: 'FP-CN'},{name: 'BP Name', ds: 'FP-BP'},{name: 'Site No.', ds: 'FP-SN'},{name: 'S. Order', ds: 'FP-SO'}];
        this.dataSources = ['FP-CN', 'FP-BP', 'FP-SN', 'FP-SO'];
        this.stopSubmit = false;
        this.noValidCheck = true;
        this.govCheck = true;
        this.filterDisplay = false;
    }
    ;
    DetailTableFpController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableFpController.prototype.sendDupliCheck = function (opp) {
        if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
            /*this.stopSubmit = true;
            this.$timeout(() => {
                      this.stopSubmit = false;
                  }, 1000);*/
            this.dc.opp = opp;
            //this.dc.iot = this.settings.calcIot(this.topic.topic.gpp_valid[0].country);
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getFuzzyResults',
                    script: '/detail/eligibility/eligibility',
                    data: this.dc,
                    token: this.env.user.token,
                    bID: this.topic.topicBrowserID,
                    partial: true
                }
            });
        }
        ;
    };
    DetailTableFpController.prototype.toggleFilter = function () {
        this.filterDisplay = this.filterDisplay ? false : true;
    };
    DetailTableFpController.prototype.sendSONcheck = function (opp) {
        this.dc.pickList = [this.topic.topic.gpp_valid[0].salesorder];
        this.sendDupliCheck(opp);
    };
    // sends a broadcast to expand or colapse the table sections
    DetailTableFpController.prototype.expandAll = function (value) {
        this.$injector.get('$rootScope').$broadcast('expand.all.fastpass', value);
        this.expand = value;
    };
    DetailTableFpController.prototype.clearList = function () {
        this.dc.pickList = [];
    };
    DetailTableFpController.prototype.pushItem = function () {
        var _this = this;
        var dupli = false;
        angular.forEach(this.dc.pickList, function (iter) {
            if (iter === _this.toBeInserted) {
                dupli = true;
            }
        });
        if (!dupli) {
            this.dc.pickList.push(this.toBeInserted);
        }
        this.toBeInserted = '';
    };
    DetailTableFpController.prototype.countryChange = function () {
        return;
    };
    DetailTableFpController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout'];
    return DetailTableFpController;
}());
var DetailTableFpComponent = (function () {
    function DetailTableFpComponent() {
        this.templateUrl = 'detail-table-dc.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableFpController;
    }
    return DetailTableFpComponent;
}());
angular
    .module('application')
    .component('detailTableFp', new DetailTableFpComponent());



var IbmDuplCheckController = (function () {
    function IbmDuplCheckController(topic, $injector, env, $stateParams, $scope) {
        this.topic = topic;
        this.$injector = $injector;
        this.env = env;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.comp = 'dc_sc';
        this.scCheckData = _.get(this, 'topic.checksData.result');
        this.scResult = this.scCheckData && angular.isDefined(this.scCheckData.DUPSC) ? [this.scCheckData.DUPSC.data] : undefined;
        this.tableName = 'IBM Duplicate Check';
        this.visible = false;
        this.filterDisplay = false;
    }
    IbmDuplCheckController.prototype.toggleFilter = function () {
        this.filterDisplay = !this.filterDisplay;
    };
    IbmDuplCheckController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    IbmDuplCheckController.prototype.isSectionEnabled = function () {
        return _.get(this, 'scResult') !== undefined
            ? !this.scResult.isError
            : false;
    };
    IbmDuplCheckController.$inject = ['topic', '$injector', 'env', '$stateParams', '$scope', '_'];
    return IbmDuplCheckController;
}());
var DetailTableIbmCheckComponent = (function () {
    function DetailTableIbmCheckComponent() {
        this.templateUrl = 'detail-table-ibm-duplcheck.html';
        this.controllerAs = 'vm';
        this.controller = IbmDuplCheckController;
    }
    return DetailTableIbmCheckComponent;
}());
angular
    .module('application')
    .component('detailTableIbmCheck', new DetailTableIbmCheckComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableIgFcmrController = (function () {
    function DetailTableIgFcmrController(topic, settings, socket, $injector, env, $timeout, $scope, $attrs) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.comp = 'cmr';
        this.requiredCountrySearch = true;
        this.sendDupliCheck = function (opp) {
            if (_this.cmrData.fuzzySearch === '' && _this.cmrData.cmrNum === '') {
                _this.errorCheckerInput = true;
            }
            else {
                _this.errorCheckerInput = false;
                if (_this.topic.updatePartialSocketStatus([_this.comp], 'Updating')) {
                    _this.cmrData.opp = opp;
                    _this.cmrData.ds = _this.comp === 'cmr' ? 'CMR' : 'VCMR';
                    _this.processing = true;
                    console.info('detail.tabl.fcmr (sendDupliCheck) => socket getFuzzyResults', _this.cmrData);
                    _this.socket.emit('module', {
                        module: {
                            application: 'dmt',
                            bID: _this.topic.topicBrowserID,
                            data: _this.cmrData,
                            function: 'runManualFindCMRCheck',
                            partial: true,
                            script: '/detail/eligibility/manualFindCMR/index',
                            token: _this.env.user.token,
                            type: _this.cmrData.ds === 'CMR' ? 'cmr' : 'cmr_valid'
                        }
                    });
                }
            }
        };
        this.socket.forward('topic.search.result', this.$scope);
        this.$scope.$on('socket:topic.search.result', function (event, data) {
            _this.processing = false;
        });
        // IF YOU CHANGE ANY OF THESE VALUES, PLEASE CHANGE IT ALSO IN TEH ELIGIBILITY.TS in prepareFuzzyObject  function!!!!
        this.errorCheckerInput = false;
        this.cmrData = {};
        this.filterDisplay = true; //
        this.bol = false;
        this.selectedCustName = [];
        this.tableName = 'Ig Find CMR';
        this.cmrData.cmrIssuingCountry = '';
        this.cmrData.customerCountryLanded = '';
        this.cmrData.fuzzyOption = 'Contains';
        this.cmrData.cmrOwner = 'IBM';
        this.cmrData.cmrTypeStandard = true;
        this.cmrData.accTypeSoldTo = true;
        this.cmrData.customerName = 'CustNameOnly';
        this.cmrData.rows = '500';
        this.cmrData.cmrNum = '';
        this.cmrData.fuzzySearch = '';
        this.visible = true; //
        this.expand = false;
        this.dataSources = ['CMR'];
        this.stopSubmit = false;
        this.noValidCheck = true;
        this.govCheck = true;
        this.processing = false;
        this.fuzzyOptions = ['Contains', 'Begins with', 'Fuzzy'];
        this.resultRows = ['50', '100', '500', '1000', '5000'];
        this.cmrOwnerOptions = ['ALL', 'IBM', 'Lenovo', 'Truro', 'Fonseca'];
        this.custNameOptions = [
            { name: 'Customer Name Only', value: 'CustNameOnly' },
            { name: 'Business Name Only', value: 'BusNameOnly' },
            { name: 'Customer & Business Name', value: 'CustBusName' }
        ];
    }
    ;
    DetailTableIgFcmrController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableIgFcmrController.prototype.toggleFilter = function () {
        this.filterDisplay = this.filterDisplay ? false : true;
    };
    DetailTableIgFcmrController.prototype.$onInit = function () {
        if (this.$attrs.data) {
            this.comp = this.$attrs.data;
            this.dataSources = ['VCMR'];
        }
        else {
            this.comp = 'cmr';
        }
    };
    DetailTableIgFcmrController.prototype.errorChecker = function () {
        if (this.cmrData.cmrNum === null) {
            this.errorCheckerInput = true;
        }
        else {
            this.errorCheckerInput = false;
        }
    };
    DetailTableIgFcmrController.prototype.nameChecker = function () {
        if (this.cmrData.fuzzySearch === '') {
            this.errorCheckerInput = true;
        }
        else {
            this.errorCheckerInput = false;
        }
    };
    // sends a broadcast to expand or colapse the table sections
    DetailTableIgFcmrController.prototype.expandAll = function (value) {
        this.$injector.get('$rootScope').$broadcast('expand.all.cmr', value);
        this.expand = value;
    };
    DetailTableIgFcmrController.prototype.countryChange = function () {
        return;
    };
    DetailTableIgFcmrController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope', '$attrs'];
    return DetailTableIgFcmrController;
}());
var DetailTableIgFcmrComponent = (function () {
    function DetailTableIgFcmrComponent() {
        this.templateUrl = 'detail-table-ig-find-cmr.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableIgFcmrController;
    }
    return DetailTableIgFcmrComponent;
}());
angular
    .module('application')
    .component('detailTableIgFindCmr', new DetailTableIgFcmrComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableIgFgoeController = (function () {
    function DetailTableIgFgoeController(topic, settings, socket, $injector, env, $timeout, $scope, $attrs) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.comp = 'goe_data';
        this.requiredCountrySearch = true;
        this.socket.forward('topic.search.result', this.$scope);
        this.$scope.$on('socket:topic.search.result', function (event, data) {
            _this.processing = false;
        });
        // IF YOU CHANGE ANY OF THESE VALUES, PLEASE CHANGE IT ALSO IN TEH ELIGIBILITY.TS in prepareFuzzyObject  function!!!!
        this.errorCheckerInput = false;
        this.cmrData = {};
        this.filterDisplay = true;
        this.bol = false;
        this.selectedCustName = [];
        this.cmrData.cmrIssuingCountry = '';
        this.cmrData.customerCountryLanded = '';
        this.cmrData.fuzzyOption = 'Contains';
        this.cmrData.cmrOwner = 'IBM';
        this.cmrData.cmrTypeStandard = true;
        this.cmrData.accTypeSoldTo = true;
        this.cmrData.customerName = 'CustNameOnly';
        this.cmrData.rows = '5000';
        this.cmrData.showCapRecords = true;
        this.cmrData.cmrNum = '';
        this.cmrData.fuzzySearch = '';
        this.visible = true;
        this.expand = false;
        this.dataSources = ['GOE'];
        this.stopSubmit = false;
        this.noValidCheck = true;
        this.govCheck = true;
        this.processing = false;
        this.fuzzyOptions = ['Contains', 'Begins with', 'Fuzzy'];
        this.resultRows = ['50', '100', '500', '1000', '5000'];
        this.cmrOwnerOptions = ['ALL', 'IBM', 'Lenovo', 'Truro', 'Fonseca'];
        this.custNameOptions = [
            { name: 'Customer Name Only', value: 'CustNameOnly' },
            { name: 'Business Name Only', value: 'BusNameOnly' },
            { name: 'Customer & Business Name', value: 'CustBusName' }
        ];
    }
    DetailTableIgFgoeController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableIgFgoeController.prototype.toggleFilter = function () {
        this.filterDisplay = this.filterDisplay ? false : true;
    };
    DetailTableIgFgoeController.prototype.$onInit = function () {
        if (this.$attrs.data) {
            this.comp = this.$attrs.data;
            this.dataSources = ['GOE_VALID'];
        }
        else {
            this.comp = 'goe_data';
        }
    };
    DetailTableIgFgoeController.prototype.errorChecker = function () {
        if (this.cmrData.cmrNum === null) {
            this.errorCheckerInput = true;
        }
        else {
            this.errorCheckerInput = false;
        }
    };
    DetailTableIgFgoeController.prototype.nameChecker = function () {
        if (this.cmrData.fuzzySearch === '') {
            this.errorCheckerInput = true;
        }
        else {
            this.errorCheckerInput = false;
        }
    };
    DetailTableIgFgoeController.prototype.sendDupliCheck = function (opp) {
        if (this.cmrData.fuzzySearch === '' && this.cmrData.cmrNum === '') {
            this.errorCheckerInput = true;
        }
        else {
            this.errorCheckerInput = false;
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                this.cmrData.opp = opp;
                this.cmrData.ds = this.comp === 'goe_valid' ? 'GOE_VALID' : 'GOE_DATA';
                this.processing = true;
                //console.info('detail.table.ig.fgoe (sendDupliCheck) => socket getFuzzyResults', this.cmrData);
                this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'getFuzzyResults',
                        script: '/detail/eligibility/eligibility',
                        data: this.cmrData,
                        token: this.env.user.token,
                        bID: this.topic.topicBrowserID,
                        partial: true
                    }
                });
            }
            ;
        }
    };
    DetailTableIgFgoeController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope', '$attrs'];
    return DetailTableIgFgoeController;
}());
var DetailTableIgFgoeComponent = (function () {
    function DetailTableIgFgoeComponent() {
        this.templateUrl = 'detail-table-ig-find-goe.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableIgFgoeController;
    }
    return DetailTableIgFgoeComponent;
}());
angular
    .module('application')
    .component('detailTableIgFindGoe', new DetailTableIgFgoeComponent());



var DetailTableIgCheckController = (function () {
    function DetailTableIgCheckController(topic, settings, socket, $injector, env, $timeout, $scope, $attrs) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.comp = ['goe_data', 'cmr'];
        this.socket.forward('topic.search.result', this.$scope);
        this.$scope.$on('socket:topic.search.result', function (event, data) {
            _this.processing = false;
        });
        // IF YOU CHANGE ANY OF THESE VALUES, PLEASE CHANGE IT ALSO IN TEH ELIGIBILITY.TS in prepareFuzzyObject  function!!!!
        this.errorCheckerInput = false;
        this.filterDisplay = false;
        this.displayFindGoe = false;
        this.displayFindCmr = false;
        this.tableName = 'Incentives Government Check';
        this.visible = false;
        this.expand = false;
    }
    DetailTableIgCheckController.prototype.toggle = function () {
        this.visible = !this.visible;
        this.tableName = 'Incentives Government Check';
    };
    DetailTableIgCheckController.prototype.toggleFilter = function () {
        this.filterDisplay = !this.filterDisplay;
    };
    DetailTableIgCheckController.prototype.getManualGoeDecisionLabel = function () {
        if (this.topic.topic.commonGOEDecision) {
            switch (this.topic.topic.commonGOEDecision.goeDecision) {
                case 'Y': return 'Government Entity';
                case 'S': return 'State Owned Enterprise';
                case 'N': return 'Non-government';
                case 'U': return 'Unknown';
                default: return '';
            }
        }
    };
    DetailTableIgCheckController.prototype.getManualGoeReasonLabel = function () {
        if (this.topic.topic.commonGOEDecision) {
            var duns = void 0;
            var trusted = void 0;
            switch (this.topic.topic.commonGOEDecision.reason) {
                case 'TRUSTED_WITH_DUNS': {
                    duns = '';
                    trusted = '';
                    break;
                }
                case 'TRUSTED_WITHOUT_DUNS': {
                    duns = 'no ';
                    trusted = '';
                    break;
                }
                case 'NOT_TRUSTED_WITH_DUNS': {
                    duns = '';
                    trusted = 'not ';
                    break;
                }
                case 'NOT_TRUSTED_WITHOUT_DUNS': {
                    duns = 'no ';
                    trusted = 'not ';
                    break;
                }
                default: {
                    return this.topic.topic.commonGOEDecision.reason || 'no records';
                }
            }
            var message = void 0;
            if (this.topic.topic.commonGOEDecision.reason === 'EMPTY_RESULTS') {
                message = 'no records';
            }
            else {
                message = duns + "DUNS - " + trusted + "Most Trusted Source";
            }
            switch (this.topic.topic.commonGOEDecision.goeDecision) {
                case 'Y': return "Yes - " + message;
                case 'N': return "No - " + message;
                case 'U': return "Unknown - " + message;
                default: return '';
            }
        }
    };
    DetailTableIgCheckController.prototype.toggleSearchInput = function (searchType) {
        if (searchType === 'findGoe') {
            this.displayFindGoe = !this.displayFindGoe;
            this.displayFindCmr = false;
            this.tableName = 'Incentives Government Check';
        }
        if (searchType === 'findCmr') {
            this.displayFindCmr = !this.displayFindCmr;
            this.displayFindGoe = false;
            this.tableName = 'Find Cmr';
        }
    };
    DetailTableIgCheckController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope', '$attrs'];
    return DetailTableIgCheckController;
}());
var DetailTableIgCheckComponent = (function () {
    function DetailTableIgCheckComponent() {
        this.templateUrl = 'detail-table-igcheck.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableIgCheckController;
    }
    return DetailTableIgCheckComponent;
}());
angular
    .module('application')
    .component('detailTableIgCheck', new DetailTableIgCheckComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableMgrController = (function () {
    function DetailTableMgrController(topic, settings, socket, $injector, env, $timeout) {
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.comp = 'mgr';
        this.requiredCountrySearch = false;
        this.OPP_VERSION_3 = 3;
        this.tableName = 'MGR';
        this.dc = { ds: 'MGR', countrySelected: '', fuzzySearch: '', opp: '', countryLine: [] };
        this.visible = false;
        this.expand = false;
        //this.dataSources = [{name: 'MGR', ds: 'MGR'}];
        this.dataSources = ['MGR'];
        this.stopSubmit = false;
        this.noValidCheck = true;
        this.govCheck = true;
        this.filterDisplay = false;
    }
    ;
    DetailTableMgrController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableMgrController.prototype.sendDupliCheck = function (opp) {
        if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
            /*this.stopSubmit = true;
            this.$timeout(() => {
                  this.stopSubmit = false;
              }, 1000);*/
            this.dc.opp = opp;
            //this.dc.iot = this.settings.calcIot(this.topic.topic.gpp_valid[0].country);
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getFuzzyResults',
                    script: '/detail/eligibility/eligibility',
                    data: this.dc,
                    token: this.env.user.token,
                    bID: this.topic.topicBrowserID,
                    partial: true
                }
            });
        }
        ;
    };
    DetailTableMgrController.prototype.toggleFilter = function () {
        this.filterDisplay = this.filterDisplay ? false : true;
    };
    // sends a broadcast to expand or colapse the table sections
    DetailTableMgrController.prototype.expandAll = function (value) {
        this.$injector.get('$rootScope').$broadcast('expand.all.mgr', value);
        this.expand = value;
    };
    DetailTableMgrController.prototype.countryChange = function () {
        return;
    };
    DetailTableMgrController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout'];
    return DetailTableMgrController;
}());
var DetailTableMgrComponent = (function () {
    function DetailTableMgrComponent() {
        //templateUrl = 'detail-table-mgr.html';
        this.templateUrl = 'detail-table-dc.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableMgrController;
    }
    return DetailTableMgrComponent;
}());
angular
    .module('application')
    .component('detailTableMgr', new DetailTableMgrComponent());



/**
 * @author Ivan Toth.
 * tables inside of the duplicate check
 */
var dcItemBindings = { item: '=', row: '<', comp: '<', filter: '=' };
var MultiController = (function () {
    function MultiController($scope, socket, settings, topic, Dialog, $state, $timeout, env, $http, notify, moment) {
        var _this = this;
        this.$scope = $scope;
        this.socket = socket;
        this.settings = settings;
        this.topic = topic;
        this.Dialog = Dialog;
        this.$state = $state;
        this.$timeout = $timeout;
        this.env = env;
        this.$http = $http;
        this.notify = notify;
        this.moment = moment;
        this.tableStyle = { 'padding': '0px', 'border': 'none' };
        this.expand = false;
        // receive broadcasts in case some1 wants to expand or collapse sections
        this.socket.forward('expand.all', this.$scope);
        this.$scope.$on('expand.all.' + this.comp, function (event, data) {
            _this.toggle(data);
        });
        this.filterObject = {};
        this.searchCriteria = false;
        this.showSecondary = false;
    }
    MultiController.prototype.$onInit = function () {
        this.goeResult = angular.isDefined(this.item.goeSearchResponse) ? this.item.goeSearchResponse : [];
        this.rowOrder = [];
        if (this.goeResult.length > 0) {
            for (var prop in this.goeResult[0]) {
                this.columnObj = (this.comp && angular.isDefined(this.settings.columnNames[this.comp][prop])) ? this.settings.columnNames[this.comp][prop] : null;
                this.columnObj.v = prop;
                if (this.columnObj.h !== '$$hashKey') {
                    this.rowOrder.push(this.columnObj);
                }
            }
        }
    };
    MultiController.prototype.toggleCriteria = function () {
        this.searchCriteria = !this.searchCriteria;
    };
    MultiController.prototype.clearFilter = function (filtName) {
        this.filterObject.filters[filtName].picked = [];
        this.blurFilterPick();
    };
    MultiController.prototype.searchParams = function () {
        var searchPath = this.item.searchParams;
        return [
            { "name": "Customer Country Landed", "value": searchPath.country },
            { "name": "CMR Num", "value": searchPath.cmrArray },
            { "name": "Address type/Sold To", "value": "true/false" },
            { "name": "CMR Types/Strandard", "value": "true/false" },
        ];
    };
    /**
      Expands or collapses sections
      @param value    boolean to decide if expand or collapse
      @returns void
    */
    MultiController.prototype.toggle = function (value) {
        if (angular.isUndefined(value)) {
            this.expand = this.expand ? false : true;
        }
        else {
            this.expand = value;
        }
    };
    /**
      Toggles the table row, when it contains a secondary row as a table
      @param rowObj    row to be toggled
      @returns void
    */
    MultiController.prototype.toggleRow = function (rowObj) {
        if (angular.isDefined(rowObj.visible) && rowObj.visible) {
            rowObj.visible = false;
        }
        else {
            rowObj.visible = true;
        }
    };
    MultiController.prototype.changedValue = function () {
        this.filterObject.calculated = false;
    };
    MultiController.prototype.makeFilterOptions = function () {
        var _this = this;
        //if (this.filterObject.notEmpty) {
        if (!this.filterObject.calculated && this.filterObject.notEmpty) {
            //browse through every item in table
            this.filterObject.calculated = true;
            angular.forEach(this.item_array, function (tableLine) {
                //if the item is unique, put it into the representing unique value
                for (var prop in _this.filterObject.filters) {
                    if (_this.filterObject.filters[prop].type === 's') {
                        if (_this.filterObject.filters[prop].unique.indexOf(tableLine[prop]) < 0) {
                            _this.filterObject.filters[prop].unique.push(tableLine[prop]);
                        }
                    }
                }
            });
        }
    };
    /**
     Opens the dropdown with the filters. By changing this, we'll change the limitTo of the filter ng-repeat. This is done for
     performance increase(So DOM doenst have to have in special cases 4k+ checkboxes)
     @param id        id of the filter
     @param size      size of the filter
     @returns void
    */
    MultiController.prototype.openDrop = function (id, size) {
        this.countDrop[id] = size;
    };
    /**
     Closes dropdown and sets the limitTo on the filter to 0
     @param id        id of the filter
     @returns void
    */
    MultiController.prototype.closeDrop = function (id) {
        this.countDrop[id] = 0;
        this.blurFilterPick();
    };
    /**
     Based on the filters selected, only those lines in table are picked, that fullfill the picked filter values
     @returns void
    */
    MultiController.prototype.blurFilterPick = function () {
        var _this = this;
        if (!this.filterObject.calculated && this.filterObject.notEmpty) {
            //if (this.filterObject.notEmpty) {
            var tempArray_1 = [];
            var filterOK_1 = true;
            angular.forEach(this.item, function (tableLine) {
                filterOK_1 = true;
                var _loop_1 = function(prop) {
                    if (_this.filterObject.filters[prop].type === 's' && filterOK_1) {
                        if (_this.filterObject.filters[prop].picked.length > 0) {
                            filterOK_1 = false;
                            angular.forEach(_this.filterObject.filters[prop].picked, function (picked) {
                                if (picked === tableLine[prop]) {
                                    filterOK_1 = true;
                                }
                            });
                        }
                    }
                };
                for (var prop in _this.filterObject.filters) {
                    _loop_1(prop);
                }
                if (filterOK_1) {
                    tempArray_1.push(tableLine);
                }
            });
            this.item_array = angular.copy(tempArray_1);
        }
    };
    /**
      Export report into Excel file
      @returns void
    */
    MultiController.prototype.excelExport = function () {
        console.log('sending export Excel request');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportReportExcel',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.getId(this.topic.topic._id),
                    comp: this.comp,
                    goeResult: this.goeResult,
                    timestamp: this.item.finalTimestamp
                }
            }
        });
    };
    MultiController.prototype.showCmrArrayList = function () {
        var toggleDecision = this.expand ? false : true;
        this.toggle(toggleDecision);
        var items = {
            dialogName: this.item.searchParams.cmrArray
        };
        this.Dialog.updateValidForm(event, items, 'cmrArray-dialog.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
    };
    MultiController.prototype.convertToUnix = function (time) {
        return this.moment.unix(time).format("LLL");
    };
    // Return full name of the country (example "US" => "USA") 
    MultiController.prototype.getCountryFullName = function (country) {
        for (var _i = 0, _a = this.topic.settings.country_list; _i < _a.length; _i++) {
            var e = _a[_i];
            if (e.short === country) {
                return e.cc_text;
            }
        }
    };
    MultiController.$inject = ['$scope', 'socket', 'settings', 'topic', 'Dialog', '$state', '$timeout', 'env', '$http', 'notify', 'moment'];
    return MultiController;
}());
var MultiComponent = (function () {
    function MultiComponent() {
        this.bindings = dcItemBindings;
        this.templateUrl = 'detail-table-multi.html';
        this.controller = MultiController;
    }
    return MultiComponent;
}());
angular
    .module('application')
    .component('multiTable', new MultiComponent());



var dcItemBindings = { item: '=', row: '<', comp: '<', filter: '=' };
var MultiController = (function () {
    function MultiController($scope, socket, settings, topic, Dialog, $state, $timeout, env, $http, notify, moment, _) {
        var _this = this;
        this.$scope = $scope;
        this.socket = socket;
        this.settings = settings;
        this.topic = topic;
        this.Dialog = Dialog;
        this.$state = $state;
        this.$timeout = $timeout;
        this.env = env;
        this.$http = $http;
        this.notify = notify;
        this.moment = moment;
        this._ = _;
        this.checksData = _.get(this, 'topic.checksData.result');
        this.tableStyle = { padding: '0px', border: 'none' };
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        if (!this.topic.topic.version || this.topic.topic.version <= this.OPP_VERSION_4) {
            this.dupPath = 'DUPMYSA';
        }
        else {
            this.dupPath = 'DUP';
        }
        this.expand = false;
        // receive broadcasts in case some1 wants to expand or collapse sections
        this.socket.forward('expand.all', this.$scope);
        this.$scope.$on("expand.all. " + this.comp, function (event, data) {
            _this.toggle(data);
        });
        this.filterObject = {};
        this.searchCriteria = false;
        this.showSecondary = false;
        if (this.comp === 'dc_v5') {
            this.excelComp = this.item.isEi ? 'dc_v5_ei' : 'dc_v5_ssa';
        }
        else {
            this.excelComp = this.comp;
        }
    }
    /**
     * If dupCheckResult contain duplicates return 0 otherwise
     * length of data
     * @returns {number}
     * @memberof MultiController
     */
    MultiController.prototype.dupCheckResultLength = function () {
        return _.get(this.dupCheckResult[0], 'duplicates')
            ? 0
            : this.dupCheckResult.length;
    };
    MultiController.prototype.toggleCriteria = function () {
        this.searchCriteria = !this.searchCriteria;
    };
    MultiController.prototype.clearFilter = function (filtName) {
        this.filterObject.filters[filtName].picked = [];
        this.blurFilterPick();
    };
    MultiController.prototype.searchParams = function () {
        var searchPath = this.item.searchParams;
        return [
            { name: 'Key Word', value: searchPath.keyWord },
            { name: 'Country selected', value: searchPath.cmrArray },
            { name: 'Alt Brand Family', value: searchPath.altBrandFamily },
        ];
    };
    /**
     * Toggles the table row, when it contains a secondary row as a table
     * @param rowObj    row to be toggled
     * @returns void
     */
    MultiController.prototype.toggleRow = function (rowObj) {
        rowObj.visible = angular.isDefined(rowObj.visible) && rowObj.visible ? false : true;
    };
    MultiController.prototype.changedValue = function () {
        this.filterObject.calculated = false;
    };
    MultiController.prototype.makeFilterOptions = function () {
        var _this = this;
        if (!this.filterObject.calculated && this.filterObject.notEmpty) {
            //browse through every item in table
            this.filterObject.calculated = true;
            angular.forEach(this.item_array, function (tableLine) {
                //if the item is unique, put it into the representing unique value
                for (var prop in _this.filterObject.filters) {
                    if (_this.filterObject.filters[prop].type === 's') {
                        if (_this.filterObject.filters[prop].unique.indexOf(tableLine[prop]) < 0) {
                            _this.filterObject.filters[prop].unique.push(tableLine[prop]);
                        }
                    }
                }
            });
        }
    };
    /**
     * Opens the dropdown with the filters. By changing this, we'll change the limitTo of the filter ng-repeat. This is done for
     * performance increase(So DOM doenst have to have in special cases 4k+ checkboxes)
     * @param id        id of the filter
     * @param size      size of the filter
     * @returns void
     */
    MultiController.prototype.openDrop = function (id, size) {
        this.countDrop[id] = size;
    };
    /**
     * Closes dropdown and sets the limitTo on the filter to 0
     * @param id        id of the filter
     * @returns void
     */
    MultiController.prototype.closeDrop = function (id) {
        this.countDrop[id] = 0;
        this.blurFilterPick();
    };
    /**
     * Export report into Excel file
     * @returns void
     */
    MultiController.prototype.excelExport = function () {
        console.info('Sending export Excel request');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    comp: this.excelComp,
                    dupCheckResult: this.dupCheckResult,
                    id: this.topic.getId(this.topic.topic._id),
                    timestamp: this.item.finalTimestamp
                },
                function: 'exportReportExcel',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token
            }
        });
    };
    MultiController.prototype.showCmrArrayList = function () {
        var toggleDecision = !this.expand;
        this.toggle(toggleDecision);
        var items = {
            dialogName: this.item.searchParams.cmrArray
        };
        this.Dialog.updateValidForm(event, items, 'cmrArray-dialog.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
    };
    MultiController.prototype.convertToUnix = function (time) {
        if (this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5) {
            return this.moment.utc(time).format('LLL');
        }
        else {
            return this.moment.unix(time).format('LLL');
        }
    };
    // Return full name of the country (example "US" => "USA")
    MultiController.prototype.getCountryFullName = function (country) {
        for (var _i = 0, _a = this.topic.settings.country_list; _i < _a.length; _i++) {
            var e = _a[_i];
            if (e.short === country) {
                return e.cc_text;
            }
        }
    };
    MultiController.prototype.fillArrayBasedOnComponent = function () {
        switch (this.comp) {
            case 'dc_mysa':
            case 'dc_mysa_v4': {
                this.dupCheckResult = this.extractMySADupCheckResults();
                if (this.dupCheckResult && this.dupCheckResult.length > 0) {
                    this.dupCheckResult = this.extendDupCheckResult();
                }
                break;
            }
            case 'dc_v5': {
                this.dupCheckResult = this.extractMySADupCheckResultsV5();
                break;
            }
            case 'dc_sc': {
                this.dupCheckResult = this.extractSCDupCheckResults();
                break;
            }
        }
        if (this.dupCheckResult && this.dupCheckResult.length > 0) {
            this.rowOrder = this.getColumnObj();
            this.convertDatesToUtc();
        }
    };
    MultiController.prototype.extractMySADupCheckResults = function () {
        var dupCheck = _.get(this.checksData, this.dupPath + ".data.mySADuplicateCheckResult.data");
        if (dupCheck === undefined) {
            dupCheck = _.get(this.checksData, this.dupPath + ".data.mySADuplicateCheckResult");
            if (Array.isArray(dupCheck)) {
                dupCheck = this.collectDuplicates(dupCheck);
            }
        }
        if (dupCheck === undefined) {
            dupCheck = [];
        }
        return dupCheck;
    };
    MultiController.prototype.extractMySADupCheckResultsV5 = function () {
        var dupCheck = this.item.mySADuplicateCheckResult;
        var inboundIncentiveDetail = _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail');
        var inboundDealRegs = inboundIncentiveDetail.dealRegs;
        var result = [];
        if (Array.isArray(dupCheck)) {
            // order of properties defines order of columns in the table
            var _loop_1 = function(check) {
                var inboundDealReg = inboundDealRegs.find(function (item) { return item.dealRegGroupId === check.dealRegGroupId; });
                for (var _i = 0, _a = check.duplicates; _i < _a.length; _i++) {
                    var duplicate = _a[_i];
                    var row = {
                        opp: duplicate.opp,
                        bpName: duplicate.bpName,
                        sviSubmitDate: duplicate.sviSubmitDate,
                        sviExpDate: duplicate.sviExpDate,
                        country: duplicate.country,
                        sviOverallStatus: duplicate.sviOverallStatus,
                        accountName: duplicate.accountName,
                        dcid: duplicate.dcid,
                        dbg: duplicate.dbg,
                        drpgId: duplicate.drpgId,
                        drpgName: inboundDealReg.dealRegGroupDescription
                    };
                    if (this_1.item.isEi) {
                        if (duplicate.eiDupReason) {
                            row.eiDup = duplicate.eiDup;
                            row.eiDupReason = duplicate.eiDupReason;
                            result.push(row);
                        }
                    }
                    else {
                        if (duplicate.ssaDupReason) {
                            row.ssaDup = duplicate.ssaDup;
                            row.ssaDupReason = duplicate.ssaDupReason;
                            result.push(row);
                        }
                    }
                }
            };
            var this_1 = this;
            for (var _b = 0, dupCheck_1 = dupCheck; _b < dupCheck_1.length; _b++) {
                var check = dupCheck_1[_b];
                _loop_1(check);
            }
        }
        return result;
    };
    MultiController.prototype.extractSCDupCheckResults = function () {
        var dupCheck = _.get(this.checksData, 'DUPSC.data.scDuplicateCheckResult.data');
        if (dupCheck === undefined) {
            dupCheck = _.get(dupCheck, 'DUPSC.data.scDuplicateCheckResult');
            if (Array.isArray(dupCheck)) {
                dupCheck = this.collectDuplicates(dupCheck);
            }
        }
        return dupCheck;
    };
    MultiController.prototype.extendDupCheckResult = function () {
        var _this = this;
        var dupCheckResultCopy = this.dupCheckResult;
        var duplicateRootObject;
        var getDupeReason = function (brandFamily) {
            var mySADuplicateCheckResult = _.get(_this.checksData, _this.dupPath + ".data.mySADuplicateCheckResult.data")
                || _.get(_this.checksData, _this.dupPath + ".data.mySADuplicateCheckResult");
            var duplicate = mySADuplicateCheckResult
                .filter(function (e) { return e.solutionId === brandFamily; });
            return duplicate.length > 0 ? duplicate[0].reason : '';
        };
        var getDrpgName = function (duplicate) {
            var mySADuplicateCheckResult = _.get(_this.checksData, _this.dupPath + ".data.mySADuplicateCheckResult.data")
                || _.get(_this.checksData, _this.dupPath + ".data.mySADuplicateCheckResult");
            var solutions = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.solutions');
            for (var _i = 0, mySADuplicateCheckResult_1 = mySADuplicateCheckResult; _i < mySADuplicateCheckResult_1.length; _i++) {
                var dupResult = mySADuplicateCheckResult_1[_i];
                for (var _a = 0, _b = dupResult.duplicates; _a < _b.length; _a++) {
                    var e = _b[_a];
                    if (e === duplicate) {
                        duplicateRootObject = Object.assign({}, dupResult);
                        break;
                    }
                }
            }
            var solution = solutions.filter(function (solutionElem) {
                return (solutionElem.solutionId === duplicateRootObject.solutionId && solutionElem.level2Label === duplicateRootObject.level2Label);
            });
            return solution.length > 0 ? solution[0].name : '';
        };
        dupCheckResultCopy.forEach(function (duplicate) {
            delete duplicate.saleStage;
            delete duplicate.brand;
            delete duplicate.bpceid;
            if (!duplicate.dcid) {
                duplicate.dcid = 'N/A';
            }
            if (!duplicate.dbg) {
                duplicate.dbg = 'N/A';
            }
            // Object.assign(duplicate, { dcid: getDomesticValue('Domestic Client ID') });
            // Object.assign(duplicate, { dbg: getDomesticValue('Domestic Buying Group') });
            // Will take common DRPG duplicate reason if it doesn't exist for dup item
            Object.assign(duplicate, { dupeReason: _.get(duplicate, 'reason', getDupeReason(duplicate.brandFamily)) });
            Object.assign(duplicate, { drpgName: getDrpgName(duplicate) });
            delete duplicate.reason;
        });
        return dupCheckResultCopy;
    };
    MultiController.prototype.getColumnObj = function () {
        var arrayOfOrders = [];
        // tslint:disable-next-line: forin
        for (var prop in this.dupCheckResult[0]) {
            this.columnObj = this.settings.columnNames[this.comp][prop]
                ? this.settings.columnNames[this.comp][prop]
                : null;
            if (this.columnObj !== null) {
                this.columnObj.v = prop;
            }
            if (this.columnObj !== null && this.columnObj.h !== '$$hashKey') {
                arrayOfOrders.push(this.columnObj);
            }
        }
        return arrayOfOrders;
    };
    MultiController.prototype.convertDatesToUtc = function () {
        var _this = this;
        this.dupCheckResult.forEach(function (result) {
            if (!Number.isNaN(Number(result.decisionDate))) {
                result.decisionDate = _this.moment.utc(Number(result.decisionDate)).format('LLL');
            }
            if (!Number.isNaN(Number(result.sviExpDate))) {
                result.sviExpDate = _this.moment.utc(Number(result.sviExpDate)).format('LLL');
            }
            if (!Number.isNaN(Number(result.sviSubmitDate))) {
                result.sviSubmitDate = _this.moment.utc(Number(result.sviSubmitDate)).format('LLL');
            }
        });
    };
    MultiController.prototype.collectDuplicates = function (dupCheckResult) {
        var duplicatesArr = [];
        dupCheckResult.forEach(function (dupResult) {
            dupResult.duplicates.forEach(function (duplicate) {
                duplicatesArr.push(duplicate);
            });
        });
        return duplicatesArr;
    };
    /**
     * Expands or collapses sections
     * @param value    boolean to decide if expand or collapse
     * @returns void
     */
    MultiController.prototype.toggle = function (value) {
        this.expand = angular.isUndefined(value) ? !this.expand : value;
    };
    /**
     * Based on the filters selected, only those lines in table are picked, that fullfill the picked filter values
     * @returns void
     */
    MultiController.prototype.blurFilterPick = function () {
        var _this = this;
        if (!this.filterObject.calculated && this.filterObject.notEmpty) {
            var tempArray_1 = [];
            var filterOK_1 = true;
            angular.forEach(this.item, function (tableLine) {
                filterOK_1 = true;
                var _loop_2 = function(prop) {
                    if (_this.filterObject.filters[prop].type === 's' && filterOK_1) {
                        if (_this.filterObject.filters[prop].picked.length > 0) {
                            filterOK_1 = false;
                            angular.forEach(_this.filterObject.filters[prop].picked, function (picked) {
                                if (picked === tableLine[prop]) {
                                    filterOK_1 = true;
                                }
                            });
                        }
                    }
                };
                for (var prop in _this.filterObject.filters) {
                    _loop_2(prop);
                }
                if (filterOK_1) {
                    tempArray_1.push(tableLine);
                }
            });
            this.item_array = angular.copy(tempArray_1);
        }
    };
    MultiController.prototype.$onInit = function () {
        this.fillArrayBasedOnComponent();
    };
    MultiController.$inject = ['$scope', 'socket', 'settings', 'topic', 'Dialog', '$state', '$timeout', 'env', '$http', 'notify', 'moment', '_'];
    return MultiController;
}());
var MultiComponent = (function () {
    function MultiComponent() {
        this.bindings = dcItemBindings;
        this.templateUrl = 'detail-table-multi-duplcheck-4x4.html';
        this.controller = MultiController;
    }
    return MultiComponent;
}());
angular
    .module('application')
    .component('multiTableDuplcheck4x4', new MultiComponent());



/**
 * @author Ivan Toth.
 * tables inside of the duplicate check
 */
var dcItemBindings = { item: '=', row: '<', comp: '<', filter: '=' };
var MultiDcController = (function () {
    function MultiDcController($scope, socket, settings, topic, Dialog, $state, $timeout, env, $http, notify) {
        var _this = this;
        this.$scope = $scope;
        this.socket = socket;
        this.settings = settings;
        this.topic = topic;
        this.Dialog = Dialog;
        this.$state = $state;
        this.$timeout = $timeout;
        this.env = env;
        this.$http = $http;
        this.notify = notify;
        this.tableStyle = { 'padding': '0px', 'border': 'none' };
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.expand = false;
        // receive broadcasts in case some1 wants to expand or collapse sections
        this.socket.forward('expand.all', this.$scope);
        this.$scope.$on('expand.all.' + this.comp, function (event, data) {
            _this.toggle(data);
        });
        this.filterObject = {};
        this.searchCriteria = false;
        this.showSecondary = false;
        this.columnNamesKey = this.topic.checksData.uiVersion > this.OPP_VERSION_4 && this.comp === 'dc'
            ? 'dc_v5'
            : this.comp;
        // console.log('this.columnNamesKey...');
        // console.log(this.columnNamesKey);
    }
    MultiDcController.prototype.$onInit = function () {
        var _this = this;
        //Fill the reports object
        if (angular.isDefined(this.item)) {
            this.filterObject = {
                notEmpty: false,
                calculated: false,
                filters: {}
            };
            // Prepare filter object
            if (this.item.table) {
                this.item_array = angular.copy(this.item.table);
            }
            else if (Array.isArray(this.item) && this.item.length > 0) {
                this.item_array = angular.copy(this.item[0].table);
            }
            else if (this.item && Array.isArray(this.item.results) && this.item.results.length > 0) {
                this.item_array = angular.copy(this.item.results[0].table);
            }
            if (this.item.table && this.item.table.length > 0) {
                this.filterObject.notEmpty = true;
                angular.forEach(this.item.table, function (arr) {
                    for (var prop in arr) {
                        _this.filterObject.filters[prop] = { unique: [], picked: [], type: 's', cond: '=' };
                    }
                    ;
                });
                this.makeFilterOptions();
                this.filterObject.calculated = false;
            }
        }
        var tempArray = [];
        this.rowOrder = [];
        this.dropRowOrder = [];
        var mainCols = [];
        var secondCols = [];
        //Create columns for the table
        if (angular.isDefined(this.item) && angular.isDefined(this.item.colVer)) {
            angular.forEach(this.settings.allColumnOrder, function (columnOrder) {
                angular.forEach(columnOrder.ds, function (ds) {
                    if (ds === _this.item.ds) {
                        mainCols = columnOrder[_this.item.colVer].main;
                        secondCols = columnOrder[_this.item.colVer].second;
                    }
                });
            });
            angular.forEach(mainCols, function (columns) {
                tempArray.push(columns);
                _this.columnObj = (_this.columnNamesKey && angular.isDefined(_this.settings.columnNames[_this.columnNamesKey][columns])) ? _this.settings.columnNames[_this.columnNamesKey][columns] : { h: columns };
                _this.columnObj.v = columns;
                if (_this.columnObj.t && _this.columnObj.t.indexOf('collapse') > -1) {
                    _this.dropRowOrder.push(_this.columnObj);
                    _this.showSecondary = true;
                }
                else {
                    _this.rowOrder.push(_this.columnObj);
                }
            });
            angular.forEach(secondCols, function (columns) {
                _this.columnObj = (_this.columnNamesKey && angular.isDefined(_this.settings.columnNames[_this.columnNamesKey][columns])) ? _this.settings.columnNames[_this.columnNamesKey][columns] : { h: columns };
                _this.columnObj.v = columns;
                _this.dropRowOrder.push(_this.columnObj);
            });
            if (this.dropRowOrder.length > 0) {
                this.showSecondary = true;
            }
        }
        // Create columns for the columns, that are not listed in  cloudant
        if (this.item && this.item.table && this.item.table.length > 0) {
            for (var prop in this.item.table[0]) {
                var found = true;
                var cmrMigratedPropsToExclude = ['type', 'searchCriteria_id', '_id', '_rev', 'parent_doc_id', 'isMigrated'];
                if (mainCols.indexOf(prop) > -1 || secondCols.indexOf(prop) > -1 || prop === '$$hashKey' || prop === 'gov' || prop === 'unk' || prop === 'cmrDuns' || cmrMigratedPropsToExclude.includes(prop)) {
                    found = false;
                }
                if (found) {
                    tempArray.push(prop);
                    this.columnObj = (this.columnNamesKey && angular.isDefined(this.settings.columnNames[this.columnNamesKey][prop])) ? this.settings.columnNames[this.columnNamesKey][prop] : { h: prop };
                    this.columnObj.v = prop;
                    if (this.columnObj.t && this.columnObj.t.indexOf('collapse') > -1) {
                        this.dropRowOrder.push(this.columnObj);
                        this.showSecondary = true;
                    }
                    else {
                        this.rowOrder.push(this.columnObj);
                    }
                }
            }
            this.countDrop = [];
            for (var i = 0; i < this.rowOrder.length; i++) {
                this.countDrop[i] = 0;
            }
            this.filterArray = angular.copy(tempArray);
        }
    };
    // If variable name is know, than it sets the Description from cloudant, otherwise call the header as the variable name
    /**
      Toggle Searched criteria that was used to get this search
      @returns void
    */
    MultiDcController.prototype.toggleCriteria = function () {
        this.searchCriteria = (this.searchCriteria) ? false : true;
    };
    // /**
    //   Toggle Searched criteria that was used to get this search
    //   @returns void
    // */
    // getChecksCompare(item) {
    //   console.info(item);
    //   return 'sss'
    // }
    /**
      Clears the selected filter
      @param filtName     name of the filter
      @returns void
    */
    MultiDcController.prototype.clearFilter = function (filtName) {
        this.filterObject.filters[filtName].picked = [];
        this.blurFilterPick();
    };
    /**
      Expands or collapses sections
      @param value    boolean to decide if expand or collapse
      @returns void
    */
    MultiDcController.prototype.toggle = function (value) {
        if (angular.isUndefined(value)) {
            this.expand = this.expand ? false : true;
        }
        else {
            this.expand = value;
        }
    };
    /**
      Toggles the table row, when it contains a secondary row as a table
      @param rowObj    row to be toggled
      @returns void
    */
    MultiDcController.prototype.toggleRow = function (rowObj) {
        if (angular.isDefined(rowObj.visible) && rowObj.visible) {
            rowObj.visible = false;
        }
        else {
            rowObj.visible = true;
        }
    };
    /**
      Downloads any file from cloudant
      @returns void
    */
    MultiDcController.prototype.downloadAttachment = function () {
        console.log('sending export Excel request');
        var name = 'DMT-' + this.item.ds + this.item.timestamp + '.xlsx'; ////CHECKTHIS - is item.ds opp or stateParam.id
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'downloadAttachment',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.topic._id,
                    name: name
                }
            }
        });
    };
    /**
      Export report into Excel file
      @returns void
    */
    MultiDcController.prototype.excelExport = function () {
        console.log('sending export Excel request');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportReportExcel',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.getId(this.topic.topic._id),
                    comp: this.columnNamesKey,
                    timestamp: this.item.timestamp,
                    arrayResults: this.item.table
                }
            }
        });
    };
    /**
      Clicked / selected a item in the filter select, this will ensure, that the table will be recalculated when dropdown closes
      @returns void
    */
    MultiDcController.prototype.changedValue = function () {
        this.filterObject.calculated = false;
    };
    /**
     Will create unique items for the filters in the table
     @returns void
    */
    MultiDcController.prototype.makeFilterOptions = function () {
        var _this = this;
        //if (this.filterObject.notEmpty) {
        if (!this.filterObject.calculated && this.filterObject.notEmpty) {
            //browse through every item in table
            this.filterObject.calculated = true;
            angular.forEach(this.item_array, function (tableLine) {
                //if the item is unique, put it into the representing unique value
                for (var prop in _this.filterObject.filters) {
                    if (_this.filterObject.filters[prop].type === 's') {
                        if (_this.filterObject.filters[prop].unique.indexOf(tableLine[prop]) < 0) {
                            _this.filterObject.filters[prop].unique.push(tableLine[prop]);
                        }
                    }
                }
            });
        }
    };
    /**
     Opens the dropdown with the filters. By changing this, we'll change the limitTo of the filter ng-repeat. This is done for
     performance increase(So DOM doenst have to have in special cases 4k+ checkboxes)
     @param id        id of the filter
     @param size      size of the filter
     @returns void
    */
    MultiDcController.prototype.openDrop = function (id, size) {
        this.countDrop[id] = size;
    };
    /**
     Closes dropdown and sets the limitTo on the filter to 0
     @param id        id of the filter
     @returns void
    */
    MultiDcController.prototype.closeDrop = function (id) {
        this.countDrop[id] = 0;
        this.blurFilterPick();
    };
    /**
     Based on the filters selected, only those lines in table are picked, that fullfill the picked filter values
     @returns void
    */
    MultiDcController.prototype.blurFilterPick = function () {
        var _this = this;
        if (!this.filterObject.calculated && this.filterObject.notEmpty) {
            //if (this.filterObject.notEmpty) {
            var tempArray_1 = [];
            var filterOK_1 = true;
            angular.forEach(this.item.table, function (tableLine) {
                filterOK_1 = true;
                var _loop_1 = function(prop) {
                    if (_this.filterObject.filters[prop].type === 's' && filterOK_1) {
                        if (_this.filterObject.filters[prop].picked.length > 0) {
                            filterOK_1 = false;
                            angular.forEach(_this.filterObject.filters[prop].picked, function (picked) {
                                if (picked === tableLine[prop]) {
                                    filterOK_1 = true;
                                }
                            });
                        }
                    }
                };
                for (var prop in _this.filterObject.filters) {
                    _loop_1(prop);
                }
                if (filterOK_1) {
                    tempArray_1.push(tableLine);
                }
            });
            this.item_array = angular.copy(tempArray_1);
        }
    };
    /**
     Removes the data in the report. (Excel report to be removed still needs to be applied)
     @returns void
    */
    MultiDcController.prototype.removeReport = function (event, comp, row) {
        var _this = this;
        var items = { message: 'Click OK to delete the results ot this search', okMessage: 'Remove', cancelMessage: 'Cancel' };
        this.Dialog.updateValidForm(event, items, 'ok-cancel.html').then(function (dResult) {
            if (!angular.isUndefined(dResult)) {
                var upData = { id: _this.topic.topic._id, data: {}, type: [comp, 'comments$' + _this.topic.tabs.short] };
                var data = {};
                _this.topic.setTempFromTopicPart(comp);
                // clears the table object
                data[comp + '.results.' + row + '.table'] = { clearArray: true, data: [] };
                data[comp + '.results.' + row + '.deleted'] = { add: true, data: true };
                upData['data'] = data;
                _this.topic.setTempFromTopicPart('comments$' + _this.topic.tabs.short);
                var commentObj = {};
                commentObj = {
                    time: (new Date()).getTime(),
                    source: _this.topic.topic.owner,
                    comment: comp + ' search result ' + row + ' cleared'
                };
                _this.topic.temp.comments[_this.$state.current.name.replace('detail.', '')].push(commentObj);
                // sets the comment to be added into topic on server
                data['comments.' + _this.$state.current.name.replace('detail.', '')] = { push: true, data: [commentObj] };
                _this.topic.temp[comp].results[row].table = [];
                _this.topic.temp[comp].results[row].deleted = true;
                _this.topic.updateServerTopic('couchUpdate', upData, false);
            }
            return;
        });
    };
    MultiDcController.prototype.showCmrArrayList = function () {
        var toggleDecision = this.expand ? false : true;
        this.toggle(toggleDecision);
        var cmrString = this.item.searchCriteria[0].v || '';
        var items = {
            dialogName: cmrString.split(', ')
        };
        this.Dialog.updateValidForm(event, items, 'cmrArray-dialog.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
    };
    MultiDcController.$inject = ['$scope', 'socket', 'settings', 'topic', 'Dialog', '$state', '$timeout', 'env', '$http', 'notify'];
    return MultiDcController;
}());
var MultiDcComponent = (function () {
    function MultiDcComponent() {
        this.bindings = dcItemBindings;
        this.templateUrl = 'detail-table-dc-multi.html';
        this.controller = MultiDcController;
    }
    return MultiDcComponent;
}());
angular
    .module('application')
    .component('multiDcTable', new MultiDcComponent());



/**
 * @author Ivan Toth.
 */
var bfBind = { comp: '=', diff: '=', diffArray: '=' };
var DetailBrandFamilyController = (function () {
    function DetailBrandFamilyController(topic, settings, $scope, env, Dialog, notify) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.$scope = $scope;
        this.env = env;
        this.Dialog = Dialog;
        this.notify = notify;
        this.editableSolution = false;
        this.editableDuplicate = false;
        this.isSolutionUpdating = false;
        this.isDupeUpdating = false;
        this.completeSection = 'bfCheck';
        this.visible = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            _this.isSolutionUpdating = false;
            _this.isDupeUpdating = false;
            _this.topic.setTempFromTopic();
            var newGoe = (_this.topic.topic.goe && _this.topic.topic.goe.picked)
                ? _this.topic.topic.goe.picked : '';
            if (_this.usedGoe !== newGoe) {
                _this.usedGoe = newGoe;
                // this.setEligOptions();
                _this.setDuplicateCheckOptions();
            }
            _this.setEligOptions();
            // Need to disable the Solution ID editing if not in Elig...currently if status is
            // changed to Rejected/Marked... the editcomponents coming back from server may not be set
            if (_this.comp === 'gpp' && !_this.topic.isInEligibilityStatus()) {
                _this.topic.editableComponents.gpp = { editable: false, editMode: false, socket: 'Not Editable' };
            }
        });
    }
    DetailBrandFamilyController.prototype.$onInit = function () {
        if (this.comp === 'gpp') {
            this.topic.setTempFromTopic([this.comp], false);
        }
        this.usedGoe = (this.topic.topic.goe && this.topic.topic.goe.picked)
            ? this.topic.topic.goe.picked : '';
        this.setEligOptions();
        this.setDuplicateCheckOptions();
    };
    /**
     * Function for when someone edits a Brand Family's Solutions IDs
     * @param event
     * @param action
     * @param line
     */
    DetailBrandFamilyController.prototype.editSolution = function (event, action, line) {
        var _this = this;
        var ids = [];
        if (angular.isDefined(line.solutionId) && line.solutionId !== '') {
            ids = line.solutionId.split('\n');
        }
        var sols = [];
        angular.forEach(ids, function (solly) {
            sols.push({ o: solly, n: angular.copy(solly), d: false });
        });
        var items = {
            count: ids.length,
            ecount: ids.length,
            edit: sols,
            mysaSols: line.solutionId_mysa ? line.solutionId_mysa.split('\n') : [],
            solDec: this.topic.topic.solutionDecision,
            update: function (t, solly, index) {
                if (t === 'Add') {
                    this.edit.push({ o: '', n: '', d: false, x: true });
                    this.ecount++;
                }
                else if (t === 'Delete') {
                    if (solly.x) {
                        this.edit.splice(index, 1);
                    }
                    else {
                        solly.d = true;
                        solly.n = 'Marked for Deletion';
                    }
                    this.ecount--;
                }
                else {
                    if (solly.d) {
                        this.ecount++;
                        solly.d = false;
                    }
                    solly.n = solly.o;
                }
            }
        };
        this.Dialog.updateValidForm(event, items, 'detail-general-solution-update-dialog.html').then(function (dResult) {
            if (!angular.isUndefined(dResult)) {
                var changed = false; // Flag to indicate if there is actually a change
                var dupes = 0; // number of dupes in the list
                var newSolutions = []; // array of solutions
                var userSolutions = []; // array of original solutions altered or deleted
                var comments = '';
                // Loop through the solutions
                for (var _i = 0, _a = dResult.edit; _i < _a.length; _i++) {
                    var solution = _a[_i];
                    // If changed...
                    if (solution.o !== solution.n) {
                        changed = true;
                        // Build comments for history
                        if (comments.length > 0) {
                            comments += '; ';
                        }
                        if (solution.d) {
                            comments += "'" + solution.o + "' deleted";
                        }
                        else if (solution.x) {
                            comments += "'" + solution.n + "' added";
                        }
                        else {
                            comments += "'" + solution.o + "' changed to '" + solution.n + "'";
                        }
                        // If not deleted...
                        if (!solution.d) {
                            if (newSolutions.indexOf(solution.n) < 0) {
                                newSolutions.push(solution.n); // build new topic.temp value
                            }
                            else {
                                dupes++;
                            }
                            userSolutions.push(solution.o); // Add new or edited entry to user-edtied list
                        }
                        else {
                            userSolutions.push(solution.o); // Add deleted entry to user-edtied list
                        }
                    }
                    else {
                        if (newSolutions.indexOf(solution.o) < 0) {
                            newSolutions.push(solution.o); // build new topic.temp value
                        }
                    }
                }
                // No changes detected...
                if (!changed) {
                    _this.notify.error('No change detected');
                    return;
                }
                // If dupes...
                if (dupes > 0) {
                    _this.notify.error('There are one or more duplicate Solution IDs in the list');
                    return;
                }
                _this.editableSolution = false;
                _this.editableDuplicate = false;
                _this.isSolutionUpdating = true;
                // If we get here, there's been a change... build string of the new values
                if (_this.topic.updatePartialSocketStatus([_this.comp], 'Updating')) {
                    _this.updateUserUpdatedSolutions(line, newSolutions, userSolutions);
                    // Update the comments...
                    _this.topic.temp.comments.eligibility.push({
                        comment: line.row_id + " Solution ID(s) Updated - Details: " + comments + " - Justification: " + dResult.comments,
                        source: _this.env.user.email,
                        time: Date.now()
                    });
                    // Send for update
                    _this.topic.sendForUpdateGeneral([_this.comp, 'comments'], true);
                }
            }
        });
    };
    /**
     * Function if someone edits a Brand Family's Duplicate Opp No.
     * @param event
     * @param action
     * @param line
     */
    DetailBrandFamilyController.prototype.editDupeOpp = function (event, action, line) {
        var _this = this;
        var items = {
            oppyName: line.dup_check_num
        };
        this.Dialog.updateValidForm(event, items, 'detail-general-solution-update-don-dialog.html').then(function (dResult) {
            if (!angular.isUndefined(dResult)) {
                // No changes detected...
                if (line.dup_check_num === dResult.oppyName.toUpperCase()) {
                    _this.notify.error('No change detected');
                    return;
                }
                // Log entry
                var comments = "Changed from '" + (line.dup_check_num ? line.dup_check_num : 'No Value') + "' to '" + dResult.oppyName.toUpperCase() + "'";
                _this.editableSolution = false;
                _this.editableDuplicate = false;
                _this.isDupeUpdating = true;
                // If we get here, there's been a change... build string of the new values
                if (_this.topic.updatePartialSocketStatus([_this.comp], 'Updating')) {
                    _this.updateUserUpdatedDupe(line, dResult.oppyName.toUpperCase());
                    // Update the comments...
                    _this.topic.temp.comments.eligibility.push({
                        comment: line.row_id + " Duplicate Opportunity No. Updated - Details: " + comments,
                        source: _this.env.user.email,
                        time: Date.now()
                    });
                    // Send for update
                    _this.topic.sendForUpdateGeneral([_this.comp, 'comments'], true);
                }
            }
        });
    };
    DetailBrandFamilyController.prototype.getOrigSols = function (line) {
        return 'The following Solution IDs have been either added, edited or deleted by users:\n' +
            line.solutionId_user + '\n\nSee the Comments log for full details of the changes';
    };
    /**
     * Function to update the new list of solutions for a line, as well as record history for original
     * solutions (from mysa) that have been changed and should therefore not be overwritten when gpp
     * data is refreshed on doc open or via Refresh GPP/MySA
     * @param line
     * @param newSolutions
     * @param userSolutions
     */
    DetailBrandFamilyController.prototype.updateUserUpdatedSolutions = function (line, newSolutions, userSolutions) {
        // Update solution ids for the line in question
        var originalSolutions = [];
        for (var _i = 0, _a = this.topic.temp.gpp; _i < _a.length; _i++) {
            var gpp = _a[_i];
            // Find the line updated...
            if (gpp.row_id === line.row_id) {
                // And update it
                gpp.solutionId = newSolutions.join('\n');
                // Update the list of solutions manipulated by users
                if (angular.isDefined(gpp.solutionId_user)) {
                    originalSolutions = gpp.solutionId_user.split('\n');
                }
                // Loop through list of solutions mucked about with...
                for (var _b = 0, userSolutions_1 = userSolutions; _b < userSolutions_1.length; _b++) {
                    var sol = userSolutions_1[_b];
                    // If not already listed...
                    if (originalSolutions.indexOf(sol) < 0) {
                        originalSolutions.push(sol); // Add
                    }
                }
                gpp.solutionId_user = originalSolutions.join('\n');
                break;
            }
        }
    };
    DetailBrandFamilyController.prototype.updateUserUpdatedDupe = function (line, newOpp) {
        for (var _i = 0, _a = this.topic.temp.gpp; _i < _a.length; _i++) {
            var gpp = _a[_i];
            // Find the line updated...
            if (gpp.row_id === line.row_id) {
                // And update it
                gpp.dup_check_num = newOpp;
                break;
            }
        }
    };
    DetailBrandFamilyController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    /**
     * @param index Function if someone changes the Elig Decision of a Brand Family line, or Duplicate Opp Flag
     */
    DetailBrandFamilyController.prototype.updateGppEligstatus = function (index) {
        if (!this.topic.editableComponents[this.comp].socket) {
            if (this.topic.temp[this.comp][index].elig_decision !== this.topic.topic[this.comp][index].elig_decision ||
                this.topic.temp[this.comp][index].dup_check_flg !== this.topic.topic[this.comp][index].dup_check_flg) {
                if (this.topic.temp[this.comp][index].elig_decision !== this.topic.topic[this.comp][index].elig_decision) {
                    switch (this.topic.temp[this.comp][index].elig_decision) {
                        case 'BP ID':
                        case 'Eligible':
                            this.topic.temp[this.comp][index].dup_check_flg = 'No';
                            break;
                        case 'Solution only':
                            if (this.topic.topic.solutionDecision === 'Solution and SSA') {
                                this.topic.temp[this.comp][index].dup_check_flg = 'Yes';
                            }
                            else if (this.topic.topic.solutionDecision === 'Solution only') {
                                this.topic.temp[this.comp][index].dup_check_flg = 'No';
                            }
                            break;
                        case 'Not Eligible':
                        case 'IBM ID':
                            this.topic.temp[this.comp][index].dup_check_flg = 'Yes';
                            break;
                        default:
                            break;
                    }
                }
                if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                    this.topic.sendForUpdateGeneral([this.comp, 'comments'], true);
                }
            }
        }
    };
    DetailBrandFamilyController.prototype.setEligOptions = function () {
        this.eligOptions = [];
        if (!this.topic.topic.goe || !this.topic.topic.goe.picked
            || !this.topic.topic.states || !this.topic.topic.states.bpoi) {
            // do nothing
            return;
        }
        else if ((!this.topic.is2ndGOENeeded() && this.topic.topic.states.bpoi.geYes)
            || (this.topic.is2ndGOENeeded() && this.topic.topic.states.bpoi.geNo)) {
            this.eligOptions = this.settings.bpoiEligibilityOptions;
        }
        else {
            this.eligOptions = this.settings.eligibilityOptions;
        }
        // If Solution Decision exists, then Solution only needs to be an option in the eligdecisions
        if (this.topic.topic.solutionDecision) {
            // Ensure soluton only is in the list
            if (this.eligOptions.indexOf('Solution only') === -1) {
                this.eligOptions.splice(0, 0, 'Solution only'); // Add it
            }
        }
        else {
            // Ensure soluton only is not in the list
            if (this.eligOptions.indexOf('Solution only') > -1) {
                this.eligOptions.splice(this.eligOptions.indexOf('Solution only'), 1); // Lose it
            }
        }
    };
    DetailBrandFamilyController.prototype.setDuplicateCheckOptions = function () {
        this.duplicateOptions = ['Yes', 'No'];
        return;
    };
    DetailBrandFamilyController.$inject = ['topic', 'settings', '$scope', 'env', 'Dialog', 'notify'];
    return DetailBrandFamilyController;
}());
var DetailBrandFamilyComponent = (function () {
    function DetailBrandFamilyComponent() {
        this.bindings = bfBind;
        this.templateUrl = 'detail-family-brand.html';
        this.controller = DetailBrandFamilyController;
    }
    return DetailBrandFamilyComponent;
}());
angular
    .module('application')
    .component('detailBrandFamily', new DetailBrandFamilyComponent());



/**
 * @author Ivelin Ivanov
 */
var ciBind = { comp: '=', diff: '=', diffArray: '=' };
var DetailContactInfoController = (function () {
    function DetailContactInfoController(topic, settings) {
        this.topic = topic;
        this.settings = settings;
        this.visible = false;
    }
    ;
    DetailContactInfoController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailContactInfoController.$inject = ['topic', 'settings'];
    return DetailContactInfoController;
}());
DetailContactInfoController = DetailContactInfoController;
var DetailContactInfoComponent = (function () {
    function DetailContactInfoComponent() {
        this.bindings = ciBind;
        this.templateUrl = 'detail-contact-info.html';
        this.controller = DetailContactInfoController;
    }
    return DetailContactInfoComponent;
}());
DetailContactInfoComponent = DetailContactInfoComponent;
angular
    .module('application')
    .component('detailContactInfo', new DetailContactInfoComponent());



var DetailGeneralController = (function () {
    function DetailGeneralController(topic, $scope, socket, $state, $stateParams) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.OPP_VERSION_3 = 3;
        this.socket.forward('queue.general', this.$scope);
        this.id = $stateParams.id;
        this.activeTab = $state.current.name;
        this.$scope.$on('socket:queue.general', function (event, data) {
            _this.loadData(event, data);
        });
        this.getNewUIInfo = {
            uiVersion: _.get(this.topic.checksData, 'uiVersion', 1)
        };
    }
    DetailGeneralController.prototype.goTo = function (tab) {
        this.$state.go(tab.name, {
            id: this.id
        });
        this.activeTab = tab.name;
    };
    DetailGeneralController.prototype.loadData = function (ev, results) {
        this.tempData = results;
    };
    DetailGeneralController.prototype.edit = function () {
        console.log('detail.general.component:edit');
    };
    DetailGeneralController.$inject = ['topic', '$scope', 'socket', '$state', '$stateParams'];
    return DetailGeneralController;
}());
var DetailGeneralComponent = (function () {
    function DetailGeneralComponent() {
        this.templateUrl = 'detail-general.html';
        this.controllerAs = 'vm';
        this.controller = DetailGeneralController;
    }
    return DetailGeneralComponent;
}());
angular
    .module('application')
    .component('detailGeneral', new DetailGeneralComponent());



/**
 * @author Ivelin Ivanov.
 */
var DetailGppController = (function () {
    function DetailGppController(topic, settings, _) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this._ = _;
        this.comp = 'gppOnAssign';
        this.diffArray = [];
        this.paSiteVisibe = false;
        this.paSiteEditable = false;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        // If the gppOnAssign object is not there...
        if (!this.topic.topic[this.comp]) {
            this.comp = 'gpp_live'; // Set as gpp_live - ie: the latest data
        }
        var contactEmail = this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5 ?
            this.topic.topic.contactEmail :
            _.get(this.topic.checksData, 'inboundInitial.inbound.incentiveInformation.incentiveDetail.createdBy');
        var oppVersion = _.get(this.topic.checksData, 'uiVersion', 1);
        this.getNewUIInfo = {
            uiVersion: oppVersion,
            email: contactEmail,
            bpCountry: function () {
                var countryShort;
                countryShort = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.country');
                return _this.topic.getCountryFullName(countryShort);
            },
            accountCountry: function () {
                var countryShort;
                countryShort = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrCountryCode');
                return _this.topic.getCountryFullName(countryShort);
            },
            bpName: function () {
                var bpFirstName;
                var bpLastName;
                if (oppVersion && oppVersion <= _this.OPP_VERSION_4) {
                    bpFirstName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.bpFirstName');
                    bpLastName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.bpLastName');
                }
                else {
                    bpFirstName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.bpFirstName');
                    bpLastName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.bpLastName');
                }
                return bpFirstName + " " + bpLastName;
            },
            getSVISumbitDateName: function () {
                return _this.getNewUIInfo.uiVersion >= _this.OPP_VERSION_3
                    ? 'Submit Date:'
                    : 'Submit Date for CVR Eligibility:';
            },
            getAccountValue: function (accountName) {
                var generics = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.generics');
                var accountObj = generics.find(function (generic) { return generic.label === accountName; });
                return accountObj ? accountObj.value : '';
            }
        };
    }
    DetailGppController.prototype.changePaVisible = function () {
        this.paSiteVisibe = !this.paSiteVisibe;
    };
    DetailGppController.prototype.isV4OrLess = function () {
        var version = this.topic.topic.version;
        return !version || version <= this.OPP_VERSION_4;
    };
    DetailGppController.$inject = ['topic', 'settings', '_'];
    return DetailGppController;
}());
var DetailGppComponent = (function () {
    function DetailGppComponent() {
        this.templateUrl = 'detail-general-gpp.html';
        this.controllerAs = 'vm';
        this.controller = DetailGppController;
    }
    return DetailGppComponent;
}());
angular
    .module('application')
    .component('detailGpp', new DetailGppComponent());



/**
 * @author Ivelin Ivanov
 */
var oppRegBind = { comp: '=', diff: '=', diffArray: '=' };
var DetailOppRegController = (function () {
    function DetailOppRegController(topic, settings) {
        this.topic = topic;
        this.settings = settings;
        this.visible = false;
    }
    ;
    DetailOppRegController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailOppRegController.$inject = ['topic', 'settings'];
    return DetailOppRegController;
}());
var DetailOppRegComponent = (function () {
    function DetailOppRegComponent() {
        this.bindings = oppRegBind;
        this.templateUrl = 'detail-opp-registration.html';
        this.controller = DetailOppRegController;
    }
    return DetailOppRegComponent;
}());
angular
    .module('application')
    .component('detailOppReg', new DetailOppRegComponent());



/**
 * @author Ivelin Ivanov
 */
var stBind = { comp: '=', diff: '=', diffArray: '=' };
var DetailSalesTeamController = (function () {
    function DetailSalesTeamController(topic, settings, socket, env) {
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.env = env;
        this.visible = false;
    }
    ;
    DetailSalesTeamController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailSalesTeamController.prototype.displayOtherContatcs = function () {
        console.log('sending req for other contacts');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'showOtherContacts',
                script: '/detail/general/general',
                //data: this.topic.topic.gpp[0].opp,
                data: this.topic.getId(this.topic.topic._id),
                token: this.env.user.token,
                user: this.env.user.email,
                bID: this.topic.topicBrowserID
            }
        });
    };
    DetailSalesTeamController.$inject = ['topic', 'settings', 'socket', 'env'];
    return DetailSalesTeamController;
}());
var DetailSalesTeamComponent = (function () {
    function DetailSalesTeamComponent() {
        this.bindings = stBind;
        this.templateUrl = 'detail-sales-team.html';
        this.controller = DetailSalesTeamController;
    }
    return DetailSalesTeamComponent;
}());
angular
    .module('application')
    .component('detailSalesTeam', new DetailSalesTeamComponent());



/**
 * @author Ivelin Ivanov
 */
var sviBind = { comp: '=', diff: '=', diffArray: '=' };
var DetailSviController = (function () {
    function DetailSviController(topic, settings) {
        this.topic = topic;
        this.settings = settings;
        this.visible = false;
    }
    ;
    DetailSviController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailSviController.$inject = ['topic', 'settings'];
    return DetailSviController;
}());
var DetailSviComponent = (function () {
    function DetailSviComponent() {
        this.bindings = sviBind;
        this.templateUrl = 'detail-svi.html';
        this.controller = DetailSviController;
    }
    return DetailSviComponent;
}());
angular
    .module('application')
    .component('detailSvi', new DetailSviComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableComplClExceptionsController = (function () {
    function DetailTableComplClExceptionsController(topic, $scope, settings) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.settings = settings;
        this.tableName = 'Exceptions Checklist';
        this.displayRadioButton = true;
        this.lock = true;
        this.enableSection = true;
        this.comp = 'complcl_exceptions';
        this.updateArray = ['complcl_exceptions'];
        this.visible = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    ;
    DetailTableComplClExceptionsController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableComplClExceptionsController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailTableComplClExceptionsController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.sendForUpdateGeneral(this.updateArray, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableComplClExceptionsController.prototype.itemChanged = function (line) { };
    DetailTableComplClExceptionsController.$inject = ['topic', '$scope', 'settings'];
    return DetailTableComplClExceptionsController;
}());
var DetailTableComplClExceptionsComponent = (function () {
    function DetailTableComplClExceptionsComponent() {
        this.templateUrl = 'detail-table-complcl.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableComplClExceptionsController;
    }
    return DetailTableComplClExceptionsComponent;
}());
angular
    .module('application')
    .component('detailTableComplClExceptions', new DetailTableComplClExceptionsComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableComplClInvestmentReviewController = (function () {
    function DetailTableComplClInvestmentReviewController(topic, $scope, settings) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.settings = settings;
        this.tableName = 'Investment Review Checklist';
        this.displayRadioButton = true;
        this.lock = true;
        this.enableSection = true;
        this.comp = 'complcl_investment_review';
        this.updateArray = ['complcl_investment_review'];
        this.visible = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    ;
    DetailTableComplClInvestmentReviewController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableComplClInvestmentReviewController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailTableComplClInvestmentReviewController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.sendForUpdateGeneral(this.updateArray, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableComplClInvestmentReviewController.prototype.itemChanged = function (line) { };
    DetailTableComplClInvestmentReviewController.$inject = ['topic', '$scope', 'settings'];
    return DetailTableComplClInvestmentReviewController;
}());
var DetailTableComplClInvestmentReviewComponent = (function () {
    function DetailTableComplClInvestmentReviewComponent() {
        this.templateUrl = 'detail-table-complcl.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableComplClInvestmentReviewController;
    }
    return DetailTableComplClInvestmentReviewComponent;
}());
angular
    .module('application')
    .component('detailTableComplClInvestmentReview', new DetailTableComplClInvestmentReviewComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableComplClOpportunityDetailController = (function () {
    function DetailTableComplClOpportunityDetailController(topic, $scope, settings) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.settings = settings;
        this.tableName = 'Opportunity Detail Checklist';
        this.displayRadioButton = true;
        this.lock = true;
        this.enableSection = true;
        this.comp = 'complcl_opportunity_detail';
        this.updateArray = ['complcl_opportunity_detail'];
        this.visible = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    ;
    DetailTableComplClOpportunityDetailController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableComplClOpportunityDetailController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailTableComplClOpportunityDetailController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.sendForUpdateGeneral(this.updateArray, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableComplClOpportunityDetailController.prototype.itemChanged = function (line) { };
    DetailTableComplClOpportunityDetailController.$inject = ['topic', '$scope', 'settings'];
    return DetailTableComplClOpportunityDetailController;
}());
var DetailTableComplClOpportunityDetailComponent = (function () {
    function DetailTableComplClOpportunityDetailComponent() {
        this.templateUrl = 'detail-table-complcl.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableComplClOpportunityDetailController;
    }
    return DetailTableComplClOpportunityDetailComponent;
}());
angular
    .module('application')
    .component('detailTableComplClOpportunityDetail', new DetailTableComplClOpportunityDetailComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableComplClPaymentController = (function () {
    function DetailTableComplClPaymentController(topic, $scope) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.tableName = 'Payment Checklist';
        this.displayRadioButton = true;
        this.enableSection = true;
        this.lock = false;
        this.comp = 'complcl_payment';
        this.updateArray = ['complcl_payment'];
        this.visible = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    ;
    DetailTableComplClPaymentController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableComplClPaymentController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailTableComplClPaymentController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                console.log('send for update');
                this.topic.sendForUpdateGeneral(this.updateArray, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableComplClPaymentController.prototype.itemChanged = function (line) { };
    DetailTableComplClPaymentController.$inject = ['topic', '$scope'];
    return DetailTableComplClPaymentController;
}());
var DetailTableComplClPaymentComponent = (function () {
    function DetailTableComplClPaymentComponent() {
        this.templateUrl = 'detail-table-complcl.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableComplClPaymentController;
    }
    return DetailTableComplClPaymentComponent;
}());
angular
    .module('application')
    .component('detailTableComplClPayment', new DetailTableComplClPaymentComponent());



/**
 * @author Ivan Toth.
 */
var bindLogs = { vm: '=' };
var DetailTableLogController = (function () {
    function DetailTableLogController(topic, Dialog, settings, $scope, socket) {
        this.topic = topic;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$scope = $scope;
        this.socket = socket;
        return;
    }
    ;
    /**
     * Contains 2 switches and 1 show dialog section. 1st switch decides what should be the data and name of the dialog based on whichLogs
     * 2nd switch decides the column headers and what is the layout of the field values
     * @param event - in html I'm passing the $event.
     * @param whichLogs - string -  identifies which logs should be shown
     */
    DetailTableLogController.prototype.viewLogs = function (event, whichLogs) {
        console.log('In the logs service');
        var logsData;
        var dialogName;
        var tableType;
        var columnHeaders;
        var items;
        switch (whichLogs) {
            case 'status':
                logsData = this.topic.topic.status.history;
                dialogName = 'History Log';
                break;
            case 'gpp_valid':
                logsData = this.topic.topic.gpp_history;
                dialogName = 'Opportunity Validation Changes Log';
                break;
            case 'gpp':
                logsData = this.topic.topic.gpp_lastload_history;
                dialogName = 'Opportunity Summary Changes Log';
                break;
            case 'calculation':
                logsData = this.topic.topic.calculation_logs.log;
                dialogName = 'Calculation Changes Log';
                break;
            default:
                return alert('Unkown logs, please add it in the component: ' + whichLogs);
        }
        switch (whichLogs) {
            case 'status':
                tableType = 'status';
                columnHeaders = ['Date & Time', 'Event', 'User', 'Description', 'Cycle Owner'];
                break;
            case 'gpp_valid':
            case 'gpp':
                tableType = 'general';
                columnHeaders = ['Updates', 'Date & Time', 'Source', 'Comment'];
                break;
            case 'calculation':
                tableType = 'calc';
                columnHeaders = ['Date & Time', 'Source', 'Comment'];
                break;
            default:
                break;
        }
        items = {
            dialogName: dialogName, logsData: logsData, tableType: tableType, columnHeaders: columnHeaders,
            dateFormat: this.settings.up.preferences.dateFormat
        };
        this.Dialog.updateValidForm(event, items, 'detail-logs-popup.html').then(function (dResult) {
            return;
        });
    };
    DetailTableLogController.$inject = ['topic', 'Dialog', 'settings', '$scope', 'socket'];
    return DetailTableLogController;
}());
var DetailTableLogComponent = (function () {
    function DetailTableLogComponent() {
        this.bindings = bindLogs;
        this.templateUrl = 'detail-logs-general.html';
        this.controller = DetailTableLogController;
    }
    return DetailTableLogComponent;
}());
angular
    .module('application')
    .component('detailTableLog', new DetailTableLogComponent());



/**
 * Created by Kim J on 2018-01-31.
 */
var DetailPaymentGOEAddFieldsController = (function () {
    function DetailPaymentGOEAddFieldsController(topic, $scope, socket) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.comp = 'goe_add_fields';
        this.visibleGOEAddFields = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp) > -1) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
        this.goe_decl_letter_sent = ['Yes', 'No'];
    }
    DetailPaymentGOEAddFieldsController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailPaymentGOEAddFieldsController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                var updateObject = {
                    data: {
                        goe_add_fields: {
                            add: true,
                            data: this.topic.temp.goe_add_fields
                        }
                    },
                    id: this.topic.topic._id,
                    type: ['goe_add_fields']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailPaymentGOEAddFieldsController.prototype.toggleGOEAddFields = function () {
        this.visibleGOEAddFields = !this.visibleGOEAddFields;
    };
    DetailPaymentGOEAddFieldsController.$inject = ['topic', '$scope', 'socket', 'env'];
    return DetailPaymentGOEAddFieldsController;
}());
DetailPaymentGOEAddFieldsController = DetailPaymentGOEAddFieldsController;
var DetailPaymentGOEAddFieldsComponent = (function () {
    function DetailPaymentGOEAddFieldsComponent() {
        this.templateUrl = 'detail-payment-goe-addfields.html';
        this.controllerAs = 'vm';
        this.controller = DetailPaymentGOEAddFieldsController;
    }
    return DetailPaymentGOEAddFieldsComponent;
}());
angular
    .module('application')
    .component('detailPaymentGoeAddfields', new DetailPaymentGOEAddFieldsComponent());



/**
 * @author Ivan Toth.
 */
var DetailPaymentController = (function () {
    function DetailPaymentController(topic) {
        this.topic = topic;
        this.OPP_VERSION_3 = 3;
    }
    DetailPaymentController.$inject = ['topic'];
    return DetailPaymentController;
}());
var DetailPaymentComponent = (function () {
    function DetailPaymentComponent() {
        this.templateUrl = 'detail-payment.html';
        this.controllerAs = 'vm';
        this.controller = DetailPaymentController;
    }
    return DetailPaymentComponent;
}());
angular
    .module('application')
    .component('detailPayment', new DetailPaymentComponent());



/**
 * Created by Roman T on 9/5/2017.
 * Modified by Kim Janneck on 2017-11-15 for issue 882.
 */
var DetailPaymentDetailController = (function () {
    function DetailPaymentDetailController(topic, $scope, socket, env) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.env = env;
        this.comp = 'invoice_flags'; // Name of this component
        this.visibleDetail = false; // Close section
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // If the topic has been updated from the server...check if this component is part of 
            // what was changed
            if (data.indexOf(_this.comp) > -1) {
                // If so, set edit status accordingly...
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    DetailPaymentDetailController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp); // Set edit based on value in topic.editableComponents
    };
    /**
     * Default function for all components that use the 10k edit/save/cancel component
     * @param action
     */
    DetailPaymentDetailController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            // Set the status of this component to Updating...
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                // Prepare data to be saved
                var updateObject = {
                    data: {
                        invoice_flags: {
                            add: true,
                            data: this.topic.temp.invoice_flags
                        }
                    },
                    editOption: undefined,
                    id: this.topic.topic._id,
                    type: ['invoice_flags']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true); // Send it to be saved
                this.edit.editMode = this.topic.cancelEdit(this.comp); // Turn edit off
            }
        }
        else if (action === 'edit') {
            // Set temp values in topic for invoice_flags - and set edit mode to editable
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
            this.setDateFields();
            this.edit.editMode = true;
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp); // Set status uneditable
        }
    };
    /**
     * Function (alas) to convert the three date fields to Date objects for use with the md-datepicker
     */
    DetailPaymentDetailController.prototype.setDateFields = function () {
        var _this = this;
        var dates = ['requestedTimestamp', 'receivedTimestamp', 'invEFTDate', 'submittedTimestamp', 'paidDate'];
        angular.forEach(dates, function (dateField) {
            if (_this.topic.topic.invoice_flags[dateField]) {
                if (!_this.topic.temp.invoice_flags) {
                    _this.topic.temp.invoice_flags = {};
                }
                _this.topic.temp.invoice_flags[dateField] = new Date(_this.topic.topic.invoice_flags[dateField]);
            }
        });
    };
    /**
     * Function to toggle whether the section is open or closed
     */
    DetailPaymentDetailController.prototype.toggleDetail = function () {
        this.visibleDetail = !this.visibleDetail;
    };
    DetailPaymentDetailController.$inject = ['topic', '$scope', 'socket', 'env'];
    return DetailPaymentDetailController;
}());
var DetailPaymentDetailComponent = (function () {
    function DetailPaymentDetailComponent() {
        this.templateUrl = 'detail-payment-detail.html';
        this.controllerAs = 'vm';
        this.controller = DetailPaymentDetailController;
    }
    return DetailPaymentDetailComponent;
}());
angular
    .module('application')
    .component('detailPaymentDetail', new DetailPaymentDetailComponent());



/**
 * @author Ivan Toth.
 */
var DetailPaymentEditController = (function () {
    function DetailPaymentEditController(topic) {
        this.topic = topic;
        this.OPP_VERSION_3 = 3;
    }
    ;
    DetailPaymentEditController.$inject = ['topic'];
    return DetailPaymentEditController;
}());
var DetailPaymentEditComponent = (function () {
    function DetailPaymentEditComponent() {
        this.templateUrl = 'detail-payment.html';
        this.controllerAs = 'vm';
        this.controller = DetailPaymentEditController;
    }
    return DetailPaymentEditComponent;
}());
angular
    .module('application')
    .component('detailPaymentEdit', new DetailPaymentEditComponent());



/**
 * Created by Roman T on 9/11/2017.
 * Modified by Kim J on 2017-11-30 (card 785)
 */
var DetailPaymentEuCheckController = (function () {
    function DetailPaymentEuCheckController(topic, $scope, socket, env) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.env = env;
        this.comp = 'eu_check';
        this.visibleEu = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // if (data.indexOf(this.comp) > 1) {
            // Temp code, make it better
            // #1774, this code changes editable state of the component based on invoice/submitted flags values updates in topic
            // flags are updated in ation-menu-component.ts
            // for NA end user check logic is the same on this step as for other countries on invoice requested step (flag === 0)
            // this is because users can get to this step after batch process and they need possibility to update end user check
            if (!((_this.topic.topic.iot === 'North America IOT' && _this.topic.topic.invoice_flags && _this.topic.topic.invoice_flags.submitted === true) ||
                (_this.topic.topic.iot !== 'North America IOT' && _this.topic.topic.invoice_flags && _this.topic.topic.invoice_flags.requested === true))) {
                _this.topic.editableComponents.eu_check = { editable: true, editMode: false, socket: '' };
            }
            else {
                _this.topic.editableComponents.eu_check = { editable: false, editMode: false, socket: 'Not Editable' };
            }
            _this.edit = _this.topic.getEditComponent(_this.comp);
            //   }
        });
        this.eu_options = ['Yes', 'No'];
    }
    DetailPaymentEuCheckController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailPaymentEuCheckController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                var updateObject = {
                    data: {
                        eu_check: {
                            add: true,
                            data: this.topic.temp.eu_check
                        }
                    },
                    id: this.topic.topic._id,
                    type: ['eu_check']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailPaymentEuCheckController.prototype.toggleEu = function () {
        this.visibleEu = !this.visibleEu;
    };
    DetailPaymentEuCheckController.$inject = ['topic', '$scope', 'socket', 'env'];
    return DetailPaymentEuCheckController;
}());
var DetailPaymentEuCheckComponent = (function () {
    function DetailPaymentEuCheckComponent() {
        this.templateUrl = 'detail-eu-check.html';
        this.controllerAs = 'vm';
        this.controller = DetailPaymentEuCheckController;
    }
    return DetailPaymentEuCheckComponent;
}());
angular
    .module('application')
    .component('detailEuCheck', new DetailPaymentEuCheckComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableBpimsController = (function () {
    function DetailTableBpimsController(topic, $scope, socket, env, notify, Dialog, settings, config) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.env = env;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.config = config;
        this.show = {
            brand: false,
            main: true,
            summary: true,
            detail: true
        };
        this.showtree = true;
        this.comp = 'calculation';
        this.incentsPaid = {
            SSA: false,
            Solution: false
        };
        this.incentsCount = 0;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.incents = ['SSA', 'Solution'];
        this.getNewUIInfo = {
            uiVersion: _.get(this.topic.checksData, 'uiVersion', 1)
        };
        this.isProcessing = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp) > -1) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
            _this.isPaid();
        });
        this.socket.forward("topic.calculation.recalculate", this.$scope);
        this.$scope.$on("socket:topic.calculation.recalculate", function (event, data) {
            _this.topic.temp.calculation = data.calculation;
            _this.isProcessing = false;
            if (data.error) {
                _this.notify.error(data.error);
            }
            else {
                _this.notify.success("Recalculated successfully - Remember to Save your changes");
            }
            return;
        });
        this.socket.forward("topic.calculation.submit", this.$scope);
        this.$scope.$on("socket:topic.calculation.submit", function (event, data) {
            if (_this.topic.topicBrowserID !== data.bID) {
                return _this.notify.error('Browser ID changed. Please, reload.');
            }
            _this.isProcessing = false;
            if (data.error) {
                _this.notify.error(data.error);
                _this.topic.topic.calculation.complete = false;
            }
            else {
                _this.notify.success("Submitted successfully.");
                _this.topic.topic.calculation = data.calculation;
            }
            return;
        });
        this.socket.forward("topic.calculation.revert", this.$scope);
        this.$scope.$on("socket:topic.calculation.revert", function (event, data) {
            _this.isProcessing = false;
        });
    }
    DetailTableBpimsController.prototype.canClickButton = function () {
        this.canClick = false;
        // If user is bpso admin or system admin
        if (this.env.user.access.bpsoAdmin ||
            this.env.user.access.systemAdmin) {
            this.canClick = true; // Enable submit and refresh buttons
        }
    };
    DetailTableBpimsController.prototype.view = function (comp) {
        this.show[comp] = !this.show[comp];
    };
    DetailTableBpimsController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_4) {
            this.incents = this.incents.concat(['Focus', 'Growth', 'Ctl']);
            this.incentsPaid.Growth = true;
            this.incentsPaid.Focus = true;
            this.incentsPaid.Ctl = true;
        }
        else {
            this.incents = this.incents.concat(['NewClient']);
            this.incentsPaid.NewClient = true;
        }
        this.canClickButton(); // Set who can click the Submit and Refresh buttons
        this.isPaid();
    };
    DetailTableBpimsController.prototype.changeValue = function () {
        this.topic.temp.calculation.recalculated = false;
    };
    DetailTableBpimsController.prototype.changePayFrq = function () {
        if (this.topic.temp.calculation.payfrq.length > 1) {
            this.topic.temp.calculation.payfrq = this.topic.temp.calculation.payfrq.slice(0, 1);
        }
        this.topic.temp.calculation.recalculated = false;
        this.topic.temp.calculation.manualPayfrq = true;
    };
    DetailTableBpimsController.prototype.getPayementCurrency = function () {
        // should always be there if payment is done
        if (Array.isArray(this.topic.topic.calculation.children) && this.topic.topic.calculation.children.length) {
            return this.topic.topic.calculation.children[0].currency;
        }
        return;
    };
    /**
     * Disables bonus cap rule. Recalculation should be performed after that.
     * @author Pavel Suboch
     * @desc 20180626 - Card 1386 - Pavel Suboch - disable bonus cap rule
     */
    DetailTableBpimsController.prototype.disableBonusCapRule = function (event) {
        var _this = this;
        var items = {
            cancelMessage: 'Cancel',
            dialogName: 'Disable Bonus Cap Rule',
            message: 'Confirm cap disabling, Please.',
            okMessage: 'Save'
        };
        this.Dialog.YesNoForm(undefined, items, 'dialog-disable-cap.html').then(function (dResult) {
            if (dResult.confirm) {
                var bonusCapComments = {
                    time: new Date().getTime(),
                    source: _this.topic.topic.owner,
                    comment: dResult.comment
                };
                _this.addComment(bonusCapComments);
                _this.topic.temp.calculation.disableBonusCap = true;
                _this.topic.temp.calculation.applyBonusCap = false;
                _this.topic.temp.calculation.displayBonusCapButton = false;
            }
        });
    };
    /**
     * Sets comment into temp object to save later
     * @param comment - comment object
     */
    DetailTableBpimsController.prototype.addComment = function (comment) {
        if (!this.topic.temp.comments.payment) {
            this.topic.temp.comments.payment = [];
        }
        this.topic.temp.comments.payment.push(comment);
    };
    DetailTableBpimsController.prototype.showBonusCapButton = function () {
        return (this.topic.topic.calculation &&
            this.topic.topic.calculation.displayBonusCapButton &&
            (!this.topic.temp ||
                !this.topic.temp.calculation ||
                this.topic.temp.calculation.displayBonusCapButton ===
                    'undefined' ||
                this.topic.temp.calculation.displayBonusCapButton));
    };
    DetailTableBpimsController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            // if (!this.calcForm.$valid) {
            //     const items: any = {
            //         icon: 'ERROR',
            //         message: 'You cannot save the Calculations with error(s). &nbsp;Please correct them and click Refresh once done.',
            //         title: 'Saving Error',
            //     };
            //     this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then((dResult) => { return; });
            //     return;
            // }
            if (!this.topic.temp.calculation.recalculated) {
                var items = {
                    icon: 'ERROR',
                    message: 'You need to refresh after doing any changes. &nbsp;Click the Refresh button.',
                    title: 'Saving Error'
                };
                this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
                    return;
                });
                return;
            }
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                var updateObject = {
                    data: {
                        calculation: {
                            add: true,
                            data: this.topic.temp.calculation
                        }
                    },
                    editOption: undefined,
                    id: this.topic.topic._id,
                    type: ['calculation']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true);
                this.topic.temp.comments.payment = [];
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            if (!this.topic.topic.calculation.payfrq ||
                !(this.topic.topic.calculation.payfrq instanceof Array)) {
                this.topic.topic.calculation.payfrq = [];
            }
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableBpimsController.prototype.isDone = function () {
        return this.config.isOppCalculationCompleted(this.topic.topic.status.status_no, this.topic.topic.status.sub_status_no);
    };
    /**
     * Function to determine if the payment details are in and set....
     */
    DetailTableBpimsController.prototype.isPaid = function () {
        var _this = this;
        var sapResult = angular.isDefined(this.topic.topic.calculation) &&
            angular.isDefined(this.topic.topic.calculation.sapResult)
            ? this.topic.topic.calculation.sapResult
            : undefined;
        this.preApril2018 = false; // Reset
        this.incentsPaid = {
            SSA: false,
            Solution: false,
            NewClient: false,
            Growth: false,
            Focus: false,
            Ctl: false
        }; // Reset
        this.incentsCount = 0; // Reset
        this.incents =
            this.getNewUIInfo.uiVersion >= this.OPP_VERSION_4
                ? this.incents.concat(['Focus', 'Growth', 'Ctl'])
                : (this.incents = this.incents.concat(['NewClient']));
        // If defined and is an array with values or a string with a value
        if (angular.isDefined(sapResult) &&
            ((angular.isArray(sapResult) && sapResult.length > 0) ||
                (angular.isString(sapResult) && sapResult !== ''))) {
            if (this.config.isOppCalculationCompleted(this.topic.topic.status.status_no, this.topic.topic.status.sub_status_no)) {
                if (angular.isArray(sapResult)) {
                    for (var _i = 0, sapResult_1 = sapResult; _i < sapResult_1.length; _i++) {
                        var payment = sapResult_1[_i];
                        for (var _a = 0, _b = this.incents; _a < _b.length; _a++) {
                            var inc = _b[_a];
                            if (payment.hasOwnProperty(inc)) {
                                this.incentsPaid[inc] = true;
                                this.incentsCount++;
                            }
                        }
                    }
                }
                else {
                    // either Set Aside or could be a pre-april credit
                    if (sapResult === 'Set Aside') {
                        if (!angular.isDefined(this.topic.topic.calculation.totalOrderValues)) {
                            this.preApril2018 = true; // No totalOrderValues so old
                            this.incentsPaid.SSA = true;
                            this.incentsCount++;
                        }
                        else {
                            angular.forEach(this.topic.topic.calculation.totalOrderValues, function (v, k) {
                                for (var _i = 0, _a = _this.incents; _i < _a.length; _i++) {
                                    var inc = _a[_i];
                                    // If value is not 0 and matches incentive
                                    if (v !== 0 && k.indexOf(inc) > -1) {
                                        _this.incentsPaid[inc] = true;
                                        _this.incentsCount++;
                                    }
                                }
                            });
                        }
                    }
                    else {
                        // pre april credit
                        this.preApril2018 = true;
                        this.incentsPaid.SSA = true;
                        this.incentsCount++;
                    }
                }
            }
            if (this.topic.topic.calculation.totalSSABonus === 0) {
                this.incentsPaid.SSA = false;
            }
            if (this.topic.topic.calculation.totalSolutionBonus === 0) {
                this.incentsPaid.Solution = false;
            }
            if (this.topic.topic.calculation.totalNewClientBonus === 0) {
                this.incentsPaid.NewClient = false;
            }
            if (this.topic.topic.calculation.totalGrowthBonus === 0) {
                this.incentsPaid.Growth = false;
            }
            if (this.topic.topic.calculation.totalFocusBonus === 0) {
                this.incentsPaid.Focus = false;
            }
            if (this.topic.topic.calculation.totalFocusCtl === 0) {
                this.incentsPaid.Ctl = false;
            }
        }
    };
    DetailTableBpimsController.prototype.getCredit = function (arr, fields) {
        if (angular.isString(arr)) {
            // If a string it can only be Set Aside or a pre-April disbursement with 1 credit for ssa
            if (arr !== 'Set Aside') {
                return fields[0] === 'SSA' ? arr.replace(/'/g, '') : 'N/A';
            }
            return arr ? arr : 'N/A';
        }
        for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
            var entry = arr_1[_i];
            if (entry.hasOwnProperty(fields[0])) {
                return entry[fields[0]] ? entry[fields[0]] : 'N/A';
            }
        }
    };
    DetailTableBpimsController.prototype.getCreditDate = function (arr, fields) {
        if (angular.isString(arr)) {
            return (this.topic.topic.calculation.sapResultTime ||
                this.topic.topic.calculation.created);
        }
        else {
            var cvrDate_1;
            arr.forEach(function (item, index) {
                if (item.hasOwnProperty(fields[0])) {
                    cvrDate_1 = item.sapResultTime;
                }
            });
            return cvrDate_1;
        }
    };
    DetailTableBpimsController.prototype.reCalculate = function () {
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_3) {
            this.topic.temp.calculation.children[0].children[0].drpgId = this.topic.temp.calculation.children[0].children[0].id;
        }
        else {
            this.topic.temp.calculation.children[0].children[0].brandCode = this.topic.temp.calculation.children[0].children[0].id;
        }
        this.isProcessing = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    calculation: this.topic.temp.calculation,
                    docId: this.topic.topic._id
                },
                function: 'reCalculate',
                script: 'detail/payment/v1/payment',
                token: this.env.user.token
            }
        });
        return;
    };
    DetailTableBpimsController.prototype.submit = function () {
        var _this = this;
        if ([4, 6].indexOf(this.topic.topic.status.status_no) < 0) {
            var items_1 = {
                icon: 'ERROR',
                message: 'You can only Submit Calculations in either the Validation or Approved statuses.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items_1, 'confirm-prompt.html').then(function (dResult) {
                return;
            });
            return;
        }
        else {
            if (this.topic.topic.status.status_no === 4 &&
                !this.topic.topic.complete.statusComplete[4]) {
                var items_2 = {
                    icon: 'WARN',
                    message: 'One or more sections for this stage are still to be completed before you can Submit.' +
                        ' &nbsp;Please check for any red thumbs before attempting again.',
                    title: 'Submit'
                };
                this.Dialog.updateValidForm(undefined, items_2, 'confirm-prompt.html').then(function (dResult) {
                    return;
                });
                return;
            }
        }
        if (this.isProcessing) {
            return;
        }
        var msg = 'Payment you are about to submit will result in <strong>';
        if (this.topic.topic.dispute_details &&
            this.topic.topic.dispute_details.dispute_itrtype === 'D') {
            msg +=
                'Debit</strong> note. Are you sure you want to continue?<br><br>Please enter justification';
        }
        else {
            msg +=
                'Credit</strong> note. Are you sure you want to continue?<br><br>Please enter justification';
        }
        var items = {
            icon: 'QUESTION',
            message: msg,
            prompt: true,
            title: 'Submit Calculations'
        };
        this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                // Add justification to calc object
                _this.topic.topic.calculation.justification =
                    dResult.justification;
                _this.isProcessing = true;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: {
                            bID: _this.topic.topicBrowserID,
                            calc: _this.topic.topic.calculation,
                            docId: _this.topic.topic._id
                        },
                        function: 'submit',
                        script: 'detail/payment/v1/payment',
                        token: _this.env.user.token
                    }
                });
                _this.topic.topic.calculation.complete = true;
            }
        });
    };
    DetailTableBpimsController.prototype.removeCalcs = function () {
        var _this = this;
        var items = {
            icon: 'QUESTION',
            message: 'You are about to permanently delete the Calculations. &nbsp;Are you sure?',
            title: 'Remove Calculations'
        };
        this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.isProcessing = true;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: {
                            bID: _this.topic.topicBrowserID,
                            calc: _this.topic.topic.calculation,
                            docId: _this.topic.topic._id
                        },
                        function: 'removeCalcs',
                        script: 'detail/payment/v1/payment',
                        token: _this.env.user.token,
                        user: _this.env.user
                    }
                });
            }
        });
    };
    DetailTableBpimsController.prototype.revertStatus = function () {
        var _this = this;
        // Needs to be in Validation and any of the Set Aside subs
        if (this.topic.topic.status.status_no !== 4 ||
            [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(this.topic.topic.status.sub_status_no) < 0) {
            var items_3 = {
                icon: 'ERROR',
                message: 'Only Disbursements in a <b>Set Aside</b> status can be reverted back.',
                title: 'Error'
            };
            this.Dialog.updateValidForm(undefined, items_3, 'confirm-prompt.html').then(function (dResult) {
                return;
            });
            return;
        }
        if (this.isProcessing) {
            return;
        }
        var items = {
            icon: 'QUESTION',
            message: 'Use this function to revert back to a <b>Pending BPSO</b> status and edit the Calculations again.',
            title: 'Revert from Set Aside'
        };
        // If already approved, warn this will wipe the approvals
        if (this.topic.topic.status.approvals.complete) {
            items.message +=
                '<br><br><b style="color:red">NOTE:</b> &nbsp;Should you choose to continue, the' +
                    ' Approvals already granted will be wiped and the Disbursement will need to go through the Approval Process again.';
        }
        items.message += '<br><br>Are you sure?';
        this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.isProcessing = true;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: {
                            bID: _this.topic.topicBrowserID,
                            calc: _this.topic.topic.calculation,
                            docId: _this.topic.topic._id
                        },
                        function: 'revertStatus',
                        script: 'detail/payment/v1/payment',
                        token: _this.env.user.token,
                        user: _this.env.user
                    }
                });
            }
        });
    };
    DetailTableBpimsController.$inject = [
        'topic',
        '$scope',
        'socket',
        'env',
        'notify',
        'Dialog',
        'settings',
        'config',
    ];
    return DetailTableBpimsController;
}());
var DetailTableBpimsComponent = (function () {
    function DetailTableBpimsComponent() {
        this.templateUrl = 'detail-table-bpims.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableBpimsController;
    }
    return DetailTableBpimsComponent;
}());
angular
    .module('application')
    .component('detailTableBpims', new DetailTableBpimsComponent());



/**
 * @author Ivan Toth.
 */
var DetailTablePdController = (function () {
    function DetailTablePdController(topic) {
        this.topic = topic;
        this.visible = false;
    }
    ;
    DetailTablePdController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTablePdController.prototype.submitPaymentRequest = function () {
        alert('Loading PD not complete');
    };
    DetailTablePdController.$inject = ['topic'];
    return DetailTablePdController;
}());
var DetailTablePdComponent = (function () {
    function DetailTablePdComponent() {
        this.templateUrl = 'detail-table-pd.html';
        this.controllerAs = 'vm';
        this.controller = DetailTablePdController;
    }
    return DetailTablePdComponent;
}());
angular
    .module('application')
    .component('detailTablePd', new DetailTablePdComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableComplClCalculationController = (function () {
    function DetailTableComplClCalculationController(topic, $scope) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.tableName = 'Calculations Checklist';
        this.displayRadioButton = true;
        this.enableSection = true;
        this.lock = false;
        this.showThumb = true; //will show on section header
        this.comp = 'complcl_calculation';
        this.updateArray = ['complcl_calculation'];
        this.visible = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    ;
    DetailTableComplClCalculationController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableComplClCalculationController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailTableComplClCalculationController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.sendForUpdateGeneral(this.updateArray, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableComplClCalculationController.prototype.itemChanged = function (line) { };
    DetailTableComplClCalculationController.$inject = ['topic', '$scope'];
    return DetailTableComplClCalculationController;
}());
var DetailTableComplClCalculationComponent = (function () {
    function DetailTableComplClCalculationComponent() {
        this.templateUrl = 'detail-table-complcl.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableComplClCalculationController;
    }
    return DetailTableComplClCalculationComponent;
}());
angular
    .module('application')
    .component('detailTableComplClCalculation', new DetailTableComplClCalculationComponent());



var PaymentGateComponent = (function () {
    function PaymentGateComponent() {
        this.templateUrl = 'payment-gate.html';
        this.controllerAs = 'vm';
        this.controller = PaymentGateController;
    }
    return PaymentGateComponent;
}());



var PaymentGateController = (function () {
    function PaymentGateController(topic, $state) {
        this.topic = topic;
        this.$state = $state;
        this.CALC_VERSION_2 = 2;
        this.CALC_VERSION_1 = 1;
        this.calculationVersion = topic.topic.calculationVersion || this.CALC_VERSION_1;
    }
    PaymentGateController.$inject = [
        'topic',
        '$state'
    ];
    return PaymentGateController;
}());
angular
    .module('application')
    .component('paymentGate', new PaymentGateComponent());



/**
 * Created by user on 12/13/2016.
 */
var incentive = { incentive: '=' };
var DetailSamplingActivateController = (function () {
    function DetailSamplingActivateController(topic, env, socket, $scope, Dialog, notify, $window) {
        var _this = this;
        this.topic = topic;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.notify = notify;
        this.$window = $window;
        this.updateArray = ['sampling', 'complcl_sampling_' + this.incentive];
        this.sampReason = '';
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.documentationStatusValues = [];
        this.ssaDocumentationStatus = '';
        this.engagementDocumentationStatus = '';
        this.events = { active: false, complete: false, overridden: false, updating: false };
        this.sampReasonOther = '';
        this.checkListArr = {};
        //this.isCLLoaded = false;
        this.reasonList = [
            'Opportunity requires Standard Exception',
            'Sampling requested by SME',
            'BP on high-risk potential list',
            'Influenced opportunity',
            'BPs 1st additional selection after failure',
            'BPs 2nd additional selection after failure',
            'Government sale',
            'Base sampling',
            'Other'
        ];
        this.documentationStatusValues = ['Not Provided', 'Need More Evidence', 'Submitted', 'Reviewed'];
        this.incentiveList = [
            'SSA',
            'Solution',
        ];
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // If the topic is updated, change event props accordingly
            _this.checkEvents();
        });
        // Listener for the an Activation or Deactivation is fired and returned from the server
        this.socket.forward('addsampling.done', this.$scope);
        this.$scope.$on('socket:addsampling.done', function (event, data) {
            _this.events.updating = false; // Done updating
            _this.checkEvents();
            _this.incentiveStatus = data.data[_this.incentive] || data.data;
            // If an error...spew it
            if (data.error) {
                _this.notify.error(data.error);
            }
            _this.$window.location.reload();
        });
    }
    /**
     * Function to determine various property values based on what's going on
     */
    DetailSamplingActivateController.prototype.checkEvents = function () {
        if (this.topic.isSamplingStarted(this.incentive)) {
            this.events.active = true;
        }
        else {
            this.events.active = false;
        }
        if (this.topic.isSamplingComplete(this.incentive)) {
            this.events.complete = true;
            if (this.incentiveStatus.samplingStatus === 'Manual override') {
                this.events.overridden = true;
                this.events.active = false;
            }
        }
        else {
            this.events.complete = false;
        }
    };
    DetailSamplingActivateController.prototype.$onInit = function () {
        this.incentiveStatus = this.topic.topic.sampling[this.incentive] || this.topic.topic.sampling;
        this.checkEvents();
        this.ssaDocumentationStatus = _.get(this, 'topic.topic.sampling.SSA.documentationStatus') || 'Not Provided';
        this.engagementDocumentationStatus = _.get(this, 'topic.topic.sampling.Solution.documentationStatus') || 'Not Provided';
    };
    DetailSamplingActivateController.prototype.sampButton = function (what, status) {
        var _this = this;
        var v4OrLater = this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_4;
        var items = {
            action: what, reasons: this.reasonList,
            incentives: this.incentiveList,
            incentiveStatus: this.incentiveStatus,
            incentive: this.incentive,
            v4OrLater: v4OrLater,
            ssaDocumentationStatus: this.ssaDocumentationStatus,
            engagementDocumentationStatus: this.engagementDocumentationStatus,
            documentationStatusValues: this.documentationStatusValues,
            uiVersion: this.topic.topic.version,
            oppVersions: {
                five: this.OPP_VERSION_5
            }
        };
        this.Dialog.updateValidForm(undefined, items, 'sampling-dialog.html').then(function (dResult) {
            if (dResult.confirm) {
                // Create a package according to Activate or Deactivate
                var sampPackage = {};
                sampPackage.status = status; // new Sampling status
                sampPackage.action = what; // Activiate or Deactivate
                sampPackage.incentiveStatus = _this.incentive; // Activiate or Deactivate
                if (what === 'Activate') {
                    var reason = dResult.sampReason;
                    var incentiveReason = dResult.incentiveComment;
                    var incentiveType = angular.isUndefined(_this.incentive) ? _this.incentiveList.filter(function (el) { return dResult.incentiveType[el] === true; }) : [_this.incentive];
                    if (dResult.sampReason === 'Other') {
                        reason += ' - ' + dResult.sampReasonOther;
                    }
                    sampPackage.reason = reason;
                    sampPackage.incentiveType = incentiveType;
                    sampPackage.incentiveReason = incentiveReason;
                    sampPackage.ssaDocumentationStatus = dResult.ssaDocumentationStatus;
                    sampPackage.engagementDocumentationStatus = dResult.engagementDocumentationStatus;
                }
                else {
                    sampPackage.reason = dResult.comment;
                }
                // Creat object to send to server
                var data = {
                    opp: _this.topic.getId(_this.topic.topic._id),
                    iot: _this.topic.topic.gpp[0].iot || _this.topic.topic.iot,
                    program: _this.topic.topic.program,
                    sampPack: sampPackage
                };
                // Set flag to indicating server call...block buttons and show spinner etc
                _this.events.updating = true;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'updateSampling',
                        script: '/detail/sampling/sampling',
                        data: data,
                        user: _this.env.user,
                        bID: _this.topic.topicBrowserID //Need this to be able to utilise the update.partial socket
                    }
                });
            }
        });
    };
    DetailSamplingActivateController.$inject = ['topic', 'env', 'socket', '$scope', 'Dialog', 'notify', '$window'];
    return DetailSamplingActivateController;
}());
var DetailSamplingActivateComponent = (function () {
    function DetailSamplingActivateComponent() {
        this.templateUrl = 'detail-sampling-activate.html';
        this.controllerAs = 'vm';
        this.bindings = incentive;
        this.controller = DetailSamplingActivateController;
    }
    return DetailSamplingActivateComponent;
}());
angular
    .module('application')
    .component('detailSamplingActivateComponent', new DetailSamplingActivateComponent());



/**
 * @author Ilya Aderiho.
 */
var DetailSamplingController = (function () {
    function DetailSamplingController(topic, env, socket, $scope, notify, $window) {
        var _this = this;
        this.topic = topic;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.notify = notify;
        this.$window = $window;
        this.incentive = ['SSA', 'Solution'];
        this.selectedInc = 'SSA';
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.isDocumentationStatusUpdating = false;
        this.documentationStatusValues = ['Not Provided', 'Need More Evidence', 'Submitted', 'Reviewed'];
        this.selectedInc = 'SSA';
        this.uiVersion = this.topic.checksData.uiVersion;
        if (this.topic.checksData.inbound && this.topic.checksData.inbound.incentive) {
            // on initialize emit  to the detail/
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getSpecialBidUpdatesPRM',
                    script: '/detail/sampling/sampling',
                    user: this.env.user,
                    data: {
                        incentive: this.topic.checksData.inbound.incentive,
                        groupIds: Object.keys(this.topic.compareGpp.gpp)
                    }
                }
            });
            this.socket.forward('fetch.detail_sampling', this.$scope);
            this.$scope.$on('socket:fetch.detail_sampling', function (event, data) {
                // collect the update history from caseId
                _this.caseIdPRMs = data.collectCaseIdPRM;
            });
        }
        this.socket.forward('update.documentation.status', this.$scope);
        this.$scope.$on('socket:update.documentation.status', function (event, data) {
            _this.isDocumentationStatusUpdating = false;
            if (data.success) {
                _this.notify.success('Documentation Status updated successfully');
            }
            else {
                _this.notify.error(data.error);
            }
            _this.$window.location.reload();
        });
    }
    DetailSamplingController.prototype.switchTable = function (inc) {
        this.selectedInc = inc;
    };
    DetailSamplingController.prototype.$onInit = function () {
        this.selectedInc = 'SSA';
        // this.isDocumentationStatusChanged = false;
        // this.commonDocumentationStatus = this.topic.topic.sampling.documentationStatus || 'Not Provided';
        // this.initialCommonDocumentationStatus = this.documentationStatus;
        this.engagementDocumentationStatusOnLoad = _.get(this, 'topic.topic.sampling.Solution.documentationStatus') || 'Not Provided';
        this.salesDocumentationStatusOnLoad = _.get(this, 'topic.topic.sampling.SSA.documentationStatus') || 'Not Provided';
        this.engagementDocumentationStatus = this.engagementDocumentationStatusOnLoad;
        this.salesDocumentationStatus = this.salesDocumentationStatusOnLoad;
    };
    DetailSamplingController.prototype.getInc = function () {
        return this.selectedInc;
    };
    DetailSamplingController.prototype.isIncEmpty = function () {
        return (!this.topic.topic.sampling.Solution && !this.topic.topic.sampling.SSA) ||
            ((this.topic.topic.sampling.Solution && this.topic.topic.sampling.Solution.samplingStatus === 'untested') &&
                (this.topic.topic.sampling.SSA && this.topic.topic.sampling.SSA.samplingStatus === 'untested'));
    };
    DetailSamplingController.prototype.saveEngagementDocumentationStatus = function () {
        this.updateDocumentationStatus('Solution', this.engagementDocumentationStatus);
    };
    DetailSamplingController.prototype.saveSalesDocumentationStatus = function () {
        this.updateDocumentationStatus('SSA', this.salesDocumentationStatus);
    };
    DetailSamplingController.prototype.changeCurrentEngagementDocumentationStatus = function () {
        this.isEngagementDocumentationStatusChanged = (this.engagementDocumentationStatusOnLoad !== this.engagementDocumentationStatus);
    };
    DetailSamplingController.prototype.changeCurrentSalesDocumentationStatus = function () {
        this.isSalesDocumentationStatusChanged = (this.salesDocumentationStatusOnLoad !== this.salesDocumentationStatus);
    };
    DetailSamplingController.prototype.isSamplingActive = function (incentive) {
        return _.get(this, "topic.topic.sampling." + incentive + ".samplingStatus") === 'Manually sampled - In Progress';
    };
    DetailSamplingController.prototype.updateDocumentationStatus = function (incentiveType, value) {
        this.isDocumentationStatusUpdating = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateDocumentationStatus',
                script: '/detail/sampling/sampling',
                data: {
                    incentiveType: incentiveType,
                    value: value,
                    opportunityId: this.topic.topic._id
                },
                user: this.env.user,
                bID: this.topic.topicBrowserID //Need this to be able to utilise the update.partial socket
            }
        });
    };
    DetailSamplingController.$inject = ['topic', 'env', 'socket', '$scope', 'notify', '$window'];
    return DetailSamplingController;
}());
var DetailSamplingComponent = (function () {
    function DetailSamplingComponent() {
        this.templateUrl = 'detail-sampling.html';
        this.controllerAs = 'vm';
        this.controller = DetailSamplingController;
    }
    return DetailSamplingComponent;
}());
angular
    .module('application')
    .component('detailSampling', new DetailSamplingComponent());



/**
 * @author Ivan Toth.
 */
var DetailSamplingEditController = (function () {
    function DetailSamplingEditController(topic, env) {
        this.topic = topic;
        this.env = env;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.uiVersion = this.topic.checksData.uiVersion;
    }
    ;
    DetailSamplingEditController.prototype.addComment = function () {
        //Here to add the comment into the server
        this.topic.clearTempComments();
        alert('Adding a comment');
    };
    DetailSamplingEditController.$inject = ['topic', 'env'];
    return DetailSamplingEditController;
}());
var DetailSamplingEditComponent = (function () {
    function DetailSamplingEditComponent() {
        this.templateUrl = 'detail-sampling.html';
        this.controllerAs = 'vm';
        this.controller = DetailSamplingEditController;
    }
    return DetailSamplingEditComponent;
}());
angular
    .module('application')
    .component('detailSamplingEdit', new DetailSamplingEditComponent());



/**
 * @author Ivan Toth.
 */
var DetailSamplingFileUploadController = (function () {
    function DetailSamplingFileUploadController($state, $scope, socket, topic, env, settings) {
        this.$state = $state;
        this.$scope = $scope;
        this.socket = socket;
        this.topic = topic;
        this.env = env;
        this.settings = settings;
        this.lockEnabled = true;
        this.section = 'sampling';
        this.comp = 'files$sampling';
        this.updateArray = ['files$sampling'];
        this.showAttachment = false;
        this.submitting = true;
        this.sources = {};
        this.fileUploaded = false;
    }
    DetailSamplingFileUploadController.prototype.showHide = function () {
        this.showAttachment = this.showAttachment ? false : true;
    };
    // Prepares the files for file upload
    DetailSamplingFileUploadController.prototype.uploadFiles = function (files) {
        if (this.files !== undefined) {
            console.info('not undefined');
        }
        this.fileNames = [];
        var fileContent = files;
        // If some files submitted perform the update
        if (fileContent.length > 0) {
            var i = 0;
            for (var _i = 0, fileContent_1 = fileContent; _i < fileContent_1.length; _i++) {
                var file = fileContent_1[_i];
                this.fileNames[i] = { name: file.name, type: file.type, comment: '' };
                i++;
            }
            this.fileUploaded = true;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'uploadFile',
                    script: 'config/config',
                    data: { files: this.fileNames, id: this.topic.topic._id, type: this.section },
                    files: this.sources,
                    bID: this.topic.topicBrowserID,
                    token: this.env.user.token,
                    email: this.env.user.email
                }
            });
        }
        this.edit.editMode = this.topic.cancelEdit(this.comp);
        //files = [];
        //return files;
    };
    DetailSamplingFileUploadController.prototype.downloadAttachment = function (name) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'downloadAttachment',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.topic._id,
                    name: name
                },
                email: this.env.user.email
            }
        });
    };
    DetailSamplingFileUploadController.prototype.showUserData = function (file, visible) {
        file.visible = visible;
    };
    DetailSamplingFileUploadController.prototype.submit = function () {
        alert('submitted');
    };
    DetailSamplingFileUploadController.prototype.setSource = function () {
        alert('source set');
    };
    DetailSamplingFileUploadController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailSamplingFileUploadController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.sendForUpdateFiles(this.comp, false);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPartFiles(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailSamplingFileUploadController.prototype.commentChange = function (fileName) {
        angular.forEach(this.topic.temp.files, function (file) {
            if (file.name === fileName) {
                file.modified = true;
            }
        });
    };
    DetailSamplingFileUploadController.$inject = ['$state', '$scope', 'socket', 'topic', 'env', 'settings'];
    return DetailSamplingFileUploadController;
}());
var DetailSamplingFileUploadComponent = (function () {
    function DetailSamplingFileUploadComponent() {
        this.templateUrl = 'detail-file-upload.html';
        this.controllerAs = 'vm';
        this.controller = DetailSamplingFileUploadController;
    }
    return DetailSamplingFileUploadComponent;
}());
angular
    .module('application')
    .component('detailSamplingUpload', new DetailSamplingFileUploadComponent());



/**
 * Created by Kim J on 2018-01-17.
 */
var DetailSamplingNotifController = (function () {
    function DetailSamplingNotifController(topic, $scope, socket, edit, $attrs) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.edit = edit;
        this.$attrs = $attrs;
        this.comp = 'sampling_notification';
        this.visibleNotifications = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp) > -1) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    DetailSamplingNotifController.prototype.$onInit = function () {
        if (this.$attrs.section) {
            this.comp = this.$attrs.section;
        }
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailSamplingNotifController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                var updateObject = {
                    data: {},
                    id: this.topic.topic._id,
                    type: [this.comp]
                };
                updateObject.data[this.comp] = {
                    add: true,
                    data: this.topic.temp[this.comp]
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
            this.setDateFields();
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    /**
     * Function to convert the three date fields to Date objects for use with the md-datepicker
     */
    DetailSamplingNotifController.prototype.setDateFields = function () {
        var _this = this;
        var dates = ['notification_date', 'first_reminder_date', 'second_reminder_date'];
        angular.forEach(dates, function (dateField) {
            if (_this.topic.topic[_this.comp][dateField]) {
                if (!_this.topic.temp[_this.comp]) {
                    _this.topic.temp[_this.comp] = {};
                }
                _this.topic.temp[_this.comp] = new Date(_this.topic.topic[_this.comp]);
            }
        });
    };
    DetailSamplingNotifController.prototype.toggleNotifications = function () {
        this.visibleNotifications = !this.visibleNotifications;
    };
    DetailSamplingNotifController.$inject = ['topic', '$scope', 'socket', 'env', '$attrs'];
    return DetailSamplingNotifController;
}());
var DetailSamplingNotifComponent = (function () {
    function DetailSamplingNotifComponent() {
        this.templateUrl = 'detail-sampling-notification.html';
        this.controllerAs = 'vm';
        this.controller = DetailSamplingNotifController;
    }
    return DetailSamplingNotifComponent;
}());
angular
    .module('application')
    .component('detailSamplingNotification', new DetailSamplingNotifComponent());



/**
 * @author Ivan Toth.
 */
var incentive = { incentive: '=' };
var DetailTableComplClSamplingController = (function () {
    function DetailTableComplClSamplingController(topic, env, Dialog, $scope, socket) {
        var _this = this;
        this.topic = topic;
        this.env = env;
        this.Dialog = Dialog;
        this.$scope = $scope;
        this.socket = socket;
        this.tableName = 'Sampling Checklist';
        this.isSamplingFinished = false;
        this.displayRadioButton = true;
        this.lock = false;
        this.isSamplingValid = true;
        this.visible = true;
        // Listener for any 10k updates
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // If the topic has been updated from the server...check if this component is part of 
            // what was changed
            _this.setSamplingCompl();
            if (data.indexOf(_this.comp) > -1) {
                // If so, set edit status accordingly...
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    ;
    DetailTableComplClSamplingController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableComplClSamplingController.prototype.setSamplingCompl = function () {
        this.samplingCompl = !(angular.isUndefined(this.incentive)) ? 'complcl_sampling_' + this.incentive : 'complcl_sampling';
        this.comp = this.samplingCompl;
        this.updateArray = [this.samplingCompl, 'sampling'];
    };
    DetailTableComplClSamplingController.prototype.$onInit = function () {
        this.setSamplingCompl();
        // Check whether should be editable or not
        this.edit = this.topic.getEditComponent(this.comp);
    };
    /**
     * Note: event here may or may not be parsed....only for use with Failed and Passed buttons
     *
     * @param {string} action
     * @param {ng.IAngularEvent} event
     * @memberof DetailTableComplClSamplingController
     */
    DetailTableComplClSamplingController.prototype.changeEditMode = function (action, event) {
        var _this = this;
        if (action === 'save') {
            // Set the status of this component to Updating...
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                // Prepare data to be saved
                var updateObject = {
                    data: {},
                    id: this.topic.topic._id,
                    type: [this.samplingCompl]
                };
                updateObject.data[this.samplingCompl] = {
                    add: true,
                    data: this.topic.temp[this.samplingCompl]
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true); // Send it to be saved
                this.edit.editMode = this.topic.cancelEdit(this.comp); // Turn edit off
            }
        }
        else if (action === 'edit') {
            this.refreshSamplingValidity();
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp); //added back to reset the updated fields
        }
        else if (action === 'Passed' || action === 'Failed') {
            //Prepare to ask question...based on event
            var items = {
                icon: 'QUESTION',
                message: 'Should you choose to continue, the results will become locked and uneditable. &nbsp;Continue?',
                title: action
            };
            //Warn
            this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                if (dResult.confirm) {
                    // Create similar package to one from activate... this time contains the action will be Fail/Pass
                    // need to update 'sampling' only but ensure this component is updated, too to put out of edit mode...and lock
                    // Create a package according to Activate or Deactivate
                    var sampPackage = {};
                    sampPackage.action = action; // Failed or Passed 
                    var currentStatus = _this.topic.topic.sampling[_this.incentive] ?
                        _this.topic.topic.sampling[_this.incentive].samplingStatus : _this.topic.topic.sampling.samplingStatus;
                    sampPackage.incentiveType = [_this.incentive];
                    switch (currentStatus) {
                        case 'In Progress':
                        case 'Pending BP Compliance Review':
                            sampPackage.status = action;
                            break;
                        case 'Manually sampled - In Progress':
                            sampPackage.status = 'Manually sampled - ' + action;
                            break;
                        default: break;
                    }
                    sampPackage.incentiveStatus = _this.incentive;
                    // Creat object to send to server
                    var data = {
                        opp: _this.topic.getId(_this.topic.topic._id),
                        sampPack: sampPackage
                    };
                    // Set the checklist status to updating...
                    if (_this.topic.updatePartialSocketStatus([_this.comp], 'Updating')) {
                        // But call the sampling update instead of the 10k... this will do both
                        _this.socket.emit('module', {
                            module: {
                                application: 'dmt',
                                function: 'updateSampling',
                                //script: '/queue/queue',
                                script: '/detail/sampling/sampling',
                                data: data,
                                user: _this.env.user,
                                //email: this.env.user.email,
                                bID: _this.topic.topicBrowserID //Need this to be able to utilise the update.partial socket
                            }
                        });
                        _this.edit.editMode = _this.topic.cancelEdit(_this.comp);
                        _this.edit.editable = false;
                    }
                }
            });
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableComplClSamplingController.prototype.refreshSamplingValidity = function () {
        var tt = 'temp';
        if (angular.isUndefined(this.topic.temp[this.samplingCompl])) {
            tt = 'topic';
        }
        this.missingSampCLQs = ''; //wipe
        this.isSamplingValid = true; //Assume all good
        for (var i = 0; i < this.topic[tt][this.samplingCompl].check_list.length; i++) {
            if (this.topic[tt][this.samplingCompl].check_list[i].answer === '' && typeof this.topic[tt][this.samplingCompl].check_list[i].head === 'undefined') {
                if (this.missingSampCLQs.length > 0) {
                    this.missingSampCLQs += ', ';
                }
                this.missingSampCLQs += (i + 1);
                this.isSamplingValid = false;
            }
        }
        if (this.missingSampCLQs.length > 0) {
            this.missingSampCLQs = 'Sampling completion not possible until the following questions are answered: ' + this.missingSampCLQs;
        }
    };
    DetailTableComplClSamplingController.prototype.itemChanged = function (line) {
        var tempValCheck = true;
        for (var i = 0; i < this.topic.temp[this.samplingCompl].check_list.length; i++) {
            if (this.topic.temp[this.samplingCompl].check_list[i].answer === '' && typeof this.topic.temp[this.samplingCompl].check_list[i].head === 'undefined') {
                tempValCheck = false;
            }
        }
        this.isSamplingValid = tempValCheck;
    };
    DetailTableComplClSamplingController.$inject = ['topic', 'env', 'Dialog', '$scope', 'socket'];
    return DetailTableComplClSamplingController;
}());
var DetailTableComplClSamplingComponent = (function () {
    function DetailTableComplClSamplingComponent() {
        this.templateUrl = 'detail-table-complcl.html';
        this.controllerAs = 'vm';
        this.bindings = incentive;
        this.controller = DetailTableComplClSamplingController;
    }
    return DetailTableComplClSamplingComponent;
}());
angular
    .module('application')
    .component('detailTableComplClSampling', new DetailTableComplClSamplingComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableSampQController = (function () {
    function DetailTableSampQController(topic, env, $scope, $attrs) {
        var _this = this;
        this.topic = topic;
        this.env = env;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.comp = 'sampling_q';
        this.showButtons = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // If the topic is updated, check if Sampling will be needed
            _this.incentiveStatus = _this.topic.topic.sampling[_this.incentive] || _this.topic.topic.sampling;
            _this.setSamplingMessage();
        });
    }
    /**
     * Function to determine if Sampling should be forced
     */
    DetailTableSampQController.prototype.setSamplingMessage = function () {
        // If validation and pre-calcs and...
        // 1 - CVR Sales Assist (nonGE), sampling needed
        // 2 - If Sampling started, regardless
        this.sampReqMess = undefined; // wipe it
        // If in Validation pre-calcs
        if (this.topic.topic.status.status_no === 4 && !this.topic.areCalcsStarted()) {
            // If Base sampling needed...or it's been started but not finished
            if (this.topic.isBaseSampling() && this.topic.isSamplingStarted() && !this.topic.isSamplingComplete(this.incentive)) {
                this.sampReqMess = 'This Disbursement has been flagged for Base Sampling and must be completed (or manually overridden) before Calculations can be triggered';
            }
            else if (this.topic.isSamplingStarted() && !this.topic.isSamplingComplete(this.incentive)) {
                this.sampReqMess = 'This Disbursement must have Sampling completed (or manually overridden) before Calculations can be triggered';
            }
        }
        else if (this.topic.topic.status.status_no === 7) {
            // If GE and sampling not done yet
            if (this.topic.isGOE() && this.topic.isSamplingStarted() && !this.topic.isSamplingComplete(this.incentive)) {
                this.sampReqMess = 'This Disbursement must have Sampling completed (or manually overridden)';
            }
        }
    };
    DetailTableSampQController.prototype.$onInit = function () {
        this.incentive = this.$attrs.incentive;
        this.incentiveStatus = this.topic.topic.sampling[this.incentive] || this.topic.topic.sampling;
        this.edit = this.topic.getEditComponent(this.comp);
        this.setSamplingMessage();
    };
    DetailTableSampQController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            // Check if we can update the values if yes continue to update temp
            this.edit.editMode = this.topic.setTopicFromTempPart(this.comp);
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableSampQController.$inject = ['topic', 'env', '$scope', '$attrs', '$state', 'settings', 'socket', 'admin', 'notify'];
    return DetailTableSampQController;
}());
var DetailTableSampQComponent = (function () {
    function DetailTableSampQComponent() {
        this.templateUrl = 'detail-table-sampq.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableSampQController;
    }
    return DetailTableSampQComponent;
}());
angular
    .module('application')
    .component('detailTableSampQ', new DetailTableSampQComponent());



//FIXME ...
// tslint:disable: no-commented-code
// tslint:disable: jsdoc-format
// tslint:disable: member-ordering
// tslint:disable: member-access
// tslint:disable: interface-name
// tslint:disable: no-consecutive-blank-lines
// tslint:disable: arrow-parens
// tslint:disable: typedef
// tslint:disable: prefer-immediate-return
// tslint:disable: typedef
// tslint:disable: prefer-const
// tslint:disable: max-classes-per-file
// tslint:disable: cognitive-complexity
// tslint:disable: object-literal-sort-keys
// tslint:disable: forin
// tslint:disable: max-line-length
// tslint:disable: semicolon
// tslint:disable: no-trailing-whitespace
// tslint:disable: no-console
// tslint:disable: prefer-template
// tslint:disable: prefer-conditional-expression
// tslint:disable: no-redundant-boolean
// tslint:disable: no-collapsible-if        
// tslint:disable: no-shadowed-variable
/**
 * @author Ivan Toth.
 */
var DetailSearchSubmitController = (function () {
    function DetailSearchSubmitController(topic, $state, $stateParams, env, searchSubmit, notify, socket, settings, $timeout, $http, moment) {
        this.topic = topic;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.env = env;
        this.searchSubmit = searchSubmit;
        this.notify = notify;
        this.socket = socket;
        this.settings = settings;
        this.$timeout = $timeout;
        this.$http = $http;
        this.moment = moment;
        this.dcLock = 'dc';
        this.OPP_VERSION_5 = 5;
        this.activeTab = $state.current.name;
        this.id = this.$stateParams.id;
        if (angular.isUndefined(this.searchSubmit.original) || angular.isUndefined(this.searchSubmit.original.table)) {
            this.finishUp();
        }
        this.tableData = this.searchSubmit.type === 'dc_v5' ?
            this.extractDcV5(this.searchSubmit.original.table) :
            this.searchSubmit.original.table;
        this.original_filter = {};
        this.searchCriteria = false;
        this.showSecondary = false;
    }
    DetailSearchSubmitController.prototype.$onInit = function () {
        var _this = this;
        // Scroll to top
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        if (!this.searchSubmit.original) {
            this.finishUp();
            return;
        }
        // Fill the all results - original & To be saved - results objects
        this.original_filter = {
            searchTxt: '',
            notEmpty: false,
            calculated: false,
            filters: {}
        };
        this.original_array = angular.copy(this.tableData);
        this.results_filter = {
            searchTxt: '',
            notEmpty: false,
            calculated: false,
            filters: {}
        };
        this.results_array = angular.copy(this.searchSubmit.results.table);
        // Prepare filter objects
        if (this.tableData.length > 0) {
            this.original_filter.notEmpty = true;
            this.results_filter.notEmpty = true;
            angular.forEach(this.tableData, function (arr) {
                for (var prop in arr) {
                    _this.original_filter.filters[prop] = { unique: [], picked: [], type: 's', cond: '=' };
                    _this.results_filter.filters[prop] = { unique: [], picked: [], type: 's', cond: '=' };
                }
            });
            this.makeFilterOptions('original');
            this.makeFilterOptions('results');
            this.original_filter.calculated = false;
            this.results_filter.calculated = false;
        }
        var tempArray = [];
        this.rowOrder = [];
        this.dropRowOrder = [];
        var mainCols = [];
        var secondCols = [];
        //Create columns for the tables
        if (angular.isDefined(this.searchSubmit.original.colVer)) {
            angular.forEach(this.settings.allColumnOrder, function (columnOrder) {
                angular.forEach(columnOrder.ds, function (ds) {
                    if (ds === _this.searchSubmit.original.ds) {
                        mainCols = columnOrder[_this.searchSubmit.original.colVer].main;
                        secondCols = columnOrder[_this.searchSubmit.original.colVer].second;
                    }
                });
            });
            angular.forEach(mainCols, function (columns) {
                tempArray.push(columns);
                _this.columnObj = (angular.isDefined(_this.settings.columnNames[_this.searchSubmit.type][columns])) ? _this.settings.columnNames[_this.searchSubmit.type][columns] : { h: columns };
                _this.columnObj.v = columns;
                if (_this.columnObj.t && _this.columnObj.t.indexOf('collapse') > -1) {
                    _this.dropRowOrder.push(_this.columnObj);
                    _this.showSecondary = true;
                }
                else {
                    _this.rowOrder.push(_this.columnObj);
                }
            });
            angular.forEach(secondCols, function (columns) {
                _this.columnObj = (angular.isDefined(_this.settings.columnNames[_this.searchSubmit.type][columns])) ? _this.settings.columnNames[_this.searchSubmit.type][columns] : { h: columns };
                _this.columnObj.v = columns;
                _this.dropRowOrder.push(_this.columnObj);
            });
            if (this.dropRowOrder.length > 0) {
                this.showSecondary = true;
            }
        }
        if (["MYSA_DUP", "SC_DUP"].includes(this.searchSubmit.original.ds) && !this.tableData.length) {
            tempArray = [];
            for (var prop in this.settings.columnNames[this.searchSubmit.type]) {
                this.columnObj = (angular.isDefined(this.settings.columnNames[this.searchSubmit.type][prop])) ? this.settings.columnNames[this.searchSubmit.type][prop] : { h: prop };
                this.columnObj.v = prop;
                if (this.columnObj.t && this.columnObj.t.indexOf('collapse') > -1) {
                    this.dropRowOrder.push(this.columnObj);
                    this.showSecondary = true;
                }
                else {
                    this.rowOrder.push(this.columnObj);
                }
            }
        }
        // Create columns for the columns, that are not listed in  cloudant
        if (this.tableData.length > 0) {
            //console.info(this.searchSubmit.original.table[0], '2');
            for (var prop in this.tableData[0]) {
                var found = true;
                if (mainCols.indexOf(prop) > -1 || secondCols.indexOf(prop) > -1 || prop === '$$hashKey' || prop === 'gov' || prop === 'unk' || prop === 'cmrDuns' || prop === '') {
                    found = false;
                }
                if (found) {
                    tempArray.push(prop);
                    this.columnObj = (this.settings.columnNames[this.searchSubmit.type] && this.settings.columnNames[this.searchSubmit.type][prop]) ? this.settings.columnNames[this.searchSubmit.type][prop] : { h: prop };
                    this.columnObj.v = prop;
                    if (this.columnObj.t && this.columnObj.t.indexOf('collapse') > -1) {
                        this.dropRowOrder.push(this.columnObj);
                        this.showSecondary = true;
                    }
                    else {
                        this.rowOrder.push(this.columnObj);
                    }
                }
            }
            // THis makes sure, that dropdowns have empty values
            this.original_countDrop = [];
            this.results_countDrop = [];
            for (var i = 0; i < this.rowOrder.length; i++) {
                this.original_countDrop[i] = 0;
                this.results_countDrop[i] = 0;
            }
            this.filterArray = angular.copy(tempArray);
        }
    };
    DetailSearchSubmitController.prototype.extractDcV5 = function (duplicateData) {
        if (!duplicateData) {
            return;
        }
        var inboundIncentiveDetail = _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail');
        var inboundDealRegs = inboundIncentiveDetail.dealRegs;
        var result = [];
        // order of properties defines order of columns in the table
        var _loop_1 = function(duplicate) {
            var inboundDealReg = inboundDealRegs.find(function (item) { return item.dealRegGroupId === duplicate.drpgId; });
            var sviSubmitDateFormatted = duplicate.sviSubmitDate ? this_1.moment.utc(Number(duplicate.sviSubmitDate)).format('LLL') : '';
            var sviExpDate = duplicate.sviExpDate ? this_1.moment.utc(Number(duplicate.sviExpDate)).format('LLL') : '';
            var row = {
                opp: duplicate.opp,
                bpName: duplicate.bpName,
                sviSubmitDate: sviSubmitDateFormatted,
                sviExpDate: sviExpDate,
                country: duplicate.country,
                sviOverallStatus: duplicate.sviOverallStatus,
                ssaDup: duplicate.ssaDup ? duplicate.ssaDup : 'N',
                eiDup: duplicate.eiDup ? duplicate.eiDup : 'N',
                accountName: duplicate.accountName,
                drpgId: duplicate.drpgId,
                drpgName: inboundDealReg.dealRegGroupDescription
            };
            result.push(row);
        };
        var this_1 = this;
        for (var _i = 0, duplicateData_1 = duplicateData; _i < duplicateData_1.length; _i++) {
            var duplicate = duplicateData_1[_i];
            _loop_1(duplicate);
        }
        return result;
    };
    DetailSearchSubmitController.prototype.showGov = function () {
        this.original_filter.filters.gov.picked = [true];
        this.results_filter.filters.gov.picked = [true];
        this.original_filter.filters.unk.picked = [];
        this.results_filter.filters.unk.picked = [];
        this.blurFilterPick('original');
        this.blurFilterPick('results');
    };
    DetailSearchSubmitController.prototype.showUnk = function () {
        this.original_filter.filters.gov.picked = [];
        this.results_filter.filters.gov.picked = [];
        this.original_filter.filters.unk.picked = [true];
        this.results_filter.filters.unk.picked = [true];
        this.blurFilterPick('original');
        this.blurFilterPick('results');
    };
    DetailSearchSubmitController.prototype.cancelGoe = function () {
        this.original_filter.filters.gov.picked = [];
        this.results_filter.filters.gov.picked = [];
        this.original_filter.filters.unk.picked = [];
        this.results_filter.filters.unk.picked = [];
        this.blurFilterPick('original');
        this.blurFilterPick('results');
    };
    DetailSearchSubmitController.prototype.goto = function (tab) {
        this.$state.go(tab.name, this.$stateParams);
        this.topic.setActiveTab(tab.name);
        this.activeTab = tab.name;
    };
    /**
      Adds the filtered results
      @param source    source of the search
      @returns void
    */
    DetailSearchSubmitController.prototype.addFiltered = function (source) {
        var _this = this;
        var srcArr = source + '_array';
        angular.forEach(this[srcArr], function (arrayItem) {
            _this.addItem(arrayItem);
        });
    };
    /**
      Removes the filtered results
      @param source    source of the search
      @returns void
    */
    DetailSearchSubmitController.prototype.removeFiltered = function (source) {
        var _this = this;
        var srcArr = source + '_array';
        angular.forEach(this[srcArr], function (arrayItem) {
            _this.removeItem(arrayItem);
        });
    };
    /**
      Toggles the table row, when it contains a secondary row as a table
      @param rowObj    row to be toggled
      @returns void
    */
    DetailSearchSubmitController.prototype.toggleRow = function (rowObj) {
        if (angular.isDefined(rowObj.visible) && rowObj.visible) {
            rowObj.visible = false;
        }
        else {
            rowObj.visible = true;
        }
    };
    /**
      Toggle Searched criteria that was used to get this search
      @returns void
    */
    DetailSearchSubmitController.prototype.toggleCriteria = function () {
        this.searchCriteria = (this.searchCriteria) ? false : true;
    };
    /**
      Submit the saved results on the Save button press
      @returns void
    */
    DetailSearchSubmitController.prototype.submitResults = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateSearchResults',
                script: '/detail/eligibility/eligibility',
                results: {
                    saved: this.searchSubmit.results,
                    allResults: this.searchSubmit.original
                },
                type: this.searchSubmit.type,
                token: this.env.user.token,
                opp: this.topic.topic._id,
                bID: this.topic.topicBrowserID,
                partial: true
            }
        });
        this.searchSubmit.updateResults(undefined);
        this.searchSubmit.updateOriginal(undefined);
        this.searchSubmit.updateLaterProcess(false);
        this.finishUp();
    };
    /**
      Action to be performed on Cancel search
      @returns void
    */
    DetailSearchSubmitController.prototype.cancelResults = function () {
        this.topic.calculateAccess([this.searchSubmit.type], false);
        this.notify.success('Search results save cancelled');
        this.searchSubmit.updateResults(undefined);
        this.searchSubmit.updateOriginal(undefined);
        this.searchSubmit.updateLaterProcess(false);
        this.finishUp();
    };
    /**
      Add a item into the saved results table
      @param item    item to be added
      @returns void
    */
    DetailSearchSubmitController.prototype.addItem = function (item) {
        if (this.searchSubmit.addItem(item)) {
            this.results_filter.calculated = false;
            this.blurFilterPick('results');
            this.makeFilterOptions('results');
            this.results_filter.calculated = false;
        }
    };
    /**
      Remove a item from the saved table
      @param item    item to be added
      @returns void
    */
    DetailSearchSubmitController.prototype.removeItem = function (item) {
        if (this.searchSubmit.removeItem(item)) {
            this.results_filter.calculated = false;
            this.blurFilterPick('results');
            this.makeFilterOptions('results');
            this.results_filter.calculated = false;
        }
    };
    /**
      This will save the result in the browser & you can click it any time to open it again
      @returns void
    */
    DetailSearchSubmitController.prototype.processLaterResults = function () {
        this.topic.calculateAccess([this.searchSubmit.type], false);
        this.searchSubmit.updateLaterProcess(true);
        this.finishUp();
    };
    /**
      Export report into Excel file
      @returns void
    */
    DetailSearchSubmitController.prototype.excelExport = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'searchExportExcel',
                script: '/detail/eligibility/eligibility',
                data: this.searchSubmit.original,
                token: this.env.user.token
            }
        });
    };
    /**
      Clears the selected filter
      @param filtName     name of the filter
      @param source       original or results
      @returns void
    */
    DetailSearchSubmitController.prototype.clearFilter = function (filtName, source) {
        var src = source + '_filter';
        this[src].filters[filtName].picked = [];
        this.blurFilterPick(source);
    };
    /**
      Clicked / selected a item in the filter select, this will ensure, that the table will be recalculated when dropdown closes
      @param source       original or results
      @returns void
    */
    DetailSearchSubmitController.prototype.changedValue = function (source) {
        var src = source + '_filter';
        this[src].calculated = false;
    };
    /**
     * Will create unique items for the filters in the table
     * @param source       original or results
     * @returns void
     */
    DetailSearchSubmitController.prototype.makeFilterOptions = function (source, reset) {
        var _this = this;
        if (reset === void 0) { reset = false; }
        var src = source + '_filter';
        var srcArr = source + '_array';
        //if (this.filterObject.notEmpty) {
        if (!this[src].calculated && this[src].notEmpty) {
            //browse through every item in table
            this[src].calculated = true;
            if (reset) {
                for (var prop in this[src].filters) {
                    this[src].filters[prop].unique = [];
                }
            }
            angular.forEach(this[srcArr], function (tableLine) {
                //if the item is unique, put it into the representing unique value
                for (var prop in _this[src].filters) {
                    if (_this[src].filters[prop].type === 's') {
                        if (_this[src].filters[prop].unique.indexOf(tableLine[prop]) < 0) {
                            _this[src].filters[prop].unique.push(tableLine[prop]);
                        }
                    }
                }
            });
        }
    };
    /**
     Opens the dropdown with the filters. By changing this, we'll change the limitTo of the filter ng-repeat. This is done for
     performance increase(So DOM doenst have to have in special cases 4k+ checkboxes)
     @param source    original or results
     @param id        id of the filter
     @param size      size of the filter
     @returns void
    */
    DetailSearchSubmitController.prototype.openDrop = function (source, id, size) {
        var srcDrop = source + '_countDrop';
        this[srcDrop][id] = size;
    };
    /**
     Closes dropdown and sets the limitTo on the filter to 0
     @param source    original or results
     @param id        id of the filter
     @returns void
    */
    DetailSearchSubmitController.prototype.closeDrop = function (source, id) {
        var srcDrop = source + '_countDrop';
        this[srcDrop][id] = 0;
        this.blurFilterPick(source);
    };
    DetailSearchSubmitController.prototype.applySearchTxtFilter = function (source) {
        this.blurFilterPick(source);
    };
    /**
     * Based on the filters selected, only those lines in table are picked, that fullfill the picked filter values
     * @param source    original or results
     * @returns void
     */
    DetailSearchSubmitController.prototype.blurFilterPick = function (source) {
        var src = source + '_filter';
        var srcArr = source + '_array';
        var srcFilterObj = this[src];
        if (!srcFilterObj.calculated && srcFilterObj.notEmpty && Array.isArray(this.searchSubmit[source].table)) {
            var searchSubmitScrTable = this.searchSubmit.type === 'dc_v5' ?
                this.extractDcV5(this.searchSubmit[source].table) :
                this.searchSubmit[source].table;
            var tempArray_1;
            var tmpSearchTxt_1 = " " + String(srcFilterObj.searchTxt).toLocaleLowerCase().trim() + " ";
            var checkCellValueFn_1 = function (val) { return (" " + String(val).toLocaleLowerCase() + " ").indexOf(tmpSearchTxt_1) !== -1; };
            if (srcFilterObj.searchTxt) {
                var rowPassedBySearchTxtFilter_1;
                tempArray_1 = [];
                searchSubmitScrTable.forEach(function (row) {
                    rowPassedBySearchTxtFilter_1 = Object.keys(row).filter(function (cellKey) { return checkCellValueFn_1(row[cellKey]); }).length > 0;
                    if (rowPassedBySearchTxtFilter_1) {
                        tempArray_1.push(row);
                    }
                });
                searchSubmitScrTable = tempArray_1.slice();
                this[srcArr] = tempArray_1.slice();
            }
            // console.log('blurFilterPick');
            this.makeFilterOptions(source, true);
            this.original_filter.calculated = false;
            this.results_filter.calculated = false;
            var filterOK_1;
            tempArray_1 = [];
            angular.forEach(searchSubmitScrTable, function (tableLine) {
                filterOK_1 = true;
                var _loop_2 = function(prop) {
                    if (srcFilterObj.filters[prop].type === 's' && filterOK_1) {
                        if (srcFilterObj.filters[prop].picked.length > 0) {
                            filterOK_1 = false;
                            angular.forEach(srcFilterObj.filters[prop].picked, function (picked) {
                                if (picked === tableLine[prop]) {
                                    filterOK_1 = true;
                                }
                            });
                        }
                    }
                };
                for (var prop in srcFilterObj.filters) {
                    _loop_2(prop);
                }
                if (filterOK_1) {
                    tempArray_1.push(tableLine);
                }
            });
            this[srcArr] = angular.copy(tempArray_1);
        }
    };
    DetailSearchSubmitController.prototype.finishUp = function () {
        //Since this could be fired from Elig or Validation...need to determine where to go
        var tabby = 'eligibility';
        if (this.searchSubmit.type === 'cmr_valid') {
            tabby = 'validation';
        }
        this.$state.go('detail.' + tabby, {
            id: this.id
        });
        this.topic.setActiveTab(tabby);
    };
    DetailSearchSubmitController.prototype.findCriteria = function (key) {
        var criteria = this.searchSubmit.original.searchCriteria.filter(function (criteria) { return criteria.k === key; })[0];
        if (!criteria) {
            return null;
        }
        return criteria;
    };
    DetailSearchSubmitController.prototype.getCriteriaValueByKey = function (key) {
        var criteria = this.findCriteria(key);
        if (!criteria) {
            return '';
        }
        return criteria.v;
    };
    DetailSearchSubmitController.prototype.getCountryByCode = function (code) {
        var countries = this.settings.country_list;
        var countryObj = _.find(countries, { cc: code });
        if (!countryObj) {
            return null;
        }
        return countryObj;
    };
    DetailSearchSubmitController.prototype.getCountryFieldValue = function () {
        var value = this.getCriteriaValueByKey('Customer Country Landed') || this.getCriteriaValueByKey('Country Selected');
        return value;
    };
    DetailSearchSubmitController.prototype.shouldDisplayIssuingCountry = function () {
        var criteria = this.findCriteria('CMR Issuing Country');
        return !!criteria;
    };
    DetailSearchSubmitController.prototype.getIssuingCountryValue = function () {
        var _this = this;
        var countryCodeObj = this.getCriteriaValueByKey('CMR Issuing Country')[0];
        if (countryCodeObj) {
            var countries = _.isArray(countryCodeObj) ? countryCodeObj.map(function (code) { return _this.getCountryByCode(code); }) : [this.getCountryByCode(countryCodeObj)];
            var shorts = countries.map(function (country) { return country.short; });
            return shorts;
        }
        return '';
    };
    DetailSearchSubmitController.$inject = ['topic', '$state', '$stateParams', 'env', 'searchSubmit', 'notify', 'socket', 'settings', '$timeout', '$http', 'moment'];
    return DetailSearchSubmitController;
}());
var DetailSearchSubmitComponent = (function () {
    function DetailSearchSubmitComponent() {
        this.templateUrl = 'detail-search-submit.html';
        this.controllerAs = 'vm';
        this.controller = DetailSearchSubmitController;
    }
    return DetailSearchSubmitComponent;
}());
angular
    .module('application')
    .component('searchSubmitSection', new DetailSearchSubmitComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableComplClValidationController = (function () {
    function DetailTableComplClValidationController(topic, $scope) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.tableName = 'Validation Checklist';
        this.displayRadioButton = true;
        this.showThumb = true; //will show on section header
        this.lock = false;
        this.comp = 'complcl_validation';
        this.updateArray = ['complcl_validation'];
        this.visible = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
        this.overallFindGOEResult = ['Government Owned Entity', 'State Owned Enterprise', 'Unknown', 'Non-Government', 'No Results Found'];
        this.overallGoeIndicator = ['Government Owned Entity', 'State Owned Enterprise', 'Unknown', 'Non-Government'];
        this.goeDeterminant = ['FindGOE Tool', 'Exception list', 'IntOrg list', 'DUNS tab check', 'PEP check', 'GOE Team', 'NGE Declaration Process', 'SO name Clarification'];
        this.declarationLetter = ['Yes', 'No'];
    }
    ;
    DetailTableComplClValidationController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableComplClValidationController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailTableComplClValidationController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'upd')) {
                if (_.get(this, 'topic.checksData.isAutoEligibilityGoe', false)) {
                    _.set(this, 'topic.temp.complcl_validation.isAutoGoeEligibility', true);
                    var updateObject = {
                        data: {
                            complcl_validation: {
                                add: true,
                                data: this.topic.temp.complcl_validation
                            }
                        },
                        id: this.topic.topic._id,
                        type: ['complcl_validation']
                    };
                    console.log('send for update');
                    this.topic.updateServerTopic('couchUpdate', updateObject, true);
                }
                else {
                    this.topic.sendForUpdateGeneral(this.updateArray, true);
                }
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
            // Check if we can update the values if yes continue to update temp
            this.edit.editMode = this.topic.setTopicFromTempPart(this.comp);
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableComplClValidationController.prototype.itemChanged = function (line) { };
    DetailTableComplClValidationController.$inject = ['topic', '$scope'];
    return DetailTableComplClValidationController;
}());
var DetailTableComplClValidatioComponent = (function () {
    function DetailTableComplClValidatioComponent() {
        this.templateUrl = 'detail-table-complcl.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableComplClValidationController;
    }
    return DetailTableComplClValidatioComponent;
}());
angular
    .module('application')
    .component('detailTableComplClValidation', new DetailTableComplClValidatioComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableFpValidController = (function () {
    function DetailTableFpValidController(topic, settings, socket, $injector, env, $timeout) {
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.comp = 'fastpass_valid';
        this.requiredCountrySearch = true;
        this.OPP_VERSION_3 = 3;
        this.tableName = 'Fast Pass Validation';
        this.dc = { ds: 'FP-V-CN', countrySelected: '', fuzzySearch: '', opp: '', countryLine: [], pickList: [] };
        this.visible = false;
        this.expand = false;
        //this.dataSources = [{name: 'Cust No.', ds: 'FP-V-CN'},{name: 'BP Name', ds: 'FP-V-BP'},{name: 'Site No.', ds: 'FP-V-SN'},{name: 'S. Order', ds: 'FP-V-SO'}];
        this.dataSources = ['FP-V-CN', 'FP-V-BP', 'FP-V-SN', 'FP-V-SO'];
        this.stopSubmit = false;
        this.noValidCheck = true;
        this.govCheck = true;
        this.filterDisplay = false;
    }
    ;
    DetailTableFpValidController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableFpValidController.prototype.toggleFilter = function () {
        this.filterDisplay = this.filterDisplay ? false : true;
    };
    DetailTableFpValidController.prototype.sendDupliCheck = function (opp) {
        if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
            /*this.stopSubmit = true;
            this.$timeout(() => {
                      this.stopSubmit = false;
                  }, 1000);*/
            this.dc.opp = opp;
            //this.dc.iot = this.settings.calcIot(this.topic.topic.gpp_valid[0].country);
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getFuzzyResults',
                    script: '/detail/eligibility/eligibility',
                    data: this.dc,
                    token: this.env.user.token,
                    bID: this.topic.topicBrowserID,
                    partial: true
                }
            });
        }
        ;
    };
    DetailTableFpValidController.prototype.sendSONcheck = function (opp) {
        this.dc.pickList = [this.topic.topic.gpp_valid[0].salesorder];
        this.sendDupliCheck(opp);
    };
    // sends a broadcast to expand or colapse the table sections
    DetailTableFpValidController.prototype.expandAll = function (value) {
        this.$injector.get('$rootScope').$broadcast('expand.all.fastpass', value);
        this.expand = value;
    };
    DetailTableFpValidController.prototype.clearList = function () {
        this.dc.pickList = [];
    };
    DetailTableFpValidController.prototype.pushItem = function () {
        var _this = this;
        var dupli = false;
        angular.forEach(this.dc.pickList, function (iter) {
            if (iter === _this.toBeInserted) {
                dupli = true;
            }
        });
        if (!dupli) {
            this.dc.pickList.push(this.toBeInserted);
        }
        this.toBeInserted = '';
    };
    DetailTableFpValidController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout'];
    return DetailTableFpValidController;
}());
var DetailTableFpValidComponent = (function () {
    function DetailTableFpValidComponent() {
        this.templateUrl = 'detail-table-dc.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableFpValidController;
    }
    return DetailTableFpValidComponent;
}());
angular
    .module('application')
    .component('detailTableFpValid', new DetailTableFpValidComponent());



var DetailTableValIgCheckController = (function () {
    function DetailTableValIgCheckController(topic, settings, socket, $injector, env, $timeout, $scope, $attrs) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.comp = ['cmr_valid', 'goe_valid'];
        this.socket.forward('topic.search.result', this.$scope);
        this.$scope.$on('socket:topic.search.result', function (event, data) {
            _this.processing = false;
        });
        // IF YOU CHANGE ANY OF THESE VALUES, PLEASE CHANGE IT ALSO IN TEH ELIGIBILITY.TS in prepareFuzzyObject  function!!!!
        this.errorCheckerInput = false;
        this.filterDisplay = false;
        this.displayFindGoe = false;
        this.displayFindCmr = false;
        this.tableName = 'Incentives Government Check';
        this.visible = false;
        this.expand = false;
    }
    DetailTableValIgCheckController.prototype.toggle = function () {
        this.visible = !this.visible;
        this.tableName = 'Incentives Government Check';
    };
    DetailTableValIgCheckController.prototype.toggleFilter = function () {
        this.filterDisplay = !this.filterDisplay;
    };
    DetailTableValIgCheckController.prototype.toggleSearchInput = function (searchType) {
        if (searchType === 'findGoe') {
            this.displayFindGoe = !this.displayFindGoe;
            this.displayFindCmr = false;
            this.tableName = 'Incentives Government Check';
        }
        if (searchType === 'findCmr') {
            this.displayFindCmr = !this.displayFindCmr;
            this.displayFindGoe = false;
            this.tableName = 'Find Cmr';
        }
    };
    DetailTableValIgCheckController.prototype.getManualValidationGoeDecisionLabel = function () {
        if (this.topic.topic.commonValidationGOEDecision) {
            switch (this.topic.topic.commonValidationGOEDecision.goeDecision) {
                case 'Y': return 'Government Entity';
                case 'S': return 'State Owned Enterprise';
                case 'N': return 'Non-government';
                case 'U': return 'Unknown';
                default: return '';
            }
        }
    };
    DetailTableValIgCheckController.prototype.getValidationManualGoeReasonLabel = function () {
        if (this.topic.topic.commonValidationGOEDecision) {
            var duns = void 0;
            var trusted = void 0;
            switch (this.topic.topic.commonValidationGOEDecision.reason) {
                case 'TRUSTED_WITH_DUNS': {
                    duns = '';
                    trusted = '';
                    break;
                }
                case 'TRUSTED_WITHOUT_DUNS': {
                    duns = 'no ';
                    trusted = '';
                    break;
                }
                case 'NOT_TRUSTED_WITH_DUNS': {
                    duns = '';
                    trusted = 'not ';
                    break;
                }
                case 'NOT_TRUSTED_WITHOUT_DUNS': {
                    duns = 'no ';
                    trusted = 'not ';
                    break;
                }
                default: {
                    return this.topic.topic.commonValidationGOEDecision.reason || 'no records';
                }
            }
            var message = void 0;
            if (this.topic.topic.commonValidationGOEDecision.reason === 'EMPTY_RESULTS') {
                message = 'no records';
            }
            else {
                message = duns + "DUNS - " + trusted + "Most Trusted Source";
            }
            switch (this.topic.topic.commonValidationGOEDecision.goeDecision) {
                case 'Y': return "Yes - " + message;
                case 'N': return "No - " + message;
                case 'U': return "Unknown - " + message;
                default: return '';
            }
        }
    };
    DetailTableValIgCheckController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope', '$attrs'];
    return DetailTableValIgCheckController;
}());
var DetailTableValidIgCheckComponent = (function () {
    function DetailTableValidIgCheckComponent() {
        this.templateUrl = 'detail-table-valid-igcheck.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableValIgCheckController;
    }
    return DetailTableValidIgCheckComponent;
}());
angular
    .module('application')
    .component('detailTableValidIgCheck', new DetailTableValidIgCheckComponent());



/**
 * @author Ivan Toth.
 */
var DetailTableVcmrController = (function () {
    function DetailTableVcmrController(topic, settings, socket, $injector, env, $timeout, $scope) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.comp = 'cmr_valid';
        this.requiredCountrySearch = true;
        this.OPP_VERSION_3 = 3;
        this.socket.forward('topic.search.result', this.$scope);
        this.$scope.$on('socket:topic.search.result', function (event, data) {
            _this.processing = false;
        });
        // IF YOU CHANGE ANY OF THESE VALUES, PLEASE CHANGE IT ALSO IN TEH ELIGIBILITY.TS in prepareFuzzyObject  function!!!!
        this.errorCheckerInput = false;
        this.cmrData = {};
        this.filterDisplay = false;
        this.bol = false;
        this.selectedCustName = [];
        this.tableName = 'Find CMR';
        this.cmrData.cmrIssuingCountry = '';
        this.cmrData.customerCountryLanded = '';
        this.cmrData.fuzzyOption = 'Contains';
        this.cmrData.cmrOwner = 'IBM';
        this.cmrData.cmrTypeStandard = true;
        this.cmrData.accTypeSoldTo = true;
        this.cmrData.customerName = 'CustNameOnly';
        this.cmrData.rows = '500';
        this.cmrData.cmrNum = '';
        this.cmrData.fuzzySearch = '';
        this.visible = false;
        this.expand = false;
        this.dataSources = ['VCMR'];
        this.stopSubmit = false;
        this.noValidCheck = true;
        this.govCheck = true;
        this.processing = false;
        this.fuzzyOptions = ['Contains', 'Begins with', 'Fuzzy'];
        this.resultRows = ['50', '100', '500', '1000', '5000'];
        this.cmrOwnerOptions = ['ALL', 'IBM', 'Lenovo', 'Truro', 'Fonseca'];
        this.custNameOptions = [
            { name: 'Customer Name Only', value: 'CustNameOnly' },
            { name: 'Business Name Only', value: 'BusNameOnly' },
            { name: 'Customer & Business Name', value: 'CustBusName' }
        ];
    }
    ;
    DetailTableVcmrController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableVcmrController.prototype.toggleFilter = function () {
        this.filterDisplay = this.filterDisplay ? false : true;
    };
    DetailTableVcmrController.prototype.errorChecker = function () {
        if (this.cmrData.cmrNum === null) {
            this.errorCheckerInput = true;
        }
        else {
            this.errorCheckerInput = false;
        }
    };
    DetailTableVcmrController.prototype.nameChecker = function () {
        if (this.cmrData.fuzzySearch === '') {
            this.errorCheckerInput = true;
        }
        else {
            this.errorCheckerInput = false;
        }
    };
    DetailTableVcmrController.prototype.sendDupliCheck = function (opp) {
        if (this.cmrData.fuzzySearch === '' && this.cmrData.cmrNum === '') {
            this.errorCheckerInput = true;
        }
        else {
            this.errorCheckerInput = false;
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                this.cmrData.opp = opp;
                //this.dc.iot = this.settings.calcIot(this.topic.topic.gpp_valid[0].country);
                this.cmrData.ds = 'VCMR';
                this.processing = true;
                console.info('detail.tabl.vcmr (sendDupliCheck) => socket getFuzzyResults', this.cmrData);
                this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'getFuzzyResults',
                        script: '/detail/eligibility/eligibility',
                        data: this.cmrData,
                        token: this.env.user.token,
                        bID: this.topic.topicBrowserID,
                        partial: true
                    }
                });
            }
            ;
        }
    };
    // sends a broadcast to expand or colapse the table sections
    DetailTableVcmrController.prototype.expandAll = function (value) {
        this.$injector.get('$rootScope').$broadcast('expand.all.vcmr', value);
        this.expand = value;
    };
    DetailTableVcmrController.prototype.countryChange = function () {
        return;
    };
    DetailTableVcmrController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope'];
    return DetailTableVcmrController;
}());
var DetailTableVcmrComponent = (function () {
    function DetailTableVcmrComponent() {
        this.templateUrl = 'detail-table-dc.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableVcmrController;
    }
    return DetailTableVcmrComponent;
}());
angular
    .module('application')
    .component('detailTableVcmr', new DetailTableVcmrComponent());



var DetailValidationController = (function () {
    function DetailValidationController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, topic, moment) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.topic = topic;
        this.moment = moment;
        this.showCLGE = false; // Whether the Validation Checklist and GE Decision should show
        this.cmrArray = [];
        this.newSelected = [];
        this.newGoeArray = [];
        this.newCmrArray = [];
        this.goeArray = [];
        this.isCommented = false;
        this.i = 0;
        this.isNewOppty = false;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.isValidationStartDateDisable = false;
        this.isNonGoeAndAutomatedEligibility = false;
        var vm = this;
        this.socket.forward('queue.validation', this.$scope);
        this.id = $stateParams.id;
        this.activeTab = $state.current.name;
        this.$scope.$on('socket:queue.validation', function (event, data) {
            _this.fillChecklist(event, data);
        });
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // If the topic is updated, work out if checklist and GE should show
            _this.showCheckListAndGE();
        });
        this.socket.forward('eligibility.getChecksResultsFromValidation', this.$scope);
        this.$scope.$on('socket:eligibility.getChecksResultsFromValidation', function (event, data) {
            if (data.uiFlag) {
                _this.isNewOppty = true;
            }
            _this.cmr = { data: data.incentiveCMRNumber };
        });
        this.socket.forward('validation.manual2ndFindCMRResult', this.$scope);
        this.$scope.$on('socket:validation.manual2ndFindCMRResult', function (event, data) {
            _this.topic.topic.cmr_valid = data.response.cmr_valid;
            _this.topic.topic.goe_valid = data.response.goe_valid;
        });
        this.socket.forward('topic.valid.goecheck', this.$scope);
        this.$scope.$on('socket:topic.valid.goecheck', function (event, data) {
            _this.i += 1;
            if (data.response.ds === 'GOE_DATA') {
                _this.goeArray.push(data.response);
            }
            var goe = _this.topic.topic.goe_data.results ? _this.topic.topic.goe_data.results.length : 0;
            var isGoeEqual = true;
            if (_this.i === goe) {
                if (goe && _this.goeArray) {
                    _this.newGoeArray = _this.getNewGoeCheckArr(_this.goeArray, _this.topic.topic.goe_data.results, 'CMR_NO');
                    var compareValueGoeElig = _this.topic.topic.goe_data.results.map(function (result) {
                        return result.table.map(function (e) {
                            return e.OVERALL_GOE_CD.slice();
                        });
                    });
                    var compareValueGoeValid = _this.newGoeArray.map(function (result) {
                        return result.table.map(function (e) {
                            return e.OVERALL_GOE_CD.slice();
                        });
                    });
                    isGoeEqual = _.isEqual(compareValueGoeElig[0], compareValueGoeValid[0]);
                }
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'performCheck',
                        script: '/detail/eligibility/eligibility',
                        data: {
                            cmrResults: _this.newCmrArray,
                            goeResults: _this.newGoeArray,
                            opp: _this.topic.topic._id.substring(4),
                            isGoeEqual: isGoeEqual
                        },
                        token: _this.env.user.token,
                        bID: _this.topic.topicBrowserID,
                        partial: true
                    }
                });
            }
        });
    }
    DetailValidationController.prototype.getAccountValue = function (accountName) {
        var generics = _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.generics');
        var accountObj = generics.find(function (generic) { return generic.name === accountName; });
        return accountObj ? accountObj.value : '';
    };
    DetailValidationController.prototype.getNewGoeCheckArr = function (newResult, oldResult, type) {
        var _this = this;
        var newGoeArray = [];
        newResult.forEach(function (result, i) {
            var newReport = result.table;
            var reportExcel = oldResult[i].table;
            _this.newSelected = _.clone(result);
            var arr = [];
            _.forEach(newReport, function (newReportLine, j) {
                for (var i_1 = 0; i_1 < reportExcel.length; i_1++) {
                    var selectedTable = reportExcel[i_1];
                    if (newReportLine[type] === selectedTable[type]) {
                        arr.push(newReportLine);
                        console.info(newReportLine);
                    }
                }
            });
            _this.newSelected.table = arr;
            newGoeArray.push(_this.newSelected);
        });
        return newGoeArray;
    };
    DetailValidationController.prototype.changeStartValidDate = function (date) {
        this.isCommented = false;
        var startValidDate = new Date(date).getTime();
        var data = {
            data: {
                'comments.validation': {
                    data: [{
                            comment: "Validation Start Date is changed, reason: " + this.validDateComment,
                            user: this.env.user.email
                        }],
                    push: true
                },
                'startValidDate': {
                    add: true,
                    data: startValidDate
                }
            },
            id: this.topic.topic._id,
            type: ['comments.validation', 'startValidDate']
        };
        this.topic.updateServerTopic('couchUpdate', data, true);
    };
    /**
     * Function to determine if the Validation Checklist and GE Decision components should be
     * rendered on screen
     */
    DetailValidationController.prototype.showCheckListAndGE = function () {
        // The Validation Checklist and GE Decision should only be visible if:
        // 2nd GOE has run
        // Manual Search performed regardless
        // Attachments added regardless
        // TEMPORATY COMMENTED
        // const goe: any = this.topic.getGOEValidStatus(); //Get the GOE results
        // if ((goe.auto > 0 && goe.errors > 0) || // If 2nd GOE and there were errors
        //     goe.manual > 0 || // If manual search done
        //     att) { // If attachments added
        //     this.showCLGE = true;
        // } else {
        //     this.showCLGE = false;
        // }
        var AUTOMATIC_SEARCH_USER_NAME = 'system';
        var att = this.topic.attachmentsFound('fcmr_valid'); //Check for files
        var isManualFindCMRPerformed;
        var isManualFindGOEPerformed;
        if (_.get(this, "topic.topic.cmr_valid.results", []).length) {
            isManualFindCMRPerformed = _.get(this, "topic.topic.cmr_valid.results", [])
                .some(function (cmrSearchResultItem) { return cmrSearchResultItem.user && cmrSearchResultItem.user !== AUTOMATIC_SEARCH_USER_NAME; });
        }
        else {
            isManualFindCMRPerformed = false;
        }
        if (_.get(this, "topic.topic.goe_valid.results", []).length) {
            isManualFindGOEPerformed = _.get(this, "topic.topic.goe_valid.results", [])
                .some(function (goeSearchResultItem) { return goeSearchResultItem.user && goeSearchResultItem.user !== AUTOMATIC_SEARCH_USER_NAME; });
        }
        else {
            isManualFindGOEPerformed = false;
        }
        this.showCLGE = att || isManualFindCMRPerformed || isManualFindGOEPerformed;
    };
    DetailValidationController.prototype.getRestricted = function () {
        return this.isV4OrLess() ? this.getRestrictedV4() : this.getRestrictedV5();
    };
    DetailValidationController.prototype.getRestrictedV4 = function () {
        switch (_.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.opportunity.isRestricted')) {
            case 'RESTNOT':
                return 'Not Restricted';
            case 'RESTOPCL':
                return 'Restricted to opportunity team, client team and incentive review team';
            case 'RESTOPTY':
                return 'Restricted to opportunity team and incentive review team';
            default:
                return '';
        }
    };
    DetailValidationController.prototype.getRevenueV5 = function () {
        if (this.topic.topic.version >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.opportunityAmount');
        }
        return undefined;
    };
    DetailValidationController.prototype.getOppCurrencyV5 = function () {
        if (this.topic.topic.version >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.opportunityCurrency');
        }
        return undefined;
    };
    DetailValidationController.prototype.getRestrictedV5 = function () {
        switch (this.topic.topic.isRestr) {
            case 'N':
                return 'Not Restricted';
            case 'Y':
                return 'Restricted';
            default:
                return '';
        }
    };
    DetailValidationController.prototype.$onInit = function () {
        this.isNonGoeAndAutomatedEligibility = _.get(this, 'topic.checksData.isAutoEligibilityGoe', false) && _.get(this, 'topic.topic.goe.picked') === 'No';
        this.showCheckListAndGE(); // Check if checklist and GE need showing
        this.topic.setTempFromTopic();
        this.getNewOppyData();
        this.setValidationDate();
    };
    DetailValidationController.prototype.setValidationDate = function () {
        this.validDate = new Date();
        this.validDate.setTime(this.topic.topic.startValidDate);
        if (!this.env.user.access.bpsoAdmin) {
            this.validDate = this.moment(this.validDate).format('YYYY-MM-DD');
        }
        this.isValidationStartDateDisable = _.get(_.find(this.topic.tabs.list, { name: 'detail.payment' }), 'editable', true);
    };
    DetailValidationController.prototype.getNewOppyData = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getChecksResultsFromValidation',
                script: '/detail/eligibility/eligibility',
                data: {
                    unid: this.topic.topic._id
                },
                token: this.env.user.token
            }
        });
    };
    DetailValidationController.prototype.fillChecklist = function (ev, results) {
        this.topic.loaded.gpp_valid = false;
        this.topic.topic.gpp_valid = results;
    };
    DetailValidationController.prototype.reload = function () {
        this.topic.loaded.gpp_valid = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'validation',
                script: '/detail/validation/validation',
                opp: this.topic.topic.opp,
                unid: this.topic.topic._id,
                token: this.env.user.token
            }
        });
    };
    DetailValidationController.prototype.goeValidation = function () {
        var dataFor2ndGOECheck = {
            opp: this.topic.topic._id
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                bID: this.topic.topicBrowserID,
                data: dataFor2ndGOECheck,
                function: 'run2ndGOECheck',
                partial: true,
                script: '/detail/eligibility/manualFindCMR/index',
                token: this.env.user.token,
                type: 'cmr_valid'
            }
        });
    };
    DetailValidationController.prototype.isV4OrLess = function () {
        var version = this.topic.topic.version;
        return !version || version <= this.OPP_VERSION_4;
    };
    DetailValidationController.$inject = ['$scope', 'env', '$filter',
        '$timeout', '$q', 'socket', 'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_', '$compile', '$state', '$stateParams', 'topic', 'moment'
    ];
    return DetailValidationController;
}());
var DetailValidationComponent = (function () {
    function DetailValidationComponent() {
        this.templateUrl = 'detail-validation.html';
        this.controllerAs = 'vm';
        this.controller = DetailValidationController;
    }
    return DetailValidationComponent;
}());
angular
    .module('application')
    .component('detailValidation', new DetailValidationComponent());
var DetailAValidationGppComponent = (function () {
    function DetailAValidationGppComponent() {
        this.templateUrl = 'detail-validation-general.html';
    }
    return DetailAValidationGppComponent;
}());
angular
    .module('application')
    .component('detailValidationGeneral', new DetailAValidationGppComponent());
var DetailAValidationGppcheckComponent = (function () {
    function DetailAValidationGppcheckComponent() {
        this.templateUrl = 'detail-validation-gppcheck.html';
    }
    return DetailAValidationGppcheckComponent;
}());
angular
    .module('application')
    .component('detailValidationGeneralGppcheck', new DetailAValidationGppcheckComponent());



/**
 * @author Ivan Toth.
 * gpp - autocheck tlogs table
 */
var DetailDaysRuleController = (function () {
    function DetailDaysRuleController(topic, settings) {
        this.topic = topic;
        this.settings = settings;
    }
    ;
    DetailDaysRuleController.$inject = ['topic', 'settings'];
    return DetailDaysRuleController;
}());
var DetailDaysRuleComponent = (function () {
    function DetailDaysRuleComponent() {
        this.templateUrl = 'detail-validation-days-rule.html';
        this.controllerAs = 'vm';
        this.controller = DetailDaysRuleController;
    }
    return DetailDaysRuleComponent;
}());
angular
    .module('application')
    .component('detailDaysRule', new DetailDaysRuleComponent());



/**
 * @author Ivan Toth.
 * gpp - autocheck tlogs table
 */
var DetailGppAcController = (function () {
    function DetailGppAcController(topic) {
        this.topic = topic;
        this.visible = false;
    }
    ;
    DetailGppAcController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailGppAcController.$inject = ['topic'];
    return DetailGppAcController;
}());
var DetailGppAcComponent = (function () {
    function DetailGppAcComponent() {
        this.templateUrl = 'detail-validation-gpp-ac.html';
        this.controllerAs = 'vm';
        this.controller = DetailGppAcController;
    }
    return DetailGppAcComponent;
}());
angular
    .module('application')
    .component('detailGppAc', new DetailGppAcComponent());



/**
 * @author Ivan Toth.
 */
var DetailValidGeneralController = (function () {
    function DetailValidGeneralController(topic, Dialog, socket, $stateParams, env, settings, $scope, _) {
        var _this = this;
        this.topic = topic;
        this.Dialog = Dialog;
        this.socket = socket;
        this.$stateParams = $stateParams;
        this.env = env;
        this.settings = settings;
        this.$scope = $scope;
        this._ = _;
        this.comp = 'gpp_valid';
        this.comp2 = 'gpp_history';
        this.updateArray = ['gpp_valid', 'gpp_history'];
        this.paSiteVisibe = false;
        this.paSiteEditable = true;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
        var contactEmail = this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5 ?
            this.topic.topic.contactEmail :
            _.get(this.topic.checksData, 'inboundInitial.inbound.incentiveInformation.incentiveDetail.createdBy');
        var oppVersion = _.get(this.topic.checksData, 'uiVersion', 1);
        this.getNewUIInfo = {
            uiVersion: oppVersion,
            email: contactEmail,
            cmr: _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.incentiveCMRNumber'),
            bpCountry: function () {
                var countryShort;
                countryShort = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.country');
                return _this.topic.getCountryFullName(countryShort);
            },
            accountCountry: function () {
                var countryShort;
                countryShort = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrCountryCode');
                return _this.topic.getCountryFullName(countryShort);
            },
            bpName: function () {
                var bpFirstName;
                var bpLastName;
                if (oppVersion && oppVersion <= _this.OPP_VERSION_4) {
                    bpFirstName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.bpFirstName');
                    bpLastName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.bpLastName');
                }
                else {
                    bpFirstName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.bpFirstName');
                    bpLastName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.bpLastName');
                }
                return bpFirstName + " " + bpLastName;
            },
            getSVISumbitDateName: function () {
                return _this.getNewUIInfo.uiVersion >= _this.OPP_VERSION_3
                    ? 'Submit Date:'
                    : 'Submit Date for CVR Eligibility:';
            },
            submitPaymentDate: function () {
                return _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.submitPaymentDate', _this.topic.topic.gpp_valid[0].svi_submit_for_payment_date);
            },
            paymentComments: function () {
                return _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.paymentComments', _this.topic.topic.gpp_valid[0].svicmnt);
            },
            externalLinks: function (link) { return _this.topic.externalLinks[link]; }
        };
    }
    DetailValidGeneralController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailValidGeneralController.prototype.getAccountValue = function (accountName) {
        var generics = _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.generics');
        var accountObj = generics.find(function (generic) { return generic.name === accountName; });
        return accountObj ? accountObj.value : '';
    };
    DetailValidGeneralController.prototype.getDcId = function () {
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrDomesticClientId');
        }
        else {
            return this.getAccountValue('domesticClientId');
        }
    };
    DetailValidGeneralController.prototype.getDbg = function () {
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrDomesticBuyingGroup');
        }
        else {
            return this.getAccountValue('domesticBuyingGroup');
        }
    };
    DetailValidGeneralController.prototype.changePaVisible = function () {
        this.paSiteVisibe = !this.paSiteVisibe;
    };
    DetailValidGeneralController.prototype.changeEditMode = function (action) {
        if (action === 'save' && this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
            console.log('send for update');
            this.topic.sendForUpdateGeneral(this.updateArray, false);
        }
        if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
            this.topic.setTempFromTopicPart(this.comp2);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    /**
     * opens the dialog with selected field and once its confirmed it changes the temp value
     * @param event - in html I'm passing the $event.
     * @param attribute - string -  identifies which fields edit button was pressed
     * @param name - string -  label of the field
     * @param type - string -  's' - menas string value, 'd'- date value (not implemented yet for date)
     */
    DetailValidGeneralController.prototype.updateField = function (event, attribute, name, type) {
        var _this = this;
        this.items = { item: this.topic.topic.gpp_valid[0][attribute], field: name, type: type };
        this.Dialog.updateValidForm(event, this.items, 'dialog-validation.html').then(function (dResult) {
            if (!angular.isUndefined(dResult)) {
                if (dResult.type === 's') {
                    console.log('changing string');
                    _this.topic.temp.gpp_valid[0][attribute] = dResult.value;
                }
                _this.topic.temp.gpp_history.push({
                    updates: name + '(' + dResult.item + ') has been updated',
                    time: (new Date()).getTime(),
                    source: _this.env.user.email,
                    comment: dResult.comment
                });
            }
        });
    };
    ;
    DetailValidGeneralController.prototype.reload = function () {
        this.topic.loaded.gpp_valid = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'refreshValidationGPP',
                script: '/detail/validation/validation',
                opp: this.topic.topic.opp,
                unid: this.topic.topic._id,
                token: this.env.user.token
            }
        });
    };
    DetailValidGeneralController.prototype.isV4OrLess = function () {
        var version = this.topic.topic.version;
        return !version || version <= this.OPP_VERSION_4;
    };
    DetailValidGeneralController.prototype.getRestricted = function () {
        return this.isV4OrLess() ? this.getRestrictedV4() : this.getRestrictedV5();
    };
    DetailValidGeneralController.prototype.getRestrictedV4 = function () {
        switch (_.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.opportunity.isRestricted')) {
            case 'RESTNOT':
                return 'Not Restricted';
            case 'RESTOPCL':
                return 'Restricted to opportunity team, client team and incentive review team';
            case 'RESTOPTY':
                return 'Restricted to opportunity team and incentive review team';
            default:
                return '';
        }
    };
    DetailValidGeneralController.prototype.getRestrictedV5 = function () {
        switch (this.topic.topic.isRestr) {
            case 'N':
                return 'Not Restricted';
            case 'Y':
                return 'Restricted';
            default:
                return '';
        }
    };
    DetailValidGeneralController.prototype.getRevenueV5 = function () {
        if (this.topic.topic.version >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.opportunityAmount');
        }
        return undefined;
    };
    DetailValidGeneralController.prototype.getOppCurrencyV5 = function () {
        if (this.topic.topic.version >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.opportunityCurrency');
        }
        return undefined;
    };
    DetailValidGeneralController.$inject = ['topic', 'Dialog', 'socket', '$stateParams', 'env', 'settings', '$scope', '_'];
    return DetailValidGeneralController;
}());
var DetailValidGeneralComponent = (function () {
    function DetailValidGeneralComponent() {
        this.templateUrl = 'detail-validation-general.html';
        this.controllerAs = 'vm';
        this.controller = DetailValidGeneralController;
    }
    return DetailValidGeneralComponent;
}());
angular
    .module('application')
    .component('detailValidGeneral', new DetailValidGeneralComponent());



/**
 * @author Ivan Toth.
 */
'use strict';
var DetailGoeValidController = (function () {
    function DetailGoeValidController(topic, $scope) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.lock = true;
        this.completeSection = 'goePick_valid';
        this.comp = 'goe_valid';
        this.updateArray = ['goe_valid'];
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
        this.goeOptions = ['Yes', 'No', 'Unknown', 'State Owned'];
    }
    DetailGoeValidController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailGoeValidController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.sendForUpdateGeneral(this.updateArray, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailGoeValidController.$inject = ['topic', '$scope'];
    return DetailGoeValidController;
}());
var DetailGoeValidComponent = (function () {
    function DetailGoeValidComponent() {
        this.templateUrl = 'detail-goe-valid.html';
        this.controllerAs = 'vm';
        this.controller = DetailGoeValidController;
    }
    return DetailGoeValidComponent;
}());
angular
    .module('application')
    .component('goeValidSection', new DetailGoeValidComponent());



/**
 * @author Ivan Toth.
 * gpp - autocheck tlogs table
 */
var DetailValidDecController = (function () {
    function DetailValidDecController(topic, socket, $stateParams, env) {
        this.topic = topic;
        this.socket = socket;
        this.$stateParams = $stateParams;
        this.env = env;
        this.comp = 'valid_dec';
        this.diffArray = [];
        this.id = $stateParams.id;
    }
    ;
    DetailValidDecController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailValidDecController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            // Check if we can update the values if yes continue to update temp
            this.edit.editMode = this.topic.setTopicFromTempPart(this.comp);
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailValidDecController.prototype.runAutoCheck = function () {
        console.log('I AM CLICKING RUN auto-check');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'runAutoCheck',
                script: '/detail/validation/validation',
                opp: this.id,
                token: this.env.user.token
            }
        });
    };
    DetailValidDecController.$inject = ['topic', 'socket', '$stateParams', 'env'];
    return DetailValidDecController;
}());
var DetailValidDecComponent = (function () {
    function DetailValidDecComponent() {
        this.templateUrl = 'detail-validation-decision.html';
        this.controllerAs = 'vm';
        this.controller = DetailValidDecController;
    }
    return DetailValidDecComponent;
}());
angular
    .module('application')
    .component('detailValidDec', new DetailValidDecComponent());



var detailValidationModelController = (function () {
    function detailValidationModelController(env, DTS, $stateParams, Dialog) {
        this.env = env;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.Dialog = Dialog;
    }
    detailValidationModelController.prototype.closeDialog = function () {
        this.Dialog.closeDialog();
    };
    detailValidationModelController.$inject = ['env', 'DTS', '$stateParams', 'Dialog'];
    return detailValidationModelController;
}());
angular
    .module('application')
    .controller('detailValidationModelController', detailValidationModelController);



/**
 * Created by user on 3/2/2017.
 */
var DetailValidationOdsController = (function () {
    function DetailValidationOdsController(topic, env, socket, $scope, Dialog, settings, notify, $state) {
        var _this = this;
        this.topic = topic;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.settings = settings;
        this.notify = notify;
        this.$state = $state;
        this.OPP_VERSION_4 = 4;
        this.datesValid = false;
        this.showFilterBtn = true;
        this.isFilterSet = true;
        this.custNumber = '';
        this.custName = '';
        this.soNumber = '';
        this.invoiceNumber = '';
        this.bpNumber = '';
        this.isChargeAgreement = false;
        this.bpName = '';
        this.brandFam = [];
        this.siteNum = '';
        this.filters = [];
        this.isFilterToggled = false;
        this.isODSfilter = true;
        this.filterToggles = {
            countries: true,
            sviStats: false,
            dmtStats: false,
            dmtSubStats: false,
            teams: false,
            vap: false,
            isODSfilter: true
        };
        this.processingODS = false;
        this.validationSuccess = false;
        this.socket.forward('odsData.list.creation.done', this.$scope);
        this.$scope.$on('socket:odsData.list.creation.done', function (event, data) {
            _this.showProgress = false;
            _this.topic.goeFired = false; //Set flag to unblock goe button and display message
            if (data.results.msg) {
                var msg = data.results.msg.message || data.results.msg;
                _this.notify.error('There was an error attempting to perform your ODS Search - ' + msg + '.  Please contact the System Administrators for guidance');
            }
            else {
                // console.log(data.results);
                if (!data.results.error) {
                    _this.odsDataList = data.results;
                    _this.createOdsDialog();
                }
                else {
                    var pushMessages = {
                        msgLines: ['No Items Found']
                    };
                    _this.Dialog.showOnlyMessage(pushMessages);
                }
            }
        });
        this.socket.forward('odsData.validation.done', this.$scope);
        this.$scope.$on('socket:odsData.validation.done', function (event, data) {
            _this.topic.goeFired = false; //Set flag to unblock goe button and display message
            alert('validation done');
        });
        this.socket.forward('ods.validation.process', this.$scope);
        this.$scope.$on('socket:ods.validation.process', function (event, data) {
            _this.processingODS = false;
            _this.topic.goeFired = false; //Set flag to unblock goe button and display message
            _this.isChargeAgreement = !!data.isChargeAgreement;
            if (data.err === true) {
                // console.warn('Error on validation of ODS , $detail.validation.ods.component.ts =>', data.msg);
                var msg = data.msg && data.msg.message || data.msg;
                _this.notify.error('There was an error attempting to perform Validation for Sales Order ' + _this.selectedSO + ': ' + msg + '.  Please contact the System Administrators for guidance');
            }
            else {
                _this.validationSuccess = true;
                // console.warn('Finished processing Validation on ' + this.selectedSO + ' =>');
                _this.notify.success('Auto-Validation successfully completed for ' + _this.selectedSO);
                //Could be a couple of scenarios here...
                //1 - user has clicked ODS Search when SAP data already present - this will result in a Dispute
                //2 - no SAP data present...
                var opp_1 = _this.topic.topic._id.substring(4);
                var unid_1 = _this.topic.topic._id;
                var dispute = opp_1.indexOf('-DIS:');
                if (dispute > -1) {
                    //Strip the dispute details from the id so it's just the opp
                    opp_1 = opp_1.substring(0, dispute);
                }
                // Check if the opps updated by io-ws-sap contain this one
                if (data.opps.indexOf(unid_1) < 0) {
                    // if not, we have to assume a new Dispute was created
                    // data.opps will be an array of _ids updated or created by the sap module...
                    // If there's only 1 and it matches the current _id then we can assume the Validation
                    // was performed on this disbursement, therefore trigger a reload
                    // If not the same, then we can assume a Dispute was created - ask user if they wanna open
                    // If more than 1...
                    if (data.opps.length === 1) {
                        //Ask user if they wanna open the new dispute
                        var items = {
                            icon: 'QUESTION',
                            message: 'The Auto-Validation process has been successful and Dispute <b>' + data.opps[0] + '</b> has been created as a result.<br><br>Do you want to open it now?',
                            title: 'Auto-Validation'
                        };
                        //Ask it...
                        _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                            //If clicked no
                            if (!dResult.confirm) {
                                //Update the topic to append the dispute number (don't bother with history)
                                _this.topic.addDisputeDetails({ unid: data.opps[0] });
                                _this.topic.setActionButtons(); //Make call on the hide/show for the action buttons
                            }
                            else {
                                _this.$state.go('detail.general', {
                                    id: data.opps[0].substring(4)
                                });
                            }
                        });
                    }
                    else {
                        if (!_this.isChargeAgreement) {
                            var ids_1 = '';
                            angular.forEach(data.opps, function (id) {
                                ids_1 = id;
                                if (ids_1.length === 0) {
                                    ids_1 += '<br>' + id;
                                }
                            });
                            //Prepare to ask question...based on event
                            var items = {
                                icon: 'INFO',
                                message: 'The following Disbursements were updated or created as a result of the Auto-Validation:<br><br>' +
                                    ids_1 + '<br><br>Access any new Disputes via the original Disbursement\'s Actions.',
                                title: 'Auto-Validation'
                            };
                            //Block
                            _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                                return false;
                            });
                        }
                    }
                }
                else {
                    //If no general errors object parsed, or they have been but all resolved, all should be good and calcs have been fired
                    if (!_this.isChargeAgreement && angular.isUndefined(data.general_errors) || (angular.isDefined(data.general_errors) && data.general_errors.unresolved === 0)) {
                        //Prompt user...
                        var items = {
                            icon: 'INFO',
                            message: 'The Auto-Validation process has been successful and the Auto-Calculation process has started.<br><br>' +
                                '<b style="color:red">WARNING:</b> &nbsp;Please wait a few seconds before clicking OK - the Calculations may not have completed and ' +
                                'the Disbursement details will be incorrect. &nbsp;If this is the case press F5 to refresh.',
                            title: 'Auto-Validation'
                        };
                        //Ask it...
                        _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                            //If clicked no
                            if (dResult.confirm) {
                                //If no sap data there, reload the page in order to see the results...ideally update validation code to send sap obby back
                                _this.topic.clearTopic(_this.topic.topic._id.substring(4));
                                _this.socket.emit('module', {
                                    module: {
                                        application: 'dmt',
                                        function: 'loadDataClient',
                                        script: '/detail/general/general',
                                        data: {
                                            opp: opp_1,
                                            unid: unid_1
                                        },
                                        token: _this.env.user.token
                                    }
                                });
                            }
                        });
                    }
                }
            }
        });
    }
    DetailValidationOdsController.prototype.select = function ($event) {
        $event.target.select();
    };
    DetailValidationOdsController.prototype.createOdsDialog = function () {
        var _this = this;
        var isV4OrLater = this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_4;
        this.Dialog.createODSList(this.odsDataList, isV4OrLater).then(function (dResult) {
            if (dResult !== null) {
                for (var i = 0; i < dResult.data.itemList.length; i++) {
                    dResult.data.itemList[i].opp = _this.topic.topic.opp;
                    delete dResult.data.itemList[i].$$hashKey;
                    delete dResult.data.itemList[i].brandfam;
                    delete dResult.data.itemList[i].brandfamDesc;
                }
                delete dResult.data.$$hashKey;
                _this.selectedSO = dResult.data.soNumber;
                _this.processingODS = true;
                _this.validationSuccess = false;
                //If the 2nd GOE is needed and has not been performed yet, it will automatically happen during the io-ws-sap run...
                if (_this.topic.is2ndGOENeeded() && !_this.topic.is2ndGOEComplete()) {
                    _this.topic.goeFired = true; //Set flag to block goe button and display message
                }
                _this.socket.emit('module', {
                    module: {
                        bID: _this.topic.topicBrowserID,
                        application: 'dmt',
                        function: 'pushODSItem',
                        script: '/validation/odsTables',
                        //email: this.env.user.email,
                        program: _this.topic.topic.program,
                        iot: _this.topic.topic.iot,
                        soNumber: dResult.data,
                        isChargeAgreement: _this.isChargeAgreement,
                        invoice_numbers: dResult.invoice,
                        id: _this.topic.topic._id,
                        user: _this.env.user
                    }
                });
            }
        });
    };
    DetailValidationOdsController.prototype.$onInit = function () {
        this.ctyCode = this.topic.topic.country;
        if (angular.isDefined(this.topic.topic.gpp_valid) && this.topic.topic.gpp_valid.length > 0) {
            this.custName = angular.isDefined(this.topic.topic.gpp_valid[0].acctname) ? this.topic.topic.gpp_valid[0].acctname : '';
        }
        this.isChargeAgreement = this.topic.topic.isChargeAgreement || false;
    };
    DetailValidationOdsController.prototype.checkValidity = function () {
        if (angular.isDefined(this.startDate) && angular.isDefined(this.endDate) &&
            this.startDate !== null && this.endDate !== null) {
            var range = 0;
            if (angular.isDate(this.startDate) && angular.isDate(this.endDate)) {
                range = Math.round((this.endDate - this.startDate) / (1000 * 60 * 60 * 24));
                if (range > 90) {
                    this.dateError = '* The Start/End Date range (' + range + ' days) is invalid.  Must be no greater than 90 days';
                    this.datesValid = false;
                    return;
                }
            }
            else {
                this.dateError = '* Either Start or End Date is invalid';
                this.datesValid = false;
                return;
            }
        }
        else if (angular.isDefined(this.startDate) && angular.isUndefined(this.endDate)) {
            this.dateError = '* Please enter the End Date';
            this.datesValid = false;
            return;
        }
        else if (angular.isUndefined(this.startDate) && angular.isDefined(this.endDate)) {
            this.dateError = '* Please enter the Start Date';
            this.datesValid = false;
            return;
        }
        this.datesValid = true;
        this.dateError = '';
        /*
                if (typeof this.startDate === 'undefined' || this.startDate === 0
                    || typeof this.endDate === 'undefined' || this.endDate === 0
                    || (this.startDate > this.endDate && (typeof this.endDate !== 'undefined' || this.endDate !== 0))
                    || Math.round((this.endDate - this.startDate) / (1000 * 60 * 60 * 24)) > 90) {
                    this.datesValid = false;
                } else {
                    this.datesValid = true;
                }*/
    };
    DetailValidationOdsController.prototype.filterToggle = function () {
        this.isFilterToggled = !this.isFilterToggled;
    };
    DetailValidationOdsController.prototype.applyFilter = function () {
        this.showProgress = true;
        if (this.brandFam.length === 0) {
            for (var i = 0; i < this.topic.topic.gpp.length; i++) {
                this.brandFam.push();
            }
        }
        var data = {
            service: 'RA',
            parameters: {
                customerNumber: this.custNumber.length > 0 ? this.topic.strRight('0000000000' + this.custNumber, 10) : undefined,
                customerName: this.custName.length > 0 ? this.custName : undefined,
                salesOrderNumber: this.soNumber.length > 0 ? this.topic.strRight('0000000000' + this.soNumber, 10) : undefined,
                SapBillgDocNum: this.invoiceNumber.length > 0 ? this.invoiceNumber : undefined,
                countryCode: this.ctyCode.length > 0 ? this.ctyCode.toUpperCase() : undefined,
                start_date: this.startDate.getFullYear() + ''
            }
        };
        /*
            Example below...
        {
            "service": "RA",
            "parameters": {
                "customerName": "Flexibreak",       <- SoldToCustName
                "customerNumber": "0003698020",     <- SoldToCustNum
                "sales_order_start_date": "2017-06-01",  <-- BillgOrdSalesOrdDate (MAND)
                "sales_order_end_date": "2017-06-30",  <-- BillgOrdSalesOrdDate (MAND)
                "salesOrderNumber": "0060628991",      < -- SapSalesOrdNum
                "countryCode": "ZA"                      < --- SoldToCntryCode2?
                }
        }
    
        */
        // Lose any undefined elements... these may be set or not
        this.loseUndefined(['customerNumber', 'countryCode', 'customerName', 'salesOrderNumber', 'SapBillgDocNum'], data.parameters);
        // Set Start and end dates
        if ((this.startDate.getMonth() + 1 + '').length === 1) {
            data.parameters.start_date += '0' + (this.startDate.getMonth() + 1);
        }
        else {
            data.parameters.start_date += (this.startDate.getMonth() + 1) + '';
        }
        if (this.startDate.getDate().toString().length === 1) {
            data.parameters.start_date += '0' + this.startDate.getDate() + '000000';
        }
        else {
            data.parameters.start_date += this.startDate.getDate() + '000000';
        }
        if (typeof this.endDate !== 'undefined' && this.endDate !== null && this.endDate !== 0) {
            data.parameters['end_date'] = this.endDate.getFullYear() + '';
            if ((this.endDate.getMonth() + 1 + '').length === 1) {
                data.parameters['end_date'] += '0' + (this.endDate.getMonth() + 1);
            }
            else {
                data.parameters['end_date'] += (this.endDate.getMonth() + 1) + '';
            }
            if (this.endDate.getDate().toString().length === 1) {
                data.parameters['end_date'] += '0' + this.endDate.getDate() + '000000';
            }
            else {
                data.parameters['end_date'] += this.endDate.getDate() + '000000';
            }
        }
        //Set Sales Order Date fields...  
        data.parameters['sales_order_start_date'] = data.parameters['start_date'].substring(0, 4) + '-' + data.parameters['start_date'].substring(4, 6) + '-' + data.parameters['start_date'].substring(6, 8);
        data.parameters['sales_order_end_date'] = data.parameters['end_date'].substring(0, 4) + '-' + data.parameters['end_date'].substring(4, 6) + '-' + data.parameters['end_date'].substring(6, 8);
        // And lose the Start/End Dates
        delete data.parameters.start_date;
        delete data.parameters.end_date;
        console.info('ODS Search Parameters: ', data.parameters);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'sendForODS',
                script: '/validation/odsTables',
                email: this.env.user.email,
                data: data,
                token: this.env.user.token
            }
        });
    };
    DetailValidationOdsController.prototype.loseUndefined = function (paramsToCheck, params) {
        for (var _i = 0, paramsToCheck_1 = paramsToCheck; _i < paramsToCheck_1.length; _i++) {
            var p = paramsToCheck_1[_i];
            if (angular.isUndefined(params[p])) {
                delete params[p];
            }
        }
    };
    DetailValidationOdsController.$inject = ['topic', 'env', 'socket', '$scope', 'Dialog', 'settings', 'notify', '$state'];
    return DetailValidationOdsController;
}());
var DetailValidationOdsComponent = (function () {
    function DetailValidationOdsComponent() {
        this.templateUrl = 'detail-validation-ods.html';
        this.controllerAs = 'vm';
        this.controller = DetailValidationOdsController;
    }
    return DetailValidationOdsComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('search', '/public/images/ic_search_black_24px.svg');
})
    .component('detailValidationOds', new DetailValidationOdsComponent());



/**
 * @author Ivan Toth.
 * gpp - autocheck tlogs table
 */
var INC_COMMENTS = {
    solutionId: 'pnEngagement',
    salesCheck: 'pnSalesInc',
    focusCheck: 'pnFocus',
    growthCheck: 'pnGrowth',
    ctlCheck: 'pnCtl'
};
//TODO - do a common code
//NOTE: failed InsentiveRule can be RED or YELLOW
var IconColor;
(function (IconColor) {
    IconColor[IconColor["GREEN"] = 'green'] = "GREEN";
    IconColor[IconColor["ORANGE"] = 'orange'] = "ORANGE";
    IconColor[IconColor["PINK"] = 'pink'] = "PINK";
    IconColor[IconColor["RED"] = 'red'] = "RED";
})(IconColor || (IconColor = {}));
var isIncentive = function (ruleModuleId) {
    return ['salesCheck', 'solutionId', 'focusCheck', 'growthCheck', 'ctlCheck'].indexOf(ruleModuleId) !== -1;
};
var countInsentiveRules = function (pnRiles) {
    return Array.isArray(pnRiles) ? pnRiles.filter(isIncentive).length : 0;
};
var hasAllIncentivesFailed = function (pnRiles) {
    var incRulesLen = countInsentiveRules(pnRiles.map(function (it) { return it.model; }));
    return incRulesLen > 0 && pnRiles.filter(function (it) { return isIncentive(it.model) && it.iconColor === IconColor.GREEN; }).length === 0;
};
var hasNonIncentiveRuleFailed = function (pnRiles) {
    return pnRiles.filter(function (it) { return !isIncentive(it.model) && it.iconColor === IconColor.RED; }).length > 0;
};
var hasAnyValidIncentiveResult = function (pnItem) {
    var pnItemResult = pnItem.result;
    return !pnItemResult ? false
        : Object.keys(pnItemResult)
            .filter(function (k) { return isIncentive(k) && (pnItemResult[k] === true || (pnItemResult[k] && pnItemResult[k].result === true)); }).length > 0;
};
var isIncResolved = function (rule, pnObj) {
    var incComment = INC_COMMENTS[rule];
    if (incComment) {
        return pnObj.result[rule] === false && pnObj.comments[incComment];
    }
    else {
        return false;
    }
};
var PENDING_BILLINGS_STATUS = 'Pending Billing Orders';
var DetailSOEvalController = (function () {
    function DetailSOEvalController(topic, $stateParams, settings, env, socket, $scope, Dialog, $state, $filter, moment) {
        var _this = this;
        this.topic = topic;
        this.$stateParams = $stateParams;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.$state = $state;
        this.$filter = $filter;
        this.moment = moment;
        this.pnsRules = [];
        this.pnsComments = [];
        this.orderRules = [];
        this.isSaasValid = false;
        this.orderData = {};
        this.APPROVED_ARR = ['Approved', 'Not Approved'];
        this.pnsGrowthComments = [];
        this.pnsSalesIncComments = [];
        this.pnsEngagementComments = [];
        this.pnsFocusComments = [];
        this.pnsCtlComments = {};
        this.orderRulesNames = ['ceidMatch', 'eligibilityStatus', 'endUserMatch', 'cntrySOMatch', 'distributionChannelMatch', 'dateSOMatch',
            'sodVSsvid', 'saasPaymentRange', 'isThresholdValid', 'prefDistMatch', 'coverageSaaS', 'isDirect', 'saasNotMixed', 'applicability', 'cmrCheck', 'goeReview'];
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.isUpdating = false;
        this.rowIdArr = [];
        this.brandfamArr = [];
        this.solutionIdMap = new Map();
        this.getNewUIInfo = {
            uiVersion: _.get(this.topic.checksData, 'uiVersion', 1)
        };
        this.socket.forward('sap.validation.reval.done', this.$scope);
        this.$scope.$on('socket:sap.validation.reval.done', function (event, data) {
            _this.isUpdating = false;
        });
        this.socket.forward('detail.sap.reset.comments', this.$scope);
        this.$scope.$on('socket:detail.sap.reset.comments', function (event, data) {
            // Remove old objects to unlock comments
            data.topic.sap.forEach(function (e) { return delete e.comments.pnOverall; });
            data.topic.sap.forEach(function (e) { return delete e.comments.pnAutofail; });
            for (var i = 0; i < _this.pnsRules.length; i++) {
                _this.checkIfPnFails(i);
            }
            // Filter out only those rules which need to fail
            Object.filter = function (obj, predicate) {
                return Object.keys(obj)
                    .filter(function (key) { return predicate(obj[key]); })
                    .reduce(function (res, key) { return (res[key] = obj[key], res); }, {});
            };
            var filteredRules = Object.filter(_this.orderData.comments, function (rule) { return rule.isFinal; });
            // Fail this rules to provide override
            Object.getOwnPropertyNames(filteredRules).forEach(function (key) { return filteredRules[key].isFinal = false; });
            // Save new 'sap' object
            var obj = {
                data: (_a = {},
                    _a['sap'] = {
                        add: true,
                        data: data.topic.sap
                    },
                    _a
                ),
                id: _this.topic.topic._id,
                isChargeAgreement: _this.topic.topic.isChargeAgreement || false,
                type: ['sap']
            };
            _this.topic.updateServerTopic('couchUpdate', obj, true);
            _this.topic.topic.sap = data.topic.sap;
            _this.setEverything();
            _this.isUpdating = false;
            var _a;
        });
        this.socket.forward('detail.sap.revalidation', this.$scope);
        this.$scope.$on('socket:detail.sap.revalidation', function (event, data) {
            _this.isUpdating = false;
            if (typeof data.topic !== 'undefined' && typeof data.topic.calculation !== 'undefined'
                && typeof data.topic.calculation.children !== 'undefined' && data.topic.calculation.children.length > 0) {
                // open up the Calcs and Payment tab
                for (var i = 0; i < _this.topic.tabs.list.length; i++) {
                    if (_this.topic.tabs.list[i].name === 'detail.payment') {
                        _this.topic.tabs.list[i].editable = true;
                        _this.topic.tabs.list[i].visible = true;
                        break;
                    }
                }
                _this.topic.setActiveTab('payment');
                // Go to calcs/payments tab
                _this.$state.go('detail.payment', $stateParams);
            }
        });
        this.socket.forward('sap.validation.reval.done', this.$scope);
        this.$scope.$on('socket:sap.validation.reval.done', function (event, data) {
            _this.topic.updateTopic({ sap: data.sap }, false, []);
            var pushMessages = {
                msgLines: ['Order has been reevaluated']
            };
            _this.Dialog.showOnlyMessage(pushMessages);
        });
        this.socket.forward('validation.updateStatus', this.$scope);
        this.$scope.$on('socket:validation.updateStatus', function (event, data) {
            if ((typeof data !== 'undefined' && data.isChargeAgreement) || _this.topic.topic.isChargeAgreement) {
                _this.changeCAStatus();
            }
        });
        this.socket.forward('ods.validation.update', this.$scope);
        this.$scope.$on('socket:ods.validation.update', function (event, data) {
            _this.topic.topic.sap = data.sap;
            _this.setEverything();
        });
    }
    DetailSOEvalController.prototype.setEverything = function () {
        var _this = this;
        if (this.topic.topic.sap) {
            this.setOrderData();
            this.setOrderRules();
            this.setPnsRules(function () { return _this.checkPnRules(); });
        }
    };
    DetailSOEvalController.prototype.changeCAStatus = function () {
        this.isSaasValid = true;
        //DMT-5070 : PENDING_BILLINGS_STATUS is not required to be set from the code logic
        /*if (this.topic.temp_ext.sub_status !== PENDING_BILLINGS_STATUS) {
            this.topic.temp_ext.sub_status = PENDING_BILLINGS_STATUS;
            this.topic.sendForUpdate(['status'], '', 'Sub-Status changed to ' + PENDING_BILLINGS_STATUS, false);
        }*/
    };
    DetailSOEvalController.prototype.$onInit = function () {
        var _this = this;
        // fill the brand family array to show which solution IDs are being compared
        this.setBrandArray();
        //if (this.topic.topic.sap) {
        //this.checkSaas();
        this.setEverything();
        //}
        var sap = this.topic.topic.sap;
        // should only be applicable for oppty that the SAP service didn't fill for PPS
        if (typeof sap !== 'undefined') {
            sap.forEach(function (pn, index) {
                _this.pnsComments.push('');
            });
        }
    };
    DetailSOEvalController.prototype.getCustomerDesignation = function (data) {
        var customerDesignationODS = data.customerSegmentCode || data.TranIBMCustSegmnttnCodeDscr;
        var CustomerDesignationMap = {
            'bp': 'BP-Led',
            'bp-led': 'BP-Led',
            'co': 'Co-Led',
            'co-led': 'Co-Led',
            'ibm': 'IBM-Led',
            'ibm-led': 'IBM-Led',
            'unas': undefined,
            'unkn': undefined
        };
        if (customerDesignationODS && CustomerDesignationMap.hasOwnProperty(customerDesignationODS.toLocaleLowerCase())) {
            customerDesignationODS = CustomerDesignationMap[customerDesignationODS.toLocaleLowerCase()];
        }
        else {
            customerDesignationODS = undefined;
        }
        return (this.topic.topic.customerDesignation && customerDesignationODS) || (!this.topic.topic.customerDesignation && customerDesignationODS) ? customerDesignationODS : 'N/A';
    };
    DetailSOEvalController.prototype.save = function (key, rule) {
        var _this = this;
        var items = {
            addCancel: true,
            cancelMessage: 'Fail',
            dialogName: 'Manual Validation Rule Decision',
            message: 'Please confirm the final Validation Rule status, or click Cancel to quit:',
            okMessage: 'Pass'
        };
        this.Dialog.YesNoForm('', items, 'yes-no.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.orderData.comments[rule].isFinal = true;
                _this.orderData.comments[rule].passFlag = true;
            }
            else if (!dResult.confirm) {
                _this.orderData.comments[rule].isFinal = true;
                _this.orderData.comments[rule].passFlag = false;
            }
            _this.topic.topic.sap[0].comments[rule] = _this.orderData.comments[rule];
            _this.uploadResults(key, rule, _this.orderData.comments[rule]);
            return;
        });
    };
    DetailSOEvalController.prototype.checkSaas = function () {
        // if entry has a SA attached and  all validation rules pass, then change status to Pending Billing Orders
        if ((this.topic.topic.complete.statusComplete['4'] || this.topic.topic.complete['sap'] &&
            this.topic.topic.complete.errorsArray['sap'].length === 0)
            && this.topic.topic.isChargeAgreement
            && !(this.topic.topic.calculation)) {
            this.isSaasValid = true;
        }
    };
    DetailSOEvalController.prototype.isValueDisplayed = function (rule, pn) {
        return rule.model !== 'focusCheck' || rule.model !== 'growthCheck' ||
            (rule.model === 'focusCheck' && (pn.result.focusCheck || pn.comments.pnFocus));
    };
    DetailSOEvalController.prototype.savePn = function (key, pn, text) {
        var _this = this;
        var items = {
            addCancel: true,
            cancelMessage: 'Fail',
            dialogName: 'Manual Validation Rule Decision',
            message: 'Please confirm the final Validation Rule status, or click Cancel to quit:',
            okMessage: 'Pass'
        };
        this.Dialog.YesNoForm('', items, 'yes-no.html').then(function (dResult) {
            if (dResult.confirm) {
                pn.comments.pnOverall = {
                    isFinal: true,
                    passFlag: true,
                    text: text
                };
                pn.comments.pnFocus = {
                    isFinal: true,
                    passFlag: true,
                    text: _this.pnsFocusComments[key]
                };
                pn.comments.pnEngagement = {
                    isFinal: true,
                    passFlag: true,
                    text: _this.pnsEngagementComments[key]
                };
                pn.comments.pnCtl = {
                    isFinal: true,
                    passFlag: true,
                    text: _this.pnsCtlComments[key]
                };
                pn.comments.pnGrowth = {
                    isFinal: true,
                    passFlag: true,
                    text: _this.pnsGrowthComments[key]
                };
                pn.comments.pnSalesInc = {
                    isFinal: true,
                    passFlag: true,
                    text: _this.pnsSalesIncComments[key]
                };
                pn.comments.pnIncentiveStatus = {
                    isFinal: true,
                    passFlag: true
                };
            }
            else if (!dResult.confirm) {
                pn.comments.pnOverall = {
                    isFinal: true,
                    passFlag: false,
                    text: text
                };
                pn.comments.pnFocus = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsFocusComments[key]
                };
                pn.comments.pnCtl = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsCtlComments[key]
                };
                pn.comments.pnEngagement = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsEngagementComments[key]
                };
                pn.comments.pnGrowth = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsGrowthComments[key]
                };
                pn.comments.pnSalesInc = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsSalesIncComments[key]
                };
                pn.comments.pnIncentiveStatus = {
                    isFinal: true,
                    passFlag: false,
                    text: 'failed manually'
                };
            }
            _this.uploadResults(0, 'pnOverall', { text: text });
            _this.setEverything();
            //this.setPnsRules(() => this.checkPnRules());
            return;
        });
    };
    DetailSOEvalController.prototype.failPart = function (event, index, part) {
        var _this = this;
        this.Dialog.updateValidForm(event, {}, 'auto-fail-dialog.html').then(function (dResult) {
            if (_.isUndefined(dResult)) {
                return;
            }
            var NOT_APPROVED = 'Not Approved';
            var APPROVED = 'Approved';
            var pnId = _.get(part, 'data.itemList[0].pn');
            // If so.data element in question AND has itemList and result
            if (!_.isUndefined(pnId) && !_.isUndefined(part.result) && !_.isUndefined(part.comments) && Array.isArray(_this.pnsRules[index])) {
                _this.pnsRules[index]
                    .map(function (el) { return el.model; })
                    .forEach(function (rule) {
                    part.result[rule] = false;
                    part.comments[rule] = {
                        isFinal: true,
                        passFlag: false,
                        text: dResult.afBundle.comment
                    };
                });
                part.comments.pnAutofail = {
                    isFinal: true,
                    passFlag: false,
                    text: dResult.afBundle.comment
                };
                //incentives
                part.comments.pnFocus = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsFocusComments[pnId] || NOT_APPROVED
                };
                part.comments.pnCtl = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsCtlComments[pnId] || NOT_APPROVED
                };
                part.comments.pnEngagement = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsEngagementComments[pnId] || NOT_APPROVED
                };
                part.comments.pnGrowth = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsGrowthComments[pnId] || NOT_APPROVED
                };
                part.comments.pnSalesInc = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsSalesIncComments[pnId] || NOT_APPROVED
                };
                var isPnIncentiveStatusPassed = _this.pnsFocusComments[pnId] === APPROVED
                    || _this.pnsCtlComments[pnId] === APPROVED
                    || _this.pnsEngagementComments[pnId] === APPROVED
                    || _this.pnsGrowthComments[pnId] === APPROVED
                    || _this.pnsSalesIncComments[pnId] === APPROVED;
                part.comments.pnIncentiveStatus = {
                    isFinal: true,
                    passFlag: isPnIncentiveStatusPassed
                };
            }
            var oneComment = { text: "All Errored Valdation Rules for Part Auto-Failed : " + dResult.afBundle.comment };
            _this.uploadResults(index, 'pnAutofail', oneComment);
            _this.setPnsRules(function () { return _this.checkPnRules(); });
        });
    };
    DetailSOEvalController.prototype.failSO = function (event) {
        var _this = this;
        this.Dialog.updateValidForm(event, {}, 'auto-fail-dialog.html').then(function (dResult) {
            if (!angular.isUndefined(dResult)) {
                _this.orderData.pns.forEach(function (pn) {
                    _this.orderRules.map(function (el) { return el.model; }).forEach(function (rule) {
                        pn.result[rule] = false;
                        pn.comments[rule] = {
                            isFinal: true,
                            passFlag: false,
                            text: dResult.afBundle.comment
                        };
                        _this.orderData.result[rule] = false;
                    });
                    pn.comments.soAutofail = {
                        isFinal: true,
                        passFlag: false,
                        text: dResult.afBundle.comment
                    };
                });
                var oneComment = { text: "All Errored Valdation Rules for Order Auto-Failed : " + dResult.afBundle.comment };
                _this.uploadResults(0, 'soAutofail', oneComment);
                _this.checkPnRules();
            }
        });
    };
    DetailSOEvalController.prototype.uploadResults = function (key, prop, oneComment) {
        this.isUpdating = true;
        var whereChange = this.topic.topic.sap[key].data.soNumber + "-" + this.topic.topic.sap[key].data.itemList[0].pn + ", " + prop;
        var sapObj = JSON.parse(JSON.stringify(this.topic.topic.sap));
        for (var i = 0; i < sapObj.length; i++) {
            delete sapObj[i].$$hashKey;
        }
        var data = {
            data: (_a = {},
                _a['comments.validation'] = {
                    data: [{
                            comment: whereChange + ": " + oneComment.text,
                            user: this.env.user.email
                        }],
                    push: true
                },
                _a['sap'] = {
                    add: true,
                    data: sapObj
                },
                _a
            ),
            id: this.topic.topic._id,
            isChargeAgreement: this.topic.topic.isChargeAgreement || false,
            type: ['comments', 'sap']
        };
        this.topic.updateServerTopic('couchUpdate', data, true);
        this.checkSaas();
        this.isUpdating = false;
        var _a;
    };
    DetailSOEvalController.prototype.retrigisOrValCheck = function (e) {
        var _this = this;
        this.topic.topic.sap.forEach(function (pn) {
            if (pn.data.itemList[0].curCode.trim() === _this.topic.topic.gpp_valid[0].crncy.trim()) {
                pn.result.isSameCur = true;
            }
        });
        var whereChange = 'Validity rechecked';
        var sapObj = JSON.parse(JSON.stringify(this.topic.topic.sap));
        var data = {
            data: (_a = {},
                _a['comments.validation'] = {
                    data: [{
                            comment: whereChange,
                            user: this.env.user.email
                        }],
                    push: true
                },
                _a['sap'] = {
                    add: true,
                    data: sapObj
                },
                _a
            ),
            id: this.topic.topic._id,
            isChargeAgreement: this.topic.topic.isChargeAgreement || false,
            type: ['comments', 'sap']
        };
        this.topic.updateServerTopic('couchUpdate', data, true);
        var _a;
    };
    /**
     * Function to trigger the Calculation stage
     * @param event Angular Event
     */
    DetailSOEvalController.prototype.reEvaluate = function (event) {
        var _this = this;
        var validCount = this.topic.topic.sap.length; // Count the number of parts that are 100% valid...assume they all are
        var allValid = true;
        // Work out if any of the parts are bad....
        this.topic.topic.sap.forEach(function (pn, index) {
            if (!_this.isPnPassed(pn, index)) {
                validCount--;
                allValid = false;
                pn.result.isWholeOpptyValid = false;
            }
            else {
                pn.result.isWholeOpptyValid = true;
            }
        });
        // Bundle for the pop-up
        var items = {
            calcBundle: {
                topic: this.topic.topic,
                valid: validCount
            }
        };
        // Prompt user
        this.Dialog.openDialog(event, items, '', 'reval-confirmation.html', '').then(function (dResult) {
            if (dResult.confirm) {
                _this.isUpdating = true;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        bID: _this.topic.topicBrowserID,
                        data: {
                            docId: _this.topic.topic._id,
                            email: _this.env.user.email,
                            errorReset: allValid,
                            oppVersion: _this.topic.topic.version,
                            sap: _this.topic.topic.sap
                        },
                        email: _this.env.user.email,
                        function: 'triggerCalculationClient',
                        className: 'CalculationGate',
                        script: '/detail/payment/calculationGate',
                        user: _this.env.user
                    }
                });
            }
            return;
        });
    };
    DetailSOEvalController.prototype.unlockComments = function () {
        this.isUpdating = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                docId: this.topic.topic._id,
                email: this.env.user.email,
                function: 'unlockComments',
                script: '/validation/validationTables',
                token: this.env.user.token
            }
        });
    };
    DetailSOEvalController.prototype.formatDate = function (date) {
        if (/\d{4}-\d{2}-\d{2}/.test(date)) {
            return this.moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD');
        }
        else if (/\d{2}\/\d{2}\/\d{4}/.test(date)) {
            return this.moment(date, 'MM-DD-YYYY').format('YYYY-MM-DD');
        }
        else if (/\d{2}.\d{2}.\d{4}/.test(date)) {
            return this.moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');
        }
        else if (/\d{4}-\d{2}-\d{2}T[\S]+/.test(date)) {
            return this.moment(date, 'YYYY-MM-DD HH:mm Z').format('YYYY-MM-DD');
        }
        else if (/\d{8}/.test(date)) {
            return this.moment(date, 'YYYYMMDD').format('YYYY-MM-DD');
        }
        else {
            var dateParsed = this.moment(date);
            if (dateParsed.isValid()) {
                return dateParsed.format('YYYY-MM-DD');
            }
            else {
                console.error("So date in a wrong format! " + date);
                return 'Invalid Date';
            }
        }
    };
    DetailSOEvalController.prototype.setOrderData = function () {
        var order = this.topic.topic.sap[0];
        if (!order) {
            return;
        }
        this.orderData.soNumber = order.data.soNumber;
        this.orderData.pns = this.topic.topic.sap;
        this.orderData.result = this.setOrderResult(this.orderData.pns);
        this.orderData.bpCEID = order.data.itemList[0].bpCEID;
        this.orderData.comparedSviStat = order.data.comparedSviStat;
        this.orderData.endUserName = order.data.endUserName;
        this.orderData.bpNumber = order.data.bpNumber;
        this.orderData.t2Number = order.data.t2Number;
        this.orderData.LOB = order.data.LOB;
        this.orderData.t2cty = order.data.t2cty;
        this.orderData.chargeAgreementStartDate = this.isMdlTypeCodeExist(this.topic.topic.sap)
            ? this.formatDate(order.data.itemList[0].chargeAgreementStartDate)
            : this.formatDate(order.data.soDate);
        this.orderData.prefDist = order.data.prefDist;
        this.orderData.cnum = order.data.cnum;
        this.orderData.comments = order.comments;
        this.orderData.isu = order.data.isu;
        this.orderData.curCode = order.data.itemList[0].curCode;
        this.orderData.firstItem = order.data.itemList[0];
        this.orderData.chanCode = order.data.chanCode;
        this.orderData.mdlTypeCode = order.data.mdlTypeCode;
        // foundRnA was replaced with isAssist, but support old oppties
        this.orderData.isAssist = this.topic.topic.isAssist !== undefined ? this.topic.topic.isAssist : order.data.foundRnA;
        this.orderData.coverageTerm = order.data.itemList[0].coverageTerm;
        this.orderData.totalRevenue = order.data.totalRevenue;
        this.orderData.invoiceNo = Array.from(new Set(this.topic.topic.sap.map(function (el) { return el.data.invoiceNo; })));
        this.orderData.resellerBp = this.orderData.bpCEID && this.topic.topic.bp_cei && this.topic.topic.bp_cei === this.orderData.bpCEID ? 'Yes' : 'No';
    };
    DetailSOEvalController.prototype.getLicenseTypeName = function (mdlTypeCode) {
        return Array.isArray(this.topic.topic.licenseTypes)
            && this.topic.topic.licenseTypes
                .filter(function (it) { return it && it.type === mdlTypeCode; })
                .map(function (it) { return it.name; })
                .pop()
            || mdlTypeCode;
    };
    DetailSOEvalController.prototype.isMdlTypeCodeExist = function (sap) {
        var types = ['SS', 'ML', 'SL'];
        for (var _i = 0, sap_1 = sap; _i < sap_1.length; _i++) {
            var el = sap_1[_i];
            return types.includes(el.data.mdlTypeCode);
        }
    };
    /**
     * Function to define all the SOV Rules... each should be a IvRule object containing a:
     * n: rule number
     * title: rule name
     * model: the angular model name
     * infoOnly: this is optional and most won't have the value - if it's set it means that
     * if the rule fails, the user will not have to enter a reason to pass it
     */
    DetailSOEvalController.prototype.setOrderRules = function () {
        var _this = this;
        var rules = [];
        if (_.get(this, "topic.topic.sales_assist.type", 'CVR Sales Assist') !== 'CVR Sales Assist') {
            rules.push({ n: 1, title: 'SO CEID vs Opportunity CEID', model: 'ceidMatch', value: this.orderData.bpCEID + " vs " + this.topic.topic.bp_cei });
        }
        //TODO - STUB fix - should be a better solution
        if (!this.orderData.result) {
            this.orderData.result = {};
        }
        var gpp_valid = this.topic.topic.gpp_valid[0] || {};
        var eligbilityStatus;
        if (this.orderData.result.eligibilityStatus && this.orderData.comparedSviStat === undefined) {
            eligbilityStatus = "Yes";
        }
        else if (!this.orderData.result.eligibilityStatus && this.orderData.comparedSviStat === undefined) {
            eligbilityStatus = "No";
        }
        else if (this.orderData.comparedSviStat !== undefined) {
            eligbilityStatus = "Used status: " + this.orderData.comparedSviStat;
        }
        rules.push({ n: 2, title: 'Is Eligibility Status Found in Validation Tables', model: 'eligibilityStatus', value: eligbilityStatus });
        rules.push({
            n: 3, title: 'BP vs End User', model: 'endUserMatch',
            value: this.orderData.t2Number + " vs " + (this.orderData.LOB === 'VP' || this.orderData.LOB === 'SP' ? this.orderData.endUserName : this.orderData.bpNumber)
        });
        rules.push({ n: 4, title: 'Country Eligibility', model: 'cntrySOMatch', value: "" + this.orderData.t2cty });
        rules.push({ n: 5, title: 'Distribution Channel', model: 'distributionChannelMatch', value: "" + this.orderData.chanCode });
        rules.push({
            n: 6, title: 'Sales Order vs Expiration Date', model: 'dateSOMatch',
            value: this.orderData.chargeAgreementStartDate + " vs " + this.moment(Number(gpp_valid.sviexpdate)).format('YYYY-MM-DD')
        });
        rules.push({
            n: 7, title: 'Is the SO Date after the Submit Date', model: 'sodVSsvid',
            value: this.orderData.chargeAgreementStartDate + " vs " + this.moment(Number(gpp_valid.svisubmitdate)).format('YYYY-MM-DD')
        });
        var saasPaymentRange;
        if (this.orderData.mdlTypeCode !== 'SS' && !this.orderData.isAssist) {
            saasPaymentRange = "Not Needed";
        }
        else {
            var submitForPaymentDateChecks = _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.submitPaymentDate');
            var submitForPaymentDateGpp = _.get(this.topic.topic, 'gpp_valid[0].svi_submit_for_payment_date');
            var submitForPaymentDate = submitForPaymentDateChecks ? submitForPaymentDateChecks : submitForPaymentDateGpp;
            var submitForPaymentDateFormatted = submitForPaymentDate
                ? "Payment " + this.moment(Number(submitForPaymentDate)).format('YYYY-MM-DD')
                : "N/A";
            // probably it is so date
            var chargeAgreementStartDate = this.orderData.chargeAgreementStartDate;
            saasPaymentRange = submitForPaymentDateFormatted + " vs " + chargeAgreementStartDate;
        }
        rules.push({ n: 8, title: '30/60 Days Rule', model: 'saasPaymentRange', value: saasPaymentRange });
        rules.push({
            n: 9, title: 'Total Revenue vs Threshold', model: 'isThresholdValid', value: "" + this.orderData.totalRevenue
        });
        rules.push({ n: 10, title: 'Preferred Distributor', model: 'prefDistMatch', value: "" + (this.orderData.prefDist || 'Not Available') });
        rules.push({ n: 11, title: 'SaaS Coverage', model: 'coverageSaaS', value: this.orderData.coverageTerm });
        rules.push({ n: 12, title: 'Is Direct Order', model: 'isDirect', value: "" + (this.orderData.result.isDirect === true ? 'Yes' : 'No') });
        if (this.getNewUIInfo.uiVersion < this.OPP_VERSION_3) {
            rules.push({ n: 14, title: 'Was SaaS mixed with OnPrem', model: 'saasNotMixed', value: "" + (this.orderData.result.saasNotMixed ? 'No conflict' : 'Conflict found') });
        }
        rules.push({ n: 15, title: 'CMR Check', model: 'cmrCheck', value: "" + this.orderData.cnum });
        var applicability;
        if ((this.orderData.result.applicability === true || (this.orderData.result.applicability !== undefined && this.orderData.result.applicability.result === true))) {
            applicability = "Applicable for " + this.orderData.cnum;
        }
        else if (this.orderData.result.applicability && this.orderData.result.applicability.error) {
            applicability = "Failed to process Rule (hover for details) for " + this.orderData.cnum;
        }
        else {
            applicability = "Not Applicable for " + this.orderData.cnum;
        }
        rules.push({ n: 16, title: 'New Client Applicability', model: 'applicability', value: applicability });
        if (this.topic.checksData.isAutoEligibilityGoe) {
            rules.push({ n: 17, title: 'GOE Review', model: 'goeReview', value: this.orderData.result.goeReview });
        }
        // Getting rules applicable for this order
        this.orderRules = rules.filter(function (el) { return _this.orderData.result[el.model] !== undefined; });
    };
    DetailSOEvalController.prototype.setPnsRules = function (callbackFn) {
        var _this = this;
        var NOT_AVAILABLE = 'N/A';
        var sap = this.topic.topic.sap;
        var is4versionAndMore = this.getNewUIInfo.uiVersion >= this.OPP_VERSION_4;
        var solutionCheckSolIdKey = is4versionAndMore ? 'EI' : 'SOL';
        sap.forEach(function (pn, index) {
            var isNotPaid;
            if (pn.result.isNotPaid) {
                isNotPaid = "No Payment Detected";
            }
            else if (!pn.result.isNotPaid && pn.data.itemList[0].isPaidIn !== undefined) {
                isNotPaid = "Paid in " + pn.data.itemList[0].isPaidIn;
            }
            else if (!pn.result.isNotPaid && pn.data.itemList[0].isPaidIn === undefined) {
                isNotPaid = "Paid (Original ID not stored)";
            }
            var renewalStartDate = pn.data.itemList[0].renewalStartDate;
            // get rid of broken dates
            if (['00000000', '00/00/0000', '00.00.0000', 'RENWL_START_DATE'].includes(renewalStartDate)) {
                renewalStartDate = '';
            }
            else if (!(/\d{4}-\d{2}-\d{2}/.test(renewalStartDate))) {
                renewalStartDate = _this.moment(renewalStartDate, 'YYYYMMDD').format('YYYY-MM-DD');
            }
            //            const columnNameBFStatus: string = is4versionAndMore ? 'DRPG Status' : 'Checking Brand Family CVR Status';
            var rules = [];
            rules.push({ n: 1, title: 'Revenue Stream Code', model: 'revStreamCodeMatch', value: pn.data.itemList[0].revenueStreamCode });
            rules.push({ n: 2, title: 'Division Code', model: 'divisionCodeMatch', value: pn.data.itemList[0].divisionCode });
            var columnName9 = _this.getNewUIInfo.uiVersion >= _this.OPP_VERSION_3
                ? 'Engagement ID Comparison'
                : 'Solution ID Comparison';
            var engagementMappedCheck = _this.getMappedSolutionCheck(solutionCheckSolIdKey, pn.data.brandFamilyCode) || {};
            var solutionIdSapValue = _.get(pn, 'data.itemList[0].solutionId') || NOT_AVAILABLE; // null vaue can be here
            var eligibleSolutionIds;
            //checking 2 docs - 'checks_results/*_checks' & 'general/DMT-*'
            if (Array.isArray(engagementMappedCheck.solutions)) {
                eligibleSolutionIds = engagementMappedCheck.solutions.map(function (it) { return it.id; }).join(', ');
            }
            else if (Array.isArray(_this.solutionIdMap.get(pn.data.brandFamilyCode))) {
                eligibleSolutionIds = _this.solutionIdMap.get(pn.data.brandFamilyCode).join(', ');
            }
            if (!eligibleSolutionIds) {
                eligibleSolutionIds = NOT_AVAILABLE;
            }
            var engagementCheckValue = solutionIdSapValue === NOT_AVAILABLE && eligibleSolutionIds === NOT_AVAILABLE ? ''
                : solutionIdSapValue + " vs " + eligibleSolutionIds;
            //Brandcheck pass+EI approved in eligibility     ===> display EI comparison
            //Brandcheck pass+EI not approved in eligibility ===> do not display EI comparison
            //Brandcheck fail                                ===> display EI check with options to approve or not approve manually
            var allEiNotApproved = _this.topic.topic.version && _this.topic.topic.version >= _this.OPP_VERSION_5 ?
                _this.isAllEIEligibilityChecksNotApprovedV5() :
                _this.isAllEIEligibilityChecksNotApproved();
            var isEIAvailable = !allEiNotApproved && (!engagementMappedCheck.data || engagementMappedCheck.data === 'APPROVED');
            if (isEIAvailable) {
                var pnComments = pn.comments.pnEngagement;
                if (pnComments && pnComments.isFinal) {
                    if (pnComments.text) {
                        engagementCheckValue = pnComments.text;
                    }
                    if (Boolean(pnComments.text)) {
                        pn.result.solutionId = engagementCheckValue !== 'Not Approved' && pn.comments.pnEngagement.passFlag;
                    }
                }
                else {
                    if ((pnComments && !pnComments.isFinal) && pn.result.solutionId !== true) {
                        pn.result.solutionId = false;
                    }
                    else {
                        if (pnComments && _.isUndefined(pn.result.solutionId)) {
                        }
                        else {
                            if (_.isUndefined(pn.result.solutionId) && engagementMappedCheck.data === 'APPROVED') {
                                pn.result.solutionId = true;
                            }
                            if (eligibleSolutionIds === NOT_AVAILABLE || solutionIdSapValue === NOT_AVAILABLE) {
                                pn.result.solutionId = false;
                            }
                        }
                    }
                }
            }
            if (is4versionAndMore) {
                var pnComments = pn.comments.pnSalesInc;
                var checkValue = '';
                if (pnComments) {
                    checkValue = pnComments.text;
                    if (pnComments.isFinal && Boolean(checkValue)) {
                        pn.result.salesCheck = checkValue !== 'Not Approved' && pnComments.passFlag;
                    }
                    else {
                        if (!pnComments.isFinal && Boolean(checkValue)) {
                            pn.result.salesCheck = false;
                        }
                        else {
                            if (pnComments) {
                                checkValue = '';
                            }
                        }
                    }
                }
                if (_.isUndefined(pn.result.salesCheck)) {
                    pn.result.salesCheck = false;
                }
                rules.push({ n: 3, title: 'Sales Incentive', model: 'salesCheck', value: checkValue });
            }
            else {
                rules.push({
                    n: 3, title: 'Checking Brand Family CVR Status', model: 'bfstatusMatch', value: !pn.result.brandFound ? 'Brand Code Mismatch' : pn.data.x_svi_status
                });
            }
            rules.push({ n: 4, title: 'Global Brand Effective Date', model: 'GBTDate', value: _this.getGBTDateResult(pn) });
            rules.push({ n: 5, title: 'PPS brand check', model: 'ppBrandCheck', value: pn.data.ppBrand || 'Not Available' });
            rules.push({ n: 6, title: 'Payment Check', model: 'isNotPaid', value: isNotPaid });
            rules.push({ n: 7, title: 'Renewal Start Date Check', model: 'renewalStartDateCheck', value: renewalStartDate });
            rules.push({ n: 8, title: 'Continuous Billing Switch', model: 'continuousBillingSwitch', value: pn.data.itemList[0].renewalCode });
            if (isEIAvailable) {
                rules.push({ n: 9, title: columnName9, model: 'solutionId', value: engagementCheckValue });
            }
            if (is4versionAndMore) {
                //NOTE pn.result.<...> can be {result: false, infoOnly: true} - but it is writen by manual mode
                var pnComments = void 0;
                var checkValue = void 0;
                //GROWTH
                pnComments = pn.comments.pnGrowth;
                checkValue = '';
                if (pnComments) {
                    checkValue = pnComments.text;
                    //update only it is a manual mode
                    if (pnComments.isFinal && Boolean(checkValue)) {
                        pn.result.growthCheck = checkValue !== 'Not Approved' && pnComments.passFlag;
                    }
                    else {
                        if (!pnComments.isFinal && Boolean(checkValue)) {
                            pn.result.growthCheck = false;
                        }
                        else {
                            checkValue = '';
                        }
                    }
                }
                if (_.isUndefined(pn.result.growthCheck)) {
                    pn.result.growthCheck = false;
                }
                rules.push({ n: 10, title: 'SO Growth Check', model: 'growthCheck', value: checkValue });
                //FOCUS
                pnComments = pn.comments.pnFocus;
                checkValue = '';
                if (pnComments) {
                    checkValue = pnComments.text;
                    if (pnComments.isFinal && Boolean(checkValue)) {
                        pn.result.focusCheck = checkValue !== 'Not Approved' && pnComments.passFlag;
                    }
                    else {
                        if (!pnComments.isFinal && Boolean(checkValue)) {
                            pn.result.focusCheck = false;
                        }
                        else {
                            checkValue = '';
                        }
                    }
                }
                if (_.isUndefined(pn.result.focusCheck)) {
                    pn.result.focusCheck = false;
                }
                rules.push({ n: 11, title: 'SO Focus Check', model: 'focusCheck', value: checkValue });
                //CTL
                pnComments = pn.comments.pnCtl;
                checkValue = '';
                if (pnComments) {
                    checkValue = pnComments.text;
                    //update only it is a manual mode
                    if (pnComments.isFinal && Boolean(checkValue)) {
                        pn.result.ctlCheck = checkValue !== 'Not Approved' && pnComments.passFlag;
                    }
                    else {
                        if (!pnComments.isFinal && Boolean(checkValue)) {
                            pn.result.ctlCheck = false;
                        }
                        else {
                            checkValue = '';
                        }
                    }
                }
                if (_.isUndefined(pn.result.ctlCheck)) {
                    pn.result.ctlCheck = false;
                }
                rules.push({ n: 12, title: 'SO CTL Check', model: 'ctlCheck', value: checkValue });
            }
            var pnObj = _this.orderData.pns[index];
            if (is4versionAndMore) {
                _this.pnsRules[index] = rules.filter(function (el) {
                    var incentiveRules = [];
                    var mappedSolutionEICheck = _this.getMappedSolutionCheck(solutionCheckSolIdKey, pn.data.brandFamilyCode);
                    var isEINotApproved = mappedSolutionEICheck && mappedSolutionEICheck.data === 'NOT_APPROVED';
                    //hide 'Engagement ID Comparison' only when it is NOT approved in mapped solution EI checks
                    if (!isEINotApproved) {
                        incentiveRules.push('solutionId');
                    }
                    incentiveRules.push.apply(incentiveRules, ['growthCheck', 'focusCheck', 'ctlCheck']);
                    return pnObj.result[el.model] !== undefined || incentiveRules.includes(el.model);
                });
            }
            else {
                _this.pnsRules[index] = rules.filter(function (el) { return pnObj.result[el.model] !== undefined; });
            }
            // Getting rules applicable for this pn
        });
        if (callbackFn) {
            callbackFn();
        }
    };
    DetailSOEvalController.prototype.hasMappedSolutionCheck = function (pnIndex) {
        var solutionId = _.get(this.topic.topic, "sap[" + pnIndex + "].data.brandFamilyCode");
        var mappedSolutions = this.getMappedSolutions(solutionId);
        return Array.isArray(mappedSolutions) && mappedSolutions.length > 0;
    };
    DetailSOEvalController.prototype.isPnFailedAndEditable = function (pnIndex) {
        var res = !this.hasMappedSolutionCheck(pnIndex) || this.isNoCorrectIncentive(pnIndex) && this.checkIfPnFails(pnIndex);
        return res;
    };
    DetailSOEvalController.prototype.getMappedSolutions = function (solutionId) {
        return this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5
            ? this.getMappedSolutionsV5(solutionId)
            : this.getMappedSolutionsV3(solutionId);
    };
    DetailSOEvalController.prototype.getMappedSolutionsV3 = function (solutionId) {
        var mappedSolutions = _.get(this.topic, 'checksData.mappedResult.solutions');
        if (!solutionId || !Array.isArray(mappedSolutions)) {
            return [];
        }
        return mappedSolutions.filter(function (it) { return it.solutionId === solutionId && Boolean(it.checks); });
    };
    DetailSOEvalController.prototype.getMappedSolutionsV5 = function (drpgId) {
        var mappedSolutions = _.get(this.topic, 'checksData.mappedResult.dealRegs');
        if (!drpgId || !Array.isArray(mappedSolutions)) {
            return [];
        }
        return mappedSolutions.filter(function (it) { return it.dealRegistrationGroupId === drpgId && Boolean(it.checks); });
    };
    DetailSOEvalController.prototype.isAllEIEligibilityChecksNotApproved = function () {
        var mappedSolutions = _.get(this.topic, 'checksData.mappedResult.solutions', []);
        return mappedSolutions.every(function (solElem) {
            return _.get(solElem, "checks.EI.data", "NOT_APPROVED") === "NOT_APPROVED";
        });
    };
    DetailSOEvalController.prototype.isAllEIEligibilityChecksNotApprovedV5 = function () {
        var mappedSolutions = _.get(this.topic, 'checksData.mappedResult.dealRegs', []);
        if (!mappedSolutions || mappedSolutions.length === 0) {
            return false;
        }
        return mappedSolutions.every(function (solElem) {
            return _.get(solElem, "checks.EI.data", "NOT_APPROVED") === "NOT_APPROVED";
        });
    };
    DetailSOEvalController.prototype.getMappedSolutionCheck = function (mappedSolutionCheckId, solutionId) {
        var mappedSolutions = this.getMappedSolutions(solutionId);
        if (!Array.isArray(mappedSolutions) || mappedSolutions.length === 0) {
            return {};
        }
        return mappedSolutions.map(function (it) { return it.checks[mappedSolutionCheckId]; }).pop();
    };
    DetailSOEvalController.prototype.checkPnRules = function () {
        var _this = this;
        var pnObj;
        var hasAnyValidInc;
        this.pnsRules.forEach(function (pnRule, index) {
            pnObj = _this.orderData.pns[index];
            hasAnyValidInc = hasAnyValidIncentiveResult(pnObj);
            pnRule.forEach(function (rule) {
                var iconColor;
                var isIncRuleResolved = isIncResolved(rule.model, pnObj);
                var pnRuleResult = pnObj.result[rule.model];
                if (pnRuleResult === true || (typeof pnRuleResult === 'object' && pnRuleResult.result === true)) {
                    iconColor = IconColor.GREEN;
                }
                else if (pnRuleResult === false
                    || typeof pnRuleResult === 'undefined'
                    || (typeof pnRuleResult === 'object' && (pnRuleResult.result === false || pnRuleResult.infoOnly || pnRuleResult.passFlag))) {
                    if ((pnRuleResult === false || (typeof pnRuleResult === 'object' && pnRuleResult.infoOnly)) && hasAnyValidInc && isIncentive(rule.model)) {
                        iconColor = IconColor.ORANGE;
                    }
                    else if ((pnObj.comments[rule.model] || isIncRuleResolved) && pnObj.comments.pnOverall && pnObj.comments.pnOverall.passFlag) {
                        iconColor = IconColor.PINK;
                    }
                    else {
                        iconColor = IconColor.RED;
                    }
                }
                rule.iconColor = iconColor;
            });
        });
        this.checkSaas();
    };
    DetailSOEvalController.prototype.checkIfPnFails = function (pnIndex) {
        if (this.getNewUIInfo.uiVersion < this.OPP_VERSION_4) {
            //Just check if any rule is RED
            return this.pnsRules[pnIndex].filter(function (it) { return it.iconColor === IconColor.RED; }).length > 0;
        }
        // has an incentive AND no any valid incentive rule model
        // OR any non-inventive rule model is RED
        return hasAllIncentivesFailed(this.pnsRules[pnIndex]) || hasNonIncentiveRuleFailed(this.pnsRules[pnIndex]);
    };
    DetailSOEvalController.prototype.isNoCorrectIncentive = function (pnIndex) {
        return this.getNewUIInfo.uiVersion < this.OPP_VERSION_4 || !hasAllIncentivesFailed(this.pnsRules[pnIndex]);
    };
    DetailSOEvalController.prototype.checkIfPnRuleFails = function (pnIndex, pnRuleIndex) {
        if (this.getNewUIInfo.uiVersion < this.OPP_VERSION_4) {
            //Just check if any rule is RED
            return this.pnsRules[pnIndex][pnRuleIndex].iconColor === IconColor.RED;
        }
        // has an incentive AND no any valid incentive rule model
        // OR any non-inventive rule model is RED
        return hasAllIncentivesFailed(this.pnsRules[pnIndex]) || hasNonIncentiveRuleFailed(this.pnsRules[pnIndex]);
    };
    DetailSOEvalController.prototype.checkOrderRuleFailed = function () {
        for (var _i = 0, _a = this.orderRules; _i < _a.length; _i++) {
            var rule = _a[_i];
            if (this.orderData.comments[rule.model] && this.orderData.comments[rule.model].isFinal && !this.orderData.comments[rule.model].passFlag) {
                return true;
            }
        }
        return false;
    };
    DetailSOEvalController.prototype.isManualMode = function (ruleModel, pn, pnIndex, pnRuleIndex) {
        var ruleModulId = ruleModel && pn && pn.comments && pn.result
            && this.checkIfPnRuleFails(pnIndex, pnRuleIndex)
            ? ruleModel : '';
        switch (ruleModulId) {
            case 'solutionId':
                return this.getNewUIInfo.uiVersion >= this.OPP_VERSION_4
                    && !this.isFinalCommentTrue(pn.comments.pnEngagement)
                    && !this.hasMappedSolutionCheck(pnIndex)
                    && !pn.result.solutionId;
            case 'growthCheck':
                return !this.isFinalCommentTrue(pn.comments.pnGrowth)
                    && !this.hasMappedSolutionCheck(pnIndex)
                    && !pn.result.growthCheck;
            case 'focusCheck':
                return !this.isFinalCommentTrue(pn.comments.pnFocus)
                    && !this.hasMappedSolutionCheck(pnIndex)
                    && !pn.result.focusCheck;
            case 'salesCheck':
                return !this.isFinalCommentTrue(pn.comments.pnSalesInc)
                    && !this.hasMappedSolutionCheck(pnIndex)
                    && !pn.result.salesCheck;
            case 'ctlCheck':
                return !this.isFinalCommentTrue(pn.comments.pnCtl)
                    && !this.hasMappedSolutionCheck(pnIndex)
                    && !pn.result.ctlCheck;
            default:
                return false;
        }
    };
    DetailSOEvalController.prototype.isFinalCommentTrue = function (pnCommentObject) {
        return pnCommentObject && pnCommentObject.isFinal;
    };
    DetailSOEvalController.prototype.getManualModeModel = function (ruleModel, pn) {
        switch (ruleModel) {
            case 'solutionId':
                return this.pnsEngagementComments[pn.data.itemList[0].pn];
            case 'growthCheck':
                return this.pnsGrowthComments[pn.data.itemList[0].pn];
            case 'focusCheck':
                return this.pnsFocusComments[pn.data.itemList[0].pn];
            case 'salesCheck':
                return this.pnsSalesIncComments[pn.data.itemList[0].pn];
            case 'ctlCheck':
                return this.pnsCtlComments[pn.data.itemList[0].pn];
            default:
                return undefined;
        }
    };
    DetailSOEvalController.prototype.setOrderResult = function (pns) {
        var _this = this;
        var result = {};
        pns.forEach(function (pn) {
            _this.orderRulesNames.forEach(function (rule) {
                var ruleValue = pn.result[rule];
                if (ruleValue !== undefined && ((result[rule] === undefined) || (result[rule] === false && ruleValue))) {
                    result[rule] = ruleValue;
                }
            });
        });
        return result;
    };
    /**
     * Function to render the Global Brand Effective Date (rule #12) results correctly
     * @param soData
     */
    DetailSOEvalController.prototype.getGBTDateResult = function (so) {
        if (!so.result.brandFound) {
            return 'Brand Code Mismatch';
        }
        else if (so.data.noSVISubmitDate) {
            // The above field will be set during Validation if not SVI Submit Date could be found when it came to compare
            // GBT entry with svi date
            return 'No Opportunity Submit Date';
        }
        else {
            var sd = this.$filter('date')(new Date(so.data.brandFamilyEffDate * 1000), 'yyyy-MM-dd');
            var ed = this.$filter('date')(new Date(so.data.brandFamilyEndDate * 1000), 'yyyy-MM-dd');
            return sd + " vs " + ed + " ";
        }
    };
    DetailSOEvalController.prototype.setBrandArray = function () {
        this.rowIdArr = [];
        this.brandfamArr = [];
        this.solutionIdMap = new Map();
        // assume oneGPP.row_id are unique, used as solution map keys
        var _loop_1 = function(oneGPP) {
            if (this_1.topic.checksData.uiVersion >= this_1.OPP_VERSION_3) {
                if (this_1.topic.checksData) {
                    // in top level of the objects from 'data' array there is 'solutionId' (correct field name would be drpgId) and
                    // array 'solutions' (correct name in this case) that contains actual solution ids
                    // get solutions from the arrays with the according drpgId 
                    // (primary key includes gbt20, but we merge solutions for all different gbt20 values) to map them to sap
                    var solutionObjects = _.get(this_1.topic.checksData, 'result.SOL.data');
                    if (Array.isArray(solutionObjects)) {
                        // filter by drpg id (solutionId = drpgId, bad naming)
                        var filteredSolutionObjects = solutionObjects.filter(function (solObj) { return solObj.solutionId === oneGPP.row_id; });
                        if (Array.isArray(filteredSolutionObjects)) {
                            // create set, if solution ids are not unique
                            var drpgSolutionIds_1 = new Set();
                            filteredSolutionObjects.forEach(function (solObj) {
                                if (solObj && solObj.solutions) {
                                    // get solution id values from arrays and put to the set
                                    solObj.solutions.map(function (sol) { return sol.id; }).forEach(drpgSolutionIds_1.add, drpgSolutionIds_1);
                                }
                            });
                            // result mapping drpg - solution ids array
                            this_1.solutionIdMap.set(oneGPP.row_id, Array.from(drpgSolutionIds_1));
                        }
                    }
                }
                this_1.brandfamArr.push(oneGPP.row_id);
            }
            else {
                this_1.brandfamArr.push(oneGPP.brandcode);
                var solIds = [];
                if (oneGPP.solutionId &&
                    oneGPP.solutionId !== null &&
                    oneGPP.solutionId.trim() !== '') {
                    solIds = oneGPP.solutionId.split('\n');
                }
                this_1.solutionIdMap.set(oneGPP.brandcode, solIds);
            }
            this_1.rowIdArr.push(oneGPP.row_id);
        };
        var this_1 = this;
        for (var _i = 0, _a = this.topic.topic.gpp_valid; _i < _a.length; _i++) {
            var oneGPP = _a[_i];
            _loop_1(oneGPP);
        }
    };
    DetailSOEvalController.prototype.isPnPassed = function (pn, index) {
        var pnNumber = pn.data.itemList[0].pn;
        // case, when decision to pass pn was taken
        if (pn.comments.pnOverall && pn.comments.pnOverall.passFlag) {
            return true;
        }
        // case, when autofail took place or decision to fail pn
        if ((pn.comments.pnAutofail && !pn.comments.pnAutofail.passFlag) || (pn.comments.pnOverall && !pn.comments.pnOverall.passFlag)) {
            return false;
        }
        // otherwise look at pn rules
        return !this.checkIfPnFails(index);
    };
    DetailSOEvalController.prototype.checkValidationComplete = function () {
        var _this = this;
        if (this.topic.topic.complete.statusComplete['4']) {
            return true;
        }
        else {
            // If calculation node is present, validation has been completed
            if (this.topic.topic.calculation && this.topic.topic.complete.calculation && this.topic.topic.complete.complcl_calculation) {
                return true;
            }
            else {
                // check if all validation sections are completed
                var validThumbSections = ['sap', 'goePick_valid', 'goeCheck_valid', 'complcl_validation',
                    'complcl_calculation', 'calculation'];
                var isValidCompleted = validThumbSections.filter(function (secName) { return !_this.topic.topic.complete[secName]; }).length === 0;
                return isValidCompleted;
            }
        }
        return false;
    };
    /**
     * Disabling button based on logic
     * @private
     * @param {string} name
     * @param {(number | string)} additionalInfo
     * @returns {boolean}
     * @memberof DetailSOEvalController
     */
    DetailSOEvalController.prototype.isButtonDisabled = function (name, additionalInfo) {
        var _this = this;
        var model, index;
        if (typeof additionalInfo === 'string') {
            model = additionalInfo;
        }
        if (typeof additionalInfo === 'number') {
            index = additionalInfo;
        }
        var buttonName = {
            'triggerCalculations': function () { return (_this.topic.editableComponents.sap.socket ||
                !_this.checkValidationComplete()
                || _this.topic.topic && _this.topic.topic.errors && _this.topic.topic.errors.unresolved > 0
                || !_this.get2GoeValidCondition()); },
            'soDecision': function () { return (_this.topic.editableComponents.sap.socket ||
                !_this.orderData.comments[model]
                || _this.orderData.comments[model].text.trim() === ''); },
            'soAutoFail': function () { return _this.orderData.pns[0].comments.soAutofail || _this.topic.editableComponents.sap.socket; },
            'pnDecision': function () {
                return _this.isPnDecisionDesbl(index);
            },
            'pnAutoFail': function () { return _this.topic.editableComponents.sap.socket; }
        };
        return this.isUpdating || buttonName[name]();
    };
    DetailSOEvalController.prototype.isPnDecisionDesbl = function (index) {
        var _this = this;
        var focus = false, growth = false, ctl = false;
        var pns = !this.pnsComments || !this.pnsComments[index] || !this.pnsComments[index].trim();
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_4) {
            this.topic.topic.sap.forEach(function (elem, i) {
                if (i === index) {
                    var bf = elem.data.itemList[0].pn;
                    ctl = !elem.result.ctlCheck && !(_.isUndefined(elem.result.ctlCheck)) &&
                        (!_this.pnsCtlComments || !_this.pnsCtlComments[bf] || !_this.pnsCtlComments[bf].trim());
                    focus = !elem.result.focusCheck && !(_.isUndefined(elem.result.focusCheck)) &&
                        (!_this.pnsFocusComments || !_this.pnsFocusComments[bf] || !_this.pnsFocusComments[bf].trim());
                    growth = !elem.result.growthCheck && !(_.isUndefined(elem.result.growthCheck)) &&
                        (!_this.pnsGrowthComments || !_this.pnsGrowthComments[bf] || !_this.pnsGrowthComments[bf].trim());
                    _this.pnsCtlComments[index] = !elem.result.ctlCheck ? _this.pnsCtlComments[bf] : '';
                    _this.pnsFocusComments[index] = !elem.result.focusCheck ? _this.pnsFocusComments[bf] : '';
                    _this.pnsGrowthComments[index] = !elem.result.growthCheck ? _this.pnsGrowthComments[bf] : '';
                    _this.pnsSalesIncComments[index] = !elem.result.salesCheck ? _this.pnsSalesIncComments[bf] : '';
                    _this.pnsEngagementComments[index] = !elem.result.solutionId ? _this.pnsEngagementComments[bf] : '';
                }
            });
        }
        return pns || focus || growth || ctl || this.topic.editableComponents.sap.socket;
    };
    DetailSOEvalController.prototype.get2GoeValidCondition = function () {
        return _.get(this.topic.topic, 'complete.goeCheck_valid');
    };
    DetailSOEvalController.prototype.isManualSearchExists = function () {
        var cmrValidResults = _.get(this.topic.topic, 'cmr_valid.results', []);
        for (var _i = 0, cmrValidResults_1 = cmrValidResults; _i < cmrValidResults_1.length; _i++) {
            var result = cmrValidResults_1[_i];
            if (result.user && result.user !== 'system' && result.user !== 'dmt') {
                return true;
            }
        }
        var goeValidResults = _.get(this.topic.topic, 'goe_valid.results', []);
        for (var _a = 0, goeValidResults_1 = goeValidResults; _a < goeValidResults_1.length; _a++) {
            var result = goeValidResults_1[_a];
            if (result.user && result.user !== 'system' && result.user !== 'dmt') {
                return true;
            }
        }
        return false;
    };
    DetailSOEvalController.prototype.isAttachmentExists = function () {
        var files = this.topic.topic.files;
        if (!files) {
            return false;
        }
        for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
            var file = files_1[_i];
            if (file.type === 'fcmr_valid') {
                return true;
            }
        }
        return false;
    };
    DetailSOEvalController.$inject = ['topic', '$stateParams', 'settings', 'env', 'socket', '$scope', 'Dialog', '$state', '$filter', 'moment'];
    return DetailSOEvalController;
}());
var DetailSOEComponent = (function () {
    function DetailSOEComponent() {
        this.templateUrl = 'detail-validation-sales-orders-eval.html';
        this.controllerAs = 'vm';
        this.controller = DetailSOEvalController;
    }
    return DetailSOEComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('delete', '/public/icons/delete-forever.svg')
        .icon('reevaluate', '/public/icons/ic_compare_arrows_black_24px.svg');
})
    .component('detailValidationSalesOrdersEval', new DetailSOEComponent());



var GoeHistoryChecklistComponent = (function () {
    function GoeHistoryChecklistComponent() {
        this.templateUrl = 'goe-history-checklist.html';
        this.controllerAs = 'vm';
        this.controller = GoeHistoryChecklistController;
    }
    return GoeHistoryChecklistComponent;
}());



var GoeHistoryChecklistController = (function () {
    function GoeHistoryChecklistController(topic, $scope) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.ANSWER_OPTIONS = ['Yes', 'No', 'Not Available'];
        this.component = 'goeHistoryChecklist';
        if (this.topic.goeHistoryCheck) {
            this.goeHistoryCheck = this.topic.goeHistoryCheck;
        }
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.component) > -1) {
                _this.edit = _this.topic.getEditComponent(_this.component);
            }
        });
    }
    GoeHistoryChecklistController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.component);
    };
    GoeHistoryChecklistController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus([this.component], 'Updating')) {
                var updateObject = {
                    data: {
                        goeHistoryChecklist: {
                            add: true,
                            data: this.topic.temp.goeHistoryChecklist
                        }
                    },
                    id: this.topic.topic._id,
                    type: ['goeHistoryChecklist']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true);
                this.edit.editMode = this.topic.cancelEdit(this.component);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.component);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.component);
        }
    };
    GoeHistoryChecklistController.$inject = ['topic', '$scope'];
    return GoeHistoryChecklistController;
}());
angular
    .module('application')
    .component('eligibilityGoeHistoryChecklist', new GoeHistoryChecklistComponent());



var GoeHistoryComponent = (function () {
    function GoeHistoryComponent() {
        this.templateUrl = 'goe-history.html';
        this.controllerAs = 'vm';
        this.controller = GoeHistoryController;
    }
    return GoeHistoryComponent;
}());



var GoeHistoryController = (function () {
    function GoeHistoryController(topic) {
        this.topic = topic;
        this.isAutoEligibilityGoe = false;
        this.isDisplayTable = false;
        this.isDisplayChecklist = false;
        this.component = 'eligibilityGoeHistory';
        this.visible = false;
        if (this.topic.goeHistoryCheck) {
            this.goeHistoryCheck = this.topic.goeHistoryCheck;
        }
        if (this.topic.checksData) {
            this.isAutoEligibilityGoe = this.topic.checksData.isAutoEligibilityGoe;
        }
        if (this.isAutoEligibilityGoe) {
            if (!this.goeHistoryCheck || this.goeHistoryCheck.errorMessage) {
                this.errorMessage = 'GOE History Check was not performed';
                this.isDisplayTable = false;
                this.isDisplayChecklist = true;
            }
            else if (!this.goeHistoryCheck.isPassed) {
                this.errorMessage = 'GOE History Check found discrepancies';
                this.isDisplayTable = true;
                this.isDisplayChecklist = true;
            }
            else if (this.goeHistoryCheck.isPassed) {
                this.isDisplayTable = true;
                this.isDisplayChecklist = false;
                this.message = "GOE History Check havn't found discrepancies";
            }
        }
    }
    GoeHistoryController.prototype.toggleVisibility = function () {
        this.visible = !this.visible;
        return this.visible;
    };
    GoeHistoryController.$inject = ['topic'];
    return GoeHistoryController;
}());
angular
    .module('application')
    .component('eligibilityGoeHistory', new GoeHistoryComponent());



var GoeHistoryTableComponent = (function () {
    function GoeHistoryTableComponent() {
        this.templateUrl = 'goe-history-table.html';
        this.controllerAs = 'vm';
        this.controller = GoeHistoryTableController;
    }
    return GoeHistoryTableComponent;
}());



var GoeHistoryTableController = (function () {
    function GoeHistoryTableController(topic, moment) {
        this.topic = topic;
        this.moment = moment;
        this.DATE_FORMAT = 'MM/DD/YYYY HH:mm:ss';
        this.TABLE_HEADERS = ['Opportunity', 'Submit Date', 'Expiration Date', 'Country', 'Status/Substatus', 'Account Name', 'Customer Number', 'GOE Decision'];
        if (this.topic.goeHistoryCheck) {
            this.goeHistoryCheck = this.topic.goeHistoryCheck;
        }
    }
    GoeHistoryTableController.prototype.isTableEmpty = function () {
        return !this.goeHistoryCheck || !this.goeHistoryCheck.historyData || this.goeHistoryCheck.historyData.length === 0;
    };
    GoeHistoryTableController.prototype.formatDate = function (date) {
        return this.moment.utc(date).format(this.DATE_FORMAT);
    };
    GoeHistoryTableController.$inject = ['topic', 'moment'];
    return GoeHistoryTableController;
}());
angular
    .module('application')
    .component('eligibilityGoeHistoryTable', new GoeHistoryTableComponent());



var BreakdownComponent = (function () {
    function BreakdownComponent() {
        this.templateUrl = 'breakdown.html';
        this.controllerAs = 'vm';
        this.controller = BreakdownController;
    }
    return BreakdownComponent;
}());



var BreakdownController = (function () {
    function BreakdownController(topic, $state, $scope, socket, env, Dialog, notify) {
        var _this = this;
        this.topic = topic;
        this.$state = $state;
        this.$scope = $scope;
        this.socket = socket;
        this.env = env;
        this.Dialog = Dialog;
        this.notify = notify;
        this.visible = true;
        this.isRemoveButtonVisible = false;
        this.isRefreshButtonVisible = false;
        //used to show processing bar while server call is performed
        this.isProcessing = false;
        // this field is used in esc-button-section
        // it is taken from vm.topic.editableComponents.calculation.editMode
        this.edit = { editable: false };
        // also used in esc-button-section, do not change name and value
        this.comp = 'calculation';
        this.isRemoveButtonVisible = this.topic.topic.status.status_no === 4
            && [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(this.topic.topic.status.sub_status_no) < 0
            && this.env.user.access.systemAdmin;
        this.isRefreshButtonVisible = this.topic.calculation ? !this.topic.calculation.complete : false;
        this.edit = this.topic.getEditComponent(BreakdownController.COMPONENT_NAME);
        this.socket.forward(BreakdownController.TOPIC_SAVE, this.$scope);
        this.$scope.$on("socket:" + BreakdownController.TOPIC_SAVE, function (event, data) {
            _this.isProcessing = false;
            _this.edit.editMode = _this.topic.cancelEdit(BreakdownController.COMPONENT_NAME);
            // used in esc button logic
            _this.topic.updatePartialSocketStatus([_this.comp], '');
            if (_this.topic.topicBrowserID !== data.bID) {
                return _this.notify.error('Browser ID changed. Please, reload.');
            }
            if (data.error) {
                _this.notify.error(data.error);
            }
            else {
                _this.topic.calculation = data.calculation;
                _this.notify.success("Calculation was updated successfully");
            }
            return;
        });
        this.socket.forward(BreakdownController.TOPIC_RECALCULATE, this.$scope);
        this.$scope.$on("socket:" + BreakdownController.TOPIC_RECALCULATE, function (event, data) {
            _this.topic.temp.calculation = data.calculation;
            _this.isProcessing = false;
            if (_this.topic.topicBrowserID !== data.bID) {
                return _this.notify.error('Browser ID changed. Please, reload.');
            }
            if (data.error) {
                _this.notify.error(data.error);
            }
            else {
                _this.topic.requireRecalculation = false;
                _this.topic.changed = true;
                _this.notify.success("Recalculated successfully - Remember to Save your changes");
            }
            return;
        });
        this.socket.forward(BreakdownController.TOPIC_REVERT_V2, this.$scope);
        this.$scope.$on("socket:" + BreakdownController.TOPIC_REVERT_V2, function (event, data) {
            _this.isProcessing = false;
            if (_this.topic.topicBrowserID !== data.bID) {
                return _this.notify.error('Browser ID changed. Please, reload.');
            }
            if (data.error) {
                _this.notify.error(data.error);
            }
            // } else {
            //     this.notify.success(`Reverted successfully`);
            // }
            return;
        });
    }
    BreakdownController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    BreakdownController.prototype.getErrors = function () {
        return this.topic.editableComponents.calculation.editMode ?
            this.topic.temp.calculation.errors.errorList.join('\n') :
            this.topic.calculation.errors.errorList.join('\n');
    };
    BreakdownController.prototype.isError = function () {
        return this.topic.editableComponents.calculation.editMode ?
            this.topic.temp.calculation.errors.errorList.length :
            this.topic.calculation.errors.errorList.length;
    };
    BreakdownController.prototype.showRefreshSaveCalculationError = function () {
        var dialogData = {
            icon: 'ERROR',
            message: 'You need to refresh after doing any changes. &nbsp;Click the Refresh button.',
            title: 'Saving Error'
        };
        // do nothing after confirmation button is pressed
        this.Dialog.updateValidForm(undefined, dialogData, BreakdownController.CONFIRM_PROMT);
    };
    BreakdownController.prototype.showChangedSaveCalculationError = function () {
        var dialogData = {
            icon: 'ERROR',
            message: 'No changes were done, nothing to save.',
            title: 'Saving Error'
        };
        // do nothing after confirmation button is pressed
        this.Dialog.updateValidForm(undefined, dialogData, BreakdownController.CONFIRM_PROMT);
    };
    BreakdownController.prototype.showValidationError = function (errorMessage) {
        var dialogData = {
            icon: 'ERROR',
            message: errorMessage,
            title: 'Edit Error'
        };
        // do nothing after confirmation button is pressed
        this.Dialog.updateValidForm(undefined, dialogData, BreakdownController.CONFIRM_PROMT);
    };
    BreakdownController.prototype.checkRevertCondition = function () {
        return this.topic.topic.status.status_no === 4 &&
            [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(this.topic.topic.status.sub_status_no) >= 0 &&
            (this.env.user.access.bpsoAdmin || this.env.user.access.systemAdmin);
    };
    BreakdownController.prototype.revertStatus = function () {
        var _this = this;
        if (this.isProcessing) {
            return;
        }
        var items = {
            icon: 'QUESTION',
            message: 'Use this function to revert back to a <b>Pending BPSO</b> status and edit the Calculations again.',
            title: 'Revert from Set Aside'
        };
        // If already approved, warn this will wipe the approvals
        if (this.topic.topic.status.approvals.complete) {
            items.message +=
                '<br><br><b style="color:red">NOTE:</b> &nbsp;Should you choose to continue, the' +
                    ' Approvals already granted will be wiped and the Disbursement will need to go through the Approval Process again.';
        }
        items.message += '<br><br>Are you sure?';
        this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.isProcessing = true;
                _this.socket.emit('module', {
                    module: {
                        className: BreakdownController.BACKEND_CLASS,
                        data: {
                            bID: _this.topic.topicBrowserID,
                            calculcation: _this.topic.calculation,
                            docId: _this.topic.topic._id
                        },
                        function: 'revertStatus',
                        script: BreakdownController.BACKEND_MODULE,
                        token: _this.env.user.token,
                        user: _this.env.user
                    }
                });
            }
        });
    };
    BreakdownController.prototype.validateEdit = function () {
        var errorMessage;
        if (!this.topic.temp.calculation.drpgs.length) {
            return 'Calculation should have at least one brand family';
        }
        // gather all ids to check uniqueness
        var drpgsIds = new Set();
        var pnIds = new Set();
        var lnIds = new Set();
        for (var _i = 0, _a = this.topic.temp.calculation.drpgs; _i < _a.length; _i++) {
            var drpg = _a[_i];
            if (drpgsIds.has(drpg.id)) {
                errorMessage = "Drpg id duplicate found: " + drpg.id + ". Ids should not be duplicated.";
            }
            else {
                errorMessage = this.validateDrpg(drpg);
            }
            if (errorMessage) {
                return errorMessage;
            }
            drpgsIds.add(drpg.id);
            for (var _b = 0, _c = drpg.partNumbers; _b < _c.length; _b++) {
                var partNumber = _c[_b];
                if (pnIds.has(partNumber.id)) {
                    errorMessage = "Part number id duplicate found. Drpg: " + drpg.id + ", part number: " + partNumber.id + ". Ids should not be duplicated.";
                }
                else {
                    errorMessage = this.validatePartNumber(partNumber);
                }
                if (errorMessage) {
                    return errorMessage;
                }
                pnIds.add(partNumber.id);
                for (var _d = 0, _e = partNumber.lineItems; _d < _e.length; _d++) {
                    var lineItem = _e[_d];
                    if (lnIds.has(lineItem.id)) {
                        errorMessage = "Line item id duplicate found. Drpg: " + drpg.id + ", part number: " + partNumber.id + ", line item: " + lineItem.id + ". Ids should not be duplicated.";
                    }
                    else {
                        errorMessage = this.validateLineItem(lineItem);
                    }
                    if (errorMessage) {
                        return errorMessage;
                    }
                    lnIds.add(lineItem.id);
                }
            }
        }
    };
    BreakdownController.prototype.validateDrpg = function (drpg) {
        if (!drpg) {
            return 'Brand family is undefined';
        }
        if (!drpg.id) {
            return 'Brand family id should not be empty';
        }
    };
    BreakdownController.prototype.validatePartNumber = function (partNumber) {
        if (!partNumber) {
            return 'Part number is undefined';
        }
        if (!partNumber.id) {
            return 'Part number id should not be empty';
        }
    };
    BreakdownController.prototype.validateLineItem = function (lineItem) {
        if (!lineItem) {
            return 'Line item is undefined';
        }
        if (!lineItem.id) {
            return 'Line item id should not be empty';
        }
        if (lineItem.data.find(function (data) { return !data.extendedPrice; })) {
            return 'Extended price should not be emtpy or 0';
        }
    };
    BreakdownController.prototype.saveCalculation = function () {
        var updateCalculationData = {
            module: {
                className: BreakdownController.BACKEND_CLASS,
                data: {
                    bID: this.topic.topicBrowserID,
                    calculation: this.topic.temp.calculation,
                    oppDocId: this.topic.topic._id
                },
                function: 'saveCalculation',
                script: BreakdownController.BACKEND_MODULE,
                token: this.env.user.token,
                user: this.env.user
            }
        };
        this.isProcessing = true;
        this.socket.emit(BreakdownController.EMIT_OBJECT_NAME, updateCalculationData);
    };
    BreakdownController.prototype.requireRecalculation = function () {
        this.topic.changed = true;
        this.topic.requireRecalculation = true;
    };
    // function that is called on edit/save calculation
    BreakdownController.prototype.changeEditMode = function (action) {
        switch (action) {
            case BreakdownController.ACTION_SAVE: {
                var errorMessage = this.validateEdit();
                if (errorMessage) {
                    this.showValidationError(errorMessage);
                }
                else if (!this.topic.changed) {
                    // do not save if nothing changed
                    this.showChangedSaveCalculationError();
                }
                else if (this.topic.requireRecalculation) {
                    // only save when data is re-calculated after values are changed
                    this.showRefreshSaveCalculationError();
                }
                else if (this.topic.updatePartialSocketStatus([BreakdownController.COMPONENT_NAME], 'Updating')) {
                    // updatePartialSocketStatus checks that no other component is being saved at the moment
                    // also checks that user can perform update at this moment/with his creds/etc
                    // if all is good - update calculation object
                    this.saveCalculation();
                }
                break;
            }
            case BreakdownController.ACTION_EDIT: {
                this.edit.editMode = this.topic.setTempFromCalculationV2();
                break;
            }
            default: {
                this.edit.editMode = this.topic.cancelEdit(BreakdownController.COMPONENT_NAME);
            }
        }
    };
    BreakdownController.prototype.removeCalculation = function () {
        var _this = this;
        var items = {
            icon: 'QUESTION',
            message: 'You are about to permanently delete the Calculations. &nbsp;Are you sure?',
            title: 'Remove Calculations'
        };
        this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.socket.emit(BreakdownController.EMIT_OBJECT_NAME, {
                    module: {
                        className: BreakdownController.BACKEND_CLASS,
                        data: {
                            bID: _this.topic.topicBrowserID,
                            docId: _this.topic.topic._id
                        },
                        function: 'removeCalculation',
                        script: BreakdownController.BACKEND_MODULE,
                        token: _this.env.user.token,
                        user: _this.env.user
                    }
                });
                _this.$state.go('detail.validation', {
                    id: _this.topic.topic._id.substring(4)
                });
            }
        });
    };
    BreakdownController.prototype.recalculate = function () {
        var errorMessage = this.validateEdit();
        if (errorMessage) {
            this.showValidationError(errorMessage);
            return;
        }
        this.isProcessing = true;
        this.socket.emit(BreakdownController.EMIT_OBJECT_NAME, {
            module: {
                className: BreakdownController.BACKEND_CLASS,
                data: {
                    bID: this.topic.topicBrowserID,
                    calculation: this.topic.temp.calculation,
                    docId: this.topic.topic._id
                },
                function: 'recalculate',
                script: BreakdownController.BACKEND_MODULE,
                token: this.env.user.token,
                user: this.env.user
            }
        });
        return;
    };
    BreakdownController.ACTION_EDIT = 'edit';
    BreakdownController.ACTION_SAVE = 'save';
    BreakdownController.CONFIRM_PROMT = 'confirm-prompt.html';
    BreakdownController.COMPONENT_NAME = 'calculation';
    BreakdownController.BACKEND_MODULE = '/detail/payment/v2/calculate/calculateClient';
    BreakdownController.BACKEND_CLASS = 'CalculateClient';
    //private static TOPIC_UPDATED: string = 'broadcast:topicUpdated';
    BreakdownController.TOPIC_RECALCULATE = 'topic.calculation.recalculate';
    BreakdownController.TOPIC_REVERT_V2 = 'topic.calculation.revertV2';
    BreakdownController.TOPIC_SAVE = 'topic.calculation.save';
    BreakdownController.EMIT_OBJECT_NAME = 'module';
    BreakdownController.$inject = [
        'topic',
        '$state',
        '$scope',
        'socket',
        'env',
        'Dialog',
        'notify',
    ];
    return BreakdownController;
}());
angular
    .module('application')
    .component('paymentBreakdown', new BreakdownComponent());



var PaymentComponent = (function () {
    function PaymentComponent() {
        this.templateUrl = 'payment.html';
        this.controllerAs = 'vm';
        this.controller = PaymentController;
    }
    return PaymentComponent;
}());



var PaymentController = (function () {
    function PaymentController(topic) {
        this.topic = topic;
        this.OPP_VERSION_3 = 3;
    }
    PaymentController.$inject = ['topic'];
    return PaymentController;
}());
angular
    .module('application')
    .component('payment', new PaymentComponent());



var TableComponent = (function () {
    function TableComponent() {
        this.controllerAs = 'vm';
        this.templateUrl = 'table.html';
        this.controller = TableController;
        this.bindings = tableBind;
    }
    return TableComponent;
}());



/**
 * @see LineItemDataType corresponds to src\server\routes\app\detail\payment\v2\enums\lineItemDataType.ts
 */
var LineItemDataType;
(function (LineItemDataType) {
    //STANDART = 'standart',
    LineItemDataType[LineItemDataType["NON_CTL_SO"] = 'non_ctl_so'] = "NON_CTL_SO";
    LineItemDataType[LineItemDataType["CTL_SO_24_INC"] = 'ctl_so_24_inc'] = "CTL_SO_24_INC";
    LineItemDataType[LineItemDataType["CTL_SO_24_PLUS"] = 'ctl_so_24_plus'] = "CTL_SO_24_PLUS";
    LineItemDataType[LineItemDataType["CTL_SO_24_PLUS_ONLY"] = 'ctl_so_24_plus_only'] = "CTL_SO_24_PLUS_ONLY";
})(LineItemDataType || (LineItemDataType = {}));
var tableBind = { item: '=', data: '=' };
var TableController = (function () {
    function TableController(topic) {
        this.topic = topic;
        this.OPP_VERSION_4 = 4;
        this.preferredCurrency = this.topic.calculation.currencyData.preferredCurrency;
        this.orderCurrency = this.topic.calculation.currencyData.orderCurrency;
        this.isVer4Plus = this.topic.topic.version >= this.OPP_VERSION_4;
        //console.log(this.item);
    }
    TableController.prototype.getBonusAmount = function (incentiveId) {
        var result = this.data.bonuses.find(function (it) { return it.incentiveType === incentiveId; });
        return result ? "" + result.amount : 'N/A';
    };
    TableController.prototype.getBonus = function (incentiveId) {
        var result = this.data.bonuses.find(function (it) { return it.incentiveType === incentiveId; });
        return result ? "Bonus " + result.bonus + "%" : 'N/A';
    };
    TableController.prototype.getBonusComment = function (incentiveId) {
        var result = this.data.bonuses.find(function (it) { return it.incentiveType === incentiveId && it.capComment; });
        return result ? result.capComment : undefined;
    };
    TableController.prototype.getSalesOrderLabel = function () {
        switch (this.data.dataType) {
            case LineItemDataType.CTL_SO_24_INC:
                return 'Sales Order (Length of term is up to 24 months)';
            case LineItemDataType.CTL_SO_24_PLUS:
                return 'Sales Order (Length of term is over 24 months)';
            case LineItemDataType.CTL_SO_24_PLUS_ONLY:
                return 'Sales Order (Length of term is over 24 months only)';
            case LineItemDataType.NON_CTL_SO:
                return 'Sales Order (Non CTL SO)';
            default:
                return 'Sales Order';
        }
    };
    TableController.prototype.getUpliftLabel = function () {
        return this.data.baseAmount.isBaseAmount
            ? "Uplifted Amount (ZFN4)"
            : "Uplift (" + this.preferredCurrency + ")";
    };
    TableController.prototype.getUplift = function () {
        return this.data.baseAmount.isBaseAmount ? "" : "Bonus " + this.data.uplift.bonus + "%";
    };
    TableController.prototype.getUpliftAmount = function () {
        return (this.data.baseAmount.isBaseAmount ? this.data.baseAmount.amount : this.data.uplift.amount) || 'N/A';
    };
    TableController.prototype.getBonusLabel = function (incentiveId) {
        switch (incentiveId) {
            case 'sales':
                return (this.isVer4Plus ? 'SSA' : 'CVR SSA') + " (" + this.preferredCurrency + ")";
            case 'engagement':
                return (this.isVer4Plus ? 'Engagement' : 'CVR Solution') + " (" + this.preferredCurrency + ")";
            case 'newClient':
                return "CVR New Client (" + this.preferredCurrency + ")";
            case 'growth':
                return "Growth (" + this.preferredCurrency + ")";
            case 'focus':
                return "Focus (" + this.preferredCurrency + ")";
            case 'ctl':
                return "CTL (" + this.preferredCurrency + ")";
        }
        ;
    };
    TableController.$inject = ['topic'];
    return TableController;
}());
angular
    .module('application')
    .component('paymentTable', new TableComponent());



var TableEditComponent = (function () {
    function TableEditComponent() {
        this.controllerAs = 'vm';
        this.templateUrl = 'table-edit.html';
        this.controller = TableEditController;
        this.bindings = tableEditBind;
    }
    return TableEditComponent;
}());



var tableEditBind = { item: '=', data: '=' };
var TableEditController = (function () {
    function TableEditController(topic) {
        this.topic = topic;
        this.NUMBER_FORMAT = /^[0-9]+(\.[0-9]{1,2})?$/;
        this.NUMBER_STEP = '0.01';
        this.OPP_VERSION_4 = 4;
        this.preferredCurrency = this.topic.calculation.currencyData.preferredCurrency;
        this.orderCurrency = this.topic.calculation.currencyData.orderCurrency;
        this.isVer4Plus = this.topic.topic.version >= this.OPP_VERSION_4;
        //console.log(this.item);
    }
    TableEditController.prototype.fieldChanged = function () {
        this.topic.requireRecalculation = true;
        this.topic.changed = true;
    };
    TableEditController.prototype.getBonusAmount = function (incentiveId) {
        var result = this.data.bonuses.find(function (it) { return it.incentiveType === incentiveId; });
        return result ? "" + result.amount : 'N/A';
    };
    TableEditController.prototype.getBonus = function (incentiveId) {
        var result = this.data.bonuses.find(function (it) { return it.incentiveType === incentiveId; });
        return result ? "Bonus " + result.bonus + "%" : 'N/A';
    };
    TableEditController.prototype.getBonusComment = function (incentiveId) {
        var result = this.data.bonuses.find(function (it) { return it.incentiveType === incentiveId && it.capComment; });
        return result ? result.capComment : undefined;
    };
    TableEditController.prototype.getUpliftLabel = function () {
        return this.data.baseAmount.isBaseAmount
            ? "Uplifted Amount (ZFN4)"
            : "Uplift (" + this.preferredCurrency + ")";
    };
    TableEditController.prototype.getUplift = function () {
        return this.data.baseAmount.isBaseAmount ? "" : "Bonus " + this.data.uplift.bonus + "%";
    };
    TableEditController.prototype.getUpliftAmount = function () {
        return (this.data.baseAmount.isBaseAmount ? this.data.baseAmount.amount : this.data.uplift.amount) || 'N/A';
    };
    TableEditController.prototype.getBonusLabel = function (incentiveId) {
        switch (incentiveId) {
            case 'sales':
                return (this.isVer4Plus ? 'SSA' : 'CVR SSA') + " (" + this.preferredCurrency + ")";
            case 'engagement':
                return (this.isVer4Plus ? 'Engagement' : 'CVR Solution') + " (" + this.preferredCurrency + ")";
            case 'newClient':
                return "CVR New Client (" + this.preferredCurrency + ")";
            case 'growth':
                return "Growth (" + this.preferredCurrency + ")";
            case 'focus':
                return "Focus (" + this.preferredCurrency + ")";
            case 'ctl':
                return "CTL (" + this.preferredCurrency + ")";
        }
        ;
    };
    TableEditController.prototype.getSalesOrderLabel = function () {
        switch (this.data.dataType) {
            case LineItemDataType.CTL_SO_24_INC:
                return 'Sales Order (Length of term is up to 24 months)';
            case LineItemDataType.CTL_SO_24_PLUS:
                return 'Sales Order (Length of term is over 24 months)';
            case LineItemDataType.CTL_SO_24_PLUS_ONLY:
                return 'Sales Order (Length of term is over 24 months only)';
            case LineItemDataType.NON_CTL_SO:
                return 'Sales Order (Non CTL SO)';
            default:
                return 'Sales Order';
        }
    };
    TableEditController.$inject = ['topic'];
    return TableEditController;
}());
angular
    .module('application')
    .component('paymentTableEdit', new TableEditComponent());



var TreeComponent = (function () {
    function TreeComponent() {
        this.controllerAs = 'vm';
        this.templateUrl = 'tree.html';
        this.controller = TreeController;
        this.bindings = treeBind;
    }
    return TreeComponent;
}());



var treeBind = { item: '=' };
var TreeController = (function () {
    function TreeController(topic) {
        this.topic = topic;
        this.visible = true;
    }
    TreeController.prototype.getChildren = function () {
        switch (this.item.type) {
            case 'calculation': {
                return this.item.drpgs;
            }
            case 'drpg': {
                return this.item.partNumbers;
            }
            case 'partNumber': {
                return this.item.lineItems;
            }
        }
    };
    TreeController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    TreeController.prototype.getErrors = function () {
        return this.item.errors && this.item.errors.errorList.join('\n');
    };
    TreeController.prototype.isError = function () {
        return this.item.errors && this.item.errors.errorList.length > 0;
    };
    TreeController.$inject = ['topic'];
    return TreeController;
}());
angular
    .module('application')
    .component('treePayment', new TreeComponent());



var TreeEdit = (function () {
    function TreeEdit() {
    }
    // idea is to copy everything, then clear copied values:
    // - ids
    // - amounts
    // - leave one line item per part number
    // copyFromItem should be a deep copy of an original item that we copy
    TreeEdit.addChild = function (item, parent) {
        var newItem = angular.copy(item);
        switch (item.type) {
            case 'drpg': {
                newItem = this.clearDrpg(newItem);
                parent.item.drpgs.unshift(newItem);
                break;
            }
            case 'partNumber': {
                newItem = this.clearPartNumber(newItem);
                parent.item.partNumbers.unshift(newItem);
                break;
            }
            case 'lineItem': {
                newItem = this.clearLineItem(newItem);
                parent.item.lineItems.unshift(newItem);
                break;
            }
        }
    };
    TreeEdit.clearLineItem = function (lineItem) {
        lineItem.id = '';
        lineItem.extendedPrice = 0;
        for (var _i = 0, _a = lineItem.bonuses; _i < _a.length; _i++) {
            var bonus = _a[_i];
            bonus.amount = 0;
        }
        return lineItem;
    };
    TreeEdit.clearPartNumber = function (partNumber) {
        partNumber.id = '';
        // copy only the first line item
        var lineItem = this.clearLineItem(partNumber.lineItems[0]);
        partNumber.lineItems = [lineItem];
        return partNumber;
    };
    TreeEdit.clearDrpg = function (drpg) {
        drpg.id = '';
        for (var _i = 0, _a = drpg.partNumbers; _i < _a.length; _i++) {
            var partNumber = _a[_i];
            this.clearPartNumber(partNumber);
        }
        return drpg;
    };
    return TreeEdit;
}());



var TreeEditComponent = (function () {
    function TreeEditComponent() {
        this.controllerAs = 'vm';
        this.templateUrl = 'tree-edit.html';
        this.controller = TreeEditController;
        this.bindings = treeEditBind;
    }
    return TreeEditComponent;
}());



var treeEditBind = { item: '=', index: '=', parent: '=' };
var TreeEditController = (function () {
    function TreeEditController(topic) {
        this.topic = topic;
        this.visible = true;
    }
    TreeEditController.prototype.getChildren = function () {
        switch (this.item.type) {
            case 'calculation': {
                return this.item.drpgs;
            }
            case 'drpg': {
                return this.item.partNumbers;
            }
            case 'partNumber': {
                return this.item.lineItems;
            }
        }
    };
    TreeEditController.prototype.getPlaceholder = function () {
        switch (this.item.type) {
            case 'drpg': {
                return 'Brand Family';
            }
            case 'partNumber': {
                return 'Part Number';
            }
            case 'lineItem': {
                return 'Revenue Line Item';
            }
        }
    };
    // idea is to copy everything, then clear copied values:
    // - ids
    // - amounts
    // - leave one line item per part number
    TreeEditController.prototype.copyItem = function () {
        this.topic.requireRecalculation = true;
        this.topic.changed = true;
        TreeEdit.addChild(this.item, this.parent);
    };
    TreeEditController.prototype.removeItem = function () {
        switch (this.item.type) {
            case 'drpg': {
                this.parent.item.drpgs.splice(this.index, 1);
                break;
            }
            case 'partNumber': {
                this.parent.item.partNumbers.splice(this.index, 1);
                if (!this.parent.item.partNumbers.length) {
                    this.parent.removeItem();
                }
                break;
            }
            case 'lineItem': {
                this.parent.item.lineItems.splice(this.index, 1);
                if (!this.parent.item.lineItems.length) {
                    this.parent.removeItem();
                }
                break;
            }
        }
    };
    TreeEditController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    TreeEditController.prototype.fieldChanged = function () {
        this.topic.requireRecalculation = true;
        this.topic.changed = true;
    };
    TreeEditController.prototype.getErrors = function () {
        return this.item.errors.errorList.join('\n');
    };
    TreeEditController.prototype.isError = function () {
        return this.item.errors.errorList.length;
    };
    TreeEditController.$inject = ['topic'];
    return TreeEditController;
}());
angular
    .module('application')
    .component('treeEditPayment', new TreeEditComponent());



var SaTableComponent = (function () {
    function SaTableComponent() {
        this.templateUrl = 'saTable.html';
        this.controllerAs = 'vm';
        this.controller = SaTableController;
    }
    return SaTableComponent;
}());



var SaTableController = (function () {
    function SaTableController(topic) {
        this.topic = topic;
        this.visible = false;
        this.tableName = 'Sales Assist';
        this.tableHeaders = [
            'Deal Reg Product Group ID',
            'Sales',
            'Engagement',
            'Engagement ID',
            'Sales Order',
        ];
    }
    SaTableController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    SaTableController.prototype.getValue = function (value) {
        if (value === true) {
            return 'Yes';
        }
        else if (value === false) {
            return 'No';
        }
        else if (value !== undefined && value.trim() === '') {
            return 'Not Applicable';
        }
        return value;
    };
    SaTableController.$inject = ['topic'];
    return SaTableController;
}());
angular
    .module('application')
    .component('salesAssistTable', new SaTableComponent());



angular.module('templates').run(['$templateCache', function($templateCache) {$templateCache.put('css.html','body {\n    height: auto;\n    top: 0 !important;    \n}\n\nbody > md-toast {\n  position: fixed;\n}\n\n\n.ibm-masthead-iconsonly>li>button.ibm-profile-link.authuser,\n.ibm-masthead-iconsonly>li>button.ibm-profile-link.authuser:hover{\n  background-image: url("/public/images/user.png");\n  background-size:cover;\n}\n\n.ibm-masthead-iconsonly>li>button.ibm-masthead-signin-link.authuser,\n.ibm-masthead-iconsonly>li>button.ibm-masthead-signin-link.authuser:hover{\n  background-image: url("/public/images/user.png");\n  background-size:cover;\n}\n\ntable.dataTable thead th, table.dataTable thead td, table.dataTable tbody th, table.dataTable tbody td {\n    padding: 8px 10px;\n}\n\n.ibm-data-table,.ibm-data-table.ibm-grid{\n  font-size:14px;\n}\n.customDialog {\n  width: 500px;\n  height: 500px;\n}\nmasthead{\n  display:block;\n}\n\n/*.ibm-row-form label{\n  height: 30px;\n}*/\n\n\n.md-dialog-is-showing .md-dialog-container{\n  z-index:920;\n}\n\n.ibm-data-table th, .ibm-data-table td {\n    padding: 16px 15px;\n}\n\n.md-dialog-is-showing md-dialog{\n  background-color:#fff;\n}\n\n.md-dialog-is-showing md-backdrop{\n  z-index:910;\n  background:#111;\n}\n\nmd-toast{\n  max-width:400px;\n  z-index:1000;\n}\n\nmd-toast.md-green-theme .md-toast-content{\n  background-color:darkcyan;\n  color:#fff\n}\n\nmd-toast.md-red-theme .md-toast-content{\n  background-color:#C2185B;\n  color:#fff\n}\n\nmd-toast .md-toast-content{\n  height:100%;\n  max-height:400px;\n  border-radius:10px;\n}\n\nmd-toast .md-toast-content .md-button {\n  position: absolute;\n    top: 0;\n    right: 20px;\n}\n\nmd-toast .md-toast-content > span {\n  /*word-break: break-all; Honestly...*/\n  margin-right: 50px;\n    padding: 10px;\n}\n\n.img-circle{\n  border-radius: 40%;\n  height: 70px;\n}\n\n#userImage{\n  float:right;\n}\ntr.expanded {\n    cursor: pointer;\n}\n\ntr.collapsed {\n  cursor: pointer;\n}\n\n.img-circle {\n    border-radius: 50%;\n}\n\n.table-img-circle {\n  border-radius: 50%;\n  height: 33px;\n}\n\nul li.item[disabled] {\n  opacity: .4;\n  cursor: default;\n  pointer-events: none;\n}\n\n[ng-click]:hover {\n\tcursor:pointer;\n}\n\nmd-icon.brown_icon svg {\n  fill: #996633;\n}\n\nmd-icon.white_icon svg {\n  fill: white;\n}\n\nmd-icon.red_icon svg {\n  fill: red;\n}\n\nmd-icon.grey_icon svg {\n  fill: grey;\n}\n\nmd-icon.green_icon svg {\n  fill: green;\n}\n\nmd-icon.orange_icon svg {\n  fill: orange;\n}\n\nmd-icon.blue_icon svg {\n  fill: #5596E6;\n}\n\nmd-icon.light_blue_icon svg {\n  fill: #a6c8f2;\n}\n\nmd-icon.teal_icon svg {\n  fill: teal;\n}\nmd-icon.bisque_icon svg {\n  fill: bisque; /* light-orange */\n}\n\nmd-icon.pink_icon svg {\n  fill: pink;\n}\n\nmd-icon.flip svg {\n  -ms-transform: rotate(45deg); /* IE 9 */\n  -webkit-transform: rotate(45deg); /* Chrome, Safari, Opera */\n  transform: rotate(45deg);\n}\n\nspan.download:hover {\n    color: green;\n}\n\nmd-icon.remove:hover svg{\n    fill: red;\n}\n\nmd-icon.rotating{\n  -webkit-animation-name: rotate;\n  -webkit-animation-duration : 5s;\n  -webkit-animation-iteration-count : infinite ;\n  -webkit-animation-timing-function: linear;\n  animation-name : rotate;\n  animation-duration :5s ;\n  animation-iteration-count : infinite;\n  animation-timing-function: linear;\n}\n\n/* Chrome, Safari, Opera */\n@-webkit-keyframes rotate {\n    100% { -webkit-transform: rotate(360deg); }\n}\n\n/* Standard syntax */\n@keyframes rotate {\n  100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); }\n}\n\n.upAndDown{\n  -webkit-animation-name: upDown;\n  -webkit-animation-duration : 2s;\n  -webkit-animation-iteration-count : 1 ;\n  animation-name : upDown;\n  animation-duration :2s ;\n  animation-iteration-count: 1;\n}\n\n\n\n/* Chrome, Safari, Opera */\n@-webkit-keyframes upDown {\n    0%   {top: 0px;}\n    25%  {top: -10px;}\n    100% {top: 0px;}\n}\n\n/* Standard syntax */\n@keyframes upDown {\n    0%   {top: 0px;}\n    25%  {top: -10px;}\n    100% {top: 0px;}\n}\n/*\np.teamview:hover {\n  background-color: #0080FF;\n}\n*/\n#customDialog {\n  min-width: 350px;\n  min-height: 350px;\n  background-color: rgb(250,250,250);\n}\n#cutomContainer {\n\n}\n#genInfo {\n  margin-right: 0px;\n  margin-left: 0px;\n  padding: 0px;\n}\nspan.formfield {\n  display: block;\n  overflow: hidden;\n  padding-right:10px;\n}\ninput.formfield {\n  width: 100%;\n}\n.dmt-team-btn {\n  margin: 0px;\n  padding: 0px;\n  float: right;\n}\n\n.flags {\n  float: right;\n  border: solid 1px lightgray;\n  padding: 7px;\n  border-radius: 7px;\n  background-color: white;\n  min-width: 15%;\n  text-align: center;\n}\n\n.userField {\n  padding: 6px;\n}\n.userField:focus {\n\tbox-shadow: 1px 1px 7px 2px #a6c8f2;\n}\n\n.logComments {\n  background-color: #ffff99;\n  padding: 0px 5px 1px 5px;\n  border-radius: 5px;\n  font-size: 8pt;\n}\n.errComments {\n  color: white;\n  background-color: steelblue;\n  padding: 0px 5px 1px 5px;\n  border-radius: 5px;\n  font-size: 8pt;\n}\n.grey_box{\n  background-color: whitesmoke; // bery light grey\n}\n\n.orange_box{\n  background-color: bisque; // light orange\n}\n\n.pink_box{\n  background-color: pink; //\n}\n\n.grey_box.red_box{\n  background-color: pink ;\n}\n\n.checkbox_container {\n  border: 1px solid lightgray;\n  border-radius: 8px;\n  background-color: #e6f2ff;\n  padding: 10px;\n}\n\n.checkbox_subcontainer {\n  border: 1px solid lightgray;\n  border-radius: 8px;\n  background-color: white;\n  padding: 8px;\n}\n\n.search_box {\n  border: 1px solid lightgray;\n  padding: 6px;\n  background-color: #e6f2ff;\n  border-radius: 8px 0px 0px 8px;\n}\n\n.download-container {\n  display: block;\n  position: relative;\n  width: 100%;\n  border: 2px solid #aad1f9;\n  transition: opacity  0.1s linear;\n  border-top: 0px;\n}\n\n.download-block-notification {\n  display: block;\n  position: relative;\n  background-color: rgba(255, 235, 169, 0.25);\n  height: 58px;\n}\n\n.download-block-notification > span {\n  display: inline-block;\n  margin-top: 10px;\n  padding: 25px;\n  font-size: 0.9em;\n}\n\n.hide-dt-column {\n  display: none;\n}\n\nbody {\n  background-image: url("/public/images/background.jpg");\n  background-size:cover;\n  background-position:center;\n}\n\n.dmt-no-md-list-padding {\n  padding : 0px;\n}\n.dmt-white-background {\n  background-color: white;\n}\n.inputError {\n\tbox-shadow: -7px 0px 10px 5px #ffe6e6;\n\tbackground-color: #ffe6e6;\n\tcolor: red;\n\tpadding: 2px;\n\tmargin: 10px;\n}\n\n.red_text{\n  color: red ;\n}\n\n.green_text{\n  color: green ;\n}\n\n.blue_text{\n  color: blue ;\n}\n\n.orange_text{\n  color: orange ;\n}\n\n.scrol-width-small {\n  min-width: 900px;\n}\n\n\n.scrol-overflow-min {\n  display: block;\n  overflow-x: auto;\n  min-width: 900px;\n}\n\n.scrol-overflow {\n  display: block;\n  overflow-x: auto;\n\n}\n\n.scrol-overflow * {\n  font-size: 12px;\n}\n\n.max-height {\n  display: block;\n  max-height: 400px;\n  overflow-y: scroll;\n}\n\n.hover-grey:hover #genInfo {\n  background-color: whitesmoke; // bery light grey\n}\n\n.hover-grey span, .search-form span, .hover-grey b, .search-form b  {\n  word-wrap: break-word;\n  word-break:normal;\n}\n\n.no-padding{\n  margin : 0px;\n}\n\n.no-padding md-select-value{\n  min-width : 30px;\n}\n/*.small-left-margin should not be used with the dynamic columns any longer */\n.small-left-margin span, .small-left-margin b {\n  margin-left : 3px;\n\n}\n\n.add-margin .three-right {\n  margin-left : 3px;\n}\n\n.thirty-right {\n  padding-left : 30px;\n}\n\n.table-wrapper {\n  width: 100%;\n  table-layout: fixed;\n}\n\n.untouched-message {\n  color: pink;\n}\n.search-button {\n  display: inline-flex;\n  min-width: 120px;\n}\n\n.grey-button {\n  background-color: silver;\n}\n\nbody.md-toast-animating {\n  overflow: auto !important;\n}\n\n/* ADMIN PAGES START */\n.right {\ntext-align: right;\n}\n.field {\n    padding-bottom: 3px;\n}\n.selectbox {\n    border-radius: 0px 0px 0px 8px;\n    padding: 10px;\n    border: 1px solid lightgray;\n    max-height: 150px;\n    overflow:scroll;\n    overflow-x:hidden\n}\n.selectbox_bottom {\n  padding: 6px;\n  border-radius: 8px;\n  border-width: 1px;\n  border-style: solid;\n  border-color: lightgrey;\n}\n.select_good {\n    background-color: rgb(225, 242, 255);\n}\n.select_error {\n    background-color: lightpink;\n}\n.selected {\n    height: 165px;\n    padding: 5px;\n    border: 1px solid lightgray;\n    overflow: scroll;\n    overflow-x:hidden;\n    max-height: 165px;\n    border-radius: 0px 0px 0px 8px\n}\n.selected_top {\n    max-height: 21px;\n    border-width: 1px 1px 0px;\n    border-style: solid solid none;\n    border-color: lightgrey lightgrey;\n    border-radius: 8px 0px 0px 0px;\n    margin-top: 8px;\n    padding-left: 11px;\n    background-color: rgb(225, 242, 255);\n}\n\n.zero_top_padding {\n  padding-top: 0px;\n}\n\n.fit_table {\n  width: 100%;\n  word-wrap: break-word;\n  table-layout:fixed;\n}\n\n.comment_real {\n  max-width:600px;\n  word-wrap: break-word;\n}\n.dmt-team-btn-run {\n  margin: 0px;\n  padding: 0px;\n  float: left;\n}\n\n/* ADMIN PAGES END */\n.ibm_select {\n  border: solid 1px lightgray;\n  margin-top: -5px;\n  margin-bottom: 12px;\n}\n\n\n.oneQuestion {\n    width: 350px;\n}\n/*\ntfoot {\n    display: table-header-group;\n}\ntfoot input {\n  width:100%;\n  display:block\n}\n*/\n.column-filter{\n  /*width: 100px;*/\n  width:100%;\n  display:block\n}\n\n.column-filter:hover{\n  width: 200px;\n}\n\ntable.queue-table {\n  display: block;\n  overflow-x: auto;\n  min-width: 900px;\n}\n\n.sap_css {\n  padding: 10px;\n}\n\n.calc_gpp {\n    padding: 3px;\n    padding-left: 10px;\n    color: darkgreen;\n    border-radius: 10px;\n    background-color: #cfffcf;\n}\n.calc_so {\n    padding: 3px;\n    padding-left: 10px;\n    color: steelblue;\n    border-radius: 10px;\n    background-color: #daeeff;\n}\n\n.input {\n  border: solid 1px lightgray\n}\n');
$templateCache.put('approval-dialog.html','<md-dialog aria-label="Select Approver" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>{{::vm.appBundle.action}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><p ng-if="vm.appBundle.textContent" ng-bind-html="vm.appBundle.textContent"></p><div ng-if="vm.appBundle.nextStatusObject.users"><p>The {{vm.appBundle.action != "Renotify Approver" ? "next Approval stage will be" : "current Approval stage is"}}&nbsp;<span class="ibm-textcolor-blue-50"><b>{{::vm.appBundle.nextSubStatusDesc}}</b></span>. &nbsp;Please select someone to notify from the&nbsp;<span class="ibm-textcolor-blue-50"><b>{{::vm.appBundle.nextStatusObject.users.length}}</b></span>&nbsp;authorised Approvers below:</p><!--select(style="width: 20em" ng-model=\'vm.appBundle.select_approver\' ng-options=\'o.name as o.name for o in vm.appBundle.nextStatusObject.users | filter: { email: "!" + vm.appBundle.owner }\' )--><!--select(style="width: 20em" ng-model=\'vm.appBundle.select_approver\' ng-options=\'o.name as o.name for o in vm.appBundle.nextStatusObject.users | appFilter:vm.appBundle.excludeList\' )--><select style="width: 20em" ng-model="vm.appBundle.select_approver" ng-options="o.name as o.name for o in vm.appBundle.nextStatusObject.users"></select><span style="margin-left: 1em" ng-if="[\'Renotify Approver\',\'Approve\'].indexOf(vm.appBundle.action) &gt; -1"><b class="ibm-textcolor-red-50">NOTE</b>: Any&nbsp;<span class="ibm-textcolor-blue-40" title="{{vm.appBundle.prevApprovers}}">previous Approvers (including the submitter)</span>&nbsp;will have been removed from this list if found.</span><span style="margin-left: 1em" ng-if="vm.appBundle.action === \'Submit for Approval\'"><b class="ibm-textcolor-red-50">NOTE</b>: As the person initiating the Approval Process, you will not be permitted to Approve any stage and will have been removed from this list if found. </span><p ng-if="vm.appBundle.selected_approver"><p></p>Should you choose to continue, &nbsp;<b>{{vm.appBundle.select_approver}}</b>&nbsp;, will receive an email asking them to approve this Disbursement.  &nbsp;This does not mean, however, only they can approve - any of those listed above can approve, but only the Approver selected will be notified.</p></div><p ng-if="vm.appBundle.commentsMandatory">Please enter the {{::vm.appBundle.action}} Reason and click&nbsp;<b>OK</b>, or&nbsp;<b>Cancel</b>&nbsp;to quit.</p><p ng-if="!vm.appBundle.commentsMandatory">You may add some Comments as support, if you like.</p><ng-form name="appForm"><textarea class="userField" name="comments" ng-model="vm.appBundle.comments" style="resize: none" rows="5" cols="100" resize="false" ng-required="vm.appBundle.commentsMandatory"></textarea></ng-form></md-content><md-button class="md-raised md-primary" ng-disabled="appForm.comments.$invalid || (!vm.appBundle.commentsMandatory &amp;&amp; !vm.appBundle.approvalComplete &amp;&amp; !vm.appBundle.select_approver)" ng-click="vm.answer()">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-dialog-content></md-dialog>');
$templateCache.put('confirm-and-comment.html','<md-dialog aria-label="{{vm.field}}" ng-cloak="ng-cloak"><md-toolbar><div class="md-toolbar-tools"><h2>{{vm.dialogName}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div><span>{{vm.message}}</span></div><p></p><div><input ng-model="vm.comment"/></div><p></p><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.clickYes()" ng-disabled="vm.comment.trim() === \'\'">{{vm.okMessage}}</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.clickNo()">{{vm.cancelMessage}}</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" style="float:right" ng-if="vm.addCancel" ng-click="vm.cancel()">Cancel</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('confirm-prompt.html','<form name="paymentForm"><md-dialog aria-label="Confirm Prompt" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>{{::vm.title}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.clickNo()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><div id="icon" style="float:left; border:solid 1px white; padding: 6px; display: flex"><md-icon class="red_icon" ng-if="vm.icon==\'ERROR\'" style="height:50px; width:50px" md-svg-src="/public/images/close-circle.svg" aria-label="Prompt icon"></md-icon><md-icon class="blue_icon" ng-if="vm.icon==\'INFO\'" style="height:50px; width:50px" md-svg-src="/public/images/ic_info_outline_black_24px.svg" aria-label="Prompt icon"></md-icon><md-icon class="orange_icon" ng-if="vm.icon==\'WARN\'" style="height:50px; width:50px" md-svg-src="/public/images/ic_warning_black_24px.svg" aria-label="Prompt icon"></md-icon><md-icon class="blue_icon" ng-if="vm.icon==\'QUESTION\'" style="height:50px; width:50px" md-svg-src="/public/images/help-circle.svg" aria-label="Prompt icon"></md-icon></div><div id="message" style="border:solid 1px white; padding: 6px; display: flex"><span ng-bind-html="vm.message"></span></div><div id="justify" ng-if="vm.prompt"><md-input-container><label>Justification</label><input required="required" aria-label="justification" ng-model="vm.justification" minlength="15"/><ng-messages for="paymentForm.justify.$error"><ng-message when="minlength">Please enter at least 15 characters.</ng-message></ng-messages></md-input-container></div><div style="text-align:center; border:solid 1px white;"><md-button class="md-raised md-primary" ng-if="vm.icon!=\'QUESTION\'" ng-click="vm.clickYes()">OK</md-button><md-button class="md-raised md-primary" ng-if="vm.icon==\'QUESTION\'" ng-click="vm.clickYes()" ng-disabled="paymentForm.$invalid">Yes</md-button><md-button class="md-raised md-secondary" style="margin-left:5px" ng-if="vm.icon==\'QUESTION\'" ng-click="vm.clickNo()">No</md-button></div></md-content></md-dialog-content></md-dialog></form>');
$templateCache.put('cross-board.html','<md-dialog ng-cloak="ng-cloak" aria-label="{{vm.dialogName}}"><md-toolbar><div class="md-toolbar-tools"><h2>{{vm.dialogName}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" aria-label="Close dialog" md-svg-src="/public/images/ic_close_black_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div><span>{{vm.message}}</span></div><p></p><br/><div class="selectbox" style="overflow: auto; background-color: white"><input ng-model="vm.isApproved" type="checkbox"/>Pass Cross Board eligibility &nbsp;&nbsp;</div><br/><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.clickYes()" ng-disabled="!vm.isApproved">{{vm.okMessage}}</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.clickNo()">{{vm.cancelMessage}}</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('cycle-times.html','<style>.center {\n    text-align: center;\n}</style><md-dialog aria-label="Cycle Times" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Cycle Times</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.clickNo()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content style="min-width: 40em"><md-content class="md-padding"><p>The following table details the&nbsp;<b>Cycle Time Ownership</b>&nbsp;for this Disbursement.</p><table class="ibm-data-table table" cellspacing="0" cellpadding="0" border="0" style="min-width: 40em"><tr style="background-color: #f2f2f2; border-bottom: 3px solid lightgray; border-right: 3px solid lightgray"><th class="center" ng-repeat="header in vm.columnHeaders"><b style="color:gray; font-size: medium">{{::header}}</b></th></tr><tr ng-repeat="cycle in vm.cycles"><td class="center" ng-repeat="(key, value) in cycle"><b class="ibm-textcolor-blue-50" ng-if="vm.currentOwner == key">{{::key}}</b><span ng-if="vm.currentOwner !== key">{{::key}}</span></td><td class="ibm-textcolor-blue-50 center" ng-repeat="(key, value) in cycle">{{::value}}</td><td class="ibm-textcolor-blue-50 center" ng-repeat="(key, value) in cycle"><span class="ibm-textcolor-blue-50 center" ng-if="vm.currentOwner == key">Current Owner</span></td></tr><tr style="background-color: #f2f2f2; border-bottom: 3px solid lightgray; border-right: 3px solid lightgray"><td class="center"><b style="font-size: medium">Total Days</b></td><td class="center"><b style="font-size: medium">{{::vm.totalDays}}</b></td><td></td></tr></table><p></p><div style="border: 1px solid lightgray; padding: 8px; width: 25em"><div style="text-align: center">Start :&nbsp;<b class="ibm-textcolor-blue-40">{{::vm.dates.startDate | date:"medium"}}</b><br/><span style="margin-top: 3px">End :&nbsp;<b class="ibm-textcolor-blue-40">{{::vm.dates.endDate | date:"medium"}}</b></span></div></div><p><div style="width: 33em">To view the breakdown of the Ownership Changes, return to the Disbursement and click&nbsp;<md-icon class="blue_icon" md-svg-src="/public/images/ic_history_black_24px.svg"></md-icon>&nbsp;to display the History Log.</div></p></md-content></md-dialog-content></md-dialog>');
$templateCache.put('detail-loading.html','<!--author Ivan Toth--><h1 class="ibm-textcolor-blue-40 ibm-h3">Loading Request Details...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><!--spanspan(class=\'ibm-spinner\')\nspan Loading Request Details....-->');
$templateCache.put('detail-tabs.html','<div id="ibm-content-nav"><div class="ibm-graphic-tabs ibm-graphic-tabs--colored"><ul class="ibm-tabs ibm-background-blue-60 ibm-border-blue-20 ibm-textcolor-white-core"><li ng-repeat="tab in vm.topic.tabs.list track by $index" ui-sref-active="ibm-active" ng-if="tab.visible"><a ng-if="tab.editable" aria-selected="{{vm.topic.tabs.activeTab===tab.name}}" role="tab" ng-click="vm.goTo(tab)" ng-bind="tab.title"></a><a ng-if="!tab.editable" ng-disabled="!tab.editable" role="tab"><md-icon class="grey_icon" md-svg-src="/public/images/ic_do_not_disturb_alt_black_24px.svg"></md-icon><span ng-bind="tab.title" style="color:grey;" layout-align="center center"></span></a></li></ul></div></div>');
$templateCache.put('detail-unassigned-deprecated.html','<div class="ibm-columns" style="float:left" id="generalInfo"><h2 class="ibm-h2">Opportunity Summary Data</h2><div class="ibm-col-4-1" id="generalInfo1"><label for="generalTemplate">Opportunity number:</label><label for="generalTemplate">Overall MySA status:</label><label for="generalTemplate">Business Partner:</label><label for="generalTemplate">Customer number:</label><label for="generalTemplate">CVR Owning Organization:</label><label for="generalTemplate">Opportunity Currency:</label></div><div class="ibm-col-4-1" id="generalInfoData"><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.topic.topic.gpp[0].opp}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.svioverallstat}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.bpname}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.cnum}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.sviownorg}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.oppcurrency}}</label></div><div class="ibm-col-4-1" id="generalInfo2"><label for="generalTemplate">ISU Code number:</label><label for="generalTemplate">ISU Code Description:</label><label for="generalTemplate">Submit Date for CVR Eligibility:</label><label for="generalTemplate">Expiration Date:</label><label for="generalTemplate">Exception Request:</label></div><div class="ibm-col-4-1" id="generalInfo2Data"><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.isucodenum}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.isucodedesc}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.svisubmitdate}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.sviexpdate}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.exceptionreq}}</label></div></div><div class="ibm-columns" style="float:left" id="accountInfo"><h2 class="ibm-h2">Account Information</h2><div class="ibm-col-4-1" id="accountInfo1"><label for="generalTemplate">Account</label><label for="generalTemplate">Account Address:</label><label for="generalTemplate">Account City:</label><label for="generalTemplate">Account State Province:</label></div><div class="ibm-col-4-1" id="accountInfoData"><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.acctname}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.acctaddr}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.acctstate}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.accprovince}}</label></div><div class="ibm-col-4-1" id="accountInfo2"><label for="generalTemplate">Account Postal Code:</label><label for="generalTemplate">Account Country:</label><label for="generalTemplate">BANT Form Attached ?</label></div><div class="ibm-col-4-1" id="accountInfo2Data"><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.acctpostcode}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.acctctry}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.bant}}</label></div></div><div class="ibm-columns" style="float:left" id="brandFamily"><h2 class="ibm-h2">Brand family and revenue information</h2><div class="ibm-col-4-1" id="brandFamily1"><label for="generalTemplate">Bill Date:</label><label for="generalTemplate">Type:</label><label for="generalTemplate">Brand:</label><label for="generalTemplate">Brand Family CVR Participation:</label><label for="generalTemplate">Win Probability:</label><label for="generalTemplate">Quantity:</label></div><div class="ibm-col-4-1" id="brandFamily1Data"><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.billdate}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.type}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.brand}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.brandfam}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.winprob}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.quantity}}</label></div><div class="ibm-col-4-1" id="brandFamily2"><label for="generalTemplate">Price:</label><label for="generalTemplate">Revenue:</label><label for="generalTemplate">Sales Order Number:</label></div><div class="ibm-col-4-1" id="brandFamily2Data"><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.price}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.revenue}}</label><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.tempData.salesorder}}</label></div></div>');
$templateCache.put('detail.html','<!-- author Ivan Toth--><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon"><div id="ibm-content" ibm-back-to-top=""><span ng-if="!(vm.topic.loaded.topic==true &amp;&amp; vm.settings.loaded==true)"><h2 class="ibm-textcolor-blue-40 ibm-h3"><span ng-if="vm.topic.loaded.topic!=true">&nbsp;Loading Disbursement Details...</span><span ng-if="vm.settings.loaded!=true">&nbsp;Loading Settings...</span><span ng-if="vm.historyLoaded!=true">&nbsp;Loading Engage Support activity history...</span><span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h2></span><div id="ibm-content-body" style="padding-top: 0px"><div id="ibm-content-main" ng-if="vm.topic.loaded.topic &amp;&amp; vm.settings.loaded"><topic-errors errors="vm.topic.topic.errors"></topic-errors><div class="ibm-band ibm-background-blue-10"><div class="ibm-columns"><div class="ibm-col-4-3"><div class="checkbox_container" id="userDetails"><div class="flags" ng-if="!vm.uiVersion || vm.uiVersion &lt; vm.OPP_VERSION_3"><span title="Incentive Type Flag"><md-icon class="blue_icon" md-svg-src="/public/images/sales_assist.svg"></md-icon>&nbsp;{{vm.getSalesLabel()}}</span><span ng-if="vm.topic.topic.solutionDecision" title="Solution Decision Flag"><br/><md-icon class="orange_icon" md-svg-src="/public/images/star-outline.svg"></md-icon>&nbsp;{{vm.topic.topic.solutionDecision}}</span><span ng-if="(vm.topic.topic.status.status_no === 3 &amp;&amp; vm.topic.topic.newClient &amp;&amp; vm.topic.topic.nc.ncDecision === undefined) || vm.topic.topic.nc.ncDecision === true" title="{{{true: \'New Client Flag\', false: \'Pending New Client Decision in Eligibility\'}[vm.topic.topic.nc &amp;&amp; vm.topic.topic.nc.ncDecision===true]}}"><br/><md-icon class="green_icon" md-svg-src="/public/images/account-plus.svg"></md-icon><span ng-class="{\'ibm-textcolor-gray-40\':vm.topic.topic.newClient &amp;&amp; !vm.topic.topic.nc.ncDecision}">&nbsp;New Client</span></span></div><div class="flags" ng-if="vm.uiVersion &gt;= vm.OPP_VERSION_3 &amp;&amp; !vm.isIncentivesEmpty"><span ng-if="vm.incentiveProgramsConfig.cvrSSA || vm.incentiveProgramsConfig.salesIncentive"><md-icon class="blue_icon" md-svg-src="/public/images/sales_assist.svg"></md-icon>&nbsp;{{vm.getSalesLabel()}}</span><span ng-if="vm.incentiveProgramsConfig.solution || vm.incentiveProgramsConfig.engagement"> <br/><md-icon class="blue_icon" md-svg-src="/public/images/star-outline.svg"></md-icon>&nbsp;{{vm.uiVersion >= 4 ? \'Engagement\' : \'CVR Solution\'}}</span><span ng-if="vm.incentiveProgramsConfig.growthIncentive"><br/><md-icon class="blue_icon" md-svg-icon="/public/images/rocket.svg"></md-icon>&nbsp;Growth</span><span ng-if="vm.incentiveProgramsConfig.focusIncentive"><br/><md-icon class="blue_icon" md-svg-src="/public/images/ic_remove_red_eye_black_24px.svg"></md-icon>&nbsp;Focus</span><span ng-if="vm.incentiveProgramsConfig.NC"><br/><md-icon class="blue_icon" md-svg-src="/public/images/account-plus.svg"></md-icon>&nbsp;New Client</span><span ng-if="vm.incentiveProgramsConfig.specialBid"><br/><md-icon class="blue_icon" md-svg-src="/public/images/cash-multiple.svg"></md-icon>&nbsp;Special Bid</span></div><div><p class="ibm-h4 ibm-textcolor-red-50 ibm-bold">IBM Confidential</p><p>Unique Ref :&nbsp;<b>{{vm.topic.topic._id}}</b><dispute-details-section style="margin-left: 8px" ng-if="vm.topic.topic.dispute_details" vm="vm"></dispute-details-section><ftpgpp-details-section style="margin-left: 8px" ng-if="vm.topic.topic.ftp_gppreport.date_processed" vm="vm"></ftpgpp-details-section></p><p>Program Type :&nbsp;<b>{{vm.getProgramType()}}&nbsp;&nbsp;<md-icon class="ng-class: {red_icon: !vm.config.proProfileLoaded , blue_icon: vm.config.proProfileLoaded}" md-svg-src="/public/images/ic_info_outline_black_24px.svg" ng-click="vm.viewProgramProfile($event)" title="View Program Workflow Profile"></md-icon><span ng-if="vm.topic.topic.status.approvals.approval_reason">&nbsp;<md-icon class="red_icon" ng-if="vm.topic.topic.status.approvals.approval_required &amp;&amp; !vm.topic.topic.status.approvals.complete" md-svg-src="/public/images/account-multiple.svg" title="{{vm.getApprovalTitle()}}"></md-icon><md-icon class="gray_icon" ng-if="!vm.topic.topic.status.approvals.approval_required" md-svg-src="/public/images/account-multiple.svg" title="{{vm.getApprovalTitle()}}"></md-icon><md-icon class="green_icon" ng-if="vm.topic.topic.status.approvals.complete" md-svg-src="/public/images/account-multiple.svg" title="{{vm.getApprovalTitle()}}"></md-icon></span></b></p><p><span>Status :&nbsp;</span><span id="status"></span><b>{{vm.topic.topic_ext.status}}&nbsp;&nbsp;</b><detail-table-log vm="vm"></detail-table-log>&nbsp;<md-icon class="blue_icon" md-svg-src="/public/images/bike.svg" ng-click="vm.viewCycleTimes($event)" title="View Cycle Times"></md-icon>&nbsp;<md-icon class="blue_icon es_history" md-svg-src="/public/images/es_history.svg" ng-click="vm.viewEngageSupportHistory($event)" title="View ES history"></md-icon>&nbsp;</p><p><span>Sub-Status :&nbsp;</span><!--span(ng-if="!vm.topic.topic.owner || vm.topic.editableComponents[vm.comp].socket || vm.topic.topic_ext.problem || [2,5,7,8,9].indexOf(vm.topic.topic.status.status_no) > -1")--><span ng-if="vm.topic.isSubSystemSet || !vm.topic.topic.owner || vm.topic.editableComponents[vm.comp].socket || vm.topic.topic_ext.problem"><b>{{vm.topic.topic_ext.sub_status}}&nbsp;&nbsp;<span class="ibm-spinner" ng-if="vm.loadingUsers">&nbsp;</span><md-icon class="blue_icon" ng-if="[2,5].indexOf(vm.topic.topic.status.status_no) &gt; -1 &amp;&amp; !vm.loadingUsers" md-svg-src="/public/images/ic_face_black_24px.svg" ng-click="vm.viewApprovers($event)" title="View Approvers"></md-icon><md-icon class="blue_icon" ng-if="vm.topic.topic.status.rejection_details &amp;&amp; vm.topic.topic.status.status_no === 8" md-svg-src="/public/images/ic_info_outline_black_24px.svg" ng-click="vm.viewRejectionDetails($event)" title="View Rejection Details"></md-icon><md-icon class="blue_icon" ng-if="vm.topic.topic.status.close_details &amp;&amp; vm.topic.topic.status.status_no === 9" md-svg-src="/public/images/ic_info_outline_black_24px.svg" ng-click="vm.viewClosureDetails($event)" title="View Closure Details"></md-icon></b></span><span ng-if="!vm.topic.topic_ext.problem &amp;&amp; vm.topic.topic.owner"><!--span(ng-if="[2,5,7,8,9].indexOf(vm.topic.topic.status.status_no) == -1 && !vm.topic.editableComponents[vm.comp].socket")--><span ng-if="!vm.topic.isSubSystemSet &amp;&amp; !vm.topic.editableComponents[vm.comp].socket"><!--select(style="width: 20em" ng-model=\'vm.topic.temp_ext.sub_status\' ng-options=\'o.txt as o.txt for o in vm.topic.temp_ext.status_array | filter: {system:false}\',ng-change="vm.showStatusSaveButton()" ng-disabled="vm.status.mainStatusChange")--><select style="width: 20em" ng-model="vm.topic.temp_ext.sub_status" ng-options="o.txt as o.txt for o in vm.topic.temp_ext.status_array | statusFilter" ng-change="vm.showStatusSaveButton()" ng-disabled="vm.status.mainStatusChange"></select><span ng-if="!vm.status.mainStatusChange &amp;&amp; vm.showstatusSave &amp;&amp; vm.topic.topic_ext.sub_status != vm.topic.temp_ext.sub_status &amp;&amp; vm.topic.topic_ext.sub_status!=\'Undefined!\'">&nbsp;<!--md-button(ng-disabled="vm.disableStatusSave" class="ibm-btn-pri ibm-btn-small ibm-btn-green-50",ng-click="vm.saveStatus()" title="{{{true: \'Sub-Status change not permitted for system-set Sub-Statuses\', false: \'Save Sub-Status Change\'}[vm.disableStatusSave]}}")--><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.saveStatus()" title="Confirm and save Sub-Status change"><md-icon class="white_icon" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Save</md-button></span></span></span></p></div></div></div><div class="ibm-col-4-1"><div class="checkbox_container" id="userImage" style="text-align:center; width: 75%">Assigned to :&nbsp;<p></p><span class="ibm-textcolor-blue-50" ng-if="vm.topic.topic.owner"><!--img.img-circle(ng-src="//w3-stpics.ibm.com/bluepages/photo/Photo.jsp?email={{vm.topic.topic.owner}}" alt="Who?" title="{{vm.topic.topic.owner}}")--><!--img.img-circle(ng-src="//faces.tap.ibm.com/imagesrv/{{vm.topic.topic.owner}}.jpg?s=75" alt="Who?" title="{{vm.topic.topic.owner}}")--><img class="img-circle" ng-src="{{vm.getAvatar()}}" alt="Who?" title="{{vm.topic.topic.owner}}"/></span><span class="ibm-textcolor-red-40" ng-if="!vm.topic.topic.owner" title="Please assign"> Awaiting<br/>BPSO Assignment</span></div></div><!--.ibm-col-4-1#userImage(class="checkbox_container" style="margin-top:5px;")\n    span(style="margin-left:17px; display: inline-block")\n        | Your Actions :\n        action-Menu\n        display-error(section="vm.allMessage" style="margin-right: 17px")--><div class="ibm-col-4-1"><div class="checkbox_container" id="userImage" style="margin-top: 4px;width: 75%;text-align: center;"><span style="display: inline-block"><action-Menu></action-Menu><display-error section="vm.allMessage"></display-error></span></div></div><!--.ibm-col-4-1#userImage(class="checkbox_container" style="margin-top:5px; text-align: center")\n        span(title="Incentive Type Flag")\n            md-icon(class="blue_icon" md-svg-src="/public/images/sales_assist.svg")\n            | &nbsp;{{(vm.topic.topic.sales_assist && vm.topic.topic.sales_assist.type) ? vm.topic.topic.sales_assist.type : \'Automatic\'}}\n        span(ng-if="vm.topic.topic.solutionDecision" title="Solution Decision Flag")\n            br\n            md-icon.orange_icon(md-svg-src="/public/images/star-outline.svg")\n            | &nbsp;{{vm.topic.topic.solutionDecision}}\n        // Card 1248 - 2018-03-05 - Domenico de Felice - Add frontend flag for new clients\n        span(ng-if="(vm.topic.topic.status.status_no === 3 && vm.topic.topic.newClient && vm.topic.topic.nc.ncDecision === undefined) || vm.topic.topic.nc.ncDecision === true" title="{{{true: \'New Client Flag\', false: \'Pending New Client Decision in Eligibility\'}[vm.topic.topic.nc && vm.topic.topic.nc.ncDecision===true]}}")\n            br\n            md-icon.green_icon(md-svg-src="/public/images/account-plus.svg")\n            span(ng-class="{\'ibm-textcolor-gray-40\':vm.topic.topic.newClient && !vm.topic.topic.nc.ncDecision}") &nbsp;New Client--><div class="ibm-col-4-1"><div class="checkbox_container" id="userImage" style="margin-top:5px" ng-if="vm.searchSubmit.laterProcess"><span style="margin-left:17px"><span title="Search was kept for later processing (Its not saved yet)">Last search - {{vm.topic.searchDropDownNames[vm.searchSubmit.original.ds]}}:</span><span class="ibm-h4" ng-click="vm.showSearchResults()" title="Click to open last search result"><md-icon md-svg-src="/public/images/ic_list_black_24px.svg"></md-icon></span></span></div></div><div class="ibm-col-1-1"><p></p><span><flag-section class="checkbox_container"></flag-section></span></div></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><div id="content"><div id="ibm-content-nav"><div class="ibm-graphic-tabs ibm-graphic-tabs--colored"><ul class="ibm-tabs ibm-background-blue-60 ibm-border-blue-20 ibm-textcolor-white-core"><li ng-repeat="tab in vm.topic.tabs.list track by $index" ui-sref-active="ibm-active" ng-if="tab.visible"><a ng-if="tab.editable" aria-selected="{{vm.topic.tabs.activeTab===tab.name}}" role="tab" ng-click="vm.goTo(tab)" ng-bind="tab.title"></a><a ng-if="!tab.editable" ng-disabled="!tab.editable" role="tab"><md-icon class="grey_icon" md-svg-src="/public/images/ic_do_not_disturb_alt_black_24px.svg"></md-icon><span ng-bind="tab.title" style="color:grey;" layout-align="center center"></span></a></li></ul></div></div><ui-view></ui-view></div></div></div><!--button(class="ibm-btn-pri ibm-contact--bg-green-50 ibm-contact-widget-btn ibm-active",value="",type="button",ng-click="vm.greenVisible = true",ng-if="!vm.greenVisible") Contact us green--><!--button(class="ibm-btn-pri ibm-contact--bg-red-50 ibm-contact-widget-btn ibm-active",value="",type="button",ng-click="vm.redVisible = true",ng-if="!vm.redVisible") Contact us red--><!--#ibm-contact-module(class="ibm-contact-widget ibm-contact--bg-teal-50 addtransition ibm-alternate-background ibm-active")h2(class="ibm-bold") It works--></div></div></div></div></main>');
$templateCache.put('embargo-check.html','<md-dialog ng-cloak="ng-cloak" aria-label="{{vm.dialogName}}"><md-toolbar><div class="md-toolbar-tools"><h2>{{vm.dialogName}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" aria-label="Close dialog" md-svg-src="/public/images/ic_close_black_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div><span>{{vm.message}}</span></div><p></p><br/><div class="selectbox" style="overflow: auto; background-color: white"><input ng-model="vm.isApproved" type="checkbox"/>{{vm.isCountryManualReview ? \'Pass Manual Review\' : \'Pass Embargo Check\'}} &nbsp;&nbsp;</div><br/><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.clickYes()" ng-disabled="!vm.isApproved">{{vm.okMessage}}</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.clickNo()">{{vm.cancelMessage}}</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('es-history.html','<style>.center {\n    text-align: center;\n}</style><md-dialog aria-label="Engage Support" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Engage Support activity history</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.clickNo()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding" style="display: flex; overflow: hidden;"><table class="ibm-data-table ibm-alternate-two" cellspacing="0" cellpadding="0" border="0"><tr style="background-color: #f2f2f2; border-bottom: 3px solid lightgray; border-right: 3px solid lightgray" colspan="3"><th class="center" colspan="3" style="border: 3px solid lightgray;"><b style="color:gray; font-size: medium">ES Creating / Closing logs</b></th></tr><tr ng-if="vm.dataDB2.data.length &gt; 0 &amp;&amp; vm.dataDB2.error == false" style="background-color: #f2f2f2; border-bottom: 3px solid lightgray; border-right: 3px solid lightgray"><th class="center" ng-repeat="header in vm.db2ColumnHeaders" style="border: 3px solid lightgray;"><b style="color:gray; font-size: medium">{{::header}}</b></th></tr><tr ng-if="vm.dataDB2.data.length &gt; 0 &amp;&amp; vm.dataDB2.error == false" ng-repeat="data in vm.dataDB2.data"><td style="border: 3px solid lightgray;">{{::data.esRequestId}}</td><td style="border: 3px solid lightgray;">{{::data.eventText}}</td><td style="border: 3px solid lightgray;">{{::data.time}}</td></tr><tr ng-if="vm.dataDB2.error == true" style="background-color: #f2f2f2; border-bottom: 3px solid lightgray; border-right: 3px solid lightgray" colspan="3"><th class="center" colspan="3" style="border: 3px solid lightgray;"><b style="color:gray; font-size: medium">Unable extract ES activity history</b></th></tr><tr ng-if="vm.dataDB2.data.length == 0" style="background-color: #f2f2f2; border-bottom: 3px solid lightgray; border-right: 3px solid lightgray" colspan="3"><th class="center" colspan="3" style="border: 3px solid lightgray;"><b style="color:gray; font-size: medium">No Logs found</b></th></tr></table><table class="ibm-data-table ibm-alternate-two" cellspacing="0" cellpadding="0" border="0"><tr style="background-color: #f2f2f2; border-bottom: 3px solid lightgray; border-right: 3px solid lightgray" colspan="3"><th class="center" colspan="3" style="border: 3px solid lightgray;"><b style="color:gray; font-size: medium">ES Errors logs</b></th></tr><tr ng-if="vm.dataCouch.data.length &gt; 0 &amp;&amp; vm.dataCouch.error == false" style="background-color: #f2f2f2; border-bottom: 3px solid lightgray; border-right: 3px solid lightgray"><th class="center" ng-repeat="header in vm.couchColumnHeaders" style="border: 3px solid lightgray;"><b style="color:gray; font-size: medium">{{::header}}</b></th></tr><tr ng-if="vm.dataCouch.data.length &gt; 0 &amp;&amp; vm.dataCouch.error == false" ng-repeat="data in vm.dataCouch.data"><td style="border: 3px solid lightgray;">{{::data.action}}</td><td style="border: 3px solid lightgray;">{{::data.message}}</td><td style="border: 3px solid lightgray;">{{::data.date}}</td></tr><tr ng-if="vm.dataCouch.error == true" style="background-color: #f2f2f2; border-bottom: 3px solid lightgray; border-right: 3px solid lightgray" colspan="3"><th class="center" colspan="3" style="border: 3px solid lightgray;"><b style="color:gray; font-size: medium">Unable extract ES activity history</b></th></tr><tr ng-if="vm.dataCouch.data.length == 0" style="background-color: #f2f2f2; border-bottom: 3px solid lightgray; border-right: 3px solid lightgray" colspan="3"><th class="center" colspan="3" style="border: 3px solid lightgray;"><b style="color:gray; font-size: medium">No Logs found</b></th></tr></table></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('move-to-paid-comment.html','<style>.cell {\n  padding-right: 5px;\n  font-size: small;\n}\n.md-datepicker-calendar-pane {\n  z-index: 9999;\n}\n.md-datepicker-input-container {\n  width: 60%;\n}\n.md-padding {\n  padding-bottom: 0;\n}</style><md-dialog ng-cloak="" aria-label="Rollback Status"><md-toolbar><div class="md-toolbar-tools"><h2>Change To Paid Status</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon aria-label="Close dialog" md-svg-src="/public/images/ic_close_white_24px.svg">             </md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><ng-form name="moveToPaidForm"><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left">    <div class="cell" style="align-self: center">Paid Date</div><div class="cell"><md-datepicker ng-model="vm.updateBundle.paidDate" ng-required="true" flex="flex" style="padding:0; margin:0"> </md-datepicker></div></div></md-list-item>Please add some supporting comments:<p></p><textarea class="userField" name="comments" ng-model="vm.action" ng-required="true" style="resize: none" rows="5" cols="100" resize="false"></textarea><p></p></ng-form><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="!vm.$scope.moveToPaidForm.$valid">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-content></md-dialog-content></md-dialog>');
$templateCache.put('notification-mail-preview.html','<style>.boldItem {\n    font-weight: bold;\n}\n</style><md-dialog ng-cloak="ng-cloak" aria-label="{{vm.dialogName}}"><md-toolbar><div class="md-toolbar-tools"><h2>{{vm.dialogName}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" aria-label="Close dialog" md-svg-src="/public/images/ic_close_black_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div><span>{{vm.message}}</span></div><br/><div><p> <span class="boldItem">Mail to: </span>{{vm.data.email}}</p><p><span class="boldItem">Mail from: </span>{{vm.data.from}}</p><p> <span class="boldItem">Mail subject: </span>{{vm.data.subject}}</p><p class="boldItem">Mail body:</p><span ng-bind-html="vm.data.html"></span></div><br/><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.clickNo()">{{vm.cancelMessage}}</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('notification-mail.html','<style>.boldItem {\n    font-weight: bold;\n}\n</style><md-dialog ng-cloak="ng-cloak" aria-label="{{vm.dialogName}}"><md-toolbar><div class="md-toolbar-tools"><h2>{{vm.dialogName}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" aria-label="Close dialog" md-svg-src="/public/images/ic_close_black_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div><span>{{vm.message}}</span></div><br/><div><p class="boldItem"> Mail to: <input ng-model="vm.data.mail.mail.mailTo" style="width: 30em;"/></p><p><span class="boldItem">Mail from: </span>{{vm.data.mail.mail.mailFrom}}</p><p> <span class="boldItem">Mail subject: </span>{{vm.data.mail.mail.subject}}</p><p class="boldItem">Mail body:</p><span ng-bind-html="vm.data.mail.mail.body"></span><p> <span class="boldItem">Attachment: </span>{{vm.data.mail.mail.attachment}}</p></div><br/><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.clickYes()">{{vm.okMessage}}</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.clickNo()">{{vm.cancelMessage}}</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('override-prospect.html','<md-dialog ng-cloak="ng-cloak" aria-label="{{vm.dialogName}}"><md-toolbar><div class="md-toolbar-tools"><h2>{{vm.dialogName}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" aria-label="Close dialog" md-svg-src="/public/images/ic_close_black_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div><span>{{vm.message}}</span></div><p></p><table class="ibm-data-table" cellspacing="0" cellpadding="0"><tr><td><span>CMR&nbsp;*&nbsp;:&nbsp;&nbsp;</span></td><td><input ng-model="vm.CMR" style="width: 20em;"/></td></tr><tr><td><span>DCID&nbsp;:&nbsp;&nbsp;</span></td><td><input ng-model="vm.DCID" style="width: 20em;"/></td></tr><tr><td><span>DBG&nbsp;:&nbsp;&nbsp;</span></td><td><input ng-model="vm.DBG" style="width: 20em;"/></td></tr></table><br/><div class="selectbox" style="overflow: auto; background-color: white"><input ng-disabled="vm.CMR.split(\'\').length &lt; 6 || vm.DCID.split(\'\').length &lt; 8" ng-model="vm.isAutomaticCheck" type="checkbox"/> Trigger Automatic Checks &nbsp;&nbsp;<input ng-disabled="vm.CMR.split(\'\').length &lt; 6" ng-model="vm.isOverride" type="checkbox"/>Override CMR &nbsp;&nbsp;</div><br/><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.clickYes()" ng-disabled="vm.CMR.split(\'\').length &lt; 6 || (vm.DCID.trim() !== \'\' &amp;&amp; vm.DCID.split(\'\').length &lt; 8) || (vm.DBG.trim() !== \'\' &amp;&amp; vm.DBG.split(\'\').length &lt; 8) || (!vm.isOverride &amp;&amp; !vm.isAutomaticCheck)">{{vm.okMessage}}</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.clickNo()">{{vm.cancelMessage}}</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('program-profile.html','<md-dialog aria-label="Program Workflow Profile" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Program Workflow Profile</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.clickNo()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content style="max-width:40em"><md-content class="md-padding" ng-if="vm.error!=null"><p>There was a problem retriving the Program Workflow Profile:<span class="ibm-textcolor-red-50">&nbsp;<b>{{::vm.error}}</b></span></p><p>You will not be permitted to move the Disbursement through the workflow until this is remedied. &nbsp;Please contact the<span class="ibm-textcolor-blue-50">&nbsp;DMT System Administrators&nbsp;</span>for guidance.</p></md-content><md-content class="md-padding" ng-if="vm.error==null"><p>Please contact the<span class="ibm-textcolor-blue-50">&nbsp;DMT System Administrators&nbsp;</span>should the following need updating.</p><table class="ibm-data-table ibm-alternate-two" cellspacing="0" cellpadding="0" border="0" style="min-width: 40em"><tr ng-repeat="(key, value) in vm.cfg.proProfile" ng-if="\'_id,_rev,type\'.indexOf(key) ==-1"><td>{{::vm.convert(key)}}</td><td><span class="ibm-textcolor-blue-50"><span ng-if="[\'approval_stages\',\'preapproval_stages\'].indexOf(key) == -1"><b ng-if="key === \'country\'">{{::vm.cfg.getCountryByShort(value).toUpperCase()}}</b><b ng-if="key !== \'country\'"> {{::vm.convert(value)}}</b></span><span ng-if="[\'approval_stages\',\'preapproval_stages\'].indexOf(key) &gt; -1"><span ng-if="vm.convert(value) != \'N/A\'">Hover over each for details:</span><b ng-if="vm.convert(value) == \'N/A\'">N/A</b><div ng-repeat="app in value"><b ng-if="key==\'approval_stages\'" title="{{vm.cfg.getAppStageForPrez(5,app,false)}}"># {{value.indexOf(app)+1}} - {{vm.cfg.getAppStageForPrez(5,app,true)}}</b><b ng-if="key==\'preapproval_stages\'" title="{{vm.cfg.getAppStageForPrez(2,app,false)}}"># {{value.indexOf(app)+1}} - {{vm.cfg.getAppStageForPrez(2,app,true)}}</b></div></span></span></td></tr><tr><td>STATUS FLOW</td><td><span class="ibm-textcolor-blue-50"><span ng-if="vm.process_statuses.length &gt; 0">Hover over each for details:</span><div ng-if="!vm.process_statuses.length &gt; 0" style="color: red"><b>Unable to retrieve Program Profile Statuses</b><p>Please contact DMT System Administrators for guidance</p></div><div ng-repeat="status in vm.process_statuses"><b title="{{vm.cfg.getMainStatusForPrez(status,false)}}">{{vm.cfg.getMainStatusForPrez(status,true)}}</b></div></span></td></tr></table></md-content></md-dialog-content></md-dialog>');
$templateCache.put('stage-approvers.html','<md-dialog aria-label="Stage Approvers" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>{{::vm.bundle.status}} - {{::vm.bundle.sub_status}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.clickNo()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding" ng-if="vm.error==\'CONFIG\' || vm.error==\'NOAPPS\'"><p><span ng-if="vm.error==\'CONFIG\'">There was a problem retrieving the Status Configuration Profile.</span><span ng-if="vm.error==\'NOAPPS\'">There are currently no Approvers set up in the Status Configuration Profile for this stage!</span></p><p>Please contact the<span class="ibm-textcolor-blue-50">&nbsp;DMT System Administrators&nbsp;</span>for guidance.</p></md-content><md-content class="md-padding" ng-if="vm.error!==\'CONFIG\' &amp;&amp; vm.error!==\'NOAPPS\'"><p><!--span(ng-if="vm.bundle.peer") span(ng-if="vm.bundle.owner") This stage can be Approved by anyone (other than {{::vm.bundle.owner}}) in the&nbsp;\nspan(ng-if="!vm.bundle.owner") This stage can be Approved by anyone in the&nbsp;--><!--span(ng-if="!vm.bundle.peer")| This stage can be Approved by any of the following from the&nbsp;-->This stage can be Approved by any of the following from the&nbsp;<b>{{::vm.bundle.team}}</b>:</p><a ng-click="vm.toggleApprovers()">{{vm.bundle.show}} Approvers<p></p></a><span class="ibm-textcolor-red-50" ng-if="vm.bundle.expand &amp;&amp; vm.error==\'USERS\'">There was a problem retrieving the Approvers list from the server.<p></p></span><div ng-if="vm.bundle.expand &amp;&amp; vm.error == null"><!--p(ng-if="vm.bundle.excludeList.length > 1") b NOTE:\n| &nbsp;Any previous Approvers will have been removed from this list if found. --><p ng-if="vm.bundle.excludeList.length &gt; 1"> <b class="ibm-textcolor-red-50">NOTE</b>: Any&nbsp;<span class="ibm-textcolor-blue-40" title="{{vm.bundle.prevApprovers}}">previous Approvers (including the submitter)</span>&nbsp;will have been removed from this list if found. </p><table class="ibm-data-table ibm-alternate-two" style="border: 1px solid lightgray" cellspacing="0" cellpadding="0" border="0"><!--tr(ng-repeat=\'approver in vm.bundle.approvers | filter: { email: "!" + vm.bundle.owner_email }\')--><!--tr(ng-repeat=\'approver in vm.bundle.approvers |  appFilter:vm.bundle.excludeList\')--><!--tr(ng-repeat=\'approver in vm.bundle.approvers\' ng-if="vm.bundle.excludeList.indexOf(approver.email) === -1")--><tr ng-repeat="approver in vm.bundle.approvers"><td>{{::approver.name}}</td><td><span class="ibm-textcolor-blue-50"><b>{{::approver.email}}</b></span></td></tr></table><p></p></div><p>The current selected Approver is:&nbsp;<b>{{::vm.bundle.selectedApprover.name}} ({{::vm.bundle.selectedApprover.email}})</b></p><p><b>NOTE:</b>&nbsp;This does not mean only they can approve - any of those listed above can approve.\n&nbsp;Should you wish to chase the selected approver or notify someone else, please select<span class="ibm-textcolor-blue-50"><b>&nbsp;Renotify Approver&nbsp;</b></span>from the Your Actions menu.</p></md-content></md-dialog-content></md-dialog>');
$templateCache.put('detail-preview.html','<span ng-if="!(vm.topic.loaded.topic==true &amp;&amp; vm.settings.loaded==true)"><h2 class="ibm-textcolor-blue-40 ibm-h3"><span ng-if="vm.topic.loaded.topic!=true">&nbsp;Loading Disbursement Details...</span><span ng-if="vm.settings.loaded!=true">&nbsp;Loading Settings...</span><span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h2></span><div ng-if="vm.topic.loaded.topic==true &amp;&amp; vm.settings.loaded==true"><topic-errors errors="vm.topic.topic.errors"></topic-errors><detail-gpp></detail-gpp></div>');
$templateCache.put('terms.html','<style>.serverError {\n        border: 1px solid red; \n        padding: 10px; \n        margin: 10px; \n        background-color: #fff4f6\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Acceptable Terms of Use</b></h1></div></div><div class="ibm-columns" ng-if="!vm.events.loaded"><div class="ibm col-1-1"><h1 class="ibm-textcolor-blue-40 ibm-h3" style="margin-left:10px"><span>Retrieving, please wait...</span><span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div></div><div class="ibm-columns" ng-if="vm.events.serverError"><div class="ibm-col-1-1"><div class="serverError"><h1 class="ibm-textcolor-red-40 ibm-h3"><b>Server Error</b></h1>There was a problem saving your confirmation:<p></p><b>{{vm.events.serverError}}</b><p></p>Please contact the System Administrators if the problem persists</div></div><br/></div></div><div ng-if="vm.events.loaded"><div class="ibm-columns"><div class="ibm-col-1-1"><span>Please read the latest Terms of Use and click Confirm to continue.</span><p></p></div></div><div class="ibm-columns"><div class="ibm-col-1-1" style="border: solid lightgray 1px;padding: 10px;"><span ng-bind-html="vm.currentTerms.tou"></span><p></p></div></div><div class="ibm-columns"><div class="ibm-col-6-2"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-if="!vm.events.confirming" ng-click="vm.confirm($event)" title="Confirm to continue"><md-icon class="white_icon" style="margin-left: -5px" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Confirm</md-button><span ng-if="vm.events.confirming"><span class="ibm-textcolor-blue-40 ibm-h4">Saving, please wait...</span><span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></span></div><div class="ibm-col-6-4" style="text-align: right; border: solid lightgray 1px;padding: 5px; background-color: #ffffd5"><span>Version&nbsp;</span><span class="ibm-textcolor-blue-50">{{vm.currentTerms.version}}</span><span>&nbsp;&nbsp;Created by&nbsp;</span><span class="ibm-textcolor-blue-50">{{vm.currentTerms.created_by}}</span><span>&nbsp;on&nbsp;</span><span class="ibm-textcolor-blue-50">{{vm.currentTerms.created_date | date: \'medium\'}}</span><br/><span>Effective Date&nbsp;</span><span class="ibm-textcolor-blue-50">{{vm.currentTerms.effective_date | date: \'medium\'}}</span></div></div><p></p></div></div></div></div></div></main>');
$templateCache.put('site-body.html','<style>.content {\n    min-height: calc(100vh - 116px);\n}\n</style><md-content flex="100"><div class="ibm-landing-page" id="ibm-top"><masthead id="ibm-masthead" role="banner" aria-label="IBM"></masthead><site-mobile class="ibm-mobilemenu" role="dialog" aria-labeledby="ibm-menu"></site-mobile><div class="content" id="ibm-content-wrapper" ng-if="vm.env.user.loggedIn"><header role="banner" aria-labelledby="ibm-pagetitle-h1"></header><md-icon class="blue_icon" ng-if="!vm.settings.connected" title="Disconnected from the server.  Waiting for reconnection" style="padding: 5px" md-svg-icon="/public/images/lan-disconnect.svg"></md-icon><span class="ibm-textcolor-blue-40" ng-if="!vm.settings.connected">You are currently disconnected from the server. &nbsp;Automatic reconnection should take place shortly, unless the server is down. &nbsp;Please wait...</span><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="vm.env.user !== undefined &amp;&amp; vm.settings.connected &amp;&amp; !(vm.settings.loaded || \'400,403,404,500,login\'.indexOf(vm.$state.current.name) &gt; -1)"><span>&nbsp;&nbsp;Loading settings...&nbsp;</span><span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><div ng-if="(vm.env.user !== undefined &amp;&amp; vm.settings.loaded) || \'400,403,404,500,login\'.indexOf(vm.$state.current.name) &gt; -1"><ui-view></ui-view></div></div><div id="ibm-content-wrapper" ng-if="!vm.env.user.loggedIn"><header role="banner" aria-labelledby="ibm-pagetitle-h1"></header><md-icon class="blue_icon" ng-if="!vm.settings.connected" title="Disconnected from the server.  Waiting for reconnection" style="padding: 5px" md-svg-icon="/public/images/lan-disconnect.svg"></md-icon><span class="ibm-textcolor-blue-40" ng-if="!vm.settings.connected">You are currently disconnected from the server. &nbsp;Automatic reconnection should take place shortly, unless the server is down. &nbsp;Please wait...</span><!--ui-view--><home-section></home-section></div><site-footer></site-footer><div id="ibm-overlay-backdrop"></div></div></md-content>');
$templateCache.put('site-footer.html','<div id="ibm-related-content"><div id="ibm-merchandising-module"><div id="ibm-footer-module"><footer role="contentinfo" aria-label="IBM" ibmStickyFooter="ibmStickyFooter"><div class="ibm-alternate" id="ibm-footer"><h2 class="ibm-access">Footer links</h2><ul><li><a href="http://www.ibm.com/contact/us/en/">Contact</a></li><li><a href="http://www.ibm.com/privacy/us/en/">Privacy</a></li><li><a href="http://www.ibm.com/legal/us/en/">Terms of use</a></li><li><a href="http://www.ibm.com/accessibility/us/en/">Accessibility</a></li></ul></div></footer><!-- FOOTER_END--></div></div></div>');
$templateCache.put('site-header.html','<div class="ibm-sitenav-menu-container" ibm-sticky-header="ibm-sticky-header"><div class="ibm-sitenav-menu-name"><a href="">Disbursement Management</a></div><div class="ibm-sitenav-menu-list" ng-if="vm.env.user.allowed"><ul role="menubar"><li class="ibm-haschildlist ibm-sitenav-menu-item-right" ng-class="{\'ibm-highlight\':vm.$state.current.name===\'help\'}" role="presentation"><button role="menuitem">Help Topics</button><ul role="menu"><li role="presentation"><a role="menuitem" ui-sref="user-profile">User Profile</a></li><li role="presentation"><a role="menuitem" ui-sref="help">Support</a></li><li role="presentation"><a role="menuitem" ui-sref="terms">Terms</a></li><li role="presentation"><a role="menuitem">Storage</a></li><li role="presentation"><a role="menuitem">Additional products</a></li><li role="presentation"><dialog-test></dialog-test></li></ul></li><li class="ibm-sitenav-menu-item-right" role="presentation" ui-sref-active="ibm-highlight"><a role="menuitem" ui-sref="reporting">Reporting</a></li><li class="ibm-sitenav-menu-item-right ibm-haschildlist" ng-class="{\'ibm-highlight\':vm.$state.current.name===\'queue\'}" role="presentation"><button role="menuitem">Queue</button><ul role="menu"><li ng-if="vm.env.user.access.bpsoAdmin || vm.env.user.access.nonBpsoAdmin" role="presentation"><a ng-click="vm.getQueue(\'myqueue\')" href="" role="menuitem">My Queue</a></li><li role="presentation"><a ng-click="vm.getQueue(\'teamqueue\')" href="" role="menuitem">Teams\' Queue</a></li><li role="presentation"><a ng-click="vm.getQueue(\'unassigned\')" href="" role="menuitem">Unassigned</a></li><li role="presentation"><a ng-click="vm.getQueue(\'manualReview\')" href="" role="menuitem">Manual Review</a></li><li role="presentation"><a ng-click="vm.getQueue(\'workitems\')" href="" role="menuitem">Work Items</a></li><li role="presentation"><a ng-click="vm.getQueue(\'errorqueue\')" href="" role="menuitem">Validation Queue</a></li><li role="presentation"><a ng-click="vm.getSamplingQueue()" href="" role="menuitem">Sampling</a></li><li role="presentation"><a ng-click="vm.sapMissingQueue()" href="" role="menuitem">SAP Not Found</a></li><li role="presentation"><a ng-click="vm.getQueue(\'setAside\')" href="" role="menuitem">Set Aside Queue</a></li><li role="presentation"><a ng-click="vm.getQueue(\'geospm\')" href="" role="menuitem">GEO SPM Queue</a></li></ul></li><li class="ibm-sitenav-menu-item-right" ng-if="vm.env.user.allowed &amp;&amp; vm.env.user.access.systemAdmin" role="presentation" ui-sref-active="ibm-highlight"><a role="menuitem" ui-sref="admin.main">Admin</a></li><li class="ibm-sitenav-menu-item-right" ng-if="vm.env.user.allowed &amp;&amp; vm.env.user.approver" role="presentation" ui-sref-active="ibm-highlight"><a role="menuitem" ui-sref="approvals">Awaiting Approval</a></li><li class="ibm-sitenav-menu-item-right" role="presentation" ui-sref-active="ibm-highlight"><a role="menuitem" ui-sref="admin.mysa-dmt-view">MySA Opp Logs            </a></li></ul></div></div>');
$templateCache.put('site-masthead.html','<div id="ibm-mast-options"><ul role="toolbar" aria-labelledby="ibm-masthead"><li id="ibm-geo" role="presentation"><a href="http://www.ibm.com/planetwide/select/selector.html">United States</a></li></ul></div><div id="ibm-universal-nav"><div id="ibm-home"><a href="http://www.ibm.com/us-en/">IBM\xAE</a></div><div class="ibm-masthead-rightside" ng-class="{\'signedin hasinitials\' : vm.env.user.loggedIn }"><ul class="ibm-masthead-iconsonly" aria-label="Tools" role="menubar"><li class="ibm-masthead-item-signin" role="presentation" ibm-user-hover=""><button class="ibm-profile-link" role="menuitem" ng-class="{\'authuser\' : vm.env.user.loggedIn}"></button><!--button.ibm-masthead-signin-link(role=\'menuitem\',\nng-class="{\'authuser\' : vm.env.user.loggedIn}"\n)--><ul class="ibm-dropdown-menu" role="menu" aria-label="Profile" id="ibm-signin-minimenu-container"><li role="presentation" ng-if="! vm.env.user.loggedIn"><a role="menuitem" href="" ng-click="vm.logIn()">Login</a></li><li role="presentation" ng-if="vm.env.user.loggedIn"><a role="menuitem" href="" ng-click="vm.logOut()">Logout</a></li><li role="presentation"><a role="menuitem">Notifications<div layout="row"><md-radio-group ng-model="vm.env.notifications"><md-radio-button value="off">Off</md-radio-button><md-radio-button value="on">On</md-radio-button></md-radio-group></div></a></li></ul></li><li class="ibm-masthead-item-menu" role="presentation"><!--button.ibm-masthead-menu-link(role=\'menuitem\', aria-label=\'Site navigation\', ng-click="vm.openMobileMenu()")--><button class="ibm-menu-link" role="menuitem" aria-label="Site navigation" ng-click="vm.openMobileMenu()"></button></li></ul></div></div>');
$templateCache.put('site-mobile.html','<p class="ibm-hide" id="ibm-burgermenu-a11y">Site navigation</p><div class="ibm-mobilemenu-close"><p class="ibm-icononly ibm-fright"><a class="ibm-close-link" ng-click="vm.closeMobileMenu()">Close</a></p></div><div class="ibm-mobilemenu-section ibm-mobilemenu-pagenav"><ul role="tablist"><li role="presentation"><a href="//w3-01.sso.ibm.com/sales/partners/pwtools/pps/profilelinks" role="tab" target="_blank" tabindex="-1">Partner World (PPS)</a></li><li role="presentation"><a href="//w3-150.ibm.com/sales/salesconnect/#bwc/index.php?module=Home&amp;action=index" role="tab" target="_blank" tabindex="-1">Sales Connect</a></li><li role="presentation"><a href="//w3-01.sso.ibm.com/software/xl/fastpass/fastpass.nsf/salesorders?Openform" role="tab" target="_blank" tabindex="-1">Fast Pass</a></li><li role="presentation"><a href="//www-07.ibm.com/partnerworld/incentives/management/index.wss" role="tab" target="_blank" tabindex="-1">BP Incentive Management System (BPIMS)</a></li><li role="presentation"><a href="//w3-03.ibm.com/transform/bacc/cognos/bi01n/ServletGateway/servlet/Gateway?gohome=&amp;encoding=UTF-8&amp;b_action=xts.run&amp;m=portal%2fcc.xts" role="tab" target="_blank" tabindex="-1">BP Incentive Management System (BPIMS) Report</a></li><li role="presentation"><a href="//w3-03.ibm.com/finance/access/accessRequest.wss?catgorieslist=Finance%20-%20Accounting/Planning" role="tab" target="_blank" tabindex="-1">One Team</a></li><li role="presentation"><a href="//www-356.ibm.com/partnerworld/wps/servlet/ContentHandler/swg_com_sfw_svi_resources_guides_agreements" role="tab" target="_blank" tabindex="-1">CVR Program Guide</a></li><li role="presentation"><a href="//sc4.ihost.com/gpp/permanent/svi_eligible_part_numbers.pdf" role="tab" target="_blank" tabindex="-1">CVR Eligible part number list</a></li><li role="presentation"><a href="//w3-01.sso.ibm.com/procurement/pessmu/enUS/index.html " role="tab" target="_blank" tabindex="-1">IBM Supplier Management Utility (SMU)</a></li></ul></div>');
$templateCache.put('about.html','<style>.versions {\n    margin-left: 240px;\n}\n.versions h2 {\n    font-weight: bold;\n    margin-left: 10px;\n}\nhr {\n    margin-left: 10px;\n}\nul.ibm-link-list {\n    margin-top: 20px;\n}\n.version-info {\n    margin-bottom: 40px;\n} \n</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Acceptable Terms of Use</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="!vm.profileLoaded &amp;&amp; !vm.serverError">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span ng-if="vm.profileLoaded"></span></div></div><div class="ibm-columns"></div></div><div ng-if="vm.serverError"><div class="ibm-columns"><div class="ibm-col-1-1"><span class="ibm-textcolor-red-50" ng-bind-html="vm.serverError"></span><p></p></div></div></div><div ng-if="vm.profileLoaded"></div><div class="ibm-columns version-info"><div class="ibm-col-6-4" ng-show="!vm.isCreateShow"><div class="ibm-columns"><div class="ibm-col-6-1"><label class="ibm-textcolor-blue-50">Created date:&nbsp;</label></div><div class="ibm-col-6-2 field"><span>{{vm.correctTerms.created_date | date: "longDate"}}</span></div></div><div class="ibm-columns"><div class="ibm-col-6-1"><label class="ibm-textcolor-blue-50">Effective date:&nbsp;</label></div><div class="ibm-col-6-2 field"><span>{{vm.correctTerms.effective_date | date: "longDate"}}</span></div></div><div class="ibm-columns"><div class="ibm-col-6-1"><label class="ibm-textcolor-blue-50">Created by:&nbsp;</label></div><div class="ibm-col-6-2 field"><b>{{vm.correctTerms.created_by}}</b></div></div><p></p><p></p><p>       </p><span class="ibm-bold">General</span><p>{{vm.correctTerms.tou}}</p></div></div></div></div></div></div></main>');
$templateCache.put('approved-list.html','<style>.approved-table {\n    min-width: 1100px;\n}\n.approved-table tbody tr td:last-child,\n.approved-table thead tr td:last-child {\n    min-width: 130px;\n}\n.actions-container {\n    box-sizing: border-box;\n    display: inline-flex;\n    flex: 0 0 auto;\n    align-items: center;\n    justify-content: flex-end;\n    z-index: 1;\n    right: 0;\n    position: absolute;\n    top: 0;\n}\n.actions-container > div {\n    padding: 10px 5px;\n}\n.actions-container > div:first-child {\n    align-items: stretch;\n    display: flex;\n    flex: 1 1 auto;\n    height: 35px;     \n}\n.actions-container .actions {\n    border: solid 1px #5596e6;\n    padding: 7px 0px 7px 7px;\n    color: #5596e6;\n    display: flex;\n    align-items: center;\n}\n.export-btn-container button {\n    margin: 0;\n}\na.link {\n    text-decoration: none;\n}\n.alpha_dead {\n    color: lightgray;\n}\n.alpha_selly {\n    color: white;\n    background-color: #5596e6;\n    border-radius: 25%;\n}\n.form-list {\n    padding-top: 15px;\n    min-height: 65px;\n}\n.delete-button md-icon svg {\n    fill: #e71d32;\n}\n.edit-button md-icon svg {\n    fill: #325c80;\n}\n.fill {\n    display: flex;\n    width: 100%;\n    height: 100%;\n}\n#ibm-content-body {\n    box-sizing: border-box;\n}\n.admin-tabs, .admin-tabs md-tabs-content-wrapper, .admin-tabs md-tab-content, .admin-tabs md-tab-content > div {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n.flex {\n    display: flex;\n}\n.history-container {\n    display: flex;\n    flex: 1;\n    width: 100%;\n    overflow: auto;\n    padding-top: 15px;\n}\n.history-table td:nth-child(2), .history-table th:nth-child(2){\n    flex-grow: 4;\n}\n.history-table td:nth-child(3), .history-table th:nth-child(3){\n    flex-grow: 3;\n}\n</style><main class="fill" role="main" aria-labelledby="ibm-pagetitle-h1"><div class="fill" id="ibm-pcon" ibm-back-to-top=""><div class="fill" id="ibm-content"><div class="fill" id="ibm-content-body"><div class="fill" id="ibm-content-main"><div class="fill" id="content" layout="column"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>New Client approved list</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!vm.clientsLoaded ">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="vm.importingExcel ">Importing from Excel list...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span ng-if="vm.settings.status_cfg"></span></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div><div class="ibm-columns" ng-if="vm.signalWrongResponse"><div class="ibm-col-2-2" style="float: right; color: red;"><span ng-bind-html="vm.signalWrongResponse">               </span></div></div><div class="ibm-columns flex"><md-tabs class="admin-tabs" md-dynamic-height="md-dynamic-height"><md-tab label="New Client"><form class="form-list fill" name="" layout="column"><div class="actions-container" ng-if="vm.clientsLoaded" flex="auto"><div><span class="actions"><span>Admin Actions</span><md-menu ng-disabled="vm.events.beingSaved" md-position-mode="target-right target" md-offset="280 40" style="margin-left:-10px"><md-button class="md-icon-button" ng-click="vm.openActionMenu($mdOpenMenu,$event)" title="Actions"><md-icon class="blue_icon" md-svg-icon="/public/images/star-circle.svg"></md-icon></md-button><md-menu-content width="4"><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.createRecord($event)"><md-icon class="blue_icon" md-svg-icon="/public/images/rocket.svg"></md-icon>Add new record</md-button></md-menu-item><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.uploadNewClientsList($event)"><md-icon class="green_icon" md-svg-icon="/public/images/ic_add_circle_outline_black_24px.svg"></md-icon>Upload new list</md-button></md-menu-item><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.deleteAllClients($event)"><md-icon class="red_icon" md-svg-icon="/public/images/close-circle-outline.svg"></md-icon>Delete all existing records</md-button></md-menu-item><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.downloadClientsListTemplate($event)"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_file_download_black_24px.svg"></md-icon>Download latest New Client list template</md-button></md-menu-item></md-menu-content></md-menu></span></div><div class="export-btn-container"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" ng-click="vm.exportNewClientPermissions()" ng-disabled="vm.exportFired" title="Export all new Clients\' to an Excel spreadsheet"><md-icon class="white_icon" ng-if="!vm.exportFired" md-svg-icon="download"></md-icon><md-icon class="ibm-spinner" ng-if="vm.exportFired" style="border: 2px solid white; min-height: 12px; min-width: 12px;"></md-icon><span style="text-transform: none; font-size: 15px; padding-left: 5px; padding-right: 2px;">{{vm.exportFired ? \'Please wait...\' : \'Export\'}}   </span></md-button></div><br></div><div class="fill" layout="column"><table class="approved-table ibm-data-table ibm-altrows ibm-alternate-two" id="table" datatable="" dt-options="vm.table.dtOptions" dt-instance="vm.table.dtInstance" dt-columns="vm.table.dtColumns" dt-disable-deep-watchers="true"></table></div></form></md-tab><md-tab label="History"><div class="history-container"><table class="ibm-data-table history-table" datatable="ng" dt-options="vm.historyTable.options" dt-instance="vm.historyTable.instance" dt-column-defs="vm.historyTable.columnDefs">                                   <thead><tr><th>Time</th><th>Changes made</th><th>Changed by</th></tr></thead><tbody><tr ng-repeat="entry in vm.docTable track by $index"><td>{{ entry.timestamp }}</td><td>{{ entry.comment[0] }}</td><td>{{ entry.user }}</td></tr></tbody></table></div></md-tab></md-tabs></div></div></div></div></div></div></main>');
$templateCache.put('bpoi-switches.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>BPOI Switches</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="!vm.bpoiLoaded">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div><!--div(ng-if=\'(vm.countriesLoaded!= true || vm.sourceLoaded != true)\' id=\'generalInfo\' class="ibm-columns")md-progress-linear(md-mode="indeterminate")\n    p Please wait, loading--><br/><div class="ibm-columns" ng-if="(vm.bpoiLoaded)" align="right"><md-button class="md-raised md-primary" ng-click="vm.saveSourceChanges($event)" ng-disabled="(!vm.changeInitiated)" style="padding: 2px; margin: 10px; margin-bottom: 10px;">Save</md-button><md-button class="md-accent md-raised md-hue-2" ng-click="vm.resetSourceChanges($event)" ng-disabled="(!vm.changeInitiated)" style="padding: 2px; margin: 10px; margin-bottom: 10px;">Reset</md-button></div><div class="ibm-columns" ng-if="(vm.bpoiLoaded)" align="center"><md-tabs md-dynamic-height="md-dynamic-height"><md-tab ng-repeat="oneLine in vm.iotCountries" label="{{oneLine.key}}"><table><thead><tr align="center"><td>Country</td><td>Start Date</td><td>End Date</td><td>GE Yes</td><td>GE No</td><td>Designation</td></tr></thead><tbody><tr ng-repeat="country in oneLine.values"><td>{{country.country}}</td><td><md-datepicker ng-change="vm.checkBpoiTable(&quot;{{oneLine.key}}&quot;, &quot;{{country.country}}&quot;, &quot;start date&quot;)" ng-model="country.startDateFormated" ng-model-options="{ timezone: \'UTC\' }"></md-datepicker></td><td><md-datepicker ng-change="vm.checkBpoiTable(&quot;{{oneLine.key}}&quot;, &quot;{{country.country}}&quot;, &quot;end date&quot;)" ng-model="country.endDateFormated" ng-model-options="{ timezone: \'UTC\' }"></md-datepicker><md-icon class="red_icon" ng-if="country.endDateFormated &lt; country.startDateFormated" md-svg-icon="invalid"></md-icon></td><td><md-switch class="md-primary" ng-change="vm.checkBpoiTable(&quot;{{oneLine.key}}&quot;, &quot;{{country.country}}&quot;, &quot;GE Yes&quot;)" ng-model="country.geYes" aria-label="geYes">{{country.geYes ? \'On\' : \'Off\'}}</md-switch></td><td><md-switch class="md-primary" ng-change="vm.checkBpoiTable(&quot;{{oneLine.key}}&quot;, &quot;{{country.country}}&quot;, &quot;GE No&quot;)" ng-model="country.geNo" aria-label="geNo">{{country.geNo ? \'On\' : \'Off\'}}</md-switch></td><td><md-switch class="md-primary" ng-change="vm.checkBpoiTable(&quot;{{oneLine.key}}&quot;, &quot;{{country.country}}&quot;, &quot;Designation&quot;)" ng-model="country.designation" aria-label="designation">{{country.designation ? \'On\' : \'Off\'}}</md-switch></td></tr></tbody></table></md-tab></md-tabs></div><br/><br/><div class="ibm-columns" ng-if="(vm.bpoiLoaded)" align="center"><table class="ibm-data-table ibm-grid ibm-altrows" ibm-altcols="ibm-altcols"><col width="10"/><col width="10"/><col width="10"/><thead><tr align="center"><td>Changed at</td><td>Comment</td><td>Changed by</td></tr></thead><tbody><tr ng-repeat="oneComment in vm.comments track by $index"><td>{{oneComment.timestamp | date : YYYY-MM-DD}}</td><td>{{oneComment.comment}}</td><td>{{oneComment.editedBy}}</td></tr></tbody></table></div></div></div></div></div></div></div></main>');
$templateCache.put('calculation-table-view.html','<!-- 20171201-1030-Domenico De Felice - Editability of Bonus--><!-- 20171017-0784-Kim Janneck--><!--div(ng-if="vm.table===2")select(ng-options="item as item.country for item in vm.countries" ng-model="vm.selectedCountry" style="width:auto" ng-change="vm.countryChanged()")--><table class="ibm-data-table ibm-grid ibm-altrows" ibm-altcols="ibm-altcols"><thead><tr><td ng-repeat="header in vm.headers"><p ng-if="vm.table===0" style="writing-mode: vertical-rl; height: min-content;">{{header}}</p><b ng-if="vm.table!==0">{{header}}</b></td></tr></thead><tbody><tr ng-repeat="row in vm.data track by $index"><td ng-repeat="col in vm.columns"> <span>{{row[col]}}</span></td><td ng-if="vm.table===6"><md-button class="md-raised md-primary" ng-click="vm.parent.withdrawRate($index)" ng-if="vm.data===vm.parent.data" ng-disabled="vm.parent.isSaving">Withdraw</md-button><span ng-if="vm.data===vm.parent.historyData">{{row[\'INACTIVE_FROM\']}}</span></td><td ng-if="vm.table===5"><md-button class="md-raised md-primary" ng-click="vm.parent.withdrawChannel($index)" ng-if="vm.data===vm.parent.data" ng-disabled="vm.parent.isSaving">Withdraw</md-button><!--span(ng-if="vm.data===vm.parent.historyData") {{row[\'ENDDATE\']}}--><!--span(ng-if="vm.data===vm.parent.historyData") {{row[\'LAST_UPDATE\']}}--></td><td ng-if="vm.table===0"><md-button class="md-raised md-primary" ng-click="vm.parent.editBonus($index)" ng-if="vm.data===vm.parent.data" ng-disabled="vm.parent.isSaving">Edit</md-button></td><td ng-if="vm.table===1"><md-button class="md-raised md-primary" ng-click="vm.parent.editBonus($index)" ng-if="vm.data===vm.parent.data" ng-disabled="vm.parent.isSaving">Edit</md-button></td></tr></tbody></table>');
$templateCache.put('calculation-view.html','<!--Created by user on 2/3/2017.--><!-- 2017-10-17: Modified by Kim Janneck (Card 784)--><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Calculation Tables Administration</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="!vm.dataLoaded">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div><!--br--><!--br--><!--md-progress-linear(md-mode="indeterminate" ng-if="!vm.isDivisionLoaded || !vm.isCountryLoaded" id=\'generalInfo\' class="ibm-columns")p Please wait, loading--><!--br--><!--TODO - table 0 - is quite big - may \'width\' be setup better ?--><div class="ibm-columns" ng-if="vm.dataLoaded" id="generalInfo" style="min-width:1590px"><md-tabs md-selected="vm.selectedTable" md-dynamic-height="md-dynamic-height" md-border-bottom="md-border-bottom"><md-tab ng-repeat="oneTab in vm.tables track by $index" label="{{oneTab}}" ng-style="{color: \'green\'}" ng-click="vm.switchTable()"><!--Card 784 Insert top: Adding logic for SO Uplifted Channels (table === 5)--><!--Add button and fields for Channel, Start date and End date--><div flex="flex" layout-padding="layout-padding" ng-if="vm.selectedTable===5"><md-button class="md-raised md-primary" ng-click="vm.addChannel()" ng-disabled="vm.isSaving">Add...</md-button></div><div flex="flex" layout-padding="layout-padding" ng-if="vm.selectedTable===5"><md-input-container class="md-input-has-value" flex="flex"><label><span>Channel:</span></label><span><input name="newChannel" ng-model="vm.newChannel.channelLetter" placeholder="Channel - 1 capital letter" required="required" type="text"/></span></md-input-container><md-input-container class="md-input-has-value" flex="flex"><label><span>Start Date:</span></label><span><md-datepicker name="startDate" ng-model="vm.newChannel.startDate" required="required"></md-datepicker></span></md-input-container><md-input-container class="md-input-has-value" flex="flex"><label><span>End Date:</span></label><span><md-datepicker name="endDate" ng-model="vm.newChannel.endDate" required="required"></md-datepicker></span></md-input-container></div><!--Card 784 Insert bottom--><div flex="flex" layout-padding="layout-padding" ng-if="vm.selectedTable===6"><table class="ibm-data-table ibm-grid ibm-altrows" ibm-altcols="ibm-altcols"><tr><th>Select date:</th><th>Select currency:</th></tr><tr><td><span flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><md-datepicker ng-model="vm.validDate"></md-datepicker></md-input-container></span></td><td><span flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><select ng-model="vm.currency" required="required" ng-options="crncy for crncy in vm.currencies" style="width:80px;"></select></md-input-container></span></td><td><md-button class="md-raised md-primary" ng-click="vm.switchTable()">Load</md-button></td></tr></table></div><br/><div flex="flex" layout-padding="layout-padding" ng-if="vm.selectedTable===6"><md-button class="md-raised md-primary" ng-click="vm.addRate()" ng-disabled="vm.isSaving">Add...</md-button></div><div flex="flex" layout-padding="layout-padding" ng-if="vm.selectedTable===6"><md-input-container class="md-input-has-value" flex="flex"><label><span>Currency Code:</span></label><span><input name="currency" ng-model="vm.newRate.currency" placeholder="USD" required="required" type="text"/></span></md-input-container><md-input-container class="md-input-has-value" flex="flex"><label><span>From USD to Local:</span></label><span><input name="fromUsd" ng-model="vm.newRate.fromUsd" placeholder="1" required="required" type="text"/></span></md-input-container><md-input-container class="md-input-has-value" flex="flex"><label><span>From Local To USD:</span></label><span><input name="toUsd" ng-model="vm.newRate.toUsd" placeholder="1" required="required" type="text"/></span></md-input-container><md-input-container class="md-input-has-value" flex="flex"><label><span>Start Date:</span></label><span><md-datepicker name="startDate" ng-model="vm.newRate.startDate" required="required"></md-datepicker></span></md-input-container><md-input-container class="md-input-has-value" flex="flex"><label><span>End Date:</span></label><span><md-datepicker name="endDate" ng-model="vm.newRate.endDate" required="required"></md-datepicker></span></md-input-container></div><br/><div flex="flex" layout-padding="layout-padding"><calculation-table-section table="vm.selectedTable" data="vm.data" parent="vm"></calculation-table-section></div><br/><a class="h2 ibm-h2 ibm-medium ibm-light ibm-padding-bottom-1" flex="50" ng-click="vm.showHistory = !vm.showHistory">Click to {{!vm.history ? \'View\' : \'Hide\'}} History</a><div flex="flex" layout-padding="layout-padding" ng-if="vm.showHistory===true"> <calculation-table-section table="vm.selectedTable" data="vm.historyData" parent="vm"></calculation-table-section></div></md-tab></md-tabs></div></div></div></div></div></div></div></main>');
$templateCache.put('complianceplan-add.html','<style>.md-datepicker-calendar-pane{z-index: 1200}\n.md-dialog-is-showing md-dialog{width: 40%}\n.select2-selection--single {width: 200px }\n.select2, .select2-container, .select2-container--default, .select2-container--below, .select2-container--focus {width: 200px ! important}\n\n</style><md-dialog ng-cloak="" aria-label="Add Compliance Plan record"><md-toolbar><div class="md-toolbar-tools"><h2>Add BP to Compliance Plan</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon aria-label="Close dialog" md-svg-src="/public/images/ic_close_white_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="vm.disForm"><md-content class="md-padding"><span class="ibm-textcolor-blue-50">GEO&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="iot" ng-model="vm.newItem.iot" ng-options="iot for iot in vm.iots" ng-required="true"><option value="">--Please select-- </option></select></div><p></p><span class="ibm-textcolor-blue-50">Market&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="imt" ng-model="vm.newItem.imt" ng-options="imt for imt in vm.imts[vm.newItem.iot]" ng-required="true"><option value="">--Please select--                    </option></select></div><p></p><span class="ibm-textcolor-blue-50">Country&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="country" ng-model="vm.newItem.country" ng-options="country as country for country in vm.listCountries(vm.tree, vm.newItem.iot, vm.newItem.imt)" ng-required="true"><option value="">--Please select--</option></select></div><p></p><span class="ibm-textcolor-blue-50">BP Name&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input ng-change="vm.modified = true;" ng-model="vm.newItem.bpName" ng-required="true" type="text"/></div><p></p><span class="ibm-textcolor-blue-50">BP CEID&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input ng-change="vm.modified = true;" ng-model="vm.newItem.bpCeid" ng-required="true" type="text"/></div><p></p><span class="ibm-textcolor-blue-50">Review start date&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><div style="z-index:99999"><md-datepicker ng-model="vm.newItem.startDate" ng-required="true"></md-datepicker></div></div><p></p></md-content></ng-form><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="!vm.disForm.$valid || vm.newItem.country===\'-Please select-\' || vm.newItem.imt===\'-Please select-\' ">Submit</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Close</md-button><p></p></md-dialog-content></md-dialog>');
$templateCache.put('complianceplan-edit.html','<style>.md-datepicker-calendar-pane{z-index: 1200}\n.md-dialog-is-showing md-dialog{width: 40%}\n.select2-selection--single {width: 200px }\n.select2, .select2-container, .select2-container--default, .select2-container--below, .select2-container--focus {width: 200px ! important}\n</style><md-dialog ng-cloak="" aria-label="Edit Compliance Plan record"><md-toolbar><div class="md-toolbar-tools"><h2>Edit Compliance plan</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon aria-label="Close dialog" md-svg-src="/public/images/ic_close_white_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="vm.disForm"><md-content class="md-padding"><span class="ibm-textcolor-blue-50">GEO&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="iot" ng-model="vm.content.iot" ng-options="iot for iot in vm.iots" ng-required="true"></select></div><p></p><span class="ibm-textcolor-blue-50">Market&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="imt" ng-model="vm.content.imt" ng-options="imt for imt in vm.imts[vm.content.iot]" ng-required="true"><option value="">--Please select--                    </option></select></div><p></p><span class="ibm-textcolor-blue-50">Country&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="country" ng-model="vm.content.country" ng-options="country as country for country in vm.listCountries(vm.tree,vm.content.iot,vm.content.imt)" ng-required="true"><option value="">--Please select--</option></select></div><p></p><span class="ibm-textcolor-blue-50">BP name&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"> <span class="ibm-textcolor-blue-40">{{vm.content.bpName}}</span></div><p></p><span class="ibm-textcolor-blue-50">BP CEID&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><span class="ibm-textcolor-blue-40">{{vm.content.bpCeid}}</span></div><p></p><span class="ibm-textcolor-blue-50">Review start date&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><div style="z-index:99999"><md-datepicker ng-model="vm.content.startDate" ng-required="true"></md-datepicker></div></div><p></p></md-content></ng-form><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="!vm.disForm.$valid || vm.newItem.country===\'-Please select-\' || vm.newItem.imt===\'-Please select-\' || vm.content.country===\'-Please select-\' || vm.content.startDate===\'\' || vm.content.country===\'-Please select-\'">Submit</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-dialog-content></md-dialog>');
$templateCache.put('complianceplan-update-add.html','<form name="paymentForm"><md-dialog aria-label="Confirm Prompt" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>{{::vm.title}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><div id="icon" style="float:left; border:solid 1px white; padding: 6px; display: flex"><md-icon class="red_icon" ng-if="vm.icon==\'ERROR\'" style="height:50px; width:50px" md-svg-src="/public/images/close-circle.svg" aria-label="Prompt icon"></md-icon><md-icon class="blue_icon" ng-if="vm.icon==\'INFO\'" style="height:50px; width:50px" md-svg-src="/public/images/ic_info_outline_black_24px.svg" aria-label="Prompt icon"></md-icon><md-icon class="orange_icon" ng-if="vm.icon==\'WARN\'" style="height:50px; width:50px" md-svg-src="/public/images/ic_warning_black_24px.svg" aria-label="Prompt icon"></md-icon><md-icon class="blue_icon" ng-if="vm.icon==\'QUESTION\'" style="height:50px; width:50px" md-svg-src="/public/images/help-circle.svg" aria-label="Prompt icon"></md-icon></div><div id="message" style="border:solid 1px white; padding: 6px; display: flex"><span ng-bind-html="vm.message"></span></div><div id="justify" ng-if="vm.prompt"><md-input-container><label>Justification</label><input required="required" aria-label="justification" ng-model="vm.justification" minlength="15"/><ng-messages for="paymentForm.justify.$error"><ng-message when="minlength">Please enter at least 15 characters.</ng-message></ng-messages></md-input-container></div><div style="text-align:center; border:solid 1px white;"><md-button class="md-raised md-primary" ng-if="vm.icon==\'QUESTION\'" ngf-select="vm.clickUploadAdd($event,$files)" ngf-max-size="5MB" accept=".xls,.xlsx">Add</md-button><md-button class="md-raised md-primary" ng-if="vm.icon==\'QUESTION\'" ng-click="vm.clickNo()" style="margin-left:5px">Replace</md-button></div></md-content></md-dialog-content></md-dialog></form>');
$templateCache.put('complianceplan.html','<style>.complianceplan-table {\n    min-width: 1100px;\n}\n.complianceplan-table tbody tr td:last-child,\n.complianceplan-table thead tr td:last-child {\n    min-width: 130px;\n}\n.actions-container {\n    box-sizing: border-box;\n    display: inline-flex;\n    flex: 0 0 auto;\n    align-items: center;\n    justify-content: flex-end;\n    z-index: 1;\n    right: 0;\n    position: absolute;\n    top: 0;\n}\n.actions-container > div {\n    padding: 10px 5px;\n}\n.actions-container > div:first-child {\n    align-items: stretch;\n    display: flex;\n    flex: 1 1 auto;\n    height: 35px;     \n}\n.actions-container .actions {\n    border: solid 1px #5596e6;\n    padding: 7px 0px 7px 7px;\n    color: #5596e6;\n    display: flex;\n    align-items: center;\n}\n.export-btn-container button {\n    margin: 0;\n}\na.link {\n    text-decoration: none;\n}\n.alpha_dead {\n    color: lightgray;\n}\n.alpha_selly {\n    color: white;\n    background-color: #5596e6;\n    border-radius: 25%;\n}\n.form-list {\n    padding-top: 15px;\n    min-height: 65px;\n}\n.delete-button md-icon svg {\n    fill: #e71d32;\n}\n.edit-button md-icon svg {\n    fill: #325c80;\n}\n.fill {\n    display: flex;\n    width: 100%;\n    height: 100%;\n}\n#ibm-content-body {\n    box-sizing: border-box;\n}\n.admin-tabs, .admin-tabs md-tabs-content-wrapper, .admin-tabs md-tab-content, .admin-tabs md-tab-content > div {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n.flex {\n    display: flex;\n}\n.history-container {\n    display: flex;\n    flex: 1;\n    width: 100%;\n    overflow: auto;\n    padding-top: 15px;\n}\n.history-table td:nth-child(2), .history-table th:nth-child(2){\n    flex-grow: 4;\n}\n.history-table td:nth-child(3), .history-table th:nth-child(3){\n    flex-grow: 3;\n}\n</style><main class="fill" role="main" aria-labelledby="ibm-pagetitle-h1"><div class="fill" id="ibm-pcon" ibm-back-to-top=""><div class="fill" id="ibm-content"><div class="fill" id="ibm-content-body"><div class="fill" id="ibm-content-main"><div class="fill" id="content" layout="column"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Compliance plan</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!vm.itemsLoaded ">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="vm.importingExcel ">Importing from Excel list...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span ng-if="vm.settings.status_cfg"></span></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div><div class="ibm-columns" ng-if="vm.signalWrongResponse"><div class="ibm-col-2-2" style="float: right; color: red;"><span ng-bind-html="vm.signalWrongResponse">               </span></div></div><div class="ibm-columns flex"><md-tabs class="admin-tabs" md-dynamic-height="md-dynamic-height"><md-tab label="BP list"><form class="form-list fill" name="" layout="column"><div class="actions-container" ng-if="vm.itemsLoaded" flex="auto"><div><span class="actions"><span>Admin Actions</span><md-menu ng-disabled="vm.events.beingSaved" md-position-mode="target-right target" md-offset="280 40" style="margin-left:-10px"><md-button class="md-icon-button" ng-click="vm.openActionMenu($mdOpenMenu,$event)" title="Actions"><md-icon class="blue_icon" md-svg-icon="/public/images/star-circle.svg"></md-icon></md-button><md-menu-content width="4"><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.addRow($event)"><md-icon class="blue_icon" md-svg-icon="/public/images/rocket.svg"></md-icon>Add new record</md-button></md-menu-item><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.uploadList($event)"><md-icon class="green_icon" md-svg-icon="/public/images/ic_add_circle_outline_black_24px.svg"></md-icon>Upload new list</md-button></md-menu-item><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.deleteAllRows($event)"><md-icon class="red_icon" md-svg-icon="/public/images/close-circle-outline.svg"></md-icon>Delete all existing records</md-button></md-menu-item></md-menu-content></md-menu></span></div><div class="export-btn-container"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" ng-click="vm.exportComplinacePlan()" ng-disabled="vm.exportFired" title="Export Compliance plan\' to an Excel spreadsheet"><md-icon class="white_icon" ng-if="!vm.exportFired" md-svg-icon="download"></md-icon><md-icon class="ibm-spinner" ng-if="vm.exportFired" style="border: 2px solid white; min-height: 12px; min-width: 12px;"></md-icon><span style="text-transform: none; font-size: 15px; padding-left: 5px; padding-right: 2px;">{{vm.exportFired ? \'Please wait...\' : \'Export\'}}   </span></md-button></div><br></div><div class="fill" layout="column"><table class="complianceplan-table ibm-data-table ibm-altrows ibm-alternate-two" id="table" datatable="" dt-options="vm.table.dtOptions" dt-instance="vm.table.dtInstance" dt-columns="vm.table.dtColumns" dt-disable-deep-watchers="true"></table></div></form></md-tab><md-tab label="History"><form class="form-list fill" name="" layout="column"><div class="history-container" ng-if="vm.logLoaded" flex="auto"></div><div class="fill" layout="column"><table class="history-table ibm-data-table ibm-altrows ibm-alternate-two" id="table" datatable="" dt-options="vm.tableLog.dtOptions" dt-instance="vm.tableLog.dtInstance" dt-columns="vm.tableLog.dtColumns"></table></div></form></md-tab></md-tabs></div></div></div></div></div></div></main>');
$templateCache.put('country-view.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Country Profiles</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="!vm.isDivisionLoaded || !vm.isCountryLoaded">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div><div style="padding-left:80px">           <md-tabs style="min-height:500px" ng-if="vm.isDivisionLoaded &amp;&amp; vm.isCountryLoaded"> <md-tab label="Profiles">                                                         <div style="padding-right: 100px"><md-button class="md-primary md-raised" ng-click="vm.save()" ng-disabled="vm.isSaving">Save                         </md-button></div><div style="padding:15px"><span style="padding-right:10px; font-weight:bold">Country Index:</span><span ng-repeat="letter in vm.alphabet track by $index " style="padding-left:5px; padding-right:5px" ng-click="vm.activateLetter(letter)">{{letter}}           </span><span style="float:right; padding-right: 70px">Showing {{vm.visibleEnd - vm.visibleStart}} of {{vm.docTable.currentTable.length}} total entries</span></div><table><thead> <tr><td ng-repeat="oneName in vm.docTable.colNames track by $index" style="border: 1px solid #CCC; height: 10px; background-color:#DFDFDF; padding-left: 1px; text-align: center; width:100px; font-size:80%"><b>{{oneName.name}}</b></td></tr></thead><tbody><tr ng-repeat="oneCode in vm.visibleTable track by $index">                                               <td ng-repeat="(oneKey,oneVal) in oneCode track by $index" ng-if="oneKey!==\'isLineValid\'" style="border: 1px solid #CCC; height: 10px; background-color:white; padding-left: 1px"><input ng-model="oneCode[oneKey]" ng-if="oneKey.search(\'country\') &gt; -1" maxlength="2" style="border:none; text-align: center; width:80px; font-size:80%; height: 40px" disabled="disabled"/><input ng-if="(oneKey.search(\'Code\') &gt; -1 || oneKey.search(\'combo\') &gt; -1) &amp;&amp; oneKey.search(\'country\') === -1" ng-model="oneCode[oneKey]" style="border:none; text-align: center; width:80px; font-size:80%; height: 40px"/><input ng-if="[\'Code\', \'combocountry\', \'reqStart\', \'reqEnd\', \'licType\', \'incType\', \'vatUsed\', \'decPlaces\', \'cvrElig\'].indexOf(oneKey) === -1" ng-model="oneCode[oneKey]" style="border:none;  text-align: center; width:80px;  font-size:80%; height: 40px"/><md-datepicker ng-if="oneKey.search(\'Start\') &gt; -1 || oneKey.search(\'End\') &gt; -1" ng-model="oneCode[oneKey]" ng-valid="vm.docTable.isLineValid" style="text-align: center; width:100px; height: 40px; padding-top:5px"></md-datepicker><md-radio-group ng-model="oneCode[oneKey]" layout="row" ng-if="[\'vatUsed\', \'cvrElig\'].indexOf(oneKey) &gt; -1" style="padding-left:5px; padding-right:5px"><md-radio-button class="md-primary" ng-repeat="c in vm.cfg.yesNo" ng-value="c.value">{{ c.label }}                                                        </md-radio-button></md-radio-group><md-select ng-model="oneCode[oneKey]" ng-if="oneKey.search(\'licType\') &gt; -1" style="margin:0; text-align:center" aria-label="License Type"><md-option ng-repeat="c in vm.cfg.licType" ng-value="c.value">{{c.label}}    </md-option></md-select><md-select ng-model="oneCode[oneKey]" ng-if="oneKey.search(\'incType\') &gt; -1" style="margin:0; text-align:center" aria-label="Incentive Type"><md-option ng-repeat="c in vm.cfg.incType" ng-value="c.value">{{c.label}}                                                                                                                                                          </md-option></md-select><md-select ng-model="oneCode[oneKey]" ng-if="oneKey.search(\'decPlaces\') &gt; -1" style="margin:0; text-align:center" aria-label="Decimal Places"><md-option ng-repeat="c in vm.cfg.decPlaces" ng-value="c.value">{{c.label}}    </md-option></md-select></td><td style="border-left: 1px solid #CCC; height: 10px; background-color:white"><md-icon class="red_icon" ng-if="!oneCode.isLineValid" md-svg-icon="invalid"></md-icon><md-button ng-click="vm.deleteConfirmation($event, oneCode)" ng-disabled="vm.isSaving"><md-icon md-svg-icon="delete"></md-icon></md-button></td></tr></tbody></table></md-tab><md-tab label="Add Profile"><table><thead> <tr><td ng-repeat="oneName in vm.docTable.colNames track by $index" style="border: 1px solid #CCC; height: 10px; background-color:#DFDFDF; text-align: center; width:100px; font-size:80%"><b>{{oneName.name}}</b></td></tr></thead><tbody><tr><td ng-repeat="(newKey, newVal) in vm.newCode track by $index" ng-if="newKey!==\'isLineValid\'" style="border: 1px solid #CCC; height: 10px; background-color:white; text-align: center; width:100px; font-size:80%"><input ng-model="vm.newCode[newKey]" ng-if="newKey.search(\'country\') &gt; -1" maxlength="2" style="border:none; width:100px; height: 40px; text-align: center"/><input ng-if="(newKey.search(\'Code\') &gt; -1 || newKey.search(\'combo\') &gt; -1) &amp;&amp; newKey.search(\'country\') === -1" ng-model="vm.newCode[newKey]" style="border:none; width:100px; height: 40px; text-align: center"/><input ng-if="[\'Code\', \'combocountry\', \'reqStart\', \'reqEnd\', \'licType\', \'incType\', \'vatUsed\', \'decPlaces\', \'cvrElig\'].indexOf(newKey) === -1" ng-model="vm.newCode[newKey]" style="border:none; width:100px; height: 40px; text-align: center"/><md-datepicker ng-if="newKey.search(\'Start\') &gt; -1 || newKey.search(\'End\') &gt; -1" ng-model="vm.newCode[newKey]" ng-valid="vm.docTable.isLineValid"></md-datepicker><md-radio-group ng-model="vm.newCode[newKey]" layout="row" ng-if="[\'vatUsed\', \'cvrElig\'].indexOf(newKey) &gt; -1" style="padding-left:5px; padding-right:5px"><md-radio-button class="md-primary" ng-repeat="c in vm.cfg.yesNo" ng-value="c.value">{{ c.label }}</md-radio-button></md-radio-group><md-select ng-model="vm.newCode[newKey]" ng-if="newKey.search(\'licType\') &gt; -1" style="margin:0; text-align:center" aria-label="License Type"><md-option ng-repeat="c in vm.cfg.licType" ng-value="c.value">{{c.label}}    </md-option></md-select><md-select ng-model="vm.newCode[newKey]" ng-if="newKey.search(\'incType\') &gt; -1" style="margin:0; text-align:center" aria-label="Incentive Type"><md-option ng-repeat="c in vm.cfg.incType" value="{{c.value}}">{{c.label}}  </md-option></md-select><md-select ng-model="vm.newCode[newKey]" ng-if="newKey.search(\'decPlaces\') &gt; -1" style="margin:0; text-align:center" aria-label="Decimal Places"><md-option ng-repeat="c in vm.cfg.decPlaces" ng-value="c.value">{{c.label}}    </md-option></md-select></td><td style="border-left: 1px solid #CCC; height: 10px; background-color:white;"><div layout="row"><md-icon class="red_icon" ng-if="!vm.newCode.isLineValid" md-svg-icon="invalid"></md-icon><md-button ng-click="vm.addNewCode()" ng-disabled="(vm.newCode.divCode === \'\' || vm.newCode.divCodeDesc === \'\' || vm.newCode.reqStart === \'\' || vm.newCode.reqEnd === \'\' || vm.isSaving)"><md-icon class="green_icon" md-svg-icon="save"></md-icon></md-button><md-button ng-click="vm.voidNew()">Cancel</md-button></div></td></tr></tbody></table></md-tab><md-tab label="History"><table class="ibm-data-table" border="0" cellspacing="0" cellpadding="0" style="margin: 5px 5px 50px; border-style: solid;">                                   <thead><tr><td><b>Time</b></td><td><b>Changes made</b></td><td><b>Changed by</b></td></tr></thead><tbody><tr ng-repeat="entry in vm.docTable.tableHistory track by $index"><td>{{entry.timestamp.toString()}}</td><td>{{entry.comment[0]}}</td><td>{{entry.user}}</td></tr></tbody></table></md-tab></md-tabs></div></div></div></div></div></div></main>');
$templateCache.put('exchangerate-view.html','<style>.records-table {\n    min-width: 1100px;\n}\n.records-table tbody tr td:last-child,\n.records-table thead tr td:last-child {\n    min-width: 130px;\n}\n.actions-container {\n    box-sizing: border-box;\n    display: inline-flex;\n    flex: 0 0 auto;\n    align-items: center;\n    justify-content: flex-end;\n    z-index: 1;\n    right: 0;\n    position: absolute;\n    top: 0;\n}\n.actions-container > div {\n    padding: 10px 5px;\n}\n.actions-container > div:first-child {\n    align-items: stretch;\n    display: flex;\n    flex: 1 1 auto;\n    height: 35px;     \n}\n.actions-container .actions {\n    border: solid 1px #5596e6;\n    padding: 7px 0px 7px 7px;\n    color: #5596e6;\n    display: flex;\n    align-items: center;\n}\n.export-btn-container button {\n    margin: 0;\n}\na.link {\n    text-decoration: none;\n}\n.alpha_dead {\n    color: lightgray;\n}\n.alpha_selly {\n    color: white;\n    background-color: #5596e6;\n    border-radius: 25%;\n}\n.form-list {\n    padding-top: 15px;\n    min-height: 65px;\n}\n.delete-button md-icon svg {\n    fill: #e71d32;\n}\n.edit-button md-icon svg {\n    fill: #325c80;\n}\n.fill {\n    display: flex;\n    width: 100%;\n    height: 100%;\n}\n#ibm-content-body {\n    box-sizing: border-box;\n}\n.admin-tabs, .admin-tabs md-tabs-content-wrapper, .admin-tabs md-tab-content, .admin-tabs md-tab-content > div {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n.flex {\n    display: flex;\n}\n.history-container {\n    display: flex;\n    flex: 1;\n    width: 100%;\n    overflow: auto;\n    padding-top: 15px;\n}\n.history-table td:nth-child(2), .history-table th:nth-child(2){\n    flex-grow: 4;\n}\n.history-table td:nth-child(3), .history-table th:nth-child(3){\n    flex-grow: 3;\n}\n</style><main class="fill" role="main" aria-labelledby="ibm-pagetitle-h1"><div class="fill" id="ibm-pcon" ibm-back-to-top=""><div class="fill" id="ibm-content"><div class="fill" id="ibm-content-body"><div class="fill" id="ibm-content-main"><div class="fill" id="content" layout="column"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Exchange Rate Profile</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!vm.recordsLoaded ">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="vm.importingExcel ">Importing from Excel list...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span ng-if="vm.settings.status_cfg"></span></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div><div class="ibm-columns flex"><md-tabs class="admin-tabs" md-dynamic-height="md-dynamic-height"><md-tab label="Exchange Rate Profile"><form class="form-list fill" name="" layout="column"><div class="actions-container" ng-if="vm.recordsLoaded" flex="auto"><div><span class="actions"><span>Admin Actions</span><md-menu ng-disabled="vm.events.beingSaved" md-position-mode="target-right target" md-offset="0 40"><md-button class="md-icon-button" ng-click="vm.openActionMenu($mdOpenMenu,$event)" title="Actions"><md-icon class="blue_icon" md-svg-icon="/public/images/star-circle.svg"></md-icon></md-button><md-menu-content width="4"><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.createRecord($event)"><md-icon class="blue_icon" md-svg-icon="/public/images/rocket.svg"></md-icon>Add new record</md-button></md-menu-item><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.uploadRecordList($event)"><md-icon class="green_icon" md-svg-icon="/public/images/ic_add_circle_outline_black_24px.svg"></md-icon>Upload new list</md-button></md-menu-item><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.deleteAllRecords($event)"><md-icon class="red_icon" md-svg-icon="/public/images/close-circle-outline.svg"></md-icon>Delete all existing records</md-button></md-menu-item><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.downloadTemplate($event)"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_file_download_black_24px.svg"></md-icon>Download latest template</md-button></md-menu-item></md-menu-content></md-menu></span></div><div class="export-btn-container"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" ng-click="vm.export()" ng-disabled="vm.exportFired" title="Export to Excel spreadsheet"><md-icon class="white_icon" ng-if="!vm.exportFired" md-svg-icon="download"></md-icon><md-icon class="ibm-spinner" ng-if="vm.exportFired" style="border: 2px solid white; min-height: 12px; min-width: 12px;"></md-icon><span style="text-transform: none; font-size: 15px; padding-left: 5px; padding-right: 2px;">{{vm.exportFired ? \'Please wait...\' : \'Export\'}}   </span></md-button></div><br></div><div class="fill" layout="column"><table class="records-table ibm-data-table ibm-altrows ibm-alternate-two" ng-if="vm.recordsLoaded" datatable="ng" dt-options="vm.table.options" dt-column-defs="vm.table.columnDefs"><thead><tr ng-repeat="hd in vm.table.headers"><td ng-repeat="(key,value) in hd"><b>{{key}}&nbsp;</b></td><td> <b>Actions</b></td></tr></thead><tBody><tr ng-repeat="record in vm.records track by record.ID"><td>{{record.CURRENCY}}</td><td>{{record.FROMUSD | number:5}}</td><td>{{record.TOUSD | number:5 }}</td><td>{{record.STARTDATE}}</td><td>{{record.ENDDATE}}</td><td>{{record.ACTIVE}}</td><td>{{record.CREATED | stringToDateFormat:"yyyy-MM-dd"}}</td><td>{{record.LAST_UPDATE | stringToDateFormat:"yyyy-MM-dd"}}</td><td>{{record.INACTIVE_FROM | stringToDateFormat:"yyyy-MM-dd"}}</td><td>{{record.CREATED_BY}}</td><td>{{record.UPDATED_BY}}</td><td><md-button class="edit-button" ng-click="vm.editRecord($event, record)" ng-disabled="vm.isSaving" aria-label="Edit"><md-icon md-svg-icon="edit_pen"></md-icon></md-button><md-button class="delete-button" ng-click="vm.deleteRecord($event, record)" ng-disabled="vm.isSaving" aria-label="Delete"><md-icon md-svg-icon="delete"></md-icon></md-button></td></tr></tBody></table></div></form></md-tab><md-tab label="History"><div class="history-container"><table class="ibm-data-table history-table" datatable="ng" dt-options="vm.historyTable.options" dt-instance="vm.historyTable.instance" dt-column-defs="vm.historyTable.columnDefs">                                   <thead><tr><th>Time</th><th>Changes made</th><th>Changed by</th></tr></thead><tbody><tr ng-repeat="entry in vm.docTable track by $index"><td>{{ entry.timestamp }}</td><td>{{ entry.comment[0] }}</td><td>{{ entry.user }}</td></tr></tbody></table></div></md-tab></md-tabs></div></div></div></div></div></div></main>');
$templateCache.put('mass-update.html','<style>.content-title { \n    text-align: center;\n}\n.file-structure-container {\n    display: flex;\n    flex: 0 0 auto;\n    justify-content: center;\n}\ntable.file-structure-table th, table.file-structure-table td {\n    padding: 5px 10px;\n}\n.submit-btn-container {\n    text-align: center;\n}\n.submit-btn {\n    width: 300px;\n}</style><div ng-cloak="ng-cloak"><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="vm.inProgress"><span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span><span>Performing mass update...</span></h1><md-content><md-tabs md-dynamic-height="md-dynamic-height" md-border-bottom="md-border-bottom"><md-tab label="Update BPOI"><md-content class="md-padding"><h1 class="content-title md-display-1">BPOI mass update</h1><div class="description"><span>BPOI mass update functionality provides possibility to update "elig_decision" for the given set of opportunities specified in the BPOI file. </span><br/><span><b>*WARNING* </b><span>Please, use it carefully since it can corrupt cloudant data.</span></span><br/><span>The BPOI file should have the following structure:</span><p></p></div><div class="file-structure-container"><table class="file-structure-table"><thead><tr><th>Opportunity</th><th>Row-ID</th><th>BPOI Flag</th></tr></thead><tbody><tr><td>opportunity number</td><td>gpp "row_id"</td><td>bpoi flag (BP ID, IBM ID etc)</td></tr></tbody></table></div><div class="description"><p></p><span>To start the process, select BPOI file and click "Submit" button.</span><p></p></div><md-button class="md-raised md-primary" ngf-select="vm.selectBPOIFile($event,$files)" ng-disabled="vm.inProgress" ngf-max-size="5MB" accept=".xls,.xlsx">Select BPOI file</md-button><span>{{vm.bpoiFile.name}}</span><p></p><div class="submit-btn-container"><md-button class="md-raised md-warn submit-btn" ng-disabled="vm.isSubmitDisabled()" ng-click="vm.onBPOISubmit($event)">Submit</md-button></div></md-content></md-tab></md-tabs></md-content></div>');
$templateCache.put('adminreporting-table-view.html','<table class="ibm-data-table ibm-grid ibm-altrows" ibm-altcols="ibm-altcols"><thead><tr><td ng-repeat="header in vm.headers"><b>{{header}}</b></td></tr></thead><tbody><tr ng-repeat="row in vm.data track by $index"><td ng-repeat="col in vm.columns"> <span>{{row[col]}}</span></td></tr></tbody></table>');
$templateCache.put('adminreporting-view.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Reporting Tables Administration</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="!vm.dataLoaded">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div><!--br--><!--br--><!--md-progress-linear(md-mode="indeterminate" ng-if="!vm.isDivisionLoaded || !vm.isCountryLoaded" id=\'generalInfo\' class="ibm-columns")p Please wait, loading--><!--br--><div class="ibm-columns" ng-if="vm.dataLoaded" id="generalInfo"><md-tabs md-selected="vm.selectedTable" md-dynamic-height="md-dynamic-height" md-border-bottom="md-border-bottom"><md-tab ng-repeat="oneTab in vm.tables track by $index" label="{{oneTab}}" ng-style="{color: \'green\'}" ng-click="vm.switchTable()"><br/><div flex="flex" layout-padding="layout-padding"><adminreporting-table-section table="vm.selectedTable" data="vm.data"></adminreporting-table-section></div><br/></md-tab></md-tabs></div></div></div></div></div></div></div></main>');
$templateCache.put('admin-main.html','<style>table, td {\n    border-color: lightgray;\n}\ntable {\n    width: inherit;\n}\na.link {\n    text-decoration: none;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Admin</b></h1></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><span class="ibm-textcolor-gray-40" ng-if="vm.countFired">Click to retrieve DMT Statistics&nbsp;</span><b class="ibm-textcolor-blue-40" ng-if="!vm.countFired" ng-click="vm.getStats()">Click to retrieve DMT Statistics</b><span ng-if="vm.countFired &amp;&amp; !vm.countLoaded"><span>...Please wait... </span><span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span><!--md-progress-circular(md-mode="indeterminate" ng-if="vm.countFired && !vm.countLoaded" md-diameter="20px")--></span><span ng-if="vm.countLoaded">: Total number of opportunities is <span class="ibm-bold">{{vm.opptyCount | number: 0}}</span></span><p></p><p>Please select which Admin section you\'d like to view.</p><table class="ibm-data-table ibm-altrows ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1"><thead><tr><td ng-repeat="hd in vm.table.headers"><b class="head">{{hd}}&nbsp;</b></td></tr></thead><tBody><tr ng-repeat="prof in vm.table.profiles | orderBy:&quot;name&quot;"><td><b ng-if="prof.enabled"><a class="link" style="color: #1e6ac8" ng-click="vm.navigate(prof.profile)">{{prof.name}}</a></b><b ng-if="!prof.enabled">{{prof.name}}</b></td><td>{{prof.desc}}</td></tr></tBody></table><p></p></div></div></div></div></div></div></div></main>');
$templateCache.put('admin-selectbox.html','<style>.right {\ntext-align: right;\n}\n.field {\n    padding-bottom: 3px;\n}\n.selectbox {\n  border-radius: 8px 0px 0px 0px;\n  padding: 10px;\n  border: 1px solid lightgray;\n  max-height: 150px;\n  overflow:scroll;\n  overflow-x:hidden;\n}\n.selectbox_bottom {\n  padding: 6px;\n  background-color: rgb(225, 242, 255);\n  border-radius: 0px 0px 0px 8px;\n  border: 1px solid lightgray;\n}</style>{{f}}<span ng-bind="f.field"></span><span ng-bind="f.order"></span><div class="selectbox"><span ng-repeat="cty in vm.getEm(vm.admin,f)">{{cty}}</span><span ng-repeat="cty in vm.admin[f.field] | filter : vm.editing.imt | orderBy: f.order"><input ng-disabled="!vm.editing.imt" type="checkbox" ng-model="vm.editing.select.[f.field][cty.short]" ng-change="vm.syncCountries()"/>{{cty[f.order]}} &nbsp;&nbsp;<p ng-if="vm.newLine($index+1)"></p></span></div><div class="selectbox_bottom"><span class="checkbox_subcontainer" style="padding: 8px 0px 9px 0px"><md-button class="md-icon-button" title="Select All" ng-click="vm.selectAll(true)"><md-icon class="blue_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon></md-button><md-button class="md-icon-button" style="margin-left: -9px" title="Deselect All" ng-click="vm.selectAll(false)"><md-icon class="red_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon></md-button></span><span class="ibm-textcolor-blue-50">&nbsp;&nbsp;Selected :&nbsp;</span><b>{{vm.editing[f.field].length}}</b></div>');
$templateCache.put('admin-selectbox2.html','<span>HIYA!\n{{f}}</span>');
$templateCache.put('admin.html','<h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="!(vm.settings.loaded &amp;&amp; vm.env.loaded.env)"><span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span><span>Loading settings...</span></h1><div ng-if="vm.settings.loaded &amp;&amp; vm.env.loaded.env"><ui-view></ui-view></div>');
$templateCache.put('approvals.html','<style>table, td {\n    border-color: lightgray;\n}\na {\n    color: "ibm-textcolor-blue-50";\n}\na.head {\n    text-decoration: none;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Awaiting Approval</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="!vm.resultsRetrieved">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span ng-if="vm.resultsRetrieved">As\n{{vm.appRole.toLowerCase().substring(1, 1) === \'a\' ? \'an\' : \'a\'}}&nbsp;<b class="ibm-textcolor-blue-40">{{vm.appRole}}</b>&nbsp;you are authorised to approve any Disbursement awaiting a&nbsp;<b>{{vm.bpsoNonBpso}}</b><span ng-if="vm.appRole.indexOf(\'Approver\') &gt; -1">&nbsp;Approval Stage where you are defined as one of the dedicated Approvers.</span><span ng-if="vm.appRole.indexOf(\'Approver\') === -1">&nbsp;Approval Stage.</span>&nbsp;&nbsp;<a style="color:cornflowerblue" ng-click="vm.toggleStages=!vm.toggleStages">{{!vm.toggleStages ? \'View\' : \'Hide\'}} the Stages</a><div ng-if="vm.toggleStages"><div ng-if="vm.stages!==null"><p></p><div ng-if="vm.stages.length"><p>You are currently defined as an Approver for the following Approval Stage(s). &nbsp;Hover over each&nbsp;<md-icon class="blue_icon" md-svg-src="/public/images/ic_info_outline_black_24px.svg"></md-icon>&nbsp;for the details:</p><table class="ibm-data-table ibm-altrows ibm-alternate-two table" ng-if="vm.stages.length" cellspacing="0" cellpadding="0" border="1"><thead><tr><td>Main Status</td><td>Approval Stage</td></tr></thead><tBody><tr ng-repeat="stage in vm.stages"><td><span class="ibm-textcolor-blue-40">{{stage.main_name}}</span></td><td>{{stage.name}}&nbsp;<md-icon class="blue_icon" md-svg-src="/public/images/ic_info_outline_black_24px.svg" title="{{stage.prez}}"></md-icon></td></tr></tBody></table></div><span ng-if="!vm.stages.length"><p>You are currently not defined as an Approver for any Approval Stage. &nbsp;Please contact the DMT System Administrators if you believe this to be incorrect.</p></span></div></div><p></p><span ng-if="!vm.results.length">There are no Disbursements specifically assigned to you for approval.</span><span ng-if="vm.results.length">The following&nbsp;<b class="ibm-textcolor-blue-50" ng-if="vm.results.length&gt;1" ng-bind="vm.results.length"></b>{{vm.results.length > 1 ? \' Disbursements have\' : \'Disbursement has\'}} been specifically assigned to you for approval.</span><span style="color: crimson; margin-left: 10px" title="Despite being able to approve ANY Disbursement where you have authority (as decsribed above), this view only shows Disbursements that have been specifically assigned to you.  So, if you know there are others you should be able to approve and you want to approve them, either ask someone to use the Renotify Approver function and select you, or hunt the Disbursements down via one of the Queues.\n\nNOTE: You will also not see Disbursements here where you initiated the Approval Process, or have already approved an earlier stage.">Missing Disbursements?</span><!--md-button(style="margin-left: 3px" class="md-icon-button" ng-click="vm.fireSocket()" title="Refresh the view")md-icon(class="blue_icon" md-svg-icon="/public/images/ic_autorenew_black_24px.svg")--><p> </p></span></div><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.fireSocket()" style="margin-left: 3px" ng-disabled="!vm.resultsRetrieved" aria-label="Refresh the view" title="Click to refresh the view"><span ng-if="vm.resultsRetrieved"><md-icon class="white_icon" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon></span><span ng-if="!vm.resultsRetrieved"><md-icon class="rotating" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon></span>&nbsp;Refresh View</md-button></div></div><!--Following div added to pad out the page...if not table results the drop-down menu is lost - need better css on it--><!--div(ng-if="!vm.results.length" style="height:250px; border")--><div class="ibm-columns" ng-if="vm.resultsRetrieved"><div class="ibm-col-1-1"><div ng-if="vm.results.length &amp;&amp; !vm.table.filter"><span class="search_box"><md-icon class="blue_icon" md-svg-icon="/public/images/magnify.svg"></md-icon></span><input class="userField" ng-model="vm.table.search" placeholder="Enter search criteria"/>&nbsp;&nbsp;<a ng-click="vm.table.filter = true"><span class="ibm-textcolor-blue-50">Advanced Search</span></a><p></p></div><div class="checkbox_container" ng-if="vm.results.length &amp;&amp; vm.table.filter">Please select the fields you would like to filter on:<p></p><div class="checkbox_subcontainer"><span ng-repeat="(key,value) in vm.table.headers[0]"><input type="checkbox" ng-model="vm.table.filters[value]"/>{{key}} &nbsp;&nbsp;</span></div><div style="padding: 6px"><span ng-repeat="(key,value) in vm.table.headers[0]"><p ng-if="vm.table.filters[value]">{{key}} &nbsp;<input class="userField" ng-if="vm.table.filters[value]" ng-model="vm.table.filterParams[value]"/></p></span></div><md-icon class="blue_icon" md-svg-icon="/public/images/magnify.svg"></md-icon>&nbsp;<a ng-click="vm.table.filter = false"><span class="ibm-textcolor-blue-50">Back to Basic Search</span></a>&nbsp;&nbsp;&nbsp;<md-icon class="blue_icon" md-svg-icon="/public/images/filter-variant.svg"></md-icon>&nbsp;<a ng-click="vm.resetFilters()"><span class="ibm-textcolor-blue-50">Reset</span></a></div><table class="ibm-data-table ibm-altrows ibm-alternate-two table" ng-if="vm.results.length" cellspacing="0" cellpadding="0" border="1"><thead><tr ng-repeat="hd in vm.table.headers"><td ng-repeat="(key,value) in hd"><a class="head" ng-click="vm.table.sortType = value; vm.table.sortReverse = !vm.table.sortReverse">{{key}}&nbsp;</a><span ng-show="vm.table.sortType==value &amp;&amp; !vm.table.sortReverse"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_expand_less_black_24px.svg"></md-icon></span><span ng-show="vm.table.sortType==value &amp;&amp; vm.table.sortReverse"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_expand_more_black_24px.svg"></md-icon></span></td></tr></thead><tBody><!--tr(ng-repeat=\'disbursement in vm.results | orderBy:vm.table.sortType:vm.table.sortReverse | filter:vm.table.filterParams\')--><tr ng-repeat="disbursement in vm.results | orderBy:vm.table.sortType:vm.table.sortReverse | filter:(vm.table.filter ? vm.table.filterParams : vm.table.search)"><td ng-repeat="(key, value) in disbursement"><span ng-if="key==&quot;opp&quot;"><a ui-sref="detail.general({id:&quot;{{value}}&quot;})">{{value}}</a></span><span ng-if="key==&quot;owner&quot;" style="vertical-align:middle"><img class="table-img-circle" ng-src="{{vm.getAvatar(value)}}"/><span class="ibm-center ibm-regular">{{value.name}}</span></span><span ng-if="[&quot;opp&quot;,&quot;owner&quot;].indexOf(key) == -1">{{value}}</span></td></tr></tBody></table></div></div></div></div></div></div></div></main>');
$templateCache.put('filter.html','<div class="checkbox_container"><span style="display: inline-flex; float: right; margin-top: -5px"><md-button class="dmt-team-btn dmt-team-btn" ng-class="{\'md-primary md-raised\' : $ctrl.vm.isFilterSet}" ng-click="$ctrl.vm.applyFilter()" ng-disabled="!$ctrl.vm.showFilterBtn" title="Apply the current filter settings"><md-tooltip ng-if="$ctrl.vm.isFilterSet" md-direction="bottom">Filters are active</md-tooltip><md-icon md-svg-icon="filter"></md-icon><span>Apply</span></md-button><md-button class="dmt-team-btn" ng-click="$ctrl.vm.clearFilter()" title="Wipe all filter settings"><md-icon md-svg-icon="clearAll"></md-icon><span>Clear All</span></md-button><md-icon ng-click="$ctrl.closeFilter()" style="padding-left: 5px;" md-menu-align-target="md-menu-align-target" md-svg-icon="/public/icons/ic_close_black_24px.svg"></md-icon></span><p></p><div class="checkbox_subcontainer" style="margin-top: 20px"><span style="border-bottom: 1px solid lightgray;"><b class="ibm-textcolor-blue-40 ibm-h4">Current Filters</b><span style="padding-left: 1em">Select the relevant filters and click&nbsp;<b>Apply</b>.</span></span><p></p><div ng-if="$ctrl.vm.$stateParams.id !== \'setAside\' &amp;&amp; $ctrl.vm.queryId !== \'sap-missing\'"><input ng-change="$ctrl.vm.changeFilters(\'verFilter\')" ng-model="$ctrl.vm.verFilter" ng-value="0" type="radio"/>All<input ng-change="$ctrl.vm.changeFilters(\'verFilter\')" ng-model="$ctrl.vm.verFilter" ng-value="1" type="radio" style="margin-left:15px"/>CVR<input ng-change="$ctrl.vm.changeFilters(\'verFilter\')" ng-model="$ctrl.vm.verFilter" ng-value="3" type="radio" style="margin-left:15px"/>SWDR</div><p></p><div ng-if="$ctrl.vm.filterToggles.goe"><input ng-change="$ctrl.vm.changeFilters(\'goeFilter\')" ng-model="$ctrl.vm.goeFilter" ng-value="true" type="checkbox" style="margin-left:15px"/>GoE Only</div><p></p><!--md-switch(title="Toggle between Disbursements that have VAP Government and those that don\'t" ng-if="$ctrl.vm.enableVAPFilter" class="md-primary" aria-label="vap g only" ng-model="$ctrl.vm.vapFilter")| Only display Disbursements&nbsp;\nb {{$ctrl.vm.vapFilter ? "with" : "without"}}\n| &nbsp;VAP-G--><div class="ibm-columns"><div class="ibm-col-3-1" style="width: 18em"><md-select class="ibm_select" ng-if="$ctrl.vm.filterToggles.errors" ng-model="$ctrl.vm.filterErrors" multiple="true" placeholder="Pick an Error Type"><md-option ng-repeat="error in $ctrl.vm.filters.errorTypes | orderBy: \'error\' track by $index" ng-value="error">{{ error.t }}</md-option></md-select><md-select class="ibm_select" ng-change="$ctrl.vm.changeFilters(\'iot\')" ng-if="$ctrl.vm.filterToggles.countries" ng-model="$ctrl.vm.filterIots" multiple="true" placeholder="Pick an IOT"><md-option ng-repeat="iot in $ctrl.vm.filters.iots | orderBy: \'iot\' track by $index" ng-value="iot">{{ iot }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.vm.filterToggles.dmtStats" ng-model="$ctrl.vm.filterStatuses" multiple="multiple" placeholder="Pick a DMT Main Status"><md-option ng-repeat="status in $ctrl.vm.filters.statuses | orderBy: status track by $index" ng-value="status">{{ status }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.vm.filterToggles.teams" ng-model="$ctrl.vm.filterTeams" multiple="multiple" placeholder="Pick a Team"><md-option ng-repeat="team in $ctrl.vm.filters.teams" ng-value="team">{{ team }}</md-option></md-select></div><div class="ibm-col-3-2" style="width: 18em"><md-select class="ibm_select" ng-change="$ctrl.vm.changeFilters(\'imt\')" ng-if="$ctrl.vm.filterToggles.countries" ng-model="$ctrl.vm.filterImts" multiple="true" placeholder="Pick an IMT"><md-option ng-repeat="imt in $ctrl.vm.filters.imts" ng-value="imt">{{ imt }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.vm.filterToggles.dmtSubStats" ng-model="$ctrl.vm.filterSubStatuses" multiple="multiple" placeholder="Pick a DMT Sub-Status"><md-option ng-repeat="subStatus in $ctrl.vm.filters.subStatuses | orderBy:subStatus" ng-value="subStatus">{{ subStatus }}</md-option></md-select></div><div class="ibm-col-3-3"><md-select class="ibm_select" ng-change="$ctrl.vm.changeFilters(\'cty\')" ng-if="$ctrl.vm.filterToggles.countries" ng-model="$ctrl.vm.filterCountries" multiple="true" placeholder="Pick a country"><md-option ng-repeat="country in $ctrl.vm.filters.countries" ng-value="country">{{ country }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.vm.filterToggles.sviStats" multiple="multiple" ng-model="$ctrl.vm.filterSviStatuses" placeholder="Pick a MySA Status"><md-option ng-repeat="sviStatus in $ctrl.vm.filters.sviStatuses | orderBy: sviStatus" ng-value="sviStatus">{{ sviStatus }}</md-option></md-select><md-select class="ibm_select" ng-change="$ctrl.vm.changeFilters(\'STAT\')" ng-if="$ctrl.vm.filterToggles.sampStat" ng-model="$ctrl.vm.filterSolutionSamplStatus" multiple="multiple" placeholder="Pick a Solution Status"><md-option ng-repeat="samplingStatus in $ctrl.vm.filters.samplingStatus| orderBy: samplingStatus" ng-value="samplingStatus">{{ samplingStatus }}</md-option></md-select><md-select class="ibm_select" ng-change="$ctrl.vm.changeFilters(\'STAT\')" ng-if="$ctrl.vm.filterToggles.sampStat" ng-model="$ctrl.vm.filterSSASamplStatus" multiple="multiple" placeholder="Pick a SSA Status"><md-option ng-repeat="samplingStatus in $ctrl.vm.filters.samplingStatus| orderBy: samplingStatus" ng-value="samplingStatus">{{ samplingStatus }}</md-option></md-select></div><div class="ibm-col-3-4"><md-select class="ibm_select" ng-if="!$ctrl.vm.filterToggles.sampStat &amp;&amp; ($ctrl.vm.filterCountries.indexOf(\'USA\') &gt; -1 || $ctrl.vm.filterImts.indexOf(\'US IMT\') &gt; -1)" ng-model="$ctrl.vm.selectedStates" multiple="multiple" placeholder="Pick a State"><md-option ng-repeat="state in $ctrl.vm.USstates | orderBy:\'long\'" ng-value="state.short">{{ state.long }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.vm.filterToggles.sampStat &amp;&amp; ($ctrl.vm.filterCountries.indexOf(\'USA\') &gt; -1 || $ctrl.vm.filterImts.indexOf(\'US IMT\') &gt; -1)" ng-model="$ctrl.vm.selectedStates" multiple="multiple" placeholder="Pick a State"><md-option ng-repeat="state in $ctrl.vm.USstates | orderBy:\'toString()\'" ng-value="state">{{state}}</md-option></md-select></div></div></div><div class="checkbox_subcontainer" ng-if="$ctrl.vm.samplingPage !== true" style="margin-top: 5px"><span style="border-bottom: 1px solid lightgray;"><b class="ibm-textcolor-blue-40 ibm-h4">Saved Filters</b><span style="padding-left: 1em">Select a saved filter to load and click&nbsp;<b>Apply</b>. &nbsp;Click&nbsp;<b>Manage</b>&nbsp;to save/delete filters.</span></span><div class="ibm-columns" style="margin-top: 10px"><div class="ibm-col-2-1"><md-select class="ibm_select" ng-change="$ctrl.vm.changeSavedFilter($ctrl.vm.currFilter)" ng-model="$ctrl.vm.currFilter" style="margin-top: 10px" placeholder="Select a Saved Filter to load"><md-option ng-repeat="filter in $ctrl.vm.userFilters track by $index" ng-selected="filter.name === \'Default\'" ng-value="{{filter}}">{{ filter.name }}</md-option></md-select></div><div class="ibm-col-2-2"><md-button class="md-raised md-primary" ng-click="$ctrl.viewProfiles($event)" title="Manage New/Saved Profiles">Manage</md-button></div></div></div></div><p></p>');
$templateCache.put('profiles.dialog.html','<md-dialog class="customDialog" aria-label="Filter Profiles"><md-toolbar><div class="md-toolbar-tools"><h2>Filter Profiles</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel($event)"><md-icon class="white_icon" md-svg-src="/public/icons/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-no-momentum" style="margin: 15px;padding: 15px;"><span>Enter a Filter Name and click&nbsp;<b>Add</b>&nbsp;to save the current filter settings.</span><p></p><md-input-container class="md-icon-float md-block"><label>Filter Name</label><md-icon class="name" md-svg-src="public/icons/ic_person_add_black_24px.svg"></md-icon><input ng-model="$ctrl.vm.newSearch" type="text"/><md-button class="md-raised md-primary" style="float: right; margin: 0px; padding: 0px; margin-top: 10px;" ng-click="$ctrl.vm.saveFilter()">Add</md-button></md-input-container></md-content><md-list flex="flex"><md-subheader class="md-no-sticky">Current Saved Profiles</md-subheader><md-list-item class="noright" ng-repeat="filter in $ctrl.vm.userFilters track by $index"><div class="md-list-tem-text" layout="column"><p>{{ filter.name }}</p><md-button class="md-secondary md-icon-button" title="Delete this Saved Filter" ng-disabled="$ctrl.vm.allowed" ng-click="$ctrl.vm.deleteProfile(filter.name)"><md-icon class="red_icon" md-svg-src="public/icons/ic_remove_circle_black_24px.svg"></md-icon></md-button></div></md-list-item></md-list></md-dialog-content></md-dialog>');
$templateCache.put('help.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div class="ibm-columns"><div class="ibm-col-1-1"><div id="content"><h1>To get access to DMT or to open a technical help request please visit the <a href="https://w3-connections.ibm.com/wikis/home?lang=en-us#!/wiki/W4cb7b695ded2_44b6_8654_afd93389abf1/page/DMT%20-%20Disbursement%20Management%20Tool"> DMT wiki</a></h1></div></div></div></div></div></div></div></main>');
$templateCache.put('home-contact.html','<button class="ibm-btn-pri ibm-contact--bg-teal-50 ibm-contact-widget-btn ibm-active" type="button" value="" ng-click="vm.openContact()">Contact us</button><div class="ibm-contact-widget ibm-contact--bg-teal-50 addtransition ibm-alternate-background ibm active" id="ibm-contact-module" ng-class="vm.className"><p class="ibm-icononly"><a class="ibm-close-link" ng-click="vm.closeContact()" href="">Close</a></p><h2 class="ibm-bold">Contact us</h2><h3 class="ibm-bold">Contact us</h3><ul class="ibm-live-assistance-list ibm-padding-bottom-0"><li><a class="ibm-requestquote-link" href="javascript:;">Comments</a></li><li><a class="ibm-task-link" href="javascript:;">Design review</a></li><li><a class="ibm-new-link" href="javascript:;">New pattern request</a></li><li><a class="ibm-caution-link" href="javascript:;">Report an issue</a></li></ul></div>');
$templateCache.put('home-leadspace.html','<div class="ibm-background-teal-core ibm-alternate-background" id="ibm-leadspace-head" style="background: url(\'/public/images/leadspace-green.jpg\') center / cover no-repeat;"><div class="ibm-padding-top-r2 ibm-padding-bottom-r2" id="ibm-leadspace-body"><div class="ibm-columns ibm-alternate-background"><div class="ibm-col-6-4 ibm-col-medium-1-1"><h1 class="ibm-h1 ibm-medium ibm-light ibm-padding-bottom-1"><b> BP Disbursement Management</b><br class="ibm-br-xlarge ibm-br-large"/></h1><h4 class="ibm-h4 ibm-padding-bottom-2 ibm-light">Integrated Application for Business Partners Disbursements</h4><p class="ibm-button-link ibm-btn-row"><!--a.ibm-btn-pri.ibm-btn-white(href=\'\' ng-click="vm.logIn()") Log In--><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-orange-50" ng-click="vm.logIn()"><md-icon class="white_icon" md-svg-icon="/public/images/login-variant.svg"></md-icon>&nbsp;Log In</md-button></p></div></div></div></div>');
$templateCache.put('home.html','<div role="banner" aria-labelledby="ibm-pagetitle-h1"><div class="ibm-background-teal-core ibm-alternate-background" id="ibm-leadspace-head" style="background: url(\'/public/images/leadspace-green.jpg\') center / cover no-repeat;"><div class="ibm-padding-top-r2 ibm-padding-bottom-r2" id="ibm-leadspace-body"><div class="ibm-columns ibm-alternate-background"><div class="ibm-col-6-4 ibm-col-medium-1-1"><h1 class="ibm-h1 ibm-medium ibm-light ibm-padding-bottom-1"><b> BP Disbursement Management</b><br class="ibm-br-xlarge ibm-br-large"/></h1><h4 class="ibm-h4 ibm-padding-bottom-2 ibm-light">Integrated Application for Business Partners Disbursements</h4><p class="ibm-button-link ibm-btn-row"><!--a.ibm-btn-pri.ibm-btn-white(href=\'\' ng-click="vm.logIn()") Log In--><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-orange-50" ng-click="vm.logIn()"><md-icon class="white_icon" md-svg-icon="/public/images/login-variant.svg"></md-icon>&nbsp;Log In</md-button></p></div></div></div></div></div><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div class="ibm-columns"><div class="ibm-col-1-1"><div class="ibm-pull-quote ibm-h2"><blockquote><p><em class="ibm-textcolor-orange-50"><!--span.ibm-pullquote-open \u201C-->A workflow management application for all BPSO Disbursement programs and processes.<!--span.ibm-pullquote-close \u201D--></em></p><p></p><p></p><p></p><p></p><p></p></blockquote></div></div></div><ibm-contact-module></ibm-contact-module></div></div></div></div></main>');
$templateCache.put('invite.html','<div class="ibm-columns"><div class="ibm-col-6-1" style="float:right;"><div style="float:right;"><md-icon md-menu-align-target="md-menu-align-target" md-svg-icon="/public/icons/ic_close_black_24px.svg" ng-click="$ctrl.vm.toggleInvite()"></md-icon></div><div><md-chips ng-model="$ctrl.selectedEmails" md-autocomplete-snap="md-autocomplete-snap" md-transform-chip="$ctrl.transformChip($chip)"><md-autocomplete flex="" md-input-name="CHGOWNER" ng-disabled="$ctrl.isDisabled" md-no-cache="$ctrl.noCache" md-selected-item="$ctrl.owner.newowner" md-search-text-change="$ctrl.searchTextChange($ctrl.searchText)" md-search-text="$ctrl.searchText" md-selected-item-change="$ctrl.selectedItemChange()" md-items="user in $ctrl.querySearch($ctrl.searchText)" md-item-text="user.name" md-min-length="1" placeholder="+ Add Member"><span md-highlight-text="$ctrl.searchText">{{user.name}}</span></md-autocomplete><md-chip-template><span class="item-title"><strong>{{$chip.name}}</strong></span></md-chip-template><md-chip-found ng-if="$ctrl.hasText" No="No" matches="matches" found="found"></md-chip-found></md-chips></div><div><md-input-container class="md-block" flex-gt-sm="flex-gt-sm"><div><md-select multiple="multiple" ng-model="$ctrl.selectedTeams" placeholder="Choose a team"><md-option ng-value="team.name" ng-repeat="team in $ctrl.clTEams">{{ team.name }}</md-option></md-select></div><div style="float:right"><md-button class="md-raised md-primary" ng-click="$ctrl.addMembers()">Invite</md-button></div></md-input-container></div></div></div>');
$templateCache.put('landing.html','<style type="text/css">.landing__plate {\n    display: inline-block;\n    text-align: left;\n    width: 30%;\n    min-width: 350px;\n    margin: 20px 0;\n}\n.landing__plate__image {\n    display: inline-block;\n    cursor: pointer;\n    width: 100%;\n    height: 400px;\n    background-size: cover;\n    box-shadow: 1px 0 9px 2px #00000024;\n    transition: all .3s ease-out;\n}\n.landing__plate__image:hover {\n    box-shadow: 1px 0 12px 4px #00000024;\n    transform: scale(1.04);\n}\n.landing__plate:not(:last-child) {\n    margin-right: 30px;\n}\n.landing__plate--core .landing__plate__image {\n    background-image: url(\'/public/images/dmt-core.png\');\n}\n.landing__plate--metrics .landing__plate__image {\n    background-position: right;\n    background-image: url(\'/public/images/dmt-metrics.png\');\n}\n.landing__plate--claim .landing__plate__image {\n    background-image: url(\'/public/images/dmt-claim.png\');\n}\n.landing__plate__title {\n    font-size: 20px;\n    color: #216ba3;\n    font-weight: bold;\n    margin-bottom: 10px;\n}\n.checkbox__label {\n    font-size: 16px;\n}\n</style><div class="ibm-alternate-background imgLarge" id="ibm-leadspace-head" layout="column" style="background-color:#f7f7f7;"><div class="ibm-padding-top-r2 ibm-padding-bottom-r2" id="ibm-leadspace-body" layout="column" flex="" layout-align="center center"><div class="ibm-columns ibm-alternate-background"><div class="ibm-col-1-1 ibm-col-medium-1-1"><h2 class="ibm-h2 ibm-medium ibm-light ibm-padding-bottom-1" style="color:#212121;"> Please select Preferred program.<div><input type="checkbox" id="select-default" ng-model="vm.shouldSave"/><label class="checkbox__label" for="select-default">I would like to use selected program as default</label></div><p></p><div class="landing__plate-container"><div class="landing__plate landing__plate--metrics" ng-if="vm.isShowMetrics" ng-click="vm.metrics()"><div class="landing__plate__title">Reporting application</div><div class="landing__plate__image"></div></div><div class="landing__plate landing__plate--core landing__plate--selected" ng-if="vm.isShowCore" ng-click="vm.core()"><div class="landing__plate__title">Core application</div><div class="landing__plate__image"></div></div><div class="landing__plate landing__plate--claim" ng-if="vm.isShowClaimForms" ng-click="vm.claim()"><div class="landing__plate__title">Claim forms application</div><div class="landing__plate__image"></div></div></div></h2></div></div></div></div>');
$templateCache.put('noadmin.html','<div class="ibm-background-teal-core ibm-alternate-background imgLarge" id="ibm-leadspace-head" style="background: url(\'/public/images/leadspace-green.jpg\') center / cover no-repeat;" layout="column"><div class="ibm-padding-top-r2 ibm-padding-bottom-r2" id="ibm-leadspace-body" layout="column" flex="" layout-align="center center"><div class="ibm-columns ibm-alternate-background"><div class="ibm-col-1-1 ibm-col-medium-1-1"><h2 class="ibm-h2 ibm-medium ibm-light ibm-padding-bottom-1"> You are not permitted to view the System Administration pages.  &nbsp;Only those with the System Admin role may continue.</h2></div></div></div></div>');
$templateCache.put('noapprover.html','<div class="ibm-background-teal-core ibm-alternate-background imgLarge" id="ibm-leadspace-head" style="background: url(\'/public/images/leadspace-green.jpg\') center / cover no-repeat;" layout="column"><div class="ibm-padding-top-r2 ibm-padding-bottom-r2" id="ibm-leadspace-body" layout="column" flex="" layout-align="center center"><div class="ibm-columns ibm-alternate-background"><div class="ibm-col-1-1 ibm-col-medium-1-1"><h2 class="ibm-h2 ibm-medium ibm-light ibm-padding-bottom-1"> You are not permitted to view the Awaiting Approval pages since your role is not defined as an Approver role.</h2></div></div></div></div>');
$templateCache.put('noprofile.html','<div class="ibm-background-teal-core ibm-alternate-background imgLarge" id="ibm-leadspace-head" style="background: url(\'/public/images/leadspace-green.jpg\') center / cover no-repeat;" layout="column"><div class="ibm-padding-top-r2 ibm-padding-bottom-r2" id="ibm-leadspace-body" layout="column" flex="" layout-align="center center"><div class="ibm-columns ibm-alternate-background"><div class="ibm-col-1-1 ibm-col-medium-1-1"><h2 class="ibm-h2 ibm-medium ibm-light ibm-padding-bottom-1"> Despite appearing to have access to DMT, your User Profile was not found in our system.<p></p> You will not be permitted to continue until the situation is remedied.  &nbsp;Please contact the&nbsp;<b>DMT System Administrators</b>&nbsp; for guidance.</h2></div></div></div></div>');
$templateCache.put('403.html','<div class="ibm-background-teal-core ibm-alternate-background imgLarge" id="ibm-leadspace-head" style="background: url(\'/public/images/error-page1.jpg\') center / cover no-repeat;" layout="column"><div class="ibm-padding-top-r2 ibm-padding-bottom-r2" id="ibm-leadspace-body" layout="column" flex="" layout-align="center center"><div class="ibm-columns ibm-alternate-background"><div class="ibm-col-1-1 ibm-col-medium-1-1"><h2 class="ibm-h2 ibm-medium ibm-light ibm-padding-bottom-1"> Session expired, please log in.<p></p></h2></div></div></div></div>');
$templateCache.put('500.html','<div class="ibm-background-teal-core ibm-alternate-background imgLarge" id="ibm-leadspace-head" style="background: url(\'/public/images/error-page1.jpg\') center / cover no-repeat;" layout="column"><div class="ibm-padding-top-r2 ibm-padding-bottom-r2" id="ibm-leadspace-body" layout="column" flex="" layout-align="center center"><div class="ibm-columns ibm-alternate-background"><div class="ibm-col-1-1 ibm-col-medium-1-1"><h2 class="ibm-h2 ibm-medium ibm-light ibm-padding-bottom-1"> It would appear that you are not authorized to access this application.  Please click Log Out.<p></p><p class="ibm-button-link ibm-btn-row"><a class="ibm-btn-pri ibm-btn-white" href="" ng-click="vm.logOut()">Log Out</a></p><p></p>If you believe this to be incorrect, please contact the DMT System Administrators for guidance.</h2></div></div></div></div>');
$templateCache.put('404.html','<div class="ibm-background-teal-core ibm-alternate-background imgLarge" id="ibm-leadspace-head" style="background: url(\'/public/images/error-page2.jpg\') center / cover no-repeat;"><div class="ibm-padding-top-r2 ibm-padding-bottom-r2" id="ibm-leadspace-body"><div class="ibm-columns ibm-alternate-background"><div class="ibm-col-1-1 ibm-col-medium-1-1" layout="column" flex=""><h2 class="ibm-h2 ibm-medium ibm-light ibm-padding-bottom-1" flex="50">Sorry, but this page cannot be found.<p></p>Please contact the DMT System Administrators for guidance.</h2></div></div></div></div>');
$templateCache.put('assign.html','<div class="ibm-columns"><div class="ibm-col-1-1"><div style="float:right;"><md-icon md-menu-align-target="md-menu-align-target" md-svg-icon="/public/icons/ic_close_black_24px.svg" ng-click="$ctrl.vm.toggleMassAssignment()"></md-icon></div><span class="ibm-textcolor-red-50" style="float:right" ng-if="!$ctrl.vm.isSelected()">Please select at least one Disbursement to Assign</span></div><div class="ibm-col-1-1"><table cellpadding="5" cellspacing="5" border="0" style="padding-left:50px;float:right; margin-top: 10px;"><tr ng-if="!$ctrl.vm.isSubmitting" style="border: 0px;"><td ng-if="!$ctrl.isReassign"><md-button class="dmt-team-btn md-primary md-raised" ng-disabled="!$ctrl.vm.isSelected()" ng-click="$ctrl.vm.assign()" style="border: 0px;"><md-tooltip>Items already assigned will be ignored</md-tooltip><md-icon class="white_icon" md-menu-align-target="md-menu-align-target" md-svg-icon="/public/icons/ic_assignment_turned_in_black_24px.svg"></md-icon><span style="text-transform: none">&nbsp;Assign to Myself&nbsp;</span></md-button></td></tr><tr style="border: 0px;margin-right=150px; padding-top: 5px"><td><type-ahead vm="$ctrl.vm" style="margin-right: 30px;"></type-ahead></td></tr></table></div><div class="ibm-col-1-1"><tr ng-if="$ctrl.vm.isSubmitting"><span class="ibm-h1" ng-if="$ctrl.vm.isSubmitting" style="padding: 5px;"><md-progress-linear md-mode="indeterminate"></md-progress-linear></span></tr></div></div>');
$templateCache.put('excel-export-queue.html','<div class="ibm-columns"><div class="ibm-col-1-1" style="float:right;"><div class="download-container"><md-progress-linear md-mode="query"></md-progress-linear><div class="download-block-notification"><span>Preparing Excel report, please wait...</span></div></div></div></div>');
$templateCache.put('fail-alert.html','<md-dialog aria-label="Confirm Prompt" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>{{::vm.title}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.clickNo()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div><span>{{vm.message}}</span></div><md-button class="md-raised md-primary" ng-click="vm.clickNo()">OK</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('queue-datatable.html','<table class="ibm-data-table ibm-grid ibm-altrows" id="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table>');
$templateCache.put('queue.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div class="ibm-columns"><div class="ibm-col-6-4"><!--| {{vm.settings.up.lastFilter}}--><p class="ibm-h2 ibm-textcolor-blue-40 ibm-bold"> {{ vm.queueLabel }}&nbsp;<md-icon class="light_blue_icon" ng-if="vm.queueHelp" md-svg-icon="/public/images/help-circle.svg" title="{{vm.queueHelp}}"></md-icon></p><p class="ibm-h4 ibm-textcolor-red-50 ibm-bold">IBM Confidential</p></div><div class="ibm-col-6-2"><md-menu style="float: right; overflow-y: hidden" title="Toggle Filters and Queue Options"><md-button class="md-icon-button" aria-label="Open demo menu" ng-click="$mdOpenMenu($event)"><md-tooltip md-direction="top">Menu</md-tooltip><md-icon md-menu-origin="md-menu-origin" md-svg-icon="/public/icons/ic_menu_black_24px.svg"></md-icon></md-button><md-menu-content width="4"><md-menu-item ng-if="vm.$stateParams.id === \'teamqueue\'"><md-button class="dmt-team-btn" ng-show="vm.isTeamQueue" ng-click="vm.getTeamView()"><md-icon md-menu-align-target="md-menu-align-target" md-svg-icon="team"></md-icon><span>My Team</span></md-button></md-menu-item><md-menu-item ng-if="vm.$stateParams.id === \'teamqueue\'"><md-button class="dmt-team-btn" ng-show="vm.isTeamQueue" ng-click="vm.toggleInvite()"><md-icon md-menu-align-target="md-menu-align-target" md-svg-icon="invitation"></md-icon><span>Invite Member</span></md-button></md-menu-item><md-menu-item><md-button class="dmt-team-btn" ng-if="vm.$stateParams.id !== \'setAside\'" ng-click="vm.toggleDownload()"><md-icon md-menu-align-target="md-menu-align-target" md-svg-icon="download"></md-icon><span>Export</span></md-button><md-button class="dmt-team-btn" ng-if="vm.$stateParams.id === \'setAside\'" ng-disabled="vm.waitForReport" ng-click="vm.toggleSetAsideDownload()"><md-icon md-menu-align-target="md-menu-align-target" md-svg-icon="download"></md-icon><span>Export Set Aside</span></md-button></md-menu-item><md-menu-item><md-button class="dmt-team-btn" ng-disabled="!vm.showFilterBtn" ng-click="vm.toggleFilter()" ng-class="{\'md-primary md-raised\' : vm.isFilterSet}"><md-icon md-menu-align-target="md-menu-align-target" md-svg-icon="filter"></md-icon><span>Filter</span></md-button></md-menu-item><md-menu-item ng-if="vm.$stateParams.id !== \'workitems\' &amp;&amp; vm.$stateParams.id !== \'setAside\' &amp;&amp; (vm.env.user.access.bpsoAdmin || vm.env.user.access.nonBpsoAdmin)"><md-button class="dmt-team-btn" ng-click="vm.toggleMassAssignment()"><md-icon md-menu-align-target="md-menu-align-target" md-svg-icon="assignment"></md-icon><span>Mass Assignment</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class="ibm-col-1-1" ng-if="vm.oncePressed"><p>The report will be loaded in .csv form. Once done, open it in a notepad and save it with the .xls extension and UTF-8 encoding</p></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><invite-section vm="vm" ng-if="vm.isInviteToggled"></invite-section><assign-section vm="vm" ng-if="vm.isMassAssignmentToggled"></assign-section><filter-section vm="vm" ng-if="vm.isFilterToggled"></filter-section><downloadq-section vm="vm" ng-if="vm.isDownloading"></downloadq-section></div></div><div class="ibm-columns" ng-if="vm.signalWrongResponse"><div class="ibm-col-2-2" style="float: right; color: red;"><span ng-bind-html="vm.signalWrongResponse"></span></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><div ng-if="[&quot;My Queue&quot;, &quot;Teams\' Queue&quot;].indexOf(vm.queueLabel) &gt; -1"><input type="radio" ng-model="vm.activeInactive_rad" ng-change="vm.applyActiveInactive(\'active\')" ng-value="undefined"/>Active<input style="margin-left:15px" type="radio" ng-model="vm.activeInactive_rad" ng-change="vm.applyActiveInactive(\'inactive\')" ng-value="false"/>Inactive<input style="margin-left:15px" type="radio" ng-model="vm.activeInactive_rad" ng-change="vm.applyActiveInactive(\'all\')" ng-value="true"/>All</div><p></p><div id="content"><table class="ibm-data-table ibm-grid ibm-altrows queue-table" id="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" dt-disable-deep-watchers="true"><thead><tr><th ng-repeat="dtLine in vm.dtColumns" ng-if="dtLine.bVisible!= false"><input class="column-filter" type="text" ng-if="dtLine.searchable === undefined" ng-model="dtLine.columnSearch" ng-change="vm.changemade($index)" placeholder="Search {{dtLine.sTitle}}" data-index="{{$index}}"/></th></tr></thead></table></div></div></div></div></div></div></div></main>');
$templateCache.put('queueSampling.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div class="ibm-columns"><div class="ibm-col-6-4"><!--| {{vm.settings.up.lastFilter}}--><p class="ibm-h2 ibm-textcolor-blue-40 ibm-bold"> {{ vm.queueLabel }}&nbsp;<md-icon class="light_blue_icon" ng-if="vm.queueHelp" md-svg-icon="/public/images/help-circle.svg" title="{{vm.queueHelp}}"></md-icon></p><p class="ibm-h4 ibm-textcolor-red-50 ibm-bold">IBM Confidential</p></div><div class="ibm-col-6-2"><md-menu ng-disabled="!vm.isSubmitting" style="float: right; overflow-y: hidden" title="Toggle Filters and Queue Options"><md-button class="md-icon-button" aria-label="Open demo menu" ng-click="$mdOpenMenu($event)"><md-tooltip md-direction="top">Menu</md-tooltip><md-icon md-menu-origin="md-menu-origin" md-svg-icon="/public/icons/ic_menu_black_24px.svg"></md-icon></md-button><md-menu-content width="4"><md-menu-item><md-button class="dmt-team-btn" ng-class="{\'md-primary md-raised\' : vm.isFilterSet}" ng-click="vm.toggleFilter()" ng-disabled="!vm.isSubmitting"><md-icon md-menu-align-target="md-menu-align-target" md-svg-icon="filter"></md-icon><span>Filter</span></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.downloadSamplingReport()"><md-icon md-menu-align-target="md-menu-align-target" md-svg-icon="download"></md-icon><span style="margin: 5px;">Export</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div class="ibm-columns"><div class="ibm-col-1-1">       <md-progress-linear class="ibm-col-1-1" ng-if="vm.reportIsBuilt" md-mode="indeterminate"><p>Report is being retrieved. Please wait...</p></md-progress-linear><filter-section ng-if="vm.isFilterToggled" vm="vm"></filter-section><div ng-if="!vm.isSubmitting"><md-progress-linear class="ibm-col-1-1" md-mode="indeterminate"><p>Please wait, loading</p></md-progress-linear></div><div ng-if="vm.isSubmitting"><div><input ng-change="vm.applysolDecFilter(\'all\')" ng-model="vm.solDecFilter" ng-value="true" type="radio" style="margin-left:15px"/>All<input ng-change="vm.applysolDecFilter(\'Solution\')" ng-model="vm.solDecFilter" ng-value="undefined" type="radio" style="margin-left:15px"/>Solution<input ng-change="vm.applysolDecFilter(\'SSA\')" ng-model="vm.solDecFilter" ng-value="false" type="radio" style="margin-left:15px"/>SSA</div><p></p><table class="ibm-data-table ibm-grid ibm-altrows" id="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div></div></div></div></div></div></main>');
$templateCache.put('queueSetaside.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div class="ibm-columns"><div class="ibm-col-2-1"><p class="ibm-h2 ibm-textcolor-blue-40 ibm-bold">{{ vm.queueLabel }}</p><p class="ibm-h4 ibm-textcolor-red-50 ibm-bold">IBM Confidential</p></div></div><div class="ibm-columns" ng-if="vm.signalWrongResponse"><div class="ibm-col-2-2" style="float: right; color: red;"><span ng-bind-html="vm.signalWrongResponse"></span></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><md-button class="dmt-team-btn" ng-disabled="vm.waitForReport" ng-click="vm.toggleDownload()"><md-icon md-menu-align-target="md-menu-align-target" md-svg-icon="download"></md-icon><span>Export</span></md-button><span ng-if="vm.oncePressed"><br/><br/><p>The report will be loaded in .txt form. Once done, open it in a notepad and save it with the .xls extension and UTF-8 encoding</p></span></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><div id="content"><table class="ibm-data-table ibm-grid ibm-altrows" id="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div></div></div></div></div></div></main>');
$templateCache.put('queueerror.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div class="ibm-columns"><div class="ibm-col-2-1"><p class="ibm-h2 ibm-textcolor-blue-40 ibm-bold">{{ vm.queueLabel }}</p><p class="ibm-h4 ibm-textcolor-red-50 ibm-bold">IBM Confidential</p></div></div><div class="ibm-columns" ng-if="vm.signalWrongResponse"><div class="ibm-col-2-2" style="float: right; color: red;"><span ng-bind-html="vm.signalWrongResponse"></span></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><div id="content"><table class="ibm-data-table ibm-grid ibm-altrows" id="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div></div></div></div></div></div></main>');
$templateCache.put('sap-missing-oppty-edit.html','<md-dialog aria-label="Change oppty number" ng-cloak=""><md-dialog-content><span align="center"><md-content class="md-padding"><p>Change the oppty {{vm.oldOpp}} to:</p><input ng-model="vm.newOppty"/></md-content></span><span align="center"><md-button class="md-raised md-primary" ng-disabled="vm.newOppty.trim() ===\'\'" ng-click="vm.changeOppty()">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button></span></md-dialog-content></md-dialog>');
$templateCache.put('sap-missing-remove-btn.html','<md-dialog aria-label="Change oppty number" ng-cloak=""><md-dialog-content><span align="center"><md-content class="md-padding"><p>Reason for removing:</p><input ng-model="vm.action"/></md-content></span><span align="center"><md-button class="md-raised md-primary" ng-disabled="!vm.action" ng-click="vm.removeBtn()">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button></span></md-dialog-content></md-dialog>');
$templateCache.put('sap-missing.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div class="ibm-columns"><div class="ibm-col-6-4"><!--| {{vm.settings.up.lastFilter}}--><p class="ibm-h2 ibm-textcolor-blue-40 ibm-bold"> {{ vm.queueLabel }}&nbsp;</p><p class="ibm-h4 ibm-textcolor-red-50 ibm-bold">IBM Confidential</p></div><div class="ibm-col-6-2"><md-menu style="float: right; overflow-y: hidden" title="Toggle Filters and Queue Options"><md-button class="md-icon-button" aria-label="Open demo menu" ng-click="$mdOpenMenu($event)"><md-tooltip md-direction="top">Menu</md-tooltip><md-icon md-menu-origin="md-menu-origin" md-svg-icon="/public/icons/ic_menu_black_24px.svg"></md-icon></md-button><md-menu-content width="4"><md-menu-item><md-button class="dmt-team-btn" ng-if="vm.$stateParams.id !== \'setAside\'" ng-click="vm.toggleDownload()"><md-icon md-menu-align-target="md-menu-align-target" md-svg-icon="download"></md-icon><span>Export</span></md-button></md-menu-item><md-menu-item><md-button class="dmt-team-btn" ng-disabled="!vm.showFilterBtn" ng-click="vm.toggleFilter()" ng-class="{\'md-primary md-raised\' : vm.isFilterSet}"><md-icon md-menu-align-target="md-menu-align-target" md-svg-icon="filter"></md-icon><span>Filter</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class="ibm-col-1-1" ng-if="vm.oncePressed"><p>The report will be loaded in .csv form. Once done, open it in a notepad and save it with the .xls extension and UTF-8 encoding</p></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><filter-section vm="vm" ng-if="vm.isFilterToggled"></filter-section><downloadq-section vm="vm" ng-if="vm.isDownloading"></downloadq-section></div></div><div class="ibm-columns" ng-if="vm.signalWrongResponse"><div class="ibm-col-2-2" style="float: right; color: red;"><span ng-bind-html="vm.signalWrongResponse"></span></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><div><div><input type="radio" default="default" ng-model="$ctrl.vm.filterTriggered" ng-change="vm.toggleFilterTriggered(\'active\')" ng-value="undefined"/>Active<input style="margin-left:15px" type="radio" ng-model="$ctrl.vm.filterTriggered" ng-change="vm.toggleFilterTriggered(\'inactive\')" ng-value="false"/>Inactive<input style="margin-left:15px" type="radio" ng-model="$ctrl.vm.filterTriggered" ng-change="vm.toggleFilterTriggered(\'all\')" ng-value="true"/>All</div><p></p><table class="ibm-data-table ibm-grid ibm-altrows" id="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div></div></div></div></div></div></main>');
$templateCache.put('setAside-details.html','<md-dialog aria-label="Details" ng-cloak="ng-cloak"><md-toolbar><div class="md-toolbar-tools"><h2>Deatils for {{vm.item.doc.ceid}}:</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><table class="ibm-data-table ibm-grid ibm-altrows" ibm-altcols="ibm-altcols"><thead><tr><th>ID</th><th>Sales Order</th><th>BP Name</th><th>Customer Name</th><th>Bonus Amount</th><th>Payment Date / Frequency</th><th>Invoice Requested</th><th>Invoice Received</th></tr></thead><tbody><tr ng-repeat="doc in vm.item.doc.docs track by $index"><td> <span ng-click="vm.select($index)">{{doc.id}}</span></td><td>{{::doc.so}}</td><td>{{::vm.item.doc.bpName}}</td><td>{{::doc.customerName}}</td><td>{{::doc.bonusAmount}} {{::vm.item.doc.currency}}</td><td>{{ (doc.paymentDate | date : YYYY-MM-DD) + \' / \' + (doc.payfreq ? doc.payfreq : \'Unknown\')}}</td><!--(doc.paymentDate | date : YYYY-MM-DD) + \' / \' + (doc.payfreq ? doc.payfreq : \'Unknown\')}}--><td>{{::doc.invoice_flags.requested?(doc.invoice_flags.requestedTimestamp?(doc.invoice_flags.requestedTimestamp|date:vm.settings.up.preferences.dateFormat : \'UTC\'):\'Yes\'):\'No\'}}</td><td>{{::doc.invoice_flags.received?(doc.invoice_flags.receivedTimestamp?(doc.invoice_flags.receivedTimestamp|date:vm.settings.up.preferences.dateFormat : \'UTC\'):\'Yes\'):\'No\'}}</td></tr></tbody></table><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="vm.processing">OK</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('setAside-documents_select.html','<!--author Ivan Toth--><md-dialog aria-label="Request" ng-cloak="ng-cloak"><md-toolbar><div class="md-toolbar-tools"><h2>Select documents to mark as paid:</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div ng-repeat="doc in vm.docs"><md-checkbox ng-model="doc.value" flex="flex">{{doc.doc}}</md-checkbox></div><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="vm.processing">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()" ng-disabled="vm.processing">Cancel</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('typeahead.html','<div layout="row"><md-autocomplete class="pd-t-0" flex="" md-input-name="CHGOWNER" ng-disabled="$ctrl.isDisabled" md-no-cache="$ctrl.noCache" md-selected-item="$ctrl.owner.newowner" md-search-text-change="$ctrl.searchTextChange($ctrl.searchText)" md-search-text="$ctrl.searchText" md-selected-item-change="$ctrl.selectedItemChange()" md-items="user in $ctrl.querySearchByCountry($ctrl.searchText)" md-item-text="user.name" md-min-length="1" placeholder="Pick a Member"><md-item-template><span class="item-title"><span> {{user.name}}</span></span></md-item-template><md-not-found ng-if="$ctrl.hasText" No="No" matches="matches" found="found"></md-not-found></md-autocomplete><md-button class="md-primary md-raised" ng-if="!$ctrl.fired" aria-label="Change Owner" style="border: 0px; margin: 0px;" ng-click="$ctrl.changeOwner($ctrl.owner.newowner)" ng-disabled="!$ctrl.owner.newowner || !$ctrl.isEnabled()"><md-tooltip>Items already assigned will be ignored</md-tooltip><md-icon class="white_icon" md-menu-align-target="md-menu-align-target" md-svg-icon="/public/icons/ic_assignment_turned_in_black_24px.svg"></md-icon><span style="text-transform: none">&nbsp;{{$ctrl.btnLabel}}</span></md-button><span style="margin-left: 5px" ng-if="$ctrl.fired"><span class="ibm-spinner"></span><span style="margin-left: 5px;color: gray">Please wait</span></span></div>');
$templateCache.put('excel-export.html','<div class="ibm-columns" ng-if="$ctrl.isDownloading"><div class="ibm-col-1-1" style="margin: 15px;"><div class="download-container"><md-progress-linear md-mode="query"></md-progress-linear><div class="download-block-notification"><span>Preparing Excel report, please wait...</span></div></div></div></div>');
$templateCache.put('report-backlog.html','<div class="ibm-columns" id="generalInfo"><span class="ibm-h4" ng-click="$ctrl.toggle()"><md-icon md-svg-src="/public/images/ic_view_agenda_black_24px.svg"></md-icon><md-icon ng-hide="$ctrl.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp; Backlog Report</span></span><div ng-if="$ctrl.visible"><br/><b>***IMPORTANT***</b><br/><p>The report will be loaded in .xlsx format and UTF-8 encoding</p><md-button class="md-raised md-primary" ng-disabled="$ctrl.reportIsLoading" ng-click="$ctrl.getReport()">Download</md-button><p ng-if="$ctrl.reportIsLoading">Report is being prepared. This may take several minutes...</p></div></div>');
$templateCache.put('report-bplm.html','<!-- author Matthew Rogers--><div class="ibm-columns" id="generalInfo"><span class="ibm-h4" ng-click="$ctrl.toggle()"><md-icon md-svg-src="/public/images/ic_view_agenda_black_24px.svg"></md-icon><md-icon ng-hide="$ctrl.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;BPLM Report</span></span></div><div class="ibm-columns" ng-if="$ctrl.visible"><div class="ibm-col-1-1" ng-if="$ctrl.visible &amp;&amp; $ctrl.details.fired &amp;&amp; !$ctrl.err.error"><p></p><md-progress-linear md-mode="indeterminate"></md-progress-linear></div><div class="ibm-col-1-1" ng-if="$ctrl.err.error"><p></p><span class="ibm-textcolor-red-50" ng-if="$ctrl.excel.err">There was a problem attempting to download the BPLM Report:           <b>{{$ctrl.err.message}}</b>. &nbsp;Please try again or contact the DMT System Administrators for guidance if the issue persists.<p></p></span><span class="ibm-textcolor-red-50" ng-if="$ctrl.details.err">There was a problem attempting to collect the BPLM Report details:           <b>{{$ctrl.err.message}}</b>. &nbsp;Please click the button below to retry or contact the DMT System Administrators for guidance if the issue persists.<p></p><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" ng-disabled="$ctrl.details.fired" ng-click="$ctrl.getBPLMDetails()"><md-icon class="white_icon" ng-if="!$ctrl.details.fired" md-svg-icon="download"></md-icon><md-icon class="ibm-spinner" ng-if="$ctrl.details.fired" style="border: 2px solid white; min-height: 12px; min-width: 12px;"></md-icon><span style="text-transform: none; padding-left: 5px; padding-right: 2px;">{{$ctrl.details.fired ? \'Please wait...\' : \'Retry\'}}     </span></md-button></span></div><div class="ibm-col-1-1" ng-if="$ctrl.details.loaded"><p></p><span>The BPLM Report is a snapshot of DMT that runs weekly. &nbsp;The latest report can be found below. &nbsp;Click the link to download.</span><p></p><!--table(class="ibm-data-table ibm-altrows ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1")            --><table class="ibm-data-table table" cellspacing="0" cellpadding="0" border="1">           <thead><tr><td class="ibm-textcolor-blue-50" style="width: 30%">Latest Report</td><td class="ibm-textcolor-blue-50" style="width: 10%">Last Run</td><td class="ibm-textcolor-blue-50" style="width: 70%">Report Creation Log</td><!--td(style="width: 20%").ibm-textcolor-blue-50 User Download Log--></tr></thead><tBody><tr><td><span ng-if="!$ctrl.excel.fired"><b><a class="link" style="color: #5596e6" ng-click="$ctrl.getReport()" title="Download the latest report">{{$ctrl.data.fileName}}</a></b><span class="ibm-textcolor-gray-30">&nbsp;&nbsp;({{$ctrl.fileSize}})</span></span><span class="ibm-textcolor-blue-60" ng-if="$ctrl.excel.fired">Please wait...&nbsp;&nbsp;</span><md-icon class="ibm-spinner" ng-if="$ctrl.excel.fired" style="border: 2px solid white; min-height: 12px; min-width: 12px;"></md-icon></td><td><span>{{$ctrl.data.lastrun_date | date:$ctrl.settings.up.preferences.dateFormat}}</span></td><td><a style="color: #5596e6" ng-click="$ctrl.viewLog = !$ctrl.viewLog">Click to {{$ctrl.viewLog ? \'hide\' : \'view\'}}</a><div ng-if="$ctrl.viewLog"><span ng-repeat="log in $ctrl.logs"><p></p><span ng-class="{\'ibm-textcolor-red-50\': log.indexOf(\'ERROR:\') &gt; -1, \'ibm-textcolor-green-50\': log.indexOf(\'INFO:\') &gt; -1}" style="font-size: 12px">{{::log}}</span></span></div></td></tr></tBody></table><p></p><b class="ibm-textcolor-green-40" ng-if="$ctrl.excel.downloaded">Report successfully downloaded</b></div></div>');
$templateCache.put('report-complianceplan.html','<div class="ibm-columns" id="generalInfo"><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_view_agenda_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;Compliance Plan report</span></span></div><div class="ibm-columns" ng-if="vm.visible"><div class="ibm-col-1-1" ng-if="vm.visible &amp;&amp; !vm.err.error &amp;&amp; !vm.excel.loaded"><p></p><md-progress-linear md-mode="indeterminate"></md-progress-linear></div><div class="ibm-col-1-1" ng-if="vm.err.error"><p></p><span class="ibm-textcolor-red-50" ng-if="vm.err.error">There was a problem attempting to download the report Compliance Plan:<b>{{vm.err.message}}</b>. &nbsp;Please try again or contact the DMT System Administrators for guidance if the issue persists.<p></p></span></div><div class="ibm-col-1-1" ng-if="vm.excel.loaded"><p></p><span>This is a NPS List.&nbsp;</span><p></p><span ng-if="!vm.err.error" cellspacing="0" cellpadding="0" border="1" style="text-align: center"><span><b><a class="link" ng-click="vm.downloadExcelSpreadsheet()" title="Download the latest report" style="color: #5596e6">{{vm.file.fileName}}</a></b><span class="ibm-textcolor-gray-30">&nbsp;&nbsp;({{vm.file.fileSize}})</span></span><span class="ibm-textcolor-blue-60" ng-if="vm.exportFired">Please wait...&nbsp;&nbsp;</span><md-icon class="ibm-spinner" ng-if="vm.exportFired" style="border: 2px solid white; min-height: 12px; min-width: 12px;"></md-icon></span><p></p><b class="ibm-textcolor-green-40" ng-if="vm.excel.downloaded">List successfully downloaded</b></div></div>');
$templateCache.put('report-custom-datatable.html','<div ng-if="$ctrl.showTable"><table class="ibm-data-table ibm-grid ibm-altrows" id="table" datatable="" dt-options="$ctrl.dtOptions" dt-columns="$ctrl.dtColumns" dt-instance="$ctrl.dtInstance"></table></div>');
$templateCache.put('report-custom-filter.html','<div class="checkbox_container" ng-if="$ctrl.isCustomReady &amp;&amp; $ctrl.filtersExist"><input type="radio" value="OPP" name="repType" id="1" ng-model="$ctrl.repType" ng-change="$ctrl.repTypeChange()"/><label for="1">Oppty</label><input type="radio" value="ROWID" name="repType" id="2" ng-model="$ctrl.repType" ng-change="$ctrl.repTypeChange()"/><label for="2">Row ID</label><span style="display: inline-flex; float: right; margin-top: -5px"><md-button class="dmt-team-btn" ng-click="$ctrl.clearFilter()" title="Wipe all filter settings"><md-icon md-svg-icon="clearAll"></md-icon><span>Clear All</span></md-button></span><p></p><label for="o">Original<input type="radio" value="original" name="filterType" id="o" ng-model="$ctrl.filterType"/></label><label for="n">Current<input type="radio" value="current" name="filterType" id="n" ng-model="$ctrl.filterType"/></label><p></p><div class="checkbox_subcontainer" style="margin-top: 20px"><span style="border-bottom: 1px solid lightgray;"><b class="ibm-textcolor-blue-40 ibm-h4">Current Filters</b><span style="padding-left: 1em">Select the relevant filters and click&nbsp;<b>Apply</b>.</span></span><md-switch class="md-primary" title="Toggle between Disbursements that have VAP Government and those that don\'t" ng-if="$ctrl.filterToggles.vap" aria-label="vap g only" ng-model="$ctrl.vapFilter">Only display Disbursements&nbsp;<b>{{$ctrl.vapFilter ? "with" : "without"}}</b>&nbsp;VAP-G</md-switch><div class="ibm-columns"><div class="ibm-col-3-1" style="width: 18em"><md-select class="ibm_select" ng-if="$ctrl.filterToggles.countries" multiple="multiple" ng-model="$ctrl.filterIots" ng-change="$ctrl.changeFilters(\'iot\')" placeholder="Pick an IOT"><md-option ng-value="iot" ng-repeat="iot in $ctrl.filters.iots">{{ iot }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.dmtStats" multiple="multiple" ng-model="$ctrl.filterStatuses" placeholder="Pick a DMT Main Status"><md-option ng-value="status" ng-repeat="status in $ctrl.filters.statuses">{{ status }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.teams" multiple="multiple" ng-model="$ctrl.filterTeams" placeholder="Pick a Team"><md-option ng-value="team" ng-repeat="team in $ctrl.filters.teams">{{ team }}</md-option></md-select></div><div class="ibm-col-3-2" style="width: 18em"><md-select class="ibm_select" ng-if="$ctrl.filterToggles.countries" multiple="multiple" ng-model="$ctrl.filterImts" ng-change="$ctrl.changeFilters(\'imt\')" placeholder="Pick an IMT"><md-option ng-value="imt" ng-repeat="imt in $ctrl.filters.imts">{{ imt }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.dmtSubStats" multiple="multiple" ng-model="$ctrl.filterSubStatuses" placeholder="Pick a DMT Sub-Status"><md-option ng-value="subStatus" ng-repeat="subStatus in $ctrl.filters.subStatuses">{{ subStatus }}</md-option></md-select></div><div class="ibm-col-3-3"><md-select class="ibm_select" ng-if="$ctrl.filterToggles.countries" multiple="multiple" ng-model="$ctrl.filterCountries" placeholder="Pick a country"><md-option ng-value="country" ng-repeat="country in $ctrl.filters.countries">{{ country }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.sviStats" multiple="multiple" ng-model="$ctrl.filterSviStatuses" placeholder="Pick a MySA Status"><md-option ng-value="sviStatus" ng-repeat="sviStatus in $ctrl.filters.sviStatuses | orderBy: sviStatus">{{ sviStatus }}</md-option></md-select></div><div class="ibm-col-3-1"><label>CVR submit From</label><md-datepicker ng-model="$ctrl.sviFromDate"></md-datepicker><label>CVR submit To</label><md-datepicker ng-model="$ctrl.sviToDate"></md-datepicker></div></div></div><div class="checkbox_subcontainer" style="margin-top: 5px"><span style="border-bottom: 1px solid lightgray;"><b class="ibm-textcolor-blue-40 ibm-h4">Saved Filters</b><span style="padding-left: 1em">Select a saved filter to load and click&nbsp;<b>Apply</b>. &nbsp;Click&nbsp;<b>Manage</b>&nbsp;to save/delete filters.</span></span><div class="ibm-columns" style="margin-top: 10px"><div class="ibm-col-2-1"><md-select class="ibm_select" style="margin-top: 10px" ng-model="$ctrl.currFilter" placeholder="Select a Saved Filter to load" ng-change="$ctrl.changeSavedFilter($ctrl.currFilter)"><md-option ng-value="{{filter}}" ng-repeat="filter in $ctrl.userFilters track by $index" ng-selected="filter.name === \'Default\'">{{ filter.name }}</md-option></md-select></div><div class="ibm-col-2-2"><md-button class="md-raised md-primary" ng-click="$ctrl.viewProfiles($event)" title="Save">Manage</md-button></div></div></div><div class="checkbox_subcontainer" style="margin-top: 5px"><span style="border-bottom: 1px solid lightgray;"><md-button class="dmt-team-btn dmt-team-btn-run" ng-disabled="!$ctrl.showFilterBtn || ($ctrl.colQty &gt; 20)" ng-click="$ctrl.generateReport(&quot;show&quot;)" ng-class="{\'md-primary md-raised\' : $ctrl.isFilterSet}" title="Apply the current filter settings"><md-tooltip ng-if="$ctrl.isFilterSet" md-direction="bottom">Filters are active</md-tooltip><md-icon md-svg-icon="/public/icons/ic_autorenew_black_24px.svg"></md-icon><span>Preview</span></md-button><md-button class="md-raised md-primary" ng-disabled="$ctrl.reportIsLoading || ($ctrl.colQty &gt; 20)" ng-click="$ctrl.generateReport(&quot;save&quot;)" title="Save">Run</md-button></span><p ng-if="($ctrl.colQty &gt; 20)"><font color="red">{{$ctrl.colQty}} out of 20 columns chosen</font></p><p ng-if="($ctrl.colQty &lt;= 20)">{{$ctrl.colQty}} out of 20 columns chosen</p></div></div><p ng-if="$ctrl.reportIsLoading">Report is being prepared. This may take several minutes...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></p><p ng-if="$ctrl.overLimit">Report is over 100 000 entries, please refine your search.</p><p ng-if="$ctrl.isRowIdpresent">DB2 Row ID dependent values selected. Row ID will be added to the config.</p><p></p><!--    div(class="checkbox_subcontainer" style="margin-top: 20px")md-contact-chips(\n    ng-model="$ctrl.asyncColumns"\n    md-contacts="$ctrl.delayedQuerySearch($query)"\n    ng-click="$ctrl.addColumns()"\n    md-contact-image="image"\n    md-contact-name="title"\n    md-require-match="true"\n    md-highlight-flags="i"\n    filter-selected="$ctrl.filterSelected"\n    placeholder="Add columns dynamically")--><!--)-->');
$templateCache.put('report-custom-profiles.html','<md-dialog class="customDialog" aria-label="Filter Profiles"><md-toolbar><div class="md-toolbar-tools"><h2>Filter Profiles</h2><span flex="flex"></span></div></md-toolbar><md-dialog-content><md-content class="md-no-momentum" style="margin: 15px;padding: 15px;"><span>Enter a Filter Name and click&nbsp;<b>Add</b>&nbsp;to save the current filter settings.</span><p></p><md-input-container class="md-icon-float md-block"><label>Filter Name</label><md-icon class="name" md-svg-src="public/icons/ic_person_add_black_24px.svg"></md-icon><input ng-model="$ctrl.newSearch" type="text"/><md-button class="md-raised md-primary" style="float: right; margin: 0px; padding: 0px; margin-top: 10px;" ng-click="$ctrl.saveFilter()">Add</md-button></md-input-container></md-content><md-list flex="flex"><md-subheader class="md-no-sticky">Current Saved Profiles</md-subheader><md-list-item class="noright" ng-repeat="filter in $ctrl.userFilters track by $index"><div class="md-list-tem-text" layout="column"><p>{{ filter.name }}</p><md-button class="md-secondary md-icon-button" title="Delete this Saved Filter" ng-disabled="$ctrl.allowed" ng-click="$ctrl.deleteProfile(filter.name)"><md-icon class="red_icon" md-svg-src="public/icons/ic_remove_circle_black_24px.svg"></md-icon></md-button></div></md-list-item></md-list></md-dialog-content></md-dialog>');
$templateCache.put('report-filter.html','<div class="checkbox_container" ng-if="$ctrl.isFilterToggled"><span style="display: inline-flex; float: right; margin-top: -5px"><md-button class="dmt-team-btn dmt-team-btn" ng-click="$ctrl.loadReport()" ng-class="{\'md-primary md-raised\' : $ctrl.isFilterSet}" title="Apply the current filter settings"><md-icon md-svg-icon="filter"></md-icon><span>Apply</span></md-button><md-button class="dmt-team-btn" ng-click="$ctrl.clearFilter()" title="Wipe all filter settings"><md-icon md-svg-icon="clearAll"></md-icon><span>Clear All</span></md-button><md-icon style="padding-left: 5px;" md-menu-align-target="md-menu-align-target" md-svg-icon="/public/icons/ic_close_black_24px.svg" ng-click="$ctrl.closeFilter()"></md-icon></span><p></p><div class="checkbox_subcontainer" style="margin-top: 20px"><span style="border-bottom: 1px solid lightgray;"><b class="ibm-textcolor-blue-40 ibm-h4">Current Filters</b><span style="padding-left: 1em">Select the relevant filters and click&nbsp;<b>Apply</b>.</span></span><p></p><div><input type="radio" ng-model="$ctrl.vapFilter"/>All<input style="margin-left:15px" type="radio" ng-model="$ctrl.vapFilter" ng-value="true"/>VAP-G Only<input style="margin-left:15px" type="radio" ng-model="$ctrl.vapFilter" ng-value="false"/>No VAP-G<span class="red_text" style="margin-left: 1em" ng-if="$ctrl.vapFilter &amp;&amp; $ctrl.settings.up.swdr_permissions.iot.indexOf(\'North America IOT\') &gt; -1">NOTE: You do not have access to view North American VAP-G Disbursements</span></div><p></p><!--md-switch(title="Toggle between Disbursements that have VAP Government and those that don\'t" ng-if="$ctrl.enableVAPFilter" class="md-primary" aria-label="vap g only" ng-model="$ctrl.vapFilter")| Only display Disbursements&nbsp;\nb {{$ctrl.vapFilter ? "with" : "without"}}\n| &nbsp;VAP-G--><div class="ibm-columns"><div class="ibm-col-3-1" style="width: 18em"><md-select class="ibm_select" ng-if="$ctrl.filterToggles.countries" multiple="multiple" ng-model="$ctrl.filterIots" ng-change="$ctrl.changeFilters(\'iot\')" placeholder="Pick an IOT"><md-option ng-value="iot" ng-repeat="iot in $ctrl.filters.iots">{{ iot }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.dmtStats" multiple="multiple" ng-model="$ctrl.filterStatuses" placeholder="Pick a DMT Main Status"><md-option ng-value="status" ng-repeat="status in $ctrl.filters.statuses">{{ status }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.teams" multiple="multiple" ng-model="$ctrl.filterTeams" placeholder="Pick a Team"><md-option ng-value="team" ng-repeat="team in $ctrl.filters.teams">{{ team }}</md-option></md-select></div><div class="ibm-col-3-2" style="width: 18em"><md-select class="ibm_select" ng-if="$ctrl.filterToggles.countries" multiple="multiple" ng-model="$ctrl.filterImts" ng-change="$ctrl.changeFilters(\'imt\')" placeholder="Pick an IMT"><md-option ng-value="imt" ng-repeat="imt in $ctrl.filters.imts">{{ imt }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.dmtSubStats" multiple="multiple" ng-model="$ctrl.filterSubStatuses" placeholder="Pick a DMT Sub-Status"><md-option ng-value="subStatus" ng-repeat="subStatus in $ctrl.filters.subStatuses | orderBy:subStatus">{{ subStatus }}</md-option></md-select></div><div class="ibm-col-3-3"><md-select class="ibm_select" ng-if="$ctrl.filterToggles.countries" multiple="multiple" ng-model="$ctrl.filterCountries" ng-change="$ctrl.changeFilters(\'cty\')" placeholder="Pick a country"><md-option ng-value="country" ng-repeat="country in $ctrl.filters.countries">{{ country }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.sviStats" multiple="multiple" ng-model="$ctrl.filterSviStatuses" placeholder="Pick a MySA Status"><md-option ng-value="sviStatus" ng-repeat="sviStatus in $ctrl.filters.sviStatuses | orderBy: sviStatus">{{ sviStatus }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.sampStat" multiple="multiple" ng-model="$ctrl.filterSamplingStatus" ng-change="$ctrl.changeFilters(\'STAT\')" placeholder="Pick a Status"><md-option ng-value="samplingStatus" ng-repeat="samplingStatus in $ctrl.filters.samplingStatus">{{ samplingStatus }}</md-option></md-select></div></div></div><div class="checkbox_subcontainer" style="margin-top: 5px"><span style="border-bottom: 1px solid lightgray;"><b class="ibm-textcolor-blue-40 ibm-h4">Saved Filters</b><span style="padding-left: 1em">Select a saved filter to load and click&nbsp;<b>Apply</b>. &nbsp;Click&nbsp;<b>Manage</b>&nbsp;to save/delete filters.</span></span><div class="ibm-columns" style="margin-top: 10px"><div class="ibm-col-2-1"><md-select class="ibm_select" style="margin-top: 10px" ng-model="$ctrl.currFilter" placeholder="Select a Saved Filter to load" ng-change="$ctrl.changeSavedFilter($ctrl.currFilter)"><md-option ng-value="{{filter}}" ng-repeat="filter in $ctrl.userFilters track by $index" ng-selected="filter.name === \'Default\'">{{ filter.name }}</md-option></md-select></div><div class="ibm-col-2-2"><md-button class="md-raised md-primary" ng-click="$ctrl.viewProfiles($event)" title="Manage New/Saved Profiles">Manage</md-button></div></div></div></div><p></p>');
$templateCache.put('report-finance.html','<div class="ibm-columns" id="generalInfo"><span class="ibm-h4" ng-click="$ctrl.toggle()"><md-icon md-svg-src="/public/images/ic_view_agenda_black_24px.svg"></md-icon><md-icon ng-hide="$ctrl.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp; Finance Reports</span></span><div ng-if="$ctrl.visible"><br/><b>***IMPORTANT***</b><br/><p>The report will be loaded in .xlsx format and UTF-8 encoding</p><md-button class="md-raised md-primary" ng-disabled="$ctrl.reportIsLoading" ng-click="$ctrl.getReport()">Download</md-button><p ng-if="$ctrl.reportIsLoading">Report is being prepared. This may take several minutes...</p></div></div>');
$templateCache.put('report-general.html','<div class="ibm-columns" id="generalInfo"><span class="ibm-h4" ng-click="$ctrl.vm.toggle()"><md-icon md-svg-src="/public/images/ic_view_agenda_black_24px.svg"></md-icon><md-icon ng-hide="$ctrl.vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;General Report</span></span><div ng-if="$ctrl.vm.visible"><span ng-if="!$ctrl.vm.settings.up.swdr_permissions.general_report"><span class="ibm-textcolor-red-40">You are not authorised to run the General Report. &nbsp;If you need access, please contact the DMT System Administrators</span></span><div ng-if="$ctrl.vm.settings.up.swdr_permissions.general_report"><div ng-if="$ctrl.vm.reportIsBuilt"><md-button ng-click="$ctrl.vm.downloadReport($ctrl.vm.results._data)"><md-icon md-menu-align-target="md-menu-align-target" md-svg-icon="download"></md-icon><span style="margin: 5px;">Export</span></md-button><md-content flex="flex" layout-padding="layout-padding"><table class="ibm-data-table ibm-grid"><thead><tr><th ng-repeat="item in $ctrl.vm.imtHeaders"><b>{{ item }}</b></th></tr></thead><tbody><tr ng-repeat="line in $ctrl.vm.results._data"><td style="font-weight: bold;">{{line[0]}}</td><td ng-repeat="entry in line[1]"><div>{{entry}}</div></td></tr></tbody></table></md-content></div><br/><md-progress-linear class="ibm-col-1-1" md-mode="indeterminate" ng-if="!$ctrl.vm.reportIsBuilt"><p>Report is being retrieved. Please wait...</p></md-progress-linear></div></div></div>');
$templateCache.put('report-newclients.html','<!-- author Ilya Aderiho--><div class="ibm-columns" id="generalInfo"><span class="ibm-h4" ng-click="$ctrl.toggle()"><md-icon md-svg-src="/public/images/ic_view_agenda_black_24px.svg"></md-icon><md-icon ng-hide="$ctrl.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp; New Approved Clients Reports</span></span></div><div class="ibm-columns" ng-if="$ctrl.visible"><div class="ibm-col-1-1" ng-if="$ctrl.visible &amp;&amp; !$ctrl.err.error &amp;&amp; !$ctrl.excel.loaded"><p></p><md-progress-linear md-mode="indeterminate"></md-progress-linear></div><div class="ibm-col-1-1" ng-if="$ctrl.err.error"><p></p><span class="ibm-textcolor-red-50" ng-if="$ctrl.err.error">There was a problem attempting to download the New approved clients Report:           <b>{{$ctrl.err.message}}</b>. &nbsp;Please try again or contact the DMT System Administrators for guidance if the issue persists.<p></p></span></div><div class="ibm-col-1-1" ng-if="$ctrl.excel.loaded"><p></p><span>This is a New Approved Clients List.&nbsp;</span><p></p><span ng-if="!$ctrl.err.error" cellspacing="0" cellpadding="0" border="1" style="text-align: center">           <span><b><a class="link" ng-click="$ctrl.downloadExcelSpreadsheet()" style="color: #5596e6" title="Download the latest report">{{$ctrl.file.fileName}}</a></b><span class="ibm-textcolor-gray-30">&nbsp;&nbsp;({{$ctrl.file.fileSize}})</span></span><span class="ibm-textcolor-blue-60" ng-if="$ctrl.exportFired">Please wait...&nbsp;&nbsp;</span><md-icon class="ibm-spinner" ng-if="$ctrl.exportFired" style="border: 2px solid white; min-height: 12px; min-width: 12px;"></md-icon></span><p></p><b class="ibm-textcolor-green-40" ng-if="$ctrl.excel.downloaded">List successfully downloaded</b></div></div>');
$templateCache.put('report-nps.html','<!-- author Vlad Sirotkin--><div class="ibm-columns" id="generalInfo"><span class="ibm-h4" ng-click="$ctrl.toggle()"><md-icon md-svg-src="/public/images/ic_view_agenda_black_24px.svg"></md-icon><md-icon ng-hide="$ctrl.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp; NPS Report</span></span></div><div class="ibm-columns" ng-if="$ctrl.visible"><div class="ibm-col-1-1" ng-if="$ctrl.visible &amp;&amp; !$ctrl.err.error &amp;&amp; !$ctrl.excel.loaded"><p></p><md-progress-linear md-mode="indeterminate"></md-progress-linear></div><div class="ibm-col-1-1" ng-if="$ctrl.err.error"><p></p><span class="ibm-textcolor-red-50" ng-if="$ctrl.err.error">There was a problem attempting to download the NPS Report:<b>{{$ctrl.err.message}}</b>. &nbsp;Please try again or contact the DMT System Administrators for guidance if the issue persists.<p></p></span></div><div class="ibm-col-1-1" ng-if="$ctrl.excel.loaded"><p></p><span>This is a NPS List.&nbsp;</span><p></p><span ng-if="!$ctrl.err.error" cellspacing="0" cellpadding="0" border="1" style="text-align: center"><span><b><a class="link" ng-click="$ctrl.downloadExcelSpreadsheet()" style="color: #5596e6" title="Download the latest report">{{$ctrl.file.fileName}}</a></b><span class="ibm-textcolor-gray-30">&nbsp;&nbsp;({{$ctrl.file.fileSize}})</span></span><span class="ibm-textcolor-blue-60" ng-if="$ctrl.exportFired">Please wait...&nbsp;&nbsp;</span><md-icon class="ibm-spinner" ng-if="$ctrl.exportFired" style="border: 2px solid white; min-height: 12px; min-width: 12px;"></md-icon></span><p></p><b class="ibm-textcolor-green-40" ng-if="$ctrl.excel.downloaded">List successfully downloaded</b></div></div>');
$templateCache.put('report-pivot.html','<div class="ibm-columns" id="generalInfo"><span class="ibm-h4" ng-click="$ctrl.vm.togglePivot()"><md-icon md-svg-src="/public/images/ic_view_agenda_black_24px.svg"></md-icon><md-icon ng-hide="$ctrl.vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;Pivot Report</span></span><div ng-if="$ctrl.vm.visiblePivot"><span ng-if="!$ctrl.vm.settings.up.swdr_permissions.pivot_report"><span class="ibm-textcolor-red-40">You are not authorised to run the Pivot Report. &nbsp;If you need access, please contact the DMT System Administrators</span></span><div ng-if="$ctrl.vm.settings.up.swdr_permissions.pivot_report"><div ng-if="$ctrl.vm.pivotIsBuilt"><md-content flex="flex" layout-padding="layout-padding"><p>{{value}}</p><pivot-chart pivot-data="$ctrl.vm.data1" rows="$ctrl.vm.testRows" cols="$ctrl.vm.testCols" aggregator-name="$ctrl.vm.testAggregatorName" vals="$ctrl.vm.testVals" renderer-name="$ctrl.vm.testRendererName" data-ng-model="value"></pivot-chart></md-content></div><br/><md-progress-linear class="ibm-col-1-1" md-mode="indeterminate" ng-if="!$ctrl.vm.pivotIsBuilt"><p>Report is being retrieved. Please wait...</p></md-progress-linear></div></div></div>');
$templateCache.put('report-standard-datatable.html','<table class="ibm-data-table ibm-grid ibm-altrows" id="table" datatable="" dt-options="$ctrl.dtOptions" dt-columns="$ctrl.dtColumns" dt-instance="$ctrl.dtInstance"></table>');
$templateCache.put('report.custom.html','<div class="ibm-columns" id="generalInfo"><span class="ibm-h4" ng-click="$ctrl.toggleCustom()"><md-icon md-svg-src="/public/images/ic_view_agenda_black_24px.svg"></md-icon><md-icon ng-hide="$ctrl.visibleCustom" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.visibleCustom" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;Custom Report</span></span><div ng-hide="!$ctrl.visibleCustom"><!--input(ng-model=\'$ctrl.opptyIdList\')--><!--md-button(class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" type="button" ng-click="$ctrl.cloudantTest()")md-icon(class="white_icon",md-svg-src="/public/images/ic_check_black_24px.svg")\nspan Cloudant, GO!\n--><span ng-if="!$ctrl.settings.up.swdr_permissions.custom_report"><span class="ibm-textcolor-red-40">You are not authorised to run the Custom Report. &nbsp;If you need access, please contact the DMT System Administrators</span></span><div ng-if="$ctrl.settings.up.swdr_permissions.custom_report"><div style="margin: 20px;"><md-button class="md-raised md-primary" ng-click="$ctrl.createCustom()">{{$ctrl.showasync ? \'Hide Report\' : \'Create Report\'}}</md-button><br/><h1 class="ibm-textcolor-blue-40 ibm-h4" ng-if="$ctrl.showasync &amp;&amp; !$ctrl.isCustomReady">Please wait...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><!--md-content(ng-hide=\'!$ctrl.showasync\')--><span ng-hide="!$ctrl.showasync"><div ng-if="$ctrl.isCustomReady &amp;&amp; $ctrl.filtersExist"><span ng-click="$ctrl.toggleCustomList()"><md-icon ng-hide="$ctrl.visibleCustomList" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.visibleCustomList" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;List of Columns</span></span><table class="scrol-overflow" cellspacing="0" cellpadding="0" border="0"><tbody><tr><td><h4>Original data</h4><md-list-item ng-repeat="oneItem in $ctrl.db2Col"><md-checkbox ng-if="oneItem.name ===\'OPP\'" aria-label="orig_data" disabled="disabled" ng-model="oneItem.isSelected" ng-change="$ctrl.checkboxChange(oneItem)"></md-checkbox><md-checkbox ng-if="oneItem.name ===\'ROW_ID\'" aria-label="orig_data" ng-disabled="$ctrl.repType===\'ROWID\'" ng-model="oneItem.isSelected" ng-change="$ctrl.checkboxChange(oneItem)"></md-checkbox><md-checkbox ng-if="oneItem.name !==\'OPP\' &amp;&amp; oneItem.name !==\'ROW_ID\'" ng-model="oneItem.isSelected" aria-label="orig_data" ng-change="$ctrl.checkboxChange(oneItem)"></md-checkbox><h3 class="ibm-bold ibm-textcolor-blue-50">{{oneItem.title}}</h3></md-list-item></td><td><h4>General Data</h4><md-list-item ng-repeat="oneItem in $ctrl.genCol"><md-checkbox ng-model="oneItem.isSelected" aria-label="gen_data" ng-change="$ctrl.checkboxChange(oneItem)"></md-checkbox><h3 class="ibm-bold ibm-textcolor-blue-50">{{oneItem.title}}</h3></md-list-item></td><td><h4>Elig Data</h4><md-list-item ng-repeat="oneItem in $ctrl.eligCol"><md-checkbox ng-model="oneItem.isSelected" aria-label="elig_data" ng-change="$ctrl.checkboxChange(oneItem)"></md-checkbox><h3 class="ibm-bold ibm-textcolor-blue-50">{{oneItem.title}}</h3></md-list-item></td><td><h4>Validation Data</h4><md-list-item ng-repeat="oneItem in $ctrl.valCol"><md-checkbox ng-model="oneItem.isSelected" aria-label="valid_data" ng-change="$ctrl.checkboxChange(oneItem)"></md-checkbox><h3 class="ibm-bold ibm-textcolor-blue-50">{{oneItem.title}}</h3></md-list-item></td></tr></tbody></table><!--table(ng-if="$ctrl.visibleCustomList")tr(ng-repeat="row in $ctrl.listColumns")\n    td(ng-repeat="cell in row track by $index") {{cell}}--></div><div class="checkbox_container" ng-if="$ctrl.isCustomReady &amp;&amp; $ctrl.filtersExist"><input type="radio" value="OPP" name="repType" id="1" ng-model="$ctrl.repType" ng-change="$ctrl.repTypeChange()"/><label for="1">Oppty</label><input type="radio" value="ROWID" name="repType" id="2" ng-model="$ctrl.repType" ng-change="$ctrl.repTypeChange()"/><label for="2">Row ID</label><span style="display: inline-flex; float: right; margin-top: -5px"><md-button class="dmt-team-btn" ng-click="$ctrl.clearFilter()" title="Wipe all filter settings"><md-icon md-svg-icon="clearAll"></md-icon><span>Clear All</span></md-button></span><p></p><label for="o">Original<input type="radio" value="original" name="filterType" id="o" ng-model="$ctrl.filterType"/></label><label for="n">Current<input type="radio" value="current" name="filterType" id="n" ng-model="$ctrl.filterType"/></label><p></p><div class="checkbox_subcontainer" style="margin-top: 20px"><span style="border-bottom: 1px solid lightgray;"><b class="ibm-textcolor-blue-40 ibm-h4">Current Filters</b><span style="padding-left: 1em">Select the relevant filters and click&nbsp;<b>Apply</b>.</span></span><md-switch class="md-primary" title="Toggle between Disbursements that have VAP Government and those that don\'t" ng-if="$ctrl.filterToggles.vap" aria-label="vap g only" ng-model="$ctrl.vapFilter">Only display Disbursements&nbsp;<b>{{$ctrl.vapFilter ? "with" : "without"}}</b>&nbsp;VAP-G</md-switch><div class="ibm-columns"><div class="ibm-col-3-1" style="width: 18em"><md-select class="ibm_select" ng-if="$ctrl.filterToggles.countries" multiple="multiple" ng-model="$ctrl.filterIots" ng-change="$ctrl.changeFilters(\'iot\')" placeholder="Pick an IOT"><md-option ng-value="iot" ng-repeat="iot in $ctrl.filters.iots">{{ iot }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.dmtStats" multiple="multiple" ng-model="$ctrl.filterStatuses" placeholder="Pick a DMT Main Status"><md-option ng-value="status" ng-repeat="status in $ctrl.filters.statuses">{{ status }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.teams" multiple="multiple" ng-model="$ctrl.filterTeams" placeholder="Pick a Team"><md-option ng-value="team" ng-repeat="team in $ctrl.filters.teams">{{ team }}</md-option></md-select></div><div class="ibm-col-3-2" style="width: 18em"><md-select class="ibm_select" ng-if="$ctrl.filterToggles.countries" multiple="multiple" ng-model="$ctrl.filterImts" ng-change="$ctrl.changeFilters(\'imt\')" placeholder="Pick an IMT"><md-option ng-value="imt" ng-repeat="imt in $ctrl.filters.imts">{{ imt }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.dmtSubStats" multiple="multiple" ng-model="$ctrl.filterSubStatuses" placeholder="Pick a DMT Sub-Status"><md-option ng-value="subStatus" ng-repeat="subStatus in $ctrl.filters.subStatuses">{{ subStatus }}</md-option></md-select></div><div class="ibm-col-3-3"><md-select class="ibm_select" ng-if="$ctrl.filterToggles.countries" multiple="multiple" ng-model="$ctrl.filterCountries" placeholder="Pick a country"><md-option ng-value="country" ng-repeat="country in $ctrl.filters.countries">{{ country }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.sviStats" multiple="multiple" ng-model="$ctrl.filterSviStatuses" placeholder="Pick a MySA Status"><md-option ng-value="sviStatus" ng-repeat="sviStatus in $ctrl.filters.sviStatuses | orderBy: sviStatus">{{ sviStatus }}</md-option></md-select></div><div class="ibm-col-3-1"><label>CVR submit From</label><md-datepicker ng-model="$ctrl.sviFromDate"></md-datepicker><label>CVR submit To</label><md-datepicker ng-model="$ctrl.sviToDate"></md-datepicker></div></div></div><div class="checkbox_subcontainer" style="margin-top: 5px"><span style="border-bottom: 1px solid lightgray;"><b class="ibm-textcolor-blue-40 ibm-h4">Saved Filters</b><span style="padding-left: 1em">Select a saved filter to load and click&nbsp;<b>Apply</b>. &nbsp;Click&nbsp;<b>Manage</b>&nbsp;to save/delete filters.</span></span><div class="ibm-columns" style="margin-top: 10px"><div class="ibm-col-2-1"><md-select class="ibm_select" style="margin-top: 10px" ng-model="$ctrl.currFilter" placeholder="Select a Saved Filter to load" ng-change="$ctrl.changeSavedFilter($ctrl.currFilter)"><md-option ng-value="{{filter}}" ng-repeat="filter in $ctrl.userFilters track by $index" ng-selected="filter.name === \'Default\'">{{ filter.name }}</md-option></md-select></div><div class="ibm-col-2-2"><md-button class="md-raised md-primary" ng-click="$ctrl.viewProfiles($event)" title="Save">Manage</md-button></div></div></div><div class="checkbox_subcontainer" style="margin-top: 5px"><span style="border-bottom: 1px solid lightgray;"><md-button class="dmt-team-btn dmt-team-btn-run" ng-disabled="!$ctrl.showFilterBtn || ($ctrl.colQty &gt; 20)" ng-click="$ctrl.generateReport(&quot;show&quot;)" ng-class="{\'md-primary md-raised\' : $ctrl.isFilterSet}" title="Apply the current filter settings"><md-tooltip ng-if="$ctrl.isFilterSet" md-direction="bottom">Filters are active</md-tooltip><md-icon md-svg-icon="/public/icons/ic_autorenew_black_24px.svg"></md-icon><span>Preview</span></md-button><md-button class="md-raised md-primary" ng-disabled="$ctrl.reportIsLoading || ($ctrl.colQty &gt; 20)" ng-click="$ctrl.generateReport(&quot;save&quot;)" title="Save">Run</md-button></span><p ng-if="($ctrl.colQty &gt; 20)"><font color="red">{{$ctrl.colQty}} out of 20 columns chosen</font></p><p ng-if="($ctrl.colQty &lt;= 20)">{{$ctrl.colQty}} out of 20 columns chosen</p></div></div><p ng-if="$ctrl.reportIsLoading">Report is being prepared. This may take several minutes...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></p><p ng-if="$ctrl.overLimit">Report is over 100 000 entries, please refine your search.</p><p ng-if="$ctrl.isRowIdpresent">DB2 Row ID dependent values selected. Row ID will be added to the config.</p><p></p><!--    div(class="checkbox_subcontainer" style="margin-top: 20px")md-contact-chips(\n    ng-model="$ctrl.asyncColumns"\n    md-contacts="$ctrl.delayedQuerySearch($query)"\n    ng-click="$ctrl.addColumns()"\n    md-contact-image="image"\n    md-contact-name="title"\n    md-require-match="true"\n    md-highlight-flags="i"\n    filter-selected="$ctrl.filterSelected"\n    placeholder="Add columns dynamically")--><!--)--><div ng-if="$ctrl.showTable"><table class="ibm-data-table ibm-grid ibm-altrows" id="table" datatable="" dt-options="$ctrl.dtOptions" dt-columns="$ctrl.dtColumns" dt-instance="$ctrl.dtInstance"></table></div></span></div></div></div></div>');
$templateCache.put('report.shared.html','<div class="ibm-columns" id="generalInfo"><span class="ibm-h4" ng-click="$ctrl.toggleShared()"><md-icon md-svg-src="/public/images/ic_view_agenda_black_24px.svg"></md-icon><md-icon ng-hide="$ctrl.visibleShared" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.visibleShared" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;Shared Report</span></span><div ng-hide="!$ctrl.visibleShared"><span class="ibm-textcolor-red-40">Come back later!  To be created...</span><!--div.reportWrapperdiv.reportOption\n  span.ibm-h4(ng-click="$ctrl.toggleOpenItems()")\n    md-icon(md-svg-src="/public/images/ic_view_agenda_black_24px.svg")\n    md-icon(ng-hide="$ctrl.visibleStandard",md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg")\n    md-icon(ng-hide="!$ctrl.visibleStandard",md-svg-src="/public/images/ic_expand_more_black_24px.svg")\n    span &nbsp;Open\ndiv.reportOption\n  span.ibm-h4(ng-click="$ctrl.toggleClosedItems()")\n    md-icon(md-svg-src="/public/images/ic_view_agenda_black_24px.svg")\n    md-icon(ng-hide="$ctrl.visibleStandard",md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg")\n    md-icon(ng-hide="!$ctrl.visibleStandard",md-svg-src="/public/images/ic_expand_more_black_24px.svg")\n    span &nbsp;Closed--></div></div>');
$templateCache.put('report.standard.html','<div class="ibm-columns" id="generalInfo"><span class="ibm-h4" ng-click="$ctrl.toggleStandard()"><md-icon md-svg-src="/public/images/ic_view_agenda_black_24px.svg"></md-icon><md-icon ng-hide="$ctrl.visibleStandard" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.visibleStandard" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;Standard Report</span></span><div ng-hide="!$ctrl.visibleStandard"><div class="reportWrapper" style="margin: 25px;"><span ng-if="!$ctrl.settings.up.swdr_permissions.standard_report.length"><span class="ibm-textcolor-red-40">You are not authorised to run any Standard Reports. &nbsp;If you need access, please contact the DMT System Administrators</span></span><div class="reportOption" ng-if="$ctrl.settings.up.swdr_permissions.standard_report.indexOf(\'Closed\') &gt; -1"><span class="ibm-h4" ng-click="$ctrl.toggleOpenItems()"><md-icon md-svg-src="/public/images/ic_view_column_black_24px.svg"></md-icon><md-icon ng-hide="$ctrl.openItems" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.openItems" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;Closed</span></span><div ng-if="$ctrl.openItems"><p>|| Currently no items</p></div></div><div class="reportOption" ng-if="$ctrl.settings.up.swdr_permissions.standard_report.indexOf(\'Open\') &gt; -1"><span class="ibm-h4" ng-click="$ctrl.toggleClosedItems()"><md-icon md-svg-src="/public/images/ic_view_column_black_24px.svg"></md-icon><md-icon ng-hide="$ctrl.closeItems" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.closeItems" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;Open</span></span><div ng-if="$ctrl.closeItems"><div><md-button class="md-raised md-primary" ng-disabled="$ctrl.isDownloading" ng-click="$ctrl.download()">Download</md-button><md-button class="md-raised md-primary" ng-click="$ctrl.loadReport()">Refresh</md-button><!--md-button.md-raised.md-primary(ng-click=\'\') Duplicate--><md-button class="md-raised md-primary" ng-click="$ctrl.toggleFilter()" ng-class="{\'md-primary md-raised\' : vm.isFilterSet}">Filter</md-button></div><div><p>|| Loaded on : {{$ctrl.loadedOn | date:"MM/dd/yyyy \'at\' h:mma" : \'GMT\'}}</p></div><div><div id="content"><div class="ibm-columns" ng-if="$ctrl.isDownloading"><div class="ibm-col-1-1" style="margin: 15px;"><div class="download-container"><md-progress-linear md-mode="query"></md-progress-linear><div class="download-block-notification"><span>Preparing Excel report, please wait...</span></div></div></div></div><div class="checkbox_container" ng-if="$ctrl.isFilterToggled"><span style="display: inline-flex; float: right; margin-top: -5px"><md-button class="dmt-team-btn dmt-team-btn" ng-click="$ctrl.loadReport()" ng-class="{\'md-primary md-raised\' : $ctrl.isFilterSet}" title="Apply the current filter settings"><md-icon md-svg-icon="filter"></md-icon><span>Apply</span></md-button><md-button class="dmt-team-btn" ng-click="$ctrl.clearFilter()" title="Wipe all filter settings"><md-icon md-svg-icon="clearAll"></md-icon><span>Clear All</span></md-button><md-icon style="padding-left: 5px;" md-menu-align-target="md-menu-align-target" md-svg-icon="/public/icons/ic_close_black_24px.svg" ng-click="$ctrl.closeFilter()"></md-icon></span><p></p><div class="checkbox_subcontainer" style="margin-top: 20px"><span style="border-bottom: 1px solid lightgray;"><b class="ibm-textcolor-blue-40 ibm-h4">Current Filters</b><span style="padding-left: 1em">Select the relevant filters and click&nbsp;<b>Apply</b>.</span></span><p></p><div><input type="radio" ng-model="$ctrl.vapFilter"/>All<input style="margin-left:15px" type="radio" ng-model="$ctrl.vapFilter" ng-value="true"/>VAP-G Only<input style="margin-left:15px" type="radio" ng-model="$ctrl.vapFilter" ng-value="false"/>No VAP-G<span class="red_text" style="margin-left: 1em" ng-if="$ctrl.vapFilter &amp;&amp; $ctrl.settings.up.swdr_permissions.iot.indexOf(\'North America IOT\') &gt; -1">NOTE: You do not have access to view North American VAP-G Disbursements</span></div><p></p><!--md-switch(title="Toggle between Disbursements that have VAP Government and those that don\'t" ng-if="$ctrl.enableVAPFilter" class="md-primary" aria-label="vap g only" ng-model="$ctrl.vapFilter")| Only display Disbursements&nbsp;\nb {{$ctrl.vapFilter ? "with" : "without"}}\n| &nbsp;VAP-G--><div class="ibm-columns"><div class="ibm-col-3-1" style="width: 18em"><md-select class="ibm_select" ng-if="$ctrl.filterToggles.countries" multiple="multiple" ng-model="$ctrl.filterIots" ng-change="$ctrl.changeFilters(\'iot\')" placeholder="Pick an IOT"><md-option ng-value="iot" ng-repeat="iot in $ctrl.filters.iots">{{ iot }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.dmtStats" multiple="multiple" ng-model="$ctrl.filterStatuses" placeholder="Pick a DMT Main Status"><md-option ng-value="status" ng-repeat="status in $ctrl.filters.statuses">{{ status }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.teams" multiple="multiple" ng-model="$ctrl.filterTeams" placeholder="Pick a Team"><md-option ng-value="team" ng-repeat="team in $ctrl.filters.teams">{{ team }}</md-option></md-select></div><div class="ibm-col-3-2" style="width: 18em"><md-select class="ibm_select" ng-if="$ctrl.filterToggles.countries" multiple="multiple" ng-model="$ctrl.filterImts" ng-change="$ctrl.changeFilters(\'imt\')" placeholder="Pick an IMT"><md-option ng-value="imt" ng-repeat="imt in $ctrl.filters.imts">{{ imt }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.dmtSubStats" multiple="multiple" ng-model="$ctrl.filterSubStatuses" placeholder="Pick a DMT Sub-Status"><md-option ng-value="subStatus" ng-repeat="subStatus in $ctrl.filters.subStatuses | orderBy:subStatus">{{ subStatus }}</md-option></md-select></div><div class="ibm-col-3-3"><md-select class="ibm_select" ng-if="$ctrl.filterToggles.countries" multiple="multiple" ng-model="$ctrl.filterCountries" ng-change="$ctrl.changeFilters(\'cty\')" placeholder="Pick a country"><md-option ng-value="country" ng-repeat="country in $ctrl.filters.countries">{{ country }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.sviStats" multiple="multiple" ng-model="$ctrl.filterSviStatuses" placeholder="Pick a MySA Status"><md-option ng-value="sviStatus" ng-repeat="sviStatus in $ctrl.filters.sviStatuses | orderBy: sviStatus">{{ sviStatus }}</md-option></md-select><md-select class="ibm_select" ng-if="$ctrl.filterToggles.sampStat" multiple="multiple" ng-model="$ctrl.filterSamplingStatus" ng-change="$ctrl.changeFilters(\'STAT\')" placeholder="Pick a Status"><md-option ng-value="samplingStatus" ng-repeat="samplingStatus in $ctrl.filters.samplingStatus">{{ samplingStatus }}</md-option></md-select></div></div></div><div class="checkbox_subcontainer" style="margin-top: 5px"><span style="border-bottom: 1px solid lightgray;"><b class="ibm-textcolor-blue-40 ibm-h4">Saved Filters</b><span style="padding-left: 1em">Select a saved filter to load and click&nbsp;<b>Apply</b>. &nbsp;Click&nbsp;<b>Manage</b>&nbsp;to save/delete filters.</span></span><div class="ibm-columns" style="margin-top: 10px"><div class="ibm-col-2-1"><md-select class="ibm_select" style="margin-top: 10px" ng-model="$ctrl.currFilter" placeholder="Select a Saved Filter to load" ng-change="$ctrl.changeSavedFilter($ctrl.currFilter)"><md-option ng-value="{{filter}}" ng-repeat="filter in $ctrl.userFilters track by $index" ng-selected="filter.name === \'Default\'">{{ filter.name }}</md-option></md-select></div><div class="ibm-col-2-2"><md-button class="md-raised md-primary" ng-click="$ctrl.viewProfiles($event)" title="Manage New/Saved Profiles">Manage</md-button></div></div></div></div><p></p><table class="ibm-data-table ibm-grid ibm-altrows" id="table" datatable="" dt-options="$ctrl.dtOptions" dt-columns="$ctrl.dtColumns" dt-instance="$ctrl.dtInstance"></table></div></div></div></div></div></div></div>');
$templateCache.put('reporting.html','<!-- @author Ivelin Ivanov--><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div class="ibm-columns"><div class="ibm-col-1-1"><div id="content"><report-general vm="vm"></report-general><br/><br/><report-pivot vm="vm"></report-pivot><br/><br/><report-standard vm="vm"></report-standard><br/><br/><report-custom vm="vm"></report-custom><br/><br/><report-shared vm="vm"></report-shared><br/><br/><report-bplm vm="vm"></report-bplm><br/><br/><report-backlog vm="vm"></report-backlog><br/><br/><report-finance vm="vm"></report-finance><br/><br/><report-newclients vm="vm"></report-newclients><br/><br/><report-nps vm="vm"></report-nps><br/><br/><report-complianceplan vm="vm"></report-complianceplan><br/></div></div></div></div></div></div></div></main>');
$templateCache.put('dialog.html','<md-dialog class="customDialog" aria-label="Team members"><md-toolbar><div class="md-toolbar-tools"><h2>Team Members</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel($event)"><md-icon md-svg-src="/public/icons/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-list flex="flex"><md-subheader class="md-no-sticky">{{vm.teamname}}</md-subheader><md-list-item class="md-3-line" ng-repeat="team in vm.people" ng-click="null"><img class="md-avatar" ng-src="{{vm.getAvatar(team)}}" alt=""/><div class="md-list-tem-text" layout="column"><p>{{team}}</p></div></md-list-item></md-list></md-dialog-content></md-dialog>');
$templateCache.put('team.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div class="ibm-columns"><div class="ibm-col-6-4 ibm-center-block"><br/><md-progress-linear class="ibm-col-6-4" md-mode="indeterminate" ng-if="vm.teamsAreLoaded"><p>DMT Teams are being retrieved ... </p></md-progress-linear><h2 class="ibm-h2 ibm-light ibm-center" style="padding: 50px;">Your teams</h2><div class="ibm-rule ibm-alternate"><hr/></div><div class="nano" data-widget="scrollable" data-height="100" style="height: 150px"><div class="nano-content" tabindex="0"><md-list flex="flex"><md-list-item ng-repeat="team in vm.myTeams"><p class="ibm-h5 ibm-light ibm-left">{{ team }}</p><md-button class="md-accent md-raised md-hue-2" ng-click="vm.leave(team, $event)">Leave</md-button><md-button class="md-primary md-hue-1" ng-click="vm.viewMembers(team, $event)">View members</md-button><p ng-show="!vm.myTeams.length"><i>You are not member of any team</i></p></md-list-item></md-list></div></div><div class="ibm-rule ibm-alternate"><hr/></div><div style="height: 50px"></div><h2 class="ibm-h2 ibm-light ibm-center">Available teams</h2><div class="ibm-rule ibm-alternate"><hr/></div><div class="nano" data-widget="scrollable" data-height="100" style="height: 100px"><div class="nano-content" tabindex="0"><md-list flex="flex"><md-list-item ng-repeat="item in vm.allTeams"><p class="ibm-h5 ibm-light ibm-left">{{item}}</p><md-button class="md-raised md-primary" style="background-color: #3fb54f" ng-click="vm.join(item, $event)">Join</md-button><md-button class="md-primary md-hue-1" ng-click="vm.viewMembers(item, $event)">View members</md-button><p class="ibm-light" ng-show="!vm.allTeams.length"><i>There are no available teams</i></p></md-list-item></md-list></div></div><div class="ibm-rule ibm-alternate"><hr/></div><div style="height: 50px"></div><div class="ibm-columns"><div class="ibm-col-6-1 ibm-left"><h2 class="ibm-h3" for="createTeam">Create team</h2></div><div class="ibm-col-6-1 ibm-left"><md-input-container style="margin: 0px; padding: 0px;"><label>Team name</label><input type="text" value="" id="createTeam" ng-model="vm.teamName"/></md-input-container></div><div class="ibm-col-6-1 ibm-left"><md-button class="md-raised md-primary" ng-click="vm.createTeam()">Create</md-button></div></div></div></div></div></div></div></div></main>');
$templateCache.put('userprofile.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><form name="userForm"><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><!--| {{vm.editing}}--><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>User Profile</b></h1></div><div class="ibm-col-6-1"><img class="img-circle" style="padding: inherit" ng-src="{{vm.getAvatar()}}"/></div></div><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="vm.events.beingSaved">Saving...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><div ng-if="!vm.events.beingSaved">This document represents your profile. &nbsp;Please update your Preferences accordingly bearing in mind all fields marked with (<req></req>) are mandatory. &nbsp;Click&nbsp;<b>Save</b>&nbsp;when done.<p></p><b>NOTE</b>&nbsp;: The&nbsp;<b>Save</b>&nbsp;button will not become available until all mandatory fields are correctly completed.</div><div ng-if="vm.serverError" style="border: 1px solid red; padding: 10px; margin: 10px; background-color: #fff4f6"><h1 class="ibm-textcolor-red-40 ibm-h3"><b>Server Error</b></h1>There was a problem at the server. &nbsp;The details are as follows:<p></p><p class="ibm-textcolor-red-40">{{vm.serverError}}</p>If the problem persists, please contact the DMT System Administrators for guidance.</div><p></p></div><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-disabled="vm.$scope.userForm.$pristine || vm.events.beingSaved || !vm.$scope.userForm.$valid" ng-click="vm.save($event)"><md-icon class="white_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Save</md-button></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Full Name&nbsp;</label></div><div class="ibm-col-6-4 field"><b>{{::vm.settings.up.name}}</b></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Email Address&nbsp;</label></div><div class="ibm-col-6-4 field"><span>{{::vm.settings.up.email}}</span></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Role&nbsp;</label></div><div class="ibm-col-6-4 field"><span>{{::vm.admin.getBGName(vm.settings.up.swdr_permissions.role)}}</span></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Is Manager&nbsp;</label></div><div class="ibm-col-6-4 field"><span>{{::vm.settings.up.is_manager}}</span></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Status&nbsp;</label></div><div class="ibm-col-6-4 field"><b ng-class="{\'ibm-textcolor-green-50\': vm.settings.up.status === \'Active\', \'ibm-textcolor-red-50\': vm.settings.up.status !== \'Active\' }">{{::vm.settings.up.status}} &nbsp;</b><md-icon class="red_icon" ng-if="vm.settings &amp;&amp; vm.settings.up.status !== \'Active\' " md-svg-icon="/public/images/help-circle.svg" title="You are no longer listed in any of the DMT Blue Groups and has therefore lost your access.  NOTE: Should access be reinstated, the Permissions will be reset."></md-icon></div></div><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-50 ibm-h3"><b>Preferences&nbsp;&nbsp;</b><a class="ibm-textcolor-blue-30" style="font-size:medium" ng-click="vm.toggle.pref = !vm.toggle.pref">Click to {{!vm.toggle.pref ? \'View\' : \'Hide\'}}</a></h1></div></div></div><div ng-if="vm.toggle.pref"><div class="ibm-columns"><div class="ibm-col-6-5"><div>Please update your personal Preferences accordingly.<p></p></div></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50" title="Determines how all Dates will be displated in DMT for you"> Date Format&nbsp;</label><req></req>&nbsp;</div><div class="ibm-col-6-4 field"><select ng-model="vm.editing.preferences.dateFormat" ng-options="o.v as o.f for o in vm.df"></select><span style="color: gray">&nbsp;&nbsp;{{vm.df[vm.editing.preferences.dateFormat].e}}</span></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Enable Notifications&nbsp;</label><req></req>&nbsp;</div><div class="ibm-col-6-4 field"><input type="radio" ng-model="vm.editing.preferences.notifications" ng-value="true"/>Yes<input type="radio" ng-model="vm.editing.preferences.notifications" ng-value="false"/>No</div></div><p></p></div><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-50 ibm-h3"><b>Country Permissions&nbsp;&nbsp;</b><a class="ibm-textcolor-blue-30" style="font-size:medium" ng-click="vm.toggle.cty = !vm.toggle.cty">Click to {{!vm.toggle.cty ? \'View\' : \'Hide\'}}</a></h1></div></div><div ng-if="vm.toggle.cty"><div class="ibm-columns"><div class="ibm-col-6-5"><div>The Country Permissions determine which Countries\' Disbursements you can see. &nbsp;Should any of this need changing please request access via&nbsp;<a href="{{vm.oneTeamUrl}}" target="_blank"><b>OneTEAM</b>.</a></div><p></p></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> IOT Access&nbsp;</label></div><div class="ibm-col-6-4 field"><span ng-repeat="x in vm.settings.up.swdr_permissions.iot | orderBy: x">{{x.replace(\' IOT\',\'\')}}{{$index+1 == vm.settings.up.swdr_permissions.iot.length ? \'\' : \', \'}}</span></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Country Access&nbsp;</label></div><div class="ibm-col-6-4 field"><div class="selected_top ibm-textcolor-blue-50" style="text-align: left;">Permitted Countries :&nbsp;<b style="color:black">{{vm.settings.up.swdr_permissions.country.length}}</b></div><div class="selected" style="text-align: left; height: 250px; max-height: 250px"><ol style="type=1; list-style: outside disc; margin-left: 3px"><li style="position: relative;" ng-repeat="x in vm.settings.country_list | orderBy: \'country\' | filter: {ic:\'Country\'}" ng-if="vm.settings.up.swdr_permissions.country.indexOf(x.short) &gt; -1 &amp;&amp; x.ic == \'Country\'">{{x.country}}</li></ol></div></div></div></div><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-50 ibm-h3"><b>Program Permissions&nbsp;&nbsp;</b><a class="ibm-textcolor-blue-30" style="font-size:medium" ng-click="vm.toggle.prg = !vm.toggle.prg">Click to {{!vm.toggle.prg ? \'View\' : \'Hide\'}}</a></h1></div></div><div ng-if="vm.toggle.prg"><div class="ibm-columns"><div class="ibm-col-6-5"><div>The Program Permissions determine which Programs you user can see. &nbsp;Should any of this need changing please request access via&nbsp;<a href="{{vm.oneTeamUrl}}" target="_blank"><b>OneTEAM</b></a>.</div></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Program Access&nbsp;</label></div><div class="ibm-col-6-4 field"><div class="selected_top ibm-textcolor-blue-50" style="text-align: left;">Selected Programs :&nbsp;<b style="color:black">{{vm.settings.up.swdr_permissions.program.length}}</b></div><div class="selected" style="text-align: left;"><ol style="type=1; list-style: outside disc; margin-left: 3px"><!--li(style="position: relative;" ng-repeat="x in vm.admin.general.programs | orderBy: x" ng-if="vm.settings.up.swdr_permissions.program.indexOf(x) > -1")--><li style="position: relative;" ng-repeat="x in vm.settings.up.swdr_permissions.program | orderBy: x">{{x}}</li></ol></div></div></div></div><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-50 ibm-h3"><b>Reporting Permissions&nbsp;&nbsp;</b><a class="ibm-textcolor-blue-30" style="font-size:medium" ng-click="vm.toggle.rep = !vm.toggle.rep">Click to {{!vm.toggle.rep ? \'View\' : \'Hide\'}}</a></h1></div></div><div ng-if="vm.toggle.rep"><div class="ibm-columns"><div class="ibm-col-6-5"><div>The Reporting Permissions determine which reports you can run or not. &nbsp;Should a change be required please contact the DMT System Administrators.</div></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> General Report&nbsp;</label></div><div class="ibm-col-6-4 field"><input type="radio" ng-model="vm.settings.up.swdr_permissions.general_report" ng-value="true" ng-disabled="true"/>Yes<input type="radio" ng-model="vm.settings.up.swdr_permissions.general_report" ng-value="false" ng-disabled="true"/>No</div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Pivot Report&nbsp;</label></div><div class="ibm-col-6-4 field"><input type="radio" ng-model="vm.settings.up.swdr_permissions.pivot_report" ng-value="true" ng-disabled="true"/>Yes<input type="radio" ng-model="vm.settings.up.swdr_permissions.pivot_report" ng-value="false" ng-disabled="true"/>No</div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Custom Reports&nbsp;</label></div><div class="ibm-col-6-4 field"><input type="radio" ng-model="vm.settings.up.swdr_permissions.custom_report" ng-value="true" ng-disabled="true"/>Yes<input type="radio" ng-model="vm.settings.up.swdr_permissions.custom_report" ng-value="false" ng-disabled="true"/>No</div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Shared Reports&nbsp;</label></div><div class="ibm-col-6-4 field"><input type="radio" ng-model="vm.settings.up.swdr_permissions.shared_report" ng-value="true" ng-disabled="true"/>Yes<input type="radio" ng-model="vm.settings.up.swdr_permissions.shared_report" ng-value="false" ng-disabled="true"/>No</div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Standard Reporting Access&nbsp;</label></div><div class="ibm-col-6-4 field"><div class="selected_top ibm-textcolor-blue-50" style="text-align: left;"> Selected Reports :&nbsp;<b style="color:black">{{vm.settings.up.swdr_permissions.standard_report.length}}</b></div><div class="selected" style="text-align: left;"><ol style="type=1; list-style: outside disc; margin-left: 3px"><li style="position: relative;" ng-repeat="x in vm.settings.up.swdr_permissions.standard_report | orderBy: x">{{x}}</li></ol></div></div></div></div></div></div></form></div></main><p></p>');
$templateCache.put('bpmergers-create.html','<style>.md-datepicker-calendar-pane{z-index: 1200}\n.md-dialog-is-showing md-dialog{width: 40%}\n.select2-selection--single {width: 200px }\n.select2, .select2-container, .select2-container--default, .select2-container--below, .select2-container--focus {width: 200px ! important}\n\n</style><md-dialog aria-label="Edit Bonus" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>{{vm.label}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="vm.disForm"><md-content class="md-padding"><span class="ibm-textcolor-blue-50">BP Country&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="country" ng-model="vm.bpMergers.bpCountry" ng-required="true" ng-options="country as country for country in vm.listCountries"><option value="">--Please select--</option></select></div><p></p><span class="ibm-textcolor-blue-50">BP Losing CEID&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.bpMergers.bpLosingCEID" ng-change="vm.modified = true;" ng-required="true"/></div><p></p><span class="ibm-textcolor-blue-50">BP Losing Name&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.bpMergers.bpLosingName" ng-change="vm.modified = true;" ng-required="true"/></div><p></p><span class="ibm-textcolor-blue-50">BP Winning CEID&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"> <input type="text" ng-model="vm.bpMergers.bpWinningCEID" ng-change="vm.modified = true;" ng-required="true"/></div><p></p><span class="ibm-textcolor-blue-50">BP Winning Name&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.bpMergers.bpWinningName" ng-change="vm.modified = true;" ng-required="true"/></div><p></p></md-content></ng-form><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="!vm.disForm.$valid || vm.bpMergers.bpCountry===\'-Please select-\'">Submit</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Close</md-button><p></p></md-dialog-content></md-dialog>');
$templateCache.put('bpmergers-edit.html','<style>.md-datepicker-calendar-pane{z-index: 1200}\n.md-dialog-is-showing md-dialog{width: 40%}\n.select2-selection--single {width: 200px }\n.select2, .select2-container, .select2-container--default, .select2-container--below, .select2-container--focus {width: 200px ! important}\n</style><md-dialog aria-label="Edit Bonus" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Edit record</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="vm.disForm"><md-content class="md-padding"><span class="ibm-textcolor-blue-50">BP Country&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="country" ng-model="vm.content.bpCountry" ng-required="true" ng-options="country as country for country in vm.listCountries"><option value="">--Please select--</option></select></div><p></p><span class="ibm-textcolor-blue-50">BP Losing CEID&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"> <input type="text" ng-model="vm.content.losingBPCeid" ng-change="vm.modified = true;" ng-required="true"/></div><p></p><span class="ibm-textcolor-blue-50">BP Losing Name&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.content.losingBPName" ng-change="vm.modified = true;" ng-required="true"/></div><p></p><span class="ibm-textcolor-blue-50">BP Winning CEID&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"> <input type="text" ng-model="vm.content.winningBPCeid" ng-change="vm.modified = true;" ng-required="true"/></div><p></p><span class="ibm-textcolor-blue-50">BP Winning Name&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.content.winningBPName" ng-change="vm.modified = true;" ng-required="true"/></div></md-content></ng-form><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="!vm.disForm.$valid || vm.content.bpCountry===\'-Please select-\'">Submit</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-dialog-content></md-dialog>');
$templateCache.put('bpmergers-view.html','<style>.approved-table {\n    min-width: 1100px;\n}\n.approved-table tbody tr td:last-child,\n.approved-table thead tr td:last-child {\n    min-width: 130px;\n}\n.actions-container {\n    box-sizing: border-box;\n    display: inline-flex;\n    flex: 0 0 auto;\n    align-items: center;\n    justify-content: flex-end;\n    z-index: 1;\n    right: 0;\n    position: absolute;\n    top: 0;\n}\n.actions-container > div {\n    padding: 10px 5px;\n}\n.actions-container > div:first-child {\n    align-items: stretch;\n    display: flex;\n    flex: 1 1 auto;\n    height: 35px;     \n}\n.actions-container .actions {\n    border: solid 1px #5596e6;\n    padding: 7px 0px 7px 7px;\n    color: #5596e6;\n    display: flex;\n    align-items: center;\n}\n.export-btn-container button {\n    margin: 0;\n}\na.link {\n    text-decoration: none;\n}\n.alpha_dead {\n    color: lightgray;\n}\n.alpha_selly {\n    color: white;\n    background-color: #5596e6;\n    border-radius: 25%;\n}\n.form-list {\n    padding-top: 15px;\n    min-height: 65px;\n}\n.delete-button md-icon svg {\n    fill: #e71d32;\n}\n.edit-button md-icon svg {\n    fill: #325c80;\n}\n.fill {\n    display: flex;\n    width: 100%;\n    height: 100%;\n}\n#ibm-content-body {\n    box-sizing: border-box;\n}\n.admin-tabs, .admin-tabs md-tabs-content-wrapper, .admin-tabs md-tab-content, .admin-tabs md-tab-content > div {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n.flex {\n    display: flex;\n}\n.history-container {\n    display: flex;\n    flex: 1;\n    width: 100%;\n    overflow: auto;\n    padding-top: 15px;\n}\n.history-table td:nth-child(2), .history-table th:nth-child(2){\n    flex-grow: 4;\n}\n.history-table td:nth-child(3), .history-table th:nth-child(3){\n    flex-grow: 3;\n}\n</style><main class="fill" role="main" aria-labelledby="ibm-pagetitle-h1"><div class="fill" id="ibm-pcon" ibm-back-to-top=""><div class="fill" id="ibm-content"><div class="fill" id="ibm-content-body"><div class="fill" id="ibm-content-main"><div class="fill" id="content" layout="column"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>BP Mergers configuration section</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!vm.bpMergersDataLoaded ">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home              </a></span></div></div><div class="ibm-columns flex"><md-tabs class="admin-tabs" md-dynamic-height="md-dynamic-height"><md-tab label="BP Mergers"><form class="form-list fill" name="" layout="column"><div class="actions-container" ng-if="vm.bpMergersDataLoaded" flex="auto"><div><span class="actions"><span>Admin Actions</span><md-menu ng-disabled="vm.events.beingSaved" md-position-mode="target-right target" md-offset="280 40" style="margin-left:-10px"><md-button class="md-icon-button" ng-click="vm.openActionMenu($mdOpenMenu,$event)" title="Actions"><md-icon class="blue_icon" md-svg-icon="/public/images/star-circle.svg"></md-icon></md-button><md-menu-content width="4"><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.createRecord($event)"><md-icon class="blue_icon" md-svg-icon="/public/images/rocket.svg"></md-icon>Add new record</md-button></md-menu-item></md-menu-content></md-menu></span></div><div class="export-btn-container"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" ng-click="vm.exportBPMergers()" ng-disabled="vm.exportFired" title="Export BP Mergers table to an Excel spreadsheet"><md-icon class="white_icon" ng-if="!vm.exportFired" md-svg-icon="download"></md-icon><md-icon class="ibm-spinner" ng-if="vm.exportFired" style="border: 2px solid white; min-height: 12px; min-width: 12px;"></md-icon><span style="text-transform: none; font-size: 15px; padding-left: 5px; padding-right: 2px;">{{vm.exportFired ? \'Please wait...\' : \'Export\'}}   </span></md-button></div><br></div><div class="fill" layout="column"><table class="approved-table ibm-data-table ibm-altrows ibm-alternate-two" id="table" datatable="" dt-options="vm.table.dtOptions" dt-instance="vm.table.dtInstance" dt-columns="vm.table.dtColumns" dt-disable-deep-watchers="true"></table></div></form></md-tab><md-tab label="History"><div class="history-container"><table class="ibm-data-table history-table" datatable="ng" dt-options="vm.historyTable.options" dt-instance="vm.historyTable.instance" dt-column-defs="vm.historyTable.columnDefs">                                   <thead><tr><th>Time</th><th>Changes made</th><th>Changed by</th></tr></thead><tbody><tr ng-repeat="entry in vm.docTable track by $index"><td>{{ entry.TIMESTAMP }}</td><td>{{ entry.COMMENT }}</td><td>{{ entry.EMAIL }}</td></tr></tbody></table></div></md-tab></md-tabs></div></div></div></div></div></div></main>');
$templateCache.put('checklist-view.html','<style>table, td {\n    border-color: lightgray;\n}\ntable {\n    width: inherit;\n}\na.link {\n    text-decoration: none;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Program Checklist Profiles</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!vm.dataLoaded">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div><div class="ibm-columns" ng-if="vm.dataLoaded"><div class="ibm-col-6-5">Please select a Program Workflow Checklist to view/edit, or create a new one via the&nbsp;<b>Create New&nbsp;</b>button.<p></p><span class="ibm-textcolor-blue-50">Program : &nbsp;</span><select style="width: 20em" ng-model="vm.selectedProgram" ng-options="x as x for x in vm.settings.programs | orderBy: x" ng-change="vm.recalculateLogsTable()"></select><!--span--><!--md-select.no-padding(aria-label="Program",ng-model="vm.selectedProgram",ng-change="vm.recalculateLogsTable()")md-option(ng-value="x" ng-repeat="x in vm.settings.programs | orderBy: x") {{ x }}--><span class="ibm-textcolor-blue-50" style="margin-left:20px">Status : &nbsp;</span><select style="width: 20em" ng-model="vm.admin.clSelection.selected" ng-options="x as x for x in vm.admin.clSelection.filters | orderBy: x" ng-change="vm.recalculateLogsTable()"></select><!--spanmd-select.no-padding(aria-label="Program",ng-model="vm.admin.clSelection.selected",ng-change="vm.recalculateLogsTable()")\n    md-option(ng-value="x" ng-repeat="x in vm.admin.clSelection.filters | orderBy: x") {{ x }}--></div><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.createNew()"><md-icon class="white_icon" style="margin-left: -5px" md-svg-icon="/public/images/star-outline.svg"></md-icon>&nbsp;Create New</md-button></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><table class="ibm-data-table ibm-alternate-two table" ng-if="vm.dataLoaded" cellspacing="0" cellpadding="0" border="1"><thead><tr><th ng-repeat="head in vm.table.header">{{head}}</th></tr></thead><tbody><tr ng-repeat="line in vm.logsTable"><td><span ng-click="vm.showSingleLog(line.value.sl)" title="View checklist"><md-icon md-svg-src="/public/images/ic_remove_red_eye_black_24px.svg"></md-icon></span><span ng-click="vm.copyLog(line.value.sl)" title="Copy to create new checklist"><md-icon md-svg-src="/public/images/ic_content_copy_black_24px.svg"></md-icon></span><span ng-click="vm.editMode(line.value.sl)" ng-if="line.value.active !== false" title="Edit checklist"><md-icon md-svg-icon="/public/images/ic_edit_black_24px.svg"></md-icon></span><span title="{{line.value.desc || \'No description provided\'}}"><md-icon md-svg-icon="/public/images/ic_info_outline_black_24px.svg"></md-icon></span></td><td><span>{{line.value.name || line.value.sl}}</span></td><td><span ng-repeat="iot in line.value.iots"><span>{{iot}}</span></span></td><td><span>{{line.value.active || \'Draft\'}}</span></td><td><span>{{line.value.effStartDate | date: \'medium\': \'UTC\'}}</span></td><td> <span>{{line.value.deactivatedOn | date: \'medium\': \'UTC\'}}</span></td></tr></tbody></table></div></div></div></div></div></div></div></main>');
$templateCache.put('checklist.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"></main><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Program Checklist Profile</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!(vm.dataLoaded) &amp;&amp; vm.settings.loaded">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div><div class="ibm-col-6-1"><span><a ng-click="vm.backToView()"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Back to View</a></span></div></div><div ng-form="vm.clForm" ng-show="vm.dataLoaded &amp;&amp; vm.settings.loaded"><div class="ibm-columns"><div class="ibm-col-6-5"><div ng-if="!vm.events.beingSaved">Please enter the details for the Program Checklist Profile. &nbsp;Once all mandatory fields (<req></req>) are completed, the&nbsp;<b>Save&nbsp;</b>button will become available.</div><div ng-if="vm.okMessage"><span class="green_text">{{vm.okMessage}}</span></div><div ng-if="vm.errorMessage"><span class="red_text">{{vm.errorMessage}}</span></div></div><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-disabled="!(vm.clForm.$valid &amp;&amp; vm.modified)" ng-click="vm.savePage($event)"><md-icon class="white_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Save</md-button></div><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-disabled="!(vm.clForm.$valid &amp;&amp; vm.sl !== \'new\')" ng-click="vm.createCopy()"><md-icon class="white_icon" md-svg-icon="/public/images/ic_content_copy_black_24px.svg"></md-icon>&nbsp;Copy</md-button></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Name&nbsp;</label><req></req></div><div class="ibm-col-6-2 field" ng-if="vm.stage &lt; 2"><input type="text" ng-model="vm.clTemp.name" ng-change="vm.modified = true;"/></div><div class="ibm-col-6-2 field" ng-if="vm.stage &gt; 1"><label ng-bind="vm.clTemp.name"></label></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Program&nbsp;</label><req></req></div><div class="ibm-col-6-2 field" ng-if="vm.stage &lt; 1"><md-select class="no-padding" aria-label="Program" ng-model="vm.clTemp.data.pickedProgram" ng-required="true"><md-option ng-value="x" ng-repeat="x in vm.settings.programs | orderBy: x">{{ x }}</md-option></md-select></div><div class="ibm-col-6-2 field" ng-if="vm.stage &gt; 0"><span ng-bind="vm.clTemp.data.pickedProgram"></span></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">IOT&nbsp;</label><req></req></div><div class="ibm-col-6-2 field" ng-if="vm.stage &lt; 2"><md-select class="no-padding" aria-label="iot" ng-model="vm.clTemp.data.pickedIots" ng-required="true" multiple="multiple" ng-change="vm.changedIot()"><md-option ng-value="x" ng-repeat="x in vm.settings.iot_list | orderBy: \'toString()\'">{{ x }}</md-option></md-select></div><div class="ibm-col-6-2 field" ng-if="vm.stage &gt; 1"><ul><li ng-repeat="iot in vm.clTemp.data.pickedIots">{{iot}}</li></ul></div></div><div class="ibm-columns" ng-if="vm.stage &lt; 2"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Effective from &nbsp;</label></div><div class="ibm-col-6-2 field"><md-datepicker ng-model="vm.effStartDate" ng-change="vm.changedEffDate()" ng-model-options="{ timezone: \'utc\' }"></md-datepicker></div></div><div class="ibm-columns" ng-if="vm.clTemp.effStartDate"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Effective Time (UTC) &nbsp;</label></div><div class="ibm-col-6-2 field"><label>{{vm.clTemp.effStartDate | date: \'medium\' : \'UTC\'}}</label></div></div><div class="ibm-columns" ng-if="vm.clTemp.effStartDate"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Effective Time (Local) &nbsp;</label></div><div class="ibm-col-6-2 field"><label>{{vm.clTemp.effStartDate | date: \'medium\'}}</label></div></div><div class="ibm-columns" ng-if="vm.clTemp.enabledBy"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Enabled by &nbsp;</label></div><div class="ibm-col-6-2 field"><label>{{vm.clTemp.enabledBy}}</label></div></div><div class="ibm-columns" ng-if="vm.clTemp.enabledOn"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Enabled on &nbsp;</label></div><div class="ibm-col-6-2 field"><label>{{vm.clTemp.enabledOn | date: \'medium\' : \'UTC\'}}</label></div></div><div class="ibm-columns" ng-if="vm.stage &gt; 1"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Active? &nbsp;</label></div><div class="ibm-col-6-2 field" ng-if="vm.stage !== 3"><md-switch class="md-primary" title="By disabling this checklist, you can never enable it again!!!" aria-label="active" ng-model="vm.clTemp.active" ng-change="vm.modified = true;">{{vm.clTemp.active}}</md-switch></div><div class="ibm-col-6-2 field" ng-if="vm.stage === 3"><label>{{vm.clTemp.active}}</label></div></div><div class="ibm-columns" ng-if="vm.clTemp.deactivatedBy"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Deactivated by &nbsp;</label></div><div class="ibm-col-6-2 field"><label>{{vm.clTemp.deactivatedBy}}</label></div></div><div class="ibm-columns" ng-if="vm.clTemp.deactivatedOn"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Deactivated on &nbsp;</label></div><div class="ibm-col-6-2 field"><label>{{vm.clTemp.deactivatedOn | date: \'medium\' : \'UTC\'}}</label></div></div><div class="ibm-columns" ng-repeat="cl in vm.admin.listOfCheckList"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">{{cl.name}}&nbsp;</label></div><div class="ibm-col-6-4 field"><div class="selectbox_bottom select_good" style="display: flex"><span class="checkbox_subcontainer" style="padding: 8px 0px 8px 0px"><span ng-click="vm.expand(cl.name)" ng-if="!cl.visible"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_expand_more_black_24px.svg" style="margin-left:9px;margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Expand</a></span><span ng-click="vm.collapse(cl.name)" ng-if="cl.visible &amp;&amp; !cl.editView"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_keyboard_arrow_left_black_24px.svg" style="margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Collapse</a></span><span ng-click="vm.editSection(cl.name)" ng-if="!cl.editView &amp;&amp; vm.editMain"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_edit_black_24px.svg" style="margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Edit</a></span><span ng-click="vm.cancelSection(cl.name)" ng-if="cl.editView"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_cancel_black_24px.svg" style="margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Cancel</a></span><span ng-click="vm.saveSection(cl.name)" ng-if="cl.editView &amp;&amp; vm.modifiedItem"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_save_black_24px.svg" style="margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Save</a></span></span></div><div ng-if="cl.visible &amp;&amp; cl.editView"><table class="ibm-data-table" ng-if="vm.clTemp.data[cl.variableName].length&gt; 0"><thead><tr><th>Actions</th><th>Question</th></tr></thead><tbody><tr ng-repeat="clItem in vm.clTemp.data[cl.variableName]"><td ng-if="clItem.editMode"><span ng-click="vm.saveItem(cl.variableName, $index)" title="Save row"><md-icon class="green_icon" md-svg-icon="public/images/ic_save_black_24px.svg"></md-icon></span><span ng-click="vm.cancelItem(cl.variableName, $index)" title="Cancel changes in row"><md-icon md-svg-icon="public/images/ic_cancel_black_24px.svg"></md-icon></span><span ng-click="vm.removeItem(cl.variableName, $index)" title="Delete row"><md-icon class="red_icon" md-svg-icon="public/images/ic_remove_circle_black_24px.svg"></md-icon></span></td><td ng-if="clItem.editMode"><span ng-if="clItem.expected &amp;&amp; clItem.expected !== clItem.answer" title="Expected answer is: {{clItem.expected}}"><md-icon class="orange_icon" md-svg-icon="public/images/ic_sms_failed_black_24px.svg"></md-icon></span><input ng-model="clItem.q"/><br/><div layout="row"><span flex="50">is header?</span><input type="checkbox" ng-model="clItem.head" ng-true-value="true" ng-false-value="undefined" flex="50"/></div><div layout="row"><span flex="50">is final?</span><input type="checkbox" ng-model="clItem.final" ng-true-value="true" ng-false-value="undefined" flex="50"/></div><!--div(layout="row")span(flex="50") Disable?\ninput(type="checkbox",ng-model="clItem.d",ng-true-value="true",ng-false-value="undefined",flex="50")--><div layout="row"><span>Set a action to checklist:</span></div><div layout="row"><md-select class="no-padding" aria-label="cl action" ng-model="clItem.i"><md-option ng-value="action.id" ng-repeat="action in vm.actionList" title="{{action.desc}}">{{ action.name }}</md-option></md-select></div><div layout="row"><span>Section:</span></div><div layout="row"><input type="number" ng-model="clItem.sec"/></div><div layout="row"><span>Additional answer:</span></div><div layout="row"><span title="Add new answer"><md-icon md-svg-icon="public/images/ic_add_circle_black_24px.svg" ng-click="vm.addAnswer(clItem)"></md-icon><input ng-model="vm.tempAnswer"/><span class="ibm-input-group ibm-radio-group"><span ng-repeat="answer in clItem.addA">{{answer}}:<span><input type="radio" value="{{answer}}" name="{{cl.radioButtonName + $index}}" ng-model="clItem.answer" ng-disabled="false"/><md-icon class="red_icon" ng-click="vm.removeAnswer(clItem, answer)" md-svg-icon="public/images/ic_remove_circle_black_24px.svg"></md-icon></span></span></span></span></div><div layout="row"><span>Expected result:</span></div><div layout="row"><input type="text" ng-model="clItem.expected"/></div></td><td ng-if="clItem.editMode &amp;&amp; !clItem.addA"><span class="ibm-input-group ibm-radio-group" ng-if="!clItem.head"><b ng-if="clItem.answer === \'Yes\'">Yes</b><span ng-if="clItem.answer !== \'Yes\'">Yes</span><span><input type="radio" value="{{\'Yes\'}}" name="{{cl.radioButtonName + $index}}" ng-model="clItem.answer"/></span></span></td><td ng-if="clItem.editMode &amp;&amp; !clItem.addA"><span class="ibm-input-group ibm-radio-group" ng-if="!clItem.head"><b ng-if="clItem.answer === \'No\'">No</b><span ng-if="clItem.answer !== \'No\'">No</span><span><input type="radio" value="{{\'No\'}}" name="{{cl.radioButtonName + $index}}" ng-model="clItem.answer"/></span></span></td><td ng-if="clItem.editMode" ng-repeat="answer in clItem.addA"><b ng-if="clItem.answer === answer">{{answer}}</b><span ng-if="clItem.answer !== answer">{{answer}}<input type="radio" value="{{answer}}" name="{{cl.radioButtonName + $index}}" ng-model="clItem.answer" ng-disabled="true"/></span></td><td ng-if="clItem.editMode"><input ng-model="clItem.answer" title="This is the selected answer, in case you want to remove selection just clear this"/></td><td ng-if="!clItem.editMode"><span ng-if="vm.editCl"><span ng-click="vm.addItemLine(cl.variableName, $index)" title="Add new row"><md-icon class="green_icon" md-svg-icon="public/images/ic_add_circle_black_24px.svg"></md-icon></span><span ng-click="vm.editItem(cl.variableName, $index)" title="Edit row"><md-icon class="black_icon" md-svg-icon="public/images/ic_edit_black_24px.svg"></md-icon></span></span><span ng-if="!vm.editCl"><span title="Add new row"><md-icon class="gery_icon" md-svg-icon="public/images/ic_add_circle_black_24px.svg"></md-icon></span><span title="Edit row"><md-icon class="grey_icon" md-svg-icon="public/images/ic_edit_black_24px.svg"></md-icon></span></span><!--span(ng-if="clItem.d",title="Disabled")md-icon(class="red_icon" md-svg-icon="public/images/ic_do_not_disturb_alt_black_24px.svg")--></td><td ng-if="!clItem.editMode"><span ng-if="clItem.expected &amp;&amp; clItem.expected !== clItem.answer" title="Expected answer is: {{clItem.expected}}"><md-icon class="orange_icon" md-svg-icon="public/images/ic_sms_failed_black_24px.svg"></md-icon></span><b ng-if="clItem.head">{{clItem.q}}</b><span ng-if="!clItem.head">{{clItem.q}}</span></td><td ng-if="!clItem.editMode &amp;&amp; !clItem.addA"><b ng-if="clItem.answer === \'Yes\'">Yes</b><span ng-if="clItem.answer !== \'Yes\'"> <span>Yes</span><span><input type="radio" value="{{\'Yes\'}}" name="{{cl.radioButtonName + $index}}" ng-model="clItem.answer" ng-disabled="true"/></span></span></td><td ng-if="!clItem.editMode &amp;&amp; !clItem.addA"><b ng-if="clItem.answer === \'No\'">No</b><span ng-if="clItem.answer !== \'No\'"> <span>No</span><span><input type="radio" value="{{\'No\'}}" name="{{cl.radioButtonName + $index}}" ng-model="clItem.answer" ng-disabled="true"/></span></span></td><td ng-if="!clItem.editMode" ng-repeat="answer in clItem.addA"><b ng-if="clItem.answer === answer">{{answer}}</b><span ng-if="clItem.answer !== answer"> <span>{{answer}}</span><span> <input type="radio" value="{{answer}}" name="{{cl.radioButtonName + $index}}" ng-model="clItem.answer" ng-disabled="true"/></span></span></td></tr></tbody></table><div ng-if="vm.clTemp.data[cl.variableName].length == 0"><span>Please add a new Check List question</span></div><div ng-click="vm.addItem(cl.variableName)" ng-if="vm.editCl"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_add_circle_black_24px.svg" style="margin-left:9px;margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Add Check List Question</a></div><div ng-if="!vm.editCl"><md-icon class="grey_icon" md-svg-icon="/public/images/ic_add_circle_black_24px.svg" style="margin-left:9px;margin-right:12px"></md-icon><a class="ibm-textcolor-grey-50" style="margin-left: -9px; margin-right: 15px">Add Check List Question</a></div><br/><div><div><b>Radio button description:</b><input ng-model="vm.clTemp.data[cl.radioButtonName].desc" ng-change="vm.modification()"/></div><div><span ng-repeat="rbItem in vm.clTemp.data[cl.radioButtonName].rb" for="{{cl.radioButtonName}}"><input ng-model="rbItem.item" ng-change="vm.modification()"/><span class="ibm-input-group ibm-radio-group"><input type="radio" value="{{rbItem.value}}" name="{{cl.radioButtonName}}" ng-model="vm.clTemp.data[cl.radioButtonName].picked" ng-disabled="false" ng-change="vm.modification()"/></span><span><md-icon class="red_icon" ng-click="vm.removeRbItem(cl.radioButtonName,$index)" md-svg-icon="public/images/ic_remove_circle_black_24px.svg"></md-icon></span></span></div><div><span ng-click="vm.addRb(cl.radioButtonName)"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_add_circle_black_24px.svg" style="margin-left:9px;margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Add Radio Button Option</a></span><span ng-click="vm.clearRb(cl.radioButtonName)" ng-if="vm.clTemp.data[cl.radioButtonName].picked != \'\'"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_more_horiz_black_24px.svg" style="margin-left:9px;margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Clear selection</a></span></div></div></div><div ng-if="cl.visible &amp;&amp; !cl.editView"><table class="ibm-data-table" ng-if="vm.clTemp.data[cl.variableName].length&gt; 0"><thead><tr><th>Question</th></tr></thead><tbody><tr ng-repeat="clItem in vm.clTemp.data[cl.variableName]"><td ng-if="!clItem.editMode"><span ng-if="clItem.expected &amp;&amp; clItem.expected !== clItem.answer" title="Expected answer is: {{clItem.expected}}"><md-icon class="orange_icon" md-svg-icon="public/images/ic_sms_failed_black_24px.svg"></md-icon></span><b ng-if="clItem.head">{{clItem.q}}</b><span ng-if="!clItem.head">{{clItem.q}}</span></td><td ng-if="!clItem.editMode &amp;&amp; !clItem.addA"><b ng-if="clItem.answer === \'Yes\'">Yes</b><span ng-if="clItem.answer !== \'Yes\'"> <span>Yes</span><span><input type="radio" value="{{\'Yes\'}}" name="{{cl.radioButtonName + $index}}" ng-model="clItem.answer" ng-disabled="true"/></span></span></td><td ng-if="!clItem.editMode &amp;&amp; !clItem.addA"><b ng-if="clItem.answer === \'No\'">No</b><span ng-if="clItem.answer !== \'No\'"> <span>No</span><span><input type="radio" value="{{\'No\'}}" name="{{cl.radioButtonName + $index}}" ng-model="clItem.answer" ng-disabled="true"/></span></span></td><td ng-if="!clItem.editMode" ng-repeat="answer in clItem.addA"><b ng-if="clItem.answer === answer">{{answer}}</b><span ng-if="clItem.answer !== answer"> <span>{{answer}}</span><span><input type="radio" value="{{answer}}" name="{{cl.radioButtonName + $index}}" ng-model="clItem.answer" ng-disabled="true"/></span></span></td></tr></tbody></table><div ng-if="vm.clTemp.data[cl.variableName].length == 0"><span>No Check List Questions Found</span></div><div><span><b ng-if="vm.clTemp.data[cl.radioButtonName].desc != \'\'">{{vm.clTemp.data[cl.radioButtonName].desc}}:&nbsp;</b><span ng-repeat="rbItem in vm.clTemp.data[cl.radioButtonName].rb" for="{{cl.radioButtonName}}">{{rbItem.item}}:<span class="ibm-input-group ibm-radio-group"><input type="radio" value="{{rbItem.value}}" name="{{cl.radioButtonName}}" ng-model="rbItem.picked" ng-disabled="true"/></span></span></span></div></div></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Description&nbsp;</label><req></req></div><div class="ibm-col-6-2 field" ng-if="vm.stage &lt; 2"><textarea ng-model="vm.clTemp.desc" ng-change="vm.modified = true;"></textarea></div><div class="ibm-col-6-2 field" ng-if="vm.stage &gt; 1"><label ng-bind="vm.clTemp.desc"></label></div></div></div></div></div></div></div></main>');
$templateCache.put('conflicts.html','<style>.conflicts {\n    border: solid 1px lightgray;\n    max-height: 500px;\n    height: 300px;\n    overflow: scroll;\n    overflow-x: hidden;\n    padding: 10px;\n}\ntable, td {\n    border-color: lightgray;\n}\ntable {\n    width: inherit;\n}</style><p></p><md-icon class="red_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;<a ng-click="vm.conflicts.viewDetails = !vm.conflicts.viewDetails"><span class="ibm-textcolor-red-60">{{!vm.conflicts.viewDetails ? "View Conflict Details" : "Hide Conflict Details"}}</span><p></p></a><div class="conflicts" ng-if="vm.conflicts.viewDetails"><p>The following&nbsp;<b>{{vm.conflicts.details.length}}&nbsp;</b>Program Profile combinations already exist. &nbsp;Either remove these conflicts from this Profile, or update the Profiles indicated in the table.</p><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-disabled="vm.conflicts.resolved" ng-click="vm.removeConflicts()"><md-icon class="white_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Remove Conflicts</md-button><span class="ibm-textcolor-red-60" ng-if="vm.conflicts.resolved">&nbsp;&nbsp;&nbsp;The conflicting Countries have been successfully removed from selection.</span><table class="ibm-data-table ibm-altrows ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1"><thead><tr ng-repeat="hd in vm.conflicts.headers"><td ng-repeat="(key,value) in hd">{{key}}</td></tr></thead><tBody><tr ng-repeat="dupe in vm.conflicts.details"><td ng-repeat="(key, value) in dupe"><span>{{value}}</span></td></tr></tBody></table><p></p></div><br/>');
$templateCache.put('detail-cl-single-log.html','<!-- author Ivan Toth--><md-dialog aria-label="{{vm.field}}" ng-cloak="ng-cloak"><md-toolbar><div class="md-toolbar-tools"><h2>{{::vm.dialogName}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.answer()" title="Create editable copy of this log"><md-icon class="white_icon" md-svg-src="/public/images/ic_content_copy_black_24px.svg" aria-label="Close dialog"></md-icon></md-button><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"> </md-icon></md-button></div></md-toolbar><md-dialog-content><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Name&nbsp;</label></div><div class="ibm-col-6-2 field"><label ng-bind="vm.logInfo.name"></label></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Program&nbsp;</label><req></req></div><div class="ibm-col-6-2 field"><span ng-bind="vm.logInfo.data.pickedProgram" ng-required="true"></span></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">IOT&nbsp;</label><req></req></div><div class="ibm-col-6-2 field"><ul><li ng-repeat="iot in vm.logInfo.data.pickedIots">{{iot}}</li></ul></div></div><div class="ibm-columns" ng-if="vm.logInfo.effStartDate"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Effective Time (UTC) &nbsp;</label></div><div class="ibm-col-6-2 field"><label>{{vm.logInfo.effStartDate | date: \'medium\' : \'UTC\'}}</label></div></div><div class="ibm-columns" ng-if="vm.logInfo.enabledBy"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Enabled by &nbsp;</label></div><div class="ibm-col-6-2 field"><label>{{vm.logInfo.enabledBy}}</label></div></div><div class="ibm-columns" ng-if="vm.logInfo.enabledOn"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Enabled on &nbsp;</label></div><div class="ibm-col-6-2 field"><label>{{vm.logInfo.enabledOn | date: \'medium\' : \'UTC\'}}</label></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Active? &nbsp;</label></div><div class="ibm-col-6-2 field"><label>{{vm.logInfo.active || \'Not enabled.\'}}</label></div></div><div class="ibm-columns" ng-if="vm.logInfo.deactivatedBy"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Deactivated by &nbsp;</label></div><div class="ibm-col-6-2 field"><label>{{vm.logInfo.deactivatedBy}}</label></div></div><div class="ibm-columns" ng-if="vm.logInfo.deactivatedOn"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Deactivated on &nbsp;</label></div><div class="ibm-col-6-2 field"><label>{{vm.logInfo.deactivatedOn | date: \'medium\' : \'UTC\'}}</label></div></div><div class="ibm-columns" ng-repeat="cl in vm.admin.listOfCheckList"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">{{cl.name}}&nbsp;</label></div><div class="ibm-col-6-4 field"><div class="selectbox_bottom select_good" style="padding-top: 14px; padding-bottom: 14px"><span class="checkbox_subcontainer" style="padding: 8px 0px 9px 0px"></span></div><div><table class="ibm-data-table" ng-if="vm.logInfo.data[cl.variableName].length&gt; 0"><thead><tr><th>Question</th></tr></thead><tbody><tr ng-repeat="clItem in vm.logInfo.data[cl.variableName]"><td><span ng-if="clItem.expected &amp;&amp; clItem.expected !== clItem.answer" title="Expected answer is: {{clItem.expected}}"><md-icon class="orange_icon" md-svg-icon="public/images/ic_sms_failed_black_24px.svg"></md-icon></span><b ng-if="clItem.head">{{clItem.q}}</b><span ng-if="!clItem.head">{{clItem.q}}</span></td><td ng-if="!clItem.addA"><b ng-if="clItem.answer === \'Yes\'">Yes</b><span ng-if="clItem.answer !== \'Yes\'"> <span>Yes</span><span><input type="radio" value="{{\'Yes\'}}" name="{{$index}}" ng-model="clItem.answer" ng-disabled="true"/></span></span></td><td ng-if="!clItem.addA"><b ng-if="clItem.answer === \'No\'">No</b><span ng-if="clItem.answer !== \'No\'"> <span>No</span><span><input type="radio" value="{{\'No\'}}" name="{{$index}}" ng-model="clItem.answer" ng-disabled="true"/></span></span></td><td ng-repeat="answer in clItem.addA"> <b ng-if="clItem.answer === answer">{{answer}}</b><span ng-if="clItem.answer !== answer"> <span>{{answer}}</span><span><input type="radio" value="{{answer}}" name="{{$index}}" ng-model="clItem.answer" ng-disabled="true"/></span></span></td></tr></tbody></table><br/><div><span><b ng-if="vm.logInfo.data[cl.radioButtonName].desc === undefined || vm.logInfo.data[cl.radioButtonName].desc != \'\'">{{vm.logInfo.data[cl.radioButtonName].desc}}:&nbsp;</b><span ng-repeat="rbItem in vm.logInfo.data[cl.radioButtonName].rb" for="{{cl.radioButtonName}}">{{rbItem.item}}:<span class="ibm-input-group ibm-radio-group"><input type="radio" value="{{rbItem.value}}" name="{{cl.radioButtonName}}" ng-model="rbItem.picked" ng-disabled="true"/></span></span></span></div></div></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Description&nbsp;</label></div><div class="ibm-col-6-2 field"><label ng-bind="vm.logInfo.desc"></label></div></div></md-dialog-content></md-dialog>');
$templateCache.put('codes-view.html','<style>table, td {\n    border-color: lightgray;\n}\ntable {\n    width: inherit;\n}\na.link {\n    text-decoration: none;\n}\n.desc {\n    border: 1px lightgray solid;\n    border-radius: 5px;\n    margin-left: 1em;\n    padding: 8px;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><!--| {{vm.codes}}--><!--p--><!--| {{vm.codeTypes}}--><!--| {{vm.table}}--><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Miscellaneous Codes</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="!vm.codesLoaded">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span ng-if="vm.codesLoaded"></span></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div></div><edit-misc-codes-section parent="vm" codepack="vm.editCodePack" ng-if="vm.editing"></edit-misc-codes-section><div ng-if="!vm.editing &amp;&amp; vm.codesLoaded"><div class="ibm-columns"><div class="ibm-col-6-5"><span ng-if="!vm.events.beingSaved &amp;&amp; !vm.serverError">Please select the set of codes you\'d like to view, and use the actions to edit/delete, or create a new one via the&nbsp;<b>Create New&nbsp;</b>button.                            </span><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="vm.events.beingSaved">Updating...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span class="ibm-textcolor-red-40" ng-if="vm.serverError" ng-bind-html="vm.serverError"></span></div><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-disabled="vm.events.beingSaved" ng-click="vm.createNew()" title="Create New Code"><md-icon class="white_icon" style="margin-left: -5px" md-svg-icon="/public/images/star-outline.svg"></md-icon>&nbsp;Create New</md-button></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><select style="width: 20em" ng-model="vm.selectedType" ng-options="o as vm.admin.toProperCase(o) for o in vm.codeTypes | orderBy: o"></select><span class="desc ibm-textcolor-blue-40" ng-if="vm.selectedType">{{vm.codes[vm.selectedType].desc}}</span><p></p><div ng-if="!vm.table.filter"><span class="search_box"><md-icon class="blue_icon" md-svg-icon="/public/images/magnify.svg"></md-icon></span><input class="userField" ng-model="vm.table.search" placeholder="Enter search criteria"/>&nbsp;&nbsp;<p></p></div><table class="ibm-data-table ibm-altrows ibm-alternate-two table" ng-if="vm.selectedType" cellspacing="0" cellpadding="0" border="1"><thead><tr ng-repeat="hd in vm.table.headers"><td ng-repeat="(value,key) in hd" ng-style="key!==\'desc\' &amp;&amp; {\'text-align\':\'center\'} || {\'text-align\': \'left\'}"><span ng-if="key === \'actions\'">{{value}}</span><span ng-if="key !== \'actions\'"><a class="link" ng-click="vm.table.sortType = key; vm.table.sortReverse = !vm.table.sortReverse">{{value}}&nbsp;</a><span ng-show="vm.table.sortType==key &amp;&amp; !vm.table.sortReverse"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_expand_less_black_24px.svg"></md-icon></span><span ng-show="vm.table.sortType==key &amp;&amp; vm.table.sortReverse"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_expand_more_black_24px.svg"></md-icon></span></span></td></tr></thead><tBody><tr ng-if="vm.codes[vm.selectedType].codes.length === 0"><td colspan="4" style="text-align: center; background-color: whitesmoke; padding: 10px; font-size: 15px"> No codes available - click&nbsp;<b>Create New</b>&nbsp;to add</td></tr><tr ng-repeat="code in vm.codes[vm.selectedType].codes | orderBy:vm.table.sortType:vm.table.sortReverse | filter:(vm.table.filter ? vm.table.filterParams : vm.table.search)"><td style="width: 5em; text-align: center">{{::code.type}}</td><td style="width: 5em; text-align: center">{{::code.code}}</td><td>{{::code.desc}}</td><td style="width: 8em;text-align: center"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50 md-icon-button" ng-disabled="vm.events.beingSaved" aria-label="Edit Code" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;" ng-click="vm.editCode(code.code)" title="Edit Code"><md-icon class="white_icon" md-svg-icon="/public/images/lead-pencil.svg"></md-icon>&nbsp;&nbsp;</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50 md-icon-button" ng-disabled="vm.events.beingSaved" aria-label="Edit Code" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;" ng-click="vm.confirmDelete($event, {code:code.code, desc:code.desc})" title="Delete Code"><md-icon class="white_icon" md-svg-icon="/public/images/delete-forever.svg"></md-icon></md-button></td></tr></tBody></table><p></p></div></div></div></div></div></div></div></main>');
$templateCache.put('codes.html','<style>.field{ padding-bottom: 10px;}</style><div class="ibm-columns"><div class="ibm-col-6-5"><span class="ibm-textcolor-blue-50 ibm-h3"> <b>{{::$ctrl.parent.admin.toProperCase($ctrl.codepack.code_set)}}</b></span><span class="desc ibm-textcolor-blue-40">{{::$ctrl.parent.codes[$ctrl.codepack.code_set].desc}}</span><p></p><p></p><span ng-if="!$ctrl.parent.events.beingSaved &amp;&amp; !$ctrl.parent.serverError"> Please update the details for the Code Profile. &nbsp;Once all mandatory fields (<req></req>) are completed, the&nbsp;<b>Save&nbsp;</b>button will become available.</span><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="$ctrl.parent.events.beingSaved">Updating...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span class="ibm-textcolor-red-40" ng-if="$ctrl.parent.serverError" ng-bind-html="$ctrl.parent.serverError"></span><p></p></div><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="$ctrl.parent.save()" title="Save your updates" ng-disabled="$ctrl.$scope.codeForm.$pristine || $ctrl.parent.events.beingSaved || !$ctrl.$scope.codeForm.$valid"><md-icon class="white_icon" style="margin-left: -5px" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Save</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="$ctrl.parent.editing=false; $ctrl.parent.serverError=false" title="Discard your updates and return to view"><md-icon class="white_icon" style="margin-left: -5px" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Cancel</md-button></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><!--| CODEPACK {{$ctrl.codepack}}--><!--p--><!--| CODEPACK2 {{$ctrl.parent.editCodePack}}--><form name="codeForm"><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Code Type&nbsp;</label><req></req></div><div class="ibm-col-6-4 field"><select class="userField" ng-if="$ctrl.codepack.code_set==\'dispute_codes\' &amp;&amp; $ctrl.codepack.new" ng-change="$ctrl.codepack.code=$ctrl.parent.getNextCode($ctrl.codepack.code_set,$ctrl.codepack.type)" style="width: 8em" ng-model="$ctrl.codepack.type" ng-options="o as o for o in $ctrl.parent.subTypes[$ctrl.codepack.code_set]"></select><span ng-if="($ctrl.codepack.code_set==\'dispute_codes\' &amp;&amp; !$ctrl.codepack.new) || $ctrl.codepack.code_set!==\'dispute_codes\'">{{$ctrl.codepack.type}}                    </span></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Code&nbsp;</label><req></req></div><div class="ibm-col-6-4 field"><!--input(placeholder="Enter a unique Code" size="15em" class="userField" ng-model="$ctrl.codepack.code"  ng-required="true")--><b>{{$ctrl.codepack.code}}</b><span ng-if="$ctrl.codepack.new">&nbsp;&nbsp;<md-icon class="orange_icon" title="New Code" md-svg-icon="/public/images/star-circle.svg"></md-icon></span></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Description&nbsp;</label><req></req></div><div class="ibm-col-6-4 field"><input class="userField" placeholder="Enter the Description" size="60em" ng-model="$ctrl.codepack.desc" ng-required="true"/></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50" title="Set to Yes if this Code is an \'Other\' code and requires the user to enter something extra">Further Description Required&nbsp;</label><req></req></div><div class="ibm-col-6-4 field"><input type="radio" ng-model="$ctrl.codepack.other" ng-value="true"/>Yes<input type="radio" ng-model="$ctrl.codepack.other" ng-value="false"/>No</div></div></form></div></div>');
$templateCache.put('columns-log.html','<!-- author Ivan Toth--><md-dialog aria-label="{{vm.field}}" ng-cloak="ng-cloak"><md-toolbar><div class="md-toolbar-tools"><h2>{{::vm.dialogName}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Program&nbsp;</label><req></req></div><div class="ibm-col-6-2 field"><span ng-bind="vm.logInfo.data.pickedProgram" ng-required="true"></span></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">IOT&nbsp;</label><req></req></div><div class="ibm-col-6-2 field"><ul><li ng-repeat="iot in vm.logInfo.data.pickedIots">{{iot}}</li></ul></div></div><div class="ibm-columns" ng-repeat="cl in vm.admin.listOfCheckList"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">{{cl.name}}&nbsp;</label></div><div class="ibm-col-6-4 field"><div class="selectbox_bottom select_good" style="padding-top: 14px; padding-bottom: 14px"><span class="checkbox_subcontainer" style="padding: 8px 0px 9px 0px"></span></div><div><table class="ibm-data-table" ng-if="vm.logInfo.data[cl.variableName].length&gt; 0"><thead><tr><th>Question</th><th>Yes</th><th>No</th><th>Alternate Answer</th></tr></thead><tbody><tr ng-repeat="clItem in vm.logInfo.data[cl.variableName]"><td><b ng-if="clItem.head">{{clItem.q}}</b><span ng-if="!clItem.head">{{clItem.q}}</span></td><td><span ng-if="clItem.answer == \'Yes\'">{{clItem.answer}}</span></td><td><span ng-if="clItem.answer == \'No\'">{{clItem.answer}}</span></td><td><span ng-bind="clItem.answer"></span></td></tr></tbody></table><br/><div><span><b ng-if="vm.logInfo.data[cl.radioButtonName].desc === undefined || vm.logInfo.data[cl.radioButtonName].desc != \'\'">{{vm.logInfo.data[cl.radioButtonName].desc}}:&nbsp;</b><span ng-repeat="rbItem in vm.logInfo.data[cl.radioButtonName].rb" for="{{cl.radioButtonName}}">{{rbItem.item}}:<span class="ibm-input-group ibm-radio-group"><input type="radio" value="{{rbItem.value}}" name="{{cl.radioButtonName}}" ng-model="rbItem.picked" ng-disabled="true"/></span></span></span></div></div></div></div></md-dialog-content></md-dialog>');
$templateCache.put('columns-view.html','<style>table, td {\n    border-color: lightgray;\n}\ntable {\n    width: inherit;\n}\na.link {\n    text-decoration: none;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Search Table Header and Order settings</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!vm.dataLoaded">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span ng-if="vm.dataLoaded"></span></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div><div class="ibm-columns"><div class="ibm-col-6-5">Please select a Table Header or Order to view/edit, or create a new one via the&nbsp;<b>Create New&nbsp;</b>button.</div><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-if="vm.dataLoaded" ng-click="vm.createNew()"><md-icon class="white_icon" style="margin-left: -5px" md-svg-icon="/public/images/star-outline.svg"></md-icon>&nbsp;Create New</md-button></div></div><div class="ibm-columns"><div class="ibm-col-6-3"><table class="fit_table ibm-data-table ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1"><thead><tr><th ng-repeat="head in vm.table.headerNames">{{head.header}}</th></tr></thead><tbody ng-repeat="line in vm.table.dataNames"><tr><td rowspan="{{line.versions.length}}"><span>{{line.ds}}</span></td><td><span ng-if="line.versions[0].versionName === line.current"><span class="red_text" ng-bind="\'*\'" title="Current/ actual column layout"></span></span><span>{{line.versions[0].versionName}}</span></td><td><span ng-if="!line.versions[0].visiblemain"><md-icon md-svg-src="/public/images/ic_remove_red_eye_black_24px.svg" title="View Column Order" ng-click="vm.showColumns(line.versions[0],\'main\')"></md-icon></span><span ng-if="line.versions[0].visiblemain"><md-icon md-svg-src="/public/images/ic_visibility_off_black_24px.svg" title="View Column Order" ng-click="vm.showColumns(line.versions[0],\'main\')"></md-icon></span><ul ng-if="line.versions[0].visiblemain"><li class="zero_top_padding" ng-repeat="main in line.versions[0].columnLayout.main">{{main}}</li></ul></td><td><ul><li class="zero_top_padding" ng-repeat="second in line.versions[0].columnLayout.second">{{second}}</li></ul></td></tr><tr ng-repeat="columnItem in line.versions" ng-show="$index &gt; 0"><td><span ng-if="columnItem.versionName === line.current"><span class="red_text" ng-bind="\'*\'" title="Current/ actual column layout"></span></span><span>{{columnItem.versionName}}</span></td><td><ul><li class="zero_top_padding" ng-repeat="main in columnItem.columnLayout.main">{{main}}</li></ul></td><td><ul><li class="zero_top_padding" ng-repeat="second in columnItem.columnLayout.second">{{second}}</li></ul></td></tr></tbody></table></div><div class="ibm-col-6-2"><table class="fit_table ibm-data-table ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1"><thead><tr><th ng-repeat="head in vm.table.headerNames">{{head.header}}</th></tr></thead><tbody ng-repeat="line in vm.table.dataNames"><tr><td rowspan="{{line.versions.length}}"><span>{{line.ds}}</span></td><td><span ng-if="line.versions[0].versionName === line.current"><span class="red_text" ng-bind="\'*\'" title="Current/ actual column layout"></span></span><span>{{line.versions[0].versionName}}</span></td><td><ul><li class="zero_top_padding" ng-repeat="main in line.versions[0].columnLayout.main">{{main}}</li></ul></td><td><ul><li class="zero_top_padding" ng-repeat="second in line.versions[0].columnLayout.second">{{second}}</li></ul></td></tr><tr ng-repeat="columnItem in line.versions" ng-show="$index &gt; 0"><td><span ng-if="columnItem.versionName === line.current"><span class="red_text" ng-bind="\'*\'" title="Current/ actual column layout"></span></span><span>{{columnItem.versionName}}</span></td><td><ul><li class="zero_top_padding" ng-repeat="main in columnItem.columnLayout.main">{{main}}</li></ul></td><td><ul><li class="zero_top_padding" ng-repeat="second in columnItem.columnLayout.second">{{second}}</li></ul></td></tr></tbody></table></div></div></div></div></div></div></div></main>');
$templateCache.put('columns.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Program Checklist Profile</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!(vm.dataLoaded &amp;&amp; vm.admin.configs.loaded.general)">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div><div class="ibm-col-6-1"><span><a ng-click="vm.backToView()"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Back to View</a></span></div></div><div ng-form="vm.clForm" ng-show="vm.dataLoaded &amp;&amp; vm.admin.configs.loaded.general"><div class="ibm-columns"><div class="ibm-col-6-5"><div ng-if="!vm.events.beingSaved">Please enter the details for the Program Checklist Profile. &nbsp;Once all mandatory fields (<req></req>) are completed, the&nbsp;<b>Save&nbsp;</b>button will become available.</div><div ng-if="vm.okMessage"><span class="green_text">{{vm.okMessage}}</span></div><div ng-if="vm.errorMessage"><span class="red_text">{{vm.errorMessage}}</span></div></div><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-disabled="!(vm.clForm.$valid &amp;&amp; vm.modified)" ng-click="vm.savePage($event)"><md-icon class="white_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Save</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-if="!vm.newProfile" ng-disabled="(!vm.clForm.$valid &amp;&amp; vm.enableProgramChange) || vm.program === \'new\' || vm.id === \'new\'" ng-click="vm.clearPage($event)"><md-icon class="white_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Delete</md-button></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Program&nbsp;</label><req></req></div><div class="ibm-col-6-2 field" ng-if="vm.enableProgramChange"><md-select class="no-padding" aria-label="Program" ng-model="vm.tempCheckList.pickedProgram" ng-required="true"><md-option ng-value="x" ng-repeat="x in vm.admin.general.programs | orderBy: x">{{ x }}</md-option></md-select></div><div class="ibm-col-6-2 field" ng-if="!vm.enableProgramChange"><span ng-bind="vm.tempCheckList.pickedProgram" ng-required="true"></span></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">IOT&nbsp;</label><req></req></div><div class="ibm-col-6-2 field"><md-select class="no-padding" aria-label="iot" ng-model="vm.tempCheckList.pickedIots" ng-required="true" multiple="multiple" ng-change="vm.changedIot()"><md-option ng-value="x.country" ng-repeat="x in vm.settings.iot_list.iots | orderBy: country">{{ x.country }}</md-option></md-select></div></div><div class="ibm-columns" ng-repeat="cl in vm.admin.listOfCheckList"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">{{cl.name}}&nbsp;</label></div><div class="ibm-col-6-4 field"><div class="selectbox_bottom select_good" style="padding-top: 14px; padding-bottom: 14px"><span class="checkbox_subcontainer" style="padding: 8px 0px 9px 0px"><span ng-click="vm.expand(cl.name)" ng-if="!cl.visible"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_expand_more_black_24px.svg" style="margin-left:9px;margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Expand</a></span><span ng-click="vm.collapse(cl.name)" ng-if="cl.visible &amp;&amp; !cl.editView"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_keyboard_arrow_left_black_24px.svg" style="margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Collapse</a></span><span ng-click="vm.editSection(cl.name)" ng-if="!cl.editView &amp;&amp; vm.editMain"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_edit_black_24px.svg" style="margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Edit</a></span><span ng-click="vm.cancelSection(cl.name)" ng-if="cl.editView"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_cancel_black_24px.svg" style="margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Cancel</a></span><span ng-click="vm.saveSection(cl.name)" ng-if="cl.editView &amp;&amp; vm.modifiedItem"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_save_black_24px.svg" style="margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Save</a></span></span></div><div ng-if="cl.visible &amp;&amp; cl.editView"><table class="ibm-data-table" ng-if="vm.tempCheckList[cl.variableName].length&gt; 0"><thead><tr><th>Actions</th><th>Question</th><th>Yes</th><th>No</th><th>Alternate Answer</th></tr></thead><tbody><tr ng-repeat="clItem in vm.tempCheckList[cl.variableName]"><td ng-if="clItem.editMode"><span ng-click="vm.saveItem(cl.variableName, $index)" title="Save row"><md-icon class="green_icon" md-svg-icon="public/images/ic_save_black_24px.svg"></md-icon></span><span ng-click="vm.cancelItem(cl.variableName, $index)" title="Cancel changes in row"><md-icon md-svg-icon="public/images/ic_cancel_black_24px.svg"></md-icon></span><span ng-click="vm.removeItem(cl.variableName, $index)" title="Delete row"><md-icon class="red_icon" md-svg-icon="public/images/ic_remove_circle_black_24px.svg"></md-icon></span></td><td ng-if="clItem.editMode"><input ng-model="clItem.q"/><br/><div layout="row"><span flex="50">is header?</span><input type="checkbox" ng-model="clItem.head" ng-true-value="true" ng-false-value="undefined" flex="50"/></div><div layout="row"><span flex="50">is final?</span><input type="checkbox" ng-model="clItem.final" ng-true-value="true" ng-false-value="undefined" flex="50"/></div><!--div(layout="row")span(flex="50") Disable?\ninput(type="checkbox",ng-model="clItem.d",ng-true-value="true",ng-false-value="undefined",flex="50")--><div layout="row"><span>Set a action to checklist:</span></div><div layout="row"><md-select class="no-padding" aria-label="cl action" ng-model="clItem.i"><md-option ng-value="action.id" ng-repeat="action in vm.actionList" title="{{action.desc}}">{{ action.name }}</md-option></md-select></div><div layout="row"><span>Section:</span></div><div layout="row"><input type="number" ng-model="clItem.sec"/></div></td><td ng-if="clItem.editMode"><span class="ibm-input-group ibm-radio-group" ng-if="!clItem.head"><input type="radio" value="Yes" name="{{$index}}" ng-model="clItem.answer"/></span></td><td ng-if="clItem.editMode"><span class="ibm-input-group ibm-radio-group" ng-if="!clItem.head"><input type="radio" value="No" name="{{$index}}" ng-model="clItem.answer"/></span></td><td ng-if="clItem.editMode"><input ng-model="clItem.answer"/></td><td ng-if="!clItem.editMode"><span ng-if="vm.editCl"><span ng-click="vm.addItemLine(cl.variableName, $index)" title="Add new row"><md-icon class="green_icon" md-svg-icon="public/images/ic_add_circle_black_24px.svg"></md-icon></span><span ng-click="vm.editItem(cl.variableName, $index)" title="Edit row"><md-icon class="black_icon" md-svg-icon="public/images/ic_edit_black_24px.svg"></md-icon></span></span><span ng-if="!vm.editCl"><span title="Add new row"><md-icon class="gery_icon" md-svg-icon="public/images/ic_add_circle_black_24px.svg"></md-icon></span><span title="Edit row"><md-icon class="grey_icon" md-svg-icon="public/images/ic_edit_black_24px.svg"></md-icon></span></span><!--span(ng-if="clItem.d",title="Disabled")md-icon(class="red_icon" md-svg-icon="public/images/ic_do_not_disturb_alt_black_24px.svg")--></td><td ng-if="!clItem.editMode"><b ng-if="clItem.head">{{clItem.q}}</b><span ng-if="!clItem.head">{{clItem.q}}</span></td><td ng-if="!clItem.editMode"><span ng-if="clItem.answer == \'Yes\'">{{clItem.answer}}</span></td><td ng-if="!clItem.editMode"><span ng-if="clItem.answer == \'No\'">{{clItem.answer}}</span></td><td ng-if="!clItem.editMode"><span ng-bind="clItem.answer"></span></td></tr></tbody></table><div ng-if="vm.tempCheckList[cl.variableName].length == 0"><span>Please add a new Check List question</span></div><div ng-click="vm.addItem(cl.variableName)" ng-if="vm.editCl"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_add_circle_black_24px.svg" style="margin-left:9px;margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Add Check List Question</a></div><div ng-if="!vm.editCl"><md-icon class="grey_icon" md-svg-icon="/public/images/ic_add_circle_black_24px.svg" style="margin-left:9px;margin-right:12px"></md-icon><a class="ibm-textcolor-grey-50" style="margin-left: -9px; margin-right: 15px">Add Check List Question</a></div><br/><div><div><b>Radio button description:</b><input ng-model="vm.tempCheckList[cl.radioButtonName].desc"/></div><div><span ng-repeat="rbItem in vm.tempCheckList[cl.radioButtonName].rb" for="{{cl.radioButtonName}}"><input ng-model="rbItem.item"/><span class="ibm-input-group ibm-radio-group"><input type="radio" value="{{rbItem.value}}" name="{{cl.radioButtonName}}" ng-model="vm.tempCheckList[cl.radioButtonName].picked" ng-disabled="false"/></span><span><md-icon class="red_icon" ng-click="vm.removeRbItem(cl.radioButtonName,$index)" md-svg-icon="public/images/ic_remove_circle_black_24px.svg"></md-icon></span></span></div><div><span ng-click="vm.addRb(cl.radioButtonName)"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_add_circle_black_24px.svg" style="margin-left:9px;margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Add Radio Button Option</a></span><span ng-click="vm.clearRb(cl.radioButtonName)" ng-if="vm.tempCheckList[cl.radioButtonName].picked != \'\'"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_more_horiz_black_24px.svg" style="margin-left:9px;margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px">Clear selection</a></span></div></div></div><div ng-if="cl.visible &amp;&amp; !cl.editView"><table class="ibm-data-table" ng-if="vm.tempCheckList[cl.variableName].length&gt; 0"><thead><tr><th>Question</th><th>Yes</th><th>No</th><th>Alternate Answer</th></tr></thead><tbody><tr ng-repeat="clItem in vm.tempCheckList[cl.variableName]"><td ng-if="!clItem.editMode"><b ng-if="clItem.head">{{clItem.q}}</b><span ng-if="!clItem.head">{{clItem.q}}</span></td><td ng-if="!clItem.editMode"><span ng-if="clItem.answer == \'Yes\'">{{clItem.answer}}</span></td><td ng-if="!clItem.editMode"><span ng-if="clItem.answer == \'No\'">{{clItem.answer}}</span></td><td ng-if="!clItem.editMode"><span ng-bind="clItem.answer"></span></td></tr></tbody></table><div ng-if="vm.tempCheckList[cl.variableName].length == 0"><span>No Check List Questions Found</span></div><div><span><b ng-if="vm.tempCheckList[cl.radioButtonName].desc != \'\'">{{vm.tempCheckList[cl.radioButtonName].desc}}:&nbsp;</b><span ng-repeat="rbItem in vm.tempCheckList[cl.radioButtonName].rb" for="{{cl.radioButtonName}}">{{rbItem.item}}:<span class="ibm-input-group ibm-radio-group"><input type="radio" value="{{rbItem.value}}" name="{{cl.radioButtonName}}" ng-model="rbItem.picked" ng-disabled="true"/></span></span></span></div></div></div></div></div></div></div></div></div></main>');
$templateCache.put('eslogs-details.html','<style>.checkbox-md {\n    width: 18px;\n    height: 18px;\n}\n.es-logs-checkbox-item {\n    display: flex;\n    margin: 20px;\n}\n.es-logs-task{\n    width: 100%;\n}\n.es-logs-task p {\n    font-weight: bold;\n    padding-bottom: 5px;\n    font-size: 1.1rem;\n}\n.es-logs-task > .task-title > div{\n    font-weight: bold;\n    font-size: 18px !important;\n}\n.es-logs-task > .task-actions {\n    margin: 5px 0px 0px 0px;\n}\n.es-logs-task button {\n    margin-left: 0;\n}\n.es-logs-container {\n    width: 50vw;\n}\n.es-logs-details {\n    border: solid 1px #d8d5d5;\n    margin: 10px 0px;\n    padding: 20px 50px;\n}\n.es-logs-code {\n    border: solid 1px #dcdcdc;\n    border-radius: 5px;\n    background: #fbfbfb;\n    padding: 20px;\n    margin-bottom: 20px;\n}\ni {\n    border: solid #fff;\n    border-width: 0 2px 2px 0;\n    margin-left: 10px;\n    margin-bottom: 1px;\n    display: inline-block;\n    padding: 3px;\n}\n\n.up {\n    transform: rotate(-135deg);\n    -webkit-transform: rotate(-135deg);\n}\n\n.down {\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n}\n.es-logs-updatedoc {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n.es-logs-updatedoc button {\n    width: 180px;\n}\n.es-logs-btn-container {\n    display: flex;\n    justify-content: center;\n}\n\n.error-text {\n    margin: 3px 0px 0px 0px;\n    display: inline-block;\n    color: rgb(225, 0, 80);\n    font-weight: 500 !important;\n    font-size: 18px !important;\n}\n.es-logs-step {\n    margin-bottom: 10px;\n}\n.ibm-btn-pri.ibm-btn-blue-50:focus  {\n    background: #4178be;\n}\n.ibm-btn-pri.ibm-btn-blue-50:hover  {\n    background: #3a6ba9;\n}\n.es-logs-icon {\n    margin: 0;\n    margin-right: 10px;\n}\n.unprocess-btn {\n    margin-left: 20px;\n    margin-top: 20px;\n    text-transform: none;\n    font-size: 17px;\n}\n</style><main class="fill" role="main" aria-labelledby="ibm-pagetitle-h1"><div class="fill" id="ibm-pcon" ibm-back-to-top=""><div class="fill" id="ibm-content"><div class="fill" id="ibm-content-body"><div class="fill" id="ibm-content-main"><div class="fill" id="content" layout="column"><div class="ibm-columns" style="display: flex; align-items:center;"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Engage Support Update Logs for {{vm.id}}</b></h1></div><div class="ibm-col-6-1"><span><a ui-sref="admin.eslogs-view"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;ES Update Logs</a></span></div></div><div class="ibm-columns"><div class="es-logs-container"><md-button class="unprocess-btn" ng-click="vm.handleShowHideUnhadledClick()" ng-if="vm.unprocessedNumber &gt; 0"> <a>{{vm.showUnhandledTasks ? \'Hide\' : \'Show\'}} Unprocessed Tasks</a></md-button><div class="es-logs-checkbox-item" ng-if="task.taskStatus !== \'unprocessed\' || (task.taskStatus === \'unprocessed\' &amp;&amp; vm.showUnhandledTasks)" ng-repeat="task in vm.tasks"><div class="es-logs-task" ng-attr-id="{{task.taskId}}"><div class="task-title"><div style="display: flex;"><md-icon class="es-logs-icon" ng-if="task.taskStatus === \'processed\'" style="color:rgba(0, 128, 0, 0.62);" md-svg-icon="processed"></md-icon><md-icon class="es-logs-icon" ng-if="task.taskStatus === \'unprocessed\'" style="color:rgba(60, 130, 196, 0.62);" md-svg-icon="unprocessed"></md-icon><md-icon class="es-logs-icon" ng-if="task.taskStatus === \'error\'" style="color:rgba(234, 35, 35, 0.62);" md-svg-icon="failed"></md-icon><div style="font-size: 18px">Task {{vm.tasks.length - $index}}. {{task.taskType}}. </div></div><div style="font-weight: 300; font-size: 16px !important; display: flex; margin-top: 5px;"> <div ng-if="task.created">Created: {{task.created}}. </div><div ng-if="task.updated">Updated: {{task.updated}}.</div></div><div class="error-text" ng-if="task.errorMessage">Error: {{task.errorMessage}}</div></div><div class="task-actions"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" ng-click="vm.handleDetailsClick(task)">Details<i ng-class="task.isDetailsOpen ? \'arrow up\' : \'arrow down\'"></i></md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" ng-click="vm.handleStepsClick(task)" ng-if="task.taskStatus !== \'unprocessed\'">Steps<i ng-class="task.areStepsOpen ? \'arrow up\' : \'arrow down\'"></i></md-button><div class="es-logs-details" ng-if="task.isDetailsOpen"><div ng-if="task.errorDetails"><p>Error Details</p><div class="es-logs-code"><pre style="overflow:auto"><code>{{task.errorDetails}}</code></pre></div></div><div ng-if="task.body"><p>Initial Execution Parameters</p><div class="es-logs-code"><pre style="overflow:auto"><code>{{task.body}}</code></pre></div></div></div><div class="es-logs-details" ng-if="task.areStepsOpen"><div ng-if="task.execution.steps &amp;&amp; task.execution.steps.length &gt; 0"><div class="es-logs-step" ng-repeat="step in task.execution.steps"><div><div style="display: flex;"><md-icon class="es-logs-icon" ng-if="step.stepStatus === \'processed\'" style="color:rgba(0, 128, 0, 0.62);" md-svg-icon="processed"></md-icon><md-icon class="es-logs-icon" ng-if="step.stepStatus === \'unprocessed\'" style="color:rgba(60, 130, 196, 0.62);" md-svg-icon="unprocessed"></md-icon><md-icon class="es-logs-icon" ng-if="step.stepStatus === \'error\'" style="color:rgba(234, 35, 35, 0.62);" md-svg-icon="failed"></md-icon><p>Step {{task.execution.steps.length - $index}}.</p></div><div ng-repeat="msg in step.messages"><div>{{msg.message}}</div></div><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="" ng-if="step.stepType === \'executable\'">Actions</md-button></div></div></div><div ng-if="!task.execution.steps || task.execution.steps.length == 0"><p>No steps for this task.</p></div></div></div></div></div></div></div></div></div></div></div></div></main>');
$templateCache.put('eslogs.html','<style>.eslogs-table {\n    min-width: 1100px;\n}\n.eslogs-table tbody tr td:last-child,\n.eslogs-table thead tr td:last-child {\n    min-width: 130px;\n}\n.eslogs-table .sorting_disabled {\n   text-align: center;\n}\n.eslogs-table td:nth-child(1) {\n    padding-left: 60px;\n}\n.eslogs-table td:nth-child(2), .eslogs-table td:nth-child(3), .eslogs-table td:nth-child(4), .eslogs-table td:nth-child(5),\n.eslogs-table td:nth-child(6)\n{\n   text-align: center;\n}\n.eslogs-table tr {\n    cursor: pointer;\n}\n.actions-container {\n    box-sizing: border-box;\n    display: inline-flex;\n    flex: 0 0 auto;\n    align-items: center;\n    justify-content: flex-end;\n    z-index: 1;\n    right: 0;\n    position: absolute;\n    top: 0;\n}\n.actions-container > div {\n    padding: 10px 5px;\n}\n.actions-container > div:first-child {\n    align-items: stretch;\n    display: flex;\n    flex: 1 1 auto;\n    height: 35px;     \n}\n.actions-container .actions {\n    border: solid 1px #5596e6;\n    padding: 7px 0px 7px 7px;\n    color: #5596e6;\n    display: flex;\n    align-items: center;\n}\n.export-btn-container button {\n    margin: 0;\n}\na.link {\n    text-decoration: none;\n}\n.alpha_dead {\n    color: lightgray;\n}\n.alpha_selly {\n    color: white;\n    background-color: #5596e6;\n    border-radius: 25%;\n}\n.form-list {\n    padding-top: 15px;\n    min-height: 65px;\n}\n.delete-button md-icon svg {\n    fill: #e71d32;\n}\n.edit-button md-icon svg {\n    fill: #325c80;\n}\n.fill {\n    display: flex;\n    width: 100%;\n    height: 100%;\n}\n#ibm-content-body {\n    box-sizing: border-box;\n}\n.admin-tabs, .admin-tabs md-tabs-content-wrapper, .admin-tabs md-tab-content, .admin-tabs md-tab-content > div {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n.flex {\n    display: flex;\n}\n.history-container {\n    display: flex;\n    flex: 1;\n    width: 100%;\n    overflow: auto;\n    padding-top: 15px;\n}\n.history-table td:nth-child(2), .history-table th:nth-child(2){\n    flex-grow: 4;\n}\n.history-table td:nth-child(3), .history-table th:nth-child(3){\n    flex-grow: 3;\n}\n</style><main class="fill" role="main" aria-labelledby="ibm-pagetitle-h1"><div class="fill" id="ibm-pcon" ibm-back-to-top=""><div class="fill" id="ibm-content"><div class="fill" id="ibm-content-body"><div class="fill" id="ibm-content-main"><div class="fill" id="content" layout="column"><div class="ibm-columns" style="display: flex; align-items:center;"><div><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Engage Support Update Logs</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!vm.itemsLoaded">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div><div style="margin-left: auto; padding-right: 10px;"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div><div class="ibm-columns" ng-if="vm.signalWrongResponse"><div class="ibm-col-2-2" style="float: right; color: red;"><span ng-bind-html="vm.signalWrongResponse">               </span></div></div><div class="ibm-columns flex"><form class="form-list fill" name="" layout="column"><div class="flex" style="margin-bottom:15px;"><span style="line-height: 17px;">Only with error</span><div><input ng-change="vm.withErrorHandler()" ng-model="vm.withError" type="checkbox" style="width:17px;height:17px;margin-left: 10px;"/></div></div><div class="fill" layout="column"><table class="eslogs-table ibm-data-table ibm-altrows ibm-alternate-two" id="eslogs-table" datatable="" dt-options="vm.table.dtOptions" dt-instance="vm.table.dtInstance" dt-columns="vm.table.dtColumns" dt-disable-deep-watchers="true"></table></div></form></div></div></div></div></div></div></main>');
$templateCache.put('gbt20-view.html','');
$templateCache.put('gppload-view.html','<style>table, td {\n    border-color: lightgray;\n}\n.tabby {\n    font-size: small;\n}\n.indent {\n    margin-left: 15px;\n}\n.indent2 {\n    margin-left: 25px;\n    font-size: smaller;\n}\n.dids {\n    font-size: smaller;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>GPP Status Update Log</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="!vm.profileLoaded &amp;&amp; !vm.serverError">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span ng-if="vm.profileLoaded"></span></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><span>The GPP Status Update runs nightly and collects all Disbursements that have been Closed, Rejected or Paid but have not</span>&nbsp;been reported back to GPP. &nbsp;Once collected, all related Disbursements are also collected to determine which\nstatus to send back to GPP. &nbsp;Results are saved in a DB2 table to be FTP\'d to GPP.<p></p></div></div></div><div ng-if="vm.serverError"><div class="ibm-columns"><div class="ibm-col-1-1"><span class="ibm-textcolor-red-50" ng-bind-html="vm.serverError"></span><p></p></div></div></div><div ng-if="vm.profileLoaded"><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Last Run Date&nbsp;</label></div><div class="ibm-col-6-4 field"><span>{{vm.profile.lastRunDate | date: "medium"}}</span></div></div><br/><div class="ibm-columns"><div class="ibm-col-1-1">Last 10 run results below. &nbsp;Click on each Start Date to view. &nbsp;<b>NOTE: </b>Entries in red indicate that an error occurred during processing that resulted in failure:<p></p><div ng-repeat="api in vm.profile.api" style="margin-top: 5px"><span class="ibm-textcolor-gray-30" style="font-size:small; padding-right: 5px">{{$index+1}}.</span><span ng-class="{\'ibm-textcolor-blue-40\':!api.error, \'ibm-textcolor-red-50\':api.error}" ng-click="vm.toggle(api)">{{api.date | date: "fullDate"}}</span><div ng-if="api.view"><md-icon class="blue_icon indent" md-svg-src="/public/images/ic_list_black_24px.svg" style="margin-right: 3px"></md-icon><b class="ibm-textcolor-blue-50" ng-click="vm.toggle(api.log)">Run Log</b><span class="indent" ng-if="api.log.view"><span ng-repeat="entry in api.log"><br/><span class="ibm-textcolor-red-50 indent2" ng-if="entry.indexOf(\'ERROR\') &gt; -1">{{entry}}</span><span class="ibm-textcolor-green-50 indent2" ng-if="entry.indexOf(\'ERROR\') &lt; 0">{{entry}}</span></span></span><br/><md-icon class="blue_icon indent" md-svg-src="/public/images/ic_grid_on_black_24px.svg" style="margin-right: 3px"></md-icon><b class="ibm-textcolor-blue-50" ng-click="vm.toggle(api.data)">Results</b><span class="indent" ng-if="api.data.view"><span class="search_box"><md-icon class="blue_icon" md-svg-icon="/public/images/magnify.svg"></md-icon></span><input class="userField" ng-model="api.search" placeholder="Enter search criteria"/>&nbsp;&nbsp;<p></p><table class="tabby ibm-data-table ibm-altrows ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1"><thead><tr><td style="text-align:center"><span>#</span></td><td style="text-align:center"><span>DMT Unique Ref</span></td><td style="text-align:center"><span>Opportunity No</span></td><td style="text-align:center"><span>Row ID</span></td><td style="text-align:center"><span>Start Date</span></td><td style="text-align:center"><span>Status</span></td><td style="text-align:center"><span>Sub-Status</span></td><td style="text-align:center"><span>Data Sent to GPP</span><p></p><span class="ibm-textcolor-gray-30">NOTE: If no data sent it means there are open Disbursements for the opportunity</span></td></tr></thead><tBody><tr ng-if="api.data.length===0"><td colspan="9" style="text-align: center; background-color: whitesmoke; padding: 10px; font-size: 15px"> No data sent</td></tr><tr ng-repeat="opp in api.data | orderBy:opp.id | filter:api.search"><td style="width:5px; text-align: center;">{{($index + 1)}}</td><td ng-repeat="(k,v) in opp" style="text-align: center;"><span ng-if="k !== \'start_date\'" style="text-align: center">{{v ? v : \'N/A\'}}</span><span ng-if="k === \'start_date\'" style="text-align: center">{{v ? (v | date: "medium") : \'N/A\'}}</span></td></tr></tBody></table></span></div><br/></div></div><p></p></div><p></p></div></div></div></div></div></main>');
$templateCache.put('mysa-dmt-view.html','<style>.defects {\n    border: 1px solid lightgray;\n    padding: 8px;\n    max-height: 210px;\n    height: 210px;\n}\n.defects_list {\n    padding: 8px;\n    max-height: 120px;\n    height: 200px;\n    overflow-y: scroll;\n}\na.link {\n    text-decoration: none;\n}\na.link:hover {\n    background-color: #e9f1fc;\n}\na.link_fail {\n    text-decoration: none;\n    color: #f76060;\n}\na.link_fail:hover {\n    background-color: rgb(255, 232, 225);\n}\n.status {\n    padding: 5px;\n    border-radius: 5px;\n    color: white;\n}\n.allgood {\n    background-color: green;\n}\n.notgood {\n    background-color: red;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>MySA Opportunity Logs</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="!vm.loaded.ready &amp;&amp; !vm.serverError">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span ng-if="vm.loaded.ready"></span></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><span>Interface to check the status of Opportunities sent between DMT and MySA.</span><p></p></div></div></div><div ng-if="vm.serverError"><div class="ibm-columns"><div class="ibm-col-1-1"><span class="ibm-textcolor-red-50" ng-bind-html="vm.serverError"></span><p></p></div></div></div><div ng-if="vm.loaded.ready"><div class="ibm-columns"><div class="ibm-col-6-5"><span>Use the search below to retrieve the log details for any MySA opportunity received by DMT.</span><br/><br/><span class="ibm-textcolor-blue-40">Opportunity Number: </span><input class="userField" ng-model="vm.oppLog.opp"/><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.retrieveLog(vm.oppLog.opp)" title="Click to search and retrieve log details" ng-disabled="!vm.oppLog.opp || vm.oppLog.searching.opp"><md-icon class="white_icon" style="margin-left: -5px" md-svg-icon="/public/images/magnify.svg"></md-icon>&nbsp;Retrieve</md-button><span class="ibm-textcolor-red-50" style="margin-left: 10px" ng-if="vm.oppLog.notfound">No log could be found for this Opportunity</span></div><div class="ibm-col-6-1"><span class="status" ng-class="{\'allgood\': vm.defects.total === 0,\'notgood\': vm.defects.total &gt; 0 }">{{vm.defects.total > 0 ? vm.defects.total + \' Defect(s)\' : \'All Good\'}}</span></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><span>The tables below detail the current list of Opportunities that have been received from MySA and failed, as well as those where status update back to MySA has failed.</span></div></div><div class="ibm-columns"><!-- Inbound Defects--><div class="ibm-col-6-3 defects"><div><span class="ibm-textcolor-blue-40 ibm-h4">Inbound Defect Opportunities:</span><b ng-class="{\'ibm-textcolor-red-40\':vm.defects.inbound.length &gt; 0}">&nbsp;{{vm.defects.inbound.length}}</b><input class="userField" style="height: 15px;float: right" ng-model="vm.filter.defectIN" placeholder="Filter"/></div><br/><div class="defects_list"><div ng-repeat="defect in vm.defects.inbound | orderBy:defect.value.time:true | filter:vm.filter.defectIN"><span><a class="link" title="Click to retrieve log details" ng-click="vm.retrieveLog(defect.value.id,$index,\'in\')">{{defect.value.id}} -&nbsp;<span class="ibm-textcolor-blue-40">{{::vm.getDate(defect.value.time) | date: \'medium\'}}</span></a><span ng-if="vm.oppLog.searching.in[$index]" style="margin-left: 5px; color:gray">Please wait...</span></span></div></div></div><!-- Outbound Defects--><div class="ibm-col-6-3 defects"><div><span class="ibm-textcolor-blue-40 ibm-h4">Outbound Defect Opportunities:</span><b ng-class="{\'ibm-textcolor-red-40\':vm.defects.outbound.length &gt; 0}">&nbsp;{{vm.defects.outbound.length}}</b><input class="userField" style="height: 15px;float: right" ng-model="vm.filter.defectOUT" placeholder="Filter"/></div><br/><div class="defects_list"><div ng-repeat="defect in vm.defects.outbound | orderBy:defect.value.time:true | filter:vm.filter.defectOUT"><span><a class="link" title="Click to retrieve log details" ng-click="vm.retrieveLog(defect.value.id,$index,\'out\')">{{defect.value.id}} -&nbsp;<span class="ibm-textcolor-blue-40">{{::vm.getDate(defect.value.time) | date: \'medium\'}}</span></a><span ng-if="vm.oppLog.searching.out[$index]" style="margin-left: 5px;color:gray">Please wait...</span></span></div></div></div></div><div class="ibm-columns" ng-if="vm.loaded.opp"><div class="ibm-col-1-1"><span class="ibm-textcolor-blue-40 ibm-h3">Logs for {{vm.oppLog.oppty}}</span><p></p><span>The tables below detail the last 10 logs for the above Opportunity. &nbsp;Click each to view the details.</span><p></p></div><!-- Inbound Logs--><div class="ibm-col-6-3 defects"><span class="ibm-textcolor-blue-40 ibm-h4">Inbound Logs</span><br/><div class="defects_list"><div ng-repeat="log in vm.oppLog.in | orderBy: log.timestamp : true"><a ng-class="{\'link\': log.success,\'link_fail\': !log.success}" title="{{vm.getTitle(log)}}" ng-click="vm.viewLog($event, log, \'Inbound\')">Log # {{$index + 1}} - {{::vm.getDate(log.timestamp) | date: \'medium\' }}</a><span style="color: #57cc3b">{{$index === 0 ? \' (Most Recent)\' : \'\'}}</span></div></div></div><!-- Outbound Logs--><div class="ibm-col-6-3 defects"><span class="ibm-textcolor-blue-40 ibm-h4">Outbound Logs</span><br/><div class="defects_list"><div ng-repeat="log in vm.oppLog.out | orderBy: log.timestamp : true"><a ng-class="{\'link\': log.success,\'link_fail\': !log.success}" title="{{vm.getTitle(log)}}" ng-click="vm.viewLog($event, log, \'Outbound\')">Log # {{$index + 1}} - {{::vm.getDate(log.timestamp) | date: \'medium\'}}</a><span style="color: #57cc3b">{{$index === 0 ? \' (Most Recent)\' : \'\'}}</span></div></div></div></div><p></p></div></div></div></div></div></main>');
$templateCache.put('mysa-dmt-viewlog.html','<style>.stamp {\n    width: 80%;\n}\n.title {\n    font-size: large;\n}\n.allgood {\n    background-color: green;\n}\n.notgood {\n    background-color: red;\n}\n.status {\n    padding: 5px;\n    border-radius: 5px;\n    color: white;\n    float: right;\n}</style><md-dialog aria-label="MySA Opportunity Log" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>MySA Opportunity Log - {{vm.logBundle.opp}} - {{vm.logBundle.io}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class="ibm-columns"><div class="ibm-col-1-1"><br/><div class="stamp"><span class="status" ng-class="{\'allgood\': vm.logBundle.success,\'notgood\': !vm.logBundle.success }">{{vm.logBundle.success ? \'Passed\' : \'Failed\'}}</span><span class="title ibm-textcolor-blue-40">Created on&nbsp;</span><b class="title">{{vm.logBundle.time | date: \'medium\'}}</b><span class="title ibm-textcolor-blue-40">&nbsp;by&nbsp;</span><b class="title">{{vm.logBundle.module}}</b><span class="title" ng-if="vm.logBundle.message"><p></p><label class="ibm-textcolor-blue-40">Message&nbsp;</label><span>{{vm.logBundle.message}}</span></span></div><br/><span class="ibm-textcolor-blue-50 ibm-h4">Full Log</span><p></p><pre><code>{{vm.logBundle.log}}</code></pre></div></div></md-dialog-content></md-dialog>');
$templateCache.put('mysa-im-outbound-dlg.html','<style>md-dialog {\n    min-height: 650px;\n    min-width: 1200px;\n}\nmd-dialog-content > div\n{\n    margin: 10px 0 0 0;\n    height: 100%;\n    padding: 20px;  \n}\n.stamp {\n    width: 100%;\n}\n.title {\n    font-size: large;\n}\n.status-success {\n    color: green;\n}\n.status-fail {\n    color: red;\n}\n.status {\n    padding: 5px;\n    border-radius: 5px;\n    float: right;\n    font-size: xx-large;\n}\n.logs-details {\n    background-color: #fffefe;\n    border: solid 1px #d8d5d5;\n    margin: 10px 0px;\n    padding: 20px 50px;\n}\n.logs-code {\n    border: solid 1px #dcdcdc;\n    border-radius: 5px;\n    background: #f3f3f3;\n    padding: 20px;\n    margin-bottom: 20px;\n}\n.response-area {\n    width: 100%;\n    height: 100%;\n}   \n.response-textarea {\n    width: 85%;\n    height: 380px;\n}\n.response-control {\n    float: right;\n    display: inline;\n}\nmd-toolbar {\n    z-index: 1000;\n}\n.overlay-screen {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    background: black;\n    opacity: .5;\n    z-index: 999;\n}\n.progress-label {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin: -50px 0 0 -100px;\n}</style><md-dialog aria-label="MySA Opportunity Log" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>MySA Opportunity Outbound Log - {{vm.data.opp}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.onClose()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><div class="overlay-screen" ng-if="vm.isSendMode()"><h1 class="progress-label ibm-textcolor-blue-40 ibm-h3">Sending...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div><md-dialog-content><div><div class="stamp"><span class="status" ng-class="{\'status-success\': vm.data.success,\'status-fail\': !vm.data.success }">{{vm.data.success ? \'Passed\' : \'Failed\'}}</span><span class="title ibm-textcolor-blue-40">Created on&nbsp;</span><b class="title">{{vm.data.time | date: \'medium\'}}</b><span class="title ibm-textcolor-blue-40">&nbsp;in&nbsp;</span><b class="title">{{vm.data.module}}</b><span class="title ibm-textcolor-blue-40">&nbsp;by&nbsp;</span><b class="title">{{vm.data.trigger}}</b><span class="title" ng-if="vm.data.message"><p></p><label class="ibm-textcolor-blue-40">Response message&nbsp;</label><span>{{vm.data.message}}</span></span></div><br/><span class="ibm-textcolor-blue-50 ibm-h4">Request body</span><div class="response-area"><textarea class="response-textarea" ng-model="vm.data.requestBody" ng-disabled="!vm.isEditMode()"></textarea><div class="response-control"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.onSend(vm.data.requestBody)" title="Click to re-send the outbound request" ng-disabled="!vm.data.requestBody">&nbsp;Send</md-button><br/><span class="status-fail" ng-if="!vm.data.isLast">not the last</span><br/><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.onEdit()" ng-if="!vm.isEditMode()" title="Click to edit the current request before sending">&nbsp;Edit</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.onEdit()" ng-if="vm.isEditMode()" title="Click to undo the change, to cancel edit-mode and to return to the original request">&nbsp;Undo</md-button><br/><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.onClose()" title="Click to close">&nbsp;Close  </md-button></div></div></div></md-dialog-content></md-dialog>');
$templateCache.put('mysa-im-outbound-view.html','<style>.defects {\n    border: 1px solid lightgray;\n    padding: 8px;\n    min-height: 210px;\n    height: 480px;\n}\n.defects_list {\n    padding: 8px;\n    min-height: 120px;\n    height: 400px;\n    overflow-y: scroll;\n}\n.outbound_log {\n    margin: 20px 0 0 0;\n}\na.link {\n    text-decoration: none;\n}\na.link:hover {\n    background-color: #e9f1fc;\n}\na.link_fail {\n    text-decoration: none;\n    color: #f76060;\n}\na.link_fail:hover {\n    background-color: rgb(255, 232, 225);\n}\n.status-success {\n    color: green;\n}\n.status-fail {\n    color: red;\n}\n.status {\n    padding: 5px;\n    border-radius: 5px;\n    color: white;\n}\n.allgood {\n    background-color: green;\n}\n.notgood {\n    background-color: red;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>MySA IM Outbound Opportunity Logs</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="!vm.loaded.ready &amp;&amp; !vm.serverError">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span ng-if="vm.loaded.ready"></span></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><span>Interface to check the status of Opportunities sent to MySA IM.</span><p></p></div></div></div><div ng-if="vm.serverError"><div class="ibm-columns"><div class="ibm-col-1-1"><span class="ibm-textcolor-red-50" ng-bind-html="vm.serverError"></span><p></p></div></div></div><div ng-if="vm.loaded.ready"><div class="ibm-columns"><div class="ibm-col-1-1"><span>Use the search below to retrieve the log details for any DMT opportunity sent to MySA IM.</span><br/><span class="ibm-textcolor-blue-40">Opportunity Number: </span><input class="userField" ng-model="vm.oppLog.opp"/><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.retrieveLog(vm.oppLog.opp)" title="Click to search and retrieve log details" ng-disabled="!vm.oppLog.opp || vm.oppLog.searching.opp"><md-icon class="white_icon" style="margin-left: -5px" md-svg-icon="/public/images/magnify.svg"></md-icon>&nbsp;Retrieve</md-button><span class="ibm-textcolor-red-50" style="margin-left: 10px" ng-if="vm.oppLog.notfound">No log could be found for this Opportunity</span></div></div><div class="ibm-columns"><!-- Outbound Defects--><div class="ibm-col-6-3 defects"><div><span class="ibm-textcolor-blue-40 ibm-h4">Total Outbound Opportunities:</span><b>&nbsp;{{vm.defects.total}}</b><input class="userField" style="height: 15px;float: right" ng-model="vm.filter.defectOUT" placeholder="Filter"/><div style="height: 15px;float: right"><input class="userField" ng-model="vm.filter.errorOnly" placeholder="Error only" type="checkbox"/><span class="ibm-h5 status-fail">Only with error:&nbsp;{{vm.defects.totalError}}&nbsp;</span></div><div style="height: 15px;float: left"></div><br/><span class="ibm-h7">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;({{filtered.length > 100 ? \'last 100\': filtered.length }}&nbsp;records are shown)</span></div><div class="defects_list"><div ng-repeat="defect in filtered = (vm.defects.outbound | filter: {value: {success : vm.filter.errorOnly ? false : defect.value.success}} | filter:vm.filter.defectOUT)"><span ng-if="$index &lt; 100"><a class="link" ng-class="{\'status-success\': defect.value.success,\'status-fail\': !defect.value.success }" title="Click to retrieve log details" ng-click="vm.retrieveOutLog(defect.value.id,$index)">{{defect.value.id}} -&nbsp;<span class="ibm-textcolor-blue-40">{{::vm.getDate(defect.value.time) | date: \'medium\'}}</span></a><span ng-if="vm.oppLog.searching.out[$index]" style="margin-left: 5px;color:gray">Please wait...</span></span><span ng-if="$index === 100">...    </span></div></div></div><!-- Outbound logs--><div class="ibm-col-6-3 defects" ng-if="vm.loaded.opp">                                           <span class="ibm-textcolor-blue-40 ibm-h4">Outbound logs for {{vm.oppLog.oppty}}</span><br/><div class="defects_list outbound_log"><div ng-repeat="log in vm.oppLog.out | orderBy: log.timestamp : true"><a ng-class="{\'link\': log.success,\'link_fail\': !log.success}" title="{{vm.getTitle(log)}}" ng-click="vm.viewLog(log, $index === 0)">Log # {{$index + 1}} - {{::vm.getStatus(log)}} - {{::vm.getDate(log.timestamp) | date: \'medium\'}}</a><span style="color: #57cc3b">{{$index === 0 ? \' (Most Recent)\' : \'\'}}</span></div></div></div></div><p></p></div></div></div></div></div></main>');
$templateCache.put('mysaerrlogs-details.html','<style>.checkbox-md {\n    width: 18px;\n    height: 18px;\n}\n.es-logs-checkbox-item {\n    display: flex;\n    margin: 20px;\n}\n.es-logs-task{\n    margin-left: 10px;\n    width: 100%;\n}\n.es-logs-task p {\n    font-weight: 500;\n    font-size: 17px;\n}\n.es-logs-container {\n    width: 70vw;\n}\n.es-logs-details {\n    background-color: #fffefe;\n    border: solid 1px #d8d5d5;\n    margin: 10px 0px;\n    padding: 20px 50px;\n}\n.es-logs-code {\n    border: solid 1px #dcdcdc;\n    border-radius: 5px;\n    background: #f3f3f3;\n    padding: 20px;\n    margin-bottom: 20px;\n}\ni {\n    border: solid #fff;\n    border-width: 0 2px 2px 0;\n    margin-left: 10px;\n    margin-bottom: 1px;\n    display: inline-block;\n    padding: 3px;\n}\n\n.up {\n    transform: rotate(-135deg);\n    -webkit-transform: rotate(-135deg);\n}\n\n.down {\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n}\n.es-logs-updatedoc {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n.es-logs-updatedoc button {\n    width: 180px;\n}\n.es-logs-btn-container {\n    display: flex;\n    justify-content: center;\n}\n</style><main class="fill" role="main" aria-labelledby="ibm-pagetitle-h1"><div class="fill" id="ibm-pcon" ibm-back-to-top=""><div class="fill" id="ibm-content"><div class="fill" id="ibm-content-body"><div class="fill" id="ibm-content-main"><div class="fill" id="content" layout="column"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>MySA Inbound Error Logs for {{vm.id}}</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="vm.dataLoaded">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div></div><div class="ibm-columns"><div class="es-logs-container"> <p ng-if="vm.failedQueue.length === 0" style="font-size: 20px;">There is no errors for {{vm.id}}</p><div class="es-logs-checkbox-item" ng-repeat="task in vm.failedQueue"><div class="es-logs-task"><b style="font-size: 20px; margin-right: 50px;">{{$index + 1}}. {{task.opptyId}}</b><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" ng-click="vm.handleDetailsClick($index)">Details<i ng-class="vm.isDetailsOpen === $index ? \'arrow down\' : \'arrow up\'"></i></md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.handleResolveClick(task.id)">Resolve</md-button><div class="es-logs-details" ng-if="vm.isDetailsOpen === $index"><div><p>Stacktrace</p><div class="es-logs-code"><pre style="overflow:auto"><code>{{task.error}}</code></pre></div></div><div><p>Request Data</p><div class="es-logs-code"><pre style="overflow:auto"><code>{{vm.getJsonInbound(task.inbound)}}</code></pre></div></div></div></div></div></div></div></div></div></div></div></div></main>');
$templateCache.put('mysaerrlogs.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>MySA Inbound Error Logs</b></h1></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div><div class="ibm-columns" ng-if="vm.signalWrongResponse"><div class="ibm-col-2-2" style="float: right; color: red;"><span ng-bind-html="vm.signalWrongResponse"></span></div></div><div class="ibm-columns flex"><md-tabs class="admin-tabs" md-dynamic-height="md-dynamic-height"><md-tab label="Errors list"><div class="ibm-columns"><div class="ibm-col-1-1"><div><p></p><table class="ibm-data-table ibm-grid ibm-altrows" id="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div></div></md-tab><md-tab label="History"><div class="ibm-columns"><div class="ibm-col-1-1"><div><p></p><table class="ibm-data-table ibm-grid ibm-altrows" id="table" datatable="" dt-options="vm.dtHistoryOptions" dt-columns="vm.dtHistoryColumns" dt-instance="vm.dtInstance"></table></div></div></div></md-tab></md-tabs></div></div></div></div></div></main>');
$templateCache.put('checkupdate.html','<style>.mysaresponse-table {\n    min-width: 1100px;\n}\n.mysaresponse-table tbody tr td:last-child,\n.mysaresponse-table thead tr td:last-child {\n    min-width: 130px;\n}\n.actions-container {\n    box-sizing: border-box;\n    display: inline-flex;\n    flex: 0 0 auto;\n    align-items: center;\n    justify-content: flex-end;\n    z-index: 1;\n    right: 0;\n    position: absolute;\n    top: 0;\n}\n.actions-container > div {\n    padding: 10px 5px;\n}\n.actions-container > div:first-child {\n    align-items: stretch;\n    display: flex;\n    flex: 1 1 auto;\n    height: 35px;     \n}\n.actions-container .actions {\n    border: solid 1px #5596e6;\n    padding: 7px 0px 7px 7px;\n    color: #5596e6;\n    display: flex;\n    align-items: center;\n}\n.export-btn-container button {\n    margin: 0;\n}\na.link {\n    text-decoration: none;\n}\n.alpha_dead {\n    color: lightgray;\n}\n.alpha_selly {\n    color: white;\n    background-color: #5596e6;\n    border-radius: 25%;\n}\n.form-list {\n    padding-top: 15px;\n    min-height: 65px;\n}\n.delete-button md-icon svg {\n    fill: #e71d32;\n}\n.edit-button md-icon svg {\n    fill: #325c80;\n}\n.fill {\n    display: flex;\n    width: 100%;\n    height: 100%;\n}\n#ibm-content-body {\n    box-sizing: border-box;\n}\n.admin-tabs, .admin-tabs md-tabs-content-wrapper, .admin-tabs md-tab-content, .admin-tabs md-tab-content > div {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n.flex {\n    display: flex;\n}\n.history-container {\n    display: flex;\n    flex: 1;\n    width: 100%;\n    overflow: auto;\n    padding-top: 15px;\n}\n.history-table td:nth-child(2), .history-table th:nth-child(2){\n    flex-grow: 4;\n}\n.history-table td:nth-child(3), .history-table th:nth-child(3){\n    flex-grow: 3;\n}\n.columnTest:first-letter {\n\n    text-transform: uppercase;\n\n}\n\n</style><main class="fill" role="main" aria-labelledby="ibm-pagetitle-h1"><div class="fill" id="ibm-pcon" ibm-back-to-top=""><div class="fill" id="ibm-content"><div class="fill" id="ibm-content-body"><div class="fill" id="ibm-content-main"><div class="fill" id="content" layout="column"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>{{ vm.checkData.name }}</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!vm.itemsLoaded ">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span ng-if="vm.settings.status_cfg"></span></div></div><div class="ibm-columns" ng-if="vm.signalWrongResponse"><div class="ibm-col-2-2" style="float: right; color: red;"><span ng-bind-html="vm.signalWrongResponse"></span></div></div><div class="ibm-columns flex"><md-tabs class="admin-tabs" md-dynamic-height="md-dynamic-height"><md-tab label="List"><form class="form-list fill" name="" layout="column"><div class="actions-container" ng-if="vm.itemsLoaded" flex="auto"><div><span class="actions"><span>Admin Actions</span><md-menu ng-disabled="vm.events.beingSaved" md-position-mode="target-right target" md-offset="280 40" style="margin-left:-10px"><md-button class="md-icon-button" ng-click="vm.openActionMenu($mdOpenMenu,$event)" title="Actions"><md-icon class="blue_icon" md-svg-icon="/public/images/star-circle.svg"></md-icon></md-button><md-menu-content width="4"><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.addRow($event)"><md-icon class="blue_icon" md-svg-icon="/public/images/rocket.svg"></md-icon>Add new record</md-button></md-menu-item></md-menu-content></md-menu></span></div><br></div><div class="fill" layout="column"><table class="mysaresponse-table ibm-data-table ibm-altrows ibm-alternate-two" id="table" datatable="" dt-options="vm.table.dtOptions" dt-instance="vm.table.dtInstance" dt-columns="vm.table.dtColumns" dt-disable-deep-watchers="true"></table></div></form></md-tab><md-tab label="History"><form class="form-list fill" name="" layout="column"><div class="history-container" ng-if="vm.logLoaded" flex="auto"></div><div class="fill" layout="column"><table class="history-table ibm-data-table ibm-altrows ibm-alternate-two" id="table" datatable="" dt-options="vm.tableLog.dtOptions" dt-instance="vm.tableLog.dtInstance" dt-columns="vm.tableLog.dtColumns"></table></div></form></md-tab></md-tabs></div></div></div></div></div></div></main>');
$templateCache.put('mysaresponse-edit.html','<style>.md-datepicker-calendar-pane{z-index: 1200}\n.md-dialog-is-showing md-dialog{width: 40%}\n.select2-selection--single {width: 200px }\n.select2, .select2-container, .select2-container--default, .select2-container--below, .select2-container--focus {width: 200px ! important}\n</style><md-dialog ng-cloak="" aria-label="Edit Compliance Plan record"><md-toolbar><div class="md-toolbar-tools"><h2>Edit Mysa Response</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon aria-label="Close dialog" md-svg-src="/public/images/ic_close_white_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="vm.disForm"><md-content class="md-padding"><span class="ibm-textcolor-blue-50">GEO&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="iot" ng-model="vm.content.GEO" ng-options="iot for iot in vm.iots" multiple="multiple"></select></div><p></p><span class="ibm-textcolor-blue-50">Market&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="imt" ng-model="vm.content.IMT" ng-options="imt for imt in vm.listIMTs(vm.tree, vm.content.GEO, vm.imts)" multiple="multiple"></select></div><p></p><span class="ibm-textcolor-blue-50">Country&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="country" ng-model="vm.content.COUNTRY" ng-options="country as country for country in vm.listCountries(vm.tree,vm.content.GEO,vm.content.IMT, vm.imts)" multiple="multiple"></select></div><p></p><span class="ibm-textcolor-blue-50">Exception&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="exception" ng-model="vm.content.EXCEPTION" ng-options="exception as exception for exception in vm.yesNoArr" ng-required="true"><option value="">--Please select--</option></select></div><p></p><div ng-if="[\'CD\', \'INC_GOE\'].indexOf(vm.table) === -1"><span class="ibm-textcolor-blue-50">BPA&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="bpa" ng-model="vm.content.BPA" ng-options="bpa as bpa for bpa in vm.yesNoArr" ng-required="true"><option value="">--Please select--</option></select></div><p></p><span class="ibm-textcolor-blue-50">TA&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="ta" ng-model="vm.content.TA" ng-options="ta as ta for ta in vm.taArr" ng-required="true"><option value="">--Please select--</option></select></div><p></p></div><div ng-if="[&quot;DUP&quot;, &quot;VALUE_ACHIEVED&quot;, &quot;CVR_SOLUTION&quot;, &quot;SPEC_BID&quot;, &quot;CVR_SSA&quot;, &quot;CVR_NC&quot;].indexOf(vm.table) !== -1"><span class="ibm-textcolor-blue-50">Value &nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="value" ng-model="vm.content.VALUE" ng-options="value as value for value in vm.yesNoArr" ng-required="true"><option value="">--Please select--</option></select></div><p></p></div><div ng-if="[&quot;DUP&quot;, &quot;CVR_NC&quot;, &quot;CVR_SSA&quot;, &quot;SPEC_BID&quot;].indexOf(vm.table) !== -1"><span class="ibm-textcolor-blue-50">MySa Dup &nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="mysaDup" ng-model="vm.content.MYSA_DUP" ng-options="mysaDup as mysaDup for mysaDup in vm.mysaArr" ng-required="true"><option value="">--Please select--</option></select></div><p></p></div><div ng-if="[&quot;CVR_SSA&quot;].indexOf(vm.table) !== -1"><span class="ibm-textcolor-blue-50">SC Dup &nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="scDup" ng-model="vm.content.SC_DUP" ng-options="scDup as scDup for scDup in vm.scArr" ng-required="true"><option value="">--Please select--</option></select></div><p></p></div><div ng-if="[&quot;DUP&quot;, &quot;CVR_SOLUTION&quot;, &quot;CD&quot;, &quot;INC_GOE&quot;, &quot;SPEC_BID&quot;, &quot;CVR_NC&quot;, &quot;CVR_SSA&quot;].indexOf(vm.table) !== -1"><span class="ibm-textcolor-blue-50">CMR &nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="cmr" ng-model="vm.content.CMR" ng-options="cmr as cmr for cmr in vm.cmrArr" ng-required="true"><option value="">--Please select--</option></select></div><p></p></div><div ng-if="[&quot;CVR_SOLUTION&quot;].indexOf(vm.table) !== -1"><span class="ibm-textcolor-blue-50">CVR Solution&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="solution" ng-model="vm.content.SOLUTION" ng-options="solution as solution for solution in vm.solArr" ng-required="true"><option value="">--Please select--</option></select></div><p></p></div><div ng-if="[&quot;INC_GOE&quot;, &quot;CVR_NC&quot;, &quot;CVR_SSA&quot;].indexOf(vm.table) !== -1"><span class="ibm-textcolor-blue-50">Incentives GOE &nbsp;&nbsp;<div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="incGoe" ng-model="vm.content.INC_GOE" ng-options="incGoe as incGoe for incGoe in vm.incArr" ng-required="true"><option value="">--Please select--</option></select></div><p></p></span></div><div ng-if="[&quot;CVR_NC&quot;].indexOf(vm.table) !== -1"><span class="ibm-textcolor-blue-50">NC &nbsp;&nbsp;<div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="nc" ng-model="vm.content.NC" ng-options="nc as nc for nc in vm.ncArr" ng-required="true"><option value="">--Please select--</option></select></div><p>       </p></span></div><div ng-if="[&quot;DUP&quot;, &quot;CVR_SSA&quot;, &quot;SPEC_BID&quot;, &quot;CVR_NC&quot;].indexOf(vm.table) !== -1"><span class="ibm-textcolor-blue-50">DR GOE &nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="drGoe" ng-model="vm.content.DR_GOE" ng-options="drGoe as drGoe for drGoe in vm.drArr" ng-required="true"><option value="">--Please select--</option></select></div><p></p></div><div ng-if="[&quot;CD&quot;, &quot;CVR_NC&quot;].indexOf(vm.table) !== -1"><span class="ibm-textcolor-blue-50">Customer Designation&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="cd" ng-model="vm.content.CD" ng-options="cd as cd for cd in vm.cdArr" ng-required="true"><option value="">--Please select--</option></select></div><p></p></div><div ng-if="[&quot;CVR_NC&quot;, &quot;DUP&quot;, &quot;CVR_SOLUTION&quot;, &quot;VALUE_ACHIEVED&quot;, &quot;BP_AUTH&quot;].indexOf(vm.table) !== -1"><span class="ibm-textcolor-blue-50">Response&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="response" ng-model="vm.content.RESPONSE" ng-options="response as response for response in vm.respArr" ng-required="true"><option value="">--Please select--</option></select></div><p></p></div><div ng-if="[&quot;CVR_SSA&quot;].indexOf(vm.table) !== -1"><span class="ibm-textcolor-blue-50">Response&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="response" ng-model="vm.content.RESPONSE" ng-options="response as response for response in vm.cvrSSAResp" ng-required="true"><option value="">--Please select--</option></select></div><p></p></div><div ng-if="[&quot;INC_GOE&quot;].indexOf(vm.table) !== -1"><span class="ibm-textcolor-blue-50">Response&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="response" ng-model="vm.content.RESPONSE" ng-options="response as response for response in vm.incGoeResp" ng-required="true"><option value="">--Please select--</option></select></div><p></p></div><div ng-if="[&quot;SPEC_BID&quot;].indexOf(vm.table) !== -1"><span class="ibm-textcolor-blue-50">Response&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="response" ng-model="vm.content.RESPONSE" ng-options="response as response for response in vm.specBidResp" ng-required="true"><option value="">--Please select--</option></select></div><p></p></div><div ng-if="[&quot;CD&quot;].indexOf(vm.table) !== -1"><span class="ibm-textcolor-blue-50">Response&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="response" ng-model="vm.content.RESPONSE" ng-options="response as response for response in vm.cdResp" ng-required="true"><option value="">--Please select--</option></select></div><p></p></div><div><span class="ibm-textcolor-blue-50">Reason Code&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="responseCode" ng-model="vm.content.RESPONSE_CODE" ng-options="responseCode as responseCode for responseCode in vm.codeResp" multiple="multiple"></select></div><p></p></div></md-content></ng-form><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="vm.disForm.$invalid">Submit</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-dialog-content></md-dialog>');
$templateCache.put('mysaresponse-view.html','<style>a.link {\n    text-decoration: none;\n}\na.link:hover {\n    background-color: #e9f1fc;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div class="ibm-columns" ng-if="!vm.editMode"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Check Results Configuration Profile</b></h1></div></div><div class="ibm-columns"><div class="ibm-col-6-5"><div ng-if="!vm.editMode"><div ng-repeat="check in vm.checkResults"><span> <a class="link" ng-click="vm.updateCheckData(check.name)" style="padding: 1px 5px; color: #5596e6">{{check.name}}</a><p></p></span></div></div></div></div><div class="ibm-columns"><div class="ibm-col-6-5"></div><div ng-if="vm.editMode &amp;&amp; vm.selectedCheckData"><div class="ibm-col-6-1"><span><md-button ng-click="vm.editMode = false" style="text-transform: unset;"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp; Back to Admin</md-button></span></div><check-results-update check="vm.selectedCheckData"></check-results-update></div></div></div></div></div></div></main>');
$templateCache.put('conflicts.html','<style>.conflicts {\n    border: solid 1px lightgray;\n    max-height: 500px;\n    height: 300px;\n    overflow: scroll;\n    overflow-x: hidden;\n    padding: 10px;\n}\ntable, td {\n    border-color: lightgray;\n}\ntable {\n    width: inherit;\n}</style><p></p><md-icon class="red_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;<a ng-click="vm.conflicts.viewDetails = !vm.conflicts.viewDetails"><span class="ibm-textcolor-red-60">{{!vm.conflicts.viewDetails ? "View Conflict Details" : "Hide Conflict Details"}}</span><p></p></a><div class="conflicts" ng-if="vm.conflicts.viewDetails"><p>The following&nbsp;<b>{{vm.conflicts.details.length}}&nbsp;</b>Program Profile combinations already exist. &nbsp;Either remove these conflicts from this Profile, or update the Profiles indicated in the table.</p><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-disabled="vm.conflicts.resolved" ng-click="vm.removeConflicts()"><md-icon class="white_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Remove Conflicts</md-button><span class="ibm-textcolor-red-60" ng-if="vm.conflicts.resolved">&nbsp;&nbsp;&nbsp;The conflicting Countries have been successfully removed from selection.</span><table class="ibm-data-table ibm-altrows ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1"><thead><tr ng-repeat="hd in vm.conflicts.headers"><td ng-repeat="(key,value) in hd">{{key}}</td></tr></thead><tBody><tr ng-repeat="dupe in vm.conflicts.details"><td ng-repeat="(key, value) in dupe"><span>{{value}}</span></td></tr></tBody></table><p></p></div><br/>');
$templateCache.put('program-view.html','<style>table, td {\n    border-color: lightgray;\n}\ntable {\n    width: inherit;\n}\na.link {\n    text-decoration: none;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Program Workflow Profiles</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!vm.programsLoaded">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span ng-if="vm.programsLoaded"></span></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div><div class="ibm-columns"><div class="ibm-col-6-5">Please select a Program Workflow Profile to view/edit, or create a new one via the&nbsp;<b>Create New&nbsp;</b>button.</div><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-if="vm.programsLoaded" ng-click="vm.createNew()"><md-icon class="white_icon" style="margin-left: -5px" md-svg-icon="/public/images/star-outline.svg"></md-icon>&nbsp;Create New</md-button></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><div ng-if="vm.programsLoaded &amp;&amp; !vm.table.filter"><span class="search_box"><md-icon class="blue_icon" md-svg-icon="/public/images/magnify.svg"></md-icon></span><input class="userField" ng-model="vm.table.search" placeholder="Enter search criteria"/>&nbsp;&nbsp;<a ng-click="vm.table.filter = true"><span class="ibm-textcolor-blue-50">Advanced Search</span></a><p></p></div><div class="checkbox_container" ng-if="vm.programs.length &amp;&amp; vm.table.filter">Please select the fields you would like to filter on:<p></p><div class="checkbox_subcontainer"><span ng-repeat="(key,value) in vm.table.headers[0]"><input type="checkbox" ng-model="vm.table.filters[value]" ng-change="vm.admin.refreshAdvancedFilter(vm.table)"/>{{key}} &nbsp;&nbsp;</span></div><div style="padding: 6px"><span ng-repeat="(key,value) in vm.table.headers[0]"><p ng-if="vm.table.filters[value] &amp;&amp; vm.table.filters!= \'\'">{{key}} &nbsp;<input class="userField" ng-if="vm.table.filters[value]" ng-model="vm.table.filterParams[value]"/></p></span></div><md-icon class="blue_icon" md-svg-icon="/public/images/magnify.svg"></md-icon>&nbsp;<a ng-click="vm.table.filter = false"><span class="ibm-textcolor-blue-50">Back to Basic Search</span></a>&nbsp;&nbsp;&nbsp;<md-icon class="blue_icon" md-svg-icon="/public/images/filter-variant.svg"></md-icon>&nbsp;<a ng-click="vm.resetFilters()"><span class="ibm-textcolor-blue-50">Reset</span></a><p></p></div></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><table class="ibm-data-table ibm-altrows ibm-alternate-two table" ng-if="vm.programs" cellspacing="0" cellpadding="0" border="1"><thead><tr ng-repeat="hd in vm.table.headers"><td ng-repeat="(key,value) in hd"><a class="link" ng-click="vm.table.sortType = value; vm.table.sortReverse = !vm.table.sortReverse">{{key}}&nbsp;</a><span ng-show="vm.table.sortType==value &amp;&amp; !vm.table.sortReverse"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_expand_less_black_24px.svg"></md-icon></span><span ng-show="vm.table.sortType==value &amp;&amp; vm.table.sortReverse"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_expand_more_black_24px.svg"></md-icon></span></td></tr></thead><tBody><tr ng-repeat="prog in vm.programs | orderBy:vm.table.sortType:vm.table.sortReverse | filter:(vm.table.filter ? vm.table.filterParams : vm.table.search)"><td ng-repeat="(key, value) in prog" ng-if="[&quot;_id&quot;,&quot;profile_id&quot;,&quot;_rev&quot;,&quot;type&quot;,&quot;onshore_offshore&quot;,&quot;status_flow&quot;].indexOf(key) == -1"><span ng-if="key==&quot;_link&quot;"><b><a class="link" style="color: #5596e6" ui-sref="admin.program({id:&quot;{{vm.prepLink(value,true)}}&quot;})">{{vm.prepLink(value,false)}}</a></b></span><span ng-if="key!=&quot;_link&quot;"><span>{{vm.admin.tidy(value)}}</span><p></p></span></td></tr></tBody></table></div></div></div></div></div></div></div></main>');
$templateCache.put('program.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Program Workflow Profile</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!vm.readyMan">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="vm.events.beingSaved">Checking for conflicts...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div><div class="ibm-col-6-1"><span><a ui-sref="admin.program-view"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Back to View</a></span></div></div><form name="progForm" ng-show="vm.readyMan"><div class="ibm-columns"><div class="ibm-col-6-5"><div ng-if="!vm.events.beingSaved &amp;&amp; !vm.conflicts.keys">Please enter the details for the Program Workflow Profile. &nbsp;Once all mandatory fields (<req></req>) are completed, the&nbsp;<b>Save&nbsp;</b>button will become available.</div><div ng-if="vm.conflicts.keys"><h1 class="ibm-textcolor-red-40 ibm-h3"><b>Conflicts Found</b></h1>It was not possible to save the Profile as it would result in duplicate entries in DMT. &nbsp;\nPlease view the details to below and remove the conflicting combinations before clicking&nbsp;<b>Save&nbsp;</b>button again.</div><div ng-if="vm.serverError" style="border: 1px solid red; padding: 10px; margin: 10px; background-color: #fff4f6"><h1 class="ibm-textcolor-red-40 ibm-h3"><b>Server Error</b></h1>There was a problem at the server. &nbsp;The details are as follows:<p></p><p class="ibm-textcolor-red-40">{{vm.serverError}}</p>If the problem persists, please contact the DMT System Administrators for guidance.</div><p></p><p></p><md-icon class="blue_icon" md-svg-icon="/public/images/help-circle.svg" title="This number represents the unique combinations that will be generated by multlplying the Countries x Brands x BP Types"></md-icon>&nbsp;Unique Combinations for this Profile :&nbsp;<b class="ibm-textcolor-blue-50">{{vm.combinations}}</b></div><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-disabled="(!vm.newProfile &amp;&amp;vm.$scope.progForm.$pristine) || vm.events.beingSaved || !vm.$scope.progForm.$valid || !vm.selectValid || !vm.valid.approval || !vm.valid.preapproval" ng-click="vm.save($event)"><md-icon class="white_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Save</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-if="!vm.newProfile" ng-disabled="vm.events.beingSaved || vm.events.beingDeleted" ng-click="vm.confirmDelete($event)"><md-icon class="white_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Delete</md-button></div></div><div ng-if="vm.conflicts.keys"><div class="ibm-columns"><div class="ibm-col-1-1"><style>.conflicts {\n    border: solid 1px lightgray;\n    max-height: 500px;\n    height: 300px;\n    overflow: scroll;\n    overflow-x: hidden;\n    padding: 10px;\n}\ntable, td {\n    border-color: lightgray;\n}\ntable {\n    width: inherit;\n}</style><p></p><md-icon class="red_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;<a ng-click="vm.conflicts.viewDetails = !vm.conflicts.viewDetails"><span class="ibm-textcolor-red-60">{{!vm.conflicts.viewDetails ? "View Conflict Details" : "Hide Conflict Details"}}</span><p></p></a><div class="conflicts" ng-if="vm.conflicts.viewDetails"><p>The following&nbsp;<b>{{vm.conflicts.details.length}}&nbsp;</b>Program Profile combinations already exist. &nbsp;Either remove these conflicts from this Profile, or update the Profiles indicated in the table.</p><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-disabled="vm.conflicts.resolved" ng-click="vm.removeConflicts()"><md-icon class="white_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Remove Conflicts</md-button><span class="ibm-textcolor-red-60" ng-if="vm.conflicts.resolved">&nbsp;&nbsp;&nbsp;The conflicting Countries have been successfully removed from selection.</span><table class="ibm-data-table ibm-altrows ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1"><thead><tr ng-repeat="hd in vm.conflicts.headers"><td ng-repeat="(key,value) in hd">{{key}}</td></tr></thead><tBody><tr ng-repeat="dupe in vm.conflicts.details"><td ng-repeat="(key, value) in dupe"><span>{{value}}</span></td></tr></tBody></table><p></p></div><br/></div></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Workflow Profile ID&nbsp;</label><req></req></div><div class="ibm-col-6-4 field"><input class="userField" placeholder="Enter a unique name for the profile, ie: SVI-LA-APU" ng-model="vm.editing.profile_id" size="50" ng-required="true"/><p class="ibm-textcolor-red-40" ng-if="vm.conflicts.profile_id == vm.editing.profile_id">A Profile already exists with this ID.  &nbsp;Please try another.</p></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Program&nbsp;</label><req></req></div><div class="ibm-col-6-4 field"><select ng-model="vm.editing.program" ng-options="x as x for x in vm.settings.programs | orderBy: x" ng-change="vm.setProgramID(vm.editing)"></select></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> IOT&nbsp;</label><req></req></div><div class="ibm-col-6-4 field"><select ng-if="vm.settings.iot_list" ng-model="vm.editing.imt" ng-options="x as x for x in vm.settings.iot_list | orderBy: x" ng-change="vm.iotChange()"></select></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Countries&nbsp;</label><req></req><div class="selected_top ibm-textcolor-blue-50" style="text-align: left;" ng-if="vm.editing.imt">Selected Countries</div><div class="selected" style="text-align: left" ng-if="vm.editing.imt"><ol style="type=1; list-style: outside disc; margin-left: 3px"><li style="position: relative;" ng-repeat="x in vm.settings.country_list | orderBy: \'country\' | filter: {ic:\'Country\'}" ng-if="vm.editing.countries.indexOf(x.short) &gt; -1 &amp;&amp; x.ic == \'Country\'">{{x.country}}</li></ol></div></div><div class="ibm-col-6-4 field"><span ng-if="!vm.editing.imt" style="color: gray">Please select the IOT</span><div class="field" id="countries" ng-if="vm.editing.imt"><div class="selectbox_bottom" style="padding-top: 14px; padding-bottom: 14px" ng-class="{select_good: vm.editing.countries.length&gt;0, select_error: !vm.editing.countries || vm.editing.countries.length==0}"><span class="checkbox_subcontainer" style="padding: 8px 0px 9px 0px"><md-icon class="blue_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg" style="margin-left:9px;margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px" ng-click="vm.selectAll(true)">Select All</a><md-icon class="blue_icon" md-svg-icon="/public/images/close-circle.svg" style="margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px" ng-click="vm.selectAll(false)">Deselect All</a></span><span class="ibm-textcolor-blue-50" ng-if="vm.editing.countries.length&gt;0">&nbsp;&nbsp;Selected :&nbsp;</span><b ng-if="vm.editing.countries.length&gt;0">{{vm.editing.countries.length}}</b><span ng-if="vm.editing.countries.length==0">&nbsp;&nbsp;Please select at least one</span></div><div class="selectbox"><span ng-repeat="cty in vm.settings.country_list | filter : {imt: vm.editing.imt,ic:\'Country\'}  | orderBy: \'country\'"><input ng-disabled="!vm.editing.imt" type="checkbox" ng-model="vm.select.countries[cty.short]" ng-change="vm.sync(\'countries\')"/>{{cty.country}} &nbsp;&nbsp;<p ng-if="vm.newLine($index+1,4)"></p></span></div></div></div></div><br/><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Brands&nbsp;</label><req></req><div class="selected_top ibm-textcolor-blue-50" style="text-align: left;">Selected Brands</div><div class="selected" style="text-align: left"><ol style="type=1; list-style: outside disc; margin-left: 3px"><li style="position: relative;" ng-repeat="x in vm.settings.brands | orderBy: x" ng-if="vm.editing.brands.indexOf(x) &gt; -1">{{x}}</li></ol></div></div><div class="ibm-col-6-4 field"><div class="selectbox_bottom" style="padding-top: 14px; padding-bottom: 14px" ng-class="{select_good: vm.editing.brands.length&gt;0, select_error: !vm.editing.brands || vm.editing.brands.length==0}"><span class="checkbox_subcontainer" style="padding: 8px 0px 9px 0px"><md-icon class="blue_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg" style="margin-left:9px;margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px" ng-click="vm.selectAll2(true,\'brands\')">Select All</a><md-icon class="blue_icon" md-svg-icon="/public/images/close-circle.svg" style="margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px" ng-click="vm.selectAll2(false,\'brands\')">Deselect All</a></span><span class="ibm-textcolor-blue-50" ng-if="vm.editing.brands.length&gt;0">&nbsp;&nbsp;Selected :&nbsp;</span><b ng-if="vm.editing.brands.length&gt;0">{{vm.editing.brands.length}}</b><span ng-if="!vm.editing.brands || vm.editing.brands.length==0">&nbsp;&nbsp;Please select at least one</span></div><div class="selectbox"><span ng-repeat="brand in vm.settings.brands | orderBy: brand"><input type="checkbox" ng-model="vm.select.brands[brand]" ng-change="vm.sync(\'brands\')"/>{{brand}} &nbsp;&nbsp;<p ng-if="vm.newLine($index+1,2)"></p></span></div></div></div><br/><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> BP Types&nbsp;</label><req></req><div class="selected_top ibm-textcolor-blue-50" style="text-align: left;">Selected BP Types</div><div class="selected" style="text-align: left"><ol style="type=1; list-style: outside disc; margin-left: 3px"><li style="position: relative;" ng-repeat="x in vm.settings.bp_types | orderBy: x" ng-if="vm.editing.bp_types.indexOf(x) &gt; -1">{{x}}</li></ol></div></div><div class="ibm-col-6-4 field"><div class="selectbox_bottom" style="padding-top: 14px; padding-bottom: 14px" ng-class="{select_good: vm.editing.bp_types.length&gt;0, select_error: !vm.editing.bp_types || vm.editing.bp_types.length==0}"><span class="checkbox_subcontainer" style="padding: 8px 0px 9px 0px"><md-icon class="blue_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg" style="margin-left:9px;margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px" ng-click="vm.selectAll2(true,\'bp_types\')">Select All</a><md-icon class="blue_icon" md-svg-icon="/public/images/close-circle.svg" style="margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px" ng-click="vm.selectAll2(false,\'bp_types\')">Deselect All</a></span><span class="ibm-textcolor-blue-50" ng-if="vm.editing.bp_types.length&gt;0">&nbsp;&nbsp;Selected :&nbsp;</span><b ng-if="vm.editing.bp_types.length&gt;0">{{vm.editing.bp_types.length}}</b><span ng-if="!vm.editing.bp_types || vm.editing.bp_types.length==0">&nbsp;&nbsp;Please select at least one</span></div><div class="selectbox"><span ng-repeat="bptype in vm.settings.bp_types | orderBy: bptype"><input type="checkbox" ng-model="vm.select.bp_types[bptype]" ng-change="vm.sync(\'bp_types\')"/>{{bptype}} &nbsp;&nbsp;<p ng-if="vm.newLine($index+1,3)"></p></span></div></div></div><br/><!--.ibm-columns.ibm-col-6-2(class="right")\n    label(class="ibm-textcolor-blue-50")  Onshore/Offshore\n.ibm-col-6-4(class="field")\n    select(ng-if="vm.readyMan" ng-model="vm.editing.onshore_offshore" ng-options="x as x for x in [\'Onshore\',\'Offshore\']")--><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Payment System&nbsp;</label><req></req></div><div class="ibm-col-6-4 field"><select ng-if="vm.settings.payment_systems" ng-model="vm.editing.payment_system" ng-options="x as x for x in vm.settings.payment_systems | orderBy: x"></select></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Approval Stages&nbsp;</label><req></req><div class="selected_top ibm-textcolor-blue-50" style="text-align: left;">Selected Approval Stages</div><div class="selected" style="text-align: left"><ol style="type=1; list-style: outside disc; margin-left: 3px"><li style="position: relative;" ng-repeat="x in vm.select.approval.stages_ordered_text">{{x}}</li></ol></div></div><div class="ibm-col-6-4 field"><div class="selectbox_bottom" style="padding-bottom: 14px" ng-class="{select_good: vm.editing.approval_stages.length&gt;0, select_error: !vm.editing.approval_stages || vm.editing.approval_stages.length==0}"><span>Please select the stages&nbsp;<u>in the order they should flow</u>&nbsp;during the approval process. &nbsp;The panel on the left will show the selected order.</span><p></p><span class="ibm-textcolor-blue-50" ng-if="vm.editing.approval_stages.length&gt;0">&nbsp;&nbsp;Selected :&nbsp;</span><b ng-if="vm.editing.approval_stages.length&gt;0">{{vm.editing.approval_stages.length}}</b><span class="checkbox_subcontainer" ng-if="vm.editing.approval_stages.length &gt; 0" style="padding: 8px 0px 9px 0px; margin-left: 10px"><md-icon class="blue_icon" md-svg-icon="/public/images/close-circle.svg" style="margin-left: 9px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: 4px; margin-right: 15px" ng-click="vm.wipeApprovals(\'approval\')">Clear Stages</a></span></div><div class="selectbox"><span ng-repeat="appstage in vm.config.getSubStatusesByMainStatusNo(5)"><input type="checkbox" ng-model="vm.select.approval.stages[appstage.no]" ng-change="vm.syncAppStages(appstage.no,\'approval\',5)"/>{{appstage.txt}} &nbsp;&nbsp;<p></p></span></div></div></div><br/><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Does this Program have a Pre-Approval Stage?&nbsp;</label><req></req></div><div class="ibm-col-6-4 field"><input type="radio" ng-model="vm.select.hasPreApproval" ng-value="true" ng-change="vm.areApprovalsValid()"/>Yes<input type="radio" ng-model="vm.select.hasPreApproval" ng-value="false" ng-change="vm.wipeApprovals(\'preapproval\')"/>No</div></div><div class="ibm-columns" ng-if="vm.select.hasPreApproval"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Pre-Approval Stages&nbsp;</label><req></req><div class="selected_top ibm-textcolor-blue-50" style="text-align: left;">Selected Pre-Approval Stages</div><div class="selected" style="text-align: left"><ol style="type=1; list-style: outside disc; margin-left: 3px"><li style="position: relative;" ng-repeat="x in vm.select.preapproval.stages_ordered_text">{{x}}</li></ol></div></div><div class="ibm-col-6-4 field"><div class="selectbox_bottom" style="padding-bottom: 14px" ng-class="{select_good: vm.editing.preapproval_stages.length&gt;0, select_error: !vm.editing.preapproval_stages || vm.editing.preapproval_stages.length==0}"><span>Please select the stages&nbsp;<u>in the order they should flow</u>&nbsp;during the pre-approval process. &nbsp;The panel on the left will show the selected order.</span><p></p><span class="ibm-textcolor-blue-50" ng-if="vm.editing.preapproval_stages.length&gt;0">&nbsp;&nbsp;Selected :&nbsp;</span><b ng-if="vm.editing.preapproval_stages.length&gt;0">{{vm.editing.preapproval_stages.length}}</b><span class="checkbox_subcontainer" ng-if="vm.editing.preapproval_stages.length &gt; 0" style="padding: 8px 0px 9px 0px; margin-left: 10px"><md-icon class="blue_icon" md-svg-icon="/public/images/close-circle.svg" style="margin-left: 9px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: 4px; margin-right: 15px" ng-click="vm.wipeApprovals(\'preapproval\')">Clear Stages</a></span></div><div class="selectbox"><span ng-repeat="appstage in vm.config.getSubStatusesByMainStatusNo(2)"><input type="checkbox" ng-model="vm.select.preapproval.stages[appstage.no]" ng-change="vm.syncAppStages(appstage.no,\'preapproval\',2)"/>{{appstage.txt}} &nbsp;&nbsp;<p></p></span></div></div></div><br/><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Opportunity expiration number of days &nbsp;</label><req></req></div><div class="ibm-col-6-4 field"><input class="userField" placeholder="1-9999" type="number" ng-min="1" ng-max="9999" ng-model="vm.editing.expiration" ng-pattern="/^-?[0-9][^.]*$/" ng-required="true"/></div></div></form></div></div></div></div></main><p></p>');
$templateCache.put('sampling-view.html','<style>.actions {\n    border: solid 1px #5596e6;\n    padding: 7px 0px 7px 7px;\n    margin-left: 18px;\n    color: #5596e6;\n}\n.errors {\n    border: solid 1px lightgray;\n    max-height: 170px;\n    height: 170px;\n    overflow: scroll;\n    overflow-x: hidden;\n}\n.seTd {\n    background-color: white;\n}\n.serverError {\n    border: 1px solid red; \n    padding: 10px; \n    margin: 10px; \n    background-color: #fff4f6\n}\ntable, td {\n    border: solid 1px lightgray;\n    padding: 10px;\n}\n.period:hover {\n    background-color: #ff4a4a05;\n}\n.alpha_dead {\n    color: lightgray;\n}\n.alpha_selly {\n    color: white;\n    background-color: #5596e6;\n    border-radius: 25%;\n}\n.cty {\n    text-align: center;\n    background-color: #ddf1ff;\n    font-size: large;\n    font-weight: bold;\n}\n.hd {\n    font-size: smaller;\n    color: gray;\n    text-align: center;\n    background-color: #f0f7ff;\n}\n.md-text {\n    font-size: smaller;\n}\n.md-datepicker-input-container {\n    width: 95px;\n    margin-left: 0px;\n}\n.k {\n    width: 60px;\n}\n.k2 {\n    font-size: 14px;\n    text-align: center;\n}\n.rate {\n    width: 30px;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Sampling Profile</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="vm.countriesLoaded!= true || vm.sourceLoaded != true">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div><br/><div class="ibm-columns" ng-if="(vm.countriesLoaded== true &amp;&amp; vm.sourceLoaded == true)" id="generalInfo"><form name="vm.sampBase"><div class="ibm-columns"><div class="ibm-col-1-1"><a class="ibm-textcolor-blue-30" style="font-size:medium; margin-left:20px" ng-click="vm.events.viewBase = !vm.events.viewBase">Click to {{!vm.events.viewBase ? \'view\' : \'hide\'}} Base Values</a><div ng-if="vm.events.viewBase"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" style="float: right" ng-click="vm.saveBaseData($event)" title="Save your updates" ng-disabled="vm.sampBase.$pristine || vm.events.beingSaved || !vm.sampBase.$valid"><md-icon class="white_icon" style="margin-left: -5px" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Save Changes</md-button><table style="width:max-content; overflow:scroll"><tbody><tr class="cty"><td style="width: 200px">Sampling Rates</td><td style="width: 250px" colspan="2">Baseline</td><td style="width: 250px" colspan="2">Low Frequency</td><td style="width: 250px" colspan="2">High Frequency</td></tr><tr class="hd"><td>Risk</td><td>Low / Std %</td><td>High %</td><td>Low / Std %</td><td>High %</td><td>Low / Std  %</td><td>High %</td></tr><tr ng-repeat="rate in vm.rates"><td class="k2">{{rate.v}}</td><td class="k2"><input class="rate" ng-model="vm.riskSamplingSource.baseline.lowStRisk[rate.k]" name="{{rate.k + \'0\' + $index}}" ng-change="vm.baseChange(\'baseline\',\'lowStRisk\',rate.k)" ng-pattern="/^[0-9][0-9]?$|100$/" ng-minlength="1" ng-maxlength="3" ng-required="true"/><b class="ibm-textcolor-red-50" style="font-size:1pc" ng-if="!vm.sampBase[rate.k + \'0\' + $index].$valid" title="The Percentage must be a number between 0 and 100">&nbsp;X</b></td><td class="k2"><input class="rate" ng-model="vm.riskSamplingSource.baseline.highRisk[rate.k]" name="{{rate.k + \'1\' + $index}}" ng-change="vm.baseChange(\'baseline\',\'highRisk\',rate.k)" ng-pattern="/^[0-9][0-9]?$|100$/" ng-minlength="1" ng-maxlength="3" ng-required="true"/><b class="ibm-textcolor-red-50" style="font-size:1pc" ng-if="!vm.sampBase[rate.k + \'1\' + $index].$valid" title="The Percentage must be a number between 0 and 100">&nbsp;X</b></td><td class="k2"><input class="rate" ng-model="vm.riskSamplingSource.lowFrequency.lowStRisk[rate.k]" name="{{rate.k + \'2\' + $index}}" ng-change="vm.baseChange(\'lowFrequency\',\'lowStRisk\',rate.k)" ng-pattern="/^[0-9][0-9]?$|100$/" ng-minlength="1" ng-maxlength="3" ng-required="true"/><b class="ibm-textcolor-red-50" style="font-size:1pc" ng-if="!vm.sampBase[rate.k + \'2\' + $index].$valid" title="The Percentage must be a number between 0 and 100">&nbsp;X</b></td><td class="k2"><input class="rate" ng-model="vm.riskSamplingSource.lowFrequency.highRisk[rate.k]" name="{{rate.k + \'3\' + $index}}" ng-change="vm.baseChange(\'lowFrequency\',\'highRisk\',rate.k)" ng-pattern="/^[0-9][0-9]?$|100$/" ng-minlength="1" ng-maxlength="3" ng-required="true"/><b class="ibm-textcolor-red-50" style="font-size:1pc" ng-if="!vm.sampBase[rate.k + \'3\' + $index].$valid" title="The Percentage must be a number between 0 and 100">&nbsp;X</b></td><td class="k2"><input class="rate" ng-model="vm.riskSamplingSource.highFrequency.lowStRisk[rate.k]" name="{{rate.k + \'4\' + $index}}" ng-change="vm.baseChange(\'highFrequency\',\'lowStRisk\',rate.k)" ng-pattern="/^[0-9][0-9]?$|100$/" ng-minlength="1" ng-maxlength="3" ng-required="true"/><b class="ibm-textcolor-red-50" style="font-size:1pc" ng-if="!vm.sampBase[rate.k + \'4\' + $index].$valid" title="The Percentage must be a number between 0 and 100">&nbsp;X</b></td><td class="k2"><input class="rate" ng-model="vm.riskSamplingSource.highFrequency.highRisk[rate.k]" name="{{rate.k + \'5\' + $index}}" ng-change="vm.baseChange(\'highFrequency\',\'highRisk\', rate.k)" ng-pattern="/^[0-9][0-9]?$|100$/" ng-minlength="1" ng-maxlength="3" ng-required="true"/><b class="ibm-textcolor-red-50" style="font-size:1pc" ng-if="!vm.sampBase[rate.k + \'5\' + $index].$valid" title="The Percentage must be a number between 0 and 100">&nbsp;X</b></td></tr></tbody></table></div></div></div></form><br/><p></p><form name="vm.sampCty"><div class="ibm-columns"><div class="ibm-col-6-5"><span class="search_box"><md-icon class="blue_icon" md-svg-icon="/public/images/magnify.svg"></md-icon></span><input class="userField" ng-model="vm.table.filters.cty" placeholder="Enter search criteria"/><span class="actions"><span>Admin Actions</span><md-menu md-position-mode="target-right target" md-offset="280 40" style="margin-left:-10px" ng-disabled="vm.events.beingSaved"><md-button class="md-icon-button" ng-click="vm.openActionMenu($mdOpenMenu,$event)" title="Actions"><md-icon class="blue_icon" md-svg-icon="/public/images/star-circle.svg"></md-icon></md-button><md-menu-content width="4"><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.createMissingCountries($event)"><md-icon class="blue_icon" md-svg-icon="/public/images/rocket.svg"></md-icon>Create Missing Countries</md-button></md-menu-item><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.massUpdateAdd($event)"><md-icon class="green_icon" md-svg-icon="/public/images/ic_add_circle_outline_black_24px.svg"></md-icon>Mass Update New Periods</md-button></md-menu-item><md-menu-item><md-button class="ibm-btn-pri" ng-click="vm.massDeleteExpired($event)"><md-icon class="red_icon" md-svg-icon="/public/images/close-circle-outline.svg"></md-icon>Mass Delete All Expired Periods</md-button></md-menu-item></md-menu-content></md-menu></span></div><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.saveCountryData($event)" title="Save your updates" ng-disabled="vm.sampCty.$pristine || vm.events.beingSaved || !vm.sampCty.$valid"><md-icon class="white_icon" style="margin-left: -5px" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Save Changes</md-button></div><br/></div><div class="ibm-columns" ng-if="vm.events.serverErrors"><div class="ibm-col-1-1"><div class="serverError"><h1 class="ibm-textcolor-red-40 ibm-h3"><b>Validation Error</b></h1>There {{vm.events.serverErrors.length === 1 ? \'is\' : \'are\'}} <b>{{vm.events.serverErrors.length}} </b>validation error(s). &nbsp;The details are as follows:<p></p><div class="errors"><table><tr class="seTd" ng-repeat="err in vm.events.serverErrors"><td># {{$index + 1}}</td><td> <b>{{err.cty}}</b></td><td>{{err.error}}</td></tr></table></div><p></p>Please correct the issues before attempting to save again.</div></div><br/></div><div style="padding:15px"><span style="padding-right:10px; font-weight:bold">Index:</span><span ng-repeat="letter in vm.alphabet.full" style="padding-left:5px; padding-right:5px" ng-class="{\'alpha_dead\': vm.alphabet.act.indexOf(letter) &lt; 0, \'alpha_selly\': vm.alphabet.selected === letter}" ng-click="vm.activateLetter(letter)">{{letter}}           </span><span style="float:right;">Showing {{vm.table.visible}} of {{vm.samplingCountries.length}} total countries</span></div><div style="overflow:scroll"><table style="width:max-content; overflow:scroll"><tbody ng-repeat="sample in vm.samplingCountries | orderBy: \'cty\' | filter:vm.table.filters.cty" ng-if="sample.periods &amp;&amp; sample.show"><tr class="cty"><td colspan="12"><span>{{sample.cty}}</span><md-button class="ibm-btn-pri ibm-btn-small md-icon-button" ng-disabled="vm.events.beingSaved" aria-label="Add" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;" ng-click="vm.addPeriod(sample.cty)" title="Add Entry"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_add_circle_outline_black_24px.svg"></md-icon></md-button></td></tr><tr class="hd"><!--td GMU--><td>Risk Level</td><td>Sampling Rate</td><td>Start Date</td><td>End Date</td><td>Delete</td><td class="k" ng-repeat="rate in vm.rates">{{rate.v}} %</td></tr><tr ng-repeat="period in sample.periods" ng-init="pi = $index"><!--tdmd-select(ng-model=\'period.newGMU\' aria-label=\'GMU\' ng-required="true")\n    md-option(ng-repeat="gmu in vm.gmuList" value=\'{{gmu.value}}\' ng-selected="gmu.value == period.GMU") {{gmu.text}}--><td><md-select ng-model="period.newRiskLevel" ng-change="vm.reevaluateCty(period)" aria-label="Risk" ng-required="true"><md-option ng-repeat="risk in vm.riskLevelList" value="{{risk.value}}" ng-selected="period.riskLevel == risk.value">{{risk.text}}</md-option></md-select></td><td><md-select ng-model="period.newSamplingRate" ng-change="vm.reevaluateCty(period)" aria-label="Rate" ng-required="true"><md-option ng-repeat="sRate in vm.samplingRateList" value="{{sRate.value}}" ng-selected="period.samplingRate == sRate.value">{{sRate.text}}</md-option></md-select></td><td> <md-datepicker ng-model="period.sdate_dp" ng-change="vm.dowhatever($event)" ng-required="true"></md-datepicker></td><td> <md-datepicker ng-model="period.edate_dp" ng-change="vm.dowhatever($event)" ng-required="true"></md-datepicker></td><td><md-button class="ibm-btn-pri ibm-btn-small md-icon-button" ng-if="sample.periods.length &gt; 1" ng-disabled="vm.events.beingSaved" aria-label="Delete" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;" ng-click="vm.deletePeriod($event, sample, pi)" title="Delete entry"><md-icon class="red_icon" md-svg-icon="/public/images/delete-forever.svg"></md-icon></md-button><md-icon class="pink_icon" style="margin-left: 9px" ng-if="sample.periods.length &lt; 2" md-svg-icon="/public/images/delete-forever.svg" title="Deletion not permitted.  There must be at least one entry for a country"></md-icon></td><td class="k2" ng-repeat="rate in vm.rates" ng-init="ri = $index"><input class="rate" ng-model="period.finalRates[rate.k]" name="{{sample.cty+\'.\'+pi+\'.\'+ri}}" ng-change="vm.checkForOverride(period)" ng-pattern="/^[0-9][0-9]?$|100$/" ng-minlength="1" ng-maxlength="3" ng-required="true"/><b class="ibm-textcolor-orange-30" style="font-size:1pc" ng-if="vm.sampCty[sample.cty+\'.\'+pi+\'.\'+ri].$valid &amp;&amp; period.override[rate.k]" title="{{vm.getTitle(period, rate.k)}}">&nbsp;!</b><b class="ibm-textcolor-red-50" style="font-size:1pc" ng-if="!vm.sampCty[sample.cty+\'.\'+pi+\'.\'+ri].$valid" title="The Percentage must be a number between 0 and 100">&nbsp;X</b></td></tr></tbody></table></div></form></div></div></div></div></div></div></div></main>');
$templateCache.put('conflicts.html','<style>.conflicts {\n    border: solid 1px lightgray;\n    max-height: 500px;\n    height: 300px;\n    overflow: scroll;\n    overflow-x: hidden;\n    padding: 10px;\n}\ntable, td {\n    border-color: lightgray;\n}\ntable {\n    width: inherit;\n}</style><p></p><md-icon class="red_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;<a ng-click="vm.conflicts.viewDetails = !vm.conflicts.viewDetails"><span class="ibm-textcolor-red-60">{{!vm.conflicts.viewDetails ? "View Approver Issues" : "Hide Approver Issues"}}</span><p></p></a><div class="conflicts" ng-if="vm.conflicts.viewDetails"><p></p>You have specified that this Approval Stage is a Manager-only stage, but the following&nbsp;<b>{{vm.conflicts.notManagers.length}}&nbsp;</b>selected Approvers are not Managers in Blue Pages. &nbsp;Please deselect them.<p></p><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-disabled="vm.conflicts.resolved" ng-click="vm.removeNonManagers()"><md-icon class="white_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Remove Approvers</md-button><span class="ibm-textcolor-red-60" ng-if="vm.conflicts.resolved">&nbsp;&nbsp;&nbsp;The users have been successfully removed from selection.</span><p></p><table class="ibm-data-table ibm-altrows ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1"><tBody><tr ng-repeat="manager in vm.conflicts.notManagers"><td>{{manager.name}}</td><td>{{manager.email}}</td></tr></tBody></table><p></p></div><br/>');
$templateCache.put('disbursements.html','<style>.conflicts {\n    border: solid 1px lightgray;\n    max-height: 500px;\n    height: 300px;\n    overflow: scroll;\n    overflow-x: hidden;\n    padding: 10px;\n}\ntable, td {\n    border-color: lightgray;\n}\ntable {\n    width: inherit;\n}\na {\n    color: "ibm-textcolor-blue-50";\n}\na.head {\n    text-decoration: none;\n}</style><md-icon class="red_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;<a ng-if="vm.disInStatus.opps.length &gt; 0" ng-click="vm.disInStatus.viewDetails = !vm.disInStatus.viewDetails"><span class="ibm-textcolor-red-60">{{!vm.disInStatus.viewDetails ? "View " : "Hide "}} Disbursements</span><p></p></a><a ng-if="vm.pwWithStatus.pws.length &gt; 0" ng-click="vm.pwWithStatus.viewDetails = !vm.pwWithStatus.viewDetails"><span class="ibm-textcolor-red-60">{{!vm.pwWithStatus.viewDetails ? "View " : "Hide "}} Program Workflows</span><p></p></a><div class="conflicts" ng-if="vm.disInStatus.viewDetails"><p></p>You have selected to Deactive this Status, but the following&nbsp;<b>{{vm.disInStatus.opps.length}}&nbsp;</b>Disbursements are currently in this status. &nbsp;Their statuses will need to change before you can continue.<p></p><table class="ibm-data-table ibm-altrows ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1"><tBody><tr ng-repeat="opp in vm.disInStatus.opps">               <td><a ui-sref="detail.general({id:&quot;{{opp.substring(4)}}&quot;})">{{opp}}</a></td></tr></tBody></table><p></p></div><div class="conflicts" ng-if="vm.pwWithStatus.viewDetails"><p></p>You have selected to Deactive this Approval Stage, but the following&nbsp;<b>{{vm.pwWithStatus.pws.length}}&nbsp;</b>Program Workflows currently use it. &nbsp;The Stage will need to be removed from each before you can continue.<p></p><table class="ibm-data-table ibm-altrows ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1"><tBody><tr ng-repeat="pw in vm.pwWithStatus.pws">               <td><a ui-sref="admin.program({id:&quot;{{pw._id}}&quot;})">{{pw.profile_id}}</a></td></tr></tBody></table><p></p></div><br/>');
$templateCache.put('status-view.html','<style>table, td {\n    border-color: lightgray;\n}\ntable {\n    width: inherit;\n}\na.link {\n    text-decoration: none;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Status Configuration Profiles</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!vm.settings.status_cfg">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span ng-if="vm.settings.status_cfg"></span></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div><div class="ibm-columns"><div class="ibm-col-6-5">Use this section to edit or add new Sub-Statuses/Approval Stages for each main DMT status. &nbsp;Please select a Status to view/edit.<p></p></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><table class="ibm-data-table ibm-altrows ibm-alternate-two table" ng-if="vm.settings.status_cfg" cellspacing="0" cellpadding="0" border="1"><thead><tr ng-repeat="hd in vm.table.headers"><td ng-repeat="(key,value) in hd"><span>{{key}}&nbsp;</span></td></tr></thead><tBody><tr ng-repeat="stat in vm.settings.status_cfg | orderBy:&quot;psn&quot;"><td ng-hide="true"><span>{{stat.psn}}</span></td><td><b><a class="link" style="color: #5596e6" ui-sref="admin.status({status:&quot;{{stat.no}}&quot;})">{{stat.txt}}</a></b><span style="color: #5596e6">&nbsp;({{stat.no}})</span></td><td><span>{{stat.desc}}</span></td></tr></tBody></table><p></p></div></div></div></div></div></div></div></main>');
$templateCache.put('status.html','<style>a.link {\n    text-decoration: none;\n}\na.link:hover {\n    background-color: #e9f1fc;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><!--b Approvers--><!--| {{vm.approvers.bpso}}--><!--b EDITING--><!--| {{vm.editing.users}}--><!--b SELECT--><!--| {{vm.select}}--><!--b APP GROUP--><!--| {{vm.approvalGroup}}--><!--b SAVED--><!--| being saved:{{vm.events.beingSaved}} formvalid:{{vm.$scope.statForm.$valid}} formpristine:{{vm.$scope.statForm.$pristine}} selectvalid:{{vm.selectValid}} conlficts:{{vm.conflicts.resolved}}--><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Status Configuration Profile</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!vm.readyMan">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><h1 class="ibm-textcolor-blue-50 ibm-h3" ng-show="vm.readyMan"><b>{{::vm.mainStatus.txt}}</b></h1></div><div class="ibm-col-6-1"><span ng-if="!vm.editMode"><a ui-sref="admin.status-view"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Back to View</a></span></div></div><div class="ibm-columns"><div class="ibm-col-6-5"><div ng-if="!vm.editMode &amp;&amp; vm.readyMan">The current {{vm.approvalStage ? "Approval Stages" : "Sub-Statuses"}} for the above Main Status are listed below.  &nbsp;Either select one to edit or create a new one via the&nbsp;<b>Create New&nbsp;</b>button. &nbsp;Hover over each for the detail.<p></p><input type="radio" ng-model="vm.filter" value="Active"/><span class="ibm-textcolor-gray-60">Active Only</span><input style="margin-left:10px" type="radio" ng-model="vm.filter" value="Inactive"/><span class="ibm-textcolor-gray-60">Inactive Only</span><input style="margin-left:10px" type="radio" ng-model="vm.filter" value="All"/><span class="ibm-textcolor-gray-60">All</span><p></p><div ng-repeat="status in vm.mainStatus.subs"><span ng-if="[\'All\',\'Active\'].indexOf(vm.filter) &gt; -1 &amp;&amp; (status.active === undefined || status.active === true)"><a class="link" title="{{::vm.config.getAppStageForPrez(vm.mainStatus.no,status.no,false)}}" style="padding: 1px 5px; color: #5596e6" ng-click="vm.setEditingData(status.no)">{{status.txt}}</a><p></p></span><span ng-if="[\'All\',\'Inactive\'].indexOf(vm.filter) &gt; -1 &amp;&amp; status.active !== undefined &amp;&amp; status.active === false"><a class="link ibm-textcolor-red-40" title="{{::vm.config.getAppStageForPrez(vm.mainStatus.no,status.no,false)}}" style="padding: 1px 5px;" ng-click="vm.setEditingData(status.no)">{{status.txt}}</a><p></p></span><!--span(style="color:lightgray")| &nbsp;[{{::vm.mainStatus.no}}-{{::status.no}}]--></div></div></div><div class="ibm-col-6-1"><div ng-if="!vm.editMode &amp;&amp; vm.readyMan"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.createNew($event)"><md-icon class="white_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Create New</md-button></div></div></div></div><form name="statForm" ng-show="vm.editMode"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="vm.events.beingSaved">Validating and Saving...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><div ng-if="!vm.events.beingSaved">Please make the necessary changes bearing in mind that all fields marked with&nbsp;<req></req>&nbsp;are mandatory.  &nbsp;Click&nbsp;<b>Save&nbsp;</b>when ready, or&nbsp;<b>Cancel&nbsp;</b>to return to the {{vm.approvalStage ? "Approval Stage" : "Sub-Status"}} list.</div><div ng-if="vm.conflicts.notManagers.length &gt; 0"><style>.conflicts {\n    border: solid 1px lightgray;\n    max-height: 500px;\n    height: 300px;\n    overflow: scroll;\n    overflow-x: hidden;\n    padding: 10px;\n}\ntable, td {\n    border-color: lightgray;\n}\ntable {\n    width: inherit;\n}</style><p></p><md-icon class="red_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;<a ng-click="vm.conflicts.viewDetails = !vm.conflicts.viewDetails"><span class="ibm-textcolor-red-60">{{!vm.conflicts.viewDetails ? "View Approver Issues" : "Hide Approver Issues"}}</span><p></p></a><div class="conflicts" ng-if="vm.conflicts.viewDetails"><p></p>You have specified that this Approval Stage is a Manager-only stage, but the following&nbsp;<b>{{vm.conflicts.notManagers.length}}&nbsp;</b>selected Approvers are not Managers in Blue Pages. &nbsp;Please deselect them.<p></p><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-disabled="vm.conflicts.resolved" ng-click="vm.removeNonManagers()"><md-icon class="white_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Remove Approvers</md-button><span class="ibm-textcolor-red-60" ng-if="vm.conflicts.resolved">&nbsp;&nbsp;&nbsp;The users have been successfully removed from selection.</span><p></p><table class="ibm-data-table ibm-altrows ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1"><tBody><tr ng-repeat="manager in vm.conflicts.notManagers"><td>{{manager.name}}</td><td>{{manager.email}}</td></tr></tBody></table><p></p></div><br/></div><div ng-if="vm.disInStatus.opps.length &gt; 0 || vm.pwWithStatus.pws.length &gt; 0"><p></p><h1 class="ibm-textcolor-red-40 ibm-h3"><b>{{vm.serverError}}</b></h1><style>.conflicts {\n    border: solid 1px lightgray;\n    max-height: 500px;\n    height: 300px;\n    overflow: scroll;\n    overflow-x: hidden;\n    padding: 10px;\n}\ntable, td {\n    border-color: lightgray;\n}\ntable {\n    width: inherit;\n}\na {\n    color: "ibm-textcolor-blue-50";\n}\na.head {\n    text-decoration: none;\n}</style><md-icon class="red_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;<a ng-if="vm.disInStatus.opps.length &gt; 0" ng-click="vm.disInStatus.viewDetails = !vm.disInStatus.viewDetails"><span class="ibm-textcolor-red-60">{{!vm.disInStatus.viewDetails ? "View " : "Hide "}} Disbursements</span><p></p></a><a ng-if="vm.pwWithStatus.pws.length &gt; 0" ng-click="vm.pwWithStatus.viewDetails = !vm.pwWithStatus.viewDetails"><span class="ibm-textcolor-red-60">{{!vm.pwWithStatus.viewDetails ? "View " : "Hide "}} Program Workflows</span><p></p></a><div class="conflicts" ng-if="vm.disInStatus.viewDetails"><p></p>You have selected to Deactive this Status, but the following&nbsp;<b>{{vm.disInStatus.opps.length}}&nbsp;</b>Disbursements are currently in this status. &nbsp;Their statuses will need to change before you can continue.<p></p><table class="ibm-data-table ibm-altrows ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1"><tBody><tr ng-repeat="opp in vm.disInStatus.opps">               <td><a ui-sref="detail.general({id:&quot;{{opp.substring(4)}}&quot;})">{{opp}}</a></td></tr></tBody></table><p></p></div><div class="conflicts" ng-if="vm.pwWithStatus.viewDetails"><p></p>You have selected to Deactive this Approval Stage, but the following&nbsp;<b>{{vm.pwWithStatus.pws.length}}&nbsp;</b>Program Workflows currently use it. &nbsp;The Stage will need to be removed from each before you can continue.<p></p><table class="ibm-data-table ibm-altrows ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1"><tBody><tr ng-repeat="pw in vm.pwWithStatus.pws">               <td><a ui-sref="admin.program({id:&quot;{{pw._id}}&quot;})">{{pw.profile_id}}</a></td></tr></tBody></table><p></p></div><br/></div><div ng-if="vm.serverError &amp;&amp; vm.disInStatus.opps.length === 0  &amp;&amp; vm.pwWithStatus.pws.length === 0" style="border: 1px solid red; padding: 10px; margin: 10px; background-color: #fff4f6"><h1 class="ibm-textcolor-red-40 ibm-h3"><b>Server Error</b></h1>There was a problem at the server. &nbsp;The details are as follows:<p></p><p class="ibm-textcolor-red-40">{{vm.serverError}}</p>If the problem persists, please contact the DMT System Administrators for guidance.</div><p></p></div><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-disabled="(!vm.newStage &amp;&amp; vm.$scope.statForm.$pristine) || !vm.conflicts.resolved || vm.events.beingSaved || vm.conflicts.title!=\'\' || !vm.$scope.statForm.$valid || !vm.selectValid" ng-click="vm.save($event)"><md-icon class="white_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Save</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.cancel($event)"><md-icon class="white_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Cancel</md-button></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> {{vm.approvalStage ? "Approval Stage" : "Sub-Status"}} Number&nbsp;</label></div><div class="ibm-col-6-4 field"><span>{{vm.mainStatus.no}}-{{vm.editing.no}}</span><span ng-if="vm.newStage">&nbsp;&nbsp;<md-icon class="orange_icon" title="New Stage" md-svg-icon="/public/images/star-circle.svg"></md-icon></span></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50"> {{vm.approvalStage ? "Approval Stage" : "Sub-Status"}} Title&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top:1em"><input class="userField" ng-disabled="vm.events.beingSaved" ng-model="vm.editing.txt" ng-required="true" size="50" placeholder="Enter a unique title that is clear, ie: Pending Team Leader" ng-change="vm.conflict.title = false"/><p class="ibm-textcolor-red-40" ng-if="vm.conflicts.title === vm.editing.txt.toUpperCase()">{{vm.approvalStage ? "An Approval Stage" : "A Sub-Status"}} already exists with this title.  &nbsp;Please try another.</p></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50" title="Determine the team where the process cycle time should be applied whilst in this stage"> Cycle Time Owner&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top:1em"><select style="width: 12em" ng-disabled="vm.events.beingSaved" ng-if="vm.stageOwners.length &gt; 0" ng-model="vm.editing.owner" ng-options="x as x for x in vm.stageOwners | orderBy: x"></select><div class="ibm-columns"></div></div><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50" title="System-set statuses can only be triggered by a DMT process and will not be available for selection for users."> System-Set&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top:1em"><input ng-disabled="vm.events.beingSaved || vm.approvalStage" type="radio" ng-model="vm.editing.system" ng-value="true"/>Yes<input ng-disabled="vm.events.beingSaved || vm.approvalStage" type="radio" ng-model="vm.editing.system" ng-value="false"/>No</div><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50" title="Update this if there is a MySA equivalent status that would need to be reported back to MySA in the event of a status change"> MySA Status&nbsp;</label></div><div class="ibm-col-6-4 field" style="margin-top:1em"><input class="userField" ng-disabled="vm.events.beingSaved" ng-model="vm.editing.mysa" ng-required="false" size="30" placeholder="if applicable" ng-change="vm.conflict.title = false"/><span class="ibm-textcolor-red-50" style="font-size: small" ng-if="vm.editing.mysa"><p></p><span>NOTE: Disbursements changed to this sub-status will trigger communication with MySA</span></span></div><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50" title="Choose a MySA Portal Status"> MySA Portal Status&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top:1em"><select style="width: 28em" ng-disabled="vm.events.beingSaved" ng-if="vm.mysaStatuses.length &gt; 0" ng-model="vm.editing.mySAPortalStatus" ng-options="st as st for st in vm.mysaStatuses | orderBy: st"></select><div class="ibm-columns"></div></div><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50" title="Choose an activity, which we will apply in the future for the certain Sub Status"> Engage Support Hand Off Activity&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top:1em"><select style="width: 12em" ng-disabled="vm.events.beingSaved" ng-if="vm.handOffActivity.length &gt; 0" ng-model="vm.editing.esHandOff" ng-options="h as h for h in vm.handOffActivity | orderBy: h"></select><div class="ibm-columns"></div></div><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50" title="Choose a role, which we will apply in the future for the certain ES Hand Off"> Engage Support Hand Off Role&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top:1em"><select style="width: 28em" ng-disabled="vm.events.beingSaved" ng-if="vm.handOffRoles.length &gt; 0" ng-model="vm.editing.esHandOffRole" ng-options="h.roleId as h.label for h in vm.handOffRoles | orderBy: h"></select><div class="ibm-columns"></div></div><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50" title="Inactive statuses will not be available for selection for users, but must remain for any old Disbursements."> Active&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top:1em"><input ng-disabled="vm.newStage || vm.events.beingSaved" type="radio" ng-model="vm.editing.active" ng-value="true"/>Yes<input ng-disabled="vm.newStage || vm.events.beingSaved" type="radio" ng-model="vm.editing.active" ng-value="false"/>No</div><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50" title="Is opportunity in this status is acceptable for Duplicate check"> Duplicate check&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top:1em"><input ng-disabled="vm.newStage || vm.events.beingSaved" type="radio" ng-model="vm.editing.duplicateCheck" ng-value="true"/>Yes<input ng-disabled="vm.newStage || vm.events.beingSaved" type="radio" ng-model="vm.editing.duplicateCheck" ng-value="false"/>No</div><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50" title="DSW Eligibility App"> DSW Eligibility App&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top:1em"><input ng-disabled="vm.newStage || vm.events.beingSaved" type="radio" ng-model="vm.editing.dswEligibilityApp" ng-value="true"/>Yes<input ng-disabled="vm.newStage || vm.events.beingSaved" type="radio" ng-model="vm.editing.dswEligibilityApp" ng-value="false"/>No</div><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50" title="Choose necessary DSW Eligibility App Status"> DSW Eligibility App Status&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top:1em"><select style="width: 28em" ng-disabled="vm.events.beingSaved" ng-if="vm.dswEligibilityAppStatusArray.length &gt; 0" ng-model="vm.editing.dswEligibilityAppStatus" ng-options="st as st for st in vm.dswEligibilityAppStatusArray | orderBy: st"></select><div class="ibm-columns"></div></div><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50" title="PRM outbound"> PRM outbound&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top:1em"><input ng-disabled="vm.newStage || vm.events.beingSaved" type="radio" ng-model="vm.editing.prmOutbound" ng-value="true"/>Yes<input ng-disabled="vm.newStage || vm.events.beingSaved" type="radio" ng-model="vm.editing.prmOutbound" ng-value="false"/>No</div></div><div ng-if="vm.approvalStage"><div class="ibm-columns"><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50" title="If set to an amount higer than 0.00 this will mean only Disbursements whose payment amount is greater than the clip will need approving; if under, the stage will be skipped"> Clip Level (USD)&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top:1em"><input class="userField" ng-disabled="vm.events.beingSaved" type="number" ng-model="vm.editing.clip" min="0" ng-required="vm.approvalStage" ng-pattern="/^[0-9]+(.[0-9]{1,2})?$/" step="0.01"/></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50" title="Determine whether this Approval Stage will be approved by BPSO users as opposed to Non-BPSO users"> Is this a BPSO Approval Stage?&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top:1em"><input ng-disabled="vm.events.beingSaved" type="radio" ng-model="vm.editing.bpso" ng-value="true" ng-click="vm.refresh()"/>Yes<input ng-disabled="vm.events.beingSaved" type="radio" ng-model="vm.editing.bpso" ng-value="false" ng-click="vm.refresh()"/>No</div></div><div class="ibm-columns"><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50" title="Determine whether this Approval Stage will be approved by the BPSO/Non-BPSO Administrators (general users) or the BPSO/Non-BPSO Approvers (team leads/management)"> Should this Stage be Approved by a Peer, ie: not a Team Lead or Manager?&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top:1em"><input ng-disabled="vm.events.beingSaved" type="radio" ng-model="vm.editing.peer" ng-value="true" ng-change="vm.refresh()"/>Yes<input ng-disabled="vm.events.beingSaved" type="radio" ng-model="vm.editing.peer" ng-value="false" ng-change="vm.refresh()"/>No</div></div><div class="ibm-columns" ng-if="!vm.editing.peer"><div class="ibm-col-6-2 right" style="margin-top:1em"><label class="ibm-textcolor-blue-50" title="If set to \'Yes\', all users selected below MUST be managers in Blue Pages"> Should this Stage be Approved by a Manager?&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top:1em"><input ng-disabled="vm.events.beingSaved" type="radio" ng-model="vm.editing.manager" ng-value="true" ng-click="vm.editing.peer=false"/>Yes<input ng-disabled="vm.events.beingSaved" type="radio" ng-model="vm.editing.manager" ng-value="false"/>No</div></div><br/><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Approvers&nbsp;</label><req></req><p></p><div ng-if="!vm.editing.peer"><div class="selected_top ibm-textcolor-blue-50" style="text-align: left;">Selected Approvers</div><div class="selected" style="text-align: left"><ol style="type=1; list-style: outside disc; margin-left: 3px"><li style="position: relative;" ng-repeat="x in vm.approvers[vm.approvalGroup] | orderBy: \'name\'" ng-if="vm.editing.users.indexOf(x) &gt; -1">{{x.name}}</li></ol></div></div></div><div class="ibm-col-6-4 field"><!--div(ng-if="vm.editing.peer")--><div>{{vm.editing.peer ? "Anyone within the" : "Select users from the"}}&nbsp;<b>{{vm.bgName}}</b>&nbsp;{{vm.editing.peer ? "group will be able to approve this stage" : "to approve this stage"}}<p></p></div><div class="selectbox_bottom" ng-if="!vm.editing.peer" style="padding-top: 14px; padding-bottom: 14px" ng-class="{select_good: vm.editing.users.length&gt;0, select_error: !vm.editing.users || vm.editing.users.length &lt; 1}"><span class="checkbox_subcontainer" style="padding: 8px 0px 9px 0px"><!--md-icon(class="blue_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg" style="margin-left:9px;margin-right:12px")--><!--a(class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px" ng-click="vm.selectAll(true)") Select All--><md-icon class="blue_icon" ng-if="!vm.events.beingSaved" md-svg-icon="/public/images/close-circle.svg" style="margin-left:9px;margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" ng-if="!vm.events.beingSaved" style="margin-left: -9px; margin-right: 15px" ng-click="vm.selectAll(false)">Deselect All</a></span><span class="ibm-textcolor-blue-50" ng-if="vm.editing.users.length&gt;0">&nbsp;&nbsp;Selected :&nbsp;</span><b ng-if="vm.editing.users.length &gt; 0">{{vm.editing.users.length}}</b><span ng-if="!vm.editing.users || vm.editing.users.length &lt; 1">&nbsp;&nbsp;Please select at least one</span></div><div class="selectbox" ng-if="!vm.editing.peer"><span ng-repeat="app in vm.approvers[vm.approvalGroup] | orderBy: \'name\'"><input ng-disabled="vm.events.beingSaved" type="checkbox" ng-model="vm.select.users[app.email]" ng-change="vm.syncApprovers()"/>{{app.name}} &nbsp;&nbsp;<p></p></span></div></div></div></div></div></form></div></div></div></main><p></p>');
$templateCache.put('termsofuse.html','<style>.versions h2 {\n    font-weight: bold;\n    margin-left: 10px;\n}\nhr {\n    margin-left: 10px;\n}\nul.ibm-link-list {\n    margin-top: 20px;\n}\n.version {\n    margin-bottom: 40px;\n}\n.versionBox {\n    border: solid lightgray 1px;\n    padding-top: 10px;\n    height: 350px;\n    overflow-y: scroll;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Acceptable Terms of Use</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="!vm.profileLoaded &amp;&amp; !vm.serverError">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span ng-if="vm.profileLoaded"></span></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div><div class="ibm-columns"></div></div><div ng-if="vm.serverError"><div class="ibm-columns"><div class="ibm-col-1-1"><span class="ibm-textcolor-red-50" ng-bind-html="vm.serverError"></span><p></p></div></div></div><div ng-if="vm.events.beingSaved"><div class="ibm-columns"><div class="ibm-col-1-1"><span class="ibm-textcolor-blue-40 ibm-h3">Saving...</span><span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span><p></p></div></div></div><div ng-if="vm.profileLoaded"><div class="ibm-columns version"><div class="ibm-col-6-5" ng-show="!vm.isCreateFormShow"><div class="ibm-columns"><div class="ibm-col-6-1"><label class="ibm-textcolor-blue-50">Created Date</label></div><div class="ibm-col-6-2 field"><span>{{vm.correctTerm.created_date | date: "longDate"}}</span></div></div><div class="ibm-columns"><div class="ibm-col-6-1"><label class="ibm-textcolor-blue-50">Effective Date&nbsp;</label></div><div class="ibm-col-6-2 field"><span>{{vm.correctTerm.effective_date | date: "longDate"}}</span><bold class="ibm-textcolor-red-50" style="margin-left: 5px; background-color: #fff6d7; padding: 1px 5px 1px 5px; border-radius: 6px" ng-if="vm.correctTerm.effective_date &gt; vm.today">Future Terms</bold></div></div><div class="ibm-columns" ng-if="vm.correctTerm.end_date"><div class="ibm-col-6-1"><label class="ibm-textcolor-blue-50">End Date&nbsp;</label></div><div class="ibm-col-6-2 field"><span>{{vm.correctTerm.end_date | date: "longDate"}}</span></div></div><div class="ibm-columns"><div class="ibm-col-6-1"><label class="ibm-textcolor-blue-50">Created by&nbsp;</label></div><div class="ibm-col-6-2 field"><b>{{vm.correctTerm.created_by}}</b></div></div><p></p><p>     </p><div style="border: solid lightgray 1px; padding: 10px"><span ng-bind-html="vm.correctTerm.tou"></span></div></div><div class="ibm-col-6-1 versions versionBox" ng-show="!vm.isCreateFormShow"><h2 class="ibm-h4">Versions</h2><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.openCreateVersionForm()">Create New</md-button><ul class="ibm-link-list"><li ng-repeat="term in vm.data.terms | orderBy:vm.data.terms:true"><a ng-click="vm.changeVersion(term.version)">{{term.version}}</a><hr/></li></ul></div><form name="vm.createVersionForm" ng-if="vm.isCreateFormShow"><div class="ibm-col-1-1" ng-if="vm.events.serverError"><span class="ibm-textcolor-red-50" ng-bind-html="vm.events.serverError"> </span><span class="ibm-textcolor-red-50">. &nbsp;If the problem persists, please contact the System Administrators for guidance.</span><p></p></div><div class="ibm-col-6-4"><!--h1.ibm-h4.ibm-textcolor-green-50.ibm-bold Add New Version--><span>Please enter the new Terms and click Save Changes, or Cancel to quit. &nbsp;</span><b>NOTE:&nbsp;</b><span>The Effective Date can be in the future.  </span><p></p><span class="ibm-textcolor-blue-50">Effective Data</span><md-datepicker ng-model="vm.saving.effective_date" name="effective_date" ng-model-options="{ timezone: \'UTC\' }" md-min-date="vm.minEffectiveDate" ng-required="true"></md-datepicker><p ng-if="vm.createVersionForm.effective_date.$invalid"><span class="ibm-textcolor-red-50">We need a valid Date here</span></p><p></p><span class="ibm-textcolor-blue-50">New Terms</span><p></p><textarea class="userField" ng-model="vm.saving.tou" name="tou" ng-required="true" placeholder="Enter text" style="resize: none" rows="5" cols="100" resize="false"></textarea></div><div class="ibm-col-6-1" style="float: right;"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.saveData($event)" title="Save your updates" ng-disabled="vm.events.beingSaved || !vm.createVersionForm.$valid"><md-icon class="white_icon" style="margin-left: -5px" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Save Changes</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.isCreateFormShow=false; vm.events.serverError = undefined" title="Discard your updates and return to Acceptable Terms of Use page"><md-icon class="white_icon" style="margin-left: -5px" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Cancel</md-button></div></form></div></div></div></div></div></div></main>');
$templateCache.put('user-main.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>User Profile</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!vm.userLoaded">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div><div class="ibm-col-6-1"><span ng-if="!vm.userLoaded"><a ui-sref="admin.users-view"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Back to View</a></span><img class="img-circle" style="padding: inherit" ng-if="vm.userLoaded" ng-src="{{vm.getAvatar()}}"/></div></div><admin-user-section parent="vm" ng-if="vm.userLoaded"></admin-user-section><!--probably will need to load ADMIN or USER options based on whoever\'s in here--></div></div></div></main>');
$templateCache.put('user.edit-changelog-view.html','<!-- author Matthew Rogers--><style>a.link {\n    text-decoration: none;\n}\n.selRow {\n    background-color: #f5f5f5;\n    border-bottom: 2px solid #939498;\n}\n.unselRow {\n    /*background-color: #ffe1cf;*/\n}\ntd {\n    word-break: break-all;\n}</style><md-dialog aria-label="User Profile Change Log" ng-cloak="ng-cloak"><md-toolbar><div class="md-toolbar-tools"><h2>Permissions Change Log - {{::vm.bod}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.clickNo()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding" style="max-width: 45em"><p ng-if="vm.logdata">The table below details the changes made to this user\'s Permissions. &nbsp;Click each date to view the detail.</p><table class="ibm-data-table" style="width: 45em" ng-if="vm.logdata.length &gt; 0" cellspacing="0" cellpadding="0" border="0"><th style="background-color: rgb(235, 236, 237); border-bottom: 2px solid lightgray; color: gray" ng-repeat="header in vm.columnHeaders">{{::header}}</th><tbody ng-repeat="line in vm.logdata | reverseF:vm.logdata" ng-init="logIndex = $index"><tr ng-class="{selRow: vm.viewEntries.indexOf(logIndex) &gt; -1, unselRow: vm.viewEntries.indexOf(logIndex) == -1}"><td style="width: 12em"><a ng-click="vm.expand($index)" style="color: #5596e6"><b>{{::line.timestamp | date:"medium"}}</b></a></td><td><b>{{::line.user}}</b></td></tr><tr ng-if="vm.viewEntries.indexOf(logIndex) &gt; -1" ng-repeat="(k,v) in line.changes"><td><b>{{::k.toUpperCase().replace(\'_\',\' \')}}</b></td><td><span class="logComments" style="background-color: lightpink; color: darkred">OLD</span>&nbsp;&nbsp;{{::v.old}}<br/><span class="logComments" style="background-color: lightgreen; color: darkgreen">NEW</span>&nbsp;&nbsp;{{::v.new}}</td></tr></tbody></table><span ng-if="!vm.logdata || vm.logdata.length == 0">No Permission Changes have been made since the Profile was created</span></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('user.edit-changelog.html','<span ng-mouseover="$ctrl.hovered = true;" ng-mouseleave="$ctrl.hovered = false;"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_history_black_24px.svg" title="View Change Log" ng-click="$ctrl.viewLog($event)"></md-icon><sup ng-bind="$ctrl.changelog.length" ng-class="{\'upAndDown\': $ctrl.hovered == true}"></sup></span>');
$templateCache.put('user.html','<main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><form name="userForm"><!--| {{$ctrl.original}}--><!--| {{$ctrl.editing}}--><!--| {{$ctrl.select}}--><!--p--><!--| {{$ctrl.select.valid}} {{$ctrl.$scope.userForm.$pristine}} {{$ctrl.events.beingSaved}} {{$ctrl.$scope.userForm.$valid}}--><!--| {{$ctrl.admin.configs}}--><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="$ctrl.events.beingSaved">Saving...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><div ng-if="!$ctrl.events.beingSaved">This document represents the Admin-editable details of this user\'s profile, namely the Permissions.  &nbsp;Please update accordingly bearing in mind all fields marked with (<req></req>) are mandatory. &nbsp;Click&nbsp;<b>Save</b>&nbsp;when done, or&nbsp;<b>Cancel&nbsp;</b>to quit. &nbsp;<p></p><b>NOTE</b>&nbsp;: The&nbsp;<b>Save</b>&nbsp;button will not become available until all mandatory fields are correctly completed.</div><div ng-if="$ctrl.serverError" style="border: 1px solid red; padding: 10px; margin: 10px; background-color: #fff4f6"><h1 class="ibm-textcolor-red-40 ibm-h3"><b>Server Error</b></h1>There was a problem at the server. &nbsp;The details are as follows:<p></p><p class="ibm-textcolor-red-40">{{$ctrl.serverError}}</p>If the problem persists, please contact the DMT System Administrators for guidance.</div><p></p></div><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-disabled="$ctrl.$scope.userForm.$pristine || $ctrl.events.beingSaved || !$ctrl.$scope.userForm.$valid || !$ctrl.select.valid" ng-click="$ctrl.save($event)"><md-icon class="white_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Save</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-disabled="$ctrl.events.beingSaved" ng-click="$ctrl.admin.navigate(\'admin.users-view\')"><md-icon class="white_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Cancel</md-button></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Full Name&nbsp;</label></div><div class="ibm-col-6-4 field"><b>{{$ctrl.parent.user.name}}</b></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50">Email Address&nbsp;</label></div><div class="ibm-col-6-4 field"><span>{{$ctrl.parent.user.email}}</span></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Role&nbsp;</label></div><div class="ibm-col-6-4 field"><span>{{$ctrl.admin.getBGName($ctrl.parent.user.swdr_permissions.role)}}</span></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Is Manager&nbsp;</label></div><div class="ibm-col-6-4 field"><span>{{$ctrl.parent.user.is_manager}}</span></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Status&nbsp;</label></div><div class="ibm-col-6-4 field"><b ng-class="{\'ibm-textcolor-green-50\': $ctrl.parent.user.status === \'Active\', \'ibm-textcolor-red-50\': $ctrl.parent.user.status !== \'Active\' }">{{$ctrl.parent.user.status}} &nbsp;</b><md-icon class="red_icon" ng-if="$ctrl.parent.user.status !== \'Active\' " md-svg-icon="/public/images/help-circle.svg" title="This user is no longer listed in any of the DMT Blue Groups and has therefore lost their access.  NOTE: Should access be reinstated, the Permissions will be reset."></md-icon></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Permission Change Log&nbsp;</label></div><div class="ibm-col-6-4 field"><user-change-log changelog="$ctrl.original.change_log" bod="$ctrl.original.name"></user-change-log><!--span(ng-mouseover="$ctrl.hovered = true;", ng-mouseleave="$ctrl.hovered = false;")md-icon(class="blue_icon" md-svg-icon="/public/images/ic_history_black_24px.svg" title="View Change Log")\nsup(ng-bind="$ctrl.original.change_log.length",ng-class="{\'upAndDown\': $ctrl.hovered == true}")--></div></div><p></p><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-50 ibm-h3"><b>Country Permissions&nbsp;</b><a class="ibm-textcolor-blue-30" style="font-size:medium" ng-click="vm.toggle.cty = !vm.toggle.cty">Click to {{!vm.toggle.cty ? \'View\' : \'Hide\'}}</a></h1></div></div><div ng-if="vm.toggle.cty"><div class="ibm-columns"><div class="ibm-col-6-5"><div ng-if="!$ctrl.events.beingSaved">The Country Permissions determine which Countries\' Disbursements this user can see. &nbsp;Enable the relevant IOTs and select the countries accordingly.</div><p></p></div></div><div ng-if="!$ctrl.view.country"><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> IOT Access&nbsp;</label></div><div class="ibm-col-6-4 field"><span ng-repeat="x in $ctrl.editing.swdr_permissions.iot | orderBy: x">{{x.replace(\' IOT\',\'\')}}{{$index+1 == $ctrl.editing.swdr_permissions.iot.length ? \'\' : \', \'}}</span></div></div></div><div ng-if="$ctrl.view.country"><div class="ibm-columns" ng-repeat="x in $ctrl.settings.iot_list | orderBy: x"><div class="ibm-col-6-2 right" style="margin-top: 5px"><label class="ibm-textcolor-blue-50"> Enable {{x.replace(\' IOT\',\'\')}} Access&nbsp;</label><req></req></div><div class="ibm-col-6-4 field" style="margin-top: 5px"><input type="radio" ng-model="$ctrl.select.iots[x]" ng-value="true" ng-change="$ctrl.refreshIOTs(true,x)"/>Yes<input type="radio" ng-model="$ctrl.select.iots[x]" ng-value="false" ng-change="$ctrl.refreshIOTs(false,x)"/>No<span class="checkbox_subcontainer" ng-if="$ctrl.select.iots[x]" style="margin-left: 10px; padding: 8px 0px 9px 0px"><md-icon class="blue_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg" style="margin-left:9px;margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px" ng-click="$ctrl.selectAll(x)">Select All</a><md-icon class="blue_icon" md-svg-icon="/public/images/close-circle.svg" style="margin-right:12px"></md-icon><a class="ibm-textcolor-blue-50" style="margin-left: -9px; margin-right: 15px" ng-click="$ctrl.deselectAll(x)">Deselect All</a></span><span ng-if="$ctrl.select.iots[x]" ng-class="{\'ibm-textcolor-red-50\': $ctrl.select.cbg[x] === undefined}"><span ng-if="$ctrl.select.cbg[x] === undefined">&nbsp;&nbsp;Select at least one or Disable</span><span ng-if="$ctrl.select.cbg[x] !== undefined"><b>&nbsp;&nbsp;{{$ctrl.select.cbg[x]}}</b>&nbsp;selected</span></span></div></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Country Access&nbsp;</label><req></req><div class="selected_top ibm-textcolor-blue-50" style="text-align: left;">Selected Countries</div><div class="selected" style="text-align: left; height: 250px; max-height: 250px"><ol style="type=1; list-style: outside disc; margin-left: 3px"><li style="position: relative;" ng-repeat="x in $ctrl.settings.country_list | orderBy: \'country\' | filter: {ic:\'Country\'}" ng-if="$ctrl.editing.swdr_permissions.country.indexOf(x.short) &gt; -1 &amp;&amp; x.ic == \'Country\'">{{x.country}}</li></ol></div></div><div class="ibm-col-6-4 field"><!--a(ng-if="!$ctrl.view.country" ng-click="$ctrl.view.country = !$ctrl.view.country") Click to Edit--><div class="field" id="countries" ng-if="$ctrl.view.country"><div class="selectbox_bottom" style="padding-top: 14px; padding-bottom: 14px" ng-class="{select_good: $ctrl.editing.swdr_permissions.country.length&gt;0, select_error: !$ctrl.editing.swdr_permissions.country || $ctrl.editing.swdr_permissions.country.length==0}"><span class="ibm-textcolor-blue-50" ng-if="$ctrl.editing.swdr_permissions.country.length&gt;0">&nbsp;&nbsp;Selected :&nbsp;</span><b ng-if="$ctrl.editing.swdr_permissions.country.length&gt;0">&nbsp;&nbsp;{{$ctrl.editing.swdr_permissions.country.length}}&nbsp;</b><span ng-if="$ctrl.editing.swdr_permissions.country.length&gt;0">{{$ctrl.editing.swdr_permissions.country.length == 1 ? \'country\' : \'countries\'}} selected for this user</span><span ng-if="$ctrl.editing.swdr_permissions.country.length==0">&nbsp;&nbsp;No country access selected for this user</span><!--a(style="padding-left: 8em" ng-if="$ctrl.view.country" ng-click="$ctrl.view.country = !$ctrl.view.country") Click to Cancel Edit--></div><div class="selectbox" style="height: 250px; max-height: 250px"><span ng-repeat="cty in $ctrl.settings.country_list | multiIOT:$ctrl.editing.swdr_permissions.iot | orderBy: \'country\'"><input type="checkbox" ng-model="$ctrl.select.countries[cty.short]" ng-change="$ctrl.syncCountries()"/>{{cty.country}} &nbsp;&nbsp;<p ng-if="$ctrl.admin.newLine($index+1,4)"></p></span></div></div></div></div></div><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-50 ibm-h3"><b>Program Permissions&nbsp;</b><a class="ibm-textcolor-blue-30" style="font-size:medium" ng-click="vm.toggle.prg = !vm.toggle.prg">Click to {{!vm.toggle.prg ? \'View\' : \'Hide\'}}</a></h1></div></div><div ng-if="vm.toggle.prg"><div class="ibm-columns"><div class="ibm-col-6-5"><div ng-if="!$ctrl.events.beingSaved">The Program Permissions determine which Programs this user can see. &nbsp;Please select accordingly. &nbsp;&nbsp;</div></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Program Access&nbsp;</label><req></req><div class="selected_top ibm-textcolor-blue-50" style="text-align: left;">Selected Programs</div><div class="selected" style="text-align: left;"><ol style="type=1; list-style: outside disc; margin-left: 3px"><li style="position: relative;" ng-repeat="x in $ctrl.settings.programs | orderBy: x" ng-if="$ctrl.editing.swdr_permissions.program.indexOf(x) &gt; -1">{{x}}</li></ol></div></div><div class="ibm-col-6-4 field"><div class="field" id="programs"><div class="selectbox_bottom" style="padding-top: 14px; padding-bottom: 14px" ng-class="{select_good: $ctrl.editing.swdr_permissions.program.length&gt;0, select_error: !$ctrl.editing.swdr_permissions.program || $ctrl.editing.swdr_permissions.program.length==0}"><span class="ibm-textcolor-blue-50" ng-if="$ctrl.editing.swdr_permissions.program.length&gt;0">&nbsp;&nbsp;Selected :&nbsp;</span><b ng-if="$ctrl.editing.swdr_permissions.program.length&gt;0">&nbsp;&nbsp;{{$ctrl.editing.swdr_permissions.program.length}}&nbsp;</b><span ng-if="$ctrl.editing.swdr_permissions.program.length&gt;0">{{$ctrl.editing.swdr_permissions.program.length == 1 ? \'program\' : \'programs\'}} selected for this user</span><span ng-if="$ctrl.editing.swdr_permissions.program.length==0">&nbsp;&nbsp;No program access selected for this user</span></div><div class="selectbox"><span ng-repeat="x in $ctrl.settings.programs |orderBy: x"><input type="checkbox" ng-model="$ctrl.select.programs[x]" ng-change="$ctrl.syncPrograms()"/>{{x}} &nbsp;&nbsp;<p ng-if="$ctrl.admin.newLine($index+1,4)"></p></span></div></div></div></div></div><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-50 ibm-h3"><b>Reporting Permissions&nbsp;</b><a class="ibm-textcolor-blue-30" style="font-size:medium" ng-click="vm.toggle.rep = !vm.toggle.rep">Click to {{!vm.toggle.rep ? \'View\' : \'Hide\'}}</a></h1></div></div><div ng-if="vm.toggle.rep"><div class="ibm-columns"><div class="ibm-col-6-5"><div ng-if="!$ctrl.events.beingSaved">The Reporting Permissions determine which Reports this user can run or not.</div></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> General Report&nbsp;</label><req></req></div><div class="ibm-col-6-4 field"><input type="radio" ng-model="$ctrl.editing.swdr_permissions.general_report" ng-value="true"/>Yes<input type="radio" ng-model="$ctrl.editing.swdr_permissions.general_report" ng-value="false"/>No</div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Pivot Report&nbsp;</label><req></req></div><div class="ibm-col-6-4 field"><input type="radio" ng-model="$ctrl.editing.swdr_permissions.pivot_report" ng-value="true"/>Yes<input type="radio" ng-model="$ctrl.editing.swdr_permissions.pivot_report" ng-value="false"/>No</div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Custom Reports&nbsp;</label><req></req></div><div class="ibm-col-6-4 field"><input type="radio" ng-model="$ctrl.editing.swdr_permissions.custom_report" ng-value="true"/>Yes<input type="radio" ng-model="$ctrl.editing.swdr_permissions.custom_report" ng-value="false"/>No</div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Shared Reports&nbsp;</label><req></req></div><div class="ibm-col-6-4 field"><input type="radio" ng-model="$ctrl.editing.swdr_permissions.shared_report" ng-value="true"/>Yes<input type="radio" ng-model="$ctrl.editing.swdr_permissions.shared_report" ng-value="false"/>No</div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Standard Reporting Access&nbsp;</label><req></req><div class="selected_top ibm-textcolor-blue-50" style="text-align: left;">Selected Reports</div><div class="selected" style="text-align: left;"><ol style="type=1; list-style: outside disc; margin-left: 3px"><li style="position: relative;" ng-repeat="x in $ctrl.standardReports | orderBy: x" ng-if="$ctrl.editing.swdr_permissions.standard_report.indexOf(x) &gt; -1">{{x}}</li></ol></div></div><div class="ibm-col-6-4 field"><div class="field" id="reports"><div class="selectbox_bottom" style="padding-top: 14px; padding-bottom: 14px" ng-class="{select_good: $ctrl.editing.swdr_permissions.standard_report.length&gt;0, select_error: !$ctrl.editing.swdr_permissions.standard_report || $ctrl.editing.swdr_permissions.standard_report.length==0}"><span class="ibm-textcolor-blue-50" ng-if="$ctrl.editing.swdr_permissions.program.length&gt;0">&nbsp;&nbsp;Selected :&nbsp;</span><b ng-if="$ctrl.editing.swdr_permissions.standard_report.length&gt;0">&nbsp;&nbsp;{{$ctrl.editing.swdr_permissions.standard_report.length}}&nbsp;</b><span ng-if="$ctrl.editing.swdr_permissions.standard_report.length&gt;0">{{$ctrl.editing.swdr_permissions.standard_report.length == 1 ? \'report\' : \'reports\'}} selected for this user</span><span ng-if="$ctrl.editing.swdr_permissions.standard_report.length==0">&nbsp;&nbsp;No report access selected for this user</span></div><div class="selectbox"><span ng-repeat="x in $ctrl.standardReports |orderBy: x"><input type="checkbox" ng-model="$ctrl.select.standard_reports[x]" ng-change="$ctrl.syncReports()"/>{{x}} &nbsp;&nbsp;<p ng-if="$ctrl.admin.newLine($index+1,4)"></p></span></div></div></div></div></div><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-50 ibm-h3"><b>Preferred program&nbsp;</b><a class="ibm-textcolor-blue-30" style="font-size:medium" ng-click="vm.toggle.app = !vm.toggle.app">Click to {{!vm.toggle.app ? \'View\' : \'Hide\'}}</a></h1></div></div><div ng-if="vm.toggle.app"><div class="ibm-columns"><div class="ibm-col-6-5"><div ng-if="!$ctrl.events.beingSaved">Please, select the preferred program you want to see when launching the application.</div></div></div><div class="ibm-columns"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50"> Preferred program&nbsp;</label><req></req></div><div class="ibm-col-6-4 field"><input type="radio" ng-if="$ctrl.isShowMetrics" ng-model="$ctrl.editing.swdr_permissions.app" value="report"/>{{$ctrl.isShowMetrics ? \'Metrics\' : \'\'}}<input type="radio" ng-if="$ctrl.isShowClaimForms" ng-model="$ctrl.editing.swdr_permissions.app" value="claim-forms"/>{{$ctrl.isShowClaimForms ? \'Claim-forms\' : \'\'}}<input type="radio" ng-if="$ctrl.isShowCore" ng-model="$ctrl.editing.swdr_permissions.app" value="core"/>{{$ctrl.isShowCore ? \'Core\' : \'\'}}</div></div></div></form></div></main>');
$templateCache.put('users-view.html','<style>table, td {\n    border-color: lightgray;\n}\ntable {\n    width: inherit;\n}\na.link {\n    text-decoration: none;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><!--| {{vm.table}}--><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>User Profiles</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-show="!vm.usersLoaded">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><!--span(ng-if="vm.config.tempData")--><span ng-if="vm.settings.status_cfg"></span></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div></div><div class="ibm-columns" ng-if="vm.usersLoaded"><div class="ibm-col-6-5">Use this section to edit Users\' profile settings, such as Country and Program permissions. &nbsp;Please select a User to view/edit.<p></p></div></div><div class="ibm-columns"><div class="ibm-col-6-5"><div ng-if="vm.usersLoaded &amp;&amp; !vm.table.filter"><span class="search_box"><md-icon class="blue_icon" md-svg-icon="/public/images/magnify.svg"></md-icon></span><input class="userField" ng-model="vm.table.search" placeholder="Enter search criteria"/>&nbsp;&nbsp;<a ng-click="vm.table.filter = true"><span class="ibm-textcolor-blue-50">Advanced Search</span></a><p></p></div><div class="checkbox_container" ng-if="vm.users.length &amp;&amp; vm.table.filter">Please select the fields you would like to filter on:<p></p><div class="checkbox_subcontainer"><span ng-repeat="(key,value) in vm.table.headers[0]"><input type="checkbox" ng-model="vm.table.filters[value]" ng-change="vm.admin.refreshAdvancedFilter(vm.table)"/>{{key}} &nbsp;&nbsp;</span></div><div style="padding: 6px"><span ng-repeat="(key,value) in vm.table.headers[0]"><p ng-if="vm.table.filters[value] &amp;&amp; vm.table.filters!= \'\'">{{key}} &nbsp;<input class="userField" ng-if="vm.table.filters[value] &amp;&amp; [\'status\',\'role\'].indexOf(value) === -1" ng-model="vm.table.filterParams[value]"/><select class="userField" ng-options="x for x in vm.table.select_options[value]" ng-if="vm.table.filters[value] &amp;&amp; [\'status\',\'role\'].indexOf(value) &gt; -1" ng-model="vm.table.filterParams[value]"></select></p></span></div><md-icon class="blue_icon" md-svg-icon="/public/images/magnify.svg"></md-icon>&nbsp;<a ng-click="vm.table.filter = false"><span class="ibm-textcolor-blue-50">Back to Basic Search</span></a>&nbsp;&nbsp;&nbsp;<md-icon class="blue_icon" md-svg-icon="/public/images/filter-variant.svg"></md-icon>&nbsp;<a ng-click="vm.resetFilters()"><span class="ibm-textcolor-blue-50">Reset</span></a><!--p--></div></div><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" ng-if="vm.usersLoaded" ng-disabled="vm.exportFired" ng-click="vm.exportUserPermissions()" title="Export all users\' Country Permissions to an Excel spreadsheet"><md-icon class="white_icon" ng-if="!vm.exportFired" md-svg-icon="download"></md-icon><md-icon class="ibm-spinner" ng-if="vm.exportFired" style="border: 2px solid white; min-height: 12px; min-width: 12px;"></md-icon><span style="text-transform: none; font-size: 15px; padding-left: 5px; padding-right: 2px;">{{vm.exportFired ? \'Please wait...\' : \'Export Permissions\'}}</span></md-button></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><table class="ibm-data-table ibm-altrows ibm-alternate-two table" ng-if="vm.usersLoaded" cellspacing="0" cellpadding="0" border="1"><thead><tr ng-repeat="hd in vm.table.headers"><td ng-repeat="(key,value) in hd"><!--| {{key}} {{value}}--><a class="link" ng-click="vm.table.sortType = value; vm.table.sortReverse = !vm.table.sortReverse">{{key}}&nbsp;</a><span ng-show="vm.table.sortType==value &amp;&amp; !vm.table.sortReverse"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_expand_less_black_24px.svg"></md-icon></span><span ng-show="vm.table.sortType==value &amp;&amp; vm.table.sortReverse"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_expand_more_black_24px.svg"></md-icon></span></td></tr></thead><tBody><tr ng-repeat="user in vm.users | orderBy:vm.table.sortType:vm.table.sortReverse | filter: (vm.table.filter ? vm.table.filterParams : vm.table.search) : vm.strict()"><td><b><a class="link" style="color: #5596e6" ui-sref="admin.user({user:&quot;{{user.email}}&quot;})">{{user.name}}</a></b></td><td><span>{{user.email}}</span></td><td><span>{{user.role}}</span></td><td ng-class="{green_text: user.status === \'Active\', red_text: user.status !== \'Active\'}"><span>{{user.status}}</span></td></tr></tBody></table><p></p></div></div></div></div></div></div></div></main>');
$templateCache.put('validation-view.html','<!--Created by user on 2/3/2017.\n--><style>.dataTables_wrapper {\n    margin-top: 12px;\n}</style><main role="main" aria-labelledby="ibm-pagetitle-h1"><div id="ibm-pcon" ibm-back-to-top=""><div id="ibm-content"><div id="ibm-content-body"><div id="ibm-content-main"><div id="content"><div class="ibm-columns"><div class="ibm-col-6-5"><h1 class="ibm-textcolor-blue-40 ibm-h2"><b>Validation Rule Tables</b></h1><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="!vm.isDivisionLoaded || !vm.isCountryLoaded">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1></div><div class="ibm-col-6-1"><span><a ui-sref="admin.main"><md-icon class="blue_icon" md-svg-icon="/public/images/arrow-left-bold.svg"></md-icon>&nbsp;Admin Home</a></span></div><!--br--><!--br--><!--md-progress-linear(md-mode="indeterminate" ng-if="!vm.isDivisionLoaded || !vm.isCountryLoaded" id=\'generalInfo\' class="ibm-columns")p Please wait, loading--><!--br--><div class="ibm-columns" ng-if="vm.isDivisionLoaded &amp;&amp; vm.isCountryLoaded" id="generalInfo"><md-tabs ng-model="vm.curTab" md-dynamic-height="md-dynamic-height" md-border-bottom="md-border-bottom"><md-tab ng-repeat="oneTab in vm.docTable.tbl track by $index" label="{{oneTab.name}}" ng-style="{color: \'green\'}" ng-click="vm.voidNew(oneTab)"><br/><md-button class="md-raised" ng-click="vm.save(oneTab)" ng-disabled="!oneTab.isValid || vm.isSaving">Save</md-button><div flex="flex" layout-padding="layout-padding"><table class="ibm-data-table ibm-grid ibm-altrows" ibm-altcols="ibm-altcols"><thead><tr><td ng-repeat="oneName in oneTab.colNames track by $index"><b>{{oneName.name}}</b></td></tr></thead><br/><tbody><tr ng-repeat="oneCode in oneTab.currentTable track by $index"><td ng-repeat="(oneKey,oneVal) in oneCode track by $index" ng-if="oneKey!==\'isLineValid\'"><input aria-label="x" ng-model="oneCode[oneKey]" ng-if="oneKey.search(\'country\') &gt; -1" maxlength="2"/><!--md-select(ng-model=\'oneCode[oneKey]\' ng-if="oneKey.search(\'country\') > -1" ng-change="vm.checkValidity(oneTab)")md-option(ng-value="oneCty.short" ng-repeat="oneCty in vm.countryTable | filter:oneCty.ic =\'Country\' | orderBy: \'country\'") {{oneCty.country}}--><md-input-container class="md-block" style="margin: 0px; padding: 0px;"><input aria-label="x" ng-if="(oneKey.search(\'Code\') &gt; -1 || oneKey.search(\'combo\') &gt; -1) &amp;&amp; oneKey.search(\'country\') === -1" ng-model="oneCode[oneKey]" ng-change="vm.checkValidity(oneTab)"/><input aria-label="x" ng-if="oneKey.search(\'Code\') === -1 &amp;&amp; oneKey.search(\'combo\') === -1 &amp;&amp; oneKey.search(\'Start\') === -1 &amp;&amp; oneKey.search(\'End\') === -1 &amp;&amp; oneKey.search(\'country\') === -1" ng-model="oneCode[oneKey]"/></md-input-container><md-datepicker ng-if="oneKey.search(\'Start\') &gt; -1 || oneKey.search(\'End\') &gt; -1" ng-model="oneCode[oneKey]" ng-change="vm.checkValidity(oneTab)" ng-valid="oneTab.isLineValid"></md-datepicker></td><td><md-icon class="red_icon" ng-if="!oneCode.isLineValid" md-svg-icon="invalid"></md-icon><md-button ng-click="vm.deleteConfirmation($event, oneTab, oneCode)" ng-disabled="vm.isSaving"><md-icon md-svg-icon="delete"></md-icon></md-button></td></tr><tr><td ng-repeat="(newKey, newVal) in vm.newCode track by $index" ng-if="newKey!==\'isLineValid\'"><input aria-label="x" ng-model="vm.newCode[newKey]" ng-if="newKey.search(\'country\') &gt; -1" maxlength="2"/><!--md-select(ng-model=\'vm.newCode[newKey]\' ng-if="newKey.search(\'country\') > -1" ng-change="vm.checkValidity(oneTab)")md-option(ng-value="oneCty.short" ng-repeat="oneCty in vm.countryTable | filter:oneCty.ic =\'Country\' | orderBy: \'country\'") {{oneCty.country}}--><md-input-container class="md-block" style="margin: 0px; padding: 0px;"><input aria-label="x" ng-if="(newKey.search(\'Code\') &gt; -1 || newKey.search(\'combo\') &gt; -1) &amp;&amp; newKey.search(\'country\') === -1" ng-model="vm.newCode[newKey]" ng-change="vm.checkValidity(oneTab)"/><input aria-label="x" ng-if="newKey.search(\'Code\') === -1 &amp;&amp; newKey.search(\'combo\') === -1 &amp;&amp; newKey.search(\'Start\') === -1 &amp;&amp; newKey.search(\'End\') === -1 &amp;&amp; newKey.search(\'country\') === -1" ng-model="vm.newCode[newKey]"/></md-input-container><md-datepicker ng-if="newKey.search(\'Start\') &gt; -1 || newKey.search(\'End\') &gt; -1" ng-model="vm.newCode[newKey]" ng-change="vm.checkValidity(oneTab)" ng-valid="oneTab.isLineValid"></md-datepicker></td><td><md-icon class="red_icon" ng-if="!vm.newCode.isLineValid" md-svg-icon="invalid"></md-icon><md-button ng-click="vm.addNewCode(oneTab)" ng-disabled="(!vm.newCode.isLineValid || vm.newCode.divCode === \'\' || vm.newCode.divCodeDesc === \'\' || vm.newCode.reqStart === \'\' || vm.newCode.reqEnd === \'\' || vm.isSaving)"><md-icon class="green_icon" md-svg-icon="save"></md-icon></md-button><md-button ng-click="vm.voidNew()">Cancel</md-button></td></tr></tbody></table></div><br/><a class="h2 ibm-h2 ibm-medium ibm-light ibm-padding-bottom-1" flex="50" ng-click="vm.history = !vm.history">Click to {{!vm.history ? \'View\' : \'Hide\'}} History</a><!--p.ibm-h2.ibm-medium.ibm-light.ibm-padding-bottom-1(flex="50") History--><!--span.ibm-textcolor-blue-30  |--><table class="ibm-data-table ibm-grid ibm-altrows" ibm-altcols="ibm-altcols" ng-if="vm.history"><col width="100"/><col width="300"/><col width="50"/><thead><tr><td><b>Time</b></td><td><b>Changes made</b></td><td><b>Changed by</b></td></tr></thead><tbody><tr ng-repeat="entry in oneTab.tableHistory track by $index"><td>{{entry.timestamp.toString()}}</td><td><table><tbody><tr class="ibm-bgcolor-blue-10" ng-repeat="oneComment in entry.comment track by $index"><td>-{{oneComment}}</td></tr></tbody></table></td><td>{{entry.user}}</td></tr></tbody></table></md-tab></md-tabs></div></div></div></div></div></div></div></main>');
$templateCache.put('accountInfoData-dialog.html','<style>.md-virtual-repeat-container.md-autocomplete-suggestions-container {\n  z-index: 9999;\n}</style><div>dddc</div><md-dialog ng-cloak="" aria-label="cmrArray "><md-toolbar><div class="md-toolbar-tools"><h2>Site IDs</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon aria-label="Close dialog" md-svg-src="/public/images/ic_close_white_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><table class="ibm-data-table ibm-alternate-two" cellspacing="0" cellpadding="0" border="0"><tr><th ng-repeat="header in vm.columnHeaders">{{::header}}</th></tr><tr ng-repeat="line in vm.dialogName"><td>{{::line.ibmCustNum}}</td><td>{{::line.custNum}}</td><td>{{::line.custName}}</td><td>{{::line.address}}</td><td>{{::line.city}}</td><td>{{::line.stateCode}}</td><td>{{::line.postalCode}}</td><td>{{::line.cntryCode}}</td></tr></table></md-content></md-dialog-content></md-dialog>');
$templateCache.put('action-menu.html','<!--author Matthew Rogers--><span>Your Actions : </span><span ng-if="vm.status.disableApproveButtons" style="display: inline-block;">&nbsp;<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span><p></p></span><!--span(ng-if="vm.topic.usFed.status || !vm.topic.topic.owner || vm.topic.actions.noneAvailable || !vm.config.proProfileLoaded || vm.topic.editableComponents.header_data.socket" style="display: inline-block;")--><span ng-if="vm.topic.usFed.status || vm.topic.actions.noneAvailable || !vm.config.proProfileLoaded || vm.topic.editableComponents.header_data.socket" style="display: inline-block;">&nbsp;<md-icon class="gray_icon" title="There are no Actions available for you" style="margin: 10px 10px 10px 0px" md-svg-icon="/public/images/star-circle.svg"></md-icon></span><!--md-menu(md-position-mode="target-right target" md-offset="-35 40" style="margin-left:-10px" ng-if="!vm.status.disableApproveButtons && !vm.topic.actions.noneAvailable && vm.config.proProfileLoaded && !vm.topic.editableComponents.header_data.socket && vm.topic.topic.owner && !vm.topic.usFed.status")--><md-menu ng-if="!vm.status.disableApproveButtons &amp;&amp; !vm.topic.actions.noneAvailable &amp;&amp; vm.config.proProfileLoaded &amp;&amp; !vm.topic.editableComponents.header_data.socket &amp;&amp; !vm.topic.usFed.status" md-position-mode="target-right target" md-offset="-35 40" style="margin-left:-10px"><md-button class="md-icon-button" ng-click="vm.openActionMenu($mdOpenMenu,$event)" title="Available User Actions for you"><md-icon class="blue_icon" md-svg-icon="/public/images/star-circle.svg"></md-icon></md-button><md-menu-content width="4"><md-menu-item ng-if="vm.topic.actions.reAssignUser"><md-button class="ibm-btn-pri" ng-click="vm.updateReAssignUser($event)"><md-icon class="blue_icon" md-svg-icon="/public/images/new_client.svg"></md-icon>{{vm.topic.topic.owner ? \'Re-Assign To Another User\' : \'Assign\'}}</md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.initiateValidation"><md-button class="ibm-btn-pri" ng-click="vm.nonAppStatusChange($event,\'Initiate Validation\')"><md-icon class="blue_icon" md-svg-icon="/public/images/rocket.svg"></md-icon>Initiate Validation</md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.submitForApproval"><md-button class="ibm-btn-pri" ng-click="vm.app($event,\'Submit for Approval\')"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_face_black_24px.svg"></md-icon>Submit for Approval</md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.approve"><md-button class="ibm-btn-pri" ng-click="vm.app($event,\'Approve\')"><md-icon class="blue_icon" md-svg-icon="/public/images/thumb-up-outline.svg"></md-icon>Approve</md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.reject"><md-button class="ibm-btn-pri" ng-click="vm.app($event,\'Reject\')"><md-icon class="deepred_icon" md-svg-icon="/public/images/thumb-down-outline.svg"></md-icon>Reject</md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.renotify"><md-button class="ibm-btn-pri" ng-click="vm.app($event,\'Renotify Approver\')"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_face_black_24px.svg"></md-icon>Renotify Approver</md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.cancelApproval"><md-button class="ibm-btn-pri" ng-click="vm.app($event,\'Cancel Approval\')"><md-icon class="red_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>Cancel Approval Process</md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.reverseApproval"><md-button class="ibm-btn-pri" ng-click="vm.app($event,\'Reverse Approval\')"><md-icon class="red_icon" md-svg-icon="/public/images/reply-all.svg"></md-icon>Reverse Approval</md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.rejectDis"><md-button class="ibm-btn-pri" ng-click="vm.rej($event)"><md-icon class="brown_icon" md-svg-icon="/public/images/delete-forever.svg"></md-icon>Reject Disbursement</md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.close"><md-button class="ibm-btn-pri" ng-click="vm.close($event)"><md-icon class="green_icon" md-svg-icon="/public/images/close-circle-outline.svg"></md-icon>Close Disbursement</md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.rollbackStatus"><md-button class="ibm-btn-pri" ng-click="vm.rollBack($event)"><md-icon class="red_icon" md-svg-icon="/public/images/ic_history_black_24px.svg"></md-icon>Roll-Back Status</md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.updatePaymentDetailsStatus"><md-button class="ibm-btn-pri" ng-click="vm.updatePaymentDetails($event)"><div ng-if="vm.topic.topic.status.status_no === 7"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon>Update Payment Details</div><div ng-if="(vm.topic.topic.status.status_no === 4 || vm.topic.topic.status.status_no === 6) &amp;&amp; vm.topic.topic.calculation.complete === true &amp;&amp; vm.topic.topic.calculation.goe === \'N\'"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon>Update Payment Details</div><div ng-if="(vm.topic.topic.status.status_no === 4 || vm.topic.topic.status.status_no === 6) &amp;&amp; vm.topic.topic.calculation.sapResult &amp;&amp; vm.topic.topic.calculation.goe === \'Y\'"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon>Update Payment Details</div><div ng-if="(vm.topic.topic.status.status_no === 4 || vm.topic.topic.status.status_no === 6) &amp;&amp; vm.topic.topic.calculation.sapResult === undefined &amp;&amp; vm.topic.topic.calculation.goe === \'Y\'"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon>Move To Paid</div><div ng-if="(vm.topic.topic.status.status_no === 4 || vm.topic.topic.status.status_no === 6) &amp;&amp; vm.topic.topic.calculation.complete === false &amp;&amp; vm.topic.topic.calculation.goe === \'N\'"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon>Move To Set Aside </div></md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.moveToPaidStatus"><md-button class="ibm-btn-pri" ng-click="vm.moveToPaid($event)"><div><md-icon class="blue_icon" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon>Change to Paid Status</div></md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.overrideProspect"><md-button class="ibm-btn-pri" ng-click="vm.overrideProspectCMR($event)"><div><md-icon class="black_icon" md-svg-icon="/public/images/wrench.svg"></md-icon>Override Prospect CMR</div></md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.updateCmrCdid"><md-button class="ibm-btn-pri" ng-click="vm.CmrCdidOverride($event)"><div><md-icon class="black_icon" md-svg-icon="/public/images/wrench.svg"></md-icon>Update CMR/DCID</div></md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.embargoCheck"><md-button class="ibm-btn-pri" ng-click="vm.passEmbargoCheck($event)"><div><md-icon class="blue_icon" md-svg-icon="/public/images/ic_thumb_up_black_24px.svg"></md-icon>Embargo Check Passed</div></md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.notificationPreview"><md-button class="ibm-btn-pri" ng-click="vm.openNotificationPreview($event)"><div><md-icon class="blue_icon" md-svg-icon="/public/images/glasses.svg"></md-icon>Notification Preview</div></md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.crossBoarderEmea"><md-button class="ibm-btn-pri" ng-click="vm.passCrossBoardEmeaCheck($event)"><div><md-icon class="blue_icon" md-svg-icon="/public/images/ic_thumb_up_black_24px.svg"></md-icon>Confirm cross board eligibility            </div></md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.countryManualReview"><md-button class="ibm-btn-pri" ng-click="vm.passCountryManualReview($event)"><div><md-icon class="blue_icon" md-svg-icon="/public/images/ic_thumb_up_black_24px.svg"></md-icon>Manual Review Completed        </div></md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.refreshChecklists"><md-button class="ibm-btn-pri" ng-click="vm.refreshChecklists($event)"><md-icon class="orange_icon" md-svg-icon="/public/images/ic_list_black_24px.svg"></md-icon>Refresh Checklists</md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.createDispute"><md-button class="ibm-btn-pri" ng-click="vm.dispute($event)"><md-icon class="green_icon" md-svg-icon="/public/images/asterisk.svg"></md-icon>Create Dispute</md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.changeInvReqFlag"><md-button class="ibm-btn-pri" ng-click="vm.changeInvFlag($event, 0)"><md-icon class="red_icon" md-svg-icon="/public/images/ic_assignment_return_black_24px.svg"></md-icon>{{vm.topic.topic.invoice_flags.requested?\'Remove Invoice Requested Flag\':\'Invoice Requested\'}}</md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.changeInvReceivedFlag"><md-button class="ibm-btn-pri" ng-click="vm.changeInvFlag($event, 1)"><md-icon class="green_icon" md-svg-icon="/public/images/ic_assignment_turned_in_black_24px.svg"></md-icon>{{vm.topic.topic.invoice_flags.received?\'Remove Invoice Received Flag\':\'Invoice Received\'}}  </md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.submittedToAccountsFlag"><md-button class="ibm-btn-pri" ng-click="vm.changeInvFlag($event, 2)"><md-icon class="green_icon" md-svg-icon="/public/images/ic_assignment_turned_in_black_24px.svg"></md-icon>{{vm.topic.topic.invoice_flags.submitted?\'Remove Submitted to Accounts Payable Flag\':\'Submitted to Accounts Payable\'}}  </md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.resolveError"><md-button class="ibm-btn-pri" ng-click="vm.resolveError($event)"><md-icon class="black_icon" md-svg-icon="/public/images/wrench.svg"></md-icon>Resolve Errors        </md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.changeSalesAssist"><md-button class="ibm-btn-pri" ng-click="vm.changeSalesAssist($event)"><md-icon class="black_icon" md-svg-icon="/public/images/sales_assist.svg"></md-icon>Change Incentive Type</md-button></md-menu-item><md-menu-item ng-if="vm.topic.actions.viewDisputeList"><md-menu md-position-mode="target-right target" md-offset="-35 40" style="margin-left:-10px"><md-button class="ibm-btn-pri" ng-click="vm.openActionMenu($mdOpenMenu,$event)" ng-mouseover="vm.getListOfAllDisputes()"><md-icon class="blue_icon" md-svg-icon="/public/images/glasses.svg"></md-icon><span style="text-transform: none; padding-left: 1em; font-size: 15px">View Dispute List</span></md-button><md-menu-content width="4"><span class="span ibm-textcolor-blue-40" ng-if="!vm.codesLoaded" style="padding:0 10px 0 20px; background-color:white; display:flex; align-items:center">Retrieving Dispute List...<span class="ibm-spinner" style="top:0; margin-left:10px;"></span></span><md-menu-item ng-if="vm.codesLoaded" ng-repeat="o in vm.reasonCodes.data" style="opacity: 1;"><md-button class="ibm-btn-pri" ng-click="vm.viewDispute($event,o)"><div ng-style="vm.setBoldStyleToParent(o)">{{o}}</div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item ng-if="vm.topic.actions.viewDisputes"><md-menu md-position-mode="target-right target" md-offset="-35 40" style="margin-left:-10px"><md-button class="ibm-btn-pri" ng-click="vm.openActionMenu($mdOpenMenu,$event)"><md-icon class="blue_icon" md-svg-icon="/public/images/glasses.svg"></md-icon><span style="text-transform: none; padding-left: 1em; font-size: 15px">View Disputes</span></md-button><md-menu-content width="4"><md-menu-item ng-repeat="x in vm.topic.topic.disputes"><md-button class="ibm-btn-pri" ng-click="vm.viewDispute($event,x)">{{x}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item ng-if="vm.topic.actions.refreshSiteIds"><md-button class="ibm-btn-pri" ng-click="vm.refreshSiteIds($event)"><md-icon class="black_icon" md-svg-icon="/public/images/ic_list_black_24px.svg"></md-icon>Refresh Site Ids</md-button></md-menu-item><md-menu-item ng-if="false &amp;&amp; vm.topic.actions.copyOppData"><md-button class="ibm-btn-pri" ng-click="vm.copyOppData($event)"><md-icon class="black_icon" md-svg-icon="/public/images/sales_assist.svg"></md-icon>Copy opportunity</md-button></md-menu-item></md-menu-content></md-menu>');
$templateCache.put('attachment.html','<!--@author Ivan Toth--><style>.fileCom{ padding-bottom: 0px; font-size: small};</style><span class="ibm-h4" ng-click="vm.showHide()"><md-icon md-svg-src="/public/images/ic_attachment_black_24px.svg"></md-icon><span ng-if="!vm.showAttachment">&nbsp;View {{vm.title}} Attachments</span><span ng-if="vm.showAttachment">&nbsp;Hide {{vm.title}} Attachments</span><span ng-if="vm.topic.topic[vm.comp].locked"></span><lock-section comp="vm.comp"></lock-section></span><div class="ibm-columns" ng-if="vm.showAttachment"><span ng-if="vm.topic.topic.lock_indicator[vm.comp].locked"><p></p><span class="ibm-textcolor-gray-30">Locked by</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp].user}}</span><span class="ibm-textcolor-gray-30">&nbsp;on</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp].date | date: $ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></span></div><div class="ibm-columns" ng-if="vm.showAttachment"><p></p><div class="ibm-col-6-4"><table class="ibm-data-table ibm-grid ibm-altrows" ng-if="!vm.topic.editableComponents[vm.comp].socket &amp;&amp; vm.edit.editMode"><tr><th>File</th><th>Comments & User Details</th></tr><tr ng-repeat="fil in vm.getFileList()"><td style="width: 15em"><span><md-icon md-svg-src="/public/images/ic_attachment_black_24px.svg"></md-icon>&nbsp;</span><u ng-click="vm.downloadAttachment(fil)" title="Download {{::vm.decode(fil.name)}}">{{::vm.decode(fil.name)}}</u></td><td style="width: 40em"><input ng-model="fil.comment" ng-change="vm.commentChange(fil.name)" style="padding: 2px; width: 30em"/><p></p><md-icon md-svg-src="/public/images/ic_expand_more_black_24px.svg" ng-if="fil.visible"></md-icon><md-icon md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg" ng-if="!fil.visible"></md-icon><u class="fileCom" ng-click="vm.showUserData(fil, !fil.visible)">User Details</u><span ng-if="fil.visible"><p class="fileCom">Uploaded by&nbsp;<b>{{fil.uploadBy}}</b>&nbsp;on&nbsp;<b>{{fil.date | date:vm.settings.up.preferences.dateFormat : \'UTC\'}}</b></p><p class="fileCom" ng-if="fil.lmUser">Comments last modified by&nbsp;<b>{{fil.lmUser}}</b>&nbsp;on&nbsp;<b>{{fil.lmDate | date:vm.settings.up.preferences.dateFormat : \'UTC\'}}</b></p></span></td></tr></table><table class="ibm-data-table ibm-grid ibm-altrows" ng-if="!(!vm.topic.editableComponents[vm.comp].socket &amp;&amp; vm.edit.editMode)"><tr><th>File</th><th>Comments & User Details</th></tr><tr ng-repeat="fil in vm.getFileList()"><td style="width: 15em"><span><md-icon md-svg-src="/public/images/ic_attachment_black_24px.svg"></md-icon>&nbsp;</span><u ng-click="vm.downloadAttachment(fil)" title="Download {{::vm.decode(fil.name)}}">{{::vm.decode(fil.name)}}</u></td><td style="width: 40em"><span>{{fil.comment ? fil.comment : \'-\'}}</span><p></p><md-icon md-svg-src="/public/images/ic_expand_more_black_24px.svg" ng-if="fil.visible"></md-icon><md-icon md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg" ng-if="!fil.visible"></md-icon><u class="fileCom" ng-click="vm.showUserData(fil, !fil.visible)">User Details</u><span ng-if="fil.visible"><p class="fileCom">Uploaded by&nbsp;<b>{{fil.uploadBy}}</b>&nbsp;on&nbsp;<b>{{fil.date | date:vm.settings.up.preferences.dateFormat : \'UTC\'}}</b></p><p class="fileCom" ng-if="fil.lmUser">Comments last modified by&nbsp;<b>{{fil.lmUser}}</b>&nbsp;on&nbsp;<b>{{fil.lmDate | date:vm.settings.up.preferences.dateFormat : \'UTC\'}}</b></p></span></td></tr></table><span ng-if="vm.fileList == 0"><span>No files uploaded.</span></span><p></p><span class="ibm-textcolor-gray-40" ng-if="vm.section !== &quot;mysa&quot;"><b>NOTE:&nbsp;</b>The file size limit is 20 MB (20,000 KB). &nbsp;Any files selected that exceed this size will be ignored.</span><br/></div><!--| {{vm.topic.editableComponents}}--><div class="ibm-col-6-2" style="float: right"><div style="border: 1px solid lightgray; height: 50px; float: right" ng-if="vm.topic.loaded.topic"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50 md-icon-button" ng-if="vm.section !== &quot;mysa&quot;" ng-disabled="vm.topic.editableComponents[vm.comp].socket !== \'\'" aria-label="Upload File" ngf-select="vm.uploadFiles($files)" multiple="multiple" ngf-max-size="20MB" ngf-drop="vm.setSource()" ng-model="vm.sources" style="width: 37px;height: 30px;padding: 6px;margin-top: 6px; margin-left: 7px;" title="Upload a File"><md-icon class="white_icon" md-svg-icon="/public/images/ic_file_upload_black_24px.svg"></md-icon></md-button><esc-button-section style="float:right; margin-top: 12px" vm="vm" lock="vm.lockEnabled"></esc-button-section></div><div ng-if="!vm.topic.loaded.topic"><md-icon class="rotating" md-svg-src="/public/images/ic_autorenew_black_24px.svg"></md-icon></div></div></div>');
$templateCache.put('auto-fail-dialog.html','<md-dialog aria-label="Auto-Fail Part" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Auto-Fail Part - {{::vm.afBundle.pn}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><ng-form name="errorForm"><p>Please enter a Failure Comment to be used for all Validation Rules for this Part<span ng-if="!vm.afBundle.all">&nbsp;that need a Decision. </span><span ng-if="vm.afBundle.all">.</span>&nbsp; Click&nbsp;<b>OK&nbsp;</b>to continue, or&nbsp;<b>Cancel&nbsp;</b>to quit.&nbsp;&nbsp;</p><p></p><textarea class="userField" name="comments" ng-model="vm.afBundle.comment" style="resize: none" rows="5" cols="100" resize="false" ng-required="true"></textarea><p></p></ng-form><md-button class="md-raised md-primary" ng-disabled="!vm.$scope.errorForm.$valid" ng-click="vm.answer()">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-content></md-dialog-content></md-dialog>');
$templateCache.put('bonus-edit.html','<style>.md-datepicker-calendar-pane{z-index: 1200}\n\n</style><md-dialog aria-label="Edit Bonus" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Edit Bonus</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><!--|| {{vm.disBundle}}--><ng-form name="disForm"><md-content class="md-padding"><p></p><span class="ibm-textcolor-blue-50">Priority&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><!--select(style="width: 20em" ng-model=\'vm.disBundle.disputeType\' ng-options=\'o as o.name for o in vm.disBundle.types\' ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name.toLowerCase()][0]")--><span class="ibm-textcolor-blue-40">{{vm.bonusBundle.priority}}</span></div><p></p><span class="ibm-textcolor-blue-50">Country&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><!--select(style="width: 20em" ng-model=\'vm.disBundle.disputeType\' ng-options=\'o as o.name for o in vm.disBundle.types\' ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name.toLowerCase()][0]")--><span class="ibm-textcolor-blue-40">{{vm.bonusBundle.country}}</span></div><p></p><span class="ibm-textcolor-blue-50">License&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><!--select(style="width: 20em" ng-model=\'vm.disBundle.disputeType\' ng-options=\'o as o.name for o in vm.disBundle.types\' ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name.toLowerCase()][0]")--><span class="ibm-textcolor-blue-40">{{vm.bonusBundle.license}}</span></div><p></p><span class="ibm-textcolor-blue-50">Revenue Stream Code&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><!--select(style="width: 20em" ng-model=\'vm.disBundle.disputeType\' ng-options=\'o as o.name for o in vm.disBundle.types\' ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name.toLowerCase()][0]")--><span class="ibm-textcolor-blue-40">{{vm.bonusBundle.revenueStreamCode}}</span></div><p></p><span class="ibm-textcolor-blue-50">GOE&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><!--select(style="width: 20em" ng-model=\'vm.disBundle.disputeType\' ng-options=\'o as o.name for o in vm.disBundle.types\' ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name.toLowerCase()][0]")--><span class="ibm-textcolor-blue-40">{{vm.bonusBundle.GOE}}</span></div><p></p><span class="ibm-textcolor-blue-50">Incentive&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><!--select(style="width: 20em" ng-model=\'vm.disBundle.disputeType\' ng-options=\'o as o.name for o in vm.disBundle.types\' ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name.toLowerCase()][0]")--><span class="ibm-textcolor-blue-40">{{vm.bonusBundle.incentive}}</span></div><p></p><span class="ibm-textcolor-blue-50">ISU&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><!--select(style="width: 20em" ng-model=\'vm.disBundle.disputeType\' ng-options=\'o as o.name for o in vm.disBundle.types\' ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name.toLowerCase()][0]")--><span class="ibm-textcolor-blue-40">{{vm.bonusBundle.ISU}}   </span></div><p></p><span class="ibm-textcolor-blue-50">Material&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><!--select(style="width: 20em" ng-model=\'vm.disBundle.disputeType\' ng-options=\'o as o.name for o in vm.disBundle.types\' ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name.toLowerCase()][0]")--><span class="ibm-textcolor-blue-40">{{vm.bonusBundle.material}}</span></div><p></p><span class="ibm-textcolor-blue-50">Bonus&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><!--select(style="width: 20em" ng-model=\'vm.disBundle.disputeType\' ng-options=\'o as o.name for o in vm.disBundle.types\' ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name.toLowerCase()][0]")--><!--span.ibm-textcolor-blue-40 {{vm.bonusBundle.bonus}}--><input type="text" ng-model="vm.bonusBundle.bonus" ng-change="vm.modified = true;"/></div><p></p><span class="ibm-textcolor-blue-50">Start Date&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><!--select(style="width: 20em" ng-model=\'vm.disBundle.disputeType\' ng-options=\'o as o.name for o in vm.disBundle.types\' ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name.toLowerCase()][0]")--><!-- span.ibm-textcolor-blue-40 {{vm.bonusBundle.startDate}}--><div style="z-index:99999"><md-datepicker ng-model="vm.bonusBundle.startDate"></md-datepicker></div></div><p></p><span class="ibm-textcolor-blue-50">End Date&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><!--select(style="width: 20em" ng-model=\'vm.disBundle.disputeType\' ng-options=\'o as o.name for o in vm.disBundle.types\' ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name.toLowerCase()][0]")--><!-- span.ibm-textcolor-blue-40 {{vm.bonusBundle.endDate}}--><div style="z-index:99999"><md-datepicker ng-model="vm.bonusBundle.endDate"></md-datepicker></div></div><p></p><span class="ibm-textcolor-blue-50">BP id&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><!--select(style="width: 20em" ng-model=\'vm.disBundle.disputeType\' ng-options=\'o as o.name for o in vm.disBundle.types\' ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name.toLowerCase()][0]")--><input type="text" ng-model="vm.bonusBundle.bpId" ng-change="vm.modified = true;"/></div><p></p><span class="ibm-textcolor-blue-50">IBM id&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><!--select(style="width: 20em" ng-model=\'vm.disBundle.disputeType\' ng-options=\'o as o.name for o in vm.disBundle.types\' ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name.toLowerCase()][0]")--><input type="text" ng-model="vm.bonusBundle.ibmId" ng-change="vm.modified = true;"/></div><span class="ibm-textcolor-blue-50">Solution&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><!--select(style="width: 20em" ng-model=\'vm.disBundle.disputeType\' ng-options=\'o as o.name for o in vm.disBundle.types\' ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name.toLowerCase()][0]")--><input type="text" ng-model="vm.bonusBundle.solution" ng-change="vm.modified = true;"/></div><span class="ibm-textcolor-blue-50">New Client&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><!--select(style="width: 20em" ng-model=\'vm.disBundle.disputeType\' ng-options=\'o as o.name for o in vm.disBundle.types\' ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name.toLowerCase()][0]")--><input type="text" ng-model="vm.bonusBundle.newclient" ng-change="vm.modified = true;"/></div><span class="ibm-textcolor-blue-50">Focus&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.bonusBundle.focus" ng-change="vm.modified = true;"/></div><span class="ibm-textcolor-blue-50">Growth&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.bonusBundle.growth" ng-change="vm.modified = true;"/></div><span class="ibm-textcolor-blue-50">Sales&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.bonusBundle.sales" ng-change="vm.modified = true;"/></div><span class="ibm-textcolor-blue-50">Engagement&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.bonusBundle.engagement" ng-change="vm.modified = true;"/></div><span class="ibm-textcolor-blue-50">CTL incentive&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.bonusBundle.ctl" ng-change="vm.modified = true;"/></div></md-content></ng-form><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="false">Submit</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-dialog-content></md-dialog>');
$templateCache.put('bp-notifications.html','<!--@author Ilya Aderiho--><style>.status-column {\n    width: 10%;\n}\n.subject-column {\n    width: 30%;\n}\n.attachment-column {\n    width: 30%;\n}\n.error-column {\n    width: 20%;\n}\n.timestamp-column {\n    width: 10%;\n}\n\n\n\n</style><span class="ibm-h4" ng-click="vm.showHide()"><md-icon md-svg-src="/public/images/ic_attachment_black_24px.svg"></md-icon><span ng-if="!vm.showBpNotifications">&nbsp;View BP Notifications</span><span ng-if="vm.showBpNotifications">&nbsp;Hide BP Notifications</span></span><div class="ibm-columns" ng-if="vm.showBpNotifications"><div id="indent-vertical"><table class="ibm-data-table ibm-grid ibm-altrows"><tr><th>Status / Sub status</th><th>Notification details</th><th>Attachments list</th><th>Error</th><th>Timestamp</th></tr><tr ng-if="vm.notificationsArray.length" ng-repeat="item in vm.notificationsArray"><td class="status-column">{{item.status}} / {{item.subStatus}}</td><td class="subject-column"><p class="ibm-textcolor-blue-40" ng-click="vm.showBpNotification(item, $event)" style="font-size:medium">{{item.mailData.subject}}</p></td><td class="attachment-column"><p ng-if="item.attachments.length" ng-repeat="attachment in item.attachments"><md-icon md-svg-src="/public/images/ic_attachment_black_24px.svg"></md-icon>&nbsp;<u ng-click="vm.downloadAttachment(attachment)">{{attachment}}</u></p></td><td class="error-column">{{item.errorDescription}} </td><td class="timestamp-column">{{item.timestamp | date:vm.settings.up.preferences.dateFormat : \'UTC\'}}</td></tr></table></div></div>');
$templateCache.put('client-edit.html','<style>.md-datepicker-calendar-pane{z-index: 1200}\n.md-dialog-is-showing md-dialog{width: 40%}\n.select2-selection--single {width: 200px }\n.select2, .select2-container, .select2-container--default, .select2-container--below, .select2-container--focus {width: 200px ! important}\n</style><md-dialog aria-label="Edit Bonus" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Edit Client</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="vm.disForm"><md-content class="md-padding"><span class="ibm-textcolor-blue-50">IOT&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="iot" ng-model="vm.content.iot" ng-required="true" ng-options="iot for iot in vm.iots"></select></div><p></p><span class="ibm-textcolor-blue-50">IMT&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="imt" ng-model="vm.content.imt" ng-required="true" ng-options="imt for imt in vm.imts[vm.content.iot]"><option value="">--Please select--                    </option></select></div><p></p><span class="ibm-textcolor-blue-50">Country&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="country" ng-model="vm.content.country" ng-required="true" ng-options="country as country for country in vm.listCountries(vm.tree,vm.content.iot,vm.content.imt)"><option value="">--Please select--</option></select></div><p></p><span class="ibm-textcolor-blue-50">BP name&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"> <input type="text" ng-model="vm.content.bp" ng-change="vm.modified = true;" ng-required="true"/></div><p></p><span class="ibm-textcolor-blue-50">BP CEID&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><span class="ibm-textcolor-blue-40">{{vm.content.bp_ceid}}</span></div><p></p><span class="ibm-textcolor-blue-50">Customer name&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"> <input type="text" ng-model="vm.content.customer_name" ng-change="vm.modified = true;" ng-required="true"/></div><p></p><span class="ibm-textcolor-blue-50">Customer number&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><span class="ibm-textcolor-blue-40">{{vm.content.customer_number}}</span></div><p></p><span class="ibm-textcolor-blue-50">Start Date&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><div style="z-index:99999"><md-datepicker ng-model="vm.content.start_date" ng-required="true"></md-datepicker></div></div><p></p><span class="ibm-textcolor-blue-50">Approval Date&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><div style="z-index:99999"><md-datepicker ng-model="vm.content.approval_date" ng-required="true"></md-datepicker></div></div><p></p><span class="ibm-textcolor-blue-50">End Date&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><div style="z-index:99999"><md-datepicker ng-model="vm.content.end_date" ng-required="true"></md-datepicker></div></div><p></p><span class="ibm-textcolor-blue-50">Opportunity number&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.content.opportunity_number" ng-change="vm.modified = true;" ng-required="true"/></div><p></p></md-content></ng-form><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="!vm.disForm.$valid || vm.newClient.country===\'-Please select-\' || vm.newClient.imt===\'-Please select-\' ">Submit</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-dialog-content></md-dialog>');
$templateCache.put('close-dialog.html','<md-dialog aria-label="Close Disbursement" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Close Disbursement</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><ng-form name="closeForm"><p>You have chosen to flag this Disbursement as&nbsp;<b class="ibm-textcolor-blue-50">Closed</b>. &nbsp;Should you choose to continue, you will no longer be able to edit the detail, or reinstate it without help from the&nbsp;<b>DMT System Administrators</b>. &nbsp;Please determine the correct Sub-Status and Close Code below:</p><select style="width: 20em" ng-model="vm.closeBundle.nextSubStatusDesc" ng-options="o.txt as o.txt for o in vm.closeBundle.nextSubStatuses" ng-change="vm.closeBundle.setSubStatus()" ng-required="true"></select>&nbsp;&nbsp;<close-reason-select parent="vm"></close-reason-select><p></p><p>Please add some supporting comments {{ vm.closeBundle.closeReason.other ? \'for the \\\'Other Reason\\\'\' : \'if you like\'}}:<textarea class="userField" name="comments" ng-model="vm.closeBundle.comments" style="resize: none" rows="5" cols="100" resize="false" ng-required="vm.closeBundle.closeReason.other"></textarea></p></ng-form><md-button class="md-raised md-primary" ng-disabled="!vm.$scope.closeForm.$valid" ng-click="vm.answer()">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-content></md-dialog-content></md-dialog>');
$templateCache.put('close-reason-select.html','<select ng-if="$ctrl.codesLoaded" style="width: 30em" ng-model="$ctrl.parent.closeBundle.closeReason" ng-init="$ctrl.parent.closeBundle.closeReason = $ctrl.parent.closeBundle.closeReason || $ctrl.reasonCodes[0]" ng-options="o as o.code + &quot; - &quot; + o.desc for o in $ctrl.reasonCodes"></select><span class="span ibm-textcolor-blue-40" ng-if="!$ctrl.codesLoaded" style="border: 1px solid lightgray; padding: 7px 40px 11px 54px; background-color:white">Retrieving Closed Codes...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></span>');
$templateCache.put('closure-details.html','<md-dialog aria-label="Closure Details" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Closure Details</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.clickNo()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content style="min-width: 40em"><md-content class="md-padding">The Closure Details for this Disbursement are as follows:<p></p><table class="ibm-data-table ibm-alternate-two" cellspacing="0" cellpadding="0" border="0"><tBody><tr><td class="ibm-textcolor-blue-50">Status Closed at</td><td>{{::vm.close_status}}</td></tr><tr><td class="ibm-textcolor-blue-50">Closure Reason</td><td>{{::vm.close_details.close_reason}}</td></tr><tr><td class="ibm-textcolor-blue-50">Optional Comments</td><td>{{::vm.close_details.close_comments ? vm.close_details.close_comments : \'N/A\' }}</td></tr></tBody></table></md-content></md-dialog-content></md-dialog>');
$templateCache.put('cmrArray-dialog.html','<style>.md-virtual-repeat-container.md-autocomplete-suggestions-container {\n  z-index: 9999;\n}</style><md-dialog aria-label="cmrArray " ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Cmr List</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><span ng-repeat="param in vm.dialogName track by $index" layout="row"><p>{{param}}</p></span></md-content></md-dialog-content></md-dialog>');
$templateCache.put('cmrCdData-dialog.html','<style>.md-virtual-repeat-container.md-autocomplete-suggestions-container {\n  z-index: 9999;\n}</style><md-dialog ng-cloak="" aria-label="cmrArray "><md-toolbar><div class="md-toolbar-tools"><h2>Customer Designation</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon aria-label="Close dialog" md-svg-src="/public/images/ic_close_white_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><table class="ibm-data-table ibm-alternate-two" cellspacing="0" cellpadding="0" border="0"><tr><th ng-repeat="header in vm.columnHeaders">{{::header}}</th></tr><tr ng-repeat="line in vm.dialogName"><td>{{::line.cmrName}}</td><td>{{::line.cmrDswBpTag}}</td><td>{{::line.cmrCountryLanded}}</td><td>{{::line.cmrNum}}</td><td>{{::line.cmrDomClient}}</td></tr></table></md-content></md-dialog-content></md-dialog>');
$templateCache.put('copy-uat-dialog.html','<md-dialog ng-cloak="" aria-label="Copy data"><md-toolbar><div class="md-toolbar-tools"><h2>Copy opportunity</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon aria-label="Close dialog" md-svg-src="/public/images/ic_close_white_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><div style="margin: 0px 0px 20px 0px"><p>Select entry:</p><select class="ibm_select" ng-disabled="!vm.locals.inCurrentStatus" ng-if="vm.locals.disputes &amp;&amp; vm.locals.disputes.length !== 0" ng-model="vm.locals.choosedDispute" style="width: 250px"><option value="undefined">-</option><option ng-repeat="dispute in vm.locals.disputes" value="{{dispute}}">{{ dispute }}</option></select><p ng-if="!vm.locals.disputes || vm.locals.disputes.length === 0">No entries found</p></div><div style="margin: 0px 0px 20px 0px"><p>Status:</p><input ng-change="vm.locals.inCurrentStatus = true" ng-model="vm.locals.inCurrentStatus" ng-value="true" type="radio"/>Current<input ng-change="vm.locals.inCurrentStatus = false; vm.locals.choosedDispute = undefined" ng-model="vm.locals.inCurrentStatus" ng-value="false" type="radio"/>Received - Unassigned</div></md-content><md-button class="md-raised md-primary" ng-click="vm.answer()">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-dialog-content></md-dialog>');
$templateCache.put('ctl-so-information.html','<style>.table {\n    width: 100%\n}\n.cell {\n    font-size: small;\n    white-space: nowrap;\n    padding: 0!important;\n}\n.p {\n    font-size: small;\n    white-space: nowrap;\n}</style><div class="ibm-columns" ng-if="vm.topic.hasCtlSo" id="ctlInfo"><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"></div><!--TITLE--><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"></div><div class="ibm-col-4-1" id="genInfo"><h2 class="ibm-h2">CTL SO Information</h2></div><div class="ibm-col-4-1 ibm-right" id="genInfo"><esc-button-section ng-if="true" vm="vm" lock="false"></esc-button-section></div></div><!--TERM--><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"></div><div class="ibm-col-4-1" id="genInfo"><md-container style="margin: 20px;"></md-container><label>Length of term:</label></div><div class="ibm-col-4-1" id="genInfo" ng-if="!vm.edit.editMode"><label>{{vm.readModel.lengthOfTerm}} months</label><span ng-if="!vm.edit.editMode &amp;&amp; vm.readModel.lengthOfTerm === \'-\'"><md-icon class="red_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="CTL SO \'Length of term\' is incorrect"></md-icon></span></div><div class="ibm-col-4-1" id="genInfo" ng-if="vm.edit.editMode"><md-input-container style="padding:0; margin:0; height: 30px; width: 100%"><input name="lengthOfTerm" ng-minlength="1" ng-model="vm.editModel.lengthOfTerm" ng-pattern="/^[0-9]*$/" ng-change="vm.onChange()" ng-required="true"/></md-input-container></div></div><!--FREQUENCY--><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"></div><div class="ibm-col-4-1" id="genInfo"><md-container style="margin: 20px;"></md-container><label>Billing frequency:</label></div><div class="ibm-col-4-1" id="genInfo"><label ng-if="!vm.edit.editMode">{{vm.readModel.billingFrequencyLabel}}</label><span ng-if="!vm.edit.editMode &amp;&amp; !vm.readModel.billingFrequencyLabel"><md-icon class="red_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="CTL SO \'Billing frequency\' is incorrect"></md-icon></span><md-select ng-if="vm.edit.editMode" style="flex-grow: unset" ng-change="vm.onChange()" ng-model="vm.editModel.billingFrequency" aria-label="Billing frequency"><md-option ng-repeat="opt in vm.billingFrequencyOptions" ng-value="opt.key">{{opt.value}}</md-option></md-select></div></div><!--BILLING --><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"></div><div class="ibm-col-4-1" id="genInfo"><md-container style="margin: 20px;"></md-container><label>Billing month:</label></div><div class="ibm-col-4-1" id="genInfo"><label ng-if="!vm.edit.editMode">{{vm.readModel.billingMonth}} months</label><span ng-if="!vm.edit.editMode &amp;&amp; vm.readModel.billingMonth === \'-\'"><md-icon class="red_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="CTL SO \'Billing month\' is calculated incorrectly"></md-icon></span><table class="table ibm-data-table" ng-if="vm.edit.editMode" cellspacing="0" cellpadding="0"><tr><td class="cell"><b>start date</b></td><td class="cell"> <md-datepicker ng-model="vm.startDate" ng-change="vm.onChange()" ng-required="true"></md-datepicker></td></tr><tr><td class="cell"><b>billing date</b></td><td class="cell"><md-datepicker ng-model="vm.billingDate" ng-change="vm.onChange()" ng-required="true">    </md-datepicker></td></tr></table><p class="ibm-textcolor-red-50 valErr" ng-bind-html="vm.termError" ng-if="vm.termError"></p><p class="ibm-textcolor-red-50 valErr" ng-bind-html="vm.frequencyError" ng-if="vm.frequencyError"></p><p class="ibm-textcolor-red-50 valErr" ng-bind-html="vm.billingError" ng-if="vm.billingError"></p></div></div></div></div>');
$templateCache.put('detail-comment-dialog.html','<!--author Ivan Toth--><md-dialog aria-label="{{vm.field}}" ng-cloak="ng-cloak"><md-toolbar><div class="md-toolbar-tools"><h2>Add a Comment</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding">Please enter the comments and click <b>Save&nbsp;</b>to confirm.<p></p><textarea style="border: 1px solid lightgray; padding: 5px" name="comment" cols="80" rows="6" ng-model="vm.comment" required="required" ng-change="vm.convertNotesLink()"></textarea><p></p><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.answer()" title="Confirm and Save the comments" ng-disabled="dialogForm.$invalid || vm.processing"><md-icon class="white_icon" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Save Comments</md-button><!--divspan(ng-if="!dialogForm.comment.$invalid") Preview:--><!--divspan\n  p.comment_real(ng-bind-html="vm.comment | linkyWithNotes : \'_blank\'")\nmd-input-container(class="md-input-has-value",flex)\n  //label\n    span Please enter the Comments below:\n    span(ng-if="dialogForm.comment.$invalid")\n      | &nbsp;\n      md-icon(md-svg-src="/public/images/ic_warning_black_24px.svg",title="Comment field empty")\n  span\n    textarea(style="border: 1px solid lightgray; padding: 5px" name="comment", cols="100" rows="3" ng-model="vm.comment",placeholder="Please enter the Comments",required,ng-change="vm.convertNotesLink()")\n  md-button(ng-click="vm.answer()",class="md-raised md-primary",ng-disabled="dialogForm.$invalid || vm.processing") Save Comments--></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('detail-comment.html','<!--author Ivan Toth--><div><b class="ibm-h3 ibm-textcolor-blue-40">Comments</b></div><br/><div class="ibm-col-1-1" id="genInfo"><span class="ibm-h4" ng-click="vm.toggle()" ng-mouseover="vm.hovered = true;" ng-mouseleave="vm.hovered = false;"><md-icon md-svg-src="/public/images/ic_forum_black_24px.svg"></md-icon><span><sup ng-bind="vm.topic.topic.comments[vm.activeTab].length" ng-class="{\'upAndDown\': vm.hovered == true}"></sup></span><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><span>&nbsp;{{vm.visible ? \'Hide\' : \'View\'}} Comments</span></span><span ng-if="vm.topic.editableComponents[vm.comp].socket===\'\'" style="margin-left: 20px"><span class="ibm-h4" ng-click="vm.addComment($event)"><md-icon md-svg-src="/public/images/ic_chat_bubble_outline_black_24px.svg" title="Add Comments"></md-icon><span>&nbsp;Add Comments</span></span></span><span ng-if="vm.topic.editableComponents[vm.comp].socket !== \'\'" style="margin-left: 20px"><span class="ibm-h4"><md-icon class="grey_icon" md-svg-src="/public/images/ic_chat_bubble_outline_black_24px.svg"></md-icon><span class="ibm-textcolor-gray-50">&nbsp;Add Comments</span></span></span><p ng-hide="!vm.visible || vm.topic.topic.comments[vm.activeTab].length === 0"></p><table class="ibm-data-table ibm-grid ibm-altrows" style="width:100%" ng-hide="!vm.visible || vm.topic.topic.comments[vm.activeTab].length === 0"><thead><tr><th style="min-width:12em">Date & Time</th><th style="min-width:12em">User</th><th>Comments</th></tr></thead><tbody><tr ng-repeat="line in vm.topic.topic.comments[vm.activeTab]"><td>{{::line.time | date:vm.settings.up.preferences.dateFormat}}</td><td>{{::line.source}}</td><td><span><p ng-bind-html="line.comment | linkyWithNotes : \'_blank\'"></p></span></td></tr></tbody></table><div ng-hide="!vm.visible || vm.topic.topic.comments[vm.activeTab].length &gt; 0"><p></p><span>No comments found</span></div><p></p></div>');
$templateCache.put('detail-search-decision.html','<!--author Ivan Toth--><md-dialog aria-label="{{vm.field}}" ng-cloak="ng-cloak" style="max-width: 100%;max-height: 80%;width: 100%;height: 80%;border-radius: 0;"><md-toolbar><div class="md-toolbar-tools"><h2>Pick search results to save for {{vm.type}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.save()"><md-icon class="white_icon" md-svg-src="/public/images/ic_save_black_24px.svg" title="Save results"></md-icon></md-button><md-button class="md-icon-button" ng-click="vm.dontSave()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" title="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="dmt-white-background" layout="column"><md-select multiple="multiple" ng-model="vm.filteredName"><md-option ng-value="iot" ng-repeat="tableItem in vm.item.table">{{ tableItem }}</md-option></md-select><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b flex="11%">Export Excel</b><b flex="11%">Filter</b><b flex="11%">Key word</b><b flex="11%">Timestamp</b><b flex="11%">User</b><b flex="11%">Country</b><b flex="11%">Results found</b><b flex="11%">Results Prepared for Save</b></div><md-divider flex="flex"></md-divider></md-list-item><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><span flex="11%" ng-click="vm.excelExport()"><md-icon md-svg-src="/public/images/ic_file_download_black_24px.svg" title="Generate Excel report of the whole search"></md-icon></span><span flex="11%"><input ng-model="vm.searchFilter" placeholder="Filter values" title="Only the lines, that contain the value will appear, by clearing the filter, all will appear back"/></span><span flex="11%">{{vm.item.fuzzySearch}}</span><span flex="11%">{{vm.item.timestamp | date:vm.settings.up.preferences.dateFormat}}</span><span flex="11%">{{vm.item.user}}</span><span flex="11%"><span ng-repeat="line in vm.item.countrySelected"><span>{{line}}</span></span></span><span flex="11%">{{vm.item.table.length}}</span><span flex="11%">{{vm.results.table.length}}</span></div><md-divider flex="flex" style="border-top-color:black"></md-divider></md-list-item></md-content><ng-form name="dialogForm"><div ng-if="vm.item.ds==\'MGR\'"><md-content class="dmt-white-background" layout="column"><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b flex="11%">Index</b><b flex="11%">Company name</b><b flex="11%">Customer Set Designation</b><b flex="11%">Contract Variant</b><b flex="11%">Curr ISU</b><b flex="11%">Date</b><b flex="11%">Init ISU</b><b flex="11%">Initial ISU Description</b><b flex="11%">ISO Country code</b><b flex="11%">ISU Sub Code</b></div><md-divider flex="flex" style="border-top-color:black"></md-divider></md-list-item><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" md-virtual-repeat="line in vm.item.table  | filter: vm.searchFilter" flex="" md-item-size="15" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unasigned &amp;&amp; {\'background-color\': \'orange\'}"><div class="md-list-item-text" layout="row" layout-align="start left"><span ng-click="vm.addItem(line)" flex="11%">+{{$index}}</span><span flex="11%">{{line.company_name}}</span><span flex="11%">{{line.customer_set_designation}}</span><span flex="11%">{{line.contract_variant}}</span><span flex="11%">{{line.curr_isu}}</span><span flex="11%">{{line.date}}</span><span flex="11%">{{line.init_isu}}</span><span flex="11%">{{line.initial_isu_description}}</span><span flex="11%">{{line.iso_country_code}}</span><span flex="11%">{{line.isu_sub_code}}</span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container></md-content></div><div ng-if="vm.item.ds==\'CMR\' || vm.item.ds==\'VCMR\' || vm.item.ds==\'AVCMR\'"><md-content class="dmt-white-background" layout="column"><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b flex="11%">Index</b><b flex="11%">Country Short</b><b flex="11%">Country</b><b flex="11%">Name1</b><b flex="11%">Name2</b><b flex="11%">International Name</b><b flex="11%">Site Party ID</b><b flex="11%">Number</b><b flex="11%">Duns</b><b flex="11%">GOE Indicator</b><b flex="11%">Trade Style Name</b></div><md-divider flex="flex" style="border-top-color:black"></md-divider></md-list-item><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" md-virtual-repeat="line in vm.item.table  | filter: vm.searchFilter" flex="" md-item-size="15" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unasigned &amp;&amp; {\'background-color\': \'orange\'}"><div class="md-list-item-text" layout="row" layout-align="start left"><span ng-click="vm.addItem(line)" flex="11%">+{{$index}}</span><span flex="11%">{{line.cmrCountryLanded}}</span><span flex="11%">{{line.cmrCountryLandedDesc}}</span><span flex="11%">{{line.cmrName1Plain}}</span><span flex="11%">{{line.cmrName2Plain}}</span><span flex="11%">{{line.cmrInternationalName}}</span><span flex="11%">{{line.cmrNum}}</span><span flex="11%">{{line.cmrGlobalBuyingGroup}}</span><span flex="11%">{{line.cmrDuns}}</span><span flex="11%">{{line.cmrGOEIndicator}}</span><span flex="11%">{{line.cmrTradeStyleName}}</span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container></md-content></div><div ng-if="vm.item.ds==\'GPP\' || $ctrl.item.ds==\'GPP-AP\'"><md-content class="dmt-white-background" layout="column"><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b flex="11%">Index</b><b flex="11%">CVR Owning Organization</b><b flex="11%">Account Name</b><b flex="11%">CVR submit date</b><b flex="11%">Brand Family</b><b flex="11%">Country</b><b flex="11%">Close Date</b><b flex="11%">Opp</b></div><md-divider flex="flex" style="border-top-color:black"></md-divider></md-list-item><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" md-virtual-repeat="line in vm.item.table  | filter: vm.searchFilter" flex="" md-item-size="15" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unasigned &amp;&amp; {\'background-color\': \'orange\'}"><div class="md-list-item-text" layout="row" layout-align="start left"><span ng-click="vm.addItem(line)" flex="11%">+{{$index}}</span><span flex="11%">{{line.sviownorg}}</span><span flex="11%">{{line.acctname}}</span><span flex="11%">{{line.svisubmitdate | date:vm.settings.up.preferences.dateFormat}}</span><span flex="11%">{{line.brandfam}}</span><span flex="11%">{{line.country}}</span><span flex="11%">{{line.closedate | date:vm.settings.up.preferences.dateFormat}}</span><span flex="11%">{{line.opp}}</span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container></md-content></div><div ng-if="vm.item.ds==\'SC\' || $ctrl.item.ds==\'SC-AP\'"><md-content class="dmt-white-background" layout="column"><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b flex="11%">Index</b><b flex="16%">Account Name</b><b flex="16%">Country</b><b flex="16%">Date Created</b><b flex="16%">Decision Date</b><b flex="16%">Type</b><b flex="16%">Brand Family</b><b flex="16%">Opp</b></div><md-divider flex="flex" style="border-top-color:black"></md-divider></md-list-item><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" md-virtual-repeat="line in vm.item.table  | filter: vm.searchFilter" flex="" md-item-size="15" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unasigned &amp;&amp; {\'background-color\': \'orange\'}"><div class="md-list-item-text" layout="row" layout-align="start left"><span ng-click="vm.addItem(line)" flex="11%">+{{$index}}</span><span flex="16%">{{line.account_name}}</span><span flex="16%">{{line.country}}</span><span flex="16%">{{line.date_created}}</span><span flex="16%">{{line.decision_date}}</span><span flex="16%">{{line.type}}</span><span flex="16%">{{line.brand_family}}</span><span flex="16%">{{line.opp}}</span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container></md-content></div><div ng-if="vm.item.ds==\'FP-CN\' || vm.item.ds==\'FP-BP\' || vm.item.ds==\'FP-SN\' || vm.item.ds==\'FP-V-CN\' || vm.item.ds==\'FP-V-BP\' || vm.item.ds==\'FP-V-SN\'"><md-content class="dmt-white-background" layout="column"><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b flex="11%">Index</b><b flex="11%">Customer Name</b><b flex="11%">Site Number</b><b flex="11%">State</b><b flex="11%">Country Code</b><b flex="11%">Coverage Code</b><b flex="11%">ISU for BP Incentives</b><b flex="11%">Gov for BP Incentives</b><b flex="11%">Current ISU Account Designation</b><b flex="11%">Current sub ISU account designation</b><b flex="11%">SAP Variant Code</b><b flex="11%">ISU for BP Incentives</b></div><md-divider flex="flex" style="border-top-color:black"></md-divider></md-list-item><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" md-virtual-repeat="line in vm.item.table  | filter: vm.searchFilter" flex="" md-item-size="15" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unasigned &amp;&amp; {\'background-color\': \'orange\'}"><div class="md-list-item-text" layout="row" layout-align="start left"><span ng-click="vm.addItem(line)" flex="11%">+{{$index}}</span><span flex="11%">{{line.cust_name}}</span><span flex="11%">{{line.site_num}}</span><span flex="11%">{{line.state}}</span><span flex="11%">{{line.cc}}</span><span flex="11%">{{line.cvrage_code}}</span><span flex="11%">{{line.init_ibm_ww_isu_code_dscr}}</span><span flex="11%">{{line.gov_ent_ind_dscr}}</span><span flex="11%">{{line.curr_web_appl_bus_dscr}}</span><span flex="11%">{{line.isu_sub_code_dscr}}</span><span flex="11%">{{line.sap_cust_var_code}}</span><span flex="11%">{{line.cust_num}}</span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container></md-content></div><div ng-if="vm.item.ds==\'FP-SO\' || vm.item.ds==\'FP-V-SO\'"><md-content class="dmt-white-background" layout="column"><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b flex="11%">Index</b><b flex="11%">Customer Number</b><b flex="11%">BP Name</b><b flex="11%">Sales Order Number</b><b flex="11%">Contract Suboption code</b><b flex="11%">ISU Code</b><b flex="11%">Host Code</b><b flex="33%">Details</b></div><md-divider flex="flex" style="border-top-color:black"></md-divider></md-list-item><md-virtual-repeat-container style="height:600px"><md-list-item class="md-2-line" md-virtual-repeat="line in vm.item.table  | filter: vm.searchFilter" flex="" md-item-size="15" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unasigned &amp;&amp; {\'background-color\': \'orange\'}"><div class="md-list-item-text" layout="row" layout-align="start left"><span ng-click="vm.addItem(line)" flex="11%">+{{$index}}</span><span flex="11%">{{line.customer_number}}</span><span flex="11%">{{line.bp_name}}</span><span flex="11%">{{line.sales_order_number}}</span><span flex="11%">{{line.contract_suboption_code}}</span><span flex="11%">{{line.isu_code}}</span><span flex="11%">{{line.host_code}}</span><span flex="33%" ng-click="vm.toggleRow(line)"><table class="ibm-data-table ibm-grid" ng-if="line.visible"><tr><td ng-style="vm.tableStyle">Sales Order Date:</td><td ng-style="vm.tableStyle">{{line.sales_order_date}}</td></tr><tr><td ng-style="vm.tableStyle">Bus Code:</td><td ng-style="vm.tableStyle">{{line.bus_code}}</td></tr><tr><td ng-style="vm.tableStyle">Level Code:</td><td ng-style="vm.tableStyle">{{line.level_code}}</td></tr><tr><td ng-style="vm.tableStyle">Channel Code:</td><td ng-style="vm.tableStyle">{{line.channel_code}}</td></tr><tr><td ng-style="vm.tableStyle">Payer Customer Number:</td><td ng-style="vm.tableStyle">{{line.payer_customer_number}}</td></tr><tr><td ng-style="vm.tableStyle">Customer Name:</td><td ng-style="vm.tableStyle">{{line.customer_name}}</td></tr><tr><td ng-style="vm.tableStyle">SAP Gov Flag:</td><td ng-style="vm.tableStyle">{{line.sap_gov_flag}}</td></tr><tr><td ng-style="vm.tableStyle">USD Extnd Price:</td><td ng-style="vm.tableStyle">{{line.usd_extnd_price | number:2}}</td></tr><tr><td ng-style="vm.tableStyle">Currency:</td><td ng-style="vm.tableStyle">{{line.currency}}</td></tr><tr><td ng-style="vm.tableStyle">Local extnd price:</td><td ng-style="vm.tableStyle">{{line.local_extnd_price | number:2}}</td></tr><tr><td ng-style="vm.tableStyle">BP Cust Num:</td><td ng-style="vm.tableStyle">{{line.bp_cust_num}}</td></tr><tr><td ng-style="vm.tableStyle">Cust Number:</td><td ng-style="vm.tableStyle">{{line.cust_number}}</td></tr><tr><td ng-style="vm.tableStyle">IBM ISU Code:</td><td ng-style="vm.tableStyle">{{line.ibm_isu_code}}</td></tr></table></span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container></md-content></div><div ng-if="vm.results.ds==\'MGR\'"><md-content class="dmt-white-background" layout="column"><md-list-item class="md-2-line"><md-divider flex="flex" style="border-top-color:black"></md-divider><div class="md-list-item-text" layout="row" layout-align="start left"><b flex="11%">Index</b><b flex="11%">Company name</b><b flex="11%">Customer Set Designation</b><b flex="11%">Contract Variant</b><b flex="11%">Curr ISU</b><b flex="11%">Date</b><b flex="11%">Init ISU</b><b flex="11%">Initial ISU Description</b><b flex="11%">ISO Country code</b><b flex="11%">ISU Sub Code</b></div><md-divider flex="flex" style="border-top-color:black"></md-divider></md-list-item><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" md-virtual-repeat="line in vm.results.table  | filter: vm.searchFilter" flex="" md-item-size="15" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unasigned &amp;&amp; {\'background-color\': \'orange\'}"><div class="md-list-item-text" layout="row" layout-align="start left"><span ng-click="vm.removeItem(line)" flex="11%">-{{$index}}</span><span flex="11%">{{line.company_name}}</span><span flex="11%">{{line.customer_set_designation}}</span><span flex="11%">{{line.contract_variant}}</span><span flex="11%">{{line.curr_isu}}</span><span flex="11%">{{line.date}}</span><span flex="11%">{{line.init_isu}}</span><span flex="11%">{{line.initial_isu_description}}</span><span flex="11%">{{line.iso_country_code}}</span><span flex="11%">{{line.isu_sub_code}}</span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container></md-content></div><div ng-if="vm.results.ds==\'CMR\' || vm.results.ds==\'VCMR\' || vm.results.ds==\'AVCMR\'"><md-content class="dmt-white-background" layout="column"><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b flex="11%">Index</b><b flex="11%">Country Short</b><b flex="11%">Country</b><b flex="11%">Name1</b><b flex="11%">Name2</b><b flex="11%">International Name</b><b flex="11%">Site Party ID</b><b flex="11%">Number</b><b flex="11%">Duns</b><b flex="11%">GOE Indicator</b></div><md-divider flex="flex" style="border-top-color:black"></md-divider></md-list-item><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" md-virtual-repeat="line in vm.results.table  | filter: vm.searchFilter" flex="" md-item-size="15" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unasigned &amp;&amp; {\'background-color\': \'orange\'}"><div class="md-list-item-text" layout="row" layout-align="start left"><span ng-click="vm.removeItem(line)" flex="11%">-{{$index}}</span><span flex="11%">{{line.cmrCountryLanded}}</span><span flex="11%">{{line.cmrCountryLandedDesc}}</span><span flex="11%">{{line.cmrName1Plain}}</span><span flex="11%">{{line.cmrName2Plain}}</span><span flex="11%">{{line.cmrInternationalName}}</span><span flex="11%">{{line.cmrSitePartyID}}</span><span flex="11%">{{line.cmrNum}}</span><span flex="11%">{{line.cmrDuns}}</span><span flex="11%">{{line.cmrGOEIndicator}}</span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container></md-content></div><div ng-if="vm.results.ds==\'GPP\'"><md-content class="dmt-white-background" layout="column"><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b flex="11%">Index</b><b flex="16%">CVR Owning Organization</b><b flex="16%">Account Name</b><b flex="16%">CVR submit date</b><b flex="16%">Brand Family</b><b flex="16%">Country</b><b flex="16%">Close Date</b><b flex="16%">Opp</b></div><md-divider flex="flex" style="border-top-color:black"></md-divider></md-list-item><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" md-virtual-repeat="line in vm.results.table  | filter: vm.searchFilter" flex="" md-item-size="15" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unasigned &amp;&amp; {\'background-color\': \'orange\'}"><div class="md-list-item-text" layout="row" layout-align="start left"><span ng-click="vm.removeItem(line)" flex="11%">-{{$index}}</span><span flex="16%">{{line.sviownorg}}</span><span flex="16%">{{line.acctname}}</span><span flex="16%">{{line.svisubmitdate | date:vm.settings.up.preferences.dateFormat}}</span><span flex="16%">{{line.brandfam}}</span><span flex="16%">{{line.country}}</span><span flex="16%">{{line.closedate | date:vm.settings.up.preferences.dateFormat}}</span><span flex="16%">{{line.opp}}</span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container></md-content></div><div ng-if="vm.results.ds==\'SC\'"><md-content class="dmt-white-background" layout="column"><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b flex="11%">Index</b><b flex="16%">Account Name</b><b flex="16%">Country</b><b flex="16%">Date Created</b><b flex="16%">Decision Date</b><b flex="16%">Type</b><b flex="16%">Brand Family</b><b flex="16%">Opp</b></div><md-divider flex="flex" style="border-top-color:black"></md-divider></md-list-item><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" md-virtual-repeat="line in vm.results.table  | filter: vm.searchFilter" flex="" md-item-size="15" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unasigned &amp;&amp; {\'background-color\': \'orange\'}"><div class="md-list-item-text" layout="row" layout-align="start left"><span ng-click="vm.removeItem(line)" flex="11%">-{{$index}}</span><span flex="16%">{{line.account_name}}</span><span flex="16%">{{line.country}}</span><span flex="16%">{{line.date_created}}</span><span flex="16%">{{line.decision_date}}</span><span flex="16%">{{line.type}}</span><span flex="16%">{{line.brand_family}}</span><span flex="16%">{{line.opp}}</span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container></md-content></div><div ng-if="vm.results.ds==\'FP-CN\' || vm.results.ds==\'FP-BP\' || vm.results.ds==\'FP-SN\' || vm.results.ds==\'FP-V-CN\' || vm.results.ds==\'FP-V-BP\' || vm.results.ds==\'FP-V-SN\'"><md-content class="dmt-white-background" layout="column"><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b flex="11%">Index</b><b flex="11%">Customer Name</b><b flex="11%">Site Number</b><b flex="11%">State</b><b flex="11%">Country Code</b><b flex="11%">Coverage Code</b><b flex="11%">ISU for BP Incentives</b><b flex="11%">Gov for BP Incentives</b><b flex="11%">Current ISU Account Designation</b><b flex="11%">Current sub ISU account designation</b><b flex="11%">SAP Variant Code</b><b flex="11%">ISU for BP Incentives</b></div><md-divider flex="flex" style="border-top-color:black"></md-divider></md-list-item><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" md-virtual-repeat="line in vm.results.table  | filter: vm.searchFilter" flex="" md-item-size="15" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unasigned &amp;&amp; {\'background-color\': \'orange\'}"><div class="md-list-item-text" layout="row" layout-align="start left"><span ng-click="vm.removeItem(line)" flex="11%">-{{$index}}</span><span flex="11%">{{line.cust_name}}</span><span flex="11%">{{line.site_num}}</span><span flex="11%">{{line.state}}</span><span flex="11%">{{line.cc}}</span><span flex="11%">{{line.cvrage_code}}</span><span flex="11%">{{line.init_ibm_ww_isu_code_dscr}}</span><span flex="11%">{{line.gov_ent_ind_dscr}}</span><span flex="11%">{{line.curr_web_appl_bus_dscr}}</span><span flex="11%">{{line.isu_sub_code_dscr}}</span><span flex="11%">{{line.sap_cust_var_code}}</span><span flex="11%">{{line.cust_num}}</span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container></md-content></div><div ng-if="vm.results.ds==\'FP-SO\' || vm.results.ds==\'FP-V-SO\'"><md-content class="dmt-white-background" layout="column"><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b flex="11%">Index</b><b flex="11%">Customer Number</b><b flex="11%">BP Name</b><b flex="11%">Sales Order Number</b><b flex="11%">Contract Suboption code</b><b flex="11%">ISU Code</b><b flex="11%">Host Code</b><b flex="33%">Details</b></div><md-divider flex="flex" style="border-top-color:black"></md-divider></md-list-item><md-virtual-repeat-container style="height:600px"><md-list-item class="md-2-line" md-virtual-repeat="line in vm.results.table  | filter: vm.searchFilter" flex="" md-item-size="15" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unasigned &amp;&amp; {\'background-color\': \'orange\'}"><div class="md-list-item-text" layout="row" layout-align="start left"><span ng-click="vm.removeItem(line)" flex="11%">-{{$index}}</span><span flex="11%">{{line.customer_number}}</span><span flex="11%">{{line.bp_name}}</span><span flex="11%">{{line.sales_order_number}}</span><span flex="11%">{{line.contract_suboption_code}}</span><span flex="11%">{{line.isu_code}}</span><span flex="11%">{{line.host_code}}</span><span flex="33%"><table class="ibm-data-table ibm-grid" ng-if="line.visible" ng-click="vm.toggleRow(line)"><tr><td ng-style="vm.tableStyle">Sales Order Date:</td><td ng-style="vm.tableStyle">{{line.sales_order_date}}</td></tr><tr><td ng-style="vm.tableStyle">Bus Code:</td><td ng-style="vm.tableStyle">{{line.bus_code}}</td></tr><tr><td ng-style="vm.tableStyle">Level Code:</td><td ng-style="vm.tableStyle">{{line.level_code}}</td></tr><tr><td ng-style="vm.tableStyle">Channel Code:</td><td ng-style="vm.tableStyle">{{line.channel_code}}</td></tr><tr><td ng-style="vm.tableStyle">Payer Customer Number:</td><td ng-style="vm.tableStyle">{{line.payer_customer_number}}</td></tr><tr><td ng-style="vm.tableStyle">Customer Name:</td><td ng-style="vm.tableStyle">{{line.customer_name}}</td></tr><tr><td ng-style="vm.tableStyle">SAP Gov Flag:</td><td ng-style="vm.tableStyle">{{line.sap_gov_flag}}</td></tr><tr><td ng-style="vm.tableStyle">USD Extnd Price:</td><td ng-style="vm.tableStyle">{{line.usd_extnd_price | number:2}}</td></tr><tr><td ng-style="vm.tableStyle">Currency:</td><td ng-style="vm.tableStyle">{{line.currency}}</td></tr><tr><td ng-style="vm.tableStyle">Local extnd price:</td><td ng-style="vm.tableStyle">{{line.local_extnd_price | number:2}}</td></tr><tr><td ng-style="vm.tableStyle">BP Cust Num:</td><td ng-style="vm.tableStyle">{{line.bp_cust_num}}</td></tr><tr><td ng-style="vm.tableStyle">Cust Number:</td><td ng-style="vm.tableStyle">{{line.cust_number}}</td></tr><tr><td ng-style="vm.tableStyle">IBM ISU Code:</td><td ng-style="vm.tableStyle">{{line.ibm_isu_code}}</td></tr></table></span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container></md-content></div><md-button class="md-raised md-primary" ng-click="vm.save()">Save</md-button><md-button class="md-raised md-primary" ng-click="vm.dontSave()">Cancel</md-button></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('detail-tree-edit-v2.html','<div class="ibm-columns" id="generalInfo"></div><span ng-click="$ctrl.toggle()"> <md-icon ng-hide="$ctrl.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><!--span.ibm-bold &nbsp;{{$ctrl.settings.calculationTreeLevels[$ctrl.level]}}:&nbsp;--></span><md-input-container flex="flex" style="padding:0; margin:0"><input class="cell" ng-model="$ctrl.item.id" style="min-width:100px; border: solid 1px lightgray" required="required" aria-label="$ctrl.settings.calculationTreeLevels[$ctrl.level]" ng-change="$ctrl.updateVal()" placeholder="{{::$ctrl.settings.calculationTreeLevels[$ctrl.level]}}"/></md-input-container><span ng-if="$ctrl.item.error!==\'\'"><md-icon class="red_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.error)}}"></md-icon><input class="cell" title="input" name="error" required="required" hidden="hidden" ng-model="$ctrl.error" style="border: solid 1px lightgray"/></span><span class="ibm-btn-row ibm-light" ng-if="$ctrl.level&lt;4"><span ng-click="$ctrl.addChild()"><md-icon md-svg-src="/public/images/ic_add_box_black_24px.svg"></md-icon></span></span><span ng-click="$ctrl.remove()" ng-if="$ctrl.level&gt;0"><md-icon md-svg-src="/public/images/ic_indeterminate_check_box_black_24px.svg"></md-icon></span><span ng-hide="!$ctrl.visible"><div class="ibm-columns"><div class="thirty-right"><span></span><div ng-if="$ctrl.caller===\'payment\' &amp;&amp; $ctrl.level===4"><div class="ibm-columns" id="generalInfo"></div><div class="ibm-columns search-form"><md-content class="dmt-white-background" layout="column"><span class="calc_gpp">Opportunity Forecast</span><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b class="cell" flex="11%">Forecast ({{$ctrl.topic.temp.calculation.forecasts.currency}})</b><b class="cell" flex="11%">Uplift {{$ctrl.item.uplift}}%<span ng-if="$ctrl.item.autoUplift===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.upliftComments)}}"></md-icon></span></b><b class="cell" flex="11%">Already paid ({{$ctrl.topic.temp.calculation.forecasts.currency}})</b><b class="cell" flex="11%">BF Available Amount ({{$ctrl.topic.temp.calculation.forecasts.currency}})</b><b class="cell" flex="11%">Item Available Amount ({{$ctrl.topic.temp.calculation.forecasts.currency}})</b><b class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast()">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_4 ? \'SSA\' : \'CVR SSA\'}}<p>{{$ctrl.item.bonus!==undefined ? \'Bonus \' + ($ctrl.item.bonus ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSSAComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSSAComment)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast()">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_4 ? \'Engagement\' : \'CVR Solution\'}}<p>{{$ctrl.item.bonusSolution!==undefined ? \'Bonus \' + ($ctrl.item.bonusSolution ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusSolutionComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusSolutionComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSolutionComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSolutionComment)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.topic.checksData.uiVersion &lt; $ctrl.OPP_VERSION_4">CVR New Client <p>{{$ctrl.item.bonusNewClient!==undefined ? \'Bonus \' + ($ctrl.item.bonusNewClient ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusNewClientComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusNewClientComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">Growth<p>{{$ctrl.item.bonusGrowth!==undefined ? \'Bonus \' + ($ctrl.item.bonusGrowth ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusGrowthComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusGrowthComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">Focus<p>{{$ctrl.item.bonusFocus!==undefined ? \'Bonus \' + ($ctrl.item.bonusFocus ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusFocusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusFocusComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">CTL<p>{{$ctrl.item.bonusCtl!==undefined ? \'Bonus \' + ($ctrl.item.bonusCtl ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusCtlComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusCtlComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()"> </b></div><md-divider flex="flex"></md-divider></md-list-item><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><span class="cell" flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" type="number" ng-pattern="/^[0-9]+(.[0-9]{1,2})?$/" step="0.01" title="input" ng-model="$ctrl.topic.temp.calculation.forecasts[$ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_3 ? $ctrl.parent.parent.item.drpgId : $ctrl.parent.parent.item.brandCode].value" required="required" ng-change="$ctrl.changeForecast()"/></md-input-container><span ng-if="$ctrl.topic.temp.calculation.forecasts[$ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_3 ? $ctrl.parent.parent.item.drpgId : $ctrl.parent.parent.item.brandCode].auto===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="Manually set by user."></md-icon></span></span><span class="cell" flex="11%">{{$ctrl.item.upliftAmount }}</span><span class="cell" flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" type="number" ng-pattern="/^[0-9]+(.[0-9]{1,2})?$/" step="0.01" title="input" ng-model="$ctrl.topic.temp.calculation.payed[$ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_3 ? $ctrl.parent.parent.item.drpgId : $ctrl.parent.parent.item.brandCode].value" required="required" ng-change="$ctrl.changePayed()"/></md-input-container><span ng-if="$ctrl.topic.temp.calculation.payed[$ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_3 ? $ctrl.parent.parent.item.drpgId : $ctrl.parent.parent.item.brandCode].auto===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="Manually set by user."></md-icon></span></span><span class="cell" flex="11%">{{$ctrl.item.availableAmount }}</span><span class="cell" flex="11%">{{$ctrl.item.itemAvailableAmount }}</span><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmount &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmount &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedByForecast()">{{$ctrl.item.bonusAmount ? ($ctrl.item.bonusAmount ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountSolution &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountSolution &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedByForecast()">{{$ctrl.item.bonusAmountSolution ? ($ctrl.item.bonusAmountSolution ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountNewClient &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountNewClient &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.topic.checksData.uiVersion &lt;= $ctrl.OPP_VERSION_3">{{$ctrl.item.bonusAmountNewClient ? ($ctrl.item.bonusAmountNewClient ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountGrowth &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountGrowth &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">{{$ctrl.item.bonusAmountGrowth ? ($ctrl.item.bonusAmountGrowth ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountFocus &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountFocus &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">{{$ctrl.item.bonusAmountFocus ? ($ctrl.item.bonusAmountFocus ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountCtl &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountCtl &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">{{$ctrl.item.bonusAmountCtl ? ($ctrl.item.bonusAmountCtl ) : \'N/A\'}}</b><span class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()"> </span></div></md-list-item></md-content></div><div class="ibm-columns" id="generalInfo"></div><div class="ibm-columns search-form"><md-content class="dmt-white-background" layout="column"><span class="calc_so">Sales Order 2 {{$ctrl.item.baseAmount.quickPriceLabel}} {{$ctrl.item.bonusDescription}}</span><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b class="cell" flex="11%">BF Total ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><b class="cell" flex="11%">BF Ratio</b><b class="cell" flex="11%">Amount ({{$ctrl.parent.parent.parent.item.currency}})</b><b class="cell" flex="11%" ng-if="$ctrl.item.baseAmount.isBaseAmount">Uplifted Amount (ZFN4)</b><b class="cell" flex="11%" ng-if="!$ctrl.item.baseAmount.isBaseAmount">Uplift {{$ctrl.item.upliftSo}}% ({{$ctrl.parent.parent.parent.item.currency}})<span ng-if="$ctrl.item.autoUpliftSo===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.upliftSoComments)}}"></md-icon></span></b><b class="cell" flex="11%">Available Amount ({{$ctrl.topic.temp.calculation.forecasts.currency}})</b><b class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_4 ? \'SSA\' : \'CVR SSA\'}}<p>{{$ctrl.item.bonus!==undefined ? \'Bonus \' + ($ctrl.item.bonus ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSSAComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSSAComment)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_4 ? \'Engagement\' : \'CVR Solution\'}}<p>{{$ctrl.item.bonusSolution!==undefined ? \'Bonus \' + ($ctrl.item.bonusSolution ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusSolutionComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusSolutionComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSolutionComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSolutionComment)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.topic.checksData.uiVersion &lt; $ctrl.OPP_VERSION_4">CVR New Client <p>{{$ctrl.item.bonusNewClient!==undefined ? \'Bonus \' + ($ctrl.item.bonusNewClient ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusNewClientComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusNewClientComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()">Growth <p>{{$ctrl.item.bonusGrowth!==undefined ? \'Bonus \' + ($ctrl.item.bonusGrowth ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusGrowthComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusGrowthComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()">Focus<p>{{$ctrl.item.bonusFocus!==undefined ? \'Bonus \' + ($ctrl.item.bonusFocus ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusFocusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusFocusComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()">CTL<p>{{$ctrl.item.bonusCtl!==undefined ? \'Bonus \' + ($ctrl.item.bonusCtl ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusCtlComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusCtlComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast()"> </b></div><md-divider flex="flex"></md-divider></md-list-item><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><span class="cell" flex="11%">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_3 ? $ctrl.topic.temp.calculation.dealRegistrationProductGroups[$ctrl.parent.parent.item.drpgId].amount : $ctrl.topic.temp.calculation.brandFamilies[$ctrl.parent.parent.item.brandCode].amount }}</span><span class="cell" flex="11%">{{$ctrl.item.ratio }}</span><!--Amount--><span class="cell" flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" type="number" ng-pattern="/^[0-9]+(.[0-9]{1,2})?$/" step="0.01" title="input" ng-model="$ctrl.item.amountLC" required="required" ng-change="$ctrl.updateAmount()"/></md-input-container></span><!--Uplifted Amount--><span class="cell" flex="11%" ng-if="!$ctrl.item.baseAmount.isBaseAmount">{{$ctrl.item.upliftAmountSo }}</span><span class="cell" flex="11%" ng-if="$ctrl.item.baseAmount.isBaseAmount"><md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" name="ZFN4" title="input" ng-model="$ctrl.item.baseAmount.amount" required="required" ng-change="$ctrl.changeBaseAmount($ctrl.item.baseAmount.amount)"/></md-input-container></span><!--Available Amount        --><span class="cell" flex="11%">{{$ctrl.item.upliftAmountSoGppCrncy }}</span><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmount &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmount &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedBySo()">{{$ctrl.item.bonusAmount ? ($ctrl.item.bonusAmount ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountSolution &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountSolution &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedBySo()">{{$ctrl.item.bonusAmountSolution ? ($ctrl.item.bonusAmountSolution ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountNewClient &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountNewClient &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.topic.checksData.uiVersion &lt;= $ctrl.OPP_VERSION_3">{{$ctrl.item.bonusAmountNewClient ? ($ctrl.item.bonusAmountNewClient ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountGrowth &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountGrowth &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; ($ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4)">{{$ctrl.item.bonusAmountGrowth ? ($ctrl.item.bonusAmountGrowth ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountFocus &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountFocus &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; ($ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4)">{{$ctrl.item.bonusAmountFocus ? ($ctrl.item.bonusAmountFocus ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountCtl &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountCtl &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; ($ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4)">{{$ctrl.item.bonusAmountCtl ? ($ctrl.item.bonusAmountCtl ) : \'N/A\'}}</b><span class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast()"> </span></div></md-list-item><span class="ibm-btn-row ibm-light"><button class="ibm-btn-pri ibm-btn-blue-50" type="button" ng-if="!$ctrl.item.baseAmount.isBaseAmount" ng-click="$ctrl.changeUplift()">Change Uplift</button><button class="ibm-btn-pri ibm-btn-blue-50" type="button" ng-click="$ctrl.changeBonus()">Change Bonus</button></span></md-content></div><div class="ibm-columns" id="generalInfo"></div><div class="ibm-columns search-form" ng-if="$ctrl.item.ctlSo"><md-content class="dmt-white-background" layout="column"><span class="calc_so">Sales Order {{$ctrl.item.ctlSo.baseAmount.quickPriceLabel}} {{$ctrl.item.ctlSo.bonusDescription}}</span><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b class="cell" flex="11%">BF Total ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><b class="cell" flex="11%">BF Ratio</b><b class="cell" flex="11%">Amount ({{$ctrl.parent.parent.parent.item.currency}})</b><b class="cell" flex="11%" ng-if="$ctrl.item.ctlSo.baseAmount.isBaseAmount">Uplifted Amount (ZFN4)</b><b class="cell" flex="11%" ng-if="!$ctrl.item.ctlSo.baseAmount.isBaseAmount">Uplift {{$ctrl.item.ctlSo.upliftSo}}% ({{$ctrl.parent.parent.parent.item.currency}})<span ng-if="$ctrl.item.ctlSo.autoUpliftSo===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.upliftSoComments)}}"></md-icon></span></b><b class="cell" flex="11%">Available Amount ({{$ctrl.topic.temp.calculation.forecasts.currency}})</b><b class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_4 ? \'SSA\' : \'CVR SSA\'}}<p>{{$ctrl.item.ctlSo.bonus!==undefined ? \'Bonus \' + ($ctrl.item.ctlSo.bonus ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.ctlSo.bonusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.bonusComments)}}"></md-icon></span><span ng-if="$ctrl.item.ctlSo.capSSAComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.capSSAComment)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_4 ? \'Engagement\' : \'CVR Solution\'}}<p>{{$ctrl.item.ctlSo.bonusSolution!==undefined ? \'Bonus \' + ($ctrl.item.ctlSo.bonusSolution ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.ctlSo.bonusSolutionComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.bonusSolutionComments)}}"></md-icon></span><span ng-if="$ctrl.item.ctlSo.capSolutionComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.capSolutionComment)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.topic.checksData.uiVersion &lt; $ctrl.OPP_VERSION_4">CVR New Client <p>{{$ctrl.item.ctlSo.bonusNewClient!==undefined ? \'Bonus \' + ($ctrl.item.ctlSo.bonusNewClient ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.ctlSo.bonusNewClientComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.bonusNewClientComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()">Growth <p>{{$ctrl.item.ctlSo.bonusGrowth!==undefined ? \'Bonus \' + ($ctrl.item.ctlSo.bonusGrowth ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.ctlSo.bonusGrowthComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.bonusGrowthComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()">Focus<p>{{$ctrl.item.ctlSo.bonusFocus!==undefined ? \'Bonus \' + ($ctrl.item.ctlSo.bonusFocus ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.ctlSo.bonusFocusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.bonusFocusComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()">CTL<p>{{$ctrl.item.ctlSo.bonusCtl!==undefined ? \'Bonus \' + ($ctrl.item.ctlSo.bonusCtl ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.ctlSo.bonusCtlComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.bonusCtlComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast()"> </b></div><md-divider flex="flex"></md-divider></md-list-item><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><span class="cell" flex="11%">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_3 ? $ctrl.topic.temp.calculation.dealRegistrationProductGroups[$ctrl.parent.parent.item.drpgId].amount : $ctrl.topic.temp.calculation.brandFamilies[$ctrl.parent.parent.item.brandCode].amount }}</span><span class="cell" flex="11%">{{$ctrl.item.ctlSo.ratio }}</span><span class="cell" flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" type="number" ng-pattern="/^[0-9]+(.[0-9]{1,2})?$/" step="0.01" title="input" ng-model="$ctrl.item.ctlSo.amountLC" required="required" ng-change="$ctrl.updateAmount(\'ctlSo\')"/></md-input-container></span><!--Uplifted Amount--><span class="cell" flex="11%" ng-if="!$ctrl.item.ctlSo.baseAmount.isBaseAmount">{{$ctrl.item.ctlSo.upliftAmountSo }}</span><span class="cell" flex="11%" ng-if="$ctrl.item.ctlSo.baseAmount.isBaseAmount"><md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" name="ZFN4" title="input" ng-model="$ctrl.item.ctlSo.baseAmount.amount" required="required" ng-change="$ctrl.changeBaseAmount($ctrl.item.ctlSo.baseAmount.amount)"/></md-input-container></span><!--Available Amount CTL SO--><span class="cell" flex="11%">{{$ctrl.item.ctlSo.upliftAmountSoGppCrncy }}</span><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.ctlSo.bonusAmount &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.ctlSo.bonusAmount &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedBySo()">{{$ctrl.item.ctlSo.bonusAmount ? ($ctrl.item.ctlSo.bonusAmount ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.ctlSo.bonusAmountSolution &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.ctlSo.bonusAmountSolution &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedBySo()">{{$ctrl.item.ctlSo.bonusAmountSolution ? ($ctrl.item.ctlSo.bonusAmountSolution ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.ctlSo.bonusAmountNewClient &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.ctlSo.bonusAmountNewClient &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.topic.checksData.uiVersion &lt;= $ctrl.OPP_VERSION_3">{{$ctrl.item.ctlSo.bonusAmountNewClient ? ($ctrl.item.ctlSo.bonusAmountNewClient ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.ctlSo.bonusAmountGrowth &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.ctlSo.bonusAmountGrowth &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; ($ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4)">{{$ctrl.item.ctlSo.bonusAmountGrowth ? ($ctrl.item.ctlSo.bonusAmountGrowth ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.ctlSo.bonusAmountFocus &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.ctlSo.bonusAmountFocus &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; ($ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4)">{{$ctrl.item.ctlSo.bonusAmountFocus ? ($ctrl.item.ctlSo.bonusAmountFocus ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.ctlSo.bonusAmountCtl &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.ctlSo.bonusAmountCtl &lt; 0 }" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; ($ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4)">{{$ctrl.item.ctlSo.bonusAmountCtl ? ($ctrl.item.ctlSo.bonusAmountCtl ) : \'N/A\'}}</b><span class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast()"> </span></div></md-list-item><span class="ibm-btn-row ibm-light"><button class="ibm-btn-pri ibm-btn-blue-50" type="button" ng-if="!$ctrl.item.ctlSo.baseAmount.isBaseAmount" ng-click="$ctrl.changeUplift(\'ctlSo\')">Change Uplift</button><button class="ibm-btn-pri ibm-btn-blue-50" type="button" ng-click="$ctrl.changeBonus(\'ctlSo\')">Change Bonus</button></span></md-content></div></div><span ng-repeat="item in $ctrl.item.children"><detail-tree-edit-v2-section item="item" caller="$ctrl.caller" level="$ctrl.level+1" parent="$ctrl"></detail-tree-edit-v2-section></span></div></div></span>');
$templateCache.put('detail-tree-edit.html','<div class="ibm-columns" id="generalInfo"></div><span ng-click="$ctrl.toggle()"> <md-icon ng-hide="$ctrl.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><!--span.ibm-bold &nbsp;{{$ctrl.settings.calculationTreeLevels[$ctrl.level]}}:&nbsp;--></span><md-input-container flex="flex" style="padding:0; margin:0"><input class="cell" ng-model="$ctrl.item.id" style="min-width:100px; border: solid 1px lightgray" required="required" aria-label="$ctrl.settings.calculationTreeLevels[$ctrl.level]" ng-change="$ctrl.updateVal()" placeholder="{{::$ctrl.settings.calculationTreeLevels[$ctrl.level]}}"/></md-input-container><span ng-if="$ctrl.item.error!==\'\'"><md-icon class="red_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.error)}}"></md-icon><input class="cell" title="input" name="error" required="required" hidden="hidden" ng-model="$ctrl.error" style="border: solid 1px lightgray"/></span><span class="ibm-btn-row ibm-light" ng-if="$ctrl.level&lt;4"><span ng-click="$ctrl.addChild()"><md-icon md-svg-src="/public/images/ic_add_box_black_24px.svg"></md-icon></span></span><span ng-click="$ctrl.remove()" ng-if="$ctrl.level&gt;0"><md-icon md-svg-src="/public/images/ic_indeterminate_check_box_black_24px.svg"></md-icon></span><span ng-hide="!$ctrl.visible"><div class="ibm-columns"><div class="thirty-right"><span></span><div ng-if="$ctrl.caller===\'payment\' &amp;&amp; $ctrl.level===4"><div class="ibm-columns" id="generalInfo"></div><div class="ibm-columns search-form"><md-content class="dmt-white-background" layout="column"><span class="calc_gpp">Opportunity Forecast</span><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b class="cell" flex="11%">Forecast ({{$ctrl.topic.temp.calculation.forecasts.currency}})</b><b class="cell" flex="11%">Uplift {{$ctrl.item.uplift}}%<span ng-if="$ctrl.item.autoUplift===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.upliftComments)}}"></md-icon></span></b><b class="cell" flex="11%">Already paid ({{$ctrl.topic.temp.calculation.forecasts.currency}})</b><b class="cell" flex="11%">BF Available Amount ({{$ctrl.topic.temp.calculation.forecasts.currency}})</b><b class="cell" flex="11%">Item Available Amount ({{$ctrl.topic.temp.calculation.forecasts.currency}})</b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\'">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_4 ? \'SSA\' : \'CVR SSA\'}}<p>{{$ctrl.item.bonus!==undefined ? \'Bonus \' + ($ctrl.item.bonus ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSSAComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSSAComment)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\'">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_4 ? \'Engagement\' : \'CVR Solution\'}}<p>{{$ctrl.item.bonusSolution!==undefined ? \'Bonus \' + ($ctrl.item.bonusSolution ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusSolutionComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusSolutionComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSolutionComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSolutionComment)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &lt; $ctrl.OPP_VERSION_4">CVR New Client <p>{{$ctrl.item.bonusNewClient!==undefined ? \'Bonus \' + ($ctrl.item.bonusNewClient ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusNewClientComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusNewClientComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">Growth<p>{{$ctrl.item.bonusGrowth!==undefined ? \'Bonus \' + ($ctrl.item.bonusGrowth ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusGrowthComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusGrowthComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">Focus<p>{{$ctrl.item.bonusFocus!==undefined ? \'Bonus \' + ($ctrl.item.bonusFocus ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusFocusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusFocusComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">CTL<p>{{$ctrl.item.bonusCtl!==undefined ? \'Bonus \' + ($ctrl.item.bonusCtl ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusCtlComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusCtlComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\'"> </b></div><md-divider flex="flex"></md-divider></md-list-item><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><span class="cell" flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" type="number" ng-pattern="/^[0-9]+(.[0-9]{1,2})?$/" step="0.01" title="input" ng-model="$ctrl.topic.temp.calculation.forecasts[$ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_3 ? $ctrl.parent.parent.item.drpgId : $ctrl.parent.parent.item.brandCode].value" required="required" ng-change="$ctrl.changeForecast()"/></md-input-container><span ng-if="$ctrl.topic.temp.calculation.forecasts[$ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_3 ? $ctrl.parent.parent.item.drpgId : $ctrl.parent.parent.item.brandCode].auto===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="Manually set by user."></md-icon></span></span><span class="cell" flex="11%">{{$ctrl.item.upliftAmount }}</span><span class="cell" flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" type="number" ng-pattern="/^[0-9]+(.[0-9]{1,2})?$/" step="0.01" title="input" ng-model="$ctrl.topic.temp.calculation.payed[$ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_3 ? $ctrl.parent.parent.item.drpgId : $ctrl.parent.parent.item.brandCode].value" required="required" ng-change="$ctrl.changePayed()"/></md-input-container><span ng-if="$ctrl.topic.temp.calculation.payed[$ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_3 ? $ctrl.parent.parent.item.drpgId : $ctrl.parent.parent.item.brandCode].auto===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="Manually set by user."></md-icon></span></span><span class="cell" flex="11%">{{$ctrl.item.availableAmount }}</span><span class="cell" flex="11%">{{$ctrl.item.itemAvailableAmount }}</span><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmount &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmount &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\'">{{$ctrl.item.bonusAmount ? ($ctrl.item.bonusAmount ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountSolution &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountSolution &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\'">{{$ctrl.item.bonusAmountSolution ? ($ctrl.item.bonusAmountSolution ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountNewClient &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountNewClient &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &lt;= $ctrl.OPP_VERSION_3">{{$ctrl.item.bonusAmountNewClient ? ($ctrl.item.bonusAmountNewClient ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountGrowth &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountGrowth &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">{{$ctrl.item.bonusAmountGrowth ? ($ctrl.item.bonusAmountGrowth ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountFocus &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountFocus &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">{{$ctrl.item.bonusAmountFocus ? ($ctrl.item.bonusAmountFocus ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountCtl &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountCtl &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">{{$ctrl.item.bonusAmountCtl ? ($ctrl.item.bonusAmountCtl ) : \'N/A\'}}</b><span class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\'"> </span></div></md-list-item></md-content></div><div class="ibm-columns" id="generalInfo"></div><div class="ibm-columns search-form"><md-content class="dmt-white-background" layout="column"><span class="calc_so">Sales Order {{$ctrl.item.baseAmount.quickPriceLabel}}</span><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b class="cell" flex="11%">BF Total ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><b class="cell" flex="11%">BF Ratio</b><b class="cell" flex="11%">Amount ({{$ctrl.parent.parent.parent.item.currency}})</b><b class="cell" flex="11%" ng-if="$ctrl.item.baseAmount.isBaseAmount">Uplifted Amount (ZFN4)</b><b class="cell" flex="11%" ng-if="!$ctrl.item.baseAmount.isBaseAmount">Uplift {{$ctrl.item.upliftSo}}% ({{$ctrl.parent.parent.parent.item.currency}})<span ng-if="$ctrl.item.autoUpliftSo===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.upliftSoComments)}}"></md-icon></span></b><b class="cell" flex="11%">Available Amount ({{$ctrl.topic.temp.calculation.forecasts.currency}})</b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\'">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_4 ? \'SSA\' : \'CVR SSA\'}}<p>{{$ctrl.item.bonus!==undefined ? \'Bonus \' + ($ctrl.item.bonus ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSSAComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSSAComment)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\'">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_4 ? \'Engagement\' : \'CVR Solution\'}}<p>{{$ctrl.item.bonusSolution!==undefined ? \'Bonus \' + ($ctrl.item.bonusSolution ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusSolutionComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusSolutionComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSolutionComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSolutionComment)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; $ctrl.topic.checksData.uiVersion &lt; $ctrl.OPP_VERSION_4">CVR New Client <p>{{$ctrl.item.bonusNewClient!==undefined ? \'Bonus \' + ($ctrl.item.bonusNewClient ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusNewClientComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusNewClientComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">Growth <p>{{$ctrl.item.bonusGrowth!==undefined ? \'Bonus \' + ($ctrl.item.bonusGrowth ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusGrowthComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusGrowthComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">Focus<p>{{$ctrl.item.bonusFocus!==undefined ? \'Bonus \' + ($ctrl.item.bonusFocus ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusFocusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusFocusComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">CTL<p>{{$ctrl.item.bonusCtl!==undefined ? \'Bonus \' + ($ctrl.item.bonusCtl ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusCtlComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusCtlComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\'"> </b></div><md-divider flex="flex"></md-divider></md-list-item><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><span class="cell" flex="11%">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_3 ? $ctrl.topic.temp.calculation.dealRegistrationProductGroups[$ctrl.parent.parent.item.drpgId].amount : $ctrl.topic.temp.calculation.brandFamilies[$ctrl.parent.parent.item.brandCode].amount }}</span><span class="cell" flex="11%">{{$ctrl.item.ratio }}</span><span class="cell" flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" type="number" ng-pattern="/^[0-9]+(.[0-9]{1,2})?$/" step="0.01" title="input" ng-model="$ctrl.item.amountLC" required="required" ng-change="$ctrl.updateAmount()"/></md-input-container></span><span class="cell" flex="11%" ng-if="!$ctrl.item.baseAmount.isBaseAmount">{{$ctrl.item.upliftAmountSo }}</span><span class="cell" flex="11%" ng-if="$ctrl.item.baseAmount.isBaseAmount"><md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" name="ZFN4" title="input" ng-model="$ctrl.item.baseAmount.amount" required="required" ng-change="$ctrl.changeBaseAmount($ctrl.item.baseAmount.amount)"/></md-input-container></span><span class="cell" flex="11%">{{$ctrl.item.upliftAmountSoGppCrncy }}</span><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmount &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmount &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'so\'">{{$ctrl.item.bonusAmount ? ($ctrl.item.bonusAmount ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountSolution &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountSolution &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'so\'">{{$ctrl.item.bonusAmountSolution ? ($ctrl.item.bonusAmountSolution ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountNewClient &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountNewClient &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; $ctrl.topic.checksData.uiVersion &lt;= $ctrl.OPP_VERSION_3">{{$ctrl.item.bonusAmountNewClient ? ($ctrl.item.bonusAmountNewClient ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountGrowth &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountGrowth &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; ($ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4)">{{$ctrl.item.bonusAmountGrowth ? ($ctrl.item.bonusAmountGrowth ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountFocus &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountFocus &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; ($ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4)">{{$ctrl.item.bonusAmountFocus ? ($ctrl.item.bonusAmountFocus ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountCtl &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountCtl &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; ($ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4)">{{$ctrl.item.bonusAmountCtl ? ($ctrl.item.bonusAmountCtl ) : \'N/A\'}}</b><span class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\'"> </span></div></md-list-item><span class="ibm-btn-row ibm-light"><button class="ibm-btn-pri ibm-btn-blue-50" type="button" ng-if="!$ctrl.item.baseAmount.isBaseAmount" ng-click="$ctrl.changeUplift()">Change Uplift</button><button class="ibm-btn-pri ibm-btn-blue-50" type="button" ng-click="$ctrl.changeBonus()">Change Bonus</button></span></md-content></div></div><span ng-repeat="item in $ctrl.item.children"><detail-tree-edit-section item="item" caller="$ctrl.caller" level="$ctrl.level+1" parent="$ctrl"></detail-tree-edit-section></span></div></div></span>');
$templateCache.put('detail-tree-v2.html','<div class="ibm-columns" id="generalInfo"></div><span ng-click="$ctrl.toggle()"> <md-icon ng-hide="$ctrl.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><b class="ibm-textcolor-blue-50">{{$ctrl.item.id}}</b></span><span ng-if="$ctrl.item.error!==\'\'"><md-icon class="red_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.error)}}"></md-icon></span><span ng-hide="!$ctrl.visible"><div class="ibm-columns"><div class="thirty-right"><div ng-if="$ctrl.isAvailable()"><div class="ibm-columns" id="genInfo"></div><div class="ibm-columns search-form"><md-content class="dmt-white-background" layout="column" ng-init="currency = $ctrl.getCurrency();">  <!-- TITLE--><span class="calc_gpp">Opportunity Forecast</span><!-- HEADER--><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b class="cell" flex="11%">Forecast ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><b class="cell" flex="11%">Uplift {{$ctrl.item.uplift }}%<span ng-if="$ctrl.item.autoUplift===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.upliftComments)}}"></md-icon></span></b><b class="cell" flex="11%">Already paid ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><b class="cell" flex="11%">BF Available Amount ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><b class="cell" flex="11%">Item Available Amount ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><div class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast()"> <b>{{$ctrl.isVer4AndMore() ? \'SSA\' : \'CVR SSA\'}}</b><br/><span bonus-percentage="$ctrl.item.bonus" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.bonusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSSAComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSSAComment)}}"></md-icon></span></div><div class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast()"> <b>{{$ctrl.isVer4AndMore() ? \'Engagement\' : \'CVR Solution\'}}</b><br/><span bonus-percentage="$ctrl.item.bonusSolution" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.bonusSolutionComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusSolutionComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSolutionComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSolutionComment)}}"></md-icon></span></div><div class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.isVerLess4()"><b>CVR New Client </b><br/><span bonus-percentage="$ctrl.item.bonusNewClient" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.bonusNewClientComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusNewClientComments)}}"></md-icon></span></div><div class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.isVer4AndMore()"><b>Growth</b><br/><span bonus-percentage="$ctrl.item.bonusGrowth" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.bonusGrowthComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusGrowthComments)}}"></md-icon></span></div><div class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.isVer4AndMore()"><b>Focus </b><br/><span bonus-percentage="$ctrl.item.bonusFocus" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.bonusFocusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusFocusComments)}}"></md-icon></span></div><div class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.isVer4AndMore()"><b>CTL </b><br/><span bonus-percentage="$ctrl.item.bonusCtl" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.bonusCtlComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusCtlComments)}}"></md-icon></span></div><b class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()"> </b></div><md-divider flex="flex"></md-divider></md-list-item><!-- BODY--><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><span class="cell" flex="11%">{{$ctrl.getTotalForecastAmount() }}<span ng-if="$ctrl.isNotAutoForecasts()"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="Manually set by user."></md-icon></span></span><span class="cell" flex="11%">{{$ctrl.item.upliftAmount }}</span><span class="cell" flex="11%">{{$ctrl.getAlreadyPaidAmount()}}<span ng-if="$ctrl.isNotAutoPayed()"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="Manually set by user."></md-icon></span></span><span class="cell" flex="11%">{{$ctrl.item.availableAmount }}</span><span class="cell" flex="11%">{{$ctrl.item.itemAvailableAmount }}</span><div class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast()"><span bonus-amount="$ctrl.item.bonusAmount"></span></div><div class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast()"><span bonus-amount="$ctrl.item.bonusAmountSolution"></span></div><div class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.isVerLess4()"><span bonus-amount="$ctrl.item.bonusAmountNewClient"></span></div><div class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.isVer4AndMore()"><span bonus-amount="$ctrl.item.bonusAmountGrowth"></span></div><div class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.isVer4AndMore()"><span bonus-amount="$ctrl.item.bonusAmountFocus"></span></div><div class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast() &amp;&amp; $ctrl.isVer4AndMore()"><span bonus-amount="$ctrl.item.bonusAmountCtl"></span></div><span class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()"> </span></div></md-list-item></md-content></div><div class="ibm-columns" id="genInfo"></div><div class="ibm-columns search-form"><md-content class="dmt-white-background" layout="column" ng-init="currency = $ctrl.getCurrency();"><!-- TITLE--><span class="calc_so">Sales Order {{$ctrl.item.baseAmount.quickPriceLabel}} {{$ctrl.item.bonusDescription}}</span><!-- HEADER--><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b class="cell" flex="11%">BF Total ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><b class="cell" flex="11%">BF Ratio</b><b class="cell" flex="11%">Amount ({{$ctrl.parent.parent.parent.item.currency}})</b><!--header uplifted Amount Header--><b class="cell" flex="11%">{{$ctrl.getUpliftedAmountHeader()}}<span ng-if="$ctrl.item.autoUpliftSo===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.upliftSoComments)}}"></md-icon></span></b><b class="cell" flex="11%">Available Amount ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><!--bonus header - SSA (bonus)--><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()"><b>{{$ctrl.isVer4AndMore() ? \'SSA\' : \'CVR SSA\'}}</b><br/><span bonus-percentage="$ctrl.item.bonus" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.bonusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSSAComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSSAComment)}}"></md-icon></span></div><!--bonus header - Engagement--><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()"> <b>{{$ctrl.isVer4AndMore() ? \'Engagement\' : \'CVR Solution\'}}</b><br/><span bonus-percentage="$ctrl.item.bonusSolution" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.bonusSolutionComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusSolutionComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSolutionComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSolutionComment)}}"></md-icon></span></div><!--bonus header - CVR New Client --><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVerLess4()"><b>CVR New Client</b><br/><span bonus-percentage="$ctrl.item.bonusNewClient" currency="{{currency}}"> </span><br/><span ng-if="$ctrl.item.bonusNewClientComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusNewClientComments)}}"></md-icon></span></div><!--bonus header - Growth        --><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()"><b>Growth</b><br/><span bonus-percentage="$ctrl.item.bonusGrowth" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.bonusGrowthComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusGrowthComments)}}"></md-icon></span></div><!--bonus header - Focus --><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()"><b>Focus</b><br/><span bonus-percentage="$ctrl.item.bonusFocus" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.bonusFocusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusFocusComments)}}"></md-icon></span></div><!--bonus header - CTL--><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()"><b>CTL</b><br/><span bonus-percentage="$ctrl.item.bonusCtl" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.bonusCtlComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusCtlComments)}}"></md-icon></span></div><b class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast()"> </b></div><md-divider flex="flex"></md-divider></md-list-item><!-- BODY--><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><span class="cell" flex="11%">{{$ctrl.getTotalAmount()}}</span><span class="cell" flex="11%">{{$ctrl.item.ratio }}</span><!--Amount--><span class="cell" flex="11%">{{$ctrl.item.amountLC }}</span><!--Uplifted Amount--><span class="cell" flex="11%" ng-if="!$ctrl.item.baseAmount.isBaseAmount">{{$ctrl.item.upliftAmountSo }}</span><span class="cell" flex="11%" ng-if="$ctrl.item.baseAmount.isBaseAmount">{{$ctrl.item.baseAmount.amount}}</span><!--Available Amount--><span class="cell" flex="11%">{{$ctrl.item.upliftAmountSoGppCrncy }}</span><!--bonus amount - bonus--><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()"><span bonus-amount="$ctrl.item.bonusAmount"></span></div><!--bonus amount - incentives: Solution--><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()"><span bonus-amount="$ctrl.item.bonusAmountSolution"></span></div><!--bonus amount - incentives: NewClient    --><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVerLess4()"><span bonus-amount="$ctrl.item.bonusAmountNewClient"></span></div><!--bonus amount - incentives: Growth                                    --><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()"><span bonus-amount="$ctrl.item.bonusAmountGrowth"></span></div><!--bonus amount - incentives: Focus--><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()"><span bonus-amount="$ctrl.item.bonusAmountFocus"></span></div><!--bonus amount - incentives: Ctl--><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()"><span bonus-amount="$ctrl.item.bonusAmountCtl"></span></div><!----><span class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast()"> </span></div></md-list-item></md-content></div><div class="ibm-columns" id="genInfo"></div><div class="ibm-columns search-form" ng-if="$ctrl.item.ctlSo"><md-content class="dmt-white-background" layout="column" ng-init="currency = $ctrl.getCurrency();"><!-- TITLE - CTL SO--><span class="calc_so">Sales Order {{$ctrl.item.ctlSo.baseAmount.quickPriceLabel}} {{$ctrl.item.ctlSo.bonusDescription}}</span><!-- HEADER--><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b class="cell" flex="11%">BF Total ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><b class="cell" flex="11%">BF Ratio</b><b class="cell" flex="11%">Amount ({{$ctrl.parent.parent.parent.item.currency}})</b><!--header uplifted Amount Header--><b class="cell" flex="11%">{{$ctrl.getUpliftedAmountHeader(\'ctlSo\')}}<span ng-if="$ctrl.item.ctlSo.autoUpliftSo===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.upliftSoComments)}}"></md-icon></span></b><b class="cell" flex="11%">Available Amount ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><!--bonus header - SSA (bonus)--><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()"><b>{{$ctrl.isVer4AndMore() ? \'SSA\' : \'CVR SSA\'}}</b><br/><span bonus-percentage="$ctrl.item.ctlSo.bonus" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.ctlSo.bonusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.bonusComments)}}"></md-icon></span><span ng-if="$ctrl.item.ctlSo.capSSAComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.capSSAComment)}}"></md-icon></span></div><!--bonus header - Engagement--><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()"> <b>{{$ctrl.isVer4AndMore() ? \'Engagement\' : \'CVR Solution\'}}</b><br/><span bonus-percentage="$ctrl.item.ctlSo.bonusSolution" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.ctlSo.bonusSolutionComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.bonusSolutionComments)}}"></md-icon></span><span ng-if="$ctrl.item.ctlSo.capSolutionComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.capSolutionComment)}}"></md-icon></span></div><!--bonus header - CVR New Client --><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVerLess4()"><b>CVR New Client</b><br/><span bonus-percentage="$ctrl.item.ctlSo.bonusNewClient" currency="{{currency}}"> </span><br/><span ng-if="$ctrl.item.ctlSo.bonusNewClientComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.bonusNewClientComments)}}"></md-icon></span></div><!--bonus header - Growth        --><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()"><b>Growth</b><br/><span bonus-percentage="$ctrl.item.ctlSo.bonusGrowth" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.ctlSo.bonusGrowthComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.bonusGrowthComments)}}"></md-icon></span></div><!--bonus header - Focus --><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()"><b>Focus</b><br/><span bonus-percentage="$ctrl.item.ctlSo.bonusFocus" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.ctlSo.bonusFocusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.bonusFocusComments)}}"></md-icon></span></div><!--bonus header - CTL--><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()"><b>CTL</b><br/><span bonus-percentage="$ctrl.item.ctlSo.bonusCtl" currency="{{currency}}"></span><br/><span ng-if="$ctrl.item.ctlSo.bonusCtlComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.ctlSo.bonusCtlComments)}}"></md-icon></span></div><b class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast()"> </b></div><md-divider flex="flex"></md-divider></md-list-item><!-- BODY--><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><span class="cell" flex="11%">{{$ctrl.getTotalAmount()}}</span><span class="cell" flex="11%">{{$ctrl.item.ctlSo.ratio }}</span><!--Amount--><span class="cell" flex="11%">{{$ctrl.item.ctlSo.amountLC }}</span><!--Uplifted Amount--><span class="cell" flex="11%" ng-if="!$ctrl.item.ctlSo.baseAmount.isBaseAmount">{{$ctrl.item.ctlSo.upliftAmountSo }}</span><span class="cell" flex="11%" ng-if="$ctrl.item.ctlSo.baseAmount.isBaseAmount">{{$ctrl.item.ctlSo.baseAmount.amount}}</span><!--Available Amount--><span class="cell" flex="11%">{{$ctrl.item.ctlSo.upliftAmountSoGppCrncy }}</span><!--bonus amount - bonus--><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()"><span bonus-amount="$ctrl.item.ctlSo.bonusAmount"></span></div><!--bonus amount - incentives: Solution--><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo()"><span bonus-amount="$ctrl.item.ctlSo.bonusAmountSolution"></span></div><!--bonus amount - incentives: NewClient    --><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVerLess4()"><span bonus-amount="$ctrl.item.ctlSo.bonusAmountNewClient"></span></div><!--bonus amount - incentives: Growth                                    --><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()"><span bonus-amount="$ctrl.item.ctlSo.bonusAmountGrowth"></span></div><!--bonus amount - incentives: Focus--><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()"><span bonus-amount="$ctrl.item.ctlSo.bonusAmountFocus"></span></div><!--bonus amount - incentives: Ctl--><div class="cell" flex="11%" ng-if="$ctrl.isPayedBySo() &amp;&amp; $ctrl.isVer4AndMore()"><span bonus-amount="$ctrl.item.ctlSo.bonusAmountCtl"></span></div><!----><span class="cell" flex="11%" ng-if="$ctrl.isPayedByForecast()"> </span></div></md-list-item></md-content></div></div><span ng-repeat="item in $ctrl.item.children"><detail-tree-v2-section item="item" caller="$ctrl.caller" level="$ctrl.level+1" parent="$ctrl"></detail-tree-v2-section></span></div></div></span>');
$templateCache.put('detail-tree.html','<div class="ibm-columns" id="generalInfo"></div><span ng-click="$ctrl.toggle()"> <md-icon ng-hide="$ctrl.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><!--span.ibm-bold &nbsp;{{$ctrl.settings.calculationTreeLevels[$ctrl.level]}}:--><b class="ibm-textcolor-blue-50">{{$ctrl.item.id}}</b></span><span ng-if="$ctrl.item.error!==\'\'"><md-icon class="red_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.error)}}"></md-icon></span><span ng-hide="!$ctrl.visible"><div class="ibm-columns"><div class="thirty-right"><div ng-if="$ctrl.caller===\'payment\' &amp;&amp; $ctrl.level===4"><div class="ibm-columns" id="genInfo"></div><div class="ibm-columns search-form"><md-content class="dmt-white-background" layout="column"><span class="calc_gpp">Opportunity Forecast</span><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b class="cell" flex="11%">Forecast ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><b class="cell" flex="11%">Uplift {{$ctrl.item.uplift }}%<span ng-if="$ctrl.item.autoUplift===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.upliftComments)}}"></md-icon></span></b><b class="cell" flex="11%">Already paid ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><b class="cell" flex="11%">BF Available Amount ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><b class="cell" flex="11%">Item Available Amount ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\'">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_4 ? \'SSA\' : \'CVR SSA\'}}<p>{{$ctrl.item.bonus!==undefined ? \'Bonus \' + ($ctrl.item.bonus ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSSAComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSSAComment)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\'">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_4 ? \'Engagement\' : \'CVR Solution\'}}<p>{{$ctrl.item.bonusSolution!==undefined ? \'Bonus \' + ($ctrl.item.bonusSolution ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusSolutionComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusSolutionComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSolutionComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSolutionComment)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &lt; $ctrl.OPP_VERSION_4">CVR New Client <p>{{$ctrl.item.bonusNewClient!==undefined ? \'Bonus \' + ($ctrl.item.bonusNewClient ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusNewClientComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusNewClientComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">Growth<p>{{$ctrl.item.bonusGrowth !==undefined ? \'Bonus \' + ($ctrl.item.bonusGrowth ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusGrowthComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusGrowthComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">Focus <p>{{$ctrl.item.bonusFocus !==undefined ? \'Bonus \' + ($ctrl.item.bonusFocus ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusFocusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusFocusComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">CTL <p>{{$ctrl.item.bonusCtl !==undefined ? \'Bonus \' + ($ctrl.item.bonusCtl ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusCtlComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusCtlComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\'"> </b></div><md-divider flex="flex"></md-divider></md-list-item><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><span class="cell" flex="11%">{{$ctrl.item.bfTotalForecast !== undefined ? $ctrl.item.bfTotalForecast : $ctrl.item.amountLC }}<span ng-if="$ctrl.topic.temp.calculation.forecasts[$ctrl.parent.parent.item.drpgId].auto===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="Manually set by user."></md-icon></span></span><span class="cell" flex="11%">{{$ctrl.item.upliftAmount }}</span><span class="cell" flex="11%">{{$ctrl.topic.topic.calculation.payed[$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_3 ? $ctrl.parent.parent.item.drpgId : ($ctrl.parent.parent.item.brandCode ? $ctrl.parent.parent.item.brandCode : $ctrl.parent.parent.item.id)].value }}<span ng-if="$ctrl.topic.topic.calculation.payed[$ctrl.parent.parent.item.drpgId].auto===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="Manually set by user."></md-icon></span></span><span class="cell" flex="11%">{{$ctrl.item.availableAmount }}</span><span class="cell" flex="11%">{{$ctrl.item.itemAvailableAmount }}</span><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmount &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmount &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\'">{{$ctrl.item.bonusAmount ? ($ctrl.item.bonusAmount ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountSolution &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountSolution &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\'">{{$ctrl.item.bonusAmountSolution ? ($ctrl.item.bonusAmountSolution ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountNewClient &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountNewClient &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &lt; $ctrl.OPP_VERSION_4">{{$ctrl.item.bonusAmountNewClient ? ($ctrl.item.bonusAmountNewClient ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountGrowth &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountGrowth &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">{{$ctrl.item.bonusAmountGrowth ? ($ctrl.item.bonusAmountGrowth ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountFocus &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountFocus &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">{{$ctrl.item.bonusAmountFocus ? ($ctrl.item.bonusAmountFocus ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountCtl &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountCtl &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">{{$ctrl.item.bonusAmountCtl ? ($ctrl.item.bonusAmountCtl ) : \'N/A\'}}</b><span class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\'"> </span></div></md-list-item></md-content></div><div class="ibm-columns" id="genInfo"></div><div class="ibm-columns search-form"><md-content class="dmt-white-background" layout="column"><span class="calc_so">Sales Order {{$ctrl.item.baseAmount.quickPriceLabel}}</span><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b class="cell" flex="11%">BF Total ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><b class="cell" flex="11%">BF Ratio</b><b class="cell" flex="11%">Amount ({{$ctrl.parent.parent.parent.item.currency}})</b><b class="cell" flex="11%" ng-if="$ctrl.item.baseAmount.isBaseAmount">Uplifted Amount (ZFN4)</b><b class="cell" flex="11%" ng-if="!$ctrl.item.baseAmount.isBaseAmount">Uplift {{$ctrl.item.upliftSo}}% ({{$ctrl.parent.parent.parent.item.currency}})<span ng-if="$ctrl.item.autoUpliftSo===false"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.upliftSoComments)}}"></md-icon></span></b><b class="cell" flex="11%">Available Amount ({{$ctrl.topic.topic.calculation.forecasts.currency}})</b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\'">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_4 ? \'SSA\' : \'CVR SSA\'}}<p>{{$ctrl.item.bonus!==undefined ? \'Bonus \' + ($ctrl.item.bonus ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSSAComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSSAComment)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\'">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_4 ? \'Engagement\' : \'CVR Solution\'}}<p>{{$ctrl.item.bonusSolution!==undefined ? \'Bonus \' + ($ctrl.item.bonusSolution ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusSolutionComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusSolutionComments)}}"></md-icon></span><span ng-if="$ctrl.item.capSolutionComment"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.capSolutionComment)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; $ctrl.topic.checksData.uiVersion &lt; $ctrl.OPP_VERSION_4">CVR New Client <p>{{$ctrl.item.bonusNewClient!==undefined ? \'Bonus \' + ($ctrl.item.bonusNewClient ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusNewClientComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusNewClientComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">Growth <p>{{$ctrl.item.bonusGrowth!==undefined ? \'Bonus \' + ($ctrl.item.bonusGrowth ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusGrowthComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusGrowthComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">Focus<p>{{$ctrl.item.bonusFocus!==undefined ? \'Bonus \' + ($ctrl.item.bonusFocus ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusFocusComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusFocusComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">CTL<p>{{$ctrl.item.bonusCtl!==undefined ? \'Bonus \' + ($ctrl.item.bonusCtl ) + \'% (\' + ($ctrl.topic.topic.calculation.goe==="Y"?$ctrl.parent.parent.parent.item.currency:$ctrl.topic.topic.calculation.forecasts.currency)+\')\' : \'N/A\'}}</p><span ng-if="$ctrl.item.bonusCtlComments"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{$ctrl.rbr($ctrl.item.bonusCtlComments)}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\'"> </b></div><md-divider flex="flex"></md-divider></md-list-item><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><span class="cell" flex="11%">{{$ctrl.topic.checksData.uiVersion >= $ctrl.OPP_VERSION_3 ? $ctrl.topic.topic.calculation.dealRegistrationProductGroups[$ctrl.parent.parent.item.drpgId].amount : ($ctrl.topic.topic.calculation.brandFamilies[$ctrl.parent.parent.item.brandCode].amount !== undefined ? $ctrl.topic.topic.calculation.brandFamilies[$ctrl.parent.parent.item.brandCode].amount : $ctrl.topic.topic.calculation.brandFamilies[$ctrl.parent.parent.item.id].amount) }}</span><span class="cell" flex="11%">{{$ctrl.item.ratio }}</span><span class="cell" flex="11%">{{$ctrl.item.amountLC }}</span><span class="cell" flex="11%" ng-if="!$ctrl.item.baseAmount.isBaseAmount">{{$ctrl.item.upliftAmountSo }}</span><span class="cell" flex="11%" ng-if="$ctrl.item.baseAmount.isBaseAmount">{{$ctrl.item.baseAmount.amount}}</span><span class="cell" flex="11%">{{$ctrl.item.upliftAmountSoGppCrncy }}</span><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmount &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmount &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'so\'">{{$ctrl.item.bonusAmount ? ($ctrl.item.bonusAmount ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountSolution &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountSolution &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'so\'">{{$ctrl.item.bonusAmountSolution ? ($ctrl.item.bonusAmountSolution ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountNewClient &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountNewClient &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; $ctrl.topic.checksData.uiVersion &lt; $ctrl.OPP_VERSION_4">{{$ctrl.item.bonusAmountNewClient ? ($ctrl.item.bonusAmountNewClient ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountGrowth &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountGrowth &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">{{$ctrl.item.bonusAmountGrowth ? ($ctrl.item.bonusAmountGrowth ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountFocus &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountFocus &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">{{$ctrl.item.bonusAmountFocus ? ($ctrl.item.bonusAmountFocus ) : \'N/A\'}}</b><b class="cell" ng-class="{\'ibm-textcolor-green-50\': $ctrl.item.bonusAmountCtl &gt;= 0, \'ibm-textcolor-red-50\': $ctrl.item.bonusAmountCtl &lt; 0 }" flex="11%" ng-if="$ctrl.item.payedBy===\'so\' &amp;&amp; $ctrl.topic.checksData.uiVersion &gt;= $ctrl.OPP_VERSION_4">{{$ctrl.item.bonusAmountCtl ? ($ctrl.item.bonusAmountCtl ) : \'N/A\'}}</b><span class="cell" flex="11%" ng-if="$ctrl.item.payedBy===\'forecast\'"> </span></div></md-list-item></md-content></div></div><span ng-repeat="item in $ctrl.item.children"><detail-tree-section item="item" caller="$ctrl.caller" level="$ctrl.level+1" parent="$ctrl"></detail-tree-section></span></div></div></span>');
$templateCache.put('dialog-missing-error.html','<!--author Ivan Toth--><md-dialog aria-label="{{vm.title}}" ng-cloak="ng-cloak"><md-toolbar><div class="md-toolbar-tools"><h2>{{vm.title}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><table class="ibm-data-table ibm-alternate-two" ng-if="vm.table.length &gt; 0" cellspacing="0" cellpadding="0" border="0"><tr><th><span>Missing Elements to be Completed:</span></th></tr><tr ng-repeat="line in vm.table"><td><span ng-bind-html="line.err"></span></td><!--td {{::line.err}}--></tr></table><span ng-if="vm.table.length == 0">All elements appear to be completed</span></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('display-topic-errors.html','<md-dialog aria-label="Disbursement Errors" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Disbursement Errors</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.clickNo()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content style="min-width: 40em"><md-content class="md-padding">This table displays the errors encountered for this Disbursement during its life, some of which may need attention. &nbsp;Please refer to the Details for tips on how to resolve each.<p></p><table class="ibm-data-table ibm-alternate-two" cellspacing="0" cellpadding="0" border="0" width="100%"><tHead><tr><th style="width: 5px"><b>#</b></th><th><b>ID</b></th><th><b>Type</b></th><th> <b>Details</b></th><th> <b>Date</b></th><th> <b>Resolved</b></th><th> <b>Cycle</b></th></tr></tHead><tBody> <tr ng-repeat="err in vm.errs.err"><td style="color: gray">{{$index+1}}</td><td>{{err.id || "-"}}</td><td class="ibm-textcolor-blue-40"><div ng-if="err.checks" ng-repeat="(key, value) in err.checks track by $index"> {{key}}</div><div ng-if="err.type"> {{err.type}}</div></td><td><div ng-if="err.checks" ng-repeat="(key, value) in err.checks track by $index"> {{value}}</div><div ng-if="err.details"> {{err.details}}</div></td><td class="ibm-textcolor-green-40" ng-if="err.resolved">Yes</td><td>{{err.timestamp | date:vm.dateFormat}}</td><td class="ibm-textcolor-red-40" ng-if="!err.resolved">No</td><td>{{err.cycle !== undefined ? err.cycle : "-"}}</td></tr></tBody></table></md-content></md-dialog-content></md-dialog>');
$templateCache.put('dispute-details.html','<style>.desc {\n    border: 1px lightgray solid;\n    border-radius: 10%;\n    margin-left: 3px;\n    padding: 2px 5px 6px 2px;\n    padding-right: 5px;\n    background-color: #fafbb6;\n    color: #e67b7b;\n}</style><span class="desc" style="align-content: center" title="{{$ctrl.disputeDetails}}"><md-icon class="blue_icon" md-svg-src="/public/images/asterisk.svg"></md-icon><span style="margin-left: 2px">{{$ctrl.cdIndicator}}</span></span>');
$templateCache.put('dispute-dialog.html','<!--author Vladislav Sirotkin--><style>.desc {\n    border: 1px lightgray solid;\n    margin-left: 1em;\n    padding: 8px;\n    background-color: white;\n}\n.valRules {\n    display: inline-block; \n    margin: 2px;\n}\n#checks {\n    max-height: 170px;\n}</style><md-dialog aria-label="Create Dispute" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Create Dispute</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="disForm"><md-content class="md-padding"><span class="ibm-textcolor-blue-50">Dispute Type&nbsp;&nbsp;</span><select style="width: 20em" ng-model="vm.disBundle.disputeType" ng-options="o as o.name for o in vm.disBundle.types" ng-change="vm.disBundle.disputeCode = vm.disBundle.disputeCodes[vm.disBundle.disputeType.name][0]"></select><span class="desc"><input type="radio" ng-model="vm.disBundle.Itrtype" value="C"/><span class="ibm-textcolor-blue-50">Credit</span><input style="margin-left: 15px" type="radio" ng-model="vm.disBundle.Itrtype" value="D"/><span class="ibm-textcolor-blue-50">Debit</span></span><p></p><div style="border: 1px solid lightgray; padding: 10px; background-color: white">Description: &nbsp;<span class="ibm-textcolor-blue-40">{{vm.disBundle.disputeType.desc}}</span></div><p></p><span class="ibm-textcolor-blue-50">Dispute Reason Code&nbsp;&nbsp;</span><select style="width: 30em" ng-model="vm.disBundle.disputeCode" ng-options="x as x.code + \' - \' + x.desc for x in vm.disBundle.disputeCodes[vm.disBundle.disputeType.name] | orderBy: x.code" required="required"></select><p ng-if="vm.disBundle.disputeCode.other" style="margin-top: 8px"><span class="ibm-textcolor-blue-50">Other Reason&nbsp;&nbsp;</span><input class="userField" ng-model="vm.disBundle.disputeCode_other" ng-required="vm.disBundle.disputeCode" size="90em" ng-maxlength="128" maxlength="128"/></p><p></p><p><span ng-if="!vm.disBundle.paid">This Disbursement was {{vm.disBundle.currStatus}} whilst in {{[\'A\',\'E\'].indexOf(vm.disBundle.lastStatus.substring(0,1)) > -1 ? \'an\' : \'a\'}}&nbsp;</span><span ng-if="vm.disBundle.paid">This Disbursement is in a&nbsp;</span><b class="ibm-textcolor-blue-50">{{vm.disBundle.lastStatus}}</b>status.<br><span ng-if="vm.disBundle.lastStatus !== \'Eligibility\'">You are therefore permitted to set the new {{vm.disBundle.disputeType.name}}\'s start Status as any up to that.</span><span ng-if="vm.disBundle.lastStatus == \'Eligibility\'">You are therefore only permitted to set the new {{vm.disBundle.disputeType.name}}\'s start Status as such.</span></p><span class="ibm-textcolor-blue-50">Start Status&nbsp;&nbsp;</span><select style="width: 20em; height: 40px;" ng-model="vm.disBundle.status" ng-options="o as o.txt for o in vm.disBundle.statuses" ng-if="vm.disBundle.uiVersion &gt;= 4"></select><select style="width: 20em; height: 40px;" ng-model="vm.disBundle.status" ng-options="o as o.txt for o in vm.disBundle.statuses" ng-if="(!vm.disBundle.uiVersion || vm.disBundle.uiVersion &lt; 4) &amp;&amp; (vm.disBundle.solutionDecision !== \'Solution only\')"></select><select style="width: 20em; height: 40px;" ng-model="vm.disBundle.status" ng-options="o as o.txt for o in vm.disBundle.statuses" ng-if="(!vm.disBundle.uiVersion || vm.disBundle.uiVersion &lt; 4) &amp;&amp; vm.disBundle.solutionDecision === \'Solution only\' &amp;&amp; !(vm.disBundle.CVRType[0].bool || vm.disBundle.CVRType[2].bool)"></select><select style="width: 20em; height: 40px;" ng-disabled="true" ng-if="(!vm.disBundle.uiVersion || vm.disBundle.uiVersion &lt; 4) &amp;&amp; (vm.disBundle.solutionDecision === \'Solution only\' &amp;&amp; (vm.disBundle.CVRType[0].bool || vm.disBundle.CVRType[2].bool))"><option>Eligibility</option></select>&nbsp;&nbsp;<div ng-if="vm.disBundle.status.no === 4"><p></p><span class="ibm-textcolor-blue-50">CVR type&nbsp;&nbsp;</span><span class="desc" style="margin-left: 1.2em;"><div style="display: inline-block" ng-repeat="o in vm.disBundle.CVRType"><input type="checkbox" ng-model="o.bool"/><span class="ibm-textcolor-blue-50">{{vm.disBundle.uiVersion >= 4 && o.name === \'Solution\'?\'Engagement\':o.name}}</span></div></span></div>&nbsp;&nbsp;&nbsp;<div ng-if="(!vm.disBundle.uiVersion || vm.disBundle.uiVersion &lt; 4) &amp;&amp; vm.disBundle.status.no === 4"><span class="ibm-textcolor-blue-50">Include Validation Rules?&nbsp;&nbsp;</span><span class="desc" style="padding: 6px; margin-left: 0"><input ng-disabled="vm.disBundle.isOppyValRejected || (vm.disBundle.solutionDecision === \'Solution only\' &amp;&amp; (vm.disBundle.CVRType[0].bool || vm.disBundle.CVRType[2].bool))" type="radio" name="validationRules" ng-model="vm.disBundle.validationRules" ng-value="true" ng-checked="vm.disBundle.solutionDecision === \'Solution only\' &amp;&amp; !(vm.disBundle.CVRType[0].bool || vm.disBundle.CVRType[2].bool)"/>Yes<input ng-disabled="vm.disBundle.isOppyValRejected || (vm.disBundle.solutionDecision === \'Solution only\' &amp;&amp; (vm.disBundle.CVRType[0].bool || vm.disBundle.CVRType[2].bool))" type="radio" name="validationRules" ng-model="vm.disBundle.validationRules" ng-value="false" ng-checked="vm.disBundle.solutionDecision === \'Solution only\' &amp;&amp; (vm.disBundle.CVRType[0].bool || vm.disBundle.CVRType[2].bool)"/>No</span></div><div ng-if="vm.disBundle.uiVersion &gt;= 4 &amp;&amp; vm.disBundle.status.no === 4"><span class="ibm-textcolor-blue-50">Include Validation Rules?&nbsp;&nbsp;</span><span class="desc" style="padding: 6px; margin-left: 0"><input ng-disabled="vm.disBundle.isOppyValRejected" type="radio" name="validationRules" ng-model="vm.disBundle.validationRules" ng-value="true" ng-checked="vm.disBundle.solutionDecision === \'Solution only\'"/>Yes<input ng-disabled="vm.disBundle.isOppyValRejected" type="radio" name="validationRules" ng-model="vm.disBundle.validationRules" ng-value="false" ng-checked=""/>No</span></div><p></p><p>All sections and their attachments will be copied from the original Disbursement unless stated otherwise. <br/>\nPlease select which {{vm.disBundle.status.txt}} sections you would <b>NOT </b>like to copy to the new {{vm.disBundle.disputeType.name}}.</p><div class="selectbox" id="checks" style="background-color: white"><div ng-if="!vm.disBundle.uiVersion || vm.disBundle.uiVersion &lt; 3"><span ng-repeat="x in vm.disBundle.sections[vm.disBundle.status.no]"><input type="checkbox" ng-model="vm.disBundle.sects2[x.section]"/>{{x.section}} &nbsp;&nbsp;<br/></span></div><div ng-if="vm.disBundle.uiVersion &gt;= 3"><div ng-if="vm.disBundle.status.txt === \'Eligibility\'"><span ng-repeat="(x, value) in vm.disBundle.swdrValidatedSects"><label ng-style="{ \'text-decoration\': value ? \'line-through\' : \'none\' }"><input type="checkbox" ng-model="vm.disBundle.swdrSects[x]" ng-disabled="value"/>{{x}}</label><span ng-if="value" style="color: red">&nbsp; (Missing document in Cloudant)</span><br/></span></div><div ng-if="vm.disBundle.status.txt === \'Validation\'"><span ng-repeat="x in vm.disBundle.sections[4]"><input type="checkbox" ng-model="vm.disBundle.sects2[x.section]"/>{{x.section}} &nbsp;&nbsp;<br/></span></div></div></div><p></p>Should you choose to continue, a new child Disbursement will be created tied to this one.<p></p><md-button class="md-raised md-primary" style="margin-left: 0" ng-click="vm.answer()" ng-disabled="!vm.$scope.disForm.$valid || (!(vm.disBundle.CVRType[0] &amp;&amp; vm.disBundle.CVRType[0].bool) &amp;&amp; !(vm.disBundle.CVRType[1] &amp;&amp; vm.disBundle.CVRType[1].bool) &amp;&amp; !(vm.disBundle.CVRType[2] &amp;&amp; vm.disBundle.CVRType[2].bool) &amp;&amp; !(vm.disBundle.CVRType[3] &amp;&amp; vm.disBundle.CVRType[3].bool) &amp;&amp; !(vm.disBundle.CVRType[4] &amp;&amp; vm.disBundle.CVRType[4].bool))">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('dispute-list.html','<span class="span ibm-textcolor-blue-40" ng-if="!$ctrl.codesLoaded" style="border: 1px solid lightgray; padding: 7px 40px 11px 54px; background-color:white">Retrieving Dispute List...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></span><md-menu-content ng-if="$ctrl.codesLoaded" width="4"><md-menu-item ng-repeat="o in $ctrl.reasonCodes.data"><md-button class="ibm-btn-pri" ng-click="vm.viewDispute($event,o)">{{o}}</md-button></md-menu-item></md-menu-content>');
$templateCache.put('esc-button.html','<span ng-if="!($ctrl.topic.editableComponents[$ctrl.vm.comp].socket || !$ctrl.vm.edit.editable)"><!-- EDIT BUTTON--><span class="ibm-btn-row ibm-button-link" ng-if="!$ctrl.vm.edit.editMode"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50 md-icon-button" ng-click="$ctrl.vm.changeEditMode(\'edit\')" ng-disabled="$ctrl.topic.usFed.status" title="Edit" aria-label="Edit" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;"><md-icon class="white_icon" md-svg-icon="/public/images/lead-pencil.svg"></md-icon></md-button></span><span class="ibm-btn-row ibm-button-link" ng-if="$ctrl.vm.edit.editMode"><span><!-- SAVE BUTTON--><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50 md-icon-button" ng-click="$ctrl.vm.changeEditMode(\'save\', $event)" ng-disabled="($ctrl.vm.comp === \'complcl_sampling\' &amp;&amp; $ctrl.vm.isSamplingFinished) || $ctrl.topic.usFed.status" title="Save" aria-label="Save" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;"><md-icon class="white_icon" md-svg-icon="/public/images/ic_check_black_24px.svg"></md-icon></md-button></span><span><!-- CANCEL BUTTON--><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50 md-icon-button" ng-click="$ctrl.vm.changeEditMode(\'\')" ng-disabled="$ctrl.topic.usFed.status" title="Cancel" aria-label="Cancel" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;"><md-icon class="white_icon" md-svg-icon="/public/images/ic_close_black_24px.svg"></md-icon></md-button></span><span ng-if="$ctrl.lock"><!-- LOCK BUTTON--><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50 md-icon-button" ng-click="$ctrl.lockComponent($event, $ctrl.vm.comp, true)" ng-disabled="$ctrl.topic.usFed.status" title="Lock" aria-label="Lock" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;"><md-icon class="white_icon" md-svg-icon="/public/images/ic_lock_black_24px.svg"></md-icon></md-button></span><span ng-if="($ctrl.vm.comp === \'complcl_sampling\' || $ctrl.vm.comp === \'complcl_sampling_SSA\' || $ctrl.vm.comp === \'complcl_sampling_Solution\')"><!-- SAMPLING SAVE AND PASS--><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-teal-50 md-icon-button" ng-click="$ctrl.vm.changeEditMode(\'Passed\', $event)" ng-disabled="!$ctrl.vm.isSamplingValid || $ctrl.vm.isSamplingFinished" title="{{$ctrl.vm.missingSampCLQs || \'Save &amp; Pass\'}}" aria-label="Save &amp; Pass" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;"><md-icon class="white_icon" md-svg-icon="/public/images/ic_done_all_black_36px.svg"></md-icon></md-button></span><span ng-if="($ctrl.vm.comp === \'complcl_sampling\' || $ctrl.vm.comp === \'complcl_sampling_SSA\' || $ctrl.vm.comp === \'complcl_sampling_Solution\')"><!-- SAMPLING SAVE AND FAIL--><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-orange-50 md-icon-button" ng-click="$ctrl.vm.changeEditMode(\'Failed\', $event)" ng-disabled="!$ctrl.vm.isSamplingValid || $ctrl.vm.isSamplingFinished" title="{{$ctrl.vm.missingSampCLQs || \'Save &amp; Fail\'}}" aria-label="Save &amp; Fail" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;"><md-icon class="white_icon" md-svg-icon="/public/images/ic_done_all_black_36px.svg"></md-icon></md-button></span></span></span><span ng-if="$ctrl.topic.editableComponents[$ctrl.vm.comp].socket || !$ctrl.vm.edit.editable"><span class="ibm-btn-row ibm-button-link" ng-if="$ctrl.topic.editableComponents[$ctrl.vm.comp].socket !==\'Locked\'"><!-- EDIT NOT PERMITTED--><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-gray-50 md-icon-button" title="{{$ctrl.topic.editableComponents[$ctrl.vm.comp].socket}} section" aria-label="Edit" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;"><md-icon class="white_icon" md-svg-icon="/public/images/ic_do_not_disturb_alt_black_24px.svg"></md-icon></md-button></span><span ng-if="$ctrl.topic.editableComponents[$ctrl.vm.comp].socket ===\'Locked\'"><span class="ibm-btn-row ibm-button-link"><!-- COMPONENT LOCKED--><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-gray-50 md-icon-button" title="Locked section - only System Admin can unlock" aria-label="Locked" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;"><md-icon class="white_icon" md-svg-icon="/public/images/ic_lock_black_24px.svg"></md-icon></md-button></span><span class="ibm-btn-row ibm-button-link" ng-if="$ctrl.env.user.access.systemAdmin"><!-- UNLOCK BUTTON--><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50 md-icon-button" ng-click="$ctrl.lockComponent($event, $ctrl.vm.comp, false)" title="Unlock" aria-label="Unlock" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;"><md-icon class="white_icon" md-svg-icon="/public/images/ic_lock_open_black_24px.svg"></md-icon></md-button></span></span></span>');
$templateCache.put('exchange-rate-edit.html','<style>.md-datepicker-calendar-pane{z-index: 1200}\n.md-dialog-is-showing md-dialog{width: 40%}\n.select2-selection--single {width: 200px }\n.select2, .select2-container, .select2-container--default, .select2-container--below, .select2-container--focus {width: 200px ! important}\n</style><md-dialog aria-label="Edit Exchange Rate" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Edit Exchange Rate</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="vm.disForm"><md-content class="md-padding"><span class="ibm-textcolor-blue-50">Currency&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.content.CURRENCY" ng-change="vm.modified = true;" ng-required="true" ng-maxLength="3"/></div><p></p><span class="ibm-textcolor-blue-50">From USD&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="number" ng-model="vm.content.FROMUSD" ng-change="vm.modified = true;" ng-required="true" ng-min="0"/></div><p></p><span class="ibm-textcolor-blue-50">To USD&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="number" ng-model="vm.content.TOUSD" ng-change="vm.modified = true;" ng-required="true" ng-min="0"/></div><p></p><span class="ibm-textcolor-blue-50">Start Date&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><div style="z-index:99999"><md-datepicker ng-model="vm.content.STARTDATE" ng-required="true"></md-datepicker></div></div><p></p><span class="ibm-textcolor-blue-50">End Date&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><div style="z-index:99999"><md-datepicker ng-model="vm.content.ENDDATE" ng-required="true"></md-datepicker></div></div><p></p><span class="ibm-textcolor-blue-50">Active&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select ng-model="vm.content.ACTIVE" ng-change="vm.modified = true;" ng-required="true"> <option value="Y">Yes</option><option value="N">No</option></select></div><p></p><span class="ibm-textcolor-blue-50">INACTIVE_FROM&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><div style="z-index:99999"><md-datepicker ng-model="vm.content.INACTIVE_FROM" ng-required="true"></md-datepicker></div></div><p></p></md-content></ng-form><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="!vm.disForm.$valid">Submit</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-dialog-content></md-dialog>');
$templateCache.put('exchange-rate-insert.html','<style>.md-datepicker-calendar-pane{z-index: 1200}\n.md-dialog-is-showing md-dialog{width: 40%}\n.select2-selection--single {width: 200px }\n.select2, .select2-container, .select2-container--default, .select2-container--below, .select2-container--focus {width: 200px ! important}\n\n</style><md-dialog aria-label="Add exchange rate record" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Add Record</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="vm.disForm"><md-content class="md-padding"><span class="ibm-textcolor-blue-50">Currency&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.record.CURRENCY" ng-change="vm.modified = true;" ng-required="true" ng-maxLength="3"/></div><p></p><span class="ibm-textcolor-blue-50">From USD&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="number" ng-model="vm.record.FROMUSD" ng-change="vm.modified = true;" ng-required="true" ng-min="0"/></div><p></p><span class="ibm-textcolor-blue-50">To USD&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="number" ng-model="vm.record.TOUSD" ng-change="vm.modified = true;" ng-required="true" ng-min="0"/></div><p></p><span class="ibm-textcolor-blue-50">Start Date&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><div style="z-index:99999"><md-datepicker ng-model="vm.record.STARTDATE" ng-required="true"></md-datepicker></div></div><p></p><span class="ibm-textcolor-blue-50">End Date&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><div style="z-index:99999"><md-datepicker ng-model="vm.record.ENDDATE" ng-required="true"></md-datepicker></div></div><p></p><span class="ibm-textcolor-blue-50">Active&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select ng-model="vm.record.ACTIVE" ng-change="vm.modified = true;" ng-required="true"> <option value="Y">Yes</option><option value="N">No</option></select></div><p></p><span class="ibm-textcolor-blue-50">INACTIVE_FROM&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><div style="z-index:99999"><md-datepicker ng-model="vm.record.INACTIVE_FROM" ng-required="true"></md-datepicker></div></div><p></p></md-content></ng-form><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="!vm.disForm.$valid">Submit</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Close</md-button><p></p></md-dialog-content></md-dialog>');
$templateCache.put('flag.html','<!--author Ivan Toth--><span ng-if="vm.topic.loaded.topic"><span ng-if="!vm.topic.editableComponents[vm.comp].socket &amp;&amp; !vm.env.user.access.reader"><md-icon class="red_icon flip" md-svg-src="/public/images/ic_flag_black_24px.svg" ng-click="vm.flagChange(true)" ng-if="!vm.topic.topic.header_data.flag" title="Set the Follow-up flag to true"></md-icon><md-icon class="green_icon" md-svg-src="/public/images/ic_flag_black_24px.svg" ng-click="vm.flagChange(false)" ng-if="vm.topic.topic.header_data.flag" title="Set the Follow-up flag to false"></md-icon></span><span ng-if="vm.topic.editableComponents[vm.comp].socket || vm.env.user.access.reader"><md-icon class="grey_icon flip" md-svg-src="/public/images/ic_flag_black_24px.svg" ng-if="!vm.topic.topic.header_data.flag" title="Please wait with update"></md-icon><md-icon class="grey_icon" md-svg-src="/public/images/ic_flag_black_24px.svg" ng-if="vm.topic.topic.header_data.flag" title="Please wait with update"></md-icon></span><span><span>&nbsp;</span><span ng-click="vm.enableComment()" ng-if="!vm.hovered &amp;&amp; (vm.topic.topic.header_data.comment == undefined || vm.topic.topic.header_data.comment == \'\') &amp;&amp; !vm.topic.editableComponents[vm.comp].socket">Insert Follow-up oppty</span><span ng-click="vm.enableComment()" ng-if="!vm.hovered  &amp;&amp; !vm.topic.editableComponents[vm.comp].socket" ng-bind="vm.topic.topic.header_data.comment"></span><span ng-if="vm.topic.editableComponents[vm.comp].socket" ng-bind="vm.topic.topic.header_data.comment" title="Please wait with the upate"></span><span ng-if="vm.hovered &amp;&amp; !vm.topic.editableComponents[vm.comp].socket"><span><input ng-model="vm.comment" size="40"/></span><span>&nbsp;<md-icon md-svg-src="/public/images/ic_check_black_24px.svg" ng-click="vm.sendComment()" title="Submit comment"></md-icon><md-icon md-svg-src="/public/images/ic_close_black_24px.svg" ng-click="vm.hovered = false;" title="Cancel comment"></md-icon></span></span></span></span>');
$templateCache.put('ftpgpp-details.html','<md-icon class="blue_icon" md-svg-src="/public/images/marker-check.svg" title="{{$ctrl.gppftpDetails}}"></md-icon>');
$templateCache.put('gov-check.html','<!--author Ivan Toth--><span>&nbsp;</span><span ng-if="$ctrl.topic.topic[$ctrl.comp].decision.success === true"> <md-icon class="green_icon" md-svg-icon="/public/images/thumb-up-outline.svg" title="GOE Validation status OK"></md-icon></span><span ng-if="$ctrl.topic.topic[$ctrl.comp].decision.success === false"> <md-icon class="red_icon" md-svg-icon="/public/images/ic_thumb_down_black_24px.svg" title="{{$ctrl.topic.topic[$ctrl.comp].decision.error}}"></md-icon></span><span ng-if="$ctrl.topic.topic[$ctrl.comp].govs &gt; 0"><md-icon class="pink_icon" md-svg-src="/public/images/ic_close_black_24px.svg" title="Gov found"></md-icon></span><span ng-if="$ctrl.topic.topic[$ctrl.comp].govs == 0"><md-icon class="green_icon" md-svg-src="/public/images/ic_check_black_24px.svg" title="Gov not found"></md-icon></span><span ng-if="!$ctrl.topic.topic[$ctrl.comp].govs &amp;&amp; $ctrl.topic.topic[$ctrl.comp].govs &lt; 0"><md-icon md-svg-src="/public/images/ic_thumb_down_black_24px.svg" title="No data found"></md-icon></span><span>&nbsp;</span><span ng-if="$ctrl.topic.topic[$ctrl.comp].unkn &gt; 0"><md-icon class="bisque_icon" md-svg-src="/public/images/ic_close_black_24px.svg" title="Unkown found"></md-icon></span><span ng-if="$ctrl.topic.topic[$ctrl.comp].unkn == 0"><md-icon class="bisque_icon" md-svg-src="/public/images/ic_check_black_24px.svg" title="Unkown not found"></md-icon></span>');
$templateCache.put('initiate-validation-dialog.html','<md-dialog ng-cloak="" aria-label="Initiate Validation"><md-toolbar><div class="md-toolbar-tools"><h2>Initiate Validation</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon aria-label="Close dialog" md-svg-src="/public/images/ic_close_white_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><div style="margin: 0px 0px 20px 0px"><p>This action will allow you to move this Disbursement to <span class="ibm-textcolor-blue-50"><b>Validation</b></span> status manually.</p><div>Select incentive type: <select class="ibm_select" ng-model="vm.locals.incentiveType" style="width: 200px"><option value="Sales">Sales</option><option value="Sales Assist">Sales assist</option></select></div><br>Choose incentive type if you want to continue</div></md-content><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="!vm.locals.incentiveType">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-dialog-content></md-dialog>');
$templateCache.put('lock.html','<!--author Ivan Toth--><span>&nbsp;</span><span ng-if="$ctrl.topic.topic.lock_indicator[$ctrl.comp].locked"><md-icon md-svg-src="/public/images/ic_lock_black_24px.svg" title="Locked"></md-icon></span><span ng-if="!$ctrl.topic.topic.lock_indicator[$ctrl.comp].locked"><md-icon md-svg-src="/public/images/ic_lock_open_black_24px.svg" title="Unlocked"></md-icon></span>');
$templateCache.put('mysaattachment.html','<!--@author Dmitry Mitsaliuk--><style>.fileCom{ padding-bottom: 0px; font-size: small};</style><span class="ibm-h4" ng-click="vm.showHide()"><md-icon md-svg-src="/public/images/ic_attachment_black_24px.svg"></md-icon><span ng-if="!vm.showAttachment">&nbsp;View MYSA Attachments</span><span ng-if="vm.showAttachment">&nbsp;Hide MYSA Attachments</span><span ng-if="vm.topic.topic[vm.comp].locked"></span><lock-section comp="vm.comp"></lock-section></span><div class="ibm-columns" ng-if="vm.showAttachment"><p></p><div class="ibm-col-6-4"><div></div><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="!vm.profileLoaded &amp;&amp; !vm.serverError">Loading...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><span ng-if="vm.profileLoaded"><table class="ibm-data-table ibm-grid ibm-altrows"><tr><th>Name</th><th>Hyperlink</th></tr><tr ng-repeat="item in vm.data"><td style="width: 15em">{{item.attachmentName}}</td><td style="width: 15em"><a ng-href="{{item.attachmentUrl}}">{{item.attachmentUrl}}</a></td></tr></table></span><div ng-if="vm.serverError"><div class="ibm-columns"><div class="ibm-col-1-1"><span class="ibm-textcolor-red-50" ng-bind-html="vm.serverError"></span></div></div></div></div></div>');
$templateCache.put('newclient-insert.html','<style>.md-datepicker-calendar-pane{z-index: 1200}\n.md-dialog-is-showing md-dialog{width: 40%}\n.select2-selection--single {width: 200px }\n.select2, .select2-container, .select2-container--default, .select2-container--below, .select2-container--focus {width: 200px ! important}\n\n</style><md-dialog aria-label="Edit Bonus" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Add new Client</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="vm.disForm"><md-content class="md-padding"><span class="ibm-textcolor-blue-50">IOT&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="iot" ng-model="vm.newClient.iot" ng-required="true" ng-options="iot for iot in vm.iots"><option value="">--Please select-- </option></select></div><p></p><span class="ibm-textcolor-blue-50">IMT&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="imt" ng-model="vm.newClient.imt" ng-required="true" ng-options="imt for imt in vm.imts[vm.newClient.iot]"><option value="">--Please select--                    </option></select></div><p></p><span class="ibm-textcolor-blue-50">Country&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><select class="ibm_select" name="country" ng-model="vm.newClient.country" ng-required="true" ng-options="country as country for country in vm.listCountries(vm.tree, vm.newClient.iot, vm.newClient.imt)"><option value="">--Please select--</option></select></div><p></p><span class="ibm-textcolor-blue-50">BP&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.newClient.bp" ng-change="vm.modified = true;" ng-required="true"/></div><p></p><span class="ibm-textcolor-blue-50">BP CEID&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.newClient.bp_ceid" ng-change="vm.modified = true;" ng-required="true"/></div><p></p><span class="ibm-textcolor-blue-50">Customer name&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"> <input type="text" ng-model="vm.newClient.customer_name" ng-change="vm.modified = true;" ng-required="true"/></div><p></p><span class="ibm-textcolor-blue-50">Customer number&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.newClient.customer_number" ng-change="vm.modified = true;" ng-required="true"/></div><p></p><span class="ibm-textcolor-blue-50">Start Date&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><div style="z-index:99999"><md-datepicker ng-model="vm.newClient.start_date" ng-required="true"></md-datepicker></div></div><p></p><span class="ibm-textcolor-blue-50">Approval Date&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><div style="z-index:99999"><md-datepicker ng-model="vm.newClient.approval_date" ng-required="true"></md-datepicker></div></div><p>       </p><span class="ibm-textcolor-blue-50">End Date&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><div style="z-index:99999"><md-datepicker ng-model="vm.newClient.end_date" ng-required="true"></md-datepicker></div></div><p></p><span class="ibm-textcolor-blue-50">Opportunity number&nbsp;&nbsp;</span><div style="border: 1px solid lightgray; padding: 10px; background-color: white"><input type="text" ng-model="vm.newClient.opportunity_number" ng-change="vm.modified = true;" ng-required="true"/></div><p></p></md-content></ng-form><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="!vm.disForm.$valid || vm.newClient.country===\'-Please select-\' || vm.newClient.imt===\'-Please select-\' ">Submit</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Close</md-button><p></p></md-dialog-content></md-dialog>');
$templateCache.put('newclient-update-add.html','<form name="paymentForm"><md-dialog aria-label="Confirm Prompt" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>{{::vm.title}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><div id="icon" style="float:left; border:solid 1px white; padding: 6px; display: flex"><md-icon class="red_icon" ng-if="vm.icon==\'ERROR\'" style="height:50px; width:50px" md-svg-src="/public/images/close-circle.svg" aria-label="Prompt icon"></md-icon><md-icon class="blue_icon" ng-if="vm.icon==\'INFO\'" style="height:50px; width:50px" md-svg-src="/public/images/ic_info_outline_black_24px.svg" aria-label="Prompt icon"></md-icon><md-icon class="orange_icon" ng-if="vm.icon==\'WARN\'" style="height:50px; width:50px" md-svg-src="/public/images/ic_warning_black_24px.svg" aria-label="Prompt icon"></md-icon><md-icon class="blue_icon" ng-if="vm.icon==\'QUESTION\'" style="height:50px; width:50px" md-svg-src="/public/images/help-circle.svg" aria-label="Prompt icon"></md-icon></div><div id="message" style="border:solid 1px white; padding: 6px; display: flex"><span ng-bind-html="vm.message"></span></div><div id="justify" ng-if="vm.prompt"><md-input-container><label>Justification</label><input required="required" aria-label="justification" ng-model="vm.justification" minlength="15"/><ng-messages for="paymentForm.justify.$error"><ng-message when="minlength">Please enter at least 15 characters.</ng-message></ng-messages></md-input-container></div><div style="text-align:center; border:solid 1px white;"><md-button class="md-raised md-primary" ng-if="vm.icon==\'QUESTION\'" ngf-select="vm.clickUploadAdd($event,$files)" ngf-max-size="5MB" accept=".xls,.xlsx">Add</md-button><md-button class="md-raised md-primary" ng-if="vm.icon==\'QUESTION\'" ng-click="vm.clickNo()" style="margin-left:5px">Replace</md-button></div></md-content></md-dialog-content></md-dialog></form>');
$templateCache.put('newclient-update-replace.html','<form name="paymentForm"><md-dialog aria-label="Confirm Prompt" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>{{::vm.title}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><div id="icon" style="float:left; border:solid 1px white; padding: 6px; display: flex"><md-icon class="red_icon" ng-if="vm.icon==\'ERROR\'" style="height:50px; width:50px" md-svg-src="/public/images/close-circle.svg" aria-label="Prompt icon"></md-icon><md-icon class="blue_icon" ng-if="vm.icon==\'INFO\'" style="height:50px; width:50px" md-svg-src="/public/images/ic_info_outline_black_24px.svg" aria-label="Prompt icon"></md-icon><md-icon class="orange_icon" ng-if="vm.icon==\'WARN\'" style="height:50px; width:50px" md-svg-src="/public/images/ic_warning_black_24px.svg" aria-label="Prompt icon"></md-icon><md-icon class="blue_icon" ng-if="vm.icon==\'QUESTION\'" style="height:50px; width:50px" md-svg-src="/public/images/help-circle.svg" aria-label="Prompt icon"></md-icon></div><div id="message" style="border:solid 1px white; padding: 6px; display: flex"><span ng-bind-html="vm.message"></span></div><div id="justify" ng-if="vm.prompt"><md-input-container><label>Justification</label><input required="required" aria-label="justification" ng-model="vm.justification" minlength="15"/><ng-messages for="paymentForm.justify.$error"><ng-message when="minlength">Please enter at least 15 characters.</ng-message></ng-messages></md-input-container></div><div style="text-align:center; border:solid 1px white;"><md-button class="md-raised md-primary" ng-if="vm.icon==\'QUESTION\'" ngf-select="vm.clickUploadReplace($event,$files)" ngf-max-size="5MB" accept=".xls,.xlsx">Yes</md-button><md-button class="md-raised md-secondary" ng-if="vm.icon==\'QUESTION\'" ng-click="vm.clickNo()" style="margin-left:5px">No</md-button></div></md-content></md-dialog-content></md-dialog></form>');
$templateCache.put('ok-cancel.html','<!--author Ivan Toth--><md-dialog aria-label="{{vm.field}}" ng-cloak="ng-cloak"><md-toolbar><div class="md-toolbar-tools"><h2>DMT</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div><span>{{vm.message}}</span></div><md-button class="md-raised md-primary" ng-click="vm.answer()">{{vm.okMessage}}</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">{{vm.cancelMessage}}</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('pa-site-num.html','<div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="!$ctrl.topic.editableComponents[$ctrl.comp].socket &amp;&amp; $ctrl.editable"><label><input ng-model="$ctrl.paSiteNum"/></label><span><md-icon md-svg-src="/public/images/ic_add_black_24px.svg" title="Add PA Site Number" ng-click="$ctrl.addPaNum()"></md-icon></span></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-repeat="paSite in $ctrl.topic.topic[$ctrl.comp]"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="paSite"></label><span ng-if="!$ctrl.topic.editableComponents[$ctrl.comp].socket &amp;&amp; $ctrl.editable"><md-icon md-svg-src="/public/images/ic_close_black_24px.svg" ng-click="$ctrl.clearPaNum(paSite)" title="Clears {{paSite}} PA Site Numbers"></md-icon></span></div></div></div></div>');
$templateCache.put('reAssignUser-dialog.html','<style>.md-virtual-repeat-container.md-autocomplete-suggestions-container {\n  z-index: 9999;\n}</style><md-dialog aria-label="Assign " ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>{{!vm.updateBundle.topic.owner ? \'Assign\' : \'Re-Assign\'}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><ng-form name="rollForm"><p>Please enter the new Assignee and click {{!vm.updateBundle.topic.owner ? \'Assign\' : \'Re-Assign\'}}:</p></ng-form><type-ahead ng-if="vm.updateBundle.topic.owner" vm="vm" style="margin-right: 30px;" opp="{{vm.updateBundle.topic._id.slice(4)}}" bpname="{{vm.updateBundle.topic.bp_name}}" status="{{vm.updateBundle.topic_ext.status}}" substatus="{{vm.updateBundle.topic_ext.sub_status}}" reassign="true"></type-ahead><type-ahead ng-if="!vm.updateBundle.topic.owner" vm="vm" style="margin-right: 30px;" opp="{{vm.updateBundle.topic._id.slice(4)}}" bpname="{{vm.updateBundle.topic.bp_name}}" status="{{vm.updateBundle.topic_ext.status}}" substatus="{{vm.updateBundle.topic_ext.sub_status}}" reassign="false"></type-ahead></md-content></md-dialog-content></md-dialog>');
$templateCache.put('refreshcl-dialog.html','<md-dialog aria-label="Refresh Checklists" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Refresh Checklists</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><ng-form name="checkForm"><p>Use this function to refresh one or more checklists based on the latest templates in the Admin Profiles. &nbsp;Please select which you would like to refresh, and give a reason for the change. &nbsp;Click&nbsp;<b>OK&nbsp;</b>to continue, or&nbsp;<b>Cancel&nbsp;</b>to quit.&nbsp;&nbsp;<b>NOTE:&nbsp;</b>The available checklists are based on the current status.</p><div class="selectbox" style="background-color: white"><span ng-repeat="x in vm.chkBundle.cls"><!--input(ng-disabled="x.stat < vm.chkBundle.status_no" type="checkbox" ng-model="x.refresh" ng-change="vm.chkBundle.tick(vm.chkBundle)")--><input ng-disabled="x.stats.indexOf(vm.chkBundle.status_no) &lt; 0" type="checkbox" ng-model="x.refresh" ng-change="vm.chkBundle.tick(vm.chkBundle)"/><!--span(ng-class="{\'ibm-textcolor-gray-30\': x.stat < vm.chkBundle.status_no }" title="{{x.info}}") {{x.name}} &nbsp;&nbsp;--><span ng-class="{\'ibm-textcolor-gray-30\': x.stats.indexOf(vm.chkBundle.status_no) &lt; 0 }" title="{{x.info}}">{{x.name}} &nbsp;&nbsp;</span><p ng-if="vm.chkBundle.newLine($index+1,4)"></p></span></div><p></p><b class="ibm-textcolor-red-40">WARNING:&nbsp;</b>Should you choose to continue, the selected Checklists within this Disbursement will be completely overwritten with the new ones.<p></p>Please add some supporting comments:<p></p><textarea class="userField" name="comments" ng-model="vm.chkBundle.comments" style="resize: none" rows="5" cols="100" resize="false" ng-required="true"></textarea><p></p></ng-form><md-button class="md-raised md-primary" ng-disabled="!vm.$scope.checkForm.$valid || vm.chkBundle.selected &lt; 1" ng-click="vm.answer()">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-content></md-dialog-content></md-dialog>');
$templateCache.put('reject-dialog.html','<md-dialog aria-label="Reject Disbursement" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Reject Disbursement</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><ng-form name="rejForm"><p>You have chosen to flag this Disbursement as&nbsp;<b class="ibm-textcolor-blue-50">Rejected</b>. &nbsp;Should you choose to continue, you will no longer be able to edit the detail, or reinstate it without help from the&nbsp;<b>DMT System Administrators</b>. &nbsp;Please determine the correct Sub-Status and Rejection Code below:</p><select style="width: 20em" ng-model="vm.rejBundle.nextSubStatusDesc" ng-options="o.txt as o.txt for o in vm.rejBundle.nextSubStatuses" ng-change="vm.rejBundle.setSubStatus()" ng-required="true"></select>&nbsp;&nbsp;<reject-reason-select parent="vm"></reject-reason-select><p></p><p>Please add some supporting comments {{ vm.rejBundle.rejectionReason.other ? \'for the \\\'Other Reason\\\'\' : \'if you like\'}}:<textarea class="userField" name="comments" ng-model="vm.rejBundle.comments" style="resize: none" rows="5" cols="100" resize="false" ng-required="vm.rejBundle.rejectionReason.other"></textarea></p></ng-form><md-button class="md-raised md-primary" ng-disabled="!vm.$scope.rejForm.$valid" ng-click="vm.answer()">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-content></md-dialog-content></md-dialog>');
$templateCache.put('reject-reason-select.html','<select ng-if="$ctrl.codesLoaded" style="width: 30em" ng-model="$ctrl.parent.rejBundle.rejectionReason" ng-init="$ctrl.parent.rejBundle.rejectionReason = $ctrl.parent.rejBundle.rejectionReason || $ctrl.reasonCodes[0]" ng-options="o as o.code + &quot; - &quot; + o.desc for o in $ctrl.reasonCodes"></select><span class="span ibm-textcolor-blue-40" ng-if="!$ctrl.codesLoaded" style="border: 1px solid lightgray; padding: 7px 40px 11px 54px; background-color:white">Retrieving Rejection Codes...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></span>');
$templateCache.put('rejection-details.html','<md-dialog aria-label="Rejection Details" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Rejection Details</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.clickNo()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content style="min-width: 40em"><md-content class="md-padding">The Rejection Details for this Disbursement are as follows:<p></p><table class="ibm-data-table ibm-alternate-two" cellspacing="0" cellpadding="0" border="0"><tBody><tr><td class="ibm-textcolor-blue-50">Status Rejected at</td><td>{{::vm.reject_status}}</td></tr><tr><td class="ibm-textcolor-blue-50">Rejection Reason</td><td>{{::vm.rejection_details.reject_reason}}</td></tr><tr><td class="ibm-textcolor-blue-50">Optional Comments</td><td>{{::vm.rejection_details.reject_comments ? vm.rejection_details.reject_comments : \'N/A\' }}</td></tr></tBody></table></md-content></md-dialog-content></md-dialog>');
$templateCache.put('resolveerror-dialog.html','<md-dialog aria-label="Resolve Error" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Resolve Error</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><ng-form name="errorForm"><p>Please select the error to resolve and give a reason. &nbsp;Click&nbsp;<b>OK&nbsp;</b>to continue, or&nbsp;<b>Cancel&nbsp;</b>to quit.&nbsp;&nbsp;</p><span class="ibm-textcolor-blue-40">Errors&nbsp;&nbsp;</span><select style="width: 20em;" ng-model="vm.resolveBundle.error" ng-options="o as o.type for o in vm.resolveBundle.errors.err | filter: {resolved:false}" ng-required="true"></select><p></p><span class="ibm-textcolor-blue-40">Description&nbsp;&nbsp;</span>{{vm.resolveBundle.error.details}} <p></p>Please add some supporting comments:<p></p><textarea class="userField" name="comments" ng-model="vm.resolveBundle.error.comments" style="resize: none" rows="5" cols="100" resize="false" ng-required="true"></textarea><p></p></ng-form><md-button class="md-raised md-primary" ng-disabled="!vm.$scope.errorForm.$valid" ng-click="vm.answer()">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-content></md-dialog-content></md-dialog>');
$templateCache.put('reval-confirmation.html','<style>.so {\n    text-align: center;\n    width: 30%;\n}\n.head {\n    font-size: medium;\n}\n.pn {\n    text-align: center;\n    width: 30%;\n}\n.status {\n    text-align: center;\n    width: 40%;\n}</style><md-dialog ng-cloak="ng-cloak" aria-label="{{vm.field}}"><md-toolbar><div class="md-toolbar-tools"><h2>Trigger Calculations</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" aria-label="Close dialog" md-svg-src="/public/images/ic_close_black_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div ng-if="vm.calcBundle.valid &gt; 0"><span>Click </span><b>Confirm </b><span>to trigger the Auto-Calculation process. </span><b>&nbsp;&nbsp;NOTE: </b>All Parts will be processed regardless of status:</div><div ng-if="vm.calcBundle.valid === 0"><span>None of the Parts are Valid therefore it is not possible to proceed with the Calculations:</span></div><p></p><table class="ibm-data-table ibm-alternate-two" style="width:100%" cellspacing="0" cellpadding="0" border="0"><tHead><tr><th class="so head"><b>Sales Order</b></th><th class="pn head"><b>Part No.</b></th><th class="status head"><b>Status</b></th></tr></tHead><tBody> <tr ng-repeat="pn in vm.calcBundle.topic.sap"><td class="so">{{pn.data.soNumber}}</td><td class="pn"><b>{{pn.data.itemList[0].pn}}</b></td><td class="status"><md-icon class="red_icon" ng-if="!pn.result.isWholeOpptyValid" md-svg-src="/public/images/ic_error_black_24px.svg"></md-icon><md-icon class="green_icon" ng-if="pn.result.isWholeOpptyValid" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon></td></tr></tBody></table><p></p><p></p><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.clickYes()">Confirm</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.cancel()">Cancel</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('rollback-dialog.html','<md-dialog aria-label="Rollback Status" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Rollback Status</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><ng-form name="rollForm"><p>Please select the new Status and/or Sub-Status and give a reason for the change. &nbsp;Click&nbsp;<b>OK&nbsp;</b>to continue, or&nbsp;<b>Cancel&nbsp;</b>to quit.&nbsp;&nbsp;<b class="ibm-textcolor-red-50">NOTE:&nbsp;</b><span ng-bind-html="vm.rollBundle.helpText"></span></p><span class="ibm-textcolor-blue-40">Status&nbsp;&nbsp;</span><select style="width: 20em;" ng-model="vm.rollBundle.nextStatus" ng-options="o as o.txt for o in vm.rollBundle.nextStatuses" ng-required="true"></select>&nbsp;&nbsp;&nbsp;<span class="ibm-textcolor-blue-40">Sub-Status&nbsp;&nbsp;</span><select style="width: 20em;" ng-model="vm.rollBundle.nextSubStatus" ng-options="o as o.txt for o in vm.rollBundle.nextStatus.subs | statusFilter" ng-required="true"></select><!--select(style="width: 20em;" ng-model=\'vm.rollBundle.nextSubStatus\' ng-options=\'o as o.txt for o in vm.rollBundle.nextStatus.subs | filter: {ignore:false}\' ng-required="true")--><md-icon class="orange_icon" style="margin-left: 3px" ng-if="vm.rollBundle.nextSubStatus.system" md-svg-src="/public/images/ic_info_outline_black_24px.svg" title="This is a System-Set Sub-Status, ie: a status that is not available for user selection normally."></md-icon><!-- Following checkbox commented out because updateStatus code would need changing to manage it--><!--div(ng-if="vm.rollBundle.currentStatus === 4 && vm.rollBundle.nextStatus.no === 3")p\n| Check the box if you like to delete all the Ad-Hoc Attachments from the Validation and Calculations & Payments tabs:\ninput(type="checkbox" ng-model="vm.rollBundle.deleteAttach" style="transform: scale(1.5); margin-left: 10px;")--><div ng-if="vm.rollBundle.currentStatus === 4 &amp;&amp; vm.rollBundle.nextStatus.no === 3"><p></p><b class="ibm-textcolor-red-50">WARNING</b><span>: By rolling back to Eligibility status all Validation Results, 2nd GOE (if set), Calculations and Payment details will be permanently deleted. &nbsp;Any ad-hoc Attachments, however, will remain.</span></div><p></p>Please add some supporting comments:<p></p><textarea class="userField" name="comments" ng-model="vm.rollBundle.comments" style="resize: none" rows="5" cols="100" resize="false" ng-required="true"></textarea><p></p></ng-form><md-button class="md-raised md-primary" ng-disabled="!vm.$scope.rollForm.$valid" ng-click="vm.answer()">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-content></md-dialog-content></md-dialog>');
$templateCache.put('set-sa-flag-dialog.html','<!--md-dialog(aria-label=\'Change SA flag\', ng-cloak=\'\')md-dialog-content\n    span(align="center" ng-if="((vm.saFlag !== vm.topic.topic.sales_assist.type && vm.topic.topic.sales_assist.type) || (vm.saFlag !==\'Automatic\' && (!vm.topic.topic.sales_assist || !vm.topic.topic.sales_assist.type)))")\n        md-content(class="md-padding")\n            | &nbsp; Select order type:\n            br\n            | &nbsp;\n    span(align="center")\n        md-content(class="md-padding")\n            select(align="center" style="width: 12em" ng-model=\'vm.saFlag\' ng-options=\'flag for flag in vm.saFlagArray\',ng-change="vm.showsaFlagSaveButton()" ng-disabled="vm.status.mainStatusChange")\n                | &nbsp;\n            br\n            br\n            input(align="center" ng-model="vm.comment")\n            br\n            br\n            md-button(ng-disabled="vm.comment.trim() ===\'\'" class="ibm-btn-pri ibm-btn-small ibm-btn-green-50",ng-click="vm.clickYes()" title="Confirm and save sa flag change")\n                md-icon(class="white_icon",md-svg-src="/public/images/checkbox-marked-circle.svg")\n                | &nbsp;Save\n            md-button(class="ibm-btn-pri ibm-btn-small ibm-btn-green-50",ng-click="vm.cancel()" title="Cancel change")\n                md-icon(class="white_icon",md-svg-src="/public/images/checkbox-marked-circle.svg")\n                | &nbsp;Cancel--><md-dialog aria-label="Change Incentive Type" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Change Incentive Type</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><ng-form name="saasForm"><p>Please select the new Incentive Type and give a reason. &nbsp;Click&nbsp;<b>OK&nbsp;</b>to continue, or&nbsp;<b>Cancel&nbsp;</b>to quit.&nbsp;&nbsp;</p><span class="ibm-textcolor-blue-40">New Type&nbsp;&nbsp;</span><select style="width: 20em;" ng-model="vm.saFlag" ng-options="flag for flag in vm.saFlags" ng-required="true"></select><span class="ibm-textcolor-blue-40" style="margin-left: 20px">Current Type&nbsp;&nbsp;</span>{{::vm.original}}<p></p>Please add some supporting comments:<p></p><textarea class="userField" name="comments" ng-model="vm.comment" style="resize: none" rows="5" cols="85" resize="false" ng-required="true"></textarea><p></p></ng-form><md-button class="md-raised md-primary" ng-disabled="!vm.$scope.saasForm.$valid || vm.saFlag === vm.original" ng-click="vm.clickYes()">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-content></md-dialog-content></md-dialog>');
$templateCache.put('showing-errors.html','<style>.errorsLabel{font-size: 30px}\n.ibm-textcolor-blue-50{font-size: 30px}\n.button{font-size: 25px}</style><d-dialog aria-label="Edit Bonus" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2 class="errorsLabel">Errors on {{vm.windowName}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.confirmOk()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="vm.disForm"><md-content class="md-padding"><span class="ibm-textcolor-blue-50" ng-if="vm.allErrors.validationErrors.length">Validation errors&nbsp;&nbsp;<p><table class="ibm-data-table ibm-altrows ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1"><thead><tr><td>Insert object</td><td>Error</td></tr></thead><tBody><tr ng-repeat="err in vm.allErrors.validationErrors"><td> <span>{{err.objectValue}}</span></td><td> <span>{{err.error}}</span></td></tr></tBody></table></p></span><span class="ibm-textcolor-blue-50" ng-if="vm.allErrors.errors.length">Another errors&nbsp;&nbsp;<p><table class="ibm-data-table ibm-altrows ibm-alternate-two table" cellspacing="0" cellpadding="0" border="1"><thead><tr><td>Error</td></tr></thead><tBody><tr ng-repeat="err in vm.allErrors.errors"><td> <span>{{err.error}} </span></td></tr></tBody></table></p></span><p></p></md-content></ng-form><md-button class="button" ng-click="vm.confirmOk()"> Ok </md-button> </md-dialog-content></d-dialog>');
$templateCache.put('siteIdData-dialog.html','<style>.md-virtual-repeat-container.md-autocomplete-suggestions-container {\n  z-index: 9999;\n}</style><div>dddc</div><md-dialog ng-cloak="" aria-label="siteIdData"><md-toolbar><div class="md-toolbar-tools"><h2>Site IDs</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon aria-label="Close dialog" md-svg-src="/public/images/ic_close_white_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><table class="ibm-data-table ibm-alternate-two" cellspacing="0" cellpadding="0" border="0"><tr><th ng-repeat="header in vm.headers">{{::header}}</th></tr><tr ng-repeat="line in vm.siteIdData"><td>{{::line.ibmCustNum}}</td><td>{{::line.custNum}}</td><td>{{::line.custName}}</td><td>{{::line.address}}</td><td>{{::line.city}}</td><td>{{::line.stateCode}}</td><td>{{::line.postalCode}}</td><td>{{::line.cntryCode}}</td></tr></table></md-content></md-dialog-content></md-dialog>');
$templateCache.put('topic-errors.html','<style>.unresolved {\n    background-color: lightpink; \n}\n.resolved {\n    background-color: steelblue; \n}\n.banner {\n    text-align: center; \n    padding: 6px;\n    color: white;\n}\n.md-button.md-icon-button {\n    padding: 7px;\n}\n.error_icon {\n    width: 37px;\n    height: 30px;\n    padding: 6px;\n    background-color: white; \n}\n.md-icon-button:hover {\n    background-color: white; \n}\n.unresolved_icon {\n    border: solid 1px #ffe6e6; \n}\n.resolved_icon {\n    border: solid 1px lightblue; \n}</style><div class="ibm-h4" ng-if="$ctrl.errors" ng-class="{\'unresolved banner\':$ctrl.errors.unresolved &gt; 0, \'resolved banner\':$ctrl.errors.unresolved === 0}"><span ng-if="$ctrl.errors.unresolved &gt; 0">This Disbursement has {{$ctrl.errors.unresolved}} Unresolved {{$ctrl.errors.unresolved > 1 ? \'Errors\' : \'Error\'}}</span><span ng-if="$ctrl.errors.unresolved === 0">This Disbursement has {{$ctrl.errors.err.length}} Resolved {{$ctrl.errors.err.length > 1 ? \'Errors\' : \'Error\'}}</span><md-button ng-class="{\'md-icon-button error_icon unresolved_icon\':$ctrl.errors.unresolved &gt; 0, \'md-icon-button error_icon resolved_icon\':$ctrl.errors.unresolved === 0}" aria-label="View Error Details" ng-click="$ctrl.showErrors($event)" title="View Error Details"><md-icon ng-class="{red_icon:$ctrl.errors.unresolved &gt; 0, blue_icon:$ctrl.errors.unresolved === 0}" md-svg-src="/public/images/alert-decagram.svg" aria-label="View Error Details">   </md-icon></md-button></div>');
$templateCache.put('updatePaymentDetails-dialog.html','<style>.spanLeftAlign {\n  display: inline-block;\n  float: left;\n  clear: left;\n  width: 250px;\n  text-align: right;\n}\n.cell {\n  padding-right: 5px;\n  font-size: small;\n}\n.md-datepicker-calendar-pane {\n  z-index: 9999;\n}\n.md-datepicker-input-container {\n  width: 60%;\n}\n.md-padding {\n  padding-bottom: 0;\n}</style><md-dialog aria-label="Rollback Status" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2 ng-if="vm.status.status_no === 7">Update Payment Details</h2><h2 ng-if="(vm.status.status_no === 4 || vm.status.status_no === 6) &amp;&amp; vm.updateBundle.complete === true &amp;&amp; vm.updateBundle.goe === \'N\'">Update Payment Details</h2><h2 ng-if="(vm.status.status_no === 4 || vm.status.status_no === 6) &amp;&amp; vm.initialSapResult &amp;&amp; vm.updateBundle.goe === \'Y\'">Update Payment Details</h2><h2 ng-if="(vm.status.status_no === 4 || vm.status.status_no === 6) &amp;&amp; vm.initialSapResult === undefined &amp;&amp; vm.updateBundle.goe === \'Y\'">Move To Paid</h2><h2 ng-if="(vm.status.status_no === 4 || vm.status.status_no === 6) &amp;&amp; vm.updateBundle.complete === false &amp;&amp; vm.updateBundle.goe === \'N\'">Move To Set Aside</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><ng-form name="saasForm" ng-if="((vm.status.status_no === 4 || vm.status.status_no === 6) &amp;&amp; vm.updateBundle.complete === true &amp;&amp; vm.updateBundle.goe === \'N\') || vm.status.status_no === 7"><p>Payment has taken place at SAP and reflected in DMT.&nbsp;<br/>Please update payment details and &nbsp;Click&nbsp;<b>OK&nbsp;</b>to Update Details or&nbsp;<b>Cancel&nbsp;</b>to quit.</p></ng-form><ng-form name="saasForm" ng-if="(vm.status.status_no === 4 || vm.status.status_no === 6) &amp;&amp; vm.initialSapResult &amp;&amp; vm.updateBundle.goe === \'Y\'"><p>Payment has taken place at SAP but is not reflected in DMT.&nbsp;<br/>Please add the payment details and &nbsp;Click&nbsp;<b>OK&nbsp;</b>to move the Disbursement to a Paid status or&nbsp;<b>Cancel&nbsp;</b>to quit.</p></ng-form><ng-form name="saasForm" ng-if="(vm.status.status_no === 4 || vm.status.status_no === 6) &amp;&amp; vm.initialSapResult === undefined &amp;&amp; vm.updateBundle.goe === \'Y\'"><p>Payment hasn\'t taken place at SAP.&nbsp;<br/>Please add the payment details and &nbsp;Click&nbsp;<b>OK&nbsp;</b>to move the Disbursement to a Paid status or&nbsp;<b>Cancel&nbsp;</b>to quit.</p></ng-form><ng-form name="saasForm" ng-if="(vm.status.status_no === 4 || vm.status.status_no === 6) &amp;&amp; vm.updateBundle.complete === false &amp;&amp; vm.updateBundle.goe === \'N\'"><p>Payment hasn\'t taken place at SAP.&nbsp;<br/>Please add the payment details and &nbsp;Click&nbsp;<b>OK&nbsp;</b>to move the Disbursement to a Set Aside status or&nbsp;<b>Cancel&nbsp;</b>to quit.                  </p></ng-form></md-content></md-dialog-content><md-dialog-content><md-content class="md-padding"><ng-form name="rollForm"><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><div class="cell" flex="11%">Incentive Program</div><div class="cell" flex="11%">Payment Amount</div><div class="cell" flex="11%">SAP Result</div><div class="cell" flex="11%" ng-if="vm.updateBundle.goe !== \'N\'">Payment Date</div></div></md-list-item><md-list-item class="md-2-line" ng-if="vm.updateBundle.sapResult[vm.nameOfCvrSSA].iaugru"><div class="md-list-item-text" layout="row" layout-align="start left"><div class="cell" flex="11%">{{vm.ssaLabel}}</div><div class="cell" flex="11%"> <md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.totalSSABonus"/></md-input-container></div><div class="cell" flex="11%"> <md-input-container flex="flex" style="padding:0; margin:0"><input ng-if="vm.updateBundle.goe === \'Y\'" style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.sapResult[vm.nameOfCvrSSA].SSA"/><input ng-if="vm.updateBundle.goe === \'N\'" style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.sapResult[vm.nameOfCvrSSA].SSA" disabled="disabled"/></md-input-container></div><div class="cell" flex="20%" ng-if="vm.updateBundle.goe !== \'N\'"><md-datepicker flex="flex" style="padding:0; margin:0" ng-model="vm.updateBundle.sapResult[vm.nameOfCvrSSA].paidTimestamp" ng-required="true"> </md-datepicker></div></div></md-list-item><md-list-item class="md-2-line" ng-if="vm.updateBundle.sapResult[vm.nameOfCvrSolution].iaugru"><div class="md-list-item-text" layout="row" layout-align="start left"><div class="cell" flex="11%">{{vm.seLabel}}</div><div class="cell" flex="11%"> <md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.totalSolutionBonus"/></md-input-container></div><div class="cell" flex="11%"> <md-input-container flex="flex" style="padding:0; margin:0"><input ng-if="vm.updateBundle.goe === \'Y\'" style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.sapResult[vm.nameOfCvrSolution].Solution"/><input ng-if="vm.updateBundle.goe === \'N\'" style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.sapResult[vm.nameOfCvrSolution].Solution" disabled="disabled"/></md-input-container></div><div class="cell" flex="11%" ng-if="vm.updateBundle.goe !== \'N\'"><md-datepicker flex="flex" style="padding:0; margin:0" ng-model="vm.updateBundle.sapResult[vm.nameOfCvrSolution].paidTimestamp" ng-required="true">    </md-datepicker></div></div></md-list-item><md-list-item class="md-2-line" ng-if="vm.updateBundle.sapResult[vm.nameOfGrowth].iaugru"><div class="md-list-item-text" layout="row" layout-align="start left"><div class="cell" flex="11%">Growth</div><div class="cell" flex="11%"> <md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.totalGrowthBonus"/></md-input-container></div><div class="cell" flex="11%"> <md-input-container flex="flex" style="padding:0; margin:0"><input ng-if="vm.updateBundle.goe === \'Y\'" style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.sapResult[vm.nameOfGrowth].Growth"/><input ng-if="vm.updateBundle.goe === \'N\'" style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.sapResult[vm.nameOfGrowth].Growth" disabled="disabled"/></md-input-container></div><div class="cell" flex="11%" ng-if="vm.updateBundle.goe !== \'N\'"><md-datepicker flex="flex" style="padding:0; margin:0" ng-model="vm.updateBundle.sapResult[vm.nameOfGrowth].paidTimestamp" ng-required="true">    </md-datepicker></div></div></md-list-item><md-list-item class="md-2-line" ng-if="vm.updateBundle.sapResult[vm.nameOfFocus].iaugru"><div class="md-list-item-text" layout="row" layout-align="start left"><div class="cell" flex="11%">Focus</div><div class="cell" flex="11%"> <md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.totalFocusBonus"/></md-input-container></div><div class="cell" flex="11%"> <md-input-container flex="flex" style="padding:0; margin:0"><input ng-if="vm.updateBundle.goe === \'Y\'" style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.sapResult[vm.nameOfFocus].Focus"/><input ng-if="vm.updateBundle.goe === \'N\'" style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.sapResult[vm.nameOfFocus].Focus" disabled="disabled"/></md-input-container></div><div class="cell" flex="11%" ng-if="vm.updateBundle.goe !== \'N\'"><md-datepicker flex="flex" style="padding:0; margin:0" ng-model="vm.updateBundle.sapResult[vm.nameOfFocus].paidTimestamp" ng-required="true">    </md-datepicker></div></div></md-list-item><md-list-item class="md-2-line" ng-if="vm.updateBundle.sapResult[vm.nameOfCtl].iaugru"><div class="md-list-item-text" layout="row" layout-align="start left"><div class="cell" flex="11%">CTL</div><div class="cell" flex="11%"> <md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.totalCtlBonus"/></md-input-container></div><div class="cell" flex="11%"> <md-input-container flex="flex" style="padding:0; margin:0"><input ng-if="vm.updateBundle.goe === \'Y\'" style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.sapResult[vm.nameOfCtl].Ctl"/><input ng-if="vm.updateBundle.goe === \'N\'" style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.sapResult[vm.nameOfCtl].Ctl" disabled="disabled"/></md-input-container></div><div class="cell" flex="11%" ng-if="vm.updateBundle.goe !== \'N\'"><md-datepicker flex="flex" style="padding:0; margin:0" ng-model="vm.updateBundle.sapResult[vm.nameOfCtl].paidTimestamp" ng-required="true">    </md-datepicker></div></div></md-list-item><md-list-item class="md-2-line" ng-if="vm.updateBundle.sapResult[vm.nameOfCvrNewClient].iaugru"><div class="md-list-item-text" layout="row" layout-align="start left"><div class="cell" flex="11%">CVR NewClient</div><div class="cell" flex="11%"> <md-input-container flex="flex" style="padding:0; margin:0"><input style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.totalNewClientBonus"/></md-input-container></div><div class="cell" flex="11%"> <md-input-container flex="flex" style="padding:0; margin:0"><input ng-if="vm.updateBundle.goe === \'Y\'" style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.sapResult[vm.nameOfCvrNewClient].NewClient"/><input ng-if="vm.updateBundle.goe === \'N\'" style="border: solid 1px lightgray" aria-label="blah" ng-model="vm.updateBundle.sapResult[vm.nameOfCvrNewClient].NewClient" disabled="disabled"/></md-input-container></div><div class="cell" flex="11%" ng-if="vm.updateBundle.goe !== \'N\'"><md-datepicker flex="flex" style="padding:0; margin:0" ng-model="vm.updateBundle.sapResult[vm.nameOfCvrNewClient].paidTimestamp" ng-required="true"> </md-datepicker></div></div></md-list-item><md-list-item class="md-2-line" ng-if="((vm.status.status_no === 4 || vm.status.status_no === 6) &amp;&amp; vm.updateBundle.goe === \'N\') || (vm.status.status_no === 7 &amp;&amp; vm.updateBundle.goe === \'N\')"><div class="md-list-item-text" layout="row" layout-align="start left">    <div class="cell" style="align-self: center">Payment Date</div><div class="cell"><md-datepicker flex="flex" style="padding:0; margin:0" ng-model="vm.updateBundle.paidTimestamp" ng-required="true"> </md-datepicker></div></div></md-list-item><md-list-item class="md-2-line" ng-if="vm.status.isMoveToPaid"><div class="md-list-item-text" layout="row" layout-align="start left"><div class="cell" flex="11%">Sub-Status&nbsp;&nbsp;<select flex="flex" style="width: 20em;" ng-model="vm.status.nextSubStatus" ng-options="o as o.txt for o in vm.status.nextStatus.subs | statusFilter" ng-required="true"></select><md-icon class="orange_icon" style="margin-left: 3px" ng-if="vm.status.nextSubStatus.system" md-svg-src="/public/images/ic_info_outline_black_24px.svg" title="This is a System-Set Sub-Status, ie: a status that is not available for user selection normally."></md-icon></div></div></md-list-item>Please add some supporting comments:<p></p><textarea class="userField" name="comments" ng-model="vm.updateBundle.comments" style="resize: none" rows="5" cols="100" resize="false" ng-required="true"></textarea><p></p></ng-form><md-button class="md-raised md-primary" ng-disabled="!vm.$scope.rollForm.$valid" ng-click="vm.answer()">OK</md-button><md-button class="md-raised md-primary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-content></md-dialog-content></md-dialog>');
$templateCache.put('yes-no.html','<!--author Ivan Toth--><md-dialog aria-label="{{vm.field}}" ng-cloak="ng-cloak"><md-toolbar><div class="md-toolbar-tools"><h2>{{vm.dialogName}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div><span ng-bind-html="vm.message"></span></div><p></p><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.clickYes()">{{vm.okMessage}}</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.clickNo()">{{vm.cancelMessage}}</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" style="float:right" ng-if="vm.addCancel" ng-click="vm.cancel()">Cancel</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('deal-registration-product-group.html','<style>.bpAuth-table * {\n    font-size: 14px;\n  }\n</style><!-- author Vlad--><div class="ibm-columns" id="generalInfo"><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span><span>{{vm.tableName}}</span><span ng-if="vm.tableError"><md-icon class="red_icon" title="{{vm.tableError}}" md-svg-src="/public/images/ic_warning_black_24px.svg"></md-icon></span><span class="ibm-textcolor-blue-40" style="font-size:medium"> Click to {{vm.visible ? \'hide\' : \'view\'}}</span></span></span><div id="indent-vertical" ng-if="vm.visible &amp;&amp; (!vm.topic.topic.version || vm.topic.topic.version &lt; vm.OPP_VERSION_4)"><table class="ibm-data-table ibm-grid ibm-altrows bpAuth-table"><thead><tr><th ng-repeat="name in vm.tableHeader track by $index"><b>{{name}}</b></th></tr></thead><tbody ng-if="vm.type !== &quot;validation&quot; || vm.DRPGsArr.length === 0"><tr ng-repeat="(key,value) in vm.tableRows track by $index"> <td>{{value.dealRegProductGroupID}}</td><td>{{value.dealRegProductGroupName}}</td><td>{{value.gbt20ID}}</td><td>{{value.gbt20Name}}</td><td>{{value.revenue}}</td><td>{{value.bpa}}</td><td>{{value.ta}}</td><td>{{value.value}}</td><td>{{value.bpDuplicateFound}}</td><td><div ng-if="value.bpDuplicateOpportunityNumber.length" ng-repeat="str in value.bpDuplicateOpportunityNumber track by $index"> <span>{{str}}</span></div><div ng-if="!value.bpDuplicateOpportunityNumber.length"><span>Not Applicable </span></div></td><td>{{value.ibmDuplicateFound}}</td><td><div ng-if="value.ibmDuplicateOpportunityNumber.length" ng-repeat="str in value.ibmDuplicateOpportunityNumber track by $index"> <span>{{str}}</span></div><div ng-if="!value.ibmDuplicateOpportunityNumber.length"><span>Not Applicable </span></div></td><td>{{value.specialBid}}</td><td>{{value.cvrSSA}}</td><td>{{value.solution}}</td><td><div ng-if="value.solutionID.length" ng-repeat="str in value.solutionID track by $index"> <span>{{str}}</span></div></td></tr></tbody><tbody ng-if="vm.type === &quot;validation&quot; &amp;&amp; vm.DRPGsArr.length !== 0"><tr ng-repeat="(key,value) in vm.DRPGsArr track by $index"><td ng-repeat="(key,value1) in vm.props track by $index"><div ng-if="value[value1].length &amp;&amp; value1 !== \'ibmDuplicateOpportunityNumber\' &amp;&amp; value1 !== \'bpDuplicateOpportunityNumber\'" ng-repeat="str in value[value1] track by $index"> <span>{{str}}</span></div><div ng-if="!value[value1].length &amp;&amp; (value1 === \'ibmDuplicateOpportunityNumber\' || value1 === \'bpDuplicateOpportunityNumber\')"><span>Not Applicable</span></div></td></tr></tbody></table></div><div id="indent-vertical" ng-if="vm.visible &amp;&amp; vm.topic.topic.version &amp;&amp; vm.topic.topic.version === vm.OPP_VERSION_4"><table class="ibm-data-table ibm-grid ibm-altrows bpAuth-table"><thead><tr><th ng-repeat="name in vm.tableHeader track by $index"><b>{{name}}</b></th></tr></thead><tbody ng-if="vm.type !== &quot;validation&quot; || vm.DRPGsArr.length === 0"><tr ng-repeat="(key,value) in vm.tableRows track by $index"> <td>{{value.dealRegProductGroupID}}</td><td>{{value.dealRegProductGroupName}}</td><td>{{value.gbt20ID}}</td><td>{{value.gbt20Name}}</td><td>{{value.revenue}}</td><td>{{value.bpa}}</td><td>{{value.ta}}</td><td>{{value.value}}</td><td>{{value.specialBid}}</td><td>{{value.salesIncentive}}</td><td>{{value.engagement}}</td><td><div ng-if="value.engagementID.length" ng-repeat="str in value.engagementID track by $index"> <span>{{str}}</span></div><div ng-if="!value.engagementID.length"><span>Not Applicable</span></div></td><td>{{value.growthIncentive}}</td><td>{{value.focusIncentive}}</td><td><div ng-if="value.sbDuplicates.length" ng-repeat="str in value.sbDuplicates track by $index"> <span>{{str}}</span></div><div ng-if="!value.sbDuplicates.length"><span>Not Applicable</span></div></td><td><div ng-if="value.ssaDuplicates.length" ng-repeat="str in value.ssaDuplicates track by $index"> <span>{{str}}</span></div><div ng-if="!value.ssaDuplicates.length"><span>Not Applicable  </span></div></td><td><div ng-if="value.eiDuplicates.length" ng-repeat="str in value.eiDuplicates track by $index"> <span>{{str}}</span></div><div ng-if="!value.eiDuplicates.length"><span>Not Applicable </span></div></td></tr></tbody><tbody ng-if="vm.type === &quot;validation&quot; &amp;&amp; vm.DRPGsArr.length !== 0"><tr ng-repeat="(key,value) in vm.DRPGsArr track by $index"><td ng-repeat="(key,value1) in vm.propsV4 track by $index"><div ng-if="value[value1].length" ng-repeat="str in value[value1] track by $index"> <span>{{str}}</span></div><div ng-if="!value[value1].length"><span>Not Applicable</span></div></td></tr></tbody></table></div><div id="indent-vertical" ng-if="vm.visible &amp;&amp; vm.topic.topic.version &amp;&amp; vm.topic.topic.version &gt;= vm.OPP_VERSION_5"><table class="ibm-data-table ibm-grid ibm-altrows bpAuth-table"><thead><tr><th ng-repeat="name in vm.tableHeader track by $index"><b>{{name}}</b></th></tr></thead><tbody ng-if="vm.type !== &quot;validation&quot; || vm.DRPGsArr.length === 0"><tr ng-repeat="(key,value) in vm.tableRows track by $index"> <td>{{value.dealRegProductGroupID}}</td><td>{{value.dealRegProductGroupName}}</td><td>{{value.bpa}}</td><td>{{value.ta}}</td><td>{{value.value}}</td><td>{{value.salesIncentive}}</td><td>{{value.engagement}}</td><td><div ng-if="value.engagementID.length" ng-repeat="str in value.engagementID track by $index"> <span>{{str}}</span></div><div ng-if="!value.engagementID.length"><span>Not Applicable</span></div></td><td>{{value.growthIncentive}}</td><td>{{value.focusIncentive}}</td><td><div ng-if="value.ssaDuplicates.length" ng-repeat="str in value.ssaDuplicates track by $index"> <span>{{str}}</span></div><div ng-if="!value.ssaDuplicates.length"><span>Not Applicable  </span></div></td><td><div ng-if="value.eiDuplicates.length" ng-repeat="str in value.eiDuplicates track by $index"> <span>{{str}}</span></div><div ng-if="!value.eiDuplicates.length"><span>Not Applicable </span></div></td></tr></tbody><tbody ng-if="vm.type === &quot;validation&quot; &amp;&amp; vm.DRPGsArr.length !== 0"><tr ng-repeat="(key,value) in vm.DRPGsArr track by $index"><td ng-repeat="(key,value1) in vm.propsV4 track by $index"><div ng-if="value[value1].length" ng-repeat="str in value[value1] track by $index"> <span>{{str}}</span></div><div ng-if="!value[value1].length"><span>Not Applicable</span></div></td></tr></tbody></table></div></div>');
$templateCache.put('detail-drgcheck-decision.html','<!--author Vlad Sirotkin--><style>.field{ padding-bottom: 10px;}</style><div class="ibm columns" style="margin: 0px; border: 1px solid lightgray; padding: 10px;"><div class="ibm-columns"><div class="ibm-col-6-2"><label class="ibm-textcolor-blue-50" style="float: right">Deal Registration Government Check Decision&nbsp;</label><lock-section comp="vm.comp" style="float: none">&nbsp;</lock-section></div><div class="ibm-col-6-1 field"><span>{{vm.goeResultStatus}}</span></div></div></div>');
$templateCache.put('detail-elig-decision.html','<style>.elig_status {\n    display: inline-block;\n}\n.decision {\n    padding: 6px;\n    color: white;\n    border-radius: 10px;\n}\n.fe {\n    background-color: darkgreen;\n}\n.se {\n    background-color: darkgreen;\n}\n.eo {\n    background-color: darkgreen;\n}\n.pe {\n    background-color: orange;\n}\n.re {\n    background-color: #fd5d5d;\n}\n.ue {\n    background-color: lightgray;\n}\n.sb {\n    background-color: darkgreen;\n}\n.sosb {\n    background-color: darkgreen;\n}\n.ensb {\n    background-color: darkgreen;\n}</style><div class="ibm-columns"><div class="ibm-col-6-4"><div><b class="ibm-h3 ibm-textcolor-blue-40">Current Eligibility Decision</b><p></p><div ng-if="!vm.eligibilityUiVersion || vm.eligibilityUiVersion &lt; vm.OPP_VERSION_3"><span class="decision" ng-class="{\'sb\': vm.topic.topic.elig_dec.eligibilityDecision === \'Special Bid Only\',\'sosb\': vm.topic.topic.elig_dec.eligibilityDecision === \'Solution and Special Bid Only\',\'se\': vm.topic.topic.elig_dec.eligibilityDecision === \'Solution Only\',\'fe\': vm.topic.topic.elig_dec.eligibilityDecision === \'Fully Eligible\',\'pe\': vm.topic.topic.elig_dec.eligibilityDecision === \'Partially Eligible\', \'re\': vm.topic.topic.elig_dec.eligibilityDecision === \'Rejected\',\'ue\': vm.topic.topic.elig_dec.eligibilityDecision === \'Unknown\' || !vm.topic.topic.elig_dec.eligibilityDecision}" ng-if="!vm.emptyIdentified"><b class="ibm-h4">{{vm.topic.topic.elig_dec.eligibilityDecision}}</b></span><span ng-if="vm.emptyIdentified"><b class="ibm-h4 ibm-textcolor-red-40">Not all Brand Family Eligible Statuses have been determined - please update all before trying again</b></span></div><div class="elig_status" ng-if="vm.eligibilityUiVersion === vm.OPP_VERSION_3"><span class="decision" ng-class="{\'sb\': vm.dealRegEligDecision === \'Special Bid Only\',\'sosb\': vm.dealRegEligDecision === \'Solution and Special Bid Only\',\'se\': vm.dealRegEligDecision === \'Solution Only\',\'fe\': vm.dealRegEligDecision === \'Fully Eligible\',\'pe\': vm.dealRegEligDecision === \'Partially Eligible\', \'re\': vm.dealRegEligDecision === \'Rejected\',\'ue\': vm.dealRegEligDecision === \'Unknown\' || !vm.dealRegEligDecision}" ng-if="!vm.emptyIdentified"><b class="ibm-h4">{{vm.dealRegEligDecision}}</b></span></div><div class="elig_status" ng-if="vm.eligibilityUiVersion &gt;= vm.OPP_VERSION_4"><span class="decision" ng-class="{\'sb\': vm.dealRegEligDecision === \'Special Bid Only\',\'ensb\': vm.dealRegEligDecision === \'Engagement and Special Bid Only\',\'eo\': vm.dealRegEligDecision === \'Engagement Only\',\'fe\': vm.dealRegEligDecision === \'Fully Eligible\',\'pe\': vm.dealRegEligDecision === \'Partially Eligible\', \'re\': vm.dealRegEligDecision === \'Rejected\',\'ue\': vm.dealRegEligDecision === \'Unknown\' || !vm.dealRegEligDecision}" ng-if="!vm.emptyIdentified"><b class="ibm-h4">{{vm.dealRegEligDecision}}</b></span></div><div ng-if="!vm.eligibilityUiVersion || vm.eligibilityUiVersion &lt; vm.OPP_VERSION_3"><span ng-if="vm.topic.topic.status.status_no === 3"><span ng-if="vm.topic.decStatus !== vm.topic.topic_ext.sub_status"><md-button aria-label="Elig Status" title="Confirm Eligibility and Status" ng-disabled="vm.isButtonDisabled()" ng-class="{\'ibm-btn-pri ibm-btn-small ibm-btn-green-50\': vm.topic.topic.elig_dec.eligibilityDecision !== \'Rejected\', \'ibm-btn-pri ibm-btn-small ibm-btn-red-50\': vm.topic.topic.elig_dec.eligibilityDecision === \'Rejected\'}" type="button" ng-click="vm.updateStatus($event)"><span ng-if="!vm.status.eligDecisionFired"> <md-icon class="white_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon></span><span ng-if="vm.status.eligDecisionFired"><md-icon class="rotating" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon></span>&nbsp;<span ng-if="vm.topic.topic.elig_dec.eligibilityDecision === \'Partially Eligible\'">Change Sub-Status to Marked as Partially Eligible</span><span ng-if="vm.topic.topic.elig_dec.eligibilityDecision === \'Fully Eligible\'">Change Sub-Status to Marked as Eligible</span><span ng-if="vm.topic.topic.elig_dec.eligibilityDecision === \'Solution Only\'">Change Sub-Status to Marked as Eligible - Solution Only</span><span ng-if="vm.topic.topic.elig_dec.eligibilityDecision === \'Rejected\'">Change Status to Rejected</span><span ng-if="vm.topic.topic.elig_dec.eligibilityDecision === \'Unknown\' || !vm.topic.topic.elig_dec.eligibilityDecision">Unable to determine Eligibility</span></md-button><p class="ibm-textcolor-red-40" ng-if="!vm.topic.topic.complete.statusComplete[\'3\'] &amp;&amp; [\'Partially Eligible\',\'Fully Eligible\',\'Solution Only\'].indexOf(vm.topic.topic.elig_dec.eligibilityDecision) &gt; -1">All sections below will need to be completed before status change possible</p></span></span></div><div class="elig_status" ng-if="vm.eligibilityUiVersion === vm.OPP_VERSION_3"><md-button ng-hide="vm.isElegibilityComplete" aria-label="Elig Status" title="Confirm Eligibility and Status" ng-disabled="vm.isButtonDisabled()" ng-class="{\'ibm-btn-pri ibm-btn-small ibm-btn-green-50\': vm.dealRegEligDecision !== \'Rejected\', \'ibm-btn-pri ibm-btn-small ibm-btn-red-50\': vm.dealRegEligDecision === \'Rejected\'}" type="button" ng-click="vm.updateStatus($event)"><span ng-if="!vm.status.eligDecisionFired"> <md-icon class="white_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon></span><span ng-if="vm.status.eligDecisionFired"><md-icon class="rotating" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon></span>&nbsp;<span ng-if="vm.dealRegEligDecision === \'Partially Eligible\'">Change Sub-Status to Marked as Partially Eligible</span><span ng-if="vm.dealRegEligDecision === \'Fully Eligible\'">Change Sub-Status to Marked as Eligible</span><span ng-if="vm.dealRegEligDecision === \'Solution Only\'">Change Sub-Status to Marked as Eligible - Solution Only</span><span ng-if="vm.dealRegEligDecision === \'Solution and Special Bid Only\'">Change Sub-Status to Marked as Eligible - Solution and Special Bid Only</span><span ng-if="vm.dealRegEligDecision === \'Special Bid Only\'">Change Sub-Status to Marked as Eligible - Special Bid Only</span><span ng-if="vm.dealRegEligDecision === \'Rejected\'">Change Status to Rejected</span><span ng-if="vm.dealRegEligDecision === \'Unknown\' || !vm.dealRegEligDecision">Unable to determine Eligibility</span></md-button><p class="ibm-textcolor-red-40" ng-if="!vm.topic.topic.complete.statusComplete[\'3\'] &amp;&amp; [\'Partially Eligible\',\'Fully Eligible\',\'Solution Only\',\'Solution and Special Bid Only\'].indexOf(vm.topic.topic.elig_dec.eligibilityDecision) &gt; -1">All sections below will need to be completed before status change possible</p></div><div class="elig_status" ng-if="vm.eligibilityUiVersion &gt;= vm.OPP_VERSION_4"><md-button ng-hide="vm.isElegibilityComplete" aria-label="Elig Status" title="Confirm Eligibility and Status" ng-disabled="vm.isButtonDisabled()" ng-class="{\'ibm-btn-pri ibm-btn-small ibm-btn-green-50\': vm.dealRegEligDecision !== \'Rejected\', \'ibm-btn-pri ibm-btn-small ibm-btn-red-50\': vm.dealRegEligDecision === \'Rejected\'}" type="button" ng-click="vm.updateStatus($event)"><span ng-if="!vm.status.eligDecisionFired"> <md-icon class="white_icon" md-svg-icon="/public/images/checkbox-marked-circle.svg"></md-icon></span><span ng-if="vm.status.eligDecisionFired"><md-icon class="rotating" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon></span>&nbsp;<span ng-if="vm.dealRegEligDecision === \'Partially Eligible\'">Change Sub-Status to Marked as Partially Eligible</span><span ng-if="vm.dealRegEligDecision === \'Fully Eligible\'">Change Sub-Status to Marked as Eligible</span><span ng-if="vm.dealRegEligDecision === \'Engagement Only\'">Change Sub-Status to Marked as Eligible - Engagement Only</span><span ng-if="vm.dealRegEligDecision === \'Engagement and Special Bid Only\'">Change Sub-Status to Marked as Eligible - Engagement and Special Bid Only</span><span ng-if="vm.dealRegEligDecision === \'Special Bid Only\'">Change Sub-Status to Marked as Eligible - Special Bid Only</span><span ng-if="vm.dealRegEligDecision === \'Rejected\'">Change Status to Rejected</span><span ng-if="vm.dealRegEligDecision === \'Unknown\' || !vm.dealRegEligDecision">Unable to determine Eligibility</span></md-button><p class="ibm-textcolor-red-40" ng-if="!vm.topic.topic.complete.statusComplete[\'3\'] &amp;&amp; [\'Partially Eligible\',\'Fully Eligible\',\'Engagement Only\',\'Engagement and Special Bid Only\'].indexOf(vm.topic.topic.elig_dec.eligibilityDecision) &gt; -1">All sections below will need to be completed before status change possible</p></div></div></div></div>');
$templateCache.put('detail-elig-designation-dialog.html','<md-dialog aria-label="{{vm.field}}" ng-cloak="ng-cloak"><md-toolbar><div class="md-toolbar-tools"><h2>{{vm.dialogName}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div><span>{{vm.message}}</span></div><p></p><table class="ibm-data-table" cellspacing="0" cellpadding="0"><tr><td><span class="ibm-textcolor-blue-40">New Customer Designation&nbsp;&nbsp;</span></td><td><select style="width: 20em;" ng-model="vm.cdFlag" ng-options="flag for flag in vm.cdFlags" ng-required="true"></select></td></tr><tr><td><span class="ibm-textcolor-blue-40">Comment&nbsp;&nbsp;</span></td><td><input style="width: 20em;" ng-model="vm.comment"/></td></tr></table><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.clickYes()" ng-disabled="vm.comment.trim() === \'\' || vm.original === vm.cdFlag">{{vm.okMessage}}</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.clickNo()">{{vm.cancelMessage}}</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" style="float:right" ng-if="vm.addCancel" ng-click="vm.cancel()">Cancel</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('detail-eligibility-designation-auto.html','<div><span style="display: inline-flex;"><b class="ibm-h3 ibm-textcolor-blue-40">Customer Designation</b></span><p></p><div class="ibm-textcolor-red-40" ng-if="!vm.isCDcheckPerformed"><span ng-if="vm.cdResult.isError">Automatic Customer Designation Check could not to be performed</span></div><p></p><div class="ibm columns" style="margin: 0px; border: 1px solid lightgray; padding: 10px;"><div class="ibm-columns"><div class="ibm-col-6-2"><label class="ibm-textcolor-blue-50" style="float: right">Designation&nbsp;</label><display-error ng-if="vm.customerDesignation === \'Not determined\'" section="vm.comp" style="float: none; margin-left: 5px">&nbsp;</display-error><md-icon class="green_icon" ng-if="vm.customerDesignation !== \'Not determined\'" title="Section complete" md-svg-src="/public/images/ic_thumb_up_black_24px.svg"></md-icon></div><div class="ibm-col-6-1 field"><span>{{vm.customerDesignation}}</span></div><div class="ibm-col-6-1" ng-if="vm.cmrArray &amp;&amp; (!vm.topic.topic.version || vm.topic.topic.version &lt; vm.OPP_VERSION_5)" style="float: right"><md-icon ng-click="vm.showCmrDataList($event)" md-svg-src="/public/images/ic_remove_red_eye_black_24px.svg" style="margin-right: 0px; margin-left: 150px;"></md-icon><md-icon ng-click="vm.excelExport()" md-svg-src="/public/images/ic_file_download_black_24px.svg"></md-icon></div><div class="ibm-col-6-2" ng-if="vm.showOverrideButton()" style="float: right"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.resetDecision($event)" ng-disabled="vm.isResetting || vm.isEligibilityCompleted()" title="Override the Designation" style="float: right"><md-icon class="white_icon" md-menu-align-target="md-menu-align-target" md-svg-icon="reevaluate"></md-icon>&nbsp;Override</md-button></div></div></div><br/><br/></div>');
$templateCache.put('detail-eligibility-designation.html','<div ng-if="(vm.topic.topic.status.status_no === 3 &amp;&amp; vm.topic.topic.states.designation) || vm.topic.topic.customerDesignation"><span style="display: inline-flex;"><b class="ibm-h3 ibm-textcolor-blue-40">Customer Designation</b></span><p></p><div class="ibm columns" style="margin: 0px; border: 1px solid lightgray; padding: 10px;"><div class="ibm-columns"><div class="ibm-col-6-2"><label class="ibm-textcolor-blue-50" style="float: right">Designation&nbsp;</label><display-error section="vm.comp" style="float: none; margin-left: 5px">&nbsp;</display-error></div><div class="ibm-col-6-1 field"><span ng-if="!vm.topic.editableComponents[vm.comp].editMode"><span>{{vm.topic.topic.customerDesignation ? vm.topic.topic.customerDesignation : \'To be Confirmed\'}}</span></span><span ng-if="vm.topic.editableComponents[vm.comp].editMode"><span>{{vm.topic.topic.customerDesignation ? vm.topic.topic.customerDesignation : \'To be Confirmed\'}}</span></span></div><div class="ibm-col-6-2" style="float: right"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.resetDecision($event)" ng-disabled="vm.isResetting" ng-if="vm.showOverride" title="Override the Designation" style="float: right"><md-icon class="white_icon" md-menu-align-target="md-menu-align-target" md-svg-icon="reevaluate"></md-icon>&nbsp;Override</md-button></div></div></div><br/><br/></div>');
$templateCache.put('detail-eligibility-findcmr-comments.html','<!--Created by user on 3/24/2017.--><span class="ibm-h4" ng-click="vm.showHide()"><md-icon md-svg-src="/public/images/ic_forum_black_24px.svg"></md-icon><span>&nbsp;{{vm.show ? \'Hide\' : \'View\'}} {{vm.title}} Comments</span></span><div ng-if="vm.show"> <p></p><div layout-gt-xs="row" ng-if="vm.section!=\'nc\'"><input size="60" ng-model="vm.newComment" placeholder="Enter comments" style="padding: 5px" ng-disabled="vm.topic.editableComponents[\'comments$\'+vm.section].socket !== \'\'"/><!--md-input-containerlabel new comment\ninput(ng-model="vm.newComment")\n// div(ng-message="required") Please fill out the comment field in order to add it --><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50 md-icon-button" ng-click="vm.addCmrComment()" aria-label="Add Comment" ng-disabled="vm.newComment === \'\'" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;" title="{{{true: \'Click to insert your comments\', false: \'Please enter some comments into the field\' }[vm.newComment!==\'\']}}"><md-icon class="white_icon" md-svg-icon="/public/icons/ic_insert_comment_black_24px.svg"></md-icon></md-button><!--md-input-containermd-button(ng-click="vm.addCmrComment()" ng-disabled="vm.newComment === \'\'" style="border: 0px;" class="md-mini" aria-label="Add Comment")\n    md-icon(md-svg-src="/public/icons/ic_insert_comment_black_24px.svg")--></div><p></p><span ng-if="typeof(vm.topic.topic.comments[vm.section]) !== \'undefined\' &amp;&amp; vm.topic.topic.comments[vm.section].length &gt; 0"><table class="ibm-data-table ibm-grid ibm-altrows" data-scrollaxis="y"><thead><tr><td><b>Comment</b></td><td><b>User</b></td><td><b>Date & Time</b></td></tr></thead><tbody><tr ng-repeat="oneComment in vm.topic.topic.comments[vm.section]"><td style="min-width: 45em">{{oneComment.comment}}</td><td>{{oneComment.source}}</td><td>{{oneComment.time | date:vm.settings.up.preferences.dateFormat}}</td></tr></tbody></table></span></div>');
$templateCache.put('detail-eligibility-goe-addfields.html','<!-- Created 2018-01-30 by Kim J (card 1224)--><span class="ibm-h4"><md-icon md-svg-src="/public/images/ic_list_black_24px.svg"></md-icon><md-icon ng-hide="vm.visibleGOEAddFields" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visibleGOEAddFields" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span ng-click="vm.toggleGOEAddFields()">&nbsp;Government Determination</span><display-error section="vm.comp" style="float: none; margin-left: 5px">&nbsp;</display-error></span><span ng-if="vm.visibleGOEAddFields"><br/><br/><esc-button-section vm="vm" lock="vm.lock" style="float:right"></esc-button-section><div ng-if="!vm.isNewGoeDetermination"><table class="ibm-data-table" cellspacing="0" cellpadding="0"><tr><td><b>Overall FindCMR result</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.goe_add_fields.goe_overall_find_cmr ? vm.topic.topic.goe_add_fields.goe_overall_find_cmr: \'NA\'}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.goe_add_fields.goe_overall_find_cmr" ng-options="o as o for o in vm.goe_overall_find_cmr"></select></td></tr><tr><td><b>Declaration Letter Sent</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.goe_add_fields.goe_decl_letter_sent ? vm.topic.topic.goe_add_fields.goe_decl_letter_sent: \'NA\'}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.goe_add_fields.goe_decl_letter_sent" ng-options="o as o for o in vm.goe_decl_letter_sent"></select></td></tr><tr><td><b>GOE Indicator</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.goe_add_fields.goe_indicator ? vm.topic.topic.goe_add_fields.goe_indicator: \'NA\'}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.goe_add_fields.goe_indicator" ng-options="o as o for o in vm.goe_indicator"></select></td></tr><tr><td><b>GOE Determinant</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.goe_add_fields.goe_determinant ? vm.topic.topic.goe_add_fields.goe_determinant : \'NA\'}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.goe_add_fields.goe_determinant" ng-options="o as o for o in vm.goe_determinant"></select></td></tr><tr></tr></table></div><div ng-if="vm.isNewGoeDetermination"><table class="ibm-data-table" cellspacing="0" cellpadding="0"><tr><td><b>Overall FindGOE Result</b></td><td> <span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.goe_add_fields.v3_overall_find_goe_result ? vm.topic.topic.goe_add_fields.v3_overall_find_goe_result: \'NA\'}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.goe_add_fields.v3_overall_find_goe_result" ng-options="o as o for o in vm.overallFindGOEResult"></select></td></tr><tr><td><b>Overall GOE indicator</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.goe_add_fields.v3_overall_goe_indicator ? vm.topic.topic.goe_add_fields.v3_overall_goe_indicator : \'NA\'}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.goe_add_fields.v3_overall_goe_indicator" ng-options="o as o for o in vm.overallGoeIndicator"></select></td></tr><tr><td><b>GOE Determinant</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.goe_add_fields.v3_goe_determinant ? vm.topic.topic.goe_add_fields.v3_goe_determinant : \'NA\'}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.goe_add_fields.v3_goe_determinant" ng-options="o as o for o in vm.goeDeterminant"></select></td></tr><tr><td><b>Declaration Letter</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.goe_add_fields.v3_declaration_letter ? vm.topic.topic.goe_add_fields.v3_declaration_letter : \'NA\'}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.goe_add_fields.v3_declaration_letter" ng-options="o as o for o in vm.declarationLetter"></select></td></tr><tr></tr></table></div></span><br/>');
$templateCache.put('detail-eligibility-goe-appeal.html','<!-- Card 1226 - Domenico de Felice - 2018-02-14 - Additional fields for disputes flagged as \'appeal\'--><span ng-if="vm.visibleGOEAppealSection"><md-icon md-svg-src="/public/images/ic_list_black_24px.svg"></md-icon><md-icon ng-click="vm.toggleGOEAppealFields()" ng-hide="vm.visibleGOEAppealFields" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-click="vm.toggleGOEAppealFields()" ng-hide="!vm.visibleGOEAppealFields" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span class="ibm-h4">&nbsp;Appeal Information</span><span ng-if="vm.visibleGOEAppealFields"><esc-button-section vm="vm" lock="vm.lock" style="float:right"></esc-button-section><table class="ibm-data-table" cellspacing="0" cellpadding="0"><tr><td><b>Appeal request received</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.goe_appeal.appealRequestReceived | date: \'medium\': \'UTC\'}}</span><md-datepicker ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.goe_appeal.appealRequestReceived" ng-model-options="{ timezone: \'UTC\' }" ng-value="vm.topic.topic.goe_appeal.appealRequestReceived"></md-datepicker></td></tr><tr><td><b>Appeal validity information</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.goe_appeal.appealValidityInformation}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.goe_appeal.appealValidityInformation" ng-value="vm.topic.temp.goe_appeal.appealValidityInformation&quot;" ng-options="o as o for o in vm.appealValidityOptions"></select></td></tr><tr><td><b>Appeal Stage</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.goe_appeal.appealStage}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.goe_appeal.appealStage" ng-value="vm.topic.temp.goe_appeal.appealStage" ng-options="o as o for o in vm.appealStageOptions"></select></td></tr><tr><td><b>Appeal request sent to second review</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.goe_appeal.appealRequestSentToSecondReview | date: \'medium\': \'UTC\'}}</span><md-datepicker ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.goe_appeal.appealRequestSentToSecondReview" ng-model-options="{ timezone: \'UTC\' }" ng-value="vm.topic.topic.goe_appeal.appealRequestReceived"></md-datepicker></td></tr><tr></tr></table></span><br/><br/></span>');
$templateCache.put('detail-eligibility-gpp.html','<div class="ibm-columns" id="generalInfo"><div class="ibm-col-6-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><h2 class="ibm-h2"> <span>General Information</span></h2></div><div class="ibm-col-6-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><span><u>Last loaded on:</u></span><span>&nbsp;{{ vm.timestamp | date:vm.settings.up.preferences.dateFormat}}</span></div><div class="ibm-col-6-2 ibm-padding-top-1 ibm-padding-bottom-1 ibm-right" id="genInfo" ng-if="!vm.getNewUIInfo.uiVersion || vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_3"><div ng-if="vm.topic.loaded.topic"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.reload()" ng-disabled="vm.topic.editableComponents.gpp.socket !== \'\'" title="Click this to refresh the current Opportunity data with the latest live data - NOTE: All current Opportunity values will be overwritten, but the logs will remain" aria-label="Reload Opportunity" style="margin-left: 3px"><span ng-if="!vm.topic.editableComponents.gpp.socket"><md-icon class="white_icon" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon></span><span ng-if="vm.topic.editableComponents.gpp.socket === \'Updating\'"><md-icon class="rotating" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon></span>&nbsp;Refresh Opportunity Data</md-button><span><detail-table-log vm="vm"></detail-table-log></span></div></div></div><div class="ibm-columns" id="generalInfo"><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].opp === vm.topic.topic.gpp_live[0].opp"><label>Opportunity Number:</label></div><div ng-if="vm.topic.topic[vm.comp][0].opp !== vm.topic.topic.gpp_live[0].opp"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].opp)}}">Opportunity Number:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].opp"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.topic.topic.version &amp;&amp; vm.topic.topic.version &gt;= vm.OPP_VERSION_5"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><label>Opportunity Group ID:</label></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.opportunityGroupId"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.topic.topic.version &amp;&amp; vm.topic.topic.version &lt;= vm.OPP_VERSION_4"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].svioverallstat === vm.topic.topic.gpp_live[0].svioverallstat"><label>Overall MySA Status:</label></div><div ng-if="vm.topic.topic[vm.comp][0].svioverallstat !== vm.topic.topic.gpp_live[0].svioverallstat"><label title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].svioverallstat)}}">Overall MySA Status:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_live[0].svioverallstat"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].svisubmitdate === vm.topic.topic.gpp_live[0].svisubmitdate"><label>{{vm.getNewUIInfo.getSVISumbitDateName()}}</label></div><div ng-if="vm.topic.topic[vm.comp][0].svisubmitdate !== vm.topic.topic.gpp_live[0].svisubmitdate"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].svisubmitdate | date:vm.settings.up.preferences.dateFormat : \'UTC\')}}">{{vm.getNewUIInfo.getSVISumbitDateName()}}</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].svisubmitdate | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].sviexpdate === vm.topic.topic.gpp_live[0].sviexpdate"><label>Expiration Date:</label></div><div ng-if="vm.topic.topic[vm.comp][0].sviexpdate !== vm.topic.topic.gpp_live[0].sviexpdate"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].sviexpdate | date:vm.settings.up.preferences.dateFormat : \'UTC\')}}">Expiration Date:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].sviexpdate | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].decisiondate === vm.topic.topic.gpp_live[0].decisiondate"><label>Decision Date:</label></div><div ng-if="vm.topic.topic[vm.comp][0].decisiondate !== vm.topic.topic.gpp_live[0].decisiondate"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].decisiondate | date:vm.settings.up.preferences.dateFormat : \'UTC\')}}">Decision Date:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].decisiondate | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].salesstage === vm.topic.topic.gpp_live[0].salesstage"><label>Sales Stage:</label></div><div ng-if="vm.topic.topic[vm.comp][0].salesstage !== vm.topic.topic.gpp_live[0].salesstage"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].salesstage)}}">Sales Stage:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].salesstage"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.getNewUIInfo.uiVersion === vm.OPP_VERSION_3 || vm.getNewUIInfo.uiVersion === vm.OPP_VERSION_4"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>MySA link:</label></div></div><div class="ibm-col-4-1" id="genInfo"><a class="ibm-textcolor-blue-50 ibm-bold" href="{{vm.getNewUIInfo.externalLinks(\'mysa-deal-registration\')}}" target="_blank">{{vm.getNewUIInfo.externalLinks("mysa-deal-registration")}}</a></div></div></div></div><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"> <div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].overall_revenue === vm.topic.topic.gpp_live[0].overall_revenue"><label>Overall Opportunity Revenue:</label></div><div ng-if="vm.topic.topic[vm.comp][0].overall_revenue !== vm.topic.topic.gpp_live[0].overall_revenue"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].overall_revenue)}}">Overall Opportunity Revenue:</label></div></div><div class="ibm-col-4-1" id="genInfo"><!--label.ibm-textcolor-blue-50.ibm-bold(ng-bind="vm.topic.topic[vm.comp][0].overall_revenue")--><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.topic.topic[vm.comp][0].overall_revenue | number : 0}}</label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].crncy === vm.topic.topic.gpp_live[0].crncy"><label>Opportunity Currency:</label></div><div ng-if="vm.topic.topic[vm.comp][0].crncy !== vm.topic.topic.gpp_live[0].crncy"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].crncy)}}">Opportunity Currency:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].crncy"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].svidesc === vm.topic.topic.gpp_live[0].svidesc"><label>Description:</label></div><div ng-if="vm.topic.topic[vm.comp][0].svidesc !== vm.topic.topic.gpp_live[0].svidesc"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].svidesc)}}">Description:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].svidesc"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].svicmnt === vm.topic.topic.gpp_live[0].svicmnt"><label>Comments:</label></div><div ng-if="vm.topic.topic[vm.comp][0].svicmnt !== vm.topic.topic.gpp_live[0].svicmnt"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].svicmnt)}}">Comments:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].svicmnt"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].isrestr === vm.topic.topic.gpp_live[0].isrestr || vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><label>Is Restricted?:</label></div><div ng-if="vm.topic.topic[vm.comp][0].isrestr !== vm.topic.topic.gpp_live[0].isrestr || !vm.getNewUIInfo.uiVersion || vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_3"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].isrestr)}}">Is Restricted?:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getRestricted()" ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"></label><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].isrestr" ng-if="!vm.getNewUIInfo.uiVersion || vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_3"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.topic.topic.version &gt;= vm.OPP_VERSION_5"> <div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><label>Overall Opportunity Revenue:</label></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.getRevenueV5() | number : 0}}</label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.topic.topic.version &gt;= vm.OPP_VERSION_5"> <div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><label>Opportunity Currency:</label></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.getOppCurrencyV5()}}</label></div></div></div></div></div><div class="ibm-columns" ng-if="!vm.topic.topic.newUI"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].opp2 === vm.topic.topic.gpp_live[0].opp2"><label>Opportunity Number 2:</label></div><div ng-if="vm.topic.topic[vm.comp][0].opp2 !== vm.topic.topic.gpp_live[0].opp2"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].opp2)}}">Opportunity Number 2:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].opp2"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].sviownorg === vm.topic.topic.gpp_live[0].sviownorg"><label>Business Partner:</label></div><div ng-if="vm.topic.topic[vm.comp][0].sviownorg !== vm.topic.topic.gpp_live[0].sviownorg"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].sviownorg)}}">Business Partner:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].sviownorg"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].accnumbpinc === vm.topic.topic.gpp_live[0].accnumbpinc"><label>Customer Number:</label></div><div ng-if="vm.topic.topic[vm.comp][0].accnumbpinc !== vm.topic.topic.gpp_live[0].accnumbpinc"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].accnumbpinc)}}">Customer Number:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].accnumbpinc"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].sviownorg === vm.topic.topic.gpp_live[0].sviownorg"><label>CVR Owning Organization:</label></div><div ng-if="vm.topic.topic[vm.comp][0].sviownorg !== vm.topic.topic.gpp_live[0].sviownorg"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].sviownorg)}}">CVR Owning Organization:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].sviownorg"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].country === vm.topic.topic.gpp_live[0].country"><label>Country from Organization:</label></div><div ng-if="vm.topic.topic[vm.comp][0].country !== vm.topic.topic.gpp_live[0].cntrybpinc"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].cntrybpinc)}}">Country from Organization:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].cntrybpinc"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].isucodenum === vm.topic.topic.gpp_live[0].isucodenum"><label>ISU Code Number:</label></div><div ng-if="vm.topic.topic[vm.comp][0].isucodenum !== vm.topic.topic.gpp_live[0].isucodenum"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].isucodenum)}}">ISU Code Number:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].isucodenum"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].isucodedesc === vm.topic.topic.gpp_live[0].isucodedesc"><label>ISU Code Description:</label></div><div ng-if="vm.topic.topic[vm.comp][0].isucodedesc !== vm.topic.topic.gpp_live[0].isucodedesc"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].isucodedesc)}}">ISU Code Description:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].isucodedesc"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].exceptionreq === vm.topic.topic.gpp_live[0].exceptionreq"><label>Extension Request:</label></div><div ng-if="vm.topic.topic[vm.comp][0].exceptionreq !== vm.topic.topic.gpp_live[0].exceptionreq"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].exceptionreq)}}">Extension Request:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].exceptionreq"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].site2 === vm.topic.topic.gpp_live[0].site2"><label>Site:</label></div><div ng-if="vm.topic.topic[vm.comp][0].site2 !== vm.topic.topic.gpp_live[0].site2"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].site2)}}">Site:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].site2"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].workgpp === vm.topic.topic.gpp_live[0].workgpp"><label>Work in MySA:</label></div><div ng-if="vm.topic.topic[vm.comp][0].workgpp !== vm.topic.topic.gpp_live[0].workgpp"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].workgpp)}}">Work in MySA:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].workgpp"></label></div></div></div></div><div class="ibm-columns" id="accountInfo"><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-col-6-4" id="genInfo"><h2 class="ibm-h2">Business Partner Information</h2></div><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].bpname === vm.topic.topic.gpp_live[0].bpname"><label>Business Partner:</label></div><div ng-if="vm.topic.topic[vm.comp][0].bpname !== vm.topic.topic.gpp_live[0].bpname"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].bpname)}}">Business Partner:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bpname"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].cnum === vm.topic.topic.gpp_live[0].cnum"><label>Business Partner CEID:</label></div><div ng-if="vm.topic.topic[vm.comp][0].cnum !== vm.topic.topic.gpp_live[0].cnum"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].cnum)}}">Business Partner CEID:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].cnum"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_country === vm.topic.topic.gpp_live[0].bp_inc_country"><label>Business Partner Country:</label></div><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_country !== vm.topic.topic.gpp_live[0].bp_inc_country"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].bp_inc_country)}}">Business Partner Country:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="!vm.getNewUIInfo.uiVersion || vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_3"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_country"></label></div><div ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.bpCountry()"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Business Partner Name:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.bpName()"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Business Partner E-mail:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.email"></label></div></div></div></div></div><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><h2 class="ibm-h2">Account Information</h2><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].acctname === vm.topic.topic.gpp_live[0].acctname"><label>Account Name:</label></div><div ng-if="vm.topic.topic[vm.comp][0].acctname !== vm.topic.topic.gpp_live[0].acctname"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].acctname)}}">Account:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].acctname"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].altlaname === vm.topic.topic.gpp_live[0].altlaname"><label>Account Alternate Language Name:</label></div><div ng-if="vm.topic.topic[vm.comp][0].altlaname !== vm.topic.topic.gpp_live[0].altlaname"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].altlaname)}}">Account Alternate Language Name:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].altlaname"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].acctaddr === vm.topic.topic.gpp_live[0].acctaddr"><label>Account Address:</label></div><div ng-if="vm.topic.topic[vm.comp][0].acctaddr !== vm.topic.topic.gpp_live[0].acctaddr"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].acctaddr)}}">Account Address:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].acctaddr"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].acctcity === vm.topic.topic.gpp_live[0].acctcity"><label>Account City:</label></div><div ng-if="vm.topic.topic[vm.comp][0].acctcity !== vm.topic.topic.gpp_live[0].acctcity"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].acctcity)}}">Account City:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].acctcity"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].acctpostcode === vm.topic.topic.gpp_live[0].acctpostcode"><label>Account Postal Code:</label></div><div ng-if="vm.topic.topic[vm.comp][0].acctpostcode !== vm.topic.topic.gpp_live[0].acctpostcode"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].acctpostcode)}}">Account Postal Code:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].acctpostcode"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].acctctry === vm.topic.topic.gpp_live[0].acctctry"><label>Account Country:</label></div><div ng-if="vm.topic.topic[vm.comp][0].acctctry !== vm.topic.topic.gpp_live[0].acctctry"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].acctctry)}}">Account Country:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="!vm.getNewUIInfo.uiVersion || vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_3"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].acctctry"></label></div><div ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.accountCountry()"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].acctstate === vm.topic.topic.gpp_live[0].acctstate"><label>Account State Province:</label></div><div ng-if="vm.topic.topic[vm.comp][0].acctstate !== vm.topic.topic.gpp_live[0].acctstate"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].acctstate)}}">Account State Province:</label></div><span ng-if="vm.paSiteVisibe"><md-icon ng-click="vm.changePaVisible()" title="Show Pa Site Nums" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon></span><span ng-if="!vm.paSiteVisibe"><md-icon ng-click="vm.changePaVisible()" title="Show Pa Site Nums" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon></span></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].acctstate"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].dummyPaSite === vm.topic.topic.gpp_live[0].dummyPaSite"><label>Passport Advantage Site Number:</label></div><div ng-if="vm.topic.topic[vm.comp][0].dummyPaSite !== vm.topic.topic.gpp_live[0].dummyPaSite"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].dummyPaSite)}}">Passport Advantage Site Number:</label></div><span ng-if="vm.paSiteVisibe"><md-icon ng-click="vm.changePaVisible()" title="Show Pa Site Nums" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon></span><span ng-if="!vm.paSiteVisibe"><md-icon ng-click="vm.changePaVisible()" title="Show Pa Site Nums" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon></span></div><div class="ibm-col-4-1" id="genInfo"><md-button class="mat-button-ripple mat-ripple" ng-click="vm.showAccountArrayList()" ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3" style="margin: -5px 0px 0px -5px;"><md-icon md-svg-src="/public/images/ic_remove_red_eye_black_24px.svg" style="margin-right: 10px;"></md-icon><span style="text-transform: lowercase;">click to view</span></md-button><md-icon ng-click="vm.excelSiteIDsExport()" title="Download Site IDs" md-svg-src="/public/images/ic_file_download_black_24px.svg"></md-icon><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].dummyPaSite"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="!vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.isSiteIdDataAvailable()"><label>Passport Advantage Site Numbers:</label></div><div ng-if="!vm.isSiteIdDataAvailable()"><label class="ibm-textcolor-red-50 ibm-bold">Passport Advantage Site Numbers Data is missing</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.isSiteIdDataAvailable()"><md-button class="mat-button-ripple mat-ripple" ng-click="vm.showSiteIdData()" style="margin: -5px 0px 0px -5px;"><md-icon md-svg-src="/public/images/ic_remove_red_eye_black_24px.svg" style="margin-right: 10px;"></md-icon><span style="text-transform: lowercase;">click to view</span></md-button><md-icon ng-click="vm.excelSiteIdsV5Export()" title="Download Site IDs" md-svg-src="/public/images/ic_file_download_black_24px.svg"></md-icon></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account CMR:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.cmr"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account DCID:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getDcId()"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account DBG:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getDbg()"> </label></div></div></div></div><pa-site-num-section ng-if="vm.paSiteVisibe" editable="vm.paSiteEditable" tab="eligibility"></pa-site-num-section></div><div ng-if="!vm.topic.topic.newUI"><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_name === vm.topic.topic.gpp_live[0].bp_inc_name"><label>Account for BP Incentives:</label></div><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_name !== vm.topic.topic.gpp_live[0].bp_inc_name"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].bp_inc_name)}}">Account for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_name"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_addr === vm.topic.topic.gpp_live[0].bp_inc_addr"><label>Address for BP Incentives:</label></div><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_addr !== vm.topic.topic.gpp_live[0].bp_inc_addr"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].bp_inc_addr)}}">Address for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_addr"></label><!--label.ibm-textcolor-blue-50.ibm-bold(ng-bind="vm.topic.topic[vm.comp][0].addbpinc")--></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_city === vm.topic.topic.gpp_live[0].bp_inc_city"><label>City for BP Incentives:</label></div><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_city !== vm.topic.topic.gpp_live[0].bp_inc_city"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].bp_inc_city)}}">City for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_city"></label><!--label.ibm-textcolor-blue-50.ibm-bold(ng-bind="vm.topic.topic[vm.comp][0].citybpinc")--></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_cmr === vm.topic.topic.gpp_live[0].bp_inc_cmr"><label>IBM Acct Cust Num for BP Incentives:</label></div><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_cmr !== vm.topic.topic.gpp_live[0].bp_inc_cmr"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].bp_inc_cmr)}}">IBM Acct Cust Num for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_cmr"></label><!--label.ibm-textcolor-blue-50.ibm-bold(ng-bind="vm.topic.topic[vm.comp][0].accnumbpinc")--></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_country === vm.topic.topic.gpp_live[0].bp_inc_country"><label>Country for BP Incentives:</label></div><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_country !== vm.topic.topic.gpp_live[0].bp_inc_country"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].bp_inc_country)}}">Country for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_country"></label><!--label.ibm-textcolor-blue-50.ibm-bold(ng-bind="vm.topic.topic[vm.comp][0].cntrybpinc")--></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_state === vm.topic.topic.gpp_live[0].bp_inc_state"><label>State for BP Incentives:</label></div><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_state !== vm.topic.topic.gpp_live[0].bp_inc_state"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].bp_inc_state)}}">State for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_state"><!--label.ibm-textcolor-blue-50.ibm-bold(ng-bind="vm.topic.topic[vm.comp][0].statebpinc")--></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_zip === vm.topic.topic.gpp_live[0].bp_inc_zip"><label>ZIP Code for BP Incentives:</label></div><div ng-if="vm.topic.topic[vm.comp][0].bp_inc_zip !== vm.topic.topic.gpp_live[0].bp_inc_zip"><label class="ibm-textcolor-red-50 ibm-bold" title="{{::\'This value has changed at MySA.  The new value is: \' + (vm.topic.topic[vm.comp][0].bp_inc_zip)}}">ZIP Code for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_zip"><!--label.ibm-textcolor-blue-50.ibm-bold(ng-bind="vm.topic.topic[vm.comp][0].zipbpinc")--></label></div></div></div></div></div></div></div><div ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><deal-registration-product-group></deal-registration-product-group></div><div ng-if="!vm.getNewUIInfo.uiVersion || vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_3"><detail-brand-family comp="vm.comp" diff="true" diffArray="vm.diffArray"></detail-brand-family><detail-sales-team comp="vm.comp" diff="true" diffArray="vm.diffArray"></detail-sales-team><detail-opp-reg comp="vm.comp" diff="true" diffArray="vm.diffArray"></detail-opp-reg><detail-svi comp="vm.comp" diff="true" diffArray="vm.diffArray"></detail-svi><detail-contact-info comp="vm.comp" diff="true" diffArray="vm.diffArray"></detail-contact-info></div>');
$templateCache.put('detail-eligibility.html','<style>#indent-vertical {\n  display: block; \n  padding: 10px 0 10px 0;\n}</style><form class="ibm-column-form" method="post"><!-- UI Version 1--><div ng-if="vm.getNewUIInfo.uiVersion === vm.OPP_VERSION_1"><detail-gpp-static></detail-gpp-static><eligibility-decision-section id="indent-vertical"></eligibility-decision-section><detail-table-compl-cl id="indent-vertical"></detail-table-compl-cl><div id="indent-vertical" layout="column"></div><span style="display: flex;"><b class="ibm-h3 ibm-textcolor-blue-40">Government Check Results</b><display-error section="vm.goeCheck" style="margin-left:10px; padding-top:2px"></display-error></span><detail-table-fcmr id="indent-vertical" flex="flex"></detail-table-fcmr><detail-eligibility-findcmr-comments id="indent-vertical" title="Find CMR" section="findCmr" flex="flex"></detail-eligibility-findcmr-comments><attachment-section id="indent-vertical" title="Find CMR" section="fcmr" flex="flex"></attachment-section><detail-table-compl-cl2 id="indent-vertical" flex="flex"></detail-table-compl-cl2><detail-eligibility-goe-addfields id="indent-vertical" flex="flex"></detail-eligibility-goe-addfields><goe-section id="indent-vertical" flex="flex"></goe-section><div id="indent-vertical" layout="column"><customer-designation flex="flex"></customer-designation><detail-eligibility-goe-appeal></detail-eligibility-goe-appeal><new-client-determination id="indent-vertical"></new-client-determination><detail-eligibility-findcmr-comments id="indent-vertical" title="AIW" section="nc"></detail-eligibility-findcmr-comments><attachment-section id="indent-vertical" title="AIW" section="nc"></attachment-section><b class="ibm-h3 ibm-textcolor-blue-40">Duplicate Check Results</b><detail-table-dupl-check id="indent-vertical" data="vm.isNewOppty"></detail-table-dupl-check><detail-table-compl-cl3 id="indent-vertical" data="vm.isNewOppty"></detail-table-compl-cl3><b class="ibm-h3 ibm-textcolor-blue-40">Attachments</b><attachment-section id="indent-vertical" title="Eligibility" section="eligibility"></attachment-section><attachment-mysa-section id="indent-vertical" title="MYSA" section="mysa"></attachment-mysa-section></div></div><!-- UI Version 2--><div ng-if="vm.getNewUIInfo.uiVersion === vm.OPP_VERSION_2"><detail-gpp-static></detail-gpp-static><eligibility-decision-section id="indent-vertical"></eligibility-decision-section><detail-table-compl-cl id="indent-vertical"></detail-table-compl-cl><div id="indent-vertical" layout="column"></div><span ng-if="vm.topic.topic.version" style="display: flex;"><b class="ibm-h3 ibm-textcolor-blue-40">Government Check Results</b><display-error section="vm.goeCheck" style="margin-left:10px; padding-top:2px"></display-error></span><detail-table-drg-check id="indent-vertical" data="vm.checksData.GOE" flex="flex"></detail-table-drg-check><drg-check-decision-section id="indent-vertical" data="vm.checksData.GOE" flex="flex"></drg-check-decision-section><detail-table-ig-check id="indent-vertical" data="vm.checksData.GOE" flex="flex"></detail-table-ig-check><detail-eligibility-findcmr-comments id="indent-vertical" title="Find CMR" section="findCmr" flex="flex"></detail-eligibility-findcmr-comments><attachment-section id="indent-vertical" title="Find CMR" section="fcmr" flex="flex"></attachment-section><detail-eligibility-goe-addfields id="indent-vertical" flex="flex"></detail-eligibility-goe-addfields><goe-section id="indent-vertical" flex="flex"></goe-section><div id="indent-vertical" layout="column"><customer-designation-auto data="vm.checksData.CD" flex="flex"></customer-designation-auto><detail-eligibility-goe-appeal></detail-eligibility-goe-appeal><new-client-determination id="indent-vertical" data="vm.checksData.NC"></new-client-determination><detail-eligibility-findcmr-comments id="indent-vertical" title="AIW" section="nc"></detail-eligibility-findcmr-comments><attachment-section id="indent-vertical" title="AIW" section="nc"></attachment-section><b class="ibm-h3 ibm-textcolor-blue-40">Duplicate Check Results</b><detail-table-dupl-check-automatic id="indent-vertical"></detail-table-dupl-check-automatic><detail-table-dupl-check id="indent-vertical"></detail-table-dupl-check><detail-table-dupl-check-results id="indent-vertical"></detail-table-dupl-check-results><b class="ibm-h3 ibm-textcolor-blue-40">Attachments</b><attachment-section id="indent-vertical" title="Eligibility" section="eligibility"></attachment-section><attachment-mysa-section id="indent-vertical" title="MYSA" section="mysa"></attachment-mysa-section></div></div><!-- UI Version 3 and more--><div ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><detail-gpp-static></detail-gpp-static><eligibility-decision-section id="indent-vertical"></eligibility-decision-section><bant-form-table id="indent-vertical" ng-if="!vm.topic.topic.version || vm.topic.topic.version &lt; vm.OPP_VERSION_5" data="vm.bantData"></bant-form-table><detail-table-bp-authorization id="indent-vertical"></detail-table-bp-authorization><div id="indent-vertical" layout="column"></div><span style="display: flex;"><b class="ibm-h3 ibm-textcolor-blue-40">Government Check Results</b><display-error section="vm.goeCheck" style="margin-left:10px; padding-top:2px"></display-error></span><detail-table-drg-check id="indent-vertical" ng-if="!vm.topic.topic.version || vm.topic.topic.version &lt; vm.OPP_VERSION_5" data="vm.checksData.GOE" flex="flex"></detail-table-drg-check><drg-check-decision-section id="indent-vertical" ng-if="!vm.topic.topic.version || vm.topic.topic.version &lt; vm.OPP_VERSION_5" data="vm.checksData.GOE" flex="flex"></drg-check-decision-section><detail-table-ig-check id="indent-vertical" data="vm.checksData.GOE" flex="flex"></detail-table-ig-check><detail-eligibility-findcmr-comments id="indent-vertical" title="Find CMR" section="findCmr" flex="flex"></detail-eligibility-findcmr-comments><attachment-section id="indent-vertical" title="Find CMR" section="fcmr" flex="flex"></attachment-section><eligibility-goe-history id="indent-vertical" ng-if="vm.isDisplayHistory()" flex="flex"></eligibility-goe-history><detail-eligibility-goe-addfields id="indent-vertical" ng-if="vm.isCheckListVisible" flex="flex"></detail-eligibility-goe-addfields><goe-section id="indent-vertical" flex="flex"></goe-section><div id="indent-vertical" layout="column"><customer-designation-auto data="vm.checksData.CD" flex="flex"></customer-designation-auto><detail-eligibility-goe-appeal></detail-eligibility-goe-appeal><!-- UI Version 3 only--><new-client-determination id="indent-vertical" data="vm.checksData.NC" ng-if="vm.getNewUIInfo.uiVersion === vm.OPP_VERSION_3"></new-client-determination><detail-eligibility-findcmr-comments id="indent-vertical" title="AIW" section="nc" ng-if="vm.getNewUIInfo.uiVersion === vm.OPP_VERSION_3"></detail-eligibility-findcmr-comments><attachment-section id="indent-vertical" title="AIW" section="nc" ng-if="vm.getNewUIInfo.uiVersion === vm.OPP_VERSION_3"></attachment-section><b class="ibm-h3 ibm-textcolor-blue-40">Duplicate Check Results</b><detail-table-bp-check id="indent-vertical"></detail-table-bp-check><!-- UI Version 3 only--><detail-table-ibm-check id="indent-vertical" ng-if="vm.getNewUIInfo.uiVersion === vm.OPP_VERSION_3"></detail-table-ibm-check><detail-table-dupl-check id="indent-vertical"></detail-table-dupl-check><detail-table-dupl-check-results id="indent-vertical"></detail-table-dupl-check-results><b class="ibm-h3 ibm-textcolor-blue-40">Attachments</b><attachment-section id="indent-vertical" title="Eligibility" section="eligibility"></attachment-section><attachment-section id="indent-vertical" ng-if="!vm.topic.topic.version || vm.topic.topic.version &lt; vm.OPP_VERSION_5" title="MYSA" section="mysa"></attachment-section></div></div></form><br/><detail-comment></detail-comment>');
$templateCache.put('detail-file-upload.html','<!--@author Ivan Toth--><style>.fileCom{ padding-bottom: 0px; font-size: small};</style><span class="ibm-h4" ng-click="vm.showHide()"><md-icon md-svg-src="/public/images/ic_attachment_black_24px.svg"></md-icon><span ng-if="!vm.showAttachment">&nbsp;View {{vm.title}} Attachments</span><span ng-if="vm.showAttachment">&nbsp;Hide {{vm.title}} Attachments</span><span ng-if="vm.topic.topic[vm.comp].locked"></span><lock-section comp="vm.comp"></lock-section></span><div class="ibm-columns" ng-if="vm.showAttachment"><span ng-if="vm.topic.topic.lock_indicator[vm.comp].locked"><p></p><span class="ibm-textcolor-gray-30">Locked by</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp].user}}</span><span class="ibm-textcolor-gray-30">&nbsp;on</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp].date | date: $ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></span></div><div class="ibm-columns" ng-if="vm.showAttachment"><p></p><div class="ibm-col-6-4"><div ng-if="vm.topic.topic.files != 0 || vm.topic.temp.files.length &gt; 0"><table class="ibm-data-table ibm-grid ibm-altrows" ng-if="!vm.topic.editableComponents[vm.comp].socket &amp;&amp; vm.edit.editMode"><tr><th>File</th><th>Comments & User Details</th></tr><tr ng-repeat="fil in vm.topic.temp.files| filter: { type: vm.section }"><td style="width: 15em"><span><md-icon md-svg-src="/public/images/ic_attachment_black_24px.svg"></md-icon>&nbsp;</span><u ng-click="vm.downloadAttachment(fil.name)" title="Download {{::vm.decode(fil.name)}}">{{::vm.decode(fil.name)}}</u></td><td style="width: 40em"><input ng-model="fil.comment" ng-change="vm.commentChange(fil.name)" style="padding: 2px; width: 30em"/><p></p><md-icon md-svg-src="/public/images/ic_expand_more_black_24px.svg" ng-if="fil.visible"></md-icon><md-icon md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg" ng-if="!fil.visible"></md-icon><u class="fileCom" ng-click="vm.showUserData(fil, !fil.visible)">User Details</u><span ng-if="fil.visible"><p class="fileCom">Uploaded by&nbsp;<b>{{fil.uploadBy}}</b>&nbsp;on&nbsp;<b>{{fil.date | date:vm.settings.up.preferences.dateFormat : \'UTC\'}}</b></p><p class="fileCom" ng-if="fil.lmUser">Comments last modified by&nbsp;<b>{{fil.lmUser}}</b>&nbsp;on&nbsp;<b>{{fil.lmDate | date:vm.settings.up.preferences.dateFormat : \'UTC\'}}</b></p></span></td></tr></table><table class="ibm-data-table ibm-grid ibm-altrows" ng-if="!(!vm.topic.editableComponents[vm.comp].socket &amp;&amp; vm.edit.editMode)"><tr><th>File</th><th>Comments & User Details</th></tr><tr ng-repeat="fil in vm.topic.topic.files| filter: { type: vm.section }"><td style="width: 15em"><span><md-icon md-svg-src="/public/images/ic_attachment_black_24px.svg"></md-icon>&nbsp;</span><u ng-click="vm.downloadAttachment(fil.name)" title="Download {{::vm.decode(fil.name)}}">{{::vm.decode(fil.name)}}</u></td><td style="width: 40em"><span>{{fil.comment ? fil.comment : \'-\'}}</span><p></p><md-icon md-svg-src="/public/images/ic_expand_more_black_24px.svg" ng-if="fil.visible"></md-icon><md-icon md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg" ng-if="!fil.visible"></md-icon><u class="fileCom" ng-click="vm.showUserData(fil, !fil.visible)">User Details</u><span ng-if="fil.visible"><p class="fileCom">Uploaded by&nbsp;<b>{{fil.uploadBy}}</b>&nbsp;on&nbsp;<b>{{fil.date | date:vm.settings.up.preferences.dateFormat : \'UTC\'}}</b></p><p class="fileCom" ng-if="fil.lmUser">Comments last modified by&nbsp;<b>{{fil.lmUser}}</b>&nbsp;on&nbsp;<b>{{fil.lmDate | date:vm.settings.up.preferences.dateFormat : \'UTC\'}}</b></p></span></td></tr></table><span ng-if="vm.topic.topic.files == 0"><span>No files uploaded.</span></span></div><br/></div><div class="ibm-col-6-2" style="float: right"><div style="border: 1px solid lightgray; height: 50px; float: right" ng-if="vm.topic.loaded.topic"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50 md-icon-button" ng-disabled="vm.topic.editableComponents[vm.comp].socket" aria-label="Upload File" ngf-select="vm.uploadFiles($files)" multiple="multiple" ngf-max-size="5MB" ngf-drop="vm.setSource()" ng-model="vm.sources" style="width: 37px;height: 30px;padding: 6px;margin-top: 6px; margin-left: 7px;" title="Upload a File"><md-icon class="white_icon" md-svg-icon="/public/images/ic_file_upload_black_24px.svg"></md-icon></md-button><esc-button-section style="float:right; margin-top: 12px" vm="vm" lock="vm.lockEnabled"></esc-button-section></div><div ng-if="!vm.topic.loaded.topic"><md-icon class="rotating" md-svg-src="/public/images/ic_autorenew_black_24px.svg"></md-icon></div></div></div>');
$templateCache.put('detail-goe.html','<style>.field{ padding-bottom: 10px;}</style><div class="ibm columns" style="margin: 0px; border: 1px solid lightgray; padding: 10px;"><div class="ibm-columns"><div class="ibm-col-6-2"><label class="ibm-textcolor-blue-50" style="float: right">Incentives Government Check Decision&nbsp;</label><lock-section comp="vm.comp" style="float: none">&nbsp;</lock-section><display-error section="vm.completeSection" style="float: none; margin-left: 5px">&nbsp;</display-error></div><div class="ibm-col-6-1 field"><span ng-if="!vm.topic.editableComponents.goe.editMode"><span>{{vm.topic.topic.goe.picked || \'To be Confirmed\'}}</span></span><span ng-if="vm.topic.editableComponents.goe.editMode"><select style="width: 10em" ng-model="vm.topic.temp.goe.picked" ng-options="o as o for o in vm.goeOptions" ng-change="vm.topic.setUSFed(\'goe\')"></select></span></div><div class="ibm-col-6-2" ng-if="vm.topic.loaded.topic &amp;&amp; vm.topic.topic.complete.goeCheck" style="float: right"><div style="border: 1px solid lightgray; height: 50px; float: right"><esc-button-section style="float:right; margin-top: 12px" vm="vm" lock="vm.lock"></esc-button-section></div></div></div><div class="ibm-columns" ng-show="[\'Yes\'].indexOf(vm.topic.temp.goe.picked) &gt; -1 &amp;&amp; vm.topic.topic.country === \'US\'"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50" style="float: none">Is this a US Federal Disbursement?&nbsp;</label></div><div class="ibm-col-6-1 field"><span ng-if="vm.topic.editableComponents.goe.editMode"><input type="radio" ng-model="vm.topic.temp.goe.usfederal" ng-value="true" ng-change="vm.topic.usFed.status = true"/>Yes<input type="radio" ng-model="vm.topic.temp.goe.usfederal" ng-value="false" ng-change="vm.topic.usFed.status = false"/>No</span><span ng-if="!vm.topic.editableComponents.goe.editMode">{{vm.topic.topic.goe.usfederal ? \'Yes\' : \'No\'}}</span></div><div class="ibm-col-6-3" ng-if="vm.topic.temp.goe.usfederal"><span class="ibm-textcolor-red-50">Since this is confirmed as a US Federal Disbursement, the content needs to be removed from DMT for legal reasons.  &nbsp;Please click the button below.</span><p></p><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-disabled="vm.topic.usFed.beingDeleted" ng-click="vm.topic.confirmUSFederal($event)"><md-icon class="white_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Delete Disbursement from DMT</md-button><span ng-if="vm.topic.usFed.beingDeleted">&nbsp;<span class="ibm-textcolor-blue-30 ibm-h4">Deleting...please wait...</span><span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></span></div></div></div>');
$templateCache.put('detail-new-client.html','<span style="display: inline-flex;"><b class="ibm-h3 ibm-textcolor-blue-40">New Client Determination</b><display-error ng-if="vm.showThumb" section="vm.comp" style="margin-left:10px;"></display-error></span><p></p><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span><span>&nbsp;AIW</span></span></span><span ng-if="vm.visible"><div ng-if="vm.getNewUIInfo.NC.isError &amp;&amp; vm.topic.topic[vm.comp].results"><br/><p class="ibm-textcolor-red-50">{{vm.getNewUIInfo.NC.error}}</p></div><div class="ibm-columns"><span><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.toggleFilter()" ng-disabled="vm.isButtonDisabled()" title="{{{true: \'Toggle Search Parameters\', false: \'Section Locked\' }[vm.topic.editableComponents[vm.comp].socket===\'\']}}" aria-label="DC Search" style="margin-left: 3px; float: right"><md-icon ng-class="{white_icon : vm.topic.editableComponents[vm.comp].socket === \'\', black_icon: !vm.topic.editableComponents[vm.comp].socket !== \'\'}" md-svg-src="/public/images/ic_filter_list_black_24px.svg"></md-icon>&nbsp;{{vm.filterDisplay ? \'Hide\' : \'Show\' }} Search Parameters</md-button></span><div class="ibm-columns" ng-form="vm.newClientForm" ng-if="vm.filterDisplay" style="border: 1px solid lightgray; padding:10px 0px 10px 10px"><div class="ibm-columns"><div class="ibm-col-6-2"><span class="ibm-textcolor-blue-40">Customer Name&nbsp;</span><p></p><input name="name" ng-change="vm.formChecker()" ng-model="vm.newClient.fuzzySearch" aria-label="name" style="padding:6px" size="40" placeholder="Customer Name"/></div><div class="ibm-col-6-2"><span class="ibm-textcolor-blue-40">CMR Number&nbsp;</span><p></p><input name="number" ng-change="vm.formChecker()" ng-model="vm.newClient.cmrNum" ng-pattern="/^[a-zA-Z0-9]{1,8}$/" type="text" placeholder="CMR Number"/><md-icon class="red_icon" ng-if="vm.newClientForm.number.$error.pattern" title="CMR Number Invalid. Must be alphanumeric no more than 8 in length. Please amend." style="margin-left: 3px;" md-svg-src="/public/images/close-circle.svg"></md-icon></div><div class="ibm-col-6-2"><span class="ibm-textcolor-blue-40">Customer Country Landed</span><p></p><select ng-change="vm.formChecker()" ng-model="vm.newClient.country" ng-options="{cc: item.cc, ctry: item.country, aiw: item.aiw} as item.country for item in vm.settings.country_list | filter:item.ic = \'Country\' | orderBy: \'country\'" ng-required="true" style="width: 18em"></select><p></p></div></div><div class="ibm-columns"><div class="ibm-col-1-1"></div><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.doSearch(vm.topic.topic._id.substring(4))" ng-disabled="!vm.errorCheckerInput" layout="row"><span>SEARCH</span></md-button></div></div></div><div ng-if="vm.topic.topic[vm.comp].results"><div style="display: grid; grid-template-columns: repeat(7, 200px); align-items: center;"><div class="ibm-padding-top-1 ibm-padding-bottom-1"><b>Source</b></div><div class="ibm-padding-top-1 ibm-padding-bottom-1"><b>CMR#</b></div><div class="ibm-padding-top-1 ibm-padding-bottom-1"><b title="Fuzzy search versus the selected data">Key word search</b></div><div class="ibm-padding-top-1 ibm-padding-bottom-1"><b>Country</b></div><div class="ibm-padding-top-1 ibm-padding-bottom-1"><b>Search Time</b></div><div class="ibm-padding-top-1 ibm-padding-bottom-1"><b>Who</b></div><div class="ibm-padding-top-1 ibm-padding-bottom-1"><b>Action</b></div></div><div ng-repeat="tab in vm.topic.topic[vm.comp].results | filter: vm.dcFilter"><multi-dc-table item="tab" row="$index" comp="vm.comp" filter="vm.dcFilter"></multi-dc-table></div><br/><div class="ibm columns" style="border: 1px solid lightgray; padding: 10px; display: grid; grid-template-columns: 150px 100px auto; align-items: center;"><div><label class="ibm-textcolor-blue-50">Is New Client&nbsp;</label></div><div ng-if="!vm.getNewUIInfo.uiVersion || vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_3"><div ng-if="vm.edit.editable"><span><md-radio-group ng-disabled="!vm.edit.editMode" ng-model="vm.topic.temp.nc.ncDecision" layout="row"><md-radio-button data-ng-value="true">Yes</md-radio-button><md-radio-button data-ng-value="false">No</md-radio-button></md-radio-group></span></div><div ng-if="!vm.edit.editable"><span><md-radio-group ng-disabled="!vm.edit.editMode" ng-model="vm.topic.topic.nc.ncDecision" layout="row"><md-radio-button data-ng-value="true">Yes</md-radio-button><md-radio-button data-ng-value="false">No</md-radio-button></md-radio-group></span></div></div><div ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><div ng-if="vm.getNewUIInfo.NC.isError"><div ng-if="!vm.edit.editMode"><span><md-radio-group ng-disabled="!vm.edit.editMode" ng-model="vm.topic.topic.nc.ncDecision" layout="row"><md-radio-button data-ng-value="true">Yes</md-radio-button><md-radio-button data-ng-value="false">No</md-radio-button></md-radio-group></span></div><div ng-if="vm.edit.editMode"><span><md-radio-group ng-disabled="!vm.edit.editMode" ng-model="vm.topic.temp.nc.ncDecision" layout="row"><md-radio-button data-ng-value="true">Yes</md-radio-button><md-radio-button data-ng-value="false">No            </md-radio-button></md-radio-group></span></div></div><div ng-if="!vm.getNewUIInfo.NC.isError"><span><md-radio-group ng-disabled="!vm.edit.editMode" ng-model="vm.topic.topic.nc.ncDecision" layout="row"><md-radio-button data-ng-value="true">Yes</md-radio-button><md-radio-button data-ng-value="false">No</md-radio-button></md-radio-group></span></div></div><div ng-if="vm.topic.loaded.topic &amp;&amp; (!vm.getNewUIInfo.uiVersion || vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_3)" style="float: right"><div ng-if="vm.edit.editable" style="border: 1px solid lightgray; height: 50px; float: right"><esc-button-section style="float:right; margin-top: 12px" vm="vm" lock="vm.lock"></esc-button-section></div><div ng-if="!vm.edit.editable" style="border: 1px solid lightgray; height: 50px; float: right"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-gray-50 md-icon-button" ng-disabled="true" style="margin: 6px"><md-icon class="white_icon" md-svg-icon="/public/images/ic_do_not_disturb_alt_black_24px.svg"></md-icon></md-button></div></div><div ng-if="vm.topic.loaded.topic &amp;&amp; vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3" style="float: right"><div ng-if="!vm.isNewClientV3Disabled()" style="border: 1px solid lightgray; height: 50px; float: right"><esc-button-section style="float:right; margin-top: 12px" vm="vm" lock="vm.lock"></esc-button-section></div><div ng-if="vm.isNewClientV3Disabled()" style="border: 1px solid lightgray; height: 50px; float: right"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-gray-50 md-icon-button" ng-disabled="true" style="margin: 6px"><md-icon class="white_icon" md-svg-icon="/public/images/ic_do_not_disturb_alt_black_24px.svg"></md-icon></md-button></div></div></div><div style="display: grid; grid-template-columns: repeat(2, 300px); padding-top: 10px;"><div><md-icon md-svg-src="/public/images/ic_warning_black_24px.svg"></md-icon><span>&nbsp;New Client Applicability End Date</span></div><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.ncEndData | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></label></div></div></div></span>');
$templateCache.put('detail-table-bant-form.html','<style>.action-width-4 {\n    width: 15em;\n}\n.action-width-none {\n    width: none;\n}</style><div layout="column"><div flex="flex"><span><b class="ibm-h3 ibm-textcolor-blue-40">Eligibility Checklist Section</b></span></div></div><div id="indent-vertical" flex="flex"><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_list_black_24px.svg"></md-icon><md-icon class="orange_icon" ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon class="orange_icon" ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span ng-bind="::vm.tableName"></span></span><div class="ibm-columns" ng-if="vm.visible" style="margin: 0px; padding: 10px;"><div class="ibm-col-6-4"><table class="ibm-data-table ibm-grid ibm-altrows"><tr ng-repeat="question in vm.data | orderBy:&quot;questionNumber&quot;"><td title="{{question.label}}" style="width: 15em">{{question.shortDescription}}</td><td style="width: 15em">{{question.value}}</td></tr></table></div></div></div>');
$templateCache.put('detail-table-bp-authorization.html','<!-- author Vlad--><style>#indent-vertical {\n    display: block;\n    padding: 10px 0 10px;\n} \n.bp-table * {\n    font-size: 14px;\n}\n.bp-table {\n    display: block;\n    overflow: auto;\n    border: 0 !important;\n}\n.bp-table > thead > tr > th,\n.bp-table > tbody > tr > td {\n    text-align: center;\n    vertical-align: middle;\n}\n.bp-table-border thead tr:first-child th:nth-last-child(2) {\n    border-bottom: 0;\n}\n.bp-table tbody label {\n    text-align: left;\n}\n.bp-table md-input-container {\n    float: left;\n    padding: 2px 8px 2px;\n}\n.bp-table button,\n.bp-table button:hover {\n    border: 0;\n}\n.bp-table .comments {\n    padding: 0 15px 0;\n}\n.bp-table .cut-text {\n    text-overflow: ellipsis;\n    overflow: hidden; \n    width: 130px; \n    height: 1.2em; \n    white-space: nowrap;\n}\n.bp-table input {\n    margin: 10px 15px;\n}\n.bp-table .bp-content,\n.bp-table tbody tr td:last-child div {\n    display: flex;\n}\n.bp-table tbody tr td:last-child button {\n    width: 37px;\n    height: 37px;\n    padding: 6px;\n}</style><div layout="column"><div flex="flex"><span><b class="ibm-h3 ibm-textcolor-blue-40">BP Authorization Check Results</b></span></div><div id="indent-vertical" flex="flex"><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span><span>{{vm.tableName}}</span><span ng-if="vm.tableError"><md-icon class="red_icon" title="{{vm.tableError}}" md-svg-src="/public/images/ic_warning_black_24px.svg"></md-icon></span><span class="ibm-textcolor-blue-40" style="font-size:medium"> Click to {{vm.visible ? \'hide\' : \'view\'}}</span></span></span><div id="indent-vertical" ng-if="vm.visible &amp;&amp; vm.topic.topic.version &amp;&amp; vm.topic.topic.version &gt;= vm.OPP_VERSION_5"><span layout="row" style="margin-top:10px"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.save()" ng-if="vm.isTableEditMode">Save</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.cancel()" ng-if="vm.isTableEditMode">Cancel</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" ng-click="vm.edit()" ng-disabled="!vm.isEditButtonEnabled()" ng-if="!vm.isTableEditMode">Edit</md-button></span><table class="ibm-data-table ibm-grid ibm-altrows bp-table bp-table-border"><thead><tr><th ng-repeat="name in vm.tableHeader[0] | limitTo:vm.tableHeader[0].length-2 track by $index" rowspan="2"><b>{{name}}</b></th><th ng-repeat="name in vm.tableHeader[0] | limitTo:1:vm.tableHeader[0].length-2 track by $index" colspan="4"><b>{{name}}</b></th><th ng-repeat="name in vm.tableHeader[0] | limitTo:-1 track by $index" rowspan="2"><b>{{name}}</b></th></tr><tr><th ng-repeat="name in vm.tableHeader[1] track by $index"><b>{{name}}</b></th></tr></thead><tbody><tr ng-repeat="(key,value) in vm.tableRows track by $index"><!-- Product Group--><td>{{value.productGroup}}</td><td>{{value.productGroupID}}</td><td>{{value.dealRegProductGroupID}}</td><td>{{value.dealRegProductGroupName}}</td><td><div ng-if="vm.displayValueDecision(value.bpAgreement, key, \'bpaDecision\')">{{value.bpAgreement}}</div><div ng-if="!vm.displayValueDecision(value.bpAgreement, key, \'bpaDecision\')"><div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].bpaDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.bpaProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].bpaDecision.value}}</span></div></div></td><td><div ng-if="vm.displayValueDecision(value.transactionAgreement, key, \'taDecision\')">{{value.transactionAgreement}}</div><div ng-if="!vm.displayValueDecision(value.transactionAgreement, key, \'taDecision\')"><div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].taDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.taProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].taDecision.value}}</span></div></div></td><td><div ng-if="vm.displayValueDecision(value.skills, key, \'skillsDecision\')">{{value.skills}}</div><div ng-if="!vm.displayValueDecision(value.skills, key, \'skillsDecision\')"><div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].skillsDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.valuesProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].skillsDecision.value}}</span></div></div></td><td><div ng-if="vm.displayValueDecision(value.competency, key, \'compDecision\')">{{value.competency}}</div><div ng-if="!vm.displayValueDecision(value.competency, key, \'compDecision\')"> <div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].compDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.valuesProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].compDecision.value}}</span></div></div></td><td><div ng-if="vm.displayValueDecision(value.solution, key, \'solDecision\')">{{value.solution}}</div><div ng-if="!vm.displayValueDecision(value.solution, key, \'solDecision\')"> <div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].solDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.valuesProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].solDecision.value}}</span></div></div></td><td><div ng-if="vm.displayValueDecision(value.valueDecision, key, \'valDecision\')">{{value.valueDecision}}</div><div ng-if="!vm.displayValueDecision(value.valueDecision, key, \'valDecision\')"> <div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].valDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.valuesProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].valDecision.value}}</span></div></div></td><td><div ng-if="!vm.isCompletedAutomatically(value, key)"><md-icon class="red_icon" ng-if="!vm.isRowCompleted(key)" md-svg-src="/public/images/ic_error_black_24px.svg"></md-icon><md-icon class="green_icon" ng-if="vm.isRowCompleted(key)" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon><div class="bp-content" ng-if="vm.isTableEditMode"><input ng-model="vm.stateList[key].comments"/></div><div class="bp-content" ng-if="!vm.isTableEditMode"><span class="comments cut-text">{{vm.stateList[key].comments}}</span></div></div><div class="bp-content" ng-if="vm.isCompletedAutomatically(value, key)"><md-icon class="green_icon" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon><span class="comments cut-text" title="checks completed automatically">checks completed automatically</span></div></td></tr></tbody></table></div><div id="indent-vertical" ng-if="vm.visible &amp;&amp; vm.topic.topic.version &amp;&amp; vm.topic.topic.version &lt; vm.OPP_VERSION_5"><span layout="row" style="margin-top:10px"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.save()" ng-if="vm.isTableEditMode">Save</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.cancel()" ng-if="vm.isTableEditMode">Cancel</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" ng-click="vm.edit()" ng-disabled="!vm.isEditButtonEnabled()" ng-if="!vm.isTableEditMode">Edit</md-button></span><table class="ibm-data-table ibm-grid ibm-altrows bp-table bp-table-border"><thead><tr><th ng-repeat="name in vm.tableHeader[0] | limitTo:vm.tableHeader[0].length-2 track by $index" rowspan="2"><b>{{name}}</b></th><th ng-repeat="name in vm.tableHeader[0] | limitTo:1:vm.tableHeader[0].length-2 track by $index" colspan="4"><b>{{name}}</b></th><th ng-repeat="name in vm.tableHeader[0] | limitTo:-1 track by $index" rowspan="2"><b>{{name}}</b></th></tr><tr><th ng-repeat="name in vm.tableHeader[1] track by $index"><b>{{name}}</b></th></tr></thead><tbody><tr ng-repeat="(key,value) in vm.tableRows track by $index"><td>{{value.productGroup}}</td><td>{{value.productGroupID}}</td><td>{{value.dealRegProductGroupID}}</td><td>{{value.dealRegProductGroupName}}</td><td>{{value.gbt20ID}} </td><td>{{value.gbt20Name}}</td><td><div ng-if="vm.displayValueDecision(value.bpAgreement, key, \'bpaDecision\')">{{value.bpAgreement}}</div><div ng-if="!vm.displayValueDecision(value.bpAgreement, key, \'bpaDecision\')"><div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].bpaDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.bpaProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].bpaDecision.value}}</span></div></div></td><td><div ng-if="vm.displayValueDecision(value.transactionAgreement, key, \'taDecision\')">{{value.transactionAgreement}}</div><div ng-if="!vm.displayValueDecision(value.transactionAgreement, key, \'taDecision\')"><div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].taDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.taProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].taDecision.value}}</span></div></div></td><td><div ng-if="vm.displayValueDecision(value.skills, key, \'skillsDecision\')">{{value.skills}}</div><div ng-if="!vm.displayValueDecision(value.skills, key, \'skillsDecision\')"><div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].skillsDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.valuesProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].skillsDecision.value}}</span></div></div></td><td><div ng-if="vm.displayValueDecision(value.competency, key, \'compDecision\')">{{value.competency}}</div><div ng-if="!vm.displayValueDecision(value.competency, key, \'compDecision\')"> <div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].compDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.valuesProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].compDecision.value}}</span></div></div></td><td><div ng-if="vm.displayValueDecision(value.solution, key, \'solDecision\')">{{value.solution}}</div><div ng-if="!vm.displayValueDecision(value.solution, key, \'solDecision\')"> <div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].solDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.valuesProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].solDecision.value}}</span></div></div></td><td><div ng-if="vm.displayValueDecision(value.valueDecision, key, \'valDecision\')">{{value.valueDecision}}</div><div ng-if="!vm.displayValueDecision(value.valueDecision, key, \'valDecision\')"> <div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].valDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.valuesProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].valDecision.value}}</span></div></div></td><td><div ng-if="!vm.isCompletedAutomatically(value, key)"><md-icon class="red_icon" ng-if="!vm.isRowCompleted(key)" md-svg-src="/public/images/ic_error_black_24px.svg"></md-icon><md-icon class="green_icon" ng-if="vm.isRowCompleted(key)" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon><div class="bp-content" ng-if="vm.isTableEditMode"><input ng-model="vm.stateList[key].comments"/></div><div class="bp-content" ng-if="!vm.isTableEditMode"><span class="comments cut-text">{{vm.stateList[key].comments}}</span></div></div><div class="bp-content" ng-if="vm.isCompletedAutomatically(value, key)"><md-icon class="green_icon" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon><span class="comments cut-text" title="checks completed automatically">checks completed automatically</span></div></td></tr></tbody></table></div></div></div>');
$templateCache.put('detail-table-bp-duplcheck.html','<span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span><span>&nbsp;{{vm.tableName}}</span><lock-section comp="vm.comp"></lock-section></span></span><span ng-if="vm.comp===\'dc\'"><display-error section="\'dcCheck\'" style="vertical-align: super; padding-left: 10px"></display-error><gov-check-section ng-if="vm.govCheck" comp="vm.comp"></gov-check-section></span><div id="genInfo" ng-hide="!vm.visible" ng-if="vm.topic.topic.lock_indicator[vm.comp].locked"><p></p><span class="ibm-textcolor-gray-30">Locked by</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp].user}}</span><span class="ibm-textcolor-gray-30">&nbsp;on</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp].date | date: $ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></div><div id="genInfo" ng-hide="!vm.visible" ng-if="vm.isSectionEnabled() &amp;&amp; vm.isError()"><br/><p class="ibm-textcolor-red-50">Automatic Duplicate Check could not to be performed</p></div><div id="genInfo" ng-hide="!vm.visible" ng-if="!vm.isSectionEnabled() &amp;&amp; !vm.isError()"><br/><p class="ibm-textcolor-red-50">User selected to perform check manually</p></div><div id="genInfo" ng-hide="!vm.visible" ng-if="vm.isSectionEnabled() &amp;&amp; !vm.isError()"><div class="ibm-columns"><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo">Source</div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>CMRs search</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo">Country</div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo">Search Time</div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Who</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><span><span>&nbsp;&nbsp;</span><input ng-model="vm.dcFilter" title="Only the lines, that contain the value will appear, by clearing the filter, all will appear back" placeholder="Filter values"/></span></div><div ng-if="(!this.oppVersion || this.oppVersion &lt; vm.OPP_VERSION_5) &amp;&amp; vm.mysaResult" ng-repeat="tab in vm.mysaResult | filter: vm.dcFilter"><multi-table-duplcheck-4x4 item="tab" row="$index" comp="vm.comp" filter="vm.dcFilter"></multi-table-duplcheck-4x4></div><div ng-if="(!this.oppVersion || this.oppVersion &gt;= vm.OPP_VERSION_5) &amp;&amp; vm.mysaEiResult" ng-repeat="tab in vm.mysaEiResult | filter: vm.dcFilter"><br/><span class="ibm-h5">EI Duplicates:</span><multi-table-duplcheck-4x4 item="tab" row="$index" comp="vm.comp" filter="vm.dcFilter"></multi-table-duplcheck-4x4></div><div ng-if="(!this.oppVersion || this.oppVersion &gt;= vm.OPP_VERSION_5) &amp;&amp; vm.mysaSsaResult" ng-repeat="tab in vm.mysaSsaResult | filter: vm.dcFilter"><br/><span class="ibm-h5">SSA Duplicates:</span><multi-table-duplcheck-4x4 item="tab" row="$index" comp="vm.comp" filter="vm.dcFilter"></multi-table-duplcheck-4x4></div></div></div>');
$templateCache.put('detail-table-complcl.html','<style>.action-width-4 {\n    width: 15em;\n}\n.action-width-none {\n    width: none;\n}\n</style><div ng-if="vm.enableSection &amp;&amp; vm.sectionHeader!= undefined"><span style="display: inline-flex;"><b class="ibm-h3 ibm-textcolor-blue-40">{{vm.sectionHeader}}</b><display-error section="vm.comp" style="margin-left:10px; padding-top:2px"></display-error></span><p></p></div><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_list_black_24px.svg"></md-icon><md-icon class="orange_icon" ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon class="orange_icon" ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span ng-bind="::vm.tableName"></span></span><display-error ng-if="vm.showThumb" section="vm.comp" style="margin-left:10px;"></display-error><div class="ibm-columns" ng-if="vm.visible" style="margin: 0px; border: 1px solid lightgray; padding: 10px;"><div class="ibm-col-6-4"><div ng-if="vm.topic.checksData.isAutoEligibilityGoe &amp;&amp; vm.comp === \'complcl_validation\'"><table class="ibm-data-table" cellspacing="0" cellpadding="0"><tr><td><b>1. Overall FindGOE Result</b></td><td> <span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.complcl_validation.v3_overall_find_goe_result ? vm.topic.topic.complcl_validation.v3_overall_find_goe_result: \'NA\'}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.complcl_validation.v3_overall_find_goe_result" ng-options="o as o for o in vm.overallFindGOEResult"></select></td></tr><tr><td><b>2. Overall GOE indicator</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.complcl_validation.v3_overall_goe_indicator ? vm.topic.topic.complcl_validation.v3_overall_goe_indicator : \'NA\'}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.complcl_validation.v3_overall_goe_indicator" ng-options="o as o for o in vm.overallGoeIndicator"></select></td></tr><tr><td><b>3. GOE Determinant</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.complcl_validation.v3_goe_determinant ? vm.topic.topic.complcl_validation.v3_goe_determinant : \'NA\'}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.complcl_validation.v3_goe_determinant" ng-options="o as o for o in vm.goeDeterminant"></select></td></tr><tr><td><b>4. Declaration Letter</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.complcl_validation.v3_declaration_letter ? vm.topic.topic.complcl_validation.v3_declaration_letter : \'NA\'}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.complcl_validation.v3_declaration_letter" ng-options="o as o for o in vm.declarationLetter"></select></td></tr><tr></tr></table></div><table class="ibm-data-table"><thead style="border-bottom: 1px solid"><tr><th>Question</th></tr></thead><tbody ng-if="!vm.topic.editableComponents[vm.comp].editMode"><tr ng-repeat="line in vm.topic.topic[vm.comp].check_list"><td ng-if="line.head"><b>{{::line.q}}</b></td><td ng-if="!line.head"><span>{{::line.q}}</span><span ng-if="line.expected &amp;&amp; line.expected !== line.answer" title="Expected answer is: {{line.expected}}"><md-icon class="orange_icon" md-svg-icon="public/images/ic_sms_failed_black_24px.svg"></md-icon></span></td><td ng-if="!line.head"><md-radio-group ng-disabled="true" ng-model="line.answer" layout="row"><md-radio-button ng-if="!line.addA" value="Yes">Yes</md-radio-button><md-radio-button ng-if="!line.addA" value="No">No</md-radio-button><md-radio-button ng-repeat="answer in line.addA" value="{{answer}}">{{answer}}                            </md-radio-button></md-radio-group></td></tr></tbody><tbody ng-if="vm.topic.editableComponents[vm.comp].editMode"><tr ng-repeat="line in vm.topic.temp[vm.comp].check_list"><td ng-if="line.head"><b>{{::line.q}}</b></td><td ng-if="!line.head"><span>{{::line.q}}</span><span ng-if="line.expected &amp;&amp; line.expected !== line.answer" title="Expected answer is: {{line.expected}}"><md-icon class="orange_icon" md-svg-icon="public/images/ic_sms_failed_black_24px.svg"></md-icon></span></td><td ng-if="!line.head"><md-radio-group ng-model="line.answer" layout="row"><md-radio-button ng-if="!line.addA" value="Yes">Yes</md-radio-button><md-radio-button ng-if="!line.addA" value="No">No</md-radio-button><md-radio-button ng-repeat="answer in line.addA" value="{{answer}}">{{answer}}</md-radio-button></md-radio-group></td></tr></tbody></table></div><div class="ibm-col-6-1" ng-class="{\'action-width-4\' : vm.comp ==\'complcl_sampling\'}" style="float: right; margin-right: -10px"><div ng-if="vm.topic.loaded.topic" style="border: 1px solid lightgray; height: 50px; float: right"><esc-button-section vm="vm" lock="vm.lock" style="float:right; margin-top: 12px"></esc-button-section></div><div ng-if="!vm.topic.loaded.topic"><md-icon class="rotating" md-svg-src="/public/images/ic_autorenew_black_24px.svg"></md-icon></div></div><p></p><div ng-if="vm.comp !==\'complcl_sampling\' &amp;&amp; vm.topic.topic[vm.comp].email"><span class="ibm-textcolor-gray-30">Last updated by </span><span class="ibm-textcolor-blue-40">{{::vm.topic.topic[vm.comp].email}}</span><span class="ibm-textcolor-gray-30">&nbsp;on&nbsp;</span><span class="ibm-textcolor-blue-40">{{::vm.topic.topic[vm.comp].timestamp | date:vm.settings.up.preferences.dateFormat : \'UTC\'}}</span></div><div ng-if="vm.displayRadioButton"><span><b ng-if="vm.topic.topic[vm.comp].cl_rb.desc">{{vm.topic.topic[vm.comp].cl_rb.desc}}: &nbsp;</b><span ng-if="!vm.topic.editableComponents[vm.comp].editMode &amp;&amp; vm.topic.loaded.topic"><md-radio-group ng-disabled="true" ng-model="vm.topic.topic[vm.comp].cl_rb.picked" layout="row">                   <md-radio-button ng-repeat="rbItem in vm.topic.topic[vm.comp].cl_rb.rb" for="{{vm.comp}}" value="{{rbItem.value}}">{{rbItem.item}}                        </md-radio-button></md-radio-group></span><span ng-if="vm.topic.editableComponents[vm.comp].editMode &amp;&amp; vm.topic.loaded.topic"> <md-radio-group ng-model="vm.topic.topic[vm.comp].cl_rb.picked" layout="row">                   <md-radio-button ng-repeat="rbItem in vm.topic.topic[vm.comp].cl_rb.rb" for="{{vm.comp}}" value="{{rbItem.value}}">{{rbItem.item}}                        </md-radio-button></md-radio-group></span></span></div><p class="ibm-btn-row" ng-if="false"><button class="ibm-btn-pri ibm-btn-blue-50" ng-click="vm.createNewChecklist()" ng-disabled="!vm.topic.editableComponents[vm.comp].editMode" type="button">Create new checklist</button><button class="ibm-btn-pri ibm-btn-blue-50" ng-click="vm.sendNotification()" ng-disabled="!vm.topic.editableComponents[vm.comp].editMode" type="button">Send notification</button></p></div>');
$templateCache.put('detail-table-dc-multi.html','<div ng-mouseleave="$ctrl.hovered = false;" ng-mouseover="$ctrl.hovered = true;"><div class="hover-grey"><div ng-click="$ctrl.toggle()" style="display: grid; grid-template-columns: repeat(7, 200px); align-items: center;"><div><span class="ibm-h4"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><sup title="saved results / total results">{{$ctrl.item.table.length}}/{{$ctrl.item.countAll}}</sup><md-icon ng-hide="$ctrl.expand" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.expand" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>{{$ctrl.row+1}}</span><sup class="ibm-textcolor-red-50" ng-bind="$ctrl.topic.searchDropDownNames[$ctrl.item.ds]" title="Search Type" style="background-color: yellow; padding: 5px; border-radius: 5px; font-size: 0.7em"></sup></span></div><div ng-if="$ctrl.item.ds==\'FP-CN\' || $ctrl.item.ds==\'FP-SO\' || $ctrl.item.ds==\'FP-SN\' || $ctrl.item.ds==\'FP-V-CN\' || $ctrl.item.ds==\'FP-V-SO\' || $ctrl.item.ds==\'FP-V-SN\'"><span ng-repeat="line in $ctrl.item.searchCriteria[0].v"><span><span>{{line}}</span><br/></span></span></div><div ng-if="!($ctrl.item.ds==\'FP-CN\' || $ctrl.item.ds==\'FP-SO\' || $ctrl.item.ds==\'FP-SN\' || $ctrl.item.ds==\'FP-V-CN\' || $ctrl.item.ds==\'FP-V-SO\' || $ctrl.item.ds==\'FP-V-SN\' || $ctrl.item.ds ===\'NC\')"><md-button class="mat-button-ripple mat-ripple" ng-click="$ctrl.showCmrArrayList()" style="margin: 0;"><md-icon md-svg-src="/public/images/ic_remove_red_eye_black_24px.svg" style="margin-right: 10px;"></md-icon><span style="text-transform: lowercase;">click to view</span></md-button></div><div ng-if="[\'NC\', \'SC_DUP\', \'MYSA_DUP\'].indexOf($ctrl.item.ds) === -1"><span>{{$ctrl.item.searchCriteria[1].v}}</span></div><div ng-if="$ctrl.item.ds==\'NC\'"><md-button class="mat-button-ripple mat-ripple" ng-click="$ctrl.showCmrArrayList()"><md-icon md-svg-src="/public/images/ic_remove_red_eye_black_24px.svg" style="margin-right: 10px;"></md-icon><span style="text-transform: lowercase;">click to view</span></md-button></div><div ng-if="[\'NC\', \'SC_DUP\', \'MYSA_DUP\'].indexOf($ctrl.item.ds) !== -1"><span>{{$ctrl.item.searchCriteria[1].v}}</span></div><div ng-if="$ctrl.item.ds==\'NC\'"><span>{{$ctrl.item.searchCriteria[2].v}}</span></div><div><span ng-show="$ctrl.item.before"><md-icon class="red_icon" title="Data before the oppty: {{$ctrl.item.before | date:$ctrl.settings.up.preferences.dateFormat : \'UTC\'}}" md-svg-src="/public/images/ic_info_outline_black_24px.svg"></md-icon></span><span>{{$ctrl.item.timestamp | date:$ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></div><div><span>{{$ctrl.item.user}}</span></div><div ng-if="$ctrl.item.ds==\'GOE_DATA\' &amp;&amp; $ctrl.item.commonGOEDecision &amp;&amp; !$ctrl.topic.topic.commonGOEDecision"><span>GOE {{$ctrl.item.commonGOEDecision}}</span></div><div ng-if="$ctrl.item.ds==\'GOE_DATA\' &amp;&amp; (!$ctrl.item.commonGOEDecision || $ctrl.topic.topic.commonGOEDecision)"><span> </span></div><div><span ng-show="!$ctrl.item.deleted &amp;&amp; $ctrl.item.table.length &gt; 0"><span><md-icon ng-click="$ctrl.excelExport()" title="Generate Saved Records Excel Report" md-svg-src="/public/images/ic_file_download_black_24px.svg"></md-icon></span></span><span ng-hide="$ctrl.item.table.length == 0 || $ctrl.topic.editableComponents[$ctrl.comp].socket"><md-icon class="red_icon" ng-click="$ctrl.removeReport($event, $ctrl.comp,$ctrl.row)" title="Remove file" md-svg-src="/public/images/ic_delete_black_24px.svg"></md-icon></span><span ng-hide="$ctrl.item.user === \'DMT\'"><md-icon ng-click="$ctrl.downloadAttachment()" title="Generate All Records Excel Report For This Search" md-svg-src="/public/images/ic_archive_black_24px.svg"></md-icon></span><span ng-hide="!$ctrl.topic.editableComponents[$ctrl.comp].socket || $ctrl.item.deleted || $ctrl.item.table.length == 0"><md-icon class="grey_icon" title="Locked" md-svg-src="/public/images/ic_delete_black_24px.svg"></md-icon></span><span ng-hide="!$ctrl.item.deleted"><md-icon class="red_icon" title="Report removed" md-svg-src="/public/images/ic_delete_forever_black_24px.svg"></md-icon></span><span ng-hide="!$ctrl.item.error"><md-icon class="red_icon" title="Error: {{$ctrl.item.error}}" md-svg-src="/public/images/ic_error_white_24px.svg"></md-icon></span><span ng-hide="!$ctrl.item.gov"><md-icon class="pink_icon" title="Gov found" md-svg-src="/public/images/ic_close_black_24px.svg"></md-icon></span><span ng-hide="!$ctrl.item.unk"><md-icon class="bisque_icon" title="Unknown found" md-svg-src="/public/images/ic_close_black_24px.svg"></md-icon></span><span ng-show="$ctrl.item.nonToGoe === false"><md-icon class="green_icon" title="OK status" md-svg-src="/public/images/thumb-up-outline.svg"></md-icon></span><span ng-show="$ctrl.item.nonToGoe === true"><md-icon class="red_icon" title="a GOE appeared" md-svg-src="/public/images/ic_thumb_down_black_24px.svg"></md-icon></span><span ng-if="$ctrl.item.overallStatus &amp;&amp; ($ctrl.item.ds==\'CMR\' || $ctrl.item.ds==\'VCMR\' || $ctrl.item.ds==\'AVCMR\')">{{$ctrl.item.overallStatus}}</span></div></div><div ng-if="$ctrl.expand"><md-button class="md-primary md-raised" ng-click="$ctrl.toggleCriteria()"><md-icon class="white_icon" md-svg-src="/public/images/ic_bookmark_border_black_24px.svg"></md-icon><span>Searched Criteria</span></md-button><span ng-if="$ctrl.searchCriteria"><span flex="50"><span ng-repeat="criteria in $ctrl.item.searchCriteria" layout="row"><b class="no-padding" flex="25">{{criteria.k}}:</b><span class="no-padding" flex="25">{{criteria.v}}</span></span></span></span></div><div ng-if="!(!$ctrl.expand || $ctrl.item.table.length == 0)"><div class="scrol-overflow"><md-content class="dmt-white-background scrol-width-small" layout="column"><md-divider flex="flex" style="border-top-color:black"></md-divider><md-list-item class="md-2-line"><div class="add-margin md-list-item-text" layout="row" layout-align="start left"><b class="three-right" ng-if="sndLine.h!==\'visible\'" ng-repeat="sndLine in ::$ctrl.rowOrder" flex="flex">{{::sndLine.h}}</b><b class="three-right" ng-if="$ctrl.showSecondary" flex="flex">Additional Info</b></div></md-list-item><md-divider flex="flex" style="border-top-color:black"></md-divider><md-list-item class="md-2-line"><span class="three-right" ng-repeat="row in ::$ctrl.rowOrder" flex="11%" layout="row" layout-wrap="layout-wrap"> <span class="three-right" ng-if="row.v===filtName" ng-repeat="filtName in $ctrl.filterArray" flex="11%" layout="row" layout-wrap="layout-wrap"> <span ng-if="$ctrl.filterObject.filters[filtName].unique!=undefined" flex="50"><md-select class="no-padding" ng-model="$ctrl.filterObject.filters[filtName].picked" ng-model-options="{trackBy: \'$value\'}" aria-label="{{::$index}}" multiple="multiple" md-on-open="$ctrl.openDrop($index, $ctrl.filterObject.filters[filtName].unique.length)" md-on-close="$ctrl.closeDrop($index)"><md-option ng-click="$ctrl.changedValue()" ng-repeat="filt in $ctrl.filterObject.filters[filtName].unique | orderBy:\'toString()\' | limitTo: $ctrl.countDrop[$index] track by $index" ng-value="::filt">{{ ::filt }}</md-option></md-select></span><span ng-if="$ctrl.filterObject.filters[filtName].picked.length &gt; 0" flex="50"><md-icon ng-click="$ctrl.clearFilter(filtName)" title="Clear filter" md-svg-src="/public/images/ic_close_black_24px.svg"></md-icon></span></span><span class="three-right"></span></span></md-list-item><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unk &amp;&amp; {\'background-color\': \'orange\'}" md-virtual-repeat="line in $ctrl.item_array" flex="" md-item-size="10"><div class="add-margin md-list-item-text" layout="row" layout-align="start left"><span class="three-right" ng-if="varN.h!==\'visible\'" ng-repeat="varN in $ctrl.rowOrder" flex="11%"><span ng-if="!varN.t">{{line[varN.v]}}</span><span ng-if="varN.t.indexOf(\'d\')&gt;-1">{{line[varN.v] | date: $ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span><span ng-if="varN.t==\'n\'">{{line[varN.v] | number: varN.n}}</span></span><span class="three-right" ng-if="$ctrl.showSecondary" flex="11%"><span ng-if="!line.visible"><span class="ibm-textcolor-orange-50" ng-click="$ctrl.toggleRow(line)">Click to View</span></span><span ng-if="line.visible"><span class="ibm-textcolor-orange-50" ng-click="$ctrl.toggleRow(line)">Click to Hide</span></span><table class="ibm-data-table ibm-grid" ng-show="line.visible" style="margin-left: -300px; margin-top: 40px; position: absolute;z-index: 1; background: white;"><tr ng-repeat="sndLine in $ctrl.dropRowOrder"><td ng-style="::$ctrl.tableStyle"><b>{{sndLine.h}}</b></td><td ng-style="::$ctrl.tableStyle"><span ng-if="!sndLine.t|| sndLine.t==\'collapse\'">{{line[sndLine.v]}}</span><span ng-if="sndLine.t.indexOf(\'d\')&gt;-1">{{line[sndLine.v] | date:vm.settings.up.preferences.dateFormat : \'UTC\'}}</span><span ng-if="sndLine.t==\'n\'">{{line[sndLine.v] | number: sndLine.n}}</span><span class="ibm-textcolor-orange-50" ng-if="sndLine.t.indexOf(\'title\')&gt;-1" title="{{line[sndLine.v]}}">Hover to View</span></td></tr></table></span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container><md-divider flex="flex" style="border-top-color:black"></md-divider></md-content></div></div><div ng-hide="!$ctrl.expand || $ctrl.item.table.length &gt; 0"><span ng-hide="$ctrl.item.deleted">No Result found</span><span ng-hide="!$ctrl.item.deleted">Results deleted</span><span ng-bind="\'-\' + $ctrl.item.error" ng-hide="!$ctrl.item.error"></span></div></div></div>');
$templateCache.put('detail-table-dc.html','<!--rewrote by Ilya Aderiho--><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span><span>&nbsp;{{vm.tableName}}</span><lock-section comp="vm.comp"></lock-section></span></span><span ng-if="vm.comp===\'dc\'"><display-error section="\'dcCheck\'" style="vertical-align: super; padding-left: 10px"></display-error><gov-check-section ng-if="vm.govCheck" comp="vm.comp"></gov-check-section></span><div id="genInfo" ng-hide="!vm.visible" ng-if="vm.topic.topic.lock_indicator[vm.comp].locked"><p></p><span class="ibm-textcolor-gray-30">Locked by</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp].user}}</span><span class="ibm-textcolor-gray-30">&nbsp;on</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp].date | date: $ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></div><div id="genInfo" ng-hide="!vm.visible"><div class="ibm-columns"><span><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.toggleFilter()" title="{{{true: \'Toggle Search Parameters\', false: \'Section Locked\' }[vm.topic.editableComponents[vm.comp].socket===\'\']}}" aria-label="DC Search" style="margin-left: 3px; float: right"><md-icon ng-class="{white_icon : vm.topic.editableComponents[vm.comp].socket === \'\', black_icon: !vm.topic.editableComponents[vm.comp].socket !== \'\'}" md-svg-src="/public/images/ic_filter_list_black_24px.svg"></md-icon>&nbsp;{{vm.filterDisplay ? \'Hide\' : \'Show\' }} Search Parameters</md-button></span></div><div class="ibm-columns" ng-form="vm.cmrSearchForm" ng-if="(vm.comp==\'cmr\'|| vm.comp==\'cmr_valid\') &amp;&amp; vm.filterDisplay" style="border: 1px solid lightgray; padding:10px 0px 10px 10px"><div class="ibm-columns"><div class="ibm-col-6-2"><span class="ibm-textcolor-blue-40">Customer Name&nbsp;</span><req ng-if="!vm.cmrData.cmrNum"></req><p></p><input name="name" ng-disabled="vm.cmrData.cmrNum" ng-model="vm.cmrData.fuzzySearch" ng-required="!vm.cmrData.cmrNum" aria-label="name" style="padding:6px" size="40" placeholder="Enter either Customer Name to search for..."/><p></p><span class="ibm-textcolor-blue-40">Customer Name Search Criteria</span><p></p><select ng-disabled="vm.cmrData.cmrNum" ng-model="vm.cmrData.customerName" ng-options="o.value as o.name for o in vm.custNameOptions" style="width: 15em"></select><p></p><span class="ibm-textcolor-blue-40">Customer Name Search Type</span><p></p><select ng-disabled="vm.cmrData.cmrNum" ng-model="vm.cmrData.fuzzyOption" ng-options="o as o for o in vm.fuzzyOptions" style="width: 8em"></select></div><div class="ibm-col-6-2"><span class="ibm-textcolor-blue-40">CMR Number&nbsp;</span><req ng-if="!vm.cmrData.fuzzySearch"></req><p></p><input name="number" ng-change="vm.errorChecker()" ng-disabled="vm.cmrData.fuzzySearch" ng-model="vm.cmrData.cmrNum" ng-pattern="/^[a-zA-Z0-9]{1,8}$/" ng-required="!vm.cmrData.fuzzySearch" type="text" placeholder="...or CMR Number"/><md-icon class="red_icon" ng-if="vm.cmrSearchForm.number.$error.pattern" title="CMR Number Invalid. Must be alphanumeric no more than 8 in length. Please amend." style="margin-left: 3px;" md-svg-src="/public/images/close-circle.svg"></md-icon><p></p><span class="ibm-textcolor-blue-40">CMR Business</span><p></p><select ng-model="vm.cmrData.cmrOwner" ng-options="o as o for o in vm.cmrOwnerOptions" style="width: 8em"></select><p></p><span class="ibm-textcolor-blue-40">State/Province</span><p></p><input ng-model="vm.cmrData.stateProvince" style="padding: 6px" size="30"/></div><div class="ibm-col-6-2"><span class="ibm-textcolor-blue-40">CMR Issuing Countries</span><p></p><md-input-container style="margin: 0px;"><md-select class="no-padding" ng-model="vm.cmrData.cmrIssuingCountry" aria-label="search" style="border: 1px solid lightgray; min-width: 200px; max-width: 350px" multiple="multiple"><md-option ng-repeat="o in vm.settings.country_list | filter:o.ic = \'Country\' | orderBy: \'country\'" ng-value="::o.cc">{{ ::o.country }}</md-option></md-select></md-input-container><p></p><span class="ibm-textcolor-blue-40">Customer Country Landed</span><p></p><select ng-model="vm.cmrData.customerCountryLanded" ng-options="item.short as item.country for item in vm.settings.country_list | filter:item.ic = \'Country\' | orderBy: \'country\'" style="width: 18em"></select><p></p><span class="ibm-textcolor-blue-40">Result Rows</span><p></p><select ng-model="vm.cmrData.rows" ng-options="o as o for o in vm.resultRows" style="width: 8em"></select></div></div><p></p><div class="ibm-columns"><div class="ibm-col-2-1"><span class="ibm-textcolor-blue-40">CMR Types</span><p></p><md-checkbox ng-false-value="false" ng-model="vm.cmrData.cmrTypeStandard" ng-true-value="true">Standard</md-checkbox><md-checkbox ng-false-value="false" ng-model="vm.cmrData.cmrTypeProspect" ng-true-value="true">Prospect</md-checkbox><md-checkbox ng-false-value="false" ng-model="vm.cmrData.cmrTypeLite" ng-true-value="true">Lite</md-checkbox><md-checkbox ng-false-value="false" ng-model="vm.cmrData.showCapRecords" ng-true-value="true">Show CAP Records Only</md-checkbox><br/><md-checkbox ng-false-value="false" ng-model="vm.cmrData.inclInvalidCust" ng-true-value="true"></md-checkbox></div><div class="ibm-col-2-1"><span class="ibm-textcolor-blue-40">CMR Address Types</span><p></p><md-checkbox ng-false-value="false" ng-model="vm.cmrData.accTypeSoldTo" ng-true-value="true">Sold To</md-checkbox><md-checkbox ng-false-value="false" ng-model="vm.cmrData.accTypeInstalAt" ng-true-value="true">Install At</md-checkbox><md-checkbox ng-false-value="false" ng-model="vm.cmrData.accTypeBillTo" ng-true-value="true">Bill To</md-checkbox><md-checkbox ng-false-value="false" ng-model="vm.cmrData.accTypeShipTo" ng-true-value="true">Ship To</md-checkbox></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.sendDupliCheck(vm.topic.topic._id.substring(4))" ng-disabled="vm.topic.editableComponents[vm.comp].socket || !vm.cmrSearchForm.$valid" aria-label="Send Duplicate Check" layout="row"><span ng-if="vm.topic.editableComponents[vm.comp].socket !== \'Updating\'"><span ng-if="vm.cmrSearchForm.$valid &amp;&amp; !vm.topic.editableComponents[vm.comp].socket"><md-icon class="white_icon" title="Start search - it may take few seconds for the values to appear" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span ng-if="!vm.cmrSearchForm.$valid"><md-icon class="grey_icon" title="Fill all mandatory fields" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span ng-if="vm.cmrSearchForm.$valid &amp;&amp; vm.topic.editableComponents[vm.comp].socket"><md-icon class="grey_icon" title="{{vm.topic.editableComponents[vm.comp].socket}} server" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span>SEARCH</span></span><span ng-if="vm.topic.editableComponents[vm.comp].socket === \'Updating\'"><span class="ibm-spinner" style="margin: -9px 5px 0px -2px;"></span>SEARCHING</span></md-button></div></div></div><div class="ibm-columns" ng-form="vm.duplSearchForm" ng-if="(!(vm.comp==\'cmr\' || vm.comp==\'cmr_valid\')) &amp;&amp; vm.filterDisplay" style="border: 1px solid lightgray; padding-left:10px; padding-right: 10px"><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><span class="ibm-textcolor-blue-40">Source&nbsp;</span><req></req><p></p><select ng-model="vm.dc.ds" ng-options="o as vm.topic.searchDropDownNames[o] for o in vm.dataSources" ng-required="true" style="width:100px"></select></div><div class="ibm-col-6-3 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo" ng-if="!(vm.dc.ds==\'FP-CN\' || vm.dc.ds==\'FP-SO\' || vm.dc.ds==\'FP-SN\' || vm.dc.ds==\'FP-V-CN\' || vm.dc.ds==\'FP-V-SO\' || vm.dc.ds==\'FP-V-SN\')"><span class="ibm-textcolor-blue-40">Account Name&nbsp;</span><req></req><md-icon class="blue_icon" title="Insert Account Name" style="margin-left: 3px;" md-svg-src="/public/images/ic_info_outline_black_24px.svg"></md-icon><p></p><input name="fuzzy_key_word" ng-model="vm.dc.accountName" ng-required="true" style="padding:6px" size="60" placeholder="Insert Account Name for your search."/><p></p><ng-form name="alterBfForm" ng-if="vm.dc.ds==\'MYSA_DUP\' || vm.dc.ds==\'SC_DUP\'"><div id="ibm-columns"><div class="ibm-col-6-1" id="genInfo" style="width: 280px"><p></p><span class="ibm-textcolor-blue-40">{{ vm.topic.topic.version >= vm.OPP_VERSION_3 && vm.dc.ds !== "SC_DUP" ? "Alternate DRPG IDs Search" : "Alternate BFs Search"}}</span><md-icon class="blue_icon" title="Add an Alternate Brand Family / Deal Registration Product Group id and click the press plus icon" style="margin-left: 3px;" md-svg-src="/public/images/ic_info_outline_black_24px.svg"></md-icon><p></p><input name="alterInput" ng-model="vm.alterToBeInserted" title="insert Alternate Brand Family and press plus sign"/><md-icon class="blue_icon" ng-click="vm.pushAlterBfItem()" ng-if="vm.alterToBeInserted" title="Add Brand Family" style="margin-left: 3px" md-svg-src="/public/images/ic_add_circle_black_24px.svg"></md-icon></div><div class="ibm-col-6-1" id="genInfo"><p></p><span class="ibm-textcolor-blue-40">Selected:&nbsp;</span><b class="ibm-textcolor-blue-50">{{vm.dc.alterBrandFam.length>0 ? vm.dc.alterBrandFam.length : 0}}</b><span ng-show="vm.dc.alterBrandFam.length&gt;0"><md-icon class="blue_icon" ng-click="vm.clearAlterBFList()" title="Click to clear the Alternate Brand Family list" md-svg-src="/public/images/ic_remove_circle_black_24px.svg"></md-icon></span><ul style="line-height: 0.9rem"><li ng-repeat="item in vm.dc.alterBrandFam"><span class="ibm-textcolor-gray-50" ng-bind="item"></span></li></ul></div></div></ng-form></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo" ng-if="vm.dc.ds==\'FP-CN\' || vm.dc.ds==\'FP-SO\' || vm.dc.ds==\'FP-SN\' || vm.dc.ds==\'FP-V-CN\' || vm.dc.ds==\'FP-V-SO\' || vm.dc.ds==\'FP-V-SN\'"><ng-form name="fpSearchForm"><md-input-container style="margin: 0px;"><label>Number to search</label><input name="input" ng-model="vm.toBeInserted" ng-pattern="/^[0-9]*$/" title="insert number and press plus sign"/><span ng-show="vm.fpSearchForm.input.$error.pattern"><span style="color: red;">Must be number!</span></span><span ng-show="vm.dc.pickList.length == 0"><span class="untouched-message">Add at least 1 number with the + sign!</span></span><span ng-if="fpSearchForm.$valid"><md-icon ng-click="vm.pushItem()" title="Add search item" md-svg-src="/public/images/ic_add_black_24px.svg"></md-icon></span><span ng-show="vm.dc.pickList.length&gt;0"><md-icon ng-click="vm.clearList()" title="Clears the list" md-svg-src="/public/images/ic_close_black_24px.svg"></md-icon></span></md-input-container></ng-form><ul><li ng-repeat="item in vm.dc.pickList"><span ng-bind="item"></span></li></ul></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><span class="ibm-textcolor-blue-40">Country&nbsp;</span><req></req><p></p><md-input-container style="margin: 0px;"><md-select class="no-padding" ng-model="vm.dc.countrySelected" ng-required="vm.requiredCountrySearch" title="Select the Country to search against" aria-label="search" style="border: 1px solid lightgray; min-width: 200px; max-width: 350px"><md-option ng-repeat="o in vm.settings.country_list | filter:o.ic = \'Country\' | orderBy: \'country\'" ng-value="::o">{{ ::o.country }}</md-option></md-select></md-input-container></div><div class="ibm-col-1-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo" ng-if="!(vm.dc.ds==\'FP-CN\' || vm.dc.ds==\'FP-SO\' || vm.dc.ds==\'FP-SN\' || vm.dc.ds==\'FP-V-CN\' || vm.dc.ds==\'FP-V-SO\' || vm.dc.ds==\'FP-V-SN\')" layout="row"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.sendDupliCheck(vm.topic.topic._id.substring(4))" ng-disabled="!vm.duplSearchForm.$valid || vm.topic.editableComponents[vm.comp].socket" aria-label="Send Duplicate Check" layout="row"><span ng-if="vm.topic.editableComponents[vm.comp].socket !== \'Updating\'"><span ng-if="vm.duplSearchForm.$valid &amp;&amp; !vm.topic.editableComponents[vm.comp].socket"><md-icon class="white_icon" title="Start search - it may take few seconds for the values to appear" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span ng-if="!vm.duplSearchForm.$valid"><md-icon class="grey_icon" title="Fill all mandatory fields" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span ng-if="vm.duplSearchForm.$valid &amp;&amp; vm.topic.editableComponents[vm.comp].socket"><md-icon class="grey_icon" title="{{vm.topic.editableComponents[vm.comp].socket}} server" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span>SEARCH</span></span><span ng-if="vm.topic.editableComponents[vm.comp].socket === \'Updating\'"><span class="ibm-spinner" style="margin: -9px 5px 0px -2px;"></span>SEARCHING</span></md-button></div><div class="ibm-col-1-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo" ng-if="vm.dc.ds==\'FP-CN\' || vm.dc.ds==\'FP-SO\' || vm.dc.ds==\'FP-SN\' || vm.dc.ds==\'FP-V-CN\' || vm.dc.ds==\'FP-V-SO\' || vm.dc.ds==\'FP-V-SN\'" layout="row"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.sendDupliCheck(vm.topic.topic._id.substring(4))" ng-disabled="vm.dc.pickList.length==0 || vm.topic.editableComponents[vm.comp].socket || !vm.duplSearchForm.$valid" aria-label="Send Duplicate Check" layout="row"><span ng-if="vm.topic.editableComponents[vm.comp].socket !== \'Updating\'"><span ng-if="vm.dc.pickList.length&gt;0 &amp;&amp; !vm.topic.editableComponents[vm.comp].socket &amp;&amp; vm.duplSearchForm.$valid"><md-icon class="white_icon" title="Start search - it may take few seconds for the values to appear" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span ng-if="(vm.dc.pickList.length==0 || !vm.duplSearchForm.$valid) &amp;&amp; !vm.topic.editableComponents[vm.comp].socket"><md-icon class="grey_icon" title="Fill all mandatory fields" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span ng-if="vm.topic.editableComponents[vm.comp].socket &amp;&amp; !vm.duplSearchForm.$valid"><md-icon class="grey_icon" title="{{vm.topic.editableComponents[vm.comp].socket}} server" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span>SEARCH</span></span><span ng-if="vm.processing"><!--md-progress-circular(md-mode="indeterminate",md-diameter="24")--><span class="ibm-spinner" style="margin: -9px 5px 0px -2px;"></span>SEARCHING</span></md-button><span ng-if="vm.topic.topic.gpp_lastload[0].salesorder &amp;&amp; !vm.topic.editableComponents[vm.comp].socket"><md-icon ng-click="vm.sendSONcheck(vm.topic.topic._id.substring(4))" title="Search for this Sales Order Number {{vm.topic.topic.gpp_lastload[0].salesorder}}" md-svg-src="/public/images/ic_youtube_searched_for_black_24px.svg"></md-icon></span><span ng-if="vm.topic.topic.gpp_lastload[0].salesorder &amp;&amp; vm.topic.editableComponents[vm.comp].socket"><md-icon class="grey_icon" title="Please wait with the update for search for this Sales Order Number" md-svg-src="/public/images/ic_youtube_searched_for_black_24px.svg"></md-icon></span></div></div><div class="ibm-columns"><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Source</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b title="Fuzzy search versus the selected data">Key word search</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Country</b></div><!--#genInfo.ibm-col-6-1.ibm-padding-top-1.ibm-padding-bottom-1(ng-if="vm.comp==\'fastpass\'")span(title="Fuzzy search versus the Sales connect numbers") Insert Sales Connect Number--><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Search Time</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Who</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><span><span>&nbsp;&nbsp;</span><input ng-model="vm.dcFilter" title="Only the lines, that contain the value will appear, by clearing the filter, all will appear back" placeholder="Filter values"/></span></div></div><div class="ibm-columns" ng-repeat="tab in vm.topic.topic[vm.comp].results | filter: vm.dcFilter"><multi-dc-table item="tab" row="$index" comp="vm.comp" filter="vm.dcFilter"></multi-dc-table></div><div ng-hide="vm.data" ng-if="vm.topic.loaded.topic" style="border: 1px solid lightgray; height: 50px; float: right"><esc-button-section vm="vm" lock="vm.lock" style="float:right; margin-top: 12px"></esc-button-section></div><span ng-if="vm.comp === \'dc\'"><div class="ibm-columns" ng-hide="vm.topic.checksData.uiVersion &gt;= vm.OPP_VERSION_3" ng-if="vm.hasCheckRun(\'MYSA_DUP\')"><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Is there a real MySA duplicate found?</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><md-radio-group ng-disabled="!vm.edit.editMode" ng-model="vm.topic.temp.dc.gppDecission" layout="row"><md-radio-button data-ng-value="true">Yes</md-radio-button><md-radio-button data-ng-value="false">No</md-radio-button></md-radio-group></div></div><div class="ibm-columns" ng-if="!vm.hasCheckRun(\'MYSA_DUP\')"><b>MySA check has not yet run</b></div></span><span ng-if="vm.showBPOI === true"><div class="ibm-columns" ng-hide="vm.topic.checksData.uiVersion &gt;= vm.OPP_VERSION_3" ng-if="vm.hasCheckRun(\'SC_DUP\')"><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Is there a real Sales Connect duplicate found?</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><md-radio-group ng-disabled="!vm.edit.editMode" ng-model="vm.topic.temp.dc.scDecission" layout="row"><md-radio-button data-ng-value="true">Yes</md-radio-button><md-radio-button data-ng-value="false">No</md-radio-button></md-radio-group></div></div><div class="ibm-columns" ng-if="!vm.hasCheckRun(\'SC_DUP\')"><b>SC check has not yet run</b></div></span></div>');
$templateCache.put('detail-table-drgcheck.html','<!--author Vlad--><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span><span>{{vm.tableName}}</span><lock-section comp="vm.comp"></lock-section></span></span><span ng-if="vm.comp===\'dc\'"><display-error section="\'dcCheck\'" style="vertical-align: super; padding-left: 10px"></display-error><gov-check-section ng-if="vm.govCheck" comp="vm.comp"></gov-check-section></span><div id="genInfo" ng-hide="!vm.visible" ng-if="vm.topic.topic.lock_indicator[vm.comp].locked"><p></p><span class="ibm-textcolor-gray-30">Locked by</span><span class="ibm-textcolor-blue-40"> {{vm.topic.topic.lock_indicator[vm.comp].user}}</span><span class="ibm-textcolor-gray-30"> on</span><span class="ibm-textcolor-blue-40"> {{vm.topic.topic.lock_indicator[vm.comp].date | date: $ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></div><div id="genInfo" ng-hide="!vm.visible" ng-if="!vm.goeResult || vm.goeError"><br/><p class="ibm-textcolor-red-50">Automatic Government Check for Deal Registration could not be performed</p></div><div id="genInfo" ng-hide="!vm.visible" ng-if="vm.goeResult &amp;&amp; !vm.goeError"><div class="ibm-columns"><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo">Source</div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>CMRs search</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo">Country</div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo">Search Time</div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>GOE result</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><span><span></span><input ng-model="vm.dcFilter" title="Only the lines, that contain the value will appear, by clearing the filter, all will appear back" placeholder="Filter values"/></span></div></div><div class="ibm-columns" ng-repeat="tab in vm.goeResult | filter: vm.dcFilter"><multi-table item="tab" row="$index" comp="vm.comp" filter="vm.dcFilter"></multi-table><gov-check-section comp="vm.comp"></gov-check-section></div></div>');
$templateCache.put('detail-table-duplcheck-4x4.html','<span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span><span>&nbsp;{{vm.tableName}}</span><lock-section comp="vm.comp"></lock-section></span></span><span ng-if="vm.comp===\'dc\'"><display-error section="\'dcCheck\'" style="vertical-align: super; padding-left: 10px"></display-error><gov-check-section ng-if="vm.govCheck" comp="vm.comp"></gov-check-section></span><div id="genInfo" ng-hide="!vm.visible" ng-if="vm.topic.topic.lock_indicator[vm.comp].locked"><p></p><span class="ibm-textcolor-gray-30">Locked by</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp].user}}</span><span class="ibm-textcolor-gray-30">&nbsp;on</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp].date | date: $ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></div><div id="genInfo" ng-hide="!vm.visible" ng-if="(!vm.mysaResult || !vm.scResult) || ( (vm.mysaResult || vm.scResult) &amp;&amp; (vm.mysaResult.isError || vm.scResult.isError) )"><br/><p class="ibm-textcolor-red-50" ng-hide="!vm.visible" ng-if="vm.mysaResult.isError || vm.scResult.isError">Automatic Duplicate Check could not be performed</p></div><div id="genInfo" ng-hide="!vm.visible" ng-if="!(vm.mysaResult.isError || vm.scResult.isError)"><div class="ibm-columns"><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo">Source</div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>CMRs search</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo">Country</div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo">Search Time</div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Who</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><span><span>&nbsp;&nbsp;</span><input ng-model="vm.dcFilter" title="Only the lines, that contain the value will appear, by clearing the filter, all will appear back" placeholder="Filter values"/></span></div><div class="ibm-columns" ng-if="vm.mysaResult" ng-repeat="tab in vm.mysaResult | filter: vm.dcFilter"><multi-table-duplcheck-4x4 item="tab" row="$index" comp="vm.comp[0]" filter="vm.dcFilter"></multi-table-duplcheck-4x4></div><div class="ibm-columns" ng-if="vm.scResult" ng-repeat="tab in vm.scResult | filter: vm.dcFilter"><multi-table-duplcheck-4x4 item="tab" row="$index" comp="vm.comp[1]" filter="vm.dcFilter"></multi-table-duplcheck-4x4></div></div></div>');
$templateCache.put('detail-table-duplcheck-results.html','<!-- author Vlad--><style>#indent-vertical {\n    display: block;\n    padding: 10px 0 10px;\n} \n.bp-table * {\n    font-size: 14px;\n}\n.bp-table {\n    display: block;\n    overflow: auto;\n    border: 0 !important;\n}\n.bp-table > thead > tr > th,\n.bp-table > tbody > tr > td {\n    text-align: center;\n    vertical-align: middle;\n}\n.bp-table-border thead tr:first-child th:nth-last-child(2) {\n    border-bottom: 0;\n}\n.bp-table tbody label {\n    text-align: left;\n}\n.bp-table md-input-container {\n    float: left;\n    padding: 2px 8px 2px;\n}\n.bp-table button,\n.bp-table button:hover {\n    border: 0;\n}\n.bp-table .comments {\n    padding: 0 15px 0;\n}\n.bp-table .cut-text {\n    text-overflow: ellipsis;\n    overflow: hidden; \n    width: 130px; \n    height: 1.2em; \n    white-space: nowrap;\n}\n.bp-table input {\n    margin: 10px 15px;\n}\n.bp-table .dup-content,\n.bp-table tbody tr td:last-child div {\n    display: flex;\n}\n.bp-table tbody tr td:last-child button {\n    width: 37px;\n    height: 37px;\n    padding: 6px;\n}\n</style><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span><span>{{vm.tableName}}</span><span style="vertical-align: super; padding-left: 10px" ng-if="vm.tableConsolidatedErrors"><md-icon class="red_icon" title="{{vm.tableConsolidatedErrors}}" md-svg-src="/public/images/ic_thumb_down_black_24px.svg"></md-icon></span><span style="vertical-align: super; padding-left: 10px" ng-if="!vm.tableConsolidatedErrors"><md-icon class="green_icon" title="Section complete" md-svg-src="/public/images/ic_thumb_up_black_24px.svg"></md-icon></span></span></span><div id="indent-vertical" ng-if="vm.visible"><span layout="row" style="margin-top:10px"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.save()" ng-if="vm.isTableEditMode">Save</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.cancel()" ng-if="vm.isTableEditMode">Cancel</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" ng-click="vm.edit()" ng-disabled="!vm.isDupEditButtonEnabledVersion3AndLess()" ng-if="!vm.isTableEditMode &amp;&amp; !vm.isVersion4AndMore">Edit</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" ng-click="vm.edit()" ng-disabled="!vm.isDupEditButtonEnabled()" ng-if="!vm.isTableEditMode &amp;&amp; vm.isVersion4AndMore">Edit</md-button></span><table class="ibm-data-table ibm-grid ibm-altrows bp-table" ng-if="!vm.isVersion4AndMore"><thead><tr><th ng-repeat="name in vm.tableHeader track by $index"><b>{{name}}</b></th></tr></thead><tbody><tr ng-repeat="(key,value) in vm.tableRows track by $index"><td>{{value.dealRegProductGroupID}}</td><td>{{value.dealRegProductGroupName}}</td><td>{{value.gbt20ID}}</td><td>{{value.gbt20name}}</td><td>{{value.revenue}}</td><td><div ng-if="!vm.isCvrDupEditable(value, key)">{{value.cvrDupFound}}</div><div ng-if="vm.isCvrDupEditable(value, key)"><div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].cvrDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.duplicateFoundProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].cvrDecision.value}}</span></div></div></td><td ng-if="(value.sbDupFound !== undefied"><div ng-if="!vm.isSbDupEditable(value, key)">{{value.sbDupFound}}</div><div ng-if="vm.isSbDupEditable(value, key)"> <div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].sbDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.duplicateFoundProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].sbDecision.value}}</span></div></div></td><td><div ng-if="value.bpDuplicateOpportunityNumber.length" ng-repeat="str in value.bpDuplicateOpportunityNumber track by $index"> <span>{{str}}</span></div><div ng-if="!value.bpDuplicateOpportunityNumber.length"><span>Not Applicable</span></div></td><td><div ng-if="!vm.isIbmDupEditable(value, key)">{{value.ibmDuplicateFound}}</div><div ng-if="vm.isIbmDupEditable(value, key)"> <div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].ibmDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.duplicateFoundProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].ibmDecision.value}}</span></div></div></td><td><div ng-if="value.ibmDuplicateOpportunityNumber.length" ng-repeat="str in value.ibmDuplicateOpportunityNumber track by $index"> <span>{{str}}</span></div><div ng-if="!value.ibmDuplicateOpportunityNumber.length"><span>Not Applicable </span></div></td><td><div ng-if="vm.isDupEditButtonEnabledVersion3AndLess()"><md-icon class="red_icon" ng-if="!vm.isRowCompleted(key)" md-svg-src="/public/images/ic_error_black_24px.svg"></md-icon><md-icon class="green_icon" ng-if="vm.isRowCompleted(key)" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon><div class="dup-content" ng-if="!vm.isTableEditMode || !vm.isRowEditableVersion3AndLess(key)"><span class="comments cut-text">{{vm.stateList[key].comments}}</span></div><div class="dup-content" ng-if="vm.isTableEditMode &amp;&amp; vm.isRowEditableVersion3AndLess(key)"><input ng-model="vm.stateList[key].comments"/></div></div><div class="dup-content" ng-if="!vm.isDupEditButtonEnabledVersion3AndLess()"><md-icon class="green_icon" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon><span class="comments cut-text" title="Checks completed automatically">Checks completed automatically</span></div></td></tr></tbody></table><table class="ibm-data-table ibm-grid ibm-altrows bp-table" ng-if="vm.isVersion4AndMore"><thead><tr><th ng-repeat="name in vm.tableHeader track by $index"><b>{{name}}</b></th></tr></thead><tbody><tr ng-repeat="(key,value) in vm.tableRows track by $index"><td>{{value.dealRegProductGroupID}}</td><td>{{value.dealRegProductGroupName}}</td><td ng-if="!vm.isVersion5AndMore">{{value.gbt20ID}}</td><td ng-if="!vm.isVersion5AndMore">{{value.gbt20name}}</td><td><div ng-if="!vm.isSsaDupEditable(value, key)">{{value.ssaDupFound}}</div><div ng-if="vm.isSsaDupEditable(value, key)"><div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].ssaDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.duplicateFoundProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].ssaDecision.value}}</span></div></div></td><td><div ng-if="value.ssaDupOpportunityNumber.length" ng-repeat="str in value.ssaDupOpportunityNumber track by $index"> <span>{{str}}</span></div><div ng-if="!value.ssaDupOpportunityNumber.length"><span>Not Applicable</span></div></td><td><div ng-if="!vm.isEiDupEditable(value, key)">{{value.eiDupFound}}</div><div ng-if="vm.isEiDupEditable(value, key)"> <div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].eiDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.duplicateFoundProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].eiDecision.value}}</span></div></div></td><td><div ng-if="value.eiDupOpportunityNumber.length" ng-repeat="str in value.eiDupOpportunityNumber track by $index"> <span>{{str}}</span></div><div ng-if="!value.eiDupOpportunityNumber.length"><span>Not Applicable</span></div></td><td ng-if="!vm.isVersion5AndMore"><div ng-if="!vm.isSbDupEditable(value, key)">{{value.sbDupFound}}</div><div ng-if="vm.isSbDupEditable(value, key)"> <div ng-if="vm.isTableEditMode"><md-input-container><label>Manual Review</label><md-select ng-model="vm.stateList[key].sbDecision.value" style="min-width:100px" required=""><md-option ng-repeat="stateList in vm.duplicateFoundProps track by $index" ng-value="stateList.abbrev">{{stateList.abbrev}}</md-option></md-select></md-input-container></div><div ng-if="!vm.isTableEditMode"><span>{{vm.stateList[key].sbDecision.value}}</span></div></div></td><td ng-if="!vm.isVersion5AndMore"><div ng-if="value.sbDupOpportunityNumber.length" ng-repeat="str in value.sbDupOpportunityNumber track by $index"> <span>{{str}}</span></div><div ng-if="!value.sbDupOpportunityNumber.length"><span>Not Applicable</span></div></td><td><div ng-if="vm.isDupEditButtonEnabled()"><md-icon class="red_icon" ng-if="!vm.isRowCompleted(key)" md-svg-src="/public/images/ic_error_black_24px.svg"></md-icon><md-icon class="green_icon" ng-if="vm.isRowCompleted(key)" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon><div class="dup-content" ng-if="!vm.isTableEditMode || !vm.isRowEditable(key)"><span class="comments cut-text">{{vm.stateList[key].comments}}</span></div><div class="dup-content" ng-if="vm.isTableEditMode &amp;&amp; vm.isRowEditable(key)"><input ng-model="vm.stateList[key].comments"/></div></div><div class="dup-content" ng-if="!vm.isDupEditButtonEnabled()"><md-icon class="green_icon" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon><span class="comments cut-text" title="Checks completed automatically">Checks completed automatically</span></div></td></tr></tbody></table></div>');
$templateCache.put('detail-table-fcmr.html','<!--author Ivan Toth--><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span><span>&nbsp;Find CMR</span><gov-check-section comp="vm.comp"></gov-check-section></span></span><table class="ibm-data-table ibm-grid" ng-hide="!vm.visible || vm.topic.gov[vm.comp] &lt; 0"><thead><tr><th>Country Short</th><th>Country</th><th>Name1</th><th>Name2</th><th>International Name</th><th>Site Party ID</th><th>Number</th><th>Preview Duns</th><th>GOE Indicator</th><th>Trade Style Name</th></tr></thead><tbody><tr ng-repeat="line in vm.topic.topic.cmr" ng-class="{\'pink_box\': line.gov == true,\'orange_box\': line.unasigned == true }"><td>{{::line.cmrCountryLanded}}</td><td>{{::line.cmrCountryLandedDesc}}</td><td>{{::line.cmrName1Plain}}</td><td>{{::line.cmrName2Plain}}</td><td>{{::line.cmrInternationalName}}</td><td>{{::line.cmrSitePartyID}}</td><td>{{::line.cmrNum}}</td><td>{{::line.cmrPDunsNo}}</td><td>{{::line.cmrGOEIndicator}}</td><td>{{::line.cmrTradeStyleName}}</td></tr></tbody></table><div ng-hide="!vm.visible || vm.topic.topic[vm.comp][0].govs &gt; -1"><span>Table empty</span></div>');
$templateCache.put('detail-table-fp.html','<!--author Ivan Toth--><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span><span>&nbsp;FastPass</span><gov-check-section comp="vm.comp"></gov-check-section></span></span><table class="ibm-data-table ibm-grid" ng-hide="!vm.visible || vm.topic.gov[vm.comp] &lt; 0"><thead><tr><th>Bill Date</th><th>Type</th><th>Brand Family</th><th>Brand</th><th>Brand Family CVR Participation</th><th>Brand Certification method</th><th>Win Probability</th><th>Quantity</th><th>Price</th><th>Revenue Opportunity Currency</th></tr></thead><tbody><tr ng-repeat="line in vm.topic.topic.fp" ng-class="{\'pink_box\': line.gov == true,\'orange_box\': line.unasigned == true }"><td>{{::line.bill_date}}</td><td>{{::line.type}}</td><td>{{::line.brand_family}}</td><td>{{::line.brand}}</td><td>{{::line.brand_svi_par}}</td><td>{{::line.brand_cer_met}}</td><td>{{::line.win_prob}}</td><td>{{::line.qty}}</td><td>{{::line.price}}</td><td>{{::line.rev_opp_cur}}</td></tr></tbody></table><div ng-hide="!vm.visible || vm.topic.gov[vm.comp] &gt; -1"><span>Table empty</span></div>');
$templateCache.put('detail-table-ibm-duplcheck.html','<span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span><span>&nbsp;{{vm.tableName}}</span><lock-section comp="vm.comp"></lock-section></span></span><span ng-if="vm.comp===\'dc\'"><display-error section="\'dcCheck\'" style="vertical-align: super; padding-left: 10px"></display-error><gov-check-section ng-if="vm.govCheck" comp="vm.comp"></gov-check-section></span><div id="genInfo" ng-hide="!vm.visible" ng-if="vm.topic.topic.lock_indicator[vm.comp].locked"><p></p><span class="ibm-textcolor-gray-30">Locked by</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp].user}}</span><span class="ibm-textcolor-gray-30">&nbsp;on</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp].date | date: $ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></div><div id="genInfo" ng-hide="!vm.visible" ng-if="!vm.isSectionEnabled()"><br/><p class="ibm-textcolor-red-50">User selected to perform check manually</p></div><div id="genInfo" ng-hide="!vm.visible" ng-if="vm.isSectionEnabled()"><div class="ibm-columns"><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo">Source</div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>CMRs search</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo">Country</div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo">Search Time</div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Who</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><span><span>&nbsp;&nbsp;</span><input ng-model="vm.dcFilter" title="Only the lines, that contain the value will appear, by clearing the filter, all will appear back" placeholder="Filter values"/></span></div><div class="ibm-columns" ng-if="vm.scResult" ng-repeat="tab in vm.scResult | filter: vm.dcFilter"><multi-table-duplcheck-4x4 item="tab" row="$index" comp="vm.comp" filter="vm.dcFilter"></multi-table-duplcheck-4x4></div></div></div>');
$templateCache.put('detail-table-ig-find-cmr.html','<div id="genInfo" ng-hide="!vm.visible"><div class="ibm-columns" ng-form="vm.cmrSearchForm" ng-if="vm.comp==\'cmr\'|| vm.comp==\'cmr_valid\'" style="border: 1px solid lightgray; padding:10px 0px 10px 10px"><div class="ibm-columns"><div class="ibm-col-6-2"><span class="ibm-textcolor-blue-40">Customer Name&nbsp;</span><req ng-if="!vm.cmrData.cmrNum"></req><p></p><input name="name" ng-disabled="vm.cmrData.cmrNum" ng-model="vm.cmrData.fuzzySearch" ng-required="!vm.cmrData.cmrNum" aria-label="name" style="padding:6px" size="40" placeholder="Enter either Customer Name to search for..."/><p></p><span class="ibm-textcolor-blue-40">Customer Name Search Criteria</span><p></p><select ng-disabled="vm.cmrData.cmrNum" ng-model="vm.cmrData.customerName" ng-options="o.value as o.name for o in vm.custNameOptions" style="width: 15em"></select><p></p><span class="ibm-textcolor-blue-40">Customer Name Search Type</span><p></p><select ng-disabled="vm.cmrData.cmrNum" ng-model="vm.cmrData.fuzzyOption" ng-options="o as o for o in vm.fuzzyOptions" style="width: 8em"></select></div><div class="ibm-col-6-2"><span class="ibm-textcolor-blue-40">CMR Number&nbsp;</span><req ng-if="!vm.cmrData.fuzzySearch"></req><p></p><input name="number" ng-change="vm.errorChecker()" ng-disabled="vm.cmrData.fuzzySearch" ng-model="vm.cmrData.cmrNum" ng-pattern="/^[a-zA-Z0-9]{1,8}$/" ng-required="!vm.cmrData.fuzzySearch" type="text" placeholder="...or CMR Number"/><md-icon class="red_icon" ng-if="vm.cmrSearchForm.number.$error.pattern" title="CMR Number Invalid. Must be alphanumeric no more than 8 in length. Please amend." style="margin-left: 3px;" md-svg-src="/public/images/close-circle.svg"></md-icon><p></p><span class="ibm-textcolor-blue-40">CMR Business</span><p></p><select ng-model="vm.cmrData.cmrOwner" ng-options="o as o for o in vm.cmrOwnerOptions" style="width: 8em"></select><p></p><span class="ibm-textcolor-blue-40">State/Province</span><p></p><input ng-model="vm.cmrData.stateProvince" style="padding: 6px" size="30"/></div><div class="ibm-col-6-2"><span class="ibm-textcolor-blue-40">CMR Issuing Countries</span><p></p><md-input-container style="margin: 0px;"><md-select class="no-padding" ng-model="vm.cmrData.cmrIssuingCountry" aria-label="search" style="border: 1px solid lightgray; min-width: 200px; max-width: 350px" multiple="multiple"><md-option ng-repeat="o in vm.settings.country_list | filter:o.ic = \'Country\' | orderBy: \'country\'" ng-value="::o.cc">{{ ::o.country }}</md-option></md-select></md-input-container><p></p><span class="ibm-textcolor-blue-40">Customer Country Landed</span><p></p><select ng-model="vm.cmrData.customerCountryLanded" ng-options="item.short as item.country for item in vm.settings.country_list | filter:item.ic = \'Country\' | orderBy: \'country\'" style="width: 18em"></select><p></p><span class="ibm-textcolor-blue-40">Result Rows</span><p></p><select ng-model="vm.cmrData.rows" ng-options="o as o for o in vm.resultRows" style="width: 8em"></select></div></div><p></p><div class="ibm-columns"><div class="ibm-col-2-1"><span class="ibm-textcolor-blue-40">CMR Types</span><p></p><md-checkbox ng-false-value="false" ng-model="vm.cmrData.cmrTypeStandard" ng-true-value="true">Standard</md-checkbox><md-checkbox ng-false-value="false" ng-model="vm.cmrData.cmrTypeProspect" ng-true-value="true">Prospect</md-checkbox><md-checkbox ng-false-value="false" ng-model="vm.cmrData.cmrTypeLite" ng-true-value="true">Lite</md-checkbox><md-checkbox ng-false-value="false" ng-model="vm.cmrData.showCapRecords" ng-true-value="true">Show CAP Records Only</md-checkbox><br/><md-checkbox ng-false-value="false" ng-model="vm.cmrData.inclInvalidCust" ng-true-value="true" aria-label="Include Invalid Customer"></md-checkbox></div><div class="ibm-col-2-1"><span class="ibm-textcolor-blue-40">CMR Address Types</span><p></p><md-checkbox ng-false-value="false" ng-model="vm.cmrData.accTypeSoldTo" ng-true-value="true">Sold To</md-checkbox><md-checkbox ng-false-value="false" ng-model="vm.cmrData.accTypeInstalAt" ng-true-value="true">Install At</md-checkbox><md-checkbox ng-false-value="false" ng-model="vm.cmrData.accTypeBillTo" ng-true-value="true">Bill To</md-checkbox><md-checkbox ng-false-value="false" ng-model="vm.cmrData.accTypeShipTo" ng-true-value="true">Ship To</md-checkbox></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.sendDupliCheck(vm.topic.topic._id.substring(4))" ng-disabled="vm.topic.editableComponents[vm.comp].socket || !vm.cmrSearchForm.$valid" layout="row" aria-label="Send Duplicate Check"><span ng-if="vm.topic.editableComponents[vm.comp].socket !== \'Updating\'"><span ng-if="vm.cmrSearchForm.$valid &amp;&amp; !vm.topic.editableComponents[vm.comp].socket"><md-icon class="white_icon" title="Start search - it may take few seconds for the values to appear" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span ng-if="!vm.cmrSearchForm.$valid"><md-icon class="grey_icon" title="Fill all mandatory fields" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span ng-if="vm.cmrSearchForm.$valid &amp;&amp; vm.topic.editableComponents[vm.comp].socket"><md-icon class="grey_icon" title="{{vm.topic.editableComponents[vm.comp].socket}} server" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span>SEARCH</span></span><span ng-if="vm.topic.editableComponents[vm.comp].socket === \'Updating\'"><span class="ibm-spinner" style="margin: -9px 5px 0px -2px;"></span>SEARCHING</span></md-button></div></div></div><div class="ibm-columns" ng-form="vm.duplSearchForm" ng-if="(!(vm.comp==\'cmr\' || vm.comp==\'cmr_valid\')) &amp;&amp; vm.filterDisplay" style="border: 1px solid lightgray; padding-left:10px; padding-right: 10px"><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><span class="ibm-textcolor-blue-40">Source&nbsp;</span><req></req><p></p><select ng-model="vm.dc.ds" ng-options="o as vm.topic.searchDropDownNames[o] for o in vm.dataSources" ng-required="true" style="width:100px"></select></div><div class="ibm-col-6-3 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo" ng-if="!(vm.dc.ds==\'FP-CN\' || vm.dc.ds==\'FP-SO\' || vm.dc.ds==\'FP-SN\' || vm.dc.ds==\'FP-V-CN\' || vm.dc.ds==\'FP-V-SO\' || vm.dc.ds==\'FP-V-SN\')"><span class="ibm-textcolor-blue-40">Fuzzy Search&nbsp;</span><req></req><md-icon class="blue_icon" title="Insert Keyword(s) for your search. NOTE: Anything entered will be bookended with % for a wildcard search, ie: if \'avnet\' is entered, that will be sent as \'%avnet%\' to search for all cases where \'avnet\' exists within a BP Name." style="margin-left: 3px;" md-svg-src="/public/images/ic_info_outline_black_24px.svg"></md-icon><p></p><input name="fuzzy_key_word" ng-model="vm.dc.fuzzySearch" ng-required="true" style="padding:6px" size="60" placeholder="Insert Keyword(s) for your search."/><p></p><ng-form name="alterBfForm" ng-if="vm.dc.ds==\'GPP\' || vm.dc.ds==\'GPP-AP\' || vm.dc.ds==\'SC\' || vm.dc.ds==\'SC-AP\'"><div id="ibm-columns"><div class="ibm-col-6-1" id="genInfo" style="width: 280px"><p></p><span class="ibm-textcolor-blue-40">Alternate Brand Family Search</span><md-icon class="blue_icon" title="Add an Alternate Brand Family and click the press plus icon" style="margin-left: 3px;" md-svg-src="/public/images/ic_info_outline_black_24px.svg"></md-icon><p></p><input name="alterInput" ng-model="vm.alterToBeInserted" title="insert Alternate Brand Family and press plus sign"/><md-icon class="blue_icon" ng-click="vm.pushAlterBfItem()" ng-if="vm.alterToBeInserted" title="Add Brand Family" style="margin-left: 3px" md-svg-src="/public/images/ic_add_circle_black_24px.svg"></md-icon></div><div class="ibm-col-6-1" id="genInfo"><p></p><span class="ibm-textcolor-blue-40">Selected:&nbsp;</span><b class="ibm-textcolor-blue-50">{{vm.dc.alterBrandFam.length>0 ? vm.dc.alterBrandFam.length : 0}}</b><span ng-show="vm.dc.alterBrandFam.length&gt;0"><md-icon class="blue_icon" ng-click="vm.clearAlterBFList()" title="Click to clear the Alternate Brand Family list" md-svg-src="/public/images/ic_remove_circle_black_24px.svg"></md-icon></span><ul style="line-height: 0.9rem"><li ng-repeat="item in vm.dc.alterBrandFam"><span class="ibm-textcolor-gray-50" ng-bind="item"></span></li></ul></div></div></ng-form></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo" ng-if="vm.dc.ds==\'FP-CN\' || vm.dc.ds==\'FP-SO\' || vm.dc.ds==\'FP-SN\' || vm.dc.ds==\'FP-V-CN\' || vm.dc.ds==\'FP-V-SO\' || vm.dc.ds==\'FP-V-SN\'"><ng-form name="fpSearchForm"><md-input-container style="margin: 0px;"><label>Number to search</label><input name="input" ng-model="vm.toBeInserted" ng-pattern="/^[0-9]*$/" title="insert number and press plus sign"/><span ng-show="vm.fpSearchForm.input.$error.pattern"><span style="color: red;">Must be number!</span></span><span ng-show="vm.dc.pickList.length == 0"><span class="untouched-message">Add at least 1 number with the + sign!</span></span><span ng-if="fpSearchForm.$valid"><md-icon ng-click="vm.pushItem()" title="Add search item" md-svg-src="/public/images/ic_add_black_24px.svg"></md-icon></span><span ng-show="vm.dc.pickList.length&gt;0"><md-icon ng-click="vm.clearList()" title="Clears the list" md-svg-src="/public/images/ic_close_black_24px.svg"></md-icon></span></md-input-container></ng-form><ul><li ng-repeat="item in vm.dc.pickList"><span ng-bind="item"></span></li></ul></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><span class="ibm-textcolor-blue-40">Countries&nbsp;</span><req></req><p></p><md-input-container style="margin: 0px;"><md-select class="no-padding" ng-model="vm.dc.countrySelected" ng-required="vm.requiredCountrySearch" title="Select the Countries to search against" aria-label="search" style="border: 1px solid lightgray; min-width: 200px; max-width: 350px" multiple="multiple" md-on-close="vm.countryChange()"><md-option ng-repeat="o in vm.settings.country_list | filter:o.ic = \'Country\' | orderBy: \'country\'" ng-value="::o">{{ ::o.country }}</md-option></md-select></md-input-container><p ng-if="vm.comp===\'dc\' &amp;&amp; vm.usPicked"></p><span class="ibm-textcolor-blue-40" ng-if="vm.comp===\'dc\' &amp;&amp; vm.usPicked">US States</span><p></p><md-input-container ng-if="vm.comp===\'dc\' &amp;&amp; vm.usPicked" style="margin: 0px;"><md-select class="no-padding" ng-model="vm.dc.usStatesAll" title="Select the US States to search against" aria-label="search_state" style="border: 1px solid lightgray; min-width: 200px; max-width: 350px" multiple="multiple"><md-option ng-repeat="o in vm.settings.us_states | orderBy: \'long\'" ng-value="::o">{{ ::o.long }}</md-option></md-select></md-input-container></div><div class="ibm-col-1-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo" ng-if="!(vm.dc.ds==\'FP-CN\' || vm.dc.ds==\'FP-SO\' || vm.dc.ds==\'FP-SN\' || vm.dc.ds==\'FP-V-CN\' || vm.dc.ds==\'FP-V-SO\' || vm.dc.ds==\'FP-V-SN\')" layout="row"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.sendDupliCheck(vm.topic.topic._id.substring(4))" ng-disabled="!vm.duplSearchForm.$valid || vm.topic.editableComponents[vm.comp].socket" layout="row" aria-label="Send Duplicate Check"><span ng-if="vm.topic.editableComponents[vm.comp].socket !== \'Updating\'"><span ng-if="vm.duplSearchForm.$valid &amp;&amp; !vm.topic.editableComponents[vm.comp].socket"><md-icon class="white_icon" title="Start search - it may take few seconds for the values to appear" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span ng-if="!vm.duplSearchForm.$valid"><md-icon class="grey_icon" title="Fill all mandatory fields" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span ng-if="vm.duplSearchForm.$valid &amp;&amp; vm.topic.editableComponents[vm.comp].socket"><md-icon class="grey_icon" title="{{vm.topic.editableComponents[vm.comp].socket}} server" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span>SEARCH</span></span><span ng-if="vm.topic.editableComponents[vm.comp].socket === \'Updating\'"><span class="ibm-spinner" style="margin: -9px 5px 0px -2px;"></span><!--md-progress-circular(md-mode="indeterminate",md-diameter="24")-->SEARCHING</span></md-button></div><div class="ibm-col-1-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo" ng-if="vm.dc.ds==\'FP-CN\' || vm.dc.ds==\'FP-SO\' || vm.dc.ds==\'FP-SN\' || vm.dc.ds==\'FP-V-CN\' || vm.dc.ds==\'FP-V-SO\' || vm.dc.ds==\'FP-V-SN\'" layout="row"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.sendDupliCheck(vm.topic.topic._id.substring(4))" ng-disabled="vm.dc.pickList.length==0 || vm.topic.editableComponents[vm.comp].socket || !vm.duplSearchForm.$valid" layout="row" aria-label="Send Duplicate Check"><span ng-if="vm.topic.editableComponents[vm.comp].socket !== \'Updating\'"><span ng-if="vm.dc.pickList.length&gt;0 &amp;&amp; !vm.topic.editableComponents[vm.comp].socket &amp;&amp; vm.duplSearchForm.$valid"><md-icon class="white_icon" title="Start search - it may take few seconds for the values to appear" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span ng-if="(vm.dc.pickList.length==0 || !vm.duplSearchForm.$valid) &amp;&amp; !vm.topic.editableComponents[vm.comp].socket"><md-icon class="grey_icon" title="Fill all mandatory fields" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span ng-if="vm.topic.editableComponents[vm.comp].socket &amp;&amp; !vm.duplSearchForm.$valid"><md-icon class="grey_icon" title="{{vm.topic.editableComponents[vm.comp].socket}} server" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span>SEARCH</span></span><span ng-if="vm.processing"><!--md-progress-circular(md-mode="indeterminate",md-diameter="24")--><span class="ibm-spinner" style="margin: -9px 5px 0px -2px;"></span>SEARCHING</span></md-button><span ng-if="vm.topic.topic.gpp_lastload[0].salesorder &amp;&amp; !vm.topic.editableComponents[vm.comp].socket"><md-icon ng-click="vm.sendSONcheck(vm.topic.topic._id.substring(4))" title="Search for this Sales Order Number {{vm.topic.topic.gpp_lastload[0].salesorder}}" md-svg-src="/public/images/ic_youtube_searched_for_black_24px.svg"></md-icon></span><span ng-if="vm.topic.topic.gpp_lastload[0].salesorder &amp;&amp; vm.topic.editableComponents[vm.comp].socket"><md-icon class="grey_icon" title="Please wait with the update for search for this Sales Order Number" md-svg-src="/public/images/ic_youtube_searched_for_black_24px.svg"></md-icon></span></div></div><div class="ibm-columns"><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Source</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b title="Fuzzy search versus the selected data">Key word search</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Country</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Search Time</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Who</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><span><span>&nbsp;&nbsp;</span><input ng-model="vm.dcFilter" title="Only the lines, that contain the value will appear, by clearing the filter, all will appear back" placeholder="Filter values"/></span></div></div><div ng-if="vm.topic.loaded.topic" style="border: 1px solid lightgray; height: 50px; float: right"><esc-button-section vm="vm" lock="vm.lock" style="float:right; margin-top: 12px"></esc-button-section></div></div>');
$templateCache.put('detail-table-ig-find-goe.html','<div id="genInfo" ng-hide="!vm.visible"><div class="ibm-columns" ng-form="vm.cmrSearchForm" ng-if="vm.comp===\'goe_data\' || vm.comp===\'goe_valid\'" style="border: 1px solid lightgray; padding:10px 0px 10px 10px"><div class="ibm-columns"><div class="ibm-col-6-2"><span class="ibm-textcolor-blue-40">Customer Name&nbsp;</span><req ng-if="!vm.cmrData.cmrNum"></req><p></p><input name="name" ng-disabled="vm.cmrData.cmrNum" ng-model="vm.cmrData.fuzzySearch" ng-required="!vm.cmrData.cmrNum" aria-label="name" style="padding:6px" size="40" placeholder="Enter either Customer Name to search for..."/><p></p><span class="ibm-textcolor-blue-40">Customer Name Search Type</span><p></p><select ng-disabled="vm.cmrData.cmrNum" ng-model="vm.cmrData.fuzzyOption" ng-options="o as o for o in vm.fuzzyOptions" style="width: 8em"></select></div><div class="ibm-col-6-2"><span class="ibm-textcolor-blue-40">CMR Number&nbsp;</span><req ng-if="!vm.cmrData.fuzzySearch"></req><p></p><input name="number" ng-change="vm.errorChecker()" ng-disabled="vm.cmrData.fuzzySearch" ng-model="vm.cmrData.cmrNum" ng-pattern="/^[a-zA-Z0-9]{1,8}$/" ng-required="!vm.cmrData.fuzzySearch" type="text" placeholder="...or CMR Number"/><md-icon class="red_icon" ng-if="vm.cmrSearchForm.number.$error.pattern" title="CMR Number Invalid. Must be alphanumeric no more than 8 in length. Please amend." style="margin-left: 3px;" md-svg-src="/public/images/close-circle.svg"></md-icon><p></p><span class="ibm-textcolor-blue-40">Customer Country Landed&nbsp;</span><req ng-if="!vm.cmrData.fuzzySearch"></req><p></p><select ng-model="vm.cmrData.customerCountryLanded" ng-options="item.short as item.country for item in vm.settings.country_list | filter:item.ic = \'Country\' | orderBy: \'country\'" ng-required="!vm.cmrData.fuzzySearch" style="width: 18em"></select><p></p></div><div class="ibm-col-6-2"><p></p><md-checkbox ng-false-value="false" ng-model="vm.cmrData.showCapRecords" ng-true-value="true">Show CAP Records Only</md-checkbox></div><div class="ibm-col-6-2"><span class="ibm-textcolor-blue-40">Result Rows</span><p></p><select ng-model="vm.cmrData.rows" ng-options="o as o for o in vm.resultRows" style="width: 8em"></select></div></div><p></p><div class="ibm-columns"><div class="ibm-col-6-2"><span class="ibm-textcolor-blue-40">CMR Types</span><p></p><md-checkbox ng-false-value="false" ng-model="vm.cmrData.cmrTypeStandard" ng-true-value="true">Standard</md-checkbox><md-checkbox ng-false-value="false" ng-model="vm.cmrData.cmrTypeProspect" ng-true-value="true">Prospect</md-checkbox><md-checkbox ng-false-value="false" ng-model="vm.cmrData.cmrTypeLite" ng-true-value="true">Lite</md-checkbox><br/></div><div class="ibm-col-6-2"><span class="ibm-textcolor-blue-40">CMR Address Types</span><p></p><md-checkbox ng-false-value="false" ng-model="vm.cmrData.accTypeSoldTo" ng-true-value="true">Sold To</md-checkbox><md-checkbox ng-false-value="false" ng-model="vm.cmrData.accTypeInstalAt" ng-true-value="true">Install At</md-checkbox></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.sendDupliCheck(vm.topic.topic._id.substring(4))" ng-disabled="vm.topic.editableComponents[vm.comp].socket || !vm.cmrSearchForm.$valid" aria-label="Send Duplicate Check" layout="row"><span ng-if="vm.topic.editableComponents[vm.comp].socket !== \'Updating\'"><span ng-if="vm.cmrSearchForm.$valid &amp;&amp; !vm.topic.editableComponents[vm.comp].socket"><md-icon class="white_icon" title="Start search - it may take few seconds for the values to appear" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span ng-if="!vm.cmrSearchForm.$valid"><md-icon class="grey_icon" title="Fill all mandatory fields" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span ng-if="vm.cmrSearchForm.$valid &amp;&amp; vm.topic.editableComponents[vm.comp].socket"><md-icon class="grey_icon" title="{{vm.topic.editableComponents[vm.comp].socket}} server" md-svg-src="/public/images/ic_search_black_24px.svg"></md-icon></span><span>SEARCH</span></span><span ng-if="vm.topic.editableComponents[vm.comp].socket === \'Updating\'"><span class="ibm-spinner" style="margin: -9px 5px 0px -2px;"></span>SEARCHING</span></md-button></div></div></div><div class="ibm-columns"><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Source</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b title="Fuzzy search versus the selected data">Key word search</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Country</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Search Time</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><b>Who</b></div><div class="ibm-col-6-1 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><span><span>&nbsp;&nbsp;</span><input ng-model="vm.dcFilter" title="Only the lines, that contain the value will appear, by clearing the filter, all will appear back" placeholder="Filter values"/></span></div></div><div ng-if="vm.topic.loaded.topic" style="border: 1px solid lightgray; height: 50px; float: right"><esc-button-section vm="vm" lock="vm.lock" style="float:right; margin-top: 12px"></esc-button-section></div></div>');
$templateCache.put('detail-table-igcheck.html','<style>md-menu-content {\n    min-width: 250px;\n}\n</style><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span><span>&nbsp;{{vm.tableName}}</span><lock-section comp="vm.comp[0]"></lock-section></span></span><span ng-if="vm.comp[0]===\'dc\'"><display-error section="\'dcCheck\'" style="vertical-align: super; padding-left: 10px"></display-error><gov-check-section ng-if="vm.govCheck" comp="vm.comp[0]"></gov-check-section></span><div id="genInfo" ng-hide="!vm.visible" ng-if="vm.topic.topic.lock_indicator[vm.comp[0]].locked"><p></p><span class="ibm-textcolor-gray-30">Locked by</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp[0]].user}}</span><span class="ibm-textcolor-gray-30">&nbsp;on</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp[0]].date | date: $ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></div><div id="genInfo" ng-hide="!vm.visible"><div class="ibm-col-4-2" id="genInfo" ng-if="vm.topic.topic.commonGOEDecision"><p></p><p></p><div class="ibm-col-4-1" id="genInfo"><label>Overall GOE Status:</label></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.getManualGoeDecisionLabel()}}</label></div></div><div class="ibm-col-4-2" id="genInfo" ng-if="vm.topic.topic.commonGOEDecision"><div class="ibm-col-4-1" id="genInfo"><label>Waterfall definition:</label></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.getManualGoeReasonLabel()}}</label></div></div><div class="ibm-columns"><span><md-menu md-offset="0 45"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-disabled="vm.topic.editableComponents[vm.comp[0]].socket !== \'\'" title="{{{true: \'Toggle Search Parameters\', false: \'Section Locked\' }[vm.topic.editableComponents[vm.comp[0]].socket===\'\']}}" aria-label="DC Search" style="margin-left: 3px; float: right" ng-mouseenter="$mdMenu.open($event)"><md-icon ng-class="{white_icon : vm.topic.editableComponents[vm.comp[0]].socket === \'\', black_icon: !vm.topic.editableComponents[vm.comp[0]].socket !== \'\'}" md-svg-src="/public/images/ic_filter_list_black_24px.svg"></md-icon>&nbsp;{{vm.filterDisplay ? \'Hide\' : \'Show\' }} Search Parameters</md-button><md-menu-content ng-mouseleave="$mdMenu.close($event)"><md-menu-item><md-button ng-click="vm.toggleSearchInput(\'findGoe\')"><span>FindGOE</span></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.toggleSearchInput(\'findCmr\')"><span>FindCMR</span></md-button></md-menu-item></md-menu-content></md-menu></span><detail-table-ig-find-goe ng-show="vm.displayFindGoe"></detail-table-ig-find-goe><detail-table-ig-find-cmr ng-show="vm.displayFindCmr"></detail-table-ig-find-cmr></div><div class="ibm-columns" ng-repeat="tab in vm.topic.topic[vm.comp[0]].results | filter: vm.dcFilter"><multi-dc-table item="tab" row="$index" comp="vm.comp[0]" filter="vm.dcFilter"></multi-dc-table></div><div class="ibm-columns" ng-repeat="tab in vm.topic.topic[vm.comp[1]].results | filter: vm.dcFilter"><multi-dc-table item="tab" row="$index" comp="vm.comp[1]" filter="vm.dcFilter"></multi-dc-table></div></div>');
$templateCache.put('detail-table-mgr.html','<!--author Ivan Toth--><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span><span>&nbsp;MGR</span><gov-check-section comp="vm.comp"></gov-check-section></span></span><table class="ibm-data-table ibm-grid" ng-hide="!vm.visible || vm.topic.gov[vm.comp] &lt; 0"><thead><tr><th>Company name</th><th>Customer Set Designation</th><th>Contract number</th><th>Curr ISU</th><th>Date</th><th>Init ISU</th><th>Initial ISU Description</th><th>ISO Country code</th><th>ISU Sub Code</th></tr></thead><tbody><tr ng-repeat="line in vm.topic.topic.mgr" ng-class="{\'pink_box\': line.gov == true,\'orange_box\': line.unasigned == true }"><td>{{::line.company_name}}</td><td>{{::line.customer_set_designation}}</td><td>{{::line.contract_variant}}</td><td>{{::line.curr_isu}}</td><td>{{::line.date}}</td><td>{{::line.init_isu}}</td><td>{{::line.initial_isu_description}}</td><td>{{::line.iso_country_code}}</td><td>{{::line.isu_sub_code}}</td></tr></tbody></table><div ng-hide="!vm.visible || vm.topic.topic[vm.comp][0].govs &gt; -1"><span>Table empty</span></div>');
$templateCache.put('detail-table-multi-duplcheck-4x4.html','<!--author Vlad Sirotkin--><style>.ibm-col-6-1 {\n  display: flex;\n  align-items: center;\n}</style><div ng-mouseleave="$ctrl.hovered = false;" ng-mouseover="$ctrl.hovered = true;"><div class="hover-grey"><div class="ibm-columns"><div class="ibm-col-6-5" id="genInfo" ng-click="$ctrl.toggle()"><div class="ibm-columns" id="genInfo" style="display:flex;"><div class="ibm-col-6-1" id="genInfo"><span class="ibm-h4"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><sup title="saved results / numbers of customer numbers that involved into the search">{{$ctrl.dupCheckResultLength()}}/{{$ctrl.dupCheckResultLength()}}</sup><md-icon ng-hide="$ctrl.expand" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.expand" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>{{$ctrl.row+1}}</span><sup class="ibm-textcolor-red-50" ng-bind="$ctrl.topic.searchDropDownNames[$ctrl.comp]" title="Search Type" style="background-color: yellow; padding: 5px; border-radius: 5px; font-size: 0.7em"></sup></span></div><div class="ibm-col-6-1" id="genInfo" ng-if="$ctrl.item"><md-button class="mat-button-ripple mat-ripple" ng-click="$ctrl.showCmrArrayList()"><md-icon md-svg-src="/public/images/ic_remove_red_eye_black_24px.svg" style="margin-right: 10px;"></md-icon><span style="text-transform: lowercase;">click to view </span></md-button></div><div class="ibm-col-6-1" id="genInfo" ng-if="$ctrl.item"><span>{{$ctrl.getCountryFullName($ctrl.item.searchParams.country)}}</span></div><div class="ibm-col-6-1" id="genInfo" ng-if="$ctrl.item"><span>{{$ctrl.convertToUnix($ctrl.item.finalTimestamp)}}</span></div><div class="ibm-col-6-1" id="genInfo" ng-if="$ctrl.item"><span>DMT</span></div></div></div><div class="ibm-col-6-1" id="genInfo"><span><md-icon ng-click="$ctrl.excelExport()" title="Generate Saved Records Excel Report" md-svg-src="/public/images/ic_file_download_black_24px.svg"></md-icon></span></div></div><div ng-if="$ctrl.expand"><md-button class="md-primary md-raised" ng-click="$ctrl.toggleCriteria(\'\')"><md-icon class="white_icon" md-svg-src="/public/images/ic_bookmark_border_black_24px.svg"></md-icon><span>Searched Criteria</span></md-button><span ng-if="$ctrl.searchCriteria &amp;&amp; $ctrl.item"><span flex="50"><div ng-init="params = $ctrl.searchParams()" style="margin: 0 10px;"><span ng-repeat="param in params" layout="row"><b class="no-padding" flex="25">{{param.name}}:</b><span class="no-padding" flex="25">{{param.value}}</span></span></div></span></span></div><div ng-if="!(!$ctrl.expand)"><div class="scrol-overflow"><md-content class="dmt-white-background scrol-width-small" layout="column"><md-divider flex="flex" style="border-top-color:black"></md-divider><md-list-item class="md-2-line"><div class="add-margin md-list-item-text" layout="row" layout-align="start left"><b class="three-right" ng-if="sndLine.h!==\'visible\'" ng-repeat="sndLine in ::$ctrl.rowOrder" flex="flex">{{::sndLine.h}}</b><b class="three-right" ng-if="$ctrl.showSecondary" flex="flex">Additional Info</b></div></md-list-item><md-divider flex="flex" style="border-top-color:black"></md-divider><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unk &amp;&amp; {\'background-color\': \'orange\'}" md-virtual-repeat="line in $ctrl.dupCheckResult" flex="" md-item-size="10"><div class="add-margin md-list-item-text" layout="row" layout-align="start left"><span class="three-right" ng-if="varN.h!==\'visible\'" ng-repeat="varN in $ctrl.rowOrder" flex="11%"><span ng-if="!varN.t">{{line[varN.v]}}</span><span ng-if="varN.t.indexOf(\'d\')&gt;-1">{{line[varN.v]}}</span><span ng-if="varN.t==\'n\'">{{line[varN.v] | number: varN.n}}</span></span><span class="three-right" ng-if="$ctrl.showSecondary" flex="11%"><span ng-if="!line.visible"><span class="ibm-textcolor-orange-50" ng-click="$ctrl.toggleRow(line)">Click to View</span></span><span ng-if="line.visible"><span class="ibm-textcolor-orange-50" ng-click="$ctrl.toggleRow(line)">Click to Hide</span></span><table class="ibm-data-table ibm-grid" ng-show="line.visible" style="margin-left: -300px; margin-top: 40px; position: absolute;z-index: 1; background: white;"><tr ng-repeat="sndLine in $ctrl.dropRowOrder"><td ng-style="::$ctrl.tableStyle"><b>{{sndLine.h}}</b></td><td ng-style="::$ctrl.tableStyle"><span ng-if="!sndLine.t|| sndLine.t==\'collapse\'">{{line[sndLine.v]}}</span><span ng-if="sndLine.t.indexOf(\'d\')&gt;-1">{{line[sndLine.v]}}</span><span ng-if="sndLine.t==\'n\'">{{line[sndLine.v] | number: sndLine.n}}</span><span class="ibm-textcolor-orange-50" ng-if="sndLine.t.indexOf(\'title\')&gt;-1" title="{{line[sndLine.v]}}">Hover to View</span></td></tr></table></span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container><md-divider flex="flex" style="border-top-color:black"></md-divider></md-content></div></div><div ng-hide="!$ctrl.expand &amp;&amp; $ctrl.dupCheckResult.length &gt; 0"><span ng-hide="$ctrl.dupCheckResult.length &gt; 0">No Result found</span></div></div></div>');
$templateCache.put('detail-table-multi.html','<!--author Vlad Sirotkin--><style>.ibm-col-6-1 {\n  display: flex;\n  align-items: center;\n}</style><div ng-mouseleave="$ctrl.hovered = false;" ng-mouseover="$ctrl.hovered = true;"><div class="hover-grey"><div class="ibm-columns"><div class="ibm-col-6-5" id="genInfo" ng-click="$ctrl.toggle()"><div class="ibm-columns" id="genInfo" style="display:flex;"><div class="ibm-col-6-1" id="genInfo"><span class="ibm-h4"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><sup title="saved results / numbers of customer numbers that involved into the search">{{$ctrl.goeResult.length}}/{{$ctrl.goeResult.length}}</sup><md-icon ng-hide="$ctrl.expand" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.expand" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>{{$ctrl.row+1}}</span><sup class="ibm-textcolor-red-50" ng-bind="$ctrl.topic.searchDropDownNames[$ctrl.comp]" title="Search Type" style="background-color: yellow; padding: 5px; border-radius: 5px; font-size: 0.7em"></sup></span></div><div class="ibm-col-6-1" id="genInfo"><md-button class="mat-button-ripple mat-ripple" ng-click="$ctrl.showCmrArrayList()"><md-icon md-svg-src="/public/images/ic_remove_red_eye_black_24px.svg" style="margin-right: 10px;"></md-icon><span style="text-transform: lowercase;">click to view </span></md-button></div><div class="ibm-col-6-1" id="genInfo"><span>{{$ctrl.getCountryFullName($ctrl.item.searchParams.country)}}</span></div><div class="ibm-col-6-1" id="genInfo"><span>{{$ctrl.convertToUnix($ctrl.item.finalTimestamp)}}</span></div><div class="ibm-col-6-1" id="genInfo"><span>{{$ctrl.item.finalGoeResult}} GOE</span></div></div></div><div class="ibm-col-6-1" id="genInfo"><span><md-icon ng-click="$ctrl.excelExport()" title="Generate Saved Records Excel Report" md-svg-src="/public/images/ic_file_download_black_24px.svg"></md-icon></span></div></div><div ng-if="$ctrl.expand"><md-button class="md-primary md-raised" ng-click="$ctrl.toggleCriteria(\'\')"><md-icon class="white_icon" md-svg-src="/public/images/ic_bookmark_border_black_24px.svg"></md-icon><span>Searched Criteria</span></md-button><span ng-if="$ctrl.searchCriteria"><span flex="50"><div ng-init="params = $ctrl.searchParams()" style="margin: 0 10px;"><span ng-repeat="param in params" layout="row"><b class="no-padding" flex="25">{{param.name}}:</b><span class="no-padding" flex="25">{{param.value}}</span></span></div></span></span></div><div ng-if="!(!$ctrl.expand)"><div class="scrol-overflow"><md-content class="dmt-white-background scrol-width-small" layout="column"><md-divider flex="flex" style="border-top-color:black"></md-divider><md-list-item class="md-2-line"><div class="add-margin md-list-item-text" layout="row" layout-align="start left"><b class="three-right" ng-if="sndLine.h!==\'visible\'" ng-repeat="sndLine in ::$ctrl.rowOrder" flex="flex">{{::sndLine.h}}</b><b class="three-right" ng-if="$ctrl.showSecondary" flex="flex">Additional Info</b></div></md-list-item><md-divider flex="flex" style="border-top-color:black"></md-divider><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unk &amp;&amp; {\'background-color\': \'orange\'}" md-virtual-repeat="line in $ctrl.goeResult" flex="" md-item-size="10"><div class="add-margin md-list-item-text" layout="row" layout-align="start left"><span class="three-right" ng-if="varN.h!==\'visible\'" ng-repeat="varN in $ctrl.rowOrder" flex="11%"><span ng-if="!varN.t">{{line[varN.v]}}</span><span ng-if="varN.t.indexOf(\'d\')&gt;-1">{{line[varN.v] | date: $ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span><span ng-if="varN.t==\'n\'">{{line[varN.v] | number: varN.n}}</span></span><span class="three-right" ng-if="$ctrl.showSecondary" flex="11%"><span ng-if="!line.visible"><span class="ibm-textcolor-orange-50" ng-click="$ctrl.toggleRow(line)">Click to View</span></span><span ng-if="line.visible"><span class="ibm-textcolor-orange-50" ng-click="$ctrl.toggleRow(line)">Click to Hide</span></span><table class="ibm-data-table ibm-grid" ng-show="line.visible" style="margin-left: -300px; margin-top: 40px; position: absolute;z-index: 1; background: white;"><tr ng-repeat="sndLine in $ctrl.dropRowOrder"><td ng-style="::$ctrl.tableStyle"><b>{{sndLine.h}}</b></td><td ng-style="::$ctrl.tableStyle"><span ng-if="!sndLine.t|| sndLine.t==\'collapse\'">{{line[sndLine.v]}}</span><span ng-if="sndLine.t.indexOf(\'d\')&gt;-1">{{line[sndLine.v] | date:vm.settings.up.preferences.dateFormat : \'UTC\'}}</span><span ng-if="sndLine.t==\'n\'">{{line[sndLine.v] | number: sndLine.n}}</span><span class="ibm-textcolor-orange-50" ng-if="sndLine.t.indexOf(\'title\')&gt;-1" title="{{line[sndLine.v]}}">Hover to View</span></td></tr></table></span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container><md-divider flex="flex" style="border-top-color:black"></md-divider></md-content></div></div><div ng-hide="!$ctrl.expand &amp;&amp; $ctrl.goeResult.length &gt; 0"><span ng-hide="$ctrl.goeResult.length &gt; 0">No Result found</span><span ng-bind="\'-\' + $ctrl.item.error" ng-hide="!$ctrl.item.error"></span></div></div></div>');
$templateCache.put('display-missing-error.html','<span ng-mouseleave="$ctrl.hovered = false;" ng-mouseover="$ctrl.hovered = true;"><span ng-if="$ctrl.topic.topic.complete.errorsArray[$ctrl.section]"><span ng-if="($ctrl.section !== \'all\' &amp;&amp; !$ctrl.topic.topic.complete[$ctrl.section]) || $ctrl.topic.topic.complete.errorsArray[$ctrl.section].length &gt; 0"><md-icon class="red_icon" ng-click="$ctrl.showErrors($event)" title="View Missing Errors" md-svg-src="/public/images/ic_thumb_down_black_24px.svg"></md-icon><sub>{{$ctrl.topic.topic.complete.errorsArray[$ctrl.section].length}}</sub></span><span ng-if="$ctrl.section === \'all\' &amp;&amp; $ctrl.topic.topic.complete.errorsArray[$ctrl.section].length === 0"><md-icon class="green_icon" title="All sections appear to be correct for this stage" md-svg-src="/public/images/ic_thumb_up_black_24px.svg"></md-icon></span><span ng-if="$ctrl.topic.topic.complete[$ctrl.section] &amp;&amp; $ctrl.topic.topic.complete.errorsArray[$ctrl.section].length === 0"><md-icon class="green_icon" title="Section complete" md-svg-src="/public/images/ic_thumb_up_black_24px.svg"></md-icon></span></span><span ng-if="!$ctrl.topic.topic.complete.errorsArray[$ctrl.section]"><md-icon class="red_icon" title="No error list found for \'{{$ctrl.section}}\' yet" md-svg-src="/public/images/ic_thumb_down_black_24px.svg"></md-icon><sub>x</sub></span></span>');
$templateCache.put('display-other-contacts.html','<!--author Ivan Toth--><md-dialog ng-cloak="ng-cloak"><md-toolbar><div class="md-toolbar-tools"><h2>{{vm.dialogName}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class="scrol-overflow search-form"><md-content class="dmt-white-background scrol-width-small" layout="column"><md-list-item class="md-2-line"><div class="add-margin md-list-item-text" layout="row" layout-align="start left"><b class="three-right" flex="11%">Position</b><b class="three-right" flex="11%">Email 2</b><b class="three-right" flex="11%">Last Name</b><b class="three-right" flex="11%">First Name</b><b class="three-right" flex="11%">Work Phone</b><b class="three-right" flex="11%">Cell Phone</b></div><md-divider flex="flex" style="border-top-color:black"></md-divider></md-list-item><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" md-virtual-repeat="line in vm.table" flex="" md-item-size="10"><div class="add-margin md-list-item-text" layout="row" layout-align="start left"><span class="three-right" flex="11%">{{line.position}}</span><span class="three-right" flex="11%">{{line.email2}}</span><span class="three-right" flex="11%">{{line.conlastname}}</span><span class="three-right" flex="11%">{{line.confirstname}}</span><span class="three-right" flex="11%">{{line.conwrkphone}}</span><span class="three-right" flex="11%">{{line.concellphone}}</span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container></md-content></div></md-dialog-content></md-dialog>');
$templateCache.put('detail-contact-info.html','<!--author Ivelin Ivanov--><div class="ibm-columns" id="generalInfo"><span class="ibm-h4" ng-click="$ctrl.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-if="!$ctrl.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-if="$ctrl.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;Contact Information</span><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp + \'Section\'].ci.status"><md-icon class="red_icon" md-svg-src="/public/images/ic_warning_black_24px.svg" title="One or more values have changed since the last time the Opportunity data was loaded"></md-icon></span><span class="ibm-textcolor-blue-40" style="font-size:medium">&nbsp;&nbsp;Click to {{$ctrl.visible ? \'hide\' : \'view\'}}</span></span><div id="contact_info" ng-if="$ctrl.topic.topic.newUI &amp;&amp; $ctrl.visible"><table class="scrol-overflow ibm-data-table ibm-grid ibm-altrows"><thead><th>Full Name</th><th>First Name</th><th>Last Name</th><th>Role</th><th>Employee Role</th><th>Email</th><th>Serial No.</th></thead><tbody> <tr ng-repeat="user in $ctrl.topic.topic.mysa_contacts.others | orderBy: user.last_name"><td>{{::user.name}}</td><td>{{::user.first_name}}</td><td>{{::user.last_name}}</td><td>{{::user.role}}</td><td>{{::user.employee_job_role || \'-\'}}</td><td>{{::user.user_name}}</td><td>{{::user.employee_cnum}}</td></tr></tbody></table></div><div id="contact_info" ng-if="!$ctrl.topic.topic.newUI &amp;&amp; $ctrl.visible"><div id="contact_info_nodiff" ng-if="!$ctrl.diff"><table class="scrol-overflow ibm-data-table ibm-grid ibm-altrows"><thead><th>Last Name</th><th>First Name</th><th>Work Phone</th><th>Job Title</th><th>E-mail</th><th>Account</th><th>Mobile Phone</th></thead><tbody><tr ng-repeat="line in $ctrl.topic.topic[$ctrl.comp]"><td>{{::line.lname}}</td><td>{{::line.fname}}</td><td>{{::line.wrkphone}}</td><td>{{::line.jobtitle}}</td><td>{{::line.email}}</td><td>{{::line.account}}</td><td>{{::line.cellphone}}</td></tr></tbody></table></div><div id="contact_info_diff" ng-if="$ctrl.diff"><table class="scrol-overflow ibm-data-table ibm-grid ibm-altrows"><thead><th>Last Name</th><th>First Name</th><th>Work Phone</th><th>Job Title</th><th>E-mail</th><th>Account</th><th>Mobile Phone</th></thead><tbody><tr ng-repeat="line in $ctrl.topic.topic[$ctrl.comp]"><td><span ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].found"><md-icon class="red_icon" md-svg-src="/public/images/ic_close_black_24px.svg" title="This row was not found in live Opportunity data"></md-icon></span><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].lname">{{::line.lname}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].lname">{{::line.lname}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].fname">{{::line.fname}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].fname">{{::line.fname}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].wrkphone">{{::line.wrkphone}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].wrkphone">{{::line.wrkphone}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].jobtitle">{{::line.jobtitle}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].jobtitle">{{::line.jobtitle}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].email">{{::line.email}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].email">{{::line.email}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].account">{{::line.account}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].account">{{::line.account}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].cellphone">{{::line.cellphone}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].cellphone">{{::line.cellphone}}</span></td></tr><tr ng-repeat="line in $ctrl.topic.compareGpp[$ctrl.comp + \'Missing\']" title="This row was not available the last time the Opportunity data was loaded - Please reload the Opportunity data by clicking the \'Refresh Opportunity Data\' button at the top of the page"><td><span class="green_text">{{::line.lname}}</span></td><td><span class="green_text">{{::line.fname}}</span></td><td><span class="green_text">{{::line.wrkphone}}</span></td><td><span class="green_text">{{::line.jobtitle}}</span></td><td><span class="green_text">{{::line.email}}</span></td><td><span class="green_text">{{::line.account}}</span></td><td><span class="green_text">{{::line.cellphone}}</span></td></tr></tbody></table></div></div></div>');
$templateCache.put('detail-family-brand.html','<!--author Ivan Toth--><div class="ibm-columns" id="generalInfo"><span class="ibm-h4" ng-click="$ctrl.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-if="!$ctrl.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-if="$ctrl.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;Brand Family</span><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp + \'Section\'].bf.status"><md-icon class="red_icon" md-svg-src="/public/images/ic_warning_black_24px.svg" title="One or more values have changed since the last time the Opportunity data was loaded"></md-icon></span><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp + \'Section\'].ods.status"><md-icon class="orange_icon" md-svg-src="/public/images/ic_warning_black_24px.svg" title="ODS mismatch found"></md-icon></span><span class="ibm-textcolor-blue-40" style="font-size:medium">&nbsp;&nbsp;Click to {{$ctrl.visible ? \'hide\' : \'view\'}}</span></span><span><span class="ibm-textcolor-orange-50" style="font-size:xx-small;">&nbsp;&nbsp;{{$ctrl.topic.compareGpp[$ctrl.comp + \'Section\'].ods.message}}</span><display-error ng-if="$ctrl.comp ===\'gpp\'" section="$ctrl.completeSection" style="margin-left:10px;"></display-error></span><div id="brand_family" ng-if="$ctrl.visible"><div id="brand_family_nodiff" ng-if="!$ctrl.diff"><table class="scrol-overflow ibm-data-table ibm-grid ibm-altrows"><thead><th ng-if="[\'gpp\',\'gpp_valid\'].indexOf($ctrl.comp) &gt; -1">Eligible?</th><th>Solution ID</th><th>Row ID</th><th ng-if="[\'gpp\',\'gpp_valid\'].indexOf($ctrl.comp) &gt; -1 &amp;&amp; $ctrl.topic.topic.newUI">Duplicate Opportunity Found?</th><th ng-if="[\'gpp\',\'gpp_valid\'].indexOf($ctrl.comp) &gt; -1 &amp;&amp; $ctrl.topic.topic.newUI">Duplicate Opportunity No.</th><th ng-if="!$ctrl.topic.topic.newUI">Bill Date</th><th>Type</th><th>Brand Family</th><th>Brand</th><th ng-if="!$ctrl.topic.topic.newUI">Win Probability</th><th>Quantity</th><th ng-if="!$ctrl.topic.topic.newUI">Price</th><th>Revenue</th><th>Sales Order Number</th><th>Brand Family CVR Participation</th><th>Brand Certification Achieved</th><th>Sales Stage</th><th>Currency</th><th>MySA status</th></thead><tbody><tr ng-repeat="line in $ctrl.topic.temp[$ctrl.comp]"><td ng-if="$ctrl.comp === \'gpp\'"><span ng-if="!$ctrl.topic.editableComponents[$ctrl.comp].socket &amp;&amp; ($ctrl.eligOptions.length === 0)"><md-icon class="red_icon" md-svg-icon="/public/images/ic_info_outline_black_24px.svg" title="Cannot make Eligibility Decision until the GOE flag is set"></md-icon></span><span ng-if="!$ctrl.topic.editableComponents[$ctrl.comp].socket &amp;&amp; ($ctrl.eligOptions.length &gt; 0)"><md-select ng-model="$ctrl.topic.temp[$ctrl.comp][$index].elig_decision" style="min-width:100px" md-on-close="$ctrl.updateGppEligstatus($index)" aria-label="Eligible"><md-option ng-repeat="item in $ctrl.eligOptions track by $index" value="{{item}}">{{item}}</md-option></md-select></span><span ng-if="$ctrl.topic.editableComponents[$ctrl.comp].socket">{{line.elig_decision}}</span></td><td ng-if="$ctrl.comp === \'gpp_valid\'"><span>{{::line.elig_decision}}</span></td><td>{{line.solutionId || \'\'}}</td><td>{{::line.row_id}}</td><td ng-if="[\'gpp\',\'gpp_valid\'].indexOf($ctrl.comp) &gt; -1 &amp;&amp; $ctrl.topic.topic.newUI"><span ng-if="!$ctrl.topic.editableComponents[$ctrl.comp].socket &amp;&amp; ($ctrl.duplicateOptions.length &gt; 0) &amp;&amp; $ctrl.comp === \'gpp\'"><md-select ng-model="$ctrl.topic.temp[$ctrl.comp][$index].dup_check_flg" style="min-width:100px" md-on-close="$ctrl.updateGppEligstatus($index)" aria-label="Yes"><md-option ng-repeat="item in $ctrl.duplicateOptions track by $index" value="{{item}}">{{item}}</md-option></md-select></span><span ng-if="$ctrl.topic.editableComponents[$ctrl.comp].socket || $ctrl.comp === \'gpp_valid\'">{{line.dup_check_flg}}</span></td><td ng-if="[\'gpp\',\'gpp_valid\'].indexOf($ctrl.comp) &gt; -1 &amp;&amp; $ctrl.topic.topic.newUI">{{line.dup_check_flg === \'No\' ? \'N/A\' : (line.dup_check_num || \'\')}}</td><td ng-if="!$ctrl.topic.topic.newUI">{{::line.billdate | date:$ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</td><td>{{::line.level10prod}}</td><td>{{::line.brandfam}}</td><td>{{::line.brand}}</td><td ng-if="!$ctrl.topic.topic.newUI">{{(line.winprob | number:0) + \' %\'}}</td><td>{{::line.revn_qty | number:0}}</td><td ng-if="!$ctrl.topic.topic.newUI">{{( line.price !== null ? (line.price | number:2) : 0.00 ) + \' \' + line.crncy}}</td><td>{{(line.revenue | number:2) + \' \' + line.crncy}}</td><td>{{::line.salesorder}}</td><td>{{::line.brandfamsviparticip}}</td><td>{{::line.brandcert}}</td><td>{{::line.salesstage}}</td><td>{{::line.crncy}}</td><td>{{::line.x_svi_status}}</td></tr></tbody></table></div><div id="brand_family_diff" ng-if="$ctrl.diff"><table class="scrol-overflow ibm-data-table ibm-grid ibm-altrows"><thead><th ng-if="$ctrl.comp === \'gpp\'">Eligible?</th><th>Solution ID</th><th>Row ID</th><th ng-if="[\'gpp\',\'gpp_valid\'].indexOf($ctrl.comp) &gt; -1 &amp;&amp; $ctrl.topic.topic.newUI">Duplicate Opportunity Found?</th><th ng-if="[\'gpp\',\'gpp_valid\'].indexOf($ctrl.comp) &gt; -1 &amp;&amp; $ctrl.topic.topic.newUI">Duplicate Opportunity No.</th><th ng-if="!$ctrl.topic.topic.newUI">Bill Date</th><th>Type</th><th>Brand Family</th><th>Brand</th><th ng-if="!$ctrl.topic.topic.newUI">Win Probability</th><th>Quantity</th><th ng-if="!$ctrl.topic.topic.newUI">Price</th><th>Revenue</th><th>Sales Order Number</th><th>Brand Family CVR Participation</th><th>Brand Certification Achieved</th><th>Sales Stage</th><th>Currency</th><th>MySA status</th></thead><tbody><tr ng-repeat="line in $ctrl.topic.temp[$ctrl.comp]"><td ng-if="$ctrl.comp === \'gpp\'"><span ng-if="!$ctrl.topic.editableComponents[$ctrl.comp].socket &amp;&amp; ($ctrl.eligOptions.length === 0)"><md-icon class="red_icon" md-svg-icon="/public/images/ic_info_outline_black_24px.svg" title="Cannot make decission before GOE flag is set"></md-icon></span><span ng-if="!$ctrl.topic.editableComponents[$ctrl.comp].socket &amp;&amp; ($ctrl.eligOptions.length &gt; 0)"><md-select ng-model="$ctrl.topic.temp[$ctrl.comp][$index].elig_decision" style="min-width:100px" md-on-close="$ctrl.updateGppEligstatus($index)" aria-label="Eligible"><md-option ng-repeat="item in $ctrl.eligOptions track by $index" value="{{item}}">{{item}}</md-option></md-select></span><span ng-if="$ctrl.topic.editableComponents[$ctrl.comp].socket">{{line.elig_decision}}</span></td><td><span ng-if="!$ctrl.editableSolution"><div>{{line.solutionId || \'\'}}</div><md-icon class="blue_icon" ng-if="$ctrl.comp === \'gpp\' &amp;&amp; !$ctrl.isSolutionUpdating &amp;&amp; !$ctrl.topic.editableComponents[$ctrl.comp].socket" md-svg-icon="/public/images/lead-pencil.svg" style="{\'cursor\':\'pointer\'}" ng-click="$ctrl.editSolution($event, \'edit\', line)" title="Edit Solution IDs"></md-icon><span class="ibm-spinner" ng-if="$ctrl.comp === \'gpp\' &amp;&amp; $ctrl.isSolutionUpdating" style="margin: 5px 10px 0px 2px"></span><p></p><span class="logComments" ng-click="$ctrl.isSolutionUpdating = !$ctrl.isSolutionUpdating" ng-if="$ctrl.comp === \'gpp\' &amp;&amp; line.solutionId_user" title="{{$ctrl.getOrigSols(line)}}">User-Edited</span></span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].row_id">{{::line.row_id}}</span></td><td><span ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].found"><md-icon class="red_icon" md-svg-src="/public/images/ic_close_black_24px.svg" title="This row was not found in live Opportunity data"></md-icon></span><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].row_id">{{::line.row_id}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].row_id">{{::line.row_id}}</span></td><td ng-if="[\'gpp\',\'gpp_valid\'].indexOf($ctrl.comp) &gt; -1 &amp;&amp; $ctrl.topic.topic.newUI"><span ng-if="!$ctrl.topic.editableComponents[$ctrl.comp].socket &amp;&amp; ($ctrl.duplicateOptions.length &gt; 0) &amp;&amp; $ctrl.comp === \'gpp\'"><md-select ng-model="$ctrl.topic.temp[$ctrl.comp][$index].dup_check_flg" style="min-width:100px" md-on-close="$ctrl.updateGppEligstatus($index)" aria-label="Yes"><md-option ng-repeat="item in $ctrl.duplicateOptions track by $index" value="{{item}}">{{item}}</md-option></md-select></span><span ng-if="($ctrl.topic.editableComponents[$ctrl.comp].socket || $ctrl.comp === \'gpp_valid\') &amp;&amp; $ctrl.topic.topic.newUI">{{line.dup_check_flg}}</span></td><td ng-if="[\'gpp\',\'gpp_valid\'].indexOf($ctrl.comp) &gt; -1 &amp;&amp; $ctrl.topic.topic.newUI"><span ng-if="!$ctrl.editableDuplicate"><div>{{$ctrl.topic.temp[$ctrl.comp][$index].dup_check_flg === \'No\' ? \'N/A\' : (line.dup_check_num || \'\')}}</div><md-icon class="blue_icon" ng-if="$ctrl.topic.temp[$ctrl.comp][$index].dup_check_flg === \'Yes\' &amp;&amp; $ctrl.comp === \'gpp\' &amp;&amp; !$ctrl.isDupeUpdating &amp;&amp; !$ctrl.topic.editableComponents[$ctrl.comp].socket" md-svg-icon="/public/images/lead-pencil.svg" style="{\'cursor\':\'pointer\'}" ng-click="$ctrl.editDupeOpp($event, \'edit\', line)" title="Edit Duplicate Check Opportunity No."></md-icon><span class="ibm-spinner" ng-if="$ctrl.topic.temp[$ctrl.comp][$index].dup_check_flg === \'Yes\' &amp;&amp; $ctrl.comp === \'gpp\' &amp;&amp; $ctrl.isDupeUpdating" style="margin: 5px 10px 0px 2px"></span><p></p></span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].row_id">{{::line.row_id}}</span></td><td ng-if="!$ctrl.topic.topic.newUI"><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].billdate">{{::line.billdate | date:$ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].billdate">{{::line.billdate | date:$ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].level10prod">{{::line.level10prod}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].level10prod">{{::line.level10prod}}</span></td><td><span ng-if="line.ods_mismatch"><md-icon class="orange_icon" md-svg-src="/public/images/ic_warning_black_24px.svg" title="Error appeared when comparing ODS data: {{line.ods_mismatch}}"> </md-icon></span><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].brandfam">{{::line.brandfam}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].brandfam">{{::line.brandfam}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].brand">{{::line.brand}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].brand">{{::line.brand}}</span></td><td ng-if="!$ctrl.topic.topic.newUI"><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].winprob">{{(line.winprob | number:0) + \' %\'}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].winprob">{{(line.winprob | number:0) + \' %\'}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].revn_qty">{{::line.revn_qty | number:0}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].revn_qty">{{::line.revn_qty | number:0}}</span></td><td ng-if="!$ctrl.topic.topic.newUI"><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].price">{{( line.price!== null ? (line.price | number:2) : 0.00 ) + \' \' + line.crncy}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].price">{{( line.price!==null ? (line.price | number:2) : 0.00 ) + \' \' + line.crncy}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].revenue">{{(line.revenue | number:2) + \' \' + line.crncy}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].revenue">{{(line.revenue | number:2) + \' \' + line.crncy}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].salesorder">{{::line.salesorder}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].salesorder">{{::line.salesorder}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].brandfamsviparticip">{{::line.brandfamsviparticip}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].brandfamsviparticip">{{::line.brandfamsviparticip}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].brandcert">{{::line.brandcert}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].brandcert">{{::line.brandcert}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].salesstage">{{::line.salesstage}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].salesstage">{{::line.salesstage}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].crncy">{{::line.crncy}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].crncy">{{::line.crncy}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].x_svi_status">{{::line.x_svi_status}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].x_svi_status">{{::line.x_svi_status}}</span></td></tr><tr ng-repeat="line in $ctrl.topic.compareGpp[$ctrl.comp + \'Missing\']" title="This row was not available the last time the Opportunity data was loaded - Please reload the Opportunity data by clicking the \'Refresh Opportunity Data\' button at the top of the page to make it editable"><td ng-if="$ctrl.comp === \'gpp\'"><span style="color:red;background-color: yellow; border-radius: 8px"> <span style="margin-left: 2px; margin-right: 2px; padding: 2px">** NEW **</span></span></td><td><span class="green_text">{{::line.solutionId || \'\'}}</span></td><td><span class="green_text">{{::line.row_id}}</span></td><td><span class="green_text">{{line.dup_check_flg}}</span></td><td><span class="green_text">{{line.dup_check_flg === \'No\' ? \'N/A\' : (line.dup_check_num || \'\')}}</span></td><td><span class="green_text">{{::line.billdate | date:$ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></td><td><span class="green_text">{{::line.level10prod}}</span></td><td><span class="green_text">{{::line.brandfam}}</span></td><td><span class="green_text">{{::line.brand}}</span></td><td><span class="green_text">{{(line.winprob | number:0) + \' %\'}}</span></td><td><span class="green_text">{{::line.revn_qty | number:0}}</span></td><td><span class="green_text">{{(line.price | number:2) + \' \' + line.crncy}}</span></td><td><span class="green_text">{{(line.revenue | number:2) + \' \' + line.crncy}}</span></td><td><span class="green_text">{{::line.salesorder}}</span></td><td><span class="green_text">{{::line.brandfamsviparticip}}</span></td><td><span class="green_text">{{::line.brandcert}}</span></td><td><span class="green_text">{{::line.salesstage}}</span></td><td><span class="green_text">{{::line.crncy}}</span></td><td><span class="green_text">{{::line.x_svi_status}}</span></td></tr></tbody></table></div></div></div>');
$templateCache.put('detail-general-body.html','<div>TO DISPLAY IF ITS PRESENT</div><form class="ibm-row-form" method="post" action=""><div class="ibm-col-6-2"><h1>General Information</h1><label for="generalTemplate">Opportunity number:<input type="text" size="40" id="oppNumber"/></label><label for="generalTemplate">Overall MySA status:<input type="text" size="40" id="sviStatus"/></label><label for="generalTemplate">Business Partner:<input type="text" size="40" id="bp"/></label><label for="generalTemplate">Customer number:<input type="text" size="40" id="custNum"/></label><label for="generalTemplate">CVR Owning Organization:<input type="text" size="40" id="sviOrganization"/></label><label for="generalTemplate">Opportunity Currency:<input type="text" size="40" id="oppCurrency"/></label></div></form>');
$templateCache.put('detail-general-gpp.html','<div class="ibm-columns" id="generalInfo"><div class="ibm-col-6-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><h2 class="ibm-h2">General Information</h2></div><div class="ibm-col-6-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><span><u>Loaded on:</u></span><span>&nbsp;{{ vm.topic.topic[vm.comp][0].timestamp | date:vm.settings.up.preferences.dateFormat}}</span></div></div><div class="ibm-columns" id="generalInfo"><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Opportunity Number:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].opp"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Overall MySA Status:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].svioverallstat"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>{{vm.getNewUIInfo.getSVISumbitDateName()}}</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].svisubmitdate | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Expiration Date:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].sviexpdate | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Decision Date:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].decisiondate | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Sales Stage:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].salesstage"></label></div></div></div></div></div><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Overall Opportunity Revenue:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div> <!-- label.ibm-textcolor-blue-50.ibm-bold(ng-bind="vm.topic.topic[vm.comp][0].overall_revenue")--><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.topic.topic[vm.comp][0].overall_revenue | number : 0}}</label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Opportunity Currency:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].crncy"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Description:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].svidesc"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Comments:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].svicmnt"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Is Restricted?:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].isrestr"></label></div></div></div></div></div></div><div class="ibm-columns" ng-if="!vm.topic.topic.newUI"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Opportunity Number 2:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].opp2"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Business Partner:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bpname"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Customer Number:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].accnumbpinc"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>CVR Owning Organization:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bpname"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Country from Organization:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].cntrybpinc"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>ISU Code Number:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].isucodenum"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>ISU Code Description:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].isucodedesc"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Extension Request:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].exceptionreq"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Site:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].site2"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Work in MySA:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].workgpp"></label></div></div></div></div></div><div class="ibm-columns" id="accountInfo"><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><h2 class="ibm-h2">Business Partner Information</h2><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Business Partner:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bpname"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Business Partner CEID:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].cnum"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Business Partner Country:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="!vm.getNewUIInfo.uiVersion || vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_3"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_country"></label></div><div ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.bpCountry()"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Business Partner Name:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.bpName()"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Business Partner E-mail:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.email"></label></div></div></div></div></div></div><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><h2 class="ibm-h2">Account Information</h2><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account Name:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].acctname"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account Alternate Language Name:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].altlaname"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account Address:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].acctaddr"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account City:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].acctcity"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account Postal Code:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].acctpostcode"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account Country:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="!vm.getNewUIInfo.uiVersion || vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_3"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].acctctry"></label></div><div ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.accountCountry()"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account State Province:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].acctstate"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Passport Advantage Site Number:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.paSiteNum"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account DCID:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.getAccountValue(\'domesticClientId\')"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account DBG:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.getAccountValue(\'domesticBuyingGroup\')"> </label></div></div></div></div></div><div ng-if="!vm.topic.topic.newUI"><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_name"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Address for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_addr"></label><!--label.ibm-textcolor-blue-50.ibm-bold(ng-bind="vm.topic.topic[vm.comp][0].addbpinc")--></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>City for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_city"></label><!--label.ibm-textcolor-blue-50.ibm-bold(ng-bind="vm.topic.topic[vm.comp][0].citybpinc")--></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>IBM Acct Cust Num for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_cmr"></label><!--label.ibm-textcolor-blue-50.ibm-bold(ng-bind="vm.topic.topic[vm.comp][0].accnumbpinc")--></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Country for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_country"></label><!--label.ibm-textcolor-blue-50.ibm-bold(ng-bind="vm.topic.topic[vm.comp][0].cntrybpinc")--></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>State for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_state"></label><!--label.ibm-textcolor-blue-50.ibm-bold(ng-bind="vm.topic.topic[vm.comp][0].statebpinc")--></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>ZIP Code for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic[vm.comp][0].bp_inc_zip"></label><!--label.ibm-textcolor-blue-50.ibm-bold(ng-bind="vm.topic.topic[vm.comp][0].zipbpinc")--></div></div></div></div></div></div></div></div><detail-brand-family comp="vm.comp" diff="false" diffArray="vm.diffArray"></detail-brand-family><detail-sales-team comp="vm.comp" diff="false" diffArray="vm.diffArray"></detail-sales-team><detail-opp-reg comp="vm.comp" diff="false" diffArray="vm.diffArray"></detail-opp-reg><detail-svi comp="vm.comp" diff="false" diffArray="vm.diffArray"></detail-svi><detail-contact-info comp="vm.comp" diff="false" diffArray="vm.diffArray"></detail-contact-info>');
$templateCache.put('detail-general-header.html','<div class="ibm-column-form"><p class="ibm-form-elem-grp"><label>Opportunity :</label><span>{{::vm.topic.OPPTYNO}}</span></p><p class="ibm-form-elem-grp"><label>Brand Family :</label><span>{{::vm.topic.BRANDFAMILY}}</span></p><p class="ibm-form-elem-grp"><label>Quantity :</label><span>{{::vm.topic.QUANTIY}}</span></p><p class="ibm-form-elem-grp"><label>Revenue :</label><span>{{::vm.topic.REVENUE}}</span></p><p class="ibm-form-elem-grp"><label>Country :</label><span>{{::vm.topic.COUNTRY}}</span></p><p class="ibm-form-elem-grp"><label>Submision Date :</label><span>{{::vm.topic.SVISUBMITDATE | date:\'dd/MM/yyyy\'}}</span></p><p class="ibm-form-elem-grp"><label>Expery Date :</label><span>{{::vm.topic.SVIEXPDATE  | date:\'dd/MM/yyyy\'}}</span></p><p class="ibm-form-elem-grp"><label>Overal Status :</label><span>{{::vm.topic.SVIOVERALLSTATUS}}</span></p><p class="ibm-form-elem-grp"><label>Account Name :</label><span>{{::vm.topic.ACCTNAME}}</span></p><p class="ibm-form-elem-grp"><label>Brand</label><span>{{::vm.topic.BRAND}}</span></p><p class="ibm-form-elem-grp"><label>BP Name :</label><span>{{::vm.topic.BPNAME}}</span></p><p class="ibm-form-elem-grp"><label>Owning Org :</label><span>{{::vm.topic.SVISVIOWNINGORGNAME}}</span></p><p class="ibm-ind-link ibm-btn-row margin-change"><a class="ibm-btn-pri ibm-forward-link" type="button" ng-click="vm.edit()">Edit</a></p></div>');
$templateCache.put('detail-general-results.html','<div style="float:left" id="expandResults"><div class="ibm-col-5-5"><a class="ibm-information-link" ng-click="" title="Information link" href="">Expand Results</a><table class="ibm-data-table ibm-grid ibm-altrows" id="expandResultsTable" style="margin-top: 30px; margin-bottom:30px;"><thead><th>Bill Date</th><th>Type</th><th>Brand Family</th><th>Brand</th><th>CVR Participation</th><th>Brand Certification Achieved</th><th>Win Probability</th><th>Quantity</th><th>Price</th><th>Revenue Opportunity Currency</th></thead><tbody><tr><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td></tr></tbody></table></div></div>');
$templateCache.put('detail-general-solution-override-dialog.html','<md-dialog aria-label="{{vm.field}}" ng-cloak="ng-cloak"><md-toolbar><div class="md-toolbar-tools"><h2>{{vm.dialogName}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div><span>{{vm.message}}</span></div><p></p><table class="ibm-data-table" cellspacing="0" cellpadding="0"><tr><td><span class="ibm-textcolor-blue-40">Comment&nbsp;&nbsp;</span></td><td><input style="width: 20em;" ng-model="vm.comment"/></td></tr></table><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.clickYes()" ng-disabled="vm.comment.trim() === \'\'">{{vm.okMessage}}</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.clickNo()">{{vm.cancelMessage}}</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" style="float:right" ng-if="vm.addCancel" ng-click="vm.cancel()">Cancel</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('detail-general-solution-update-dialog.html','<style>.box {\n    border: solid lightgray 1px; \n    overflow-y: scroll; \n    overflow-x:hidden; \n    padding: 10px; \n    background-color: white; \n    height: 200px; \n    width: 40em\n}\n.new {\n    float: left; \n    border: 1px solid lightgray; \n    padding: 5px 0px 5px 17px; \n    background-color: #fdffdd;\n}\n.actions {\n    border: solid 1px lightgray;  \n    padding: 7px 0px 7px 0px;  \n    margin-left: 10px;\n}\n.mysa {\n    background-color: #e6ffe6;\n}\n.key {\n    border: 1px solid #91f791;\n    background-color: #e6fee6;\n    color: #e6fee6;\n}\n.keyBox {\n    float: right;\n    border: 1px solid lightgray;\n    padding: 7px;\n}</style><md-dialog aria-label="Update Solution IDs" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Update Solution IDs</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="vm.solForm"><md-content class="md-padding"><span>Please add, edit or delete accordingly. &nbsp;Click </span><b>Save Changes </b><span>or </span><b>Cancel </b><span>when done.</span><p></p><div class="box"><div class="new"><span style="color: #a57123">Add New Solution ID -></span><md-button class="ibm-btn-pri ibm-btn-small md-icon-button" aria-label="Add" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px -6px -3px;" ng-click="vm.update(\'Add\',solly)" title="New Solution ID"><md-icon class="orange_icon" md-svg-icon="/public/images/ic_add_circle_black_24px.svg"></md-icon></md-button><span>Total: </span><b>{{vm.ecount}} &nbsp;&nbsp;</b></div><span class="keyBox" title="Any Solution ID with a green background indicates an ID that originated from MySA"><span class="key">KEY</span><span>&nbsp;&nbsp;Original MySA Solution ID</span></span><p></p><p></p><span ng-repeat="solly in vm.edit"><p></p><span style="font-size: x-small; color: lightgray">{{$index+1}}.&nbsp;&nbsp;</span><input class="userField" ng-class="{\'mysa\': vm.mysaSols.indexOf(solly.n) &gt; -1}" ng-disabled="solly.d" ng-model="solly.n" ng-required="true" size="30em" placeholder="Delete if not needed"/><!--span(ng-if="solly.d" style="margin-right: 138px;") Marked for Deletion--><span class="actions"><md-button class="ibm-btn-pri ibm-btn-small md-icon-button" ng-if="solly.d || solly.n !== solly.o" aria-label="Undo" style="width: 37px;height: 30px;padding: 6px;margin-left: 3px; margin-right: -17px;" ng-click="vm.update(\'Undo\',solly)" title="Undo Changes"><md-icon class="blue_icon" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon></md-button><md-icon class="light_blue_icon" ng-if="!solly.d &amp;&amp; solly.n === solly.o" style="margin-left: 10px; margin-right: -11px;" md-svg-icon="/public/images/ic_autorenew_black_24px.svg" title="No change detected.  Can\'t undo"></md-icon><!--md-button(aria-label="Delete" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;" ng-click="vm.edit.splice($index,1)", class="ibm-btn-pri ibm-btn-small md-icon-button" title="Delete Solution ID")--><md-button class="ibm-btn-pri ibm-btn-small md-icon-button" ng-if="!solly.d" aria-label="Delete" style="width: 37px;height: 30px;padding: 6px;margin: -7px 7px;" ng-click="vm.update(\'Delete\',solly, $index)" title="Delete Solution ID"><md-icon class="red_icon" md-svg-icon="/public/images/delete-forever.svg"></md-icon></md-button><md-icon class="pink_icon" ng-if="solly.d" style="margin: 0px 13px 1px 14px;" md-svg-icon="/public/images/delete-forever.svg" title="Already marked for deletion"></md-icon></span><span ng-if="solly.d || solly.n !== solly.o" style="color: slategray; margin-left: 10px" title="Original Solution ID - Click Undo to revert">{{solly.o}}</span></span></div><p></p><span>Please enter justification for overriding the Solution ID(s):</span><p></p><textarea class="userField" name="comments" ng-model="vm.comments" style="resize: none" rows="3" cols="80" resize="false" ng-required="true"></textarea></md-content><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.answer()" ng-disabled="(vm.solDec === \'Solution only\' &amp;&amp; vm.ecount === 0) || (vm.solForm.$pristine &amp;&amp; vm.count === vm.ecount) || !vm.solForm.$valid">Save Changes</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.cancel()">Cancel</md-button><span class="ibm-textcolor-red-50" style="font-size: small" ng-if="vm.solDec === \'Solution only\' &amp;&amp; vm.ecount === 0">\'Solution only\' Disbursements must have at least 1 Solution ID</span><p></p></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('detail-general-solution-update-don-dialog.html','<md-dialog aria-label="Update Duplicate Opportunity Number" ng-cloak=""><md-toolbar><div class="md-toolbar-tools"><h2>Update Duplicate Opportunity Number</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_white_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="vm.solForm"><md-content class="md-padding"><span>Please type Duplicate Opportunity Number. &nbsp;Click </span><b>Save Changes </b><span>or </span><b>Cancel </b><span>when done.</span><p></p><div><input class="userField" ng-model="vm.oppyName" ng-required="true" size="30em"/></div></md-content><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.answer()" ng-disabled="(vm.solDec === \'Solution only\' &amp;&amp; vm.ecount === 0) || (vm.solForm.$pristine &amp;&amp; vm.count === vm.ecount) || !vm.solForm.$valid">Save Changes</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.cancel()">Cancel</md-button><p></p></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('detail-general-status.html','<div id="OverallStatus"><div class="ibm-col-5-5"><h2 class="ibm-h2">Overall Status</h2><textarea id="statusArea" rows="5" cols="80">TEST</textarea><table class="ibm-data-table ibm-grid ibm-altrows" id="statusTable" style="margin-top: 30px; margin-bottom:30px;"><thead><th>Missing information</th><th>Date/ Time</th><th>Source</th><th>Comment</th></thead><tbody><tr><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td></tr></tbody></table><a class="ibm-document-link">Attach document</a></div></div>');
$templateCache.put('detail-general.html','<style>#indent-vertical {\n  display: block; \n  padding: 10px 0 10px 0;\n}</style><form class="ibm-column-form" method="post"><div ng-if="!vm.getNewUIInfo.uiVersion || vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_3"><detail-gpp></detail-gpp></div><div ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><detail-gpp-static></detail-gpp-static><div class="ibm-columns" id="indent-vertical"><detail-table-compl-cl-opportunity-detail id="indent-vertical"></detail-table-compl-cl-opportunity-detail><detail-table-compl-cl-investment-review id="indent-vertical"></detail-table-compl-cl-investment-review><detail-table-compl-cl-payment id="indent-vertical"></detail-table-compl-cl-payment><detail-table-compl-cl-exceptions id="indent-vertical"></detail-table-compl-cl-exceptions><b class="ibm-h3 ibm-textcolor-blue-40">BP Notifications</b><bp-notifications-section id="indent-vertical"></bp-notifications-section><detail-comment id="indent-vertical"></detail-comment></div></div></form>');
$templateCache.put('detail-opp-registration.html','<!--author Ivelin Ivanov--><div class="ibm-columns" ng-if="!$ctrl.topic.topic.newUI" id="generalInfo"><span class="ibm-h4" ng-click="$ctrl.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="$ctrl.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;Opportunity Registration</span><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp + \'Section\'].st.status"><md-icon class="red_icon" md-svg-src="/public/images/ic_warning_black_24px.svg" title="One or more values have changed since the last time the Opportunity data was loaded"></md-icon></span><span class="ibm-textcolor-blue-40" style="font-size:medium">&nbsp;&nbsp;Click to {{$ctrl.visible ? \'hide\' : \'view\'}}</span></span><div id="opp_reg" ng-if="$ctrl.visible"><div id="opp_reg_nodiff" ng-if="!$ctrl.diff"><table class="scrol-overflow ibm-data-table ibm-grid ibm-altrows"><thead><th>Incentive Name</th><th>Incentive Status</th><th>Request Date</th><th>Approval Identifier</th><th>Bussiness Type</th><th>Competitor</th><th>Serial Number Replaced</th><th>Incentive Expiration Date</th><th>Partner Name</th></thead><tbody><tr ng-repeat="line in $ctrl.topic.topic[$ctrl.comp]"><td>{{::line.inctvname}}</td><td>{{::line.inctvstat}}</td><td>{{::line.reqdate | date:$ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</td><td>{{::line.approvalident}}</td><td>{{::line.bustype}}</td><td>{{::line.competitor}}</td><td>{{::line.sernumreplaced}}</td><td>{{::line.inctvexpdate | date:$ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</td><td>{{::line.bpname}}</td></tr></tbody></table></div><div id="contact_info_diff" ng-if="$ctrl.diff"><table class="scrol-overflow ibm-data-table ibm-grid ibm-altrows"><thead><th>Incentive Name</th><th>Incentive Status</th><th>Request Date</th><th>Approval Identifier</th><th>Bussiness Type</th><th>Competitor</th><th>Serial Number Replaced</th><th>Incentive Expiration Date</th><th>Partner Name</th></thead><tbody><tr ng-repeat="line in $ctrl.topic.topic[$ctrl.comp]"><td><span ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].found"><md-icon class="red_icon" md-svg-src="/public/images/ic_close_black_24px.svg" title="This row was not found in live Opportunity data"></md-icon></span><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].inctvname">{{::line.inctvname}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].inctvname">{{::line.inctvname}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].inctvstat">{{::line.inctvstat}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].inctvstat">{{::line.inctvstat}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].reqdate">{{::line.reqdate | date:$ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].reqdate">{{::line.reqdate | date:$ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].approvalident">{{::line.approvalident}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].approvalident">{{::line.approvalident}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].bustype">{{::line.bustype}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].bustype">{{::line.bustype}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].competitor">{{::line.competitor}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].competitor">{{::line.competitor}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].sernumreplaced">{{::line.sernumreplaced}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].sernumreplaced">{{::line.sernumreplaced}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].inctvexpdate">{{::line.inctvexpdate | date:$ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].inctvexpdate">{{::line.inctvexpdate | date:$ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].bpname">{{::line.bpname}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].bpname">{{::line.bpname}}</span></td></tr><tr ng-repeat="line in $ctrl.topic.compareGpp[$ctrl.comp + \'Missing\']" title="This row was not available the last time the Opportunity data was loaded - Please reload the Opportunity data by clicking the \'Refresh Opportunity Data\' button at the top of the page"><td><span class="green_text">{{::line.inctvname}}</span></td><td><span class="green_text">{{::line.inctvstat}}</span></td><td><span class="green_text">{{::line.reqdate | date:$ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></td><td><span class="green_text">{{::line.approvalident}}</span></td><td><span class="green_text">{{::line.bustype}}</span></td><td><span class="green_text">{{::line.competitor}}</span></td><td><span class="green_text">{{::line.sernumreplaced}}</span></td><td><span class="green_text">{{::line.inctvexpdate | date:$ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></td><td><span class="green_text">{{::line.bpname}}</span></td></tr></tbody></table></div></div></div>');
$templateCache.put('detail-sales-team.html','<style>.primary{\n    background-color: yellow;\n}</style><!--author Ivelin Ivanov--><div class="ibm-columns" id="generalInfo"><span class="ibm-h4" ng-click="$ctrl.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-if="!$ctrl.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-if="$ctrl.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;Sales Team</span><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp + \'Section\'].st.status"><md-icon class="red_icon" md-svg-src="/public/images/ic_warning_black_24px.svg" title="One or more values have changed since the last time the Opportunity data was loaded"></md-icon></span><span class="ibm-textcolor-blue-40" style="font-size:medium">&nbsp;&nbsp;Click to {{$ctrl.visible ? \'hide\' : \'view\'}}</span></span><table class="scrol-overflow ibm-data-table ibm-grid ibm-altrows" ng-if="$ctrl.topic.topic.newUI &amp;&amp; $ctrl.visible"><thead><th>Full Name</th><th>First Name</th><th>Last Name</th><th>Role</th><th>Employee Role</th><th>Email</th><th>Serial No.</th></thead><tbody> <tr ng-class="{primary: user.primary}" ng-repeat="user in $ctrl.topic.topic.mysa_contacts.sales_team | orderBy: user.last_name"><td>{{::user.name}}</td><td>{{::user.first_name}}</td><td>{{::user.last_name}}</td><td ng-if="user.primary">Requestor</td><td ng-if="!user.primary">{{::user.role}}</td><td>{{::user.employee_job_role || \'-\'}}</td><td>{{::user.user_name}}</td><td>{{::user.employee_cnum}}</td></tr></tbody></table><table class="scrol-overflow ibm-data-table ibm-grid ibm-altrows" ng-if="!$ctrl.topic.topic.newUI &amp;&amp; $ctrl.visible"><thead><th>Work phone {{!$ctrl.topic.topic.newUI}}</th><th>CE_ID</th><th>Organization</th><th>Position</th><th>Mobile Phone</th><th>Primary</th><th>First Name</th><th>Last Name</th><th>E-mail</th><th>Other Contacts</th></thead><tbody><tr><td>{{::$ctrl.topic.topic[$ctrl.comp][0].conwrkphone}}</td><td>{{::$ctrl.topic.topic[$ctrl.comp][0].cnum}}</td><td>{{::$ctrl.topic.topic[$ctrl.comp][0].bpname}}</td><td>{{::$ctrl.topic.topic[$ctrl.comp][0].position}}</td><td>{{::$ctrl.topic.topic[$ctrl.comp][0].phone}}</td><td>{{::$ctrl.topic.topic[$ctrl.comp][0].primary}}</td><td>{{::$ctrl.topic.topic[$ctrl.comp][0].confirstname}}</td><td>{{::$ctrl.topic.topic[$ctrl.comp][0].conlastname}}</td><td>{{::$ctrl.topic.topic[$ctrl.comp][0].email2}}</td><td><md-icon md-svg-src="/public/images/ic_list_black_24px.svg" ng-click="$ctrl.displayOtherContatcs()" title="Display other contacts"></md-icon></td></tr></tbody></table></div>');
$templateCache.put('detail-svi.html','<!--author Ivan Toth--><div class="ibm-columns" ng-if="!$ctrl.topic.topic.newUI" id="generalInfo"><span class="ibm-h4" ng-click="$ctrl.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="$ctrl.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!$ctrl.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;Software Value Incentive</span><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp + \'Section\'].svi.status"><md-icon class="red_icon" md-svg-src="/public/images/ic_warning_black_24px.svg" title="One or more values have changed since the last time the Opportunity data was loaded"></md-icon></span><span class="ibm-textcolor-blue-40" style="font-size:medium">&nbsp;&nbsp;Click to {{$ctrl.visible ? \'hide\' : \'view\'}}</span></span><div id="svi" ng-if="$ctrl.visible"><div id="svi_nodiff" ng-if="!$ctrl.diff"><table class="scrol-overflow ibm-data-table ibm-grid ibm-altrows"><thead><th>Row ID</th><th>Type</th><th>Brand Family</th><th>Quantity</th><th>Price</th><th>Revenue</th><th>Opportunity Currency</th><th>MySA Status</th><th>Duplicate Opportunity</th><th>Duplicate Opportunity Number</th><th>CVR comments</th></thead><tbody><tr ng-repeat="line in $ctrl.topic.topic[$ctrl.comp]"><td>{{::line.row_id}}</td><td>{{::line.level10prod}}</td><td>{{::line.brandfam}}</td><td>{{::line.revn_qty | number:0}}</td><td>{{(line.price | number:2) + \' \' + line.crncy}}</td><td>{{(line.revenue | number:2) + \' \' + line.crncy}}</td><td>{{::line.crncy}}</td><td>{{::line.x_svi_status}}</td><td>{{::line.dup_opp_flg}}</td><td>{{::line.dup_opp_num}}</td><td>{{::line.svicmnt}}</td></tr></tbody></table></div><div id="svi_diff" ng-if="$ctrl.diff"><table class="scrol-overflow ibm-data-table ibm-grid ibm-altrows"><thead><th>Row ID</th><th>Type</th><th>Brand Family</th><th>Quantity</th><th>Price</th><th>Revenue</th><th>Opportunity Currency</th><th>MySA Status</th><th>Duplicate Opportunity</th><th>Duplicate Opportunity Number</th><th>CVR comments</th></thead><tbody><tr ng-repeat="line in $ctrl.topic.topic[$ctrl.comp]"><td><span ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].found"><md-icon class="red_icon" md-svg-src="/public/images/ic_close_black_24px.svg" title="This row was not found in live Opportunity data"></md-icon></span><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].row_id">{{::line.row_id}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].row_id">{{::line.row_id}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].level10prod">{{::line.level10prod}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].level10prod">{{::line.level10prod}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].brandfam">{{::line.brandfam}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].brandfam">{{::line.brandfam}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].revn_qty">{{::line.revn_qty | number:0}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].revn_qty">{{::line.revn_qty | number:0}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].price">{{(line.price | number:2) + \' \' + line.crncy}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].price">{{(line.price | number:2) + \' \' + line.crncy}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].revenue">{{(line.revenue | number:2) + \' \' + line.crncy}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].revenue">{{(line.revenue | number:2) + \' \' + line.crncy}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].crncy">{{::line.crncy}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].crncy">{{::line.crncy}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].x_svi_status">{{::line.x_svi_status}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].x_svi_status">{{::line.x_svi_status}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].dup_opp_flg">{{::line.dup_opp_flg}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].dup_opp_flg">{{::line.dup_opp_flg}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].dup_opp_num">{{::line.dup_opp_num}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].dup_opp_num">{{::line.dup_opp_num}}</span></td><td><span ng-if="$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].svicmnt">{{::line.svicmnt}}</span><span class="red_text" ng-if="!$ctrl.topic.compareGpp[$ctrl.comp][line.row_id].svicmnt">{{::line.svicmnt}}</span></td></tr><tr ng-repeat="line in $ctrl.topic.compareGpp[$ctrl.comp + \'Missing\']" title="This row was not available the last time the Opportunity data was loaded - Please reload the Opportunity data by clicking the \'Refresh Opportunity Data\' button at the top of the page"><td><span class="green_text">{{::line.row_id}}</span></td><td><span class="green_text">{{::line.level10prod}}</span></td><td><span class="green_text">{{::line.brandfam}}</span></td><td><span class="green_text">{{::line.revn_qty | number:0}}</span></td><td><span class="green_text">{{(line.price | number:2) + \' \' + line.crncy}}</span></td><td><span class="green_text">{{(line.revenue | number:2) + \' \' + line.crncy}}</span></td><td><span class="green_text">{{::line.crncy}}</span></td><td><span class="green_text">{{::line.x_svi_status}}</span></td><td><span class="green_text">{{::line.dup_opp_flg}}</span></td><td><span class="green_text">{{::line.dup_opp_num}}</span></td><td><span class="green_text">{{::line.svicmnt}}</span></td></tr></tbody></table></div></div></div>');
$templateCache.put('detail-logs-general.html','<!-- author Ivan Toth--><span ng-mouseover="vm.hovered = true;" ng-mouseleave="vm.hovered = false;"><md-icon class="blue_icon" md-svg-src="/public/images/ic_history_black_24px.svg" ng-click="$ctrl.viewLogs($event,$ctrl.vm.comp)" title="View Logs"></md-icon><span ng-if="$ctrl.vm.comp!=\'gpp_valid\' &amp;&amp; $ctrl.vm.comp!=\'gpp\' &amp;&amp; $ctrl.vm.comp!=\'calculation\'"><sup ng-bind="$ctrl.vm.topic.topic[$ctrl.vm.comp][\'history\'].length" ng-class="{\'upAndDown\': vm.hovered == true}"></sup></span><span ng-if="$ctrl.vm.comp==\'gpp_valid\'"><sup ng-bind="$ctrl.vm.topic.topic.gpp_history.length" ng-class="{\'upAndDown\': vm.hovered == true}"></sup></span><span ng-if="$ctrl.vm.comp==\'gpp\'"><sup ng-bind="$ctrl.vm.topic.topic.gpp_lastload_history.length" ng-class="{\'upAndDown\': vm.hovered == true}"></sup></span><span ng-if="$ctrl.vm.comp==\'calculation\'"><sup ng-bind="$ctrl.vm.topic.topic.calculation_logs.log.length" ng-class="{\'upAndDown\': vm.hovered == true}"></sup></span></span>');
$templateCache.put('detail-logs-popup.html','<!-- author Ivan Toth--><md-dialog aria-label="{{vm.field}}" ng-cloak="ng-cloak"><md-toolbar><div class="md-toolbar-tools"><h2>{{::vm.dialogName}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><table class="ibm-data-table ibm-alternate-two" ng-if="vm.logsData.length &gt; 0" cellspacing="0" cellpadding="0" border="0"><tr><th ng-repeat="header in vm.columnHeaders">{{::header}}</th></tr><tr ng-if="vm.tableType ==\'status\'" ng-repeat="line in vm.logsData"><td>{{::line.timestamp | date:vm.dateFormat}}</td><td>{{::line.event}}</td><td>{{::line.user}}</td><td><span class="ibm-textcolor-blue-50">{{::line.desc}}&nbsp;&nbsp;<span class="ibm-textcolor-orange-50 logComments" ng-if="line.comments" title="{{line.comments}}">COMMENTS</span></span></td><td>{{::line.new_owner}}</td></tr><tr ng-if="vm.tableType ==\'general\'" ng-repeat="line in vm.logsData"><td><p ng-bind-html="line.updates | linkyWithNotes : \'_blank\'"></p></td><td>{{::line.time | date:vm.dateFormat}}</td><td>{{::line.source}}</td><td>{{::line.comment}}</td></tr><tr ng-if="vm.tableType ==\'calc\'" ng-repeat="line in vm.logsData"><td>{{::line.timestamp | date:vm.dateFormat}}</td><td>{{::line.source}}</td><td>{{::line.text}}</td></tr></table><span ng-if="vm.logsData.length == 0">No Logs found</span></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('detail-eu-check.html','<!-- Modified 2017-12-01 by Kim J (card 785)--><div id="generalInfo"><span class="ibm-h4"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visibleEu" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visibleEu" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span ng-click="vm.toggleEu()">&nbsp;EU check</span><span ng-if="vm.visibleEu"><br/><esc-button-section vm="vm" lock="vm.lock" style="float:right"></esc-button-section><table class="ibm-data-table" cellspacing="0" cellpadding="0"><tr><td><br/><b>Sales Order End User name</b></td><td><br/><span>{{vm.topic.topic.sap[0].data.bpName ? vm.topic.topic.sap[0].data.bpName : \'N/A\'}}</span></td><td></td><td></td></tr><tr><td><b>Opportunity End User Name</b></td><td><span>{{vm.topic.topic.gpp_valid[0].acctname ? vm.topic.topic.gpp_valid[0].acctname : \'N/A\'}}</span></td><td></td><td></td></tr><tr><td><b>EU Check</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.eu_check.decision ? vm.topic.topic.eu_check.decision : \'To be Confirmed\'}}</span><select style="width: 10em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.eu_check.decision" ng-options="o as o for o in vm.eu_options"></select></td><td><span class="ibm-textcolor-blue-40">{{vm.topic.topic.eu_check.checkedBy}}</span></td><td><span class="ibm-textcolor-blue-40" ng-bind="vm.topic.topic.eu_check.checkedTimestamp | date:vm.settings.up.preferences.dateFormat : \'UTC\'">{{vm.topic.topic.eu_check.checkedTimestamp}}</span></td></tr></table></span></span></div>');
$templateCache.put('detail-payment-detail.html','<div id="generalInfo"><span class="ibm-h4"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visibleDetail" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visibleDetail" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span ng-click="vm.toggleDetail()">&nbsp;Manual Payment Details</span><span ng-if="vm.visibleDetail"><br/><esc-button-section vm="vm" lock="vm.lock" style="float:right"></esc-button-section><!-- md-button(ng-if="vm.canEdit" ng-disabled="vm.beingSaved" class="md-raised md-primary" ng-click="vm.saveDetail()") SAVE--><table class="ibm-data-table" cellspacing="0" cellpadding="0"><tbody><tr><td><br/><b>BP Invoice Requested:</b></td><td><br/><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.invoice_flags.requestedTimestamp ? (vm.topic.topic.invoice_flags.requestedTimestamp | date: \'yyyy-MM-dd\' ): \'N/A\'}}</span><md-datepicker ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.invoice_flags.requestedTimestamp"></md-datepicker></td><td ng-if="(vm.topic.topic.invoice_flags &amp;&amp; vm.topic.topic.invoice_flags.requestedFlaggedBy)"><br/><span class="ibm-textcolor-blue-40">{{vm.topic.topic.invoice_flags.requestedFlaggedBy}}</span></td></tr><tr><td><b>BP Invoice Received:</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.invoice_flags.receivedTimestamp ? (vm.topic.topic.invoice_flags.receivedTimestamp | date: \'yyyy-MM-dd\' ): \'N/A\'}}</span><md-datepicker ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.invoice_flags.receivedTimestamp"></md-datepicker></td><td ng-if="(vm.topic.topic.invoice_flags &amp;&amp; vm.topic.topic.invoice_flags.receivedFlaggedBy)"><span class="ibm-textcolor-blue-40">{{vm.topic.topic.invoice_flags.receivedFlaggedBy}}</span></td></tr><tr><td><b>BP Invoice Number:</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.invoice_flags.invEFTNumber ? vm.topic.topic.invoice_flags.invEFTNumber : \'N/A\'}}</span><input ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.invoice_flags.invEFTNumber" placeholder="BP Invoice No"/></td><td></td></tr><tr><td><b>BP Invoice Date:</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.invoice_flags.invEFTDate ? (vm.topic.topic.invoice_flags.invEFTDate | date: \'yyyy-MM-dd\' ): \'N/A\'}}</span><md-datepicker ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.invoice_flags.invEFTDate"></md-datepicker></td></tr><tr><td><b>Submitted to Accounts Payable:</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.invoice_flags.submittedTimestamp ? (vm.topic.topic.invoice_flags.submittedTimestamp | date: \'yyyy-MM-dd\') : \'N/A\'}}</span><md-datepicker ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.invoice_flags.submittedTimestamp"></md-datepicker></td><td ng-if="(vm.topic.topic.invoice_flags &amp;&amp; vm.topic.topic.invoice_flags.submittedFlaggedBy)"><span class="ibm-textcolor-blue-40">{{vm.topic.topic.invoice_flags.submittedFlaggedBy}}</span></td></tr><tr><td><b>APU Tracking Number:</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.invoice_flags.apuNumber ? vm.topic.topic.invoice_flags.apuNumber : \'N/A\'}}</span><input ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.invoice_flags.apuNumber" placeholder="APU Tracking No."/></td><td></td></tr><tr><td><b>EFT:</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.invoice_flags.invEFT ? vm.topic.topic.invoice_flags.invEFT : \'N/A\'}}</span><input ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.invoice_flags.invEFT" placeholder="EFT"/></td></tr><tr><td><b>Paid Date:</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.invoice_flags.paidDate ? (vm.topic.topic.invoice_flags.paidDate | date: \'yyyy-MM-dd\') : \'N/A\'}}</span><md-datepicker ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.invoice_flags.paidDate"></md-datepicker></td></tr><tr></tr></tbody></table><table class="ibm-data-table" cellspacing="0" cellpadding="0" border="0"><tbody><tr><td><br/><b>Paid Amount:</b></td><td><br/><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.invoice_flags.paidAmount ? vm.topic.topic.invoice_flags.paidAmount : \'0.00\'}}</span><input ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.invoice_flags.paidAmount" placeholder="Enter the Amount Paid"/></td><td><br/><b>Paid Currency:</b></td><td><br/><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.invoice_flags.paidCur ? vm.topic.topic.invoice_flags.paidCur : \'???\'}}</span><input ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.invoice_flags.paidCur" placeholder="Enter the Currency"/></td><td><br/><b>Calculation Currency:</b></td><td> <br/><span ng-if="vm.topic.editableComponents[vm.comp]">{{(vm.topic.topic.calculation.children && vm.topic.topic.calculation.children[0]) ? vm.topic.topic.calculation.children[0].currency : \'???\'}}</span></td><td><br/><b>Exchange Rate</b></td><td><!--td(ng-if="!vm.topic.editableComponents[vm.comp].editMode") {{vm.topic.topic.invoice_flags.exRate ? vm.topic.topic.invoice_flags.exRate : 0.00}}--><br/><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.invoice_flags.exRate ? vm.topic.topic.invoice_flags.exRate : \'???\'}}</span><input ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.invoice_flags.exRate" placeholder="Enter the Exchange Rate"/></td><td></td></tr><tr></tr></tbody></table></span></span></div>');
$templateCache.put('detail-payment-goe-addfields.html','<!-- Created 2018-01-30 by Kim J (card 1225)--><div id="generalInfo"><span class="ibm-h4"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visibleGOEAddFields" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visibleGOEAddFields" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span ng-click="vm.toggleGOEAddFields()">&nbsp;Declaration Letter</span><span ng-if="vm.visibleGOEAddFields"><br/><br/><esc-button-section vm="vm" lock="vm.lock" style="float:right"></esc-button-section><table class="ibm-data-table" cellspacing="0" cellpadding="0"><tr><td><b>Declaration Letter Sent</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic.goe_add_fields.goe_decl_letter_sent ? vm.topic.topic.goe_add_fields.goe_decl_letter_sent: \'NA\'}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp.goe_add_fields.goe_decl_letter_sent" ng-options="o as o for o in vm.goe_decl_letter_sent"></select></td></tr></table></span><br/></span></div>');
$templateCache.put('detail-payment.html','<!--author Ivan Toth--><form class="ibm-column-form" method="post"><ctl-so-information></ctl-so-information><div><div class="ibm-columns" id="generalInfo"><detail-table-bpims></detail-table-bpims></div><div class="ibm-columns" id="generalInfo"><detail-table-compl-cl-calculation></detail-table-compl-cl-calculation></div><br/><div class="ibm-columns" id="generalInfo" ng-if="vm.topic.topic.calculation.complete &amp;&amp; vm.topic.topic.calculation.goe === \'N\' &amp;&amp; ([7,8,9].indexOf(vm.topic.topic.status.status_no) &gt; -1 || (vm.topic.topic.status.status_no === 4 &amp;&amp; [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(vm.topic.topic.status.sub_status_no) &gt; -1))"><detail-payment-detail></detail-payment-detail></div><br/><div class="ibm-columns" id="generalInfo" ng-if="vm.topic.topic.calculation.complete &amp;&amp; vm.topic.topic.calculation.goe === \'N\' &amp;&amp; ([7,8,9].indexOf(vm.topic.topic.status.status_no) &gt; -1 || (vm.topic.topic.status.status_no === 4 &amp;&amp; [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(vm.topic.topic.status.sub_status_no) &gt; -1)) &amp;&amp; (!vm.topic.topic.version || vm.topic.topic.version &lt; vm.OPP_VERSION_3)"><detail-eu-check></detail-eu-check></div><br/><div class="ibm-columns" id="generalInfo"><detail-payment-goe-addfields></detail-payment-goe-addfields></div><br/></div></form><b class="ibm-h3 ibm-textcolor-blue-40">Attachments</b><br/><br/><attachment-section title="Payment &amp; Calculation" section="payment"></attachment-section><br/><br/><detail-comment></detail-comment>');
$templateCache.put('detail-table-bpims.html','<!--author Ivan Toth--><style>.cell {\n    padding-right: 5px;\n    font-size: small;\n    white-space: normal;\n}</style><div class="ibm-textcolor-red-50" ng-if="vm.topic.topic.status.approvals.approval_required &amp;&amp; vm.topic.topic.status.status_no === 4 &amp;&amp; !vm.topic.topic.status.approvals.complete"> <p></p><b>NOTE: </b>This Disbursement has been flagged to go through the Approval Process (see&nbsp;<md-icon class="red_icon" md-svg-src="/public/images/account-multiple.svg"></md-icon>&nbsp;above).  &nbsp;Only once Approved will Payment be permitted. &nbsp;Please <span ng-if="!vm.topic.topic.complete.calculation">correct the errors beforehand.</span><span ng-if="vm.topic.topic.complete.calculation">select <b>Submit for Approval </b>from the Your Actions icon above.</span><p></p></div><div class="ibm-textcolor-red-50" ng-if="vm.topic.topic.status.approvals.approval_required &amp;&amp; vm.topic.topic.status.approvals.complete &amp;&amp; [4,6,7].indexOf(vm.topic.topic.status.status_no) &gt; -1"> <p></p><b>NOTE: </b>This Disbursement has been through the Approval Process (see&nbsp;<md-icon class="blue_icon" md-svg-src="/public/images/ic_history_black_24px.svg"></md-icon>&nbsp;above).<span ng-if="[4,6].indexOf(vm.topic.topic.status.status_no) &gt; -1"> &nbsp;&nbsp;To roll-back to Validation select&nbsp;<b>{{vm.topic.topic.status.status_no === 4 ? \'Revert\' : \'Reverse Approval\'}}</b>&nbsp;from {{vm.topic.topic.status.status_no === 4 ? \'within the Calculations section.\' : \'the Your Actions icon above.\'}}</span><p></p></div><div class="ibm-textcolor-red-50" ng-if="vm.topic.topic.status.approvals.approval_required &amp;&amp; vm.topic.topic.calculation.displayBonusCapButton"> <b>NOTE: </b>This Disbursement has been capped. To see the datails please hover over the exclamation mark next to the bonus amount.<p></p></div><div><!--span(style="display: inline-flex;")b.ibm-h3.ibm-textcolor-blue-40 &nbsp;Calculations\ndisplay-error(section="\'calculation\'" style="margin-left:10px; padding-top:2px")\n//span(ng-click="vm.toggle()")\n    md-icon(md-svg-src="/public/images/ic_grid_on_black_24px.svg")\n    md-icon(ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg")\n    md-icon(ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg")\n    b.ibm-h3.ibm-textcolor-blue-40 &nbsp;Calculations  --><!--p--><div ng-if="vm.show.main"><div class="ibm-columns" ng-form="vm.calcForm"><div class="ibm-col-6-3"><span style="display: inline-flex;"><b class="ibm-h3 ibm-textcolor-blue-40">&nbsp;Calculations</b><display-error section="\'calculation\'" style="margin-left:10px; padding-top:2px"></display-error></span></div><div class="ibm-col-6-3 ibm-right"><!--div(ng-if="vm.topic.topic.calculation && vm.topic.topic.calculation.auto===false")--><div ng-if="vm.topic.topic.calculation"><detail-table-log vm="vm"></detail-table-log><span>&nbsp;</span><esc-button-section ng-if="!vm.topic.topic.calculation.complete" vm="vm" lock="vm.lock"></esc-button-section></div></div><div class="ibm-col-1-1"><p></p><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.show.summary" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.show.summary" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span class="ibm-h4" ng-click="vm.view(\'summary\')">&nbsp;Summary</span><span ng-if="vm.show.summary" style="font-size: small"><span ng-if="vm.topic.topic.calculation.children.length &gt; 0"><div class="ibm-columns search-form"><md-content class="dmt-white-background" layout="column"><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b class="cell" flex="11%">Payment Instruction</b><b class="cell" flex="11%">Country</b><b class="cell" flex="11%">Business Partner</b><b class="cell" flex="11%">CEID</b><b class="cell" flex="11%">Status</b><b class="cell" flex="11%">Payment Frequency</b><b class="cell" flex="11%">Payment Currency</b><b class="cell" flex="11%">Forecast Total</b><b class="cell" flex="11%">Total Payment Amount</b></div></md-list-item><md-list-item class="md-2-line"><div class="md-list-item-text" ng-if="!vm.topic.editableComponents.calculation.editMode" layout="row" layout-align="start left"><span class="cell" flex="11%">{{::vm.topic.topic.calculation.id}}</span><span class="cell" flex="11%">{{::vm.topic.topic.calculation.country}}</span><span class="cell" flex="11%">{{::vm.topic.topic[\'gpp\'][0].bpname }}</span><span class="cell" flex="11%">{{::vm.topic.topic[\'gpp\'][0].cnum}}</span><span class="cell" flex="11%">{{::vm.topic.topic.calculation.auto ? \'Automatic\' : \'Manual\'}}</span><span class="cell" flex="11%">{{vm.topic.topic.calculation.goe===\'Y\'?\'N/A\':vm.topic.topic.calculation.payfrq[0]}}</span><span class="cell" flex="11%">{{vm.topic.topic.calculation.forecasts.currency}} </span><span class="cell" flex="11%">{{vm.topic.topic.calculation.totalForecastValue }} </span><span class="cell" flex="11%">{{vm.topic.topic.calculation.bonusTotal }}</span></div><div class="md-list-item-text" ng-if="vm.topic.editableComponents.calculation.editMode" layout="row" layout-align="start left"><span class="cell" flex="11%">{{::vm.topic.temp.calculation.id}}</span><span class="cell" flex="11%">{{::vm.topic.temp.calculation.country}}</span><span class="cell" flex="11%">{{::vm.topic.topic[\'gpp\'][0].bpname}}</span><span class="cell" flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><input ng-change="vm.changeValue()" ng-model="vm.topic.topic.gpp[0].cnum" aria-label="blah" style="border: solid 1px lightgray" required="required"/></md-input-container></span><span class="cell" flex="11%">{{::vm.topic.temp.calculation.auto ? \'Automatic\' : \'Manual\'}}</span><span class="cell" flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><md-select ng-change="vm.changePayFrq()" ng-model="vm.topic.temp.calculation.payfrq[0]" aria-label="blah"><md-option ng-repeat="opt in [\'WEEKLY\',\'MONTHLY\',\'QUARTERLY\']" ng-value="opt">{{opt}}</md-option></md-select><!--select(style="width: 100%" ng-model="vm.topic.temp.calculation.payfrq[0]" ng-change="vm.changePayFrq()" ng-options="opt as opt for opt in [\'WEEKLY\',\'MONTHLY\',\'QUARTERLY\']")--></md-input-container></span><span class="cell" flex="11%">{{vm.topic.topic.calculation.forecasts.currency}} </span><span class="cell" flex="11%">{{vm.topic.topic.calculation.totalForecastValue }} </span><span class="cell" flex="11%">{{vm.topic.topic.calculation.bonusTotal }}</span></div><md-divider flex="flex"></md-divider></md-list-item><md-list-item class="md-1-line" ng-if="vm.incentsCount === 0"><p></p><span ng-class="{\'ibm-textcolor-red-50\': vm.isDone(), \'ibm-textcolor-blue-40\': !vm.isDone()}" title="{{{false: \'No Payment Details are available yet.  Click the Submit button below when ready\', true: \'Contact System Admin to update the Details\'}[vm.isDone()]}}" style="padding: 5px;background-color: lightgoldenrodyellow;margin-left: 20px;">{{vm.isDone() ? \'*** Payment Details Missing ***\' : \'Awaiting Payment Details\'}}</span></md-list-item><md-list-item class="md-2-line" ng-if="vm.incentsCount &gt; 0"><div class="md-list-item-text" layout="row" layout-align="start left"><b class="cell" flex="11%">Incentive Program</b><b class="cell" flex="11%">Date Instruction Created</b><b class="cell" flex="11%">Payment Amount</b><b class="cell" flex="11%">Order Value Total</b><b class="cell" flex="11%">SAP Result</b><b class="cell" flex="11%">SAP Result Date</b></div></md-list-item><md-list-item class="md-2-line" ng-if="vm.incentsCount &gt; 0"><div class="md-list-item-text" ng-if="!vm.topic.editableComponents.calculation.editMode" layout="row" layout-align="start left"><b class="cell" flex="11%">{{vm.getNewUIInfo.uiVersion >= vm.OPP_VERSION_4 ? \'SSA\' : \'CVR SSA\'}}</b><span class="cell" flex="11%">{{::vm.incentsPaid.SSA ? (vm.topic.topic.calculation.created | date:vm.settings.up.preferences.dateFormat : \'UTC\') : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.SSA ? ((vm.topic.topic.calculation.totalSSABonus || vm.topic.topic.calculation.bonusTotal) ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.SSA ? ((vm.topic.topic.calculation.totalOrderValue || vm.topic.topic.calculation.totalOrderValues.orderTotalSSA) ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.SSA ? vm.getCredit(vm.topic.topic.calculation.sapResult, [\'SSA\']) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.SSA ? (vm.getCreditDate(vm.topic.topic.calculation.sapResult, [\'SSA\']) | date:vm.settings.up.preferences.dateFormat) : \'N/A\'}}</span></div><div class="md-list-item-text" ng-if="vm.topic.editableComponents.calculation.editMode" layout="row" layout-align="start left"><b class="cell" flex="11%">{{vm.getNewUIInfo.uiVersion >= vm.OPP_VERSION_4 ? \'SSA\' : \'CVR SSA\'}}</b><span class="cell" flex="11%">{{::vm.incentsPaid.SSA ? (vm.topic.temp.calculation.created | date:vm.settings.up.preferences.dateFormat : \'UTC\') : \'N/A\'}}</span><span class="cell" ng-if="vm.incentsPaid.SSA" flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><input ng-model="vm.topic.topic.calculation.totalSSABonus" aria-label="blah" style="border: solid 1px lightgray" required="required" disabled="disabled"/></md-input-container></span><span class="cell" ng-if="!vm.incentsPaid.SSA" flex="11%">{{\'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.SSA ? ((vm.topic.topic.calculation.totalOrderValue || vm.topic.topic.calculation.totalOrderValues.orderTotalSSA) ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.SSA ? vm.getCredit(vm.topic.topic.calculation.sapResult, [\'SSA\']) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.SSA ? (vm.getCreditDate(vm.topic.topic.calculation.sapResult, [\'SSA\']) | date:vm.settings.up.preferences.dateFormat) : \'N/A\'}}  </span></div></md-list-item><md-list-item class="md-2-line" ng-if="vm.incentsCount &gt; 0 &amp;&amp; !vm.preApril2018"><div class="md-list-item-text" ng-if="!vm.topic.editableComponents.calculation.editMode" layout="row" layout-align="start left"><b class="cell" flex="11%">{{vm.getNewUIInfo.uiVersion >= vm.OPP_VERSION_4 ? \'Engagement\' : \'CVR Solution\'}}</b><span class="cell" flex="11%">{{::vm.incentsPaid.Solution ? (vm.topic.topic.calculation.created | date:vm.settings.up.preferences.dateFormat : \'UTC\') : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Solution ? (vm.topic.topic.calculation.totalSolutionBonus ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Solution ? (vm.topic.topic.calculation.totalOrderValues.orderTotalSolution ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Solution ? vm.getCredit(vm.topic.topic.calculation.sapResult, [\'Solution\']) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Solution ? (vm.getCreditDate(vm.topic.topic.calculation.sapResult, [\'Solution\']) | date:vm.settings.up.preferences.dateFormat) : \'N/A\'}}</span></div><div class="md-list-item-text" ng-if="vm.topic.editableComponents.calculation.editMode" layout="row" layout-align="start left"><b class="cell" flex="11%">{{vm.getNewUIInfo.uiVersion >= vm.OPP_VERSION_4 ? \'Engagement\' : \'CVR Solution\'}}</b><span class="cell" flex="11%">{{::vm.incentsPaid.Solution ? (vm.topic.temp.calculation.created | date:vm.settings.up.preferences.dateFormat : \'UTC\') : \'N/A\'}}</span><span class="cell" ng-if="vm.incentsPaid.Solution" flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><input ng-model="vm.topic.temp.calculation.totalSolutionBonus" aria-label="blah" style="border: solid 1px lightgray" required="required" disabled="disabled"/></md-input-container></span><span class="cell" ng-if="!vm.incentsPaid.Solution" flex="11%">{{\'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Solution ? (vm.topic.topic.calculation.totalOrderValues.orderTotalSolution ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Solution ? vm.getCredit(vm.topic.topic.calculation.sapResult, [\'Solution\']) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Solution ? (vm.getCreditDate(vm.topic.topic.calculation.sapResult, [\'Solution\']) | date:vm.settings.up.preferences.dateFormat) : \'N/A\'}}</span></div></md-list-item><md-list-item class="md-2-line" ng-if="vm.incentsCount &gt; 0 &amp;&amp; !vm.preApril2018 &amp;&amp; vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_4"><div class="md-list-item-text" ng-if="!vm.topic.editableComponents.calculation.editMode" layout="row" layout-align="start left"><b class="cell" flex="11%">{{\'CVR New Client\'}}</b><span class="cell" flex="11%">{{::vm.incentsPaid.NewClient ? (vm.topic.topic.calculation.created | date:vm.settings.up.preferences.dateFormat : \'UTC\') : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.NewClient ? (vm.topic.topic.calculation.totalNewClientBonus ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.NewClient ? (vm.topic.topic.calculation.totalOrderValues.orderTotalNewClient ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.NewClient ? vm.getCredit(vm.topic.topic.calculation.sapResult, [\'NewClient\']) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.NewClient ? (vm.getCreditDate(vm.topic.topic.calculation.sapResult, [\'NewClient\']) | date:vm.settings.up.preferences.dateFormat) : \'N/A\'}}</span></div><div class="md-list-item-text" ng-if="vm.topic.editableComponents.calculation.editMode " layout="row" layout-align="start left"><b class="cell" flex="11%">{{\'CVR New Client\'}}</b><span class="cell" flex="11%">{{::vm.incentsPaid.NewClient ? (vm.topic.temp.calculation.created | date:vm.settings.up.preferences.dateFormat : \'UTC\') : \'N/A\'}}</span><span class="cell" ng-if="vm.incentsPaid.NewClient" flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><input ng-model="vm.topic.temp.calculation.totalNewClientBonus" aria-label="blah" style="border: solid 1px lightgray" required="required" disabled="disabled"/></md-input-container></span><span class="cell" ng-if="!vm.incentsPaid.NewClient" flex="11%">{{\'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.NewClient ? (vm.topic.topic.calculation.totalOrderValues.orderTotalNewClient ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.NewClient ? vm.getCredit(vm.topic.topic.calculation.sapResult, [\'NewClient\']) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.NewClient ? (vm.getCreditDate(vm.topic.topic.calculation.sapResult, [\'NewClient\']) | date:vm.settings.up.preferences.dateFormat) : \'N/A\'}}</span></div></md-list-item><md-list-item class="md-2-line" ng-if="vm.incentsCount &gt; 0 &amp;&amp; !vm.preApril2018 &amp;&amp; vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_4"><div class="md-list-item-text" ng-if="!vm.topic.editableComponents.calculation.editMode" layout="row" layout-align="start left"><b class="cell" flex="11%">Growth</b><span class="cell" flex="11%">{{::vm.incentsPaid.Growth ? (vm.topic.topic.calculation.created | date:vm.settings.up.preferences.dateFormat : \'UTC\') : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Growth && vm.topic.topic.calculation.totalGrowthBonus ? (vm.topic.topic.calculation.totalGrowthBonus ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Growth && vm.topic.topic.calculation.totalOrderValues.orderTotalGrowth ? (vm.topic.topic.calculation.totalOrderValues.orderTotalGrowth ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Growth && vm.getCredit(vm.topic.topic.calculation.sapResult, [\'Growth\']) ? vm.getCredit(vm.topic.topic.calculation.sapResult, [\'Growth\']) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Growth ? (vm.getCreditDate(vm.topic.topic.calculation.sapResult, [\'Growth\']) | date:vm.settings.up.preferences.dateFormat) : \'N/A\'}}</span></div><div class="md-list-item-text" ng-if="vm.topic.editableComponents.calculation.editMode" layout="row" layout-align="start left"><b class="cell" flex="11%">Growth</b><span class="cell" flex="11%">{{::vm.incentsPaid.Growth ? (vm.topic.temp.calculation.created | date:vm.settings.up.preferences.dateFormat : \'UTC\') : \'N/A\'}}</span><span class="cell" ng-if="vm.incentsPaid.Growth" flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><input ng-model="vm.topic.temp.calculation.totalGrowthBonus" aria-label="blah" style="border: solid 1px lightgray" required="required" disabled="disabled"/></md-input-container></span><span class="cell" ng-if="!vm.incentsPaid.Growth" flex="11%">{{\'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Growth ? (vm.topic.topic.calculation.totalOrderValues.orderTotalGrowth ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Growth ? vm.getCredit(vm.topic.topic.calculation.sapResult, [\'Growth\']) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Growth ? (vm.getCreditDate(vm.topic.topic.calculation.sapResult, [\'Growth\']) | date:vm.settings.up.preferences.dateFormat) : \'N/A\'}}</span></div></md-list-item><md-list-item class="md-2-line" ng-if="vm.incentsCount &gt; 0 &amp;&amp; !vm.preApril2018 &amp;&amp; vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_4"><div class="md-list-item-text" ng-if="!vm.topic.editableComponents.calculation.editMode" layout="row" layout-align="start left"><b class="cell" flex="11%">Focus</b><span class="cell" flex="11%">{{::vm.incentsPaid.Focus ? (vm.topic.topic.calculation.created | date:vm.settings.up.preferences.dateFormat : \'UTC\') : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Focus && vm.topic.topic.calculation.totalFocusBonus ? (vm.topic.topic.calculation.totalFocusBonus ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Focus && vm.topic.topic.calculation.totalOrderValues.orderTotalFocus? (vm.topic.topic.calculation.totalOrderValues.orderTotalFocus ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Focus && vm.getCredit(vm.topic.topic.calculation.sapResult, [\'Focus\']) ? vm.getCredit(vm.topic.topic.calculation.sapResult, [\'Focus\']) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Focus ? (vm.getCreditDate(vm.topic.topic.calculation.sapResult, [\'Focus\']) | date:vm.settings.up.preferences.dateFormat) : \'N/A\'}}</span></div><div class="md-list-item-text" ng-if="vm.topic.editableComponents.calculation.editMode" layout="row" layout-align="start left"><b class="cell" flex="11%">Focus</b><span class="cell" flex="11%">{{::vm.incentsPaid.Focus ? (vm.topic.temp.calculation.created | date:vm.settings.up.preferences.dateFormat : \'UTC\') : \'N/A\'}}</span><span class="cell" ng-if="vm.incentsPaid.Focus" flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><input ng-model="vm.topic.temp.calculation.totalFocusBonus" aria-label="blah" style="border: solid 1px lightgray" required="required" disabled="disabled"/></md-input-container></span><span class="cell" ng-if="!vm.incentsPaid.Focus" flex="11%">{{\'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Focus ? (vm.topic.topic.calculation.totalOrderValues.orderTotalFocus ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Focus ? vm.getCredit(vm.topic.topic.calculation.sapResult, [\'Focus\']) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Focus ? (vm.getCreditDate(vm.topic.topic.calculation.sapResult, [\'Focus\']) | date:vm.settings.up.preferences.dateFormat) : \'N/A\'}}</span></div></md-list-item><md-list-item class="md-2-line" ng-if="vm.incentsCount &gt; 0 &amp;&amp; !vm.preApril2018 &amp;&amp; vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_4"><div class="md-list-item-text" ng-if="!vm.topic.editableComponents.calculation.editMode" layout="row" layout-align="start left"><b class="cell" flex="11%">CTL</b><span class="cell" flex="11%">{{::vm.incentsPaid.Ctl ? (vm.topic.topic.calculation.created | date:vm.settings.up.preferences.dateFormat : \'UTC\') : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Ctl && vm.topic.topic.calculation.totalCtlBonus ? (vm.topic.topic.calculation.totalCtlBonus ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Ctl && vm.topic.topic.calculation.totalOrderValues.orderTotalCtl? (vm.topic.topic.calculation.totalOrderValues.orderTotalCtl ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Ctl && vm.getCredit(vm.topic.topic.calculation.sapResult, [\'Ctl\']) ? vm.getCredit(vm.topic.topic.calculation.sapResult, [\'Ctl\']) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Ctl ? (vm.getCreditDate(vm.topic.topic.calculation.sapResult, [\'Ctl\']) | date:vm.settings.up.preferences.dateFormat) : \'N/A\'}}</span></div><div class="md-list-item-text" ng-if="vm.topic.editableComponents.calculation.editMode" layout="row" layout-align="start left"><b class="cell" flex="11%">CTL</b><span class="cell" flex="11%">{{::vm.incentsPaid.Ctl ? (vm.topic.temp.calculation.created | date:vm.settings.up.preferences.dateFormat : \'UTC\') : \'N/A\'}}</span><span class="cell" ng-if="vm.incentsPaid.Ctl" flex="11%"><md-input-container flex="flex" style="padding:0; margin:0"><input ng-model="vm.topic.temp.calculation.totalCtlBonus" aria-label="blah" style="border: solid 1px lightgray" required="required" disabled="disabled"/></md-input-container></span><span class="cell" ng-if="!vm.incentsPaid.Ctl" flex="11%">{{\'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Ctl ? (vm.topic.topic.calculation.totalOrderValues.orderTotalCtl ) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Ctl ? vm.getCredit(vm.topic.topic.calculation.sapResult, [\'Ctl\']) : \'N/A\'}}</span><span class="cell" flex="11%">{{vm.incentsPaid.Ctl ? (vm.getCreditDate(vm.topic.topic.calculation.sapResult, [\'Ctl\']) | date:vm.settings.up.preferences.dateFormat) : \'N/A\'}}</span></div></md-list-item></md-content></div></span></span><p></p><div id="generalInfo"><span class="ibm-h4" ng-if="vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_4"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.show.brand" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.show.brand" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span ng-click="vm.view(\'brand\')">&nbsp;Brand Family Breakdown</span><table class="ibm-data-table ibm-grid" ng-if="vm.show.brand"><thead><tr><th>Brand Family</th><th>Paid Amount</th><th>Details</th><th>This Payment</th><th>Status</th></tr></thead><tbody ng-if="!vm.topic.editableComponents.calculation.editMode"><tr ng-repeat="(key, value) in vm.topic.topic.calculation.brandFamilies"><th><b>{{key}}</b></th><td>{{vm.topic.topic.calculation.payed[key].value}}<span ng-if="vm.topic.topic.calculation.payed[key].auto===false"><md-icon class="blue_icon" title="Manually set by user." md-svg-src="/public/images/ic_error_white_24px.svg"></md-icon></span></td><td>{{vm.topic.topic.calculation.payed[key].orders.join(\',\')}}</td><td>{{value.appliedAmount}}</td><td>{{(vm.topic.topic.calculation.payed[key].value === 0 && value.appliedAmount === 0) ? \'Not applied\' : value.fully ? \'Fully applied\' : \'Partially applied\'}}</td></tr></tbody><tbody ng-if="vm.topic.editableComponents.calculation.editMode"><tr ng-repeat="(key, value) in vm.topic.temp.calculation.brandFamilies"><th><b>{{key}}</b></th><td>{{vm.topic.temp.calculation.payed[key].value}}<span ng-if="vm.topic.topic.calculation.payed[key].auto===false"><md-icon class="blue_icon" title="Manually set by user." md-svg-src="/public/images/ic_error_white_24px.svg"></md-icon></span></td><td>{{vm.topic.temp.calculation.payed[key].orders.join(\',\')}}</td><td>{{value.appliedAmount}}</td><td>{{(vm.topic.temp.calculation.payed[key].value === 0 && value.appliedAmount === 0) ? \'Not applied\' : value.fully ? \'Fully applied\' : \'Partialy applied\'}}</td></tr></tbody></table><p></p></span></div><div id="generalInfo"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.show.detail" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.show.detail" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span class="ibm-h4" ng-click="vm.view(\'detail\')">&nbsp;Details</span><div ng-if="vm.show.detail"><p></p><span ng-if="vm.topic.editableComponents[vm.comp].socket || !vm.edit.editMode"><!--TODO - tmp --><!--the feature flag \'ctl_so\' is involved--><detail-tree-section ng-if="!vm.topic.hasCtlSo" item="vm.topic.topic.calculation" caller="\'payment\'" level="0"></detail-tree-section><detail-tree-v2-section ng-if="vm.topic.hasCtlSo" item="vm.topic.topic.calculation" caller="\'payment\'" level="0"></detail-tree-v2-section><!--TODO - tmp - end--></span><span ng-if="!vm.topic.editableComponents[vm.comp].socket &amp;&amp; vm.edit.editMode"><detail-tree-edit-section ng-if="!vm.topic.hasCtlSo" item="vm.topic.temp.calculation" caller="\'payment\'" level="0"></detail-tree-edit-section><detail-tree-edit-v2-section ng-if="vm.topic.hasCtlSo" item="vm.topic.temp.calculation" caller="\'payment\'" level="0"></detail-tree-edit-v2-section></span><div class="ibm-columns" id="generalInfo"><div layout="row" layout-sm="column">   <md-button class="md-raised md-primary" ng-if="!vm.topic.topic.calculation.complete" ng-click="vm.submit()" ng-disabled="vm.topic.editableComponents.calculation.editMode || vm.topic.topic.calculation.complete || !vm.canClick" title="{{{true: \'Submit to SAP for automated payment\', false: \'Submit to Set Aside status\' }[vm.topic.topic.calculation.goe===\'Y\']}}">Submit</md-button><md-button class="md-raised" ng-if="!vm.topic.topic.calculation.complete" ng-click="vm.reCalculate()" ng-disabled="vm.topic.editableComponents[vm.comp].socket || !vm.topic.editableComponents.calculation.editMode || !vm.canClick">Refresh</md-button><md-button class="md-raised" ng-if="vm.topic.topic.status.status_no===4 &amp;&amp; [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(vm.topic.topic.status.sub_status_no)&gt;=0 &amp;&amp; (vm.env.user.access.bpsoAdmin || vm.env.user.access.systemAdmin)" ng-click="vm.revertStatus()" ng-disabled="vm.topic.editableComponents.calculation.editMode" title="Use this to move from \'Set Aside\' back to \'Pending BPSO\' - NOTE: the Calculation will become editable again and Approval will be required if you wish to continue">Revert</md-button><md-button class="md-raised" ng-if="!vm.topic.topic.calculation.complete &amp;&amp; vm.showBonusCapButton()" ng-click="vm.disableBonusCapRule()" ng-disabled="vm.topic.editableComponents[vm.comp].socket || !vm.topic.editableComponents.calculation.editMode || !vm.canClick" title="Remove bonus cap restriction (requires recalculation)">Disable Bonus Cap</md-button><md-button class="md-raised" ng-if="vm.topic.topic.status.status_no===4 &amp;&amp; [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(vm.topic.topic.status.sub_status_no) &lt; 0 &amp;&amp; vm.env.user.access.systemAdmin" ng-click="vm.removeCalcs()" ng-disabled="vm.topic.editableComponents[vm.comp].socket || vm.topic.editableComponents.calculation.editMode || vm.isProcessing" title="Completely delete the Calculations so they can be triggered again">Remove</md-button></div></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><span ng-if="vm.isProcessing"><p></p><h2 class="ibm-textcolor-blue-50 ibm-h3">Processing. &nbsp;Please wait ...</h2><md-progress-linear md-mode="indeterminate"></md-progress-linear></span></div></div></div></div><!--.ibm-col-6-2.ibm-rightdiv(ng-if="vm.topic.topic.calculation && vm.topic.topic.calculation.auto===false")\n    detail-table-log(vm="vm")\n    span &nbsp;\n    esc-button-section(vm="vm" lock="vm.lock")--></div></div></div><br/>');
$templateCache.put('detail-table-pd.html','<!--author Ivan Toth--><div><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;Payment Details</span></span><span ng-hide="!vm.visible"><table class="ibm-data-table ibm-grid ibm-altrows"><thead><tr><th>Bill Date</th><th>Type</th><th>Brand Family</th><th>Brand</th><th>Brand Family CVR Participation</th><th>Brand Certification method</th><th>Win Probability</th><th>Quantity</th><th>Price</th><th>Revenue Opportunity Currency</th></tr></thead><tbody><tr ng-repeat="line in vm.topic.topic.pd.table"><td>{{::line.bill_date}}</td><td>{{::line.type}}</td><td>{{::line.brand_family}}</td><td>{{::line.brand}}</td><td>{{::line.brand_svi_par}}</td><td>{{::line.brand_cer_met}}</td><td>{{::line.win_prob}}</td><td>{{::line.qty}}</td><td>{{::line.price}}</td><td>{{::line.rev_opp_cur}}</td></tr></tbody></table><span class="ibm-btn-row ibm-light" ng-hide="!vm.visible"><button class="ibm-btn-pri ibm-btn-blue-50" type="button" ng-click="vm.submitPaymentRequest()" ng-disabled="!vm.topic.editableComponents.pd.editMode">Submit Payment Request</button></span></span></div><br/>');
$templateCache.put('detail-uplift-dialog.html','<!--author Ivan Toth--><md-dialog aria-label="{{vm.field}}" ng-cloak="ng-cloak"><md-toolbar><div class="md-toolbar-tools"><h2>Enter criteria for the uplift:</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div><md-input-container class="md-input-has-value" flex="flex"><label><span>IOT:</span></label><span><input name="iot" ng-model="vm.iot" placeholder="IOT" required="required" type="text"/></span></md-input-container><md-input-container class="md-input-has-value" flex="flex"><label><span>Country:</span></label><span><input name="country" ng-model="vm.country" placeholder="Country" required="required" type="text"/></span></md-input-container></div><div><md-input-container class="md-input-has-value" flex="flex"><label><span>Division Code:</span></label><span><input name="divCode" ng-model="vm.divCode" placeholder="Division Code" required="required" type="text"/></span></md-input-container><md-input-container class="md-input-has-value" flex="flex"><label><span>Channel:</span></label><span><input name="channel" ng-model="vm.channel" placeholder="Channel" required="required" type="text"/></span></md-input-container></div><div><md-input-container class="md-input-has-value" flex="flex"><label><span>Brand:</span></label><span><input name="brand" ng-model="vm.brand" placeholder="Brand" required="required" type="text"/></span></md-input-container><md-input-container class="md-input-has-value" flex="flex"><label><span>Revenue Stream Code:</span></label><span><input name="revStreamCode" ng-model="vm.revStreamCode" placeholder="Revenue Stream Code" required="required" type="text"/></span></md-input-container></div><div><md-input-container class="md-input-has-value" flex="flex"><label><span>Contract Variant:</span></label><span><input name="conVar" ng-model="vm.conVar" placeholder="Contract Variant" required="required" type="text"/></span></md-input-container><md-input-container class="md-input-has-value" flex="flex"><label><span>Line of Business:</span></label><span><input name="lob" ng-model="vm.lob" placeholder="Line of Business" required="required" type="text"/></span></md-input-container></div><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="vm.processing">OK</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('dialog-disable-cap.html','<!--author Pavel Suboch--><md-dialog ng-cloak="ng-cloak" aria-label="{{vm.field}}"><md-toolbar><div class="md-toolbar-tools"><h2>{{vm.dialogName}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" aria-label="Close dialog" md-svg-src="/public/images/ic_close_black_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div><span ng-bind-html="vm.message"></span></div><p></p><span class="ibm-textcolor-blue-40 pad">Comments:</span><p><textarea name="comment" ng-model="vm.comment" style="border: 1px solid lightgray; padding: 5px" cols="80" rows="6" required="required"></textarea></p><p></p><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.clickYes()" ng-disabled="dialogForm.$invalid || vm.processing">{{vm.okMessage}}</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.clickNo()">{{vm.cancelMessage}}</md-button><!--ng-model="vm.comment",--></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('dialog-uplift-bonus.html','<!--author Ivan Toth--><style>.pad {\n    margin-left: 1em;\n}\n.head {\n    font-size: large;\n    background-color: #ffecca;\n    padding: 1px 8px 1px 8px;\n    border-radius: 10px;\n}\n.split {\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n.perc {\n    width: 40px;\n}\n.comm {\n    width: 300px;\n    height: 25px\n}</style><md-dialog ng-cloak="ng-cloak" aria-label="Request {{::vm.type}}"><md-toolbar><div class="md-toolbar-tools"><h2>Change {{::vm.type}} Details</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon class="white_icon" aria-label="Close dialog" md-svg-src="/public/images/ic_close_black_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="vm.dialogForm"><md-content class="md-padding"><div ng-if="vm.type===\'Uplift\'"><span class="ibm-textcolor-blue-40">Uplift Type:&nbsp;&nbsp;&nbsp;</span><select ng-init="vm.upliftType=vm.upliftTypes[0]" ng-model="vm.upliftType" ng-options="type for type in vm.upliftTypes" required="required" style="width:200px;"></select><p></p><span class="ibm-textcolor-blue-40">Bonus %:</span><input class="pad perc userField" name="value" ng-model="vm.value" type="text" placeholder="%" required="required"/><span class="ibm-textcolor-blue-40 pad">Comments:</span><input class="pad comm userField" name="comments" ng-model="vm.comments" type="text" placeholder="Enter some comments" required="required"/></div><div ng-if="vm.type===\'Bonus\'"><div ng-if="vm.item.createdManual === true"><b>NOTE:&nbsp</b><span>Enter \'N/A\' in the Bonus % field to not specify Bonus or comments</span><p></p></div><div ng-if="vm.item.bonus !== undefined || vm.item.isBonusSales"><span class="head ibm-textcolor-blue-50">{{::vm.bonuses.bonus}}</span><p></p><span class="ibm-textcolor-blue-40">Bonus %:</span><input class="pad perc userField" name="value" ng-model="vm.valueBonus" ng-required="vm.item.bonus !== undefined" type="text" placeholder="%"/><span class="ibm-textcolor-blue-40 pad">Comments:</span><input class="pad comm userField" name="comments" ng-model="vm.commentsBonus" ng-required="vm.item.bonus !== undefined" type="text" placeholder="Enter some comments"/></div><div ng-if="vm.item.bonusSolution !== undefined || vm.item.isBonusSolution"><md-divider class="split" flex="flex"></md-divider><span class="head ibm-textcolor-blue-50">{{::vm.bonuses.bonusSolution}}</span><p></p><span class="ibm-textcolor-blue-40">Bonus %:</span><input class="pad perc userField" name="value" ng-model="vm.valueSolution" ng-required="vm.item.bonusSolution !== undefined" type="text" placeholder="%"/><span class="ibm-textcolor-blue-40 pad">Comments:</span><input class="pad comm userField" name="comments" ng-model="vm.commentsSolution" ng-required="vm.item.bonusSolution !== undefined" type="text" placeholder="Enter some comments"/></div><div ng-if="vm.item.bonusNewClient !== undefined || vm.item.isBonusNewClient"><md-divider class="split" flex="flex"></md-divider><span class="head ibm-textcolor-blue-50">{{::vm.bonuses.bonusNewClient}}</span><p></p><span class="ibm-textcolor-blue-40">Bonus %:</span><input class="pad perc userField" name="value" ng-model="vm.valueNewClient" ng-required="vm.item.bonusNewClient !== undefined" type="text" placeholder="%"/><span class="ibm-textcolor-blue-40 pad">Comments:</span><input class="pad comm userField" name="comments" ng-model="vm.commentsNewClient" ng-required="vm.item.bonusNewClient !== undefined" type="text" placeholder="Enter some comments"/></div></div><div ng-if="vm.item.bonusGrowth !== undefined || vm.item.isBonusGrowth"><md-divider class="split" flex="flex"></md-divider><span class="head ibm-textcolor-blue-50">{{::vm.bonuses.bonusGrowth}}</span><p></p><span class="ibm-textcolor-blue-40">Bonus %:</span><input class="pad perc userField" name="value" ng-model="vm.valueGrowth" ng-required="vm.item.bonusGrowth !== undefined" type="text" placeholder="%"/><span class="ibm-textcolor-blue-40 pad">Comments:</span><input class="pad comm userField" name="comments" ng-model="vm.commentsGrowth" ng-required="vm.item.bonusGrowth !== undefined" type="text" placeholder="Enter some comments"/></div><div ng-if="vm.item.bonusFocus !== undefined || vm.item.isBonusFocus"><md-divider class="split" flex="flex"></md-divider><span class="head ibm-textcolor-blue-50">{{::vm.bonuses.bonusFocus}}</span><p></p><span class="ibm-textcolor-blue-40">Bonus %:</span><input class="pad perc userField" name="value" ng-model="vm.valueFocus" ng-required="vm.item.bonusFocus !== undefined" type="text" placeholder="%"/><span class="ibm-textcolor-blue-40 pad">Comments:</span><input class="pad comm userField" name="comments" ng-model="vm.commentsFocus" ng-required="vm.item.bonusFocus !== undefined" type="text" placeholder="Enter some comments"/></div><div ng-if="vm.item.bonusCtl !== undefined || vm.item.isBonusCtl"><md-divider class="split" flex="flex"></md-divider><span class="head ibm-textcolor-blue-50">{{::vm.bonuses.bonusCtl}}</span><p></p><span class="ibm-textcolor-blue-40">Bonus %:</span><input class="pad perc userField" name="value" ng-model="vm.valueCtl" ng-required="vm.item.bonusCtl !== undefined" type="text" placeholder="%"/><span class="ibm-textcolor-blue-40 pad">Comments:</span><input class="pad comm userField" name="comments" ng-model="vm.commentsCtl" ng-required="vm.item.bonusCtl !== undefined" type="text" placeholder="Enter some comments"/></div><p></p><md-divider class="split" flex="flex"></md-divider><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.answer()" ng-disabled="!vm.dialogForm.$valid">OK</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.cancel()">Cancel</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('payment-gate.html','<span class="ibm-h4"><span ng-if="vm.calculationVersion === 1"><detail-payment></detail-payment></span><span ng-if="vm.calculationVersion === 2"><payment></payment></span></span>');
$templateCache.put('detail-sampling-activate.html','<style>.ui {\n    border: lightgray solid 1px;\n    padding: 10px\n}\n.uia {\n    background-color: #d6ffd6;\n    color: darkgreen\n}\n.uid {\n    background-color: #ffe9ec;\n    color: red;\n}\n.status {\n    padding: 0px 5px 2px 5px;\n    border-radius: 5%;\n}</style><div><div class="ibm-cols"><div class="ibm-col-1-1"></div><!--h1(style="margin-left:10px" ng-if="!vm.isCLLoaded || vm.events.updating" class="ibm-textcolor-blue-40 ibm-h3")--><h1 class="ibm-textcolor-blue-40 ibm-h3" ng-if="vm.events.updating" style="margin-left:10px"><span>Updating, please wait...</span><span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h1><div class="ui"><span class="ibm-textcolor-blue-50 ibm-h4">Current Status&nbsp;</span><span class="status ibm-h4" ng-class="{\'uia\': vm.events.active || vm.events.complete, \'uid\': !vm.events.active }">{{!vm.events.active && !vm.events.overridden ? \'Untested - Awaiting Activation\' : vm.incentiveStatus.samplingStatus}}</span><span ng-if="vm.incentiveStatus.sampTimeStart"><p></p><span class="ibm-textcolor-blue-40">Activated for Sampling on&nbsp;</span><b>{{vm.incentiveStatus.sampTimeStart | date: \'medium\' : \'UTC\'}}&nbsp;</b><span class="ibm-textcolor-blue-40">by&nbsp;</span><b>{{vm.incentiveStatus.initBy}}</b><p></p><span class="ibm-textcolor-blue-40">Activation Reason:&nbsp;</span><span>{{vm.incentiveStatus.sampReason}}</span></span><span ng-if="vm.incentiveStatus.sampTimeEnd"><p></p><span class="ibm-textcolor-blue-40">Completed on&nbsp;</span><b>{{vm.incentiveStatus.sampTimeEnd | date: \'medium\'  : \'UTC\'}}&nbsp;</b></span><span ng-if="vm.incentiveStatus.deactDate"><p></p><span class="ibm-textcolor-blue-40">Deactivated on&nbsp;</span><b>{{vm.incentiveStatus.deactDate | date: \'medium\'  : \'UTC\'}}&nbsp;</b><span class="ibm-textcolor-blue-40">by&nbsp;</span><b>{{vm.incentiveStatus.deactBy}}</b><p></p><span class="ibm-textcolor-blue-40">Dectivation Reason:&nbsp;</span><span>{{vm.incentiveStatus.deactReason}}</span></span><span ng-if="vm.incentiveStatus.checklistError"><p></p><span class="ibm-textcolor-blue-50">Checklist Error:&nbsp;</span><span class="ibm-textcolor-red-50">{{vm.incentiveStatus.checklistError}}&nbsp; Once resolved, Deactivate and Reactivate to pull the latest checklist.</span></span><p>      </p><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.sampButton(\'Activate\',\'Manually sampled - In Progress\')" ng-disabled="vm.events.updating || vm.topic.editableComponents.sampling.socket !==\'\' " ng-if="!vm.events.active"><md-icon class="white_icon" md-svg-icon="/public/images/rocket.svg"></md-icon><span style="margin-left: 5px">Activate Sampling    </span></md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.sampButton(\'Deactivate\',\'Manual override\')" ng-disabled="vm.events.updating || vm.topic.editableComponents.sampling.socket !==\'\' " ng-if="vm.events.active &amp;&amp; !vm.events.complete"><md-icon class="white_icon" md-svg-icon="/public/images/close-circle-outline.svg"></md-icon><span style="margin-left: 5px">Deactivate Sampling</span></md-button></div></div></div><p></p>');
$templateCache.put('detail-sampling-notification.html','<!-- Created 2017-12-01 by Kim J (card 1165)--><div id="generalInfo"><span class="ibm-h4"><md-icon md-svg-src="/public/images/ic_list_black_24px.svg"></md-icon><md-icon ng-hide="vm.visibleNotifications" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visibleNotifications" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span ng-click="vm.toggleNotifications()">&nbsp;View notifications</span><span ng-if="vm.visibleNotifications"><br/><esc-button-section vm="vm" lock="vm.lock" style="float:right"></esc-button-section><table class="ibm-data-table" cellspacing="0" cellpadding="0"><tr><td><b>Initial Notification</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic[vm.comp].notification ? vm.topic.topic[vm.comp].notification: \'No notification\'}}</span><input ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp[vm.comp].notification" style="width: 30em"/></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic[vm.comp].notification_date ? (vm.topic.topic[vm.comp].notification_date | date: \'yyyy-MM-dd\' ): \'No notification date\'}}</span><md-datepicker ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp[vm.comp].notification_date"></md-datepicker></td></tr><tr><td><b>1. Reminder</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic[vm.comp].first_reminder ? vm.topic.topic[vm.comp].first_reminder : \'No reminder\'}}</span><input ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp[vm.comp].first_reminder" style="width: 30em"/></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic[vm.comp].first_reminder_date ? (vm.topic.topic[vm.comp].first_reminder_date | date: \'yyyy-MM-dd\' ): \'No reminder date\'}}</span><md-datepicker ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp[vm.comp].first_reminder_date"></md-datepicker></td></tr><tr><td><b>2. Reminder</b></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic[vm.comp].second_reminder ? vm.topic.topic[vm.comp].second_reminder : \'No reminder\'}}</span><input ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp[vm.comp].second_reminder" style="width: 30em"/></td><td><span ng-if="!vm.topic.editableComponents[vm.comp].editMode">{{vm.topic.topic[vm.comp].second_reminder_date ? (vm.topic.topic[vm.comp].second_reminder_date | date: \'yyyy-MM-dd\' ): \'No reminder date\'}}</span><md-datepicker ng-if="vm.topic.editableComponents[vm.comp].editMode" ng-model="vm.topic.temp[vm.comp].second_reminder_date"></md-datepicker></td></tr><tr></tr></table></span><br/><br/></span></div>');
$templateCache.put('detail-sampling-upload.html','<!--@author Ivan Toth--><span class="ibm-h4" ng-click="vm.showHide()"><md-icon md-svg-src="/public/images/ic_attachment_black_24px.svg"></md-icon><span ng-if="!vm.showAttachment">&nbsp;Expand Attachment</span><span ng-if="vm.showAttachment">&nbsp;Collapse Attachment</span></span><div class="ibm-columns" ng-if="vm.showAttachment"><div class="ibm-col-6-4"><div ng-if="vm.topic.topic.files != 0"><table ng-if="!vm.topic.editableComponents.files.socket &amp;&amp; vm.edit.editMode"><tr><th>File</th><th>Comments</th></tr><tr ng-repeat="fil in vm.topic.temp.files| filter: { type: \'sampling\' }"><td><span><md-icon md-svg-src="/public/images/ic_remove_red_eye_black_24px.svg"></md-icon></span><u ng-click="vm.downloadAttachment(fil.name)" title="Download {{::fil.name}}">{{::fil.name}}&nbsp;&nbsp;</u></td><td><input ng-model="fil.comment"/></td></tr></table><table ng-if="!(!vm.topic.editableComponents.files.socket &amp;&amp; vm.edit.editMode)"><tr><th>File</th><th>Comments</th></tr><tr ng-repeat="fil in vm.topic.topic.files| filter: { type: \'sampling\' }"><td><span><md-icon md-svg-src="/public/images/ic_remove_red_eye_black_24px.svg"></md-icon></span><u ng-click="vm.downloadAttachment(fil.name)" title="Download {{::fil.name}}">{{::fil.name}}&nbsp;&nbsp;</u></td><td><span>{{fil.comment}}</span></td></tr></table><span ng-if="vm.topic.topic.files == 0"><span>No files uploaded.</span></span></div><br/><br/><div ng-if="!vm.topic.editableComponents.files.socket"><button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" ngf-select="vm.uploadFiles($files)" multiple="multiple" ngf-max-size="5MB" ngf-drop="vm.setSource()" ng-model="vm.sources"><md-icon class="white_icon" md-svg-src="/public/images/ic_file_upload_black_24px.svg"></md-icon><span>Upload File</span></button><span></span><span ng-if="vm.fileUploaded"></span></div></div><div class="ibm-col-6-2 ibm-right"><div ng-if="vm.topic.loaded.topic"><esc-button-section vm="vm" lock="false"></esc-button-section></div><div ng-if="!vm.topic.loaded.topic"><md-icon class="rotating" md-svg-src="/public/images/ic_autorenew_black_24px.svg"></md-icon></div></div></div>');
$templateCache.put('detail-sampling.html','<!--author Ivan Toth--><br/><b class="ibm-h3 ibm-textcolor-blue-40">Sampling Details</b><br/><div class="ibm-columns flex" ng-if="!(vm.isIncEmpty())" style="margin-left: 10px; margin-top: 15px "><md-tabs class="admin-tabs" md-dynamic-height="md-dynamic-height"><md-tab label="SSA"><form class="ibm-column-form" method="post"><detail-table-samp-q incentive="SSA"></detail-table-samp-q></form><b class="ibm-h3 ibm-textcolor-blue-40">Notifications</b><br/><br/><detail-sampling-notification section="sampling_notification_Solution"></detail-sampling-notification><br/><br/><b class="ibm-h3 ibm-textcolor-blue-40">Case IDs</b><table class="ibm-data-table" ng-if="vm.caseIdPRMs.length" cellspacing="0" cellpadding="0"><tr><td><b>Group IDs</b></td><td><b>URL</b></td></tr><tr ng-repeat="case in vm.caseIdPRMs"><td> <b>{{case.groupId}}</b></td><td><a href="{{case.url}}" target="_blank"> {{case.url}}</a></td></tr></table><br/><br/><b class="ibm-h3 ibm-textcolor-blue-40">Attachments</b><br/><br/><attachment-section title="Sampling" section="sampling_SSA" incentive="SSA"></attachment-section><br/><br/><div ng-if="[1,2].includes(vm.uiVersion)"><attachment-mysa-section title="MYSA" section="mysa" incentive="SSA"></attachment-mysa-section><br/><br/></div><div ng-if="vm.uiVersion &gt;= vm.OPP_VERSION_3"><attachment-section title="MYSA" section="mysa" incentive="SSA"></attachment-section><br/><br/></div><div ng-if="vm.uiVersion &gt;= vm.OPP_VERSION_5"><p style="font-weight: bold">Documentation Status</p><select style="width: 20em" ng-model="vm.salesDocumentationStatus" ng-options="o as o for o in vm.documentationStatusValues" ng-change="vm.changeCurrentSalesDocumentationStatus()" ng-disabled="!vm.isSamplingActive(\'SSA\')"></select><span ng-if="vm.isSalesDocumentationStatusChanged"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.saveSalesDocumentationStatus()" ng-disabled="vm.isDocumentationStatusUpdating" title="Confirm and save SSA Documentation Status"><md-icon class="white_icon" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Save</md-button></span></div><detail-comment section="sampling_SSA"></detail-comment></md-tab><div ng-if="vm.uiVersion &gt;= vm.OPP_VERSION_4"><md-tab label="Engagement"><form class="ibm-column-form" method="post"><detail-table-samp-q incentive="Solution"></detail-table-samp-q></form><b class="ibm-h3 ibm-textcolor-blue-40">Notifications</b><br/><br/><detail-sampling-notification section="sampling_notification_SSA"></detail-sampling-notification><b class="ibm-h3 ibm-textcolor-blue-40">Attachments </b><br/><br/><attachment-section title="Sampling" section="sampling_Solution" incentive="Solution"></attachment-section><br/><br/><div ng-if="vm.uiVersion &gt;= vm.OPP_VERSION_3"><attachment-section title="MYSA" section="mysa" incentive="Solution"></attachment-section><br/><br/></div><div ng-if="vm.uiVersion &gt;= vm.OPP_VERSION_5"><p style="font-weight: bold">Documentation Status</p><select style="width: 20em" ng-model="vm.engagementDocumentationStatus" ng-options="o as o for o in vm.documentationStatusValues" ng-change="vm.changeCurrentEngagementDocumentationStatus()" ng-disabled="!vm.isSamplingActive(\'Solution\')"></select><span ng-if="vm.isEngagementDocumentationStatusChanged"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.saveEngagementDocumentationStatus()" ng-disabled="vm.isDocumentationStatusUpdating" title="Confirm and save Engagement Documentation Status"><md-icon class="white_icon" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Save</md-button></span></div><detail-comment section="sampling_Solution"></detail-comment></md-tab></div><div ng-if="!vm.uiVersion || vm.uiVersion &lt; vm.OPP_VERSION_4"><md-tab label="Solutoin"><form class="ibm-column-form" method="post"><detail-table-samp-q incentive="Solution"></detail-table-samp-q></form><b class="ibm-h3 ibm-textcolor-blue-40">Notifications</b><br/><br/><detail-sampling-notification section="sampling_notification_SSA"></detail-sampling-notification><b class="ibm-h3 ibm-textcolor-blue-40">Attachments </b><br/><br/><attachment-section title="Sampling" section="sampling_Solution" incentive="Solution"></attachment-section><br/><br/><div ng-if="[1,2].includes(vm.uiVersion)"><attachment-mysa-section title="MYSA" section="mysa" incentive="Solution"></attachment-mysa-section><br/><br/></div><div ng-if="vm.uiVersion &gt;= vm.OPP_VERSION_3"><attachment-section title="MYSA" section="mysa" incentive="Solution"></attachment-section><br/><br/></div><detail-comment section="sampling_Solution"></detail-comment></md-tab></div></md-tabs></div><div class="ibm-columns flex" ng-if="vm.isIncEmpty()" style="margin-left: 10px; margin-top: 15px "><form class="ibm-column-form" method="post"><detail-table-samp-q></detail-table-samp-q></form><b class="ibm-h3 ibm-textcolor-blue-40">Notifications</b><br/><br/><detail-sampling-notification></detail-sampling-notification><br/><br/><b class="ibm-h3 ibm-textcolor-blue-40">Case IDs</b><table class="ibm-data-table" ng-if="vm.caseIdPRMs.length" cellspacing="0" cellpadding="0"><tr><td><b>Group IDs</b></td><td><b>URL</b></td></tr><tr ng-repeat="case in vm.caseIdPRMs"><td> <b>{{case.groupId}}</b></td><td><a href="{{case.url}}" target="_blank"> {{case.url}}</a></td></tr></table><br/><br/><b class="ibm-h3 ibm-textcolor-blue-40">Attachments</b><br/><br/><attachment-section title="Sampling" section="sampling"></attachment-section><br/><br/><div ng-if="[1,2].includes(vm.uiVersion)"><attachment-mysa-section title="MYSA" section="mysa"></attachment-mysa-section><br/><br/></div><div ng-if="vm.uiVersion &gt;= vm.OPP_VERSION_3"><attachment-section title="MYSA" section="mysa" incentive="Inactive"></attachment-section><br/><br/></div><detail-comment></detail-comment></div>');
$templateCache.put('detail-table-sampq.html','<!--author Ivan Toth--><div class="ibm-columns"><div class="ibm-cols-1-1"><span class="ibm-textcolor-red-50" ng-if="vm.sampReqMess" style="margin-left: 10px"> <br/><b>NOTE: &nbsp;</b><span>{{vm.sampReqMess}}</span></span></div><div class="ibm-cols-1-1"><!--div(ng-if="(((vm.incentiveStatus.samplingStatus === \'untested\') || (vm.incentiveStatus.samplingStatus === \'Manual override\') || (vm.incentiveStatus.samplingStatus === \'unassigned\') || (typeof(vm.incentiveStatus.samplingStatus) === \'undefined\') || (typeof(vm.incentiveStatus) === \'undefined\') || (vm.incentiveStatus.samplingStatus.search(\'In Progress\') > - 1)) && ((vm.env.user.access.bpsoAdmin === true) || (vm.env.user.access.nonBpsoAdmin === true)))")--><div><p></p><detail-sampling-activate-component incentive="vm.incentive"></detail-sampling-activate-component></div><div ng-if="((vm.incentiveStatus.samplingStatus.search(\'Pending BP Compliance Review\') &gt; - 1) || (vm.incentiveStatus.samplingStatus.search(\'In Progress\') &gt; - 1) || (vm.incentiveStatus.samplingStatus.search(\'Passed\') &gt; - 1)|| (vm.incentiveStatus.samplingStatus.search(\'Failed\') &gt; - 1))"><p></p><detail-table-compl-cl-sampling incentive="vm.incentive"></detail-table-compl-cl-sampling><p></p></div></div></div>');
$templateCache.put('sampling-dialog.html','<md-dialog ng-cloak="" aria-label="Sampling Dialog"><md-toolbar><div class="md-toolbar-tools"><h2>{{vm.action}} Sampling</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon aria-label="Close dialog" md-svg-src="/public/images/ic_close_white_24px.svg"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class="md-padding"><ng-form name="sampForm"><div ng-if="vm.action === \'Activate\'"><p>Please select a Reason and Incentive type for Activating the Sampling process and click&nbsp;<b>OK&nbsp;</b>to continue, or&nbsp;<b>Cancel&nbsp;</b>to quit.&nbsp;&nbsp;</p><span class="ibm-textcolor-blue-40">Activatation Reason&nbsp;&nbsp;</span><select class="userField" ng-model="vm.sampReason" ng-options="o as o for o in vm.reasons" ng-required="true" style="width:20em"></select><p ng-if="vm.sampReason === \'Other\'" style="margin-top: 16px;"><span class="ibm-textcolor-blue-40">Other Reason&nbsp;&nbsp;</span><input class="userField" ng-model="vm.sampReasonOther" ng-required="true" style="height: 20px; width: 500px" placeholder="Please enter the \'Other\' Reason"/></p><p></p><p></p><span class="ibm-textcolor-blue-40" ng-if="vm.uiVersion &gt;= vm.oppVersions.five">SSA Documentation Status&nbsp;&nbsp;<select class="userField" ng-model="vm.ssaDocumentationStatus" ng-options="o as o for o in vm.documentationStatusValues" ng-required="true" style="width:20em"></select><p></p><p></p></span><span class="ibm-textcolor-blue-40" ng-if="vm.uiVersion &gt;= vm.oppVersions.five">Engagement Documentation Status&nbsp;&nbsp;<select class="userField" ng-model="vm.engagementDocumentationStatus" ng-options="o as o for o in vm.documentationStatusValues" ng-required="true" style="width:20em"></select><p></p><p></p></span><span class="ibm-textcolor-blue-40">Activatation Incentive &nbsp;&nbsp;</span><span ng-repeat="in in vm.incentives"><input ng-checked="vm.incentive &amp;&amp; in === vm.incentive" ng-model="vm.incentiveType[in]" type="checkbox"/><b>{{vm.v4OrLater && in === \'Solution\' ? \'Engagement\' : in}} &nbsp;&nbsp;</b></span><p></p><p>Please enter some comments explaining the reason for sampling per incentive:</p><textarea class="userField" name="comments" ng-model="vm.incentiveComment" ng-required="true" style="resize: none" rows="5" cols="85" resize="false"></textarea><p></p></div><div ng-if="vm.action === \'Deactivate\'" style="width: 750px"><p>Please enter some comments explaining the reasons why you are Deactivating the \nSampling process and click&nbsp;<b>OK&nbsp;</b>to continue, or&nbsp;<b>Cancel&nbsp;</b>to quit.&nbsp;&nbsp;</p><textarea class="userField" name="comments" ng-model="vm.comment" ng-required="true" style="resize: none" rows="5" cols="85" resize="false"></textarea><p></p></div></ng-form><md-button class="md-raised md-primary" ng-click="vm.clickYes()" ng-disabled="!vm.$scope.sampForm.$valid &amp;&amp; vm.incentiveType">OK</md-button><md-button class="md-raised md-secondary" ng-click="vm.cancel()">Cancel</md-button><p></p></md-content></md-dialog-content></md-dialog>');
$templateCache.put('detail-search-submit.html','<div><div class="ibm-columns"><span class="ibm-h3 ibm-textcolor-blue-40">Please select the results to save from the {{vm.topic.searchDropDownNames[vm.searchSubmit.original.ds]}} search</span><h2 class="ibm-h2 red_text" ng-if="vm.results_array.length &gt; 50">NOTE: Selecting more results than you need will lower the performance of the application</h2><span flex="flex"></span><span layout="row" style="margin-top:10px"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.submitResults()">Save</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.cancelResults()">Remove</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-teal-50" ng-click="vm.processLaterResults()">Process Later</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-blue-50" ng-click="vm.toggleCriteria()"><md-icon class="white_icon" md-svg-src="/public/images/ic_bookmark_border_black_24px.svg"></md-icon><span>Searched Criteria</span></md-button></span><span ng-if="vm.searchCriteria"><span flex="50"><span ng-repeat="criteria in vm.searchSubmit.original.searchCriteria" layout="row"><b class="no-padding" flex="25">{{criteria.k}}:</b><span class="no-padding" flex="25">{{criteria.v}}</span></span></span></span></div><div class="ibm-columns search-form"><md-content class="dmt-white-background" layout="column"><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><b flex="11%">Export Excel</b><b flex="11%" ng-if="![\'MYSA_DUP\', \'SC_DUP\', \'CMR\', CMR_VALID_DATA].includes(vm.searchSubmit.original.ds)">Result</b><b flex="11%">Key word</b><b flex="11%">Timestamp</b><b flex="11%">User</b><b flex="11%">Country</b><b flex="11%" ng-if="vm.shouldDisplayIssuingCountry()">CMR Issuing countries</b><b flex="11%">Results found</b><b flex="11%">Results Prepared for Save</b></div><md-divider flex="flex"></md-divider></md-list-item><md-list-item class="md-2-line"><div class="md-list-item-text" layout="row" layout-align="start left"><span flex="11%" ng-click="vm.excelExport()"><md-icon md-svg-src="/public/images/ic_file_download_black_24px.svg" title="Generate Excel report of the whole search"></md-icon></span><span flex="11%" ng-if="![\'MYSA_DUP\', \'SC_DUP\', \'CMR\', CMR_VALID_DATA].includes(vm.searchSubmit.original.ds)">{{vm.searchSubmit.original.overallStatus}}</span><span flex="11%">{{vm.searchSubmit.original.searchCriteria[0].v}}</span><span flex="11%">{{vm.searchSubmit.original.timestamp | date:vm.settings.up.preferences.dateFormat : \'UTC\'}}</span><span flex="11%">{{vm.searchSubmit.original.user}}</span><span flex="11%"><span ng-repeat="line in vm.getCountryFieldValue() track by $index"><span>{{line}}</span></span></span><span flex="11%" ng-if="vm.shouldDisplayIssuingCountry()"><span ng-repeat="line in vm.getIssuingCountryValue() track by $index">   <span>{{line}}</span></span></span><span flex="11%">{{vm.tableData.length}}</span><span flex="11%">{{vm.searchSubmit.results.table.length}}</span></div></md-list-item><md-divider flex="flex" style="border-top-color:black"></md-divider></md-content><div ng-if="vm.searchSubmit.original.error !== undefined" style="padding: 10px"><span class="ibm-h4 ibm-textcolor-red-50">There was a problem with the connection to the resources ({{vm.topic.searchDropDownNames[vm.searchSubmit.original.ds]}}).  &nbsp;It may be a temporary problem so please try again, however, if the problem persists contact the DMT System Administrators. &nbsp;Hover for the error details -> &nbsp;</span><md-icon class="red_icon" md-svg-icon="/public/images/ic_pan_tool_black_24px.svg" title="{{vm.searchSubmit.original.error}}"></md-icon></div><ng-form name="dialogForms" ng-if="vm.searchSubmit.original.error == undefined"><div class="ibm-columns">     <h2 class="ibm-col-6-2 ibm-h2">All Search Results:</h2><input class="ibm-col-6-4" type="text" ng-model="vm.original_filter.searchTxt" ng-change="vm.applySearchTxtFilter(\'original\')" style="margin: 6px;"/></div><div class="ibm-columns"><div class="ibm-col-1-1 scrol-overflow"><md-content class="dmt-white-background scrol-width-small" layout="column"><md-divider flex="flex" style="border-top-color:black"></md-divider><md-list-item class="md-2-line"><div class="add-margin md-list-item-text" layout="row" layout-align="start left"><b class="three-right" flex="flex">Action</b><b class="three-right" flex="flex" ng-repeat="header in ::vm.rowOrder">{{::header.h}}</b><b class="three-right" flex="flex" ng-if="vm.showSecondary">Additional Info</b></div></md-list-item><md-divider flex="flex" style="border-top-color:black"></md-divider><md-list-item class="md-2-line"><div class="add-margin md-list-item-text" layout="row" layout-align="start left"><span class="three-right" flex="11%" layout="row"><span ng-if="vm.tableData.length &gt; vm.original_array.length"><md-icon class="blue_icon" md-svg-src="/public/images/ic_add_circle_outline_black_24px.svg" ng-click="vm.addFiltered(\'original\')" title="Add all filtered to To Be Saved Results"></md-icon></span><span ng-if="vm.tableData.length &gt; vm.original_array.length"><md-icon class="blue_icon" md-svg-src="/public/images/ic_remove_circle_outline_black_24px.svg" ng-click="vm.removeFiltered(\'original\')" title="Remove all filtered from To Be Saved Results"></md-icon></span></span><span class="three-right" flex="11%" layout="row" layout-wrap="layout-wrap" ng-repeat="row in ::vm.rowOrder"> <span class="three-right" flex="11%" layout="row" layout-wrap="layout-wrap" ng-repeat="filtName in ::vm.filterArray" ng-if="row.v===filtName"> <span flex="50" ng-if="vm.original_filter.filters[filtName].unique!=undefined"><md-select class="no-padding" aria-label="original{{::$index}}" multiple="multiple" ng-model="vm.original_filter.filters[filtName].picked" md-on-open="vm.openDrop(\'original\',$index, vm.original_filter.filters[filtName].unique.length)" md-on-close="vm.closeDrop(\'original\',$index)" ng-model-options="{trackBy: \'$value\'}"><md-option ng-value="::filt" ng-repeat="filt in vm.original_filter.filters[filtName].unique | orderBy:\'toString()\' | limitTo: vm.original_countDrop[$index] track by $index" ng-click="vm.changedValue(\'original\')">{{ ::filt }}</md-option></md-select></span><span flex="50" ng-if="vm.original_filter.filters[filtName].picked.length &gt; 0"><md-icon md-svg-src="/public/images/ic_close_black_24px.svg" ng-click="vm.clearFilter(filtName,\'original\')" title="Clear filter"></md-icon></span></span></span><span class="three-right" flex="11%" ng-if="vm.showSecondary"></span></div></md-list-item><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" md-virtual-repeat="line in vm.original_array" flex="" md-item-size="10" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unk &amp;&amp; {\'background-color\': \'orange\'}"><div class="add-margin md-list-item-text" layout="row" layout-align="start left"><span class="three-right" flex="11%"><md-icon class="green_icon" md-svg-src="/public/images/ic_add_circle_black_24px.svg" title="Move this line to Selected" ng-click="vm.addItem(line)"></md-icon></span><span class="three-right" flex="11%" ng-repeat="varN in vm.rowOrder"><span ng-if="!varN.t">{{line[varN.v]}}</span><span ng-if="varN.t.indexOf(\'d\')&gt;-1">{{line[varN.v] | date: vm.settings.up.preferences.dateFormat : \'UTC\'}}</span><span ng-if="varN.t==\'n\'">{{line[varN.v] | number: varN.n}}</span></span><span class="three-right" flex="11%" ng-if="vm.showSecondary"><span ng-if="!line.visible"><!--md-icon(md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg",ng-click="vm.toggleRow(line)",title="See more data")--><span class="ibm-textcolor-orange-50" ng-click="vm.toggleRow(line)">Click to View</span></span><span ng-if="line.visible"><!--md-icon(md-svg-src="/public/images/ic_expand_more_black_24px.svg",ng-click="vm.toggleRow(line)",title="See less data")--><span class="ibm-textcolor-orange-50" ng-click="vm.toggleRow(line)">Click to Hide</span></span><table class="ibm-data-table ibm-grid" ng-if="line.visible" style="margin-left: -300px; margin-top: 40px; position: absolute;z-index: 1; background: white;"><tr ng-repeat="sndLine in vm.dropRowOrder"><td ng-style="::vm.tableStyle"><b>{{sndLine.h}}</b></td><td ng-style="::vm.tableStyle"><span ng-if="!sndLine.t|| sndLine.t==\'collapse\'">{{line[sndLine.v]}}</span><span ng-if="sndLine.t.indexOf(\'d\')&gt;-1">{{line[sndLine.v] | date:vm.settings.up.preferences.dateFormat : \'UTC\'}}</span><span ng-if="sndLine.t==\'n\'">{{line[sndLine.v] | number: sndLine.n}}</span><span class="ibm-textcolor-orange-50" ng-if="sndLine.t.indexOf(\'title\')&gt;-1" title="{{line[sndLine.v]}}">Hover to View</span></td></tr></table></span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container></md-content></div><md-divider flex="flex" style="border-top-color:black"></md-divider></div><md-divider flex="flex" style="border-top-color:black"> </md-divider><div class="ibm-columns">     <h2 class="ibm-col-6-2 ibm-h2">To Be Saved Results:</h2><input class="ibm-col-6-4" type="text" ng-model="vm.results_filter.searchTxt" ng-change="vm.applySearchTxtFilter(\'results\')" style="margin: 6px;"/></div><div class="ibm-columns"> <div class="ibm-col-1-1 scrol-overflow"><md-content class="dmt-white-background scrol-width-small" layout="column"><md-divider flex="flex" style="border-top-color:black"></md-divider><md-list-item class="md-2-line"><div class="add-margin md-list-item-text" layout="row" layout-align="start left"><b class="three-right" flex="flex">Action</b><b class="three-right" flex="flex" ng-repeat="header in ::vm.rowOrder">{{::header.h}}</b><b class="three-right" flex="flex" ng-if="::vm.showSecondary">Additional Info</b></div></md-list-item><md-divider flex="flex" style="border-top-color:black"></md-divider><md-list-item class="md-2-line"><div class="add-margin md-list-item-text" layout="row" layout-align="start left"><span class="three-right" flex="11%" layout="row"><span ng-if="vm.searchSubmit.results.table.length &gt; 0"><md-icon class="blue_icon" md-svg-src="/public/images/ic_remove_circle_outline_black_24px.svg" ng-click="vm.removeFiltered(\'results\')" title="Remove all filtered from to be saved results"></md-icon></span></span><span class="three-right" flex="11%" layout="row" layout-wrap="layout-wrap" ng-repeat="row in ::vm.rowOrder"><span class="three-right" flex="11%" layout="row" layout-wrap="layout-wrap" ng-repeat="filtName in ::vm.filterArray" ng-if="row.v===filtName"><span flex="50" ng-if="vm.results_filter.filters[filtName].unique!=undefined"><md-select class="no-padding" aria-label="results{{::$index}}" multiple="multiple" ng-model="vm.results_filter.filters[filtName].picked" md-on-open="vm.openDrop(\'results\',$index, vm.results_filter.filters[filtName].unique.length)" md-on-close="vm.closeDrop(\'results\',$index)" ng-model-options="{trackBy: \'$value\'}"><md-option ng-value="::filt" ng-repeat="filt in vm.results_filter.filters[filtName].unique  | orderBy:\'toString()\' | limitTo: vm.results_countDrop[$index] track by $index" ng-click="vm.changedValue(\'results\')">{{ ::filt }}</md-option></md-select></span><span flex="50" ng-if="vm.results_filter.filters[filtName].picked.length &gt; 0"><md-icon md-svg-src="/public/images/ic_close_black_24px.svg" ng-click="vm.clearFilter(filtName,\'results\')" title="Clear filter"></md-icon></span></span></span><span class="three-right" flex="11%" ng-if="vm.showSecondary"></span></div></md-list-item><md-virtual-repeat-container style="height:400px"><md-list-item class="md-2-line" md-virtual-repeat="line in vm.results_array" flex="" md-item-size="10" ng-style="line.gov &amp;&amp; {\'background-color\': \'pink\'} || line.unk &amp;&amp; {\'background-color\': \'orange\'}"><div class="add-margin md-list-item-text" layout="row" layout-align="start left"><span class="three-right" flex="11%"><md-icon class="red_icon" md-svg-src="/public/images/ic_remove_circle_black_24px.svg" title="Remove this line from Selected" ng-click="vm.removeItem(line)"></md-icon></span><span class="three-right" flex="11%" ng-repeat="varN in vm.rowOrder"><span ng-if="!varN.t">{{line[varN.v]}}</span><span ng-if="varN.t==\'d\'">{{line[varN.v] | date: vm.settings.up.preferences.dateFormat : \'UTC\'}}</span><span ng-if="varN.t==\'n\'">{{line[varN.v] | number: varN.n}}</span></span><span class="three-right" flex="11%" ng-if="vm.showSecondary"><span ng-if="!line.visible"><!--md-icon(md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg",ng-click="vm.toggleRow(line)",title="See more data")--><span class="ibm-textcolor-orange-50" ng-click="vm.toggleRow(line)">Click to View</span></span><span ng-if="line.visible"><!--md-icon(md-svg-src="/public/images/ic_expand_more_black_24px.svg",ng-click="vm.toggleRow(line)",title="See less data")--><span class="ibm-textcolor-orange-50" ng-click="vm.toggleRow(line)">Click to Hide</span></span><table class="ibm-data-table ibm-grid" ng-if="line.visible" style="margin-left: -300px; margin-top: 40px; position: absolute;z-index: 1; background: white;"><tr ng-repeat="sndLine in vm.dropRowOrder"><td ng-style="::vm.tableStyle"><b>{{sndLine.h}}</b></td><td ng-style="::vm.tableStyle"><span ng-if="!sndLine.t|| sndLine.t==\'collapse\'">{{line[sndLine.v]}}</span><span ng-if="sndLine.t==\'d\'">{{line[sndLine.v] | date:vm.settings.up.preferences.dateFormat : \'UTC\'}}</span><span ng-if="sndLine.t==\'n\'">{{line[sndLine.v] | number: sndLine.n}}</span><span class="ibm-textcolor-orange-50" ng-if="sndLine.t.indexOf(\'title\')&gt;-1" title="{{line[sndLine.v]}}">Hover to View</span></td></tr></table></span></div><md-divider flex="flex"></md-divider></md-list-item></md-virtual-repeat-container></md-content></div><md-divider flex="flex" style="border-top-color:black"></md-divider></div></ng-form></div></div>');
$templateCache.put('detail-goe-valid.html','<style>.field{ padding-bottom: 10px;}</style><div class="ibm columns" style="margin: 0px; border: 1px solid lightgray; padding: 10px;"><div class="ibm-columns"><div class="ibm-col-6-2"><label class="ibm-textcolor-blue-50" style="float: right">Government Check Decision&nbsp;</label><lock-section comp="vm.comp" style="float: none">&nbsp;</lock-section><display-error section="vm.completeSection" style="float: none;margin-left: 5px">&nbsp;  HMM</display-error></div><div class="ibm-col-6-1 field"><span ng-if="!vm.topic.editableComponents.goe_valid.editMode"><span>{{vm.topic.topic.goe_valid.picked || \'To be Confirmed\'}}</span></span><span ng-if="vm.topic.editableComponents.goe_valid.editMode"><select style="width: 10em" ng-model="vm.topic.temp.goe_valid.picked" ng-options="o as o for o in vm.goeOptions" ng-value="vm.topic.setUSFed(\'goe_valid\')"></select></span></div><div class="ibm-col-6-2" ng-if="vm.topic.loaded.topic" style="float: right"><div style="border: 1px solid lightgray; height: 50px; float: right"><esc-button-section style="float:right; margin-top: 12px" vm="vm" lock="vm.lock"></esc-button-section></div></div></div><div class="ibm-columns" ng-if="[\'Yes\',\'State Owned\'].indexOf(vm.topic.temp.goe_valid.picked) &gt; -1 &amp;&amp; vm.topic.topic.country === \'US\'"><div class="ibm-col-6-2 right"><label class="ibm-textcolor-blue-50" style="float: none">Is this a US Federal Disbursement?&nbsp;</label></div><div class="ibm-col-6-1 field"><span ng-if="vm.topic.editableComponents.goe_valid.editMode"><input type="radio" ng-model="vm.topic.temp.goe_valid.usfederal" ng-value="true" ng-change="vm.topic.usFed.status = true"/>Yes<input type="radio" ng-model="vm.topic.temp.goe_valid.usfederal" ng-value="false" ng-change="vm.topic.usFed.status = false"/>No</span><span ng-if="!vm.topic.editableComponents.goe_valid.editMode">{{vm.topic.topic.goe_valid.usfederal ? \'Yes\' : \'No\'}}</span></div><div class="ibm-col-6-3" ng-if="vm.topic.temp.goe_valid.usfederal"><span class="ibm-textcolor-red-50">Since this is confirmed as a US Federal Disbursement, the content needs to be removed from DMT for legal reasons.  &nbsp;Please click the button below.</span><p></p><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-disabled="vm.topic.usFed.beingDeleted" ng-click="vm.topic.confirmUSFederal($event)"><md-icon class="white_icon" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Delete Disbursement from DMT</md-button><span ng-if="vm.topic.usFed.beingDeleted">&nbsp;<span class="ibm-textcolor-blue-30 ibm-h4">Deleting...please wait...</span><span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></span></div></div></div>');
$templateCache.put('detail-notifications.html','<md-dialog aria-label="Delete" flex="40"><md-toolbar class="bg-dev co-wh" layout="row" flex="none" layout-align="start center" layout-padding=""><div class="md-title pd-l-10">Notification Settings (Under Construction)</div><span flex=""></span><md-button class="md-icon-button" ng-click="vm.closeDialog()"><md-icon md-svg-icon="close" aria-label="Close dialog"></md-icon></md-button></md-toolbar><md-content class="pdlr-20 bg-wh fs-14 co-tt" style="min-height:280px" layout-padding="" flex="" layout-fill=""><div class="mg-t-10" layout="row" flex=""><md-icon class="mg-r-10" md-svg-src="/avatar/icons/done.svg" flex="10" ng-show="vm.notif===0" layout="column"></md-icon><div class="cu-pt" layout="column" flex="none" ng-click="vm.setNotif(0)"><div layout="row"><md-icon class="co-or" md-svg-src="/avatar/icons/visibility.svg"></md-icon><div class="md-title mg-l-10">Watching</div><div flex=""></div></div><div>You will be notified of any change in the board</div></div><div flex=""></div></div><div class="mg-t-10" layout="row" flex=""><md-icon class="mg-r-10" md-svg-src="/avatar/icons/done.svg" flex="10" ng-show="vm.notif===1" layout="column"></md-icon><div class="cu-pt" layout="column" flex="none" ng-click="vm.setNotif(1)"><div layout="row"><md-icon class="co-gr" md-svg-src="/avatar/icons/alarm.svg"></md-icon><div class="md-title mg-l-10">Tracking</div><div flex=""></div></div><div>You will be notified of any changes to those cards</div><div>you are involved as creator or owner</div></div><div flex=""></div></div><div class="mg-t-10" layout="row" flex=""><md-icon class="mg-r-10" md-svg-src="/avatar/icons/done.svg" flex="10" ng-show="vm.notif===2" layout="column"></md-icon><div class="cu-pt" layout="column" flex="none" ng-click="vm.setNotif(2)"><div layout="row"><md-icon class="co-rd" md-svg-src="/avatar/icons/muted.svg"></md-icon><div class="md-title mg-l-10">Muted</div><div flex=""></div></div><span>You will never be notified of any changes in this board</span></div><div flex=""></div></div><div class="mg-t-10" layout="row" flex=""><md-switch ng-model="vm.notif" aria-label="Switch" ng-change="vm.setBrowerNotif(vm.notif)">Desktop notifications are {{vm.notif===true ? \'On\' : \'Off\'}}</md-switch></div><div flex=""></div></md-content><md-dialog-actions layout="row" flex="none"><span flex=""></span><md-button class="md-raised" ng-click="vm.closeDialog()">Done</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('detail-table-valid-igcheck.html','<style>md-menu-content {\n  min-width: 250px;\n}\n</style><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span><span>&nbsp;{{vm.tableName}}</span><lock-section comp="vm.comp[0]"></lock-section></span></span><span ng-if="vm.comp[0]===\'dc\'"><display-error section="\'dcCheck\'" style="vertical-align: super; padding-left: 10px"></display-error><gov-check-section ng-if="vm.govCheck" comp="vm.comp[0]"></gov-check-section></span><div id="genInfo" ng-hide="!vm.visible" ng-if="vm.topic.topic.lock_indicator[vm.comp[0]].locked"><p></p><span class="ibm-textcolor-gray-30">Locked by</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp[0]].user}}</span><span class="ibm-textcolor-gray-30">&nbsp;on</span><span class="ibm-textcolor-blue-40">&nbsp;{{vm.topic.topic.lock_indicator[vm.comp[0]].date | date: $ctrl.settings.up.preferences.dateFormat : \'UTC\'}}</span></div><div id="genInfo" ng-hide="!vm.visible"><div class="ibm-col-4-2" id="genInfo" ng-if="vm.topic.topic.commonValidationGOEDecision"><p></p><p></p><div class="ibm-col-4-1" id="genInfo"><label>Overall Validation GOE Status:</label></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.getManualValidationGoeDecisionLabel()}}</label></div></div><div class="ibm-col-4-2" id="genInfo" ng-if="vm.topic.topic.commonValidationGOEDecision"><div class="ibm-col-4-1" id="genInfo"><label>Waterfall definition:</label></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.getValidationManualGoeReasonLabel()}}</label></div></div><div class="ibm-columns"><span><md-menu md-offset="0 45"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-disabled="vm.topic.editableComponents[vm.comp[0]].socket !== \'\'" ng-mouseenter="$mdMenu.open($event)" title="{{{true: \'Toggle Search Parameters\', false: \'Section Locked\' }[vm.topic.editableComponents[vm.comp[0]].socket===\'\']}}" aria-label="DC Search" style="margin-left: 3px; float: right"><md-icon ng-class="{white_icon : vm.topic.editableComponents[vm.comp[0]].socket === \'\', black_icon: !vm.topic.editableComponents[vm.comp[0]].socket !== \'\'}" md-svg-src="/public/images/ic_filter_list_black_24px.svg"></md-icon>&nbsp;{{vm.filterDisplay ? \'Hide\' : \'Show\' }} Search Parameters</md-button><md-menu-content ng-mouseleave="$mdMenu.close($event)"><md-menu-item><md-button ng-click="vm.toggleSearchInput(\'findGoe\')"><span>FindGOE</span></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.toggleSearchInput(\'findCmr\')"><span>FindCMR</span></md-button></md-menu-item></md-menu-content></md-menu></span><detail-table-ig-find-goe ng-show="vm.displayFindGoe" data="goe_valid"></detail-table-ig-find-goe><detail-table-ig-find-cmr ng-show="vm.displayFindCmr" data="cmr_valid"></detail-table-ig-find-cmr><div class="ibm-columns" ng-repeat="tab in vm.topic.topic[\'cmr_valid\'].results | filter: vm.dcFilter"><multi-dc-table item="tab" row="$index" comp="\'cmr_valid\'" filter="vm.dcFilter"></multi-dc-table></div><div class="ibm-columns" ng-repeat="tab in vm.topic.topic[\'goe_valid\'].results | filter: vm.dcFilter"><multi-dc-table item="tab" row="$index" comp="\'goe_valid\'" filter="vm.dcFilter"></multi-dc-table></div></div></div>');
$templateCache.put('detail-validation-days-rule-deprecated.html','<div class="ibm-columns"><div class="ibm-col-6-3" id="genInfo"><div class="ibm-h3">15 days rule:</div><div>At least 15 days between Submit Date for CVR Eligibility and Sales Order Date</div><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-bold">Submit Date for CVR ELigibility:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label>{{::vm.topic.topic.gpp[0].svisubmitdate | date:vm.settings.up.preferences.dateFormat}}</label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-bold">Sales Order Date:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-bold">Result:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label></label></div></div></div></div></div></div></div><div class="ibm-columns"><div class="ibm-col-6-3" id="genInfo"><div class="ibm-h3">30/60 days rule:</div><div>Submit Date for Payment is no more than 30 days before or 60 days after Sales Order Date</div><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-bold">Submit Date for Payment:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-bold">Sales Order Date:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-bold">Result:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label></label></div></div></div></div></div></div></div>');
$templateCache.put('detail-validation-decision.html','<div class="ibm-columns" id="auto-check"><div class="ibm-col-6-4" id="genInfo"><h2 class="ibm-h2">Validation Checklist</h2></div><div class="ibm-col-6-2 ibm-right"><div ng-if="vm.topic.loaded.topic"><esc-button-section vm="vm" ="" lock="false"></esc-button-section></div><div ng-if="!vm.topic.loaded.topic"><md-icon class="rotating" md-svg-src="/public/images/ic_autorenew_black_24px.svg"></md-icon></div></div></div><div class="ibm-columns" id="auto-check"><button class="ibm-btn-pri ibm-btn-blue-50" ng-click="vm.runAutoCheck()">Run AutoCheck</button><br/><table class="ibm-data-table ibm-grid ibm-altrows"><thead><tr><th>Question</th><th>Yes</th><th>No</th><th>Source</th><th>Timestamp</th></tr></thead><tbody><tr><td>Customer Name Match ?</td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="yes" name="1" ng-model="vm.tempData.custName.value"/></span></td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="no" name="1" ng-model="vm.tempData.custName.value"/></span></td><td ng-bind="vm.tempData.custName.source"></td><td ng-bind="vm.tempData.custName.timestamp"></td></tr><tr><td>Country Match ?</td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="yes" ng-model="vm.tempData.ctyMatch.value"/></span></td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="no" ng-model="vm.tempData.ctyMatch.value"/></span></td><td ng-bind="vm.tempData.ctyMatch.source"></td><td ng-bind="vm.tempData.ctyMatch.timestamp"></td></tr><tr><td>Payment Submit date before CVR Expiration date ?</td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="yes" name="1"/></span></td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="no" name="1"/></span></td><td>Testing</td><td>Testing</td></tr><tr><td>BP Active on Sales Order Date ?</td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="yes" name="1"/></span></td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="no" name="1"/></span></td><td>Testing</td><td>Testing</td></tr><tr><td>If BP is a reseller, was the sales order placed via preferred VAD?</td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="yes" name="1"/></span></td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="no" name="1"/></span></td><td>Testing</td><td>Testing</td></tr><tr><td>Does the sales order contain D part numbers from the same Brand Family listed in Opportunity?</td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="yes" name="1"/></span></td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="no" name="1"/></span></td><td>Testing</td><td>Testing</td></tr><tr><td> Is the sum of eligible D part numbers in the sales order more than the minimum revenue threshold amount?</td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="yes" name="1"/></span></td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="no" name="1"/></span></td><td>Testing</td><td>Testing</td></tr><tr><td> Is the ISU code assigned and is it non-government?</td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="yes" name="1"/></span></td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="no" name="1"/></span></td><td>Testing</td><td>Testing</td></tr><tr><td> Is VAP applied on SO together with Incentive Fee Type ID - Sell? (VAP + SELL only = ineligible!)</td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="yes" name="1"/></span></td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="no" name="1"/></span><td>Testing</td></td><td>Testing</td></tr><tr><td> Is this the first time the Brand family in Opportunity is going to be paid for this sales order?</td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="yes" name="1"/></span></td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="no" name="1"/></span></td><td>Testing</td><td>Testing</td></tr><tr><td> Is the sales order without credit?</td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="yes" name="1"/></span></td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="no" name="1"/></span></td><td>Testing</td><td>Testing</td></tr><tr><td> For CVR opportunity submitted by GSI** (Global System Integrators), does BP = Reseller of the sales order?</td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="yes" name="1"/></span></td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="no" name="1"/></span></td><td>Testing</td><td>Testing</td></tr><tr><td>Does it qualify for small\\VAP deal waiver?</td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="yes" name="1"/></span></td><td><span class="ibm-input-group ibm-radio-group"><input type="radio" value="no" name="1"/></span></td><td>Testing</td><td>Testing</td></tr></tbody></table></div>');
$templateCache.put('detail-validation-general.html','<div class="ibm-columns"><div class="ibm-col-6-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><span><h2 class="ibm-h2"> <span>General Information</span></h2></span></div><div class="ibm-col-6-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><span ng-if="vm.topic.topic.gpp_valid[0].opp"><u>Loaded on:</u><span>&nbsp;{{ vm.topic.topic.gpp_valid[0].timestamp | date:vm.settings.up.preferences.dateFormat}}</span></span></div><div class="ibm-col-6-2 ibm-padding-top-1 ibm-padding-bottom-1 ibm-right" id="genInfo" ng-if="!vm.topic.checksData.uiVersion || vm.topic.checksData.uiVersion &lt; vm.OPP_VERSION_3"><div ng-if="vm.topic.loaded.topic"><!--md-button(ng-click="vm.reload()" style="margin-left: 3px" ng-disabled="vm.topic.editableComponents.gpp_valid.socket || vm.topic.loaded.gpp_valid || (vm.topic.topic.sap && vm.topic.topic.sap.length > 0)" aria-label="Reload GPP" class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" title="{{{false: \'Click to refresh the current GPP within this tab with the latest live data - NOTE: All current GPP values will be overwritten, but the logs will remain\', true: \'It is not possible to Refresh the GPP data once the Validation Results have been created.\'}[vm.topic.topic.sap && vm.topic.topic.sap.length > 0]}}")--><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.reload()" ng-disabled="vm.topic.editableComponents.gpp_valid.socket || vm.topic.loaded.gpp_valid" title="{{{false: \'Click to refresh the current Opportunity within this tab with the latest live data - NOTE: All current Opportunity values will be overwritten, but the logs will remain\', true: \'It is not possible to Refresh the Opportunity data once the Validation Results have been created.\'}[vm.topic.topic.sap.length &gt; 0]}}" aria-label="Reload GPP" style="margin-left: 3px"><span ng-if="!vm.topic.loaded.gpp_valid"><md-icon class="white_icon" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon></span><span ng-if="vm.topic.loaded.gpp_valid"><md-icon class="rotating" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon></span>&nbsp;{{vm.topic.topic.gpp_valid[0].opp ? \'Refresh\' : \'Load Missing\'}} Opportunity Data</md-button><span><detail-table-log vm="vm"></detail-table-log><span>&nbsp;</span><esc-button-section ng-if="vm.topic.topic.gpp_valid[0].opp" vm="vm" lock="false"></esc-button-section></span></div><div ng-if="!vm.topic.loaded.topic"><md-icon class="rotating" md-svg-src="/public/images/ic_autorenew_black_24px.svg"></md-icon></div></div></div><div class="ibm-columns" ng-if="vm.topic.topic.gpp_valid[0].opp"><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Opportunity Number:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].opp != vm.topic.topic.gpp[0].opp"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].opp" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].opp"></span><md-icon ng-click="vm.updateField($event,\'opp\',\'Opportunity number\',\'s\')" title="update Opportunity" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].opp == vm.topic.topic.gpp[0].opp"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].opp"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.topic.topic.version &amp;&amp; vm.topic.topic.version &gt;= vm.OPP_VERSION_5"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><label>Opportunity Group ID:</label></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.opportunityGroupId"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.topic.topic.version &amp;&amp; vm.topic.topic.version &lt;= vm.OPP_VERSION_4"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Overall MySA Status:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].svioverallstat != vm.topic.topic.gpp[0].svioverallstat"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].svioverallstat" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].svioverallstat"></span><md-icon ng-click="vm.updateField($event,\'svioverallstat\',\'Overall MySA status\',\'s\')" title="update Overall MySA status" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].svioverallstat == vm.topic.topic.gpp[0].svioverallstat"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].svioverallstat"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>{{vm.getNewUIInfo.getSVISumbitDateName()}}</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].svisubmitdate != vm.topic.topic.gpp[0].svisubmitdate"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].svisubmitdate | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></span></div><div ng-if="vm.topic.topic.gpp_valid[0].svisubmitdate == vm.topic.topic.gpp[0].svisubmitdate"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].svisubmitdate | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Submit for payment date:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.salesAssistData &amp;&amp; vm.topic.salesAssistData.submitPaymentDate"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.salesAssistData.submitPaymentDate  | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></label></div><div ng-if="!(vm.topic.salesAssistData &amp;&amp; vm.topic.salesAssistData.submitPaymentDate) &amp;&amp; vm.topic.topic.gpp_valid[0].svisubmitdate != vm.topic.topic.gpp[0].svi_submit_for_payment_date"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.getNewUIInfo.submitPaymentDate()  | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></span></div><div ng-if="!(vm.topic.salesAssistData &amp;&amp; vm.topic.salesAssistData.submitPaymentDate) &amp;&amp; vm.topic.topic.gpp_valid[0].svisubmitdate == vm.topic.topic.gpp[0].svi_submit_for_payment_date"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.submitPaymentDate()  | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Expiration Date:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].sviexpdate != vm.topic.topic.gpp[0].sviexpdate"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].sviexpdate | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></span></div><div ng-if="vm.topic.topic.gpp_valid[0].sviexpdate == vm.topic.topic.gpp[0].sviexpdate"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].sviexpdate | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Decision Date:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].decisiondate != vm.topic.topic.gpp[0].decisiondate"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].decisiondate | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></span></div><div ng-if="vm.topic.topic.gpp_valid[0].decisiondate == vm.topic.topic.gpp[0].decisiondate"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].decisiondate | date:vm.settings.up.preferences.dateFormat : \'UTC\'"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Sales Stage:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].salesstage != vm.topic.topic.gpp[0].salesstage"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].salesstage"></span></div><div ng-if="vm.topic.topic.gpp_valid[0].salesstage == vm.topic.topic.gpp[0].salesstage"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].salesstage"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.getNewUIInfo.uiVersion === vm.OPP_VERSION_3 || vm.getNewUIInfo.uiVersion === vm.OPP_VERSION_4"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>MySA link:</label></div></div><div class="ibm-col-4-1" id="genInfo"><a class="ibm-textcolor-blue-50 ibm-bold" href="{{vm.getNewUIInfo.externalLinks(\'mysa-deal-registration\')}}">{{vm.getNewUIInfo.externalLinks("mysa-deal-registration")}}</a></div></div></div></div><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Overall Opportunity Revenue:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].overall_revenue != vm.topic.topic.gpp[0].overall_revenue"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="(vm.topic.topic.gpp_valid[0].overall_revenue | number: 0) + \' \' + (vm.topic.topic.gpp_valid[0].crncy)" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="(vm.topic.temp.gpp_valid[0].overall_revenue | number: 0) + \' \' + (vm.topic.temp.gpp_valid[0].crncy)"></span><md-icon ng-click="vm.updateField($event,\'overall_revenue\',\'Overall Revenue\',\'s\')" title="update Overall Revenue" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].overall_revenue == vm.topic.topic.gpp[0].overall_revenue"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="(vm.topic.topic.gpp_valid[0].overall_revenue | number: 0) + \' \' + (vm.topic.topic.gpp_valid[0].crncy)"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Opportunity Currency:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].crncy != vm.topic.topic.gpp[0].crncy"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].crncy" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].crncy"></span><md-icon ng-click="vm.updateField($event,\'crncy\',\'Opportunity Currency\',\'s\')" title="update Opportunity Currency" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].crncy == vm.topic.topic.gpp[0].crncy"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].crncy"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Description:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].svidesc != vm.topic.topic.gpp[0].svidesc"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].svidesc" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].svidesc"></span><md-icon ng-click="vm.updateField($event,\'svidesc\',\'Description for CVR\',\'s\')" title="update Description for CVR" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].svidesc == vm.topic.topic.gpp[0].svidesc"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].svidesc"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Comments:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].svicmnt != vm.topic.topic.gpp[0].svicmnt"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.getNewUIInfo.paymentComments()" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.getNewUIInfo.paymentComments()"></span><md-icon ng-click="vm.updateField($event,\'svicmnt\',\'Comments for CVR\',\'s\')" title="update Comments for CVR" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].svicmnt == vm.topic.topic.gpp[0].svicmnt"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.paymentComments()"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Is Restricted?:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].isrestr != vm.topic.topic.gpp[0].isrestr &amp;&amp; (!vm.getNewUIInfo.uiVersion || vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_3)"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].isrestr" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].isrestr"></span><md-icon ng-click="vm.updateField($event,\'isrestr\',\'Comments for Is restricted\',\'s\')" title="update Is restricted" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].isrestr == vm.topic.topic.gpp[0].isrestr &amp;&amp; vm.getNewUIInfo.uiVersion &amp;&amp; vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_3"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].isrestr"></label></div><div ng-if="vm.getNewUIInfo.uiVersion &amp;&amp; vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getRestricted()"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.topic.topic.version &gt;= vm.OPP_VERSION_5"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><label>Overall Opportunity Revenue:</label></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.getRevenueV5() | number : 0}}</label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.topic.topic.version &gt;= vm.OPP_VERSION_5"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><label>Opportunity Currency:</label></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold">{{vm.getOppCurrencyV5()}}</label></div></div></div></div></div><div class="ibm-columns" ng-if="!vm.topic.topic.newUI"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Opportunity number2:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].opp2 != vm.topic.topic.gpp[0].opp2"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].opp2" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].opp2"></span><md-icon ng-click="vm.updateField($event,\'opp2\',\'Opportunity number2\',\'s\')" title="update Opportunity2" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].opp2 == vm.topic.topic.gpp[0].opp2"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].opp2"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>CVR Owning Organization:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].bpname != vm.topic.topic.gpp[0].bpname"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bpname" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].bpname"></span><md-icon ng-click="vm.updateField($event,\'bpname\',\'CVR Owning Organization\',\'s\')" title="update CVR Owning Organization" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].bpname == vm.topic.topic.gpp[0].bpname"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bpname"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Opportunity Currency:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].oppcurrency != vm.topic.topic.gpp[0].oppcurrency"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].oppcurrency" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].oppcurrency"></span><md-icon ng-click="vm.updateField($event,\'oppcurrency\',\'Opportunity Currency\',\'s\')" title="update Opportunity Currency" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].oppcurrency == vm.topic.topic.gpp[0].oppcurrency"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].oppcurrency"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Country from organization:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].country != vm.topic.topic.gpp[0].cntrybpinc"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].country" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].country"></span><md-icon ng-click="vm.updateField($event,\'country\',\'Country from organization\',\'s\')" title="Country from organization" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].country == vm.topic.topic.gpp[0].country"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].country"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>ISU Code number:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].isucodenum != vm.topic.topic.gpp[0].isucodenum"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].isucodenum" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].isucodenum"></span><md-icon ng-click="vm.updateField($event,\'isucodenum\',\'ISU Code number\',\'s\')" title="update ISU Code number" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].isucodenum == vm.topic.topic.gpp[0].isucodenum"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].isucodenum"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>ISU Code Description:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].isucodedesc != vm.topic.topic.gpp[0].isucodedesc"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].isucodedesc" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].isucodedesc"></span><md-icon ng-click="vm.updateField($event,\'isucodedesc\',\'ISU Code Description\',\'s\')" title="update ISU Code Description" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].isucodedesc == vm.topic.topic.gpp[0].isucodedesc"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].isucodedesc"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Extension Request:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].exceptionreq != vm.topic.topic.gpp[0].exceptionreq"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].exceptionreq" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].exceptionreq"></span><md-icon ng-click="vm.updateField($event,\'exceptionreq\',\'Exception Request\',\'s\')" title="update Exception Request" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].exceptionreq == vm.topic.topic.gpp[0].exceptionreq"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].exceptionreq"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Site:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].site2 != vm.topic.topic.gpp[0].site2"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].site2" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].site2"></span><md-icon ng-click="vm.updateField($event,\'site2\',\'Site\',\'s\')" title="update Site" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].site2 == vm.topic.topic.gpp[0].site2"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].site2"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Work in GPP:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].workgpp != vm.topic.topic.gpp[0].workgpp"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].workgpp" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].workgpp"></span><md-icon ng-click="vm.updateField($event,\'workgpp\',\'Comments for Work in GPP\',\'s\')" title="update Work in GPP" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].workgpp == vm.topic.topic.gpp[0].workgpp"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].workgpp"></label></div></div></div></div></div><div class="ibm-columns" ng-if="vm.topic.topic.gpp_valid[0].opp"><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-col-6-4" id="genInfo"><h2 class="ibm-h2">Business Partner Information</h2></div><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Business Partner:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].bpname != vm.topic.topic.gpp[0].bpname"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bpname" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].bpname"></span><md-icon ng-click="vm.updateField($event,\'bpname\',\'Business Partner\',\'s\')" title="update Business Partner" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].bpname == vm.topic.topic.gpp[0].bpname"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bpname"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Business Partner CEID:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].cnum != vm.topic.topic.gpp[0].cnum"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].cnum" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].cnum"></span><md-icon ng-click="vm.updateField($event,\'cnum\',\'Customer number\',\'s\')" title="update Customer number" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].cnum == vm.topic.topic.gpp[0].cnum"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].cnum"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Business Partner Country:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="!vm.getNewUIInfo.uiVersion || vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_3"><div ng-if="vm.topic.topic.gpp_valid[0].bp_inc_country != vm.topic.topic.gpp[0].bp_inc_country"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bp_inc_country" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].bp_inc_country"></span><md-icon ng-click="vm.updateField($event,\'bp_inc_country\',\'Country for BP Incentives\',\'s\')" title="update Country for BP Incentives" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].bp_inc_country == vm.topic.topic.gpp[0].bp_inc_country"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bp_inc_country"></label></div></div><div ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.bpCountry()"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Business Partner Name:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.bpName()"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Business Partner E-mail:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.email"></label></div></div></div></div></div></div><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-col-6-4" id="genInfo"><h2 class="ibm-h2">Account Information</h2></div><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account Name:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].acctname != vm.topic.topic.gpp[0].acctname"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].acctname" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].acctname"></span><md-icon ng-click="vm.updateField($event,\'acctname\',\'Account\',\'s\')" title="update Account" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].acctname == vm.topic.topic.gpp[0].acctname"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].acctname"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account Alternate Language Name:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].altlaname != vm.topic.topic.gpp[0].altlaname"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].altlaname" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].altlaname"></span><md-icon ng-click="vm.updateField($event,\'altlaname\',\'Alt Language\',\'s\')" title="update Alt Language" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].altlaname == vm.topic.topic.gpp[0].altlaname"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].altlaname"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account Address:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].acctaddr != vm.topic.topic.gpp[0].acctaddr"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].acctaddr" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].acctaddr"></span><md-icon ng-click="vm.updateField($event,\'acctaddr\',\'Account Address\',\'s\')" title="update Account Address" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].acctaddr == vm.topic.topic.gpp[0].acctaddr"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].acctaddr"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account City:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].acctcity != vm.topic.topic.gpp[0].acctcity"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].acctcity" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].acctcity"></span><md-icon ng-click="vm.updateField($event,\'acctcity\',\'Account City\',\'s\')" title="update Account City" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].acctcity == vm.topic.topic.gpp[0].acctcity"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].acctcity"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account Postal Code:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].acctpostcode != vm.topic.topic.gpp[0].acctpostcode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].acctpostcode" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].acctpostcode"></span><md-icon ng-click="vm.updateField($event,\'acctpostcode\',\'Account Postal Code\',\'s\')" title="update Account Postal Code" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].acctpostcode == vm.topic.topic.gpp[0].acctpostcode"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].acctpostcode"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account Country:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="!vm.getNewUIInfo.uiVersion || vm.getNewUIInfo.uiVersion &lt; vm.OPP_VERSION_3"><div ng-if="vm.topic.topic.gpp_valid[0].acctctry != vm.topic.topic.gpp[0].acctctry"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].acctctry" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].acctctry"></span><md-icon ng-click="vm.updateField($event,\'acctctry\',\'Account Country\',\'s\')" title="update Account Country" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].acctctry == vm.topic.topic.gpp[0].acctctry"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].acctctry"></label></div></div><div ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.accountCountry()"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account State Province:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].accprovince != vm.topic.topic.gpp[0].accprovince"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].accprovince" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].accprovince"></span><md-icon ng-click="vm.updateField($event,\'accprovince\',\'Account State Province\',\'s\')" title="update Account State Province" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].accprovince == vm.topic.topic.gpp[0].accprovince"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].accprovince"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.isV4OrLess()"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Passport Advantage Site Number:</label></div><span ng-if="vm.paSiteVisibe"><md-icon ng-click="vm.changePaVisible()" title="Show Pa Site Nums" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon></span><span ng-if="!vm.paSiteVisibe"><md-icon ng-click="vm.changePaVisible()" title="Show Pa Site Nums" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon></span></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].dummyPaSite != vm.topic.topic.gpp[0].dummyPaSite"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].dummyPaSite" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].dummyPaSite"></span><md-icon ng-click="vm.updateField($event,\'dummyPaSite\',\'Passport Advantage Site Num\',\'s\')" title="update Passport Advantage Site Num" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].dummyPaSite == vm.topic.topic.gpp[0].dummyPaSite"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].dummyPaSite"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account CMR:</label></div></div><div class="ibm-col-4-1" id="genInfo"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getNewUIInfo.cmr"></label></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account DCID:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getDcId()"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns" ng-if="vm.getNewUIInfo.uiVersion &gt;= vm.OPP_VERSION_3"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account DBG:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.getDbg()"></label></div></div></div></div><pa-site-num-section ng-if="vm.paSiteVisibe" editable="vm.paSiteEditable" tab="validation"></pa-site-num-section></div><div ng-if="!vm.topic.topic.newUI"><div class="ibm-col-4-2 ibm-padding-top-1 ibm-padding-bottom-1" id="genInfo"><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Account for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].bp_inc_name != vm.topic.topic.gpp[0].bp_inc_name"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bp_inc_name" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].bp_inc_name"></span><md-icon ng-click="vm.updateField($event,\'bp_inc_name\',\'Account for BP Incentives\',\'s\')" title="update Account for BP Incentives" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].bp_inc_name == vm.topic.topic.gpp[0].bp_inc_name"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bp_inc_name"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>Address for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].bp_inc_addr != vm.topic.topic.gpp[0].bp_inc_addr"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bp_inc_addr" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].bp_inc_addr"></span><md-icon ng-click="vm.updateField($event,\'bp_inc_addr\',\'Address for BP Incentives\',\'s\')" title="update Address for BP Incentives" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].bp_inc_addr == vm.topic.topic.gpp[0].bp_inc_addr"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bp_inc_addr"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>City for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].bp_inc_city != vm.topic.topic.gpp[0].bp_inc_city"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bp_inc_city" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].bp_inc_city"></span><md-icon ng-click="vm.updateField($event,\'bp_inc_city\',\'City for BP Incentives\',\'s\')" title="update City for BP Incentives" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].bp_inc_city == vm.topic.topic.gpp[0].bp_inc_city"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bp_inc_city"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>IBM Acct Cust Num for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].bp_inc_cmr != vm.topic.topic.gpp[0].bp_inc_cmr"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bp_inc_cmr" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].bp_inc_cmr"></span><md-icon ng-click="vm.updateField($event,\'bp_inc_cmr\',\'IBM Acct Cust Num for BP Incentives\',\'s\')" title="update IBM Acct Cust Num for BP Incentives" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].bp_inc_cmr == vm.topic.topic.gpp[0].bp_inc_cmr"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bp_inc_cmr"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>State for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].bp_inc_state != vm.topic.topic.gpp[0].bp_inc_state"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bp_inc_state" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].bp_inc_state"></span><md-icon ng-click="vm.updateField($event,\'bp_inc_state\',\'State for BP Incentives\',\'s\')" title="update State for BP Incentives" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].bp_inc_state == vm.topic.topic.gpp[0].bp_inc_state"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bp_inc_state"></label></div></div></div></div><div class="ibm-padding-bottom-1" id="ibm-columns"><div class="ibm-col-4-2" id="genInfo"><div class="ibm-col-4-1" id="genInfo"><div><label>ZIP Code for BP Incentives:</label></div></div><div class="ibm-col-4-1" id="genInfo"><div ng-if="vm.topic.topic.gpp_valid[0].bp_inc_zip != vm.topic.topic.gpp[0].bp_inc_zip"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bp_inc_zip" ng-if="!vm.edit.editMode"></span><span ng-if="vm.edit.editMode"><span class="ibm-textcolor-red-50 ibm-bold" ng-bind="vm.topic.temp.gpp_valid[0].bp_inc_zip"></span><md-icon ng-click="vm.updateField($event,\'bp_inc_zip\',\'ZIP Code for BP Incentives\',\'s\')" title="update ZIP Code for BP Incentives" md-svg-src="/public/images/ic_mode_edit_black_24px.svg"></md-icon></span></div><div ng-if="vm.topic.topic.gpp_valid[0].bp_inc_zip == vm.topic.topic.gpp[0].bp_inc_zip"><label class="ibm-textcolor-blue-50 ibm-bold" ng-bind="vm.topic.topic.gpp_valid[0].bp_inc_zip"></label></div></div></div></div></div></div></div></div>');
$templateCache.put('detail-validation-gpp-ac.html','<div class="ibm-columns" id="auto-check"><div class="ibm-col-6-4" id="genInfo"><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_info_outline_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span>&nbsp;Opportunity auto-check</span></span></div><table class="ibm-data-table ibm-grid ibm-altrows" ng-hide="!vm.visible"><thead><tr><th>Updates</th><th>Date/ Time</th><th>Source</th><th>Comment</th></tr></thead><tbody><tr ng-repeat="line in vm.topic.topic.gpp_history"><td>{{::line.updates}}</td><td>{{::line.time | date:\'MM/dd/yyyy\'}}</td><td>{{::line.source}}</td><td>{{::line.comment}}</td></tr></tbody></table></div>');
$templateCache.put('detail-validation-gppcheck.html','<div style="float:left" id="auto-check"><div class="ibm-col-5-5"><h2 class="ibm-h2">Opportunity auto-check</h2><table class="ibm-data-table" id="expandResultsTable" style="margin-top: 30px; margin-bottom:30px;"><thead class="ibm-bgcolor-blue-10"><th>Updates</th><th>Date/ Time</th><th>Source</th><th>Comment</th></thead><tbody><tr><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td></tr></tbody></table></div></div>');
$templateCache.put('detail-validation-list-deprecated.html','<ul><li>item1<div id="example1"><h2 class="ibm-h2">title</h2><h3 class="ibm-h3">subtitle</h3><label for="validationTemplate">Submit Date for CVR Eligibility:<label type="Date" id=""></label></label><label>Sales Order Date:<label type="Date" id=""></label></label><label>Result:<label type="text" id=""></label></label></div></li></ul>');
$templateCache.put('detail-validation-ods.html','<style>.valErr {\n    margin-bottom: -15px\n}</style><div class="ibm-col-2-2" style="float: left;"><div class="ibm columns" style="margin: 0px; padding: 10px;"><div class="ibm-columns"><div class="ibm-col-6-1"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.filterToggle()" ng-disabled="vm.topic.editableComponents.sap.socket" title="Click to open ODS Search form" style="margin: 30px 0px"><md-icon class="white_icon" md-menu-align-target="md-menu-align-target" md-svg-icon="search"></md-icon><span style="padding: 5px;">ODS Search </span></md-button></div><div class="ibm-col-6-1 field" style="margin-top: 35px;"><span><md-radio-group ng-disabled="vm.topic.topic.sap.length &gt; 0" ng-model="vm.isChargeAgreement" layout="row"><md-radio-button class="md-checked" data-ng-value="false">Sales Order</md-radio-button><md-radio-button data-ng-value="true">Charge Agreement</md-radio-button></md-radio-group></span></div></div></div><div ng-if="vm.isFilterToggled" flex="100"><form name="vm.odsForm"> <div ng-message="min" style="padding: 22px;"><span>Please fill out the search criteria bearing in mind if searching by </span><b>Sales Order Number </b>do not fill out the <b>Customer Name </b>or <b>Invoice number</b>. These 3 options are mutually exclusive. <b>Sales Order Start </b>and <b>End Dates </b>must also be within 90 days range; the other fields are optional.</div><md-input-container style="margin: 20px;"><label>Sales Order Number</label><input name="son" ng-click="vm.select($event)" ng-if="vm.filterToggles.isODSfilter" ng-maxlength="10" ng-minlength="8" ng-model="vm.soNumber" ng-pattern="/^[0-9]*$/"/></md-input-container><md-input-container style="margin: 20px;"><label>Customer Name</label><input name="cname" ng-click="vm.select($event)" ng-if="vm.filterToggles.isODSfilter" ng-minlength="3" ng-model="vm.custName"/></md-input-container><md-input-container style="margin: 20px;"><label>Customer Number</label><input name="cnum" ng-if="vm.filterToggles.isODSfilter" ng-maxlength="10" ng-model="vm.custNumber" ng-pattern="/^[0-9]*$/"/></md-input-container><md-input-container style="margin: 20px;"><label>Invoice number</label><input name="invoiceNumber" ng-click="vm.select($event)" ng-if="vm.filterToggles.isODSfilter" ng-maxlength="10" ng-minlength="8" ng-model="vm.invoiceNumber" ng-pattern="/^[0-9]*$/"/></md-input-container><md-input-container style="margin: 20px; width: 100px;"><label>Country</label><input name="cty" ng-maxlength="2" ng-model="vm.ctyCode" ng-pattern="/^[a-zA-Z]*$/"/></md-input-container><p></p><md-input-container style="margin: 20px;"><label>Start Date</label><md-datepicker ng-change="vm.checkValidity()" ng-model="vm.startDate" required="required"></md-datepicker></md-input-container><md-input-container style="margin: 20px;"><label>End Date </label><md-datepicker ng-change="vm.checkValidity()" ng-model="vm.endDate" required="required"></md-datepicker></md-input-container><md-input-container><md-button class="dmt-team-btn dmt-team-btn md-primary md-raised" ng-click="vm.applyFilter()" ng-disabled="!vm.datesValid || (vm.odsForm.cname.$viewValue.length === 0 &amp;&amp; vm.odsForm.son.$viewValue.length === 0 &amp;&amp; vm.odsForm.cnum.$viewValue.length === 0 &amp;&amp; vm.odsForm.invoiceNumber.$viewValue.length === 0) || (vm.odsForm.cname.$viewValue.length &gt; 0 &amp;&amp; vm.odsForm.son.$viewValue.length &gt; 0) || (vm.odsForm.son.$viewValue.length === 0 &amp;&amp; vm.odsForm.cname.$viewValue.length &gt; 0 &amp;&amp; vm.odsForm.cname.$invalid) || (vm.odsForm.cname.$viewValue.length === 0 &amp;&amp; vm.odsForm.son.$viewValue.length &gt; 0 &amp;&amp; vm.odsForm.son.$invalid) || (vm.odsForm.cname.$viewValue.length &gt; 0 &amp;&amp; vm.odsForm.invoiceNumber.$viewValue.length &gt; 0) || (vm.odsForm.invoiceNumber.$viewValue.length &gt; 0 &amp;&amp; vm.odsForm.son.$viewValue.length &gt; 0) || (vm.odsForm.invoiceNumber.$viewValue.length &gt; 0 &amp;&amp; vm.odsForm.cnum.$viewValue.length &gt; 0) || vm.odsForm.$invalid || vm.showProgress" style="margin-bottom: 20px;">Search</md-button></md-input-container><p class="ibm-textcolor-red-50 valErr" ng-if="vm.odsForm.son.$viewValue.length &gt; 0 &amp;&amp; vm.odsForm.son.$invalid">* Sales Order Number must be either 8 numbers or 10 with leading 00s, ie: 60123456 or 0060123456</p><p class="ibm-textcolor-red-50 valErr" ng-if="vm.odsForm.cname.$viewValue.length &gt; 0 &amp;&amp; vm.odsForm.cname.$invalid">* Customer Name must be at least 3 characters</p><p class="ibm-textcolor-red-50 valErr" ng-if="vm.odsForm.cnum.$viewValue.length &gt; 0 &amp;&amp; vm.odsForm.cnum.$invalid">* Customer Number must be no more than 10 numbers, ie: 0001234567</p><p class="ibm-textcolor-red-50 valErr" ng-if="(vm.odsForm.invoiceNumber.$viewValue.length &gt; 0 &amp;&amp; vm.odsForm.invoiceNumber.$invalid) || vm.odsForm.invoiceNumber.$viewValue.length === 9">* Invoice Number must be either 8 or 10 digits.</p><p class="ibm-textcolor-red-50 valErr" ng-if="vm.odsForm.cty.$viewValue.length &gt; 0 &amp;&amp; vm.odsForm.cty.$invalid">* Country must be 2 letters, ie: GB, DE, SK</p><p class="ibm-textcolor-red-50 valErr" ng-if="vm.odsForm.son.$viewValue.length &gt; 0 &amp;&amp; (vm.odsForm.cname.$viewValue.length &gt; 0 || vm.odsForm.cnum.$viewValue.length &gt; 0)">* You may only search by either Sales Order Number or by Customer Name/Number; please remove one or the other</p><p class="ibm-textcolor-red-50 valErr" ng-if="vm.odsForm.son.$viewValue.length &gt; 0 &amp;&amp; vm.odsForm.invoiceNumber.$viewValue.length &gt; 0">* You may only search by either Sales Order Number or by Invoice number; please remove one or the other</p><p class="ibm-textcolor-red-50 valErr" ng-if="(vm.odsForm.cname.$viewValue.length &gt; 0 || vm.odsForm.cnum.$viewValue.length &gt; 0) &amp;&amp; vm.odsForm.invoiceNumber.$viewValue.length &gt; 0">* You may only search by Customer Name/Number or by Invoice number; please remove one or the other</p><p class="ibm-textcolor-red-50 valErr" ng-bind-html="vm.dateError" ng-if="!vm.datesValid"></p><p ng-if="vm.topic.topic.sap.length &gt; 0"></p><span class="ibm-textcolor-red-50" ng-if="vm.topic.topic.sap.length &gt; 0 &amp;&amp; !(vm.validationSuccess)"><div></div><b>NOTE:&nbsp;</b>This Disbursement already has a Sales Order loaded and Validated. &nbsp;Should you search again and select another Sales Order for Validation, a new Dispute for this opportunity will be created and the results inserted there.<p></p></span><div ng-if="vm.showProgress"><h2 class="ibm-textcolor-blue-50 ibm-h3">Searching ODS. &nbsp;Please wait...</h2><p></p><md-progress-linear md-mode="indeterminate"></md-progress-linear></div><div ng-if="vm.processingODS"><h2 class="ibm-textcolor-blue-50 ibm-h3">Sales Order <b>{{vm.selectedSO}} </b>has been sent for Auto-Validation. &nbsp;Please wait...<span class="ibm-spinner" style="margin: 5px 10px 0px 2px"></span></h2></div></form></div></div>');
$templateCache.put('detail-validation-results.html','<div style="float:left" id="expandResults"><div class="ibm-col-5-5"><a class="ibm-information-link" title="Information link" href="">Expand Results</a><table class="ibm-data-table" id="expandResultsTable" style="margin-top: 30px; margin-bottom:30px;"><thead class="ibm-bgcolor-blue-10"><th>Bill Date</th><th>type</th><th>Brand family</th><th>Brand</th><th>CVR Participation</th><th>Brand Certification Achieved</th><th>Win Probability</th><th>Quantity</th><th>Price</th><th>Revenue Opportunity Currency</th></thead><tbody><tr><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td><td>Testing</td></tr></tbody></table></div></div>');
$templateCache.put('detail-validation-sales-orders-eval.html','<style>.final {\n    padding: 6px;\n    color: white;\n    border-radius: 10px;\n    background-color: darkgreen;\n}\n.pn-mark {\n    margin: 0px 20px 0px 5px;\n}</style><div class="ibm-columns"><div class="ibm-col-6-6"><div ng-if="vm.topic.topic.sap !== undefined &amp;&amp; vm.topic.topic.sap.length &gt; 0"><div style="margin: 20px 0px"><span class="final" ng-if="vm.topic.topic.calculation.complete"><b class="ibm-h4">Validation Final</b></span><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.reEvaluate($event)" ng-disabled="vm.isButtonDisabled(\'triggerCalculations\')" ng-if="!vm.topic.topic.calculation.complete" title="{{{true: \'Please complete all sections as well as resolve all Disbursement Errors before attempting Calculations\', false: \'Click to trigger the Auto-Calculation process\'}[(vm.topic.topic.errors.unresolved &gt; 0 || !vm.topic.topic.complete.statusComplete[\'4\']) &amp;&amp; !vm.topic.editableComponents.sap.socket]}}"><md-icon class="white_icon" md-svg-icon="/public/images/calculator.svg"></md-icon>&nbsp;Trigger Calculations</md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.unlockComments($event)" ng-disabled="vm.isUpdating" ng-if="vm.env.user.access.systemAdmin &amp;&amp; vm.topic.topic.status.status_no === 4  &amp;&amp; !vm.topic.topic.calculation &amp;&amp; !vm.topic.topic.calculation.bp " title="Reset all Failed Rules so they can be editted again"><md-icon class="white_icon" md-menu-align-target="md-menu-align-target" md-svg-icon="reevaluate"></md-icon>&nbsp;Admin Override</md-button><span ng-if="vm.isUpdating"><p></p><h2 class="ibm-textcolor-blue-50 ibm-h3">Processing. &nbsp;Please wait ...</h2><md-progress-linear md-mode="indeterminate"></md-progress-linear></span></div><table class="ibm-data-table" cellspacing="0" cellpadding="0" border="0" style="text-align: center"><thead><tr><td></td><td>ISU code</td><td>Customer Designation</td><td>LOB</td><td>Opportunity Currency</td><td>Sales Order Currency</td><td>Invoice Number</td><td ng-if="vm.topic.topic.version &gt;= vm.OPP_VERSION_4">Reseller BP</td></tr></thead><tbody><tr><td class="ibm-textcolor-blue-50 ibm-bold ibm-h4">{{vm.orderData.soNumber}}</td><td>{{vm.orderData.isu}}</td><td>{{vm.getCustomerDesignation(vm.orderData.firstItem)}}</td><td>{{vm.orderData.LOB}}</td><td>{{vm.topic.topic.gpp_valid[0].crncy}}</td><td>{{vm.orderData.curCode}}</td><td> <p ng-if="vm.topic.topic.invoice_numbers &amp;&amp; vm.topic.topic.invoice_numbers.length !== 0" ng-repeat="invoiceNo in vm.topic.topic.invoice_numbers">{{invoiceNo}}</p><p ng-if="!vm.topic.topic.invoice_numbers || vm.topic.topic.invoice_numbers.length === 0" ng-repeat="invoiceNo in vm.orderData.invoiceNo">{{invoiceNo}}</p></td><td ng-if="vm.topic.topic.version &gt;= vm.OPP_VERSION_4">{{vm.orderData.resellerBp}}</td></tr></tbody></table><div style="display: flex; line-height: 50px;"><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-teal-50" ng-class="!vm.checkOrderRuleFailed() ? \'ibm-btn-teal-50\' : \'ibm-btn-orange-50\'" ng-click="vm.failSO($event)" ng-disabled="vm.isButtonDisabled(\'soAutoFail\')" ng-style="{top: spanTop + \'px\'}" style="padding:6px; font-size:x-small"><md-icon class="white_icon" md-menu-align-target="md-menu-align-target" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Auto-Fail</md-button><span ng-if="vm.orderData.pns[0].comments.soAutofail">Auto-Failed. Reason: {{vm.orderData.pns[0].comments.soAutofail.text}}</span></div><div><span class="ibm-h4 ibm-bold ibm-textcolor-blue-50"> <table class="ibm-data-table" cellspacing="0" cellpadding="0" border="0"><thead><tr class="ibm-textcolor-gray-40"><td>#</td><td>Validation Rule Description</td><td colspan="2" align="center">Results</td><td>Status</td><td colspan="3">Comments & Final Status</td></tr></thead><tbody><tr ng-repeat="rule in vm.orderRules"><td style="width: 5px"> <span class="ibm-textcolor-gray-40">{{rule.n}}.</span></td><td><h3 class="ibm-bold ibm-textcolor-blue-50">{{rule.title}}</h3></td><td colspan="2" align="center"><span><h4 class="ibm-light">{{rule.value}}</h4></span></td><td><!-- IF RULE PASSES--><md-icon class="green_icon" ng-if="vm.orderData.result[rule.model] === true" md-svg-src="/public/images/checkbox-marked-circle.svg" align="center"></md-icon><!-- IF THE RULE FAILED...--><span ng-if="vm.orderData.result[rule.model] === false || vm.orderData.result[rule.model].result === false || vm.orderData.result[rule.model].infoOnly || (vm.orderData.result[rule.model] &amp;&amp; vm.orderData.comments[rule.model].passFlag)" align="center"><!-- SHOW ORANGE ICON IF FAILED FOR INFO ONLY....RED IF AN ERROR THAT NEEDS DEALING WITH--><md-icon ng-class="{\'orange_icon\': rule.infoOnly || vm.orderData.result[rule.model].infoOnly, \'pink_icon\': vm.orderData.comments[rule.model].passFlag,\'red_icon\': !vm.orderData.comments[rule.model].passFlag}" md-svg-src="/public/images/ic_error_black_24px.svg"></md-icon></span></td><!-- SHOW INPUT BOX IF RULE FAILED, BUT NOT FAILED FOR INFO ONLY...AND NO COMMENTS ALREADY ADDED--><td ng-if="!rule.infoOnly &amp;&amp; !vm.orderData.result[rule.model].infoOnly &amp;&amp; (vm.orderData.result[rule.model] === false || vm.orderData.result[rule.model].result === false) &amp;&amp; !vm.orderData.comments[rule.model].isFinal &amp;&amp; !vm.topic.editableComponents.sap.socket"><input ng-model="vm.orderData.comments[rule.model].text"/></td><!-- SHOW DECISION BUTTON IF RULE FAILED, BUT NOT FAILED FOR INFO ONLY...AND NO COMMENTS ALREADY ADDED--><td ng-if="((!rule.infoOnly &amp;&amp; !vm.orderData.result[rule.model].infoOnly) &amp;&amp; (vm.orderData.result[rule.model] === false || vm.orderData.result[rule.model] === false) &amp;&amp; vm.orderData.comments[rule.model].isFinal) || vm.topic.editableComponents.sap.socket">{{vm.orderData.comments[rule.model].text}}</td><td ng-if="(!rule.infoOnly &amp;&amp; !vm.orderData.result[rule.model].infoOnly) &amp;&amp; (vm.orderData.result[rule.model] === false || vm.orderData.result[rule.model].result === false) &amp;&amp; !vm.orderData.comments[rule.model].isFinal"><md-button class="md-raised md-primary" ng-click="vm.save(0, rule.model)" ng-disabled="vm.isButtonDisabled(\'soDecision\', rule.model)" ng-if="!vm.orderData.result[rule.model].infoOnly &amp;&amp; !vm.topic.editableComponents.sap.socket" style="height: 40px"><span>Decision</span></md-button></td><!-- SHOW FINAL STATUS GREEN IF FAILED BUT DECISION IS PASSED--><td ng-if="(!rule.infoOnly &amp;&amp; !vm.orderData.result[rule.model].infoOnly) &amp;&amp; vm.orderData.comments[rule.model].isFinal &amp;&amp; vm.orderData.comments[rule.model].passFlag " align="center"><md-icon class="green_icon" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon></td><!-- SHOW FINAL STATUS RED IF FAILED AND DECISION IS FAILED--><td ng-if="(!rule.infoOnly &amp;&amp; !vm.orderData.result[rule.model].infoOnly) &amp;&amp; vm.orderData.comments[rule.model].isFinal &amp;&amp; !vm.orderData.comments[rule.model].passFlag " align="center"><md-icon class="red_icon" md-svg-src="/public/images/ic_error_black_24px.svg"></md-icon></td><td></td><td></td></tr></tbody></table></span></div><div><b class="ibm-h3 ibm-textcolor-blue-40" style="line-height: 60px;">Part Number Breakdown</b><div ng-init="pnIndex = $index" ng-repeat="pn in vm.topic.topic.sap"><div style="display: flex; line-height: 47px"><h4 class="ibm-textcolor-blue-50 ibm-bold" style="font-size: 1.2rem; line-height: 47px">{{vm.topic.topic.sap[pnIndex].data.itemList[0].pn}}</h4><!-- Case, when at least 1 order rule failed--><div ng-if="vm.checkOrderRuleFailed()"><md-icon class="pn-mark red_icon" md-svg-src="/public/images/ic_error_black_24px.svg"></md-icon></div><!-- Case [RED], when at least 1 pn rule failed--><div ng-if="vm.checkIfPnFails(pnIndex) &amp;&amp; !vm.checkOrderRuleFailed() &amp;&amp; !vm.isFinalCommentTrue(pn.comments[\'pnOverall\']) &amp;&amp; !vm.isFinalCommentTrue(pn.comments[\'pnAutofail\'])"><md-icon class="pn-mark red_icon" md-svg-src="/public/images/ic_error_black_24px.svg"></md-icon><input ng-if="vm.isPnFailedAndEditable(pnIndex)" ng-model="vm.pnsComments[$index]" style="margin: 10px 0px"/><md-button class="md-raised md-primary" ng-if="vm.isPnFailedAndEditable(pnIndex)" ng-click="vm.savePn($index, pn, vm.pnsComments[$index])" ng-disabled="vm.isButtonDisabled(\'pnDecision\', $index)" style="height: 40px"><span>Decision</span></md-button><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-orange-50" ng-if="!vm.hasMappedSolutionCheck(pnIndex) &amp;&amp; vm.checkIfPnFails(pnIndex)" ng-click="vm.failPart($event, $index, pn)" ng-disabled="isButtonDisabled(\'pnAutoFail\', $index)" style="padding:6px; font-size:x-small"><md-icon class="white_icon" md-menu-align-target="md-menu-align-target" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Auto-Fail</md-button></div><!-- Case [GREEN], when all rule passed--><div ng-if="!vm.checkIfPnFails(pnIndex) &amp;&amp; !vm.checkOrderRuleFailed() &amp;&amp; !pn.comments[\'pnOverall\'] &amp;&amp; !pn.comments[\'pnAutofail\']"><md-icon class="pn-mark green_icon" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-teal-50" ng-click="vm.failPart($event, $index, pn)" ng-disabled="isButtonDisabled(\'pnAutoFail\')" style="padding:6px; font-size:x-small"><md-icon class="white_icon" md-menu-align-target="md-menu-align-target" md-svg-icon="/public/images/close-circle.svg"></md-icon>&nbsp;Auto-Fail</md-button></div><!-- Case [GREEN/RED], when user make pn failed using decision --><div ng-if="pn.comments[\'pnOverall\'] &amp;&amp; !vm.checkOrderRuleFailed()"><md-icon class="pn-mark red_icon" ng-if="!pn.comments[\'pnOverall\'].passFlag" md-svg-src="/public/images/ic_error_black_24px.svg"></md-icon><md-icon class="pn-mark green_icon" ng-if="pn.comments[\'pnOverall\'].passFlag" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon><span ng-if="pn.comments[\'pnOverall\']">User Decision. Reason: {{pn.comments[\'pnOverall\'].text}}</span></div><!-- Case [RED], when pn was autofailed--><div ng-if="pn.comments[\'pnAutofail\'] &amp;&amp; !vm.checkOrderRuleFailed()"><md-icon class="pn-mark red_icon" md-svg-src="/public/images/ic_error_black_24px.svg"></md-icon><!-- Taking the comment from the fisrt pn rule--><span>Auto-Failed. Reason: {{pn.comments.pnAutofail.text}}</span></div><!-- Case, when PN is failed --- no valid incentive rule--><div ng-if="vm.hasMappedSolutionCheck(pnIndex) &amp;&amp; pn.comments[\'pnIncentiveStatus\'] &amp;&amp; pn.comments[\'pnIncentiveStatus\'].text &amp;&amp; !pn.comments[\'pnIncentiveStatus\'].passFlag"><span>Auto-Failed. Reason: {{pn.comments.pnIncentiveStatus.text}}</span></div></div><span ng-if="vm.isUpdating"><p></p><h2 class="ibm-textcolor-blue-50 ibm-h3">Processing. &nbsp;Please wait ...</h2><md-progress-linear md-mode="indeterminate"></md-progress-linear></span><table class="scrol-overflow ibm-data-table" cellspacing="0" cellpadding="0" border="0" style="text-align: center;"><thead><tr><td>DRPG code</td><td>DRPG description</td><td>Eff Date</td><td>End Date</td><td>License Type</td><td ng-repeat="rule in vm.pnsRules[pnIndex]">{{rule.title}}</td></tr></thead><tbody><tr><td>{{pn.data.brandFamilyCode}}</td><td>{{pn.data.brandFamilyName}}</td><td>{{(pn.data.brandFamilyEffDate * 1000) | date: \'yyyy-MM-dd\'}}</td><td>{{(pn.data.brandFamilyEndDate * 1000) | date: \'yyyy-MM-dd\'}}</td><td>{{vm.getLicenseTypeName(pn.data.mdlTypeCode)}}</td><td ng-init="pnRuleIndex = $index" ng-repeat="rule in vm.pnsRules[pnIndex]"><md-icon class="green_icon" ng-if="rule.iconColor === \'green\'" md-svg-src="/public/images/checkbox-marked-circle.svg" align="center"></md-icon><md-icon ng-if="rule.iconColor === \'orange\' || rule.iconColor === \'pink\' || rule.iconColor === \'red\'" ng-class="{\'orange_icon\': rule.iconColor === \'orange\',\'pink_icon\': rule.iconColor === \'pink\',\'red_icon\': rule.iconColor === \'red\'}" md-svg-src="/public/images/ic_error_black_24px.svg"></md-icon><!--TODO - it can be better - just 1 \'div\' of \'option\' with parameterized model--><div ng-if="rule.model === \'solutionId\' &amp;&amp; vm.isManualMode(rule.model, pn, pnIndex, pnRuleIndex)"><md-select class="ibm_select" ng-model="vm.pnsEngagementComments[pn.data.itemList[0].pn]"><md-option ng-repeat="value in vm.APPROVED_ARR" ng-value="value">{{value}}</md-option></md-select></div><div ng-if="rule.model === \'growthCheck\' &amp;&amp; vm.isManualMode(rule.model, pn, pnIndex, pnRuleIndex)"><md-select class="ibm_select" ng-model="vm.pnsGrowthComments[pn.data.itemList[0].pn]"><md-option ng-repeat="value in vm.APPROVED_ARR" ng-value="value">{{value}}</md-option></md-select></div><div ng-if="rule.model === \'focusCheck\' &amp;&amp; vm.isManualMode(rule.model, pn, pnIndex, pnRuleIndex)"><md-select class="ibm_select" ng-model="vm.pnsFocusComments[pn.data.itemList[0].pn]"><md-option ng-repeat="value in vm.APPROVED_ARR" ng-value="value">{{value}}</md-option></md-select></div><div ng-if="rule.model === \'salesCheck\' &amp;&amp; vm.isManualMode(rule.model, pn, pnIndex, pnRuleIndex)"><md-select class="ibm_select" ng-model="vm.pnsSalesIncComments[pn.data.itemList[0].pn]"><md-option ng-repeat="value in vm.APPROVED_ARR" ng-value="value">{{value}}</md-option></md-select></div><div ng-if="rule.model === \'ctlCheck\' &amp;&amp; vm.isManualMode(rule.model, pn, pnIndex, pnRuleIndex)"><md-select class="ibm_select" ng-model="vm.pnsCtlComments[pn.data.itemList[0].pn]"><md-option ng-repeat="value in vm.APPROVED_ARR" ng-value="value">{{value}}</md-option></md-select></div><div ng-if="vm.isValueDisplayed(rule, pn)"><p>{{rule.value}}</p></div></td></tr></tbody></table><div class="ibm-rule ibm-alternate-1" ng-if="pnIndex !== vm.orderData.pns.length - 1"></div></div></div></div></div></div>');
$templateCache.put('detail-validation.html','<form class="ibm-column-form" method="post"> <div><detail-valid-general ng-if="!vm.isNewOppty" data="vm.cmr"></detail-valid-general><detail-valid-general ng-if="vm.isNewOppty" data="vm.cmr"></detail-valid-general><div ng-if="vm.topic.topic.gpp_valid[0].opp &amp;&amp; !(vm.topic.topic.version &amp;&amp; vm.topic.topic.version &gt;= vm.OPP_VERSION_3)"><detail-brand-family comp="\'gpp_valid\'" diff="false" diffArray="vm.diffArray"></detail-brand-family><detail-sales-team comp="\'gpp_valid\'" diff="false" diffArray="vm.diffArray"></detail-sales-team><detail-opp-reg comp="\'gpp_valid\'" diff="false" diffArray="vm.diffArray"></detail-opp-reg><detail-svi comp="\'gpp_valid\'" diff="false" diffArray="vm.diffArray"></detail-svi><detail-contact-info comp="\'gpp_valid\'" diff="false" diffArray="vm.diffArray"></detail-contact-info></div></div><ctl-so-information></ctl-so-information><div ng-if="vm.topic.topic.version &amp;&amp; vm.topic.topic.version &gt;= vm.OPP_VERSION_3"><deal-registration-product-group type="\'validation\'"></deal-registration-product-group></div><div ng-if="vm.topic.topic.version &amp;&amp; vm.topic.topic.version &gt;= vm.OPP_VERSION_4"><sales-assist-table></sales-assist-table></div><detail-validation-ods></detail-validation-ods><span style="display: inline-flex;"><b class="ibm-h3 ibm-textcolor-blue-40">Validation Results</b><display-error section="\'sap\'" style="margin-left:10px; padding-top:2px"></display-error></span><div class="ibm-rule ibm-alternate"></div><span style="padding-top: 20px; display: inline-flex;"><md-icon md-svg-icon="/public/images/ic_history_black_24px.svg" style="margin-top: 0px;"> </md-icon><span style="padding-left: 22px; padding-right: 50px; font-size: 18px;">Validation Start Date:</span><md-datepicker ng-change="vm.isCommented = true" ng-if="vm.env.user.access.bpsoAdmin" ng-model="vm.validDate" ng-disabled="vm.isValidationStartDateDisable"></md-datepicker><span ng-if="!vm.env.user.access.bpsoAdmin">{{vm.validDate}}</span><span ng-if="vm.isCommented" style="padding: 12px; margin-left: 20px;">&nbsp; Please add supporting comments:</span><input ng-if="vm.isCommented" ng-model="vm.validDateComment"/><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.changeStartValidDate(vm.validDate)" ng-disabled="!vm.validDateComment" ng-if="vm.isCommented" title="Confirm and save Start Valid date change"><md-icon class="white_icon" md-svg-src="/public/images/checkbox-marked-circle.svg"></md-icon>&nbsp;Save</md-button></span><detail-validation-sales-orders-eval></detail-validation-sales-orders-eval><div class="ibm-rule ibm-alternate"></div><span style="display: inline-flex;"><b class="ibm-h3 ibm-textcolor-blue-40">Government Check Results</b><display-error section="\'goeCheck_valid\'" style="margin-left:10px; padding-top:2px"></display-error></span><div ng-if="([\'US\', \'CA\'].indexOf(vm.topic.topic.country) &gt; -1 &amp;&amp; [\'Yes\', \'State Owned\'].indexOf(vm.topic.topic.goe.picked) &gt; -1) || ([\'US\', \'CA\'].indexOf(vm.topic.topic.country) &lt; 0 &amp;&amp; [\'Yes\',\'Unknown\', \'State Owned\'].indexOf(vm.topic.topic.goe.picked) &gt; -1)"><p></p>A 2nd GOE Check is not required since the \'Eligibility\' GOE Decision is <b>{{[\'US\', \'CA\'].indexOf(vm.topic.topic.country) > -1 ? \'Yes/State Owned\' : \'Yes/State Owned/Unknown\' }}</b>.  &nbsp;However, feel free to perform manual searches.<p></p><p></p><!--detail-table-vcmr--><!--br--><!--br--><!--detail-eligibility-findcmr-comments(section=\'findCmr_valid\')--><!--br--><!--br--><!--attachment-section(title=\'Find CMR\', section=\'fcmr_valid\')--><!--br--><!--br--></div><div ng-if="([\'US\', \'CA\'].indexOf(vm.topic.topic.country) &gt; -1 &amp;&amp; [\'No\', \'Unknown\'].indexOf(vm.topic.topic.goe.picked) &gt; -1) || ([\'US\', \'CA\'].indexOf(vm.topic.topic.country) &lt; 0 &amp;&amp; [\'No\'].indexOf(vm.topic.topic.goe.picked) &gt; -1)"><div><p></p>A 2nd GOE Check is required since the \'Eligibility\' GOE Decision is <b>{{[\'US\', \'CA\'].indexOf(vm.topic.topic.country) > -1 ? \'No/Unknown\' : \'No\' }} </b>.&nbsp; Either perform the searches manually, or via the automated check based on the Eligibility results. &nbsp;<!-- If no auto performed and no SAP yet--><span ng-if="vm.topic.topic.cmr_valid.decision.success === undefined  &amp;&amp; vm.topic.topic.goe_valid_data.decision.success === undefined &amp;&amp; (!vm.topic.topic.sap || vm.topic.topic.sap.length === 0)"> The automated check can be triggered by clicking the button below, or by performing the ODS Search.</span><!-- If no auto performed but SAP performed--><span ng-if="!(vm.topic.topic.cmr_valid.decision.success !== undefined || vm.topic.topic.goe_valid_data.decision.success !== undefined ) &amp;&amp; vm.topic.topic.sap &amp;&amp; vm.topic.topic.sap.length &gt; 0"> The automated check can be triggered by clicking the button below.</span><p></p><md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.goeValidation()" ng-disabled=" vm.isNonGoeAndAutomatedEligibility || vm.topic.editableComponents.cmr_valid.socket || vm.topic.goeFired || vm.topic.topic.complete.goeCheck_valid" title="{{{true: \'The 2nd GOE has already been performed and cannot be triggered again without Rolling-Back to Eligibility status\', false: \'Initiate 2nd GOE Validation based on GOE Checks performed in the Eligibility tab\'}[vm.topic.topic.cmr_valid.decision.success !== undefined]}}"><span ng-if="!vm.topic.goeFired"><md-icon class="white_icon" md-svg-src="/public/images/ic_playlist_add_check_black_24px.svg"></md-icon></span><span ng-if="vm.topic.goeFired"><md-icon class="rotating" md-svg-icon="/public/images/ic_autorenew_black_24px.svg"></md-icon></span><span style="padding: 5px;">Automated 2nd GOE Check</span></md-button><span class="ibm-textcolor-red-50" ng-if="vm.topic.goeFired"> <b>NOTE:&nbsp;</b>The automated 2nd GOE Check is running in the background. &nbsp;It may take a while for the results to appear.</span><span class="ibm-textcolor-green-40" ng-if="vm.topic.topic.cmr_valid.decision.success !== undefined"><b>NOTE:&nbsp;</b>The automated 2nd GOE Check has been performed. &nbsp;See the results in the Find CMR section below.</span></div><br/><br/><!--br--><!--br--><!--detail-eligibility-findcmr-comments(section=\'findCmr_valid\')--><!--br--><!--br--><!--attachment-section(title=\'Find CMR\', section=\'fcmr_valid\')--><!--br--><!--br--><!--divdetail-table-compl-cl-validation--><!--br--><!--br--><!--goe-valid-section--><!--br--><!--br--></div><detail-table-valid-ig-check id="indent-vertical" ng-if="vm.topic.topic.version &amp;&amp; vm.topic.topic.version &gt;= vm.OPP_VERSION_3" data="vm.checksData.GOE" flex="flex"></detail-table-valid-ig-check><detail-table-vcmr ng-if="!(vm.topic.topic.version &amp;&amp; vm.topic.topic.version &gt;= vm.OPP_VERSION_3) "></detail-table-vcmr><br/><br/><detail-eligibility-findcmr-comments section="findCmr_valid"></detail-eligibility-findcmr-comments><br/><br/><attachment-section title="Find CMR" section="fcmr_valid"></attachment-section><br/><br/><div ng-if="vm.showCLGE"><detail-table-compl-cl-validation></detail-table-compl-cl-validation><br/><br/><goe-valid-section></goe-valid-section><br/><br/></div></form><b class="ibm-h3 ibm-textcolor-blue-40">Attachments</b><br/><br/><attachment-section title="Validation" section="validation"></attachment-section><br/><br/><detail-comment></detail-comment>');
$templateCache.put('dialog-validation.html','<md-dialog aria-label="{{vm.field}}" ng-cloak="ng-cloak" flex="60"><md-toolbar><div class="md-toolbar-tools"><h2>Update {{vm.field}}</h2><span flex="flex"></span><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon md-svg-src="/public/images/ic_close_black_24px.svg" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><ng-form name="dialogForm"><md-content class="md-padding"><div ng-if="vm.type==\'s\'"><div><md-input-container class="md-input-has-value" flex="flex"><label>Current value</label><input ng-model="vm.item" placeholder="item" ng-disabled="true"/></md-input-container></div><div><md-input-container class="md-input-has-value" flex="flex"><label>New value</label><input ng-model="vm.value" placeholder="value"/></md-input-container></div></div><div><md-input-container class="md-input-has-value" flex="flex"><label><span>Comment</span><span ng-if="dialogForm.comment.$invalid"><md-icon md-svg-src="/public/images/ic_warning_black_24px.svg" title="Comment field empty"></md-icon></span></label><span><input name="comment" ng-model="vm.comment" placeholder="comment" required="required"/></span></md-input-container></div><md-button class="md-raised md-primary" ng-click="vm.answer()" ng-disabled="dialogForm.$invalid">Update</md-button></md-content></ng-form></md-dialog-content></md-dialog>');
$templateCache.put('goe-history-checklist.html','<br/><span class="ibm-h5">GOE History Checklist</span><esc-button-section vm="vm" lock="vm.lock" style="float:right"></esc-button-section><table class="ibm-data-table" cellspacing="0" cellpadding="0"><tr><td><b>Have you reviewed all retrieved opportunities</b></td><td> <span ng-if="!vm.topic.editableComponents[vm.component].editMode">{{vm.topic.topic.goeHistoryChecklist.reviewedOppties ? vm.topic.topic.goeHistoryChecklist.reviewedOppties: \'NA\'}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.component].editMode" ng-model="vm.topic.temp.goeHistoryChecklist.reviewedOppties" ng-options="o as o for o in vm.ANSWER_OPTIONS"></select></td></tr><tr><td><b>Have you updated GOE decision on existing opportunities based on current GOE determination</b></td><td><span ng-if="!vm.topic.editableComponents[vm.component].editMode">{{vm.topic.topic.goeHistoryChecklist.updatedOppties ? vm.topic.topic.goeHistoryChecklist.updatedOppties: \'NA\'}}</span><select style="width: 20em" ng-if="vm.topic.editableComponents[vm.component].editMode" ng-model="vm.topic.temp.goeHistoryChecklist.updatedOppties" ng-options="o as o for o in vm.ANSWER_OPTIONS"></select></td></tr><tr></tr></table>');
$templateCache.put('goe-history-table.html','<style>#indent-vertical {\n    display: block;\n    padding: 10px 0 10px;\n} \n.bp-table * {\n    font-size: 14px;\n}\n.bp-table {\n    display: block;\n    overflow: auto;\n    border: 0 !important;\n}\n.bp-table > thead > tr > th,\n.bp-table > tbody > tr > td {\n    text-align: center;\n    vertical-align: middle;\n}\n.bp-table-border thead tr:first-child th:nth-last-child(2) {\n    border-bottom: 0;\n}\n.bp-table tbody label {\n    text-align: left;\n}\n.bp-table .cut-text {\n    text-overflow: ellipsis;\n    overflow: hidden; \n    width: 130px; \n    height: 1.2em; \n    white-space: nowrap;\n}</style><span class="ibm-h5">GOE History Check Results</span><div id="indent-vertical"><div ng-if="vm.isTableEmpty()">Results are empty</div><table class="ibm-data-table ibm-grid ibm-altrows bp-table" ng-if="!vm.isTableEmpty()"><thead><tr><th ng-repeat="name in vm.TABLE_HEADERS"><b>{{name}}</b></th></tr></thead><tbody><tr ng-repeat="(key,value) in vm.goeHistoryCheck.historyData"><td>{{value.opportunityId}}</td><td>{{vm.formatDate(value.submitDate)}}</td><td>{{vm.formatDate(value.expireDate)}}</td><td>{{value.country}}</td><td>{{value.statusLabel}}/{{value.subStatusLabel}}</td><td>{{value.accountName}}</td><td>{{value.customerNumber}}</td><td>{{value.goeDecision || \'To be Confirmed\'}}</td></tr></tbody></table></div>');
$templateCache.put('goe-history.html','<span class="ibm-h4"><md-icon md-svg-src="/public/images/ic_list_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span ng-click="vm.toggleVisibility()">&nbsp;GOE History Check</span><display-error section="vm.component" style="float: none; margin-left: 5px">&nbsp;</display-error></span><div id="indent-vertical" ng-if="vm.visible"><p class="ibm-textcolor-red-40" ng-if="vm.errorMessage">{{vm.errorMessage}}</p><p ng-if="vm.message">{{vm.message}}</p><eligibility-goe-history-table ng-if="vm.isDisplayTable"></eligibility-goe-history-table><eligibility-goe-history-checklist ng-if="vm.isDisplayChecklist"></eligibility-goe-history-checklist></div>');
$templateCache.put('breakdown.html','<div><div class="ibm-columns"><div class="ibm-col-6-3"><span style="display: inline-flex;"><b class="ibm-h3 ibm-textcolor-blue-40">&nbsp;Calculations</b></span></div><div class="ibm-col-6-3 ibm-right"><div><esc-button-section ng-if="!vm.topic.calculation.complete" vm="vm" lock="vm.lock"></esc-button-section></div></div><div class="ibm-col-1-1"><div id="generalInfo"><span ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span class="ibm-h4">&nbsp;Details</span><span ng-if="vm.isError()"><md-icon class="red_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{vm.getErrors()}}"></md-icon></span></span><div ng-if="vm.visible"><span ng-if="!vm.topic.editableComponents.calculation.editMode"><tree-payment item="vm.topic.calculation"></tree-payment></span><span ng-if="vm.topic.editableComponents.calculation.editMode"><p></p><tree-edit-payment item="vm.topic.temp.calculation"></tree-edit-payment></span><div class="ibm-columns" id="generalInfo"><md-checkbox ng-model="vm.topic.calculation.bonusCapData.isApplied" ng-if="vm.topic.calculation.bonusCapData.isGenerallyEnabled &amp;&amp; vm.topic.calculation.bonusCapData.ratio &lt; 1 &amp;&amp; !vm.topic.editableComponents.calculation.editMode" ng-disabled="true" ng-false-value="false" ng-true-value="true">Apply Bonus Cap</md-checkbox><md-checkbox ng-model="vm.topic.temp.calculation.bonusCapData.isApplied" ng-if="vm.topic.calculation.bonusCapData.isGenerallyEnabled &amp;&amp; vm.topic.temp.calculation.bonusCapData.ratio &lt; 1 &amp;&amp; vm.topic.editableComponents.calculation.editMode" ng-click="vm.requireRecalculation()" ng-false-value="false" ng-true-value="true">Apply Bonus Cap</md-checkbox><div layout="row" layout-sm="column">   <md-button class="md-raised" ng-if="vm.isRefreshButtonVisible" ng-click="vm.recalculate()" ng-disabled="!vm.topic.editableComponents.calculation.editMode" title="Completely delete the Calculations so they can be triggered again">Refresh</md-button><md-button class="md-raised" ng-if="vm.isRemoveButtonVisible" ng-click="vm.removeCalculation()" ng-disabled="vm.topic.editableComponents.calculation.editMode" title="Completely delete the Calculations so they can be triggered again">Remove</md-button><md-button class="md-raised" ng-if="vm.checkRevertCondition()" ng-click="vm.revertStatus()" ng-disabled="vm.topic.editableComponents.calculation.editMode" title="Use this to move from \'Set Aside\' back to \'Pending BPSO\' - NOTE: the Calculation will become editable again and Approval will be required if you wish to continue">Revert</md-button></div></div></div><div class="ibm-columns"><div class="ibm-col-1-1"><span ng-if="vm.isProcessing"><p></p><h2 class="ibm-textcolor-blue-50 ibm-h3">Processing. &nbsp;Please wait ...</h2><md-progress-linear md-mode="indeterminate"></md-progress-linear></span></div></div></div></div></div></div><br/>');
$templateCache.put('payment.html','<form class="ibm-column-form" method="post"><div class="ibm-textcolor-red-50" ng-if="vm.topic.calculation.bonusCapData.isApplied &amp;&amp; vm.topic.calculation.bonusCapData.ratio &lt; 1"> <b>NOTE: </b>This Disbursement has been capped. To see the datails please hover over the exclamation mark next to the bonus amount.<p></p></div><ctl-so-information></ctl-so-information><div><payment-breakdown></payment-breakdown></div></form>');
$templateCache.put('table-edit.html','<style>.cell {\n    padding-right: 5px;\n    font-size: small;\n    white-space: nowrap;\n}\n.paymentEditContainer {\n    margin-top: 10px;\n    margin-bottom: 0;\n    padding: 0;\n}\n.p {\n    font-size: small;\n    white-space: nowrap;\n}\n</style><md-content class="dmt-white-background" layout="column" style="margin-left:30px" ng-if="vm.item"><span class="calc_so">{{vm.getSalesOrderLabel()}}</span><div class="md-list-item-text" layout="row" layout-align="start left"><b class="cell" flex="11%">Extended Price ({{vm.orderCurrency}})</b><b class="cell" flex="11%">{{vm.getUpliftLabel()}}<br/>{{vm.getUplift()}}</b><b class="cell" flex="11%">{{vm.getBonusLabel(\'sales\')}}<br/>{{vm.getBonus(\'sales\')}}<span ng-if="vm.getBonusComment(\'sales\')"> <md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{vm.getBonusComment(\'sales\')}}"></md-icon></span></b><b class="cell" flex="11%">{{vm.getBonusLabel(\'engagement\')}}<br/>{{vm.getBonus(\'engagement\')}}<span ng-if="vm.getBonusComment(\'engagement\')"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{vm.getBonusComment(\'engagement\')}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="!vm.isVer4Plus">{{vm.getBonusLabel(\'newClient\')}}<br/>{{vm.getBonus(\'newClient\')}}</b><b class="cell" flex="11%" ng-if="vm.isVer4Plus">{{vm.getBonusLabel(\'growth\')}}<br/>{{vm.getBonus(\'growth\')}}</b><b class="cell" flex="11%" ng-if="vm.isVer4Plus">{{vm.getBonusLabel(\'focus\')}}<br/>{{vm.getBonus(\'focus\')}}</b><b class="cell" flex="11%" ng-if="vm.isVer4Plus">{{vm.getBonusLabel(\'ctl\')}}<br/>{{vm.getBonus(\'ctl\')}}</b></div><md-divider flex="flex"></md-divider><div class="md-list-item-text" layout="row" layout-align="start left"><span class="cell" flex="11%"><md-input-container class="paymentEditContainer" flex="flex"><input style="border: solid 1px lightgray; padding-bottom: 1px" title="Extended Price" type="number" ng-pattern="vm.NUMBER_FORMAT" step="vm.NUMBER_STEP" ng-model="vm.data.extendedPrice" required="required" ng-change="vm.fieldChanged()"/></md-input-container></span><span class="cell" flex="11%" style="margin-top: 13px">{{vm.getUpliftAmount()}}</span><span class="cell" flex="11%" style="margin-top: 13px">{{vm.getBonusAmount(\'sales\')}}</span><span class="cell" flex="11%" style="margin-top: 13px">{{vm.getBonusAmount(\'engagement\')}}</span><span class="cell" flex="11%" style="margin-top: 13px" ng-if="!vm.isVer4Plus">{{vm.getBonusAmount(\'newClient\')}}</span><span class="cell" flex="11%" style="margin-top: 13px" ng-if="vm.isVer4Plus">{{vm.getBonusAmount(\'growth\')}}</span><span class="cell" flex="11%" style="margin-top: 13px" ng-if="vm.isVer4Plus">{{vm.getBonusAmount(\'focus\')}}</span><span class="cell" flex="11%" style="margin-top: 13px" ng-if="vm.isVer4Plus">{{vm.getBonusAmount(\'ctl\')}}</span></div></md-content><p></p>');
$templateCache.put('table.html','<style>.cell {\n    padding-right: 5px;\n    font-size: small;\n    white-space: nowrap;\n}\n.p {\n    font-size: small;\n    white-space: nowrap;\n}</style><md-content class="dmt-white-background" layout="column" style="margin-left:20px" ng-if="vm.item"><span class="calc_so">{{vm.getSalesOrderLabel()}}</span><div class="md-list-item-text" layout="row" layout-align="start left"><b class="cell" flex="11%">Extended Price ({{vm.orderCurrency}})</b><b class="cell" flex="11%">{{vm.getUpliftLabel()}}<br/>{{vm.getUplift()}}</b><b class="cell" flex="11%">{{vm.getBonusLabel(\'sales\')}}<br/>{{vm.getBonus(\'sales\')}}<span ng-if="vm.getBonusComment(\'sales\')"> <md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{vm.getBonusComment(\'sales\')}}"></md-icon></span></b><b class="cell" flex="11%">{{vm.getBonusLabel(\'engagement\')}}<br/>{{vm.getBonus(\'engagement\')}} <span ng-if="vm.getBonusComment(\'engagement\')"><md-icon class="blue_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{vm.getBonusComment(\'engagement\')}}"></md-icon></span></b><b class="cell" flex="11%" ng-if="!vm.isVer4Plus">{{vm.getBonusLabel(\'newClient\')}}<br/>{{vm.getBonus(\'newClient\')}}</b><b class="cell" flex="11%" ng-if="vm.isVer4Plus">{{vm.getBonusLabel(\'growth\')}}<br/>{{vm.getBonus(\'growth\')}}</b><b class="cell" flex="11%" ng-if="vm.isVer4Plus">{{vm.getBonusLabel(\'focus\')}}<br/>{{vm.getBonus(\'focus\')}}</b><b class="cell" flex="11%" ng-if="vm.isVer4Plus">{{vm.getBonusLabel(\'ctl\')}}<br/>{{vm.getBonus(\'ctl\')}}</b></div><md-divider flex="flex"></md-divider><div class="md-list-item-text" layout="row" layout-align="start left"><span class="cell" flex="11%">{{vm.data.extendedPrice}}</span><span class="cell" flex="11%">{{vm.getUpliftAmount()}}</span><span class="cell" flex="11%">{{vm.getBonusAmount(\'sales\')}}</span><span class="cell" flex="11%">{{vm.getBonusAmount(\'engagement\')}}</span><span class="cell" flex="11%" ng-if="!vm.isVer4Plus">{{vm.getBonusAmount(\'newClient\')}}</span><span class="cell" flex="11%" ng-if="vm.isVer4Plus">{{vm.getBonusAmount(\'growth\')}}</span><span class="cell" flex="11%" ng-if="vm.isVer4Plus">{{vm.getBonusAmount(\'focus\')}}</span><span class="cell" flex="11%" ng-if="vm.isVer4Plus">{{vm.getBonusAmount(\'ctl\')}}</span></div><p></p></md-content>');
$templateCache.put('tree-edit.html','<style>.paymentEditContainer {\n    margin-top: 10px;\n    margin-bottom: 0;\n    padding: 0;\n}\n.md-errors-spacer{\n    min-height: 10px !important;\n}</style><div class="ibm-columns" id="generalInfo"></div><span ng-click="vm.toggle()" ng-if="vm.item.type !== \'calculation\'"> <md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon></span><span ng-if="vm.item.type !== \'calculation\'"> <md-input-container class="paymentEditContainer" flex="flex"><input ng-model="vm.item.id" style="min-width:100px; border: solid 1px lightgray" required="required" ng-change="vm.fieldChanged()" aria-label="{{::vm.getPlaceholder()}}" placeholder="{{::vm.getPlaceholder()}}"/></md-input-container><span ng-if="vm.isError() &amp;&amp; vm.item.type !== \'calculation\'"><md-icon class="red_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{vm.getErrors()}}"></md-icon></span><md-button class="md-raised" style="font-size: 10px; min-height: 16px; min-width: 40px; line-height: 16px" ng-click="vm.removeItem()" title="Remove item">Remove</md-button><md-button class="md-raised" style="font-size: 10px; min-height: 16px; min-width: 40px; line-height: 16px" ng-click="vm.copyItem()" title="Copy item">Copy</md-button></span><div ng-hide="!vm.visible" ng-if="vm.item.type === \'lineItem\'"><div class="ibm-columns" id="genInfo"></div><div class="ibm-columns search-form"><span ng-repeat="data in vm.item.data"><payment-table-edit item="vm.item" data="data"></payment-table-edit></span></div></div><span ng-hide="!vm.visible" ng-if="vm.getChildren()"><div class="ibm-columns"><div class="thirty-right"><span ng-repeat="item in vm.getChildren() track by $index"><tree-edit-payment item="item" index="$index" parent="vm"></tree-edit-payment></span></div></div></span>');
$templateCache.put('tree.html','<div class="ibm-columns" id="generalInfo"></div><span ng-click="vm.toggle()" ng-if="vm.item.type !== \'calculation\'"> <md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><b class="ibm-textcolor-blue-50">{{vm.item.id}}</b><span ng-if="vm.isError() &amp;&amp; vm.item.type !== \'calculation\'"><md-icon class="red_icon" style="padding-left:5px" md-svg-src="/public/images/ic_error_white_24px.svg" title="{{vm.getErrors()}}"></md-icon></span></span><div ng-hide="!vm.visible" ng-if="vm.item.type === \'lineItem\'"><div class="ibm-columns" id="genInfo"></div><div class="ibm-columns search-form"><span ng-repeat="data in vm.item.data"><payment-table item="vm.item" data="data"></payment-table></span></div></div><span ng-hide="!vm.visible" ng-if="vm.getChildren()"><div class="ibm-columns"><div class="thirty-right"><span ng-repeat="item in vm.getChildren()"><tree-payment item="item"></tree-payment></span></div></div></span>');
$templateCache.put('saTable.html','<style>.sa-table * {\n    font-size: 14px;\n}</style><br/><div class="ibm-columns" ng-if="vm.topic.salesAssistData.dealRegs"><span class="ibm-h4" ng-click="vm.toggle()"><md-icon md-svg-src="/public/images/ic_grid_on_black_24px.svg"></md-icon><md-icon ng-hide="vm.visible" md-svg-src="/public/images/ic_keyboard_arrow_left_black_24px.svg"></md-icon><md-icon ng-hide="!vm.visible" md-svg-src="/public/images/ic_expand_more_black_24px.svg"></md-icon><span><span>{{vm.tableName}}</span><span class="ibm-textcolor-blue-40" style="font-size:medium"> Click to {{vm.visible ? \'hide\' : \'view\'}}</span></span></span><div id="indent-vertical" ng-if="vm.visible"><table class="ibm-data-table ibm-grid ibm-altrows sa-table"><thead><tr><th ng-repeat="name in vm.tableHeaders track by $index"><b>{{name}}</b></th></tr></thead><tbody><tr ng-repeat="(key,value) in vm.topic.salesAssistData.dealRegs track by $index"> <td>{{vm.getValue(value.dealRegGroupId)}}</td><td>{{vm.getValue(value.siAssist)}}</td><td>{{vm.getValue(value.eiAssist)}}</td><td>{{vm.getValue(value.engagementID)}}</td><td>{{vm.getValue(value.salesOrderNumber)}}</td></tr></tbody></table></div></div>');}]);